import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import styled, { css, keyframes as keyframes$1 } from 'styled-components';
import { BookingRepeatEnum, BookingRepeatIntervalEnum, RepeatMonthlyOnEnum, RepeatEndsOnEnum, ProjectStatusEnum, CatColorDisplayNewEnum, ExtensionsEnum, ProjectTypeEnum, ResourceRoleEnum, ResourceStatusEnum, ResourceTypeEnum, BookingScaleEnum, ResourceRoleRightStatusEnum, BookingTypeEnum, AllocationStateEnum, SimpleRepeatEnum, CategoryGroupTypeEnum, CategoryTypeEnum, SchedulerGridModeEnum, ContextMenuType } from '@hub-mono/api-client';
import { CUSTOM_MONTH_OCCURRENCE_ORDINAL_IDENTIFIERS, CUSTOM_MONTH_OCCURRENCE_DAYS, formatCustomMonthDayOrdinalIdentifiers, formatCustomMonthDay, Layout, Typography, RadioGroupReduxFormWrapper, WeekDaysCheckboxList, useOpenState, Radio, DaysOfMonthSelectDialog, CustomMonthDatesSelectDialog, NumberInputReduxFormWrapper, DatePickerReduxFormWrapper, SelectReduxFormWrapper, ListItem, Icon, Select, NumberInput, Tooltip, IconButton, Chip, Checkbox, List as List$1, useDebouncedValue, Dot, TextField, CheckboxListDialog, DatePickerInput, Switch, Divider, CheckboxTreeDialog, SortableList, useKeyDown, Dialog, Button, Tag, Menu, Modal, Image as Image$1, useHubUIConfigContext, HubUIConfigContextProvider, Fab, Logo as Logo$1, DEFAULT_COUNTRY, StyledCheckbox, useScreenSize, useFormValidation, PhoneNumberInput, ContextMenu, Slides, DEFAULT_COLOR, usePrevious, TextFieldFormikWrapper, DatePickerInputFormikWrapper, isAvatarPlaceholder, Avatar, NumberInputFormikWrapper, ColorPicker, useAccordionState, WeekDaysSelectedFormat, Accordion, ContextMenuItem, SelectFormikWrapper, ColorPickerFormikWrapper, RadioFormikWrapper, ColorPickerDialogFormikWrapper, CheckboxFormikWrapper, RadioGroup, Slider, ColorPickerDialog } from '@hub-mono/ui';
import { toDate as toDate$1, calculateDifference, dayKeys, sortNumbersCompareFn, removeUTCZuluFromDateObject, formatOrdinals, normalizeIntegerNumber, isBefore, searchStringCompare, isAfter, firstLetterToUpperCase, formatDate, DATE_FORMATS, setYear, isBetween, getDateDayKey, startOfDay, endOfDay, addDays as addDays$1, isDayKey, startOfMonth, differenceInDays, startOfWeek, toFixedTrimmed, isSameOrBefore, isSameOrAfter, toMidnight, addMonths, addWeeks, set as set$2, getHours, getMinutes, subDays, dateToPrecision, removeUTCZuluFromDateTimestamp, isNumber, isSameDay, truncate } from '@hub-mono/utils';
import * as React from 'react';
import React__default, { useCallback, useMemo, useState, useEffect, forwardRef, createElement as createElement$2, useReducer, useRef, createContext, useContext, cloneElement, useId, useInsertionEffect, Children, isValidElement, useLayoutEffect, Fragment as Fragment$1, Component, memo as memo$1 } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFormValues, touch, change, Field, getFormMeta, getFormSyncErrors } from 'redux-form';
import { createSelector } from 'reselect';
import io from 'react-dom';
import require$$0 from 'crypto';
import { Formik, Form, useFormikContext, Field as Field$1 } from 'formik';
import { ObjectID } from 'bson';
import { useHistory } from 'react-router-dom';
import { Link } from '@material-ui/core';
import { useUpdateSurveyResponse, useCreateSurveyResponse, useSurveys, useSurveyResponseForAccount } from '@hub-mono/app-services';
const StyledAppModules = /*#__PURE__*/styled.div.withConfig({
  displayName: "app-modules__StyledAppModules",
  componentId: "sc-12vd2w6-0"
})(["color:pink;"]);
function AppModules(props) {
  return jsx(StyledAppModules, {
    children: jsx("h1", {
      children: "Welcome to AppModules!"
    })
  });
}
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$q =
// eslint-disable-next-line es/no-global-this -- safe
check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) ||
// eslint-disable-next-line no-restricted-globals -- safe
check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
// eslint-disable-next-line no-new-func -- fallback
function () {
  return this;
}() || Function('return this')();
var objectGetOwnPropertyDescriptor = {};
var fails$y = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};
var fails$x = fails$y;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$x(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, {
    get: function () {
      return 7;
    }
  })[1] !== 7;
});
var fails$w = fails$y;
var functionBindNative = !fails$w(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = function () {/* empty */}.bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});
var NATIVE_BIND$3 = functionBindNative;
var call$s = Function.prototype.call;
var functionCall = NATIVE_BIND$3 ? call$s.bind(call$s) : function () {
  return call$s.apply(call$s, arguments);
};
var objectPropertyIsEnumerable = {};
var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$3 && !$propertyIsEnumerable.call({
  1: 2
}, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$3(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;
var createPropertyDescriptor$5 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};
var NATIVE_BIND$2 = functionBindNative;
var FunctionPrototype$2 = Function.prototype;
var call$r = FunctionPrototype$2.call;
var uncurryThisWithBind = NATIVE_BIND$2 && FunctionPrototype$2.bind.bind(call$r, call$r);
var functionUncurryThis = NATIVE_BIND$2 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$r.apply(fn, arguments);
  };
};
var uncurryThis$x = functionUncurryThis;
var toString$i = uncurryThis$x({}.toString);
var stringSlice$8 = uncurryThis$x(''.slice);
var classofRaw$2 = function (it) {
  return stringSlice$8(toString$i(it), 8, -1);
};
var uncurryThis$w = functionUncurryThis;
var fails$v = fails$y;
var classof$9 = classofRaw$2;
var $Object$4 = Object;
var split$1 = uncurryThis$w(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$v(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$9(it) === 'String' ? split$1(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$6 = function (it) {
  return it === null || it === undefined;
};
var isNullOrUndefined$5 = isNullOrUndefined$6;
var $TypeError$l = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$a = function (it) {
  if (isNullOrUndefined$5(it)) throw new $TypeError$l("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$9 = requireObjectCoercible$a;
var toIndexedObject$5 = function (it) {
  return IndexedObject$2(requireObjectCoercible$9(it));
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable$s = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};
var isCallable$r = isCallable$s;
var isObject$i = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$r(it);
};
var global$p = global$q;
var isCallable$q = isCallable$s;
var aFunction = function (argument) {
  return isCallable$q(argument) ? argument : undefined;
};
var getBuiltIn$b = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$p[namespace]) : global$p[namespace] && global$p[namespace][method];
};
var uncurryThis$v = functionUncurryThis;
var objectIsPrototypeOf = uncurryThis$v({}.isPrototypeOf);
var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';
var global$o = global$q;
var userAgent$5 = engineUserAgent;
var process$4 = global$o.process;
var Deno$1 = global$o.Deno;
var versions = process$4 && process$4.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;
if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$5) {
  match = userAgent$5.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$5.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}
var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION$1 = engineV8Version;
var fails$u = fails$y;
var global$n = global$q;
var $String$7 = global$n.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$u(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$7(symbol) || !(Object(symbol) instanceof Symbol) ||
  // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$3 = symbolConstructorDetection;
var useSymbolAsUid = NATIVE_SYMBOL$3 && !Symbol.sham && typeof Symbol.iterator == 'symbol';
var getBuiltIn$a = getBuiltIn$b;
var isCallable$p = isCallable$s;
var isPrototypeOf$5 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;
var $Object$3 = Object;
var isSymbol$5 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$a('Symbol');
  return isCallable$p($Symbol) && isPrototypeOf$5($Symbol.prototype, $Object$3(it));
};
var $String$6 = String;
var tryToString$5 = function (argument) {
  try {
    return $String$6(argument);
  } catch (error) {
    return 'Object';
  }
};
var isCallable$o = isCallable$s;
var tryToString$4 = tryToString$5;
var $TypeError$k = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$k = function (argument) {
  if (isCallable$o(argument)) return argument;
  throw new $TypeError$k(tryToString$4(argument) + ' is not a function');
};
var aCallable$j = aCallable$k;
var isNullOrUndefined$4 = isNullOrUndefined$6;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$6 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$4(func) ? undefined : aCallable$j(func);
};
var call$q = functionCall;
var isCallable$n = isCallable$s;
var isObject$h = isObject$i;
var $TypeError$j = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$n(fn = input.toString) && !isObject$h(val = call$q(fn, input))) return val;
  if (isCallable$n(fn = input.valueOf) && !isObject$h(val = call$q(fn, input))) return val;
  if (pref !== 'string' && isCallable$n(fn = input.toString) && !isObject$h(val = call$q(fn, input))) return val;
  throw new $TypeError$j("Can't convert object to primitive value");
};
var sharedStore = {
  exports: {}
};
var isPure = false;
var global$m = global$q;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$7 = Object.defineProperty;
var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$7(global$m, key, {
      value: value,
      configurable: true,
      writable: true
    });
  } catch (error) {
    global$m[key] = value;
  }
  return value;
};
var globalThis$1 = global$q;
var defineGlobalProperty$2 = defineGlobalProperty$3;
var SHARED = '__core-js_shared__';
var store$3 = sharedStore.exports = globalThis$1[SHARED] || defineGlobalProperty$2(SHARED, {});
(store$3.versions || (store$3.versions = [])).push({
  version: '3.36.1',
  mode: 'global',
  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.36.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});
var store$2 = sharedStore.exports;
var shared$4 = function (key, value) {
  return store$2[key] || (store$2[key] = value || {});
};
var requireObjectCoercible$8 = requireObjectCoercible$a;
var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$b = function (argument) {
  return $Object$2(requireObjectCoercible$8(argument));
};
var uncurryThis$u = functionUncurryThis;
var toObject$a = toObject$b;
var hasOwnProperty$2 = uncurryThis$u({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty$2(toObject$a(it), key);
};
var uncurryThis$t = functionUncurryThis;
var id$2 = 0;
var postfix = Math.random();
var toString$h = uncurryThis$t(1.0.toString);
var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$h(++id$2 + postfix, 36);
};
var global$l = global$q;
var shared$3 = shared$4;
var hasOwn$d = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL$2 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;
var Symbol$6 = global$l.Symbol;
var WellKnownSymbolsStore = shared$3('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$6['for'] || Symbol$6 : Symbol$6 && Symbol$6.withoutSetter || uid$1;
var wellKnownSymbol$l = function (name) {
  if (!hasOwn$d(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL$2 && hasOwn$d(Symbol$6, name) ? Symbol$6[name] : createWellKnownSymbol('Symbol.' + name);
  }
  return WellKnownSymbolsStore[name];
};
var call$p = functionCall;
var isObject$g = isObject$i;
var isSymbol$4 = isSymbol$5;
var getMethod$5 = getMethod$6;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$k = wellKnownSymbol$l;
var $TypeError$i = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$k('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$2 = function (input, pref) {
  if (!isObject$g(input) || isSymbol$4(input)) return input;
  var exoticToPrim = getMethod$5(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$p(exoticToPrim, input, pref);
    if (!isObject$g(result) || isSymbol$4(result)) return result;
    throw new $TypeError$i("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};
var toPrimitive$1 = toPrimitive$2;
var isSymbol$3 = isSymbol$5;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$3 = function (argument) {
  var key = toPrimitive$1(argument, 'string');
  return isSymbol$3(key) ? key : key + '';
};
var global$k = global$q;
var isObject$f = isObject$i;
var document$3 = global$k.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$f(document$3) && isObject$f(document$3.createElement);
var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};
var DESCRIPTORS$g = descriptors;
var fails$t = fails$y;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$g && !fails$t(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () {
      return 7;
    }
  }).a !== 7;
});
var DESCRIPTORS$f = descriptors;
var call$o = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$4 = createPropertyDescriptor$5;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$2 = toPropertyKey$3;
var hasOwn$c = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$f ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$2(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) {/* empty */}
  if (hasOwn$c(O, P)) return createPropertyDescriptor$4(!call$o(propertyIsEnumerableModule$1.f, O, P), O[P]);
};
var objectDefineProperty = {};
var DESCRIPTORS$e = descriptors;
var fails$s = fails$y;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$e && fails$s(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () {/* empty */}, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});
var isObject$e = isObject$i;
var $String$5 = String;
var $TypeError$h = TypeError;

// `Assert: Type(argument) is Object`
var anObject$r = function (argument) {
  if (isObject$e(argument)) return argument;
  throw new $TypeError$h($String$5(argument) + ' is not an object');
};
var DESCRIPTORS$d = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$q = anObject$r;
var toPropertyKey$1 = toPropertyKey$3;
var $TypeError$g = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$d ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$q(O);
  P = toPropertyKey$1(P);
  anObject$q(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  }
  return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$q(O);
  P = toPropertyKey$1(P);
  anObject$q(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$g('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};
var DESCRIPTORS$c = descriptors;
var definePropertyModule$4 = objectDefineProperty;
var createPropertyDescriptor$3 = createPropertyDescriptor$5;
var createNonEnumerableProperty$9 = DESCRIPTORS$c ? function (object, key, value) {
  return definePropertyModule$4.f(object, key, createPropertyDescriptor$3(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};
var makeBuiltIn$3 = {
  exports: {}
};
var DESCRIPTORS$b = descriptors;
var hasOwn$b = hasOwnProperty_1;
var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$b && Object.getOwnPropertyDescriptor;
var EXISTS = hasOwn$b(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && function something() {/* empty */}.name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$b || DESCRIPTORS$b && getDescriptor(FunctionPrototype$1, 'name').configurable);
var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};
var uncurryThis$s = functionUncurryThis;
var isCallable$m = isCallable$s;
var store$1 = sharedStore.exports;
var functionToString = uncurryThis$s(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$m(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}
var inspectSource$3 = store$1.inspectSource;
var global$j = global$q;
var isCallable$l = isCallable$s;
var WeakMap$2 = global$j.WeakMap;
var weakMapBasicDetection = isCallable$l(WeakMap$2) && /native code/.test(String(WeakMap$2));
var shared$2 = shared$4;
var uid = uid$2;
var keys$1 = shared$2('keys');
var sharedKey$3 = function (key) {
  return keys$1[key] || (keys$1[key] = uid(key));
};
var hiddenKeys$4 = {};
var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$i = global$q;
var isObject$d = isObject$i;
var createNonEnumerableProperty$8 = createNonEnumerableProperty$9;
var hasOwn$a = hasOwnProperty_1;
var shared$1 = sharedStore.exports;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;
var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$2 = global$i.TypeError;
var WeakMap$1 = global$i.WeakMap;
var set$1, get, has$9;
var enforce = function (it) {
  return has$9(it) ? get(it) : set$1(it, {});
};
var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$d(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$2('Incompatible receiver, ' + TYPE + ' required');
    }
    return state;
  };
};
if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap$1());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set$1 = function (it, metadata) {
    if (store.has(it)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has$9 = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$a(it, STATE)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$8(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$a(it, STATE) ? it[STATE] : {};
  };
  has$9 = function (it) {
    return hasOwn$a(it, STATE);
  };
}
var internalState = {
  set: set$1,
  get: get,
  has: has$9,
  enforce: enforce,
  getterFor: getterFor
};
var uncurryThis$r = functionUncurryThis;
var fails$r = fails$y;
var isCallable$k = isCallable$s;
var hasOwn$9 = hasOwnProperty_1;
var DESCRIPTORS$a = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$3;
var InternalStateModule$3 = internalState;
var enforceInternalState = InternalStateModule$3.enforce;
var getInternalState$2 = InternalStateModule$3.get;
var $String$4 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;
var stringSlice$7 = uncurryThis$r(''.slice);
var replace$6 = uncurryThis$r(''.replace);
var join$1 = uncurryThis$r([].join);
var CONFIGURABLE_LENGTH = DESCRIPTORS$a && !fails$r(function () {
  return defineProperty$6(function () {/* empty */}, 'length', {
    value: 8
  }).length !== 8;
});
var TEMPLATE = String(String).split('String');
var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice$7($String$4(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$6($String$4(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$9(value, 'name') || CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name) {
    if (DESCRIPTORS$a) defineProperty$6(value, 'name', {
      value: name,
      configurable: true
    });else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$9(options, 'arity') && value.length !== options.arity) {
    defineProperty$6(value, 'length', {
      value: options.arity
    });
  }
  try {
    if (options && hasOwn$9(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$a) defineProperty$6(value, 'prototype', {
        writable: false
      });
      // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) {/* empty */}
  var state = enforceInternalState(value);
  if (!hasOwn$9(state, 'source')) {
    state.source = join$1(TEMPLATE, typeof name == 'string' ? name : '');
  }
  return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$k(this) && getInternalState$2(this).source || inspectSource$2(this);
}, 'toString');
var isCallable$j = isCallable$s;
var definePropertyModule$3 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltIn$3.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;
var defineBuiltIn$9 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$j(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];else if (O[key]) simple = true;
    } catch (error) {/* empty */}
    if (simple) O[key] = value;else definePropertyModule$3.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  }
  return O;
};
var objectGetOwnPropertyNames = {};
var ceil = Math.ceil;
var floor$3 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$3 : ceil)(n);
};
var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$9 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};
var toIntegerOrInfinity$8 = toIntegerOrInfinity$9;
var max$2 = Math.max;
var min$3 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$8(index);
  return integer < 0 ? max$2(integer + length, 0) : min$3(integer, length);
};
var toIntegerOrInfinity$7 = toIntegerOrInfinity$9;
var min$2 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$3 = function (argument) {
  var len = toIntegerOrInfinity$7(argument);
  return len > 0 ? min$2(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var toLength$2 = toLength$3;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$9 = function (obj) {
  return toLength$2(obj.length);
};
var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$8 = lengthOfArrayLike$9;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$3 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike$8(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    }
    return !IS_INCLUDES && -1;
  };
};
var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$3(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$3(false)
};
var uncurryThis$q = functionUncurryThis;
var hasOwn$8 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;
var push$4 = uncurryThis$q([].push);
var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$8(hiddenKeys$2, key) && hasOwn$8(O, key) && push$4(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$8(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$4(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];
var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;
var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};
var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var getBuiltIn$9 = getBuiltIn$b;
var uncurryThis$p = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$p = anObject$r;
var concat$2 = uncurryThis$p([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$c = getBuiltIn$9('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$p(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};
var hasOwn$7 = hasOwnProperty_1;
var ownKeys$b = ownKeys$c;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$2 = objectDefineProperty;
var copyConstructorProperties$3 = function (target, source, exceptions) {
  var keys = ownKeys$b(source);
  var defineProperty = definePropertyModule$2.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$7(target, key) && !(exceptions && hasOwn$7(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};
var fails$q = fails$y;
var isCallable$i = isCallable$s;
var replacement = /#|\.prototype\./;
var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true : value === NATIVE ? false : isCallable$i(detection) ? fails$q(detection) : !!detection;
};
var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};
var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';
var isForced_1 = isForced$2;
var global$h = global$q;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$7 = createNonEnumerableProperty$9;
var defineBuiltIn$8 = defineBuiltIn$9;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$2 = copyConstructorProperties$3;
var isForced$1 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$h;
  } else if (STATIC) {
    target = global$h[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = global$h[TARGET] && global$h[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$2(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$2(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || targetProperty && targetProperty.sham) {
      createNonEnumerableProperty$7(sourceProperty, 'sham', true);
    }
    defineBuiltIn$8(target, key, sourceProperty, options);
  }
};
var objectDefineProperties = {};
var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};
var DESCRIPTORS$9 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$1 = objectDefineProperty;
var anObject$o = anObject$r;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$9 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$o(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$1.f(O, key = keys[index++], props[key]);
  return O;
};
var getBuiltIn$8 = getBuiltIn$b;
var html$2 = getBuiltIn$8('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */
var anObject$n = anObject$r;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;
var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');
var EmptyConstructor = function () {/* empty */};
var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) {/* ignore */}
  NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
  : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};
hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$n(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};
var wellKnownSymbol$j = wellKnownSymbol$l;
var create$a = objectCreate;
var defineProperty$5 = objectDefineProperty.f;
var UNSCOPABLES = wellKnownSymbol$j('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] === undefined) {
  defineProperty$5(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$a(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$4 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};
var $$J = _export;
var $includes = arrayIncludes.includes;
var fails$p = fails$y;
var addToUnscopables$3 = addToUnscopables$4;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$p(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$J({
  target: 'Array',
  proto: true,
  forced: BROKEN_ON_SPARSE
}, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$3('includes');
var tryToString$3 = tryToString$5;
var $TypeError$f = TypeError;
var deletePropertyOrThrow$2 = function (O, P) {
  if (!delete O[P]) throw new $TypeError$f('Cannot delete property ' + tryToString$3(P) + ' of ' + tryToString$3(O));
};
var wellKnownSymbol$i = wellKnownSymbol$l;
var TO_STRING_TAG$4 = wellKnownSymbol$i('toStringTag');
var test$2 = {};
test$2[TO_STRING_TAG$4] = 'z';
var toStringTagSupport = String(test$2) === '[object z]';
var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$h = isCallable$s;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$h = wellKnownSymbol$l;
var TO_STRING_TAG$3 = wellKnownSymbol$h('toStringTag');
var $Object$1 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () {
  return arguments;
}()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) {/* empty */}
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$8 = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
  // @@toStringTag case
  : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG$3)) == 'string' ? tag
  // builtinTag case
  : CORRECT_ARGUMENTS ? classofRaw$1(O)
  // ES3 arguments fallback
  : (result = classofRaw$1(O)) === 'Object' && isCallable$h(O.callee) ? 'Arguments' : result;
};
var classof$7 = classof$8;
var $String$3 = String;
var toString$g = function (argument) {
  if (classof$7(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String$3(argument);
};
var uncurryThis$o = functionUncurryThis;
var arraySlice$3 = uncurryThis$o([].slice);
var arraySlice$2 = arraySlice$3;
var floor$2 = Math.floor;
var sort = function (array, comparefn) {
  var length = array.length;
  if (length < 8) {
    // insertion sort
    var i = 1;
    var element, j;
    while (i < length) {
      j = i;
      element = array[i];
      while (j && comparefn(array[j - 1], element) > 0) {
        array[j] = array[--j];
      }
      if (j !== i++) array[j] = element;
    }
  } else {
    // merge sort
    var middle = floor$2(length / 2);
    var left = sort(arraySlice$2(array, 0, middle), comparefn);
    var right = sort(arraySlice$2(array, middle), comparefn);
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;
    while (lindex < llength || rindex < rlength) {
      array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    }
  }
  return array;
};
var arraySort = sort;
var fails$o = fails$y;
var arrayMethodIsStrict$2 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$o(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () {
      return 1;
    }, 1);
  });
};
var userAgent$4 = engineUserAgent;
var firefox = userAgent$4.match(/firefox\/(\d+)/i);
var engineFfVersion = !!firefox && +firefox[1];
var UA = engineUserAgent;
var engineIsIeOrEdge = /MSIE|Trident/.test(UA);
var userAgent$3 = engineUserAgent;
var webkit = userAgent$3.match(/AppleWebKit\/(\d+)\./);
var engineWebkitVersion = !!webkit && +webkit[1];
var $$I = _export;
var uncurryThis$n = functionUncurryThis;
var aCallable$i = aCallable$k;
var toObject$9 = toObject$b;
var lengthOfArrayLike$7 = lengthOfArrayLike$9;
var deletePropertyOrThrow$1 = deletePropertyOrThrow$2;
var toString$f = toString$g;
var fails$n = fails$y;
var internalSort = arraySort;
var arrayMethodIsStrict$1 = arrayMethodIsStrict$2;
var FF = engineFfVersion;
var IE_OR_EDGE = engineIsIeOrEdge;
var V8 = engineV8Version;
var WEBKIT = engineWebkitVersion;
var test$1 = [];
var nativeSort = uncurryThis$n(test$1.sort);
var push$3 = uncurryThis$n(test$1.push);

// IE8-
var FAILS_ON_UNDEFINED = fails$n(function () {
  test$1.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails$n(function () {
  test$1.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict$1('sort');
var STABLE_SORT = !fails$n(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;
  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);
    switch (code) {
      case 66:
      case 69:
      case 70:
      case 72:
        value = 3;
        break;
      case 68:
      case 71:
        value = 4;
        break;
      default:
        value = 2;
    }
    for (index = 0; index < 47; index++) {
      test$1.push({
        k: chr + index,
        v: value
      });
    }
  }
  test$1.sort(function (a, b) {
    return b.v - a.v;
  });
  for (index = 0; index < test$1.length; index++) {
    chr = test$1[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }
  return result !== 'DGBEFHACIJK';
});
var FORCED$9 = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;
var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString$f(x) > toString$f(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$$I({
  target: 'Array',
  proto: true,
  forced: FORCED$9
}, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable$i(comparefn);
    var array = toObject$9(this);
    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);
    var items = [];
    var arrayLength = lengthOfArrayLike$7(array);
    var itemsLength, index;
    for (index = 0; index < arrayLength; index++) {
      if (index in array) push$3(items, array[index]);
    }
    internalSort(items, getSortCompare(comparefn));
    itemsLength = lengthOfArrayLike$7(items);
    index = 0;
    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow$1(array, index++);
    return array;
  }
});
var DESCRIPTORS$8 = descriptors;
var uncurryThis$m = functionUncurryThis;
var call$n = functionCall;
var fails$m = fails$y;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$8 = toObject$b;
var IndexedObject$1 = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$4 = Object.defineProperty;
var concat$1 = uncurryThis$m([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign$1 = !$assign || fails$m(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$8 && $assign({
    b: 1
  }, $assign(defineProperty$4({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$4(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), {
    b: 2
  })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) {
    B[chr] = chr;
  });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$8(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$8 || call$n(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  }
  return T;
} : $assign;
var $$H = _export;
var assign$1 = objectAssign$1;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$H({
  target: 'Object',
  stat: true,
  arity: 2,
  forced: Object.assign !== assign$1
}, {
  assign: assign$1
});
var isObject$c = isObject$i;
var classof$6 = classofRaw$2;
var wellKnownSymbol$g = wellKnownSymbol$l;
var MATCH$1 = wellKnownSymbol$g('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$c(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$6(it) === 'RegExp');
};
var isRegExp = isRegexp;
var $TypeError$e = TypeError;
var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw new $TypeError$e("The method doesn't accept regular expressions");
  }
  return it;
};
var wellKnownSymbol$f = wellKnownSymbol$l;
var MATCH = wellKnownSymbol$f('match');
var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) {/* empty */}
  }
  return false;
};
var $$G = _export;
var uncurryThis$l = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible$7 = requireObjectCoercible$a;
var toString$e = toString$g;
var correctIsRegExpLogic = correctIsRegexpLogic;
var stringIndexOf$1 = uncurryThis$l(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$G({
  target: 'String',
  proto: true,
  forced: !correctIsRegExpLogic('includes')
}, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf$1(toString$e(requireObjectCoercible$7(this)), toString$e(notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
  }
});
var isPrototypeOf$4 = objectIsPrototypeOf;
var $TypeError$d = TypeError;
var anInstance$2 = function (it, Prototype) {
  if (isPrototypeOf$4(Prototype, it)) return it;
  throw new $TypeError$d('Incorrect invocation');
};
var fails$l = fails$y;
var correctPrototypeGetter = !fails$l(function () {
  function F() {/* empty */}
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});
var hasOwn$6 = hasOwnProperty_1;
var isCallable$g = isCallable$s;
var toObject$7 = toObject$b;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;
var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject$7(O);
  if (hasOwn$6(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$g(constructor) && object instanceof constructor) {
    return constructor.prototype;
  }
  return object instanceof $Object ? ObjectPrototype : null;
};
var makeBuiltIn = makeBuiltIn$3.exports;
var defineProperty$3 = objectDefineProperty;
var defineBuiltInAccessor$3 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, {
    getter: true
  });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, {
    setter: true
  });
  return defineProperty$3.f(target, name, descriptor);
};
var DESCRIPTORS$7 = descriptors;
var definePropertyModule = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$5;
var createProperty$1 = function (object, key, value) {
  if (DESCRIPTORS$7) definePropertyModule.f(object, key, createPropertyDescriptor$2(0, value));else object[key] = value;
};
var fails$k = fails$y;
var isCallable$f = isCallable$s;
var isObject$b = isObject$i;
var getPrototypeOf$2 = objectGetPrototypeOf;
var defineBuiltIn$7 = defineBuiltIn$9;
var wellKnownSymbol$e = wellKnownSymbol$l;
var ITERATOR$8 = wellKnownSymbol$e('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$4, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$2(getPrototypeOf$2(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$4 = PrototypeOfArrayIteratorPrototype;
  }
}
var NEW_ITERATOR_PROTOTYPE = !isObject$b(IteratorPrototype$4) || fails$k(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$4[ITERATOR$8].call(test) !== test;
});
if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$4 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$f(IteratorPrototype$4[ITERATOR$8])) {
  defineBuiltIn$7(IteratorPrototype$4, ITERATOR$8, function () {
    return this;
  });
}
var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$4,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};
var $$F = _export;
var global$g = global$q;
var anInstance$1 = anInstance$2;
var anObject$m = anObject$r;
var isCallable$e = isCallable$s;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltInAccessor$2 = defineBuiltInAccessor$3;
var createProperty = createProperty$1;
var fails$j = fails$y;
var hasOwn$5 = hasOwnProperty_1;
var wellKnownSymbol$d = wellKnownSymbol$l;
var IteratorPrototype$3 = iteratorsCore.IteratorPrototype;
var DESCRIPTORS$6 = descriptors;
var CONSTRUCTOR = 'constructor';
var ITERATOR$7 = 'Iterator';
var TO_STRING_TAG$2 = wellKnownSymbol$d('toStringTag');
var $TypeError$c = TypeError;
var NativeIterator = global$g[ITERATOR$7];

// FF56- have non-standard global helper `Iterator`
var FORCED$8 = !isCallable$e(NativeIterator) || NativeIterator.prototype !== IteratorPrototype$3
// FF44- non-standard `Iterator` passes previous tests
|| !fails$j(function () {
  NativeIterator({});
});
var IteratorConstructor = function Iterator() {
  anInstance$1(this, IteratorPrototype$3);
  if (getPrototypeOf$1(this) === IteratorPrototype$3) throw new $TypeError$c('Abstract class Iterator not directly constructable');
};
var defineIteratorPrototypeAccessor = function (key, value) {
  if (DESCRIPTORS$6) {
    defineBuiltInAccessor$2(IteratorPrototype$3, key, {
      configurable: true,
      get: function () {
        return value;
      },
      set: function (replacement) {
        anObject$m(this);
        if (this === IteratorPrototype$3) throw new $TypeError$c("You can't redefine this property");
        if (hasOwn$5(this, key)) this[key] = replacement;else createProperty(this, key, replacement);
      }
    });
  } else IteratorPrototype$3[key] = value;
};
if (!hasOwn$5(IteratorPrototype$3, TO_STRING_TAG$2)) defineIteratorPrototypeAccessor(TO_STRING_TAG$2, ITERATOR$7);
if (FORCED$8 || !hasOwn$5(IteratorPrototype$3, CONSTRUCTOR) || IteratorPrototype$3[CONSTRUCTOR] === Object) {
  defineIteratorPrototypeAccessor(CONSTRUCTOR, IteratorConstructor);
}
IteratorConstructor.prototype = IteratorPrototype$3;

// `Iterator` constructor
// https://github.com/tc39/proposal-iterator-helpers
$$F({
  global: true,
  constructor: true,
  forced: FORCED$8
}, {
  Iterator: IteratorConstructor
});
var classofRaw = classofRaw$2;
var uncurryThis$k = functionUncurryThis;
var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$k(fn);
};
var uncurryThis$j = functionUncurryThisClause;
var aCallable$h = aCallable$k;
var NATIVE_BIND$1 = functionBindNative;
var bind$7 = uncurryThis$j(uncurryThis$j.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$h(fn);
  return that === undefined ? fn : NATIVE_BIND$1 ? bind$7(fn, that) : function /* ...args */
  () {
    return fn.apply(that, arguments);
  };
};
var iterators = {};
var wellKnownSymbol$c = wellKnownSymbol$l;
var Iterators$4 = iterators;
var ITERATOR$6 = wellKnownSymbol$c('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$4.Array === it || ArrayPrototype[ITERATOR$6] === it);
};
var classof$5 = classof$8;
var getMethod$4 = getMethod$6;
var isNullOrUndefined$3 = isNullOrUndefined$6;
var Iterators$3 = iterators;
var wellKnownSymbol$b = wellKnownSymbol$l;
var ITERATOR$5 = wellKnownSymbol$b('iterator');
var getIteratorMethod$3 = function (it) {
  if (!isNullOrUndefined$3(it)) return getMethod$4(it, ITERATOR$5) || getMethod$4(it, '@@iterator') || Iterators$3[classof$5(it)];
};
var call$m = functionCall;
var aCallable$g = aCallable$k;
var anObject$l = anObject$r;
var tryToString$2 = tryToString$5;
var getIteratorMethod$2 = getIteratorMethod$3;
var $TypeError$b = TypeError;
var getIterator$1 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$2(argument) : usingIterator;
  if (aCallable$g(iteratorMethod)) return anObject$l(call$m(iteratorMethod, argument));
  throw new $TypeError$b(tryToString$2(argument) + ' is not iterable');
};
var call$l = functionCall;
var anObject$k = anObject$r;
var getMethod$3 = getMethod$6;
var iteratorClose$6 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$k(iterator);
  try {
    innerResult = getMethod$3(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$l(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$k(innerResult);
  return value;
};
var bind$6 = functionBindContext;
var call$k = functionCall;
var anObject$j = anObject$r;
var tryToString$1 = tryToString$5;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike$6 = lengthOfArrayLike$9;
var isPrototypeOf$3 = objectIsPrototypeOf;
var getIterator = getIterator$1;
var getIteratorMethod$1 = getIteratorMethod$3;
var iteratorClose$5 = iteratorClose$6;
var $TypeError$a = TypeError;
var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};
var ResultPrototype = Result.prototype;
var iterate$9 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$6(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;
  var stop = function (condition) {
    if (iterator) iteratorClose$5(iterator, 'normal', condition);
    return new Result(true, condition);
  };
  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$j(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    }
    return INTERRUPTED ? fn(value, stop) : fn(value);
  };
  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$1(iterable);
    if (!iterFn) throw new $TypeError$a(tryToString$1(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$6(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$3(ResultPrototype, result)) return result;
      }
      return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }
  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$k(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose$5(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$3(ResultPrototype, result)) return result;
  }
  return new Result(false);
};

// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
var getIteratorDirect$a = function (obj) {
  return {
    iterator: obj,
    next: obj.next,
    done: false
  };
};
var $$E = _export;
var iterate$8 = iterate$9;
var aCallable$f = aCallable$k;
var anObject$i = anObject$r;
var getIteratorDirect$9 = getIteratorDirect$a;

// `Iterator.prototype.forEach` method
// https://github.com/tc39/proposal-iterator-helpers
$$E({
  target: 'Iterator',
  proto: true,
  real: true
}, {
  forEach: function forEach(fn) {
    anObject$i(this);
    aCallable$f(fn);
    var record = getIteratorDirect$9(this);
    var counter = 0;
    iterate$8(record, function (value) {
      fn(value, counter++);
    }, {
      IS_RECORD: true
    });
  }
});
var defineBuiltIn$6 = defineBuiltIn$9;
var defineBuiltIns$1 = function (target, src, options) {
  for (var key in src) defineBuiltIn$6(target, key, src[key], options);
  return target;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$2 = function (value, done) {
  return {
    value: value,
    done: done
  };
};
var call$j = functionCall;
var create$9 = objectCreate;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$9;
var defineBuiltIns = defineBuiltIns$1;
var wellKnownSymbol$a = wellKnownSymbol$l;
var InternalStateModule$2 = internalState;
var getMethod$2 = getMethod$6;
var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
var createIterResultObject$1 = createIterResultObject$2;
var iteratorClose$4 = iteratorClose$6;
var TO_STRING_TAG$1 = wellKnownSymbol$a('toStringTag');
var ITERATOR_HELPER = 'IteratorHelper';
var WRAP_FOR_VALID_ITERATOR = 'WrapForValidIterator';
var setInternalState$2 = InternalStateModule$2.set;
var createIteratorProxyPrototype = function (IS_ITERATOR) {
  var getInternalState = InternalStateModule$2.getterFor(IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER);
  return defineBuiltIns(create$9(IteratorPrototype$2), {
    next: function next() {
      var state = getInternalState(this);
      // for simplification:
      //   for `%WrapForValidIteratorPrototype%.next` our `nextHandler` returns `IterResultObject`
      //   for `%IteratorHelperPrototype%.next` - just a value
      if (IS_ITERATOR) return state.nextHandler();
      try {
        var result = state.done ? undefined : state.nextHandler();
        return createIterResultObject$1(result, state.done);
      } catch (error) {
        state.done = true;
        throw error;
      }
    },
    'return': function () {
      var state = getInternalState(this);
      var iterator = state.iterator;
      state.done = true;
      if (IS_ITERATOR) {
        var returnMethod = getMethod$2(iterator, 'return');
        return returnMethod ? call$j(returnMethod, iterator) : createIterResultObject$1(undefined, true);
      }
      if (state.inner) try {
        iteratorClose$4(state.inner.iterator, 'normal');
      } catch (error) {
        return iteratorClose$4(iterator, 'throw', error);
      }
      iteratorClose$4(iterator, 'normal');
      return createIterResultObject$1(undefined, true);
    }
  });
};
var WrapForValidIteratorPrototype = createIteratorProxyPrototype(true);
var IteratorHelperPrototype = createIteratorProxyPrototype(false);
createNonEnumerableProperty$6(IteratorHelperPrototype, TO_STRING_TAG$1, 'Iterator Helper');
var iteratorCreateProxy = function (nextHandler, IS_ITERATOR) {
  var IteratorProxy = function Iterator(record, state) {
    if (state) {
      state.iterator = record.iterator;
      state.next = record.next;
    } else state = record;
    state.type = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;
    state.nextHandler = nextHandler;
    state.counter = 0;
    state.done = false;
    setInternalState$2(this, state);
  };
  IteratorProxy.prototype = IS_ITERATOR ? WrapForValidIteratorPrototype : IteratorHelperPrototype;
  return IteratorProxy;
};
var anObject$h = anObject$r;
var iteratorClose$3 = iteratorClose$6;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$2 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$h(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose$3(iterator, 'throw', error);
  }
};
var call$i = functionCall;
var aCallable$e = aCallable$k;
var anObject$g = anObject$r;
var getIteratorDirect$8 = getIteratorDirect$a;
var createIteratorProxy$2 = iteratorCreateProxy;
var callWithSafeIterationClosing$1 = callWithSafeIterationClosing$2;
var IteratorProxy$2 = createIteratorProxy$2(function () {
  var iterator = this.iterator;
  var result = anObject$g(call$i(this.next, iterator));
  var done = this.done = !!result.done;
  if (!done) return callWithSafeIterationClosing$1(iterator, this.mapper, [result.value, this.counter++], true);
});

// `Iterator.prototype.map` method
// https://github.com/tc39/proposal-iterator-helpers
var iteratorMap = function map(mapper) {
  anObject$g(this);
  aCallable$e(mapper);
  return new IteratorProxy$2(getIteratorDirect$8(this), {
    mapper: mapper
  });
};
var $$D = _export;
var map = iteratorMap;
var IS_PURE$2 = isPure;

// `Iterator.prototype.map` method
// https://github.com/tc39/proposal-iterator-helpers
$$D({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: IS_PURE$2
}, {
  map: map
});
const workDays = {
  0: false,
  1: true,
  2: true,
  3: true,
  4: true,
  5: true,
  6: false
};
const getCustomMonthOccurrenceConfig = (booking, newDate) => {
  const day = newDate.getDay();
  const dayOfMonth = newDate.getDate();
  const year = newDate.getFullYear();
  const month = newDate.getMonth();
  if (booking.repeatOnCustom2 === 'DAY') {
    if (dayOfMonth > 5) {
      return {
        repeatOn: RepeatMonthlyOnEnum.DATES,
        repeatOnDates: [dayOfMonth]
      };
    } else {
      return {
        repeatOnCustom1: CUSTOM_MONTH_OCCURRENCE_ORDINAL_IDENTIFIERS[day - 1],
        repeatOnCustom2: 'DAY'
      };
    }
  }
  if (booking.repeatOnCustom2 === 'WEEKDAY' || booking.repeatOnCustom2 === 'WEEKEND_DAY') {
    let weekendDaysCounter = 0;
    let weekDaysCounter = 0;
    const isWeekday = workDays[day];
    for (let i = 1; i <= dayOfMonth; i++) {
      const currentDay = new Date(year, month, i);
      if (workDays[currentDay.getDay()]) {
        weekDaysCounter++;
      } else {
        weekendDaysCounter++;
      }
    }
    if (isWeekday) {
      if (weekDaysCounter > 4) {
        return {
          repeatOn: RepeatMonthlyOnEnum.DATES,
          repeatOnDates: [dayOfMonth]
        };
      } else {
        return {
          repeatOnCustom1: CUSTOM_MONTH_OCCURRENCE_ORDINAL_IDENTIFIERS[weekDaysCounter - 1],
          repeatOnCustom2: 'WEEKDAY'
        };
      }
    } else {
      if (weekendDaysCounter > 4) {
        return {
          repeatOn: RepeatMonthlyOnEnum.DATES,
          repeatOnDates: [dayOfMonth]
        };
      } else {
        return {
          repeatOnCustom1: CUSTOM_MONTH_OCCURRENCE_ORDINAL_IDENTIFIERS[weekendDaysCounter - 1],
          repeatOnCustom2: 'WEEKEND_DAY'
        };
      }
    }
  }
  let daysInMonthCounter = 0;
  let ordinalIdentifier;
  for (let i = 1; i <= 31; i++) {
    const currentDay = new Date(year, month, i);
    if (currentDay.getDay() === day) {
      daysInMonthCounter++;
    }
    if (currentDay.getDate() === newDate.getDate()) {
      ordinalIdentifier = daysInMonthCounter;
      break;
    }
  }
  let newRepeatCustomDay;
  if (booking.repeatOnCustom2 && CUSTOM_MONTH_OCCURRENCE_DAYS.includes(booking.repeatOnCustom2)) {
    newRepeatCustomDay = CUSTOM_MONTH_OCCURRENCE_DAYS[(day + 6) % 7]; // 0 - monday, ...., 6 - sunday
  }
  if (!ordinalIdentifier || !newRepeatCustomDay) {
    return {};
  }
  return {
    repeatOnCustom1: CUSTOM_MONTH_OCCURRENCE_ORDINAL_IDENTIFIERS[ordinalIdentifier - 1],
    repeatOnCustom2: newRepeatCustomDay
  };
};
const calculateNewRepeatOptions = (booking, newDateLike) => {
  var _a;
  if (!booking.repeat || !booking.start || !newDateLike) {
    return {};
  }
  const newDate = toDate$1(newDateLike);
  const diffInDays = calculateDifference(newDate, booking.start);
  if (booking.interval === BookingRepeatEnum.CUSTOM) {
    if (booking.repeatEveryInterval === BookingRepeatIntervalEnum.WEEK) {
      if (diffInDays % 7 === 0) {
        return {};
      }
      const newWeekdays = {
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false
      };
      dayKeys.forEach((day, index) => {
        var _a;
        if ((_a = booking.repeatOnWeekdays) === null || _a === void 0 ? void 0 : _a[day]) {
          let newIndex = (index + diffInDays) % 7;
          if (newIndex < 0) {
            newIndex = newIndex + 7;
          }
          const newDay = dayKeys[newIndex];
          newWeekdays[newDay] = true;
        }
      });
      return {
        repeatOnWeekdays: newWeekdays
      };
    }
    if (booking.repeatEveryInterval === BookingRepeatIntervalEnum.MONTH) {
      if (booking.repeatOn === RepeatMonthlyOnEnum.DATES) {
        const newRepeatOnDates = (_a = booking.repeatOnDates) === null || _a === void 0 ? void 0 : _a.map(date => (date + diffInDays) % 31);
        newRepeatOnDates === null || newRepeatOnDates === void 0 ? void 0 : newRepeatOnDates.sort(sortNumbersCompareFn);
        return {
          repeatOnDates: newRepeatOnDates,
          repeatOnCustom1: null,
          repeatOnCustom2: null
        };
      }
      if (booking.repeatOn === RepeatMonthlyOnEnum.CUSTOM) {
        return Object.assign({
          repeatOnDates: null
        }, getCustomMonthOccurrenceConfig(booking, newDate));
      }
    }
  }
  return {};
};
var aCallable$d = aCallable$k;
var toObject$6 = toObject$b;
var IndexedObject = indexedObject;
var lengthOfArrayLike$5 = lengthOfArrayLike$9;
var $TypeError$9 = TypeError;
var REDUCE_EMPTY = 'Reduce of empty array with no initial value';

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$2 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    var O = toObject$6(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike$5(O);
    aCallable$d(callbackfn);
    if (length === 0 && argumentsLength < 2) throw new $TypeError$9(REDUCE_EMPTY);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw new $TypeError$9(REDUCE_EMPTY);
      }
    }
    for (; IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};
var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$2(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$2(true)
};
var global$f = global$q;
var classof$4 = classofRaw$2;
var engineIsNode = classof$4(global$f.process) === 'process';
var $$C = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$2;
var CHROME_VERSION = engineV8Version;
var IS_NODE$4 = engineIsNode;

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE$4 && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED$7 = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$C({
  target: 'Array',
  proto: true,
  forced: FORCED$7
}, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});
var $$B = _export;
var iterate$7 = iterate$9;
var aCallable$c = aCallable$k;
var anObject$f = anObject$r;
var getIteratorDirect$7 = getIteratorDirect$a;
var $TypeError$8 = TypeError;

// `Iterator.prototype.reduce` method
// https://github.com/tc39/proposal-iterator-helpers
$$B({
  target: 'Iterator',
  proto: true,
  real: true
}, {
  reduce: function reduce(reducer /* , initialValue */) {
    anObject$f(this);
    aCallable$c(reducer);
    var record = getIteratorDirect$7(this);
    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? undefined : arguments[1];
    var counter = 0;
    iterate$7(record, function (value) {
      if (noInitial) {
        noInitial = false;
        accumulator = value;
      } else {
        accumulator = reducer(accumulator, value, counter);
      }
      counter++;
    }, {
      IS_RECORD: true
    });
    if (noInitial) throw new $TypeError$8('Reduce of empty iterator with no initial value');
    return accumulator;
  }
});
const BookingRepeatEndsOnLabels = {
  [RepeatEndsOnEnum.NEVER]: 'Never',
  [RepeatEndsOnEnum.DATE]: 'On date',
  [RepeatEndsOnEnum.AFTERTIMES]: 'No. of occurrences'
};
const bookingRepeatOptions = [{
  label: 'Does not repeat',
  value: BookingRepeatEnum.NONE
}, {
  label: 'Daily',
  value: BookingRepeatEnum.DAILY
}, {
  label: 'Weekly',
  value: BookingRepeatEnum.WEEKLY
}, {
  label: 'Bi Weekly',
  value: BookingRepeatEnum.BI_WEEKLY
}, {
  label: 'Monthly',
  value: BookingRepeatEnum.MONTHLY
}, {
  label: 'Yearly',
  value: BookingRepeatEnum.YEARLY
}, {
  label: 'Custom',
  value: BookingRepeatEnum.CUSTOM
}];
const bookingRepeatOptionsMap = bookingRepeatOptions.reduce((acc, option) => {
  acc[option.value] = option;
  return acc;
}, {});
const repeatIntervalOptions = [{
  label: 'Day/s',
  value: BookingRepeatIntervalEnum.DAY
}, {
  label: 'Week/s',
  value: BookingRepeatIntervalEnum.WEEK
}, {
  label: 'Month/s',
  value: BookingRepeatIntervalEnum.MONTH
}, {
  label: 'Year/s',
  value: BookingRepeatIntervalEnum.YEAR
}];
const repeatIntervalOptionsMap = repeatIntervalOptions.reduce((acc, option) => {
  acc[option.value] = option;
  return acc;
}, {});
const repeatMonthlyOnDatesOption = {
  value: RepeatMonthlyOnEnum.DATES,
  label: 'Monthly on date/s'
};
const repeatMonthlyOnCustomOption = {
  value: RepeatMonthlyOnEnum.CUSTOM,
  label: 'Monthly on the...'
};
const repeatMonthlyOnOptions = [repeatMonthlyOnDatesOption, repeatMonthlyOnCustomOption];
const repeatMonthlyOnCustomOptionsMap = repeatMonthlyOnOptions.reduce((acc, option) => {
  acc[option.value] = option;
  return acc;
}, {});
const normalizeDate = date => {
  return date ? removeUTCZuluFromDateObject(toDate$1(date)) : date;
};
const CustomMonthDatesFormat = props => {
  const {
    days,
    repeatEvery
  } = props;
  if (!(days === null || days === void 0 ? void 0 : days.day) || !(days === null || days === void 0 ? void 0 : days.ordinalIdentifier)) {
    return null;
  }
  const repeatLabel = !repeatEvery || repeatEvery === 1 ? 'every' : "every ".concat(formatOrdinals(repeatEvery));
  return "Booking will occur ".concat(repeatLabel, " month on the ").concat(formatCustomMonthDayOrdinalIdentifiers(days.ordinalIdentifier), " ").concat(formatCustomMonthDay(days.day));
};
const DaysOfMonthFormat = props => {
  const {
    days,
    repeatEvery
  } = props;
  if (!(days === null || days === void 0 ? void 0 : days.length)) {
    return null;
  }
  const repeatLabel = !repeatEvery || repeatEvery === 1 ? 'every' : "every ".concat(formatOrdinals(repeatEvery));
  const daysText = days.map((day, index) => {
    let joinSign = '';
    if (index < days.length - 2) joinSign = ', ';
    if (index === days.length - 2) joinSign = ' and ';
    if (index < days.length - 1) joinSign = ' ';
    return formatOrdinals(day) + joinSign;
  });
  return "Booking will occur ".concat(repeatLabel, " month on the ").concat(daysText);
};
const StyledRepeatEveryTypography = /*#__PURE__*/styled(Typography).withConfig({
  displayName: "booking-repeat-form-part__StyledRepeatEveryTypography",
  componentId: "sc-15eeg6j-0"
})(["min-width:124px;align-self:flex-start;"]);
const AmountInput = /*#__PURE__*/styled(NumberInputReduxFormWrapper).withConfig({
  displayName: "booking-repeat-form-part__AmountInput",
  componentId: "sc-15eeg6j-1"
})(["max-width:75px;"]);
const OccurrencesInput = /*#__PURE__*/styled(NumberInputReduxFormWrapper).withConfig({
  displayName: "booking-repeat-form-part__OccurrencesInput",
  componentId: "sc-15eeg6j-2"
})(["max-width:210px;"]);
const EndDateInput = /*#__PURE__*/styled(DatePickerReduxFormWrapper).withConfig({
  displayName: "booking-repeat-form-part__EndDateInput",
  componentId: "sc-15eeg6j-3"
})(["max-width:210px;"]);
const StyledEndTypography = /*#__PURE__*/styled(Typography).withConfig({
  displayName: "booking-repeat-form-part__StyledEndTypography",
  componentId: "sc-15eeg6j-4"
})(["align-self:flex-start;"]);
const StyledRadio = /*#__PURE__*/styled(Radio).withConfig({
  displayName: "booking-repeat-form-part__StyledRadio",
  componentId: "sc-15eeg6j-5"
})(["&&{margin-left:", "px;}"], props => props.theme.designSpacing['--Spacing-150']);
const StyledEndsSectionWrapper = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "booking-repeat-form-part__StyledEndsSectionWrapper",
  componentId: "sc-15eeg6j-6"
})(["width:302px;"]);
const RepeatIntervalSelect$1 = /*#__PURE__*/styled(SelectReduxFormWrapper).withConfig({
  displayName: "booking-repeat-form-part__RepeatIntervalSelect",
  componentId: "sc-15eeg6j-7"
})(["min-width:130px;"]);
function BookingRepeatFormPart(_ref10) {
  let {
    formName
  } = _ref10;
  const dispatch = useDispatch();
  const formValues = useSelector(getFormValues(formName)) || {};
  const formValueEndDate = formValues.end || formValues.endDate;
  const {
    interval,
    repeatEndsOn,
    repeatEveryInterval
  } = formValues;
  const onRepeatEndsOnChange = useCallback(value => {
    dispatch(touch(formName, 'repeatEndsOn'));
    dispatch(change(formName, 'repeatEndsOn', value));
    if (value === RepeatEndsOnEnum.DATE) {
      dispatch(change(formName, 'repeatEndsAfterTimes', null));
    }
    if (value === RepeatEndsOnEnum.AFTERTIMES) {
      dispatch(change(formName, 'repeatEndsOnDate', null));
    }
    if (value === RepeatEndsOnEnum.NEVER) {
      dispatch(change(formName, 'repeatEndsOnDate', null));
      dispatch(change(formName, 'repeatEndsAfterTimes', null));
    }
  }, [dispatch, formName]);
  return jsxs(Layout, {
    stack: true,
    gap: 24,
    children: [jsx(Typography, {
      variant: "label",
      size: "large",
      prominent: true,
      children: "Booking Repeat"
    }), jsx(Field, {
      name: "interval",
      component: RadioGroupReduxFormWrapper,
      options: bookingRepeatOptions,
      optionLabel: "label",
      optionValue: "value"
    }), interval && interval !== BookingRepeatEnum.NONE ? jsxs(Layout, {
      stack: true,
      gap: "--Spacing-200",
      hAlign: "flex-start",
      children: [interval === BookingRepeatEnum.CUSTOM ? jsxs(Layout, {
        stack: true,
        gap: "--Spacing-200",
        children: [jsx(StyledRepeatEveryTypography, {
          variant: "label",
          size: "medium",
          prominent: true,
          color: "on-surface-variant",
          children: "Repeat every"
        }), jsxs(Layout, {
          vAlign: "center",
          gap: "--Spacing-200",
          children: [jsx(Field, {
            component: AmountInput,
            normalize: normalizeIntegerNumber,
            type: "number",
            label: "Amount",
            name: "repeatEveryTime",
            dataCy: "repeat-every-time",
            step: 1
          }), jsx(Field, {
            name: "repeatEveryInterval",
            component: RepeatIntervalSelect$1,
            options: repeatIntervalOptions,
            disableClearable: true,
            label: "",
            optionLabel: "label",
            optionValue: "value",
            dataCy: "repeat-every-time-select"
          })]
        })]
      }) : null, jsxs(StyledEndsSectionWrapper, {
        stack: true,
        gap: "--Spacing-200",
        children: [jsx(StyledEndTypography, {
          variant: "label",
          size: "medium",
          prominent: true,
          color: "on-surface-variant",
          children: "Ends"
        }), jsxs(Layout, {
          vAlign: "center",
          hAlign: "space-between",
          children: [jsx(Layout, {
            vAlign: "center",
            children: jsx(StyledRadio, {
              dataCy: "repeat-ends-on-date",
              name: "repeatEndsOn",
              value: "DATE",
              checked: repeatEndsOn === RepeatEndsOnEnum.DATE,
              onChange: () => {
                onRepeatEndsOnChange(repeatEndsOn === RepeatEndsOnEnum.DATE ? null : RepeatEndsOnEnum.DATE);
              },
              label: jsx(Typography, {
                variant: "body",
                size: "medium",
                color: "on-surface-variant",
                children: "On"
              })
            })
          }), jsx(Field, {
            dataCy: "repeat-ends-on-date-picker",
            normalize: normalizeDate,
            component: EndDateInput,
            label: "Date",
            name: "repeatEndsOnDate",
            onOpen: () => {
              dispatch(change(formName, 'repeatEndsOn', RepeatEndsOnEnum.DATE));
            },
            disabledDays: day => {
              if (!formValueEndDate) {
                return false;
              }
              return isBefore(day, formValueEndDate, 'day');
            },
            initialMonthDate: formValueEndDate
          })]
        }), jsxs(Layout, {
          vAlign: "center",
          hAlign: "space-between",
          children: [jsx(Layout, {
            vAlign: "center",
            children: jsx(StyledRadio, {
              name: "ends",
              value: "AFTERTIMES",
              dataCy: "repeat-ends-after-times",
              checked: repeatEndsOn === RepeatEndsOnEnum.AFTERTIMES,
              onChange: () => {
                onRepeatEndsOnChange(repeatEndsOn === RepeatEndsOnEnum.AFTERTIMES ? null : RepeatEndsOnEnum.AFTERTIMES);
              },
              label: jsx(Typography, {
                variant: "body",
                size: "medium",
                color: "on-surface-variant",
                children: "After"
              })
            })
          }), jsx(Field, {
            component: OccurrencesInput,
            normalize: normalizeIntegerNumber,
            type: "number",
            name: "repeatEndsAfterTimes",
            endAdornment: "Occurrences",
            label: "Occurrences",
            dataCy: "after-times-number-input",
            step: 1,
            onClick: () => {
              dispatch(change(formName, 'repeatEndsOn', RepeatEndsOnEnum.AFTERTIMES));
            }
          })]
        }), jsx(Layout, {
          vAlign: "center",
          children: jsx(StyledRadio, {
            dataCy: "repeat-never-ends",
            name: "ends",
            value: "NEVER",
            checked: repeatEndsOn === RepeatEndsOnEnum.NEVER,
            onChange: () => {
              onRepeatEndsOnChange(repeatEndsOn === RepeatEndsOnEnum.NEVER ? null : RepeatEndsOnEnum.NEVER);
            },
            label: jsx(Typography, {
              variant: "body",
              size: "medium",
              color: "on-surface-variant",
              children: "Never"
            })
          })
        })]
      })]
    }) : null, interval === BookingRepeatEnum.CUSTOM && (repeatEveryInterval === null || repeatEveryInterval === void 0 ? void 0 : repeatEveryInterval.value) === BookingRepeatIntervalEnum.WEEK ? jsx(WeekRepeatInterval, {
      formName: formName
    }) : null, interval === BookingRepeatEnum.CUSTOM && (repeatEveryInterval === null || repeatEveryInterval === void 0 ? void 0 : repeatEveryInterval.value) === BookingRepeatIntervalEnum.MONTH ? jsx(MonthRepeatInterval, {
      formName: formName
    }) : null]
  });
}
const WeekRepeatInterval = _ref11 => {
  let {
    formName
  } = _ref11;
  const dispatch = useDispatch();
  const formSelector = useMemo(() => {
    return getFormValues(formName);
  }, [formName]);
  const {
    repeatOnWeekdays = {
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      sunday: false,
      saturday: false,
      friday: false
    }
  } = useSelector(formSelector);
  const onRepeatOnWeekdaysChange = useCallback(value => {
    dispatch(touch(formName, 'repeatOnWeekdays'));
    dispatch(change(formName, 'repeatOnWeekdays', value));
  }, [dispatch, formName]);
  return jsxs(Layout, {
    stack: true,
    gap: "--Spacing-100",
    children: [jsx(Typography, {
      variant: "body",
      size: "medium",
      children: "Repeat On"
    }), jsx(WeekDaysCheckboxList, {
      value: repeatOnWeekdays,
      onChange: onRepeatOnWeekdaysChange
    })]
  });
};
const MonthRepeatInterval = _ref12 => {
  let {
    formName
  } = _ref12;
  var _a, _b;
  const dispatch = useDispatch();
  const formSelector = useMemo(() => {
    return getFormValues(formName);
  }, [formName]);
  const {
    repeatOn,
    repeatOnDates = [],
    repeatOnCustom1,
    repeatOnCustom2,
    repeatEveryTime
  } = useSelector(formSelector) || {};
  const meta = useSelector(getFormMeta(formName)) || {};
  const syncErrors = useSelector(getFormSyncErrors(formName)) || {};
  const repeatOnCustomDates = useMemo(() => {
    return {
      ordinalIdentifier: repeatOnCustom1,
      day: repeatOnCustom2
    };
  }, [repeatOnCustom1, repeatOnCustom2]);
  const {
    open: openRepeatOnDates,
    isOpen: isOpenRepeatOnDates,
    anchorElement: anchorElementRepeatOnDates,
    close: closeRepeatOnDates
  } = useOpenState();
  const {
    open: openRepeatOnCustomDates,
    isOpen: isOpenRepeatOnCustomDates,
    anchorElement: anchorElementRepeatOnCustomDates,
    close: closeRepeatOnCustomDates
  } = useOpenState();
  const handleRepeatOnCustom1Change = useCallback(value => {
    dispatch(touch(formName, 'repeatOnCustom1'));
    dispatch(change(formName, 'repeatOnCustom1', value));
  }, [dispatch, formName]);
  const handleRepeatOnCustom2Change = useCallback(value => {
    dispatch(touch(formName, 'repeatOnCustom2'));
    dispatch(change(formName, 'repeatOnCustom2', value));
  }, [dispatch, formName]);
  const handleRepeatOnDatesChange = useCallback(value => {
    dispatch(touch(formName, 'repeatOnDates'));
    dispatch(change(formName, 'repeatOnDates', value));
  }, [dispatch, formName]);
  const onRepeatOnChange = useCallback(value => {
    dispatch(touch(formName, 'repeatOn'));
    dispatch(change(formName, 'repeatOn', value));
    if (value === 'DATES') {
      dispatch(change(formName, 'repeatOnCustom1', null));
      dispatch(change(formName, 'repeatOnCustom2', null));
    } else if (value === 'CUSTOM') {
      dispatch(change(formName, 'repeatOnDates', []));
    }
  }, [dispatch, formName]);
  const handleRepeatOnDates = useCallback(event => {
    onRepeatOnChange('DATES');
    openRepeatOnDates(event);
  }, [onRepeatOnChange, openRepeatOnDates]);
  const handleRepeatOnCustomDates = useCallback(event => {
    onRepeatOnChange('CUSTOM');
    openRepeatOnCustomDates(event);
  }, [onRepeatOnChange, openRepeatOnCustomDates]);
  return jsxs(Layout, {
    stack: true,
    gap: "--Spacing-100",
    children: [jsx(Typography, {
      variant: "body",
      size: "medium",
      children: "Repeat On"
    }), repeatOn === 'DATES' ? jsx(Typography, {
      variant: "body",
      size: "small",
      color: "on-surface-variant",
      children: jsx(DaysOfMonthFormat, {
        days: repeatOnDates,
        repeatEvery: repeatEveryTime
      })
    }) : null, repeatOn === 'CUSTOM' ? jsx(Typography, {
      variant: "body",
      size: "small",
      color: "on-surface-variant",
      children: jsx(CustomMonthDatesFormat, {
        days: repeatOnCustomDates,
        repeatEvery: repeatEveryTime
      })
    }) : null, jsxs(Layout, {
      gap: "--Spacing-200",
      vAlign: "center",
      children: [jsx(Radio, {
        name: "repeatOn",
        dataCy: "month-repeat-interval-on-dates",
        value: "DATES",
        checked: repeatOn === 'DATES',
        label: "On select date/s",
        onChange: handleRepeatOnDates,
        onClick: handleRepeatOnDates
      }), isOpenRepeatOnDates ? jsx(DaysOfMonthSelectDialog, {
        selected: repeatOnDates,
        anchorElement: anchorElementRepeatOnDates,
        open: isOpenRepeatOnDates,
        onClose: () => {
          dispatch(touch(formName, 'repeatOnDates'));
          closeRepeatOnDates();
        },
        onSelect: value => {
          handleRepeatOnDatesChange(value);
          closeRepeatOnDates();
        }
      }) : null, repeatOn === 'DATES' && ((_a = meta.repeatOnDates) === null || _a === void 0 ? void 0 : _a.touched) && syncErrors.repeatOnDates ? jsx(Typography, {
        variant: "body",
        size: "small",
        color: "error",
        children: "Missing value, please select dates"
      }) : null, jsx(Radio, {
        name: "repeatOn",
        dataCy: "month-repeat-interval-on-custom",
        value: "CUSTOM",
        checked: repeatOn === 'CUSTOM',
        label: "on the...",
        onChange: handleRepeatOnCustomDates,
        onClick: handleRepeatOnCustomDates
      }), isOpenRepeatOnCustomDates ? jsx(CustomMonthDatesSelectDialog, {
        value: repeatOnCustomDates,
        onClose: () => {
          dispatch(touch(formName, 'repeatOnCustom1'));
          dispatch(touch(formName, 'repeatOnCustom2'));
          closeRepeatOnCustomDates();
        },
        open: isOpenRepeatOnCustomDates,
        anchorElement: anchorElementRepeatOnCustomDates,
        onSelect: value => {
          handleRepeatOnCustom1Change(value.ordinalIdentifier);
          handleRepeatOnCustom2Change(value.day);
          closeRepeatOnCustomDates();
        }
      }) : null, repeatOn === 'CUSTOM' && ((_b = meta.repeatOnCustom1) === null || _b === void 0 ? void 0 : _b.touched) && syncErrors.repeatOnCustom1 ? jsx(Typography, {
        variant: "body",
        size: "small",
        color: "error",
        children: "Missing value"
      }) : null]
    })]
  });
};
var $$A = _export;
var iterate$6 = iterate$9;
var aCallable$b = aCallable$k;
var anObject$e = anObject$r;
var getIteratorDirect$6 = getIteratorDirect$a;

// `Iterator.prototype.find` method
// https://github.com/tc39/proposal-iterator-helpers
$$A({
  target: 'Iterator',
  proto: true,
  real: true
}, {
  find: function find(predicate) {
    anObject$e(this);
    aCallable$b(predicate);
    var record = getIteratorDirect$6(this);
    var counter = 0;
    return iterate$6(record, function (value, stop) {
      if (predicate(value, counter++)) return stop(value);
    }, {
      IS_RECORD: true,
      INTERRUPTED: true
    }).result;
  }
});
var $$z = _export;
var call$h = functionCall;
var aCallable$a = aCallable$k;
var anObject$d = anObject$r;
var getIteratorDirect$5 = getIteratorDirect$a;
var createIteratorProxy$1 = iteratorCreateProxy;
var callWithSafeIterationClosing = callWithSafeIterationClosing$2;
var IS_PURE$1 = isPure;
var IteratorProxy$1 = createIteratorProxy$1(function () {
  var iterator = this.iterator;
  var predicate = this.predicate;
  var next = this.next;
  var result, done, value;
  while (true) {
    result = anObject$d(call$h(next, iterator));
    done = this.done = !!result.done;
    if (done) return;
    value = result.value;
    if (callWithSafeIterationClosing(iterator, predicate, [value, this.counter++], true)) return value;
  }
});

// `Iterator.prototype.filter` method
// https://github.com/tc39/proposal-iterator-helpers
$$z({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: IS_PURE$1
}, {
  filter: function filter(predicate) {
    anObject$d(this);
    aCallable$a(predicate);
    return new IteratorProxy$1(getIteratorDirect$5(this), {
      predicate: predicate
    });
  }
});
const getExtensionByShortId = (extensions, shortId) => {
  return extensions.find(extension => extension.shortId === shortId);
};
const isActive = (extensions, shortId) => {
  const extension = getExtensionByShortId(extensions, shortId);
  return Boolean(extension === null || extension === void 0 ? void 0 : extension.installed);
};
const DEFAULT_PROJECT_STATUSES = [{
  display: 'Active',
  value: ProjectStatusEnum.STATUS_ACTIVE
}, {
  display: 'Pending',
  value: ProjectStatusEnum.STATUS_PENDING
}, {
  display: 'Floating',
  value: ProjectStatusEnum.STATUS_FLOATING
}, {
  display: 'Planned',
  value: ProjectStatusEnum.STATUS_PLANNED
}, {
  display: 'Archived',
  value: ProjectStatusEnum.STATUS_ARCHIVED
}];
const EMPTY_ARRAY$1 = [];
const selectCompany = state => state.companyReducer.company;
const selectCalendars = state => selectCompany(state).calendars;
const selectExtensions = state => selectCompany(state).extensions;
const selectBookingDefaultState = state => selectCompany(state).settings.grid.bookingDefaultState;
const selectUseCategoriesAllocation = state => selectCompany(state).settings.useCategoriesAllocation;
const selectCompanyAvgDailyCapacity = state => selectCompany(state).settings.report.avgDailyCapacity;
const selectIsDefaultVacationEventSet = state => Boolean(selectCompany(state).settings.vacationBookingCategoryId);
const selectDefaultVacationId = state => selectCompany(state).settings.vacationId;
const selectSickLeaveId = state => selectCompany(state).settings.sickLeaveId;
const selectWeekDaysSetting = state => selectCompany(state).settings.weekDays;
const selectCompanyStartEndTimes = state => state.companyReducer.startEndTimes;
const selectCompanyApproversBase = state => state.companyReducer.approvers;
const selectCompanyDeadlinesBeforeBookingEndDateConfig = state => state.companyReducer.company.settings.grid.deadlineBeforeBookingEndDate;
const selectCatColorDisplayNew = state => state.companyReducer.company.settings.grid.catColorDisplayNew;
const selectIsCategoryColorUsed = createSelector(selectCatColorDisplayNew, catColorDisplayNew => {
  return catColorDisplayNew === CatColorDisplayNewEnum.CATEGORY_COLOR_BOOKING;
});
const selectCompanyApprovers = createSelector(selectCompanyApproversBase, approvers => {
  return (approvers !== null && approvers !== void 0 ? approvers : []).map(approver => {
    return Object.assign(Object.assign({}, approver), {
      name: "".concat(approver.firstName, " ").concat(approver.lastName)
    });
  });
});
const makeSelectHolidaysByCalendarIds = function () {
  let calendarIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return createSelector(selectCalendars, calendars => {
    let selectedCalendars = calendars;
    if (calendarIds.length) {
      const idsMap = calendarIds.reduce((acc, id) => {
        acc[id] = true;
        return acc;
      }, {});
      selectedCalendars = calendars.filter(calendar => idsMap[calendar._id]);
    } else {
      return EMPTY_ARRAY$1;
    }
    const holidays = selectedCalendars.reduce((acc, calendar) => {
      const calendarHolidays = calendar.holidays;
      return acc.concat(calendarHolidays);
    }, []);
    holidays.sort((a, b) => {
      return a.date > b.date ? 1 : -1;
    });
    return holidays;
  });
};
const makeIsExtensionInstalled = extensionName => createSelector(selectExtensions, extensions => {
  return isActive(extensions, extensionName);
});
const selectIsApprovalExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.APPROVAL);
const selectIsAuditLogExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.AUDIT_LOGS);
const selectIsCategoryGroupsExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.CATEGORY_GROUPS);
const selectIsCustomColumnsExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.CUSTOM_COLUMNS);
const selectIsCustomFieldsExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.CUSTOM_FIELDS);
const selectIsDeadlinesExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.DEADLINES);
const selectIsDependenciesExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.DEPENDENCIES);
const selectIsExtendedDashboardExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.EXTENDED_DASHBOARD);
const selectIsFixedCostsExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.FIXED_COSTS);
const selectIsHolidayCalendarsExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.HOLIDAY_CALENDARS);
const selectIsMFAExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.MFA);
const selectIsMyDashboardExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.MY_DASHBOARD);
const selectIsPMExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.PM);
const selectIsSidebarProExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.SIDEBAR_PRO);
const selectIsSSOExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.SINGLE_SIGN_ON);
const selectIsResourceRateExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.RESOURCE_RATE);
const selectIsResourceRequestExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.RESOURCE_REQUEST);
const selectIsSmartFiltersExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.SMART_FILTERS);
const selectIsSmartGroupsExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.SMART_GROUPS);
const selectIsSmartSchedulesExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.SMART_SCHEDULES);
const selectIsTasksExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.TASKS);
const selectIsToilExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.TOIL);
const selectIsTimeSheetsExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.TIME_SHEET);
const selectIsUnassignedExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.UNASSIGNED);
const selectIsVacationRequestExtensionInstalled = makeIsExtensionInstalled(ExtensionsEnum.VACATION_REQUEST);
const selectAppKeyWords = createSelector(selectCompany, company => {
  const keyWords = company.settings.keyword;
  return {
    resourceKeyWord: keyWords.keyword2Singular,
    resourcePluralKeyWord: keyWords.keyword2Plural,
    projectKeyWord: keyWords.keyword1Singular,
    projectPluralKeyWord: keyWords.keyword1Plural,
    customerKeyWord: keyWords.keyword3Singular,
    customerPluralKeyWord: keyWords.keyword3Plural,
    vacationEventName: company.settings.vacationEventName
  };
});
const selectProjectStatuses = createSelector(selectCompany, company => {
  var _a;
  if (!((_a = company === null || company === void 0 ? void 0 : company.settings) === null || _a === void 0 ? void 0 : _a.projectStatus)) {
    return DEFAULT_PROJECT_STATUSES;
  }
  return company.settings.projectStatus.map(status => ({
    display: status.name,
    value: status.status
  }));
});
const selectProjectStatusesMapped = createSelector(selectProjectStatuses, statuses => {
  return statuses.reduce((acc, status) => {
    acc[status.value] = status;
    return acc;
  }, {});
});
const useAppKeyWords = () => {
  return useSelector(selectAppKeyWords);
};
const OPERATORS = [{
  name: 'Equal',
  description: 'Is equal to',
  value: 'eq',
  match: (match, value) => value === match,
  icon: 'equals'
}, {
  name: 'Not equal',
  description: 'Is not equal to',
  value: 'ne',
  match: (match, value) => value !== match,
  icon: 'notEquals'
}, {
  name: 'Less than',
  description: 'Less than',
  value: 'lt',
  match: (match, value) => value < match,
  icon: 'lessThan'
}, {
  name: 'Greater than',
  description: 'Greater than',
  value: 'gt',
  match: (match, value) => value > match,
  icon: 'greaterThan'
}, {
  name: 'Less than or equal',
  description: 'Less than or equal',
  value: 'lte',
  match: (match, value) => value <= match,
  icon: 'lessThanOrEqual'
}, {
  name: 'Greater than or equal',
  description: 'Greater than or equal',
  value: 'gte',
  match: (match, value) => value >= match,
  icon: 'greaterThanOrEqual'
}];
const getOperatorsWithDataCy = key => {
  return OPERATORS.map(operator => {
    return Object.assign(Object.assign({}, operator), {
      'data-cy': "".concat(key, "-operator-").concat(operator.value)
    });
  });
};
const BuilderWrapper = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "common__BuilderWrapper",
  componentId: "sc-1esu42g-0"
})(["width:100%;height:100%;min-height:0;@media (max-height:700px){min-height:1000px;}"]);
const BuilderHeaderWrapper = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "common__BuilderHeaderWrapper",
  componentId: "sc-1esu42g-1"
})(["min-height:56px;"]);
const BuilderListWrapper = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "common__BuilderListWrapper",
  componentId: "sc-1esu42g-2"
})(["height:100%;width:100%;min-height:0;flex-grow:1;padding:", "px;border-radius:4px;border:1px solid ", ";background-color:", ";"], props => props.theme.designSpacing['--Spacing-50'], props => props.theme.designTokens.color.color.light['outline-variant'].value, props => props.theme.designTokens.color.color.surfaces['background'].value);
const SelectedListWrapper = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "common__SelectedListWrapper",
  componentId: "sc-1esu42g-3"
})(["height:100%;width:100%;flex-grow:1;min-height:0;padding:", "px;border:0;overflow:auto;"], props => props.theme.designSpacing['--Spacing-50']);
const StyledAvailableListItem = /*#__PURE__*/styled(ListItem).withConfig({
  displayName: "common__StyledAvailableListItem",
  componentId: "sc-1esu42g-4"
})(["min-height:64px;"]);
const StyledSelectedListItem = /*#__PURE__*/styled(ListItem).withConfig({
  displayName: "common__StyledSelectedListItem",
  componentId: "sc-1esu42g-5"
})(["min-height:64px;border:1px solid ", ";background-color:", ";"], props => props.theme.designTokens.color.color.surfaces['surface-container'].value, props => props.theme.designTokens.color.color.surfaces['surface-container-high'].value);
const EmptyLayout = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "common__EmptyLayout",
  componentId: "sc-1esu42g-6"
})(["height:100%;width:100%;flex-grow:1;border-radius:4px;border:1px dashed ", ";"], props => props.theme.designTokens.color.color.light.outline.value);
const BuilderEmptyList = _ref13 => {
  let {
    text,
    title,
    icon: _icon = 'searchFace'
  } = _ref13;
  return jsxs(EmptyLayout, {
    stack: true,
    vAlign: "center",
    gap: "--Spacing-100",
    hAlign: "center",
    pl: 28,
    pr: 28,
    children: [jsx(Icon, {
      name: _icon,
      size: 111
    }), title ? jsx(Typography, {
      variant: "label",
      size: "large",
      prominent: true,
      children: title
    }) : null, text ? jsx(Typography, {
      variant: "body",
      size: "small",
      color: "on-surface-variant",
      align: "center",
      children: text
    }) : null]
  });
};
const ALL = {
  value: 'ALL',
  name: 'All'
};
const ANY = {
  value: 'ANY',
  name: 'Any'
};
const filterRelationsMap = {
  ALL,
  ANY
};
const filterRelationsArray = [ALL, ANY];
const FilterRelationFormat = props => {
  const {
    relation
  } = props;
  if (!relation) {
    return null;
  }
  return jsxs(Typography, {
    variant: "body",
    size: "small",
    prominent: true,
    tagName: "span",
    children: ["Matches", ' ', jsx(Typography, {
      variant: "label",
      size: "large",
      prominent: true,
      tagName: "span",
      children: filterRelationsMap[relation].name
    }), ' ', "filters below."]
  });
};
var FilterRelationFormat$1 = /*#__PURE__*/React__default.memo(FilterRelationFormat);
const BUDGET_STATUSES = [{
  name: 'Not set',
  value: 'not_set'
}, {
  name: 'Over Budget',
  value: 'over'
}, {
  name: 'Under Budget',
  value: 'under'
}, {
  name: 'On Budget',
  value: 'on'
}, {
  name: 'No Budget',
  value: 'no'
}];
const Row$6 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "budget-status-filter__Row",
  componentId: "sc-115pgn4-0"
})(["min-height:56px;padding:8px 16px;"]);
function BudgetStatusFilter(props) {
  const {
    budgetStatus,
    budgetRange,
    onChange
  } = props;
  const {
    projectKeyWord
  } = useAppKeyWords();
  const handleBudgetStatusChange = useCallback((event, statusOption) => {
    onChange({
      budgetStatus: statusOption.value
    });
  }, [onChange]);
  const handleBudgetOperatorChange = useCallback((event, operatorOption) => {
    onChange({
      budgetRange: Object.assign(Object.assign({}, budgetRange), {
        operator: operatorOption.value
      })
    });
  }, [budgetRange, onChange]);
  const handleBudgetValueChange = useCallback((event, value) => {
    onChange({
      budgetRange: Object.assign(Object.assign({}, budgetRange), {
        value
      })
    });
  }, [budgetRange, onChange]);
  const budgetOperatorOptions = useMemo(() => {
    return getOperatorsWithDataCy("budget-range-operator");
  }, []);
  const budgetOperatorSelectedOption = useMemo(() => {
    return budgetOperatorOptions.find(operator => operator.value === budgetRange.operator);
  }, [budgetOperatorOptions, budgetRange.operator]);
  const selectedBudgetStatus = useMemo(() => {
    return BUDGET_STATUSES.find(status => status.value === budgetStatus);
  }, [budgetStatus]);
  return jsxs(BuilderWrapper, {
    stack: true,
    gap: "--Spacing-100",
    children: [jsxs(BuilderHeaderWrapper, {
      stack: true,
      gap: "--Spacing-50",
      vAlign: "flex-end",
      children: [jsxs(Typography, {
        variant: "label",
        size: "xl",
        children: [projectKeyWord, " Budget"]
      }), jsx(FilterRelationFormat, {
        relation: "ANY"
      })]
    }), jsxs(BuilderListWrapper, {
      stack: true,
      pt: "--Spacing-200",
      children: [jsx(Row$6, {
        gap: "--Spacing-100",
        vAlign: "center",
        children: jsx(Select, {
          label: "Budget status",
          name: "budget-status",
          dataCy: "budget-status",
          value: selectedBudgetStatus,
          onChange: handleBudgetStatusChange,
          options: BUDGET_STATUSES,
          optionLabel: "name",
          optionValue: "value",
          disableClearable: true
        })
      }), jsxs(Row$6, {
        gap: "--Spacing-100",
        vAlign: "center",
        children: [jsx(Select, {
          label: "Budget range",
          name: "budget-range-operator",
          dataCy: "budget-range-operator",
          onChange: handleBudgetOperatorChange,
          value: budgetOperatorSelectedOption,
          options: budgetOperatorOptions,
          optionLabel: "name",
          optionValue: "value",
          disableClearable: true
        }), jsx(NumberInput, {
          label: "Value",
          name: "budget-range-value",
          dataCy: "budget-range-value",
          value: budgetRange.value,
          onChange: handleBudgetValueChange
        })]
      })]
    })]
  });
}
var defineProperty$2 = objectDefineProperty.f;
var hasOwn$4 = hasOwnProperty_1;
var wellKnownSymbol$9 = wellKnownSymbol$l;
var TO_STRING_TAG = wellKnownSymbol$9('toStringTag');
var setToStringTag$4 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$4(target, TO_STRING_TAG)) {
    defineProperty$2(target, TO_STRING_TAG, {
      configurable: true,
      value: TAG
    });
  }
};
var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$1 = objectCreate;
var createPropertyDescriptor$1 = createPropertyDescriptor$5;
var setToStringTag$3 = setToStringTag$4;
var Iterators$2 = iterators;
var returnThis$1 = function () {
  return this;
};
var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$1(IteratorPrototype$1, {
    next: createPropertyDescriptor$1(+!ENUMERABLE_NEXT, next)
  });
  setToStringTag$3(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};
var uncurryThis$i = functionUncurryThis;
var aCallable$9 = aCallable$k;
var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$i(aCallable$9(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) {/* empty */}
};
var isObject$a = isObject$i;
var isPossiblePrototype$1 = function (argument) {
  return isObject$a(argument) || argument === null;
};
var isPossiblePrototype = isPossiblePrototype$1;
var $String$2 = String;
var $TypeError$7 = TypeError;
var aPossiblePrototype$1 = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError$7("Can't set " + $String$2(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor$1 = functionUncurryThisAccessor;
var isObject$9 = isObject$i;
var requireObjectCoercible$6 = requireObjectCoercible$a;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor$1(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) {/* empty */}
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible$6(O);
    aPossiblePrototype(proto);
    if (!isObject$9(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);else O.__proto__ = proto;
    return O;
  };
}() : undefined);
var $$y = _export;
var call$g = functionCall;
var FunctionName = functionName;
var isCallable$d = isCallable$s;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$3 = objectSetPrototypeOf;
var setToStringTag$2 = setToStringTag$4;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$9;
var defineBuiltIn$5 = defineBuiltIn$9;
var wellKnownSymbol$8 = wellKnownSymbol$l;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;
var PROPER_FUNCTION_NAME$2 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$4 = wellKnownSymbol$8('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';
var returnThis = function () {
  return this;
};
var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);
  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS:
        return function keys() {
          return new IteratorConstructor(this, KIND);
        };
      case VALUES:
        return function values() {
          return new IteratorConstructor(this, KIND);
        };
      case ENTRIES:
        return function entries() {
          return new IteratorConstructor(this, KIND);
        };
    }
    return function () {
      return new IteratorConstructor(this);
    };
  };
  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$4] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$3) {
          setPrototypeOf$3(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$d(CurrentIteratorPrototype[ITERATOR$4])) {
          defineBuiltIn$5(CurrentIteratorPrototype, ITERATOR$4, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$2(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$2 && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$5(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() {
        return call$g(nativeIterator, this);
      };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$5(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$y({
      target: NAME,
      proto: true,
      forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
    }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$4] !== defaultIterator) {
    defineBuiltIn$5(IterablePrototype, ITERATOR$4, defaultIterator, {
      name: DEFAULT
    });
  }
  Iterators$1[NAME] = defaultIterator;
  return methods;
};
var toIndexedObject = toIndexedObject$5;
var addToUnscopables$2 = addToUnscopables$4;
var Iterators = iterators;
var InternalStateModule$1 = internalState;
var defineProperty$1 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject = createIterResultObject$2;
var DESCRIPTORS$5 = descriptors;
var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState$1 = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated),
    // target
    index: 0,
    // next index
    kind: kind // kind
  });
  // `%ArrayIteratorPrototype%.next` method
  // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  switch (state.kind) {
    case 'keys':
      return createIterResultObject(index, false);
    case 'values':
      return createIterResultObject(target[index], false);
  }
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$2('keys');
addToUnscopables$2('values');
addToUnscopables$2('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$5 && values.name !== 'values') try {
  defineProperty$1(values, 'name', {
    value: 'values'
  });
} catch (error) {/* empty */}

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;
var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;
var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;
var global$e = global$q;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$9;
var setToStringTag$1 = setToStringTag$4;
var wellKnownSymbol$7 = wellKnownSymbol$l;
var ITERATOR$3 = wellKnownSymbol$7('iterator');
var ArrayValues = ArrayIteratorMethods.values;
var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$3] !== ArrayValues) try {
      createNonEnumerableProperty$4(CollectionPrototype, ITERATOR$3, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$3] = ArrayValues;
    }
    setToStringTag$1(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$4(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};
for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$e[COLLECTION_NAME] && global$e[COLLECTION_NAME].prototype, COLLECTION_NAME);
}
handlePrototype(DOMTokenListPrototype, 'DOMTokenList');
function FilterCondition(props) {
  const {
    onChange,
    value,
    dataCy,
    tooltip,
    disabled
  } = props;
  const btnsDisabled = value === undefined || disabled;
  return jsxs(Layout, {
    gap: "--Spacing-100",
    children: [jsx(Tooltip, {
      title: tooltip || 'Is equal to',
      children: jsx(IconButton, {
        disabled: btnsDisabled,
        icon: "equals",
        size: "small",
        variant: value ? 'tonal' : 'outlined',
        dataCy: dataCy ? "".concat(dataCy, "-is-equal-to") : undefined,
        onClick: event => onChange(event, true)
      })
    }), jsx(Tooltip, {
      title: tooltip || 'Is not equal to',
      children: jsx(IconButton, {
        disabled: btnsDisabled,
        icon: "notEquals",
        size: "small",
        variant: !value ? 'tonal' : 'outlined',
        dataCy: dataCy ? "".concat(dataCy, "-is-not-equal-to") : undefined,
        onClick: event => onChange(event, false)
      })
    })]
  });
}
var FilterCondition$1 = /*#__PURE__*/React__default.memo(FilterCondition);
const FilterRelationToggle = props => {
  const {
    onChange,
    value,
    tooltip,
    disabled
  } = props;
  return jsxs(Layout, {
    gap: "--Spacing-100",
    hAlign: "flex-start",
    vAlign: "center",
    children: [filterRelationsArray.map(filterRelation => jsx(Chip, {
      label: filterRelation.name,
      onClick: event => onChange(filterRelation.value),
      disabled: disabled,
      dataCy: "relation-button--".concat(filterRelation.name),
      startIcon: value === filterRelation.value ? 'check' : undefined,
      selected: value === filterRelation.value
    }, filterRelation.value)), tooltip ? jsx(Tooltip, {
      title: tooltip,
      children: jsx(Icon, {
        name: "info"
      })
    }) : null]
  });
};
var FilterRelationToggle$1 = /*#__PURE__*/React__default.memo(FilterRelationToggle);
const isValueObject = value => {
  return Boolean(value && typeof value === 'object');
};
function BuilderCheckboxList(props) {
  const {
    header,
    filterRelation,
    onFilterRelationChange,
    options,
    optionLabel,
    optionValue,
    selected,
    withFilterCondition,
    onChange,
    dataCy,
    useValueToDataCy
  } = props;
  const selectedMapped = useMemo(() => {
    return (selected || []).reduce((acc, selectedItem) => {
      if (isValueObject(selectedItem)) {
        acc[selectedItem.value] = selectedItem;
      } else {
        acc[selectedItem] = selectedItem;
      }
      return acc;
    }, {});
  }, [selected]);
  const onItemClick = useCallback((checked, rowItem) => {
    const rowItemValue = rowItem[optionValue];
    if (checked) {
      if (withFilterCondition) {
        onChange([...(selected || []), {
          value: rowItemValue,
          set: true
        }]);
      } else {
        return onChange([...(selected || []), rowItemValue]);
      }
    } else {
      if (withFilterCondition) {
        onChange((selected || []).filter(selectedItem => selectedItem.value !== rowItemValue));
      } else {
        onChange((selected || []).filter(selectedItem => selectedItem !== rowItemValue));
      }
    }
  }, [onChange, optionValue, selected, withFilterCondition]);
  const rowRenderer = useCallback(rowItem => {
    const rowItemValue = rowItem[optionValue];
    const rowItemLabel = rowItem[optionLabel];
    const selectedValue = selectedMapped[rowItemValue];
    return jsx(ListItem, {
      noWrap: true,
      density: -2,
      onClick: () => {
        onItemClick(!selectedValue, rowItem);
      },
      label: rowItem[optionLabel],
      labelTooltip: rowItem[optionLabel],
      startAdornment: jsx(Layout, {
        flex: "0 0 20px",
        children: jsx(Checkbox, {
          dataCy: dataCy ? "".concat(dataCy, "-checkbox-").concat(useValueToDataCy ? rowItemValue : rowItemLabel) : undefined,
          checked: Boolean(selectedValue),
          onChange: event => {
            onItemClick(event.target.checked, rowItem);
          }
        })
      }),
      endAdornment: withFilterCondition ? jsx(Layout, {
        children: jsx(FilterCondition$1, {
          dataCy: "".concat(dataCy, "-").concat(useValueToDataCy ? rowItemValue : rowItemLabel),
          disabled: rowItem.deleted,
          tooltip: rowItem.deleted ? "Unable to edit: This filter has been deleted." : undefined,
          value: isValueObject(selectedValue) ? selectedValue.set : undefined,
          onChange: (event, value) => {
            event.stopPropagation();
            if (isValueObject(selectedValue) && withFilterCondition) {
              onChange([...(selected || []).filter(selectedItem => selectedItem.value !== rowItemValue), {
                value: rowItemValue,
                set: value
              }]);
            }
          }
        })
      }) : null
    });
  }, [dataCy, onChange, onItemClick, optionLabel, optionValue, selected, selectedMapped, useValueToDataCy, withFilterCondition]);
  const allSelected = selected.length === options.length;
  const indeterminate = Boolean(selected.length && selected.length !== options.length);
  const handleSelectAllClick = useCallback(() => {
    if (allSelected) {
      onChange([]);
    } else {
      if (withFilterCondition) {
        onChange(options.map(option => {
          const currentValue = selectedMapped[option[optionValue]];
          return {
            value: option[optionValue],
            set: isValueObject(currentValue) && currentValue.set !== undefined ? currentValue.set : true
          };
        }));
      } else {
        onChange(options.map(option => option[optionValue]));
      }
    }
  }, [allSelected, onChange, optionValue, options, selectedMapped, withFilterCondition]);
  return jsxs(BuilderWrapper, {
    stack: true,
    gap: "--Spacing-100",
    children: [jsxs(BuilderHeaderWrapper, {
      stack: true,
      gap: "--Spacing-50",
      vAlign: "flex-end",
      children: [jsx(Typography, {
        variant: "label",
        size: "xl",
        children: header
      }), onFilterRelationChange ? jsx(FilterRelationToggle$1, {
        value: filterRelation,
        onChange: onFilterRelationChange,
        tooltip: "Choose to match All or Any of the filter combinations in the filter panels below."
      }) : jsx(FilterRelationFormat$1, {
        relation: filterRelation
      })]
    }), jsxs(BuilderListWrapper, {
      stack: true,
      flex: "1 1 auto",
      children: [jsx(Layout, {
        pl: "--Spacing-50",
        children: jsx(Checkbox, {
          name: "select-all",
          dataCy: "checkbox-list-select-all",
          checked: allSelected,
          indeterminate: indeterminate,
          onChange: handleSelectAllClick,
          label: jsx(Typography, {
            variant: "body",
            size: "medium",
            tagName: "span",
            children: "Select All"
          })
        })
      }), jsx(List$1, {
        virtualized: true,
        items: options,
        rowRenderer: rowRenderer
      })]
    })]
  });
}
var $$x = _export;
var iterate$5 = iterate$9;
var aCallable$8 = aCallable$k;
var anObject$c = anObject$r;
var getIteratorDirect$4 = getIteratorDirect$a;

// `Iterator.prototype.some` method
// https://github.com/tc39/proposal-iterator-helpers
$$x({
  target: 'Iterator',
  proto: true,
  real: true
}, {
  some: function some(predicate) {
    anObject$c(this);
    aCallable$8(predicate);
    var record = getIteratorDirect$4(this);
    var counter = 0;
    return iterate$5(record, function (value, stop) {
      if (predicate(value, counter++)) return stop();
    }, {
      IS_RECORD: true,
      INTERRUPTED: true
    }).stopped;
  }
});
var uncurryThis$h = functionUncurryThis;

// eslint-disable-next-line es/no-set -- safe
var SetPrototype$1 = Set.prototype;
var setHelpers = {
  // eslint-disable-next-line es/no-set -- safe
  Set: Set,
  add: uncurryThis$h(SetPrototype$1.add),
  has: uncurryThis$h(SetPrototype$1.has),
  remove: uncurryThis$h(SetPrototype$1['delete']),
  proto: SetPrototype$1
};
var has$8 = setHelpers.has;

// Perform ? RequireInternalSlot(M, [[SetData]])
var aSet$7 = function (it) {
  has$8(it);
  return it;
};
var call$f = functionCall;
var iterateSimple$7 = function (record, fn, ITERATOR_INSTEAD_OF_RECORD) {
  var iterator = ITERATOR_INSTEAD_OF_RECORD ? record : record.iterator;
  var next = record.next;
  var step, result;
  while (!(step = call$f(next, iterator)).done) {
    result = fn(step.value);
    if (result !== undefined) return result;
  }
};
var uncurryThis$g = functionUncurryThis;
var iterateSimple$6 = iterateSimple$7;
var SetHelpers$5 = setHelpers;
var Set$3 = SetHelpers$5.Set;
var SetPrototype = SetHelpers$5.proto;
var forEach$1 = uncurryThis$g(SetPrototype.forEach);
var keys = uncurryThis$g(SetPrototype.keys);
var next = keys(new Set$3()).next;
var setIterate = function (set, fn, interruptible) {
  return interruptible ? iterateSimple$6({
    iterator: keys(set),
    next: next
  }, fn) : forEach$1(set, fn);
};
var SetHelpers$4 = setHelpers;
var iterate$4 = setIterate;
var Set$2 = SetHelpers$4.Set;
var add$3 = SetHelpers$4.add;
var setClone = function (set) {
  var result = new Set$2();
  iterate$4(set, function (it) {
    add$3(result, it);
  });
  return result;
};
var uncurryThisAccessor = functionUncurryThisAccessor;
var SetHelpers$3 = setHelpers;
var setSize = uncurryThisAccessor(SetHelpers$3.proto, 'size', 'get') || function (set) {
  return set.size;
};
var aCallable$7 = aCallable$k;
var anObject$b = anObject$r;
var call$e = functionCall;
var toIntegerOrInfinity$6 = toIntegerOrInfinity$9;
var getIteratorDirect$3 = getIteratorDirect$a;
var INVALID_SIZE = 'Invalid size';
var $RangeError$2 = RangeError;
var $TypeError$6 = TypeError;
var max$1 = Math.max;
var SetRecord = function (set, intSize) {
  this.set = set;
  this.size = max$1(intSize, 0);
  this.has = aCallable$7(set.has);
  this.keys = aCallable$7(set.keys);
};
SetRecord.prototype = {
  getIterator: function () {
    return getIteratorDirect$3(anObject$b(call$e(this.keys, this.set)));
  },
  includes: function (it) {
    return call$e(this.has, this.set, it);
  }
};

// `GetSetRecord` abstract operation
// https://tc39.es/proposal-set-methods/#sec-getsetrecord
var getSetRecord$7 = function (obj) {
  anObject$b(obj);
  var numSize = +obj.size;
  // NOTE: If size is undefined, then numSize will be NaN
  // eslint-disable-next-line no-self-compare -- NaN check
  if (numSize !== numSize) throw new $TypeError$6(INVALID_SIZE);
  var intSize = toIntegerOrInfinity$6(numSize);
  if (intSize < 0) throw new $RangeError$2(INVALID_SIZE);
  return new SetRecord(obj, intSize);
};
var aSet$6 = aSet$7;
var SetHelpers$2 = setHelpers;
var clone$3 = setClone;
var size$5 = setSize;
var getSetRecord$6 = getSetRecord$7;
var iterateSet$2 = setIterate;
var iterateSimple$5 = iterateSimple$7;
var has$7 = SetHelpers$2.has;
var remove$1 = SetHelpers$2.remove;

// `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods
var setDifference = function difference(other) {
  var O = aSet$6(this);
  var otherRec = getSetRecord$6(other);
  var result = clone$3(O);
  if (size$5(O) <= otherRec.size) iterateSet$2(O, function (e) {
    if (otherRec.includes(e)) remove$1(result, e);
  });else iterateSimple$5(otherRec.getIterator(), function (e) {
    if (has$7(O, e)) remove$1(result, e);
  });
  return result;
};
var getBuiltIn$7 = getBuiltIn$b;
var createSetLike = function (size) {
  return {
    size: size,
    has: function () {
      return false;
    },
    keys: function () {
      return {
        next: function () {
          return {
            done: true
          };
        }
      };
    }
  };
};
var setMethodAcceptSetLike$7 = function (name) {
  var Set = getBuiltIn$7('Set');
  try {
    new Set()[name](createSetLike(0));
    try {
      // late spec change, early WebKit ~ Safari 17.0 beta implementation does not pass it
      // https://github.com/tc39/proposal-set-methods/pull/88
      new Set()[name](createSetLike(-1));
      return false;
    } catch (error2) {
      return true;
    }
  } catch (error) {
    return false;
  }
};
var $$w = _export;
var difference = setDifference;
var setMethodAcceptSetLike$6 = setMethodAcceptSetLike$7;

// `Set.prototype.difference` method
// https://github.com/tc39/proposal-set-methods
$$w({
  target: 'Set',
  proto: true,
  real: true,
  forced: !setMethodAcceptSetLike$6('difference')
}, {
  difference: difference
});
var aSet$5 = aSet$7;
var SetHelpers$1 = setHelpers;
var size$4 = setSize;
var getSetRecord$5 = getSetRecord$7;
var iterateSet$1 = setIterate;
var iterateSimple$4 = iterateSimple$7;
var Set$1 = SetHelpers$1.Set;
var add$2 = SetHelpers$1.add;
var has$6 = SetHelpers$1.has;

// `Set.prototype.intersection` method
// https://github.com/tc39/proposal-set-methods
var setIntersection = function intersection(other) {
  var O = aSet$5(this);
  var otherRec = getSetRecord$5(other);
  var result = new Set$1();
  if (size$4(O) > otherRec.size) {
    iterateSimple$4(otherRec.getIterator(), function (e) {
      if (has$6(O, e)) add$2(result, e);
    });
  } else {
    iterateSet$1(O, function (e) {
      if (otherRec.includes(e)) add$2(result, e);
    });
  }
  return result;
};
var $$v = _export;
var fails$i = fails$y;
var intersection = setIntersection;
var setMethodAcceptSetLike$5 = setMethodAcceptSetLike$7;
var INCORRECT = !setMethodAcceptSetLike$5('intersection') || fails$i(function () {
  // eslint-disable-next-line es/no-array-from, es/no-set -- testing
  return String(Array.from(new Set([1, 2, 3]).intersection(new Set([3, 2])))) !== '3,2';
});

// `Set.prototype.intersection` method
// https://github.com/tc39/proposal-set-methods
$$v({
  target: 'Set',
  proto: true,
  real: true,
  forced: INCORRECT
}, {
  intersection: intersection
});
var aSet$4 = aSet$7;
var has$5 = setHelpers.has;
var size$3 = setSize;
var getSetRecord$4 = getSetRecord$7;
var iterateSet = setIterate;
var iterateSimple$3 = iterateSimple$7;
var iteratorClose$2 = iteratorClose$6;

// `Set.prototype.isDisjointFrom` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isDisjointFrom
var setIsDisjointFrom = function isDisjointFrom(other) {
  var O = aSet$4(this);
  var otherRec = getSetRecord$4(other);
  if (size$3(O) <= otherRec.size) return iterateSet(O, function (e) {
    if (otherRec.includes(e)) return false;
  }, true) !== false;
  var iterator = otherRec.getIterator();
  return iterateSimple$3(iterator, function (e) {
    if (has$5(O, e)) return iteratorClose$2(iterator, 'normal', false);
  }) !== false;
};
var $$u = _export;
var isDisjointFrom = setIsDisjointFrom;
var setMethodAcceptSetLike$4 = setMethodAcceptSetLike$7;

// `Set.prototype.isDisjointFrom` method
// https://github.com/tc39/proposal-set-methods
$$u({
  target: 'Set',
  proto: true,
  real: true,
  forced: !setMethodAcceptSetLike$4('isDisjointFrom')
}, {
  isDisjointFrom: isDisjointFrom
});
var aSet$3 = aSet$7;
var size$2 = setSize;
var iterate$3 = setIterate;
var getSetRecord$3 = getSetRecord$7;

// `Set.prototype.isSubsetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSubsetOf
var setIsSubsetOf = function isSubsetOf(other) {
  var O = aSet$3(this);
  var otherRec = getSetRecord$3(other);
  if (size$2(O) > otherRec.size) return false;
  return iterate$3(O, function (e) {
    if (!otherRec.includes(e)) return false;
  }, true) !== false;
};
var $$t = _export;
var isSubsetOf = setIsSubsetOf;
var setMethodAcceptSetLike$3 = setMethodAcceptSetLike$7;

// `Set.prototype.isSubsetOf` method
// https://github.com/tc39/proposal-set-methods
$$t({
  target: 'Set',
  proto: true,
  real: true,
  forced: !setMethodAcceptSetLike$3('isSubsetOf')
}, {
  isSubsetOf: isSubsetOf
});
var aSet$2 = aSet$7;
var has$4 = setHelpers.has;
var size$1 = setSize;
var getSetRecord$2 = getSetRecord$7;
var iterateSimple$2 = iterateSimple$7;
var iteratorClose$1 = iteratorClose$6;

// `Set.prototype.isSupersetOf` method
// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSupersetOf
var setIsSupersetOf = function isSupersetOf(other) {
  var O = aSet$2(this);
  var otherRec = getSetRecord$2(other);
  if (size$1(O) < otherRec.size) return false;
  var iterator = otherRec.getIterator();
  return iterateSimple$2(iterator, function (e) {
    if (!has$4(O, e)) return iteratorClose$1(iterator, 'normal', false);
  }) !== false;
};
var $$s = _export;
var isSupersetOf = setIsSupersetOf;
var setMethodAcceptSetLike$2 = setMethodAcceptSetLike$7;

// `Set.prototype.isSupersetOf` method
// https://github.com/tc39/proposal-set-methods
$$s({
  target: 'Set',
  proto: true,
  real: true,
  forced: !setMethodAcceptSetLike$2('isSupersetOf')
}, {
  isSupersetOf: isSupersetOf
});
var aSet$1 = aSet$7;
var SetHelpers = setHelpers;
var clone$2 = setClone;
var getSetRecord$1 = getSetRecord$7;
var iterateSimple$1 = iterateSimple$7;
var add$1 = SetHelpers.add;
var has$3 = SetHelpers.has;
var remove = SetHelpers.remove;

// `Set.prototype.symmetricDifference` method
// https://github.com/tc39/proposal-set-methods
var setSymmetricDifference = function symmetricDifference(other) {
  var O = aSet$1(this);
  var keysIter = getSetRecord$1(other).getIterator();
  var result = clone$2(O);
  iterateSimple$1(keysIter, function (e) {
    if (has$3(O, e)) remove(result, e);else add$1(result, e);
  });
  return result;
};
var $$r = _export;
var symmetricDifference = setSymmetricDifference;
var setMethodAcceptSetLike$1 = setMethodAcceptSetLike$7;

// `Set.prototype.symmetricDifference` method
// https://github.com/tc39/proposal-set-methods
$$r({
  target: 'Set',
  proto: true,
  real: true,
  forced: !setMethodAcceptSetLike$1('symmetricDifference')
}, {
  symmetricDifference: symmetricDifference
});
var aSet = aSet$7;
var add = setHelpers.add;
var clone$1 = setClone;
var getSetRecord = getSetRecord$7;
var iterateSimple = iterateSimple$7;

// `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods
var setUnion = function union(other) {
  var O = aSet(this);
  var keysIter = getSetRecord(other).getIterator();
  var result = clone$1(O);
  iterateSimple(keysIter, function (it) {
    add(result, it);
  });
  return result;
};
var $$q = _export;
var union = setUnion;
var setMethodAcceptSetLike = setMethodAcceptSetLike$7;

// `Set.prototype.union` method
// https://github.com/tc39/proposal-set-methods
$$q({
  target: 'Set',
  proto: true,
  real: true,
  forced: !setMethodAcceptSetLike('union')
}, {
  union: union
});
var anObject$a = anObject$r;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$a(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};
var fails$h = fails$y;
var global$d = global$q;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$d.RegExp;
var UNSUPPORTED_Y$2 = fails$h(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$2 || fails$h(function () {
  return !$RegExp$2('a', 'y').sticky;
});
var BROKEN_CARET = UNSUPPORTED_Y$2 || fails$h(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});
var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$2
};
var fails$g = fails$y;
var global$c = global$q;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$c.RegExp;
var regexpUnsupportedDotAll = fails$g(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});
var fails$f = fails$y;
var global$b = global$q;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$b.RegExp;
var regexpUnsupportedNcg = fails$f(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' || 'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$d = functionCall;
var uncurryThis$f = functionUncurryThis;
var toString$d = toString$g;
var regexpFlags = regexpFlags$1;
var stickyHelpers$1 = regexpStickyHelpers;
var shared = shared$4;
var create = objectCreate;
var getInternalState = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;
var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$6 = uncurryThis$f(''.charAt);
var indexOf = uncurryThis$f(''.indexOf);
var replace$5 = uncurryThis$f(''.replace);
var stringSlice$6 = uncurryThis$f(''.slice);
var UPDATES_LAST_INDEX_WRONG = function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$d(nativeExec, re1, 'a');
  call$d(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var UNSUPPORTED_Y$1 = stickyHelpers$1.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1 || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;
if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString$d(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$d(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }
    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = call$d(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
      flags = replace$5(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }
      strCopy = stringSlice$6(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$6(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }
    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = call$d(nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
      if (match) {
        match.input = stringSlice$6(match.input, charsAdded);
        match[0] = stringSlice$6(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$d(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }
    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }
    return match;
  };
}
var regexpExec$2 = patchedExec;
var $$p = _export;
var exec$3 = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$p({
  target: 'RegExp',
  proto: true,
  forced: /./.exec !== exec$3
}, {
  exec: exec$3
});
var NATIVE_BIND = functionBindNative;
var FunctionPrototype = Function.prototype;
var apply$4 = FunctionPrototype.apply;
var call$c = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call$c.bind(apply$4) : function () {
  return call$c.apply(apply$4, arguments);
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var call$b = functionCall;
var defineBuiltIn$4 = defineBuiltIn$9;
var regexpExec$1 = regexpExec$2;
var fails$e = fails$y;
var wellKnownSymbol$6 = wellKnownSymbol$l;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$9;
var SPECIES$4 = wellKnownSymbol$6('species');
var RegExpPrototype$2 = RegExp.prototype;
var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$6(KEY);
  var DELEGATES_TO_SYMBOL = !fails$e(function () {
    // String methods call symbol-named RegExp methods
    var O = {};
    O[SYMBOL] = function () {
      return 7;
    };
    return ''[KEY](O) !== 7;
  });
  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$e(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$4] = function () {
        return re;
      };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }
    re.exec = function () {
      execCalled = true;
      return null;
    };
    re[SYMBOL]('');
    return !execCalled;
  });
  if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype$2.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return {
            done: true,
            value: call$b(nativeRegExpMethod, regexp, str, arg2)
          };
        }
        return {
          done: true,
          value: call$b(nativeMethod, str, regexp, arg2)
        };
      }
      return {
        done: false
      };
    });
    defineBuiltIn$4(String.prototype, KEY, methods[0]);
    defineBuiltIn$4(RegExpPrototype$2, SYMBOL, methods[1]);
  }
  if (SHAM) createNonEnumerableProperty$3(RegExpPrototype$2[SYMBOL], 'sham', true);
};
var uncurryThis$e = functionUncurryThis;
var toIntegerOrInfinity$5 = toIntegerOrInfinity$9;
var toString$c = toString$g;
var requireObjectCoercible$5 = requireObjectCoercible$a;
var charAt$5 = uncurryThis$e(''.charAt);
var charCodeAt$1 = uncurryThis$e(''.charCodeAt);
var stringSlice$5 = uncurryThis$e(''.slice);
var createMethod$1 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$c(requireObjectCoercible$5($this));
    var position = toIntegerOrInfinity$5(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt$1(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt$1(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt$5(S, position) : first : CONVERT_TO_STRING ? stringSlice$5(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};
var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$1(true)
};
var charAt$4 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$2 = function (S, index, unicode) {
  return index + (unicode ? charAt$4(S, index).length : 1);
};
var uncurryThis$d = functionUncurryThis;
var toObject$5 = toObject$b;
var floor$1 = Math.floor;
var charAt$3 = uncurryThis$d(''.charAt);
var replace$4 = uncurryThis$d(''.replace);
var stringSlice$4 = uncurryThis$d(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject$5(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$4(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt$3(ch, 0)) {
      case '$':
        return '$';
      case '&':
        return matched;
      case '`':
        return stringSlice$4(str, 0, position);
      case "'":
        return stringSlice$4(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$4(ch, 1, -1)];
        break;
      default:
        // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor$1(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt$3(ch, 1) : captures[f - 1] + charAt$3(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};
var call$a = functionCall;
var anObject$9 = anObject$r;
var isCallable$c = isCallable$s;
var classof$3 = classofRaw$2;
var regexpExec = regexpExec$2;
var $TypeError$5 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$c(exec)) {
    var result = call$a(exec, R, S);
    if (result !== null) anObject$9(result);
    return result;
  }
  if (classof$3(R) === 'RegExp') return call$a(regexpExec, R, S);
  throw new $TypeError$5('RegExp#exec called on incompatible receiver');
};
var apply$3 = functionApply;
var call$9 = functionCall;
var uncurryThis$c = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var fails$d = fails$y;
var anObject$8 = anObject$r;
var isCallable$b = isCallable$s;
var isNullOrUndefined$2 = isNullOrUndefined$6;
var toIntegerOrInfinity$4 = toIntegerOrInfinity$9;
var toLength$1 = toLength$3;
var toString$b = toString$g;
var requireObjectCoercible$4 = requireObjectCoercible$a;
var advanceStringIndex$1 = advanceStringIndex$2;
var getMethod$1 = getMethod$6;
var getSubstitution = getSubstitution$1;
var regExpExec$1 = regexpExecAbstract;
var wellKnownSymbol$5 = wellKnownSymbol$l;
var REPLACE = wellKnownSymbol$5('replace');
var max = Math.max;
var min$1 = Math.min;
var concat = uncurryThis$c([].concat);
var push$2 = uncurryThis$c([].push);
var stringIndexOf = uncurryThis$c(''.indexOf);
var stringSlice$3 = uncurryThis$c(''.slice);
var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
}();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
}();
var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$d(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = {
      a: '7'
    };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic$1('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
  return [
  // `String.prototype.replace` method
  // https://tc39.es/ecma262/#sec-string.prototype.replace
  function replace(searchValue, replaceValue) {
    var O = requireObjectCoercible$4(this);
    var replacer = isNullOrUndefined$2(searchValue) ? undefined : getMethod$1(searchValue, REPLACE);
    return replacer ? call$9(replacer, searchValue, O, replaceValue) : call$9(nativeReplace, toString$b(O), searchValue, replaceValue);
  },
  // `RegExp.prototype[@@replace]` method
  // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
  function (string, replaceValue) {
    var rx = anObject$8(this);
    var S = toString$b(string);
    if (typeof replaceValue == 'string' && stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && stringIndexOf(replaceValue, '$<') === -1) {
      var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
      if (res.done) return res.value;
    }
    var functionalReplace = isCallable$b(replaceValue);
    if (!functionalReplace) replaceValue = toString$b(replaceValue);
    var global = rx.global;
    var fullUnicode;
    if (global) {
      fullUnicode = rx.unicode;
      rx.lastIndex = 0;
    }
    var results = [];
    var result;
    while (true) {
      result = regExpExec$1(rx, S);
      if (result === null) break;
      push$2(results, result);
      if (!global) break;
      var matchStr = toString$b(result[0]);
      if (matchStr === '') rx.lastIndex = advanceStringIndex$1(S, toLength$1(rx.lastIndex), fullUnicode);
    }
    var accumulatedResult = '';
    var nextSourcePosition = 0;
    for (var i = 0; i < results.length; i++) {
      result = results[i];
      var matched = toString$b(result[0]);
      var position = max(min$1(toIntegerOrInfinity$4(result.index), S.length), 0);
      var captures = [];
      var replacement;
      // NOTE: This is equivalent to
      //   captures = result.slice(1).map(maybeToString)
      // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
      // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
      // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
      for (var j = 1; j < result.length; j++) push$2(captures, maybeToString(result[j]));
      var namedCaptures = result.groups;
      if (functionalReplace) {
        var replacerArgs = concat([matched], captures, position, S);
        if (namedCaptures !== undefined) push$2(replacerArgs, namedCaptures);
        replacement = toString$b(apply$3(replaceValue, undefined, replacerArgs));
      } else {
        replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
      }
      if (position >= nextSourcePosition) {
        accumulatedResult += stringSlice$3(S, nextSourcePosition, position) + replacement;
        nextSourcePosition = position + matched.length;
      }
    }
    return accumulatedResult + stringSlice$3(S, nextSourcePosition);
  }];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);
const createCySelector = function () {
  let selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return selector.replace(/\s/g, '-').toLowerCase();
};
const StyledChip = /*#__PURE__*/styled(Chip).withConfig({
  displayName: "cross-filter__StyledChip",
  componentId: "sc-1spkqlu-0"
})(["&&{height:44px;}"]);
const StyledListItem$2 = /*#__PURE__*/styled(ListItem).withConfig({
  displayName: "cross-filter__StyledListItem",
  componentId: "sc-1spkqlu-1"
})(["min-height:62px;"]);
const StyledBuilderListWrapper$2 = /*#__PURE__*/styled(BuilderListWrapper).withConfig({
  displayName: "cross-filter__StyledBuilderListWrapper",
  componentId: "sc-1spkqlu-2"
})(["padding-top:", "px;"], props => props.noFilterButtons ? 16 : 4);
const StyledList$2 = /*#__PURE__*/styled(List$1).withConfig({
  displayName: "cross-filter__StyledList",
  componentId: "sc-1spkqlu-3"
})(["min-height:0;"]);
const otherType = {
  PROJECT: 'EVENT',
  EVENT: 'PROJECT',
  RESOURCE: 'UNASSIGNED',
  UNASSIGNED: 'RESOURCE'
};
function CrossFilterComponent(props) {
  const {
    title,
    items,
    selected,
    subItemType,
    onSubItemTypeChange,
    onChange,
    groups = [],
    checkedGroups = [],
    onCheckGroups,
    noFilterButtons,
    filterRelation
  } = props;
  const {
    anchorElement,
    open,
    isOpen,
    close
  } = useOpenState();
  const {
    value: searchInputValue,
    setDebouncedValue: setFilterText,
    debounced: searchInputDebouncedValue
  } = useDebouncedValue({
    defaultValue: ''
  });
  const tabsOptions = useCrossFilterTabsOptions(subItemType);
  const visibleGroups = useMemo(() => {
    return groups.filter(group => {
      switch (subItemType) {
        case 'RESOURCE':
          return group.criteria !== 'UNASSIGNED';
        case 'UNASSIGNED':
          return group.criteria === 'UNASSIGNED';
        case 'PROJECT':
          return group.criteria !== 'EVENT';
        case 'EVENT':
          return group.criteria === 'EVENT';
        default:
          return false;
      }
    });
  }, [groups, subItemType]);
  const itemsMapped = useMemo(() => {
    return items.reduce((acc, item) => {
      acc[item.value] = item;
      return acc;
    }, {});
  }, [items]);
  const subItems = useMemo(() => {
    return items.filter(item => item.subItemType === subItemType);
  }, [items, subItemType]);
  const filteredItems = useMemo(() => {
    return subItems.filter(item => {
      return searchStringCompare(item.label, searchInputDebouncedValue) && (item.deleted || checkedGroups.filter(Boolean).some(group => item.groupIdsMapped[group._id]));
    });
  }, [checkedGroups, searchInputDebouncedValue, subItems]);
  const selectedMapped = useMemo(() => {
    const result = selected.reduce((acc, selectedItemValue) => {
      const selectedItem = itemsMapped[selectedItemValue];
      if (selectedItem) {
        acc[selectedItem.subItemType].collection[selectedItem.value] = selectedItem;
        acc[selectedItem.subItemType].set.add(selectedItem.value);
      }
      return acc;
    }, {
      PROJECT: {
        collection: {},
        set: new Set(),
        count: 0
      },
      EVENT: {
        collection: {},
        set: new Set(),
        count: 0
      },
      RESOURCE: {
        collection: {},
        set: new Set(),
        count: 0
      },
      UNASSIGNED: {
        collection: {},
        set: new Set(),
        count: 0
      }
    });
    result.PROJECT.count = result.PROJECT.set.size;
    result.EVENT.count = result.EVENT.set.size;
    result.RESOURCE.count = result.RESOURCE.set.size;
    result.UNASSIGNED.count = result.UNASSIGNED.set.size;
    return result;
  }, [itemsMapped, selected]);
  const handleSelectAllClick = useCallback(event => {
    const restSelected = selectedMapped[otherType[subItemType]].set;
    if (event.target.checked) {
      const newSelected = filteredItems.map(item => item.value);
      onChange(newSelected.concat(Array.from(restSelected)));
    } else {
      const currentlySelected = selectedMapped[subItemType].set;
      filteredItems.forEach(item => {
        currentlySelected.delete(item.value);
      });
      onChange(Array.from(currentlySelected).concat(Array.from(restSelected)));
    }
  }, [filteredItems, onChange, selectedMapped, subItemType]);
  const onCheckNode = useCallback(groups => {
    onCheckGroups === null || onCheckGroups === void 0 ? void 0 : onCheckGroups(groups, subItemType);
  }, [onCheckGroups, subItemType]);
  const rowRenderer = useCallback(item => {
    return jsx(StyledListItem$2, {
      noWrap: true,
      density: -2,
      label: item.label,
      labelTooltip: item.label,
      supportingText: item.subText,
      startAdornment: jsx(Layout, {
        flex: "0 0 40px",
        children: jsx(Checkbox, {
          dataCy: "checkbox-list-option-".concat(createCySelector(item.label)),
          checked: Boolean(selectedMapped[item.subItemType].collection[item.value]),
          onChange: event => {
            const newSelected = selectedMapped[item.subItemType].set;
            const restSelected = selectedMapped[otherType[item.subItemType]].set;
            if (event.target.checked) {
              onChange(Array.from(newSelected).concat([item.value]).concat(Array.from(restSelected)));
            } else {
              newSelected.delete(item.value);
              onChange(Array.from(newSelected).concat(Array.from(restSelected)));
            }
          }
        })
      })
    });
  }, [onChange, selectedMapped]);
  const filteredItemsCount = filteredItems.length;
  const noOfSelectedVisibleItems = useMemo(() => {
    return filteredItems.reduce((acc, option) => {
      return selectedMapped[option.subItemType].collection[option.value] ? acc + 1 : acc;
    }, 0);
  }, [filteredItems, selectedMapped]);
  const allSelected = noOfSelectedVisibleItems !== 0 && noOfSelectedVisibleItems === filteredItemsCount;
  const indeterminate = !allSelected && noOfSelectedVisibleItems !== 0;
  return jsxs(BuilderWrapper, {
    stack: true,
    gap: "--Spacing-100",
    stretch: true,
    children: [jsxs(BuilderHeaderWrapper, {
      stack: true,
      gap: "--Spacing-50",
      vAlign: "flex-end",
      children: [jsx(Typography, {
        variant: "label",
        size: "xl",
        children: title
      }), jsx(FilterRelationFormat, {
        relation: filterRelation
      })]
    }), jsxs(StyledBuilderListWrapper$2, {
      stack: true,
      noFilterButtons: noFilterButtons,
      children: [!noFilterButtons ? jsx(Layout, {
        gap: 16,
        pl: "--Spacing-50",
        children: tabsOptions.map(tab => {
          return jsxs(Layout, {
            gap: "--Spacing-100",
            vAlign: "center",
            children: [jsx(Radio, {
              dataCy: "filter-tab--".concat(tab.label),
              value: tab.value,
              label: tab.label,
              checked: tab.value === subItemType,
              onClick: () => onSubItemTypeChange(tab.value)
            }), selectedMapped[tab.value].count ? jsx(Dot, {
              size: 12,
              color: "warning - medium"
            }) : jsx("div", {
              style: {
                width: 12
              }
            })]
          }, tab.value);
        })
      }) : null, jsxs(Layout, {
        gap: "--Spacing-100",
        vAlign: "stretch",
        pl: 14,
        pr: "--Spacing-150",
        children: [jsx(TextField, {
          label: "Filter",
          placeholder: "Type to filter",
          name: "filter-search",
          dataCy: "filter-search",
          value: searchInputValue,
          onChange: event => {
            var _a;
            return setFilterText((_a = event.target.value) === null || _a === void 0 ? void 0 : _a.toLowerCase());
          },
          endIcon: "search",
          clearable: true,
          onClear: () => setFilterText('')
        }), (visibleGroups === null || visibleGroups === void 0 ? void 0 : visibleGroups.length) ? jsxs(Fragment, {
          children: [jsx(StyledChip, {
            label: "Filters",
            endIcon: "chevronDown",
            onClick: open
          }), isOpen ? jsx(CheckboxListDialog, {
            withSelectAll: true,
            options: visibleGroups,
            checked: checkedGroups,
            optionLabel: "name",
            optionValue: "_id",
            open: true,
            onClose: close,
            anchorElement: anchorElement,
            onChange: onCheckNode
          }) : null]
        }) : null]
      }), jsx(Layout, {
        pl: "--Spacing-50",
        children: jsx(Checkbox, {
          name: "select-all",
          dataCy: "checkbox-list-select-all",
          checked: allSelected,
          indeterminate: indeterminate,
          onChange: handleSelectAllClick,
          label: jsx(Typography, {
            variant: "body",
            size: "medium",
            tagName: "span",
            children: "Select All"
          })
        })
      }), jsx(StyledList$2, {
        virtualized: true,
        items: filteredItems,
        onItemClick: item => {
          const newSelected = selectedMapped[item.subItemType].set;
          const restSelected = selectedMapped[otherType[item.subItemType]].set;
          const selected = selectedMapped[item.subItemType].collection[item.value];
          if (!selected) {
            onChange(Array.from(newSelected).concat([item.value]).concat(Array.from(restSelected)));
          } else {
            newSelected.delete(item.value);
            onChange(Array.from(newSelected).concat(Array.from(restSelected)));
          }
        },
        rowRenderer: rowRenderer
      })]
    })]
  });
}
const useCrossFilterTabsOptions = selectedSubItemType => {
  const keyWords = useAppKeyWords();
  const isUnassignedExtensionInstalled = useSelector(selectIsUnassignedExtensionInstalled);
  switch (selectedSubItemType) {
    case 'PROJECT':
    case 'EVENT':
      return [{
        label: keyWords.projectPluralKeyWord,
        value: 'PROJECT',
        type: 'REGULAR'
      }, {
        label: 'Events',
        value: 'EVENT',
        type: 'EVENT'
      }];
    case 'RESOURCE':
    case 'UNASSIGNED':
      return [{
        label: keyWords.resourcePluralKeyWord,
        value: 'RESOURCE',
        type: 'REGULAR'
      }, ...(isUnassignedExtensionInstalled ? [{
        label: 'Unassigned',
        value: 'UNASSIGNED',
        type: 'UNASSIGNED'
      }] : [])];
  }
};
const CrossFilter = /*#__PURE__*/React__default.memo(CrossFilterComponent);
var classof$2 = classofRaw$2;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$4 = Array.isArray || function isArray(argument) {
  return classof$2(argument) === 'Array';
};
var $TypeError$4 = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger$3 = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError$4('Maximum allowed index exceeded');
  return it;
};
var isArray$3 = isArray$4;
var lengthOfArrayLike$4 = lengthOfArrayLike$9;
var doesNotExceedSafeInteger$2 = doesNotExceedSafeInteger$3;
var bind$5 = functionBindContext;

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray$1 = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind$5(mapper, thisArg) : false;
  var element, elementLen;
  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
      if (depth > 0 && isArray$3(element)) {
        elementLen = lengthOfArrayLike$4(element);
        targetIndex = flattenIntoArray$1(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        doesNotExceedSafeInteger$2(targetIndex + 1);
        target[targetIndex] = element;
      }
      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};
var flattenIntoArray_1 = flattenIntoArray$1;
var uncurryThis$b = functionUncurryThis;
var fails$c = fails$y;
var isCallable$a = isCallable$s;
var classof$1 = classof$8;
var getBuiltIn$6 = getBuiltIn$b;
var inspectSource$1 = inspectSource$3;
var noop$2 = function () {/* empty */};
var construct = getBuiltIn$6('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$2 = uncurryThis$b(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop$2);
var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$a(argument)) return false;
  try {
    construct(noop$2, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};
var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$a(argument)) return false;
  switch (classof$1(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction':
      return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$2(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};
isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$2 = !construct || fails$c(function () {
  var called;
  return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function () {
    called = true;
  }) || called;
}) ? isConstructorLegacy : isConstructorModern;
var isArray$2 = isArray$4;
var isConstructor$1 = isConstructor$2;
var isObject$8 = isObject$i;
var wellKnownSymbol$4 = wellKnownSymbol$l;
var SPECIES$3 = wellKnownSymbol$4('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray$2(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor$1(C) && (C === $Array || isArray$2(C.prototype))) C = undefined;else if (isObject$8(C)) {
      C = C[SPECIES$3];
      if (C === null) C = undefined;
    }
  }
  return C === undefined ? $Array : C;
};
var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};
var $$o = _export;
var flattenIntoArray = flattenIntoArray_1;
var aCallable$6 = aCallable$k;
var toObject$4 = toObject$b;
var lengthOfArrayLike$3 = lengthOfArrayLike$9;
var arraySpeciesCreate = arraySpeciesCreate$1;

// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$$o({
  target: 'Array',
  proto: true
}, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject$4(this);
    var sourceLen = lengthOfArrayLike$3(O);
    var A;
    aCallable$6(callbackfn);
    A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables$1 = addToUnscopables$4;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('flatMap');
var call$8 = functionCall;
var anObject$7 = anObject$r;
var getIteratorDirect$2 = getIteratorDirect$a;
var getIteratorMethod = getIteratorMethod$3;
var getIteratorFlattenable$1 = function (obj, stringHandling) {
  if (!stringHandling || typeof obj !== 'string') anObject$7(obj);
  var method = getIteratorMethod(obj);
  return getIteratorDirect$2(anObject$7(method !== undefined ? call$8(method, obj) : obj));
};
var $$n = _export;
var call$7 = functionCall;
var aCallable$5 = aCallable$k;
var anObject$6 = anObject$r;
var getIteratorDirect$1 = getIteratorDirect$a;
var getIteratorFlattenable = getIteratorFlattenable$1;
var createIteratorProxy = iteratorCreateProxy;
var iteratorClose = iteratorClose$6;
var IS_PURE = isPure;
var IteratorProxy = createIteratorProxy(function () {
  var iterator = this.iterator;
  var mapper = this.mapper;
  var result, inner;
  while (true) {
    if (inner = this.inner) try {
      result = anObject$6(call$7(inner.next, inner.iterator));
      if (!result.done) return result.value;
      this.inner = null;
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    result = anObject$6(call$7(this.next, iterator));
    if (this.done = !!result.done) return;
    try {
      this.inner = getIteratorFlattenable(mapper(result.value, this.counter++), false);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
  }
});

// `Iterator.prototype.flatMap` method
// https://github.com/tc39/proposal-iterator-helpers
$$n({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: IS_PURE
}, {
  flatMap: function flatMap(mapper) {
    anObject$6(this);
    aCallable$5(mapper);
    return new IteratorProxy(getIteratorDirect$1(this), {
      mapper: mapper,
      inner: null
    });
  }
});
const Column$2 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "custom-fields-filter__Column",
  componentId: "az7g66-0"
})(["max-width:50%;"]);
const StyledList$1 = /*#__PURE__*/styled(List$1).withConfig({
  displayName: "custom-fields-filter__StyledList",
  componentId: "az7g66-1"
})(["min-height:0;"]);
function isSelectedCustomFieldValue(value) {
  return value !== null && typeof value === 'object' && 'value' in value;
}
function getStringValue(value) {
  if (isSelectedCustomFieldValue(value)) {
    return typeof value.value === 'string' ? value.value : null;
  }
  return typeof value === 'string' ? value : null;
}
function isValidChoice(value, validChoices) {
  const stringValue = getStringValue(value);
  return stringValue !== null && validChoices.has(stringValue);
}
function filterValidChoices(values, validChoices) {
  if (!values) return [];
  return values.filter(value => isValidChoice(value, validChoices));
}
function countVisibleChoices(values, visibleChoiceIds) {
  if (!values) return 0;
  const visibleChoicesSet = new Set(visibleChoiceIds);
  return filterValidChoices(values, visibleChoicesSet).length;
}
function CustomFieldsFilter(props) {
  var _a;
  const {
    customFieldsFilterRelation,
    customFieldsOptionsFilterRelation,
    onCustomFieldsFilterRelationChange,
    title,
    optionsTitle,
    customFields,
    selectedCustomFields,
    onCustomFieldItemChange,
    withFilterCondition,
    customFieldGroupId
  } = props;
  const selectedCustomFieldsMapped = useMemo(() => {
    if (withFilterCondition) {
      return selectedCustomFields.reduce((acc, selectedCustomField) => {
        const selectedIdKey = selectedCustomField.id;
        acc[selectedIdKey] = Object.assign(Object.assign({}, selectedCustomField), {
          valuesMapped: {}
        });
        selectedCustomField.values.forEach(value => {
          acc[selectedIdKey].valuesMapped[value.value] = value;
        });
        return acc;
      }, {});
    } else {
      return selectedCustomFields.reduce((acc, selectedCustomField) => {
        const selectedIdKey = selectedCustomField.id;
        acc[selectedIdKey] = Object.assign(Object.assign({}, selectedCustomField), {
          valuesMapped: {}
        });
        if (withFilterCondition) {
          selectedCustomField.values.forEach(value => {
            acc[selectedIdKey].valuesMapped[value] = {
              value
            };
          });
        } else {
          selectedCustomField.values.forEach(value => {
            acc[selectedIdKey].valuesMapped[value] = {
              value
            };
          });
        }
        return acc;
      }, {});
    }
  }, [withFilterCondition, selectedCustomFields]);
  const [currentCustomField, setCurrentCustomField] = useState(null);
  const isCurrentCustomFieldDeleted = currentCustomField === null || currentCustomField === void 0 ? void 0 : currentCustomField.deleted;
  useEffect(() => {
    setCurrentCustomField(null);
  }, [customFieldGroupId]);
  const customFieldRowRenderer = useCallback(customField => {
    var _a, _b;
    const primaryKey = customFieldGroupId || customField._id;
    const backupKey = customField._id;
    const targetMapping = selectedCustomFieldsMapped[primaryKey] || selectedCustomFieldsMapped[backupKey];
    const filteredValues = targetMapping ? filterValidChoices(targetMapping.values, new Set((customField === null || customField === void 0 ? void 0 : customField.choices.flatMap(choice => choice._id)) || [])) : [];
    const countSelected = (_b = customFieldGroupId ? filteredValues.length : (_a = selectedCustomFieldsMapped[customField._id]) === null || _a === void 0 ? void 0 : _a.values.length) !== null && _b !== void 0 ? _b : 0;
    return jsx(ListItem, {
      noWrap: true,
      density: -2,
      dataCy: "custom-field-list-item-".concat(customField._id),
      label: customField.label,
      labelTooltip: customField.label,
      supportingText: "Selected ".concat(countSelected, " items"),
      isActive: customField._id === (currentCustomField === null || currentCustomField === void 0 ? void 0 : currentCustomField._id),
      endAdornment: countSelected ? jsx(Layout, {
        flex: "0 0 12px",
        children: jsx(Dot, {
          size: 12,
          color: "warning - medium"
        })
      }) : null
    });
  }, [selectedCustomFieldsMapped, customFieldGroupId, currentCustomField]);
  const onCustomFieldClick = useCallback(customField => {
    setCurrentCustomField(customField);
  }, []);
  const checkOption = useCallback((checked, choice) => {
    if (!currentCustomField) {
      return;
    }
    const selectedIdKey = customFieldGroupId || currentCustomField._id;
    const selectedCustomFieldWithValues = selectedCustomFieldsMapped[selectedIdKey];
    const choiceValue = selectedCustomFieldWithValues === null || selectedCustomFieldWithValues === void 0 ? void 0 : selectedCustomFieldWithValues.valuesMapped[choice._id];
    if (withFilterCondition) {
      if (checked) {
        onCustomFieldItemChange([...((selectedCustomFieldWithValues === null || selectedCustomFieldWithValues === void 0 ? void 0 : selectedCustomFieldWithValues.values) || []), {
          value: choice._id,
          set: true
        }], currentCustomField);
      } else {
        onCustomFieldItemChange(((selectedCustomFieldWithValues === null || selectedCustomFieldWithValues === void 0 ? void 0 : selectedCustomFieldWithValues.values) || []).filter(value => value.value !== choice._id), currentCustomField);
      }
    } else {
      if (checked) {
        onCustomFieldItemChange([...((selectedCustomFieldWithValues === null || selectedCustomFieldWithValues === void 0 ? void 0 : selectedCustomFieldWithValues.values) || []), choice._id], currentCustomField);
      } else {
        onCustomFieldItemChange(((selectedCustomFieldWithValues === null || selectedCustomFieldWithValues === void 0 ? void 0 : selectedCustomFieldWithValues.values) || []).filter(value => value !== choiceValue.value), currentCustomField);
      }
    }
  }, [currentCustomField, onCustomFieldItemChange, selectedCustomFieldsMapped, withFilterCondition, customFieldGroupId]);
  const customFieldOptionRowRenderer = useCallback(choice => {
    if (!currentCustomField) {
      return jsx(Fragment, {});
    }
    const selectedIdKey = customFieldGroupId || currentCustomField._id;
    const selectedCustomFieldWithValues = selectedCustomFieldsMapped[selectedIdKey];
    const choiceValue = selectedCustomFieldWithValues === null || selectedCustomFieldWithValues === void 0 ? void 0 : selectedCustomFieldWithValues.valuesMapped[choice._id];
    return jsx(ListItem, {
      dataCy: "custom-field-list-item-".concat(choice._id),
      noWrap: true,
      density: -2,
      label: choice.value,
      labelTooltip: choice.value,
      startAdornment: jsx(Layout, {
        flex: "0 0 20px",
        children: jsx(Checkbox, {
          dataCy: "custom-field-list-checkbox-".concat(choice.value),
          checked: Boolean(choiceValue),
          onChange: event => {
            checkOption(event.target.checked, choice);
          }
        })
      }),
      endAdornment: withFilterCondition ? jsx(FilterCondition, {
        dataCy: "custom-fields-list-".concat(choice.value),
        disabled: isCurrentCustomFieldDeleted || !choiceValue,
        tooltip: isCurrentCustomFieldDeleted ? "You can't edit filter which was deleted" : undefined,
        value: choiceValue === null || choiceValue === void 0 ? void 0 : choiceValue.set,
        onChange: (event, newCondition) => {
          event.stopPropagation();
          onCustomFieldItemChange(((selectedCustomFieldWithValues === null || selectedCustomFieldWithValues === void 0 ? void 0 : selectedCustomFieldWithValues.values) || []).map(customFieldOptionValue => {
            if (customFieldOptionValue.value !== choice._id) {
              return customFieldOptionValue;
            } else {
              return Object.assign(Object.assign({}, customFieldOptionValue), {
                set: newCondition
              });
            }
          }), currentCustomField);
        }
      }) : null
    });
  }, [checkOption, currentCustomField, isCurrentCustomFieldDeleted, onCustomFieldItemChange, selectedCustomFieldsMapped, withFilterCondition, customFieldGroupId]);
  const choicesToDisplay = useMemo(() => {
    if (!currentCustomField) {
      return [];
    }
    const selectedIdKey = customFieldGroupId || currentCustomField._id;
    const selectedCustomFieldValues = selectedCustomFieldsMapped[selectedIdKey];
    if (currentCustomField.deleted && !selectedCustomFieldValues) {
      return [];
    }
    return currentCustomField.choices.filter(choice => {
      if (choice.deleted) {
        return Boolean(selectedCustomFieldValues.valuesMapped[choice._id]);
      }
      return true;
    });
  }, [currentCustomField, selectedCustomFieldsMapped, customFieldGroupId]);
  const handleSelectAllClick = useCallback(event => {
    if (!currentCustomField) {
      return null;
    }
    if (event.target.checked) {
      if (withFilterCondition) {
        onCustomFieldItemChange(currentCustomField.choices.map(choice => {
          return {
            value: choice._id,
            set: true,
            metadata: {
              customFieldGroupId: customFieldGroupId
            }
          };
        }), currentCustomField);
      } else {
        onCustomFieldItemChange(currentCustomField.choices.map(choice => {
          return choice._id;
        }), currentCustomField);
      }
    } else {
      onCustomFieldItemChange([], currentCustomField);
    }
  }, [currentCustomField, onCustomFieldItemChange, withFilterCondition, customFieldGroupId]);
  const selectedIdKey = customFieldGroupId || (currentCustomField === null || currentCustomField === void 0 ? void 0 : currentCustomField._id);
  const visibleChoicesCount = choicesToDisplay.length;
  const visibleChoiceIds = choicesToDisplay.map(choice => choice._id);
  const activeChoicesCount = selectedIdKey ? countVisibleChoices((_a = selectedCustomFieldsMapped[selectedIdKey]) === null || _a === void 0 ? void 0 : _a.values, visibleChoiceIds) : 0;
  const allSelected = visibleChoicesCount === activeChoicesCount;
  const indeterminate = visibleChoicesCount !== activeChoicesCount && activeChoicesCount > 0;
  return jsxs(BuilderWrapper, {
    gap: "--Spacing-100",
    stretch: true,
    children: [jsxs(Column$2, {
      stack: true,
      gap: "--Spacing-100",
      flex: "0 0 50%",
      children: [jsxs(BuilderHeaderWrapper, {
        stack: true,
        gap: "--Spacing-50",
        vAlign: "flex-end",
        children: [jsx(Typography, {
          variant: "label",
          size: "xl",
          children: title || 'Custom Field Groups'
        }), onCustomFieldsFilterRelationChange ? jsx(FilterRelationToggle, {
          onChange: onCustomFieldsFilterRelationChange,
          value: customFieldsFilterRelation
        }) : jsx(FilterRelationFormat, {
          relation: customFieldsFilterRelation
        })]
      }), jsx(BuilderListWrapper, {
        stack: true,
        flex: "1 1 auto",
        children: jsx(StyledList$1, {
          virtualized: true,
          items: customFields,
          rowRenderer: customFieldRowRenderer,
          onItemClick: onCustomFieldClick
        })
      })]
    }), jsxs(Column$2, {
      stack: true,
      gap: "--Spacing-100",
      flex: "0 0 50%",
      children: [jsxs(BuilderHeaderWrapper, {
        stack: true,
        gap: "--Spacing-50",
        vAlign: "flex-end",
        children: [jsx(Typography, {
          variant: "label",
          size: "xl",
          children: optionsTitle || 'Custom Field Options'
        }), jsx("div", {
          style: {
            minHeight: 32
          },
          children: jsx(FilterRelationFormat, {
            relation: customFieldsOptionsFilterRelation
          })
        })]
      }), choicesToDisplay.length ? jsxs(BuilderListWrapper, {
        stack: true,
        flex: "1 1 auto",
        children: [jsx(Checkbox, {
          name: "select-all",
          dataCy: "checkbox-list-select--all",
          checked: allSelected,
          indeterminate: indeterminate,
          onChange: handleSelectAllClick,
          label: jsx(Typography, {
            variant: "body",
            size: "medium",
            tagName: "span",
            children: "Select All"
          })
        }), jsx(StyledList$1, {
          virtualized: true,
          items: choicesToDisplay,
          rowRenderer: customFieldOptionRowRenderer
        })]
      }) : jsx(BuilderEmptyList, {
        text: "Looks like no groups are selected. Choose from Custom Field Groups to continue."
      })]
    })]
  });
}
const Wrapper$4 = /*#__PURE__*/styled(BuilderListWrapper).withConfig({
  displayName: "filters-navigation__Wrapper",
  componentId: "s8wm0o-0"
})(["flex:1 1 auto;overflow:auto;padding:16px 4px 8px 16px;"]);
function FiltersNavigation(props) {
  const {
    sections
  } = props;
  return jsx(Wrapper$4, {
    stack: true,
    gap: "--Spacing-200",
    children: sections.map((section, index) => {
      const {
        header,
        items,
        id
      } = section;
      return jsxs(Layout, {
        gap: "--Spacing-100",
        stack: true,
        children: [jsx(Typography, {
          variant: "label",
          size: "xl",
          children: header
        }), jsx(Layout, {
          stack: true,
          children: items.map((item, itemIndex) => {
            return jsx(ListItem, {
              dataCy: item.dataCy,
              onClick: item.onClick,
              label: item.label,
              isActive: item.isActive,
              startAdornment: item.icon,
              endAdornment: item.selected ? jsx(Layout, {
                flex: "0 0 12px",
                children: jsx(Dot, {
                  size: 12,
                  color: "warning - medium"
                })
              }) : null,
              noWrap: true,
              withDivider: true
            }, item.id || itemIndex);
          })
        })]
      }, id || index);
    })
  });
}
function IsPmFilter(props) {
  const {
    onChange,
    checked
  } = props;
  const {
    resourceKeyWord,
    projectKeyWord
  } = useAppKeyWords();
  return jsxs(BuilderWrapper, {
    stack: true,
    gap: "--Spacing-100",
    children: [jsx(BuilderHeaderWrapper, {
      stack: true,
      vAlign: "flex-end",
      children: jsxs(Typography, {
        variant: "label",
        size: "xl",
        children: [resourceKeyWord, " ", projectKeyWord, " Manager"]
      })
    }), jsxs(BuilderListWrapper, {
      stack: true,
      flex: "1 1 auto",
      children: [jsx(ListItem, {
        withDivider: true,
        onClick: () => {
          onChange(checked ? undefined : true);
        },
        startAdornment: jsx(Layout, {
          flex: "0 0 40px",
          children: jsx(Checkbox, {
            name: "resourceIsPm",
            checked: checked === true
          })
        }),
        label: "".concat(resourceKeyWord, " is ").concat(projectKeyWord, " Manager")
      }), jsx(ListItem, {
        withDivider: true,
        onClick: () => {
          onChange(checked === false ? undefined : false);
        },
        label: "".concat(resourceKeyWord, " is Not ").concat(projectKeyWord, " Manager"),
        startAdornment: jsx(Layout, {
          flex: "0 0 40px",
          children: jsx(Checkbox, {
            name: "resourceIsNotPm",
            checked: checked === false
          })
        })
      })]
    })]
  });
}
const StyledBuilderListWrapper$1 = /*#__PURE__*/styled(BuilderListWrapper).withConfig({
  displayName: "project-dates-filter__StyledBuilderListWrapper",
  componentId: "sc-11vnfb5-0"
})(["padding-top:8px;"]);
const Row$5 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "project-dates-filter__Row",
  componentId: "sc-11vnfb5-1"
})(["min-height:56px;padding:8px 16px;"]);
function ProjectDatesFilter(props) {
  var _a, _b;
  const {
    onChange,
    projectDates
  } = props;
  const {
    projectKeyWord
  } = useAppKeyWords();
  const enableStartSwitch = !!(projectDates && projectDates.start && projectDates.start.operator && projectDates.start.operator !== '' && projectDates.start.date && projectDates.start.date !== '');
  const enableEndSwitch = !!(projectDates && projectDates.end && projectDates.end.operator && projectDates.end.operator !== '' && projectDates.end.date && projectDates.end.date !== '');
  const startOperatorOptions = useMemo(() => {
    return getOperatorsWithDataCy("projects-starts-start");
  }, []);
  const startOperatorSelectedOption = useMemo(() => {
    return startOperatorOptions.find(operator => {
      var _a;
      return operator.value === ((_a = projectDates.start) === null || _a === void 0 ? void 0 : _a.operator);
    });
  }, [projectDates, startOperatorOptions]);
  const endOperatorOptions = useMemo(() => {
    return getOperatorsWithDataCy("projects-starts-end");
  }, []);
  const endOperatorSelectedOption = useMemo(() => {
    return startOperatorOptions.find(operator => {
      var _a;
      return operator.value === ((_a = projectDates.end) === null || _a === void 0 ? void 0 : _a.operator);
    });
  }, [projectDates, startOperatorOptions]);
  const onDateChange = (key, date) => {
    onChange({
      [key]: Object.assign(Object.assign({}, projectDates[key]), {
        date: date
      })
    });
  };
  const onDropdownChange = (key, operator) => {
    onChange({
      [key]: Object.assign(Object.assign({}, projectDates[key]), {
        operator: operator
      })
    });
  };
  const clear = key => {
    onChange({
      [key]: {
        operator: '',
        date: null
      }
    });
  };
  return jsxs(BuilderWrapper, {
    stack: true,
    gap: "--Spacing-100",
    children: [jsxs(BuilderHeaderWrapper, {
      stack: true,
      gap: "--Spacing-50",
      vAlign: "flex-end",
      children: [jsxs(Typography, {
        variant: "label",
        size: "xl",
        children: [projectKeyWord, " Dates"]
      }), jsx(Typography, {
        variant: "body",
        size: "small",
        children: "Choose Date Filter Options Below."
      })]
    }), jsxs(StyledBuilderListWrapper$1, {
      stack: true,
      pt: "--Spacing-200",
      children: [jsxs(Row$5, {
        gap: "--Spacing-200",
        vAlign: "center",
        children: [jsx(Layout, {
          flex: "0 0 10%",
          children: jsx(Typography, {
            variant: "body",
            size: "medium",
            children: "Starts:"
          })
        }), jsx(Select, {
          dataCy: "project-starts-dropdown",
          name: "startKeyName",
          value: startOperatorSelectedOption,
          onChange: (event, value) => {
            onDropdownChange('start', value === null || value === void 0 ? void 0 : value.value);
          },
          options: startOperatorOptions,
          label: "Operator",
          optionLabel: "name",
          optionValue: "value",
          disableClearable: true
        }), jsx(DatePickerInput, {
          label: "Date",
          name: "projectStartDate",
          dataCy: "project-starts-date-range-picker",
          value: ((_a = projectDates.start) === null || _a === void 0 ? void 0 : _a.date) ? toDate$1(projectDates.start.date) : undefined,
          onChange: value => onDateChange('start', value),
          disabledDays: date => {
            var _a;
            return ((_a = projectDates.end) === null || _a === void 0 ? void 0 : _a.date) ? isAfter(date, projectDates.end.date, 'day') : false;
          }
        }), jsx(Switch, {
          checked: enableStartSwitch,
          disabled: !enableStartSwitch,
          onChange: () => clear('start'),
          dataCy: "project-starts-clear-button"
        })]
      }), jsx(Divider, {}), jsxs(Row$5, {
        gap: "--Spacing-200",
        vAlign: "center",
        children: [jsx(Layout, {
          flex: "0 0 10%",
          children: jsx(Typography, {
            variant: "body",
            size: "medium",
            children: "Ends:"
          })
        }), jsx(Select, {
          dataCy: "project-ends-dropdown",
          name: "startKeyName",
          value: endOperatorSelectedOption,
          onChange: (event, value) => {
            onDropdownChange('end', value === null || value === void 0 ? void 0 : value.value);
          },
          options: endOperatorOptions,
          label: "Operator",
          optionLabel: "name",
          optionValue: "value",
          disableClearable: true
        }), jsx(DatePickerInput, {
          label: "Date",
          name: "projectEndDate",
          dataCy: "project-ends-date-range-picker",
          value: ((_b = projectDates.end) === null || _b === void 0 ? void 0 : _b.date) ? toDate$1(projectDates.end.date) : undefined,
          onChange: value => onDateChange('end', value),
          disabledDays: date => {
            var _a;
            return ((_a = projectDates.start) === null || _a === void 0 ? void 0 : _a.date) ? isBefore(date, projectDates.start.date, 'day') : false;
          }
        }), jsx(Switch, {
          checked: enableEndSwitch,
          disabled: !enableEndSwitch,
          onChange: () => clear('end'),
          dataCy: "project-end-clear-button"
        })]
      })]
    })]
  });
}
var isConstructor = isConstructor$2;
var tryToString = tryToString$5;
var $TypeError$3 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor(argument)) return argument;
  throw new $TypeError$3(tryToString(argument) + ' is not a constructor');
};
var anObject$5 = anObject$r;
var aConstructor = aConstructor$1;
var isNullOrUndefined$1 = isNullOrUndefined$6;
var wellKnownSymbol$3 = wellKnownSymbol$l;
var SPECIES$2 = wellKnownSymbol$3('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$3 = function (O, defaultConstructor) {
  var C = anObject$5(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined$1(S = anObject$5(C)[SPECIES$2]) ? defaultConstructor : aConstructor(S);
};
var call$6 = functionCall;
var uncurryThis$a = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject$4 = anObject$r;
var isNullOrUndefined = isNullOrUndefined$6;
var requireObjectCoercible$3 = requireObjectCoercible$a;
var speciesConstructor$2 = speciesConstructor$3;
var advanceStringIndex = advanceStringIndex$2;
var toLength = toLength$3;
var toString$a = toString$g;
var getMethod = getMethod$6;
var regExpExec = regexpExecAbstract;
var stickyHelpers = regexpStickyHelpers;
var fails$b = fails$y;
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var push$1 = uncurryThis$a([].push);
var stringSlice$2 = uncurryThis$a(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails$b(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () {
    return originalExec.apply(this, arguments);
  };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});
var BUGGY = 'abbc'.split(/(b)*/)[1] === 'c' ||
// eslint-disable-next-line regexp/no-empty-group -- required for testing
'test'.split(/(?:)/, -1).length !== 4 || 'ab'.split(/(?:ab)*/).length !== 2 || '.'.split(/(.?)(.?)/).length !== 4 ||
// eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
'.'.split(/()()/).length > 1 || ''.split(/.?/).length;

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit = '0'.split(undefined, 0).length ? function (separator, limit) {
    return separator === undefined && limit === 0 ? [] : call$6(nativeSplit, this, separator, limit);
  } : nativeSplit;
  return [
  // `String.prototype.split` method
  // https://tc39.es/ecma262/#sec-string.prototype.split
  function split(separator, limit) {
    var O = requireObjectCoercible$3(this);
    var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
    return splitter ? call$6(splitter, separator, O, limit) : call$6(internalSplit, toString$a(O), separator, limit);
  },
  // `RegExp.prototype[@@split]` method
  // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
  //
  // NOTE: This cannot be properly polyfilled in engines that don't support
  // the 'y' flag.
  function (string, limit) {
    var rx = anObject$4(this);
    var S = toString$a(string);
    if (!BUGGY) {
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;
    }
    var C = speciesConstructor$2(rx, RegExp);
    var unicodeMatching = rx.unicode;
    var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (UNSUPPORTED_Y ? 'g' : 'y');
    // ^(? + rx + ) is needed, in combination with some S slicing, to
    // simulate the 'y' flag.
    var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
    var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
    if (lim === 0) return [];
    if (S.length === 0) return regExpExec(splitter, S) === null ? [S] : [];
    var p = 0;
    var q = 0;
    var A = [];
    while (q < S.length) {
      splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
      var z = regExpExec(splitter, UNSUPPORTED_Y ? stringSlice$2(S, q) : S);
      var e;
      if (z === null || (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p) {
        q = advanceStringIndex(S, q, unicodeMatching);
      } else {
        push$1(A, stringSlice$2(S, p, q));
        if (A.length === lim) return A;
        for (var i = 1; i <= z.length - 1; i++) {
          push$1(A, z[i]);
          if (A.length === lim) return A;
        }
        q = p = e;
      }
    }
    push$1(A, stringSlice$2(S, p));
    return A;
  }];
}, BUGGY || !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);
var _rect$4, _rect2$4, _rect3$4, _path$8, _path2$7, _path3$7, _path4$5, _path5$5, _rect4$4, _g$4, _g2$4, _g3$4, _path6$5, _path7$5, _path8$5, _path9$5, _path10$5, _path11$5, _rect5$4, _g4, _rect6$4, _path12$5, _defs$4;
var _excluded$b = ["title", "titleId"];
function _extends$a() {
  return _extends$a = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$a.apply(null, arguments);
}
function _objectWithoutProperties$9(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$a(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$a(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgManualChooseColumns = function SvgManualChooseColumns(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$9(_ref, _excluded$b);
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    width: 220,
    height: 127,
    viewBox: "0 0 220 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect$4 || (_rect$4 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 28,
    width: 39,
    height: 27,
    rx: 4,
    fill: "#DEE4DE"
  })), _rect2$4 || (_rect2$4 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 61,
    width: 39,
    height: 24,
    rx: 4,
    fill: "#DEE4DE"
  })), _rect3$4 || (_rect3$4 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 91,
    width: 39,
    height: 28,
    rx: 4,
    fill: "#DEE4DE"
  })), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    d: "M42 1L42 123",
    stroke: "#BDCAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2$7 || (_path2$7 = /*#__PURE__*/React.createElement("path", {
    d: "M85 1L85 123",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path3$7 || (_path3$7 = /*#__PURE__*/React.createElement("path", {
    d: "M219 25L1.00001 25",
    stroke: "#BDCAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4$5 || (_path4$5 = /*#__PURE__*/React.createElement("path", {
    d: "M219 58L1.00001 58",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path5$5 || (_path5$5 = /*#__PURE__*/React.createElement("path", {
    d: "M219 88L1.00001 88",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _rect4$4 || (_rect4$4 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 1.20703,
    width: 39,
    height: 22,
    rx: 4,
    fill: "#F4F0EF"
  })), _g$4 || (_g$4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2686_31240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9827 43.6987C21.5328 43.6987 23.6001 41.6314 23.6001 39.0813C23.6001 36.5312 21.5328 34.4639 18.9827 34.4639C16.4325 34.4639 14.3652 36.5312 14.3652 39.0813C14.3652 41.6314 16.4325 43.6987 18.9827 43.6987Z",
    fill: "#D6DCD5",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 47.7395C13.4551 45.3247 15.9932 43.6992 18.9837 43.6992C21.9742 43.6992 24.5124 45.3247 25.9099 47.7395",
    fill: "#D6DCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 47.7395C13.4551 45.3247 15.9932 43.6992 18.9837 43.6992C21.9742 43.6992 24.5124 45.3247 25.9099 47.7395",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2$4 || (_g2$4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2686_31240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9827 75.0737C21.5328 75.0737 23.6001 73.0064 23.6001 70.4563C23.6001 67.9062 21.5328 65.8389 18.9827 65.8389C16.4325 65.8389 14.3652 67.9062 14.3652 70.4563C14.3652 73.0064 16.4325 75.0737 18.9827 75.0737Z",
    fill: "#D6DCD5",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 79.1145C13.4551 76.6997 15.9932 75.0742 18.9837 75.0742C21.9742 75.0742 24.5124 76.6997 25.9099 79.1145",
    fill: "#D6DCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 79.1145C13.4551 76.6997 15.9932 75.0742 18.9837 75.0742C21.9742 75.0742 24.5124 76.6997 25.9099 79.1145",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3$4 || (_g3$4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2686_31240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9827 107.699C21.5328 107.699 23.6001 105.631 23.6001 103.081C23.6001 100.531 21.5328 98.4639 18.9827 98.4639C16.4325 98.4639 14.3652 100.531 14.3652 103.081C14.3652 105.631 16.4325 107.699 18.9827 107.699Z",
    fill: "#D6DCD5",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 111.739C13.4551 109.325 15.9932 107.699 18.9837 107.699C21.9742 107.699 24.5124 109.325 25.9099 111.739",
    fill: "#D6DCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 111.739C13.4551 109.325 15.9932 107.699 18.9837 107.699C21.9742 107.699 24.5124 109.325 25.9099 111.739",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path6$5 || (_path6$5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3725 9.03V9.77H54.4725V16H53.5625V9.77H51.6525V9.03H56.3725ZM57.9627 9.63C57.7893 9.63 57.6427 9.57 57.5227 9.45C57.4027 9.33 57.3427 9.18333 57.3427 9.01C57.3427 8.83667 57.4027 8.69 57.5227 8.57C57.6427 8.45 57.7893 8.39 57.9627 8.39C58.1293 8.39 58.2693 8.45 58.3827 8.57C58.5027 8.69 58.5627 8.83667 58.5627 9.01C58.5627 9.18333 58.5027 9.33 58.3827 9.45C58.2693 9.57 58.1293 9.63 57.9627 9.63ZM58.4027 10.52V16H57.4927V10.52H58.4027ZM66.5436 10.42C66.9703 10.42 67.3503 10.51 67.6836 10.69C68.0169 10.8633 68.2803 11.1267 68.4736 11.48C68.6669 11.8333 68.7636 12.2633 68.7636 12.77V16H67.8636V12.9C67.8636 12.3533 67.7269 11.9367 67.4536 11.65C67.1869 11.3567 66.8236 11.21 66.3636 11.21C65.8903 11.21 65.5136 11.3633 65.2336 11.67C64.9536 11.97 64.8136 12.4067 64.8136 12.98V16H63.9136V12.9C63.9136 12.3533 63.7769 11.9367 63.5036 11.65C63.2369 11.3567 62.8736 11.21 62.4136 11.21C61.9403 11.21 61.5636 11.3633 61.2836 11.67C61.0036 11.97 60.8636 12.4067 60.8636 12.98V16H59.9536V10.52H60.8636V11.31C61.0436 11.0233 61.2836 10.8033 61.5836 10.65C61.8903 10.4967 62.2269 10.42 62.5936 10.42C63.0536 10.42 63.4603 10.5233 63.8136 10.73C64.1669 10.9367 64.4303 11.24 64.6036 11.64C64.7569 11.2533 65.0103 10.9533 65.3636 10.74C65.7169 10.5267 66.1103 10.42 66.5436 10.42ZM75.2563 13.05C75.2563 13.2233 75.2463 13.4067 75.2263 13.6H70.8463C70.8797 14.14 71.063 14.5633 71.3963 14.87C71.7363 15.17 72.1463 15.32 72.6263 15.32C73.0197 15.32 73.3463 15.23 73.6063 15.05C73.873 14.8633 74.0597 14.6167 74.1663 14.31H75.1463C74.9997 14.8367 74.7063 15.2667 74.2663 15.6C73.8263 15.9267 73.2797 16.09 72.6263 16.09C72.1063 16.09 71.6397 15.9733 71.2263 15.74C70.8197 15.5067 70.4997 15.1767 70.2663 14.75C70.033 14.3167 69.9163 13.8167 69.9163 13.25C69.9163 12.6833 70.0297 12.1867 70.2563 11.76C70.483 11.3333 70.7997 11.0067 71.2063 10.78C71.6197 10.5467 72.093 10.43 72.6263 10.43C73.1463 10.43 73.6063 10.5433 74.0063 10.77C74.4063 10.9967 74.713 11.31 74.9263 11.71C75.1463 12.1033 75.2563 12.55 75.2563 13.05ZM74.3163 12.86C74.3163 12.5133 74.2397 12.2167 74.0863 11.97C73.933 11.7167 73.723 11.5267 73.4563 11.4C73.1963 11.2667 72.9063 11.2 72.5863 11.2C72.1263 11.2 71.733 11.3467 71.4063 11.64C71.0863 11.9333 70.903 12.34 70.8563 12.86H74.3163Z",
    fill: "black"
  })), _path7$5 || (_path7$5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6788 44.532C64.6228 44.532 64.5708 44.524 64.5228 44.508C64.3708 44.476 64.2628 44.384 64.1988 44.232C64.1508 44.096 64.1628 43.944 64.2348 43.776C64.3148 43.608 64.4188 43.42 64.5468 43.212C64.5948 43.14 64.6388 43.068 64.6788 42.996C64.7268 42.916 64.7668 42.844 64.7988 42.78C64.8148 42.756 64.8268 42.736 64.8348 42.72C64.8428 42.696 64.8508 42.676 64.8588 42.66C64.6188 42.62 64.3388 42.612 64.0188 42.636C63.7068 42.652 63.3548 42.712 62.9628 42.816C62.6188 42.904 62.2468 43.02 61.8468 43.164C61.4548 43.3 61.0388 43.464 60.5988 43.656C60.5108 43.688 60.4228 43.688 60.3348 43.656C60.2468 43.624 60.1828 43.564 60.1428 43.476C60.0948 43.388 60.0908 43.296 60.1308 43.2C60.1708 43.096 60.2348 43.028 60.3228 42.996C60.7708 42.796 61.1988 42.624 61.6068 42.48C62.0228 42.328 62.4148 42.208 62.7828 42.12C63.7668 41.872 64.5708 41.832 65.1948 42C65.3788 42.048 65.5068 42.16 65.5788 42.336C65.6508 42.512 65.6348 42.708 65.5308 42.924C65.4268 43.14 65.3028 43.364 65.1588 43.596C65.1508 43.612 65.1388 43.632 65.1228 43.656C65.1068 43.68 65.0908 43.708 65.0748 43.74C65.2588 43.7 65.5308 43.62 65.8908 43.5C66.2508 43.38 66.7468 43.204 67.3788 42.972C67.4668 42.94 67.5548 42.948 67.6428 42.996C67.7388 43.036 67.8028 43.104 67.8348 43.2C67.8748 43.288 67.8748 43.38 67.8348 43.476C67.7948 43.564 67.7228 43.628 67.6188 43.668C67.2508 43.796 66.9148 43.912 66.6108 44.016C66.3068 44.12 66.0348 44.208 65.7948 44.28C65.4748 44.376 65.2308 44.444 65.0628 44.484C64.8948 44.516 64.7668 44.532 64.6788 44.532Z",
    fill: "black"
  })), _path8$5 || (_path8$5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6788 75.532C64.6228 75.532 64.5708 75.524 64.5228 75.508C64.3708 75.476 64.2628 75.384 64.1988 75.232C64.1508 75.096 64.1628 74.944 64.2348 74.776C64.3148 74.608 64.4188 74.42 64.5468 74.212C64.5948 74.14 64.6388 74.068 64.6788 73.996C64.7268 73.916 64.7668 73.844 64.7988 73.78C64.8148 73.756 64.8268 73.736 64.8348 73.72C64.8428 73.696 64.8508 73.676 64.8588 73.66C64.6188 73.62 64.3388 73.612 64.0188 73.636C63.7068 73.652 63.3548 73.712 62.9628 73.816C62.6188 73.904 62.2468 74.02 61.8468 74.164C61.4548 74.3 61.0388 74.464 60.5988 74.656C60.5108 74.688 60.4228 74.688 60.3348 74.656C60.2468 74.624 60.1828 74.564 60.1428 74.476C60.0948 74.388 60.0908 74.296 60.1308 74.2C60.1708 74.096 60.2348 74.028 60.3228 73.996C60.7708 73.796 61.1988 73.624 61.6068 73.48C62.0228 73.328 62.4148 73.208 62.7828 73.12C63.7668 72.872 64.5708 72.832 65.1948 73C65.3788 73.048 65.5068 73.16 65.5788 73.336C65.6508 73.512 65.6348 73.708 65.5308 73.924C65.4268 74.14 65.3028 74.364 65.1588 74.596C65.1508 74.612 65.1388 74.632 65.1228 74.656C65.1068 74.68 65.0908 74.708 65.0748 74.74C65.2588 74.7 65.5308 74.62 65.8908 74.5C66.2508 74.38 66.7468 74.204 67.3788 73.972C67.4668 73.94 67.5548 73.948 67.6428 73.996C67.7388 74.036 67.8028 74.104 67.8348 74.2C67.8748 74.288 67.8748 74.38 67.8348 74.476C67.7948 74.564 67.7228 74.628 67.6188 74.668C67.2508 74.796 66.9148 74.912 66.6108 75.016C66.3068 75.12 66.0348 75.208 65.7948 75.28C65.4748 75.376 65.2308 75.444 65.0628 75.484C64.8948 75.516 64.7668 75.532 64.6788 75.532Z",
    fill: "black"
  })), _path9$5 || (_path9$5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6788 107.532C64.6228 107.532 64.5708 107.524 64.5228 107.508C64.3708 107.476 64.2628 107.384 64.1988 107.232C64.1508 107.096 64.1628 106.944 64.2348 106.776C64.3148 106.608 64.4188 106.42 64.5468 106.212C64.5948 106.14 64.6388 106.068 64.6788 105.996C64.7268 105.916 64.7668 105.844 64.7988 105.78C64.8148 105.756 64.8268 105.736 64.8348 105.72C64.8428 105.696 64.8508 105.676 64.8588 105.66C64.6188 105.62 64.3388 105.612 64.0188 105.636C63.7068 105.652 63.3548 105.712 62.9628 105.816C62.6188 105.904 62.2468 106.02 61.8468 106.164C61.4548 106.3 61.0388 106.464 60.5988 106.656C60.5108 106.688 60.4228 106.688 60.3348 106.656C60.2468 106.624 60.1828 106.564 60.1428 106.476C60.0948 106.388 60.0908 106.296 60.1308 106.2C60.1708 106.096 60.2348 106.028 60.3228 105.996C60.7708 105.796 61.1988 105.624 61.6068 105.48C62.0228 105.328 62.4148 105.208 62.7828 105.12C63.7668 104.872 64.5708 104.832 65.1948 105C65.3788 105.048 65.5068 105.16 65.5788 105.336C65.6508 105.512 65.6348 105.708 65.5308 105.924C65.4268 106.14 65.3028 106.364 65.1588 106.596C65.1508 106.612 65.1388 106.632 65.1228 106.656C65.1068 106.68 65.0908 106.708 65.0748 106.74C65.2588 106.7 65.5308 106.62 65.8908 106.5C66.2508 106.38 66.7468 106.204 67.3788 105.972C67.4668 105.94 67.5548 105.948 67.6428 105.996C67.7388 106.036 67.8028 106.104 67.8348 106.2C67.8748 106.288 67.8748 106.38 67.8348 106.476C67.7948 106.564 67.7228 106.628 67.6188 106.668C67.2508 106.796 66.9148 106.912 66.6108 107.016C66.3068 107.12 66.0348 107.208 65.7948 107.28C65.4748 107.376 65.2308 107.444 65.0628 107.484C64.8948 107.516 64.7668 107.532 64.6788 107.532Z",
    fill: "black"
  })), _path10$5 || (_path10$5 = /*#__PURE__*/React.createElement("path", {
    d: "M129 26L129 124",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path11$5 || (_path11$5 = /*#__PURE__*/React.createElement("path", {
    d: "M177 25L177 123",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2686_31240",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 61,
    width: 24,
    height: 24
  }, _rect5$4 || (_rect5$4 = /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 61,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2686_31240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152 78H154V74H158V72H154V68H152V72H148V74H152V78ZM153 83C151.617 83 150.317 82.7375 149.1 82.2125C147.883 81.6875 146.825 80.975 145.925 80.075C145.025 79.175 144.313 78.1167 143.788 76.9C143.262 75.6833 143 74.3833 143 73C143 71.6167 143.262 70.3167 143.788 69.1C144.313 67.8833 145.025 66.825 145.925 65.925C146.825 65.025 147.883 64.3125 149.1 63.7875C150.317 63.2625 151.617 63 153 63C154.383 63 155.683 63.2625 156.9 63.7875C158.117 64.3125 159.175 65.025 160.075 65.925C160.975 66.825 161.687 67.8833 162.212 69.1C162.737 70.3167 163 71.6167 163 73C163 74.3833 162.737 75.6833 162.212 76.9C161.687 78.1167 160.975 79.175 160.075 80.075C159.175 80.975 158.117 81.6875 156.9 82.2125C155.683 82.7375 154.383 83 153 83ZM153 81C155.233 81 157.125 80.225 158.675 78.675C160.225 77.125 161 75.2333 161 73C161 70.7667 160.225 68.875 158.675 67.325C157.125 65.775 155.233 65 153 65C150.767 65 148.875 65.775 147.325 67.325C145.775 68.875 145 70.7667 145 73C145 75.2333 145.775 77.125 147.325 78.675C148.875 80.225 150.767 81 153 81Z",
    fill: "#3E4A42"
  }))), _rect6$4 || (_rect6$4 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 1,
    width: 134,
    height: 22,
    rx: 4,
    fill: "#F4F0EF"
  })), _path12$5 || (_path12$5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2346 12.73H90.1046V14.89H89.2546V12.73H87.1346V11.96H89.2546V9.79H90.1046V11.96H92.2346V12.73ZM97.1368 9.6V8.77H99.0168V16H98.0968V9.6H97.1368ZM101.08 12.31C101.08 11.1633 101.267 10.27 101.64 9.63C102.013 8.98333 102.667 8.66 103.6 8.66C104.527 8.66 105.177 8.98333 105.55 9.63C105.923 10.27 106.11 11.1633 106.11 12.31C106.11 13.4767 105.923 14.3833 105.55 15.03C105.177 15.6767 104.527 16 103.6 16C102.667 16 102.013 15.6767 101.64 15.03C101.267 14.3833 101.08 13.4767 101.08 12.31ZM105.21 12.31C105.21 11.73 105.17 11.24 105.09 10.84C105.017 10.4333 104.86 10.1067 104.62 9.86C104.387 9.61333 104.047 9.49 103.6 9.49C103.147 9.49 102.8 9.61333 102.56 9.86C102.327 10.1067 102.17 10.4333 102.09 10.84C102.017 11.24 101.98 11.73 101.98 12.31C101.98 12.91 102.017 13.4133 102.09 13.82C102.17 14.2267 102.327 14.5533 102.56 14.8C102.8 15.0467 103.147 15.17 103.6 15.17C104.047 15.17 104.387 15.0467 104.62 14.8C104.86 14.5533 105.017 14.2267 105.09 13.82C105.17 13.4133 105.21 12.91 105.21 12.31ZM107.859 12.31C107.859 11.1633 108.046 10.27 108.419 9.63C108.793 8.98333 109.446 8.66 110.379 8.66C111.306 8.66 111.956 8.98333 112.329 9.63C112.703 10.27 112.889 11.1633 112.889 12.31C112.889 13.4767 112.703 14.3833 112.329 15.03C111.956 15.6767 111.306 16 110.379 16C109.446 16 108.793 15.6767 108.419 15.03C108.046 14.3833 107.859 13.4767 107.859 12.31ZM111.989 12.31C111.989 11.73 111.949 11.24 111.869 10.84C111.796 10.4333 111.639 10.1067 111.399 9.86C111.166 9.61333 110.826 9.49 110.379 9.49C109.926 9.49 109.579 9.61333 109.339 9.86C109.106 10.1067 108.949 10.4333 108.869 10.84C108.796 11.24 108.759 11.73 108.759 12.31C108.759 12.91 108.796 13.4133 108.869 13.82C108.949 14.2267 109.106 14.5533 109.339 14.8C109.579 15.0467 109.926 15.17 110.379 15.17C110.826 15.17 111.166 15.0467 111.399 14.8C111.639 14.5533 111.796 14.2267 111.869 13.82C111.949 13.4133 111.989 12.91 111.989 12.31ZM114.929 9.03H115.939L114.979 11.3H114.339L114.929 9.03ZM119.416 16.09C118.996 16.09 118.619 16.02 118.286 15.88C117.953 15.7333 117.689 15.5333 117.496 15.28C117.303 15.02 117.196 14.7233 117.176 14.39H118.116C118.143 14.6633 118.269 14.8867 118.496 15.06C118.729 15.2333 119.033 15.32 119.406 15.32C119.753 15.32 120.026 15.2433 120.226 15.09C120.426 14.9367 120.526 14.7433 120.526 14.51C120.526 14.27 120.419 14.0933 120.206 13.98C119.993 13.86 119.663 13.7433 119.216 13.63C118.809 13.5233 118.476 13.4167 118.216 13.31C117.963 13.1967 117.743 13.0333 117.556 12.82C117.376 12.6 117.286 12.3133 117.286 11.96C117.286 11.68 117.369 11.4233 117.536 11.19C117.703 10.9567 117.939 10.7733 118.246 10.64C118.553 10.5 118.903 10.43 119.296 10.43C119.903 10.43 120.393 10.5833 120.766 10.89C121.139 11.1967 121.339 11.6167 121.366 12.15H120.456C120.436 11.8633 120.319 11.6333 120.106 11.46C119.899 11.2867 119.619 11.2 119.266 11.2C118.939 11.2 118.679 11.27 118.486 11.41C118.293 11.55 118.196 11.7333 118.196 11.96C118.196 12.14 118.253 12.29 118.366 12.41C118.486 12.5233 118.633 12.6167 118.806 12.69C118.986 12.7567 119.233 12.8333 119.546 12.92C119.939 13.0267 120.259 13.1333 120.506 13.24C120.753 13.34 120.963 13.4933 121.136 13.7C121.316 13.9067 121.409 14.1767 121.416 14.51C121.416 14.81 121.333 15.08 121.166 15.32C120.999 15.56 120.763 15.75 120.456 15.89C120.156 16.0233 119.809 16.09 119.416 16.09ZM128.757 16.09C128.243 16.09 127.777 15.9733 127.357 15.74C126.943 15.5067 126.617 15.1767 126.377 14.75C126.143 14.3167 126.027 13.8167 126.027 13.25C126.027 12.69 126.147 12.1967 126.387 11.77C126.633 11.3367 126.967 11.0067 127.387 10.78C127.807 10.5467 128.277 10.43 128.797 10.43C129.317 10.43 129.787 10.5467 130.207 10.78C130.627 11.0067 130.957 11.3333 131.197 11.76C131.443 12.1867 131.567 12.6833 131.567 13.25C131.567 13.8167 131.44 14.3167 131.187 14.75C130.94 15.1767 130.603 15.5067 130.177 15.74C129.75 15.9733 129.277 16.09 128.757 16.09ZM128.757 15.29C129.083 15.29 129.39 15.2133 129.677 15.06C129.963 14.9067 130.193 14.6767 130.367 14.37C130.547 14.0633 130.637 13.69 130.637 13.25C130.637 12.81 130.55 12.4367 130.377 12.13C130.203 11.8233 129.977 11.5967 129.697 11.45C129.417 11.2967 129.113 11.22 128.787 11.22C128.453 11.22 128.147 11.2967 127.867 11.45C127.593 11.5967 127.373 11.8233 127.207 12.13C127.04 12.4367 126.957 12.81 126.957 13.25C126.957 13.6967 127.037 14.0733 127.197 14.38C127.363 14.6867 127.583 14.9167 127.857 15.07C128.13 15.2167 128.43 15.29 128.757 15.29ZM135.493 11.27H134.343V16H133.433V11.27H132.723V10.52H133.433V10.13C133.433 9.51667 133.59 9.07 133.903 8.79C134.223 8.50333 134.733 8.36 135.433 8.36V9.12C135.033 9.12 134.75 9.2 134.583 9.36C134.423 9.51333 134.343 9.77 134.343 10.13V10.52H135.493V11.27ZM142.61 16.09C142.097 16.09 141.63 15.9733 141.21 15.74C140.797 15.5067 140.47 15.1767 140.23 14.75C139.997 14.3167 139.88 13.8167 139.88 13.25C139.88 12.69 140 12.1967 140.24 11.77C140.487 11.3367 140.82 11.0067 141.24 10.78C141.66 10.5467 142.13 10.43 142.65 10.43C143.17 10.43 143.64 10.5467 144.06 10.78C144.48 11.0067 144.81 11.3333 145.05 11.76C145.297 12.1867 145.42 12.6833 145.42 13.25C145.42 13.8167 145.294 14.3167 145.04 14.75C144.794 15.1767 144.457 15.5067 144.03 15.74C143.604 15.9733 143.13 16.09 142.61 16.09ZM142.61 15.29C142.937 15.29 143.244 15.2133 143.53 15.06C143.817 14.9067 144.047 14.6767 144.22 14.37C144.4 14.0633 144.49 13.69 144.49 13.25C144.49 12.81 144.404 12.4367 144.23 12.13C144.057 11.8233 143.83 11.5967 143.55 11.45C143.27 11.2967 142.967 11.22 142.64 11.22C142.307 11.22 142 11.2967 141.72 11.45C141.447 11.5967 141.227 11.8233 141.06 12.13C140.894 12.4367 140.81 12.81 140.81 13.25C140.81 13.6967 140.89 14.0733 141.05 14.38C141.217 14.6867 141.437 14.9167 141.71 15.07C141.984 15.2167 142.284 15.29 142.61 15.29ZM148.227 11.27V14.5C148.227 14.7667 148.283 14.9567 148.397 15.07C148.51 15.1767 148.707 15.23 148.987 15.23H149.657V16H148.837C148.33 16 147.95 15.8833 147.697 15.65C147.443 15.4167 147.317 15.0333 147.317 14.5V11.27H146.607V10.52H147.317V9.14H148.227V10.52H149.657V11.27H148.227ZM153.979 10.42C154.393 10.42 154.766 10.51 155.099 10.69C155.433 10.8633 155.693 11.1267 155.879 11.48C156.073 11.8333 156.169 12.2633 156.169 12.77V16H155.269V12.9C155.269 12.3533 155.133 11.9367 154.859 11.65C154.586 11.3567 154.213 11.21 153.739 11.21C153.259 11.21 152.876 11.36 152.589 11.66C152.309 11.96 152.169 12.3967 152.169 12.97V16H151.259V8.6H152.169V11.3C152.349 11.02 152.596 10.8033 152.909 10.65C153.229 10.4967 153.586 10.42 153.979 10.42ZM163.156 13.05C163.156 13.2233 163.146 13.4067 163.126 13.6H158.746C158.779 14.14 158.962 14.5633 159.296 14.87C159.636 15.17 160.046 15.32 160.526 15.32C160.919 15.32 161.246 15.23 161.506 15.05C161.772 14.8633 161.959 14.6167 162.066 14.31H163.046C162.899 14.8367 162.606 15.2667 162.166 15.6C161.726 15.9267 161.179 16.09 160.526 16.09C160.006 16.09 159.539 15.9733 159.126 15.74C158.719 15.5067 158.399 15.1767 158.166 14.75C157.932 14.3167 157.816 13.8167 157.816 13.25C157.816 12.6833 157.929 12.1867 158.156 11.76C158.382 11.3333 158.699 11.0067 159.106 10.78C159.519 10.5467 159.992 10.43 160.526 10.43C161.046 10.43 161.506 10.5433 161.906 10.77C162.306 10.9967 162.612 11.31 162.826 11.71C163.046 12.1033 163.156 12.55 163.156 13.05ZM162.216 12.86C162.216 12.5133 162.139 12.2167 161.986 11.97C161.832 11.7167 161.622 11.5267 161.356 11.4C161.096 11.2667 160.806 11.2 160.486 11.2C160.026 11.2 159.632 11.3467 159.306 11.64C158.986 11.9333 158.802 12.34 158.756 12.86H162.216ZM165.767 11.41C165.927 11.0967 166.154 10.8533 166.447 10.68C166.747 10.5067 167.11 10.42 167.537 10.42V11.36H167.297C166.277 11.36 165.767 11.9133 165.767 13.02V16H164.857V10.52H165.767V11.41ZM171.913 13.25C171.913 12.6833 172.027 12.19 172.253 11.77C172.48 11.3433 172.793 11.0133 173.193 10.78C173.6 10.5467 174.063 10.43 174.583 10.43C175.257 10.43 175.81 10.5933 176.243 10.92C176.683 11.2467 176.973 11.7 177.113 12.28H176.133C176.04 11.9467 175.857 11.6833 175.583 11.49C175.317 11.2967 174.983 11.2 174.583 11.2C174.063 11.2 173.643 11.38 173.323 11.74C173.003 12.0933 172.843 12.5967 172.843 13.25C172.843 13.91 173.003 14.42 173.323 14.78C173.643 15.14 174.063 15.32 174.583 15.32C174.983 15.32 175.317 15.2267 175.583 15.04C175.85 14.8533 176.033 14.5867 176.133 14.24H177.113C176.967 14.8 176.673 15.25 176.233 15.59C175.793 15.9233 175.243 16.09 174.583 16.09C174.063 16.09 173.6 15.9733 173.193 15.74C172.793 15.5067 172.48 15.1767 172.253 14.75C172.027 14.3233 171.913 13.8233 171.913 13.25ZM181.218 16.09C180.704 16.09 180.238 15.9733 179.818 15.74C179.404 15.5067 179.078 15.1767 178.838 14.75C178.604 14.3167 178.488 13.8167 178.488 13.25C178.488 12.69 178.608 12.1967 178.848 11.77C179.094 11.3367 179.428 11.0067 179.848 10.78C180.268 10.5467 180.738 10.43 181.258 10.43C181.778 10.43 182.248 10.5467 182.668 10.78C183.088 11.0067 183.418 11.3333 183.658 11.76C183.904 12.1867 184.028 12.6833 184.028 13.25C184.028 13.8167 183.901 14.3167 183.648 14.75C183.401 15.1767 183.064 15.5067 182.638 15.74C182.211 15.9733 181.738 16.09 181.218 16.09ZM181.218 15.29C181.544 15.29 181.851 15.2133 182.138 15.06C182.424 14.9067 182.654 14.6767 182.828 14.37C183.008 14.0633 183.098 13.69 183.098 13.25C183.098 12.81 183.011 12.4367 182.838 12.13C182.664 11.8233 182.438 11.5967 182.158 11.45C181.878 11.2967 181.574 11.22 181.248 11.22C180.914 11.22 180.608 11.2967 180.328 11.45C180.054 11.5967 179.834 11.8233 179.668 12.13C179.501 12.4367 179.418 12.81 179.418 13.25C179.418 13.6967 179.498 14.0733 179.658 14.38C179.824 14.6867 180.044 14.9167 180.318 15.07C180.591 15.2167 180.891 15.29 181.218 15.29ZM186.634 8.6V16H185.724V8.6H186.634ZM193.545 10.52V16H192.635V15.19C192.462 15.47 192.218 15.69 191.905 15.85C191.598 16.0033 191.258 16.08 190.885 16.08C190.458 16.08 190.075 15.9933 189.735 15.82C189.395 15.64 189.125 15.3733 188.925 15.02C188.732 14.6667 188.635 14.2367 188.635 13.73V10.52H189.535V13.61C189.535 14.15 189.672 14.5667 189.945 14.86C190.218 15.1467 190.592 15.29 191.065 15.29C191.552 15.29 191.935 15.14 192.215 14.84C192.495 14.54 192.635 14.1033 192.635 13.53V10.52H193.545ZM202.172 10.42C202.598 10.42 202.978 10.51 203.312 10.69C203.645 10.8633 203.908 11.1267 204.102 11.48C204.295 11.8333 204.392 12.2633 204.392 12.77V16H203.492V12.9C203.492 12.3533 203.355 11.9367 203.082 11.65C202.815 11.3567 202.452 11.21 201.992 11.21C201.518 11.21 201.142 11.3633 200.862 11.67C200.582 11.97 200.442 12.4067 200.442 12.98V16H199.542V12.9C199.542 12.3533 199.405 11.9367 199.132 11.65C198.865 11.3567 198.502 11.21 198.042 11.21C197.568 11.21 197.192 11.3633 196.912 11.67C196.632 11.97 196.492 12.4067 196.492 12.98V16H195.582V10.52H196.492V11.31C196.672 11.0233 196.912 10.8033 197.212 10.65C197.518 10.4967 197.855 10.42 198.222 10.42C198.682 10.42 199.088 10.5233 199.442 10.73C199.795 10.9367 200.058 11.24 200.232 11.64C200.385 11.2533 200.638 10.9533 200.992 10.74C201.345 10.5267 201.738 10.42 202.172 10.42ZM209.054 10.42C209.721 10.42 210.261 10.6233 210.674 11.03C211.088 11.43 211.294 12.01 211.294 12.77V16H210.394V12.9C210.394 12.3533 210.258 11.9367 209.984 11.65C209.711 11.3567 209.338 11.21 208.864 11.21C208.384 11.21 208.001 11.36 207.714 11.66C207.434 11.96 207.294 12.3967 207.294 12.97V16H206.384V10.52H207.294V11.3C207.474 11.02 207.718 10.8033 208.024 10.65C208.338 10.4967 208.681 10.42 209.054 10.42ZM215.221 16.09C214.801 16.09 214.424 16.02 214.091 15.88C213.757 15.7333 213.494 15.5333 213.301 15.28C213.107 15.02 213.001 14.7233 212.981 14.39H213.921C213.947 14.6633 214.074 14.8867 214.301 15.06C214.534 15.2333 214.837 15.32 215.211 15.32C215.557 15.32 215.831 15.2433 216.031 15.09C216.231 14.9367 216.331 14.7433 216.331 14.51C216.331 14.27 216.224 14.0933 216.011 13.98C215.797 13.86 215.467 13.7433 215.021 13.63C214.614 13.5233 214.281 13.4167 214.021 13.31C213.767 13.1967 213.547 13.0333 213.361 12.82C213.181 12.6 213.091 12.3133 213.091 11.96C213.091 11.68 213.174 11.4233 213.341 11.19C213.507 10.9567 213.744 10.7733 214.051 10.64C214.357 10.5 214.707 10.43 215.101 10.43C215.707 10.43 216.197 10.5833 216.571 10.89C216.944 11.1967 217.144 11.6167 217.171 12.15H216.261C216.241 11.8633 216.124 11.6333 215.911 11.46C215.704 11.2867 215.424 11.2 215.071 11.2C214.744 11.2 214.484 11.27 214.291 11.41C214.097 11.55 214.001 11.7333 214.001 11.96C214.001 12.14 214.057 12.29 214.171 12.41C214.291 12.5233 214.437 12.6167 214.611 12.69C214.791 12.7567 215.037 12.8333 215.351 12.92C215.744 13.0267 216.064 13.1333 216.311 13.24C216.557 13.34 216.767 13.4933 216.941 13.7C217.121 13.9067 217.214 14.1767 217.221 14.51C217.221 14.81 217.137 15.08 216.971 15.32C216.804 15.56 216.567 15.75 216.261 15.89C215.961 16.0233 215.614 16.09 215.221 16.09Z",
    fill: "black"
  })), _defs$4 || (_defs$4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2686_31240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18.75,
    fill: "white",
    transform: "translate(9 32)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2686_31240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18.75,
    fill: "white",
    transform: "translate(9 63.375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2686_31240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18.75,
    fill: "white",
    transform: "translate(9 96)"
  })))));
};
var ForwardRef$8 = /*#__PURE__*/forwardRef(SvgManualChooseColumns);
var _rect$3, _rect2$3, _rect3$3, _path$7, _path2$6, _path3$6, _path4$4, _path5$4, _path6$4, _path7$4, _path8$4, _rect4$3, _rect5$3, _rect6$3, _rect7$3, _g$3, _g2$3, _g3$3, _path9$4, _path10$4, _path11$4, _path12$4, _path13$4, _path14$3, _path15$3, _path16$3, _path17$3, _path18$3, _path19$3, _path20$3, _path21$3, _path22$3, _path23$3, _path24$3, _defs$3;
var _excluded$a = ["title", "titleId"];
function _extends$9() {
  return _extends$9 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$9.apply(null, arguments);
}
function _objectWithoutProperties$8(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$9(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$9(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgSplitByTimePeriodMonth = function SvgSplitByTimePeriodMonth(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$8(_ref, _excluded$a);
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    width: 221,
    height: 127,
    viewBox: "0 0 221 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect$3 || (_rect$3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 28,
    width: 172,
    height: 27,
    rx: 4,
    fill: "#DEE4DE"
  })), _rect2$3 || (_rect2$3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 61,
    width: 172,
    height: 24,
    rx: 4,
    fill: "#DEE4DE"
  })), _rect3$3 || (_rect3$3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 91,
    width: 172,
    height: 28,
    rx: 4,
    fill: "#DEE4DE"
  })), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    d: "M42 1L42 123",
    stroke: "#BDCAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React.createElement("path", {
    d: "M85 1L85 123",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path3$6 || (_path3$6 = /*#__PURE__*/React.createElement("path", {
    d: "M130 1L130 123",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path4$4 || (_path4$4 = /*#__PURE__*/React.createElement("path", {
    d: "M176 1L176 123",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path5$4 || (_path5$4 = /*#__PURE__*/React.createElement("path", {
    d: "M220 1L220 123",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path6$4 || (_path6$4 = /*#__PURE__*/React.createElement("path", {
    d: "M219 25L1.00001 25",
    stroke: "#BDCAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7$4 || (_path7$4 = /*#__PURE__*/React.createElement("path", {
    d: "M220 58L0.999999 58",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path8$4 || (_path8$4 = /*#__PURE__*/React.createElement("path", {
    d: "M220 88L0.999999 88",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _rect4$3 || (_rect4$3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 1.20703,
    width: 39,
    height: 22,
    rx: 4,
    fill: "#F4F0EF"
  })), _rect5$3 || (_rect5$3 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 1.20703,
    width: 41,
    height: 22,
    rx: 4,
    fill: "#F4F0EF"
  })), _rect6$3 || (_rect6$3 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 1.20703,
    width: 42,
    height: 22,
    rx: 4,
    fill: "#F4F0EF"
  })), _rect7$3 || (_rect7$3 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 1.20703,
    width: 40,
    height: 22,
    rx: 4,
    fill: "#F4F0EF"
  })), _g$3 || (_g$3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2686_31272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9827 43.6987C21.5328 43.6987 23.6001 41.6314 23.6001 39.0813C23.6001 36.5312 21.5328 34.4639 18.9827 34.4639C16.4325 34.4639 14.3652 36.5312 14.3652 39.0813C14.3652 41.6314 16.4325 43.6987 18.9827 43.6987Z",
    fill: "#D6DCD5",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 47.7395C13.4551 45.3247 15.9932 43.6992 18.9837 43.6992C21.9742 43.6992 24.5124 45.3247 25.9099 47.7395",
    fill: "#D6DCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 47.7395C13.4551 45.3247 15.9932 43.6992 18.9837 43.6992C21.9742 43.6992 24.5124 45.3247 25.9099 47.7395",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2$3 || (_g2$3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2686_31272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9827 75.0737C21.5328 75.0737 23.6001 73.0064 23.6001 70.4563C23.6001 67.9062 21.5328 65.8389 18.9827 65.8389C16.4325 65.8389 14.3652 67.9062 14.3652 70.4563C14.3652 73.0064 16.4325 75.0737 18.9827 75.0737Z",
    fill: "#D6DCD5",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 79.1145C13.4551 76.6997 15.9932 75.0742 18.9837 75.0742C21.9742 75.0742 24.5124 76.6997 25.9099 79.1145",
    fill: "#D6DCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 79.1145C13.4551 76.6997 15.9932 75.0742 18.9837 75.0742C21.9742 75.0742 24.5124 76.6997 25.9099 79.1145",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3$3 || (_g3$3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2686_31272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9827 107.699C21.5328 107.699 23.6001 105.631 23.6001 103.081C23.6001 100.531 21.5328 98.4639 18.9827 98.4639C16.4325 98.4639 14.3652 100.531 14.3652 103.081C14.3652 105.631 16.4325 107.699 18.9827 107.699Z",
    fill: "#D6DCD5",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 111.739C13.4551 109.325 15.9932 107.699 18.9837 107.699C21.9742 107.699 24.5124 109.325 25.9099 111.739",
    fill: "#D6DCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 111.739C13.4551 109.325 15.9932 107.699 18.9837 107.699C21.9742 107.699 24.5124 109.325 25.9099 111.739",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path9$4 || (_path9$4 = /*#__PURE__*/React.createElement("path", {
    d: "M197.679 107.532C197.623 107.532 197.571 107.524 197.523 107.508C197.371 107.476 197.263 107.384 197.199 107.232C197.151 107.096 197.163 106.944 197.235 106.776C197.315 106.608 197.419 106.42 197.547 106.212C197.595 106.14 197.639 106.068 197.679 105.996C197.727 105.916 197.767 105.844 197.799 105.78C197.815 105.756 197.827 105.736 197.835 105.72C197.843 105.696 197.851 105.676 197.859 105.66C197.619 105.62 197.339 105.612 197.019 105.636C196.707 105.652 196.355 105.712 195.963 105.816C195.619 105.904 195.247 106.02 194.847 106.164C194.455 106.3 194.039 106.464 193.599 106.656C193.511 106.688 193.423 106.688 193.335 106.656C193.247 106.624 193.183 106.564 193.143 106.476C193.095 106.388 193.091 106.296 193.131 106.2C193.171 106.096 193.235 106.028 193.323 105.996C193.771 105.796 194.199 105.624 194.607 105.48C195.023 105.328 195.415 105.208 195.783 105.12C196.767 104.872 197.571 104.832 198.195 105C198.379 105.048 198.507 105.16 198.579 105.336C198.651 105.512 198.635 105.708 198.531 105.924C198.427 106.14 198.303 106.364 198.159 106.596C198.151 106.612 198.139 106.632 198.123 106.656C198.107 106.68 198.091 106.708 198.075 106.74C198.259 106.7 198.531 106.62 198.891 106.5C199.251 106.38 199.747 106.204 200.379 105.972C200.467 105.94 200.555 105.948 200.643 105.996C200.739 106.036 200.803 106.104 200.835 106.2C200.875 106.288 200.875 106.38 200.835 106.476C200.795 106.564 200.723 106.628 200.619 106.668C200.251 106.796 199.915 106.912 199.611 107.016C199.307 107.12 199.035 107.208 198.795 107.28C198.475 107.376 198.231 107.444 198.063 107.484C197.895 107.516 197.767 107.532 197.679 107.532Z",
    fill: "black"
  })), _path10$4 || (_path10$4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6788 44.532C64.6228 44.532 64.5708 44.524 64.5228 44.508C64.3708 44.476 64.2628 44.384 64.1988 44.232C64.1508 44.096 64.1628 43.944 64.2348 43.776C64.3148 43.608 64.4188 43.42 64.5468 43.212C64.5948 43.14 64.6388 43.068 64.6788 42.996C64.7268 42.916 64.7668 42.844 64.7988 42.78C64.8148 42.756 64.8268 42.736 64.8348 42.72C64.8428 42.696 64.8508 42.676 64.8588 42.66C64.6188 42.62 64.3388 42.612 64.0188 42.636C63.7068 42.652 63.3548 42.712 62.9628 42.816C62.6188 42.904 62.2468 43.02 61.8468 43.164C61.4548 43.3 61.0388 43.464 60.5988 43.656C60.5108 43.688 60.4228 43.688 60.3348 43.656C60.2468 43.624 60.1828 43.564 60.1428 43.476C60.0948 43.388 60.0908 43.296 60.1308 43.2C60.1708 43.096 60.2348 43.028 60.3228 42.996C60.7708 42.796 61.1988 42.624 61.6068 42.48C62.0228 42.328 62.4148 42.208 62.7828 42.12C63.7668 41.872 64.5708 41.832 65.1948 42C65.3788 42.048 65.5068 42.16 65.5788 42.336C65.6508 42.512 65.6348 42.708 65.5308 42.924C65.4268 43.14 65.3028 43.364 65.1588 43.596C65.1508 43.612 65.1388 43.632 65.1228 43.656C65.1068 43.68 65.0908 43.708 65.0748 43.74C65.2588 43.7 65.5308 43.62 65.8908 43.5C66.2508 43.38 66.7468 43.204 67.3788 42.972C67.4668 42.94 67.5548 42.948 67.6428 42.996C67.7388 43.036 67.8028 43.104 67.8348 43.2C67.8748 43.288 67.8748 43.38 67.8348 43.476C67.7948 43.564 67.7228 43.628 67.6188 43.668C67.2508 43.796 66.9148 43.912 66.6108 44.016C66.3068 44.12 66.0348 44.208 65.7948 44.28C65.4748 44.376 65.2308 44.444 65.0628 44.484C64.8948 44.516 64.7668 44.532 64.6788 44.532Z",
    fill: "black"
  })), _path11$4 || (_path11$4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.679 44.532C107.623 44.532 107.571 44.524 107.523 44.508C107.371 44.476 107.263 44.384 107.199 44.232C107.151 44.096 107.163 43.944 107.235 43.776C107.315 43.608 107.419 43.42 107.547 43.212C107.595 43.14 107.639 43.068 107.679 42.996C107.727 42.916 107.767 42.844 107.799 42.78C107.815 42.756 107.827 42.736 107.835 42.72C107.843 42.696 107.851 42.676 107.859 42.66C107.619 42.62 107.339 42.612 107.019 42.636C106.707 42.652 106.355 42.712 105.963 42.816C105.619 42.904 105.247 43.02 104.847 43.164C104.455 43.3 104.039 43.464 103.599 43.656C103.511 43.688 103.423 43.688 103.335 43.656C103.247 43.624 103.183 43.564 103.143 43.476C103.095 43.388 103.091 43.296 103.131 43.2C103.171 43.096 103.235 43.028 103.323 42.996C103.771 42.796 104.199 42.624 104.607 42.48C105.023 42.328 105.415 42.208 105.783 42.12C106.767 41.872 107.571 41.832 108.195 42C108.379 42.048 108.507 42.16 108.579 42.336C108.651 42.512 108.635 42.708 108.531 42.924C108.427 43.14 108.303 43.364 108.159 43.596C108.151 43.612 108.139 43.632 108.123 43.656C108.107 43.68 108.091 43.708 108.075 43.74C108.259 43.7 108.531 43.62 108.891 43.5C109.251 43.38 109.747 43.204 110.379 42.972C110.467 42.94 110.555 42.948 110.643 42.996C110.739 43.036 110.803 43.104 110.835 43.2C110.875 43.288 110.875 43.38 110.835 43.476C110.795 43.564 110.723 43.628 110.619 43.668C110.251 43.796 109.915 43.912 109.611 44.016C109.307 44.12 109.035 44.208 108.795 44.28C108.475 44.376 108.231 44.444 108.063 44.484C107.895 44.516 107.767 44.532 107.679 44.532Z",
    fill: "black"
  })), _path12$4 || (_path12$4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.679 44.532C153.623 44.532 153.571 44.524 153.523 44.508C153.371 44.476 153.263 44.384 153.199 44.232C153.151 44.096 153.163 43.944 153.235 43.776C153.315 43.608 153.419 43.42 153.547 43.212C153.595 43.14 153.639 43.068 153.679 42.996C153.727 42.916 153.767 42.844 153.799 42.78C153.815 42.756 153.827 42.736 153.835 42.72C153.843 42.696 153.851 42.676 153.859 42.66C153.619 42.62 153.339 42.612 153.019 42.636C152.707 42.652 152.355 42.712 151.963 42.816C151.619 42.904 151.247 43.02 150.847 43.164C150.455 43.3 150.039 43.464 149.599 43.656C149.511 43.688 149.423 43.688 149.335 43.656C149.247 43.624 149.183 43.564 149.143 43.476C149.095 43.388 149.091 43.296 149.131 43.2C149.171 43.096 149.235 43.028 149.323 42.996C149.771 42.796 150.199 42.624 150.607 42.48C151.023 42.328 151.415 42.208 151.783 42.12C152.767 41.872 153.571 41.832 154.195 42C154.379 42.048 154.507 42.16 154.579 42.336C154.651 42.512 154.635 42.708 154.531 42.924C154.427 43.14 154.303 43.364 154.159 43.596C154.151 43.612 154.139 43.632 154.123 43.656C154.107 43.68 154.091 43.708 154.075 43.74C154.259 43.7 154.531 43.62 154.891 43.5C155.251 43.38 155.747 43.204 156.379 42.972C156.467 42.94 156.555 42.948 156.643 42.996C156.739 43.036 156.803 43.104 156.835 43.2C156.875 43.288 156.875 43.38 156.835 43.476C156.795 43.564 156.723 43.628 156.619 43.668C156.251 43.796 155.915 43.912 155.611 44.016C155.307 44.12 155.035 44.208 154.795 44.28C154.475 44.376 154.231 44.444 154.063 44.484C153.895 44.516 153.767 44.532 153.679 44.532Z",
    fill: "black"
  })), _path13$4 || (_path13$4 = /*#__PURE__*/React.createElement("path", {
    d: "M197.679 44.532C197.623 44.532 197.571 44.524 197.523 44.508C197.371 44.476 197.263 44.384 197.199 44.232C197.151 44.096 197.163 43.944 197.235 43.776C197.315 43.608 197.419 43.42 197.547 43.212C197.595 43.14 197.639 43.068 197.679 42.996C197.727 42.916 197.767 42.844 197.799 42.78C197.815 42.756 197.827 42.736 197.835 42.72C197.843 42.696 197.851 42.676 197.859 42.66C197.619 42.62 197.339 42.612 197.019 42.636C196.707 42.652 196.355 42.712 195.963 42.816C195.619 42.904 195.247 43.02 194.847 43.164C194.455 43.3 194.039 43.464 193.599 43.656C193.511 43.688 193.423 43.688 193.335 43.656C193.247 43.624 193.183 43.564 193.143 43.476C193.095 43.388 193.091 43.296 193.131 43.2C193.171 43.096 193.235 43.028 193.323 42.996C193.771 42.796 194.199 42.624 194.607 42.48C195.023 42.328 195.415 42.208 195.783 42.12C196.767 41.872 197.571 41.832 198.195 42C198.379 42.048 198.507 42.16 198.579 42.336C198.651 42.512 198.635 42.708 198.531 42.924C198.427 43.14 198.303 43.364 198.159 43.596C198.151 43.612 198.139 43.632 198.123 43.656C198.107 43.68 198.091 43.708 198.075 43.74C198.259 43.7 198.531 43.62 198.891 43.5C199.251 43.38 199.747 43.204 200.379 42.972C200.467 42.94 200.555 42.948 200.643 42.996C200.739 43.036 200.803 43.104 200.835 43.2C200.875 43.288 200.875 43.38 200.835 43.476C200.795 43.564 200.723 43.628 200.619 43.668C200.251 43.796 199.915 43.912 199.611 44.016C199.307 44.12 199.035 44.208 198.795 44.28C198.475 44.376 198.231 44.444 198.063 44.484C197.895 44.516 197.767 44.532 197.679 44.532Z",
    fill: "black"
  })), _path14$3 || (_path14$3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6788 76.532C64.6228 76.532 64.5708 76.524 64.5228 76.508C64.3708 76.476 64.2628 76.384 64.1988 76.232C64.1508 76.096 64.1628 75.944 64.2348 75.776C64.3148 75.608 64.4188 75.42 64.5468 75.212C64.5948 75.14 64.6388 75.068 64.6788 74.996C64.7268 74.916 64.7668 74.844 64.7988 74.78C64.8148 74.756 64.8268 74.736 64.8348 74.72C64.8428 74.696 64.8508 74.676 64.8588 74.66C64.6188 74.62 64.3388 74.612 64.0188 74.636C63.7068 74.652 63.3548 74.712 62.9628 74.816C62.6188 74.904 62.2468 75.02 61.8468 75.164C61.4548 75.3 61.0388 75.464 60.5988 75.656C60.5108 75.688 60.4228 75.688 60.3348 75.656C60.2468 75.624 60.1828 75.564 60.1428 75.476C60.0948 75.388 60.0908 75.296 60.1308 75.2C60.1708 75.096 60.2348 75.028 60.3228 74.996C60.7708 74.796 61.1988 74.624 61.6068 74.48C62.0228 74.328 62.4148 74.208 62.7828 74.12C63.7668 73.872 64.5708 73.832 65.1948 74C65.3788 74.048 65.5068 74.16 65.5788 74.336C65.6508 74.512 65.6348 74.708 65.5308 74.924C65.4268 75.14 65.3028 75.364 65.1588 75.596C65.1508 75.612 65.1388 75.632 65.1228 75.656C65.1068 75.68 65.0908 75.708 65.0748 75.74C65.2588 75.7 65.5308 75.62 65.8908 75.5C66.2508 75.38 66.7468 75.204 67.3788 74.972C67.4668 74.94 67.5548 74.948 67.6428 74.996C67.7388 75.036 67.8028 75.104 67.8348 75.2C67.8748 75.288 67.8748 75.38 67.8348 75.476C67.7948 75.564 67.7228 75.628 67.6188 75.668C67.2508 75.796 66.9148 75.912 66.6108 76.016C66.3068 76.12 66.0348 76.208 65.7948 76.28C65.4748 76.376 65.2308 76.444 65.0628 76.484C64.8948 76.516 64.7668 76.532 64.6788 76.532Z",
    fill: "black"
  })), _path15$3 || (_path15$3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.679 76.532C107.623 76.532 107.571 76.524 107.523 76.508C107.371 76.476 107.263 76.384 107.199 76.232C107.151 76.096 107.163 75.944 107.235 75.776C107.315 75.608 107.419 75.42 107.547 75.212C107.595 75.14 107.639 75.068 107.679 74.996C107.727 74.916 107.767 74.844 107.799 74.78C107.815 74.756 107.827 74.736 107.835 74.72C107.843 74.696 107.851 74.676 107.859 74.66C107.619 74.62 107.339 74.612 107.019 74.636C106.707 74.652 106.355 74.712 105.963 74.816C105.619 74.904 105.247 75.02 104.847 75.164C104.455 75.3 104.039 75.464 103.599 75.656C103.511 75.688 103.423 75.688 103.335 75.656C103.247 75.624 103.183 75.564 103.143 75.476C103.095 75.388 103.091 75.296 103.131 75.2C103.171 75.096 103.235 75.028 103.323 74.996C103.771 74.796 104.199 74.624 104.607 74.48C105.023 74.328 105.415 74.208 105.783 74.12C106.767 73.872 107.571 73.832 108.195 74C108.379 74.048 108.507 74.16 108.579 74.336C108.651 74.512 108.635 74.708 108.531 74.924C108.427 75.14 108.303 75.364 108.159 75.596C108.151 75.612 108.139 75.632 108.123 75.656C108.107 75.68 108.091 75.708 108.075 75.74C108.259 75.7 108.531 75.62 108.891 75.5C109.251 75.38 109.747 75.204 110.379 74.972C110.467 74.94 110.555 74.948 110.643 74.996C110.739 75.036 110.803 75.104 110.835 75.2C110.875 75.288 110.875 75.38 110.835 75.476C110.795 75.564 110.723 75.628 110.619 75.668C110.251 75.796 109.915 75.912 109.611 76.016C109.307 76.12 109.035 76.208 108.795 76.28C108.475 76.376 108.231 76.444 108.063 76.484C107.895 76.516 107.767 76.532 107.679 76.532Z",
    fill: "black"
  })), _path16$3 || (_path16$3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.679 76.532C153.623 76.532 153.571 76.524 153.523 76.508C153.371 76.476 153.263 76.384 153.199 76.232C153.151 76.096 153.163 75.944 153.235 75.776C153.315 75.608 153.419 75.42 153.547 75.212C153.595 75.14 153.639 75.068 153.679 74.996C153.727 74.916 153.767 74.844 153.799 74.78C153.815 74.756 153.827 74.736 153.835 74.72C153.843 74.696 153.851 74.676 153.859 74.66C153.619 74.62 153.339 74.612 153.019 74.636C152.707 74.652 152.355 74.712 151.963 74.816C151.619 74.904 151.247 75.02 150.847 75.164C150.455 75.3 150.039 75.464 149.599 75.656C149.511 75.688 149.423 75.688 149.335 75.656C149.247 75.624 149.183 75.564 149.143 75.476C149.095 75.388 149.091 75.296 149.131 75.2C149.171 75.096 149.235 75.028 149.323 74.996C149.771 74.796 150.199 74.624 150.607 74.48C151.023 74.328 151.415 74.208 151.783 74.12C152.767 73.872 153.571 73.832 154.195 74C154.379 74.048 154.507 74.16 154.579 74.336C154.651 74.512 154.635 74.708 154.531 74.924C154.427 75.14 154.303 75.364 154.159 75.596C154.151 75.612 154.139 75.632 154.123 75.656C154.107 75.68 154.091 75.708 154.075 75.74C154.259 75.7 154.531 75.62 154.891 75.5C155.251 75.38 155.747 75.204 156.379 74.972C156.467 74.94 156.555 74.948 156.643 74.996C156.739 75.036 156.803 75.104 156.835 75.2C156.875 75.288 156.875 75.38 156.835 75.476C156.795 75.564 156.723 75.628 156.619 75.668C156.251 75.796 155.915 75.912 155.611 76.016C155.307 76.12 155.035 76.208 154.795 76.28C154.475 76.376 154.231 76.444 154.063 76.484C153.895 76.516 153.767 76.532 153.679 76.532Z",
    fill: "black"
  })), _path17$3 || (_path17$3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.679 76.532C197.623 76.532 197.571 76.524 197.523 76.508C197.371 76.476 197.263 76.384 197.199 76.232C197.151 76.096 197.163 75.944 197.235 75.776C197.315 75.608 197.419 75.42 197.547 75.212C197.595 75.14 197.639 75.068 197.679 74.996C197.727 74.916 197.767 74.844 197.799 74.78C197.815 74.756 197.827 74.736 197.835 74.72C197.843 74.696 197.851 74.676 197.859 74.66C197.619 74.62 197.339 74.612 197.019 74.636C196.707 74.652 196.355 74.712 195.963 74.816C195.619 74.904 195.247 75.02 194.847 75.164C194.455 75.3 194.039 75.464 193.599 75.656C193.511 75.688 193.423 75.688 193.335 75.656C193.247 75.624 193.183 75.564 193.143 75.476C193.095 75.388 193.091 75.296 193.131 75.2C193.171 75.096 193.235 75.028 193.323 74.996C193.771 74.796 194.199 74.624 194.607 74.48C195.023 74.328 195.415 74.208 195.783 74.12C196.767 73.872 197.571 73.832 198.195 74C198.379 74.048 198.507 74.16 198.579 74.336C198.651 74.512 198.635 74.708 198.531 74.924C198.427 75.14 198.303 75.364 198.159 75.596C198.151 75.612 198.139 75.632 198.123 75.656C198.107 75.68 198.091 75.708 198.075 75.74C198.259 75.7 198.531 75.62 198.891 75.5C199.251 75.38 199.747 75.204 200.379 74.972C200.467 74.94 200.555 74.948 200.643 74.996C200.739 75.036 200.803 75.104 200.835 75.2C200.875 75.288 200.875 75.38 200.835 75.476C200.795 75.564 200.723 75.628 200.619 75.668C200.251 75.796 199.915 75.912 199.611 76.016C199.307 76.12 199.035 76.208 198.795 76.28C198.475 76.376 198.231 76.444 198.063 76.484C197.895 76.516 197.767 76.532 197.679 76.532Z",
    fill: "black"
  })), _path18$3 || (_path18$3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6788 107.532C64.6228 107.532 64.5708 107.524 64.5228 107.508C64.3708 107.476 64.2628 107.384 64.1988 107.232C64.1508 107.096 64.1628 106.944 64.2348 106.776C64.3148 106.608 64.4188 106.42 64.5468 106.212C64.5948 106.14 64.6388 106.068 64.6788 105.996C64.7268 105.916 64.7668 105.844 64.7988 105.78C64.8148 105.756 64.8268 105.736 64.8348 105.72C64.8428 105.696 64.8508 105.676 64.8588 105.66C64.6188 105.62 64.3388 105.612 64.0188 105.636C63.7068 105.652 63.3548 105.712 62.9628 105.816C62.6188 105.904 62.2468 106.02 61.8468 106.164C61.4548 106.3 61.0388 106.464 60.5988 106.656C60.5108 106.688 60.4228 106.688 60.3348 106.656C60.2468 106.624 60.1828 106.564 60.1428 106.476C60.0948 106.388 60.0908 106.296 60.1308 106.2C60.1708 106.096 60.2348 106.028 60.3228 105.996C60.7708 105.796 61.1988 105.624 61.6068 105.48C62.0228 105.328 62.4148 105.208 62.7828 105.12C63.7668 104.872 64.5708 104.832 65.1948 105C65.3788 105.048 65.5068 105.16 65.5788 105.336C65.6508 105.512 65.6348 105.708 65.5308 105.924C65.4268 106.14 65.3028 106.364 65.1588 106.596C65.1508 106.612 65.1388 106.632 65.1228 106.656C65.1068 106.68 65.0908 106.708 65.0748 106.74C65.2588 106.7 65.5308 106.62 65.8908 106.5C66.2508 106.38 66.7468 106.204 67.3788 105.972C67.4668 105.94 67.5548 105.948 67.6428 105.996C67.7388 106.036 67.8028 106.104 67.8348 106.2C67.8748 106.288 67.8748 106.38 67.8348 106.476C67.7948 106.564 67.7228 106.628 67.6188 106.668C67.2508 106.796 66.9148 106.912 66.6108 107.016C66.3068 107.12 66.0348 107.208 65.7948 107.28C65.4748 107.376 65.2308 107.444 65.0628 107.484C64.8948 107.516 64.7668 107.532 64.6788 107.532Z",
    fill: "black"
  })), _path19$3 || (_path19$3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.679 107.532C107.623 107.532 107.571 107.524 107.523 107.508C107.371 107.476 107.263 107.384 107.199 107.232C107.151 107.096 107.163 106.944 107.235 106.776C107.315 106.608 107.419 106.42 107.547 106.212C107.595 106.14 107.639 106.068 107.679 105.996C107.727 105.916 107.767 105.844 107.799 105.78C107.815 105.756 107.827 105.736 107.835 105.72C107.843 105.696 107.851 105.676 107.859 105.66C107.619 105.62 107.339 105.612 107.019 105.636C106.707 105.652 106.355 105.712 105.963 105.816C105.619 105.904 105.247 106.02 104.847 106.164C104.455 106.3 104.039 106.464 103.599 106.656C103.511 106.688 103.423 106.688 103.335 106.656C103.247 106.624 103.183 106.564 103.143 106.476C103.095 106.388 103.091 106.296 103.131 106.2C103.171 106.096 103.235 106.028 103.323 105.996C103.771 105.796 104.199 105.624 104.607 105.48C105.023 105.328 105.415 105.208 105.783 105.12C106.767 104.872 107.571 104.832 108.195 105C108.379 105.048 108.507 105.16 108.579 105.336C108.651 105.512 108.635 105.708 108.531 105.924C108.427 106.14 108.303 106.364 108.159 106.596C108.151 106.612 108.139 106.632 108.123 106.656C108.107 106.68 108.091 106.708 108.075 106.74C108.259 106.7 108.531 106.62 108.891 106.5C109.251 106.38 109.747 106.204 110.379 105.972C110.467 105.94 110.555 105.948 110.643 105.996C110.739 106.036 110.803 106.104 110.835 106.2C110.875 106.288 110.875 106.38 110.835 106.476C110.795 106.564 110.723 106.628 110.619 106.668C110.251 106.796 109.915 106.912 109.611 107.016C109.307 107.12 109.035 107.208 108.795 107.28C108.475 107.376 108.231 107.444 108.063 107.484C107.895 107.516 107.767 107.532 107.679 107.532Z",
    fill: "black"
  })), _path20$3 || (_path20$3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.679 107.532C153.623 107.532 153.571 107.524 153.523 107.508C153.371 107.476 153.263 107.384 153.199 107.232C153.151 107.096 153.163 106.944 153.235 106.776C153.315 106.608 153.419 106.42 153.547 106.212C153.595 106.14 153.639 106.068 153.679 105.996C153.727 105.916 153.767 105.844 153.799 105.78C153.815 105.756 153.827 105.736 153.835 105.72C153.843 105.696 153.851 105.676 153.859 105.66C153.619 105.62 153.339 105.612 153.019 105.636C152.707 105.652 152.355 105.712 151.963 105.816C151.619 105.904 151.247 106.02 150.847 106.164C150.455 106.3 150.039 106.464 149.599 106.656C149.511 106.688 149.423 106.688 149.335 106.656C149.247 106.624 149.183 106.564 149.143 106.476C149.095 106.388 149.091 106.296 149.131 106.2C149.171 106.096 149.235 106.028 149.323 105.996C149.771 105.796 150.199 105.624 150.607 105.48C151.023 105.328 151.415 105.208 151.783 105.12C152.767 104.872 153.571 104.832 154.195 105C154.379 105.048 154.507 105.16 154.579 105.336C154.651 105.512 154.635 105.708 154.531 105.924C154.427 106.14 154.303 106.364 154.159 106.596C154.151 106.612 154.139 106.632 154.123 106.656C154.107 106.68 154.091 106.708 154.075 106.74C154.259 106.7 154.531 106.62 154.891 106.5C155.251 106.38 155.747 106.204 156.379 105.972C156.467 105.94 156.555 105.948 156.643 105.996C156.739 106.036 156.803 106.104 156.835 106.2C156.875 106.288 156.875 106.38 156.835 106.476C156.795 106.564 156.723 106.628 156.619 106.668C156.251 106.796 155.915 106.912 155.611 107.016C155.307 107.12 155.035 107.208 154.795 107.28C154.475 107.376 154.231 107.444 154.063 107.484C153.895 107.516 153.767 107.532 153.679 107.532Z",
    fill: "black"
  })), _path21$3 || (_path21$3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.711 9.03V9.77H58.681V12.12H61.141V12.86H58.681V16H57.771V9.03H61.711ZM67.81 13.05C67.81 13.2233 67.8 13.4067 67.78 13.6H63.4C63.4334 14.14 63.6167 14.5633 63.95 14.87C64.29 15.17 64.7 15.32 65.18 15.32C65.5734 15.32 65.9 15.23 66.16 15.05C66.4267 14.8633 66.6134 14.6167 66.72 14.31H67.7C67.5534 14.8367 67.26 15.2667 66.82 15.6C66.38 15.9267 65.8334 16.09 65.18 16.09C64.66 16.09 64.1934 15.9733 63.78 15.74C63.3734 15.5067 63.0534 15.1767 62.82 14.75C62.5867 14.3167 62.47 13.8167 62.47 13.25C62.47 12.6833 62.5834 12.1867 62.81 11.76C63.0367 11.3333 63.3534 11.0067 63.76 10.78C64.1734 10.5467 64.6467 10.43 65.18 10.43C65.7 10.43 66.16 10.5433 66.56 10.77C66.96 10.9967 67.2667 11.31 67.48 11.71C67.7 12.1033 67.81 12.55 67.81 13.05ZM66.87 12.86C66.87 12.5133 66.7934 12.2167 66.64 11.97C66.4867 11.7167 66.2767 11.5267 66.01 11.4C65.75 11.2667 65.46 11.2 65.14 11.2C64.68 11.2 64.2867 11.3467 63.96 11.64C63.64 11.9333 63.4567 12.34 63.41 12.86H66.87ZM69.9212 11.54C70.1079 11.2133 70.3812 10.9467 70.7412 10.74C71.1012 10.5333 71.5112 10.43 71.9712 10.43C72.4645 10.43 72.9079 10.5467 73.3012 10.78C73.6945 11.0133 74.0045 11.3433 74.2312 11.77C74.4579 12.19 74.5712 12.68 74.5712 13.24C74.5712 13.7933 74.4579 14.2867 74.2312 14.72C74.0045 15.1533 73.6912 15.49 73.2912 15.73C72.8979 15.97 72.4579 16.09 71.9712 16.09C71.4979 16.09 71.0812 15.9867 70.7212 15.78C70.3679 15.5733 70.1012 15.31 69.9212 14.99V16H69.0112V8.6H69.9212V11.54ZM73.6412 13.24C73.6412 12.8267 73.5579 12.4667 73.3912 12.16C73.2245 11.8533 72.9979 11.62 72.7112 11.46C72.4312 11.3 72.1212 11.22 71.7812 11.22C71.4479 11.22 71.1379 11.3033 70.8512 11.47C70.5712 11.63 70.3445 11.8667 70.1712 12.18C70.0045 12.4867 69.9212 12.8433 69.9212 13.25C69.9212 13.6633 70.0045 14.0267 70.1712 14.34C70.3445 14.6467 70.5712 14.8833 70.8512 15.05C71.1379 15.21 71.4479 15.29 71.7812 15.29C72.1212 15.29 72.4312 15.21 72.7112 15.05C72.9979 14.8833 73.2245 14.6467 73.3912 14.34C73.5579 14.0267 73.6412 13.66 73.6412 13.24Z",
    fill: "black"
  })), _path22$3 || (_path22$3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.289 9.08V16H103.379V10.84L101.079 16H100.439L98.1292 10.83V16H97.2192V9.08H98.1992L100.759 14.8L103.319 9.08H104.289ZM105.493 13.24C105.493 12.68 105.606 12.19 105.833 11.77C106.059 11.3433 106.369 11.0133 106.763 10.78C107.163 10.5467 107.606 10.43 108.093 10.43C108.573 10.43 108.989 10.5333 109.343 10.74C109.696 10.9467 109.959 11.2067 110.133 11.52V10.52H111.053V16H110.133V14.98C109.953 15.3 109.683 15.5667 109.323 15.78C108.969 15.9867 108.556 16.09 108.083 16.09C107.596 16.09 107.156 15.97 106.763 15.73C106.369 15.49 106.059 15.1533 105.833 14.72C105.606 14.2867 105.493 13.7933 105.493 13.24ZM110.133 13.25C110.133 12.8367 110.049 12.4767 109.883 12.17C109.716 11.8633 109.489 11.63 109.203 11.47C108.923 11.3033 108.613 11.22 108.273 11.22C107.933 11.22 107.623 11.3 107.343 11.46C107.063 11.62 106.839 11.8533 106.673 12.16C106.506 12.4667 106.423 12.8267 106.423 13.24C106.423 13.66 106.506 14.0267 106.673 14.34C106.839 14.6467 107.063 14.8833 107.343 15.05C107.623 15.21 107.933 15.29 108.273 15.29C108.613 15.29 108.923 15.21 109.203 15.05C109.489 14.8833 109.716 14.6467 109.883 14.34C110.049 14.0267 110.133 13.6633 110.133 13.25ZM113.5 11.41C113.66 11.0967 113.887 10.8533 114.18 10.68C114.48 10.5067 114.844 10.42 115.27 10.42V11.36H115.03C114.01 11.36 113.5 11.9133 113.5 13.02V16H112.59V10.52H113.5V11.41Z",
    fill: "black"
  })), _path23$3 || (_path23$3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.277 14.45H145.237L144.677 16H143.717L146.237 9.07H147.287L149.797 16H148.837L148.277 14.45ZM148.017 13.71L146.757 10.19L145.497 13.71H148.017ZM151.805 11.53C151.985 11.2167 152.252 10.9567 152.605 10.75C152.965 10.5367 153.382 10.43 153.855 10.43C154.342 10.43 154.782 10.5467 155.175 10.78C155.575 11.0133 155.888 11.3433 156.115 11.77C156.342 12.19 156.455 12.68 156.455 13.24C156.455 13.7933 156.342 14.2867 156.115 14.72C155.888 15.1533 155.575 15.49 155.175 15.73C154.782 15.97 154.342 16.09 153.855 16.09C153.388 16.09 152.975 15.9867 152.615 15.78C152.262 15.5667 151.992 15.3033 151.805 14.99V18.6H150.895V10.52H151.805V11.53ZM155.525 13.24C155.525 12.8267 155.442 12.4667 155.275 12.16C155.108 11.8533 154.882 11.62 154.595 11.46C154.315 11.3 154.005 11.22 153.665 11.22C153.332 11.22 153.022 11.3033 152.735 11.47C152.455 11.63 152.228 11.8667 152.055 12.18C151.888 12.4867 151.805 12.8433 151.805 13.25C151.805 13.6633 151.888 14.0267 152.055 14.34C152.228 14.6467 152.455 14.8833 152.735 15.05C153.022 15.21 153.332 15.29 153.665 15.29C154.005 15.29 154.315 15.21 154.595 15.05C154.882 14.8833 155.108 14.6467 155.275 14.34C155.442 14.0267 155.525 13.66 155.525 13.24ZM158.563 11.41C158.723 11.0967 158.949 10.8533 159.243 10.68C159.543 10.5067 159.906 10.42 160.333 10.42V11.36H160.093C159.073 11.36 158.563 11.9133 158.563 13.02V16H157.653V10.52H158.563V11.41Z",
    fill: "black"
  })), _path24$3 || (_path24$3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.337 9.08V16H192.427V10.84L190.127 16H189.487L187.177 10.83V16H186.267V9.08H187.247L189.807 14.8L192.367 9.08H193.337ZM194.54 13.24C194.54 12.68 194.654 12.19 194.88 11.77C195.107 11.3433 195.417 11.0133 195.81 10.78C196.21 10.5467 196.654 10.43 197.14 10.43C197.62 10.43 198.037 10.5333 198.39 10.74C198.744 10.9467 199.007 11.2067 199.18 11.52V10.52H200.1V16H199.18V14.98C199 15.3 198.73 15.5667 198.37 15.78C198.017 15.9867 197.604 16.09 197.13 16.09C196.644 16.09 196.204 15.97 195.81 15.73C195.417 15.49 195.107 15.1533 194.88 14.72C194.654 14.2867 194.54 13.7933 194.54 13.24ZM199.18 13.25C199.18 12.8367 199.097 12.4767 198.93 12.17C198.764 11.8633 198.537 11.63 198.25 11.47C197.97 11.3033 197.66 11.22 197.32 11.22C196.98 11.22 196.67 11.3 196.39 11.46C196.11 11.62 195.887 11.8533 195.72 12.16C195.554 12.4667 195.47 12.8267 195.47 13.24C195.47 13.66 195.554 14.0267 195.72 14.34C195.887 14.6467 196.11 14.8833 196.39 15.05C196.67 15.21 196.98 15.29 197.32 15.29C197.66 15.29 197.97 15.21 198.25 15.05C198.537 14.8833 198.764 14.6467 198.93 14.34C199.097 14.0267 199.18 13.6633 199.18 13.25ZM206.358 10.52L203.058 18.58H202.118L203.198 15.94L200.988 10.52H201.998L203.718 14.96L205.418 10.52H206.358Z",
    fill: "black"
  })), _defs$3 || (_defs$3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2686_31272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18.75,
    fill: "white",
    transform: "translate(9 32)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2686_31272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18.75,
    fill: "white",
    transform: "translate(9 63.375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2686_31272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18.75,
    fill: "white",
    transform: "translate(9 96)"
  })))));
};
var ForwardRef$7 = /*#__PURE__*/forwardRef(SvgSplitByTimePeriodMonth);
var _rect$2, _rect2$2, _rect3$2, _path$6, _path2$5, _path3$5, _path4$3, _path5$3, _path6$3, _path7$3, _path8$3, _rect4$2, _rect5$2, _rect6$2, _rect7$2, _g$2, _g2$2, _g3$2, _path9$3, _path10$3, _path11$3, _path12$3, _path13$3, _path14$2, _path15$2, _path16$2, _path17$2, _path18$2, _path19$2, _path20$2, _path21$2, _path22$2, _path23$2, _path24$2, _defs$2;
var _excluded$9 = ["title", "titleId"];
function _extends$8() {
  return _extends$8 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$8.apply(null, arguments);
}
function _objectWithoutProperties$7(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$8(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$8(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgSplitByTimePeriodWk = function SvgSplitByTimePeriodWk(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$7(_ref, _excluded$9);
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    width: 221,
    height: 127,
    viewBox: "0 0 221 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect$2 || (_rect$2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 28,
    width: 172,
    height: 27,
    rx: 4,
    fill: "#DEE4DE"
  })), _rect2$2 || (_rect2$2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 61,
    width: 172,
    height: 24,
    rx: 4,
    fill: "#DEE4DE"
  })), _rect3$2 || (_rect3$2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 91,
    width: 172,
    height: 28,
    rx: 4,
    fill: "#DEE4DE"
  })), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    d: "M42 1L42 123",
    stroke: "#BDCAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React.createElement("path", {
    d: "M85 1L85 123",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path3$5 || (_path3$5 = /*#__PURE__*/React.createElement("path", {
    d: "M130 1L130 123",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path4$3 || (_path4$3 = /*#__PURE__*/React.createElement("path", {
    d: "M176 1L176 123",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path5$3 || (_path5$3 = /*#__PURE__*/React.createElement("path", {
    d: "M220 1L220 123",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path6$3 || (_path6$3 = /*#__PURE__*/React.createElement("path", {
    d: "M219 25L1.00001 25",
    stroke: "#BDCAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7$3 || (_path7$3 = /*#__PURE__*/React.createElement("path", {
    d: "M220 58L0.999999 58",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path8$3 || (_path8$3 = /*#__PURE__*/React.createElement("path", {
    d: "M220 88L0.999999 88",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _rect4$2 || (_rect4$2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 1.20703,
    width: 39,
    height: 22,
    rx: 4,
    fill: "#F4F0EF"
  })), _rect5$2 || (_rect5$2 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 1.20703,
    width: 41,
    height: 22,
    rx: 4,
    fill: "#F4F0EF"
  })), _rect6$2 || (_rect6$2 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 1.20703,
    width: 42,
    height: 22,
    rx: 4,
    fill: "#F4F0EF"
  })), _rect7$2 || (_rect7$2 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 1.20703,
    width: 40,
    height: 22,
    rx: 4,
    fill: "#F4F0EF"
  })), _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2686_31363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9827 43.6987C21.5328 43.6987 23.6001 41.6314 23.6001 39.0813C23.6001 36.5312 21.5328 34.4639 18.9827 34.4639C16.4325 34.4639 14.3652 36.5312 14.3652 39.0813C14.3652 41.6314 16.4325 43.6987 18.9827 43.6987Z",
    fill: "#D6DCD5",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 47.7395C13.4551 45.3247 15.9932 43.6992 18.9837 43.6992C21.9742 43.6992 24.5124 45.3247 25.9099 47.7395",
    fill: "#D6DCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 47.7395C13.4551 45.3247 15.9932 43.6992 18.9837 43.6992C21.9742 43.6992 24.5124 45.3247 25.9099 47.7395",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2$2 || (_g2$2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2686_31363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9827 75.0737C21.5328 75.0737 23.6001 73.0064 23.6001 70.4563C23.6001 67.9062 21.5328 65.8389 18.9827 65.8389C16.4325 65.8389 14.3652 67.9062 14.3652 70.4563C14.3652 73.0064 16.4325 75.0737 18.9827 75.0737Z",
    fill: "#D6DCD5",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 79.1145C13.4551 76.6997 15.9932 75.0742 18.9837 75.0742C21.9742 75.0742 24.5124 76.6997 25.9099 79.1145",
    fill: "#D6DCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 79.1145C13.4551 76.6997 15.9932 75.0742 18.9837 75.0742C21.9742 75.0742 24.5124 76.6997 25.9099 79.1145",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3$2 || (_g3$2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2686_31363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9827 107.699C21.5328 107.699 23.6001 105.631 23.6001 103.081C23.6001 100.531 21.5328 98.4639 18.9827 98.4639C16.4325 98.4639 14.3652 100.531 14.3652 103.081C14.3652 105.631 16.4325 107.699 18.9827 107.699Z",
    fill: "#D6DCD5",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 111.739C13.4551 109.325 15.9932 107.699 18.9837 107.699C21.9742 107.699 24.5124 109.325 25.9099 111.739",
    fill: "#D6DCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 111.739C13.4551 109.325 15.9932 107.699 18.9837 107.699C21.9742 107.699 24.5124 109.325 25.9099 111.739",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path9$3 || (_path9$3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.679 107.532C197.623 107.532 197.571 107.524 197.523 107.508C197.371 107.476 197.263 107.384 197.199 107.232C197.151 107.096 197.163 106.944 197.235 106.776C197.315 106.608 197.419 106.42 197.547 106.212C197.595 106.14 197.639 106.068 197.679 105.996C197.727 105.916 197.767 105.844 197.799 105.78C197.815 105.756 197.827 105.736 197.835 105.72C197.843 105.696 197.851 105.676 197.859 105.66C197.619 105.62 197.339 105.612 197.019 105.636C196.707 105.652 196.355 105.712 195.963 105.816C195.619 105.904 195.247 106.02 194.847 106.164C194.455 106.3 194.039 106.464 193.599 106.656C193.511 106.688 193.423 106.688 193.335 106.656C193.247 106.624 193.183 106.564 193.143 106.476C193.095 106.388 193.091 106.296 193.131 106.2C193.171 106.096 193.235 106.028 193.323 105.996C193.771 105.796 194.199 105.624 194.607 105.48C195.023 105.328 195.415 105.208 195.783 105.12C196.767 104.872 197.571 104.832 198.195 105C198.379 105.048 198.507 105.16 198.579 105.336C198.651 105.512 198.635 105.708 198.531 105.924C198.427 106.14 198.303 106.364 198.159 106.596C198.151 106.612 198.139 106.632 198.123 106.656C198.107 106.68 198.091 106.708 198.075 106.74C198.259 106.7 198.531 106.62 198.891 106.5C199.251 106.38 199.747 106.204 200.379 105.972C200.467 105.94 200.555 105.948 200.643 105.996C200.739 106.036 200.803 106.104 200.835 106.2C200.875 106.288 200.875 106.38 200.835 106.476C200.795 106.564 200.723 106.628 200.619 106.668C200.251 106.796 199.915 106.912 199.611 107.016C199.307 107.12 199.035 107.208 198.795 107.28C198.475 107.376 198.231 107.444 198.063 107.484C197.895 107.516 197.767 107.532 197.679 107.532Z",
    fill: "black"
  })), _path10$3 || (_path10$3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6788 44.532C64.6228 44.532 64.5708 44.524 64.5228 44.508C64.3708 44.476 64.2628 44.384 64.1988 44.232C64.1508 44.096 64.1628 43.944 64.2348 43.776C64.3148 43.608 64.4188 43.42 64.5468 43.212C64.5948 43.14 64.6388 43.068 64.6788 42.996C64.7268 42.916 64.7668 42.844 64.7988 42.78C64.8148 42.756 64.8268 42.736 64.8348 42.72C64.8428 42.696 64.8508 42.676 64.8588 42.66C64.6188 42.62 64.3388 42.612 64.0188 42.636C63.7068 42.652 63.3548 42.712 62.9628 42.816C62.6188 42.904 62.2468 43.02 61.8468 43.164C61.4548 43.3 61.0388 43.464 60.5988 43.656C60.5108 43.688 60.4228 43.688 60.3348 43.656C60.2468 43.624 60.1828 43.564 60.1428 43.476C60.0948 43.388 60.0908 43.296 60.1308 43.2C60.1708 43.096 60.2348 43.028 60.3228 42.996C60.7708 42.796 61.1988 42.624 61.6068 42.48C62.0228 42.328 62.4148 42.208 62.7828 42.12C63.7668 41.872 64.5708 41.832 65.1948 42C65.3788 42.048 65.5068 42.16 65.5788 42.336C65.6508 42.512 65.6348 42.708 65.5308 42.924C65.4268 43.14 65.3028 43.364 65.1588 43.596C65.1508 43.612 65.1388 43.632 65.1228 43.656C65.1068 43.68 65.0908 43.708 65.0748 43.74C65.2588 43.7 65.5308 43.62 65.8908 43.5C66.2508 43.38 66.7468 43.204 67.3788 42.972C67.4668 42.94 67.5548 42.948 67.6428 42.996C67.7388 43.036 67.8028 43.104 67.8348 43.2C67.8748 43.288 67.8748 43.38 67.8348 43.476C67.7948 43.564 67.7228 43.628 67.6188 43.668C67.2508 43.796 66.9148 43.912 66.6108 44.016C66.3068 44.12 66.0348 44.208 65.7948 44.28C65.4748 44.376 65.2308 44.444 65.0628 44.484C64.8948 44.516 64.7668 44.532 64.6788 44.532Z",
    fill: "black"
  })), _path11$3 || (_path11$3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.679 44.532C107.623 44.532 107.571 44.524 107.523 44.508C107.371 44.476 107.263 44.384 107.199 44.232C107.151 44.096 107.163 43.944 107.235 43.776C107.315 43.608 107.419 43.42 107.547 43.212C107.595 43.14 107.639 43.068 107.679 42.996C107.727 42.916 107.767 42.844 107.799 42.78C107.815 42.756 107.827 42.736 107.835 42.72C107.843 42.696 107.851 42.676 107.859 42.66C107.619 42.62 107.339 42.612 107.019 42.636C106.707 42.652 106.355 42.712 105.963 42.816C105.619 42.904 105.247 43.02 104.847 43.164C104.455 43.3 104.039 43.464 103.599 43.656C103.511 43.688 103.423 43.688 103.335 43.656C103.247 43.624 103.183 43.564 103.143 43.476C103.095 43.388 103.091 43.296 103.131 43.2C103.171 43.096 103.235 43.028 103.323 42.996C103.771 42.796 104.199 42.624 104.607 42.48C105.023 42.328 105.415 42.208 105.783 42.12C106.767 41.872 107.571 41.832 108.195 42C108.379 42.048 108.507 42.16 108.579 42.336C108.651 42.512 108.635 42.708 108.531 42.924C108.427 43.14 108.303 43.364 108.159 43.596C108.151 43.612 108.139 43.632 108.123 43.656C108.107 43.68 108.091 43.708 108.075 43.74C108.259 43.7 108.531 43.62 108.891 43.5C109.251 43.38 109.747 43.204 110.379 42.972C110.467 42.94 110.555 42.948 110.643 42.996C110.739 43.036 110.803 43.104 110.835 43.2C110.875 43.288 110.875 43.38 110.835 43.476C110.795 43.564 110.723 43.628 110.619 43.668C110.251 43.796 109.915 43.912 109.611 44.016C109.307 44.12 109.035 44.208 108.795 44.28C108.475 44.376 108.231 44.444 108.063 44.484C107.895 44.516 107.767 44.532 107.679 44.532Z",
    fill: "black"
  })), _path12$3 || (_path12$3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.679 44.532C153.623 44.532 153.571 44.524 153.523 44.508C153.371 44.476 153.263 44.384 153.199 44.232C153.151 44.096 153.163 43.944 153.235 43.776C153.315 43.608 153.419 43.42 153.547 43.212C153.595 43.14 153.639 43.068 153.679 42.996C153.727 42.916 153.767 42.844 153.799 42.78C153.815 42.756 153.827 42.736 153.835 42.72C153.843 42.696 153.851 42.676 153.859 42.66C153.619 42.62 153.339 42.612 153.019 42.636C152.707 42.652 152.355 42.712 151.963 42.816C151.619 42.904 151.247 43.02 150.847 43.164C150.455 43.3 150.039 43.464 149.599 43.656C149.511 43.688 149.423 43.688 149.335 43.656C149.247 43.624 149.183 43.564 149.143 43.476C149.095 43.388 149.091 43.296 149.131 43.2C149.171 43.096 149.235 43.028 149.323 42.996C149.771 42.796 150.199 42.624 150.607 42.48C151.023 42.328 151.415 42.208 151.783 42.12C152.767 41.872 153.571 41.832 154.195 42C154.379 42.048 154.507 42.16 154.579 42.336C154.651 42.512 154.635 42.708 154.531 42.924C154.427 43.14 154.303 43.364 154.159 43.596C154.151 43.612 154.139 43.632 154.123 43.656C154.107 43.68 154.091 43.708 154.075 43.74C154.259 43.7 154.531 43.62 154.891 43.5C155.251 43.38 155.747 43.204 156.379 42.972C156.467 42.94 156.555 42.948 156.643 42.996C156.739 43.036 156.803 43.104 156.835 43.2C156.875 43.288 156.875 43.38 156.835 43.476C156.795 43.564 156.723 43.628 156.619 43.668C156.251 43.796 155.915 43.912 155.611 44.016C155.307 44.12 155.035 44.208 154.795 44.28C154.475 44.376 154.231 44.444 154.063 44.484C153.895 44.516 153.767 44.532 153.679 44.532Z",
    fill: "black"
  })), _path13$3 || (_path13$3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.679 44.532C197.623 44.532 197.571 44.524 197.523 44.508C197.371 44.476 197.263 44.384 197.199 44.232C197.151 44.096 197.163 43.944 197.235 43.776C197.315 43.608 197.419 43.42 197.547 43.212C197.595 43.14 197.639 43.068 197.679 42.996C197.727 42.916 197.767 42.844 197.799 42.78C197.815 42.756 197.827 42.736 197.835 42.72C197.843 42.696 197.851 42.676 197.859 42.66C197.619 42.62 197.339 42.612 197.019 42.636C196.707 42.652 196.355 42.712 195.963 42.816C195.619 42.904 195.247 43.02 194.847 43.164C194.455 43.3 194.039 43.464 193.599 43.656C193.511 43.688 193.423 43.688 193.335 43.656C193.247 43.624 193.183 43.564 193.143 43.476C193.095 43.388 193.091 43.296 193.131 43.2C193.171 43.096 193.235 43.028 193.323 42.996C193.771 42.796 194.199 42.624 194.607 42.48C195.023 42.328 195.415 42.208 195.783 42.12C196.767 41.872 197.571 41.832 198.195 42C198.379 42.048 198.507 42.16 198.579 42.336C198.651 42.512 198.635 42.708 198.531 42.924C198.427 43.14 198.303 43.364 198.159 43.596C198.151 43.612 198.139 43.632 198.123 43.656C198.107 43.68 198.091 43.708 198.075 43.74C198.259 43.7 198.531 43.62 198.891 43.5C199.251 43.38 199.747 43.204 200.379 42.972C200.467 42.94 200.555 42.948 200.643 42.996C200.739 43.036 200.803 43.104 200.835 43.2C200.875 43.288 200.875 43.38 200.835 43.476C200.795 43.564 200.723 43.628 200.619 43.668C200.251 43.796 199.915 43.912 199.611 44.016C199.307 44.12 199.035 44.208 198.795 44.28C198.475 44.376 198.231 44.444 198.063 44.484C197.895 44.516 197.767 44.532 197.679 44.532Z",
    fill: "black"
  })), _path14$2 || (_path14$2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6788 76.532C64.6228 76.532 64.5708 76.524 64.5228 76.508C64.3708 76.476 64.2628 76.384 64.1988 76.232C64.1508 76.096 64.1628 75.944 64.2348 75.776C64.3148 75.608 64.4188 75.42 64.5468 75.212C64.5948 75.14 64.6388 75.068 64.6788 74.996C64.7268 74.916 64.7668 74.844 64.7988 74.78C64.8148 74.756 64.8268 74.736 64.8348 74.72C64.8428 74.696 64.8508 74.676 64.8588 74.66C64.6188 74.62 64.3388 74.612 64.0188 74.636C63.7068 74.652 63.3548 74.712 62.9628 74.816C62.6188 74.904 62.2468 75.02 61.8468 75.164C61.4548 75.3 61.0388 75.464 60.5988 75.656C60.5108 75.688 60.4228 75.688 60.3348 75.656C60.2468 75.624 60.1828 75.564 60.1428 75.476C60.0948 75.388 60.0908 75.296 60.1308 75.2C60.1708 75.096 60.2348 75.028 60.3228 74.996C60.7708 74.796 61.1988 74.624 61.6068 74.48C62.0228 74.328 62.4148 74.208 62.7828 74.12C63.7668 73.872 64.5708 73.832 65.1948 74C65.3788 74.048 65.5068 74.16 65.5788 74.336C65.6508 74.512 65.6348 74.708 65.5308 74.924C65.4268 75.14 65.3028 75.364 65.1588 75.596C65.1508 75.612 65.1388 75.632 65.1228 75.656C65.1068 75.68 65.0908 75.708 65.0748 75.74C65.2588 75.7 65.5308 75.62 65.8908 75.5C66.2508 75.38 66.7468 75.204 67.3788 74.972C67.4668 74.94 67.5548 74.948 67.6428 74.996C67.7388 75.036 67.8028 75.104 67.8348 75.2C67.8748 75.288 67.8748 75.38 67.8348 75.476C67.7948 75.564 67.7228 75.628 67.6188 75.668C67.2508 75.796 66.9148 75.912 66.6108 76.016C66.3068 76.12 66.0348 76.208 65.7948 76.28C65.4748 76.376 65.2308 76.444 65.0628 76.484C64.8948 76.516 64.7668 76.532 64.6788 76.532Z",
    fill: "black"
  })), _path15$2 || (_path15$2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.679 76.532C107.623 76.532 107.571 76.524 107.523 76.508C107.371 76.476 107.263 76.384 107.199 76.232C107.151 76.096 107.163 75.944 107.235 75.776C107.315 75.608 107.419 75.42 107.547 75.212C107.595 75.14 107.639 75.068 107.679 74.996C107.727 74.916 107.767 74.844 107.799 74.78C107.815 74.756 107.827 74.736 107.835 74.72C107.843 74.696 107.851 74.676 107.859 74.66C107.619 74.62 107.339 74.612 107.019 74.636C106.707 74.652 106.355 74.712 105.963 74.816C105.619 74.904 105.247 75.02 104.847 75.164C104.455 75.3 104.039 75.464 103.599 75.656C103.511 75.688 103.423 75.688 103.335 75.656C103.247 75.624 103.183 75.564 103.143 75.476C103.095 75.388 103.091 75.296 103.131 75.2C103.171 75.096 103.235 75.028 103.323 74.996C103.771 74.796 104.199 74.624 104.607 74.48C105.023 74.328 105.415 74.208 105.783 74.12C106.767 73.872 107.571 73.832 108.195 74C108.379 74.048 108.507 74.16 108.579 74.336C108.651 74.512 108.635 74.708 108.531 74.924C108.427 75.14 108.303 75.364 108.159 75.596C108.151 75.612 108.139 75.632 108.123 75.656C108.107 75.68 108.091 75.708 108.075 75.74C108.259 75.7 108.531 75.62 108.891 75.5C109.251 75.38 109.747 75.204 110.379 74.972C110.467 74.94 110.555 74.948 110.643 74.996C110.739 75.036 110.803 75.104 110.835 75.2C110.875 75.288 110.875 75.38 110.835 75.476C110.795 75.564 110.723 75.628 110.619 75.668C110.251 75.796 109.915 75.912 109.611 76.016C109.307 76.12 109.035 76.208 108.795 76.28C108.475 76.376 108.231 76.444 108.063 76.484C107.895 76.516 107.767 76.532 107.679 76.532Z",
    fill: "black"
  })), _path16$2 || (_path16$2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.679 76.532C153.623 76.532 153.571 76.524 153.523 76.508C153.371 76.476 153.263 76.384 153.199 76.232C153.151 76.096 153.163 75.944 153.235 75.776C153.315 75.608 153.419 75.42 153.547 75.212C153.595 75.14 153.639 75.068 153.679 74.996C153.727 74.916 153.767 74.844 153.799 74.78C153.815 74.756 153.827 74.736 153.835 74.72C153.843 74.696 153.851 74.676 153.859 74.66C153.619 74.62 153.339 74.612 153.019 74.636C152.707 74.652 152.355 74.712 151.963 74.816C151.619 74.904 151.247 75.02 150.847 75.164C150.455 75.3 150.039 75.464 149.599 75.656C149.511 75.688 149.423 75.688 149.335 75.656C149.247 75.624 149.183 75.564 149.143 75.476C149.095 75.388 149.091 75.296 149.131 75.2C149.171 75.096 149.235 75.028 149.323 74.996C149.771 74.796 150.199 74.624 150.607 74.48C151.023 74.328 151.415 74.208 151.783 74.12C152.767 73.872 153.571 73.832 154.195 74C154.379 74.048 154.507 74.16 154.579 74.336C154.651 74.512 154.635 74.708 154.531 74.924C154.427 75.14 154.303 75.364 154.159 75.596C154.151 75.612 154.139 75.632 154.123 75.656C154.107 75.68 154.091 75.708 154.075 75.74C154.259 75.7 154.531 75.62 154.891 75.5C155.251 75.38 155.747 75.204 156.379 74.972C156.467 74.94 156.555 74.948 156.643 74.996C156.739 75.036 156.803 75.104 156.835 75.2C156.875 75.288 156.875 75.38 156.835 75.476C156.795 75.564 156.723 75.628 156.619 75.668C156.251 75.796 155.915 75.912 155.611 76.016C155.307 76.12 155.035 76.208 154.795 76.28C154.475 76.376 154.231 76.444 154.063 76.484C153.895 76.516 153.767 76.532 153.679 76.532Z",
    fill: "black"
  })), _path17$2 || (_path17$2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.679 76.532C197.623 76.532 197.571 76.524 197.523 76.508C197.371 76.476 197.263 76.384 197.199 76.232C197.151 76.096 197.163 75.944 197.235 75.776C197.315 75.608 197.419 75.42 197.547 75.212C197.595 75.14 197.639 75.068 197.679 74.996C197.727 74.916 197.767 74.844 197.799 74.78C197.815 74.756 197.827 74.736 197.835 74.72C197.843 74.696 197.851 74.676 197.859 74.66C197.619 74.62 197.339 74.612 197.019 74.636C196.707 74.652 196.355 74.712 195.963 74.816C195.619 74.904 195.247 75.02 194.847 75.164C194.455 75.3 194.039 75.464 193.599 75.656C193.511 75.688 193.423 75.688 193.335 75.656C193.247 75.624 193.183 75.564 193.143 75.476C193.095 75.388 193.091 75.296 193.131 75.2C193.171 75.096 193.235 75.028 193.323 74.996C193.771 74.796 194.199 74.624 194.607 74.48C195.023 74.328 195.415 74.208 195.783 74.12C196.767 73.872 197.571 73.832 198.195 74C198.379 74.048 198.507 74.16 198.579 74.336C198.651 74.512 198.635 74.708 198.531 74.924C198.427 75.14 198.303 75.364 198.159 75.596C198.151 75.612 198.139 75.632 198.123 75.656C198.107 75.68 198.091 75.708 198.075 75.74C198.259 75.7 198.531 75.62 198.891 75.5C199.251 75.38 199.747 75.204 200.379 74.972C200.467 74.94 200.555 74.948 200.643 74.996C200.739 75.036 200.803 75.104 200.835 75.2C200.875 75.288 200.875 75.38 200.835 75.476C200.795 75.564 200.723 75.628 200.619 75.668C200.251 75.796 199.915 75.912 199.611 76.016C199.307 76.12 199.035 76.208 198.795 76.28C198.475 76.376 198.231 76.444 198.063 76.484C197.895 76.516 197.767 76.532 197.679 76.532Z",
    fill: "black"
  })), _path18$2 || (_path18$2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6788 107.532C64.6228 107.532 64.5708 107.524 64.5228 107.508C64.3708 107.476 64.2628 107.384 64.1988 107.232C64.1508 107.096 64.1628 106.944 64.2348 106.776C64.3148 106.608 64.4188 106.42 64.5468 106.212C64.5948 106.14 64.6388 106.068 64.6788 105.996C64.7268 105.916 64.7668 105.844 64.7988 105.78C64.8148 105.756 64.8268 105.736 64.8348 105.72C64.8428 105.696 64.8508 105.676 64.8588 105.66C64.6188 105.62 64.3388 105.612 64.0188 105.636C63.7068 105.652 63.3548 105.712 62.9628 105.816C62.6188 105.904 62.2468 106.02 61.8468 106.164C61.4548 106.3 61.0388 106.464 60.5988 106.656C60.5108 106.688 60.4228 106.688 60.3348 106.656C60.2468 106.624 60.1828 106.564 60.1428 106.476C60.0948 106.388 60.0908 106.296 60.1308 106.2C60.1708 106.096 60.2348 106.028 60.3228 105.996C60.7708 105.796 61.1988 105.624 61.6068 105.48C62.0228 105.328 62.4148 105.208 62.7828 105.12C63.7668 104.872 64.5708 104.832 65.1948 105C65.3788 105.048 65.5068 105.16 65.5788 105.336C65.6508 105.512 65.6348 105.708 65.5308 105.924C65.4268 106.14 65.3028 106.364 65.1588 106.596C65.1508 106.612 65.1388 106.632 65.1228 106.656C65.1068 106.68 65.0908 106.708 65.0748 106.74C65.2588 106.7 65.5308 106.62 65.8908 106.5C66.2508 106.38 66.7468 106.204 67.3788 105.972C67.4668 105.94 67.5548 105.948 67.6428 105.996C67.7388 106.036 67.8028 106.104 67.8348 106.2C67.8748 106.288 67.8748 106.38 67.8348 106.476C67.7948 106.564 67.7228 106.628 67.6188 106.668C67.2508 106.796 66.9148 106.912 66.6108 107.016C66.3068 107.12 66.0348 107.208 65.7948 107.28C65.4748 107.376 65.2308 107.444 65.0628 107.484C64.8948 107.516 64.7668 107.532 64.6788 107.532Z",
    fill: "black"
  })), _path19$2 || (_path19$2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.679 107.532C107.623 107.532 107.571 107.524 107.523 107.508C107.371 107.476 107.263 107.384 107.199 107.232C107.151 107.096 107.163 106.944 107.235 106.776C107.315 106.608 107.419 106.42 107.547 106.212C107.595 106.14 107.639 106.068 107.679 105.996C107.727 105.916 107.767 105.844 107.799 105.78C107.815 105.756 107.827 105.736 107.835 105.72C107.843 105.696 107.851 105.676 107.859 105.66C107.619 105.62 107.339 105.612 107.019 105.636C106.707 105.652 106.355 105.712 105.963 105.816C105.619 105.904 105.247 106.02 104.847 106.164C104.455 106.3 104.039 106.464 103.599 106.656C103.511 106.688 103.423 106.688 103.335 106.656C103.247 106.624 103.183 106.564 103.143 106.476C103.095 106.388 103.091 106.296 103.131 106.2C103.171 106.096 103.235 106.028 103.323 105.996C103.771 105.796 104.199 105.624 104.607 105.48C105.023 105.328 105.415 105.208 105.783 105.12C106.767 104.872 107.571 104.832 108.195 105C108.379 105.048 108.507 105.16 108.579 105.336C108.651 105.512 108.635 105.708 108.531 105.924C108.427 106.14 108.303 106.364 108.159 106.596C108.151 106.612 108.139 106.632 108.123 106.656C108.107 106.68 108.091 106.708 108.075 106.74C108.259 106.7 108.531 106.62 108.891 106.5C109.251 106.38 109.747 106.204 110.379 105.972C110.467 105.94 110.555 105.948 110.643 105.996C110.739 106.036 110.803 106.104 110.835 106.2C110.875 106.288 110.875 106.38 110.835 106.476C110.795 106.564 110.723 106.628 110.619 106.668C110.251 106.796 109.915 106.912 109.611 107.016C109.307 107.12 109.035 107.208 108.795 107.28C108.475 107.376 108.231 107.444 108.063 107.484C107.895 107.516 107.767 107.532 107.679 107.532Z",
    fill: "black"
  })), _path20$2 || (_path20$2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.679 107.532C153.623 107.532 153.571 107.524 153.523 107.508C153.371 107.476 153.263 107.384 153.199 107.232C153.151 107.096 153.163 106.944 153.235 106.776C153.315 106.608 153.419 106.42 153.547 106.212C153.595 106.14 153.639 106.068 153.679 105.996C153.727 105.916 153.767 105.844 153.799 105.78C153.815 105.756 153.827 105.736 153.835 105.72C153.843 105.696 153.851 105.676 153.859 105.66C153.619 105.62 153.339 105.612 153.019 105.636C152.707 105.652 152.355 105.712 151.963 105.816C151.619 105.904 151.247 106.02 150.847 106.164C150.455 106.3 150.039 106.464 149.599 106.656C149.511 106.688 149.423 106.688 149.335 106.656C149.247 106.624 149.183 106.564 149.143 106.476C149.095 106.388 149.091 106.296 149.131 106.2C149.171 106.096 149.235 106.028 149.323 105.996C149.771 105.796 150.199 105.624 150.607 105.48C151.023 105.328 151.415 105.208 151.783 105.12C152.767 104.872 153.571 104.832 154.195 105C154.379 105.048 154.507 105.16 154.579 105.336C154.651 105.512 154.635 105.708 154.531 105.924C154.427 106.14 154.303 106.364 154.159 106.596C154.151 106.612 154.139 106.632 154.123 106.656C154.107 106.68 154.091 106.708 154.075 106.74C154.259 106.7 154.531 106.62 154.891 106.5C155.251 106.38 155.747 106.204 156.379 105.972C156.467 105.94 156.555 105.948 156.643 105.996C156.739 106.036 156.803 106.104 156.835 106.2C156.875 106.288 156.875 106.38 156.835 106.476C156.795 106.564 156.723 106.628 156.619 106.668C156.251 106.796 155.915 106.912 155.611 107.016C155.307 107.12 155.035 107.208 154.795 107.28C154.475 107.376 154.231 107.444 154.063 107.484C153.895 107.516 153.767 107.532 153.679 107.532Z",
    fill: "black"
  })), _path21$2 || (_path21$2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7683 9.03L57.7483 16H56.7283L55.1083 10.39L53.4283 16L52.4183 16.01L50.4683 9.03H51.4383L52.9583 14.94L54.6383 9.03H55.6583L57.2583 14.92L58.7883 9.03H59.7683ZM63.8241 16L61.6741 13.58V16H60.7641V8.6H61.6741V12.95L63.7841 10.52H65.0541L62.4741 13.25L65.0641 16H63.8241ZM68.1866 9.6V8.77H70.0666V16H69.1466V9.6H68.1866ZM71.5198 15.27C72.3664 14.59 73.0298 14.0333 73.5098 13.6C73.9898 13.16 74.3931 12.7033 74.7198 12.23C75.0531 11.75 75.2198 11.28 75.2198 10.82C75.2198 10.3867 75.1131 10.0467 74.8998 9.8C74.6931 9.54667 74.3564 9.42 73.8898 9.42C73.4364 9.42 73.0831 9.56333 72.8298 9.85C72.5831 10.13 72.4498 10.5067 72.4298 10.98H71.5498C71.5764 10.2333 71.8031 9.65667 72.2298 9.25C72.6564 8.84333 73.2064 8.64 73.8798 8.64C74.5664 8.64 75.1098 8.83 75.5098 9.21C75.9164 9.59 76.1198 10.1133 76.1198 10.78C76.1198 11.3333 75.9531 11.8733 75.6198 12.4C75.2931 12.92 74.9198 13.38 74.4998 13.78C74.0798 14.1733 73.5431 14.6333 72.8898 15.16H76.3298V15.92H71.5198V15.27Z",
    fill: "black"
  })), _path22$2 || (_path22$2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.7 9.03L102.68 16H101.66L100.04 10.39L98.3599 16L97.3499 16.01L95.3999 9.03H96.3699L97.8899 14.94L99.5699 9.03H100.59L102.19 14.92L103.72 9.03H104.7ZM108.756 16L106.606 13.58V16H105.696V8.6H106.606V12.95L108.716 10.52H109.986L107.406 13.25L109.996 16H108.756ZM113.118 9.6V8.77H114.998V16H114.078V9.6H113.118ZM116.541 10.59C116.588 9.97667 116.825 9.49667 117.251 9.15C117.678 8.80333 118.231 8.63 118.911 8.63C119.365 8.63 119.755 8.71333 120.081 8.88C120.415 9.04 120.665 9.26 120.831 9.54C121.005 9.82 121.091 10.1367 121.091 10.49C121.091 10.9033 120.971 11.26 120.731 11.56C120.498 11.86 120.191 12.0533 119.811 12.14V12.19C120.245 12.2967 120.588 12.5067 120.841 12.82C121.095 13.1333 121.221 13.5433 121.221 14.05C121.221 14.43 121.135 14.7733 120.961 15.08C120.788 15.38 120.528 15.6167 120.181 15.79C119.835 15.9633 119.418 16.05 118.931 16.05C118.225 16.05 117.645 15.8667 117.191 15.5C116.738 15.1267 116.485 14.6 116.431 13.92H117.311C117.358 14.32 117.521 14.6467 117.801 14.9C118.081 15.1533 118.455 15.28 118.921 15.28C119.388 15.28 119.741 15.16 119.981 14.92C120.228 14.6733 120.351 14.3567 120.351 13.97C120.351 13.47 120.185 13.11 119.851 12.89C119.518 12.67 119.015 12.56 118.341 12.56H118.111V11.8H118.351C118.965 11.7933 119.428 11.6933 119.741 11.5C120.055 11.3 120.211 10.9933 120.211 10.58C120.211 10.2267 120.095 9.94333 119.861 9.73C119.635 9.51667 119.308 9.41 118.881 9.41C118.468 9.41 118.135 9.51667 117.881 9.73C117.628 9.94333 117.478 10.23 117.431 10.59H116.541Z",
    fill: "black"
  })), _path23$2 || (_path23$2 = /*#__PURE__*/React.createElement("path", {
    d: "M151 9.03L148.98 16H147.96L146.34 10.39L144.66 16L143.65 16.01L141.7 9.03H142.67L144.19 14.94L145.87 9.03H146.89L148.49 14.92L150.02 9.03H151ZM155.056 16L152.906 13.58V16H151.996V8.6H152.906V12.95L155.016 10.52H156.286L153.706 13.25L156.296 16H155.056ZM159.418 9.6V8.77H161.298V16H160.378V9.6H159.418ZM162.641 14.39V13.7L166.151 8.84H167.241V13.6H168.241V14.39H167.241V16H166.341V14.39H162.641ZM166.381 9.79L163.691 13.6H166.381V9.79Z",
    fill: "black"
  })), _path24$2 || (_path24$2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.005 9.03L192.985 16H191.965L190.345 10.39L188.665 16L187.655 16.01L185.705 9.03H186.675L188.195 14.94L189.875 9.03H190.895L192.495 14.92L194.025 9.03H195.005ZM199.06 16L196.91 13.58V16H196V8.6H196.91V12.95L199.02 10.52H200.29L197.71 13.25L200.3 16H199.06ZM203.423 9.6V8.77H205.303V16H204.383V9.6H203.423ZM211.476 9.56H207.966V11.84C208.119 11.6267 208.346 11.4533 208.646 11.32C208.946 11.18 209.269 11.11 209.616 11.11C210.169 11.11 210.619 11.2267 210.966 11.46C211.313 11.6867 211.559 11.9833 211.706 12.35C211.859 12.71 211.936 13.0933 211.936 13.5C211.936 13.98 211.846 14.41 211.666 14.79C211.486 15.17 211.209 15.47 210.836 15.69C210.469 15.91 210.013 16.02 209.466 16.02C208.766 16.02 208.199 15.84 207.766 15.48C207.333 15.12 207.069 14.64 206.976 14.04H207.866C207.953 14.42 208.136 14.7167 208.416 14.93C208.696 15.1433 209.049 15.25 209.476 15.25C210.003 15.25 210.399 15.0933 210.666 14.78C210.933 14.46 211.066 14.04 211.066 13.52C211.066 13 210.933 12.6 210.666 12.32C210.399 12.0333 210.006 11.89 209.486 11.89C209.133 11.89 208.823 11.9767 208.556 12.15C208.296 12.3167 208.106 12.5467 207.986 12.84H207.126V8.76H211.476V9.56Z",
    fill: "black"
  })), _defs$2 || (_defs$2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2686_31363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18.75,
    fill: "white",
    transform: "translate(9 32)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2686_31363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18.75,
    fill: "white",
    transform: "translate(9 63.375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2686_31363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18.75,
    fill: "white",
    transform: "translate(9 96)"
  })))));
};
var ForwardRef$6 = /*#__PURE__*/forwardRef(SvgSplitByTimePeriodWk);
var _rect$1, _rect2$1, _rect3$1, _path$5, _path2$4, _path3$4, _path4$2, _path5$2, _path6$2, _path7$2, _path8$2, _rect4$1, _rect5$1, _rect6$1, _rect7$1, _g$1, _g2$1, _g3$1, _path9$2, _path10$2, _path11$2, _path12$2, _path13$2, _path14$1, _path15$1, _path16$1, _path17$1, _path18$1, _path19$1, _path20$1, _path21$1, _path22$1, _path23$1, _path24$1, _defs$1;
var _excluded$8 = ["title", "titleId"];
function _extends$7() {
  return _extends$7 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$7.apply(null, arguments);
}
function _objectWithoutProperties$6(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$7(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$7(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgSplitByTimePeriodYear = function SvgSplitByTimePeriodYear(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$6(_ref, _excluded$8);
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    width: 221,
    height: 127,
    viewBox: "0 0 221 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect$1 || (_rect$1 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 28,
    width: 172,
    height: 27,
    rx: 4,
    fill: "#DEE4DE"
  })), _rect2$1 || (_rect2$1 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 61,
    width: 172,
    height: 24,
    rx: 4,
    fill: "#DEE4DE"
  })), _rect3$1 || (_rect3$1 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 91,
    width: 172,
    height: 28,
    rx: 4,
    fill: "#DEE4DE"
  })), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    d: "M42 1L42 123",
    stroke: "#BDCAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
    d: "M85 1L85 123",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path3$4 || (_path3$4 = /*#__PURE__*/React.createElement("path", {
    d: "M130 1L130 123",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path4$2 || (_path4$2 = /*#__PURE__*/React.createElement("path", {
    d: "M176 1L176 123",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path5$2 || (_path5$2 = /*#__PURE__*/React.createElement("path", {
    d: "M220 1L220 123",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path6$2 || (_path6$2 = /*#__PURE__*/React.createElement("path", {
    d: "M219 25L1.00001 25",
    stroke: "#BDCAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7$2 || (_path7$2 = /*#__PURE__*/React.createElement("path", {
    d: "M220 58L0.999999 58",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path8$2 || (_path8$2 = /*#__PURE__*/React.createElement("path", {
    d: "M220 88L0.999999 88",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _rect4$1 || (_rect4$1 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 1.20703,
    width: 39,
    height: 22,
    rx: 4,
    fill: "#F4F0EF"
  })), _rect5$1 || (_rect5$1 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 1.20703,
    width: 41,
    height: 22,
    rx: 4,
    fill: "#F4F0EF"
  })), _rect6$1 || (_rect6$1 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 1.20703,
    width: 42,
    height: 22,
    rx: 4,
    fill: "#F4F0EF"
  })), _rect7$1 || (_rect7$1 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 1.20703,
    width: 40,
    height: 22,
    rx: 4,
    fill: "#F4F0EF"
  })), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2686_31407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9827 43.6987C21.5328 43.6987 23.6001 41.6314 23.6001 39.0813C23.6001 36.5312 21.5328 34.4639 18.9827 34.4639C16.4325 34.4639 14.3652 36.5312 14.3652 39.0813C14.3652 41.6314 16.4325 43.6987 18.9827 43.6987Z",
    fill: "#D6DCD5",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 47.7395C13.4551 45.3247 15.9932 43.6992 18.9837 43.6992C21.9742 43.6992 24.5124 45.3247 25.9099 47.7395",
    fill: "#D6DCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 47.7395C13.4551 45.3247 15.9932 43.6992 18.9837 43.6992C21.9742 43.6992 24.5124 45.3247 25.9099 47.7395",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2$1 || (_g2$1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2686_31407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9827 75.0737C21.5328 75.0737 23.6001 73.0064 23.6001 70.4563C23.6001 67.9062 21.5328 65.8389 18.9827 65.8389C16.4325 65.8389 14.3652 67.9062 14.3652 70.4563C14.3652 73.0064 16.4325 75.0737 18.9827 75.0737Z",
    fill: "#D6DCD5",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 79.1145C13.4551 76.6997 15.9932 75.0742 18.9837 75.0742C21.9742 75.0742 24.5124 76.6997 25.9099 79.1145",
    fill: "#D6DCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 79.1145C13.4551 76.6997 15.9932 75.0742 18.9837 75.0742C21.9742 75.0742 24.5124 76.6997 25.9099 79.1145",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3$1 || (_g3$1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2686_31407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9827 107.699C21.5328 107.699 23.6001 105.631 23.6001 103.081C23.6001 100.531 21.5328 98.4639 18.9827 98.4639C16.4325 98.4639 14.3652 100.531 14.3652 103.081C14.3652 105.631 16.4325 107.699 18.9827 107.699Z",
    fill: "#D6DCD5",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 111.739C13.4551 109.325 15.9932 107.699 18.9837 107.699C21.9742 107.699 24.5124 109.325 25.9099 111.739",
    fill: "#D6DCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 111.739C13.4551 109.325 15.9932 107.699 18.9837 107.699C21.9742 107.699 24.5124 109.325 25.9099 111.739",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path9$2 || (_path9$2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.679 107.532C197.623 107.532 197.571 107.524 197.523 107.508C197.371 107.476 197.263 107.384 197.199 107.232C197.151 107.096 197.163 106.944 197.235 106.776C197.315 106.608 197.419 106.42 197.547 106.212C197.595 106.14 197.639 106.068 197.679 105.996C197.727 105.916 197.767 105.844 197.799 105.78C197.815 105.756 197.827 105.736 197.835 105.72C197.843 105.696 197.851 105.676 197.859 105.66C197.619 105.62 197.339 105.612 197.019 105.636C196.707 105.652 196.355 105.712 195.963 105.816C195.619 105.904 195.247 106.02 194.847 106.164C194.455 106.3 194.039 106.464 193.599 106.656C193.511 106.688 193.423 106.688 193.335 106.656C193.247 106.624 193.183 106.564 193.143 106.476C193.095 106.388 193.091 106.296 193.131 106.2C193.171 106.096 193.235 106.028 193.323 105.996C193.771 105.796 194.199 105.624 194.607 105.48C195.023 105.328 195.415 105.208 195.783 105.12C196.767 104.872 197.571 104.832 198.195 105C198.379 105.048 198.507 105.16 198.579 105.336C198.651 105.512 198.635 105.708 198.531 105.924C198.427 106.14 198.303 106.364 198.159 106.596C198.151 106.612 198.139 106.632 198.123 106.656C198.107 106.68 198.091 106.708 198.075 106.74C198.259 106.7 198.531 106.62 198.891 106.5C199.251 106.38 199.747 106.204 200.379 105.972C200.467 105.94 200.555 105.948 200.643 105.996C200.739 106.036 200.803 106.104 200.835 106.2C200.875 106.288 200.875 106.38 200.835 106.476C200.795 106.564 200.723 106.628 200.619 106.668C200.251 106.796 199.915 106.912 199.611 107.016C199.307 107.12 199.035 107.208 198.795 107.28C198.475 107.376 198.231 107.444 198.063 107.484C197.895 107.516 197.767 107.532 197.679 107.532Z",
    fill: "black"
  })), _path10$2 || (_path10$2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6788 44.532C64.6228 44.532 64.5708 44.524 64.5228 44.508C64.3708 44.476 64.2628 44.384 64.1988 44.232C64.1508 44.096 64.1628 43.944 64.2348 43.776C64.3148 43.608 64.4188 43.42 64.5468 43.212C64.5948 43.14 64.6388 43.068 64.6788 42.996C64.7268 42.916 64.7668 42.844 64.7988 42.78C64.8148 42.756 64.8268 42.736 64.8348 42.72C64.8428 42.696 64.8508 42.676 64.8588 42.66C64.6188 42.62 64.3388 42.612 64.0188 42.636C63.7068 42.652 63.3548 42.712 62.9628 42.816C62.6188 42.904 62.2468 43.02 61.8468 43.164C61.4548 43.3 61.0388 43.464 60.5988 43.656C60.5108 43.688 60.4228 43.688 60.3348 43.656C60.2468 43.624 60.1828 43.564 60.1428 43.476C60.0948 43.388 60.0908 43.296 60.1308 43.2C60.1708 43.096 60.2348 43.028 60.3228 42.996C60.7708 42.796 61.1988 42.624 61.6068 42.48C62.0228 42.328 62.4148 42.208 62.7828 42.12C63.7668 41.872 64.5708 41.832 65.1948 42C65.3788 42.048 65.5068 42.16 65.5788 42.336C65.6508 42.512 65.6348 42.708 65.5308 42.924C65.4268 43.14 65.3028 43.364 65.1588 43.596C65.1508 43.612 65.1388 43.632 65.1228 43.656C65.1068 43.68 65.0908 43.708 65.0748 43.74C65.2588 43.7 65.5308 43.62 65.8908 43.5C66.2508 43.38 66.7468 43.204 67.3788 42.972C67.4668 42.94 67.5548 42.948 67.6428 42.996C67.7388 43.036 67.8028 43.104 67.8348 43.2C67.8748 43.288 67.8748 43.38 67.8348 43.476C67.7948 43.564 67.7228 43.628 67.6188 43.668C67.2508 43.796 66.9148 43.912 66.6108 44.016C66.3068 44.12 66.0348 44.208 65.7948 44.28C65.4748 44.376 65.2308 44.444 65.0628 44.484C64.8948 44.516 64.7668 44.532 64.6788 44.532Z",
    fill: "black"
  })), _path11$2 || (_path11$2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.679 44.532C107.623 44.532 107.571 44.524 107.523 44.508C107.371 44.476 107.263 44.384 107.199 44.232C107.151 44.096 107.163 43.944 107.235 43.776C107.315 43.608 107.419 43.42 107.547 43.212C107.595 43.14 107.639 43.068 107.679 42.996C107.727 42.916 107.767 42.844 107.799 42.78C107.815 42.756 107.827 42.736 107.835 42.72C107.843 42.696 107.851 42.676 107.859 42.66C107.619 42.62 107.339 42.612 107.019 42.636C106.707 42.652 106.355 42.712 105.963 42.816C105.619 42.904 105.247 43.02 104.847 43.164C104.455 43.3 104.039 43.464 103.599 43.656C103.511 43.688 103.423 43.688 103.335 43.656C103.247 43.624 103.183 43.564 103.143 43.476C103.095 43.388 103.091 43.296 103.131 43.2C103.171 43.096 103.235 43.028 103.323 42.996C103.771 42.796 104.199 42.624 104.607 42.48C105.023 42.328 105.415 42.208 105.783 42.12C106.767 41.872 107.571 41.832 108.195 42C108.379 42.048 108.507 42.16 108.579 42.336C108.651 42.512 108.635 42.708 108.531 42.924C108.427 43.14 108.303 43.364 108.159 43.596C108.151 43.612 108.139 43.632 108.123 43.656C108.107 43.68 108.091 43.708 108.075 43.74C108.259 43.7 108.531 43.62 108.891 43.5C109.251 43.38 109.747 43.204 110.379 42.972C110.467 42.94 110.555 42.948 110.643 42.996C110.739 43.036 110.803 43.104 110.835 43.2C110.875 43.288 110.875 43.38 110.835 43.476C110.795 43.564 110.723 43.628 110.619 43.668C110.251 43.796 109.915 43.912 109.611 44.016C109.307 44.12 109.035 44.208 108.795 44.28C108.475 44.376 108.231 44.444 108.063 44.484C107.895 44.516 107.767 44.532 107.679 44.532Z",
    fill: "black"
  })), _path12$2 || (_path12$2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.679 44.532C153.623 44.532 153.571 44.524 153.523 44.508C153.371 44.476 153.263 44.384 153.199 44.232C153.151 44.096 153.163 43.944 153.235 43.776C153.315 43.608 153.419 43.42 153.547 43.212C153.595 43.14 153.639 43.068 153.679 42.996C153.727 42.916 153.767 42.844 153.799 42.78C153.815 42.756 153.827 42.736 153.835 42.72C153.843 42.696 153.851 42.676 153.859 42.66C153.619 42.62 153.339 42.612 153.019 42.636C152.707 42.652 152.355 42.712 151.963 42.816C151.619 42.904 151.247 43.02 150.847 43.164C150.455 43.3 150.039 43.464 149.599 43.656C149.511 43.688 149.423 43.688 149.335 43.656C149.247 43.624 149.183 43.564 149.143 43.476C149.095 43.388 149.091 43.296 149.131 43.2C149.171 43.096 149.235 43.028 149.323 42.996C149.771 42.796 150.199 42.624 150.607 42.48C151.023 42.328 151.415 42.208 151.783 42.12C152.767 41.872 153.571 41.832 154.195 42C154.379 42.048 154.507 42.16 154.579 42.336C154.651 42.512 154.635 42.708 154.531 42.924C154.427 43.14 154.303 43.364 154.159 43.596C154.151 43.612 154.139 43.632 154.123 43.656C154.107 43.68 154.091 43.708 154.075 43.74C154.259 43.7 154.531 43.62 154.891 43.5C155.251 43.38 155.747 43.204 156.379 42.972C156.467 42.94 156.555 42.948 156.643 42.996C156.739 43.036 156.803 43.104 156.835 43.2C156.875 43.288 156.875 43.38 156.835 43.476C156.795 43.564 156.723 43.628 156.619 43.668C156.251 43.796 155.915 43.912 155.611 44.016C155.307 44.12 155.035 44.208 154.795 44.28C154.475 44.376 154.231 44.444 154.063 44.484C153.895 44.516 153.767 44.532 153.679 44.532Z",
    fill: "black"
  })), _path13$2 || (_path13$2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.679 44.532C197.623 44.532 197.571 44.524 197.523 44.508C197.371 44.476 197.263 44.384 197.199 44.232C197.151 44.096 197.163 43.944 197.235 43.776C197.315 43.608 197.419 43.42 197.547 43.212C197.595 43.14 197.639 43.068 197.679 42.996C197.727 42.916 197.767 42.844 197.799 42.78C197.815 42.756 197.827 42.736 197.835 42.72C197.843 42.696 197.851 42.676 197.859 42.66C197.619 42.62 197.339 42.612 197.019 42.636C196.707 42.652 196.355 42.712 195.963 42.816C195.619 42.904 195.247 43.02 194.847 43.164C194.455 43.3 194.039 43.464 193.599 43.656C193.511 43.688 193.423 43.688 193.335 43.656C193.247 43.624 193.183 43.564 193.143 43.476C193.095 43.388 193.091 43.296 193.131 43.2C193.171 43.096 193.235 43.028 193.323 42.996C193.771 42.796 194.199 42.624 194.607 42.48C195.023 42.328 195.415 42.208 195.783 42.12C196.767 41.872 197.571 41.832 198.195 42C198.379 42.048 198.507 42.16 198.579 42.336C198.651 42.512 198.635 42.708 198.531 42.924C198.427 43.14 198.303 43.364 198.159 43.596C198.151 43.612 198.139 43.632 198.123 43.656C198.107 43.68 198.091 43.708 198.075 43.74C198.259 43.7 198.531 43.62 198.891 43.5C199.251 43.38 199.747 43.204 200.379 42.972C200.467 42.94 200.555 42.948 200.643 42.996C200.739 43.036 200.803 43.104 200.835 43.2C200.875 43.288 200.875 43.38 200.835 43.476C200.795 43.564 200.723 43.628 200.619 43.668C200.251 43.796 199.915 43.912 199.611 44.016C199.307 44.12 199.035 44.208 198.795 44.28C198.475 44.376 198.231 44.444 198.063 44.484C197.895 44.516 197.767 44.532 197.679 44.532Z",
    fill: "black"
  })), _path14$1 || (_path14$1 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6788 76.532C64.6228 76.532 64.5708 76.524 64.5228 76.508C64.3708 76.476 64.2628 76.384 64.1988 76.232C64.1508 76.096 64.1628 75.944 64.2348 75.776C64.3148 75.608 64.4188 75.42 64.5468 75.212C64.5948 75.14 64.6388 75.068 64.6788 74.996C64.7268 74.916 64.7668 74.844 64.7988 74.78C64.8148 74.756 64.8268 74.736 64.8348 74.72C64.8428 74.696 64.8508 74.676 64.8588 74.66C64.6188 74.62 64.3388 74.612 64.0188 74.636C63.7068 74.652 63.3548 74.712 62.9628 74.816C62.6188 74.904 62.2468 75.02 61.8468 75.164C61.4548 75.3 61.0388 75.464 60.5988 75.656C60.5108 75.688 60.4228 75.688 60.3348 75.656C60.2468 75.624 60.1828 75.564 60.1428 75.476C60.0948 75.388 60.0908 75.296 60.1308 75.2C60.1708 75.096 60.2348 75.028 60.3228 74.996C60.7708 74.796 61.1988 74.624 61.6068 74.48C62.0228 74.328 62.4148 74.208 62.7828 74.12C63.7668 73.872 64.5708 73.832 65.1948 74C65.3788 74.048 65.5068 74.16 65.5788 74.336C65.6508 74.512 65.6348 74.708 65.5308 74.924C65.4268 75.14 65.3028 75.364 65.1588 75.596C65.1508 75.612 65.1388 75.632 65.1228 75.656C65.1068 75.68 65.0908 75.708 65.0748 75.74C65.2588 75.7 65.5308 75.62 65.8908 75.5C66.2508 75.38 66.7468 75.204 67.3788 74.972C67.4668 74.94 67.5548 74.948 67.6428 74.996C67.7388 75.036 67.8028 75.104 67.8348 75.2C67.8748 75.288 67.8748 75.38 67.8348 75.476C67.7948 75.564 67.7228 75.628 67.6188 75.668C67.2508 75.796 66.9148 75.912 66.6108 76.016C66.3068 76.12 66.0348 76.208 65.7948 76.28C65.4748 76.376 65.2308 76.444 65.0628 76.484C64.8948 76.516 64.7668 76.532 64.6788 76.532Z",
    fill: "black"
  })), _path15$1 || (_path15$1 = /*#__PURE__*/React.createElement("path", {
    d: "M107.679 76.532C107.623 76.532 107.571 76.524 107.523 76.508C107.371 76.476 107.263 76.384 107.199 76.232C107.151 76.096 107.163 75.944 107.235 75.776C107.315 75.608 107.419 75.42 107.547 75.212C107.595 75.14 107.639 75.068 107.679 74.996C107.727 74.916 107.767 74.844 107.799 74.78C107.815 74.756 107.827 74.736 107.835 74.72C107.843 74.696 107.851 74.676 107.859 74.66C107.619 74.62 107.339 74.612 107.019 74.636C106.707 74.652 106.355 74.712 105.963 74.816C105.619 74.904 105.247 75.02 104.847 75.164C104.455 75.3 104.039 75.464 103.599 75.656C103.511 75.688 103.423 75.688 103.335 75.656C103.247 75.624 103.183 75.564 103.143 75.476C103.095 75.388 103.091 75.296 103.131 75.2C103.171 75.096 103.235 75.028 103.323 74.996C103.771 74.796 104.199 74.624 104.607 74.48C105.023 74.328 105.415 74.208 105.783 74.12C106.767 73.872 107.571 73.832 108.195 74C108.379 74.048 108.507 74.16 108.579 74.336C108.651 74.512 108.635 74.708 108.531 74.924C108.427 75.14 108.303 75.364 108.159 75.596C108.151 75.612 108.139 75.632 108.123 75.656C108.107 75.68 108.091 75.708 108.075 75.74C108.259 75.7 108.531 75.62 108.891 75.5C109.251 75.38 109.747 75.204 110.379 74.972C110.467 74.94 110.555 74.948 110.643 74.996C110.739 75.036 110.803 75.104 110.835 75.2C110.875 75.288 110.875 75.38 110.835 75.476C110.795 75.564 110.723 75.628 110.619 75.668C110.251 75.796 109.915 75.912 109.611 76.016C109.307 76.12 109.035 76.208 108.795 76.28C108.475 76.376 108.231 76.444 108.063 76.484C107.895 76.516 107.767 76.532 107.679 76.532Z",
    fill: "black"
  })), _path16$1 || (_path16$1 = /*#__PURE__*/React.createElement("path", {
    d: "M153.679 76.532C153.623 76.532 153.571 76.524 153.523 76.508C153.371 76.476 153.263 76.384 153.199 76.232C153.151 76.096 153.163 75.944 153.235 75.776C153.315 75.608 153.419 75.42 153.547 75.212C153.595 75.14 153.639 75.068 153.679 74.996C153.727 74.916 153.767 74.844 153.799 74.78C153.815 74.756 153.827 74.736 153.835 74.72C153.843 74.696 153.851 74.676 153.859 74.66C153.619 74.62 153.339 74.612 153.019 74.636C152.707 74.652 152.355 74.712 151.963 74.816C151.619 74.904 151.247 75.02 150.847 75.164C150.455 75.3 150.039 75.464 149.599 75.656C149.511 75.688 149.423 75.688 149.335 75.656C149.247 75.624 149.183 75.564 149.143 75.476C149.095 75.388 149.091 75.296 149.131 75.2C149.171 75.096 149.235 75.028 149.323 74.996C149.771 74.796 150.199 74.624 150.607 74.48C151.023 74.328 151.415 74.208 151.783 74.12C152.767 73.872 153.571 73.832 154.195 74C154.379 74.048 154.507 74.16 154.579 74.336C154.651 74.512 154.635 74.708 154.531 74.924C154.427 75.14 154.303 75.364 154.159 75.596C154.151 75.612 154.139 75.632 154.123 75.656C154.107 75.68 154.091 75.708 154.075 75.74C154.259 75.7 154.531 75.62 154.891 75.5C155.251 75.38 155.747 75.204 156.379 74.972C156.467 74.94 156.555 74.948 156.643 74.996C156.739 75.036 156.803 75.104 156.835 75.2C156.875 75.288 156.875 75.38 156.835 75.476C156.795 75.564 156.723 75.628 156.619 75.668C156.251 75.796 155.915 75.912 155.611 76.016C155.307 76.12 155.035 76.208 154.795 76.28C154.475 76.376 154.231 76.444 154.063 76.484C153.895 76.516 153.767 76.532 153.679 76.532Z",
    fill: "black"
  })), _path17$1 || (_path17$1 = /*#__PURE__*/React.createElement("path", {
    d: "M197.679 76.532C197.623 76.532 197.571 76.524 197.523 76.508C197.371 76.476 197.263 76.384 197.199 76.232C197.151 76.096 197.163 75.944 197.235 75.776C197.315 75.608 197.419 75.42 197.547 75.212C197.595 75.14 197.639 75.068 197.679 74.996C197.727 74.916 197.767 74.844 197.799 74.78C197.815 74.756 197.827 74.736 197.835 74.72C197.843 74.696 197.851 74.676 197.859 74.66C197.619 74.62 197.339 74.612 197.019 74.636C196.707 74.652 196.355 74.712 195.963 74.816C195.619 74.904 195.247 75.02 194.847 75.164C194.455 75.3 194.039 75.464 193.599 75.656C193.511 75.688 193.423 75.688 193.335 75.656C193.247 75.624 193.183 75.564 193.143 75.476C193.095 75.388 193.091 75.296 193.131 75.2C193.171 75.096 193.235 75.028 193.323 74.996C193.771 74.796 194.199 74.624 194.607 74.48C195.023 74.328 195.415 74.208 195.783 74.12C196.767 73.872 197.571 73.832 198.195 74C198.379 74.048 198.507 74.16 198.579 74.336C198.651 74.512 198.635 74.708 198.531 74.924C198.427 75.14 198.303 75.364 198.159 75.596C198.151 75.612 198.139 75.632 198.123 75.656C198.107 75.68 198.091 75.708 198.075 75.74C198.259 75.7 198.531 75.62 198.891 75.5C199.251 75.38 199.747 75.204 200.379 74.972C200.467 74.94 200.555 74.948 200.643 74.996C200.739 75.036 200.803 75.104 200.835 75.2C200.875 75.288 200.875 75.38 200.835 75.476C200.795 75.564 200.723 75.628 200.619 75.668C200.251 75.796 199.915 75.912 199.611 76.016C199.307 76.12 199.035 76.208 198.795 76.28C198.475 76.376 198.231 76.444 198.063 76.484C197.895 76.516 197.767 76.532 197.679 76.532Z",
    fill: "black"
  })), _path18$1 || (_path18$1 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6788 107.532C64.6228 107.532 64.5708 107.524 64.5228 107.508C64.3708 107.476 64.2628 107.384 64.1988 107.232C64.1508 107.096 64.1628 106.944 64.2348 106.776C64.3148 106.608 64.4188 106.42 64.5468 106.212C64.5948 106.14 64.6388 106.068 64.6788 105.996C64.7268 105.916 64.7668 105.844 64.7988 105.78C64.8148 105.756 64.8268 105.736 64.8348 105.72C64.8428 105.696 64.8508 105.676 64.8588 105.66C64.6188 105.62 64.3388 105.612 64.0188 105.636C63.7068 105.652 63.3548 105.712 62.9628 105.816C62.6188 105.904 62.2468 106.02 61.8468 106.164C61.4548 106.3 61.0388 106.464 60.5988 106.656C60.5108 106.688 60.4228 106.688 60.3348 106.656C60.2468 106.624 60.1828 106.564 60.1428 106.476C60.0948 106.388 60.0908 106.296 60.1308 106.2C60.1708 106.096 60.2348 106.028 60.3228 105.996C60.7708 105.796 61.1988 105.624 61.6068 105.48C62.0228 105.328 62.4148 105.208 62.7828 105.12C63.7668 104.872 64.5708 104.832 65.1948 105C65.3788 105.048 65.5068 105.16 65.5788 105.336C65.6508 105.512 65.6348 105.708 65.5308 105.924C65.4268 106.14 65.3028 106.364 65.1588 106.596C65.1508 106.612 65.1388 106.632 65.1228 106.656C65.1068 106.68 65.0908 106.708 65.0748 106.74C65.2588 106.7 65.5308 106.62 65.8908 106.5C66.2508 106.38 66.7468 106.204 67.3788 105.972C67.4668 105.94 67.5548 105.948 67.6428 105.996C67.7388 106.036 67.8028 106.104 67.8348 106.2C67.8748 106.288 67.8748 106.38 67.8348 106.476C67.7948 106.564 67.7228 106.628 67.6188 106.668C67.2508 106.796 66.9148 106.912 66.6108 107.016C66.3068 107.12 66.0348 107.208 65.7948 107.28C65.4748 107.376 65.2308 107.444 65.0628 107.484C64.8948 107.516 64.7668 107.532 64.6788 107.532Z",
    fill: "black"
  })), _path19$1 || (_path19$1 = /*#__PURE__*/React.createElement("path", {
    d: "M107.679 107.532C107.623 107.532 107.571 107.524 107.523 107.508C107.371 107.476 107.263 107.384 107.199 107.232C107.151 107.096 107.163 106.944 107.235 106.776C107.315 106.608 107.419 106.42 107.547 106.212C107.595 106.14 107.639 106.068 107.679 105.996C107.727 105.916 107.767 105.844 107.799 105.78C107.815 105.756 107.827 105.736 107.835 105.72C107.843 105.696 107.851 105.676 107.859 105.66C107.619 105.62 107.339 105.612 107.019 105.636C106.707 105.652 106.355 105.712 105.963 105.816C105.619 105.904 105.247 106.02 104.847 106.164C104.455 106.3 104.039 106.464 103.599 106.656C103.511 106.688 103.423 106.688 103.335 106.656C103.247 106.624 103.183 106.564 103.143 106.476C103.095 106.388 103.091 106.296 103.131 106.2C103.171 106.096 103.235 106.028 103.323 105.996C103.771 105.796 104.199 105.624 104.607 105.48C105.023 105.328 105.415 105.208 105.783 105.12C106.767 104.872 107.571 104.832 108.195 105C108.379 105.048 108.507 105.16 108.579 105.336C108.651 105.512 108.635 105.708 108.531 105.924C108.427 106.14 108.303 106.364 108.159 106.596C108.151 106.612 108.139 106.632 108.123 106.656C108.107 106.68 108.091 106.708 108.075 106.74C108.259 106.7 108.531 106.62 108.891 106.5C109.251 106.38 109.747 106.204 110.379 105.972C110.467 105.94 110.555 105.948 110.643 105.996C110.739 106.036 110.803 106.104 110.835 106.2C110.875 106.288 110.875 106.38 110.835 106.476C110.795 106.564 110.723 106.628 110.619 106.668C110.251 106.796 109.915 106.912 109.611 107.016C109.307 107.12 109.035 107.208 108.795 107.28C108.475 107.376 108.231 107.444 108.063 107.484C107.895 107.516 107.767 107.532 107.679 107.532Z",
    fill: "black"
  })), _path20$1 || (_path20$1 = /*#__PURE__*/React.createElement("path", {
    d: "M153.679 107.532C153.623 107.532 153.571 107.524 153.523 107.508C153.371 107.476 153.263 107.384 153.199 107.232C153.151 107.096 153.163 106.944 153.235 106.776C153.315 106.608 153.419 106.42 153.547 106.212C153.595 106.14 153.639 106.068 153.679 105.996C153.727 105.916 153.767 105.844 153.799 105.78C153.815 105.756 153.827 105.736 153.835 105.72C153.843 105.696 153.851 105.676 153.859 105.66C153.619 105.62 153.339 105.612 153.019 105.636C152.707 105.652 152.355 105.712 151.963 105.816C151.619 105.904 151.247 106.02 150.847 106.164C150.455 106.3 150.039 106.464 149.599 106.656C149.511 106.688 149.423 106.688 149.335 106.656C149.247 106.624 149.183 106.564 149.143 106.476C149.095 106.388 149.091 106.296 149.131 106.2C149.171 106.096 149.235 106.028 149.323 105.996C149.771 105.796 150.199 105.624 150.607 105.48C151.023 105.328 151.415 105.208 151.783 105.12C152.767 104.872 153.571 104.832 154.195 105C154.379 105.048 154.507 105.16 154.579 105.336C154.651 105.512 154.635 105.708 154.531 105.924C154.427 106.14 154.303 106.364 154.159 106.596C154.151 106.612 154.139 106.632 154.123 106.656C154.107 106.68 154.091 106.708 154.075 106.74C154.259 106.7 154.531 106.62 154.891 106.5C155.251 106.38 155.747 106.204 156.379 105.972C156.467 105.94 156.555 105.948 156.643 105.996C156.739 106.036 156.803 106.104 156.835 106.2C156.875 106.288 156.875 106.38 156.835 106.476C156.795 106.564 156.723 106.628 156.619 106.668C156.251 106.796 155.915 106.912 155.611 107.016C155.307 107.12 155.035 107.208 154.795 107.28C154.475 107.376 154.231 107.444 154.063 107.484C153.895 107.516 153.767 107.532 153.679 107.532Z",
    fill: "black"
  })), _path21$1 || (_path21$1 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6741 15.27C55.5207 14.59 56.1841 14.0333 56.6641 13.6C57.1441 13.16 57.5474 12.7033 57.8741 12.23C58.2074 11.75 58.3741 11.28 58.3741 10.82C58.3741 10.3867 58.2674 10.0467 58.0541 9.8C57.8474 9.54667 57.5107 9.42 57.0441 9.42C56.5907 9.42 56.2374 9.56333 55.9841 9.85C55.7374 10.13 55.6041 10.5067 55.5841 10.98H54.7041C54.7307 10.2333 54.9574 9.65667 55.3841 9.25C55.8107 8.84333 56.3607 8.64 57.0341 8.64C57.7207 8.64 58.2641 8.83 58.6641 9.21C59.0707 9.59 59.2741 10.1133 59.2741 10.78C59.2741 11.3333 59.1074 11.8733 58.7741 12.4C58.4474 12.92 58.0741 13.38 57.6541 13.78C57.2341 14.1733 56.6974 14.6333 56.0441 15.16H59.4841V15.92H54.6741V15.27ZM60.536 12.31C60.536 11.1633 60.7227 10.27 61.096 9.63C61.4693 8.98333 62.1227 8.66 63.056 8.66C63.9827 8.66 64.6327 8.98333 65.006 9.63C65.3793 10.27 65.566 11.1633 65.566 12.31C65.566 13.4767 65.3793 14.3833 65.006 15.03C64.6327 15.6767 63.9827 16 63.056 16C62.1227 16 61.4693 15.6767 61.096 15.03C60.7227 14.3833 60.536 13.4767 60.536 12.31ZM64.666 12.31C64.666 11.73 64.626 11.24 64.546 10.84C64.4727 10.4333 64.316 10.1067 64.076 9.86C63.8427 9.61333 63.5027 9.49 63.056 9.49C62.6027 9.49 62.256 9.61333 62.016 9.86C61.7827 10.1067 61.626 10.4333 61.546 10.84C61.4727 11.24 61.436 11.73 61.436 12.31C61.436 12.91 61.4727 13.4133 61.546 13.82C61.626 14.2267 61.7827 14.5533 62.016 14.8C62.256 15.0467 62.6027 15.17 63.056 15.17C63.5027 15.17 63.8427 15.0467 64.076 14.8C64.316 14.5533 64.4727 14.2267 64.546 13.82C64.626 13.4133 64.666 12.91 64.666 12.31ZM66.7053 15.27C67.552 14.59 68.2153 14.0333 68.6953 13.6C69.1753 13.16 69.5786 12.7033 69.9053 12.23C70.2386 11.75 70.4053 11.28 70.4053 10.82C70.4053 10.3867 70.2986 10.0467 70.0853 9.8C69.8786 9.54667 69.542 9.42 69.0753 9.42C68.622 9.42 68.2686 9.56333 68.0153 9.85C67.7686 10.13 67.6353 10.5067 67.6153 10.98H66.7353C66.762 10.2333 66.9886 9.65667 67.4153 9.25C67.842 8.84333 68.392 8.64 69.0653 8.64C69.752 8.64 70.2953 8.83 70.6953 9.21C71.102 9.59 71.3053 10.1133 71.3053 10.78C71.3053 11.3333 71.1386 11.8733 70.8053 12.4C70.4786 12.92 70.1053 13.38 69.6853 13.78C69.2653 14.1733 68.7286 14.6333 68.0753 15.16H71.5153V15.92H66.7053V15.27ZM72.5473 10.59C72.5939 9.97667 72.8306 9.49667 73.2573 9.15C73.6839 8.80333 74.2373 8.63 74.9173 8.63C75.3706 8.63 75.7606 8.71333 76.0873 8.88C76.4206 9.04 76.6706 9.26 76.8373 9.54C77.0106 9.82 77.0973 10.1367 77.0973 10.49C77.0973 10.9033 76.9773 11.26 76.7373 11.56C76.5039 11.86 76.1973 12.0533 75.8173 12.14V12.19C76.2506 12.2967 76.5939 12.5067 76.8473 12.82C77.1006 13.1333 77.2273 13.5433 77.2273 14.05C77.2273 14.43 77.1406 14.7733 76.9673 15.08C76.7939 15.38 76.5339 15.6167 76.1873 15.79C75.8406 15.9633 75.4239 16.05 74.9373 16.05C74.2306 16.05 73.6506 15.8667 73.1973 15.5C72.7439 15.1267 72.4906 14.6 72.4373 13.92H73.3173C73.3639 14.32 73.5273 14.6467 73.8073 14.9C74.0873 15.1533 74.4606 15.28 74.9273 15.28C75.3939 15.28 75.7473 15.16 75.9873 14.92C76.2339 14.6733 76.3573 14.3567 76.3573 13.97C76.3573 13.47 76.1906 13.11 75.8573 12.89C75.5239 12.67 75.0206 12.56 74.3473 12.56H74.1173V11.8H74.3573C74.9706 11.7933 75.4339 11.6933 75.7473 11.5C76.0606 11.3 76.2173 10.9933 76.2173 10.58C76.2173 10.2267 76.1006 9.94333 75.8673 9.73C75.6406 9.51667 75.3139 9.41 74.8873 9.41C74.4739 9.41 74.1406 9.51667 73.8873 9.73C73.6339 9.94333 73.4839 10.23 73.4373 10.59H72.5473Z",
    fill: "black"
  })), _path22$1 || (_path22$1 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9739 15.27C95.8205 14.59 96.4839 14.0333 96.9639 13.6C97.4439 13.16 97.8472 12.7033 98.1739 12.23C98.5072 11.75 98.6739 11.28 98.6739 10.82C98.6739 10.3867 98.5672 10.0467 98.3539 9.8C98.1472 9.54667 97.8105 9.42 97.3439 9.42C96.8905 9.42 96.5372 9.56333 96.2839 9.85C96.0372 10.13 95.9039 10.5067 95.8839 10.98H95.0039C95.0305 10.2333 95.2572 9.65667 95.6839 9.25C96.1105 8.84333 96.6605 8.64 97.3339 8.64C98.0205 8.64 98.5639 8.83 98.9639 9.21C99.3705 9.59 99.5739 10.1133 99.5739 10.78C99.5739 11.3333 99.4072 11.8733 99.0739 12.4C98.7472 12.92 98.3739 13.38 97.9539 13.78C97.5339 14.1733 96.9972 14.6333 96.3439 15.16H99.7839V15.92H94.9739V15.27ZM100.836 12.31C100.836 11.1633 101.022 10.27 101.396 9.63C101.769 8.98333 102.422 8.66 103.356 8.66C104.282 8.66 104.932 8.98333 105.306 9.63C105.679 10.27 105.866 11.1633 105.866 12.31C105.866 13.4767 105.679 14.3833 105.306 15.03C104.932 15.6767 104.282 16 103.356 16C102.422 16 101.769 15.6767 101.396 15.03C101.022 14.3833 100.836 13.4767 100.836 12.31ZM104.966 12.31C104.966 11.73 104.926 11.24 104.846 10.84C104.772 10.4333 104.616 10.1067 104.376 9.86C104.142 9.61333 103.802 9.49 103.356 9.49C102.902 9.49 102.556 9.61333 102.316 9.86C102.082 10.1067 101.926 10.4333 101.846 10.84C101.772 11.24 101.736 11.73 101.736 12.31C101.736 12.91 101.772 13.4133 101.846 13.82C101.926 14.2267 102.082 14.5533 102.316 14.8C102.556 15.0467 102.902 15.17 103.356 15.17C103.802 15.17 104.142 15.0467 104.376 14.8C104.616 14.5533 104.772 14.2267 104.846 13.82C104.926 13.4133 104.966 12.91 104.966 12.31ZM107.005 15.27C107.852 14.59 108.515 14.0333 108.995 13.6C109.475 13.16 109.878 12.7033 110.205 12.23C110.538 11.75 110.705 11.28 110.705 10.82C110.705 10.3867 110.598 10.0467 110.385 9.8C110.178 9.54667 109.842 9.42 109.375 9.42C108.922 9.42 108.568 9.56333 108.315 9.85C108.068 10.13 107.935 10.5067 107.915 10.98H107.035C107.062 10.2333 107.288 9.65667 107.715 9.25C108.142 8.84333 108.692 8.64 109.365 8.64C110.052 8.64 110.595 8.83 110.995 9.21C111.402 9.59 111.605 10.1133 111.605 10.78C111.605 11.3333 111.438 11.8733 111.105 12.4C110.778 12.92 110.405 13.38 109.985 13.78C109.565 14.1733 109.028 14.6333 108.375 15.16H111.815V15.92H107.005V15.27ZM112.647 14.39V13.7L116.157 8.84H117.247V13.6H118.247V14.39H117.247V16H116.347V14.39H112.647ZM116.387 9.79L113.697 13.6H116.387V9.79Z",
    fill: "black"
  })), _path23$1 || (_path23$1 = /*#__PURE__*/React.createElement("path", {
    d: "M140.979 15.27C141.825 14.59 142.489 14.0333 142.969 13.6C143.449 13.16 143.852 12.7033 144.179 12.23C144.512 11.75 144.679 11.28 144.679 10.82C144.679 10.3867 144.572 10.0467 144.359 9.8C144.152 9.54667 143.815 9.42 143.349 9.42C142.895 9.42 142.542 9.56333 142.289 9.85C142.042 10.13 141.909 10.5067 141.889 10.98H141.009C141.035 10.2333 141.262 9.65667 141.689 9.25C142.115 8.84333 142.665 8.64 143.339 8.64C144.025 8.64 144.569 8.83 144.969 9.21C145.375 9.59 145.579 10.1133 145.579 10.78C145.579 11.3333 145.412 11.8733 145.079 12.4C144.752 12.92 144.379 13.38 143.959 13.78C143.539 14.1733 143.002 14.6333 142.349 15.16H145.789V15.92H140.979V15.27ZM146.841 12.31C146.841 11.1633 147.027 10.27 147.401 9.63C147.774 8.98333 148.427 8.66 149.361 8.66C150.287 8.66 150.937 8.98333 151.311 9.63C151.684 10.27 151.871 11.1633 151.871 12.31C151.871 13.4767 151.684 14.3833 151.311 15.03C150.937 15.6767 150.287 16 149.361 16C148.427 16 147.774 15.6767 147.401 15.03C147.027 14.3833 146.841 13.4767 146.841 12.31ZM150.971 12.31C150.971 11.73 150.931 11.24 150.851 10.84C150.777 10.4333 150.621 10.1067 150.381 9.86C150.147 9.61333 149.807 9.49 149.361 9.49C148.907 9.49 148.561 9.61333 148.321 9.86C148.087 10.1067 147.931 10.4333 147.851 10.84C147.777 11.24 147.741 11.73 147.741 12.31C147.741 12.91 147.777 13.4133 147.851 13.82C147.931 14.2267 148.087 14.5533 148.321 14.8C148.561 15.0467 148.907 15.17 149.361 15.17C149.807 15.17 150.147 15.0467 150.381 14.8C150.621 14.5533 150.777 14.2267 150.851 13.82C150.931 13.4133 150.971 12.91 150.971 12.31ZM153.01 15.27C153.857 14.59 154.52 14.0333 155 13.6C155.48 13.16 155.883 12.7033 156.21 12.23C156.543 11.75 156.71 11.28 156.71 10.82C156.71 10.3867 156.603 10.0467 156.39 9.8C156.183 9.54667 155.847 9.42 155.38 9.42C154.927 9.42 154.573 9.56333 154.32 9.85C154.073 10.13 153.94 10.5067 153.92 10.98H153.04C153.067 10.2333 153.293 9.65667 153.72 9.25C154.147 8.84333 154.697 8.64 155.37 8.64C156.057 8.64 156.6 8.83 157 9.21C157.407 9.59 157.61 10.1133 157.61 10.78C157.61 11.3333 157.443 11.8733 157.11 12.4C156.783 12.92 156.41 13.38 155.99 13.78C155.57 14.1733 155.033 14.6333 154.38 15.16H157.82V15.92H153.01V15.27ZM163.482 9.56H159.972V11.84C160.125 11.6267 160.352 11.4533 160.652 11.32C160.952 11.18 161.275 11.11 161.622 11.11C162.175 11.11 162.625 11.2267 162.972 11.46C163.319 11.6867 163.565 11.9833 163.712 12.35C163.865 12.71 163.942 13.0933 163.942 13.5C163.942 13.98 163.852 14.41 163.672 14.79C163.492 15.17 163.215 15.47 162.842 15.69C162.475 15.91 162.019 16.02 161.472 16.02C160.772 16.02 160.205 15.84 159.772 15.48C159.339 15.12 159.075 14.64 158.982 14.04H159.872C159.959 14.42 160.142 14.7167 160.422 14.93C160.702 15.1433 161.055 15.25 161.482 15.25C162.009 15.25 162.405 15.0933 162.672 14.78C162.939 14.46 163.072 14.04 163.072 13.52C163.072 13 162.939 12.6 162.672 12.32C162.405 12.0333 162.012 11.89 161.492 11.89C161.139 11.89 160.829 11.9767 160.562 12.15C160.302 12.3167 160.112 12.5467 159.992 12.84H159.132V8.76H163.482V9.56Z",
    fill: "black"
  })), _path24$1 || (_path24$1 = /*#__PURE__*/React.createElement("path", {
    d: "M184.945 15.27C185.791 14.59 186.455 14.0333 186.935 13.6C187.415 13.16 187.818 12.7033 188.145 12.23C188.478 11.75 188.645 11.28 188.645 10.82C188.645 10.3867 188.538 10.0467 188.325 9.8C188.118 9.54667 187.781 9.42 187.315 9.42C186.861 9.42 186.508 9.56333 186.255 9.85C186.008 10.13 185.875 10.5067 185.855 10.98H184.975C185.001 10.2333 185.228 9.65667 185.655 9.25C186.081 8.84333 186.631 8.64 187.305 8.64C187.991 8.64 188.535 8.83 188.935 9.21C189.341 9.59 189.545 10.1133 189.545 10.78C189.545 11.3333 189.378 11.8733 189.045 12.4C188.718 12.92 188.345 13.38 187.925 13.78C187.505 14.1733 186.968 14.6333 186.315 15.16H189.755V15.92H184.945V15.27ZM190.807 12.31C190.807 11.1633 190.993 10.27 191.367 9.63C191.74 8.98333 192.393 8.66 193.327 8.66C194.253 8.66 194.903 8.98333 195.277 9.63C195.65 10.27 195.837 11.1633 195.837 12.31C195.837 13.4767 195.65 14.3833 195.277 15.03C194.903 15.6767 194.253 16 193.327 16C192.393 16 191.74 15.6767 191.367 15.03C190.993 14.3833 190.807 13.4767 190.807 12.31ZM194.937 12.31C194.937 11.73 194.897 11.24 194.817 10.84C194.743 10.4333 194.587 10.1067 194.347 9.86C194.113 9.61333 193.773 9.49 193.327 9.49C192.873 9.49 192.527 9.61333 192.287 9.86C192.053 10.1067 191.897 10.4333 191.817 10.84C191.743 11.24 191.707 11.73 191.707 12.31C191.707 12.91 191.743 13.4133 191.817 13.82C191.897 14.2267 192.053 14.5533 192.287 14.8C192.527 15.0467 192.873 15.17 193.327 15.17C193.773 15.17 194.113 15.0467 194.347 14.8C194.587 14.5533 194.743 14.2267 194.817 13.82C194.897 13.4133 194.937 12.91 194.937 12.31ZM196.976 15.27C197.822 14.59 198.486 14.0333 198.966 13.6C199.446 13.16 199.849 12.7033 200.176 12.23C200.509 11.75 200.676 11.28 200.676 10.82C200.676 10.3867 200.569 10.0467 200.356 9.8C200.149 9.54667 199.812 9.42 199.346 9.42C198.892 9.42 198.539 9.56333 198.286 9.85C198.039 10.13 197.906 10.5067 197.886 10.98H197.006C197.032 10.2333 197.259 9.65667 197.686 9.25C198.112 8.84333 198.662 8.64 199.336 8.64C200.022 8.64 200.566 8.83 200.966 9.21C201.372 9.59 201.576 10.1133 201.576 10.78C201.576 11.3333 201.409 11.8733 201.076 12.4C200.749 12.92 200.376 13.38 199.956 13.78C199.536 14.1733 198.999 14.6333 198.346 15.16H201.786V15.92H196.976V15.27ZM206.868 10.49C206.721 9.75 206.264 9.38 205.498 9.38C204.904 9.38 204.461 9.61 204.168 10.07C203.874 10.5233 203.731 11.2733 203.738 12.32C203.891 11.9733 204.144 11.7033 204.498 11.51C204.858 11.31 205.258 11.21 205.698 11.21C206.384 11.21 206.931 11.4233 207.338 11.85C207.751 12.2767 207.958 12.8667 207.958 13.62C207.958 14.0733 207.868 14.48 207.688 14.84C207.514 15.2 207.248 15.4867 206.888 15.7C206.534 15.9133 206.104 16.02 205.598 16.02C204.911 16.02 204.374 15.8667 203.988 15.56C203.601 15.2533 203.331 14.83 203.178 14.29C203.024 13.75 202.948 13.0833 202.948 12.29C202.948 9.84333 203.801 8.62 205.508 8.62C206.161 8.62 206.674 8.79667 207.048 9.15C207.421 9.50333 207.641 9.95 207.708 10.49H206.868ZM205.508 11.98C205.221 11.98 204.951 12.04 204.698 12.16C204.444 12.2733 204.238 12.45 204.078 12.69C203.924 12.9233 203.848 13.21 203.848 13.55C203.848 14.0567 203.994 14.47 204.288 14.79C204.581 15.1033 205.001 15.26 205.548 15.26C206.014 15.26 206.384 15.1167 206.658 14.83C206.938 14.5367 207.078 14.1433 207.078 13.65C207.078 13.13 206.944 12.7233 206.678 12.43C206.411 12.13 206.021 11.98 205.508 11.98Z",
    fill: "black"
  })), _defs$1 || (_defs$1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2686_31407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18.75,
    fill: "white",
    transform: "translate(9 32)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2686_31407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18.75,
    fill: "white",
    transform: "translate(9 63.375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2686_31407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18.75,
    fill: "white",
    transform: "translate(9 96)"
  })))));
};
var ForwardRef$5 = /*#__PURE__*/forwardRef(SvgSplitByTimePeriodYear);
var _rect, _rect2, _rect3, _path$4, _path2$3, _path3$3, _path4$1, _path5$1, _path6$1, _path7$1, _path8$1, _rect4, _rect5, _rect6, _rect7, _g, _g2, _g3, _path9$1, _path10$1, _path11$1, _path12$1, _path13$1, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
var _excluded$7 = ["title", "titleId"];
function _extends$6() {
  return _extends$6 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$6.apply(null, arguments);
}
function _objectWithoutProperties$5(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$6(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$6(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgSplitByTimePeriod = function SvgSplitByTimePeriod(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$5(_ref, _excluded$7);
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    width: 221,
    height: 127,
    viewBox: "0 0 221 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 28,
    width: 172,
    height: 27,
    rx: 4,
    fill: "#DEE4DE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 61,
    width: 172,
    height: 24,
    rx: 4,
    fill: "#DEE4DE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 91,
    width: 172,
    height: 28,
    rx: 4,
    fill: "#DEE4DE"
  })), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    d: "M42 1L42 123",
    stroke: "#BDCAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    d: "M85 1L85 123",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path3$3 || (_path3$3 = /*#__PURE__*/React.createElement("path", {
    d: "M130 1L130 123",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path4$1 || (_path4$1 = /*#__PURE__*/React.createElement("path", {
    d: "M176 1L176 123",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path5$1 || (_path5$1 = /*#__PURE__*/React.createElement("path", {
    d: "M220 1L220 123",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path6$1 || (_path6$1 = /*#__PURE__*/React.createElement("path", {
    d: "M219 25L1.00001 25",
    stroke: "#BDCAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7$1 || (_path7$1 = /*#__PURE__*/React.createElement("path", {
    d: "M220 58L0.999999 58",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _path8$1 || (_path8$1 = /*#__PURE__*/React.createElement("path", {
    d: "M220 88L0.999999 88",
    stroke: "#BDCAC0",
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 1.20703,
    width: 39,
    height: 22,
    rx: 4,
    fill: "#F4F0EF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 1.20703,
    width: 41,
    height: 22,
    rx: 4,
    fill: "#F4F0EF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 1.20703,
    width: 42,
    height: 22,
    rx: 4,
    fill: "#F4F0EF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 1.20703,
    width: 40,
    height: 22,
    rx: 4,
    fill: "#F4F0EF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2687_31451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9827 43.6982C21.5328 43.6982 23.6001 41.6309 23.6001 39.0808C23.6001 36.5307 21.5328 34.4634 18.9827 34.4634C16.4325 34.4634 14.3652 36.5307 14.3652 39.0808C14.3652 41.6309 16.4325 43.6982 18.9827 43.6982Z",
    fill: "#D6DCD5",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 47.7395C13.4551 45.3247 15.9932 43.6992 18.9837 43.6992C21.9742 43.6992 24.5124 45.3247 25.9099 47.7395",
    fill: "#D6DCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 47.7395C13.4551 45.3247 15.9932 43.6992 18.9837 43.6992C21.9742 43.6992 24.5124 45.3247 25.9099 47.7395",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2687_31451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9827 75.0732C21.5328 75.0732 23.6001 73.0059 23.6001 70.4558C23.6001 67.9057 21.5328 65.8384 18.9827 65.8384C16.4325 65.8384 14.3652 67.9057 14.3652 70.4558C14.3652 73.0059 16.4325 75.0732 18.9827 75.0732Z",
    fill: "#D6DCD5",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 79.1145C13.4551 76.6997 15.9932 75.0742 18.9837 75.0742C21.9742 75.0742 24.5124 76.6997 25.9099 79.1145",
    fill: "#D6DCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 79.1145C13.4551 76.6997 15.9932 75.0742 18.9837 75.0742C21.9742 75.0742 24.5124 76.6997 25.9099 79.1145",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2687_31451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9827 107.698C21.5328 107.698 23.6001 105.631 23.6001 103.081C23.6001 100.531 21.5328 98.4634 18.9827 98.4634C16.4325 98.4634 14.3652 100.531 14.3652 103.081C14.3652 105.631 16.4325 107.698 18.9827 107.698Z",
    fill: "#D6DCD5",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 111.739C13.4551 109.325 15.9932 107.699 18.9837 107.699C21.9742 107.699 24.5124 109.325 25.9099 111.739",
    fill: "#D6DCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0576 111.739C13.4551 109.325 15.9932 107.699 18.9837 107.699C21.9742 107.699 24.5124 109.325 25.9099 111.739",
    stroke: "#3E4A42",
    strokeWidth: 1.25055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path9$1 || (_path9$1 = /*#__PURE__*/React.createElement("path", {
    d: "M197.679 107.532C197.623 107.532 197.571 107.524 197.523 107.508C197.371 107.476 197.263 107.384 197.199 107.232C197.151 107.096 197.163 106.944 197.235 106.776C197.315 106.608 197.419 106.42 197.547 106.212C197.595 106.14 197.639 106.068 197.679 105.996C197.727 105.916 197.767 105.844 197.799 105.78C197.815 105.756 197.827 105.736 197.835 105.72C197.843 105.696 197.851 105.676 197.859 105.66C197.619 105.62 197.339 105.612 197.019 105.636C196.707 105.652 196.355 105.712 195.963 105.816C195.619 105.904 195.247 106.02 194.847 106.164C194.455 106.3 194.039 106.464 193.599 106.656C193.511 106.688 193.423 106.688 193.335 106.656C193.247 106.624 193.183 106.564 193.143 106.476C193.095 106.388 193.091 106.296 193.131 106.2C193.171 106.096 193.235 106.028 193.323 105.996C193.771 105.796 194.199 105.624 194.607 105.48C195.023 105.328 195.415 105.208 195.783 105.12C196.767 104.872 197.571 104.832 198.195 105C198.379 105.048 198.507 105.16 198.579 105.336C198.651 105.512 198.635 105.708 198.531 105.924C198.427 106.14 198.303 106.364 198.159 106.596C198.151 106.612 198.139 106.632 198.123 106.656C198.107 106.68 198.091 106.708 198.075 106.74C198.259 106.7 198.531 106.62 198.891 106.5C199.251 106.38 199.747 106.204 200.379 105.972C200.467 105.94 200.555 105.948 200.643 105.996C200.739 106.036 200.803 106.104 200.835 106.2C200.875 106.288 200.875 106.38 200.835 106.476C200.795 106.564 200.723 106.628 200.619 106.668C200.251 106.796 199.915 106.912 199.611 107.016C199.307 107.12 199.035 107.208 198.795 107.28C198.475 107.376 198.231 107.444 198.063 107.484C197.895 107.516 197.767 107.532 197.679 107.532Z",
    fill: "black"
  })), _path10$1 || (_path10$1 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6788 44.532C64.6228 44.532 64.5708 44.524 64.5228 44.508C64.3708 44.476 64.2628 44.384 64.1988 44.232C64.1508 44.096 64.1628 43.944 64.2348 43.776C64.3148 43.608 64.4188 43.42 64.5468 43.212C64.5948 43.14 64.6388 43.068 64.6788 42.996C64.7268 42.916 64.7668 42.844 64.7988 42.78C64.8148 42.756 64.8268 42.736 64.8348 42.72C64.8428 42.696 64.8508 42.676 64.8588 42.66C64.6188 42.62 64.3388 42.612 64.0188 42.636C63.7068 42.652 63.3548 42.712 62.9628 42.816C62.6188 42.904 62.2468 43.02 61.8468 43.164C61.4548 43.3 61.0388 43.464 60.5988 43.656C60.5108 43.688 60.4228 43.688 60.3348 43.656C60.2468 43.624 60.1828 43.564 60.1428 43.476C60.0948 43.388 60.0908 43.296 60.1308 43.2C60.1708 43.096 60.2348 43.028 60.3228 42.996C60.7708 42.796 61.1988 42.624 61.6068 42.48C62.0228 42.328 62.4148 42.208 62.7828 42.12C63.7668 41.872 64.5708 41.832 65.1948 42C65.3788 42.048 65.5068 42.16 65.5788 42.336C65.6508 42.512 65.6348 42.708 65.5308 42.924C65.4268 43.14 65.3028 43.364 65.1588 43.596C65.1508 43.612 65.1388 43.632 65.1228 43.656C65.1068 43.68 65.0908 43.708 65.0748 43.74C65.2588 43.7 65.5308 43.62 65.8908 43.5C66.2508 43.38 66.7468 43.204 67.3788 42.972C67.4668 42.94 67.5548 42.948 67.6428 42.996C67.7388 43.036 67.8028 43.104 67.8348 43.2C67.8748 43.288 67.8748 43.38 67.8348 43.476C67.7948 43.564 67.7228 43.628 67.6188 43.668C67.2508 43.796 66.9148 43.912 66.6108 44.016C66.3068 44.12 66.0348 44.208 65.7948 44.28C65.4748 44.376 65.2308 44.444 65.0628 44.484C64.8948 44.516 64.7668 44.532 64.6788 44.532Z",
    fill: "black"
  })), _path11$1 || (_path11$1 = /*#__PURE__*/React.createElement("path", {
    d: "M107.679 44.532C107.623 44.532 107.571 44.524 107.523 44.508C107.371 44.476 107.263 44.384 107.199 44.232C107.151 44.096 107.163 43.944 107.235 43.776C107.315 43.608 107.419 43.42 107.547 43.212C107.595 43.14 107.639 43.068 107.679 42.996C107.727 42.916 107.767 42.844 107.799 42.78C107.815 42.756 107.827 42.736 107.835 42.72C107.843 42.696 107.851 42.676 107.859 42.66C107.619 42.62 107.339 42.612 107.019 42.636C106.707 42.652 106.355 42.712 105.963 42.816C105.619 42.904 105.247 43.02 104.847 43.164C104.455 43.3 104.039 43.464 103.599 43.656C103.511 43.688 103.423 43.688 103.335 43.656C103.247 43.624 103.183 43.564 103.143 43.476C103.095 43.388 103.091 43.296 103.131 43.2C103.171 43.096 103.235 43.028 103.323 42.996C103.771 42.796 104.199 42.624 104.607 42.48C105.023 42.328 105.415 42.208 105.783 42.12C106.767 41.872 107.571 41.832 108.195 42C108.379 42.048 108.507 42.16 108.579 42.336C108.651 42.512 108.635 42.708 108.531 42.924C108.427 43.14 108.303 43.364 108.159 43.596C108.151 43.612 108.139 43.632 108.123 43.656C108.107 43.68 108.091 43.708 108.075 43.74C108.259 43.7 108.531 43.62 108.891 43.5C109.251 43.38 109.747 43.204 110.379 42.972C110.467 42.94 110.555 42.948 110.643 42.996C110.739 43.036 110.803 43.104 110.835 43.2C110.875 43.288 110.875 43.38 110.835 43.476C110.795 43.564 110.723 43.628 110.619 43.668C110.251 43.796 109.915 43.912 109.611 44.016C109.307 44.12 109.035 44.208 108.795 44.28C108.475 44.376 108.231 44.444 108.063 44.484C107.895 44.516 107.767 44.532 107.679 44.532Z",
    fill: "black"
  })), _path12$1 || (_path12$1 = /*#__PURE__*/React.createElement("path", {
    d: "M153.679 44.532C153.623 44.532 153.571 44.524 153.523 44.508C153.371 44.476 153.263 44.384 153.199 44.232C153.151 44.096 153.163 43.944 153.235 43.776C153.315 43.608 153.419 43.42 153.547 43.212C153.595 43.14 153.639 43.068 153.679 42.996C153.727 42.916 153.767 42.844 153.799 42.78C153.815 42.756 153.827 42.736 153.835 42.72C153.843 42.696 153.851 42.676 153.859 42.66C153.619 42.62 153.339 42.612 153.019 42.636C152.707 42.652 152.355 42.712 151.963 42.816C151.619 42.904 151.247 43.02 150.847 43.164C150.455 43.3 150.039 43.464 149.599 43.656C149.511 43.688 149.423 43.688 149.335 43.656C149.247 43.624 149.183 43.564 149.143 43.476C149.095 43.388 149.091 43.296 149.131 43.2C149.171 43.096 149.235 43.028 149.323 42.996C149.771 42.796 150.199 42.624 150.607 42.48C151.023 42.328 151.415 42.208 151.783 42.12C152.767 41.872 153.571 41.832 154.195 42C154.379 42.048 154.507 42.16 154.579 42.336C154.651 42.512 154.635 42.708 154.531 42.924C154.427 43.14 154.303 43.364 154.159 43.596C154.151 43.612 154.139 43.632 154.123 43.656C154.107 43.68 154.091 43.708 154.075 43.74C154.259 43.7 154.531 43.62 154.891 43.5C155.251 43.38 155.747 43.204 156.379 42.972C156.467 42.94 156.555 42.948 156.643 42.996C156.739 43.036 156.803 43.104 156.835 43.2C156.875 43.288 156.875 43.38 156.835 43.476C156.795 43.564 156.723 43.628 156.619 43.668C156.251 43.796 155.915 43.912 155.611 44.016C155.307 44.12 155.035 44.208 154.795 44.28C154.475 44.376 154.231 44.444 154.063 44.484C153.895 44.516 153.767 44.532 153.679 44.532Z",
    fill: "black"
  })), _path13$1 || (_path13$1 = /*#__PURE__*/React.createElement("path", {
    d: "M197.679 44.532C197.623 44.532 197.571 44.524 197.523 44.508C197.371 44.476 197.263 44.384 197.199 44.232C197.151 44.096 197.163 43.944 197.235 43.776C197.315 43.608 197.419 43.42 197.547 43.212C197.595 43.14 197.639 43.068 197.679 42.996C197.727 42.916 197.767 42.844 197.799 42.78C197.815 42.756 197.827 42.736 197.835 42.72C197.843 42.696 197.851 42.676 197.859 42.66C197.619 42.62 197.339 42.612 197.019 42.636C196.707 42.652 196.355 42.712 195.963 42.816C195.619 42.904 195.247 43.02 194.847 43.164C194.455 43.3 194.039 43.464 193.599 43.656C193.511 43.688 193.423 43.688 193.335 43.656C193.247 43.624 193.183 43.564 193.143 43.476C193.095 43.388 193.091 43.296 193.131 43.2C193.171 43.096 193.235 43.028 193.323 42.996C193.771 42.796 194.199 42.624 194.607 42.48C195.023 42.328 195.415 42.208 195.783 42.12C196.767 41.872 197.571 41.832 198.195 42C198.379 42.048 198.507 42.16 198.579 42.336C198.651 42.512 198.635 42.708 198.531 42.924C198.427 43.14 198.303 43.364 198.159 43.596C198.151 43.612 198.139 43.632 198.123 43.656C198.107 43.68 198.091 43.708 198.075 43.74C198.259 43.7 198.531 43.62 198.891 43.5C199.251 43.38 199.747 43.204 200.379 42.972C200.467 42.94 200.555 42.948 200.643 42.996C200.739 43.036 200.803 43.104 200.835 43.2C200.875 43.288 200.875 43.38 200.835 43.476C200.795 43.564 200.723 43.628 200.619 43.668C200.251 43.796 199.915 43.912 199.611 44.016C199.307 44.12 199.035 44.208 198.795 44.28C198.475 44.376 198.231 44.444 198.063 44.484C197.895 44.516 197.767 44.532 197.679 44.532Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6788 76.532C64.6228 76.532 64.5708 76.524 64.5228 76.508C64.3708 76.476 64.2628 76.384 64.1988 76.232C64.1508 76.096 64.1628 75.944 64.2348 75.776C64.3148 75.608 64.4188 75.42 64.5468 75.212C64.5948 75.14 64.6388 75.068 64.6788 74.996C64.7268 74.916 64.7668 74.844 64.7988 74.78C64.8148 74.756 64.8268 74.736 64.8348 74.72C64.8428 74.696 64.8508 74.676 64.8588 74.66C64.6188 74.62 64.3388 74.612 64.0188 74.636C63.7068 74.652 63.3548 74.712 62.9628 74.816C62.6188 74.904 62.2468 75.02 61.8468 75.164C61.4548 75.3 61.0388 75.464 60.5988 75.656C60.5108 75.688 60.4228 75.688 60.3348 75.656C60.2468 75.624 60.1828 75.564 60.1428 75.476C60.0948 75.388 60.0908 75.296 60.1308 75.2C60.1708 75.096 60.2348 75.028 60.3228 74.996C60.7708 74.796 61.1988 74.624 61.6068 74.48C62.0228 74.328 62.4148 74.208 62.7828 74.12C63.7668 73.872 64.5708 73.832 65.1948 74C65.3788 74.048 65.5068 74.16 65.5788 74.336C65.6508 74.512 65.6348 74.708 65.5308 74.924C65.4268 75.14 65.3028 75.364 65.1588 75.596C65.1508 75.612 65.1388 75.632 65.1228 75.656C65.1068 75.68 65.0908 75.708 65.0748 75.74C65.2588 75.7 65.5308 75.62 65.8908 75.5C66.2508 75.38 66.7468 75.204 67.3788 74.972C67.4668 74.94 67.5548 74.948 67.6428 74.996C67.7388 75.036 67.8028 75.104 67.8348 75.2C67.8748 75.288 67.8748 75.38 67.8348 75.476C67.7948 75.564 67.7228 75.628 67.6188 75.668C67.2508 75.796 66.9148 75.912 66.6108 76.016C66.3068 76.12 66.0348 76.208 65.7948 76.28C65.4748 76.376 65.2308 76.444 65.0628 76.484C64.8948 76.516 64.7668 76.532 64.6788 76.532Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M107.679 76.532C107.623 76.532 107.571 76.524 107.523 76.508C107.371 76.476 107.263 76.384 107.199 76.232C107.151 76.096 107.163 75.944 107.235 75.776C107.315 75.608 107.419 75.42 107.547 75.212C107.595 75.14 107.639 75.068 107.679 74.996C107.727 74.916 107.767 74.844 107.799 74.78C107.815 74.756 107.827 74.736 107.835 74.72C107.843 74.696 107.851 74.676 107.859 74.66C107.619 74.62 107.339 74.612 107.019 74.636C106.707 74.652 106.355 74.712 105.963 74.816C105.619 74.904 105.247 75.02 104.847 75.164C104.455 75.3 104.039 75.464 103.599 75.656C103.511 75.688 103.423 75.688 103.335 75.656C103.247 75.624 103.183 75.564 103.143 75.476C103.095 75.388 103.091 75.296 103.131 75.2C103.171 75.096 103.235 75.028 103.323 74.996C103.771 74.796 104.199 74.624 104.607 74.48C105.023 74.328 105.415 74.208 105.783 74.12C106.767 73.872 107.571 73.832 108.195 74C108.379 74.048 108.507 74.16 108.579 74.336C108.651 74.512 108.635 74.708 108.531 74.924C108.427 75.14 108.303 75.364 108.159 75.596C108.151 75.612 108.139 75.632 108.123 75.656C108.107 75.68 108.091 75.708 108.075 75.74C108.259 75.7 108.531 75.62 108.891 75.5C109.251 75.38 109.747 75.204 110.379 74.972C110.467 74.94 110.555 74.948 110.643 74.996C110.739 75.036 110.803 75.104 110.835 75.2C110.875 75.288 110.875 75.38 110.835 75.476C110.795 75.564 110.723 75.628 110.619 75.668C110.251 75.796 109.915 75.912 109.611 76.016C109.307 76.12 109.035 76.208 108.795 76.28C108.475 76.376 108.231 76.444 108.063 76.484C107.895 76.516 107.767 76.532 107.679 76.532Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M153.679 76.532C153.623 76.532 153.571 76.524 153.523 76.508C153.371 76.476 153.263 76.384 153.199 76.232C153.151 76.096 153.163 75.944 153.235 75.776C153.315 75.608 153.419 75.42 153.547 75.212C153.595 75.14 153.639 75.068 153.679 74.996C153.727 74.916 153.767 74.844 153.799 74.78C153.815 74.756 153.827 74.736 153.835 74.72C153.843 74.696 153.851 74.676 153.859 74.66C153.619 74.62 153.339 74.612 153.019 74.636C152.707 74.652 152.355 74.712 151.963 74.816C151.619 74.904 151.247 75.02 150.847 75.164C150.455 75.3 150.039 75.464 149.599 75.656C149.511 75.688 149.423 75.688 149.335 75.656C149.247 75.624 149.183 75.564 149.143 75.476C149.095 75.388 149.091 75.296 149.131 75.2C149.171 75.096 149.235 75.028 149.323 74.996C149.771 74.796 150.199 74.624 150.607 74.48C151.023 74.328 151.415 74.208 151.783 74.12C152.767 73.872 153.571 73.832 154.195 74C154.379 74.048 154.507 74.16 154.579 74.336C154.651 74.512 154.635 74.708 154.531 74.924C154.427 75.14 154.303 75.364 154.159 75.596C154.151 75.612 154.139 75.632 154.123 75.656C154.107 75.68 154.091 75.708 154.075 75.74C154.259 75.7 154.531 75.62 154.891 75.5C155.251 75.38 155.747 75.204 156.379 74.972C156.467 74.94 156.555 74.948 156.643 74.996C156.739 75.036 156.803 75.104 156.835 75.2C156.875 75.288 156.875 75.38 156.835 75.476C156.795 75.564 156.723 75.628 156.619 75.668C156.251 75.796 155.915 75.912 155.611 76.016C155.307 76.12 155.035 76.208 154.795 76.28C154.475 76.376 154.231 76.444 154.063 76.484C153.895 76.516 153.767 76.532 153.679 76.532Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M197.679 76.532C197.623 76.532 197.571 76.524 197.523 76.508C197.371 76.476 197.263 76.384 197.199 76.232C197.151 76.096 197.163 75.944 197.235 75.776C197.315 75.608 197.419 75.42 197.547 75.212C197.595 75.14 197.639 75.068 197.679 74.996C197.727 74.916 197.767 74.844 197.799 74.78C197.815 74.756 197.827 74.736 197.835 74.72C197.843 74.696 197.851 74.676 197.859 74.66C197.619 74.62 197.339 74.612 197.019 74.636C196.707 74.652 196.355 74.712 195.963 74.816C195.619 74.904 195.247 75.02 194.847 75.164C194.455 75.3 194.039 75.464 193.599 75.656C193.511 75.688 193.423 75.688 193.335 75.656C193.247 75.624 193.183 75.564 193.143 75.476C193.095 75.388 193.091 75.296 193.131 75.2C193.171 75.096 193.235 75.028 193.323 74.996C193.771 74.796 194.199 74.624 194.607 74.48C195.023 74.328 195.415 74.208 195.783 74.12C196.767 73.872 197.571 73.832 198.195 74C198.379 74.048 198.507 74.16 198.579 74.336C198.651 74.512 198.635 74.708 198.531 74.924C198.427 75.14 198.303 75.364 198.159 75.596C198.151 75.612 198.139 75.632 198.123 75.656C198.107 75.68 198.091 75.708 198.075 75.74C198.259 75.7 198.531 75.62 198.891 75.5C199.251 75.38 199.747 75.204 200.379 74.972C200.467 74.94 200.555 74.948 200.643 74.996C200.739 75.036 200.803 75.104 200.835 75.2C200.875 75.288 200.875 75.38 200.835 75.476C200.795 75.564 200.723 75.628 200.619 75.668C200.251 75.796 199.915 75.912 199.611 76.016C199.307 76.12 199.035 76.208 198.795 76.28C198.475 76.376 198.231 76.444 198.063 76.484C197.895 76.516 197.767 76.532 197.679 76.532Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6788 107.532C64.6228 107.532 64.5708 107.524 64.5228 107.508C64.3708 107.476 64.2628 107.384 64.1988 107.232C64.1508 107.096 64.1628 106.944 64.2348 106.776C64.3148 106.608 64.4188 106.42 64.5468 106.212C64.5948 106.14 64.6388 106.068 64.6788 105.996C64.7268 105.916 64.7668 105.844 64.7988 105.78C64.8148 105.756 64.8268 105.736 64.8348 105.72C64.8428 105.696 64.8508 105.676 64.8588 105.66C64.6188 105.62 64.3388 105.612 64.0188 105.636C63.7068 105.652 63.3548 105.712 62.9628 105.816C62.6188 105.904 62.2468 106.02 61.8468 106.164C61.4548 106.3 61.0388 106.464 60.5988 106.656C60.5108 106.688 60.4228 106.688 60.3348 106.656C60.2468 106.624 60.1828 106.564 60.1428 106.476C60.0948 106.388 60.0908 106.296 60.1308 106.2C60.1708 106.096 60.2348 106.028 60.3228 105.996C60.7708 105.796 61.1988 105.624 61.6068 105.48C62.0228 105.328 62.4148 105.208 62.7828 105.12C63.7668 104.872 64.5708 104.832 65.1948 105C65.3788 105.048 65.5068 105.16 65.5788 105.336C65.6508 105.512 65.6348 105.708 65.5308 105.924C65.4268 106.14 65.3028 106.364 65.1588 106.596C65.1508 106.612 65.1388 106.632 65.1228 106.656C65.1068 106.68 65.0908 106.708 65.0748 106.74C65.2588 106.7 65.5308 106.62 65.8908 106.5C66.2508 106.38 66.7468 106.204 67.3788 105.972C67.4668 105.94 67.5548 105.948 67.6428 105.996C67.7388 106.036 67.8028 106.104 67.8348 106.2C67.8748 106.288 67.8748 106.38 67.8348 106.476C67.7948 106.564 67.7228 106.628 67.6188 106.668C67.2508 106.796 66.9148 106.912 66.6108 107.016C66.3068 107.12 66.0348 107.208 65.7948 107.28C65.4748 107.376 65.2308 107.444 65.0628 107.484C64.8948 107.516 64.7668 107.532 64.6788 107.532Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.679 107.532C107.623 107.532 107.571 107.524 107.523 107.508C107.371 107.476 107.263 107.384 107.199 107.232C107.151 107.096 107.163 106.944 107.235 106.776C107.315 106.608 107.419 106.42 107.547 106.212C107.595 106.14 107.639 106.068 107.679 105.996C107.727 105.916 107.767 105.844 107.799 105.78C107.815 105.756 107.827 105.736 107.835 105.72C107.843 105.696 107.851 105.676 107.859 105.66C107.619 105.62 107.339 105.612 107.019 105.636C106.707 105.652 106.355 105.712 105.963 105.816C105.619 105.904 105.247 106.02 104.847 106.164C104.455 106.3 104.039 106.464 103.599 106.656C103.511 106.688 103.423 106.688 103.335 106.656C103.247 106.624 103.183 106.564 103.143 106.476C103.095 106.388 103.091 106.296 103.131 106.2C103.171 106.096 103.235 106.028 103.323 105.996C103.771 105.796 104.199 105.624 104.607 105.48C105.023 105.328 105.415 105.208 105.783 105.12C106.767 104.872 107.571 104.832 108.195 105C108.379 105.048 108.507 105.16 108.579 105.336C108.651 105.512 108.635 105.708 108.531 105.924C108.427 106.14 108.303 106.364 108.159 106.596C108.151 106.612 108.139 106.632 108.123 106.656C108.107 106.68 108.091 106.708 108.075 106.74C108.259 106.7 108.531 106.62 108.891 106.5C109.251 106.38 109.747 106.204 110.379 105.972C110.467 105.94 110.555 105.948 110.643 105.996C110.739 106.036 110.803 106.104 110.835 106.2C110.875 106.288 110.875 106.38 110.835 106.476C110.795 106.564 110.723 106.628 110.619 106.668C110.251 106.796 109.915 106.912 109.611 107.016C109.307 107.12 109.035 107.208 108.795 107.28C108.475 107.376 108.231 107.444 108.063 107.484C107.895 107.516 107.767 107.532 107.679 107.532Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M153.679 107.532C153.623 107.532 153.571 107.524 153.523 107.508C153.371 107.476 153.263 107.384 153.199 107.232C153.151 107.096 153.163 106.944 153.235 106.776C153.315 106.608 153.419 106.42 153.547 106.212C153.595 106.14 153.639 106.068 153.679 105.996C153.727 105.916 153.767 105.844 153.799 105.78C153.815 105.756 153.827 105.736 153.835 105.72C153.843 105.696 153.851 105.676 153.859 105.66C153.619 105.62 153.339 105.612 153.019 105.636C152.707 105.652 152.355 105.712 151.963 105.816C151.619 105.904 151.247 106.02 150.847 106.164C150.455 106.3 150.039 106.464 149.599 106.656C149.511 106.688 149.423 106.688 149.335 106.656C149.247 106.624 149.183 106.564 149.143 106.476C149.095 106.388 149.091 106.296 149.131 106.2C149.171 106.096 149.235 106.028 149.323 105.996C149.771 105.796 150.199 105.624 150.607 105.48C151.023 105.328 151.415 105.208 151.783 105.12C152.767 104.872 153.571 104.832 154.195 105C154.379 105.048 154.507 105.16 154.579 105.336C154.651 105.512 154.635 105.708 154.531 105.924C154.427 106.14 154.303 106.364 154.159 106.596C154.151 106.612 154.139 106.632 154.123 106.656C154.107 106.68 154.091 106.708 154.075 106.74C154.259 106.7 154.531 106.62 154.891 106.5C155.251 106.38 155.747 106.204 156.379 105.972C156.467 105.94 156.555 105.948 156.643 105.996C156.739 106.036 156.803 106.104 156.835 106.2C156.875 106.288 156.875 106.38 156.835 106.476C156.795 106.564 156.723 106.628 156.619 106.668C156.251 106.796 155.915 106.912 155.611 107.016C155.307 107.12 155.035 107.208 154.795 107.28C154.475 107.376 154.231 107.444 154.063 107.484C153.895 107.516 153.767 107.532 153.679 107.532Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5283 9.6V8.77H64.4083V16H63.4883V9.6H62.5283ZM66.9774 12.054C66.7254 12.054 66.4994 12.012 66.2994 11.928C66.0994 11.84 65.9414 11.72 65.8254 11.568C65.7094 11.412 65.6454 11.234 65.6334 11.034H66.1974C66.2134 11.198 66.2894 11.332 66.4254 11.436C66.5654 11.54 66.7474 11.592 66.9714 11.592C67.1794 11.592 67.3434 11.546 67.4634 11.454C67.5834 11.362 67.6434 11.246 67.6434 11.106C67.6434 10.962 67.5794 10.856 67.4514 10.788C67.3234 10.716 67.1254 10.646 66.8574 10.578C66.6134 10.514 66.4134 10.45 66.2574 10.386C66.1054 10.318 65.9734 10.22 65.8614 10.092C65.7534 9.96 65.6994 9.788 65.6994 9.576C65.6994 9.408 65.7494 9.254 65.8494 9.114C65.9494 8.974 66.0914 8.864 66.2754 8.784C66.4594 8.7 66.6694 8.658 66.9054 8.658C67.2694 8.658 67.5634 8.75 67.7874 8.934C68.0114 9.118 68.1314 9.37 68.1474 9.69H67.6014C67.5894 9.518 67.5194 9.38 67.3914 9.276C67.2674 9.172 67.0994 9.12 66.8874 9.12C66.6914 9.12 66.5354 9.162 66.4194 9.246C66.3034 9.33 66.2454 9.44 66.2454 9.576C66.2454 9.684 66.2794 9.774 66.3474 9.846C66.4194 9.914 66.5074 9.97 66.6114 10.014C66.7194 10.054 66.8674 10.1 67.0554 10.152C67.2914 10.216 67.4834 10.28 67.6314 10.344C67.7794 10.404 67.9054 10.496 68.0094 10.62C68.1174 10.744 68.1734 10.906 68.1774 11.106C68.1774 11.286 68.1274 11.448 68.0274 11.592C67.9274 11.736 67.7854 11.85 67.6014 11.934C67.4214 12.014 67.2134 12.054 66.9774 12.054ZM69.7942 9.162V11.1C69.7942 11.26 69.8282 11.374 69.8962 11.442C69.9642 11.506 70.0822 11.538 70.2502 11.538H70.6522V12H70.1602C69.8562 12 69.6282 11.93 69.4762 11.79C69.3242 11.65 69.2482 11.42 69.2482 11.1V9.162H68.8222V8.712H69.2482V7.884H69.7942V8.712H70.6522V9.162H69.7942Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5977 15.27C100.444 14.59 101.108 14.0333 101.588 13.6C102.068 13.16 102.471 12.7033 102.798 12.23C103.131 11.75 103.298 11.28 103.298 10.82C103.298 10.3867 103.191 10.0467 102.978 9.8C102.771 9.54667 102.434 9.42 101.968 9.42C101.514 9.42 101.161 9.56333 100.908 9.85C100.661 10.13 100.528 10.5067 100.508 10.98H99.6277C99.6544 10.2333 99.8811 9.65667 100.308 9.25C100.734 8.84333 101.284 8.64 101.958 8.64C102.644 8.64 103.188 8.83 103.588 9.21C103.994 9.59 104.198 10.1133 104.198 10.78C104.198 11.3333 104.031 11.8733 103.698 12.4C103.371 12.92 102.998 13.38 102.578 13.78C102.158 14.1733 101.621 14.6333 100.968 15.16H104.408V15.92H99.5977V15.27ZM106.904 8.652C107.304 8.652 107.628 8.774 107.876 9.018C108.124 9.258 108.248 9.606 108.248 10.062V12H107.708V10.14C107.708 9.812 107.626 9.562 107.462 9.39C107.298 9.214 107.074 9.126 106.79 9.126C106.502 9.126 106.272 9.216 106.1 9.396C105.932 9.576 105.848 9.838 105.848 10.182V12H105.302V8.712H105.848V9.18C105.956 9.012 106.102 8.882 106.286 8.79C106.474 8.698 106.68 8.652 106.904 8.652ZM109.116 10.344C109.116 10.008 109.184 9.714 109.32 9.462C109.456 9.206 109.642 9.008 109.878 8.868C110.118 8.728 110.386 8.658 110.682 8.658C110.938 8.658 111.176 8.718 111.396 8.838C111.616 8.954 111.784 9.108 111.9 9.3V7.56H112.452V12H111.9V11.382C111.792 11.578 111.632 11.74 111.42 11.868C111.208 11.992 110.96 12.054 110.676 12.054C110.384 12.054 110.118 11.982 109.878 11.838C109.642 11.694 109.456 11.492 109.32 11.232C109.184 10.972 109.116 10.676 109.116 10.344ZM111.9 10.35C111.9 10.102 111.85 9.886 111.75 9.702C111.65 9.518 111.514 9.378 111.342 9.282C111.174 9.182 110.988 9.132 110.784 9.132C110.58 9.132 110.394 9.18 110.226 9.276C110.058 9.372 109.924 9.512 109.824 9.696C109.724 9.88 109.674 10.096 109.674 10.344C109.674 10.596 109.724 10.816 109.824 11.004C109.924 11.188 110.058 11.33 110.226 11.43C110.394 11.526 110.58 11.574 110.784 11.574C110.988 11.574 111.174 11.526 111.342 11.43C111.514 11.33 111.65 11.188 111.75 11.004C111.85 10.816 111.9 10.598 111.9 10.35Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M146.919 10.59C146.966 9.97667 147.203 9.49667 147.629 9.15C148.056 8.80333 148.609 8.63 149.289 8.63C149.743 8.63 150.133 8.71333 150.459 8.88C150.793 9.04 151.043 9.26 151.209 9.54C151.383 9.82 151.469 10.1367 151.469 10.49C151.469 10.9033 151.349 11.26 151.109 11.56C150.876 11.86 150.569 12.0533 150.189 12.14V12.19C150.623 12.2967 150.966 12.5067 151.219 12.82C151.473 13.1333 151.599 13.5433 151.599 14.05C151.599 14.43 151.513 14.7733 151.339 15.08C151.166 15.38 150.906 15.6167 150.559 15.79C150.213 15.9633 149.796 16.05 149.309 16.05C148.603 16.05 148.023 15.8667 147.569 15.5C147.116 15.1267 146.863 14.6 146.809 13.92H147.689C147.736 14.32 147.899 14.6467 148.179 14.9C148.459 15.1533 148.833 15.28 149.299 15.28C149.766 15.28 150.119 15.16 150.359 14.92C150.606 14.6733 150.729 14.3567 150.729 13.97C150.729 13.47 150.563 13.11 150.229 12.89C149.896 12.67 149.393 12.56 148.719 12.56H148.489V11.8H148.729C149.343 11.7933 149.806 11.6933 150.119 11.5C150.433 11.3 150.589 10.9933 150.589 10.58C150.589 10.2267 150.473 9.94333 150.239 9.73C150.013 9.51667 149.686 9.41 149.259 9.41C148.846 9.41 148.513 9.51667 148.259 9.73C148.006 9.94333 147.856 10.23 147.809 10.59H146.919ZM153.216 9.246C153.312 9.058 153.448 8.912 153.624 8.808C153.804 8.704 154.022 8.652 154.278 8.652V9.216H154.134C153.522 9.216 153.216 9.548 153.216 10.212V12H152.67V8.712H153.216V9.246ZM154.884 10.344C154.884 10.008 154.952 9.714 155.088 9.462C155.224 9.206 155.41 9.008 155.646 8.868C155.886 8.728 156.154 8.658 156.45 8.658C156.706 8.658 156.944 8.718 157.164 8.838C157.384 8.954 157.552 9.108 157.668 9.3V7.56H158.22V12H157.668V11.382C157.56 11.578 157.4 11.74 157.188 11.868C156.976 11.992 156.728 12.054 156.444 12.054C156.152 12.054 155.886 11.982 155.646 11.838C155.41 11.694 155.224 11.492 155.088 11.232C154.952 10.972 154.884 10.676 154.884 10.344ZM157.668 10.35C157.668 10.102 157.618 9.886 157.518 9.702C157.418 9.518 157.282 9.378 157.11 9.282C156.942 9.182 156.756 9.132 156.552 9.132C156.348 9.132 156.162 9.18 155.994 9.276C155.826 9.372 155.692 9.512 155.592 9.696C155.492 9.88 155.442 10.096 155.442 10.344C155.442 10.596 155.492 10.816 155.592 11.004C155.692 11.188 155.826 11.33 155.994 11.43C156.162 11.526 156.348 11.574 156.552 11.574C156.756 11.574 156.942 11.526 157.11 11.43C157.282 11.33 157.418 11.188 157.518 11.004C157.618 10.816 157.668 10.598 157.668 10.35Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M190.654 14.39V13.7L194.164 8.84H195.254V13.6H196.254V14.39H195.254V16H194.354V14.39H190.654ZM194.394 9.79L191.704 13.6H194.394V9.79ZM197.671 9.162V11.1C197.671 11.26 197.705 11.374 197.773 11.442C197.841 11.506 197.959 11.538 198.127 11.538H198.529V12H198.037C197.733 12 197.505 11.93 197.353 11.79C197.201 11.65 197.125 11.42 197.125 11.1V9.162H196.699V8.712H197.125V7.884H197.671V8.712H198.529V9.162H197.671ZM201.002 8.652C201.25 8.652 201.474 8.706 201.674 8.814C201.874 8.918 202.03 9.076 202.142 9.288C202.258 9.5 202.316 9.758 202.316 10.062V12H201.776V10.14C201.776 9.812 201.694 9.562 201.53 9.39C201.366 9.214 201.142 9.126 200.858 9.126C200.57 9.126 200.34 9.216 200.168 9.396C200 9.576 199.916 9.838 199.916 10.182V12H199.37V7.56H199.916V9.18C200.024 9.012 200.172 8.882 200.36 8.79C200.552 8.698 200.766 8.652 201.002 8.652Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2687_31451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18.75,
    fill: "white",
    transform: "translate(9 32)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2687_31451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18.75,
    fill: "white",
    transform: "translate(9 63.375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2687_31451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18.75,
    fill: "white",
    transform: "translate(9 96)"
  })))));
};
var ForwardRef$4 = /*#__PURE__*/forwardRef(SvgSplitByTimePeriod);
const Row$4 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "report-columns__Row",
  componentId: "oz63j-0"
})(["overflow:auto;"]);
const Column$1 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "report-columns__Column",
  componentId: "oz63j-1"
})(["max-width:calc(50% - 4px);"]);
const ListItemContent = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "report-columns__ListItemContent",
  componentId: "oz63j-2"
})(["overflow:hidden;"]);
const StyledBuilderListWrapper = /*#__PURE__*/styled(BuilderListWrapper).withConfig({
  displayName: "report-columns__StyledBuilderListWrapper",
  componentId: "oz63j-3"
})(["overflow:auto;"]);
const StyledHeatMupSupportedTypography = /*#__PURE__*/styled(Typography).withConfig({
  displayName: "report-columns__StyledHeatMupSupportedTypography",
  componentId: "oz63j-4"
})(["&&&{font-weight:700;}"]);
const ICONS = {
  budget: 'priceChange',
  capacity: 'format_size',
  text: 'format_size',
  time: 'accessTime',
  customField: 'edit',
  spend: 'attachMoney'
};
const getAllChecked = columnTypes => {
  const inner = (innerColumns, innerChecked) => {
    return innerColumns.reduce((acc, column) => {
      var _a;
      if (!((_a = column.children) === null || _a === void 0 ? void 0 : _a.length)) {
        acc[column.value] = true;
      }
      if (column.children) {
        inner(column.children, acc);
      }
      return acc;
    }, innerChecked);
  };
  return inner(columnTypes, {});
};
function ReportColumnsComponent(props) {
  const {
    selected,
    columns,
    columnType,
    split,
    columnTypes,
    onParamChange,
    splitColumnName
  } = props;
  const [checkedColumnsTypes, setCheckedColumnsTypes] = useState(getAllChecked(columnTypes));
  const {
    value: filterText,
    debounced: debouncedFilterText,
    setDebouncedValue: setFilterText
  } = useDebouncedValue({
    defaultValue: ''
  });
  const disableDragDrop = Boolean(debouncedFilterText);
  const selectedHashed = useMemo(() => {
    return selected.reduce((acc, item) => {
      acc[item.name] = item;
      return acc;
    }, {});
  }, [selected]);
  const columnsHashed = useMemo(() => {
    return columns.reduce((acc, column) => {
      acc[column.id] = column;
      return acc;
    }, {});
  }, [columns]);
  const selectedSplitColumn = useMemo(() => {
    return columnsHashed[splitColumnName];
  }, [columnsHashed, splitColumnName]);
  const selectedColumns = useMemo(() => {
    return selected.map(s => columnsHashed[s.name]).filter(Boolean);
  }, [columnsHashed, selected]);
  const heatMapColumnOptions = useMemo(() => {
    return selectedColumns.filter(column => column.heatMapSupport);
  }, [selectedColumns]);
  useEffect(() => {
    var _a;
    if (columnType === 'DATE') {
      if (splitColumnName && !selectedHashed[splitColumnName]) {
        onParamChange({
          splitColumnName: undefined
        });
      }
      if (!splitColumnName) {
        onParamChange({
          splitColumnName: (_a = heatMapColumnOptions[0]) === null || _a === void 0 ? void 0 : _a.id
        });
      }
    } else {
      onParamChange({
        splitColumnName: undefined
      });
    }
  }, [columnType, heatMapColumnOptions, onParamChange, selectedHashed, splitColumnName]);
  const filtered = useMemo(() => {
    return {
      selectedColumns: debouncedFilterText ? selectedColumns.filter(column => searchStringCompare(column.searchPhrase, debouncedFilterText)) : selectedColumns,
      availableColumns: columns.filter(column => !selectedHashed[column.id] && checkedColumnsTypes[column.columnTypeFull] && searchStringCompare(column.searchPhrase, debouncedFilterText))
    };
  }, [checkedColumnsTypes, columns, debouncedFilterText, selectedColumns, selectedHashed]);
  const handleAdd = useCallback(reportColumn => {
    onParamChange({
      columns: selected.concat({
        name: reportColumn.id
      })
    });
  }, [onParamChange, selected]);
  const handleAddAll = useCallback(() => {
    onParamChange({
      columns: selected.concat(filtered.availableColumns.map(column => ({
        name: column.id
      })))
    });
  }, [filtered.availableColumns, onParamChange, selected]);
  const handleRemoveAll = useCallback(() => {
    const columnsToRemove = filtered.selectedColumns.reduce((acc, column) => {
      if (column.id === 'name') {
        return acc;
      }
      acc[column.id] = true;
      return acc;
    }, {});
    onParamChange({
      columns: selected.filter(item => !columnsToRemove[item.name])
    });
  }, [filtered.selectedColumns, onParamChange, selected]);
  const handleRemove = useCallback(reportColumn => {
    onParamChange({
      columns: selected.filter(item => item.name !== reportColumn.id)
    });
  }, [onParamChange, selected]);
  const availableColumnRowRenderer = useCallback(item => {
    const heatMapSupported = columnType === 'DATE' && item.heatMapSupport;
    return jsx(StyledAvailableListItem, {
      density: -2,
      noWrap: true,
      startAdornment: jsx(Layout, {
        flex: "0 0 40px",
        children: jsx(Icon, {
          name: ICONS[item.columnType]
        })
      }),
      label: jsxs(ListItemContent, {
        stack: true,
        flex: "1 1 auto",
        children: [jsx(ColumnName, {
          column: item,
          isHeatMapSupported: columnType === 'DATE' && item.heatMapSupport
        }), jsx(ColumnDescription, {
          column: item
        })]
      }),
      endAdornment: jsxs(Layout, {
        flex: heatMapSupported ? '0 0 80px' : '0 0 40px',
        gap: 10,
        vAlign: "center",
        hAlign: "flex-end",
        children: [heatMapSupported ? jsx(StyledHeatMupSupportedTypography, {
          variant: "label",
          size: "small",
          children: "III"
        }) : null, jsx(IconButton, {
          dataCy: "report-add-column-".concat(item.id),
          icon: "addCircle",
          onClick: () => handleAdd(item)
        })]
      })
    });
  }, [columnType, handleAdd]);
  const selectedColumnRowRenderer = useCallback(item => {
    const heatMapSupported = columnType === 'DATE' && item.heatMapSupport;
    return jsx(StyledSelectedListItem, {
      density: -2,
      noWrap: true,
      startAdornment: jsx(Layout, {
        flex: "0 0 40px",
        children: disableDragDrop ? null : jsx(Icon, {
          name: "dragIndicator"
        })
      }),
      label: jsxs(ListItemContent, {
        stack: true,
        flex: "1 1 auto",
        children: [columnType === 'DATE' && item.heatMapSupport && splitColumnName === item.id ? jsx(Typography, {
          variant: "label",
          size: "medium",
          color: "primary",
          children: "Active split column"
        }) : null, jsx(ColumnName, {
          column: item,
          isHeatMapSupported: columnType === 'DATE' && item.heatMapSupport
        }), jsx(ColumnDescription, {
          column: item
        })]
      }),
      endAdornment: jsxs(Layout, {
        flex: heatMapSupported ? '0 0 80px' : '0 0 40px',
        gap: 10,
        vAlign: "center",
        hAlign: "flex-end",
        children: [heatMapSupported ? jsx(StyledHeatMupSupportedTypography, {
          variant: "label",
          size: "small",
          children: "III"
        }) : null, item.id !== 'name' ? jsx(IconButton, {
          dataCy: "report-remove-column-".concat(item.id),
          icon: "delete",
          onClick: () => handleRemove(item)
        }) : null]
      })
    });
  }, [columnType, disableDragDrop, handleRemove, splitColumnName]);
  const handleReorder = useCallback(newOrder => {
    onParamChange({
      columns: newOrder.map(column => ({
        name: column.id
      }))
    });
  }, [onParamChange]);
  const {
    open: openColumnTypeDialog,
    isOpen: isColumnTypeDialogOpen,
    anchorElement: columnTypeDialogAnchorElement,
    close: closeColumnTypeDialog
  } = useOpenState();
  const {
    open: openReportViewDialog,
    isOpen: isReportViewDialogOpen,
    anchorElement: reportViewDialogAnchorElement,
    close: closeReportViewDialog
  } = useOpenState();
  return jsxs(BuilderWrapper, {
    stack: true,
    gap: "--Spacing-200",
    children: [jsxs(Layout, {
      gap: "--Spacing-100",
      vAlign: "center",
      children: [jsx(Column$1, {
        stack: true,
        gap: "--Spacing-100",
        flex: "0 0 50%",
        children: jsx(TextField, {
          value: filterText,
          onChange: event => {
            var _a;
            return setFilterText((_a = event.target.value) === null || _a === void 0 ? void 0 : _a.toLowerCase());
          },
          endIcon: "search",
          label: "Filter",
          placeholder: "Filter"
        })
      }), jsx(Column$1, {
        gap: "--Spacing-100",
        flex: "0 0 50%",
        children: jsxs(Layout, {
          gap: "--Spacing-200",
          children: [jsx(Chip, {
            endIcon: "chevronDown",
            label: "Column type",
            onClick: openColumnTypeDialog
          }), isColumnTypeDialogOpen ? jsx(CheckboxTreeDialog, {
            options: columnTypes,
            open: true,
            onClose: closeColumnTypeDialog,
            anchorElement: columnTypeDialogAnchorElement,
            checked: checkedColumnsTypes,
            onChange: newChecked => setCheckedColumnsTypes(newChecked)
          }) : null, jsx(Chip, {
            endIcon: "chevronDown",
            label: "Report Types",
            onClick: openReportViewDialog
          }), isReportViewDialogOpen ? jsx(ReportViewDialog, {
            onClose: closeReportViewDialog,
            anchorElement: reportViewDialogAnchorElement,
            columnType: columnType,
            split: split,
            onParamChange: onParamChange
          }) : null]
        })
      })]
    }), jsxs(Row$4, {
      gap: "--Spacing-100",
      flex: "1 1 auto",
      children: [jsxs(Column$1, {
        stack: true,
        gap: "--Spacing-100",
        flex: "0 0 50%",
        children: [jsxs(Layout, {
          gap: "--Spacing-50",
          hAlign: "space-between",
          vAlign: "center",
          pr: "--Spacing-200",
          children: [jsx(Typography, {
            variant: "label",
            size: "xl",
            children: "Available Columns"
          }), jsxs(Layout, {
            vAlign: "center",
            gap: "--Spacing-50",
            children: [jsx(Typography, {
              variant: "body",
              size: "small",
              children: "Add all"
            }), jsx(IconButton, {
              dataCy: "report-add-all-columns",
              icon: "add",
              variant: "outlined",
              size: "medium",
              onClick: handleAddAll
            })]
          })]
        }), filtered.availableColumns.length ? jsx(StyledBuilderListWrapper, {
          stack: true,
          children: jsx(List$1, {
            virtualized: true,
            items: filtered.availableColumns,
            idKey: "id",
            rowRenderer: availableColumnRowRenderer
          })
        }) : debouncedFilterText ? jsx(BuilderEmptyList, {
          text: "Hmmm...There seem to be no matches found. Try adjusting your filters or search terms.",
          icon: "unhappy"
        }) : jsx(BuilderEmptyList, {
          text: "Looks like all columns are selected",
          icon: "searchFace"
        })]
      }), jsxs(Column$1, {
        stack: true,
        gap: "--Spacing-100",
        flex: "0 0 50%",
        children: [jsxs(Layout, {
          gap: "--Spacing-50",
          hAlign: "space-between",
          vAlign: "center",
          pr: "--Spacing-200",
          children: [jsx(Typography, {
            variant: "label",
            size: "xl",
            children: "Selected Columns"
          }), jsxs(Layout, {
            vAlign: "center",
            gap: "--Spacing-50",
            children: [jsx(Typography, {
              variant: "body",
              size: "small",
              children: "Remove all"
            }), jsx(IconButton, {
              dataCy: "report-remove-all-columns",
              icon: "delete",
              variant: "outlined",
              size: "medium",
              onClick: handleRemoveAll
            })]
          })]
        }), columnType === 'DATE' ? jsxs(Fragment, {
          children: [jsx(Select, {
            disableClearable: true,
            label: "Choose column to split report by",
            value: selectedSplitColumn,
            onChange: (event, option) => {
              onParamChange({
                splitColumnName: option === null || option === void 0 ? void 0 : option.id
              });
            },
            options: heatMapColumnOptions,
            optionLabel: "label",
            optionValue: "id"
          }), jsx(SplitOptions, {
            split: split,
            columnType: columnType,
            onParamChange: onParamChange
          })]
        }) : null, filtered.selectedColumns.length ? jsx(SelectedListWrapper, {
          stack: true,
          children: jsx(SortableList, {
            disabledDragDrop: disableDragDrop,
            withDivider: false,
            virtualized: true,
            items: filtered.selectedColumns,
            idKey: "id",
            rowRenderer: selectedColumnRowRenderer,
            onReorder: handleReorder
          })
        }) : debouncedFilterText ? jsx(BuilderEmptyList, {
          text: "Hmmm...There seem to be no matches found. Try adjusting your filters or search terms.",
          icon: "unhappy"
        }) : jsx(BuilderEmptyList, {
          title: "No Column Selected",
          text: "At least 1 column is required to generate report.",
          icon: "searchFace"
        })]
      })]
    })]
  });
}
const splitOptions = ['DAY', 'WEEK', 'MONTH', 'YEAR'];
const StyleRadio = /*#__PURE__*/styled(Radio).withConfig({
  displayName: "report-columns__StyleRadio",
  componentId: "oz63j-5"
})(["align-self:flex-start;"]);
const ReportViewDialog = props => {
  const {
    columnType,
    split,
    onClose,
    anchorElement,
    onParamChange
  } = props;
  useKeyDown({
    Enter: () => {
      onClose();
    }
  });
  const changeToDynamic = () => {
    onParamChange({
      columnType: 'DYNAMIC',
      split: ''
    });
  };
  const changeToDate = () => {
    onParamChange({
      columnType: 'DATE',
      split: 'DAY'
    });
  };
  const titleJSX = jsxs(Fragment, {
    children: [jsx(Typography, {
      variant: "label",
      size: "xl",
      prominent: true,
      children: "Report views"
    }), jsx(Divider, {})]
  });
  const contentJSX = jsxs(Layout, {
    stack: true,
    gap: "--Spacing-50",
    hAlign: "center",
    children: [jsx(StyleRadio, {
      value: "DYNAMIC",
      dataCy: "standart-report",
      label: "Manually choose columns",
      checked: columnType === 'DYNAMIC',
      onChange: changeToDynamic
    }), jsx("div", {
      style: {
        minHeight: 130,
        cursor: 'pointer'
      },
      "data-role": "button",
      onClick: changeToDynamic,
      children: jsx(ForwardRef$8, {})
    }), jsx(Divider, {}), jsx(StyleRadio, {
      value: "DATE",
      dataCy: "date-column-report",
      label: "Split column by time period",
      checked: columnType === 'DATE',
      onChange: changeToDate
    }), jsxs("div", {
      style: {
        minHeight: 130,
        cursor: 'pointer'
      },
      "data-role": "button",
      onClick: changeToDate,
      children: [split === 'DAY' || !split ? jsx(ForwardRef$4, {}) : null, split === 'WEEK' ? jsx(ForwardRef$6, {}) : null, split === 'MONTH' ? jsx(ForwardRef$7, {}) : null, split === 'YEAR' ? jsx(ForwardRef$5, {}) : null]
    }), jsx(SplitOptions, {
      split: split,
      columnType: columnType,
      onParamChange: onParamChange
    })]
  });
  const actionsJSX = undefined;
  return jsx(Dialog, {
    open: true,
    title: titleJSX,
    content: contentJSX,
    actions: actionsJSX,
    onClose: onClose,
    anchorElement: anchorElement,
    withCloseButton: true
  });
};
const SplitOptions = props => {
  const {
    split,
    columnType,
    onParamChange
  } = props;
  return jsx(Layout, {
    gap: "--Spacing-100",
    children: splitOptions.map(option => {
      return jsx(Chip, {
        selected: option === split,
        disabled: columnType !== 'DATE',
        label: firstLetterToUpperCase(option),
        onClick: () => {
          onParamChange({
            columnType: 'DATE',
            split: option
          });
        }
      }, option);
    })
  });
};
const ColumnDescription = _ref14 => {
  let {
    column
  } = _ref14;
  return jsxs(Fragment, {
    children: [jsxs(Typography, {
      variant: "body",
      size: "medium",
      color: "on-surface-variant",
      noWrap: true,
      children: [-1 !== column.display.indexOf('To Date') && jsx(Icon, {
        size: 16,
        name: "arrowForward"
      }), -1 !== column.display.indexOf('All Time') && jsx(Icon, {
        size: 16,
        name: "arrowBack"
      }), -1 === column.columnType.indexOf('capacity') && column.display, -1 !== column.columnType.indexOf('capacity') && 'based on ' + column.displayTimeType, -1 !== column.display.indexOf('All Time') && jsx(Icon, {
        size: 16,
        name: "arrowForward"
      }), -1 !== column.display.indexOf('Future') && jsx(Icon, {
        size: 16,
        name: "arrowBack"
      })]
    }), column.displayRateType && jsxs(Typography, {
      variant: "body",
      size: "medium",
      color: "on-surface-variant",
      noWrap: true,
      children: ["using ", column.displayRateType]
    })]
  });
};
const ColumnName = _ref15 => {
  let {
    column
  } = _ref15;
  var _a, _b, _c;
  return jsxs(Typography, {
    variant: "label",
    size: "large",
    prominent: true,
    noWrap: true,
    children: [-1 !== column.columnType.indexOf('spend') && -1 !== ((_a = column.timeType) === null || _a === void 0 ? void 0 : _a.indexOf('scheduled')) && 'Scheduled Spend', -1 !== column.columnType.indexOf('capacity') && column.display, -1 !== column.columnType.indexOf('spend') && -1 !== ((_b = column.timeType) === null || _b === void 0 ? void 0 : _b.indexOf('reported')) && 'Reported Spend', -1 !== column.columnType.indexOf('budget') && 'Budget - ', (-1 === column.columnType.indexOf('spend') && -1 === column.columnType.indexOf('capacity') || -1 !== ((_c = column.timeType) === null || _c === void 0 ? void 0 : _c.indexOf('general')) && -1 === column.columnType.indexOf('capacity')) && column.displayTimeType]
  });
};
const ReportColumns = /*#__PURE__*/React__default.memo(ReportColumnsComponent);
const isEvent = project => {
  if (!project || typeof project === 'string') {
    return false;
  }
  return project.type === ProjectTypeEnum.EVENT;
};
const replaceProjectStatus = (project, projectStatusesMapped) => {
  if (!project) {
    return '';
  }
  if (isEvent(project)) {
    return 'Event';
  }
  const {
    status
  } = project;
  if (!status) {
    return '';
  }
  return projectStatusesMapped[status].display;
};
const useProjectStatusFormat = project => {
  const projectStatusesMapped = useSelector(selectProjectStatusesMapped);
  return useMemo(() => {
    return replaceProjectStatus(project, projectStatusesMapped);
  }, [project, projectStatusesMapped]);
};
const useProjectStatusFormatter = () => {
  const projectStatusesMapped = useSelector(selectProjectStatusesMapped);
  return useCallback(project => {
    return replaceProjectStatus(project, projectStatusesMapped);
  }, [projectStatusesMapped]);
};
const ROLE_OWNER = {
  label: 'Account owner',
  value: ResourceRoleEnum.ROLE_OWNER
};
const ROLE_ADMIN = {
  label: 'Admin',
  value: ResourceRoleEnum.ROLE_ADMIN
};
const ROLE_TEAM = {
  label: 'Team',
  value: ResourceRoleEnum.ROLE_TEAM
};
const ROLE_ACCOUNT_HANDLER = {
  label: 'Account handler 1',
  value: ResourceRoleEnum.ROLE_ACCOUNT_HANDLER
};
const ROLE_ACCOUNT_HANDLER_1 = {
  label: 'Account handler 2',
  value: ResourceRoleEnum.ROLE_ACCOUNT_HANDLER_1
};
const ROLE_CONTRACTOR = {
  label: 'Contractor',
  value: ResourceRoleEnum.ROLE_CONTRACTOR
};
const RESOURCE_ROLE_OPTIONS = [ROLE_ADMIN, ROLE_ACCOUNT_HANDLER, ROLE_ACCOUNT_HANDLER_1, ROLE_TEAM, ROLE_CONTRACTOR];
const RESOURCE_ROLES_BY_NAMES = {
  [ResourceRoleEnum.ROLE_OWNER]: ROLE_OWNER,
  [ResourceRoleEnum.ROLE_ADMIN]: ROLE_ADMIN,
  [ResourceRoleEnum.ROLE_ACCOUNT_HANDLER]: ROLE_ACCOUNT_HANDLER,
  [ResourceRoleEnum.ROLE_ACCOUNT_HANDLER_1]: ROLE_ACCOUNT_HANDLER_1,
  [ResourceRoleEnum.ROLE_TEAM]: ROLE_TEAM,
  [ResourceRoleEnum.ROLE_CONTRACTOR]: ROLE_CONTRACTOR
};
const STATUS_ARCHIVED = {
  display: 'Archived',
  value: ResourceStatusEnum.STATUS_ARCHIVED,
  color: '#c5594c'
};
const STATUS_NON_BOOKABLE = {
  display: 'Non Bookable',
  value: ResourceStatusEnum.STATUS_NON_BOOKABLE,
  color: '#d29137'
};
const STATUS_PARKED = {
  display: 'Parked',
  value: ResourceStatusEnum.STATUS_PARKED,
  color: '#ff5722'
};
const STATUS_ACTIVE = {
  display: 'Active',
  value: ResourceStatusEnum.STATUS_ACTIVE,
  color: '#5a884a'
};
const RESOURCE_STATUS_NAMES = {
  STATUS_ACTIVE: STATUS_ACTIVE.display,
  STATUS_ARCHIVED: STATUS_ARCHIVED.display,
  STATUS_PARKED: STATUS_PARKED.display,
  STATUS_NON_BOOKABLE: STATUS_NON_BOOKABLE.display
};
const isUnassignedWork = resource => {
  return (resource === null || resource === void 0 ? void 0 : resource.type) === ResourceTypeEnum.UNASSIGNED;
};
const resourceStatusFormat = resource => {
  if (!resource) {
    return '';
  }
  if (isUnassignedWork(resource)) {
    return 'Unassigned';
  }
  return RESOURCE_STATUS_NAMES[resource.status];
};
const isProject$1 = item => {
  if ('listType' in item) {
    return item.isProject && item.listType === 'item';
  }
  return !('role' in item) && 'type' in item && item.type === ProjectTypeEnum.REGULAR || item.type === ProjectTypeEnum.EVENT;
};
const isProjectGroup = group => {
  if ('listType' in group) {
    return group.isProject && group.listType === 'group';
  }
  return 'projects' in group;
};
const isResource$1 = item => {
  if ('listType' in item) {
    return !item.isProject && item.listType === 'item';
  }
  return 'type' in item && item.type === ResourceTypeEnum.REGULAR || item.type === ResourceTypeEnum.UNASSIGNED;
};
const isResourceGroup = group => {
  if ('listType' in group) {
    return !group.isProject && group.listType === 'group';
  }
  return 'resources' in group && !('projectCode' in group);
};
const getItemIcon = item => {
  if (isProjectGroup(item)) {
    return 'projectGroup';
  } else if (isResourceGroup(item)) {
    return 'people';
  } else if (isProject$1(item)) {
    if (item.type === ProjectTypeEnum.EVENT) {
      return 'event';
    }
    return 'folder';
  } else if (isResource$1(item)) {
    if (item.type === ResourceTypeEnum.UNASSIGNED) {
      return 'resourceMgmt';
    }
    return 'personOutline';
  }
  return undefined;
};
function BuilderSelectData(props) {
  var _a, _b, _c, _d;
  const {
    itemTitle,
    groupTitle,
    items,
    groups,
    selected,
    selectedGroups,
    selectedItems,
    showGroupColumn,
    onItemSelect,
    onAddManyItems,
    onGroupSelect,
    onAddManyGroups,
    onRemoveOne,
    onRemoveMany,
    isProjectRelatedItemType,
    itemTypeObject
  } = props;
  const appKeywords = useAppKeyWords();
  const projectStatusFormatter = useProjectStatusFormatter();
  const {
    value: filterText,
    debounced: debouncedFilterText,
    setDebouncedValue: setFilterText
  } = useDebouncedValue({
    defaultValue: ''
  });
  const filtered = useMemo(() => {
    return {
      items: items.filter(item => searchStringCompare(item.name, debouncedFilterText)),
      groups: groups.filter(group => searchStringCompare(group.name, debouncedFilterText)),
      selected: selected.filter(item => searchStringCompare(item.name, debouncedFilterText))
    };
  }, [debouncedFilterText, groups, items, selected]);
  return jsxs(BuilderWrapper, {
    stack: true,
    gap: "--Spacing-200",
    children: [jsx(Layout, {
      children: jsx(TextField, {
        value: filterText,
        onChange: event => {
          var _a;
          return setFilterText((_a = event.target.value) === null || _a === void 0 ? void 0 : _a.toLowerCase());
        },
        endIcon: "search",
        label: "Filter",
        placeholder: "Filter by name",
        dataCy: "common-type-to-filter",
        clearable: true,
        onClear: () => setFilterText('')
      })
    }), jsxs(Layout, {
      gap: "--Spacing-100",
      flex: "1 1 auto",
      children: [showGroupColumn ? jsxs(Layout, {
        stack: true,
        gap: "--Spacing-100",
        flex: "1 0 33%",
        children: [jsxs(Layout, {
          hAlign: "space-between",
          vAlign: "center",
          children: [jsx(Typography, {
            variant: "label",
            size: "xl",
            children: groupTitle
          }), jsxs(Layout, {
            vAlign: "center",
            pr: "--Spacing-200",
            gap: "--Spacing-50",
            children: [jsx(Typography, {
              variant: "body",
              size: "small",
              children: "Add all"
            }), jsx(IconButton, {
              icon: "add",
              variant: "outlined",
              size: "small",
              onClick: () => {
                onAddManyGroups(filtered.groups);
              }
            })]
          })]
        }), ((_a = filtered.groups) === null || _a === void 0 ? void 0 : _a.length) ? jsx(BuilderListWrapper, {
          stack: true,
          children: jsx(List$1, {
            virtualized: true,
            items: filtered.groups,
            rowRenderer: group => {
              var _a, _b, _c, _d;
              return jsx(StyledAvailableListItem, {
                noWrap: true,
                density: -2,
                label: group.name,
                labelTooltip: group.name,
                supportingText: isProjectGroup(group) ? "".concat((_b = (_a = group.projects) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0, " ").concat(appKeywords.projectPluralKeyWord) : "".concat((_d = (_c = group.resources) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0, " ").concat(appKeywords.resourcePluralKeyWord),
                startAdornment: isProjectGroup(group) ? 'projectGroup' : 'people',
                endAdornment: jsx(IconButton, {
                  icon: "addCircle",
                  dataCy: "data-list--Add--".concat(group.name),
                  onClick: () => onGroupSelect(group)
                })
              });
            }
          })
        }) : debouncedFilterText ? jsx(BuilderEmptyList, {
          text: "Hmmm...There seem to be no matches found in this category. Try adjusting your filters or search terms.",
          icon: "unhappy"
        }) : jsx(BuilderEmptyList, {
          text: "Looks like you have selected and added all available options from this table",
          icon: "searchFace"
        })]
      }) : null, jsxs(Layout, {
        stack: true,
        gap: "--Spacing-100",
        flex: "1 0 33%",
        children: [jsxs(Layout, {
          hAlign: "space-between",
          vAlign: "center",
          children: [jsx(Typography, {
            variant: "label",
            size: "xl",
            children: itemTitle
          }), jsxs(Layout, {
            vAlign: "center",
            pr: "--Spacing-200",
            gap: "--Spacing-50",
            children: [jsx(Typography, {
              variant: "body",
              size: "small",
              children: "Add all"
            }), jsx(IconButton, {
              icon: "add",
              variant: "outlined",
              size: "small",
              onClick: () => {
                onAddManyItems(filtered.items);
              }
            })]
          })]
        }), ((_b = filtered.items) === null || _b === void 0 ? void 0 : _b.length) ? jsx(BuilderListWrapper, {
          stack: true,
          children: jsx(List$1, {
            virtualized: true,
            items: filtered.items,
            rowRenderer: item => {
              return jsx(StyledAvailableListItem, {
                noWrap: true,
                density: -2,
                label: "".concat(item.name).concat(isProject$1(item) && item.projectCode ? " (".concat(item.projectCode, ")") : ''),
                labelTooltip: item.name,
                supportingText: isProject$1(item) ? projectStatusFormatter(item) : isResource$1(item) ? resourceStatusFormat(item) : '',
                startAdornment: getItemIcon(item),
                endAdornment: jsx(IconButton, {
                  icon: "addCircle",
                  dataCy: "data-list--Add--".concat(item.name),
                  onClick: () => {
                    onItemSelect(item);
                  }
                })
              });
            }
          })
        }) : debouncedFilterText ? jsx(BuilderEmptyList, {
          text: "Hmmm...There seem to be no matches found in this category. Try adjusting your filters or search terms.",
          icon: "unhappy"
        }) : jsx(BuilderEmptyList, {
          text: "Looks like you have selected and added all available options from this table",
          icon: "searchFace"
        })]
      }), jsxs(Layout, {
        stack: true,
        gap: "--Spacing-100",
        flex: "1 0 33%",
        children: [jsxs(Layout, {
          hAlign: "space-between",
          vAlign: "center",
          children: [jsx(Typography, {
            variant: "label",
            size: "xl",
            children: "Selected Data"
          }), jsxs(Layout, {
            vAlign: "center",
            pr: "--Spacing-200",
            gap: "--Spacing-50",
            children: [jsx(Typography, {
              variant: "body",
              size: "small",
              children: "Remove all"
            }), jsx(IconButton, {
              icon: "delete",
              variant: "outlined",
              size: "small",
              onClick: () => {
                onRemoveMany(filtered.selected);
              }
            })]
          })]
        }), filtered.selected.length ? jsx(SelectedListWrapper, {
          stack: true,
          children: jsx(List$1, {
            withDivider: false,
            virtualized: true,
            items: filtered.selected,
            rowRenderer: item => {
              var _a, _b, _c, _d;
              return jsx(StyledSelectedListItem, {
                noWrap: true,
                density: -2,
                label: "".concat(item.name).concat(isProject$1(item) && item.projectCode ? " (".concat(item.projectCode, ")") : ''),
                labelTooltip: item.name,
                startAdornment: getItemIcon(item),
                supportingText: isProjectGroup(item) ? "".concat((_b = (_a = item.projects) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0, " ").concat(appKeywords.projectPluralKeyWord) : isResourceGroup(item) ? "".concat((_d = (_c = item.resources) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0, " ").concat(appKeywords.resourcePluralKeyWord) : isProject$1(item) ? projectStatusFormatter(item) : isResource$1(item) ? resourceStatusFormat(item) : '',
                endAdornment: jsx(IconButton, {
                  icon: "delete",
                  dataCy: "data-list--Remove--".concat(item.name),
                  onClick: () => {
                    onRemoveOne(item);
                  }
                })
              });
            }
          })
        }) : debouncedFilterText ? jsx(BuilderEmptyList, {
          text: "Hmmm...There seem to be no matches found in this category. Try adjusting your filters or search terms.",
          icon: "unhappy"
        }) : jsx(BuilderEmptyList, {
          text: "Looks like nothing is selected. Choose from ".concat((itemTypeObject === null || itemTypeObject === void 0 ? void 0 : itemTypeObject.value) === 'PROJECT' || (itemTypeObject === null || itemTypeObject === void 0 ? void 0 : itemTypeObject.value) === 'RESOURCE' ? 'Groups or ' : '', " ").concat(isProjectRelatedItemType ? (itemTypeObject === null || itemTypeObject === void 0 ? void 0 : itemTypeObject.value) === 'EVENT' ? 'Events' : appKeywords.projectPluralKeyWord : (itemTypeObject === null || itemTypeObject === void 0 ? void 0 : itemTypeObject.value) === 'UNASSIGNED' ? 'Unassigned Work' : appKeywords.resourcePluralKeyWord, " to continue."),
          icon: "searchFace"
        })]
      })]
    }), jsx(Layout, {
      hAlign: "flex-end",
      children: jsxs(Typography, {
        variant: "body",
        size: "small",
        dataCy: "data-list-wrapper-sub-title--selected-column",
        children: ["Selected Groups: ", (_c = selectedGroups === null || selectedGroups === void 0 ? void 0 : selectedGroups.length) !== null && _c !== void 0 ? _c : 0, " / Selected", ' ', isProjectRelatedItemType ? appKeywords.projectPluralKeyWord : appKeywords.resourcePluralKeyWord, ":", ' ', (_d = selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) !== null && _d !== void 0 ? _d : 0]
      })
    })]
  });
}
const StyledTypeSelector = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "type-selector__StyledTypeSelector",
  componentId: "wiaso5-0"
})(["width:100%;border-radius:8px;border:1px solid ", ";background-color:", ";& *{cursor:pointer;}", " ", ""], props => props.theme.designTokens.color.color.light['outline-variant'].value, props => props.theme.designTokens.color.color.surfaces['background'].value, props => props.active && css(["border:1px solid ", ";background-color:", ";box-shadow:", ";"], props.theme.designTokens.color.color.surfaces['surface-container-highest'].value, props.theme.designTokens.color.color.surfaces['surface-container-highest'].value, props.theme.shadows[2]), props => props.disabled && css(["&:before{content:'';width:100%;height:100%;top:0;left:0;position:absolute;border-radius:8px;border:1px solid ", ";background-color:", ";opacity:0.4;}position:relative;cursor:unset;border:1px solid ", ";background-color:", ";"], props.theme.designTokens.color.color.neutral['neutral70'].value, props.theme.designTokens.color.color.neutral['neutral80'].value, props.theme.designTokens.color.color.neutral['neutral70'].value, props.theme.designTokens.color.color.neutral['neutral80'].value));
function TypeSelector(props) {
  const {
    className,
    dataCy,
    onClick,
    active,
    icon,
    header,
    content,
    startAdornment,
    disabled,
    vertical
  } = props;
  return jsxs(StyledTypeSelector, {
    dataCy: dataCy,
    className: className,
    pt: "--Spacing-200",
    pb: "--Spacing-200",
    pr: "--Spacing-200",
    pl: "--Spacing-200",
    gap: vertical ? undefined : '--Spacing-100',
    active: active,
    disabled: disabled,
    onClick: event => {
      if (disabled) {
        return;
      }
      onClick === null || onClick === void 0 ? void 0 : onClick(event);
    },
    stack: vertical,
    children: [startAdornment ? startAdornment : icon ? jsx(Layout, {
      flex: "0 0 40px",
      children: jsx(Icon, {
        size: 40,
        name: icon,
        color: "on-surface-variant"
      })
    }) : null, jsxs(Layout, {
      stack: true,
      gap: "--Spacing-100",
      children: [jsx(Typography, {
        variant: "title",
        children: header
      }), jsx(Typography, {
        variant: "body",
        size: "small",
        children: content
      })]
    })]
  });
}
var defineProperty = objectDefineProperty.f;
var proxyAccessor$1 = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () {
      return Source[key];
    },
    set: function (it) {
      Source[key] = it;
    }
  });
};
var isCallable$9 = isCallable$s;
var isObject$7 = isObject$i;
var setPrototypeOf$2 = objectSetPrototypeOf;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$1 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
  // it can work only with native `setPrototypeOf`
  setPrototypeOf$2 &&
  // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
  isCallable$9(NewTarget = dummy.constructor) && NewTarget !== Wrapper && isObject$7(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) setPrototypeOf$2($this, NewTargetPrototype);
  return $this;
};
var toString$9 = toString$g;
var normalizeStringArgument$1 = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString$9(argument);
};
var isObject$6 = isObject$i;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$9;

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
var installErrorCause$1 = function (O, options) {
  if (isObject$6(options) && 'cause' in options) {
    createNonEnumerableProperty$2(O, 'cause', options.cause);
  }
};
var uncurryThis$9 = functionUncurryThis;
var $Error = Error;
var replace$3 = uncurryThis$9(''.replace);
var TEST = function (arg) {
  return String(new $Error(arg).stack);
}('zxcasd');
// eslint-disable-next-line redos/no-vulnerable -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);
var errorStackClear = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace$3(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  }
  return stack;
};
var fails$a = fails$y;
var createPropertyDescriptor = createPropertyDescriptor$5;
var errorStackInstallable = !fails$a(function () {
  var error = new Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});
var createNonEnumerableProperty$1 = createNonEnumerableProperty$9;
var clearErrorStack = errorStackClear;
var ERROR_STACK_INSTALLABLE = errorStackInstallable;

// non-standard V8
var captureStackTrace = Error.captureStackTrace;
var errorStackInstall = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);else createNonEnumerableProperty$1(error, 'stack', clearErrorStack(stack, dropEntries));
  }
};
var getBuiltIn$5 = getBuiltIn$b;
var hasOwn$3 = hasOwnProperty_1;
var createNonEnumerableProperty = createNonEnumerableProperty$9;
var isPrototypeOf$2 = objectIsPrototypeOf;
var setPrototypeOf$1 = objectSetPrototypeOf;
var copyConstructorProperties$1 = copyConstructorProperties$3;
var proxyAccessor = proxyAccessor$1;
var inheritIfRequired = inheritIfRequired$1;
var normalizeStringArgument = normalizeStringArgument$1;
var installErrorCause = installErrorCause$1;
var installErrorStack = errorStackInstall;
var DESCRIPTORS$4 = descriptors;
var wrapErrorConstructorWithCause$1 = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn$5.apply(null, path);
  if (!OriginalError) return;
  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (hasOwn$3(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;
  if (!FORCED) return OriginalError;
  var BaseError = getBuiltIn$5('Error');
  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    installErrorStack(result, WrappedError, result.stack, 2);
    if (this && isPrototypeOf$2(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });
  WrappedError.prototype = OriginalErrorPrototype;
  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf$1) setPrototypeOf$1(WrappedError, BaseError);else copyConstructorProperties$1(WrappedError, BaseError, {
      name: true
    });
  } else if (DESCRIPTORS$4 && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }
  copyConstructorProperties$1(WrappedError, OriginalError);
  try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) {/* empty */}
  return WrappedError;
};

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $$m = _export;
var global$a = global$q;
var apply$2 = functionApply;
var wrapErrorConstructorWithCause = wrapErrorConstructorWithCause$1;
var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global$a[WEB_ASSEMBLY];

// eslint-disable-next-line es/no-error-cause -- feature detection
var FORCED$6 = new Error('e', {
  cause: 7
}).cause !== 7;
var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED$6);
  $$m({
    global: true,
    constructor: true,
    arity: 1,
    forced: FORCED$6
  }, O);
};
var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED$6);
    $$m({
      target: WEB_ASSEMBLY,
      stat: true,
      constructor: true,
      arity: 1,
      forced: FORCED$6
    }, O);
  }
};

// https://tc39.es/ecma262/#sec-nativeerror
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) {
    return apply$2(init, this, arguments);
  };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) {
    return apply$2(init, this, arguments);
  };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) {
    return apply$2(init, this, arguments);
  };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) {
    return apply$2(init, this, arguments);
  };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) {
    return apply$2(init, this, arguments);
  };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) {
    return apply$2(init, this, arguments);
  };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) {
    return apply$2(init, this, arguments);
  };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) {
    return apply$2(init, this, arguments);
  };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) {
    return apply$2(init, this, arguments);
  };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) {
    return apply$2(init, this, arguments);
  };
});
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}
function _arrayLikeToArray$2(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _unsupportedIterableToArray$2(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$2(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$2(r, a) : void 0;
  }
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
var DESCRIPTORS$3 = descriptors;
var isArray$1 = isArray$4;
var $TypeError$2 = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS$3 && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', {
      writable: false
    }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();
var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray$1(O) && !getOwnPropertyDescriptor$1(O, 'length').writable) {
    throw new $TypeError$2('Cannot set read only .length');
  }
  return O.length = length;
} : function (O, length) {
  return O.length = length;
};
var $$l = _export;
var toObject$3 = toObject$b;
var lengthOfArrayLike$2 = lengthOfArrayLike$9;
var setArrayLength$1 = arraySetLength;
var doesNotExceedSafeInteger$1 = doesNotExceedSafeInteger$3;
var fails$9 = fails$y;
var INCORRECT_TO_LENGTH = fails$9(function () {
  return [].push.call({
    length: 0x100000000
  }, 1) !== 4294967297;
});

// V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength$1 = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', {
      writable: false
    }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};
var FORCED$5 = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength$1();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$$l({
  target: 'Array',
  proto: true,
  arity: 1,
  forced: FORCED$5
}, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject$3(this);
    var len = lengthOfArrayLike$2(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger$1(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength$1(O, len);
    return len;
  }
});
const getUniqHolidays = holidays => {
  const uniqHolidaysMap = {};
  for (const holiday of holidays) {
    const holidayDayMonthDate = formatDate(holiday.date, DATE_FORMATS.MONTH_DAY);
    if (!uniqHolidaysMap[holidayDayMonthDate]) {
      uniqHolidaysMap[holidayDayMonthDate] = [];
      uniqHolidaysMap[holidayDayMonthDate].push(holiday);
      continue;
    }
    uniqHolidaysMap[holidayDayMonthDate].find(uniqHoliday => {
      if (uniqHoliday.repeat && !holiday.repeat || uniqHoliday.repeat && holiday.repeat) {
        return formatDate(uniqHoliday.date, DATE_FORMATS.MONTH_DAY) === holidayDayMonthDate;
      }
      return uniqHoliday.date === holiday.date;
    });
  }
  return Object.values(uniqHolidaysMap).reduce((acc, uniqHolidays) => {
    return acc.concat(uniqHolidays);
  }, []);
};
const getHolidayDateBetweenDates = (holiday, start, end) => {
  if (holiday.repeat) {
    const dateWithStart = setYear(holiday.date, start.getFullYear());
    if (isBetween(dateWithStart, start, end)) {
      return dateWithStart;
    }
    return setYear(holiday.date, end.getFullYear());
  }
  return toDate$1(holiday.date);
};
const isHolidayBetweenDates = (holiday, start, end) => {
  const {
    date,
    repeat
  } = holiday;
  if (repeat) {
    const dateWithStart = setYear(date, start.getFullYear());
    const dateWithEnd = setYear(date, end.getFullYear());
    return isBetween(dateWithStart, start, end) || isBetween(dateWithEnd, start, end);
  }
  return isBetween(date, start, end);
};
const checkIfWorkDay = _ref16 => {
  let {
    dateToCheck,
    holidaysMapped,
    resource,
    workWeekDetails
  } = _ref16;
  var _a;
  const dayName = getDateDayKey(dateToCheck);
  if (resource === null || resource === void 0 ? void 0 : resource.resourceHasCustomAvailabilityOverrides) {
    const overrideId = (_a = resource === null || resource === void 0 ? void 0 : resource.customAvailabilitiesOverridesByDay) === null || _a === void 0 ? void 0 : _a[formatDate(dateToCheck, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT)];
    if (overrideId && resource.customAvailabilitiesOverridesById[overrideId]) {
      const override = resource.customAvailabilitiesOverridesById[overrideId];
      if (!override.intervals.length && override.minutes === 0) {
        return false;
      } else {
        return true;
      }
    }
  }
  const details = workWeekDetails[dayName];
  if (!details.workDay) {
    return false;
  }
  const isHoliday = Boolean(holidaysMapped[formatDate(dateToCheck, DATE_FORMATS.MONTH_DAY)] || holidaysMapped[formatDate(dateToCheck, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT)]);
  if (isHoliday) {
    return false;
  }
  return true;
};
const calculateEndDate = _ref17 => {
  let {
    startDate,
    noOfDays,
    resource,
    companyWorkWeekDetails,
    holidays: _holidays = []
  } = _ref17;
  var _a, _b;
  let workWeekDetails;
  if (resource === null || resource === void 0 ? void 0 : resource.useResourceAvailability) {
    workWeekDetails = ((_b = (_a = resource.customAvailabilities) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.weekDays) || companyWorkWeekDetails;
  } else {
    workWeekDetails = companyWorkWeekDetails;
  }
  const uniqHolidays = getUniqHolidays(_holidays);
  const holidaysMapped = uniqHolidays.reduce((acc, holiday) => {
    if (holiday.repeat) {
      acc[formatDate(holiday.date, DATE_FORMATS.MONTH_DAY)] = holiday;
    } else {
      acc[formatDate(holiday.date, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT)] = holiday;
    }
    return acc;
  }, {});
  if (noOfDays === 0) {
    const isWorkDay = checkIfWorkDay({
      dateToCheck: startDate,
      workWeekDetails,
      resource,
      holidaysMapped
    });
    return {
      endDate: startDate,
      numberOfWorkDays: isWorkDay ? 1 : 0
    };
  }
  let workDaysLeft = noOfDays;
  let dateToCheck = startDate;
  let temp = 0;
  while (workDaysLeft > 0) {
    dateToCheck = addDays(startDate, temp);
    const isWorkDay = checkIfWorkDay({
      dateToCheck,
      holidaysMapped,
      resource,
      workWeekDetails
    });
    if (!isWorkDay) {
      temp += 1;
      continue;
    }
    workDaysLeft -= 1;
    if (temp > 5000) {
      // To avoid infinite loop
      throw new Error("Not able to find next work day for resource ".concat(resource === null || resource === void 0 ? void 0 : resource._id, ", start: ").concat(startDate, ", noOfDays: ").concat(noOfDays));
    }
    temp += 1;
  }
  return {
    endDate: dateToCheck,
    numberOfWorkDays: noOfDays
  };
};
var lodash = {
  exports: {}
};

/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

(function (module, exports) {
  (function () {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */
    var undefined$1;

    /** Used as the semantic version number. */
    var VERSION = '4.17.21';

    /** Used as the size to enable large array optimizations. */
    var LARGE_ARRAY_SIZE = 200;

    /** Error message constants. */
    var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

    /** Used to stand-in for `undefined` hash values. */
    var HASH_UNDEFINED = '__lodash_hash_undefined__';

    /** Used as the maximum memoize cache size. */
    var MAX_MEMOIZE_SIZE = 500;

    /** Used as the internal argument placeholder. */
    var PLACEHOLDER = '__lodash_placeholder__';

    /** Used to compose bitmasks for cloning. */
    var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

    /** Used to compose bitmasks for function metadata. */
    var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

    /** Used as default options for `_.truncate`. */
    var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

    /** Used to detect hot functions by number of calls within a span of milliseconds. */
    var HOT_COUNT = 800,
      HOT_SPAN = 16;

    /** Used to indicate the type of lazy iteratees. */
    var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

    /** Used as references for various `Number` constants. */
    var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

    /** Used to associate wrap methods with their bit flags. */
    var wrapFlags = [['ary', WRAP_ARY_FLAG], ['bind', WRAP_BIND_FLAG], ['bindKey', WRAP_BIND_KEY_FLAG], ['curry', WRAP_CURRY_FLAG], ['curryRight', WRAP_CURRY_RIGHT_FLAG], ['flip', WRAP_FLIP_FLAG], ['partial', WRAP_PARTIAL_FLAG], ['partialRight', WRAP_PARTIAL_RIGHT_FLAG], ['rearg', WRAP_REARG_FLAG]];

    /** `Object#toString` result references. */
    var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

    /** Used to match empty string literals in compiled template source. */
    var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

    /** Used to match HTML entities and HTML characters. */
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

    /** Used to match template delimiters. */
    var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

    /** Used to match property names within property paths. */
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

    /**
     * Used to match `RegExp`
     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
     */
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

    /** Used to match leading whitespace. */
    var reTrimStart = /^\s+/;

    /** Used to match a single whitespace character. */
    var reWhitespace = /\s/;

    /** Used to match wrap detail comments. */
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

    /** Used to match words composed of alphanumeric characters. */
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

    /**
     * Used to validate the `validate` option in `_.template` variable.
     *
     * Forbids characters which could potentially change the meaning of the function argument definition:
     * - "()," (modification of function parameters)
     * - "=" (default value)
     * - "[]{}" (destructuring of function parameters)
     * - "/" (beginning of a comment)
     * - whitespace
     */
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

    /** Used to match backslashes in property paths. */
    var reEscapeChar = /\\(\\)?/g;

    /**
     * Used to match
     * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
     */
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

    /** Used to match `RegExp` flags from their coerced string values. */
    var reFlags = /\w*$/;

    /** Used to detect bad signed hexadecimal string values. */
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

    /** Used to detect binary string values. */
    var reIsBinary = /^0b[01]+$/i;

    /** Used to detect host constructors (Safari). */
    var reIsHostCtor = /^\[object .+?Constructor\]$/;

    /** Used to detect octal string values. */
    var reIsOctal = /^0o[0-7]+$/i;

    /** Used to detect unsigned integer values. */
    var reIsUint = /^(?:0|[1-9]\d*)$/;

    /** Used to match Latin Unicode letters (excluding mathematical operators). */
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

    /** Used to ensure capturing order of template delimiters. */
    var reNoMatch = /($^)/;

    /** Used to match unescaped characters in compiled string literals. */
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

    /** Used to compose unicode character classes. */
    var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

    /** Used to compose unicode capture groups. */
    var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

    /** Used to compose unicode regexes. */
    var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

    /** Used to match apostrophes. */
    var reApos = RegExp(rsApos, 'g');

    /**
     * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
     * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
     */
    var reComboMark = RegExp(rsCombo, 'g');

    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
    var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

    /** Used to match complex or compound words. */
    var reUnicodeWord = RegExp([rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')', rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower, rsUpper + '+' + rsOptContrUpper, rsOrdUpper, rsOrdLower, rsDigits, rsEmoji].join('|'), 'g');

    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
    var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');

    /** Used to detect strings that need a more robust regexp to match words. */
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

    /** Used to assign default `context` object properties. */
    var contextProps = ['Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array', 'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object', 'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array', 'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap', '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'];

    /** Used to make template sourceURLs easier to identify. */
    var templateCounter = -1;

    /** Used to identify `toStringTag` values of typed arrays. */
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

    /** Used to identify `toStringTag` values supported by `_.clone`. */
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;

    /** Used to map Latin Unicode letters to basic Latin letters. */
    var deburredLetters = {
      // Latin-1 Supplement block.
      '\xc0': 'A',
      '\xc1': 'A',
      '\xc2': 'A',
      '\xc3': 'A',
      '\xc4': 'A',
      '\xc5': 'A',
      '\xe0': 'a',
      '\xe1': 'a',
      '\xe2': 'a',
      '\xe3': 'a',
      '\xe4': 'a',
      '\xe5': 'a',
      '\xc7': 'C',
      '\xe7': 'c',
      '\xd0': 'D',
      '\xf0': 'd',
      '\xc8': 'E',
      '\xc9': 'E',
      '\xca': 'E',
      '\xcb': 'E',
      '\xe8': 'e',
      '\xe9': 'e',
      '\xea': 'e',
      '\xeb': 'e',
      '\xcc': 'I',
      '\xcd': 'I',
      '\xce': 'I',
      '\xcf': 'I',
      '\xec': 'i',
      '\xed': 'i',
      '\xee': 'i',
      '\xef': 'i',
      '\xd1': 'N',
      '\xf1': 'n',
      '\xd2': 'O',
      '\xd3': 'O',
      '\xd4': 'O',
      '\xd5': 'O',
      '\xd6': 'O',
      '\xd8': 'O',
      '\xf2': 'o',
      '\xf3': 'o',
      '\xf4': 'o',
      '\xf5': 'o',
      '\xf6': 'o',
      '\xf8': 'o',
      '\xd9': 'U',
      '\xda': 'U',
      '\xdb': 'U',
      '\xdc': 'U',
      '\xf9': 'u',
      '\xfa': 'u',
      '\xfb': 'u',
      '\xfc': 'u',
      '\xdd': 'Y',
      '\xfd': 'y',
      '\xff': 'y',
      '\xc6': 'Ae',
      '\xe6': 'ae',
      '\xde': 'Th',
      '\xfe': 'th',
      '\xdf': 'ss',
      // Latin Extended-A block.
      '\u0100': 'A',
      '\u0102': 'A',
      '\u0104': 'A',
      '\u0101': 'a',
      '\u0103': 'a',
      '\u0105': 'a',
      '\u0106': 'C',
      '\u0108': 'C',
      '\u010a': 'C',
      '\u010c': 'C',
      '\u0107': 'c',
      '\u0109': 'c',
      '\u010b': 'c',
      '\u010d': 'c',
      '\u010e': 'D',
      '\u0110': 'D',
      '\u010f': 'd',
      '\u0111': 'd',
      '\u0112': 'E',
      '\u0114': 'E',
      '\u0116': 'E',
      '\u0118': 'E',
      '\u011a': 'E',
      '\u0113': 'e',
      '\u0115': 'e',
      '\u0117': 'e',
      '\u0119': 'e',
      '\u011b': 'e',
      '\u011c': 'G',
      '\u011e': 'G',
      '\u0120': 'G',
      '\u0122': 'G',
      '\u011d': 'g',
      '\u011f': 'g',
      '\u0121': 'g',
      '\u0123': 'g',
      '\u0124': 'H',
      '\u0126': 'H',
      '\u0125': 'h',
      '\u0127': 'h',
      '\u0128': 'I',
      '\u012a': 'I',
      '\u012c': 'I',
      '\u012e': 'I',
      '\u0130': 'I',
      '\u0129': 'i',
      '\u012b': 'i',
      '\u012d': 'i',
      '\u012f': 'i',
      '\u0131': 'i',
      '\u0134': 'J',
      '\u0135': 'j',
      '\u0136': 'K',
      '\u0137': 'k',
      '\u0138': 'k',
      '\u0139': 'L',
      '\u013b': 'L',
      '\u013d': 'L',
      '\u013f': 'L',
      '\u0141': 'L',
      '\u013a': 'l',
      '\u013c': 'l',
      '\u013e': 'l',
      '\u0140': 'l',
      '\u0142': 'l',
      '\u0143': 'N',
      '\u0145': 'N',
      '\u0147': 'N',
      '\u014a': 'N',
      '\u0144': 'n',
      '\u0146': 'n',
      '\u0148': 'n',
      '\u014b': 'n',
      '\u014c': 'O',
      '\u014e': 'O',
      '\u0150': 'O',
      '\u014d': 'o',
      '\u014f': 'o',
      '\u0151': 'o',
      '\u0154': 'R',
      '\u0156': 'R',
      '\u0158': 'R',
      '\u0155': 'r',
      '\u0157': 'r',
      '\u0159': 'r',
      '\u015a': 'S',
      '\u015c': 'S',
      '\u015e': 'S',
      '\u0160': 'S',
      '\u015b': 's',
      '\u015d': 's',
      '\u015f': 's',
      '\u0161': 's',
      '\u0162': 'T',
      '\u0164': 'T',
      '\u0166': 'T',
      '\u0163': 't',
      '\u0165': 't',
      '\u0167': 't',
      '\u0168': 'U',
      '\u016a': 'U',
      '\u016c': 'U',
      '\u016e': 'U',
      '\u0170': 'U',
      '\u0172': 'U',
      '\u0169': 'u',
      '\u016b': 'u',
      '\u016d': 'u',
      '\u016f': 'u',
      '\u0171': 'u',
      '\u0173': 'u',
      '\u0174': 'W',
      '\u0175': 'w',
      '\u0176': 'Y',
      '\u0177': 'y',
      '\u0178': 'Y',
      '\u0179': 'Z',
      '\u017b': 'Z',
      '\u017d': 'Z',
      '\u017a': 'z',
      '\u017c': 'z',
      '\u017e': 'z',
      '\u0132': 'IJ',
      '\u0133': 'ij',
      '\u0152': 'Oe',
      '\u0153': 'oe',
      '\u0149': "'n",
      '\u017f': 's'
    };

    /** Used to map characters to HTML entities. */
    var htmlEscapes = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    };

    /** Used to map HTML entities to characters. */
    var htmlUnescapes = {
      '&amp;': '&',
      '&lt;': '<',
      '&gt;': '>',
      '&quot;': '"',
      '&#39;': "'"
    };

    /** Used to escape characters for inclusion in compiled string literals. */
    var stringEscapes = {
      '\\': '\\',
      "'": "'",
      '\n': 'n',
      '\r': 'r',
      '\u2028': 'u2028',
      '\u2029': 'u2029'
    };

    /** Built-in method references without a dependency on `root`. */
    var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

    /** Detect free variable `global` from Node.js. */
    var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

    /** Detect free variable `self`. */
    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

    /** Used as a reference to the global object. */
    var root = freeGlobal || freeSelf || Function('return this')();

    /** Detect free variable `exports`. */
    var freeExports = exports && !exports.nodeType && exports;

    /** Detect free variable `module`. */
    var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports;

    /** Detect free variable `process` from Node.js. */
    var freeProcess = moduleExports && freeGlobal.process;

    /** Used to access faster Node.js helpers. */
    var nodeUtil = function () {
      try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) {
          return types;
        }

        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
      } catch (e) {}
    }();

    /* Node.js helper references. */
    var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

    /*--------------------------------------------------------------------------*/

    /**
     * A faster alternative to `Function#apply`, this function invokes `func`
     * with the `this` binding of `thisArg` and the arguments of `args`.
     *
     * @private
     * @param {Function} func The function to invoke.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} args The arguments to invoke `func` with.
     * @returns {*} Returns the result of `func`.
     */
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }

    /**
     * A specialized version of `baseAggregator` for arrays.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function arrayAggregator(array, setter, iteratee, accumulator) {
      var index = -1,
        length = array == null ? 0 : array.length;
      while (++index < length) {
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.forEach` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
      var index = -1,
        length = array == null ? 0 : array.length;
      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEachRight(array, iteratee) {
      var length = array == null ? 0 : array.length;
      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.every` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */
    function arrayEvery(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length;
      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `_.filter` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.includes` for arrays without support for
     * specifying an index to search from.
     *
     * @private
     * @param {Array} [array] The array to inspect.
     * @param {*} target The value to search for.
     * @returns {boolean} Returns `true` if `target` is found, else `false`.
     */
    function arrayIncludes(array, value) {
      var length = array == null ? 0 : array.length;
      return !!length && baseIndexOf(array, value, 0) > -1;
    }

    /**
     * This function is like `arrayIncludes` except that it accepts a comparator.
     *
     * @private
     * @param {Array} [array] The array to inspect.
     * @param {*} target The value to search for.
     * @param {Function} comparator The comparator invoked per element.
     * @returns {boolean} Returns `true` if `target` is found, else `false`.
     */
    function arrayIncludesWith(array, value, comparator) {
      var index = -1,
        length = array == null ? 0 : array.length;
      while (++index < length) {
        if (comparator(value, array[index])) {
          return true;
        }
      }
      return false;
    }

    /**
     * A specialized version of `_.map` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);
      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }

    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
        length = values.length,
        offset = array.length;
      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.reduce` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initAccum] Specify using the first element of `array` as
     *  the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduce(array, iteratee, accumulator, initAccum) {
      var index = -1,
        length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initAccum] Specify using the last element of `array` as
     *  the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduceRight(array, iteratee, accumulator, initAccum) {
      var length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.some` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length;
      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }

    /**
     * Gets the size of an ASCII `string`.
     *
     * @private
     * @param {string} string The string inspect.
     * @returns {number} Returns the string size.
     */
    var asciiSize = baseProperty('length');

    /**
     * Converts an ASCII `string` to an array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the converted array.
     */
    function asciiToArray(string) {
      return string.split('');
    }

    /**
     * Splits an ASCII `string` into an array of its words.
     *
     * @private
     * @param {string} The string to inspect.
     * @returns {Array} Returns the words of `string`.
     */
    function asciiWords(string) {
      return string.match(reAsciiWord) || [];
    }

    /**
     * The base implementation of methods like `_.findKey` and `_.findLastKey`,
     * without support for iteratee shorthands, which iterates over `collection`
     * using `eachFunc`.
     *
     * @private
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */
    function baseFindKey(collection, predicate, eachFunc) {
      var result;
      eachFunc(collection, function (value, key, collection) {
        if (predicate(value, key, collection)) {
          result = key;
          return false;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.findIndex` and `_.findLastIndex` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} predicate The function invoked per iteration.
     * @param {number} fromIndex The index to search from.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index-- : ++index < length) {
        if (predicate(array[index], index, array)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function baseIndexOf(array, value, fromIndex) {
      return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }

    /**
     * This function is like `baseIndexOf` except that it accepts a comparator.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @param {Function} comparator The comparator invoked per element.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function baseIndexOfWith(array, value, fromIndex, comparator) {
      var index = fromIndex - 1,
        length = array.length;
      while (++index < length) {
        if (comparator(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * The base implementation of `_.isNaN` without support for number objects.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     */
    function baseIsNaN(value) {
      return value !== value;
    }

    /**
     * The base implementation of `_.mean` and `_.meanBy` without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the mean.
     */
    function baseMean(array, iteratee) {
      var length = array == null ? 0 : array.length;
      return length ? baseSum(array, iteratee) / length : NAN;
    }

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function baseProperty(key) {
      return function (object) {
        return object == null ? undefined$1 : object[key];
      };
    }

    /**
     * The base implementation of `_.propertyOf` without support for deep paths.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyOf(object) {
      return function (key) {
        return object == null ? undefined$1 : object[key];
      };
    }

    /**
     * The base implementation of `_.reduce` and `_.reduceRight`, without support
     * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initAccum Specify using the first or last element of
     *  `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */
    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
      eachFunc(collection, function (value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.sortBy` which uses `comparer` to define the
     * sort order of `array` and replaces criteria objects with their corresponding
     * values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */
    function baseSortBy(array, comparer) {
      var length = array.length;
      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }

    /**
     * The base implementation of `_.sum` and `_.sumBy` without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function baseSum(array, iteratee) {
      var result,
        index = -1,
        length = array.length;
      while (++index < length) {
        var current = iteratee(array[index]);
        if (current !== undefined$1) {
          result = result === undefined$1 ? current : result + current;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.times` without support for iteratee shorthands
     * or max array length checks.
     *
     * @private
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     */
    function baseTimes(n, iteratee) {
      var index = -1,
        result = Array(n);
      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }

    /**
     * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
     * of key-value pairs for `object` corresponding to the property names of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the key-value pairs.
     */
    function baseToPairs(object, props) {
      return arrayMap(props, function (key) {
        return [key, object[key]];
      });
    }

    /**
     * The base implementation of `_.trim`.
     *
     * @private
     * @param {string} string The string to trim.
     * @returns {string} Returns the trimmed string.
     */
    function baseTrim(string) {
      return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }

    /**
     * The base implementation of `_.unary` without support for storing metadata.
     *
     * @private
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     */
    function baseUnary(func) {
      return function (value) {
        return func(value);
      };
    }

    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
      return arrayMap(props, function (key) {
        return object[key];
      });
    }

    /**
     * Checks if a `cache` value for `key` exists.
     *
     * @private
     * @param {Object} cache The cache to query.
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function cacheHas(cache, key) {
      return cache.has(key);
    }

    /**
     * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
     * that is not found in the character symbols.
     *
     * @private
     * @param {Array} strSymbols The string symbols to inspect.
     * @param {Array} chrSymbols The character symbols to find.
     * @returns {number} Returns the index of the first unmatched string symbol.
     */
    function charsStartIndex(strSymbols, chrSymbols) {
      var index = -1,
        length = strSymbols.length;
      while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
      return index;
    }

    /**
     * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
     * that is not found in the character symbols.
     *
     * @private
     * @param {Array} strSymbols The string symbols to inspect.
     * @param {Array} chrSymbols The character symbols to find.
     * @returns {number} Returns the index of the last unmatched string symbol.
     */
    function charsEndIndex(strSymbols, chrSymbols) {
      var index = strSymbols.length;
      while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
      return index;
    }

    /**
     * Gets the number of `placeholder` occurrences in `array`.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} placeholder The placeholder to search for.
     * @returns {number} Returns the placeholder count.
     */
    function countHolders(array, placeholder) {
      var length = array.length,
        result = 0;
      while (length--) {
        if (array[length] === placeholder) {
          ++result;
        }
      }
      return result;
    }

    /**
     * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
     * letters to basic Latin letters.
     *
     * @private
     * @param {string} letter The matched letter to deburr.
     * @returns {string} Returns the deburred letter.
     */
    var deburrLetter = basePropertyOf(deburredLetters);

    /**
     * Used by `_.escape` to convert characters to HTML entities.
     *
     * @private
     * @param {string} chr The matched character to escape.
     * @returns {string} Returns the escaped character.
     */
    var escapeHtmlChar = basePropertyOf(htmlEscapes);

    /**
     * Used by `_.template` to escape characters for inclusion in compiled string literals.
     *
     * @private
     * @param {string} chr The matched character to escape.
     * @returns {string} Returns the escaped character.
     */
    function escapeStringChar(chr) {
      return '\\' + stringEscapes[chr];
    }

    /**
     * Gets the value at `key` of `object`.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function getValue(object, key) {
      return object == null ? undefined$1 : object[key];
    }

    /**
     * Checks if `string` contains Unicode symbols.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {boolean} Returns `true` if a symbol is found, else `false`.
     */
    function hasUnicode(string) {
      return reHasUnicode.test(string);
    }

    /**
     * Checks if `string` contains a word composed of Unicode symbols.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {boolean} Returns `true` if a word is found, else `false`.
     */
    function hasUnicodeWord(string) {
      return reHasUnicodeWord.test(string);
    }

    /**
     * Converts `iterator` to an array.
     *
     * @private
     * @param {Object} iterator The iterator to convert.
     * @returns {Array} Returns the converted array.
     */
    function iteratorToArray(iterator) {
      var data,
        result = [];
      while (!(data = iterator.next()).done) {
        result.push(data.value);
      }
      return result;
    }

    /**
     * Converts `map` to its key-value pairs.
     *
     * @private
     * @param {Object} map The map to convert.
     * @returns {Array} Returns the key-value pairs.
     */
    function mapToArray(map) {
      var index = -1,
        result = Array(map.size);
      map.forEach(function (value, key) {
        result[++index] = [key, value];
      });
      return result;
    }

    /**
     * Creates a unary function that invokes `func` with its argument transformed.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {Function} transform The argument transform.
     * @returns {Function} Returns the new function.
     */
    function overArg(func, transform) {
      return function (arg) {
        return func(transform(arg));
      };
    }

    /**
     * Replaces all `placeholder` elements in `array` with an internal placeholder
     * and returns an array of their indexes.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {*} placeholder The placeholder to replace.
     * @returns {Array} Returns the new array of placeholder indexes.
     */
    function replaceHolders(array, placeholder) {
      var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];
      while (++index < length) {
        var value = array[index];
        if (value === placeholder || value === PLACEHOLDER) {
          array[index] = PLACEHOLDER;
          result[resIndex++] = index;
        }
      }
      return result;
    }

    /**
     * Converts `set` to an array of its values.
     *
     * @private
     * @param {Object} set The set to convert.
     * @returns {Array} Returns the values.
     */
    function setToArray(set) {
      var index = -1,
        result = Array(set.size);
      set.forEach(function (value) {
        result[++index] = value;
      });
      return result;
    }

    /**
     * Converts `set` to its value-value pairs.
     *
     * @private
     * @param {Object} set The set to convert.
     * @returns {Array} Returns the value-value pairs.
     */
    function setToPairs(set) {
      var index = -1,
        result = Array(set.size);
      set.forEach(function (value) {
        result[++index] = [value, value];
      });
      return result;
    }

    /**
     * A specialized version of `_.indexOf` which performs strict equality
     * comparisons of values, i.e. `===`.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function strictIndexOf(array, value, fromIndex) {
      var index = fromIndex - 1,
        length = array.length;
      while (++index < length) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }

    /**
     * A specialized version of `_.lastIndexOf` which performs strict equality
     * comparisons of values, i.e. `===`.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function strictLastIndexOf(array, value, fromIndex) {
      var index = fromIndex + 1;
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return index;
    }

    /**
     * Gets the number of symbols in `string`.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {number} Returns the string size.
     */
    function stringSize(string) {
      return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }

    /**
     * Converts `string` to an array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the converted array.
     */
    function stringToArray(string) {
      return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }

    /**
     * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
     * character of `string`.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {number} Returns the index of the last non-whitespace character.
     */
    function trimmedEndIndex(string) {
      var index = string.length;
      while (index-- && reWhitespace.test(string.charAt(index))) {}
      return index;
    }

    /**
     * Used by `_.unescape` to convert HTML entities to characters.
     *
     * @private
     * @param {string} chr The matched character to unescape.
     * @returns {string} Returns the unescaped character.
     */
    var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

    /**
     * Gets the size of a Unicode `string`.
     *
     * @private
     * @param {string} string The string inspect.
     * @returns {number} Returns the string size.
     */
    function unicodeSize(string) {
      var result = reUnicode.lastIndex = 0;
      while (reUnicode.test(string)) {
        ++result;
      }
      return result;
    }

    /**
     * Converts a Unicode `string` to an array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the converted array.
     */
    function unicodeToArray(string) {
      return string.match(reUnicode) || [];
    }

    /**
     * Splits a Unicode `string` into an array of its words.
     *
     * @private
     * @param {string} The string to inspect.
     * @returns {Array} Returns the words of `string`.
     */
    function unicodeWords(string) {
      return string.match(reUnicodeWord) || [];
    }

    /*--------------------------------------------------------------------------*/

    /**
     * Create a new pristine `lodash` function using the `context` object.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Util
     * @param {Object} [context=root] The context object.
     * @returns {Function} Returns a new `lodash` function.
     * @example
     *
     * _.mixin({ 'foo': _.constant('foo') });
     *
     * var lodash = _.runInContext();
     * lodash.mixin({ 'bar': lodash.constant('bar') });
     *
     * _.isFunction(_.foo);
     * // => true
     * _.isFunction(_.bar);
     * // => false
     *
     * lodash.isFunction(lodash.foo);
     * // => false
     * lodash.isFunction(lodash.bar);
     * // => true
     *
     * // Create a suped-up `defer` in Node.js.
     * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
     */
    var runInContext = function runInContext(context) {
      context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

      /** Built-in constructor references. */
      var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

      /** Used for built-in method references. */
      var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

      /** Used to detect overreaching core-js shims. */
      var coreJsData = context['__core-js_shared__'];

      /** Used to resolve the decompiled source of functions. */
      var funcToString = funcProto.toString;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /** Used to generate unique IDs. */
      var idCounter = 0;

      /** Used to detect methods masquerading as native. */
      var maskSrcKey = function () {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
        return uid ? 'Symbol(src)_1.' + uid : '';
      }();

      /**
       * Used to resolve the
       * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
       * of values.
       */
      var nativeObjectToString = objectProto.toString;

      /** Used to infer the `Object` constructor. */
      var objectCtorString = funcToString.call(Object);

      /** Used to restore the original `_` reference in `_.noConflict`. */
      var oldDash = root._;

      /** Used to detect if a method is native. */
      var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

      /** Built-in value references. */
      var Buffer = moduleExports ? context.Buffer : undefined$1,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined$1,
        symIterator = Symbol ? Symbol.iterator : undefined$1,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined$1;
      var defineProperty = function () {
        try {
          var func = getNative(Object, 'defineProperty');
          func({}, '', {});
          return func;
        } catch (e) {}
      }();

      /** Mocked built-ins. */
      var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

      /* Built-in method references that are verified to be native. */
      var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

      /** Used to store function metadata. */
      var metaMap = WeakMap && new WeakMap();

      /** Used to lookup unminified function names. */
      var realNames = {};

      /** Used to detect maps, sets, and weakmaps. */
      var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

      /** Used to convert symbols to primitives and strings. */
      var symbolProto = Symbol ? Symbol.prototype : undefined$1,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1,
        symbolToString = symbolProto ? symbolProto.toString : undefined$1;

      /*------------------------------------------------------------------------*/

      /**
       * Creates a `lodash` object which wraps `value` to enable implicit method
       * chain sequences. Methods that operate on and return arrays, collections,
       * and functions can be chained together. Methods that retrieve a single value
       * or may return a primitive value will automatically end the chain sequence
       * and return the unwrapped value. Otherwise, the value must be unwrapped
       * with `_#value`.
       *
       * Explicit chain sequences, which must be unwrapped with `_#value`, may be
       * enabled using `_.chain`.
       *
       * The execution of chained methods is lazy, that is, it's deferred until
       * `_#value` is implicitly or explicitly called.
       *
       * Lazy evaluation allows several methods to support shortcut fusion.
       * Shortcut fusion is an optimization to merge iteratee calls; this avoids
       * the creation of intermediate arrays and can greatly reduce the number of
       * iteratee executions. Sections of a chain sequence qualify for shortcut
       * fusion if the section is applied to an array and iteratees accept only
       * one argument. The heuristic for whether a section qualifies for shortcut
       * fusion is subject to change.
       *
       * Chaining is supported in custom builds as long as the `_#value` method is
       * directly or indirectly included in the build.
       *
       * In addition to lodash methods, wrappers have `Array` and `String` methods.
       *
       * The wrapper `Array` methods are:
       * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
       *
       * The wrapper `String` methods are:
       * `replace` and `split`
       *
       * The wrapper methods that support shortcut fusion are:
       * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
       * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
       * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
       *
       * The chainable wrapper methods are:
       * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
       * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
       * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
       * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
       * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
       * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
       * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
       * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
       * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
       * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
       * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
       * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
       * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
       * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
       * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
       * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
       * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
       * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
       * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
       * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
       * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
       * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
       * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
       * `zipObject`, `zipObjectDeep`, and `zipWith`
       *
       * The wrapper methods that are **not** chainable by default are:
       * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
       * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
       * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
       * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
       * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
       * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
       * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
       * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
       * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
       * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
       * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
       * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
       * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
       * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
       * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
       * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
       * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
       * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
       * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
       * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
       * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
       * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
       * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
       * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
       * `upperFirst`, `value`, and `words`
       *
       * @name _
       * @constructor
       * @category Seq
       * @param {*} value The value to wrap in a `lodash` instance.
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * function square(n) {
       *   return n * n;
       * }
       *
       * var wrapped = _([1, 2, 3]);
       *
       * // Returns an unwrapped value.
       * wrapped.reduce(_.add);
       * // => 6
       *
       * // Returns a wrapped value.
       * var squares = wrapped.map(square);
       *
       * _.isArray(squares);
       * // => false
       *
       * _.isArray(squares.value());
       * // => true
       */
      function lodash(value) {
        if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
          if (value instanceof LodashWrapper) {
            return value;
          }
          if (hasOwnProperty.call(value, '__wrapped__')) {
            return wrapperClone(value);
          }
        }
        return new LodashWrapper(value);
      }

      /**
       * The base implementation of `_.create` without support for assigning
       * properties to the created object.
       *
       * @private
       * @param {Object} proto The object to inherit from.
       * @returns {Object} Returns the new object.
       */
      var baseCreate = function () {
        function object() {}
        return function (proto) {
          if (!isObject(proto)) {
            return {};
          }
          if (objectCreate) {
            return objectCreate(proto);
          }
          object.prototype = proto;
          var result = new object();
          object.prototype = undefined$1;
          return result;
        };
      }();

      /**
       * The function whose prototype chain sequence wrappers inherit from.
       *
       * @private
       */
      function baseLodash() {
        // No operation performed.
      }

      /**
       * The base constructor for creating `lodash` wrapper objects.
       *
       * @private
       * @param {*} value The value to wrap.
       * @param {boolean} [chainAll] Enable explicit method chain sequences.
       */
      function LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$1;
      }

      /**
       * By default, the template delimiters used by lodash are like those in
       * embedded Ruby (ERB) as well as ES2015 template strings. Change the
       * following template settings to use alternative delimiters.
       *
       * @static
       * @memberOf _
       * @type {Object}
       */
      lodash.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        'escape': reEscape,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        'evaluate': reEvaluate,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        'interpolate': reInterpolate,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        'variable': '',
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        'imports': {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          '_': lodash
        }
      };

      // Ensure wrappers are instances of `baseLodash`.
      lodash.prototype = baseLodash.prototype;
      lodash.prototype.constructor = lodash;
      LodashWrapper.prototype = baseCreate(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;

      /*------------------------------------------------------------------------*/

      /**
       * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
       *
       * @private
       * @constructor
       * @param {*} value The value to wrap.
       */
      function LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH;
        this.__views__ = [];
      }

      /**
       * Creates a clone of the lazy wrapper object.
       *
       * @private
       * @name clone
       * @memberOf LazyWrapper
       * @returns {Object} Returns the cloned `LazyWrapper` object.
       */
      function lazyClone() {
        var result = new LazyWrapper(this.__wrapped__);
        result.__actions__ = copyArray(this.__actions__);
        result.__dir__ = this.__dir__;
        result.__filtered__ = this.__filtered__;
        result.__iteratees__ = copyArray(this.__iteratees__);
        result.__takeCount__ = this.__takeCount__;
        result.__views__ = copyArray(this.__views__);
        return result;
      }

      /**
       * Reverses the direction of lazy iteration.
       *
       * @private
       * @name reverse
       * @memberOf LazyWrapper
       * @returns {Object} Returns the new reversed `LazyWrapper` object.
       */
      function lazyReverse() {
        if (this.__filtered__) {
          var result = new LazyWrapper(this);
          result.__dir__ = -1;
          result.__filtered__ = true;
        } else {
          result = this.clone();
          result.__dir__ *= -1;
        }
        return result;
      }

      /**
       * Extracts the unwrapped value from its lazy wrapper.
       *
       * @private
       * @name value
       * @memberOf LazyWrapper
       * @returns {*} Returns the unwrapped value.
       */
      function lazyValue() {
        var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : start - 1,
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);
        if (!isArr || !isRight && arrLength == length && takeCount == length) {
          return baseWrapperValue(array, this.__actions__);
        }
        var result = [];
        outer: while (length-- && resIndex < takeCount) {
          index += dir;
          var iterIndex = -1,
            value = array[index];
          while (++iterIndex < iterLength) {
            var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);
            if (type == LAZY_MAP_FLAG) {
              value = computed;
            } else if (!computed) {
              if (type == LAZY_FILTER_FLAG) {
                continue outer;
              } else {
                break outer;
              }
            }
          }
          result[resIndex++] = value;
        }
        return result;
      }

      // Ensure `LazyWrapper` is an instance of `baseLodash`.
      LazyWrapper.prototype = baseCreate(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;

      /*------------------------------------------------------------------------*/

      /**
       * Creates a hash object.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */
      function Hash(entries) {
        var index = -1,
          length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }

      /**
       * Removes all key-value entries from the hash.
       *
       * @private
       * @name clear
       * @memberOf Hash
       */
      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }

      /**
       * Removes `key` and its value from the hash.
       *
       * @private
       * @name delete
       * @memberOf Hash
       * @param {Object} hash The hash to modify.
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */
      function hashDelete(key) {
        var result = this.has(key) && delete this.__data__[key];
        this.size -= result ? 1 : 0;
        return result;
      }

      /**
       * Gets the hash value for `key`.
       *
       * @private
       * @name get
       * @memberOf Hash
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */
      function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
          var result = data[key];
          return result === HASH_UNDEFINED ? undefined$1 : result;
        }
        return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
      }

      /**
       * Checks if a hash value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf Hash
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined$1 : hasOwnProperty.call(data, key);
      }

      /**
       * Sets the hash `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf Hash
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the hash instance.
       */
      function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === undefined$1 ? HASH_UNDEFINED : value;
        return this;
      }

      // Add methods to `Hash`.
      Hash.prototype.clear = hashClear;
      Hash.prototype['delete'] = hashDelete;
      Hash.prototype.get = hashGet;
      Hash.prototype.has = hashHas;
      Hash.prototype.set = hashSet;

      /*------------------------------------------------------------------------*/

      /**
       * Creates an list cache object.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */
      function ListCache(entries) {
        var index = -1,
          length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }

      /**
       * Removes all key-value entries from the list cache.
       *
       * @private
       * @name clear
       * @memberOf ListCache
       */
      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }

      /**
       * Removes `key` and its value from the list cache.
       *
       * @private
       * @name delete
       * @memberOf ListCache
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */
      function listCacheDelete(key) {
        var data = this.__data__,
          index = assocIndexOf(data, key);
        if (index < 0) {
          return false;
        }
        var lastIndex = data.length - 1;
        if (index == lastIndex) {
          data.pop();
        } else {
          splice.call(data, index, 1);
        }
        --this.size;
        return true;
      }

      /**
       * Gets the list cache value for `key`.
       *
       * @private
       * @name get
       * @memberOf ListCache
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */
      function listCacheGet(key) {
        var data = this.__data__,
          index = assocIndexOf(data, key);
        return index < 0 ? undefined$1 : data[index][1];
      }

      /**
       * Checks if a list cache value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf ListCache
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }

      /**
       * Sets the list cache `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf ListCache
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the list cache instance.
       */
      function listCacheSet(key, value) {
        var data = this.__data__,
          index = assocIndexOf(data, key);
        if (index < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index][1] = value;
        }
        return this;
      }

      // Add methods to `ListCache`.
      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype['delete'] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;

      /*------------------------------------------------------------------------*/

      /**
       * Creates a map cache object to store key-value pairs.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */
      function MapCache(entries) {
        var index = -1,
          length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }

      /**
       * Removes all key-value entries from the map.
       *
       * @private
       * @name clear
       * @memberOf MapCache
       */
      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          'hash': new Hash(),
          'map': new (Map || ListCache)(),
          'string': new Hash()
        };
      }

      /**
       * Removes `key` and its value from the map.
       *
       * @private
       * @name delete
       * @memberOf MapCache
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */
      function mapCacheDelete(key) {
        var result = getMapData(this, key)['delete'](key);
        this.size -= result ? 1 : 0;
        return result;
      }

      /**
       * Gets the map value for `key`.
       *
       * @private
       * @name get
       * @memberOf MapCache
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */
      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }

      /**
       * Checks if a map value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf MapCache
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }

      /**
       * Sets the map `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf MapCache
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the map cache instance.
       */
      function mapCacheSet(key, value) {
        var data = getMapData(this, key),
          size = data.size;
        data.set(key, value);
        this.size += data.size == size ? 0 : 1;
        return this;
      }

      // Add methods to `MapCache`.
      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype['delete'] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;

      /*------------------------------------------------------------------------*/

      /**
       *
       * Creates an array cache object to store unique values.
       *
       * @private
       * @constructor
       * @param {Array} [values] The values to cache.
       */
      function SetCache(values) {
        var index = -1,
          length = values == null ? 0 : values.length;
        this.__data__ = new MapCache();
        while (++index < length) {
          this.add(values[index]);
        }
      }

      /**
       * Adds `value` to the array cache.
       *
       * @private
       * @name add
       * @memberOf SetCache
       * @alias push
       * @param {*} value The value to cache.
       * @returns {Object} Returns the cache instance.
       */
      function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);
        return this;
      }

      /**
       * Checks if `value` is in the array cache.
       *
       * @private
       * @name has
       * @memberOf SetCache
       * @param {*} value The value to search for.
       * @returns {number} Returns `true` if `value` is found, else `false`.
       */
      function setCacheHas(value) {
        return this.__data__.has(value);
      }

      // Add methods to `SetCache`.
      SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
      SetCache.prototype.has = setCacheHas;

      /*------------------------------------------------------------------------*/

      /**
       * Creates a stack cache object to store key-value pairs.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */
      function Stack(entries) {
        var data = this.__data__ = new ListCache(entries);
        this.size = data.size;
      }

      /**
       * Removes all key-value entries from the stack.
       *
       * @private
       * @name clear
       * @memberOf Stack
       */
      function stackClear() {
        this.__data__ = new ListCache();
        this.size = 0;
      }

      /**
       * Removes `key` and its value from the stack.
       *
       * @private
       * @name delete
       * @memberOf Stack
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */
      function stackDelete(key) {
        var data = this.__data__,
          result = data['delete'](key);
        this.size = data.size;
        return result;
      }

      /**
       * Gets the stack value for `key`.
       *
       * @private
       * @name get
       * @memberOf Stack
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */
      function stackGet(key) {
        return this.__data__.get(key);
      }

      /**
       * Checks if a stack value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf Stack
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function stackHas(key) {
        return this.__data__.has(key);
      }

      /**
       * Sets the stack `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf Stack
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the stack cache instance.
       */
      function stackSet(key, value) {
        var data = this.__data__;
        if (data instanceof ListCache) {
          var pairs = data.__data__;
          if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }
          data = this.__data__ = new MapCache(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
      }

      // Add methods to `Stack`.
      Stack.prototype.clear = stackClear;
      Stack.prototype['delete'] = stackDelete;
      Stack.prototype.get = stackGet;
      Stack.prototype.has = stackHas;
      Stack.prototype.set = stackSet;

      /*------------------------------------------------------------------------*/

      /**
       * Creates an array of the enumerable property names of the array-like `value`.
       *
       * @private
       * @param {*} value The value to query.
       * @param {boolean} inherited Specify returning inherited property names.
       * @returns {Array} Returns the array of property names.
       */
      function arrayLikeKeys(value, inherited) {
        var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;
        for (var key in value) {
          if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
          // Safari 9 has enumerable `arguments.length` in strict mode.
          key == 'length' ||
          // Node.js 0.10 has enumerable non-index properties on buffers.
          isBuff && (key == 'offset' || key == 'parent') ||
          // PhantomJS 2 has enumerable non-index properties on typed arrays.
          isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
          // Skip index properties.
          isIndex(key, length)))) {
            result.push(key);
          }
        }
        return result;
      }

      /**
       * A specialized version of `_.sample` for arrays.
       *
       * @private
       * @param {Array} array The array to sample.
       * @returns {*} Returns the random element.
       */
      function arraySample(array) {
        var length = array.length;
        return length ? array[baseRandom(0, length - 1)] : undefined$1;
      }

      /**
       * A specialized version of `_.sampleSize` for arrays.
       *
       * @private
       * @param {Array} array The array to sample.
       * @param {number} n The number of elements to sample.
       * @returns {Array} Returns the random elements.
       */
      function arraySampleSize(array, n) {
        return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
      }

      /**
       * A specialized version of `_.shuffle` for arrays.
       *
       * @private
       * @param {Array} array The array to shuffle.
       * @returns {Array} Returns the new shuffled array.
       */
      function arrayShuffle(array) {
        return shuffleSelf(copyArray(array));
      }

      /**
       * This function is like `assignValue` except that it doesn't assign
       * `undefined` values.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {string} key The key of the property to assign.
       * @param {*} value The value to assign.
       */
      function assignMergeValue(object, key, value) {
        if (value !== undefined$1 && !eq(object[key], value) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }

      /**
       * Assigns `value` to `key` of `object` if the existing value is not equivalent
       * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {string} key The key of the property to assign.
       * @param {*} value The value to assign.
       */
      function assignValue(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }

      /**
       * Gets the index at which the `key` is found in `array` of key-value pairs.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} key The key to search for.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */
      function assocIndexOf(array, key) {
        var length = array.length;
        while (length--) {
          if (eq(array[length][0], key)) {
            return length;
          }
        }
        return -1;
      }

      /**
       * Aggregates elements of `collection` on `accumulator` with keys transformed
       * by `iteratee` and values set by `setter`.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} setter The function to set `accumulator` values.
       * @param {Function} iteratee The iteratee to transform keys.
       * @param {Object} accumulator The initial aggregated object.
       * @returns {Function} Returns `accumulator`.
       */
      function baseAggregator(collection, setter, iteratee, accumulator) {
        baseEach(collection, function (value, key, collection) {
          setter(accumulator, value, iteratee(value), collection);
        });
        return accumulator;
      }

      /**
       * The base implementation of `_.assign` without support for multiple sources
       * or `customizer` functions.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @returns {Object} Returns `object`.
       */
      function baseAssign(object, source) {
        return object && copyObject(source, keys(source), object);
      }

      /**
       * The base implementation of `_.assignIn` without support for multiple sources
       * or `customizer` functions.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @returns {Object} Returns `object`.
       */
      function baseAssignIn(object, source) {
        return object && copyObject(source, keysIn(source), object);
      }

      /**
       * The base implementation of `assignValue` and `assignMergeValue` without
       * value checks.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {string} key The key of the property to assign.
       * @param {*} value The value to assign.
       */
      function baseAssignValue(object, key, value) {
        if (key == '__proto__' && defineProperty) {
          defineProperty(object, key, {
            'configurable': true,
            'enumerable': true,
            'value': value,
            'writable': true
          });
        } else {
          object[key] = value;
        }
      }

      /**
       * The base implementation of `_.at` without support for individual paths.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {string[]} paths The property paths to pick.
       * @returns {Array} Returns the picked elements.
       */
      function baseAt(object, paths) {
        var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;
        while (++index < length) {
          result[index] = skip ? undefined$1 : get(object, paths[index]);
        }
        return result;
      }

      /**
       * The base implementation of `_.clamp` which doesn't coerce arguments.
       *
       * @private
       * @param {number} number The number to clamp.
       * @param {number} [lower] The lower bound.
       * @param {number} upper The upper bound.
       * @returns {number} Returns the clamped number.
       */
      function baseClamp(number, lower, upper) {
        if (number === number) {
          if (upper !== undefined$1) {
            number = number <= upper ? number : upper;
          }
          if (lower !== undefined$1) {
            number = number >= lower ? number : lower;
          }
        }
        return number;
      }

      /**
       * The base implementation of `_.clone` and `_.cloneDeep` which tracks
       * traversed objects.
       *
       * @private
       * @param {*} value The value to clone.
       * @param {boolean} bitmask The bitmask flags.
       *  1 - Deep clone
       *  2 - Flatten inherited properties
       *  4 - Clone symbols
       * @param {Function} [customizer] The function to customize cloning.
       * @param {string} [key] The key of `value`.
       * @param {Object} [object] The parent object of `value`.
       * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
       * @returns {*} Returns the cloned value.
       */
      function baseClone(value, bitmask, customizer, key, object, stack) {
        var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;
        if (customizer) {
          result = object ? customizer(value, key, object, stack) : customizer(value);
        }
        if (result !== undefined$1) {
          return result;
        }
        if (!isObject(value)) {
          return value;
        }
        var isArr = isArray(value);
        if (isArr) {
          result = initCloneArray(value);
          if (!isDeep) {
            return copyArray(value, result);
          }
        } else {
          var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;
          if (isBuffer(value)) {
            return cloneBuffer(value, isDeep);
          }
          if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) {
              return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object ? value : {};
            }
            result = initCloneByTag(value, tag, isDeep);
          }
        }
        // Check for circular references and return its corresponding clone.
        stack || (stack = new Stack());
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result);
        if (isSet(value)) {
          value.forEach(function (subValue) {
            result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap(value)) {
          value.forEach(function (subValue, key) {
            result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
          });
        }
        var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
        var props = isArr ? undefined$1 : keysFunc(value);
        arrayEach(props || value, function (subValue, key) {
          if (props) {
            key = subValue;
            subValue = value[key];
          }
          // Recursively populate clone (susceptible to call stack limits).
          assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
        return result;
      }

      /**
       * The base implementation of `_.conforms` which doesn't clone `source`.
       *
       * @private
       * @param {Object} source The object of property predicates to conform to.
       * @returns {Function} Returns the new spec function.
       */
      function baseConforms(source) {
        var props = keys(source);
        return function (object) {
          return baseConformsTo(object, source, props);
        };
      }

      /**
       * The base implementation of `_.conformsTo` which accepts `props` to check.
       *
       * @private
       * @param {Object} object The object to inspect.
       * @param {Object} source The object of property predicates to conform to.
       * @returns {boolean} Returns `true` if `object` conforms, else `false`.
       */
      function baseConformsTo(object, source, props) {
        var length = props.length;
        if (object == null) {
          return !length;
        }
        object = Object(object);
        while (length--) {
          var key = props[length],
            predicate = source[key],
            value = object[key];
          if (value === undefined$1 && !(key in object) || !predicate(value)) {
            return false;
          }
        }
        return true;
      }

      /**
       * The base implementation of `_.delay` and `_.defer` which accepts `args`
       * to provide to `func`.
       *
       * @private
       * @param {Function} func The function to delay.
       * @param {number} wait The number of milliseconds to delay invocation.
       * @param {Array} args The arguments to provide to `func`.
       * @returns {number|Object} Returns the timer id or timeout object.
       */
      function baseDelay(func, wait, args) {
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return setTimeout(function () {
          func.apply(undefined$1, args);
        }, wait);
      }

      /**
       * The base implementation of methods like `_.difference` without support
       * for excluding multiple arrays or iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {Array} values The values to exclude.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       */
      function baseDifference(array, values, iteratee, comparator) {
        var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;
        if (!length) {
          return result;
        }
        if (iteratee) {
          values = arrayMap(values, baseUnary(iteratee));
        }
        if (comparator) {
          includes = arrayIncludesWith;
          isCommon = false;
        } else if (values.length >= LARGE_ARRAY_SIZE) {
          includes = cacheHas;
          isCommon = false;
          values = new SetCache(values);
        }
        outer: while (++index < length) {
          var value = array[index],
            computed = iteratee == null ? value : iteratee(value);
          value = comparator || value !== 0 ? value : 0;
          if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while (valuesIndex--) {
              if (values[valuesIndex] === computed) {
                continue outer;
              }
            }
            result.push(value);
          } else if (!includes(values, computed, comparator)) {
            result.push(value);
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.forEach` without support for iteratee shorthands.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array|Object} Returns `collection`.
       */
      var baseEach = createBaseEach(baseForOwn);

      /**
       * The base implementation of `_.forEachRight` without support for iteratee shorthands.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array|Object} Returns `collection`.
       */
      var baseEachRight = createBaseEach(baseForOwnRight, true);

      /**
       * The base implementation of `_.every` without support for iteratee shorthands.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} predicate The function invoked per iteration.
       * @returns {boolean} Returns `true` if all elements pass the predicate check,
       *  else `false`
       */
      function baseEvery(collection, predicate) {
        var result = true;
        baseEach(collection, function (value, index, collection) {
          result = !!predicate(value, index, collection);
          return result;
        });
        return result;
      }

      /**
       * The base implementation of methods like `_.max` and `_.min` which accepts a
       * `comparator` to determine the extremum value.
       *
       * @private
       * @param {Array} array The array to iterate over.
       * @param {Function} iteratee The iteratee invoked per iteration.
       * @param {Function} comparator The comparator used to compare values.
       * @returns {*} Returns the extremum value.
       */
      function baseExtremum(array, iteratee, comparator) {
        var index = -1,
          length = array.length;
        while (++index < length) {
          var value = array[index],
            current = iteratee(value);
          if (current != null && (computed === undefined$1 ? current === current && !isSymbol(current) : comparator(current, computed))) {
            var computed = current,
              result = value;
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.fill` without an iteratee call guard.
       *
       * @private
       * @param {Array} array The array to fill.
       * @param {*} value The value to fill `array` with.
       * @param {number} [start=0] The start position.
       * @param {number} [end=array.length] The end position.
       * @returns {Array} Returns `array`.
       */
      function baseFill(array, value, start, end) {
        var length = array.length;
        start = toInteger(start);
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end === undefined$1 || end > length ? length : toInteger(end);
        if (end < 0) {
          end += length;
        }
        end = start > end ? 0 : toLength(end);
        while (start < end) {
          array[start++] = value;
        }
        return array;
      }

      /**
       * The base implementation of `_.filter` without support for iteratee shorthands.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} predicate The function invoked per iteration.
       * @returns {Array} Returns the new filtered array.
       */
      function baseFilter(collection, predicate) {
        var result = [];
        baseEach(collection, function (value, index, collection) {
          if (predicate(value, index, collection)) {
            result.push(value);
          }
        });
        return result;
      }

      /**
       * The base implementation of `_.flatten` with support for restricting flattening.
       *
       * @private
       * @param {Array} array The array to flatten.
       * @param {number} depth The maximum recursion depth.
       * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
       * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
       * @param {Array} [result=[]] The initial result value.
       * @returns {Array} Returns the new flattened array.
       */
      function baseFlatten(array, depth, predicate, isStrict, result) {
        var index = -1,
          length = array.length;
        predicate || (predicate = isFlattenable);
        result || (result = []);
        while (++index < length) {
          var value = array[index];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              // Recursively flatten arrays (susceptible to call stack limits).
              baseFlatten(value, depth - 1, predicate, isStrict, result);
            } else {
              arrayPush(result, value);
            }
          } else if (!isStrict) {
            result[result.length] = value;
          }
        }
        return result;
      }

      /**
       * The base implementation of `baseForOwn` which iterates over `object`
       * properties returned by `keysFunc` and invokes `iteratee` for each property.
       * Iteratee functions may exit iteration early by explicitly returning `false`.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @param {Function} keysFunc The function to get the keys of `object`.
       * @returns {Object} Returns `object`.
       */
      var baseFor = createBaseFor();

      /**
       * This function is like `baseFor` except that it iterates over properties
       * in the opposite order.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @param {Function} keysFunc The function to get the keys of `object`.
       * @returns {Object} Returns `object`.
       */
      var baseForRight = createBaseFor(true);

      /**
       * The base implementation of `_.forOwn` without support for iteratee shorthands.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Object} Returns `object`.
       */
      function baseForOwn(object, iteratee) {
        return object && baseFor(object, iteratee, keys);
      }

      /**
       * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Object} Returns `object`.
       */
      function baseForOwnRight(object, iteratee) {
        return object && baseForRight(object, iteratee, keys);
      }

      /**
       * The base implementation of `_.functions` which creates an array of
       * `object` function property names filtered from `props`.
       *
       * @private
       * @param {Object} object The object to inspect.
       * @param {Array} props The property names to filter.
       * @returns {Array} Returns the function names.
       */
      function baseFunctions(object, props) {
        return arrayFilter(props, function (key) {
          return isFunction(object[key]);
        });
      }

      /**
       * The base implementation of `_.get` without support for default values.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array|string} path The path of the property to get.
       * @returns {*} Returns the resolved value.
       */
      function baseGet(object, path) {
        path = castPath(path, object);
        var index = 0,
          length = path.length;
        while (object != null && index < length) {
          object = object[toKey(path[index++])];
        }
        return index && index == length ? object : undefined$1;
      }

      /**
       * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
       * `keysFunc` and `symbolsFunc` to get the enumerable property names and
       * symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Function} keysFunc The function to get the keys of `object`.
       * @param {Function} symbolsFunc The function to get the symbols of `object`.
       * @returns {Array} Returns the array of property names and symbols.
       */
      function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result = keysFunc(object);
        return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
      }

      /**
       * The base implementation of `getTag` without fallbacks for buggy environments.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the `toStringTag`.
       */
      function baseGetTag(value) {
        if (value == null) {
          return value === undefined$1 ? undefinedTag : nullTag;
        }
        return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
      }

      /**
       * The base implementation of `_.gt` which doesn't coerce arguments.
       *
       * @private
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if `value` is greater than `other`,
       *  else `false`.
       */
      function baseGt(value, other) {
        return value > other;
      }

      /**
       * The base implementation of `_.has` without support for deep paths.
       *
       * @private
       * @param {Object} [object] The object to query.
       * @param {Array|string} key The key to check.
       * @returns {boolean} Returns `true` if `key` exists, else `false`.
       */
      function baseHas(object, key) {
        return object != null && hasOwnProperty.call(object, key);
      }

      /**
       * The base implementation of `_.hasIn` without support for deep paths.
       *
       * @private
       * @param {Object} [object] The object to query.
       * @param {Array|string} key The key to check.
       * @returns {boolean} Returns `true` if `key` exists, else `false`.
       */
      function baseHasIn(object, key) {
        return object != null && key in Object(object);
      }

      /**
       * The base implementation of `_.inRange` which doesn't coerce arguments.
       *
       * @private
       * @param {number} number The number to check.
       * @param {number} start The start of the range.
       * @param {number} end The end of the range.
       * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
       */
      function baseInRange(number, start, end) {
        return number >= nativeMin(start, end) && number < nativeMax(start, end);
      }

      /**
       * The base implementation of methods like `_.intersection`, without support
       * for iteratee shorthands, that accepts an array of arrays to inspect.
       *
       * @private
       * @param {Array} arrays The arrays to inspect.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of shared values.
       */
      function baseIntersection(arrays, iteratee, comparator) {
        var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];
        while (othIndex--) {
          var array = arrays[othIndex];
          if (othIndex && iteratee) {
            array = arrayMap(array, baseUnary(iteratee));
          }
          maxLength = nativeMin(array.length, maxLength);
          caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined$1;
        }
        array = arrays[0];
        var index = -1,
          seen = caches[0];
        outer: while (++index < length && result.length < maxLength) {
          var value = array[index],
            computed = iteratee ? iteratee(value) : value;
          value = comparator || value !== 0 ? value : 0;
          if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while (--othIndex) {
              var cache = caches[othIndex];
              if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
                continue outer;
              }
            }
            if (seen) {
              seen.push(computed);
            }
            result.push(value);
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.invert` and `_.invertBy` which inverts
       * `object` with values transformed by `iteratee` and set by `setter`.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {Function} setter The function to set `accumulator` values.
       * @param {Function} iteratee The iteratee to transform values.
       * @param {Object} accumulator The initial inverted object.
       * @returns {Function} Returns `accumulator`.
       */
      function baseInverter(object, setter, iteratee, accumulator) {
        baseForOwn(object, function (value, key, object) {
          setter(accumulator, iteratee(value), key, object);
        });
        return accumulator;
      }

      /**
       * The base implementation of `_.invoke` without support for individual
       * method arguments.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array|string} path The path of the method to invoke.
       * @param {Array} args The arguments to invoke the method with.
       * @returns {*} Returns the result of the invoked method.
       */
      function baseInvoke(object, path, args) {
        path = castPath(path, object);
        object = parent(object, path);
        var func = object == null ? object : object[toKey(last(path))];
        return func == null ? undefined$1 : apply(func, object, args);
      }

      /**
       * The base implementation of `_.isArguments`.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an `arguments` object,
       */
      function baseIsArguments(value) {
        return isObjectLike(value) && baseGetTag(value) == argsTag;
      }

      /**
       * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
       */
      function baseIsArrayBuffer(value) {
        return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
      }

      /**
       * The base implementation of `_.isDate` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
       */
      function baseIsDate(value) {
        return isObjectLike(value) && baseGetTag(value) == dateTag;
      }

      /**
       * The base implementation of `_.isEqual` which supports partial comparisons
       * and tracks traversed objects.
       *
       * @private
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @param {boolean} bitmask The bitmask flags.
       *  1 - Unordered comparison
       *  2 - Partial comparison
       * @param {Function} [customizer] The function to customize comparisons.
       * @param {Object} [stack] Tracks traversed `value` and `other` objects.
       * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
       */
      function baseIsEqual(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }
        if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
          return value !== value && other !== other;
        }
        return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
      }

      /**
       * A specialized version of `baseIsEqual` for arrays and objects which performs
       * deep comparisons and tracks traversed objects enabling objects with circular
       * references to be compared.
       *
       * @private
       * @param {Object} object The object to compare.
       * @param {Object} other The other object to compare.
       * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
       * @param {Function} customizer The function to customize comparisons.
       * @param {Function} equalFunc The function to determine equivalents of values.
       * @param {Object} [stack] Tracks traversed `object` and `other` objects.
       * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
       */
      function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);
        objTag = objTag == argsTag ? objectTag : objTag;
        othTag = othTag == argsTag ? objectTag : othTag;
        var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;
        if (isSameTag && isBuffer(object)) {
          if (!isBuffer(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack());
          return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
          var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack || (stack = new Stack());
        return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
      }

      /**
       * The base implementation of `_.isMap` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a map, else `false`.
       */
      function baseIsMap(value) {
        return isObjectLike(value) && getTag(value) == mapTag;
      }

      /**
       * The base implementation of `_.isMatch` without support for iteratee shorthands.
       *
       * @private
       * @param {Object} object The object to inspect.
       * @param {Object} source The object of property values to match.
       * @param {Array} matchData The property names, values, and compare flags to match.
       * @param {Function} [customizer] The function to customize comparisons.
       * @returns {boolean} Returns `true` if `object` is a match, else `false`.
       */
      function baseIsMatch(object, source, matchData, customizer) {
        var index = matchData.length,
          length = index,
          noCustomizer = !customizer;
        if (object == null) {
          return !length;
        }
        object = Object(object);
        while (index--) {
          var data = matchData[index];
          if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
            return false;
          }
        }
        while (++index < length) {
          data = matchData[index];
          var key = data[0],
            objValue = object[key],
            srcValue = data[1];
          if (noCustomizer && data[2]) {
            if (objValue === undefined$1 && !(key in object)) {
              return false;
            }
          } else {
            var stack = new Stack();
            if (customizer) {
              var result = customizer(objValue, srcValue, key, object, source, stack);
            }
            if (!(result === undefined$1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
              return false;
            }
          }
        }
        return true;
      }

      /**
       * The base implementation of `_.isNative` without bad shim checks.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a native function,
       *  else `false`.
       */
      function baseIsNative(value) {
        if (!isObject(value) || isMasked(value)) {
          return false;
        }
        var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
      }

      /**
       * The base implementation of `_.isRegExp` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
       */
      function baseIsRegExp(value) {
        return isObjectLike(value) && baseGetTag(value) == regexpTag;
      }

      /**
       * The base implementation of `_.isSet` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a set, else `false`.
       */
      function baseIsSet(value) {
        return isObjectLike(value) && getTag(value) == setTag;
      }

      /**
       * The base implementation of `_.isTypedArray` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
       */
      function baseIsTypedArray(value) {
        return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
      }

      /**
       * The base implementation of `_.iteratee`.
       *
       * @private
       * @param {*} [value=_.identity] The value to convert to an iteratee.
       * @returns {Function} Returns the iteratee.
       */
      function baseIteratee(value) {
        // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
        // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
        if (typeof value == 'function') {
          return value;
        }
        if (value == null) {
          return identity;
        }
        if (typeof value == 'object') {
          return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
        }
        return property(value);
      }

      /**
       * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       */
      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }
        var result = [];
        for (var key in Object(object)) {
          if (hasOwnProperty.call(object, key) && key != 'constructor') {
            result.push(key);
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       */
      function baseKeysIn(object) {
        if (!isObject(object)) {
          return nativeKeysIn(object);
        }
        var isProto = isPrototype(object),
          result = [];
        for (var key in object) {
          if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
            result.push(key);
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.lt` which doesn't coerce arguments.
       *
       * @private
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if `value` is less than `other`,
       *  else `false`.
       */
      function baseLt(value, other) {
        return value < other;
      }

      /**
       * The base implementation of `_.map` without support for iteratee shorthands.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array} Returns the new mapped array.
       */
      function baseMap(collection, iteratee) {
        var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];
        baseEach(collection, function (value, key, collection) {
          result[++index] = iteratee(value, key, collection);
        });
        return result;
      }

      /**
       * The base implementation of `_.matches` which doesn't clone `source`.
       *
       * @private
       * @param {Object} source The object of property values to match.
       * @returns {Function} Returns the new spec function.
       */
      function baseMatches(source) {
        var matchData = getMatchData(source);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        }
        return function (object) {
          return object === source || baseIsMatch(object, source, matchData);
        };
      }

      /**
       * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
       *
       * @private
       * @param {string} path The path of the property to get.
       * @param {*} srcValue The value to match.
       * @returns {Function} Returns the new spec function.
       */
      function baseMatchesProperty(path, srcValue) {
        if (isKey(path) && isStrictComparable(srcValue)) {
          return matchesStrictComparable(toKey(path), srcValue);
        }
        return function (object) {
          var objValue = get(object, path);
          return objValue === undefined$1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
        };
      }

      /**
       * The base implementation of `_.merge` without support for multiple sources.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @param {number} srcIndex The index of `source`.
       * @param {Function} [customizer] The function to customize merged values.
       * @param {Object} [stack] Tracks traversed source values and their merged
       *  counterparts.
       */
      function baseMerge(object, source, srcIndex, customizer, stack) {
        if (object === source) {
          return;
        }
        baseFor(source, function (srcValue, key) {
          stack || (stack = new Stack());
          if (isObject(srcValue)) {
            baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
          } else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined$1;
            if (newValue === undefined$1) {
              newValue = srcValue;
            }
            assignMergeValue(object, key, newValue);
          }
        }, keysIn);
      }

      /**
       * A specialized version of `baseMerge` for arrays and objects which performs
       * deep merges and tracks traversed objects enabling objects with circular
       * references to be merged.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @param {string} key The key of the value to merge.
       * @param {number} srcIndex The index of `source`.
       * @param {Function} mergeFunc The function to merge values.
       * @param {Function} [customizer] The function to customize assigned values.
       * @param {Object} [stack] Tracks traversed source values and their merged
       *  counterparts.
       */
      function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);
        if (stacked) {
          assignMergeValue(object, key, stacked);
          return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined$1;
        var isCommon = newValue === undefined$1;
        if (isCommon) {
          var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) {
              newValue = toPlainObject(objValue);
            } else if (!isObject(objValue) || isFunction(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          // Recursively merge objects and arrays (susceptible to call stack limits).
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack['delete'](srcValue);
        }
        assignMergeValue(object, key, newValue);
      }

      /**
       * The base implementation of `_.nth` which doesn't coerce arguments.
       *
       * @private
       * @param {Array} array The array to query.
       * @param {number} n The index of the element to return.
       * @returns {*} Returns the nth element of `array`.
       */
      function baseNth(array, n) {
        var length = array.length;
        if (!length) {
          return;
        }
        n += n < 0 ? length : 0;
        return isIndex(n, length) ? array[n] : undefined$1;
      }

      /**
       * The base implementation of `_.orderBy` without param guards.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
       * @param {string[]} orders The sort orders of `iteratees`.
       * @returns {Array} Returns the new sorted array.
       */
      function baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap(iteratees, function (iteratee) {
            if (isArray(iteratee)) {
              return function (value) {
                return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
              };
            }
            return iteratee;
          });
        } else {
          iteratees = [identity];
        }
        var index = -1;
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        var result = baseMap(collection, function (value, key, collection) {
          var criteria = arrayMap(iteratees, function (iteratee) {
            return iteratee(value);
          });
          return {
            'criteria': criteria,
            'index': ++index,
            'value': value
          };
        });
        return baseSortBy(result, function (object, other) {
          return compareMultiple(object, other, orders);
        });
      }

      /**
       * The base implementation of `_.pick` without support for individual
       * property identifiers.
       *
       * @private
       * @param {Object} object The source object.
       * @param {string[]} paths The property paths to pick.
       * @returns {Object} Returns the new object.
       */
      function basePick(object, paths) {
        return basePickBy(object, paths, function (value, path) {
          return hasIn(object, path);
        });
      }

      /**
       * The base implementation of  `_.pickBy` without support for iteratee shorthands.
       *
       * @private
       * @param {Object} object The source object.
       * @param {string[]} paths The property paths to pick.
       * @param {Function} predicate The function invoked per property.
       * @returns {Object} Returns the new object.
       */
      function basePickBy(object, paths, predicate) {
        var index = -1,
          length = paths.length,
          result = {};
        while (++index < length) {
          var path = paths[index],
            value = baseGet(object, path);
          if (predicate(value, path)) {
            baseSet(result, castPath(path, object), value);
          }
        }
        return result;
      }

      /**
       * A specialized version of `baseProperty` which supports deep paths.
       *
       * @private
       * @param {Array|string} path The path of the property to get.
       * @returns {Function} Returns the new accessor function.
       */
      function basePropertyDeep(path) {
        return function (object) {
          return baseGet(object, path);
        };
      }

      /**
       * The base implementation of `_.pullAllBy` without support for iteratee
       * shorthands.
       *
       * @private
       * @param {Array} array The array to modify.
       * @param {Array} values The values to remove.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns `array`.
       */
      function basePullAll(array, values, iteratee, comparator) {
        var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;
        if (array === values) {
          values = copyArray(values);
        }
        if (iteratee) {
          seen = arrayMap(array, baseUnary(iteratee));
        }
        while (++index < length) {
          var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;
          while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
            if (seen !== array) {
              splice.call(seen, fromIndex, 1);
            }
            splice.call(array, fromIndex, 1);
          }
        }
        return array;
      }

      /**
       * The base implementation of `_.pullAt` without support for individual
       * indexes or capturing the removed elements.
       *
       * @private
       * @param {Array} array The array to modify.
       * @param {number[]} indexes The indexes of elements to remove.
       * @returns {Array} Returns `array`.
       */
      function basePullAt(array, indexes) {
        var length = array ? indexes.length : 0,
          lastIndex = length - 1;
        while (length--) {
          var index = indexes[length];
          if (length == lastIndex || index !== previous) {
            var previous = index;
            if (isIndex(index)) {
              splice.call(array, index, 1);
            } else {
              baseUnset(array, index);
            }
          }
        }
        return array;
      }

      /**
       * The base implementation of `_.random` without support for returning
       * floating-point numbers.
       *
       * @private
       * @param {number} lower The lower bound.
       * @param {number} upper The upper bound.
       * @returns {number} Returns the random number.
       */
      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }

      /**
       * The base implementation of `_.range` and `_.rangeRight` which doesn't
       * coerce arguments.
       *
       * @private
       * @param {number} start The start of the range.
       * @param {number} end The end of the range.
       * @param {number} step The value to increment or decrement by.
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Array} Returns the range of numbers.
       */
      function baseRange(start, end, step, fromRight) {
        var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);
        while (length--) {
          result[fromRight ? length : ++index] = start;
          start += step;
        }
        return result;
      }

      /**
       * The base implementation of `_.repeat` which doesn't coerce arguments.
       *
       * @private
       * @param {string} string The string to repeat.
       * @param {number} n The number of times to repeat the string.
       * @returns {string} Returns the repeated string.
       */
      function baseRepeat(string, n) {
        var result = '';
        if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
          return result;
        }
        // Leverage the exponentiation by squaring algorithm for a faster repeat.
        // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
        do {
          if (n % 2) {
            result += string;
          }
          n = nativeFloor(n / 2);
          if (n) {
            string += string;
          }
        } while (n);
        return result;
      }

      /**
       * The base implementation of `_.rest` which doesn't validate or coerce arguments.
       *
       * @private
       * @param {Function} func The function to apply a rest parameter to.
       * @param {number} [start=func.length-1] The start position of the rest parameter.
       * @returns {Function} Returns the new function.
       */
      function baseRest(func, start) {
        return setToString(overRest(func, start, identity), func + '');
      }

      /**
       * The base implementation of `_.sample`.
       *
       * @private
       * @param {Array|Object} collection The collection to sample.
       * @returns {*} Returns the random element.
       */
      function baseSample(collection) {
        return arraySample(values(collection));
      }

      /**
       * The base implementation of `_.sampleSize` without param guards.
       *
       * @private
       * @param {Array|Object} collection The collection to sample.
       * @param {number} n The number of elements to sample.
       * @returns {Array} Returns the random elements.
       */
      function baseSampleSize(collection, n) {
        var array = values(collection);
        return shuffleSelf(array, baseClamp(n, 0, array.length));
      }

      /**
       * The base implementation of `_.set`.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to set.
       * @param {*} value The value to set.
       * @param {Function} [customizer] The function to customize path creation.
       * @returns {Object} Returns `object`.
       */
      function baseSet(object, path, value, customizer) {
        if (!isObject(object)) {
          return object;
        }
        path = castPath(path, object);
        var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;
        while (nested != null && ++index < length) {
          var key = toKey(path[index]),
            newValue = value;
          if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
            return object;
          }
          if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
            if (newValue === undefined$1) {
              newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
            }
          }
          assignValue(nested, key, newValue);
          nested = nested[key];
        }
        return object;
      }

      /**
       * The base implementation of `setData` without support for hot loop shorting.
       *
       * @private
       * @param {Function} func The function to associate metadata with.
       * @param {*} data The metadata.
       * @returns {Function} Returns `func`.
       */
      var baseSetData = !metaMap ? identity : function (func, data) {
        metaMap.set(func, data);
        return func;
      };

      /**
       * The base implementation of `setToString` without support for hot loop shorting.
       *
       * @private
       * @param {Function} func The function to modify.
       * @param {Function} string The `toString` result.
       * @returns {Function} Returns `func`.
       */
      var baseSetToString = !defineProperty ? identity : function (func, string) {
        return defineProperty(func, 'toString', {
          'configurable': true,
          'enumerable': false,
          'value': constant(string),
          'writable': true
        });
      };

      /**
       * The base implementation of `_.shuffle`.
       *
       * @private
       * @param {Array|Object} collection The collection to shuffle.
       * @returns {Array} Returns the new shuffled array.
       */
      function baseShuffle(collection) {
        return shuffleSelf(values(collection));
      }

      /**
       * The base implementation of `_.slice` without an iteratee call guard.
       *
       * @private
       * @param {Array} array The array to slice.
       * @param {number} [start=0] The start position.
       * @param {number} [end=array.length] The end position.
       * @returns {Array} Returns the slice of `array`.
       */
      function baseSlice(array, start, end) {
        var index = -1,
          length = array.length;
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end > length ? length : end;
        if (end < 0) {
          end += length;
        }
        length = start > end ? 0 : end - start >>> 0;
        start >>>= 0;
        var result = Array(length);
        while (++index < length) {
          result[index] = array[index + start];
        }
        return result;
      }

      /**
       * The base implementation of `_.some` without support for iteratee shorthands.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} predicate The function invoked per iteration.
       * @returns {boolean} Returns `true` if any element passes the predicate check,
       *  else `false`.
       */
      function baseSome(collection, predicate) {
        var result;
        baseEach(collection, function (value, index, collection) {
          result = predicate(value, index, collection);
          return !result;
        });
        return !!result;
      }

      /**
       * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
       * performs a binary search of `array` to determine the index at which `value`
       * should be inserted into `array` in order to maintain its sort order.
       *
       * @private
       * @param {Array} array The sorted array to inspect.
       * @param {*} value The value to evaluate.
       * @param {boolean} [retHighest] Specify returning the highest qualified index.
       * @returns {number} Returns the index at which `value` should be inserted
       *  into `array`.
       */
      function baseSortedIndex(array, value, retHighest) {
        var low = 0,
          high = array == null ? low : array.length;
        if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
          while (low < high) {
            var mid = low + high >>> 1,
              computed = array[mid];
            if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return high;
        }
        return baseSortedIndexBy(array, value, identity, retHighest);
      }

      /**
       * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
       * which invokes `iteratee` for `value` and each element of `array` to compute
       * their sort ranking. The iteratee is invoked with one argument; (value).
       *
       * @private
       * @param {Array} array The sorted array to inspect.
       * @param {*} value The value to evaluate.
       * @param {Function} iteratee The iteratee invoked per element.
       * @param {boolean} [retHighest] Specify returning the highest qualified index.
       * @returns {number} Returns the index at which `value` should be inserted
       *  into `array`.
       */
      function baseSortedIndexBy(array, value, iteratee, retHighest) {
        var low = 0,
          high = array == null ? 0 : array.length;
        if (high === 0) {
          return 0;
        }
        value = iteratee(value);
        var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined$1;
        while (low < high) {
          var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined$1,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);
          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? computed <= value : computed < value;
          }
          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return nativeMin(high, MAX_ARRAY_INDEX);
      }

      /**
       * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
       * support for iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @returns {Array} Returns the new duplicate free array.
       */
      function baseSortedUniq(array, iteratee) {
        var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];
        while (++index < length) {
          var value = array[index],
            computed = iteratee ? iteratee(value) : value;
          if (!index || !eq(computed, seen)) {
            var seen = computed;
            result[resIndex++] = value === 0 ? 0 : value;
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.toNumber` which doesn't ensure correct
       * conversions of binary, hexadecimal, or octal string values.
       *
       * @private
       * @param {*} value The value to process.
       * @returns {number} Returns the number.
       */
      function baseToNumber(value) {
        if (typeof value == 'number') {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        return +value;
      }

      /**
       * The base implementation of `_.toString` which doesn't convert nullish
       * values to empty strings.
       *
       * @private
       * @param {*} value The value to process.
       * @returns {string} Returns the string.
       */
      function baseToString(value) {
        // Exit early for strings to avoid a performance hit in some environments.
        if (typeof value == 'string') {
          return value;
        }
        if (isArray(value)) {
          // Recursively convert values (susceptible to call stack limits).
          return arrayMap(value, baseToString) + '';
        }
        if (isSymbol(value)) {
          return symbolToString ? symbolToString.call(value) : '';
        }
        var result = value + '';
        return result == '0' && 1 / value == -INFINITY ? '-0' : result;
      }

      /**
       * The base implementation of `_.uniqBy` without support for iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new duplicate free array.
       */
      function baseUniq(array, iteratee, comparator) {
        var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;
        if (comparator) {
          isCommon = false;
          includes = arrayIncludesWith;
        } else if (length >= LARGE_ARRAY_SIZE) {
          var set = iteratee ? null : createSet(array);
          if (set) {
            return setToArray(set);
          }
          isCommon = false;
          includes = cacheHas;
          seen = new SetCache();
        } else {
          seen = iteratee ? [] : result;
        }
        outer: while (++index < length) {
          var value = array[index],
            computed = iteratee ? iteratee(value) : value;
          value = comparator || value !== 0 ? value : 0;
          if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while (seenIndex--) {
              if (seen[seenIndex] === computed) {
                continue outer;
              }
            }
            if (iteratee) {
              seen.push(computed);
            }
            result.push(value);
          } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) {
              seen.push(computed);
            }
            result.push(value);
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.unset`.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {Array|string} path The property path to unset.
       * @returns {boolean} Returns `true` if the property is deleted, else `false`.
       */
      function baseUnset(object, path) {
        path = castPath(path, object);
        object = parent(object, path);
        return object == null || delete object[toKey(last(path))];
      }

      /**
       * The base implementation of `_.update`.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to update.
       * @param {Function} updater The function to produce the updated value.
       * @param {Function} [customizer] The function to customize path creation.
       * @returns {Object} Returns `object`.
       */
      function baseUpdate(object, path, updater, customizer) {
        return baseSet(object, path, updater(baseGet(object, path)), customizer);
      }

      /**
       * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
       * without support for iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to query.
       * @param {Function} predicate The function invoked per iteration.
       * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Array} Returns the slice of `array`.
       */
      function baseWhile(array, predicate, isDrop, fromRight) {
        var length = array.length,
          index = fromRight ? length : -1;
        while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
        return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
      }

      /**
       * The base implementation of `wrapperValue` which returns the result of
       * performing a sequence of actions on the unwrapped `value`, where each
       * successive action is supplied the return value of the previous.
       *
       * @private
       * @param {*} value The unwrapped value.
       * @param {Array} actions Actions to perform to resolve the unwrapped value.
       * @returns {*} Returns the resolved value.
       */
      function baseWrapperValue(value, actions) {
        var result = value;
        if (result instanceof LazyWrapper) {
          result = result.value();
        }
        return arrayReduce(actions, function (result, action) {
          return action.func.apply(action.thisArg, arrayPush([result], action.args));
        }, result);
      }

      /**
       * The base implementation of methods like `_.xor`, without support for
       * iteratee shorthands, that accepts an array of arrays to inspect.
       *
       * @private
       * @param {Array} arrays The arrays to inspect.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of values.
       */
      function baseXor(arrays, iteratee, comparator) {
        var length = arrays.length;
        if (length < 2) {
          return length ? baseUniq(arrays[0]) : [];
        }
        var index = -1,
          result = Array(length);
        while (++index < length) {
          var array = arrays[index],
            othIndex = -1;
          while (++othIndex < length) {
            if (othIndex != index) {
              result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
          }
        }
        return baseUniq(baseFlatten(result, 1), iteratee, comparator);
      }

      /**
       * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
       *
       * @private
       * @param {Array} props The property identifiers.
       * @param {Array} values The property values.
       * @param {Function} assignFunc The function to assign values.
       * @returns {Object} Returns the new object.
       */
      function baseZipObject(props, values, assignFunc) {
        var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};
        while (++index < length) {
          var value = index < valsLength ? values[index] : undefined$1;
          assignFunc(result, props[index], value);
        }
        return result;
      }

      /**
       * Casts `value` to an empty array if it's not an array like object.
       *
       * @private
       * @param {*} value The value to inspect.
       * @returns {Array|Object} Returns the cast array-like object.
       */
      function castArrayLikeObject(value) {
        return isArrayLikeObject(value) ? value : [];
      }

      /**
       * Casts `value` to `identity` if it's not a function.
       *
       * @private
       * @param {*} value The value to inspect.
       * @returns {Function} Returns cast function.
       */
      function castFunction(value) {
        return typeof value == 'function' ? value : identity;
      }

      /**
       * Casts `value` to a path array if it's not one.
       *
       * @private
       * @param {*} value The value to inspect.
       * @param {Object} [object] The object to query keys on.
       * @returns {Array} Returns the cast property path array.
       */
      function castPath(value, object) {
        if (isArray(value)) {
          return value;
        }
        return isKey(value, object) ? [value] : stringToPath(toString(value));
      }

      /**
       * A `baseRest` alias which can be replaced with `identity` by module
       * replacement plugins.
       *
       * @private
       * @type {Function}
       * @param {Function} func The function to apply a rest parameter to.
       * @returns {Function} Returns the new function.
       */
      var castRest = baseRest;

      /**
       * Casts `array` to a slice if it's needed.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {number} start The start position.
       * @param {number} [end=array.length] The end position.
       * @returns {Array} Returns the cast slice.
       */
      function castSlice(array, start, end) {
        var length = array.length;
        end = end === undefined$1 ? length : end;
        return !start && end >= length ? array : baseSlice(array, start, end);
      }

      /**
       * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
       *
       * @private
       * @param {number|Object} id The timer id or timeout object of the timer to clear.
       */
      var clearTimeout = ctxClearTimeout || function (id) {
        return root.clearTimeout(id);
      };

      /**
       * Creates a clone of  `buffer`.
       *
       * @private
       * @param {Buffer} buffer The buffer to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Buffer} Returns the cloned buffer.
       */
      function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
        buffer.copy(result);
        return result;
      }

      /**
       * Creates a clone of `arrayBuffer`.
       *
       * @private
       * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
       * @returns {ArrayBuffer} Returns the cloned array buffer.
       */
      function cloneArrayBuffer(arrayBuffer) {
        var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array(result).set(new Uint8Array(arrayBuffer));
        return result;
      }

      /**
       * Creates a clone of `dataView`.
       *
       * @private
       * @param {Object} dataView The data view to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Object} Returns the cloned data view.
       */
      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }

      /**
       * Creates a clone of `regexp`.
       *
       * @private
       * @param {Object} regexp The regexp to clone.
       * @returns {Object} Returns the cloned regexp.
       */
      function cloneRegExp(regexp) {
        var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result.lastIndex = regexp.lastIndex;
        return result;
      }

      /**
       * Creates a clone of the `symbol` object.
       *
       * @private
       * @param {Object} symbol The symbol object to clone.
       * @returns {Object} Returns the cloned symbol object.
       */
      function cloneSymbol(symbol) {
        return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
      }

      /**
       * Creates a clone of `typedArray`.
       *
       * @private
       * @param {Object} typedArray The typed array to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Object} Returns the cloned typed array.
       */
      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }

      /**
       * Compares values to sort them in ascending order.
       *
       * @private
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {number} Returns the sort order indicator for `value`.
       */
      function compareAscending(value, other) {
        if (value !== other) {
          var valIsDefined = value !== undefined$1,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);
          var othIsDefined = other !== undefined$1,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);
          if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
            return 1;
          }
          if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
            return -1;
          }
        }
        return 0;
      }

      /**
       * Used by `_.orderBy` to compare multiple properties of a value to another
       * and stable sort them.
       *
       * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
       * specify an order of "desc" for descending or "asc" for ascending sort order
       * of corresponding values.
       *
       * @private
       * @param {Object} object The object to compare.
       * @param {Object} other The other object to compare.
       * @param {boolean[]|string[]} orders The order to sort by for each property.
       * @returns {number} Returns the sort order indicator for `object`.
       */
      function compareMultiple(object, other, orders) {
        var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;
        while (++index < length) {
          var result = compareAscending(objCriteria[index], othCriteria[index]);
          if (result) {
            if (index >= ordersLength) {
              return result;
            }
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
          }
        }
        // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
        // that causes it, under certain circumstances, to provide the same value for
        // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
        // for more details.
        //
        // This also ensures a stable sort in V8 and other engines.
        // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
        return object.index - other.index;
      }

      /**
       * Creates an array that is the composition of partially applied arguments,
       * placeholders, and provided arguments into a single array of arguments.
       *
       * @private
       * @param {Array} args The provided arguments.
       * @param {Array} partials The arguments to prepend to those provided.
       * @param {Array} holders The `partials` placeholder indexes.
       * @params {boolean} [isCurried] Specify composing for a curried function.
       * @returns {Array} Returns the new array of composed arguments.
       */
      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;
        while (++leftIndex < leftLength) {
          result[leftIndex] = partials[leftIndex];
        }
        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result[holders[argsIndex]] = args[argsIndex];
          }
        }
        while (rangeLength--) {
          result[leftIndex++] = args[argsIndex++];
        }
        return result;
      }

      /**
       * This function is like `composeArgs` except that the arguments composition
       * is tailored for `_.partialRight`.
       *
       * @private
       * @param {Array} args The provided arguments.
       * @param {Array} partials The arguments to append to those provided.
       * @param {Array} holders The `partials` placeholder indexes.
       * @params {boolean} [isCurried] Specify composing for a curried function.
       * @returns {Array} Returns the new array of composed arguments.
       */
      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;
        while (++argsIndex < rangeLength) {
          result[argsIndex] = args[argsIndex];
        }
        var offset = argsIndex;
        while (++rightIndex < rightLength) {
          result[offset + rightIndex] = partials[rightIndex];
        }
        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result[offset + holders[holdersIndex]] = args[argsIndex++];
          }
        }
        return result;
      }

      /**
       * Copies the values of `source` to `array`.
       *
       * @private
       * @param {Array} source The array to copy values from.
       * @param {Array} [array=[]] The array to copy values to.
       * @returns {Array} Returns `array`.
       */
      function copyArray(source, array) {
        var index = -1,
          length = source.length;
        array || (array = Array(length));
        while (++index < length) {
          array[index] = source[index];
        }
        return array;
      }

      /**
       * Copies properties of `source` to `object`.
       *
       * @private
       * @param {Object} source The object to copy properties from.
       * @param {Array} props The property identifiers to copy.
       * @param {Object} [object={}] The object to copy properties to.
       * @param {Function} [customizer] The function to customize copied values.
       * @returns {Object} Returns `object`.
       */
      function copyObject(source, props, object, customizer) {
        var isNew = !object;
        object || (object = {});
        var index = -1,
          length = props.length;
        while (++index < length) {
          var key = props[index];
          var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined$1;
          if (newValue === undefined$1) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue(object, key, newValue);
          } else {
            assignValue(object, key, newValue);
          }
        }
        return object;
      }

      /**
       * Copies own symbols of `source` to `object`.
       *
       * @private
       * @param {Object} source The object to copy symbols from.
       * @param {Object} [object={}] The object to copy symbols to.
       * @returns {Object} Returns `object`.
       */
      function copySymbols(source, object) {
        return copyObject(source, getSymbols(source), object);
      }

      /**
       * Copies own and inherited symbols of `source` to `object`.
       *
       * @private
       * @param {Object} source The object to copy symbols from.
       * @param {Object} [object={}] The object to copy symbols to.
       * @returns {Object} Returns `object`.
       */
      function copySymbolsIn(source, object) {
        return copyObject(source, getSymbolsIn(source), object);
      }

      /**
       * Creates a function like `_.groupBy`.
       *
       * @private
       * @param {Function} setter The function to set accumulator values.
       * @param {Function} [initializer] The accumulator object initializer.
       * @returns {Function} Returns the new aggregator function.
       */
      function createAggregator(setter, initializer) {
        return function (collection, iteratee) {
          var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};
          return func(collection, setter, getIteratee(iteratee, 2), accumulator);
        };
      }

      /**
       * Creates a function like `_.assign`.
       *
       * @private
       * @param {Function} assigner The function to assign values.
       * @returns {Function} Returns the new assigner function.
       */
      function createAssigner(assigner) {
        return baseRest(function (object, sources) {
          var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined$1,
            guard = length > 2 ? sources[2] : undefined$1;
          customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined$1;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined$1 : customizer;
            length = 1;
          }
          object = Object(object);
          while (++index < length) {
            var source = sources[index];
            if (source) {
              assigner(object, source, index, customizer);
            }
          }
          return object;
        });
      }

      /**
       * Creates a `baseEach` or `baseEachRight` function.
       *
       * @private
       * @param {Function} eachFunc The function to iterate over a collection.
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Function} Returns the new base function.
       */
      function createBaseEach(eachFunc, fromRight) {
        return function (collection, iteratee) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee);
          }
          var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);
          while (fromRight ? index-- : ++index < length) {
            if (iteratee(iterable[index], index, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }

      /**
       * Creates a base function for methods like `_.forIn` and `_.forOwn`.
       *
       * @private
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Function} Returns the new base function.
       */
      function createBaseFor(fromRight) {
        return function (object, iteratee, keysFunc) {
          var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;
          while (length--) {
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object;
        };
      }

      /**
       * Creates a function that wraps `func` to invoke it with the optional `this`
       * binding of `thisArg`.
       *
       * @private
       * @param {Function} func The function to wrap.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @param {*} [thisArg] The `this` binding of `func`.
       * @returns {Function} Returns the new wrapped function.
       */
      function createBind(func, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);
        function wrapper() {
          var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          return fn.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
      }

      /**
       * Creates a function like `_.lowerFirst`.
       *
       * @private
       * @param {string} methodName The name of the `String` case method to use.
       * @returns {Function} Returns the new case function.
       */
      function createCaseFirst(methodName) {
        return function (string) {
          string = toString(string);
          var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined$1;
          var chr = strSymbols ? strSymbols[0] : string.charAt(0);
          var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
          return chr[methodName]() + trailing;
        };
      }

      /**
       * Creates a function like `_.camelCase`.
       *
       * @private
       * @param {Function} callback The function to combine each word.
       * @returns {Function} Returns the new compounder function.
       */
      function createCompounder(callback) {
        return function (string) {
          return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
        };
      }

      /**
       * Creates a function that produces an instance of `Ctor` regardless of
       * whether it was invoked as part of a `new` expression or by `call` or `apply`.
       *
       * @private
       * @param {Function} Ctor The constructor to wrap.
       * @returns {Function} Returns the new wrapped function.
       */
      function createCtor(Ctor) {
        return function () {
          // Use a `switch` statement to work with class constructors. See
          // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
          // for more details.
          var args = arguments;
          switch (args.length) {
            case 0:
              return new Ctor();
            case 1:
              return new Ctor(args[0]);
            case 2:
              return new Ctor(args[0], args[1]);
            case 3:
              return new Ctor(args[0], args[1], args[2]);
            case 4:
              return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
              return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
          }
          var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

          // Mimic the constructor's `return` behavior.
          // See https://es5.github.io/#x13.2.2 for more details.
          return isObject(result) ? result : thisBinding;
        };
      }

      /**
       * Creates a function that wraps `func` to enable currying.
       *
       * @private
       * @param {Function} func The function to wrap.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @param {number} arity The arity of `func`.
       * @returns {Function} Returns the new wrapped function.
       */
      function createCurry(func, bitmask, arity) {
        var Ctor = createCtor(func);
        function wrapper() {
          var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);
          while (index--) {
            args[index] = arguments[index];
          }
          var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
          length -= holders.length;
          if (length < arity) {
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined$1, args, holders, undefined$1, undefined$1, arity - length);
          }
          var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          return apply(fn, this, args);
        }
        return wrapper;
      }

      /**
       * Creates a `_.find` or `_.findLast` function.
       *
       * @private
       * @param {Function} findIndexFunc The function to find the collection index.
       * @returns {Function} Returns the new find function.
       */
      function createFind(findIndexFunc) {
        return function (collection, predicate, fromIndex) {
          var iterable = Object(collection);
          if (!isArrayLike(collection)) {
            var iteratee = getIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function (key) {
              return iteratee(iterable[key], key, iterable);
            };
          }
          var index = findIndexFunc(collection, predicate, fromIndex);
          return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined$1;
        };
      }

      /**
       * Creates a `_.flow` or `_.flowRight` function.
       *
       * @private
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Function} Returns the new flow function.
       */
      function createFlow(fromRight) {
        return flatRest(function (funcs) {
          var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;
          if (fromRight) {
            funcs.reverse();
          }
          while (index--) {
            var func = funcs[index];
            if (typeof func != 'function') {
              throw new TypeError(FUNC_ERROR_TEXT);
            }
            if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
              var wrapper = new LodashWrapper([], true);
            }
          }
          index = wrapper ? index : length;
          while (++index < length) {
            func = funcs[index];
            var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined$1;
            if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
              wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
            } else {
              wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
            }
          }
          return function () {
            var args = arguments,
              value = args[0];
            if (wrapper && args.length == 1 && isArray(value)) {
              return wrapper.plant(value).value();
            }
            var index = 0,
              result = length ? funcs[index].apply(this, args) : value;
            while (++index < length) {
              result = funcs[index].call(this, result);
            }
            return result;
          };
        });
      }

      /**
       * Creates a function that wraps `func` to invoke it with optional `this`
       * binding of `thisArg`, partial application, and currying.
       *
       * @private
       * @param {Function|string} func The function or method name to wrap.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @param {*} [thisArg] The `this` binding of `func`.
       * @param {Array} [partials] The arguments to prepend to those provided to
       *  the new function.
       * @param {Array} [holders] The `partials` placeholder indexes.
       * @param {Array} [partialsRight] The arguments to append to those provided
       *  to the new function.
       * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
       * @param {Array} [argPos] The argument positions of the new function.
       * @param {number} [ary] The arity cap of `func`.
       * @param {number} [arity] The arity of `func`.
       * @returns {Function} Returns the new wrapped function.
       */
      function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
        var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined$1 : createCtor(func);
        function wrapper() {
          var length = arguments.length,
            args = Array(length),
            index = length;
          while (index--) {
            args[index] = arguments[index];
          }
          if (isCurried) {
            var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
          }
          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }
          if (partialsRight) {
            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
          }
          length -= holdersCount;
          if (isCurried && length < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
          }
          var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;
          length = args.length;
          if (argPos) {
            args = reorder(args, argPos);
          } else if (isFlip && length > 1) {
            args.reverse();
          }
          if (isAry && ary < length) {
            args.length = ary;
          }
          if (this && this !== root && this instanceof wrapper) {
            fn = Ctor || createCtor(fn);
          }
          return fn.apply(thisBinding, args);
        }
        return wrapper;
      }

      /**
       * Creates a function like `_.invertBy`.
       *
       * @private
       * @param {Function} setter The function to set accumulator values.
       * @param {Function} toIteratee The function to resolve iteratees.
       * @returns {Function} Returns the new inverter function.
       */
      function createInverter(setter, toIteratee) {
        return function (object, iteratee) {
          return baseInverter(object, setter, toIteratee(iteratee), {});
        };
      }

      /**
       * Creates a function that performs a mathematical operation on two values.
       *
       * @private
       * @param {Function} operator The function to perform the operation.
       * @param {number} [defaultValue] The value used for `undefined` arguments.
       * @returns {Function} Returns the new mathematical operation function.
       */
      function createMathOperation(operator, defaultValue) {
        return function (value, other) {
          var result;
          if (value === undefined$1 && other === undefined$1) {
            return defaultValue;
          }
          if (value !== undefined$1) {
            result = value;
          }
          if (other !== undefined$1) {
            if (result === undefined$1) {
              return other;
            }
            if (typeof value == 'string' || typeof other == 'string') {
              value = baseToString(value);
              other = baseToString(other);
            } else {
              value = baseToNumber(value);
              other = baseToNumber(other);
            }
            result = operator(value, other);
          }
          return result;
        };
      }

      /**
       * Creates a function like `_.over`.
       *
       * @private
       * @param {Function} arrayFunc The function to iterate over iteratees.
       * @returns {Function} Returns the new over function.
       */
      function createOver(arrayFunc) {
        return flatRest(function (iteratees) {
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          return baseRest(function (args) {
            var thisArg = this;
            return arrayFunc(iteratees, function (iteratee) {
              return apply(iteratee, thisArg, args);
            });
          });
        });
      }

      /**
       * Creates the padding for `string` based on `length`. The `chars` string
       * is truncated if the number of characters exceeds `length`.
       *
       * @private
       * @param {number} length The padding length.
       * @param {string} [chars=' '] The string used as padding.
       * @returns {string} Returns the padding for `string`.
       */
      function createPadding(length, chars) {
        chars = chars === undefined$1 ? ' ' : baseToString(chars);
        var charsLength = chars.length;
        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars, length) : chars;
        }
        var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
        return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
      }

      /**
       * Creates a function that wraps `func` to invoke it with the `this` binding
       * of `thisArg` and `partials` prepended to the arguments it receives.
       *
       * @private
       * @param {Function} func The function to wrap.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @param {*} thisArg The `this` binding of `func`.
       * @param {Array} partials The arguments to prepend to those provided to
       *  the new function.
       * @returns {Function} Returns the new wrapped function.
       */
      function createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);
        function wrapper() {
          var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }
          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }
          return apply(fn, isBind ? thisArg : this, args);
        }
        return wrapper;
      }

      /**
       * Creates a `_.range` or `_.rangeRight` function.
       *
       * @private
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Function} Returns the new range function.
       */
      function createRange(fromRight) {
        return function (start, end, step) {
          if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
            end = step = undefined$1;
          }
          // Ensure the sign of `-0` is preserved.
          start = toFinite(start);
          if (end === undefined$1) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          step = step === undefined$1 ? start < end ? 1 : -1 : toFinite(step);
          return baseRange(start, end, step, fromRight);
        };
      }

      /**
       * Creates a function that performs a relational operation on two values.
       *
       * @private
       * @param {Function} operator The function to perform the operation.
       * @returns {Function} Returns the new relational operation function.
       */
      function createRelationalOperation(operator) {
        return function (value, other) {
          if (!(typeof value == 'string' && typeof other == 'string')) {
            value = toNumber(value);
            other = toNumber(other);
          }
          return operator(value, other);
        };
      }

      /**
       * Creates a function that wraps `func` to continue currying.
       *
       * @private
       * @param {Function} func The function to wrap.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @param {Function} wrapFunc The function to create the `func` wrapper.
       * @param {*} placeholder The placeholder value.
       * @param {*} [thisArg] The `this` binding of `func`.
       * @param {Array} [partials] The arguments to prepend to those provided to
       *  the new function.
       * @param {Array} [holders] The `partials` placeholder indexes.
       * @param {Array} [argPos] The argument positions of the new function.
       * @param {number} [ary] The arity cap of `func`.
       * @param {number} [arity] The arity of `func`.
       * @returns {Function} Returns the new wrapped function.
       */
      function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
        var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined$1,
          newHoldersRight = isCurry ? undefined$1 : holders,
          newPartials = isCurry ? partials : undefined$1,
          newPartialsRight = isCurry ? undefined$1 : partials;
        bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
        }
        var newData = [func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity];
        var result = wrapFunc.apply(undefined$1, newData);
        if (isLaziable(func)) {
          setData(result, newData);
        }
        result.placeholder = placeholder;
        return setWrapToString(result, func, bitmask);
      }

      /**
       * Creates a function like `_.round`.
       *
       * @private
       * @param {string} methodName The name of the `Math` method to use when rounding.
       * @returns {Function} Returns the new round function.
       */
      function createRound(methodName) {
        var func = Math[methodName];
        return function (number, precision) {
          number = toNumber(number);
          precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
          if (precision && nativeIsFinite(number)) {
            // Shift with exponential notation to avoid floating-point issues.
            // See [MDN](https://mdn.io/round#Examples) for more details.
            var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));
            pair = (toString(value) + 'e').split('e');
            return +(pair[0] + 'e' + (+pair[1] - precision));
          }
          return func(number);
        };
      }

      /**
       * Creates a set object of `values`.
       *
       * @private
       * @param {Array} values The values to add to the set.
       * @returns {Object} Returns the new set.
       */
      var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function (values) {
        return new Set(values);
      };

      /**
       * Creates a `_.toPairs` or `_.toPairsIn` function.
       *
       * @private
       * @param {Function} keysFunc The function to get the keys of a given object.
       * @returns {Function} Returns the new pairs function.
       */
      function createToPairs(keysFunc) {
        return function (object) {
          var tag = getTag(object);
          if (tag == mapTag) {
            return mapToArray(object);
          }
          if (tag == setTag) {
            return setToPairs(object);
          }
          return baseToPairs(object, keysFunc(object));
        };
      }

      /**
       * Creates a function that either curries or invokes `func` with optional
       * `this` binding and partially applied arguments.
       *
       * @private
       * @param {Function|string} func The function or method name to wrap.
       * @param {number} bitmask The bitmask flags.
       *    1 - `_.bind`
       *    2 - `_.bindKey`
       *    4 - `_.curry` or `_.curryRight` of a bound function
       *    8 - `_.curry`
       *   16 - `_.curryRight`
       *   32 - `_.partial`
       *   64 - `_.partialRight`
       *  128 - `_.rearg`
       *  256 - `_.ary`
       *  512 - `_.flip`
       * @param {*} [thisArg] The `this` binding of `func`.
       * @param {Array} [partials] The arguments to be partially applied.
       * @param {Array} [holders] The `partials` placeholder indexes.
       * @param {Array} [argPos] The argument positions of the new function.
       * @param {number} [ary] The arity cap of `func`.
       * @param {number} [arity] The arity of `func`.
       * @returns {Function} Returns the new wrapped function.
       */
      function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        var length = partials ? partials.length : 0;
        if (!length) {
          bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
          partials = holders = undefined$1;
        }
        ary = ary === undefined$1 ? ary : nativeMax(toInteger(ary), 0);
        arity = arity === undefined$1 ? arity : toInteger(arity);
        length -= holders ? holders.length : 0;
        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials,
            holdersRight = holders;
          partials = holders = undefined$1;
        }
        var data = isBindKey ? undefined$1 : getData(func);
        var newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
        if (data) {
          mergeData(newData, data);
        }
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
        }
        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result = createBind(func, bitmask, thisArg);
        } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
          result = createCurry(func, bitmask, arity);
        } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
          result = createPartial(func, bitmask, thisArg, partials);
        } else {
          result = createHybrid.apply(undefined$1, newData);
        }
        var setter = data ? baseSetData : setData;
        return setWrapToString(setter(result, newData), func, bitmask);
      }

      /**
       * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
       * of source objects to the destination object for all destination properties
       * that resolve to `undefined`.
       *
       * @private
       * @param {*} objValue The destination value.
       * @param {*} srcValue The source value.
       * @param {string} key The key of the property to assign.
       * @param {Object} object The parent object of `objValue`.
       * @returns {*} Returns the value to assign.
       */
      function customDefaultsAssignIn(objValue, srcValue, key, object) {
        if (objValue === undefined$1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
          return srcValue;
        }
        return objValue;
      }

      /**
       * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
       * objects into destination objects that are passed thru.
       *
       * @private
       * @param {*} objValue The destination value.
       * @param {*} srcValue The source value.
       * @param {string} key The key of the property to merge.
       * @param {Object} object The parent object of `objValue`.
       * @param {Object} source The parent object of `srcValue`.
       * @param {Object} [stack] Tracks traversed source values and their merged
       *  counterparts.
       * @returns {*} Returns the value to assign.
       */
      function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
        if (isObject(objValue) && isObject(srcValue)) {
          // Recursively merge objects and arrays (susceptible to call stack limits).
          stack.set(srcValue, objValue);
          baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
          stack['delete'](srcValue);
        }
        return objValue;
      }

      /**
       * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
       * objects.
       *
       * @private
       * @param {*} value The value to inspect.
       * @param {string} key The key of the property to inspect.
       * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
       */
      function customOmitClone(value) {
        return isPlainObject(value) ? undefined$1 : value;
      }

      /**
       * A specialized version of `baseIsEqualDeep` for arrays with support for
       * partial deep comparisons.
       *
       * @private
       * @param {Array} array The array to compare.
       * @param {Array} other The other array to compare.
       * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
       * @param {Function} customizer The function to customize comparisons.
       * @param {Function} equalFunc The function to determine equivalents of values.
       * @param {Object} stack Tracks traversed `array` and `other` objects.
       * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
       */
      function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        // Check that cyclic values are equal.
        var arrStacked = stack.get(array);
        var othStacked = stack.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array;
        }
        var index = -1,
          result = true,
          seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$1;
        stack.set(array, other);
        stack.set(other, array);

        // Ignore non-index properties.
        while (++index < arrLength) {
          var arrValue = array[index],
            othValue = other[index];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
          }
          if (compared !== undefined$1) {
            if (compared) {
              continue;
            }
            result = false;
            break;
          }
          // Recursively compare arrays (susceptible to call stack limits).
          if (seen) {
            if (!arraySome(other, function (othValue, othIndex) {
              if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
              result = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
          }
        }
        stack['delete'](array);
        stack['delete'](other);
        return result;
      }

      /**
       * A specialized version of `baseIsEqualDeep` for comparing objects of
       * the same `toStringTag`.
       *
       * **Note:** This function only supports comparing values with tags of
       * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
       *
       * @private
       * @param {Object} object The object to compare.
       * @param {Object} other The other object to compare.
       * @param {string} tag The `toStringTag` of the objects to compare.
       * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
       * @param {Function} customizer The function to customize comparisons.
       * @param {Function} equalFunc The function to determine equivalents of values.
       * @param {Object} stack Tracks traversed `object` and `other` objects.
       * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
       */
      function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
              return false;
            }
            object = object.buffer;
            other = other.buffer;
          case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
              return false;
            }
            return true;
          case boolTag:
          case dateTag:
          case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
          case errorTag:
            return object.name == other.name && object.message == other.message;
          case regexpTag:
          case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
          case mapTag:
            var convert = mapToArray;
          case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) {
              return false;
            }
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG;

            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
          case symbolTag:
            if (symbolValueOf) {
              return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
        }
        return false;
      }

      /**
       * A specialized version of `baseIsEqualDeep` for objects with support for
       * partial deep comparisons.
       *
       * @private
       * @param {Object} object The object to compare.
       * @param {Object} other The other object to compare.
       * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
       * @param {Function} customizer The function to customize comparisons.
       * @param {Function} equalFunc The function to determine equivalents of values.
       * @param {Object} stack Tracks traversed `object` and `other` objects.
       * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
       */
      function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;
        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index = objLength;
        while (index--) {
          var key = objProps[index];
          if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
            return false;
          }
        }
        // Check that cyclic values are equal.
        var objStacked = stack.get(object);
        var othStacked = stack.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object;
        }
        var result = true;
        stack.set(object, other);
        stack.set(other, object);
        var skipCtor = isPartial;
        while (++index < objLength) {
          key = objProps[index];
          var objValue = object[key],
            othValue = other[key];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
          }
          // Recursively compare objects (susceptible to call stack limits).
          if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
          }
          skipCtor || (skipCtor = key == 'constructor');
        }
        if (result && !skipCtor) {
          var objCtor = object.constructor,
            othCtor = other.constructor;

          // Non `Object` object instances with different constructors are not equal.
          if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
            result = false;
          }
        }
        stack['delete'](object);
        stack['delete'](other);
        return result;
      }

      /**
       * A specialized version of `baseRest` which flattens the rest array.
       *
       * @private
       * @param {Function} func The function to apply a rest parameter to.
       * @returns {Function} Returns the new function.
       */
      function flatRest(func) {
        return setToString(overRest(func, undefined$1, flatten), func + '');
      }

      /**
       * Creates an array of own enumerable property names and symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names and symbols.
       */
      function getAllKeys(object) {
        return baseGetAllKeys(object, keys, getSymbols);
      }

      /**
       * Creates an array of own and inherited enumerable property names and
       * symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names and symbols.
       */
      function getAllKeysIn(object) {
        return baseGetAllKeys(object, keysIn, getSymbolsIn);
      }

      /**
       * Gets metadata for `func`.
       *
       * @private
       * @param {Function} func The function to query.
       * @returns {*} Returns the metadata for `func`.
       */
      var getData = !metaMap ? noop : function (func) {
        return metaMap.get(func);
      };

      /**
       * Gets the name of `func`.
       *
       * @private
       * @param {Function} func The function to query.
       * @returns {string} Returns the function name.
       */
      function getFuncName(func) {
        var result = func.name + '',
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
        while (length--) {
          var data = array[length],
            otherFunc = data.func;
          if (otherFunc == null || otherFunc == func) {
            return data.name;
          }
        }
        return result;
      }

      /**
       * Gets the argument placeholder value for `func`.
       *
       * @private
       * @param {Function} func The function to inspect.
       * @returns {*} Returns the placeholder value.
       */
      function getHolder(func) {
        var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
        return object.placeholder;
      }

      /**
       * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
       * this function returns the custom method, otherwise it returns `baseIteratee`.
       * If arguments are provided, the chosen function is invoked with them and
       * its result is returned.
       *
       * @private
       * @param {*} [value] The value to convert to an iteratee.
       * @param {number} [arity] The arity of the created iteratee.
       * @returns {Function} Returns the chosen function or its result.
       */
      function getIteratee() {
        var result = lodash.iteratee || iteratee;
        result = result === iteratee ? baseIteratee : result;
        return arguments.length ? result(arguments[0], arguments[1]) : result;
      }

      /**
       * Gets the data for `map`.
       *
       * @private
       * @param {Object} map The map to query.
       * @param {string} key The reference key.
       * @returns {*} Returns the map data.
       */
      function getMapData(map, key) {
        var data = map.__data__;
        return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
      }

      /**
       * Gets the property names, values, and compare flags of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the match data of `object`.
       */
      function getMatchData(object) {
        var result = keys(object),
          length = result.length;
        while (length--) {
          var key = result[length],
            value = object[key];
          result[length] = [key, value, isStrictComparable(value)];
        }
        return result;
      }

      /**
       * Gets the native function at `key` of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {string} key The key of the method to get.
       * @returns {*} Returns the function if it's native, else `undefined`.
       */
      function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined$1;
      }

      /**
       * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the raw `toStringTag`.
       */
      function getRawTag(value) {
        var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];
        try {
          value[symToStringTag] = undefined$1;
          var unmasked = true;
        } catch (e) {}
        var result = nativeObjectToString.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }
        return result;
      }

      /**
       * Creates an array of the own enumerable symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of symbols.
       */
      var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
        if (object == null) {
          return [];
        }
        object = Object(object);
        return arrayFilter(nativeGetSymbols(object), function (symbol) {
          return propertyIsEnumerable.call(object, symbol);
        });
      };

      /**
       * Creates an array of the own and inherited enumerable symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of symbols.
       */
      var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
        var result = [];
        while (object) {
          arrayPush(result, getSymbols(object));
          object = getPrototype(object);
        }
        return result;
      };

      /**
       * Gets the `toStringTag` of `value`.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the `toStringTag`.
       */
      var getTag = baseGetTag;

      // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
      if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
        getTag = function (value) {
          var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined$1,
            ctorString = Ctor ? toSource(Ctor) : '';
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString:
                return dataViewTag;
              case mapCtorString:
                return mapTag;
              case promiseCtorString:
                return promiseTag;
              case setCtorString:
                return setTag;
              case weakMapCtorString:
                return weakMapTag;
            }
          }
          return result;
        };
      }

      /**
       * Gets the view, applying any `transforms` to the `start` and `end` positions.
       *
       * @private
       * @param {number} start The start of the view.
       * @param {number} end The end of the view.
       * @param {Array} transforms The transformations to apply to the view.
       * @returns {Object} Returns an object containing the `start` and `end`
       *  positions of the view.
       */
      function getView(start, end, transforms) {
        var index = -1,
          length = transforms.length;
        while (++index < length) {
          var data = transforms[index],
            size = data.size;
          switch (data.type) {
            case 'drop':
              start += size;
              break;
            case 'dropRight':
              end -= size;
              break;
            case 'take':
              end = nativeMin(end, start + size);
              break;
            case 'takeRight':
              start = nativeMax(start, end - size);
              break;
          }
        }
        return {
          'start': start,
          'end': end
        };
      }

      /**
       * Extracts wrapper details from the `source` body comment.
       *
       * @private
       * @param {string} source The source to inspect.
       * @returns {Array} Returns the wrapper details.
       */
      function getWrapDetails(source) {
        var match = source.match(reWrapDetails);
        return match ? match[1].split(reSplitDetails) : [];
      }

      /**
       * Checks if `path` exists on `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array|string} path The path to check.
       * @param {Function} hasFunc The function to check properties.
       * @returns {boolean} Returns `true` if `path` exists, else `false`.
       */
      function hasPath(object, path, hasFunc) {
        path = castPath(path, object);
        var index = -1,
          length = path.length,
          result = false;
        while (++index < length) {
          var key = toKey(path[index]);
          if (!(result = object != null && hasFunc(object, key))) {
            break;
          }
          object = object[key];
        }
        if (result || ++index != length) {
          return result;
        }
        length = object == null ? 0 : object.length;
        return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
      }

      /**
       * Initializes an array clone.
       *
       * @private
       * @param {Array} array The array to clone.
       * @returns {Array} Returns the initialized clone.
       */
      function initCloneArray(array) {
        var length = array.length,
          result = new array.constructor(length);

        // Add properties assigned by `RegExp#exec`.
        if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
          result.index = array.index;
          result.input = array.input;
        }
        return result;
      }

      /**
       * Initializes an object clone.
       *
       * @private
       * @param {Object} object The object to clone.
       * @returns {Object} Returns the initialized clone.
       */
      function initCloneObject(object) {
        return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
      }

      /**
       * Initializes an object clone based on its `toStringTag`.
       *
       * **Note:** This function only supports cloning values with tags of
       * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
       *
       * @private
       * @param {Object} object The object to clone.
       * @param {string} tag The `toStringTag` of the object to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Object} Returns the initialized clone.
       */
      function initCloneByTag(object, tag, isDeep) {
        var Ctor = object.constructor;
        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object);
          case boolTag:
          case dateTag:
            return new Ctor(+object);
          case dataViewTag:
            return cloneDataView(object, isDeep);
          case float32Tag:
          case float64Tag:
          case int8Tag:
          case int16Tag:
          case int32Tag:
          case uint8Tag:
          case uint8ClampedTag:
          case uint16Tag:
          case uint32Tag:
            return cloneTypedArray(object, isDeep);
          case mapTag:
            return new Ctor();
          case numberTag:
          case stringTag:
            return new Ctor(object);
          case regexpTag:
            return cloneRegExp(object);
          case setTag:
            return new Ctor();
          case symbolTag:
            return cloneSymbol(object);
        }
      }

      /**
       * Inserts wrapper `details` in a comment at the top of the `source` body.
       *
       * @private
       * @param {string} source The source to modify.
       * @returns {Array} details The details to insert.
       * @returns {string} Returns the modified source.
       */
      function insertWrapDetails(source, details) {
        var length = details.length;
        if (!length) {
          return source;
        }
        var lastIndex = length - 1;
        details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
        details = details.join(length > 2 ? ', ' : ' ');
        return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
      }

      /**
       * Checks if `value` is a flattenable `arguments` object or array.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
       */
      function isFlattenable(value) {
        return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
      }

      /**
       * Checks if `value` is a valid array-like index.
       *
       * @private
       * @param {*} value The value to check.
       * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
       * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
       */
      function isIndex(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER : length;
        return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
      }

      /**
       * Checks if the given arguments are from an iteratee call.
       *
       * @private
       * @param {*} value The potential iteratee value argument.
       * @param {*} index The potential iteratee index or key argument.
       * @param {*} object The potential iteratee object argument.
       * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
       *  else `false`.
       */
      function isIterateeCall(value, index, object) {
        if (!isObject(object)) {
          return false;
        }
        var type = typeof index;
        if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
          return eq(object[index], value);
        }
        return false;
      }

      /**
       * Checks if `value` is a property name and not a property path.
       *
       * @private
       * @param {*} value The value to check.
       * @param {Object} [object] The object to query keys on.
       * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
       */
      function isKey(value, object) {
        if (isArray(value)) {
          return false;
        }
        var type = typeof value;
        if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
          return true;
        }
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
      }

      /**
       * Checks if `value` is suitable for use as unique object key.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
       */
      function isKeyable(value) {
        var type = typeof value;
        return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
      }

      /**
       * Checks if `func` has a lazy counterpart.
       *
       * @private
       * @param {Function} func The function to check.
       * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
       *  else `false`.
       */
      function isLaziable(func) {
        var funcName = getFuncName(func),
          other = lodash[funcName];
        if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
          return false;
        }
        if (func === other) {
          return true;
        }
        var data = getData(other);
        return !!data && func === data[0];
      }

      /**
       * Checks if `func` has its source masked.
       *
       * @private
       * @param {Function} func The function to check.
       * @returns {boolean} Returns `true` if `func` is masked, else `false`.
       */
      function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
      }

      /**
       * Checks if `func` is capable of being masked.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
       */
      var isMaskable = coreJsData ? isFunction : stubFalse;

      /**
       * Checks if `value` is likely a prototype object.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
       */
      function isPrototype(value) {
        var Ctor = value && value.constructor,
          proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
        return value === proto;
      }

      /**
       * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` if suitable for strict
       *  equality comparisons, else `false`.
       */
      function isStrictComparable(value) {
        return value === value && !isObject(value);
      }

      /**
       * A specialized version of `matchesProperty` for source values suitable
       * for strict equality comparisons, i.e. `===`.
       *
       * @private
       * @param {string} key The key of the property to get.
       * @param {*} srcValue The value to match.
       * @returns {Function} Returns the new spec function.
       */
      function matchesStrictComparable(key, srcValue) {
        return function (object) {
          if (object == null) {
            return false;
          }
          return object[key] === srcValue && (srcValue !== undefined$1 || key in Object(object));
        };
      }

      /**
       * A specialized version of `_.memoize` which clears the memoized function's
       * cache when it exceeds `MAX_MEMOIZE_SIZE`.
       *
       * @private
       * @param {Function} func The function to have its output memoized.
       * @returns {Function} Returns the new memoized function.
       */
      function memoizeCapped(func) {
        var result = memoize(func, function (key) {
          if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
          }
          return key;
        });
        var cache = result.cache;
        return result;
      }

      /**
       * Merges the function metadata of `source` into `data`.
       *
       * Merging metadata reduces the number of wrappers used to invoke a function.
       * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
       * may be applied regardless of execution order. Methods like `_.ary` and
       * `_.rearg` modify function arguments, making the order in which they are
       * executed important, preventing the merging of metadata. However, we make
       * an exception for a safe combined case where curried functions have `_.ary`
       * and or `_.rearg` applied.
       *
       * @private
       * @param {Array} data The destination metadata.
       * @param {Array} source The source metadata.
       * @returns {Array} Returns `data`.
       */
      function mergeData(data, source) {
        var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
        var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;

        // Exit early if metadata can't be merged.
        if (!(isCommon || isCombo)) {
          return data;
        }
        // Use source `thisArg` if available.
        if (srcBitmask & WRAP_BIND_FLAG) {
          data[2] = source[2];
          // Set when currying a bound function.
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }
        // Compose partial arguments.
        var value = source[3];
        if (value) {
          var partials = data[3];
          data[3] = partials ? composeArgs(partials, value, source[4]) : value;
          data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
        }
        // Compose partial right arguments.
        value = source[5];
        if (value) {
          partials = data[5];
          data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
          data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
        }
        // Use source `argPos` if available.
        value = source[7];
        if (value) {
          data[7] = value;
        }
        // Use source `ary` if it's smaller.
        if (srcBitmask & WRAP_ARY_FLAG) {
          data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
        }
        // Use source `arity` if one is not provided.
        if (data[9] == null) {
          data[9] = source[9];
        }
        // Use source `func` and merge bitmasks.
        data[0] = source[0];
        data[1] = newBitmask;
        return data;
      }

      /**
       * This function is like
       * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
       * except that it includes inherited enumerable properties.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       */
      function nativeKeysIn(object) {
        var result = [];
        if (object != null) {
          for (var key in Object(object)) {
            result.push(key);
          }
        }
        return result;
      }

      /**
       * Converts `value` to a string using `Object.prototype.toString`.
       *
       * @private
       * @param {*} value The value to convert.
       * @returns {string} Returns the converted string.
       */
      function objectToString(value) {
        return nativeObjectToString.call(value);
      }

      /**
       * A specialized version of `baseRest` which transforms the rest array.
       *
       * @private
       * @param {Function} func The function to apply a rest parameter to.
       * @param {number} [start=func.length-1] The start position of the rest parameter.
       * @param {Function} transform The rest array transform.
       * @returns {Function} Returns the new function.
       */
      function overRest(func, start, transform) {
        start = nativeMax(start === undefined$1 ? func.length - 1 : start, 0);
        return function () {
          var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);
          while (++index < length) {
            array[index] = args[start + index];
          }
          index = -1;
          var otherArgs = Array(start + 1);
          while (++index < start) {
            otherArgs[index] = args[index];
          }
          otherArgs[start] = transform(array);
          return apply(func, this, otherArgs);
        };
      }

      /**
       * Gets the parent value at `path` of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array} path The path to get the parent value of.
       * @returns {*} Returns the parent value.
       */
      function parent(object, path) {
        return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
      }

      /**
       * Reorder `array` according to the specified indexes where the element at
       * the first index is assigned as the first element, the element at
       * the second index is assigned as the second element, and so on.
       *
       * @private
       * @param {Array} array The array to reorder.
       * @param {Array} indexes The arranged array indexes.
       * @returns {Array} Returns `array`.
       */
      function reorder(array, indexes) {
        var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);
        while (length--) {
          var index = indexes[length];
          array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
        }
        return array;
      }

      /**
       * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
       *
       * @private
       * @param {Object} object The object to query.
       * @param {string} key The key of the property to get.
       * @returns {*} Returns the property value.
       */
      function safeGet(object, key) {
        if (key === 'constructor' && typeof object[key] === 'function') {
          return;
        }
        if (key == '__proto__') {
          return;
        }
        return object[key];
      }

      /**
       * Sets metadata for `func`.
       *
       * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
       * period of time, it will trip its breaker and transition to an identity
       * function to avoid garbage collection pauses in V8. See
       * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
       * for more details.
       *
       * @private
       * @param {Function} func The function to associate metadata with.
       * @param {*} data The metadata.
       * @returns {Function} Returns `func`.
       */
      var setData = shortOut(baseSetData);

      /**
       * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
       *
       * @private
       * @param {Function} func The function to delay.
       * @param {number} wait The number of milliseconds to delay invocation.
       * @returns {number|Object} Returns the timer id or timeout object.
       */
      var setTimeout = ctxSetTimeout || function (func, wait) {
        return root.setTimeout(func, wait);
      };

      /**
       * Sets the `toString` method of `func` to return `string`.
       *
       * @private
       * @param {Function} func The function to modify.
       * @param {Function} string The `toString` result.
       * @returns {Function} Returns `func`.
       */
      var setToString = shortOut(baseSetToString);

      /**
       * Sets the `toString` method of `wrapper` to mimic the source of `reference`
       * with wrapper details in a comment at the top of the source body.
       *
       * @private
       * @param {Function} wrapper The function to modify.
       * @param {Function} reference The reference function.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @returns {Function} Returns `wrapper`.
       */
      function setWrapToString(wrapper, reference, bitmask) {
        var source = reference + '';
        return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
      }

      /**
       * Creates a function that'll short out and invoke `identity` instead
       * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
       * milliseconds.
       *
       * @private
       * @param {Function} func The function to restrict.
       * @returns {Function} Returns the new shortable function.
       */
      function shortOut(func) {
        var count = 0,
          lastCalled = 0;
        return function () {
          var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(undefined$1, arguments);
        };
      }

      /**
       * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
       *
       * @private
       * @param {Array} array The array to shuffle.
       * @param {number} [size=array.length] The size of `array`.
       * @returns {Array} Returns `array`.
       */
      function shuffleSelf(array, size) {
        var index = -1,
          length = array.length,
          lastIndex = length - 1;
        size = size === undefined$1 ? length : size;
        while (++index < size) {
          var rand = baseRandom(index, lastIndex),
            value = array[rand];
          array[rand] = array[index];
          array[index] = value;
        }
        array.length = size;
        return array;
      }

      /**
       * Converts `string` to a property path array.
       *
       * @private
       * @param {string} string The string to convert.
       * @returns {Array} Returns the property path array.
       */
      var stringToPath = memoizeCapped(function (string) {
        var result = [];
        if (string.charCodeAt(0) === 46 /* . */) {
          result.push('');
        }
        string.replace(rePropName, function (match, number, quote, subString) {
          result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
        });
        return result;
      });

      /**
       * Converts `value` to a string key if it's not a string or symbol.
       *
       * @private
       * @param {*} value The value to inspect.
       * @returns {string|symbol} Returns the key.
       */
      function toKey(value) {
        if (typeof value == 'string' || isSymbol(value)) {
          return value;
        }
        var result = value + '';
        return result == '0' && 1 / value == -INFINITY ? '-0' : result;
      }

      /**
       * Converts `func` to its source code.
       *
       * @private
       * @param {Function} func The function to convert.
       * @returns {string} Returns the source code.
       */
      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e) {}
          try {
            return func + '';
          } catch (e) {}
        }
        return '';
      }

      /**
       * Updates wrapper `details` based on `bitmask` flags.
       *
       * @private
       * @returns {Array} details The details to modify.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @returns {Array} Returns `details`.
       */
      function updateWrapDetails(details, bitmask) {
        arrayEach(wrapFlags, function (pair) {
          var value = '_.' + pair[0];
          if (bitmask & pair[1] && !arrayIncludes(details, value)) {
            details.push(value);
          }
        });
        return details.sort();
      }

      /**
       * Creates a clone of `wrapper`.
       *
       * @private
       * @param {Object} wrapper The wrapper to clone.
       * @returns {Object} Returns the cloned wrapper.
       */
      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }
        var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result.__actions__ = copyArray(wrapper.__actions__);
        result.__index__ = wrapper.__index__;
        result.__values__ = wrapper.__values__;
        return result;
      }

      /*------------------------------------------------------------------------*/

      /**
       * Creates an array of elements split into groups the length of `size`.
       * If `array` can't be split evenly, the final chunk will be the remaining
       * elements.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to process.
       * @param {number} [size=1] The length of each chunk
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the new array of chunks.
       * @example
       *
       * _.chunk(['a', 'b', 'c', 'd'], 2);
       * // => [['a', 'b'], ['c', 'd']]
       *
       * _.chunk(['a', 'b', 'c', 'd'], 3);
       * // => [['a', 'b', 'c'], ['d']]
       */
      function chunk(array, size, guard) {
        if (guard ? isIterateeCall(array, size, guard) : size === undefined$1) {
          size = 1;
        } else {
          size = nativeMax(toInteger(size), 0);
        }
        var length = array == null ? 0 : array.length;
        if (!length || size < 1) {
          return [];
        }
        var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));
        while (index < length) {
          result[resIndex++] = baseSlice(array, index, index += size);
        }
        return result;
      }

      /**
       * Creates an array with all falsey values removed. The values `false`, `null`,
       * `0`, `""`, `undefined`, and `NaN` are falsey.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to compact.
       * @returns {Array} Returns the new array of filtered values.
       * @example
       *
       * _.compact([0, 1, false, 2, '', 3]);
       * // => [1, 2, 3]
       */
      function compact(array) {
        var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];
        while (++index < length) {
          var value = array[index];
          if (value) {
            result[resIndex++] = value;
          }
        }
        return result;
      }

      /**
       * Creates a new array concatenating `array` with any additional arrays
       * and/or values.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to concatenate.
       * @param {...*} [values] The values to concatenate.
       * @returns {Array} Returns the new concatenated array.
       * @example
       *
       * var array = [1];
       * var other = _.concat(array, 2, [3], [[4]]);
       *
       * console.log(other);
       * // => [1, 2, 3, [4]]
       *
       * console.log(array);
       * // => [1]
       */
      function concat() {
        var length = arguments.length;
        if (!length) {
          return [];
        }
        var args = Array(length - 1),
          array = arguments[0],
          index = length;
        while (index--) {
          args[index - 1] = arguments[index];
        }
        return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
      }

      /**
       * Creates an array of `array` values not included in the other given arrays
       * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons. The order and references of result values are
       * determined by the first array.
       *
       * **Note:** Unlike `_.pullAll`, this method returns a new array.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {...Array} [values] The values to exclude.
       * @returns {Array} Returns the new array of filtered values.
       * @see _.without, _.xor
       * @example
       *
       * _.difference([2, 1], [2, 3]);
       * // => [1]
       */
      var difference = baseRest(function (array, values) {
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
      });

      /**
       * This method is like `_.difference` except that it accepts `iteratee` which
       * is invoked for each element of `array` and `values` to generate the criterion
       * by which they're compared. The order and references of result values are
       * determined by the first array. The iteratee is invoked with one argument:
       * (value).
       *
       * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {...Array} [values] The values to exclude.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       * @example
       *
       * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
       * // => [1.2]
       *
       * // The `_.property` iteratee shorthand.
       * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
       * // => [{ 'x': 2 }]
       */
      var differenceBy = baseRest(function (array, values) {
        var iteratee = last(values);
        if (isArrayLikeObject(iteratee)) {
          iteratee = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
      });

      /**
       * This method is like `_.difference` except that it accepts `comparator`
       * which is invoked to compare elements of `array` to `values`. The order and
       * references of result values are determined by the first array. The comparator
       * is invoked with two arguments: (arrVal, othVal).
       *
       * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {...Array} [values] The values to exclude.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       * @example
       *
       * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
       *
       * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
       * // => [{ 'x': 2, 'y': 1 }]
       */
      var differenceWith = baseRest(function (array, values) {
        var comparator = last(values);
        if (isArrayLikeObject(comparator)) {
          comparator = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined$1, comparator) : [];
      });

      /**
       * Creates a slice of `array` with `n` elements dropped from the beginning.
       *
       * @static
       * @memberOf _
       * @since 0.5.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {number} [n=1] The number of elements to drop.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * _.drop([1, 2, 3]);
       * // => [2, 3]
       *
       * _.drop([1, 2, 3], 2);
       * // => [3]
       *
       * _.drop([1, 2, 3], 5);
       * // => []
       *
       * _.drop([1, 2, 3], 0);
       * // => [1, 2, 3]
       */
      function drop(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        return baseSlice(array, n < 0 ? 0 : n, length);
      }

      /**
       * Creates a slice of `array` with `n` elements dropped from the end.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {number} [n=1] The number of elements to drop.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * _.dropRight([1, 2, 3]);
       * // => [1, 2]
       *
       * _.dropRight([1, 2, 3], 2);
       * // => [1]
       *
       * _.dropRight([1, 2, 3], 5);
       * // => []
       *
       * _.dropRight([1, 2, 3], 0);
       * // => [1, 2, 3]
       */
      function dropRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }

      /**
       * Creates a slice of `array` excluding elements dropped from the end.
       * Elements are dropped until `predicate` returns falsey. The predicate is
       * invoked with three arguments: (value, index, array).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'active': true },
       *   { 'user': 'fred',    'active': false },
       *   { 'user': 'pebbles', 'active': false }
       * ];
       *
       * _.dropRightWhile(users, function(o) { return !o.active; });
       * // => objects for ['barney']
       *
       * // The `_.matches` iteratee shorthand.
       * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
       * // => objects for ['barney', 'fred']
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.dropRightWhile(users, ['active', false]);
       * // => objects for ['barney']
       *
       * // The `_.property` iteratee shorthand.
       * _.dropRightWhile(users, 'active');
       * // => objects for ['barney', 'fred', 'pebbles']
       */
      function dropRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
      }

      /**
       * Creates a slice of `array` excluding elements dropped from the beginning.
       * Elements are dropped until `predicate` returns falsey. The predicate is
       * invoked with three arguments: (value, index, array).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'active': false },
       *   { 'user': 'fred',    'active': false },
       *   { 'user': 'pebbles', 'active': true }
       * ];
       *
       * _.dropWhile(users, function(o) { return !o.active; });
       * // => objects for ['pebbles']
       *
       * // The `_.matches` iteratee shorthand.
       * _.dropWhile(users, { 'user': 'barney', 'active': false });
       * // => objects for ['fred', 'pebbles']
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.dropWhile(users, ['active', false]);
       * // => objects for ['pebbles']
       *
       * // The `_.property` iteratee shorthand.
       * _.dropWhile(users, 'active');
       * // => objects for ['barney', 'fred', 'pebbles']
       */
      function dropWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
      }

      /**
       * Fills elements of `array` with `value` from `start` up to, but not
       * including, `end`.
       *
       * **Note:** This method mutates `array`.
       *
       * @static
       * @memberOf _
       * @since 3.2.0
       * @category Array
       * @param {Array} array The array to fill.
       * @param {*} value The value to fill `array` with.
       * @param {number} [start=0] The start position.
       * @param {number} [end=array.length] The end position.
       * @returns {Array} Returns `array`.
       * @example
       *
       * var array = [1, 2, 3];
       *
       * _.fill(array, 'a');
       * console.log(array);
       * // => ['a', 'a', 'a']
       *
       * _.fill(Array(3), 2);
       * // => [2, 2, 2]
       *
       * _.fill([4, 6, 8, 10], '*', 1, 3);
       * // => [4, '*', '*', 10]
       */
      function fill(array, value, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
          start = 0;
          end = length;
        }
        return baseFill(array, value, start, end);
      }

      /**
       * This method is like `_.find` except that it returns the index of the first
       * element `predicate` returns truthy for instead of the element itself.
       *
       * @static
       * @memberOf _
       * @since 1.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @param {number} [fromIndex=0] The index to search from.
       * @returns {number} Returns the index of the found element, else `-1`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'active': false },
       *   { 'user': 'fred',    'active': false },
       *   { 'user': 'pebbles', 'active': true }
       * ];
       *
       * _.findIndex(users, function(o) { return o.user == 'barney'; });
       * // => 0
       *
       * // The `_.matches` iteratee shorthand.
       * _.findIndex(users, { 'user': 'fred', 'active': false });
       * // => 1
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.findIndex(users, ['active', false]);
       * // => 0
       *
       * // The `_.property` iteratee shorthand.
       * _.findIndex(users, 'active');
       * // => 2
       */
      function findIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index < 0) {
          index = nativeMax(length + index, 0);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index);
      }

      /**
       * This method is like `_.findIndex` except that it iterates over elements
       * of `collection` from right to left.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @param {number} [fromIndex=array.length-1] The index to search from.
       * @returns {number} Returns the index of the found element, else `-1`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'active': true },
       *   { 'user': 'fred',    'active': false },
       *   { 'user': 'pebbles', 'active': false }
       * ];
       *
       * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
       * // => 2
       *
       * // The `_.matches` iteratee shorthand.
       * _.findLastIndex(users, { 'user': 'barney', 'active': true });
       * // => 0
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.findLastIndex(users, ['active', false]);
       * // => 2
       *
       * // The `_.property` iteratee shorthand.
       * _.findLastIndex(users, 'active');
       * // => 0
       */
      function findLastIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = length - 1;
        if (fromIndex !== undefined$1) {
          index = toInteger(fromIndex);
          index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index, true);
      }

      /**
       * Flattens `array` a single level deep.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to flatten.
       * @returns {Array} Returns the new flattened array.
       * @example
       *
       * _.flatten([1, [2, [3, [4]], 5]]);
       * // => [1, 2, [3, [4]], 5]
       */
      function flatten(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, 1) : [];
      }

      /**
       * Recursively flattens `array`.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to flatten.
       * @returns {Array} Returns the new flattened array.
       * @example
       *
       * _.flattenDeep([1, [2, [3, [4]], 5]]);
       * // => [1, 2, 3, 4, 5]
       */
      function flattenDeep(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, INFINITY) : [];
      }

      /**
       * Recursively flatten `array` up to `depth` times.
       *
       * @static
       * @memberOf _
       * @since 4.4.0
       * @category Array
       * @param {Array} array The array to flatten.
       * @param {number} [depth=1] The maximum recursion depth.
       * @returns {Array} Returns the new flattened array.
       * @example
       *
       * var array = [1, [2, [3, [4]], 5]];
       *
       * _.flattenDepth(array, 1);
       * // => [1, 2, [3, [4]], 5]
       *
       * _.flattenDepth(array, 2);
       * // => [1, 2, 3, [4], 5]
       */
      function flattenDepth(array, depth) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(array, depth);
      }

      /**
       * The inverse of `_.toPairs`; this method returns an object composed
       * from key-value `pairs`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} pairs The key-value pairs.
       * @returns {Object} Returns the new object.
       * @example
       *
       * _.fromPairs([['a', 1], ['b', 2]]);
       * // => { 'a': 1, 'b': 2 }
       */
      function fromPairs(pairs) {
        var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};
        while (++index < length) {
          var pair = pairs[index];
          result[pair[0]] = pair[1];
        }
        return result;
      }

      /**
       * Gets the first element of `array`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @alias first
       * @category Array
       * @param {Array} array The array to query.
       * @returns {*} Returns the first element of `array`.
       * @example
       *
       * _.head([1, 2, 3]);
       * // => 1
       *
       * _.head([]);
       * // => undefined
       */
      function head(array) {
        return array && array.length ? array[0] : undefined$1;
      }

      /**
       * Gets the index at which the first occurrence of `value` is found in `array`
       * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons. If `fromIndex` is negative, it's used as the
       * offset from the end of `array`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @param {number} [fromIndex=0] The index to search from.
       * @returns {number} Returns the index of the matched value, else `-1`.
       * @example
       *
       * _.indexOf([1, 2, 1, 2], 2);
       * // => 1
       *
       * // Search from the `fromIndex`.
       * _.indexOf([1, 2, 1, 2], 2, 2);
       * // => 3
       */
      function indexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index < 0) {
          index = nativeMax(length + index, 0);
        }
        return baseIndexOf(array, value, index);
      }

      /**
       * Gets all but the last element of `array`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to query.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * _.initial([1, 2, 3]);
       * // => [1, 2]
       */
      function initial(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 0, -1) : [];
      }

      /**
       * Creates an array of unique values that are included in all given arrays
       * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons. The order and references of result values are
       * determined by the first array.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @returns {Array} Returns the new array of intersecting values.
       * @example
       *
       * _.intersection([2, 1], [2, 3]);
       * // => [2]
       */
      var intersection = baseRest(function (arrays) {
        var mapped = arrayMap(arrays, castArrayLikeObject);
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
      });

      /**
       * This method is like `_.intersection` except that it accepts `iteratee`
       * which is invoked for each element of each `arrays` to generate the criterion
       * by which they're compared. The order and references of result values are
       * determined by the first array. The iteratee is invoked with one argument:
       * (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns the new array of intersecting values.
       * @example
       *
       * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
       * // => [2.1]
       *
       * // The `_.property` iteratee shorthand.
       * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
       * // => [{ 'x': 1 }]
       */
      var intersectionBy = baseRest(function (arrays) {
        var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);
        if (iteratee === last(mapped)) {
          iteratee = undefined$1;
        } else {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
      });

      /**
       * This method is like `_.intersection` except that it accepts `comparator`
       * which is invoked to compare elements of `arrays`. The order and references
       * of result values are determined by the first array. The comparator is
       * invoked with two arguments: (arrVal, othVal).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of intersecting values.
       * @example
       *
       * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
       * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
       *
       * _.intersectionWith(objects, others, _.isEqual);
       * // => [{ 'x': 1, 'y': 2 }]
       */
      var intersectionWith = baseRest(function (arrays) {
        var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);
        comparator = typeof comparator == 'function' ? comparator : undefined$1;
        if (comparator) {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
      });

      /**
       * Converts all elements in `array` into a string separated by `separator`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to convert.
       * @param {string} [separator=','] The element separator.
       * @returns {string} Returns the joined string.
       * @example
       *
       * _.join(['a', 'b', 'c'], '~');
       * // => 'a~b~c'
       */
      function join(array, separator) {
        return array == null ? '' : nativeJoin.call(array, separator);
      }

      /**
       * Gets the last element of `array`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to query.
       * @returns {*} Returns the last element of `array`.
       * @example
       *
       * _.last([1, 2, 3]);
       * // => 3
       */
      function last(array) {
        var length = array == null ? 0 : array.length;
        return length ? array[length - 1] : undefined$1;
      }

      /**
       * This method is like `_.indexOf` except that it iterates over elements of
       * `array` from right to left.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @param {number} [fromIndex=array.length-1] The index to search from.
       * @returns {number} Returns the index of the matched value, else `-1`.
       * @example
       *
       * _.lastIndexOf([1, 2, 1, 2], 2);
       * // => 3
       *
       * // Search from the `fromIndex`.
       * _.lastIndexOf([1, 2, 1, 2], 2, 2);
       * // => 1
       */
      function lastIndexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = length;
        if (fromIndex !== undefined$1) {
          index = toInteger(fromIndex);
          index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
        }
        return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
      }

      /**
       * Gets the element at index `n` of `array`. If `n` is negative, the nth
       * element from the end is returned.
       *
       * @static
       * @memberOf _
       * @since 4.11.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {number} [n=0] The index of the element to return.
       * @returns {*} Returns the nth element of `array`.
       * @example
       *
       * var array = ['a', 'b', 'c', 'd'];
       *
       * _.nth(array, 1);
       * // => 'b'
       *
       * _.nth(array, -2);
       * // => 'c';
       */
      function nth(array, n) {
        return array && array.length ? baseNth(array, toInteger(n)) : undefined$1;
      }

      /**
       * Removes all given values from `array` using
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons.
       *
       * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
       * to remove elements from an array by predicate.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Array
       * @param {Array} array The array to modify.
       * @param {...*} [values] The values to remove.
       * @returns {Array} Returns `array`.
       * @example
       *
       * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
       *
       * _.pull(array, 'a', 'c');
       * console.log(array);
       * // => ['b', 'b']
       */
      var pull = baseRest(pullAll);

      /**
       * This method is like `_.pull` except that it accepts an array of values to remove.
       *
       * **Note:** Unlike `_.difference`, this method mutates `array`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to modify.
       * @param {Array} values The values to remove.
       * @returns {Array} Returns `array`.
       * @example
       *
       * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
       *
       * _.pullAll(array, ['a', 'c']);
       * console.log(array);
       * // => ['b', 'b']
       */
      function pullAll(array, values) {
        return array && array.length && values && values.length ? basePullAll(array, values) : array;
      }

      /**
       * This method is like `_.pullAll` except that it accepts `iteratee` which is
       * invoked for each element of `array` and `values` to generate the criterion
       * by which they're compared. The iteratee is invoked with one argument: (value).
       *
       * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to modify.
       * @param {Array} values The values to remove.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns `array`.
       * @example
       *
       * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
       *
       * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
       * console.log(array);
       * // => [{ 'x': 2 }]
       */
      function pullAllBy(array, values, iteratee) {
        return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
      }

      /**
       * This method is like `_.pullAll` except that it accepts `comparator` which
       * is invoked to compare elements of `array` to `values`. The comparator is
       * invoked with two arguments: (arrVal, othVal).
       *
       * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
       *
       * @static
       * @memberOf _
       * @since 4.6.0
       * @category Array
       * @param {Array} array The array to modify.
       * @param {Array} values The values to remove.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns `array`.
       * @example
       *
       * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
       *
       * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
       * console.log(array);
       * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
       */
      function pullAllWith(array, values, comparator) {
        return array && array.length && values && values.length ? basePullAll(array, values, undefined$1, comparator) : array;
      }

      /**
       * Removes elements from `array` corresponding to `indexes` and returns an
       * array of removed elements.
       *
       * **Note:** Unlike `_.at`, this method mutates `array`.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to modify.
       * @param {...(number|number[])} [indexes] The indexes of elements to remove.
       * @returns {Array} Returns the new array of removed elements.
       * @example
       *
       * var array = ['a', 'b', 'c', 'd'];
       * var pulled = _.pullAt(array, [1, 3]);
       *
       * console.log(array);
       * // => ['a', 'c']
       *
       * console.log(pulled);
       * // => ['b', 'd']
       */
      var pullAt = flatRest(function (array, indexes) {
        var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);
        basePullAt(array, arrayMap(indexes, function (index) {
          return isIndex(index, length) ? +index : index;
        }).sort(compareAscending));
        return result;
      });

      /**
       * Removes all elements from `array` that `predicate` returns truthy for
       * and returns an array of the removed elements. The predicate is invoked
       * with three arguments: (value, index, array).
       *
       * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
       * to pull elements from an array by value.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Array
       * @param {Array} array The array to modify.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the new array of removed elements.
       * @example
       *
       * var array = [1, 2, 3, 4];
       * var evens = _.remove(array, function(n) {
       *   return n % 2 == 0;
       * });
       *
       * console.log(array);
       * // => [1, 3]
       *
       * console.log(evens);
       * // => [2, 4]
       */
      function remove(array, predicate) {
        var result = [];
        if (!(array && array.length)) {
          return result;
        }
        var index = -1,
          indexes = [],
          length = array.length;
        predicate = getIteratee(predicate, 3);
        while (++index < length) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result.push(value);
            indexes.push(index);
          }
        }
        basePullAt(array, indexes);
        return result;
      }

      /**
       * Reverses `array` so that the first element becomes the last, the second
       * element becomes the second to last, and so on.
       *
       * **Note:** This method mutates `array` and is based on
       * [`Array#reverse`](https://mdn.io/Array/reverse).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to modify.
       * @returns {Array} Returns `array`.
       * @example
       *
       * var array = [1, 2, 3];
       *
       * _.reverse(array);
       * // => [3, 2, 1]
       *
       * console.log(array);
       * // => [3, 2, 1]
       */
      function reverse(array) {
        return array == null ? array : nativeReverse.call(array);
      }

      /**
       * Creates a slice of `array` from `start` up to, but not including, `end`.
       *
       * **Note:** This method is used instead of
       * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
       * returned.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to slice.
       * @param {number} [start=0] The start position.
       * @param {number} [end=array.length] The end position.
       * @returns {Array} Returns the slice of `array`.
       */
      function slice(array, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
          start = 0;
          end = length;
        } else {
          start = start == null ? 0 : toInteger(start);
          end = end === undefined$1 ? length : toInteger(end);
        }
        return baseSlice(array, start, end);
      }

      /**
       * Uses a binary search to determine the lowest index at which `value`
       * should be inserted into `array` in order to maintain its sort order.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The sorted array to inspect.
       * @param {*} value The value to evaluate.
       * @returns {number} Returns the index at which `value` should be inserted
       *  into `array`.
       * @example
       *
       * _.sortedIndex([30, 50], 40);
       * // => 1
       */
      function sortedIndex(array, value) {
        return baseSortedIndex(array, value);
      }

      /**
       * This method is like `_.sortedIndex` except that it accepts `iteratee`
       * which is invoked for `value` and each element of `array` to compute their
       * sort ranking. The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The sorted array to inspect.
       * @param {*} value The value to evaluate.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {number} Returns the index at which `value` should be inserted
       *  into `array`.
       * @example
       *
       * var objects = [{ 'x': 4 }, { 'x': 5 }];
       *
       * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
       * // => 0
       *
       * // The `_.property` iteratee shorthand.
       * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
       * // => 0
       */
      function sortedIndexBy(array, value, iteratee) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
      }

      /**
       * This method is like `_.indexOf` except that it performs a binary
       * search on a sorted `array`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @returns {number} Returns the index of the matched value, else `-1`.
       * @example
       *
       * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
       * // => 1
       */
      function sortedIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index = baseSortedIndex(array, value);
          if (index < length && eq(array[index], value)) {
            return index;
          }
        }
        return -1;
      }

      /**
       * This method is like `_.sortedIndex` except that it returns the highest
       * index at which `value` should be inserted into `array` in order to
       * maintain its sort order.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The sorted array to inspect.
       * @param {*} value The value to evaluate.
       * @returns {number} Returns the index at which `value` should be inserted
       *  into `array`.
       * @example
       *
       * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
       * // => 4
       */
      function sortedLastIndex(array, value) {
        return baseSortedIndex(array, value, true);
      }

      /**
       * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
       * which is invoked for `value` and each element of `array` to compute their
       * sort ranking. The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The sorted array to inspect.
       * @param {*} value The value to evaluate.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {number} Returns the index at which `value` should be inserted
       *  into `array`.
       * @example
       *
       * var objects = [{ 'x': 4 }, { 'x': 5 }];
       *
       * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
       * // => 1
       *
       * // The `_.property` iteratee shorthand.
       * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
       * // => 1
       */
      function sortedLastIndexBy(array, value, iteratee) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
      }

      /**
       * This method is like `_.lastIndexOf` except that it performs a binary
       * search on a sorted `array`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @returns {number} Returns the index of the matched value, else `-1`.
       * @example
       *
       * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
       * // => 3
       */
      function sortedLastIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index = baseSortedIndex(array, value, true) - 1;
          if (eq(array[index], value)) {
            return index;
          }
        }
        return -1;
      }

      /**
       * This method is like `_.uniq` except that it's designed and optimized
       * for sorted arrays.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @returns {Array} Returns the new duplicate free array.
       * @example
       *
       * _.sortedUniq([1, 1, 2]);
       * // => [1, 2]
       */
      function sortedUniq(array) {
        return array && array.length ? baseSortedUniq(array) : [];
      }

      /**
       * This method is like `_.uniqBy` except that it's designed and optimized
       * for sorted arrays.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @returns {Array} Returns the new duplicate free array.
       * @example
       *
       * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
       * // => [1.1, 2.3]
       */
      function sortedUniqBy(array, iteratee) {
        return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
      }

      /**
       * Gets all but the first element of `array`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * _.tail([1, 2, 3]);
       * // => [2, 3]
       */
      function tail(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 1, length) : [];
      }

      /**
       * Creates a slice of `array` with `n` elements taken from the beginning.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {number} [n=1] The number of elements to take.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * _.take([1, 2, 3]);
       * // => [1]
       *
       * _.take([1, 2, 3], 2);
       * // => [1, 2]
       *
       * _.take([1, 2, 3], 5);
       * // => [1, 2, 3]
       *
       * _.take([1, 2, 3], 0);
       * // => []
       */
      function take(array, n, guard) {
        if (!(array && array.length)) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }

      /**
       * Creates a slice of `array` with `n` elements taken from the end.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {number} [n=1] The number of elements to take.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * _.takeRight([1, 2, 3]);
       * // => [3]
       *
       * _.takeRight([1, 2, 3], 2);
       * // => [2, 3]
       *
       * _.takeRight([1, 2, 3], 5);
       * // => [1, 2, 3]
       *
       * _.takeRight([1, 2, 3], 0);
       * // => []
       */
      function takeRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, n < 0 ? 0 : n, length);
      }

      /**
       * Creates a slice of `array` with elements taken from the end. Elements are
       * taken until `predicate` returns falsey. The predicate is invoked with
       * three arguments: (value, index, array).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'active': true },
       *   { 'user': 'fred',    'active': false },
       *   { 'user': 'pebbles', 'active': false }
       * ];
       *
       * _.takeRightWhile(users, function(o) { return !o.active; });
       * // => objects for ['fred', 'pebbles']
       *
       * // The `_.matches` iteratee shorthand.
       * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
       * // => objects for ['pebbles']
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.takeRightWhile(users, ['active', false]);
       * // => objects for ['fred', 'pebbles']
       *
       * // The `_.property` iteratee shorthand.
       * _.takeRightWhile(users, 'active');
       * // => []
       */
      function takeRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
      }

      /**
       * Creates a slice of `array` with elements taken from the beginning. Elements
       * are taken until `predicate` returns falsey. The predicate is invoked with
       * three arguments: (value, index, array).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'active': false },
       *   { 'user': 'fred',    'active': false },
       *   { 'user': 'pebbles', 'active': true }
       * ];
       *
       * _.takeWhile(users, function(o) { return !o.active; });
       * // => objects for ['barney', 'fred']
       *
       * // The `_.matches` iteratee shorthand.
       * _.takeWhile(users, { 'user': 'barney', 'active': false });
       * // => objects for ['barney']
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.takeWhile(users, ['active', false]);
       * // => objects for ['barney', 'fred']
       *
       * // The `_.property` iteratee shorthand.
       * _.takeWhile(users, 'active');
       * // => []
       */
      function takeWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
      }

      /**
       * Creates an array of unique values, in order, from all given arrays using
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @returns {Array} Returns the new array of combined values.
       * @example
       *
       * _.union([2], [1, 2]);
       * // => [2, 1]
       */
      var union = baseRest(function (arrays) {
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
      });

      /**
       * This method is like `_.union` except that it accepts `iteratee` which is
       * invoked for each element of each `arrays` to generate the criterion by
       * which uniqueness is computed. Result values are chosen from the first
       * array in which the value occurs. The iteratee is invoked with one argument:
       * (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns the new array of combined values.
       * @example
       *
       * _.unionBy([2.1], [1.2, 2.3], Math.floor);
       * // => [2.1, 1.2]
       *
       * // The `_.property` iteratee shorthand.
       * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
       * // => [{ 'x': 1 }, { 'x': 2 }]
       */
      var unionBy = baseRest(function (arrays) {
        var iteratee = last(arrays);
        if (isArrayLikeObject(iteratee)) {
          iteratee = undefined$1;
        }
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
      });

      /**
       * This method is like `_.union` except that it accepts `comparator` which
       * is invoked to compare elements of `arrays`. Result values are chosen from
       * the first array in which the value occurs. The comparator is invoked
       * with two arguments: (arrVal, othVal).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of combined values.
       * @example
       *
       * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
       * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
       *
       * _.unionWith(objects, others, _.isEqual);
       * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
       */
      var unionWith = baseRest(function (arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == 'function' ? comparator : undefined$1;
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
      });

      /**
       * Creates a duplicate-free version of an array, using
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons, in which only the first occurrence of each element
       * is kept. The order of result values is determined by the order they occur
       * in the array.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @returns {Array} Returns the new duplicate free array.
       * @example
       *
       * _.uniq([2, 1, 2]);
       * // => [2, 1]
       */
      function uniq(array) {
        return array && array.length ? baseUniq(array) : [];
      }

      /**
       * This method is like `_.uniq` except that it accepts `iteratee` which is
       * invoked for each element in `array` to generate the criterion by which
       * uniqueness is computed. The order of result values is determined by the
       * order they occur in the array. The iteratee is invoked with one argument:
       * (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns the new duplicate free array.
       * @example
       *
       * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
       * // => [2.1, 1.2]
       *
       * // The `_.property` iteratee shorthand.
       * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
       * // => [{ 'x': 1 }, { 'x': 2 }]
       */
      function uniqBy(array, iteratee) {
        return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
      }

      /**
       * This method is like `_.uniq` except that it accepts `comparator` which
       * is invoked to compare elements of `array`. The order of result values is
       * determined by the order they occur in the array.The comparator is invoked
       * with two arguments: (arrVal, othVal).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new duplicate free array.
       * @example
       *
       * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
       *
       * _.uniqWith(objects, _.isEqual);
       * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
       */
      function uniqWith(array, comparator) {
        comparator = typeof comparator == 'function' ? comparator : undefined$1;
        return array && array.length ? baseUniq(array, undefined$1, comparator) : [];
      }

      /**
       * This method is like `_.zip` except that it accepts an array of grouped
       * elements and creates an array regrouping the elements to their pre-zip
       * configuration.
       *
       * @static
       * @memberOf _
       * @since 1.2.0
       * @category Array
       * @param {Array} array The array of grouped elements to process.
       * @returns {Array} Returns the new array of regrouped elements.
       * @example
       *
       * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
       * // => [['a', 1, true], ['b', 2, false]]
       *
       * _.unzip(zipped);
       * // => [['a', 'b'], [1, 2], [true, false]]
       */
      function unzip(array) {
        if (!(array && array.length)) {
          return [];
        }
        var length = 0;
        array = arrayFilter(array, function (group) {
          if (isArrayLikeObject(group)) {
            length = nativeMax(group.length, length);
            return true;
          }
        });
        return baseTimes(length, function (index) {
          return arrayMap(array, baseProperty(index));
        });
      }

      /**
       * This method is like `_.unzip` except that it accepts `iteratee` to specify
       * how regrouped values should be combined. The iteratee is invoked with the
       * elements of each group: (...group).
       *
       * @static
       * @memberOf _
       * @since 3.8.0
       * @category Array
       * @param {Array} array The array of grouped elements to process.
       * @param {Function} [iteratee=_.identity] The function to combine
       *  regrouped values.
       * @returns {Array} Returns the new array of regrouped elements.
       * @example
       *
       * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
       * // => [[1, 10, 100], [2, 20, 200]]
       *
       * _.unzipWith(zipped, _.add);
       * // => [3, 30, 300]
       */
      function unzipWith(array, iteratee) {
        if (!(array && array.length)) {
          return [];
        }
        var result = unzip(array);
        if (iteratee == null) {
          return result;
        }
        return arrayMap(result, function (group) {
          return apply(iteratee, undefined$1, group);
        });
      }

      /**
       * Creates an array excluding all given values using
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons.
       *
       * **Note:** Unlike `_.pull`, this method returns a new array.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {...*} [values] The values to exclude.
       * @returns {Array} Returns the new array of filtered values.
       * @see _.difference, _.xor
       * @example
       *
       * _.without([2, 1, 2, 3], 1, 2);
       * // => [3]
       */
      var without = baseRest(function (array, values) {
        return isArrayLikeObject(array) ? baseDifference(array, values) : [];
      });

      /**
       * Creates an array of unique values that is the
       * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
       * of the given arrays. The order of result values is determined by the order
       * they occur in the arrays.
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @returns {Array} Returns the new array of filtered values.
       * @see _.difference, _.without
       * @example
       *
       * _.xor([2, 1], [2, 3]);
       * // => [1, 3]
       */
      var xor = baseRest(function (arrays) {
        return baseXor(arrayFilter(arrays, isArrayLikeObject));
      });

      /**
       * This method is like `_.xor` except that it accepts `iteratee` which is
       * invoked for each element of each `arrays` to generate the criterion by
       * which by which they're compared. The order of result values is determined
       * by the order they occur in the arrays. The iteratee is invoked with one
       * argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       * @example
       *
       * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
       * // => [1.2, 3.4]
       *
       * // The `_.property` iteratee shorthand.
       * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
       * // => [{ 'x': 2 }]
       */
      var xorBy = baseRest(function (arrays) {
        var iteratee = last(arrays);
        if (isArrayLikeObject(iteratee)) {
          iteratee = undefined$1;
        }
        return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
      });

      /**
       * This method is like `_.xor` except that it accepts `comparator` which is
       * invoked to compare elements of `arrays`. The order of result values is
       * determined by the order they occur in the arrays. The comparator is invoked
       * with two arguments: (arrVal, othVal).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       * @example
       *
       * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
       * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
       *
       * _.xorWith(objects, others, _.isEqual);
       * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
       */
      var xorWith = baseRest(function (arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == 'function' ? comparator : undefined$1;
        return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
      });

      /**
       * Creates an array of grouped elements, the first of which contains the
       * first elements of the given arrays, the second of which contains the
       * second elements of the given arrays, and so on.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {...Array} [arrays] The arrays to process.
       * @returns {Array} Returns the new array of grouped elements.
       * @example
       *
       * _.zip(['a', 'b'], [1, 2], [true, false]);
       * // => [['a', 1, true], ['b', 2, false]]
       */
      var zip = baseRest(unzip);

      /**
       * This method is like `_.fromPairs` except that it accepts two arrays,
       * one of property identifiers and one of corresponding values.
       *
       * @static
       * @memberOf _
       * @since 0.4.0
       * @category Array
       * @param {Array} [props=[]] The property identifiers.
       * @param {Array} [values=[]] The property values.
       * @returns {Object} Returns the new object.
       * @example
       *
       * _.zipObject(['a', 'b'], [1, 2]);
       * // => { 'a': 1, 'b': 2 }
       */
      function zipObject(props, values) {
        return baseZipObject(props || [], values || [], assignValue);
      }

      /**
       * This method is like `_.zipObject` except that it supports property paths.
       *
       * @static
       * @memberOf _
       * @since 4.1.0
       * @category Array
       * @param {Array} [props=[]] The property identifiers.
       * @param {Array} [values=[]] The property values.
       * @returns {Object} Returns the new object.
       * @example
       *
       * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
       * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
       */
      function zipObjectDeep(props, values) {
        return baseZipObject(props || [], values || [], baseSet);
      }

      /**
       * This method is like `_.zip` except that it accepts `iteratee` to specify
       * how grouped values should be combined. The iteratee is invoked with the
       * elements of each group: (...group).
       *
       * @static
       * @memberOf _
       * @since 3.8.0
       * @category Array
       * @param {...Array} [arrays] The arrays to process.
       * @param {Function} [iteratee=_.identity] The function to combine
       *  grouped values.
       * @returns {Array} Returns the new array of grouped elements.
       * @example
       *
       * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
       *   return a + b + c;
       * });
       * // => [111, 222]
       */
      var zipWith = baseRest(function (arrays) {
        var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined$1;
        iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined$1;
        return unzipWith(arrays, iteratee);
      });

      /*------------------------------------------------------------------------*/

      /**
       * Creates a `lodash` wrapper instance that wraps `value` with explicit method
       * chain sequences enabled. The result of such sequences must be unwrapped
       * with `_#value`.
       *
       * @static
       * @memberOf _
       * @since 1.3.0
       * @category Seq
       * @param {*} value The value to wrap.
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'age': 36 },
       *   { 'user': 'fred',    'age': 40 },
       *   { 'user': 'pebbles', 'age': 1 }
       * ];
       *
       * var youngest = _
       *   .chain(users)
       *   .sortBy('age')
       *   .map(function(o) {
       *     return o.user + ' is ' + o.age;
       *   })
       *   .head()
       *   .value();
       * // => 'pebbles is 1'
       */
      function chain(value) {
        var result = lodash(value);
        result.__chain__ = true;
        return result;
      }

      /**
       * This method invokes `interceptor` and returns `value`. The interceptor
       * is invoked with one argument; (value). The purpose of this method is to
       * "tap into" a method chain sequence in order to modify intermediate results.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Seq
       * @param {*} value The value to provide to `interceptor`.
       * @param {Function} interceptor The function to invoke.
       * @returns {*} Returns `value`.
       * @example
       *
       * _([1, 2, 3])
       *  .tap(function(array) {
       *    // Mutate input array.
       *    array.pop();
       *  })
       *  .reverse()
       *  .value();
       * // => [2, 1]
       */
      function tap(value, interceptor) {
        interceptor(value);
        return value;
      }

      /**
       * This method is like `_.tap` except that it returns the result of `interceptor`.
       * The purpose of this method is to "pass thru" values replacing intermediate
       * results in a method chain sequence.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Seq
       * @param {*} value The value to provide to `interceptor`.
       * @param {Function} interceptor The function to invoke.
       * @returns {*} Returns the result of `interceptor`.
       * @example
       *
       * _('  abc  ')
       *  .chain()
       *  .trim()
       *  .thru(function(value) {
       *    return [value];
       *  })
       *  .value();
       * // => ['abc']
       */
      function thru(value, interceptor) {
        return interceptor(value);
      }

      /**
       * This method is the wrapper version of `_.at`.
       *
       * @name at
       * @memberOf _
       * @since 1.0.0
       * @category Seq
       * @param {...(string|string[])} [paths] The property paths to pick.
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
       *
       * _(object).at(['a[0].b.c', 'a[1]']).value();
       * // => [3, 4]
       */
      var wrapperAt = flatRest(function (paths) {
        var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function (object) {
            return baseAt(object, paths);
          };
        if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
          return this.thru(interceptor);
        }
        value = value.slice(start, +start + (length ? 1 : 0));
        value.__actions__.push({
          'func': thru,
          'args': [interceptor],
          'thisArg': undefined$1
        });
        return new LodashWrapper(value, this.__chain__).thru(function (array) {
          if (length && !array.length) {
            array.push(undefined$1);
          }
          return array;
        });
      });

      /**
       * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
       *
       * @name chain
       * @memberOf _
       * @since 0.1.0
       * @category Seq
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * var users = [
       *   { 'user': 'barney', 'age': 36 },
       *   { 'user': 'fred',   'age': 40 }
       * ];
       *
       * // A sequence without explicit chaining.
       * _(users).head();
       * // => { 'user': 'barney', 'age': 36 }
       *
       * // A sequence with explicit chaining.
       * _(users)
       *   .chain()
       *   .head()
       *   .pick('user')
       *   .value();
       * // => { 'user': 'barney' }
       */
      function wrapperChain() {
        return chain(this);
      }

      /**
       * Executes the chain sequence and returns the wrapped result.
       *
       * @name commit
       * @memberOf _
       * @since 3.2.0
       * @category Seq
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * var array = [1, 2];
       * var wrapped = _(array).push(3);
       *
       * console.log(array);
       * // => [1, 2]
       *
       * wrapped = wrapped.commit();
       * console.log(array);
       * // => [1, 2, 3]
       *
       * wrapped.last();
       * // => 3
       *
       * console.log(array);
       * // => [1, 2, 3]
       */
      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }

      /**
       * Gets the next value on a wrapped object following the
       * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
       *
       * @name next
       * @memberOf _
       * @since 4.0.0
       * @category Seq
       * @returns {Object} Returns the next iterator value.
       * @example
       *
       * var wrapped = _([1, 2]);
       *
       * wrapped.next();
       * // => { 'done': false, 'value': 1 }
       *
       * wrapped.next();
       * // => { 'done': false, 'value': 2 }
       *
       * wrapped.next();
       * // => { 'done': true, 'value': undefined }
       */
      function wrapperNext() {
        if (this.__values__ === undefined$1) {
          this.__values__ = toArray(this.value());
        }
        var done = this.__index__ >= this.__values__.length,
          value = done ? undefined$1 : this.__values__[this.__index__++];
        return {
          'done': done,
          'value': value
        };
      }

      /**
       * Enables the wrapper to be iterable.
       *
       * @name Symbol.iterator
       * @memberOf _
       * @since 4.0.0
       * @category Seq
       * @returns {Object} Returns the wrapper object.
       * @example
       *
       * var wrapped = _([1, 2]);
       *
       * wrapped[Symbol.iterator]() === wrapped;
       * // => true
       *
       * Array.from(wrapped);
       * // => [1, 2]
       */
      function wrapperToIterator() {
        return this;
      }

      /**
       * Creates a clone of the chain sequence planting `value` as the wrapped value.
       *
       * @name plant
       * @memberOf _
       * @since 3.2.0
       * @category Seq
       * @param {*} value The value to plant.
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * function square(n) {
       *   return n * n;
       * }
       *
       * var wrapped = _([1, 2]).map(square);
       * var other = wrapped.plant([3, 4]);
       *
       * other.value();
       * // => [9, 16]
       *
       * wrapped.value();
       * // => [1, 4]
       */
      function wrapperPlant(value) {
        var result,
          parent = this;
        while (parent instanceof baseLodash) {
          var clone = wrapperClone(parent);
          clone.__index__ = 0;
          clone.__values__ = undefined$1;
          if (result) {
            previous.__wrapped__ = clone;
          } else {
            result = clone;
          }
          var previous = clone;
          parent = parent.__wrapped__;
        }
        previous.__wrapped__ = value;
        return result;
      }

      /**
       * This method is the wrapper version of `_.reverse`.
       *
       * **Note:** This method mutates the wrapped array.
       *
       * @name reverse
       * @memberOf _
       * @since 0.1.0
       * @category Seq
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * var array = [1, 2, 3];
       *
       * _(array).reverse().value()
       * // => [3, 2, 1]
       *
       * console.log(array);
       * // => [3, 2, 1]
       */
      function wrapperReverse() {
        var value = this.__wrapped__;
        if (value instanceof LazyWrapper) {
          var wrapped = value;
          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }
          wrapped = wrapped.reverse();
          wrapped.__actions__.push({
            'func': thru,
            'args': [reverse],
            'thisArg': undefined$1
          });
          return new LodashWrapper(wrapped, this.__chain__);
        }
        return this.thru(reverse);
      }

      /**
       * Executes the chain sequence to resolve the unwrapped value.
       *
       * @name value
       * @memberOf _
       * @since 0.1.0
       * @alias toJSON, valueOf
       * @category Seq
       * @returns {*} Returns the resolved unwrapped value.
       * @example
       *
       * _([1, 2, 3]).value();
       * // => [1, 2, 3]
       */
      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }

      /*------------------------------------------------------------------------*/

      /**
       * Creates an object composed of keys generated from the results of running
       * each element of `collection` thru `iteratee`. The corresponding value of
       * each key is the number of times the key was returned by `iteratee`. The
       * iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 0.5.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
       * @returns {Object} Returns the composed aggregate object.
       * @example
       *
       * _.countBy([6.1, 4.2, 6.3], Math.floor);
       * // => { '4': 1, '6': 2 }
       *
       * // The `_.property` iteratee shorthand.
       * _.countBy(['one', 'two', 'three'], 'length');
       * // => { '3': 2, '5': 1 }
       */
      var countBy = createAggregator(function (result, value, key) {
        if (hasOwnProperty.call(result, key)) {
          ++result[key];
        } else {
          baseAssignValue(result, key, 1);
        }
      });

      /**
       * Checks if `predicate` returns truthy for **all** elements of `collection`.
       * Iteration is stopped once `predicate` returns falsey. The predicate is
       * invoked with three arguments: (value, index|key, collection).
       *
       * **Note:** This method returns `true` for
       * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
       * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
       * elements of empty collections.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {boolean} Returns `true` if all elements pass the predicate check,
       *  else `false`.
       * @example
       *
       * _.every([true, 1, null, 'yes'], Boolean);
       * // => false
       *
       * var users = [
       *   { 'user': 'barney', 'age': 36, 'active': false },
       *   { 'user': 'fred',   'age': 40, 'active': false }
       * ];
       *
       * // The `_.matches` iteratee shorthand.
       * _.every(users, { 'user': 'barney', 'active': false });
       * // => false
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.every(users, ['active', false]);
       * // => true
       *
       * // The `_.property` iteratee shorthand.
       * _.every(users, 'active');
       * // => false
       */
      function every(collection, predicate, guard) {
        var func = isArray(collection) ? arrayEvery : baseEvery;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }

      /**
       * Iterates over elements of `collection`, returning an array of all elements
       * `predicate` returns truthy for. The predicate is invoked with three
       * arguments: (value, index|key, collection).
       *
       * **Note:** Unlike `_.remove`, this method returns a new array.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the new filtered array.
       * @see _.reject
       * @example
       *
       * var users = [
       *   { 'user': 'barney', 'age': 36, 'active': true },
       *   { 'user': 'fred',   'age': 40, 'active': false }
       * ];
       *
       * _.filter(users, function(o) { return !o.active; });
       * // => objects for ['fred']
       *
       * // The `_.matches` iteratee shorthand.
       * _.filter(users, { 'age': 36, 'active': true });
       * // => objects for ['barney']
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.filter(users, ['active', false]);
       * // => objects for ['fred']
       *
       * // The `_.property` iteratee shorthand.
       * _.filter(users, 'active');
       * // => objects for ['barney']
       *
       * // Combining several predicates using `_.overEvery` or `_.overSome`.
       * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
       * // => objects for ['fred', 'barney']
       */
      function filter(collection, predicate) {
        var func = isArray(collection) ? arrayFilter : baseFilter;
        return func(collection, getIteratee(predicate, 3));
      }

      /**
       * Iterates over elements of `collection`, returning the first element
       * `predicate` returns truthy for. The predicate is invoked with three
       * arguments: (value, index|key, collection).
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to inspect.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @param {number} [fromIndex=0] The index to search from.
       * @returns {*} Returns the matched element, else `undefined`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'age': 36, 'active': true },
       *   { 'user': 'fred',    'age': 40, 'active': false },
       *   { 'user': 'pebbles', 'age': 1,  'active': true }
       * ];
       *
       * _.find(users, function(o) { return o.age < 40; });
       * // => object for 'barney'
       *
       * // The `_.matches` iteratee shorthand.
       * _.find(users, { 'age': 1, 'active': true });
       * // => object for 'pebbles'
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.find(users, ['active', false]);
       * // => object for 'fred'
       *
       * // The `_.property` iteratee shorthand.
       * _.find(users, 'active');
       * // => object for 'barney'
       */
      var find = createFind(findIndex);

      /**
       * This method is like `_.find` except that it iterates over elements of
       * `collection` from right to left.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to inspect.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @param {number} [fromIndex=collection.length-1] The index to search from.
       * @returns {*} Returns the matched element, else `undefined`.
       * @example
       *
       * _.findLast([1, 2, 3, 4], function(n) {
       *   return n % 2 == 1;
       * });
       * // => 3
       */
      var findLast = createFind(findLastIndex);

      /**
       * Creates a flattened array of values by running each element in `collection`
       * thru `iteratee` and flattening the mapped results. The iteratee is invoked
       * with three arguments: (value, index|key, collection).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the new flattened array.
       * @example
       *
       * function duplicate(n) {
       *   return [n, n];
       * }
       *
       * _.flatMap([1, 2], duplicate);
       * // => [1, 1, 2, 2]
       */
      function flatMap(collection, iteratee) {
        return baseFlatten(map(collection, iteratee), 1);
      }

      /**
       * This method is like `_.flatMap` except that it recursively flattens the
       * mapped results.
       *
       * @static
       * @memberOf _
       * @since 4.7.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the new flattened array.
       * @example
       *
       * function duplicate(n) {
       *   return [[[n, n]]];
       * }
       *
       * _.flatMapDeep([1, 2], duplicate);
       * // => [1, 1, 2, 2]
       */
      function flatMapDeep(collection, iteratee) {
        return baseFlatten(map(collection, iteratee), INFINITY);
      }

      /**
       * This method is like `_.flatMap` except that it recursively flattens the
       * mapped results up to `depth` times.
       *
       * @static
       * @memberOf _
       * @since 4.7.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @param {number} [depth=1] The maximum recursion depth.
       * @returns {Array} Returns the new flattened array.
       * @example
       *
       * function duplicate(n) {
       *   return [[[n, n]]];
       * }
       *
       * _.flatMapDepth([1, 2], duplicate, 2);
       * // => [[1, 1], [2, 2]]
       */
      function flatMapDepth(collection, iteratee, depth) {
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(map(collection, iteratee), depth);
      }

      /**
       * Iterates over elements of `collection` and invokes `iteratee` for each element.
       * The iteratee is invoked with three arguments: (value, index|key, collection).
       * Iteratee functions may exit iteration early by explicitly returning `false`.
       *
       * **Note:** As with other "Collections" methods, objects with a "length"
       * property are iterated like arrays. To avoid this behavior use `_.forIn`
       * or `_.forOwn` for object iteration.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @alias each
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Array|Object} Returns `collection`.
       * @see _.forEachRight
       * @example
       *
       * _.forEach([1, 2], function(value) {
       *   console.log(value);
       * });
       * // => Logs `1` then `2`.
       *
       * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
       *   console.log(key);
       * });
       * // => Logs 'a' then 'b' (iteration order is not guaranteed).
       */
      function forEach(collection, iteratee) {
        var func = isArray(collection) ? arrayEach : baseEach;
        return func(collection, getIteratee(iteratee, 3));
      }

      /**
       * This method is like `_.forEach` except that it iterates over elements of
       * `collection` from right to left.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @alias eachRight
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Array|Object} Returns `collection`.
       * @see _.forEach
       * @example
       *
       * _.forEachRight([1, 2], function(value) {
       *   console.log(value);
       * });
       * // => Logs `2` then `1`.
       */
      function forEachRight(collection, iteratee) {
        var func = isArray(collection) ? arrayEachRight : baseEachRight;
        return func(collection, getIteratee(iteratee, 3));
      }

      /**
       * Creates an object composed of keys generated from the results of running
       * each element of `collection` thru `iteratee`. The order of grouped values
       * is determined by the order they occur in `collection`. The corresponding
       * value of each key is an array of elements responsible for generating the
       * key. The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
       * @returns {Object} Returns the composed aggregate object.
       * @example
       *
       * _.groupBy([6.1, 4.2, 6.3], Math.floor);
       * // => { '4': [4.2], '6': [6.1, 6.3] }
       *
       * // The `_.property` iteratee shorthand.
       * _.groupBy(['one', 'two', 'three'], 'length');
       * // => { '3': ['one', 'two'], '5': ['three'] }
       */
      var groupBy = createAggregator(function (result, value, key) {
        if (hasOwnProperty.call(result, key)) {
          result[key].push(value);
        } else {
          baseAssignValue(result, key, [value]);
        }
      });

      /**
       * Checks if `value` is in `collection`. If `collection` is a string, it's
       * checked for a substring of `value`, otherwise
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * is used for equality comparisons. If `fromIndex` is negative, it's used as
       * the offset from the end of `collection`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object|string} collection The collection to inspect.
       * @param {*} value The value to search for.
       * @param {number} [fromIndex=0] The index to search from.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
       * @returns {boolean} Returns `true` if `value` is found, else `false`.
       * @example
       *
       * _.includes([1, 2, 3], 1);
       * // => true
       *
       * _.includes([1, 2, 3], 1, 2);
       * // => false
       *
       * _.includes({ 'a': 1, 'b': 2 }, 1);
       * // => true
       *
       * _.includes('abcd', 'bc');
       * // => true
       */
      function includes(collection, value, fromIndex, guard) {
        collection = isArrayLike(collection) ? collection : values(collection);
        fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
        var length = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax(length + fromIndex, 0);
        }
        return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
      }

      /**
       * Invokes the method at `path` of each element in `collection`, returning
       * an array of the results of each invoked method. Any additional arguments
       * are provided to each invoked method. If `path` is a function, it's invoked
       * for, and `this` bound to, each element in `collection`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Array|Function|string} path The path of the method to invoke or
       *  the function invoked per iteration.
       * @param {...*} [args] The arguments to invoke each method with.
       * @returns {Array} Returns the array of results.
       * @example
       *
       * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
       * // => [[1, 5, 7], [1, 2, 3]]
       *
       * _.invokeMap([123, 456], String.prototype.split, '');
       * // => [['1', '2', '3'], ['4', '5', '6']]
       */
      var invokeMap = baseRest(function (collection, path, args) {
        var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];
        baseEach(collection, function (value) {
          result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
        });
        return result;
      });

      /**
       * Creates an object composed of keys generated from the results of running
       * each element of `collection` thru `iteratee`. The corresponding value of
       * each key is the last element responsible for generating the key. The
       * iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
       * @returns {Object} Returns the composed aggregate object.
       * @example
       *
       * var array = [
       *   { 'dir': 'left', 'code': 97 },
       *   { 'dir': 'right', 'code': 100 }
       * ];
       *
       * _.keyBy(array, function(o) {
       *   return String.fromCharCode(o.code);
       * });
       * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
       *
       * _.keyBy(array, 'dir');
       * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
       */
      var keyBy = createAggregator(function (result, value, key) {
        baseAssignValue(result, key, value);
      });

      /**
       * Creates an array of values by running each element in `collection` thru
       * `iteratee`. The iteratee is invoked with three arguments:
       * (value, index|key, collection).
       *
       * Many lodash methods are guarded to work as iteratees for methods like
       * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
       *
       * The guarded methods are:
       * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
       * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
       * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
       * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the new mapped array.
       * @example
       *
       * function square(n) {
       *   return n * n;
       * }
       *
       * _.map([4, 8], square);
       * // => [16, 64]
       *
       * _.map({ 'a': 4, 'b': 8 }, square);
       * // => [16, 64] (iteration order is not guaranteed)
       *
       * var users = [
       *   { 'user': 'barney' },
       *   { 'user': 'fred' }
       * ];
       *
       * // The `_.property` iteratee shorthand.
       * _.map(users, 'user');
       * // => ['barney', 'fred']
       */
      function map(collection, iteratee) {
        var func = isArray(collection) ? arrayMap : baseMap;
        return func(collection, getIteratee(iteratee, 3));
      }

      /**
       * This method is like `_.sortBy` except that it allows specifying the sort
       * orders of the iteratees to sort by. If `orders` is unspecified, all values
       * are sorted in ascending order. Otherwise, specify an order of "desc" for
       * descending or "asc" for ascending sort order of corresponding values.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
       *  The iteratees to sort by.
       * @param {string[]} [orders] The sort orders of `iteratees`.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
       * @returns {Array} Returns the new sorted array.
       * @example
       *
       * var users = [
       *   { 'user': 'fred',   'age': 48 },
       *   { 'user': 'barney', 'age': 34 },
       *   { 'user': 'fred',   'age': 40 },
       *   { 'user': 'barney', 'age': 36 }
       * ];
       *
       * // Sort by `user` in ascending order and by `age` in descending order.
       * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
       * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
       */
      function orderBy(collection, iteratees, orders, guard) {
        if (collection == null) {
          return [];
        }
        if (!isArray(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }
        orders = guard ? undefined$1 : orders;
        if (!isArray(orders)) {
          orders = orders == null ? [] : [orders];
        }
        return baseOrderBy(collection, iteratees, orders);
      }

      /**
       * Creates an array of elements split into two groups, the first of which
       * contains elements `predicate` returns truthy for, the second of which
       * contains elements `predicate` returns falsey for. The predicate is
       * invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the array of grouped elements.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'age': 36, 'active': false },
       *   { 'user': 'fred',    'age': 40, 'active': true },
       *   { 'user': 'pebbles', 'age': 1,  'active': false }
       * ];
       *
       * _.partition(users, function(o) { return o.active; });
       * // => objects for [['fred'], ['barney', 'pebbles']]
       *
       * // The `_.matches` iteratee shorthand.
       * _.partition(users, { 'age': 1, 'active': false });
       * // => objects for [['pebbles'], ['barney', 'fred']]
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.partition(users, ['active', false]);
       * // => objects for [['barney', 'pebbles'], ['fred']]
       *
       * // The `_.property` iteratee shorthand.
       * _.partition(users, 'active');
       * // => objects for [['fred'], ['barney', 'pebbles']]
       */
      var partition = createAggregator(function (result, value, key) {
        result[key ? 0 : 1].push(value);
      }, function () {
        return [[], []];
      });

      /**
       * Reduces `collection` to a value which is the accumulated result of running
       * each element in `collection` thru `iteratee`, where each successive
       * invocation is supplied the return value of the previous. If `accumulator`
       * is not given, the first element of `collection` is used as the initial
       * value. The iteratee is invoked with four arguments:
       * (accumulator, value, index|key, collection).
       *
       * Many lodash methods are guarded to work as iteratees for methods like
       * `_.reduce`, `_.reduceRight`, and `_.transform`.
       *
       * The guarded methods are:
       * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
       * and `sortBy`
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @param {*} [accumulator] The initial value.
       * @returns {*} Returns the accumulated value.
       * @see _.reduceRight
       * @example
       *
       * _.reduce([1, 2], function(sum, n) {
       *   return sum + n;
       * }, 0);
       * // => 3
       *
       * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
       *   (result[value] || (result[value] = [])).push(key);
       *   return result;
       * }, {});
       * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
       */
      function reduce(collection, iteratee, accumulator) {
        var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
      }

      /**
       * This method is like `_.reduce` except that it iterates over elements of
       * `collection` from right to left.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @param {*} [accumulator] The initial value.
       * @returns {*} Returns the accumulated value.
       * @see _.reduce
       * @example
       *
       * var array = [[0, 1], [2, 3], [4, 5]];
       *
       * _.reduceRight(array, function(flattened, other) {
       *   return flattened.concat(other);
       * }, []);
       * // => [4, 5, 2, 3, 0, 1]
       */
      function reduceRight(collection, iteratee, accumulator) {
        var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
      }

      /**
       * The opposite of `_.filter`; this method returns the elements of `collection`
       * that `predicate` does **not** return truthy for.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the new filtered array.
       * @see _.filter
       * @example
       *
       * var users = [
       *   { 'user': 'barney', 'age': 36, 'active': false },
       *   { 'user': 'fred',   'age': 40, 'active': true }
       * ];
       *
       * _.reject(users, function(o) { return !o.active; });
       * // => objects for ['fred']
       *
       * // The `_.matches` iteratee shorthand.
       * _.reject(users, { 'age': 40, 'active': true });
       * // => objects for ['barney']
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.reject(users, ['active', false]);
       * // => objects for ['fred']
       *
       * // The `_.property` iteratee shorthand.
       * _.reject(users, 'active');
       * // => objects for ['barney']
       */
      function reject(collection, predicate) {
        var func = isArray(collection) ? arrayFilter : baseFilter;
        return func(collection, negate(getIteratee(predicate, 3)));
      }

      /**
       * Gets a random element from `collection`.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to sample.
       * @returns {*} Returns the random element.
       * @example
       *
       * _.sample([1, 2, 3, 4]);
       * // => 2
       */
      function sample(collection) {
        var func = isArray(collection) ? arraySample : baseSample;
        return func(collection);
      }

      /**
       * Gets `n` random elements at unique keys from `collection` up to the
       * size of `collection`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to sample.
       * @param {number} [n=1] The number of elements to sample.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the random elements.
       * @example
       *
       * _.sampleSize([1, 2, 3], 2);
       * // => [3, 1]
       *
       * _.sampleSize([1, 2, 3], 4);
       * // => [2, 3, 1]
       */
      function sampleSize(collection, n, guard) {
        if (guard ? isIterateeCall(collection, n, guard) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger(n);
        }
        var func = isArray(collection) ? arraySampleSize : baseSampleSize;
        return func(collection, n);
      }

      /**
       * Creates an array of shuffled values, using a version of the
       * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to shuffle.
       * @returns {Array} Returns the new shuffled array.
       * @example
       *
       * _.shuffle([1, 2, 3, 4]);
       * // => [4, 1, 3, 2]
       */
      function shuffle(collection) {
        var func = isArray(collection) ? arrayShuffle : baseShuffle;
        return func(collection);
      }

      /**
       * Gets the size of `collection` by returning its length for array-like
       * values or the number of own enumerable string keyed properties for objects.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object|string} collection The collection to inspect.
       * @returns {number} Returns the collection size.
       * @example
       *
       * _.size([1, 2, 3]);
       * // => 3
       *
       * _.size({ 'a': 1, 'b': 2 });
       * // => 2
       *
       * _.size('pebbles');
       * // => 7
       */
      function size(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike(collection)) {
          return isString(collection) ? stringSize(collection) : collection.length;
        }
        var tag = getTag(collection);
        if (tag == mapTag || tag == setTag) {
          return collection.size;
        }
        return baseKeys(collection).length;
      }

      /**
       * Checks if `predicate` returns truthy for **any** element of `collection`.
       * Iteration is stopped once `predicate` returns truthy. The predicate is
       * invoked with three arguments: (value, index|key, collection).
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {boolean} Returns `true` if any element passes the predicate check,
       *  else `false`.
       * @example
       *
       * _.some([null, 0, 'yes', false], Boolean);
       * // => true
       *
       * var users = [
       *   { 'user': 'barney', 'active': true },
       *   { 'user': 'fred',   'active': false }
       * ];
       *
       * // The `_.matches` iteratee shorthand.
       * _.some(users, { 'user': 'barney', 'active': false });
       * // => false
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.some(users, ['active', false]);
       * // => true
       *
       * // The `_.property` iteratee shorthand.
       * _.some(users, 'active');
       * // => true
       */
      function some(collection, predicate, guard) {
        var func = isArray(collection) ? arraySome : baseSome;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }

      /**
       * Creates an array of elements, sorted in ascending order by the results of
       * running each element in a collection thru each iteratee. This method
       * performs a stable sort, that is, it preserves the original sort order of
       * equal elements. The iteratees are invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {...(Function|Function[])} [iteratees=[_.identity]]
       *  The iteratees to sort by.
       * @returns {Array} Returns the new sorted array.
       * @example
       *
       * var users = [
       *   { 'user': 'fred',   'age': 48 },
       *   { 'user': 'barney', 'age': 36 },
       *   { 'user': 'fred',   'age': 30 },
       *   { 'user': 'barney', 'age': 34 }
       * ];
       *
       * _.sortBy(users, [function(o) { return o.user; }]);
       * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
       *
       * _.sortBy(users, ['user', 'age']);
       * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
       */
      var sortBy = baseRest(function (collection, iteratees) {
        if (collection == null) {
          return [];
        }
        var length = iteratees.length;
        if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
          iteratees = [];
        } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
          iteratees = [iteratees[0]];
        }
        return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
      });

      /*------------------------------------------------------------------------*/

      /**
       * Gets the timestamp of the number of milliseconds that have elapsed since
       * the Unix epoch (1 January 1970 00:00:00 UTC).
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Date
       * @returns {number} Returns the timestamp.
       * @example
       *
       * _.defer(function(stamp) {
       *   console.log(_.now() - stamp);
       * }, _.now());
       * // => Logs the number of milliseconds it took for the deferred invocation.
       */
      var now = ctxNow || function () {
        return root.Date.now();
      };

      /*------------------------------------------------------------------------*/

      /**
       * The opposite of `_.before`; this method creates a function that invokes
       * `func` once it's called `n` or more times.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {number} n The number of calls before `func` is invoked.
       * @param {Function} func The function to restrict.
       * @returns {Function} Returns the new restricted function.
       * @example
       *
       * var saves = ['profile', 'settings'];
       *
       * var done = _.after(saves.length, function() {
       *   console.log('done saving!');
       * });
       *
       * _.forEach(saves, function(type) {
       *   asyncSave({ 'type': type, 'complete': done });
       * });
       * // => Logs 'done saving!' after the two async saves have completed.
       */
      function after(n, func) {
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        n = toInteger(n);
        return function () {
          if (--n < 1) {
            return func.apply(this, arguments);
          }
        };
      }

      /**
       * Creates a function that invokes `func`, with up to `n` arguments,
       * ignoring any additional arguments.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Function
       * @param {Function} func The function to cap arguments for.
       * @param {number} [n=func.length] The arity cap.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Function} Returns the new capped function.
       * @example
       *
       * _.map(['6', '8', '10'], _.ary(parseInt, 1));
       * // => [6, 8, 10]
       */
      function ary(func, n, guard) {
        n = guard ? undefined$1 : n;
        n = func && n == null ? func.length : n;
        return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
      }

      /**
       * Creates a function that invokes `func`, with the `this` binding and arguments
       * of the created function, while it's called less than `n` times. Subsequent
       * calls to the created function return the result of the last `func` invocation.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Function
       * @param {number} n The number of calls at which `func` is no longer invoked.
       * @param {Function} func The function to restrict.
       * @returns {Function} Returns the new restricted function.
       * @example
       *
       * jQuery(element).on('click', _.before(5, addContactToList));
       * // => Allows adding up to 4 contacts to the list.
       */
      function before(n, func) {
        var result;
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        n = toInteger(n);
        return function () {
          if (--n > 0) {
            result = func.apply(this, arguments);
          }
          if (n <= 1) {
            func = undefined$1;
          }
          return result;
        };
      }

      /**
       * Creates a function that invokes `func` with the `this` binding of `thisArg`
       * and `partials` prepended to the arguments it receives.
       *
       * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
       * may be used as a placeholder for partially applied arguments.
       *
       * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
       * property of bound functions.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to bind.
       * @param {*} thisArg The `this` binding of `func`.
       * @param {...*} [partials] The arguments to be partially applied.
       * @returns {Function} Returns the new bound function.
       * @example
       *
       * function greet(greeting, punctuation) {
       *   return greeting + ' ' + this.user + punctuation;
       * }
       *
       * var object = { 'user': 'fred' };
       *
       * var bound = _.bind(greet, object, 'hi');
       * bound('!');
       * // => 'hi fred!'
       *
       * // Bound with placeholders.
       * var bound = _.bind(greet, object, _, '!');
       * bound('hi');
       * // => 'hi fred!'
       */
      var bind = baseRest(function (func, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(func, bitmask, thisArg, partials, holders);
      });

      /**
       * Creates a function that invokes the method at `object[key]` with `partials`
       * prepended to the arguments it receives.
       *
       * This method differs from `_.bind` by allowing bound functions to reference
       * methods that may be redefined or don't yet exist. See
       * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
       * for more details.
       *
       * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
       * builds, may be used as a placeholder for partially applied arguments.
       *
       * @static
       * @memberOf _
       * @since 0.10.0
       * @category Function
       * @param {Object} object The object to invoke the method on.
       * @param {string} key The key of the method.
       * @param {...*} [partials] The arguments to be partially applied.
       * @returns {Function} Returns the new bound function.
       * @example
       *
       * var object = {
       *   'user': 'fred',
       *   'greet': function(greeting, punctuation) {
       *     return greeting + ' ' + this.user + punctuation;
       *   }
       * };
       *
       * var bound = _.bindKey(object, 'greet', 'hi');
       * bound('!');
       * // => 'hi fred!'
       *
       * object.greet = function(greeting, punctuation) {
       *   return greeting + 'ya ' + this.user + punctuation;
       * };
       *
       * bound('!');
       * // => 'hiya fred!'
       *
       * // Bound with placeholders.
       * var bound = _.bindKey(object, 'greet', _, '!');
       * bound('hi');
       * // => 'hiya fred!'
       */
      var bindKey = baseRest(function (object, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(key, bitmask, object, partials, holders);
      });

      /**
       * Creates a function that accepts arguments of `func` and either invokes
       * `func` returning its result, if at least `arity` number of arguments have
       * been provided, or returns a function that accepts the remaining `func`
       * arguments, and so on. The arity of `func` may be specified if `func.length`
       * is not sufficient.
       *
       * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
       * may be used as a placeholder for provided arguments.
       *
       * **Note:** This method doesn't set the "length" property of curried functions.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Function
       * @param {Function} func The function to curry.
       * @param {number} [arity=func.length] The arity of `func`.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Function} Returns the new curried function.
       * @example
       *
       * var abc = function(a, b, c) {
       *   return [a, b, c];
       * };
       *
       * var curried = _.curry(abc);
       *
       * curried(1)(2)(3);
       * // => [1, 2, 3]
       *
       * curried(1, 2)(3);
       * // => [1, 2, 3]
       *
       * curried(1, 2, 3);
       * // => [1, 2, 3]
       *
       * // Curried with placeholders.
       * curried(1)(_, 3)(2);
       * // => [1, 2, 3]
       */
      function curry(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result.placeholder = curry.placeholder;
        return result;
      }

      /**
       * This method is like `_.curry` except that arguments are applied to `func`
       * in the manner of `_.partialRight` instead of `_.partial`.
       *
       * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
       * builds, may be used as a placeholder for provided arguments.
       *
       * **Note:** This method doesn't set the "length" property of curried functions.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Function
       * @param {Function} func The function to curry.
       * @param {number} [arity=func.length] The arity of `func`.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Function} Returns the new curried function.
       * @example
       *
       * var abc = function(a, b, c) {
       *   return [a, b, c];
       * };
       *
       * var curried = _.curryRight(abc);
       *
       * curried(3)(2)(1);
       * // => [1, 2, 3]
       *
       * curried(2, 3)(1);
       * // => [1, 2, 3]
       *
       * curried(1, 2, 3);
       * // => [1, 2, 3]
       *
       * // Curried with placeholders.
       * curried(3)(1, _)(2);
       * // => [1, 2, 3]
       */
      function curryRight(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result.placeholder = curryRight.placeholder;
        return result;
      }

      /**
       * Creates a debounced function that delays invoking `func` until after `wait`
       * milliseconds have elapsed since the last time the debounced function was
       * invoked. The debounced function comes with a `cancel` method to cancel
       * delayed `func` invocations and a `flush` method to immediately invoke them.
       * Provide `options` to indicate whether `func` should be invoked on the
       * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
       * with the last arguments provided to the debounced function. Subsequent
       * calls to the debounced function return the result of the last `func`
       * invocation.
       *
       * **Note:** If `leading` and `trailing` options are `true`, `func` is
       * invoked on the trailing edge of the timeout only if the debounced function
       * is invoked more than once during the `wait` timeout.
       *
       * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
       * until to the next tick, similar to `setTimeout` with a timeout of `0`.
       *
       * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
       * for details over the differences between `_.debounce` and `_.throttle`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to debounce.
       * @param {number} [wait=0] The number of milliseconds to delay.
       * @param {Object} [options={}] The options object.
       * @param {boolean} [options.leading=false]
       *  Specify invoking on the leading edge of the timeout.
       * @param {number} [options.maxWait]
       *  The maximum time `func` is allowed to be delayed before it's invoked.
       * @param {boolean} [options.trailing=true]
       *  Specify invoking on the trailing edge of the timeout.
       * @returns {Function} Returns the new debounced function.
       * @example
       *
       * // Avoid costly calculations while the window size is in flux.
       * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
       *
       * // Invoke `sendMail` when clicked, debouncing subsequent calls.
       * jQuery(element).on('click', _.debounce(sendMail, 300, {
       *   'leading': true,
       *   'trailing': false
       * }));
       *
       * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
       * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
       * var source = new EventSource('/stream');
       * jQuery(source).on('message', debounced);
       *
       * // Cancel the trailing debounced invocation.
       * jQuery(window).on('popstate', debounced.cancel);
       */
      function debounce(func, wait, options) {
        var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        wait = toNumber(wait) || 0;
        if (isObject(options)) {
          leading = !!options.leading;
          maxing = 'maxWait' in options;
          maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
          trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
          var args = lastArgs,
            thisArg = lastThis;
          lastArgs = lastThis = undefined$1;
          lastInvokeTime = time;
          result = func.apply(thisArg, args);
          return result;
        }
        function leadingEdge(time) {
          // Reset any `maxWait` timer.
          lastInvokeTime = time;
          // Start the timer for the trailing edge.
          timerId = setTimeout(timerExpired, wait);
          // Invoke the leading edge.
          return leading ? invokeFunc(time) : result;
        }
        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

          // Either this is the first call, activity has stopped and we're at the
          // trailing edge, the system time has gone backwards and we're treating
          // it as the trailing edge, or we've hit the `maxWait` limit.
          return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time = now();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          // Restart the timer.
          timerId = setTimeout(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
          timerId = undefined$1;

          // Only invoke if we have `lastArgs` which means `func` has been
          // debounced at least once.
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined$1;
          return result;
        }
        function cancel() {
          if (timerId !== undefined$1) {
            clearTimeout(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$1;
        }
        function flush() {
          return timerId === undefined$1 ? result : trailingEdge(now());
        }
        function debounced() {
          var time = now(),
            isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;
          if (isInvoking) {
            if (timerId === undefined$1) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              // Handle invocations in a tight loop.
              clearTimeout(timerId);
              timerId = setTimeout(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined$1) {
            timerId = setTimeout(timerExpired, wait);
          }
          return result;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }

      /**
       * Defers invoking the `func` until the current call stack has cleared. Any
       * additional arguments are provided to `func` when it's invoked.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to defer.
       * @param {...*} [args] The arguments to invoke `func` with.
       * @returns {number} Returns the timer id.
       * @example
       *
       * _.defer(function(text) {
       *   console.log(text);
       * }, 'deferred');
       * // => Logs 'deferred' after one millisecond.
       */
      var defer = baseRest(function (func, args) {
        return baseDelay(func, 1, args);
      });

      /**
       * Invokes `func` after `wait` milliseconds. Any additional arguments are
       * provided to `func` when it's invoked.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to delay.
       * @param {number} wait The number of milliseconds to delay invocation.
       * @param {...*} [args] The arguments to invoke `func` with.
       * @returns {number} Returns the timer id.
       * @example
       *
       * _.delay(function(text) {
       *   console.log(text);
       * }, 1000, 'later');
       * // => Logs 'later' after one second.
       */
      var delay = baseRest(function (func, wait, args) {
        return baseDelay(func, toNumber(wait) || 0, args);
      });

      /**
       * Creates a function that invokes `func` with arguments reversed.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Function
       * @param {Function} func The function to flip arguments for.
       * @returns {Function} Returns the new flipped function.
       * @example
       *
       * var flipped = _.flip(function() {
       *   return _.toArray(arguments);
       * });
       *
       * flipped('a', 'b', 'c', 'd');
       * // => ['d', 'c', 'b', 'a']
       */
      function flip(func) {
        return createWrap(func, WRAP_FLIP_FLAG);
      }

      /**
       * Creates a function that memoizes the result of `func`. If `resolver` is
       * provided, it determines the cache key for storing the result based on the
       * arguments provided to the memoized function. By default, the first argument
       * provided to the memoized function is used as the map cache key. The `func`
       * is invoked with the `this` binding of the memoized function.
       *
       * **Note:** The cache is exposed as the `cache` property on the memoized
       * function. Its creation may be customized by replacing the `_.memoize.Cache`
       * constructor with one whose instances implement the
       * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
       * method interface of `clear`, `delete`, `get`, `has`, and `set`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to have its output memoized.
       * @param {Function} [resolver] The function to resolve the cache key.
       * @returns {Function} Returns the new memoized function.
       * @example
       *
       * var object = { 'a': 1, 'b': 2 };
       * var other = { 'c': 3, 'd': 4 };
       *
       * var values = _.memoize(_.values);
       * values(object);
       * // => [1, 2]
       *
       * values(other);
       * // => [3, 4]
       *
       * object.a = 2;
       * values(object);
       * // => [1, 2]
       *
       * // Modify the result cache.
       * values.cache.set(object, ['a', 'b']);
       * values(object);
       * // => ['a', 'b']
       *
       * // Replace `_.memoize.Cache`.
       * _.memoize.Cache = WeakMap;
       */
      function memoize(func, resolver) {
        if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        var memoized = function () {
          var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;
          if (cache.has(key)) {
            return cache.get(key);
          }
          var result = func.apply(this, args);
          memoized.cache = cache.set(key, result) || cache;
          return result;
        };
        memoized.cache = new (memoize.Cache || MapCache)();
        return memoized;
      }

      // Expose `MapCache`.
      memoize.Cache = MapCache;

      /**
       * Creates a function that negates the result of the predicate `func`. The
       * `func` predicate is invoked with the `this` binding and arguments of the
       * created function.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Function
       * @param {Function} predicate The predicate to negate.
       * @returns {Function} Returns the new negated function.
       * @example
       *
       * function isEven(n) {
       *   return n % 2 == 0;
       * }
       *
       * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
       * // => [1, 3, 5]
       */
      function negate(predicate) {
        if (typeof predicate != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return function () {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }

      /**
       * Creates a function that is restricted to invoking `func` once. Repeat calls
       * to the function return the value of the first invocation. The `func` is
       * invoked with the `this` binding and arguments of the created function.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to restrict.
       * @returns {Function} Returns the new restricted function.
       * @example
       *
       * var initialize = _.once(createApplication);
       * initialize();
       * initialize();
       * // => `createApplication` is invoked once
       */
      function once(func) {
        return before(2, func);
      }

      /**
       * Creates a function that invokes `func` with its arguments transformed.
       *
       * @static
       * @since 4.0.0
       * @memberOf _
       * @category Function
       * @param {Function} func The function to wrap.
       * @param {...(Function|Function[])} [transforms=[_.identity]]
       *  The argument transforms.
       * @returns {Function} Returns the new function.
       * @example
       *
       * function doubled(n) {
       *   return n * 2;
       * }
       *
       * function square(n) {
       *   return n * n;
       * }
       *
       * var func = _.overArgs(function(x, y) {
       *   return [x, y];
       * }, [square, doubled]);
       *
       * func(9, 3);
       * // => [81, 6]
       *
       * func(10, 5);
       * // => [100, 10]
       */
      var overArgs = castRest(function (func, transforms) {
        transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
        var funcsLength = transforms.length;
        return baseRest(function (args) {
          var index = -1,
            length = nativeMin(args.length, funcsLength);
          while (++index < length) {
            args[index] = transforms[index].call(this, args[index]);
          }
          return apply(func, this, args);
        });
      });

      /**
       * Creates a function that invokes `func` with `partials` prepended to the
       * arguments it receives. This method is like `_.bind` except it does **not**
       * alter the `this` binding.
       *
       * The `_.partial.placeholder` value, which defaults to `_` in monolithic
       * builds, may be used as a placeholder for partially applied arguments.
       *
       * **Note:** This method doesn't set the "length" property of partially
       * applied functions.
       *
       * @static
       * @memberOf _
       * @since 0.2.0
       * @category Function
       * @param {Function} func The function to partially apply arguments to.
       * @param {...*} [partials] The arguments to be partially applied.
       * @returns {Function} Returns the new partially applied function.
       * @example
       *
       * function greet(greeting, name) {
       *   return greeting + ' ' + name;
       * }
       *
       * var sayHelloTo = _.partial(greet, 'hello');
       * sayHelloTo('fred');
       * // => 'hello fred'
       *
       * // Partially applied with placeholders.
       * var greetFred = _.partial(greet, _, 'fred');
       * greetFred('hi');
       * // => 'hi fred'
       */
      var partial = baseRest(function (func, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
      });

      /**
       * This method is like `_.partial` except that partially applied arguments
       * are appended to the arguments it receives.
       *
       * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
       * builds, may be used as a placeholder for partially applied arguments.
       *
       * **Note:** This method doesn't set the "length" property of partially
       * applied functions.
       *
       * @static
       * @memberOf _
       * @since 1.0.0
       * @category Function
       * @param {Function} func The function to partially apply arguments to.
       * @param {...*} [partials] The arguments to be partially applied.
       * @returns {Function} Returns the new partially applied function.
       * @example
       *
       * function greet(greeting, name) {
       *   return greeting + ' ' + name;
       * }
       *
       * var greetFred = _.partialRight(greet, 'fred');
       * greetFred('hi');
       * // => 'hi fred'
       *
       * // Partially applied with placeholders.
       * var sayHelloTo = _.partialRight(greet, 'hello', _);
       * sayHelloTo('fred');
       * // => 'hello fred'
       */
      var partialRight = baseRest(function (func, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
      });

      /**
       * Creates a function that invokes `func` with arguments arranged according
       * to the specified `indexes` where the argument value at the first index is
       * provided as the first argument, the argument value at the second index is
       * provided as the second argument, and so on.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Function
       * @param {Function} func The function to rearrange arguments for.
       * @param {...(number|number[])} indexes The arranged argument indexes.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var rearged = _.rearg(function(a, b, c) {
       *   return [a, b, c];
       * }, [2, 0, 1]);
       *
       * rearged('b', 'c', 'a')
       * // => ['a', 'b', 'c']
       */
      var rearg = flatRest(function (func, indexes) {
        return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
      });

      /**
       * Creates a function that invokes `func` with the `this` binding of the
       * created function and arguments from `start` and beyond provided as
       * an array.
       *
       * **Note:** This method is based on the
       * [rest parameter](https://mdn.io/rest_parameters).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Function
       * @param {Function} func The function to apply a rest parameter to.
       * @param {number} [start=func.length-1] The start position of the rest parameter.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var say = _.rest(function(what, names) {
       *   return what + ' ' + _.initial(names).join(', ') +
       *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
       * });
       *
       * say('hello', 'fred', 'barney', 'pebbles');
       * // => 'hello fred, barney, & pebbles'
       */
      function rest(func, start) {
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        start = start === undefined$1 ? start : toInteger(start);
        return baseRest(func, start);
      }

      /**
       * Creates a function that invokes `func` with the `this` binding of the
       * create function and an array of arguments much like
       * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
       *
       * **Note:** This method is based on the
       * [spread operator](https://mdn.io/spread_operator).
       *
       * @static
       * @memberOf _
       * @since 3.2.0
       * @category Function
       * @param {Function} func The function to spread arguments over.
       * @param {number} [start=0] The start position of the spread.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var say = _.spread(function(who, what) {
       *   return who + ' says ' + what;
       * });
       *
       * say(['fred', 'hello']);
       * // => 'fred says hello'
       *
       * var numbers = Promise.all([
       *   Promise.resolve(40),
       *   Promise.resolve(36)
       * ]);
       *
       * numbers.then(_.spread(function(x, y) {
       *   return x + y;
       * }));
       * // => a Promise of 76
       */
      function spread(func, start) {
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        start = start == null ? 0 : nativeMax(toInteger(start), 0);
        return baseRest(function (args) {
          var array = args[start],
            otherArgs = castSlice(args, 0, start);
          if (array) {
            arrayPush(otherArgs, array);
          }
          return apply(func, this, otherArgs);
        });
      }

      /**
       * Creates a throttled function that only invokes `func` at most once per
       * every `wait` milliseconds. The throttled function comes with a `cancel`
       * method to cancel delayed `func` invocations and a `flush` method to
       * immediately invoke them. Provide `options` to indicate whether `func`
       * should be invoked on the leading and/or trailing edge of the `wait`
       * timeout. The `func` is invoked with the last arguments provided to the
       * throttled function. Subsequent calls to the throttled function return the
       * result of the last `func` invocation.
       *
       * **Note:** If `leading` and `trailing` options are `true`, `func` is
       * invoked on the trailing edge of the timeout only if the throttled function
       * is invoked more than once during the `wait` timeout.
       *
       * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
       * until to the next tick, similar to `setTimeout` with a timeout of `0`.
       *
       * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
       * for details over the differences between `_.throttle` and `_.debounce`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to throttle.
       * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
       * @param {Object} [options={}] The options object.
       * @param {boolean} [options.leading=true]
       *  Specify invoking on the leading edge of the timeout.
       * @param {boolean} [options.trailing=true]
       *  Specify invoking on the trailing edge of the timeout.
       * @returns {Function} Returns the new throttled function.
       * @example
       *
       * // Avoid excessively updating the position while scrolling.
       * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
       *
       * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
       * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
       * jQuery(element).on('click', throttled);
       *
       * // Cancel the trailing throttled invocation.
       * jQuery(window).on('popstate', throttled.cancel);
       */
      function throttle(func, wait, options) {
        var leading = true,
          trailing = true;
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        if (isObject(options)) {
          leading = 'leading' in options ? !!options.leading : leading;
          trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        return debounce(func, wait, {
          'leading': leading,
          'maxWait': wait,
          'trailing': trailing
        });
      }

      /**
       * Creates a function that accepts up to one argument, ignoring any
       * additional arguments.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Function
       * @param {Function} func The function to cap arguments for.
       * @returns {Function} Returns the new capped function.
       * @example
       *
       * _.map(['6', '8', '10'], _.unary(parseInt));
       * // => [6, 8, 10]
       */
      function unary(func) {
        return ary(func, 1);
      }

      /**
       * Creates a function that provides `value` to `wrapper` as its first
       * argument. Any additional arguments provided to the function are appended
       * to those provided to the `wrapper`. The wrapper is invoked with the `this`
       * binding of the created function.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {*} value The value to wrap.
       * @param {Function} [wrapper=identity] The wrapper function.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var p = _.wrap(_.escape, function(func, text) {
       *   return '<p>' + func(text) + '</p>';
       * });
       *
       * p('fred, barney, & pebbles');
       * // => '<p>fred, barney, &amp; pebbles</p>'
       */
      function wrap(value, wrapper) {
        return partial(castFunction(wrapper), value);
      }

      /*------------------------------------------------------------------------*/

      /**
       * Casts `value` as an array if it's not one.
       *
       * @static
       * @memberOf _
       * @since 4.4.0
       * @category Lang
       * @param {*} value The value to inspect.
       * @returns {Array} Returns the cast array.
       * @example
       *
       * _.castArray(1);
       * // => [1]
       *
       * _.castArray({ 'a': 1 });
       * // => [{ 'a': 1 }]
       *
       * _.castArray('abc');
       * // => ['abc']
       *
       * _.castArray(null);
       * // => [null]
       *
       * _.castArray(undefined);
       * // => [undefined]
       *
       * _.castArray();
       * // => []
       *
       * var array = [1, 2, 3];
       * console.log(_.castArray(array) === array);
       * // => true
       */
      function castArray() {
        if (!arguments.length) {
          return [];
        }
        var value = arguments[0];
        return isArray(value) ? value : [value];
      }

      /**
       * Creates a shallow clone of `value`.
       *
       * **Note:** This method is loosely based on the
       * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
       * and supports cloning arrays, array buffers, booleans, date objects, maps,
       * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
       * arrays. The own enumerable properties of `arguments` objects are cloned
       * as plain objects. An empty object is returned for uncloneable values such
       * as error objects, functions, DOM nodes, and WeakMaps.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to clone.
       * @returns {*} Returns the cloned value.
       * @see _.cloneDeep
       * @example
       *
       * var objects = [{ 'a': 1 }, { 'b': 2 }];
       *
       * var shallow = _.clone(objects);
       * console.log(shallow[0] === objects[0]);
       * // => true
       */
      function clone(value) {
        return baseClone(value, CLONE_SYMBOLS_FLAG);
      }

      /**
       * This method is like `_.clone` except that it accepts `customizer` which
       * is invoked to produce the cloned value. If `customizer` returns `undefined`,
       * cloning is handled by the method instead. The `customizer` is invoked with
       * up to four arguments; (value [, index|key, object, stack]).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to clone.
       * @param {Function} [customizer] The function to customize cloning.
       * @returns {*} Returns the cloned value.
       * @see _.cloneDeepWith
       * @example
       *
       * function customizer(value) {
       *   if (_.isElement(value)) {
       *     return value.cloneNode(false);
       *   }
       * }
       *
       * var el = _.cloneWith(document.body, customizer);
       *
       * console.log(el === document.body);
       * // => false
       * console.log(el.nodeName);
       * // => 'BODY'
       * console.log(el.childNodes.length);
       * // => 0
       */
      function cloneWith(value, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
      }

      /**
       * This method is like `_.clone` except that it recursively clones `value`.
       *
       * @static
       * @memberOf _
       * @since 1.0.0
       * @category Lang
       * @param {*} value The value to recursively clone.
       * @returns {*} Returns the deep cloned value.
       * @see _.clone
       * @example
       *
       * var objects = [{ 'a': 1 }, { 'b': 2 }];
       *
       * var deep = _.cloneDeep(objects);
       * console.log(deep[0] === objects[0]);
       * // => false
       */
      function cloneDeep(value) {
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }

      /**
       * This method is like `_.cloneWith` except that it recursively clones `value`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to recursively clone.
       * @param {Function} [customizer] The function to customize cloning.
       * @returns {*} Returns the deep cloned value.
       * @see _.cloneWith
       * @example
       *
       * function customizer(value) {
       *   if (_.isElement(value)) {
       *     return value.cloneNode(true);
       *   }
       * }
       *
       * var el = _.cloneDeepWith(document.body, customizer);
       *
       * console.log(el === document.body);
       * // => false
       * console.log(el.nodeName);
       * // => 'BODY'
       * console.log(el.childNodes.length);
       * // => 20
       */
      function cloneDeepWith(value, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
      }

      /**
       * Checks if `object` conforms to `source` by invoking the predicate
       * properties of `source` with the corresponding property values of `object`.
       *
       * **Note:** This method is equivalent to `_.conforms` when `source` is
       * partially applied.
       *
       * @static
       * @memberOf _
       * @since 4.14.0
       * @category Lang
       * @param {Object} object The object to inspect.
       * @param {Object} source The object of property predicates to conform to.
       * @returns {boolean} Returns `true` if `object` conforms, else `false`.
       * @example
       *
       * var object = { 'a': 1, 'b': 2 };
       *
       * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
       * // => true
       *
       * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
       * // => false
       */
      function conformsTo(object, source) {
        return source == null || baseConformsTo(object, source, keys(source));
      }

      /**
       * Performs a
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * comparison between two values to determine if they are equivalent.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
       * @example
       *
       * var object = { 'a': 1 };
       * var other = { 'a': 1 };
       *
       * _.eq(object, object);
       * // => true
       *
       * _.eq(object, other);
       * // => false
       *
       * _.eq('a', 'a');
       * // => true
       *
       * _.eq('a', Object('a'));
       * // => false
       *
       * _.eq(NaN, NaN);
       * // => true
       */
      function eq(value, other) {
        return value === other || value !== value && other !== other;
      }

      /**
       * Checks if `value` is greater than `other`.
       *
       * @static
       * @memberOf _
       * @since 3.9.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if `value` is greater than `other`,
       *  else `false`.
       * @see _.lt
       * @example
       *
       * _.gt(3, 1);
       * // => true
       *
       * _.gt(3, 3);
       * // => false
       *
       * _.gt(1, 3);
       * // => false
       */
      var gt = createRelationalOperation(baseGt);

      /**
       * Checks if `value` is greater than or equal to `other`.
       *
       * @static
       * @memberOf _
       * @since 3.9.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if `value` is greater than or equal to
       *  `other`, else `false`.
       * @see _.lte
       * @example
       *
       * _.gte(3, 1);
       * // => true
       *
       * _.gte(3, 3);
       * // => true
       *
       * _.gte(1, 3);
       * // => false
       */
      var gte = createRelationalOperation(function (value, other) {
        return value >= other;
      });

      /**
       * Checks if `value` is likely an `arguments` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an `arguments` object,
       *  else `false`.
       * @example
       *
       * _.isArguments(function() { return arguments; }());
       * // => true
       *
       * _.isArguments([1, 2, 3]);
       * // => false
       */
      var isArguments = baseIsArguments(function () {
        return arguments;
      }()) ? baseIsArguments : function (value) {
        return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
      };

      /**
       * Checks if `value` is classified as an `Array` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array, else `false`.
       * @example
       *
       * _.isArray([1, 2, 3]);
       * // => true
       *
       * _.isArray(document.body.children);
       * // => false
       *
       * _.isArray('abc');
       * // => false
       *
       * _.isArray(_.noop);
       * // => false
       */
      var isArray = Array.isArray;

      /**
       * Checks if `value` is classified as an `ArrayBuffer` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
       * @example
       *
       * _.isArrayBuffer(new ArrayBuffer(2));
       * // => true
       *
       * _.isArrayBuffer(new Array(2));
       * // => false
       */
      var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

      /**
       * Checks if `value` is array-like. A value is considered array-like if it's
       * not a function and has a `value.length` that's an integer greater than or
       * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
       * @example
       *
       * _.isArrayLike([1, 2, 3]);
       * // => true
       *
       * _.isArrayLike(document.body.children);
       * // => true
       *
       * _.isArrayLike('abc');
       * // => true
       *
       * _.isArrayLike(_.noop);
       * // => false
       */
      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction(value);
      }

      /**
       * This method is like `_.isArrayLike` except that it also checks if `value`
       * is an object.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array-like object,
       *  else `false`.
       * @example
       *
       * _.isArrayLikeObject([1, 2, 3]);
       * // => true
       *
       * _.isArrayLikeObject(document.body.children);
       * // => true
       *
       * _.isArrayLikeObject('abc');
       * // => false
       *
       * _.isArrayLikeObject(_.noop);
       * // => false
       */
      function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
      }

      /**
       * Checks if `value` is classified as a boolean primitive or object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
       * @example
       *
       * _.isBoolean(false);
       * // => true
       *
       * _.isBoolean(null);
       * // => false
       */
      function isBoolean(value) {
        return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
      }

      /**
       * Checks if `value` is a buffer.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
       * @example
       *
       * _.isBuffer(new Buffer(2));
       * // => true
       *
       * _.isBuffer(new Uint8Array(2));
       * // => false
       */
      var isBuffer = nativeIsBuffer || stubFalse;

      /**
       * Checks if `value` is classified as a `Date` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
       * @example
       *
       * _.isDate(new Date);
       * // => true
       *
       * _.isDate('Mon April 23 2012');
       * // => false
       */
      var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

      /**
       * Checks if `value` is likely a DOM element.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
       * @example
       *
       * _.isElement(document.body);
       * // => true
       *
       * _.isElement('<body>');
       * // => false
       */
      function isElement(value) {
        return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
      }

      /**
       * Checks if `value` is an empty object, collection, map, or set.
       *
       * Objects are considered empty if they have no own enumerable string keyed
       * properties.
       *
       * Array-like values such as `arguments` objects, arrays, buffers, strings, or
       * jQuery-like collections are considered empty if they have a `length` of `0`.
       * Similarly, maps and sets are considered empty if they have a `size` of `0`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is empty, else `false`.
       * @example
       *
       * _.isEmpty(null);
       * // => true
       *
       * _.isEmpty(true);
       * // => true
       *
       * _.isEmpty(1);
       * // => true
       *
       * _.isEmpty([1, 2, 3]);
       * // => false
       *
       * _.isEmpty({ 'a': 1 });
       * // => false
       */
      function isEmpty(value) {
        if (value == null) {
          return true;
        }
        if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
          return !value.length;
        }
        var tag = getTag(value);
        if (tag == mapTag || tag == setTag) {
          return !value.size;
        }
        if (isPrototype(value)) {
          return !baseKeys(value).length;
        }
        for (var key in value) {
          if (hasOwnProperty.call(value, key)) {
            return false;
          }
        }
        return true;
      }

      /**
       * Performs a deep comparison between two values to determine if they are
       * equivalent.
       *
       * **Note:** This method supports comparing arrays, array buffers, booleans,
       * date objects, error objects, maps, numbers, `Object` objects, regexes,
       * sets, strings, symbols, and typed arrays. `Object` objects are compared
       * by their own, not inherited, enumerable properties. Functions and DOM
       * nodes are compared by strict equality, i.e. `===`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
       * @example
       *
       * var object = { 'a': 1 };
       * var other = { 'a': 1 };
       *
       * _.isEqual(object, other);
       * // => true
       *
       * object === other;
       * // => false
       */
      function isEqual(value, other) {
        return baseIsEqual(value, other);
      }

      /**
       * This method is like `_.isEqual` except that it accepts `customizer` which
       * is invoked to compare values. If `customizer` returns `undefined`, comparisons
       * are handled by the method instead. The `customizer` is invoked with up to
       * six arguments: (objValue, othValue [, index|key, object, other, stack]).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @param {Function} [customizer] The function to customize comparisons.
       * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
       * @example
       *
       * function isGreeting(value) {
       *   return /^h(?:i|ello)$/.test(value);
       * }
       *
       * function customizer(objValue, othValue) {
       *   if (isGreeting(objValue) && isGreeting(othValue)) {
       *     return true;
       *   }
       * }
       *
       * var array = ['hello', 'goodbye'];
       * var other = ['hi', 'goodbye'];
       *
       * _.isEqualWith(array, other, customizer);
       * // => true
       */
      function isEqualWith(value, other, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        var result = customizer ? customizer(value, other) : undefined$1;
        return result === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result;
      }

      /**
       * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
       * `SyntaxError`, `TypeError`, or `URIError` object.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
       * @example
       *
       * _.isError(new Error);
       * // => true
       *
       * _.isError(Error);
       * // => false
       */
      function isError(value) {
        if (!isObjectLike(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
      }

      /**
       * Checks if `value` is a finite primitive number.
       *
       * **Note:** This method is based on
       * [`Number.isFinite`](https://mdn.io/Number/isFinite).
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
       * @example
       *
       * _.isFinite(3);
       * // => true
       *
       * _.isFinite(Number.MIN_VALUE);
       * // => true
       *
       * _.isFinite(Infinity);
       * // => false
       *
       * _.isFinite('3');
       * // => false
       */
      function isFinite(value) {
        return typeof value == 'number' && nativeIsFinite(value);
      }

      /**
       * Checks if `value` is classified as a `Function` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a function, else `false`.
       * @example
       *
       * _.isFunction(_);
       * // => true
       *
       * _.isFunction(/abc/);
       * // => false
       */
      function isFunction(value) {
        if (!isObject(value)) {
          return false;
        }
        // The use of `Object#toString` avoids issues with the `typeof` operator
        // in Safari 9 which returns 'object' for typed arrays and other constructors.
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
      }

      /**
       * Checks if `value` is an integer.
       *
       * **Note:** This method is based on
       * [`Number.isInteger`](https://mdn.io/Number/isInteger).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
       * @example
       *
       * _.isInteger(3);
       * // => true
       *
       * _.isInteger(Number.MIN_VALUE);
       * // => false
       *
       * _.isInteger(Infinity);
       * // => false
       *
       * _.isInteger('3');
       * // => false
       */
      function isInteger(value) {
        return typeof value == 'number' && value == toInteger(value);
      }

      /**
       * Checks if `value` is a valid array-like length.
       *
       * **Note:** This method is loosely based on
       * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
       * @example
       *
       * _.isLength(3);
       * // => true
       *
       * _.isLength(Number.MIN_VALUE);
       * // => false
       *
       * _.isLength(Infinity);
       * // => false
       *
       * _.isLength('3');
       * // => false
       */
      function isLength(value) {
        return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }

      /**
       * Checks if `value` is the
       * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
       * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an object, else `false`.
       * @example
       *
       * _.isObject({});
       * // => true
       *
       * _.isObject([1, 2, 3]);
       * // => true
       *
       * _.isObject(_.noop);
       * // => true
       *
       * _.isObject(null);
       * // => false
       */
      function isObject(value) {
        var type = typeof value;
        return value != null && (type == 'object' || type == 'function');
      }

      /**
       * Checks if `value` is object-like. A value is object-like if it's not `null`
       * and has a `typeof` result of "object".
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
       * @example
       *
       * _.isObjectLike({});
       * // => true
       *
       * _.isObjectLike([1, 2, 3]);
       * // => true
       *
       * _.isObjectLike(_.noop);
       * // => false
       *
       * _.isObjectLike(null);
       * // => false
       */
      function isObjectLike(value) {
        return value != null && typeof value == 'object';
      }

      /**
       * Checks if `value` is classified as a `Map` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a map, else `false`.
       * @example
       *
       * _.isMap(new Map);
       * // => true
       *
       * _.isMap(new WeakMap);
       * // => false
       */
      var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

      /**
       * Performs a partial deep comparison between `object` and `source` to
       * determine if `object` contains equivalent property values.
       *
       * **Note:** This method is equivalent to `_.matches` when `source` is
       * partially applied.
       *
       * Partial comparisons will match empty array and empty object `source`
       * values against any array or object value, respectively. See `_.isEqual`
       * for a list of supported value comparisons.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {Object} object The object to inspect.
       * @param {Object} source The object of property values to match.
       * @returns {boolean} Returns `true` if `object` is a match, else `false`.
       * @example
       *
       * var object = { 'a': 1, 'b': 2 };
       *
       * _.isMatch(object, { 'b': 2 });
       * // => true
       *
       * _.isMatch(object, { 'b': 1 });
       * // => false
       */
      function isMatch(object, source) {
        return object === source || baseIsMatch(object, source, getMatchData(source));
      }

      /**
       * This method is like `_.isMatch` except that it accepts `customizer` which
       * is invoked to compare values. If `customizer` returns `undefined`, comparisons
       * are handled by the method instead. The `customizer` is invoked with five
       * arguments: (objValue, srcValue, index|key, object, source).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {Object} object The object to inspect.
       * @param {Object} source The object of property values to match.
       * @param {Function} [customizer] The function to customize comparisons.
       * @returns {boolean} Returns `true` if `object` is a match, else `false`.
       * @example
       *
       * function isGreeting(value) {
       *   return /^h(?:i|ello)$/.test(value);
       * }
       *
       * function customizer(objValue, srcValue) {
       *   if (isGreeting(objValue) && isGreeting(srcValue)) {
       *     return true;
       *   }
       * }
       *
       * var object = { 'greeting': 'hello' };
       * var source = { 'greeting': 'hi' };
       *
       * _.isMatchWith(object, source, customizer);
       * // => true
       */
      function isMatchWith(object, source, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return baseIsMatch(object, source, getMatchData(source), customizer);
      }

      /**
       * Checks if `value` is `NaN`.
       *
       * **Note:** This method is based on
       * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
       * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
       * `undefined` and other non-number values.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
       * @example
       *
       * _.isNaN(NaN);
       * // => true
       *
       * _.isNaN(new Number(NaN));
       * // => true
       *
       * isNaN(undefined);
       * // => true
       *
       * _.isNaN(undefined);
       * // => false
       */
      function isNaN(value) {
        // An `NaN` primitive is the only value that is not equal to itself.
        // Perform the `toStringTag` check first to avoid errors with some
        // ActiveX objects in IE.
        return isNumber(value) && value != +value;
      }

      /**
       * Checks if `value` is a pristine native function.
       *
       * **Note:** This method can't reliably detect native functions in the presence
       * of the core-js package because core-js circumvents this kind of detection.
       * Despite multiple requests, the core-js maintainer has made it clear: any
       * attempt to fix the detection will be obstructed. As a result, we're left
       * with little choice but to throw an error. Unfortunately, this also affects
       * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
       * which rely on core-js.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a native function,
       *  else `false`.
       * @example
       *
       * _.isNative(Array.prototype.push);
       * // => true
       *
       * _.isNative(_);
       * // => false
       */
      function isNative(value) {
        if (isMaskable(value)) {
          throw new Error(CORE_ERROR_TEXT);
        }
        return baseIsNative(value);
      }

      /**
       * Checks if `value` is `null`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
       * @example
       *
       * _.isNull(null);
       * // => true
       *
       * _.isNull(void 0);
       * // => false
       */
      function isNull(value) {
        return value === null;
      }

      /**
       * Checks if `value` is `null` or `undefined`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
       * @example
       *
       * _.isNil(null);
       * // => true
       *
       * _.isNil(void 0);
       * // => true
       *
       * _.isNil(NaN);
       * // => false
       */
      function isNil(value) {
        return value == null;
      }

      /**
       * Checks if `value` is classified as a `Number` primitive or object.
       *
       * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
       * classified as numbers, use the `_.isFinite` method.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a number, else `false`.
       * @example
       *
       * _.isNumber(3);
       * // => true
       *
       * _.isNumber(Number.MIN_VALUE);
       * // => true
       *
       * _.isNumber(Infinity);
       * // => true
       *
       * _.isNumber('3');
       * // => false
       */
      function isNumber(value) {
        return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
      }

      /**
       * Checks if `value` is a plain object, that is, an object created by the
       * `Object` constructor or one with a `[[Prototype]]` of `null`.
       *
       * @static
       * @memberOf _
       * @since 0.8.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       * }
       *
       * _.isPlainObject(new Foo);
       * // => false
       *
       * _.isPlainObject([1, 2, 3]);
       * // => false
       *
       * _.isPlainObject({ 'x': 0, 'y': 0 });
       * // => true
       *
       * _.isPlainObject(Object.create(null));
       * // => true
       */
      function isPlainObject(value) {
        if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
          return false;
        }
        var proto = getPrototype(value);
        if (proto === null) {
          return true;
        }
        var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
        return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
      }

      /**
       * Checks if `value` is classified as a `RegExp` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
       * @example
       *
       * _.isRegExp(/abc/);
       * // => true
       *
       * _.isRegExp('/abc/');
       * // => false
       */
      var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

      /**
       * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
       * double precision number which isn't the result of a rounded unsafe integer.
       *
       * **Note:** This method is based on
       * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
       * @example
       *
       * _.isSafeInteger(3);
       * // => true
       *
       * _.isSafeInteger(Number.MIN_VALUE);
       * // => false
       *
       * _.isSafeInteger(Infinity);
       * // => false
       *
       * _.isSafeInteger('3');
       * // => false
       */
      function isSafeInteger(value) {
        return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
      }

      /**
       * Checks if `value` is classified as a `Set` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a set, else `false`.
       * @example
       *
       * _.isSet(new Set);
       * // => true
       *
       * _.isSet(new WeakSet);
       * // => false
       */
      var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

      /**
       * Checks if `value` is classified as a `String` primitive or object.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a string, else `false`.
       * @example
       *
       * _.isString('abc');
       * // => true
       *
       * _.isString(1);
       * // => false
       */
      function isString(value) {
        return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
      }

      /**
       * Checks if `value` is classified as a `Symbol` primitive or object.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
       * @example
       *
       * _.isSymbol(Symbol.iterator);
       * // => true
       *
       * _.isSymbol('abc');
       * // => false
       */
      function isSymbol(value) {
        return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
      }

      /**
       * Checks if `value` is classified as a typed array.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
       * @example
       *
       * _.isTypedArray(new Uint8Array);
       * // => true
       *
       * _.isTypedArray([]);
       * // => false
       */
      var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

      /**
       * Checks if `value` is `undefined`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
       * @example
       *
       * _.isUndefined(void 0);
       * // => true
       *
       * _.isUndefined(null);
       * // => false
       */
      function isUndefined(value) {
        return value === undefined$1;
      }

      /**
       * Checks if `value` is classified as a `WeakMap` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
       * @example
       *
       * _.isWeakMap(new WeakMap);
       * // => true
       *
       * _.isWeakMap(new Map);
       * // => false
       */
      function isWeakMap(value) {
        return isObjectLike(value) && getTag(value) == weakMapTag;
      }

      /**
       * Checks if `value` is classified as a `WeakSet` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
       * @example
       *
       * _.isWeakSet(new WeakSet);
       * // => true
       *
       * _.isWeakSet(new Set);
       * // => false
       */
      function isWeakSet(value) {
        return isObjectLike(value) && baseGetTag(value) == weakSetTag;
      }

      /**
       * Checks if `value` is less than `other`.
       *
       * @static
       * @memberOf _
       * @since 3.9.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if `value` is less than `other`,
       *  else `false`.
       * @see _.gt
       * @example
       *
       * _.lt(1, 3);
       * // => true
       *
       * _.lt(3, 3);
       * // => false
       *
       * _.lt(3, 1);
       * // => false
       */
      var lt = createRelationalOperation(baseLt);

      /**
       * Checks if `value` is less than or equal to `other`.
       *
       * @static
       * @memberOf _
       * @since 3.9.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if `value` is less than or equal to
       *  `other`, else `false`.
       * @see _.gte
       * @example
       *
       * _.lte(1, 3);
       * // => true
       *
       * _.lte(3, 3);
       * // => true
       *
       * _.lte(3, 1);
       * // => false
       */
      var lte = createRelationalOperation(function (value, other) {
        return value <= other;
      });

      /**
       * Converts `value` to an array.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {Array} Returns the converted array.
       * @example
       *
       * _.toArray({ 'a': 1, 'b': 2 });
       * // => [1, 2]
       *
       * _.toArray('abc');
       * // => ['a', 'b', 'c']
       *
       * _.toArray(1);
       * // => []
       *
       * _.toArray(null);
       * // => []
       */
      function toArray(value) {
        if (!value) {
          return [];
        }
        if (isArrayLike(value)) {
          return isString(value) ? stringToArray(value) : copyArray(value);
        }
        if (symIterator && value[symIterator]) {
          return iteratorToArray(value[symIterator]());
        }
        var tag = getTag(value),
          func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
        return func(value);
      }

      /**
       * Converts `value` to a finite number.
       *
       * @static
       * @memberOf _
       * @since 4.12.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {number} Returns the converted number.
       * @example
       *
       * _.toFinite(3.2);
       * // => 3.2
       *
       * _.toFinite(Number.MIN_VALUE);
       * // => 5e-324
       *
       * _.toFinite(Infinity);
       * // => 1.7976931348623157e+308
       *
       * _.toFinite('3.2');
       * // => 3.2
       */
      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber(value);
        if (value === INFINITY || value === -INFINITY) {
          var sign = value < 0 ? -1 : 1;
          return sign * MAX_INTEGER;
        }
        return value === value ? value : 0;
      }

      /**
       * Converts `value` to an integer.
       *
       * **Note:** This method is loosely based on
       * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {number} Returns the converted integer.
       * @example
       *
       * _.toInteger(3.2);
       * // => 3
       *
       * _.toInteger(Number.MIN_VALUE);
       * // => 0
       *
       * _.toInteger(Infinity);
       * // => 1.7976931348623157e+308
       *
       * _.toInteger('3.2');
       * // => 3
       */
      function toInteger(value) {
        var result = toFinite(value),
          remainder = result % 1;
        return result === result ? remainder ? result - remainder : result : 0;
      }

      /**
       * Converts `value` to an integer suitable for use as the length of an
       * array-like object.
       *
       * **Note:** This method is based on
       * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {number} Returns the converted integer.
       * @example
       *
       * _.toLength(3.2);
       * // => 3
       *
       * _.toLength(Number.MIN_VALUE);
       * // => 0
       *
       * _.toLength(Infinity);
       * // => 4294967295
       *
       * _.toLength('3.2');
       * // => 3
       */
      function toLength(value) {
        return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
      }

      /**
       * Converts `value` to a number.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to process.
       * @returns {number} Returns the number.
       * @example
       *
       * _.toNumber(3.2);
       * // => 3.2
       *
       * _.toNumber(Number.MIN_VALUE);
       * // => 5e-324
       *
       * _.toNumber(Infinity);
       * // => Infinity
       *
       * _.toNumber('3.2');
       * // => 3.2
       */
      function toNumber(value) {
        if (typeof value == 'number') {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        if (isObject(value)) {
          var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
          value = isObject(other) ? other + '' : other;
        }
        if (typeof value != 'string') {
          return value === 0 ? value : +value;
        }
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
      }

      /**
       * Converts `value` to a plain object flattening inherited enumerable string
       * keyed properties of `value` to own properties of the plain object.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {Object} Returns the converted plain object.
       * @example
       *
       * function Foo() {
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.assign({ 'a': 1 }, new Foo);
       * // => { 'a': 1, 'b': 2 }
       *
       * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
       * // => { 'a': 1, 'b': 2, 'c': 3 }
       */
      function toPlainObject(value) {
        return copyObject(value, keysIn(value));
      }

      /**
       * Converts `value` to a safe integer. A safe integer can be compared and
       * represented correctly.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {number} Returns the converted integer.
       * @example
       *
       * _.toSafeInteger(3.2);
       * // => 3
       *
       * _.toSafeInteger(Number.MIN_VALUE);
       * // => 0
       *
       * _.toSafeInteger(Infinity);
       * // => 9007199254740991
       *
       * _.toSafeInteger('3.2');
       * // => 3
       */
      function toSafeInteger(value) {
        return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
      }

      /**
       * Converts `value` to a string. An empty string is returned for `null`
       * and `undefined` values. The sign of `-0` is preserved.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {string} Returns the converted string.
       * @example
       *
       * _.toString(null);
       * // => ''
       *
       * _.toString(-0);
       * // => '-0'
       *
       * _.toString([1, 2, 3]);
       * // => '1,2,3'
       */
      function toString(value) {
        return value == null ? '' : baseToString(value);
      }

      /*------------------------------------------------------------------------*/

      /**
       * Assigns own enumerable string keyed properties of source objects to the
       * destination object. Source objects are applied from left to right.
       * Subsequent sources overwrite property assignments of previous sources.
       *
       * **Note:** This method mutates `object` and is loosely based on
       * [`Object.assign`](https://mdn.io/Object/assign).
       *
       * @static
       * @memberOf _
       * @since 0.10.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @see _.assignIn
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       * }
       *
       * function Bar() {
       *   this.c = 3;
       * }
       *
       * Foo.prototype.b = 2;
       * Bar.prototype.d = 4;
       *
       * _.assign({ 'a': 0 }, new Foo, new Bar);
       * // => { 'a': 1, 'c': 3 }
       */
      var assign = createAssigner(function (object, source) {
        if (isPrototype(source) || isArrayLike(source)) {
          copyObject(source, keys(source), object);
          return;
        }
        for (var key in source) {
          if (hasOwnProperty.call(source, key)) {
            assignValue(object, key, source[key]);
          }
        }
      });

      /**
       * This method is like `_.assign` except that it iterates over own and
       * inherited source properties.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @alias extend
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @see _.assign
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       * }
       *
       * function Bar() {
       *   this.c = 3;
       * }
       *
       * Foo.prototype.b = 2;
       * Bar.prototype.d = 4;
       *
       * _.assignIn({ 'a': 0 }, new Foo, new Bar);
       * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
       */
      var assignIn = createAssigner(function (object, source) {
        copyObject(source, keysIn(source), object);
      });

      /**
       * This method is like `_.assignIn` except that it accepts `customizer`
       * which is invoked to produce the assigned values. If `customizer` returns
       * `undefined`, assignment is handled by the method instead. The `customizer`
       * is invoked with five arguments: (objValue, srcValue, key, object, source).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @alias extendWith
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} sources The source objects.
       * @param {Function} [customizer] The function to customize assigned values.
       * @returns {Object} Returns `object`.
       * @see _.assignWith
       * @example
       *
       * function customizer(objValue, srcValue) {
       *   return _.isUndefined(objValue) ? srcValue : objValue;
       * }
       *
       * var defaults = _.partialRight(_.assignInWith, customizer);
       *
       * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
       * // => { 'a': 1, 'b': 2 }
       */
      var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
        copyObject(source, keysIn(source), object, customizer);
      });

      /**
       * This method is like `_.assign` except that it accepts `customizer`
       * which is invoked to produce the assigned values. If `customizer` returns
       * `undefined`, assignment is handled by the method instead. The `customizer`
       * is invoked with five arguments: (objValue, srcValue, key, object, source).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} sources The source objects.
       * @param {Function} [customizer] The function to customize assigned values.
       * @returns {Object} Returns `object`.
       * @see _.assignInWith
       * @example
       *
       * function customizer(objValue, srcValue) {
       *   return _.isUndefined(objValue) ? srcValue : objValue;
       * }
       *
       * var defaults = _.partialRight(_.assignWith, customizer);
       *
       * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
       * // => { 'a': 1, 'b': 2 }
       */
      var assignWith = createAssigner(function (object, source, srcIndex, customizer) {
        copyObject(source, keys(source), object, customizer);
      });

      /**
       * Creates an array of values corresponding to `paths` of `object`.
       *
       * @static
       * @memberOf _
       * @since 1.0.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {...(string|string[])} [paths] The property paths to pick.
       * @returns {Array} Returns the picked values.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
       *
       * _.at(object, ['a[0].b.c', 'a[1]']);
       * // => [3, 4]
       */
      var at = flatRest(baseAt);

      /**
       * Creates an object that inherits from the `prototype` object. If a
       * `properties` object is given, its own enumerable string keyed properties
       * are assigned to the created object.
       *
       * @static
       * @memberOf _
       * @since 2.3.0
       * @category Object
       * @param {Object} prototype The object to inherit from.
       * @param {Object} [properties] The properties to assign to the object.
       * @returns {Object} Returns the new object.
       * @example
       *
       * function Shape() {
       *   this.x = 0;
       *   this.y = 0;
       * }
       *
       * function Circle() {
       *   Shape.call(this);
       * }
       *
       * Circle.prototype = _.create(Shape.prototype, {
       *   'constructor': Circle
       * });
       *
       * var circle = new Circle;
       * circle instanceof Circle;
       * // => true
       *
       * circle instanceof Shape;
       * // => true
       */
      function create(prototype, properties) {
        var result = baseCreate(prototype);
        return properties == null ? result : baseAssign(result, properties);
      }

      /**
       * Assigns own and inherited enumerable string keyed properties of source
       * objects to the destination object for all destination properties that
       * resolve to `undefined`. Source objects are applied from left to right.
       * Once a property is set, additional values of the same property are ignored.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @see _.defaultsDeep
       * @example
       *
       * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
       * // => { 'a': 1, 'b': 2 }
       */
      var defaults = baseRest(function (object, sources) {
        object = Object(object);
        var index = -1;
        var length = sources.length;
        var guard = length > 2 ? sources[2] : undefined$1;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          var props = keysIn(source);
          var propsIndex = -1;
          var propsLength = props.length;
          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined$1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
              object[key] = source[key];
            }
          }
        }
        return object;
      });

      /**
       * This method is like `_.defaults` except that it recursively assigns
       * default properties.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 3.10.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @see _.defaults
       * @example
       *
       * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
       * // => { 'a': { 'b': 2, 'c': 3 } }
       */
      var defaultsDeep = baseRest(function (args) {
        args.push(undefined$1, customDefaultsMerge);
        return apply(mergeWith, undefined$1, args);
      });

      /**
       * This method is like `_.find` except that it returns the key of the first
       * element `predicate` returns truthy for instead of the element itself.
       *
       * @static
       * @memberOf _
       * @since 1.1.0
       * @category Object
       * @param {Object} object The object to inspect.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {string|undefined} Returns the key of the matched element,
       *  else `undefined`.
       * @example
       *
       * var users = {
       *   'barney':  { 'age': 36, 'active': true },
       *   'fred':    { 'age': 40, 'active': false },
       *   'pebbles': { 'age': 1,  'active': true }
       * };
       *
       * _.findKey(users, function(o) { return o.age < 40; });
       * // => 'barney' (iteration order is not guaranteed)
       *
       * // The `_.matches` iteratee shorthand.
       * _.findKey(users, { 'age': 1, 'active': true });
       * // => 'pebbles'
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.findKey(users, ['active', false]);
       * // => 'fred'
       *
       * // The `_.property` iteratee shorthand.
       * _.findKey(users, 'active');
       * // => 'barney'
       */
      function findKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
      }

      /**
       * This method is like `_.findKey` except that it iterates over elements of
       * a collection in the opposite order.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Object
       * @param {Object} object The object to inspect.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {string|undefined} Returns the key of the matched element,
       *  else `undefined`.
       * @example
       *
       * var users = {
       *   'barney':  { 'age': 36, 'active': true },
       *   'fred':    { 'age': 40, 'active': false },
       *   'pebbles': { 'age': 1,  'active': true }
       * };
       *
       * _.findLastKey(users, function(o) { return o.age < 40; });
       * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
       *
       * // The `_.matches` iteratee shorthand.
       * _.findLastKey(users, { 'age': 36, 'active': true });
       * // => 'barney'
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.findLastKey(users, ['active', false]);
       * // => 'fred'
       *
       * // The `_.property` iteratee shorthand.
       * _.findLastKey(users, 'active');
       * // => 'pebbles'
       */
      function findLastKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
      }

      /**
       * Iterates over own and inherited enumerable string keyed properties of an
       * object and invokes `iteratee` for each property. The iteratee is invoked
       * with three arguments: (value, key, object). Iteratee functions may exit
       * iteration early by explicitly returning `false`.
       *
       * @static
       * @memberOf _
       * @since 0.3.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Object} Returns `object`.
       * @see _.forInRight
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.forIn(new Foo, function(value, key) {
       *   console.log(key);
       * });
       * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
       */
      function forIn(object, iteratee) {
        return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
      }

      /**
       * This method is like `_.forIn` except that it iterates over properties of
       * `object` in the opposite order.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Object} Returns `object`.
       * @see _.forIn
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.forInRight(new Foo, function(value, key) {
       *   console.log(key);
       * });
       * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
       */
      function forInRight(object, iteratee) {
        return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
      }

      /**
       * Iterates over own enumerable string keyed properties of an object and
       * invokes `iteratee` for each property. The iteratee is invoked with three
       * arguments: (value, key, object). Iteratee functions may exit iteration
       * early by explicitly returning `false`.
       *
       * @static
       * @memberOf _
       * @since 0.3.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Object} Returns `object`.
       * @see _.forOwnRight
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.forOwn(new Foo, function(value, key) {
       *   console.log(key);
       * });
       * // => Logs 'a' then 'b' (iteration order is not guaranteed).
       */
      function forOwn(object, iteratee) {
        return object && baseForOwn(object, getIteratee(iteratee, 3));
      }

      /**
       * This method is like `_.forOwn` except that it iterates over properties of
       * `object` in the opposite order.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Object} Returns `object`.
       * @see _.forOwn
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.forOwnRight(new Foo, function(value, key) {
       *   console.log(key);
       * });
       * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
       */
      function forOwnRight(object, iteratee) {
        return object && baseForOwnRight(object, getIteratee(iteratee, 3));
      }

      /**
       * Creates an array of function property names from own enumerable properties
       * of `object`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to inspect.
       * @returns {Array} Returns the function names.
       * @see _.functionsIn
       * @example
       *
       * function Foo() {
       *   this.a = _.constant('a');
       *   this.b = _.constant('b');
       * }
       *
       * Foo.prototype.c = _.constant('c');
       *
       * _.functions(new Foo);
       * // => ['a', 'b']
       */
      function functions(object) {
        return object == null ? [] : baseFunctions(object, keys(object));
      }

      /**
       * Creates an array of function property names from own and inherited
       * enumerable properties of `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The object to inspect.
       * @returns {Array} Returns the function names.
       * @see _.functions
       * @example
       *
       * function Foo() {
       *   this.a = _.constant('a');
       *   this.b = _.constant('b');
       * }
       *
       * Foo.prototype.c = _.constant('c');
       *
       * _.functionsIn(new Foo);
       * // => ['a', 'b', 'c']
       */
      function functionsIn(object) {
        return object == null ? [] : baseFunctions(object, keysIn(object));
      }

      /**
       * Gets the value at `path` of `object`. If the resolved value is
       * `undefined`, the `defaultValue` is returned in its place.
       *
       * @static
       * @memberOf _
       * @since 3.7.0
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path of the property to get.
       * @param {*} [defaultValue] The value returned for `undefined` resolved values.
       * @returns {*} Returns the resolved value.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 3 } }] };
       *
       * _.get(object, 'a[0].b.c');
       * // => 3
       *
       * _.get(object, ['a', '0', 'b', 'c']);
       * // => 3
       *
       * _.get(object, 'a.b.c', 'default');
       * // => 'default'
       */
      function get(object, path, defaultValue) {
        var result = object == null ? undefined$1 : baseGet(object, path);
        return result === undefined$1 ? defaultValue : result;
      }

      /**
       * Checks if `path` is a direct property of `object`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path to check.
       * @returns {boolean} Returns `true` if `path` exists, else `false`.
       * @example
       *
       * var object = { 'a': { 'b': 2 } };
       * var other = _.create({ 'a': _.create({ 'b': 2 }) });
       *
       * _.has(object, 'a');
       * // => true
       *
       * _.has(object, 'a.b');
       * // => true
       *
       * _.has(object, ['a', 'b']);
       * // => true
       *
       * _.has(other, 'a');
       * // => false
       */
      function has(object, path) {
        return object != null && hasPath(object, path, baseHas);
      }

      /**
       * Checks if `path` is a direct or inherited property of `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path to check.
       * @returns {boolean} Returns `true` if `path` exists, else `false`.
       * @example
       *
       * var object = _.create({ 'a': _.create({ 'b': 2 }) });
       *
       * _.hasIn(object, 'a');
       * // => true
       *
       * _.hasIn(object, 'a.b');
       * // => true
       *
       * _.hasIn(object, ['a', 'b']);
       * // => true
       *
       * _.hasIn(object, 'b');
       * // => false
       */
      function hasIn(object, path) {
        return object != null && hasPath(object, path, baseHasIn);
      }

      /**
       * Creates an object composed of the inverted keys and values of `object`.
       * If `object` contains duplicate values, subsequent values overwrite
       * property assignments of previous values.
       *
       * @static
       * @memberOf _
       * @since 0.7.0
       * @category Object
       * @param {Object} object The object to invert.
       * @returns {Object} Returns the new inverted object.
       * @example
       *
       * var object = { 'a': 1, 'b': 2, 'c': 1 };
       *
       * _.invert(object);
       * // => { '1': 'c', '2': 'b' }
       */
      var invert = createInverter(function (result, value, key) {
        if (value != null && typeof value.toString != 'function') {
          value = nativeObjectToString.call(value);
        }
        result[value] = key;
      }, constant(identity));

      /**
       * This method is like `_.invert` except that the inverted object is generated
       * from the results of running each element of `object` thru `iteratee`. The
       * corresponding inverted value of each inverted key is an array of keys
       * responsible for generating the inverted value. The iteratee is invoked
       * with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.1.0
       * @category Object
       * @param {Object} object The object to invert.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Object} Returns the new inverted object.
       * @example
       *
       * var object = { 'a': 1, 'b': 2, 'c': 1 };
       *
       * _.invertBy(object);
       * // => { '1': ['a', 'c'], '2': ['b'] }
       *
       * _.invertBy(object, function(value) {
       *   return 'group' + value;
       * });
       * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
       */
      var invertBy = createInverter(function (result, value, key) {
        if (value != null && typeof value.toString != 'function') {
          value = nativeObjectToString.call(value);
        }
        if (hasOwnProperty.call(result, value)) {
          result[value].push(key);
        } else {
          result[value] = [key];
        }
      }, getIteratee);

      /**
       * Invokes the method at `path` of `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path of the method to invoke.
       * @param {...*} [args] The arguments to invoke the method with.
       * @returns {*} Returns the result of the invoked method.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
       *
       * _.invoke(object, 'a[0].b.c.slice', 1, 3);
       * // => [2, 3]
       */
      var invoke = baseRest(baseInvoke);

      /**
       * Creates an array of the own enumerable property names of `object`.
       *
       * **Note:** Non-object values are coerced to objects. See the
       * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
       * for more details.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.keys(new Foo);
       * // => ['a', 'b'] (iteration order is not guaranteed)
       *
       * _.keys('hi');
       * // => ['0', '1']
       */
      function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }

      /**
       * Creates an array of the own and inherited enumerable property names of `object`.
       *
       * **Note:** Non-object values are coerced to objects.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.keysIn(new Foo);
       * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
       */
      function keysIn(object) {
        return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
      }

      /**
       * The opposite of `_.mapValues`; this method creates an object with the
       * same values as `object` and keys generated by running each own enumerable
       * string keyed property of `object` thru `iteratee`. The iteratee is invoked
       * with three arguments: (value, key, object).
       *
       * @static
       * @memberOf _
       * @since 3.8.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Object} Returns the new mapped object.
       * @see _.mapValues
       * @example
       *
       * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
       *   return key + value;
       * });
       * // => { 'a1': 1, 'b2': 2 }
       */
      function mapKeys(object, iteratee) {
        var result = {};
        iteratee = getIteratee(iteratee, 3);
        baseForOwn(object, function (value, key, object) {
          baseAssignValue(result, iteratee(value, key, object), value);
        });
        return result;
      }

      /**
       * Creates an object with the same keys as `object` and values generated
       * by running each own enumerable string keyed property of `object` thru
       * `iteratee`. The iteratee is invoked with three arguments:
       * (value, key, object).
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Object} Returns the new mapped object.
       * @see _.mapKeys
       * @example
       *
       * var users = {
       *   'fred':    { 'user': 'fred',    'age': 40 },
       *   'pebbles': { 'user': 'pebbles', 'age': 1 }
       * };
       *
       * _.mapValues(users, function(o) { return o.age; });
       * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
       *
       * // The `_.property` iteratee shorthand.
       * _.mapValues(users, 'age');
       * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
       */
      function mapValues(object, iteratee) {
        var result = {};
        iteratee = getIteratee(iteratee, 3);
        baseForOwn(object, function (value, key, object) {
          baseAssignValue(result, key, iteratee(value, key, object));
        });
        return result;
      }

      /**
       * This method is like `_.assign` except that it recursively merges own and
       * inherited enumerable string keyed properties of source objects into the
       * destination object. Source properties that resolve to `undefined` are
       * skipped if a destination value exists. Array and plain object properties
       * are merged recursively. Other objects and value types are overridden by
       * assignment. Source objects are applied from left to right. Subsequent
       * sources overwrite property assignments of previous sources.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 0.5.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var object = {
       *   'a': [{ 'b': 2 }, { 'd': 4 }]
       * };
       *
       * var other = {
       *   'a': [{ 'c': 3 }, { 'e': 5 }]
       * };
       *
       * _.merge(object, other);
       * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
       */
      var merge = createAssigner(function (object, source, srcIndex) {
        baseMerge(object, source, srcIndex);
      });

      /**
       * This method is like `_.merge` except that it accepts `customizer` which
       * is invoked to produce the merged values of the destination and source
       * properties. If `customizer` returns `undefined`, merging is handled by the
       * method instead. The `customizer` is invoked with six arguments:
       * (objValue, srcValue, key, object, source, stack).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} sources The source objects.
       * @param {Function} customizer The function to customize assigned values.
       * @returns {Object} Returns `object`.
       * @example
       *
       * function customizer(objValue, srcValue) {
       *   if (_.isArray(objValue)) {
       *     return objValue.concat(srcValue);
       *   }
       * }
       *
       * var object = { 'a': [1], 'b': [2] };
       * var other = { 'a': [3], 'b': [4] };
       *
       * _.mergeWith(object, other, customizer);
       * // => { 'a': [1, 3], 'b': [2, 4] }
       */
      var mergeWith = createAssigner(function (object, source, srcIndex, customizer) {
        baseMerge(object, source, srcIndex, customizer);
      });

      /**
       * The opposite of `_.pick`; this method creates an object composed of the
       * own and inherited enumerable property paths of `object` that are not omitted.
       *
       * **Note:** This method is considerably slower than `_.pick`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The source object.
       * @param {...(string|string[])} [paths] The property paths to omit.
       * @returns {Object} Returns the new object.
       * @example
       *
       * var object = { 'a': 1, 'b': '2', 'c': 3 };
       *
       * _.omit(object, ['a', 'c']);
       * // => { 'b': '2' }
       */
      var omit = flatRest(function (object, paths) {
        var result = {};
        if (object == null) {
          return result;
        }
        var isDeep = false;
        paths = arrayMap(paths, function (path) {
          path = castPath(path, object);
          isDeep || (isDeep = path.length > 1);
          return path;
        });
        copyObject(object, getAllKeysIn(object), result);
        if (isDeep) {
          result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
        }
        var length = paths.length;
        while (length--) {
          baseUnset(result, paths[length]);
        }
        return result;
      });

      /**
       * The opposite of `_.pickBy`; this method creates an object composed of
       * the own and inherited enumerable string keyed properties of `object` that
       * `predicate` doesn't return truthy for. The predicate is invoked with two
       * arguments: (value, key).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The source object.
       * @param {Function} [predicate=_.identity] The function invoked per property.
       * @returns {Object} Returns the new object.
       * @example
       *
       * var object = { 'a': 1, 'b': '2', 'c': 3 };
       *
       * _.omitBy(object, _.isNumber);
       * // => { 'b': '2' }
       */
      function omitBy(object, predicate) {
        return pickBy(object, negate(getIteratee(predicate)));
      }

      /**
       * Creates an object composed of the picked `object` properties.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The source object.
       * @param {...(string|string[])} [paths] The property paths to pick.
       * @returns {Object} Returns the new object.
       * @example
       *
       * var object = { 'a': 1, 'b': '2', 'c': 3 };
       *
       * _.pick(object, ['a', 'c']);
       * // => { 'a': 1, 'c': 3 }
       */
      var pick = flatRest(function (object, paths) {
        return object == null ? {} : basePick(object, paths);
      });

      /**
       * Creates an object composed of the `object` properties `predicate` returns
       * truthy for. The predicate is invoked with two arguments: (value, key).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The source object.
       * @param {Function} [predicate=_.identity] The function invoked per property.
       * @returns {Object} Returns the new object.
       * @example
       *
       * var object = { 'a': 1, 'b': '2', 'c': 3 };
       *
       * _.pickBy(object, _.isNumber);
       * // => { 'a': 1, 'c': 3 }
       */
      function pickBy(object, predicate) {
        if (object == null) {
          return {};
        }
        var props = arrayMap(getAllKeysIn(object), function (prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy(object, props, function (value, path) {
          return predicate(value, path[0]);
        });
      }

      /**
       * This method is like `_.get` except that if the resolved value is a
       * function it's invoked with the `this` binding of its parent object and
       * its result is returned.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path of the property to resolve.
       * @param {*} [defaultValue] The value returned for `undefined` resolved values.
       * @returns {*} Returns the resolved value.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
       *
       * _.result(object, 'a[0].b.c1');
       * // => 3
       *
       * _.result(object, 'a[0].b.c2');
       * // => 4
       *
       * _.result(object, 'a[0].b.c3', 'default');
       * // => 'default'
       *
       * _.result(object, 'a[0].b.c3', _.constant('default'));
       * // => 'default'
       */
      function result(object, path, defaultValue) {
        path = castPath(path, object);
        var index = -1,
          length = path.length;

        // Ensure the loop is entered when path is empty.
        if (!length) {
          length = 1;
          object = undefined$1;
        }
        while (++index < length) {
          var value = object == null ? undefined$1 : object[toKey(path[index])];
          if (value === undefined$1) {
            index = length;
            value = defaultValue;
          }
          object = isFunction(value) ? value.call(object) : value;
        }
        return object;
      }

      /**
       * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
       * it's created. Arrays are created for missing index properties while objects
       * are created for all other missing properties. Use `_.setWith` to customize
       * `path` creation.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 3.7.0
       * @category Object
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 3 } }] };
       *
       * _.set(object, 'a[0].b.c', 4);
       * console.log(object.a[0].b.c);
       * // => 4
       *
       * _.set(object, ['x', '0', 'y', 'z'], 5);
       * console.log(object.x[0].y.z);
       * // => 5
       */
      function set(object, path, value) {
        return object == null ? object : baseSet(object, path, value);
      }

      /**
       * This method is like `_.set` except that it accepts `customizer` which is
       * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
       * path creation is handled by the method instead. The `customizer` is invoked
       * with three arguments: (nsValue, key, nsObject).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to set.
       * @param {*} value The value to set.
       * @param {Function} [customizer] The function to customize assigned values.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var object = {};
       *
       * _.setWith(object, '[0][1]', 'a', Object);
       * // => { '0': { '1': 'a' } }
       */
      function setWith(object, path, value, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return object == null ? object : baseSet(object, path, value, customizer);
      }

      /**
       * Creates an array of own enumerable string keyed-value pairs for `object`
       * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
       * entries are returned.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @alias entries
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the key-value pairs.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.toPairs(new Foo);
       * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
       */
      var toPairs = createToPairs(keys);

      /**
       * Creates an array of own and inherited enumerable string keyed-value pairs
       * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
       * or set, its entries are returned.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @alias entriesIn
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the key-value pairs.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.toPairsIn(new Foo);
       * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
       */
      var toPairsIn = createToPairs(keysIn);

      /**
       * An alternative to `_.reduce`; this method transforms `object` to a new
       * `accumulator` object which is the result of running each of its own
       * enumerable string keyed properties thru `iteratee`, with each invocation
       * potentially mutating the `accumulator` object. If `accumulator` is not
       * provided, a new object with the same `[[Prototype]]` will be used. The
       * iteratee is invoked with four arguments: (accumulator, value, key, object).
       * Iteratee functions may exit iteration early by explicitly returning `false`.
       *
       * @static
       * @memberOf _
       * @since 1.3.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @param {*} [accumulator] The custom accumulator value.
       * @returns {*} Returns the accumulated value.
       * @example
       *
       * _.transform([2, 3, 4], function(result, n) {
       *   result.push(n *= n);
       *   return n % 2 == 0;
       * }, []);
       * // => [4, 9]
       *
       * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
       *   (result[value] || (result[value] = [])).push(key);
       * }, {});
       * // => { '1': ['a', 'c'], '2': ['b'] }
       */
      function transform(object, iteratee, accumulator) {
        var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
        iteratee = getIteratee(iteratee, 4);
        if (accumulator == null) {
          var Ctor = object && object.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject(object)) {
            accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
          } else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach : baseForOwn)(object, function (value, index, object) {
          return iteratee(accumulator, value, index, object);
        });
        return accumulator;
      }

      /**
       * Removes the property at `path` of `object`.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to unset.
       * @returns {boolean} Returns `true` if the property is deleted, else `false`.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 7 } }] };
       * _.unset(object, 'a[0].b.c');
       * // => true
       *
       * console.log(object);
       * // => { 'a': [{ 'b': {} }] };
       *
       * _.unset(object, ['a', '0', 'b', 'c']);
       * // => true
       *
       * console.log(object);
       * // => { 'a': [{ 'b': {} }] };
       */
      function unset(object, path) {
        return object == null ? true : baseUnset(object, path);
      }

      /**
       * This method is like `_.set` except that accepts `updater` to produce the
       * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
       * is invoked with one argument: (value).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.6.0
       * @category Object
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to set.
       * @param {Function} updater The function to produce the updated value.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 3 } }] };
       *
       * _.update(object, 'a[0].b.c', function(n) { return n * n; });
       * console.log(object.a[0].b.c);
       * // => 9
       *
       * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
       * console.log(object.x[0].y.z);
       * // => 0
       */
      function update(object, path, updater) {
        return object == null ? object : baseUpdate(object, path, castFunction(updater));
      }

      /**
       * This method is like `_.update` except that it accepts `customizer` which is
       * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
       * path creation is handled by the method instead. The `customizer` is invoked
       * with three arguments: (nsValue, key, nsObject).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.6.0
       * @category Object
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to set.
       * @param {Function} updater The function to produce the updated value.
       * @param {Function} [customizer] The function to customize assigned values.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var object = {};
       *
       * _.updateWith(object, '[0][1]', _.constant('a'), Object);
       * // => { '0': { '1': 'a' } }
       */
      function updateWith(object, path, updater, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
      }

      /**
       * Creates an array of the own enumerable string keyed property values of `object`.
       *
       * **Note:** Non-object values are coerced to objects.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property values.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.values(new Foo);
       * // => [1, 2] (iteration order is not guaranteed)
       *
       * _.values('hi');
       * // => ['h', 'i']
       */
      function values(object) {
        return object == null ? [] : baseValues(object, keys(object));
      }

      /**
       * Creates an array of the own and inherited enumerable string keyed property
       * values of `object`.
       *
       * **Note:** Non-object values are coerced to objects.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property values.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.valuesIn(new Foo);
       * // => [1, 2, 3] (iteration order is not guaranteed)
       */
      function valuesIn(object) {
        return object == null ? [] : baseValues(object, keysIn(object));
      }

      /*------------------------------------------------------------------------*/

      /**
       * Clamps `number` within the inclusive `lower` and `upper` bounds.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Number
       * @param {number} number The number to clamp.
       * @param {number} [lower] The lower bound.
       * @param {number} upper The upper bound.
       * @returns {number} Returns the clamped number.
       * @example
       *
       * _.clamp(-10, -5, 5);
       * // => -5
       *
       * _.clamp(10, -5, 5);
       * // => 5
       */
      function clamp(number, lower, upper) {
        if (upper === undefined$1) {
          upper = lower;
          lower = undefined$1;
        }
        if (upper !== undefined$1) {
          upper = toNumber(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined$1) {
          lower = toNumber(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp(toNumber(number), lower, upper);
      }

      /**
       * Checks if `n` is between `start` and up to, but not including, `end`. If
       * `end` is not specified, it's set to `start` with `start` then set to `0`.
       * If `start` is greater than `end` the params are swapped to support
       * negative ranges.
       *
       * @static
       * @memberOf _
       * @since 3.3.0
       * @category Number
       * @param {number} number The number to check.
       * @param {number} [start=0] The start of the range.
       * @param {number} end The end of the range.
       * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
       * @see _.range, _.rangeRight
       * @example
       *
       * _.inRange(3, 2, 4);
       * // => true
       *
       * _.inRange(4, 8);
       * // => true
       *
       * _.inRange(4, 2);
       * // => false
       *
       * _.inRange(2, 2);
       * // => false
       *
       * _.inRange(1.2, 2);
       * // => true
       *
       * _.inRange(5.2, 4);
       * // => false
       *
       * _.inRange(-3, -2, -6);
       * // => true
       */
      function inRange(number, start, end) {
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        number = toNumber(number);
        return baseInRange(number, start, end);
      }

      /**
       * Produces a random number between the inclusive `lower` and `upper` bounds.
       * If only one argument is provided a number between `0` and the given number
       * is returned. If `floating` is `true`, or either `lower` or `upper` are
       * floats, a floating-point number is returned instead of an integer.
       *
       * **Note:** JavaScript follows the IEEE-754 standard for resolving
       * floating-point values which can produce unexpected results.
       *
       * @static
       * @memberOf _
       * @since 0.7.0
       * @category Number
       * @param {number} [lower=0] The lower bound.
       * @param {number} [upper=1] The upper bound.
       * @param {boolean} [floating] Specify returning a floating-point number.
       * @returns {number} Returns the random number.
       * @example
       *
       * _.random(0, 5);
       * // => an integer between 0 and 5
       *
       * _.random(5);
       * // => also an integer between 0 and 5
       *
       * _.random(5, true);
       * // => a floating-point number between 0 and 5
       *
       * _.random(1.2, 5.2);
       * // => a floating-point number between 1.2 and 5.2
       */
      function random(lower, upper, floating) {
        if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
          upper = floating = undefined$1;
        }
        if (floating === undefined$1) {
          if (typeof upper == 'boolean') {
            floating = upper;
            upper = undefined$1;
          } else if (typeof lower == 'boolean') {
            floating = lower;
            lower = undefined$1;
          }
        }
        if (lower === undefined$1 && upper === undefined$1) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite(lower);
          if (upper === undefined$1) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite(upper);
          }
        }
        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }
        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
        }
        return baseRandom(lower, upper);
      }

      /*------------------------------------------------------------------------*/

      /**
       * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the camel cased string.
       * @example
       *
       * _.camelCase('Foo Bar');
       * // => 'fooBar'
       *
       * _.camelCase('--foo-bar--');
       * // => 'fooBar'
       *
       * _.camelCase('__FOO_BAR__');
       * // => 'fooBar'
       */
      var camelCase = createCompounder(function (result, word, index) {
        word = word.toLowerCase();
        return result + (index ? capitalize(word) : word);
      });

      /**
       * Converts the first character of `string` to upper case and the remaining
       * to lower case.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to capitalize.
       * @returns {string} Returns the capitalized string.
       * @example
       *
       * _.capitalize('FRED');
       * // => 'Fred'
       */
      function capitalize(string) {
        return upperFirst(toString(string).toLowerCase());
      }

      /**
       * Deburrs `string` by converting
       * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
       * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
       * letters to basic Latin letters and removing
       * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to deburr.
       * @returns {string} Returns the deburred string.
       * @example
       *
       * _.deburr('déjà vu');
       * // => 'deja vu'
       */
      function deburr(string) {
        string = toString(string);
        return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
      }

      /**
       * Checks if `string` ends with the given target string.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to inspect.
       * @param {string} [target] The string to search for.
       * @param {number} [position=string.length] The position to search up to.
       * @returns {boolean} Returns `true` if `string` ends with `target`,
       *  else `false`.
       * @example
       *
       * _.endsWith('abc', 'c');
       * // => true
       *
       * _.endsWith('abc', 'b');
       * // => false
       *
       * _.endsWith('abc', 'b', 2);
       * // => true
       */
      function endsWith(string, target, position) {
        string = toString(string);
        target = baseToString(target);
        var length = string.length;
        position = position === undefined$1 ? length : baseClamp(toInteger(position), 0, length);
        var end = position;
        position -= target.length;
        return position >= 0 && string.slice(position, end) == target;
      }

      /**
       * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
       * corresponding HTML entities.
       *
       * **Note:** No other characters are escaped. To escape additional
       * characters use a third-party library like [_he_](https://mths.be/he).
       *
       * Though the ">" character is escaped for symmetry, characters like
       * ">" and "/" don't need escaping in HTML and have no special meaning
       * unless they're part of a tag or unquoted attribute value. See
       * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
       * (under "semi-related fun fact") for more details.
       *
       * When working with HTML you should always
       * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
       * XSS vectors.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category String
       * @param {string} [string=''] The string to escape.
       * @returns {string} Returns the escaped string.
       * @example
       *
       * _.escape('fred, barney, & pebbles');
       * // => 'fred, barney, &amp; pebbles'
       */
      function escape(string) {
        string = toString(string);
        return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
      }

      /**
       * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
       * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to escape.
       * @returns {string} Returns the escaped string.
       * @example
       *
       * _.escapeRegExp('[lodash](https://lodash.com/)');
       * // => '\[lodash\]\(https://lodash\.com/\)'
       */
      function escapeRegExp(string) {
        string = toString(string);
        return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
      }

      /**
       * Converts `string` to
       * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the kebab cased string.
       * @example
       *
       * _.kebabCase('Foo Bar');
       * // => 'foo-bar'
       *
       * _.kebabCase('fooBar');
       * // => 'foo-bar'
       *
       * _.kebabCase('__FOO_BAR__');
       * // => 'foo-bar'
       */
      var kebabCase = createCompounder(function (result, word, index) {
        return result + (index ? '-' : '') + word.toLowerCase();
      });

      /**
       * Converts `string`, as space separated words, to lower case.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the lower cased string.
       * @example
       *
       * _.lowerCase('--Foo-Bar--');
       * // => 'foo bar'
       *
       * _.lowerCase('fooBar');
       * // => 'foo bar'
       *
       * _.lowerCase('__FOO_BAR__');
       * // => 'foo bar'
       */
      var lowerCase = createCompounder(function (result, word, index) {
        return result + (index ? ' ' : '') + word.toLowerCase();
      });

      /**
       * Converts the first character of `string` to lower case.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the converted string.
       * @example
       *
       * _.lowerFirst('Fred');
       * // => 'fred'
       *
       * _.lowerFirst('FRED');
       * // => 'fRED'
       */
      var lowerFirst = createCaseFirst('toLowerCase');

      /**
       * Pads `string` on the left and right sides if it's shorter than `length`.
       * Padding characters are truncated if they can't be evenly divided by `length`.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to pad.
       * @param {number} [length=0] The padding length.
       * @param {string} [chars=' '] The string used as padding.
       * @returns {string} Returns the padded string.
       * @example
       *
       * _.pad('abc', 8);
       * // => '  abc   '
       *
       * _.pad('abc', 8, '_-');
       * // => '_-abc_-_'
       *
       * _.pad('abc', 3);
       * // => 'abc'
       */
      function pad(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        if (!length || strLength >= length) {
          return string;
        }
        var mid = (length - strLength) / 2;
        return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
      }

      /**
       * Pads `string` on the right side if it's shorter than `length`. Padding
       * characters are truncated if they exceed `length`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to pad.
       * @param {number} [length=0] The padding length.
       * @param {string} [chars=' '] The string used as padding.
       * @returns {string} Returns the padded string.
       * @example
       *
       * _.padEnd('abc', 6);
       * // => 'abc   '
       *
       * _.padEnd('abc', 6, '_-');
       * // => 'abc_-_'
       *
       * _.padEnd('abc', 3);
       * // => 'abc'
       */
      function padEnd(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
      }

      /**
       * Pads `string` on the left side if it's shorter than `length`. Padding
       * characters are truncated if they exceed `length`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to pad.
       * @param {number} [length=0] The padding length.
       * @param {string} [chars=' '] The string used as padding.
       * @returns {string} Returns the padded string.
       * @example
       *
       * _.padStart('abc', 6);
       * // => '   abc'
       *
       * _.padStart('abc', 6, '_-');
       * // => '_-_abc'
       *
       * _.padStart('abc', 3);
       * // => 'abc'
       */
      function padStart(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
      }

      /**
       * Converts `string` to an integer of the specified radix. If `radix` is
       * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
       * hexadecimal, in which case a `radix` of `16` is used.
       *
       * **Note:** This method aligns with the
       * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
       *
       * @static
       * @memberOf _
       * @since 1.1.0
       * @category String
       * @param {string} string The string to convert.
       * @param {number} [radix=10] The radix to interpret `value` by.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {number} Returns the converted integer.
       * @example
       *
       * _.parseInt('08');
       * // => 8
       *
       * _.map(['6', '08', '10'], _.parseInt);
       * // => [6, 8, 10]
       */
      function parseInt(string, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
      }

      /**
       * Repeats the given string `n` times.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to repeat.
       * @param {number} [n=1] The number of times to repeat the string.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {string} Returns the repeated string.
       * @example
       *
       * _.repeat('*', 3);
       * // => '***'
       *
       * _.repeat('abc', 2);
       * // => 'abcabc'
       *
       * _.repeat('abc', 0);
       * // => ''
       */
      function repeat(string, n, guard) {
        if (guard ? isIterateeCall(string, n, guard) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger(n);
        }
        return baseRepeat(toString(string), n);
      }

      /**
       * Replaces matches for `pattern` in `string` with `replacement`.
       *
       * **Note:** This method is based on
       * [`String#replace`](https://mdn.io/String/replace).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to modify.
       * @param {RegExp|string} pattern The pattern to replace.
       * @param {Function|string} replacement The match replacement.
       * @returns {string} Returns the modified string.
       * @example
       *
       * _.replace('Hi Fred', 'Fred', 'Barney');
       * // => 'Hi Barney'
       */
      function replace() {
        var args = arguments,
          string = toString(args[0]);
        return args.length < 3 ? string : string.replace(args[1], args[2]);
      }

      /**
       * Converts `string` to
       * [snake case](https://en.wikipedia.org/wiki/Snake_case).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the snake cased string.
       * @example
       *
       * _.snakeCase('Foo Bar');
       * // => 'foo_bar'
       *
       * _.snakeCase('fooBar');
       * // => 'foo_bar'
       *
       * _.snakeCase('--FOO-BAR--');
       * // => 'foo_bar'
       */
      var snakeCase = createCompounder(function (result, word, index) {
        return result + (index ? '_' : '') + word.toLowerCase();
      });

      /**
       * Splits `string` by `separator`.
       *
       * **Note:** This method is based on
       * [`String#split`](https://mdn.io/String/split).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to split.
       * @param {RegExp|string} separator The separator pattern to split by.
       * @param {number} [limit] The length to truncate results to.
       * @returns {Array} Returns the string segments.
       * @example
       *
       * _.split('a-b-c', '-', 2);
       * // => ['a', 'b']
       */
      function split(string, separator, limit) {
        if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
          separator = limit = undefined$1;
        }
        limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
        if (!limit) {
          return [];
        }
        string = toString(string);
        if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
          separator = baseToString(separator);
          if (!separator && hasUnicode(string)) {
            return castSlice(stringToArray(string), 0, limit);
          }
        }
        return string.split(separator, limit);
      }

      /**
       * Converts `string` to
       * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
       *
       * @static
       * @memberOf _
       * @since 3.1.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the start cased string.
       * @example
       *
       * _.startCase('--foo-bar--');
       * // => 'Foo Bar'
       *
       * _.startCase('fooBar');
       * // => 'Foo Bar'
       *
       * _.startCase('__FOO_BAR__');
       * // => 'FOO BAR'
       */
      var startCase = createCompounder(function (result, word, index) {
        return result + (index ? ' ' : '') + upperFirst(word);
      });

      /**
       * Checks if `string` starts with the given target string.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to inspect.
       * @param {string} [target] The string to search for.
       * @param {number} [position=0] The position to search from.
       * @returns {boolean} Returns `true` if `string` starts with `target`,
       *  else `false`.
       * @example
       *
       * _.startsWith('abc', 'a');
       * // => true
       *
       * _.startsWith('abc', 'b');
       * // => false
       *
       * _.startsWith('abc', 'b', 1);
       * // => true
       */
      function startsWith(string, target, position) {
        string = toString(string);
        position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
        target = baseToString(target);
        return string.slice(position, position + target.length) == target;
      }

      /**
       * Creates a compiled template function that can interpolate data properties
       * in "interpolate" delimiters, HTML-escape interpolated data properties in
       * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
       * properties may be accessed as free variables in the template. If a setting
       * object is given, it takes precedence over `_.templateSettings` values.
       *
       * **Note:** In the development build `_.template` utilizes
       * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
       * for easier debugging.
       *
       * For more information on precompiling templates see
       * [lodash's custom builds documentation](https://lodash.com/custom-builds).
       *
       * For more information on Chrome extension sandboxes see
       * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category String
       * @param {string} [string=''] The template string.
       * @param {Object} [options={}] The options object.
       * @param {RegExp} [options.escape=_.templateSettings.escape]
       *  The HTML "escape" delimiter.
       * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
       *  The "evaluate" delimiter.
       * @param {Object} [options.imports=_.templateSettings.imports]
       *  An object to import into the template as free variables.
       * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
       *  The "interpolate" delimiter.
       * @param {string} [options.sourceURL='lodash.templateSources[n]']
       *  The sourceURL of the compiled template.
       * @param {string} [options.variable='obj']
       *  The data object variable name.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Function} Returns the compiled template function.
       * @example
       *
       * // Use the "interpolate" delimiter to create a compiled template.
       * var compiled = _.template('hello <%= user %>!');
       * compiled({ 'user': 'fred' });
       * // => 'hello fred!'
       *
       * // Use the HTML "escape" delimiter to escape data property values.
       * var compiled = _.template('<b><%- value %></b>');
       * compiled({ 'value': '<script>' });
       * // => '<b>&lt;script&gt;</b>'
       *
       * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
       * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
       * compiled({ 'users': ['fred', 'barney'] });
       * // => '<li>fred</li><li>barney</li>'
       *
       * // Use the internal `print` function in "evaluate" delimiters.
       * var compiled = _.template('<% print("hello " + user); %>!');
       * compiled({ 'user': 'barney' });
       * // => 'hello barney!'
       *
       * // Use the ES template literal delimiter as an "interpolate" delimiter.
       * // Disable support by replacing the "interpolate" delimiter.
       * var compiled = _.template('hello ${ user }!');
       * compiled({ 'user': 'pebbles' });
       * // => 'hello pebbles!'
       *
       * // Use backslashes to treat delimiters as plain text.
       * var compiled = _.template('<%= "\\<%- value %\\>" %>');
       * compiled({ 'value': 'ignored' });
       * // => '<%- value %>'
       *
       * // Use the `imports` option to import `jQuery` as `jq`.
       * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
       * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
       * compiled({ 'users': ['fred', 'barney'] });
       * // => '<li>fred</li><li>barney</li>'
       *
       * // Use the `sourceURL` option to specify a custom sourceURL for the template.
       * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
       * compiled(data);
       * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
       *
       * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
       * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
       * compiled.source;
       * // => function(data) {
       * //   var __t, __p = '';
       * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
       * //   return __p;
       * // }
       *
       * // Use custom template delimiters.
       * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
       * var compiled = _.template('hello {{ user }}!');
       * compiled({ 'user': 'mustache' });
       * // => 'hello mustache!'
       *
       * // Use the `source` property to inline compiled templates for meaningful
       * // line numbers in error messages and stack traces.
       * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
       *   var JST = {\
       *     "main": ' + _.template(mainText).source + '\
       *   };\
       * ');
       */
      function template(string, options, guard) {
        // Based on John Resig's `tmpl` implementation
        // (http://ejohn.org/blog/javascript-micro-templating/)
        // and Laura Doktorova's doT.js (https://github.com/olado/doT).
        var settings = lodash.templateSettings;
        if (guard && isIterateeCall(string, options, guard)) {
          options = undefined$1;
        }
        string = toString(string);
        options = assignInWith({}, options, settings, customDefaultsAssignIn);
        var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);
        var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

        // Compile the regexp to match each delimiter.
        var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');

        // Use a sourceURL for easier debugging.
        // The sourceURL gets injected into the source that's eval-ed, so be careful
        // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
        // and escape the comment, thus injecting code that gets evaled.
        var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
        string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
          interpolateValue || (interpolateValue = esTemplateValue);

          // Escape characters that can't be included in string literals.
          source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

          // Replace delimiters with snippets.
          if (escapeValue) {
            isEscaping = true;
            source += "' +\n__e(" + escapeValue + ") +\n'";
          }
          if (evaluateValue) {
            isEvaluating = true;
            source += "';\n" + evaluateValue + ";\n__p += '";
          }
          if (interpolateValue) {
            source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
          }
          index = offset + match.length;

          // The JS engine embedded in Adobe products needs `match` returned in
          // order to produce the correct `offset` value.
          return match;
        });
        source += "';\n";

        // If `variable` is not specified wrap a with-statement around the generated
        // code to add the data object to the top of the scope chain.
        var variable = hasOwnProperty.call(options, 'variable') && options.variable;
        if (!variable) {
          source = 'with (obj) {\n' + source + '\n}\n';
        }
        // Throw an error if a forbidden character was found in `variable`, to prevent
        // potential command injection attacks.
        else if (reForbiddenIdentifierChars.test(variable)) {
          throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
        }

        // Cleanup code by stripping empty strings.
        source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');

        // Frame code as the function body.
        source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
        var result = attempt(function () {
          return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined$1, importsValues);
        });

        // Provide the compiled function's source by its `toString` method or
        // the `source` property as a convenience for inlining compiled templates.
        result.source = source;
        if (isError(result)) {
          throw result;
        }
        return result;
      }

      /**
       * Converts `string`, as a whole, to lower case just like
       * [String#toLowerCase](https://mdn.io/toLowerCase).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the lower cased string.
       * @example
       *
       * _.toLower('--Foo-Bar--');
       * // => '--foo-bar--'
       *
       * _.toLower('fooBar');
       * // => 'foobar'
       *
       * _.toLower('__FOO_BAR__');
       * // => '__foo_bar__'
       */
      function toLower(value) {
        return toString(value).toLowerCase();
      }

      /**
       * Converts `string`, as a whole, to upper case just like
       * [String#toUpperCase](https://mdn.io/toUpperCase).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the upper cased string.
       * @example
       *
       * _.toUpper('--foo-bar--');
       * // => '--FOO-BAR--'
       *
       * _.toUpper('fooBar');
       * // => 'FOOBAR'
       *
       * _.toUpper('__foo_bar__');
       * // => '__FOO_BAR__'
       */
      function toUpper(value) {
        return toString(value).toUpperCase();
      }

      /**
       * Removes leading and trailing whitespace or specified characters from `string`.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to trim.
       * @param {string} [chars=whitespace] The characters to trim.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {string} Returns the trimmed string.
       * @example
       *
       * _.trim('  abc  ');
       * // => 'abc'
       *
       * _.trim('-_-abc-_-', '_-');
       * // => 'abc'
       *
       * _.map(['  foo  ', '  bar  '], _.trim);
       * // => ['foo', 'bar']
       */
      function trim(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return baseTrim(string);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;
        return castSlice(strSymbols, start, end).join('');
      }

      /**
       * Removes trailing whitespace or specified characters from `string`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to trim.
       * @param {string} [chars=whitespace] The characters to trim.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {string} Returns the trimmed string.
       * @example
       *
       * _.trimEnd('  abc  ');
       * // => '  abc'
       *
       * _.trimEnd('-_-abc-_-', '_-');
       * // => '-_-abc'
       */
      function trimEnd(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return string.slice(0, trimmedEndIndex(string) + 1);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
        return castSlice(strSymbols, 0, end).join('');
      }

      /**
       * Removes leading whitespace or specified characters from `string`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to trim.
       * @param {string} [chars=whitespace] The characters to trim.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {string} Returns the trimmed string.
       * @example
       *
       * _.trimStart('  abc  ');
       * // => 'abc  '
       *
       * _.trimStart('-_-abc-_-', '_-');
       * // => 'abc-_-'
       */
      function trimStart(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return string.replace(reTrimStart, '');
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));
        return castSlice(strSymbols, start).join('');
      }

      /**
       * Truncates `string` if it's longer than the given maximum string length.
       * The last characters of the truncated string are replaced with the omission
       * string which defaults to "...".
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to truncate.
       * @param {Object} [options={}] The options object.
       * @param {number} [options.length=30] The maximum string length.
       * @param {string} [options.omission='...'] The string to indicate text is omitted.
       * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
       * @returns {string} Returns the truncated string.
       * @example
       *
       * _.truncate('hi-diddly-ho there, neighborino');
       * // => 'hi-diddly-ho there, neighbo...'
       *
       * _.truncate('hi-diddly-ho there, neighborino', {
       *   'length': 24,
       *   'separator': ' '
       * });
       * // => 'hi-diddly-ho there,...'
       *
       * _.truncate('hi-diddly-ho there, neighborino', {
       *   'length': 24,
       *   'separator': /,? +/
       * });
       * // => 'hi-diddly-ho there...'
       *
       * _.truncate('hi-diddly-ho there, neighborino', {
       *   'omission': ' [...]'
       * });
       * // => 'hi-diddly-ho there, neig [...]'
       */
      function truncate(string, options) {
        var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;
        if (isObject(options)) {
          var separator = 'separator' in options ? options.separator : separator;
          length = 'length' in options ? toInteger(options.length) : length;
          omission = 'omission' in options ? baseToString(options.omission) : omission;
        }
        string = toString(string);
        var strLength = string.length;
        if (hasUnicode(string)) {
          var strSymbols = stringToArray(string);
          strLength = strSymbols.length;
        }
        if (length >= strLength) {
          return string;
        }
        var end = length - stringSize(omission);
        if (end < 1) {
          return omission;
        }
        var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
        if (separator === undefined$1) {
          return result + omission;
        }
        if (strSymbols) {
          end += result.length - end;
        }
        if (isRegExp(separator)) {
          if (string.slice(end).search(separator)) {
            var match,
              substring = result;
            if (!separator.global) {
              separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
            }
            separator.lastIndex = 0;
            while (match = separator.exec(substring)) {
              var newEnd = match.index;
            }
            result = result.slice(0, newEnd === undefined$1 ? end : newEnd);
          }
        } else if (string.indexOf(baseToString(separator), end) != end) {
          var index = result.lastIndexOf(separator);
          if (index > -1) {
            result = result.slice(0, index);
          }
        }
        return result + omission;
      }

      /**
       * The inverse of `_.escape`; this method converts the HTML entities
       * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
       * their corresponding characters.
       *
       * **Note:** No other HTML entities are unescaped. To unescape additional
       * HTML entities use a third-party library like [_he_](https://mths.be/he).
       *
       * @static
       * @memberOf _
       * @since 0.6.0
       * @category String
       * @param {string} [string=''] The string to unescape.
       * @returns {string} Returns the unescaped string.
       * @example
       *
       * _.unescape('fred, barney, &amp; pebbles');
       * // => 'fred, barney, & pebbles'
       */
      function unescape(string) {
        string = toString(string);
        return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
      }

      /**
       * Converts `string`, as space separated words, to upper case.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the upper cased string.
       * @example
       *
       * _.upperCase('--foo-bar');
       * // => 'FOO BAR'
       *
       * _.upperCase('fooBar');
       * // => 'FOO BAR'
       *
       * _.upperCase('__foo_bar__');
       * // => 'FOO BAR'
       */
      var upperCase = createCompounder(function (result, word, index) {
        return result + (index ? ' ' : '') + word.toUpperCase();
      });

      /**
       * Converts the first character of `string` to upper case.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the converted string.
       * @example
       *
       * _.upperFirst('fred');
       * // => 'Fred'
       *
       * _.upperFirst('FRED');
       * // => 'FRED'
       */
      var upperFirst = createCaseFirst('toUpperCase');

      /**
       * Splits `string` into an array of its words.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to inspect.
       * @param {RegExp|string} [pattern] The pattern to match words.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the words of `string`.
       * @example
       *
       * _.words('fred, barney, & pebbles');
       * // => ['fred', 'barney', 'pebbles']
       *
       * _.words('fred, barney, & pebbles', /[^, ]+/g);
       * // => ['fred', 'barney', '&', 'pebbles']
       */
      function words(string, pattern, guard) {
        string = toString(string);
        pattern = guard ? undefined$1 : pattern;
        if (pattern === undefined$1) {
          return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
        }
        return string.match(pattern) || [];
      }

      /*------------------------------------------------------------------------*/

      /**
       * Attempts to invoke `func`, returning either the result or the caught error
       * object. Any additional arguments are provided to `func` when it's invoked.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Util
       * @param {Function} func The function to attempt.
       * @param {...*} [args] The arguments to invoke `func` with.
       * @returns {*} Returns the `func` result or error object.
       * @example
       *
       * // Avoid throwing errors for invalid selectors.
       * var elements = _.attempt(function(selector) {
       *   return document.querySelectorAll(selector);
       * }, '>_>');
       *
       * if (_.isError(elements)) {
       *   elements = [];
       * }
       */
      var attempt = baseRest(function (func, args) {
        try {
          return apply(func, undefined$1, args);
        } catch (e) {
          return isError(e) ? e : new Error(e);
        }
      });

      /**
       * Binds methods of an object to the object itself, overwriting the existing
       * method.
       *
       * **Note:** This method doesn't set the "length" property of bound functions.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {Object} object The object to bind and assign the bound methods to.
       * @param {...(string|string[])} methodNames The object method names to bind.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var view = {
       *   'label': 'docs',
       *   'click': function() {
       *     console.log('clicked ' + this.label);
       *   }
       * };
       *
       * _.bindAll(view, ['click']);
       * jQuery(element).on('click', view.click);
       * // => Logs 'clicked docs' when clicked.
       */
      var bindAll = flatRest(function (object, methodNames) {
        arrayEach(methodNames, function (key) {
          key = toKey(key);
          baseAssignValue(object, key, bind(object[key], object));
        });
        return object;
      });

      /**
       * Creates a function that iterates over `pairs` and invokes the corresponding
       * function of the first predicate to return truthy. The predicate-function
       * pairs are invoked with the `this` binding and arguments of the created
       * function.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {Array} pairs The predicate-function pairs.
       * @returns {Function} Returns the new composite function.
       * @example
       *
       * var func = _.cond([
       *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
       *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
       *   [_.stubTrue,                      _.constant('no match')]
       * ]);
       *
       * func({ 'a': 1, 'b': 2 });
       * // => 'matches A'
       *
       * func({ 'a': 0, 'b': 1 });
       * // => 'matches B'
       *
       * func({ 'a': '1', 'b': '2' });
       * // => 'no match'
       */
      function cond(pairs) {
        var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();
        pairs = !length ? [] : arrayMap(pairs, function (pair) {
          if (typeof pair[1] != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          return [toIteratee(pair[0]), pair[1]];
        });
        return baseRest(function (args) {
          var index = -1;
          while (++index < length) {
            var pair = pairs[index];
            if (apply(pair[0], this, args)) {
              return apply(pair[1], this, args);
            }
          }
        });
      }

      /**
       * Creates a function that invokes the predicate properties of `source` with
       * the corresponding property values of a given object, returning `true` if
       * all predicates return truthy, else `false`.
       *
       * **Note:** The created function is equivalent to `_.conformsTo` with
       * `source` partially applied.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {Object} source The object of property predicates to conform to.
       * @returns {Function} Returns the new spec function.
       * @example
       *
       * var objects = [
       *   { 'a': 2, 'b': 1 },
       *   { 'a': 1, 'b': 2 }
       * ];
       *
       * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
       * // => [{ 'a': 1, 'b': 2 }]
       */
      function conforms(source) {
        return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
      }

      /**
       * Creates a function that returns `value`.
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Util
       * @param {*} value The value to return from the new function.
       * @returns {Function} Returns the new constant function.
       * @example
       *
       * var objects = _.times(2, _.constant({ 'a': 1 }));
       *
       * console.log(objects);
       * // => [{ 'a': 1 }, { 'a': 1 }]
       *
       * console.log(objects[0] === objects[1]);
       * // => true
       */
      function constant(value) {
        return function () {
          return value;
        };
      }

      /**
       * Checks `value` to determine whether a default value should be returned in
       * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
       * or `undefined`.
       *
       * @static
       * @memberOf _
       * @since 4.14.0
       * @category Util
       * @param {*} value The value to check.
       * @param {*} defaultValue The default value.
       * @returns {*} Returns the resolved value.
       * @example
       *
       * _.defaultTo(1, 10);
       * // => 1
       *
       * _.defaultTo(undefined, 10);
       * // => 10
       */
      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }

      /**
       * Creates a function that returns the result of invoking the given functions
       * with the `this` binding of the created function, where each successive
       * invocation is supplied the return value of the previous.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Util
       * @param {...(Function|Function[])} [funcs] The functions to invoke.
       * @returns {Function} Returns the new composite function.
       * @see _.flowRight
       * @example
       *
       * function square(n) {
       *   return n * n;
       * }
       *
       * var addSquare = _.flow([_.add, square]);
       * addSquare(1, 2);
       * // => 9
       */
      var flow = createFlow();

      /**
       * This method is like `_.flow` except that it creates a function that
       * invokes the given functions from right to left.
       *
       * @static
       * @since 3.0.0
       * @memberOf _
       * @category Util
       * @param {...(Function|Function[])} [funcs] The functions to invoke.
       * @returns {Function} Returns the new composite function.
       * @see _.flow
       * @example
       *
       * function square(n) {
       *   return n * n;
       * }
       *
       * var addSquare = _.flowRight([square, _.add]);
       * addSquare(1, 2);
       * // => 9
       */
      var flowRight = createFlow(true);

      /**
       * This method returns the first argument it receives.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {*} value Any value.
       * @returns {*} Returns `value`.
       * @example
       *
       * var object = { 'a': 1 };
       *
       * console.log(_.identity(object) === object);
       * // => true
       */
      function identity(value) {
        return value;
      }

      /**
       * Creates a function that invokes `func` with the arguments of the created
       * function. If `func` is a property name, the created function returns the
       * property value for a given element. If `func` is an array or object, the
       * created function returns `true` for elements that contain the equivalent
       * source properties, otherwise it returns `false`.
       *
       * @static
       * @since 4.0.0
       * @memberOf _
       * @category Util
       * @param {*} [func=_.identity] The value to convert to a callback.
       * @returns {Function} Returns the callback.
       * @example
       *
       * var users = [
       *   { 'user': 'barney', 'age': 36, 'active': true },
       *   { 'user': 'fred',   'age': 40, 'active': false }
       * ];
       *
       * // The `_.matches` iteratee shorthand.
       * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
       * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.filter(users, _.iteratee(['user', 'fred']));
       * // => [{ 'user': 'fred', 'age': 40 }]
       *
       * // The `_.property` iteratee shorthand.
       * _.map(users, _.iteratee('user'));
       * // => ['barney', 'fred']
       *
       * // Create custom iteratee shorthands.
       * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
       *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
       *     return func.test(string);
       *   };
       * });
       *
       * _.filter(['abc', 'def'], /ef/);
       * // => ['def']
       */
      function iteratee(func) {
        return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
      }

      /**
       * Creates a function that performs a partial deep comparison between a given
       * object and `source`, returning `true` if the given object has equivalent
       * property values, else `false`.
       *
       * **Note:** The created function is equivalent to `_.isMatch` with `source`
       * partially applied.
       *
       * Partial comparisons will match empty array and empty object `source`
       * values against any array or object value, respectively. See `_.isEqual`
       * for a list of supported value comparisons.
       *
       * **Note:** Multiple values can be checked by combining several matchers
       * using `_.overSome`
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Util
       * @param {Object} source The object of property values to match.
       * @returns {Function} Returns the new spec function.
       * @example
       *
       * var objects = [
       *   { 'a': 1, 'b': 2, 'c': 3 },
       *   { 'a': 4, 'b': 5, 'c': 6 }
       * ];
       *
       * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
       * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
       *
       * // Checking for several possible values
       * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
       * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
       */
      function matches(source) {
        return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
      }

      /**
       * Creates a function that performs a partial deep comparison between the
       * value at `path` of a given object to `srcValue`, returning `true` if the
       * object value is equivalent, else `false`.
       *
       * **Note:** Partial comparisons will match empty array and empty object
       * `srcValue` values against any array or object value, respectively. See
       * `_.isEqual` for a list of supported value comparisons.
       *
       * **Note:** Multiple values can be checked by combining several matchers
       * using `_.overSome`
       *
       * @static
       * @memberOf _
       * @since 3.2.0
       * @category Util
       * @param {Array|string} path The path of the property to get.
       * @param {*} srcValue The value to match.
       * @returns {Function} Returns the new spec function.
       * @example
       *
       * var objects = [
       *   { 'a': 1, 'b': 2, 'c': 3 },
       *   { 'a': 4, 'b': 5, 'c': 6 }
       * ];
       *
       * _.find(objects, _.matchesProperty('a', 4));
       * // => { 'a': 4, 'b': 5, 'c': 6 }
       *
       * // Checking for several possible values
       * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
       * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
       */
      function matchesProperty(path, srcValue) {
        return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
      }

      /**
       * Creates a function that invokes the method at `path` of a given object.
       * Any additional arguments are provided to the invoked method.
       *
       * @static
       * @memberOf _
       * @since 3.7.0
       * @category Util
       * @param {Array|string} path The path of the method to invoke.
       * @param {...*} [args] The arguments to invoke the method with.
       * @returns {Function} Returns the new invoker function.
       * @example
       *
       * var objects = [
       *   { 'a': { 'b': _.constant(2) } },
       *   { 'a': { 'b': _.constant(1) } }
       * ];
       *
       * _.map(objects, _.method('a.b'));
       * // => [2, 1]
       *
       * _.map(objects, _.method(['a', 'b']));
       * // => [2, 1]
       */
      var method = baseRest(function (path, args) {
        return function (object) {
          return baseInvoke(object, path, args);
        };
      });

      /**
       * The opposite of `_.method`; this method creates a function that invokes
       * the method at a given path of `object`. Any additional arguments are
       * provided to the invoked method.
       *
       * @static
       * @memberOf _
       * @since 3.7.0
       * @category Util
       * @param {Object} object The object to query.
       * @param {...*} [args] The arguments to invoke the method with.
       * @returns {Function} Returns the new invoker function.
       * @example
       *
       * var array = _.times(3, _.constant),
       *     object = { 'a': array, 'b': array, 'c': array };
       *
       * _.map(['a[2]', 'c[0]'], _.methodOf(object));
       * // => [2, 0]
       *
       * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
       * // => [2, 0]
       */
      var methodOf = baseRest(function (object, args) {
        return function (path) {
          return baseInvoke(object, path, args);
        };
      });

      /**
       * Adds all own enumerable string keyed function properties of a source
       * object to the destination object. If `object` is a function, then methods
       * are added to its prototype as well.
       *
       * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
       * avoid conflicts caused by modifying the original.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {Function|Object} [object=lodash] The destination object.
       * @param {Object} source The object of functions to add.
       * @param {Object} [options={}] The options object.
       * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
       * @returns {Function|Object} Returns `object`.
       * @example
       *
       * function vowels(string) {
       *   return _.filter(string, function(v) {
       *     return /[aeiou]/i.test(v);
       *   });
       * }
       *
       * _.mixin({ 'vowels': vowels });
       * _.vowels('fred');
       * // => ['e']
       *
       * _('fred').vowels().value();
       * // => ['e']
       *
       * _.mixin({ 'vowels': vowels }, { 'chain': false });
       * _('fred').vowels();
       * // => ['e']
       */
      function mixin(object, source, options) {
        var props = keys(source),
          methodNames = baseFunctions(source, props);
        if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
          options = source;
          source = object;
          object = this;
          methodNames = baseFunctions(source, keys(source));
        }
        var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);
        arrayEach(methodNames, function (methodName) {
          var func = source[methodName];
          object[methodName] = func;
          if (isFunc) {
            object.prototype[methodName] = function () {
              var chainAll = this.__chain__;
              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);
                actions.push({
                  'func': func,
                  'args': arguments,
                  'thisArg': object
                });
                result.__chain__ = chainAll;
                return result;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }
        });
        return object;
      }

      /**
       * Reverts the `_` variable to its previous value and returns a reference to
       * the `lodash` function.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @returns {Function} Returns the `lodash` function.
       * @example
       *
       * var lodash = _.noConflict();
       */
      function noConflict() {
        if (root._ === this) {
          root._ = oldDash;
        }
        return this;
      }

      /**
       * This method returns `undefined`.
       *
       * @static
       * @memberOf _
       * @since 2.3.0
       * @category Util
       * @example
       *
       * _.times(2, _.noop);
       * // => [undefined, undefined]
       */
      function noop() {
        // No operation performed.
      }

      /**
       * Creates a function that gets the argument at index `n`. If `n` is negative,
       * the nth argument from the end is returned.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {number} [n=0] The index of the argument to return.
       * @returns {Function} Returns the new pass-thru function.
       * @example
       *
       * var func = _.nthArg(1);
       * func('a', 'b', 'c', 'd');
       * // => 'b'
       *
       * var func = _.nthArg(-2);
       * func('a', 'b', 'c', 'd');
       * // => 'c'
       */
      function nthArg(n) {
        n = toInteger(n);
        return baseRest(function (args) {
          return baseNth(args, n);
        });
      }

      /**
       * Creates a function that invokes `iteratees` with the arguments it receives
       * and returns their results.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {...(Function|Function[])} [iteratees=[_.identity]]
       *  The iteratees to invoke.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var func = _.over([Math.max, Math.min]);
       *
       * func(1, 2, 3, 4);
       * // => [4, 1]
       */
      var over = createOver(arrayMap);

      /**
       * Creates a function that checks if **all** of the `predicates` return
       * truthy when invoked with the arguments it receives.
       *
       * Following shorthands are possible for providing predicates.
       * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
       * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {...(Function|Function[])} [predicates=[_.identity]]
       *  The predicates to check.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var func = _.overEvery([Boolean, isFinite]);
       *
       * func('1');
       * // => true
       *
       * func(null);
       * // => false
       *
       * func(NaN);
       * // => false
       */
      var overEvery = createOver(arrayEvery);

      /**
       * Creates a function that checks if **any** of the `predicates` return
       * truthy when invoked with the arguments it receives.
       *
       * Following shorthands are possible for providing predicates.
       * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
       * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {...(Function|Function[])} [predicates=[_.identity]]
       *  The predicates to check.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var func = _.overSome([Boolean, isFinite]);
       *
       * func('1');
       * // => true
       *
       * func(null);
       * // => true
       *
       * func(NaN);
       * // => false
       *
       * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
       * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
       */
      var overSome = createOver(arraySome);

      /**
       * Creates a function that returns the value at `path` of a given object.
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Util
       * @param {Array|string} path The path of the property to get.
       * @returns {Function} Returns the new accessor function.
       * @example
       *
       * var objects = [
       *   { 'a': { 'b': 2 } },
       *   { 'a': { 'b': 1 } }
       * ];
       *
       * _.map(objects, _.property('a.b'));
       * // => [2, 1]
       *
       * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
       * // => [1, 2]
       */
      function property(path) {
        return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
      }

      /**
       * The opposite of `_.property`; this method creates a function that returns
       * the value at a given path of `object`.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Util
       * @param {Object} object The object to query.
       * @returns {Function} Returns the new accessor function.
       * @example
       *
       * var array = [0, 1, 2],
       *     object = { 'a': array, 'b': array, 'c': array };
       *
       * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
       * // => [2, 0]
       *
       * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
       * // => [2, 0]
       */
      function propertyOf(object) {
        return function (path) {
          return object == null ? undefined$1 : baseGet(object, path);
        };
      }

      /**
       * Creates an array of numbers (positive and/or negative) progressing from
       * `start` up to, but not including, `end`. A step of `-1` is used if a negative
       * `start` is specified without an `end` or `step`. If `end` is not specified,
       * it's set to `start` with `start` then set to `0`.
       *
       * **Note:** JavaScript follows the IEEE-754 standard for resolving
       * floating-point values which can produce unexpected results.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {number} [start=0] The start of the range.
       * @param {number} end The end of the range.
       * @param {number} [step=1] The value to increment or decrement by.
       * @returns {Array} Returns the range of numbers.
       * @see _.inRange, _.rangeRight
       * @example
       *
       * _.range(4);
       * // => [0, 1, 2, 3]
       *
       * _.range(-4);
       * // => [0, -1, -2, -3]
       *
       * _.range(1, 5);
       * // => [1, 2, 3, 4]
       *
       * _.range(0, 20, 5);
       * // => [0, 5, 10, 15]
       *
       * _.range(0, -4, -1);
       * // => [0, -1, -2, -3]
       *
       * _.range(1, 4, 0);
       * // => [1, 1, 1]
       *
       * _.range(0);
       * // => []
       */
      var range = createRange();

      /**
       * This method is like `_.range` except that it populates values in
       * descending order.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {number} [start=0] The start of the range.
       * @param {number} end The end of the range.
       * @param {number} [step=1] The value to increment or decrement by.
       * @returns {Array} Returns the range of numbers.
       * @see _.inRange, _.range
       * @example
       *
       * _.rangeRight(4);
       * // => [3, 2, 1, 0]
       *
       * _.rangeRight(-4);
       * // => [-3, -2, -1, 0]
       *
       * _.rangeRight(1, 5);
       * // => [4, 3, 2, 1]
       *
       * _.rangeRight(0, 20, 5);
       * // => [15, 10, 5, 0]
       *
       * _.rangeRight(0, -4, -1);
       * // => [-3, -2, -1, 0]
       *
       * _.rangeRight(1, 4, 0);
       * // => [1, 1, 1]
       *
       * _.rangeRight(0);
       * // => []
       */
      var rangeRight = createRange(true);

      /**
       * This method returns a new empty array.
       *
       * @static
       * @memberOf _
       * @since 4.13.0
       * @category Util
       * @returns {Array} Returns the new empty array.
       * @example
       *
       * var arrays = _.times(2, _.stubArray);
       *
       * console.log(arrays);
       * // => [[], []]
       *
       * console.log(arrays[0] === arrays[1]);
       * // => false
       */
      function stubArray() {
        return [];
      }

      /**
       * This method returns `false`.
       *
       * @static
       * @memberOf _
       * @since 4.13.0
       * @category Util
       * @returns {boolean} Returns `false`.
       * @example
       *
       * _.times(2, _.stubFalse);
       * // => [false, false]
       */
      function stubFalse() {
        return false;
      }

      /**
       * This method returns a new empty object.
       *
       * @static
       * @memberOf _
       * @since 4.13.0
       * @category Util
       * @returns {Object} Returns the new empty object.
       * @example
       *
       * var objects = _.times(2, _.stubObject);
       *
       * console.log(objects);
       * // => [{}, {}]
       *
       * console.log(objects[0] === objects[1]);
       * // => false
       */
      function stubObject() {
        return {};
      }

      /**
       * This method returns an empty string.
       *
       * @static
       * @memberOf _
       * @since 4.13.0
       * @category Util
       * @returns {string} Returns the empty string.
       * @example
       *
       * _.times(2, _.stubString);
       * // => ['', '']
       */
      function stubString() {
        return '';
      }

      /**
       * This method returns `true`.
       *
       * @static
       * @memberOf _
       * @since 4.13.0
       * @category Util
       * @returns {boolean} Returns `true`.
       * @example
       *
       * _.times(2, _.stubTrue);
       * // => [true, true]
       */
      function stubTrue() {
        return true;
      }

      /**
       * Invokes the iteratee `n` times, returning an array of the results of
       * each invocation. The iteratee is invoked with one argument; (index).
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {number} n The number of times to invoke `iteratee`.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the array of results.
       * @example
       *
       * _.times(3, String);
       * // => ['0', '1', '2']
       *
       *  _.times(4, _.constant(0));
       * // => [0, 0, 0, 0]
       */
      function times(n, iteratee) {
        n = toInteger(n);
        if (n < 1 || n > MAX_SAFE_INTEGER) {
          return [];
        }
        var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);
        iteratee = getIteratee(iteratee);
        n -= MAX_ARRAY_LENGTH;
        var result = baseTimes(length, iteratee);
        while (++index < n) {
          iteratee(index);
        }
        return result;
      }

      /**
       * Converts `value` to a property path array.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {*} value The value to convert.
       * @returns {Array} Returns the new property path array.
       * @example
       *
       * _.toPath('a.b.c');
       * // => ['a', 'b', 'c']
       *
       * _.toPath('a[0].b.c');
       * // => ['a', '0', 'b', 'c']
       */
      function toPath(value) {
        if (isArray(value)) {
          return arrayMap(value, toKey);
        }
        return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
      }

      /**
       * Generates a unique ID. If `prefix` is given, the ID is appended to it.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {string} [prefix=''] The value to prefix the ID with.
       * @returns {string} Returns the unique ID.
       * @example
       *
       * _.uniqueId('contact_');
       * // => 'contact_104'
       *
       * _.uniqueId();
       * // => '105'
       */
      function uniqueId(prefix) {
        var id = ++idCounter;
        return toString(prefix) + id;
      }

      /*------------------------------------------------------------------------*/

      /**
       * Adds two numbers.
       *
       * @static
       * @memberOf _
       * @since 3.4.0
       * @category Math
       * @param {number} augend The first number in an addition.
       * @param {number} addend The second number in an addition.
       * @returns {number} Returns the total.
       * @example
       *
       * _.add(6, 4);
       * // => 10
       */
      var add = createMathOperation(function (augend, addend) {
        return augend + addend;
      }, 0);

      /**
       * Computes `number` rounded up to `precision`.
       *
       * @static
       * @memberOf _
       * @since 3.10.0
       * @category Math
       * @param {number} number The number to round up.
       * @param {number} [precision=0] The precision to round up to.
       * @returns {number} Returns the rounded up number.
       * @example
       *
       * _.ceil(4.006);
       * // => 5
       *
       * _.ceil(6.004, 2);
       * // => 6.01
       *
       * _.ceil(6040, -2);
       * // => 6100
       */
      var ceil = createRound('ceil');

      /**
       * Divide two numbers.
       *
       * @static
       * @memberOf _
       * @since 4.7.0
       * @category Math
       * @param {number} dividend The first number in a division.
       * @param {number} divisor The second number in a division.
       * @returns {number} Returns the quotient.
       * @example
       *
       * _.divide(6, 4);
       * // => 1.5
       */
      var divide = createMathOperation(function (dividend, divisor) {
        return dividend / divisor;
      }, 1);

      /**
       * Computes `number` rounded down to `precision`.
       *
       * @static
       * @memberOf _
       * @since 3.10.0
       * @category Math
       * @param {number} number The number to round down.
       * @param {number} [precision=0] The precision to round down to.
       * @returns {number} Returns the rounded down number.
       * @example
       *
       * _.floor(4.006);
       * // => 4
       *
       * _.floor(0.046, 2);
       * // => 0.04
       *
       * _.floor(4060, -2);
       * // => 4000
       */
      var floor = createRound('floor');

      /**
       * Computes the maximum value of `array`. If `array` is empty or falsey,
       * `undefined` is returned.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Math
       * @param {Array} array The array to iterate over.
       * @returns {*} Returns the maximum value.
       * @example
       *
       * _.max([4, 2, 8, 6]);
       * // => 8
       *
       * _.max([]);
       * // => undefined
       */
      function max(array) {
        return array && array.length ? baseExtremum(array, identity, baseGt) : undefined$1;
      }

      /**
       * This method is like `_.max` except that it accepts `iteratee` which is
       * invoked for each element in `array` to generate the criterion by which
       * the value is ranked. The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Math
       * @param {Array} array The array to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {*} Returns the maximum value.
       * @example
       *
       * var objects = [{ 'n': 1 }, { 'n': 2 }];
       *
       * _.maxBy(objects, function(o) { return o.n; });
       * // => { 'n': 2 }
       *
       * // The `_.property` iteratee shorthand.
       * _.maxBy(objects, 'n');
       * // => { 'n': 2 }
       */
      function maxBy(array, iteratee) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined$1;
      }

      /**
       * Computes the mean of the values in `array`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Math
       * @param {Array} array The array to iterate over.
       * @returns {number} Returns the mean.
       * @example
       *
       * _.mean([4, 2, 8, 6]);
       * // => 5
       */
      function mean(array) {
        return baseMean(array, identity);
      }

      /**
       * This method is like `_.mean` except that it accepts `iteratee` which is
       * invoked for each element in `array` to generate the value to be averaged.
       * The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.7.0
       * @category Math
       * @param {Array} array The array to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {number} Returns the mean.
       * @example
       *
       * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
       *
       * _.meanBy(objects, function(o) { return o.n; });
       * // => 5
       *
       * // The `_.property` iteratee shorthand.
       * _.meanBy(objects, 'n');
       * // => 5
       */
      function meanBy(array, iteratee) {
        return baseMean(array, getIteratee(iteratee, 2));
      }

      /**
       * Computes the minimum value of `array`. If `array` is empty or falsey,
       * `undefined` is returned.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Math
       * @param {Array} array The array to iterate over.
       * @returns {*} Returns the minimum value.
       * @example
       *
       * _.min([4, 2, 8, 6]);
       * // => 2
       *
       * _.min([]);
       * // => undefined
       */
      function min(array) {
        return array && array.length ? baseExtremum(array, identity, baseLt) : undefined$1;
      }

      /**
       * This method is like `_.min` except that it accepts `iteratee` which is
       * invoked for each element in `array` to generate the criterion by which
       * the value is ranked. The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Math
       * @param {Array} array The array to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {*} Returns the minimum value.
       * @example
       *
       * var objects = [{ 'n': 1 }, { 'n': 2 }];
       *
       * _.minBy(objects, function(o) { return o.n; });
       * // => { 'n': 1 }
       *
       * // The `_.property` iteratee shorthand.
       * _.minBy(objects, 'n');
       * // => { 'n': 1 }
       */
      function minBy(array, iteratee) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined$1;
      }

      /**
       * Multiply two numbers.
       *
       * @static
       * @memberOf _
       * @since 4.7.0
       * @category Math
       * @param {number} multiplier The first number in a multiplication.
       * @param {number} multiplicand The second number in a multiplication.
       * @returns {number} Returns the product.
       * @example
       *
       * _.multiply(6, 4);
       * // => 24
       */
      var multiply = createMathOperation(function (multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);

      /**
       * Computes `number` rounded to `precision`.
       *
       * @static
       * @memberOf _
       * @since 3.10.0
       * @category Math
       * @param {number} number The number to round.
       * @param {number} [precision=0] The precision to round to.
       * @returns {number} Returns the rounded number.
       * @example
       *
       * _.round(4.006);
       * // => 4
       *
       * _.round(4.006, 2);
       * // => 4.01
       *
       * _.round(4060, -2);
       * // => 4100
       */
      var round = createRound('round');

      /**
       * Subtract two numbers.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Math
       * @param {number} minuend The first number in a subtraction.
       * @param {number} subtrahend The second number in a subtraction.
       * @returns {number} Returns the difference.
       * @example
       *
       * _.subtract(6, 4);
       * // => 2
       */
      var subtract = createMathOperation(function (minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);

      /**
       * Computes the sum of the values in `array`.
       *
       * @static
       * @memberOf _
       * @since 3.4.0
       * @category Math
       * @param {Array} array The array to iterate over.
       * @returns {number} Returns the sum.
       * @example
       *
       * _.sum([4, 2, 8, 6]);
       * // => 20
       */
      function sum(array) {
        return array && array.length ? baseSum(array, identity) : 0;
      }

      /**
       * This method is like `_.sum` except that it accepts `iteratee` which is
       * invoked for each element in `array` to generate the value to be summed.
       * The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Math
       * @param {Array} array The array to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {number} Returns the sum.
       * @example
       *
       * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
       *
       * _.sumBy(objects, function(o) { return o.n; });
       * // => 20
       *
       * // The `_.property` iteratee shorthand.
       * _.sumBy(objects, 'n');
       * // => 20
       */
      function sumBy(array, iteratee) {
        return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
      }

      /*------------------------------------------------------------------------*/

      // Add methods that return wrapped values in chain sequences.
      lodash.after = after;
      lodash.ary = ary;
      lodash.assign = assign;
      lodash.assignIn = assignIn;
      lodash.assignInWith = assignInWith;
      lodash.assignWith = assignWith;
      lodash.at = at;
      lodash.before = before;
      lodash.bind = bind;
      lodash.bindAll = bindAll;
      lodash.bindKey = bindKey;
      lodash.castArray = castArray;
      lodash.chain = chain;
      lodash.chunk = chunk;
      lodash.compact = compact;
      lodash.concat = concat;
      lodash.cond = cond;
      lodash.conforms = conforms;
      lodash.constant = constant;
      lodash.countBy = countBy;
      lodash.create = create;
      lodash.curry = curry;
      lodash.curryRight = curryRight;
      lodash.debounce = debounce;
      lodash.defaults = defaults;
      lodash.defaultsDeep = defaultsDeep;
      lodash.defer = defer;
      lodash.delay = delay;
      lodash.difference = difference;
      lodash.differenceBy = differenceBy;
      lodash.differenceWith = differenceWith;
      lodash.drop = drop;
      lodash.dropRight = dropRight;
      lodash.dropRightWhile = dropRightWhile;
      lodash.dropWhile = dropWhile;
      lodash.fill = fill;
      lodash.filter = filter;
      lodash.flatMap = flatMap;
      lodash.flatMapDeep = flatMapDeep;
      lodash.flatMapDepth = flatMapDepth;
      lodash.flatten = flatten;
      lodash.flattenDeep = flattenDeep;
      lodash.flattenDepth = flattenDepth;
      lodash.flip = flip;
      lodash.flow = flow;
      lodash.flowRight = flowRight;
      lodash.fromPairs = fromPairs;
      lodash.functions = functions;
      lodash.functionsIn = functionsIn;
      lodash.groupBy = groupBy;
      lodash.initial = initial;
      lodash.intersection = intersection;
      lodash.intersectionBy = intersectionBy;
      lodash.intersectionWith = intersectionWith;
      lodash.invert = invert;
      lodash.invertBy = invertBy;
      lodash.invokeMap = invokeMap;
      lodash.iteratee = iteratee;
      lodash.keyBy = keyBy;
      lodash.keys = keys;
      lodash.keysIn = keysIn;
      lodash.map = map;
      lodash.mapKeys = mapKeys;
      lodash.mapValues = mapValues;
      lodash.matches = matches;
      lodash.matchesProperty = matchesProperty;
      lodash.memoize = memoize;
      lodash.merge = merge;
      lodash.mergeWith = mergeWith;
      lodash.method = method;
      lodash.methodOf = methodOf;
      lodash.mixin = mixin;
      lodash.negate = negate;
      lodash.nthArg = nthArg;
      lodash.omit = omit;
      lodash.omitBy = omitBy;
      lodash.once = once;
      lodash.orderBy = orderBy;
      lodash.over = over;
      lodash.overArgs = overArgs;
      lodash.overEvery = overEvery;
      lodash.overSome = overSome;
      lodash.partial = partial;
      lodash.partialRight = partialRight;
      lodash.partition = partition;
      lodash.pick = pick;
      lodash.pickBy = pickBy;
      lodash.property = property;
      lodash.propertyOf = propertyOf;
      lodash.pull = pull;
      lodash.pullAll = pullAll;
      lodash.pullAllBy = pullAllBy;
      lodash.pullAllWith = pullAllWith;
      lodash.pullAt = pullAt;
      lodash.range = range;
      lodash.rangeRight = rangeRight;
      lodash.rearg = rearg;
      lodash.reject = reject;
      lodash.remove = remove;
      lodash.rest = rest;
      lodash.reverse = reverse;
      lodash.sampleSize = sampleSize;
      lodash.set = set;
      lodash.setWith = setWith;
      lodash.shuffle = shuffle;
      lodash.slice = slice;
      lodash.sortBy = sortBy;
      lodash.sortedUniq = sortedUniq;
      lodash.sortedUniqBy = sortedUniqBy;
      lodash.split = split;
      lodash.spread = spread;
      lodash.tail = tail;
      lodash.take = take;
      lodash.takeRight = takeRight;
      lodash.takeRightWhile = takeRightWhile;
      lodash.takeWhile = takeWhile;
      lodash.tap = tap;
      lodash.throttle = throttle;
      lodash.thru = thru;
      lodash.toArray = toArray;
      lodash.toPairs = toPairs;
      lodash.toPairsIn = toPairsIn;
      lodash.toPath = toPath;
      lodash.toPlainObject = toPlainObject;
      lodash.transform = transform;
      lodash.unary = unary;
      lodash.union = union;
      lodash.unionBy = unionBy;
      lodash.unionWith = unionWith;
      lodash.uniq = uniq;
      lodash.uniqBy = uniqBy;
      lodash.uniqWith = uniqWith;
      lodash.unset = unset;
      lodash.unzip = unzip;
      lodash.unzipWith = unzipWith;
      lodash.update = update;
      lodash.updateWith = updateWith;
      lodash.values = values;
      lodash.valuesIn = valuesIn;
      lodash.without = without;
      lodash.words = words;
      lodash.wrap = wrap;
      lodash.xor = xor;
      lodash.xorBy = xorBy;
      lodash.xorWith = xorWith;
      lodash.zip = zip;
      lodash.zipObject = zipObject;
      lodash.zipObjectDeep = zipObjectDeep;
      lodash.zipWith = zipWith;

      // Add aliases.
      lodash.entries = toPairs;
      lodash.entriesIn = toPairsIn;
      lodash.extend = assignIn;
      lodash.extendWith = assignInWith;

      // Add methods to `lodash.prototype`.
      mixin(lodash, lodash);

      /*------------------------------------------------------------------------*/

      // Add methods that return unwrapped values in chain sequences.
      lodash.add = add;
      lodash.attempt = attempt;
      lodash.camelCase = camelCase;
      lodash.capitalize = capitalize;
      lodash.ceil = ceil;
      lodash.clamp = clamp;
      lodash.clone = clone;
      lodash.cloneDeep = cloneDeep;
      lodash.cloneDeepWith = cloneDeepWith;
      lodash.cloneWith = cloneWith;
      lodash.conformsTo = conformsTo;
      lodash.deburr = deburr;
      lodash.defaultTo = defaultTo;
      lodash.divide = divide;
      lodash.endsWith = endsWith;
      lodash.eq = eq;
      lodash.escape = escape;
      lodash.escapeRegExp = escapeRegExp;
      lodash.every = every;
      lodash.find = find;
      lodash.findIndex = findIndex;
      lodash.findKey = findKey;
      lodash.findLast = findLast;
      lodash.findLastIndex = findLastIndex;
      lodash.findLastKey = findLastKey;
      lodash.floor = floor;
      lodash.forEach = forEach;
      lodash.forEachRight = forEachRight;
      lodash.forIn = forIn;
      lodash.forInRight = forInRight;
      lodash.forOwn = forOwn;
      lodash.forOwnRight = forOwnRight;
      lodash.get = get;
      lodash.gt = gt;
      lodash.gte = gte;
      lodash.has = has;
      lodash.hasIn = hasIn;
      lodash.head = head;
      lodash.identity = identity;
      lodash.includes = includes;
      lodash.indexOf = indexOf;
      lodash.inRange = inRange;
      lodash.invoke = invoke;
      lodash.isArguments = isArguments;
      lodash.isArray = isArray;
      lodash.isArrayBuffer = isArrayBuffer;
      lodash.isArrayLike = isArrayLike;
      lodash.isArrayLikeObject = isArrayLikeObject;
      lodash.isBoolean = isBoolean;
      lodash.isBuffer = isBuffer;
      lodash.isDate = isDate;
      lodash.isElement = isElement;
      lodash.isEmpty = isEmpty;
      lodash.isEqual = isEqual;
      lodash.isEqualWith = isEqualWith;
      lodash.isError = isError;
      lodash.isFinite = isFinite;
      lodash.isFunction = isFunction;
      lodash.isInteger = isInteger;
      lodash.isLength = isLength;
      lodash.isMap = isMap;
      lodash.isMatch = isMatch;
      lodash.isMatchWith = isMatchWith;
      lodash.isNaN = isNaN;
      lodash.isNative = isNative;
      lodash.isNil = isNil;
      lodash.isNull = isNull;
      lodash.isNumber = isNumber;
      lodash.isObject = isObject;
      lodash.isObjectLike = isObjectLike;
      lodash.isPlainObject = isPlainObject;
      lodash.isRegExp = isRegExp;
      lodash.isSafeInteger = isSafeInteger;
      lodash.isSet = isSet;
      lodash.isString = isString;
      lodash.isSymbol = isSymbol;
      lodash.isTypedArray = isTypedArray;
      lodash.isUndefined = isUndefined;
      lodash.isWeakMap = isWeakMap;
      lodash.isWeakSet = isWeakSet;
      lodash.join = join;
      lodash.kebabCase = kebabCase;
      lodash.last = last;
      lodash.lastIndexOf = lastIndexOf;
      lodash.lowerCase = lowerCase;
      lodash.lowerFirst = lowerFirst;
      lodash.lt = lt;
      lodash.lte = lte;
      lodash.max = max;
      lodash.maxBy = maxBy;
      lodash.mean = mean;
      lodash.meanBy = meanBy;
      lodash.min = min;
      lodash.minBy = minBy;
      lodash.stubArray = stubArray;
      lodash.stubFalse = stubFalse;
      lodash.stubObject = stubObject;
      lodash.stubString = stubString;
      lodash.stubTrue = stubTrue;
      lodash.multiply = multiply;
      lodash.nth = nth;
      lodash.noConflict = noConflict;
      lodash.noop = noop;
      lodash.now = now;
      lodash.pad = pad;
      lodash.padEnd = padEnd;
      lodash.padStart = padStart;
      lodash.parseInt = parseInt;
      lodash.random = random;
      lodash.reduce = reduce;
      lodash.reduceRight = reduceRight;
      lodash.repeat = repeat;
      lodash.replace = replace;
      lodash.result = result;
      lodash.round = round;
      lodash.runInContext = runInContext;
      lodash.sample = sample;
      lodash.size = size;
      lodash.snakeCase = snakeCase;
      lodash.some = some;
      lodash.sortedIndex = sortedIndex;
      lodash.sortedIndexBy = sortedIndexBy;
      lodash.sortedIndexOf = sortedIndexOf;
      lodash.sortedLastIndex = sortedLastIndex;
      lodash.sortedLastIndexBy = sortedLastIndexBy;
      lodash.sortedLastIndexOf = sortedLastIndexOf;
      lodash.startCase = startCase;
      lodash.startsWith = startsWith;
      lodash.subtract = subtract;
      lodash.sum = sum;
      lodash.sumBy = sumBy;
      lodash.template = template;
      lodash.times = times;
      lodash.toFinite = toFinite;
      lodash.toInteger = toInteger;
      lodash.toLength = toLength;
      lodash.toLower = toLower;
      lodash.toNumber = toNumber;
      lodash.toSafeInteger = toSafeInteger;
      lodash.toString = toString;
      lodash.toUpper = toUpper;
      lodash.trim = trim;
      lodash.trimEnd = trimEnd;
      lodash.trimStart = trimStart;
      lodash.truncate = truncate;
      lodash.unescape = unescape;
      lodash.uniqueId = uniqueId;
      lodash.upperCase = upperCase;
      lodash.upperFirst = upperFirst;

      // Add aliases.
      lodash.each = forEach;
      lodash.eachRight = forEachRight;
      lodash.first = head;
      mixin(lodash, function () {
        var source = {};
        baseForOwn(lodash, function (func, methodName) {
          if (!hasOwnProperty.call(lodash.prototype, methodName)) {
            source[methodName] = func;
          }
        });
        return source;
      }(), {
        'chain': false
      });

      /*------------------------------------------------------------------------*/

      /**
       * The semantic version number.
       *
       * @static
       * @memberOf _
       * @type {string}
       */
      lodash.VERSION = VERSION;

      // Assign default placeholders.
      arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function (methodName) {
        lodash[methodName].placeholder = lodash;
      });

      // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
      arrayEach(['drop', 'take'], function (methodName, index) {
        LazyWrapper.prototype[methodName] = function (n) {
          n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);
          var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
          if (result.__filtered__) {
            result.__takeCount__ = nativeMin(n, result.__takeCount__);
          } else {
            result.__views__.push({
              'size': nativeMin(n, MAX_ARRAY_LENGTH),
              'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
            });
          }
          return result;
        };
        LazyWrapper.prototype[methodName + 'Right'] = function (n) {
          return this.reverse()[methodName](n).reverse();
        };
      });

      // Add `LazyWrapper` methods that accept an `iteratee` value.
      arrayEach(['filter', 'map', 'takeWhile'], function (methodName, index) {
        var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
        LazyWrapper.prototype[methodName] = function (iteratee) {
          var result = this.clone();
          result.__iteratees__.push({
            'iteratee': getIteratee(iteratee, 3),
            'type': type
          });
          result.__filtered__ = result.__filtered__ || isFilter;
          return result;
        };
      });

      // Add `LazyWrapper` methods for `_.head` and `_.last`.
      arrayEach(['head', 'last'], function (methodName, index) {
        var takeName = 'take' + (index ? 'Right' : '');
        LazyWrapper.prototype[methodName] = function () {
          return this[takeName](1).value()[0];
        };
      });

      // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
      arrayEach(['initial', 'tail'], function (methodName, index) {
        var dropName = 'drop' + (index ? '' : 'Right');
        LazyWrapper.prototype[methodName] = function () {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });
      LazyWrapper.prototype.compact = function () {
        return this.filter(identity);
      };
      LazyWrapper.prototype.find = function (predicate) {
        return this.filter(predicate).head();
      };
      LazyWrapper.prototype.findLast = function (predicate) {
        return this.reverse().find(predicate);
      };
      LazyWrapper.prototype.invokeMap = baseRest(function (path, args) {
        if (typeof path == 'function') {
          return new LazyWrapper(this);
        }
        return this.map(function (value) {
          return baseInvoke(value, path, args);
        });
      });
      LazyWrapper.prototype.reject = function (predicate) {
        return this.filter(negate(getIteratee(predicate)));
      };
      LazyWrapper.prototype.slice = function (start, end) {
        start = toInteger(start);
        var result = this;
        if (result.__filtered__ && (start > 0 || end < 0)) {
          return new LazyWrapper(result);
        }
        if (start < 0) {
          result = result.takeRight(-start);
        } else if (start) {
          result = result.drop(start);
        }
        if (end !== undefined$1) {
          end = toInteger(end);
          result = end < 0 ? result.dropRight(-end) : result.take(end - start);
        }
        return result;
      };
      LazyWrapper.prototype.takeRightWhile = function (predicate) {
        return this.reverse().takeWhile(predicate).reverse();
      };
      LazyWrapper.prototype.toArray = function () {
        return this.take(MAX_ARRAY_LENGTH);
      };

      // Add `LazyWrapper` methods to `lodash.prototype`.
      baseForOwn(LazyWrapper.prototype, function (func, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);
        if (!lodashFunc) {
          return;
        }
        lodash.prototype[methodName] = function () {
          var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);
          var interceptor = function (value) {
            var result = lodashFunc.apply(lodash, arrayPush([value], args));
            return isTaker && chainAll ? result[0] : result;
          };
          if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
            // Avoid lazy use if the iteratee has a "length" value other than `1`.
            isLazy = useLazy = false;
          }
          var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;
          if (!retUnwrapped && useLazy) {
            value = onlyLazy ? value : new LazyWrapper(this);
            var result = func.apply(value, args);
            result.__actions__.push({
              'func': thru,
              'args': [interceptor],
              'thisArg': undefined$1
            });
            return new LodashWrapper(result, chainAll);
          }
          if (isUnwrapped && onlyLazy) {
            return func.apply(this, args);
          }
          result = this.thru(interceptor);
          return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
        };
      });

      // Add `Array` methods to `lodash.prototype`.
      arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function (methodName) {
        var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
        lodash.prototype[methodName] = function () {
          var args = arguments;
          if (retUnwrapped && !this.__chain__) {
            var value = this.value();
            return func.apply(isArray(value) ? value : [], args);
          }
          return this[chainName](function (value) {
            return func.apply(isArray(value) ? value : [], args);
          });
        };
      });

      // Map minified method names to their real names.
      baseForOwn(LazyWrapper.prototype, function (func, methodName) {
        var lodashFunc = lodash[methodName];
        if (lodashFunc) {
          var key = lodashFunc.name + '';
          if (!hasOwnProperty.call(realNames, key)) {
            realNames[key] = [];
          }
          realNames[key].push({
            'name': methodName,
            'func': lodashFunc
          });
        }
      });
      realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
        'name': 'wrapper',
        'func': undefined$1
      }];

      // Add methods to `LazyWrapper`.
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;

      // Add chain sequence methods to the `lodash` wrapper.
      lodash.prototype.at = wrapperAt;
      lodash.prototype.chain = wrapperChain;
      lodash.prototype.commit = wrapperCommit;
      lodash.prototype.next = wrapperNext;
      lodash.prototype.plant = wrapperPlant;
      lodash.prototype.reverse = wrapperReverse;
      lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

      // Add lazy aliases.
      lodash.prototype.first = lodash.prototype.head;
      if (symIterator) {
        lodash.prototype[symIterator] = wrapperToIterator;
      }
      return lodash;
    };

    /*--------------------------------------------------------------------------*/

    // Export lodash.
    var _ = runInContext();

    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (freeModule) {
      // Export for Node.js.
      (freeModule.exports = _)._ = _;
      // Export for CommonJS support.
      freeExports._ = _;
    } else {
      // Export to the global object.
      root._ = _;
    }
  }).call(commonjsGlobal);
})(lodash, lodash.exports);
const includeHolidaysForRange = _ref18 => {
  let {
    holidays,
    end,
    workDays,
    start
  } = _ref18;
  var _a;
  const currentWorkDays = lodash.exports.cloneDeep(workDays);
  for (const holiday of holidays) {
    const holidayDate = getHolidayDateBetweenDates(holiday, start, end);
    if (!isHolidayBetweenDates(holiday, start, end)) {
      continue;
    }
    const formatted = formatDate(holidayDate, DATE_FORMATS.DAY_LONG).toLowerCase();
    if (isDayKey(formatted)) {
      currentWorkDays[formatted].holidaysCount = ((_a = currentWorkDays[formatted].holidaysCount) !== null && _a !== void 0 ? _a : 0) + 1;
    }
  }
  return currentWorkDays;
};
const calculateResourceCapacity = _ref19 => {
  let {
    resource,
    endDate,
    startDate,
    companyWorkWeekDetails,
    holidays: _holidays = []
  } = _ref19;
  var _a, _b, _c;
  let workWeekDetails;
  if (resource === null || resource === void 0 ? void 0 : resource.useResourceAvailability) {
    workWeekDetails = ((_b = (_a = resource.customAvailabilities) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.weekDays) || companyWorkWeekDetails;
  } else {
    workWeekDetails = companyWorkWeekDetails;
  }
  let offDaysCount = 0,
    workDaysCount = 0,
    totalMinutes = 0;
  const rangeStart = startOfDay(startDate);
  const rangeEnd = endOfDay(endDate);
  const uniqHolidays = getUniqHolidays(_holidays);
  const inRangeHolidays = uniqHolidays.filter(holiday => isHolidayBetweenDates(holiday, rangeStart, rangeEnd));
  const inRangeHolidaysMapped = inRangeHolidays.reduce((acc, holiday) => {
    if (holiday.repeat) {
      acc[formatDate(holiday.date, DATE_FORMATS.MONTH_DAY)] = holiday;
    } else {
      acc[formatDate(holiday.date, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT)] = holiday;
    }
    return acc;
  }, {});
  const workWeekDetailsWithHolidays = includeHolidaysForRange({
    start: rangeStart,
    end: rangeEnd,
    holidays: inRangeHolidays,
    workDays: workWeekDetails
  });
  let currentDay = rangeStart;
  const rangeEndFormat = formatDate(rangeEnd, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT);
  while (formatDate(currentDay, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT) <= rangeEndFormat) {
    let dayMinutes = 0;
    let offDay = false;
    const dayName = getDateDayKey(currentDay);
    const workDay = workWeekDetailsWithHolidays[dayName];
    if (!workDay.workDay) {
      offDay = true;
    } else {
      dayMinutes = workDay.minutes;
    }
    const isHoliday = Boolean(inRangeHolidaysMapped[formatDate(currentDay, DATE_FORMATS.MONTH_DAY)] || inRangeHolidaysMapped[formatDate(currentDay, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT)]);
    if (isHoliday) {
      dayMinutes = 0;
    }
    if (resource === null || resource === void 0 ? void 0 : resource.resourceHasCustomAvailabilityOverrides) {
      const overrideId = (_c = resource === null || resource === void 0 ? void 0 : resource.customAvailabilitiesOverridesByDay) === null || _c === void 0 ? void 0 : _c[formatDate(currentDay, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT)];
      if (overrideId && resource.customAvailabilitiesOverridesById[overrideId]) {
        const {
          minutes
        } = resource.customAvailabilitiesOverridesById[overrideId];
        dayMinutes = minutes;
        offDay = !!minutes;
      }
    }
    offDaysCount = offDay ? offDaysCount + 1 : offDaysCount;
    workDaysCount = dayMinutes > 0 ? workDaysCount + 1 : workDaysCount;
    totalMinutes += dayMinutes;
    currentDay = addDays$1(currentDay, 1);
  }
  return {
    workDaysCount,
    totalMinutes,
    offDaysCount,
    holidayCount: inRangeHolidays.length,
    workWeekDetails: workWeekDetailsWithHolidays,
    averageWorkDay: totalMinutes > 0 ? totalMinutes / workDaysCount / 60 : 0,
    averageDay: totalMinutes > 0 ? totalMinutes / (workDaysCount + offDaysCount) / 60 : 0
  };
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
const Ce = 0,
  Lt = 1,
  Yt = 2,
  En = 4;
function sn(t) {
  return () => t;
}
function lo(t) {
  t();
}
function ne(t, e) {
  return n => t(e(n));
}
function ln(t, e) {
  return () => t(e);
}
function Hn(t, e) {
  return n => t(e, n);
}
function Ae(t) {
  return t !== void 0;
}
function co() {
  for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    t[_key2] = arguments[_key2];
  }
  return () => {
    t.map(lo);
  };
}
function Gt() {}
function ye(t, e) {
  return e(t), t;
}
function uo(t, e) {
  return e(t);
}
function X() {
  for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    t[_key3] = arguments[_key3];
  }
  return t;
}
function K(t, e) {
  return t(Lt, e);
}
function M$1(t, e) {
  t(Ce, e);
}
function We(t) {
  t(Yt);
}
function lt(t) {
  return t(En);
}
function F(t, e) {
  return K(t, Hn(e, Ce));
}
function Rt(t, e) {
  const n = t(Lt, o => {
    n(), e(o);
  });
  return n;
}
function cn(t) {
  let e, n;
  return o => r => {
    e = r, n && clearTimeout(n), n = setTimeout(() => {
      o(e);
    }, t);
  };
}
function Bn(t, e) {
  return t === e;
}
function Y() {
  let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Bn;
  let e;
  return n => o => {
    t(e, o) || (e = o, n(o));
  };
}
function V(t) {
  return e => n => {
    t(n) && e(n);
  };
}
function H(t) {
  return e => ne(e, t);
}
function vt(t) {
  return e => () => {
    e(t);
  };
}
function x$1(t) {
  for (var _len4 = arguments.length, e = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    e[_key4 - 1] = arguments[_key4];
  }
  const n = ao(...e);
  return (o, r) => {
    switch (o) {
      case Yt:
        We(t);
        return;
      case Lt:
        return K(t, n(r));
    }
  };
}
function bt(t, e) {
  return n => o => {
    n(e = t(e, o));
  };
}
function qt(t) {
  return e => n => {
    t > 0 ? t-- : e(n);
  };
}
function zt(t) {
  let e = null,
    n;
  return o => r => {
    e = r, !n && (n = setTimeout(() => {
      n = void 0, o(e);
    }, t));
  };
}
function G() {
  for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    t[_key5] = arguments[_key5];
  }
  const e = new Array(t.length);
  let n = 0,
    o = null;
  const r = Math.pow(2, t.length) - 1;
  return t.forEach((s, i) => {
    const l = Math.pow(2, i);
    K(s, c => {
      const d = n;
      n = n | l, e[i] = c, d !== r && n === r && o && (o(), o = null);
    });
  }), s => i => {
    const l = () => {
      s([i].concat(e));
    };
    n === r ? l() : o = l;
  };
}
function ao() {
  for (var _len6 = arguments.length, t = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    t[_key6] = arguments[_key6];
  }
  return e => t.reduceRight(uo, e);
}
function fo(t) {
  let e, n;
  const o = () => e == null ? void 0 : e();
  return function (r, s) {
    switch (r) {
      case Lt:
        return s ? n === s ? void 0 : (o(), n = s, e = K(t, s), e) : (o(), Gt);
      case Yt:
        o(), n = null;
        return;
    }
  };
}
function w$1(t) {
  let e = t;
  const n = $$k();
  return (o, r) => {
    switch (o) {
      case Ce:
        e = r;
        break;
      case Lt:
        {
          r(e);
          break;
        }
      case En:
        return e;
    }
    return n(o, r);
  };
}
function ct(t, e) {
  return ye(w$1(e), n => F(t, n));
}
function $$k() {
  const t = [];
  return (e, n) => {
    switch (e) {
      case Ce:
        t.slice().forEach(o => {
          o(n);
        });
        return;
      case Yt:
        t.splice(0, t.length);
        return;
      case Lt:
        return t.push(n), () => {
          const o = t.indexOf(n);
          o > -1 && t.splice(o, 1);
        };
    }
  };
}
function pt(t) {
  return ye($$k(), e => F(t, e));
}
function U(t) {
  let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let {
    singleton: n
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    singleton: !0
  };
  return {
    constructor: t,
    dependencies: e,
    id: mo(),
    singleton: n
  };
}
const mo = () => Symbol();
function po(t) {
  const e = /* @__PURE__ */new Map(),
    n = _ref20 => {
      let {
        constructor: o,
        dependencies: r,
        id: s,
        singleton: i
      } = _ref20;
      if (i && e.has(s)) return e.get(s);
      const l = o(r.map(c => n(c)));
      return i && e.set(s, l), l;
    };
  return n(t);
}
function rt() {
  for (var _len7 = arguments.length, t = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    t[_key7] = arguments[_key7];
  }
  const e = $$k(),
    n = new Array(t.length);
  let o = 0;
  const r = Math.pow(2, t.length) - 1;
  return t.forEach((s, i) => {
    const l = Math.pow(2, i);
    K(s, c => {
      n[i] = c, o = o | l, o === r && M$1(e, n);
    });
  }), function (s, i) {
    switch (s) {
      case Yt:
        {
          We(e);
          return;
        }
      case Lt:
        return o === r && i(n), K(e, i);
    }
  };
}
function A$1(t) {
  let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Bn;
  return x$1(t, Y(e));
}
function un() {
  for (var _len8 = arguments.length, t = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    t[_key8] = arguments[_key8];
  }
  return function (e, n) {
    switch (e) {
      case Yt:
        return;
      case Lt:
        return co(...t.map(o => K(o, n)));
    }
  };
}
var ht = /* @__PURE__ */(t => (t[t.DEBUG = 0] = "DEBUG", t[t.INFO = 1] = "INFO", t[t.WARN = 2] = "WARN", t[t.ERROR = 3] = "ERROR", t))(ht || {});
const ho = {
    0: "debug",
    3: "error",
    1: "log",
    2: "warn"
  },
  go = () => typeof globalThis > "u" ? window : globalThis,
  Pt = U(() => {
    const t = w$1(3
    /* ERROR */);
    return {
      log: w$1(function (n, o) {
        let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var i;
        const s = (i = go().VIRTUOSO_LOG_LEVEL) != null ? i : lt(t);
        r >= s && console[ho[r]]("%creact-virtuoso: %c%s %o", "color: #0253b3; font-weight: bold", "color: initial", n, o);
      }),
      logLevel: t
    };
  }, [], {
    singleton: !0
  });
function Et(t, e, n) {
  return Me(t, e, n).callbackRef;
}
function Me(t, e, n) {
  const o = React__default.useRef(null);
  let r = s => {};
  if (typeof ResizeObserver < "u") {
    const s = React__default.useMemo(() => new ResizeObserver(i => {
      const l = () => {
        const c = i[0].target;
        c.offsetParent !== null && t(c);
      };
      n ? l() : requestAnimationFrame(l);
    }), [t]);
    r = i => {
      i && e ? (s.observe(i), o.current = i) : (o.current && s.unobserve(o.current), o.current = null);
    };
  }
  return {
    callbackRef: r,
    ref: o
  };
}
function kn(t, e, n, o, r, s, i, l, c) {
  const d = React__default.useCallback(f => {
    const S = Io(f.children, e, l ? "offsetWidth" : "offsetHeight", r);
    let p = f.parentElement;
    for (; !p.dataset.virtuosoScroller;) p = p.parentElement;
    const m = p.lastElementChild.dataset.viewportType === "window",
      C = i ? l ? i.scrollLeft : i.scrollTop : m ? l ? window.pageXOffset || document.documentElement.scrollLeft : window.pageYOffset || document.documentElement.scrollTop : l ? p.scrollLeft : p.scrollTop,
      I = i ? l ? i.scrollWidth : i.scrollHeight : m ? l ? document.documentElement.scrollWidth : document.documentElement.scrollHeight : l ? p.scrollWidth : p.scrollHeight,
      y = i ? l ? i.offsetWidth : i.offsetHeight : m ? l ? window.innerWidth : window.innerHeight : l ? p.offsetWidth : p.offsetHeight;
    o({
      scrollHeight: I,
      scrollTop: Math.max(C, 0),
      viewportHeight: y
    }), s == null || s(l ? an("column-gap", getComputedStyle(f).columnGap, r) : an("row-gap", getComputedStyle(f).rowGap, r)), S !== null && t(S);
  }, [t, e, r, s, i, o]);
  return Me(d, n, c);
}
function Io(t, e, n, o) {
  const r = t.length;
  if (r === 0) return null;
  const s = [];
  for (let i = 0; i < r; i++) {
    const l = t.item(i);
    if (l.dataset.index === void 0) continue;
    const c = parseInt(l.dataset.index),
      d = parseFloat(l.dataset.knownSize),
      f = e(l, n);
    if (f === 0 && o("Zero-sized element, this should not happen", {
      child: l
    }, ht.ERROR), f === d) continue;
    const S = s[s.length - 1];
    s.length === 0 || S.size !== f || S.endIndex !== c - 1 ? s.push({
      endIndex: c,
      size: f,
      startIndex: c
    }) : s[s.length - 1].endIndex++;
  }
  return s;
}
function an(t, e, n) {
  return e !== "normal" && !(e != null && e.endsWith("px")) && n("".concat(t, " was not resolved to pixel value correctly"), e, ht.WARN), e === "normal" ? 0 : parseInt(e != null ? e : "0", 10);
}
function _e(t, e, n) {
  const o = React__default.useRef(null),
    r = React__default.useCallback(c => {
      if (!(c != null && c.offsetParent)) return;
      const d = c.getBoundingClientRect(),
        f = d.width;
      let S, p;
      if (e) {
        const m = e.getBoundingClientRect(),
          C = d.top - m.top;
        p = m.height - Math.max(0, C), S = C + e.scrollTop;
      } else p = window.innerHeight - Math.max(0, d.top), S = d.top + window.pageYOffset;
      o.current = {
        offsetTop: S,
        visibleHeight: p,
        visibleWidth: f
      }, t(o.current);
    }, [t, e]),
    {
      callbackRef: s,
      ref: i
    } = Me(r, !0, n),
    l = React__default.useCallback(() => {
      r(i.current);
    }, [r, i]);
  return React__default.useEffect(() => {
    if (e) {
      e.addEventListener("scroll", l);
      const c = new ResizeObserver(() => {
        requestAnimationFrame(l);
      });
      return c.observe(e), () => {
        e.removeEventListener("scroll", l), c.unobserve(e);
      };
    } else return window.addEventListener("scroll", l), window.addEventListener("resize", l), () => {
      window.removeEventListener("scroll", l), window.removeEventListener("resize", l);
    };
  }, [l, e]), s;
}
const at = U(() => {
    const t = $$k(),
      e = $$k(),
      n = w$1(0),
      o = $$k(),
      r = w$1(0),
      s = $$k(),
      i = $$k(),
      l = w$1(0),
      c = w$1(0),
      d = w$1(0),
      f = w$1(0),
      S = $$k(),
      p = $$k(),
      m = w$1(!1),
      C = w$1(!1),
      I = w$1(!1);
    return F(x$1(t, H(_ref21 => {
      let {
        scrollTop: y
      } = _ref21;
      return y;
    })), e), F(x$1(t, H(_ref22 => {
      let {
        scrollHeight: y
      } = _ref22;
      return y;
    })), i), F(e, r), {
      deviation: n,
      fixedFooterHeight: d,
      fixedHeaderHeight: c,
      footerHeight: f,
      headerHeight: l,
      horizontalDirection: C,
      scrollBy: p,
      // input
      scrollContainerState: t,
      scrollHeight: i,
      scrollingInProgress: m,
      // signals
      scrollTo: S,
      scrollTop: e,
      skipAnimationFrameInResizeObserver: I,
      smoothScrollTargetReached: o,
      // state
      statefulScrollTop: r,
      viewportHeight: s
    };
  }, [], {
    singleton: !0
  }),
  oe = {
    lvl: 0
  };
function On(t, e) {
  const n = t.length;
  if (n === 0) return [];
  let {
    index: o,
    value: r
  } = e(t[0]);
  const s = [];
  for (let i = 1; i < n; i++) {
    const {
      index: l,
      value: c
    } = e(t[i]);
    s.push({
      end: l - 1,
      start: o,
      value: r
    }), o = l, r = c;
  }
  return s.push({
    end: 1 / 0,
    start: o,
    value: r
  }), s;
}
function j(t) {
  return t === oe;
}
function re(t, e) {
  if (!j(t)) return e === t.k ? t.v : e < t.k ? re(t.l, e) : re(t.r, e);
}
function wt(t, e) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "k";
  if (j(t)) return [-1 / 0, void 0];
  if (Number(t[n]) === e) return [t.k, t.v];
  if (Number(t[n]) < e) {
    const o = wt(t.r, e, n);
    return o[0] === -1 / 0 ? [t.k, t.v] : o;
  }
  return wt(t.l, e, n);
}
function mt(t, e, n) {
  return j(t) ? Ln(e, n, 1) : e === t.k ? ot(t, {
    k: e,
    v: n
  }) : e < t.k ? dn(ot(t, {
    l: mt(t.l, e, n)
  })) : dn(ot(t, {
    r: mt(t.r, e, n)
  }));
}
function Kt() {
  return oe;
}
function ve(t, e, n) {
  if (j(t)) return [];
  const o = wt(t, e)[0];
  return So(ze(t, o, n));
}
function Fe(t, e) {
  if (j(t)) return oe;
  const {
    k: n,
    l: o,
    r
  } = t;
  if (e === n) {
    if (j(o)) return r;
    if (j(r)) return o;
    {
      const [s, i] = zn(o);
      return ge(ot(t, {
        k: s,
        l: Fn(o),
        v: i
      }));
    }
  } else return e < n ? ge(ot(t, {
    l: Fe(o, e)
  })) : ge(ot(t, {
    r: Fe(r, e)
  }));
}
function _t(t) {
  return j(t) ? [] : [..._t(t.l), {
    k: t.k,
    v: t.v
  }, ..._t(t.r)];
}
function ze(t, e, n) {
  if (j(t)) return [];
  const {
    k: o,
    l: r,
    r: s,
    v: i
  } = t;
  let l = [];
  return o > e && (l = l.concat(ze(r, e, n))), o >= e && o <= n && l.push({
    k: o,
    v: i
  }), o <= n && (l = l.concat(ze(s, e, n))), l;
}
function ge(t) {
  const {
    l: e,
    lvl: n,
    r: o
  } = t;
  if (o.lvl >= n - 1 && e.lvl >= n - 1) return t;
  if (n > o.lvl + 1) {
    if (He(e)) return Pn(ot(t, {
      lvl: n - 1
    }));
    if (!j(e) && !j(e.r)) return ot(e.r, {
      l: ot(e, {
        r: e.r.l
      }),
      lvl: n,
      r: ot(t, {
        l: e.r.r,
        lvl: n - 1
      })
    });
    throw new Error("Unexpected empty nodes");
  } else {
    if (He(t)) return Le(ot(t, {
      lvl: n - 1
    }));
    if (!j(o) && !j(o.l)) {
      const r = o.l,
        s = He(r) ? o.lvl - 1 : o.lvl;
      return ot(r, {
        l: ot(t, {
          lvl: n - 1,
          r: r.l
        }),
        lvl: r.lvl + 1,
        r: Le(ot(o, {
          l: r.r,
          lvl: s
        }))
      });
    } else throw new Error("Unexpected empty nodes");
  }
}
function ot(t, e) {
  return Ln(e.k !== void 0 ? e.k : t.k, e.v !== void 0 ? e.v : t.v, e.lvl !== void 0 ? e.lvl : t.lvl, e.l !== void 0 ? e.l : t.l, e.r !== void 0 ? e.r : t.r);
}
function Fn(t) {
  return j(t.r) ? t.l : ge(ot(t, {
    r: Fn(t.r)
  }));
}
function He(t) {
  return j(t) || t.lvl > t.r.lvl;
}
function zn(t) {
  return j(t.r) ? [t.k, t.v] : zn(t.r);
}
function Ln(t, e, n) {
  let o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : oe;
  let r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : oe;
  return {
    k: t,
    l: o,
    lvl: n,
    r,
    v: e
  };
}
function dn(t) {
  return Le(Pn(t));
}
function Pn(t) {
  const {
    l: e
  } = t;
  return !j(e) && e.lvl === t.lvl ? ot(e, {
    r: ot(t, {
      l: e.r
    })
  }) : t;
}
function Le(t) {
  const {
    lvl: e,
    r: n
  } = t;
  return !j(n) && !j(n.r) && n.lvl === e && n.r.lvl === e ? ot(n, {
    l: ot(t, {
      r: n.l
    }),
    lvl: e + 1
  }) : t;
}
function So(t) {
  return On(t, _ref23 => {
    let {
      k: e,
      v: n
    } = _ref23;
    return {
      index: e,
      value: n
    };
  });
}
function Vn(t, e) {
  return !!(t && t.startIndex === e.startIndex && t.endIndex === e.endIndex);
}
function se(t, e) {
  return !!(t && t[0] === e[0] && t[1] === e[1]);
}
const Ge = U(() => ({
  recalcInProgress: w$1(!1)
}), [], {
  singleton: !0
});
function An(t, e, n) {
  return t[Se(t, e, n)];
}
function Se(t, e, n) {
  let o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  let r = t.length - 1;
  for (; o <= r;) {
    const s = Math.floor((o + r) / 2),
      i = t[s],
      l = n(i, e);
    if (l === 0) return s;
    if (l === -1) {
      if (r - o < 2) return s - 1;
      r = s - 1;
    } else {
      if (r === o) return s;
      o = s + 1;
    }
  }
  throw new Error("Failed binary finding record in array - ".concat(t.join(","), ", searched for ").concat(e));
}
function xo(t, e, n, o) {
  const r = Se(t, e, o),
    s = Se(t, n, o, r);
  return t.slice(r, s + 1);
}
function Ct(t, e) {
  return Math.round(t.getBoundingClientRect()[e]);
}
function be(t) {
  return !j(t.groupOffsetTree);
}
function Ne(_ref24, e) {
  let {
    index: t
  } = _ref24;
  return e === t ? 0 : e < t ? -1 : 1;
}
function To() {
  return {
    groupIndices: [],
    groupOffsetTree: Kt(),
    lastIndex: 0,
    lastOffset: 0,
    lastSize: 0,
    offsetTree: [],
    sizeTree: Kt()
  };
}
function wo(t, e) {
  let n = j(t) ? 0 : 1 / 0;
  for (const o of e) {
    const {
      endIndex: r,
      size: s,
      startIndex: i
    } = o;
    if (n = Math.min(n, i), j(t)) {
      t = mt(t, 0, s);
      continue;
    }
    const l = ve(t, i - 1, r + 1);
    if (l.some(Ho(o))) continue;
    let c = !1,
      d = !1;
    for (const {
      end: f,
      start: S,
      value: p
    } of l) c ? (r >= S || s === p) && (t = Fe(t, S)) : (d = p !== s, c = !0), f > r && r >= S && p !== s && (t = mt(t, r + 1, p));
    d && (t = mt(t, i, s));
  }
  return [t, n];
}
function Co(t) {
  return typeof t.groupIndex < "u";
}
function yo(_ref25, e) {
  let {
    offset: t
  } = _ref25;
  return e === t ? 0 : e < t ? -1 : 1;
}
function ie(t, e, n) {
  if (e.length === 0) return 0;
  const {
      index: o,
      offset: r,
      size: s
    } = An(e, t, Ne),
    i = t - o,
    l = s * i + (i - 1) * n + r;
  return l > 0 ? l + n : l;
}
function Wn(t, e) {
  if (!be(e)) return t;
  let n = 0;
  for (; e.groupIndices[n] <= t + n;) n++;
  return t + n;
}
function Mn(t, e, n) {
  if (Co(t)) return e.groupIndices[t.groupIndex] + 1;
  {
    const o = t.index === "LAST" ? n : t.index;
    let r = Wn(o, e);
    return r = Math.max(0, r, Math.min(n, r)), r;
  }
}
function vo(t, e, n) {
  let o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return o > 0 && (e = Math.max(e, An(t, o, Ne).offset)), On(xo(t, e, n, yo), Eo);
}
function bo(t, _ref26) {
  let [e, n, o, r] = _ref26;
  e.length > 0 && o("received item sizes", e, ht.DEBUG);
  const s = t.sizeTree;
  let i = s,
    l = 0;
  if (n.length > 0 && j(s) && e.length === 2) {
    const p = e[0].size,
      m = e[1].size;
    i = n.reduce((C, I) => mt(mt(C, I, p), I + 1, m), i);
  } else [i, l] = wo(i, e);
  if (i === s) return t;
  const {
    lastIndex: c,
    lastOffset: d,
    lastSize: f,
    offsetTree: S
  } = Pe(t.offsetTree, l, i, r);
  return {
    groupIndices: n,
    groupOffsetTree: n.reduce((p, m) => mt(p, m, ie(m, S, r)), Kt()),
    lastIndex: c,
    lastOffset: d,
    lastSize: f,
    offsetTree: S,
    sizeTree: i
  };
}
function Ro(t) {
  return _t(t).map((_ref27, o, r) => {
    let {
      k: e,
      v: n
    } = _ref27;
    const s = r[o + 1];
    return {
      endIndex: s ? s.k - 1 : 1 / 0,
      size: n,
      startIndex: e
    };
  });
}
function fn(t, e) {
  let n = 0,
    o = 0;
  for (; n < t;) n += e[o + 1] - e[o] - 1, o++;
  return o - (n === t ? 0 : 1);
}
function Pe(t, e, n, o) {
  let r = t,
    s = 0,
    i = 0,
    l = 0,
    c = 0;
  if (e !== 0) {
    c = Se(r, e - 1, Ne), l = r[c].offset;
    const f = wt(n, e - 1);
    s = f[0], i = f[1], r.length && r[c].size === wt(n, e)[1] && (c -= 1), r = r.slice(0, c + 1);
  } else r = [];
  for (const {
    start: d,
    value: f
  } of ve(n, e, 1 / 0)) {
    const S = d - s,
      p = S * i + l + S * o;
    r.push({
      index: d,
      offset: p,
      size: f
    }), s = d, l = p, i = f;
  }
  return {
    lastIndex: s,
    lastOffset: l,
    lastSize: i,
    offsetTree: r
  };
}
function Eo(t) {
  return {
    index: t.index,
    value: t
  };
}
function Ho(t) {
  const {
    endIndex: e,
    size: n,
    startIndex: o
  } = t;
  return r => r.start === o && (r.end === e || r.end === 1 / 0) && r.value === n;
}
const Bo = {
    offsetHeight: "height",
    offsetWidth: "width"
  },
  Ht = U(_ref28 => {
    let [{
      log: t
    }, {
      recalcInProgress: e
    }] = _ref28;
    const n = $$k(),
      o = $$k(),
      r = ct(o, 0),
      s = $$k(),
      i = $$k(),
      l = w$1(0),
      c = w$1([]),
      d = w$1(void 0),
      f = w$1(void 0),
      S = w$1((h, a) => Ct(h, Bo[a])),
      p = w$1(void 0),
      m = w$1(0),
      C = To(),
      I = ct(x$1(n, G(c, t, m), bt(bo, C), Y()), C),
      y = ct(x$1(c, Y(), bt((h, a) => ({
        current: a,
        prev: h.current
      }), {
        current: [],
        prev: []
      }), H(_ref29 => {
        let {
          prev: h
        } = _ref29;
        return h;
      })), []);
    F(x$1(c, V(h => h.length > 0), G(I, m), H(_ref30 => {
      let [h, a, R] = _ref30;
      const k = h.reduce((O, z, P) => mt(O, z, ie(z, a.offsetTree, R) || P), Kt());
      return {
        ...a,
        groupIndices: h,
        groupOffsetTree: k
      };
    })), I), F(x$1(o, G(I), V(_ref31 => {
      let [h, {
        lastIndex: a
      }] = _ref31;
      return h < a;
    }), H(_ref32 => {
      let [h, {
        lastIndex: a,
        lastSize: R
      }] = _ref32;
      return [{
        endIndex: a,
        size: R,
        startIndex: h
      }];
    })), n), F(d, f);
    const g = ct(x$1(d, H(h => h === void 0)), !0);
    F(x$1(f, V(h => h !== void 0 && j(lt(I).sizeTree)), H(h => [{
      endIndex: 0,
      size: h,
      startIndex: 0
    }])), n);
    const u = pt(x$1(n, G(I), bt((_ref33, _ref34) => {
      let {
        sizes: h
      } = _ref33;
      let [a, R] = _ref34;
      return {
        changed: R !== h,
        sizes: R
      };
    }, {
      changed: !1,
      sizes: C
    }), H(h => h.changed)));
    K(x$1(l, bt((h, a) => ({
      diff: h.prev - a,
      prev: a
    }), {
      diff: 0,
      prev: 0
    }), H(h => h.diff)), h => {
      const {
        groupIndices: a
      } = lt(I);
      if (h > 0) M$1(e, !0), M$1(s, h + fn(h, a));else if (h < 0) {
        const R = lt(y);
        R.length > 0 && (h -= fn(-h, R)), M$1(i, h);
      }
    }), K(x$1(l, G(t)), _ref35 => {
      let [h, a] = _ref35;
      h < 0 && a("`firstItemIndex` prop should not be set to less than zero. If you don't know the total count, just use a very high value", {
        firstItemIndex: l
      }, ht.ERROR);
    });
    const T = pt(s);
    F(x$1(s, G(I), H(_ref36 => {
      let [h, a] = _ref36;
      const R = a.groupIndices.length > 0,
        k = [],
        O = a.lastSize;
      if (R) {
        const z = re(a.sizeTree, 0);
        let P = 0,
          D = 0;
        for (; P < h;) {
          const B = a.groupIndices[D],
            q = a.groupIndices.length === D + 1 ? 1 / 0 : a.groupIndices[D + 1] - B - 1;
          k.push({
            endIndex: B,
            size: z,
            startIndex: B
          }), k.push({
            endIndex: B + 1 + q - 1,
            size: O,
            startIndex: B + 1
          }), D++, P += q + 1;
        }
        const J = _t(a.sizeTree);
        return P !== h && J.shift(), J.reduce((B, _ref37) => {
          let {
            k: q,
            v: st
          } = _ref37;
          let dt = B.ranges;
          return B.prevSize !== 0 && (dt = [...B.ranges, {
            endIndex: q + h - 1,
            size: B.prevSize,
            startIndex: B.prevIndex
          }]), {
            prevIndex: q + h,
            prevSize: st,
            ranges: dt
          };
        }, {
          prevIndex: h,
          prevSize: 0,
          ranges: k
        }).ranges;
      }
      return _t(a.sizeTree).reduce((z, _ref38) => {
        let {
          k: P,
          v: D
        } = _ref38;
        return {
          prevIndex: P + h,
          prevSize: D,
          ranges: [...z.ranges, {
            endIndex: P + h - 1,
            size: z.prevSize,
            startIndex: z.prevIndex
          }]
        };
      }, {
        prevIndex: 0,
        prevSize: O,
        ranges: []
      }).ranges;
    })), n);
    const b = pt(x$1(i, G(I, m), H(_ref39 => {
      let [h, {
        offsetTree: a
      }, R] = _ref39;
      const k = -h;
      return ie(k, a, R);
    })));
    return F(x$1(i, G(I, m), H(_ref40 => {
      let [h, a, R] = _ref40;
      if (a.groupIndices.length > 0) {
        if (j(a.sizeTree)) return a;
        let O = Kt();
        const z = lt(y);
        let P = 0,
          D = 0,
          J = 0;
        for (; P < -h;) {
          J = z[D];
          const B = z[D + 1] - J - 1;
          D++, P += B + 1;
        }
        if (O = _t(a.sizeTree).reduce((B, _ref41) => {
          let {
            k: q,
            v: st
          } = _ref41;
          return mt(B, Math.max(0, q + h), st);
        }, O), P !== -h) {
          const B = re(a.sizeTree, J);
          O = mt(O, 0, B);
          const q = wt(a.sizeTree, -h + 1)[1];
          O = mt(O, 1, q);
        }
        return {
          ...a,
          sizeTree: O,
          ...Pe(a.offsetTree, 0, O, R)
        };
      } else {
        const O = _t(a.sizeTree).reduce((z, _ref42) => {
          let {
            k: P,
            v: D
          } = _ref42;
          return mt(z, Math.max(0, P + h), D);
        }, Kt());
        return {
          ...a,
          sizeTree: O,
          ...Pe(a.offsetTree, 0, O, R)
        };
      }
    })), I), {
      beforeUnshiftWith: T,
      // input
      data: p,
      defaultItemSize: f,
      firstItemIndex: l,
      fixedItemSize: d,
      gap: m,
      groupIndices: c,
      itemSize: S,
      listRefresh: u,
      shiftWith: i,
      shiftWithOffset: b,
      sizeRanges: n,
      // output
      sizes: I,
      statefulTotalCount: r,
      totalCount: o,
      trackItemSizes: g,
      unshiftWith: s
    };
  }, X(Pt, Ge), {
    singleton: !0
  });
function ko(t) {
  return t.reduce((e, n) => (e.groupIndices.push(e.totalCount), e.totalCount += n + 1, e), {
    groupIndices: [],
    totalCount: 0
  });
}
const _n = U(_ref43 => {
    let [{
      groupIndices: t,
      sizes: e,
      totalCount: n
    }, {
      headerHeight: o,
      scrollTop: r
    }] = _ref43;
    const s = $$k(),
      i = $$k(),
      l = pt(x$1(s, H(ko)));
    return F(x$1(l, H(c => c.totalCount)), n), F(x$1(l, H(c => c.groupIndices)), t), F(x$1(rt(r, e, o), V(_ref44 => {
      let [c, d] = _ref44;
      return be(d);
    }), H(_ref45 => {
      let [c, d, f] = _ref45;
      return wt(d.groupOffsetTree, Math.max(c - f, 0), "v")[0];
    }), Y(), H(c => [c])), i), {
      groupCounts: s,
      topItemsIndexes: i
    };
  }, X(Ht, at)),
  Vt = U(_ref46 => {
    let [{
      log: t
    }] = _ref46;
    const e = w$1(!1),
      n = pt(x$1(e, V(o => o), Y()));
    return K(e, o => {
      o && lt(t)("props updated", {}, ht.DEBUG);
    }), {
      didMount: n,
      propsReady: e
    };
  }, X(Pt), {
    singleton: !0
  }),
  Oo = typeof document < "u" && "scrollBehavior" in document.documentElement.style;
function Gn(t) {
  const e = typeof t == "number" ? {
    index: t
  } : t;
  return e.align || (e.align = "start"), (!e.behavior || !Oo) && (e.behavior = "auto"), e.offset || (e.offset = 0), e;
}
const ce = U(_ref47 => {
  let [{
    gap: t,
    listRefresh: e,
    sizes: n,
    totalCount: o
  }, {
    fixedFooterHeight: r,
    fixedHeaderHeight: s,
    footerHeight: i,
    headerHeight: l,
    scrollingInProgress: c,
    scrollTo: d,
    smoothScrollTargetReached: f,
    viewportHeight: S
  }, {
    log: p
  }] = _ref47;
  const m = $$k(),
    C = $$k(),
    I = w$1(0);
  let y = null,
    g = null,
    u = null;
  function T() {
    y && (y(), y = null), u && (u(), u = null), g && (clearTimeout(g), g = null), M$1(c, !1);
  }
  return F(x$1(m, G(n, S, o, I, l, i, p), G(t, s, r), H(_ref48 => {
    let [[b, h, a, R, k, O, z, P], D, J, nt] = _ref48;
    const B = Gn(b),
      {
        align: q,
        behavior: st,
        offset: dt
      } = B,
      St = R - 1,
      ft = Mn(B, h, St);
    let ut = ie(ft, h.offsetTree, D) + O;
    q === "end" ? (ut += J + wt(h.sizeTree, ft)[1] - a + nt, ft === St && (ut += z)) : q === "center" ? ut += (J + wt(h.sizeTree, ft)[1] - a + nt) / 2 : ut -= k, dt && (ut += dt);
    const At = xt => {
      T(), xt ? (P("retrying to scroll to", {
        location: b
      }, ht.DEBUG), M$1(m, b)) : (M$1(C, !0), P("list did not change, scroll successful", {}, ht.DEBUG));
    };
    if (T(), st === "smooth") {
      let xt = !1;
      u = K(e, Xt => {
        xt = xt || Xt;
      }), y = Rt(f, () => {
        At(xt);
      });
    } else y = Rt(x$1(e, Fo(150)), At);
    return g = setTimeout(() => {
      T();
    }, 1200), M$1(c, !0), P("scrolling from index to", {
      behavior: st,
      index: ft,
      top: ut
    }, ht.DEBUG), {
      behavior: st,
      top: ut
    };
  })), d), {
    scrollTargetReached: C,
    scrollToIndex: m,
    topListHeight: I
  };
}, X(Ht, at, Pt), {
  singleton: !0
});
function Fo(t) {
  return e => {
    const n = setTimeout(() => {
      e(!1);
    }, t);
    return o => {
      o && (e(!0), clearTimeout(n));
    };
  };
}
function De(t, e) {
  t == 0 ? e() : requestAnimationFrame(() => {
    De(t - 1, e);
  });
}
function $e(t, e) {
  const n = e - 1;
  return typeof t == "number" ? t : t.index === "LAST" ? n : t.index;
}
const ue = U(_ref49 => {
  let [{
    defaultItemSize: t,
    listRefresh: e,
    sizes: n
  }, {
    scrollTop: o
  }, {
    scrollTargetReached: r,
    scrollToIndex: s
  }, {
    didMount: i
  }] = _ref49;
  const l = w$1(!0),
    c = w$1(0),
    d = w$1(!0);
  return F(x$1(i, G(c), V(_ref50 => {
    let [f, S] = _ref50;
    return !!S;
  }), vt(!1)), l), F(x$1(i, G(c), V(_ref51 => {
    let [f, S] = _ref51;
    return !!S;
  }), vt(!1)), d), K(x$1(rt(e, i), G(l, n, t, d), V(_ref52 => {
    let [[, f], S, {
      sizeTree: p
    }, m, C] = _ref52;
    return f && (!j(p) || Ae(m)) && !S && !C;
  }), G(c)), _ref53 => {
    let [, f] = _ref53;
    Rt(r, () => {
      M$1(d, !0);
    }), De(4, () => {
      Rt(o, () => {
        M$1(l, !0);
      }), M$1(s, f);
    });
  }), {
    initialItemFinalLocationReached: d,
    initialTopMostItemIndex: c,
    scrolledToInitialItem: l
  };
}, X(Ht, at, ce, Vt), {
  singleton: !0
});
function Nn(t, e) {
  return Math.abs(t - e) < 1.01;
}
const le = "up",
  te = "down",
  zo = "none",
  Lo = {
    atBottom: !1,
    notAtBottomBecause: "NOT_SHOWING_LAST_ITEM",
    state: {
      offsetBottom: 0,
      scrollHeight: 0,
      scrollTop: 0,
      viewportHeight: 0
    }
  },
  Po = 0,
  ae = U(_ref54 => {
    let [{
      footerHeight: t,
      headerHeight: e,
      scrollBy: n,
      scrollContainerState: o,
      scrollTop: r,
      viewportHeight: s
    }] = _ref54;
    const i = w$1(!1),
      l = w$1(!0),
      c = $$k(),
      d = $$k(),
      f = w$1(4),
      S = w$1(Po),
      p = ct(x$1(un(x$1(A$1(r), qt(1), vt(!0)), x$1(A$1(r), qt(1), vt(!1), cn(100))), Y()), !1),
      m = ct(x$1(un(x$1(n, vt(!0)), x$1(n, vt(!1), cn(200))), Y()), !1);
    F(x$1(rt(A$1(r), A$1(S)), H(_ref55 => {
      let [u, T] = _ref55;
      return u <= T;
    }), Y()), l), F(x$1(l, zt(50)), d);
    const C = pt(x$1(rt(o, A$1(s), A$1(e), A$1(t), A$1(f)), bt((u, _ref56) => {
        let [{
          scrollHeight: T,
          scrollTop: b
        }, h, a, R, k] = _ref56;
        const O = b + h - T > -k,
          z = {
            scrollHeight: T,
            scrollTop: b,
            viewportHeight: h
          };
        if (O) {
          let D, J;
          return b > u.state.scrollTop ? (D = "SCROLLED_DOWN", J = u.state.scrollTop - b) : (D = "SIZE_DECREASED", J = u.state.scrollTop - b || u.scrollTopDelta), {
            atBottom: !0,
            atBottomBecause: D,
            scrollTopDelta: J,
            state: z
          };
        }
        let P;
        return z.scrollHeight > u.state.scrollHeight ? P = "SIZE_INCREASED" : h < u.state.viewportHeight ? P = "VIEWPORT_HEIGHT_DECREASING" : b < u.state.scrollTop ? P = "SCROLLING_UPWARDS" : P = "NOT_FULLY_SCROLLED_TO_LAST_ITEM_BOTTOM", {
          atBottom: !1,
          notAtBottomBecause: P,
          state: z
        };
      }, Lo), Y((u, T) => u && u.atBottom === T.atBottom))),
      I = ct(x$1(o, bt((u, _ref57) => {
        let {
          scrollHeight: T,
          scrollTop: b,
          viewportHeight: h
        } = _ref57;
        if (Nn(u.scrollHeight, T)) return {
          changed: !1,
          jump: 0,
          scrollHeight: T,
          scrollTop: b
        };
        {
          const a = T - (b + h) < 1;
          return u.scrollTop !== b && a ? {
            changed: !0,
            jump: u.scrollTop - b,
            scrollHeight: T,
            scrollTop: b
          } : {
            changed: !0,
            jump: 0,
            scrollHeight: T,
            scrollTop: b
          };
        }
      }, {
        changed: !1,
        jump: 0,
        scrollHeight: 0,
        scrollTop: 0
      }), V(u => u.changed), H(u => u.jump)), 0);
    F(x$1(C, H(u => u.atBottom)), i), F(x$1(i, zt(50)), c);
    const y = w$1(te);
    F(x$1(o, H(_ref58 => {
      let {
        scrollTop: u
      } = _ref58;
      return u;
    }), Y(), bt((u, T) => lt(m) ? {
      direction: u.direction,
      prevScrollTop: T
    } : {
      direction: T < u.prevScrollTop ? le : te,
      prevScrollTop: T
    }, {
      direction: te,
      prevScrollTop: 0
    }), H(u => u.direction)), y), F(x$1(o, zt(50), vt(zo)), y);
    const g = w$1(0);
    return F(x$1(p, V(u => !u), vt(0)), g), F(x$1(r, zt(100), G(p), V(_ref59 => {
      let [u, T] = _ref59;
      return !!T;
    }), bt((_ref60, _ref61) => {
      let [u, T] = _ref60;
      let [b] = _ref61;
      return [T, b];
    }, [0, 0]), H(_ref62 => {
      let [u, T] = _ref62;
      return T - u;
    })), g), {
      atBottomState: C,
      atBottomStateChange: c,
      atBottomThreshold: f,
      atTopStateChange: d,
      atTopThreshold: S,
      isAtBottom: i,
      isAtTop: l,
      isScrolling: p,
      lastJumpDueToItemResize: I,
      scrollDirection: y,
      scrollVelocity: g
    };
  }, X(at)),
  xe = "top",
  Te = "bottom",
  mn = "none";
function pn(t, e, n) {
  return typeof t == "number" ? n === le && e === xe || n === te && e === Te ? t : 0 : n === le ? e === xe ? t.main : t.reverse : e === Te ? t.main : t.reverse;
}
function hn(t, e) {
  var n;
  return typeof t == "number" ? t : (n = t[e]) != null ? n : 0;
}
const Ue = U(_ref63 => {
  let [{
    deviation: t,
    fixedHeaderHeight: e,
    headerHeight: n,
    scrollTop: o,
    viewportHeight: r
  }] = _ref63;
  const s = $$k(),
    i = w$1(0),
    l = w$1(0),
    c = w$1(0),
    d = ct(x$1(rt(A$1(o), A$1(r), A$1(n), A$1(s, se), A$1(c), A$1(i), A$1(e), A$1(t), A$1(l)), H(_ref64 => {
      let [f, S, p, [m, C], I, y, g, u, T] = _ref64;
      const b = f - u,
        h = y + g,
        a = Math.max(p - b, 0);
      let R = mn;
      const k = hn(T, xe),
        O = hn(T, Te);
      return m -= u, m += p + g, C += p + g, C -= u, m > f + h - k && (R = le), C < f - a + S + O && (R = te), R !== mn ? [Math.max(b - p - pn(I, xe, R) - k, 0), b - a - g + S + pn(I, Te, R) + O] : null;
    }), V(f => f != null), Y(se)), [0, 0]);
  return {
    increaseViewportBy: l,
    // input
    listBoundary: s,
    overscan: c,
    topListHeight: i,
    // output
    visibleRange: d
  };
}, X(at), {
  singleton: !0
});
function Vo(t, e, n) {
  if (be(e)) {
    const o = Wn(t, e);
    return [{
      index: wt(e.groupOffsetTree, o)[0],
      offset: 0,
      size: 0
    }, {
      data: n == null ? void 0 : n[0],
      index: o,
      offset: 0,
      size: 0
    }];
  }
  return [{
    data: n == null ? void 0 : n[0],
    index: t,
    offset: 0,
    size: 0
  }];
}
const Be = {
  bottom: 0,
  firstItemIndex: 0,
  items: [],
  offsetBottom: 0,
  offsetTop: 0,
  top: 0,
  topItems: [],
  topListHeight: 0,
  totalCount: 0
};
function Ie(t, e, n, o, r, s) {
  const {
    lastIndex: i,
    lastOffset: l,
    lastSize: c
  } = r;
  let d = 0,
    f = 0;
  if (t.length > 0) {
    d = t[0].offset;
    const I = t[t.length - 1];
    f = I.offset + I.size;
  }
  const S = n - i,
    p = l + S * c + (S - 1) * o,
    m = d,
    C = p - f;
  return {
    bottom: f,
    firstItemIndex: s,
    items: gn(t, r, s),
    offsetBottom: C,
    offsetTop: d,
    top: m,
    topItems: gn(e, r, s),
    topListHeight: e.reduce((I, y) => y.size + I, 0),
    totalCount: n
  };
}
function Dn(t, e, n, o, r, s) {
  let i = 0;
  if (n.groupIndices.length > 0) for (const f of n.groupIndices) {
    if (f - i >= t) break;
    i++;
  }
  const l = t + i,
    c = $e(e, l),
    d = Array.from({
      length: l
    }).map((f, S) => ({
      data: s[S + c],
      index: S + c,
      offset: 0,
      size: 0
    }));
  return Ie(d, [], l, r, n, o);
}
function gn(t, e, n) {
  if (t.length === 0) return [];
  if (!be(e)) return t.map(d => ({
    ...d,
    index: d.index + n,
    originalIndex: d.index
  }));
  const o = t[0].index,
    r = t[t.length - 1].index,
    s = [],
    i = ve(e.groupOffsetTree, o, r);
  let l,
    c = 0;
  for (const d of t) {
    (!l || l.end < d.index) && (l = i.shift(), c = e.groupIndices.indexOf(l.start));
    let f;
    d.index === l.start ? f = {
      index: c,
      type: "group"
    } : f = {
      groupIndex: c,
      index: d.index - (c + 1) + n
    }, s.push({
      ...f,
      data: d.data,
      offset: d.offset,
      originalIndex: d.index,
      size: d.size
    });
  }
  return s;
}
const Nt = U(_ref65 => {
    let [{
      data: t,
      firstItemIndex: e,
      gap: n,
      sizes: o,
      totalCount: r
    }, s, {
      listBoundary: i,
      topListHeight: l,
      visibleRange: c
    }, {
      initialTopMostItemIndex: d,
      scrolledToInitialItem: f
    }, {
      topListHeight: S
    }, p, {
      didMount: m
    }, {
      recalcInProgress: C
    }] = _ref65;
    const I = w$1([]),
      y = w$1(0),
      g = $$k();
    F(s.topItemsIndexes, I);
    const u = ct(x$1(rt(m, C, A$1(c, se), A$1(r), A$1(o), A$1(d), f, A$1(I), A$1(e), A$1(n), t), V(_ref66 => {
      let [a, R,, k,,,,,,, O] = _ref66;
      const z = O && O.length !== k;
      return a && !R && !z;
    }), H(_ref67 => {
      let [,, [a, R], k, O, z, P, D, J, nt, B] = _ref67;
      const q = O,
        {
          offsetTree: st,
          sizeTree: dt
        } = q,
        St = lt(y);
      if (k === 0) return {
        ...Be,
        totalCount: k
      };
      if (a === 0 && R === 0) return St === 0 ? {
        ...Be,
        totalCount: k
      } : Dn(St, z, O, J, nt, B || []);
      if (j(dt)) return St > 0 ? null : Ie(Vo($e(z, k), q, B), [], k, nt, q, J);
      const ft = [];
      if (D.length > 0) {
        const Wt = D[0],
          yt = D[D.length - 1];
        let Bt = 0;
        for (const v of ve(dt, Wt, yt)) {
          const N = v.value,
            Q = Math.max(v.start, Wt),
            it = Math.min(v.end, yt);
          for (let tt = Q; tt <= it; tt++) ft.push({
            data: B == null ? void 0 : B[tt],
            index: tt,
            offset: Bt,
            size: N
          }), Bt += N;
        }
      }
      if (!P) return Ie([], ft, k, nt, q, J);
      const ut = D.length > 0 ? D[D.length - 1] + 1 : 0,
        At = vo(st, a, R, ut);
      if (At.length === 0) return null;
      const xt = k - 1,
        Xt = ye([], Wt => {
          for (const yt of At) {
            const Bt = yt.value;
            let v = Bt.offset,
              N = yt.start;
            const Q = Bt.size;
            if (Bt.offset < a) {
              N += Math.floor((a - Bt.offset + nt) / (Q + nt));
              const tt = N - yt.start;
              v += tt * Q + tt * nt;
            }
            N < ut && (v += (ut - N) * Q, N = ut);
            const it = Math.min(yt.end, xt);
            for (let tt = N; tt <= it && !(v >= R); tt++) Wt.push({
              data: B == null ? void 0 : B[tt],
              index: tt,
              offset: v,
              size: Q
            }), v += Q + nt;
          }
        });
      return Ie(Xt, ft, k, nt, q, J);
    }),
    //@ts-expect-error filter needs to be fixed
    V(a => a !== null), Y()), Be);
    F(x$1(t, V(Ae), H(a => a == null ? void 0 : a.length)), r), F(x$1(u, H(a => a.topListHeight)), S), F(S, l), F(x$1(u, H(a => [a.top, a.bottom])), i), F(x$1(u, H(a => a.items)), g);
    const T = pt(x$1(u, V(_ref68 => {
        let {
          items: a
        } = _ref68;
        return a.length > 0;
      }), G(r, t), V(_ref69 => {
        let [{
          items: a
        }, R] = _ref69;
        return a[a.length - 1].originalIndex === R - 1;
      }), H(_ref70 => {
        let [, a, R] = _ref70;
        return [a - 1, R];
      }), Y(se), H(_ref71 => {
        let [a] = _ref71;
        return a;
      }))),
      b = pt(x$1(u, zt(200), V(_ref72 => {
        let {
          items: a,
          topItems: R
        } = _ref72;
        return a.length > 0 && a[0].originalIndex === R.length;
      }), H(_ref73 => {
        let {
          items: a
        } = _ref73;
        return a[0].index;
      }), Y())),
      h = pt(x$1(u, V(_ref74 => {
        let {
          items: a
        } = _ref74;
        return a.length > 0;
      }), H(_ref75 => {
        let {
          items: a
        } = _ref75;
        let R = 0,
          k = a.length - 1;
        for (; a[R].type === "group" && R < k;) R++;
        for (; a[k].type === "group" && k > R;) k--;
        return {
          endIndex: a[k].index,
          startIndex: a[R].index
        };
      }), Y(Vn)));
    return {
      endReached: T,
      initialItemCount: y,
      itemsRendered: g,
      listState: u,
      rangeChanged: h,
      startReached: b,
      topItemsIndexes: I,
      ...p
    };
  }, X(Ht, _n, Ue, ue, ce, ae, Vt, Ge), {
    singleton: !0
  }),
  $n = U(_ref76 => {
    let [{
      fixedFooterHeight: t,
      fixedHeaderHeight: e,
      footerHeight: n,
      headerHeight: o
    }, {
      listState: r
    }] = _ref76;
    const s = $$k(),
      i = ct(x$1(rt(n, t, o, e, r), H(_ref77 => {
        let [l, c, d, f, S] = _ref77;
        return l + c + d + f + S.offsetBottom + S.bottom;
      })), 0);
    return F(A$1(i), s), {
      totalListHeight: i,
      totalListHeightChanged: s
    };
  }, X(at, Nt), {
    singleton: !0
  }),
  Ao = U(_ref78 => {
    let [{
      viewportHeight: t
    }, {
      totalListHeight: e
    }] = _ref78;
    const n = w$1(!1),
      o = ct(x$1(rt(n, t, e), V(_ref79 => {
        let [r] = _ref79;
        return r;
      }), H(_ref80 => {
        let [, r, s] = _ref80;
        return Math.max(0, r - s);
      }), zt(0), Y()), 0);
    return {
      alignToBottom: n,
      paddingTopAddition: o
    };
  }, X(at, $n), {
    singleton: !0
  });
function In(t) {
  return t ? t === "smooth" ? "smooth" : "auto" : !1;
}
const Wo = (t, e) => typeof t == "function" ? In(t(e)) : e && In(t),
  Mo = U(_ref81 => {
    let [{
      listRefresh: t,
      totalCount: e
    }, {
      atBottomState: n,
      isAtBottom: o
    }, {
      scrollToIndex: r
    }, {
      scrolledToInitialItem: s
    }, {
      didMount: i,
      propsReady: l
    }, {
      log: c
    }, {
      scrollingInProgress: d
    }] = _ref81;
    const f = w$1(!1),
      S = $$k();
    let p = null;
    function m(I) {
      M$1(r, {
        align: "end",
        behavior: I,
        index: "LAST"
      });
    }
    K(x$1(rt(x$1(A$1(e), qt(1)), i), G(A$1(f), o, s, d), H(_ref82 => {
      let [[I, y], g, u, T, b] = _ref82;
      let h = y && T,
        a = "auto";
      return h && (a = Wo(g, u || b), h = h && !!a), {
        followOutputBehavior: a,
        shouldFollow: h,
        totalCount: I
      };
    }), V(_ref83 => {
      let {
        shouldFollow: I
      } = _ref83;
      return I;
    })), _ref84 => {
      let {
        followOutputBehavior: I,
        totalCount: y
      } = _ref84;
      p && (p(), p = null), p = Rt(t, () => {
        lt(c)("following output to ", {
          totalCount: y
        }, ht.DEBUG), m(I), p = null;
      });
    });
    function C(I) {
      const y = Rt(n, g => {
        I && !g.atBottom && g.notAtBottomBecause === "SIZE_INCREASED" && !p && (lt(c)("scrolling to bottom due to increased size", {}, ht.DEBUG), m("auto"));
      });
      setTimeout(y, 100);
    }
    return K(x$1(rt(A$1(f), e, l), V(_ref85 => {
      let [I,, y] = _ref85;
      return I && y;
    }), bt((_ref86, _ref87) => {
      let {
        value: I
      } = _ref86;
      let [, y] = _ref87;
      return {
        refreshed: I === y,
        value: y
      };
    }, {
      refreshed: !1,
      value: 0
    }), V(_ref88 => {
      let {
        refreshed: I
      } = _ref88;
      return I;
    }), G(f, e)), _ref89 => {
      let [, I] = _ref89;
      lt(s) && C(I !== !1);
    }), K(S, () => {
      C(lt(f) !== !1);
    }), K(rt(A$1(f), n), _ref90 => {
      let [I, y] = _ref90;
      I && !y.atBottom && y.notAtBottomBecause === "VIEWPORT_HEIGHT_DECREASING" && m("auto");
    }), {
      autoscrollToBottom: S,
      followOutput: f
    };
  }, X(Ht, ae, ce, ue, Vt, Pt, at)),
  _o = U(_ref91 => {
    let [{
      data: t,
      firstItemIndex: e,
      gap: n,
      sizes: o
    }, {
      initialTopMostItemIndex: r
    }, {
      initialItemCount: s,
      listState: i
    }, {
      didMount: l
    }] = _ref91;
    return F(x$1(l, G(s), V(_ref92 => {
      let [, c] = _ref92;
      return c !== 0;
    }), G(r, o, e, n, t), H(_ref93 => {
      let [[, c], d, f, S, p, m = []] = _ref93;
      return Dn(c, d, f, S, p, m);
    })), i), {};
  }, X(Ht, ue, Nt, Vt), {
    singleton: !0
  }),
  Go = U(_ref94 => {
    let [{
      didMount: t
    }, {
      scrollTo: e
    }, {
      listState: n
    }] = _ref94;
    const o = w$1(0);
    return K(x$1(t, G(o), V(_ref95 => {
      let [, r] = _ref95;
      return r !== 0;
    }), H(_ref96 => {
      let [, r] = _ref96;
      return {
        top: r
      };
    })), r => {
      Rt(x$1(n, qt(1), V(s => s.items.length > 1)), () => {
        requestAnimationFrame(() => {
          M$1(e, r);
        });
      });
    }), {
      initialScrollTop: o
    };
  }, X(Vt, at, Nt), {
    singleton: !0
  }),
  No = _ref97 => {
    let {
      itemBottom: t,
      itemTop: e,
      locationParams: {
        align: n,
        behavior: o,
        ...r
      },
      viewportBottom: s,
      viewportTop: i
    } = _ref97;
    return e < i ? {
      ...r,
      align: n != null ? n : "start",
      behavior: o
    } : t > s ? {
      ...r,
      align: n != null ? n : "end",
      behavior: o
    } : null;
  },
  Do = U(_ref98 => {
    let [{
      gap: t,
      sizes: e,
      totalCount: n
    }, {
      fixedFooterHeight: o,
      fixedHeaderHeight: r,
      headerHeight: s,
      scrollingInProgress: i,
      scrollTop: l,
      viewportHeight: c
    }, {
      scrollToIndex: d
    }] = _ref98;
    const f = $$k();
    return F(x$1(f, G(e, c, n, s, r, o, l), G(t), H(_ref99 => {
      let [[S, p, m, C, I, y, g, u], T] = _ref99;
      const {
          align: b,
          behavior: h,
          calculateViewLocation: a = No,
          done: R,
          ...k
        } = S,
        O = Mn(S, p, C - 1),
        z = ie(O, p.offsetTree, T) + I + y,
        P = z + wt(p.sizeTree, O)[1],
        D = u + y,
        J = u + m - g,
        nt = a({
          itemBottom: P,
          itemTop: z,
          locationParams: {
            align: b,
            behavior: h,
            ...k
          },
          viewportBottom: J,
          viewportTop: D
        });
      return nt ? R && Rt(x$1(i, V(B => !B),
      // skips the initial publish of false, and the cleanup call.
      // but if scrollingInProgress is true, we skip the initial publish.
      qt(lt(i) ? 1 : 2)), R) : R && R(), nt;
    }), V(S => S !== null)), d), {
      scrollIntoView: f
    };
  }, X(Ht, at, ce, Nt, Pt), {
    singleton: !0
  }),
  Un = U(_ref100 => {
    let [{
      scrollVelocity: t
    }] = _ref100;
    const e = w$1(!1),
      n = $$k(),
      o = w$1(!1);
    return F(x$1(t, G(o, e, n), V(_ref101 => {
      let [r, s] = _ref101;
      return !!s;
    }), H(_ref102 => {
      let [r, s, i, l] = _ref102;
      const {
        enter: c,
        exit: d
      } = s;
      if (i) {
        if (d(r, l)) return !1;
      } else if (c(r, l)) return !0;
      return i;
    }), Y()), e), K(x$1(rt(e, t, n), G(o)), _ref103 => {
      let [[r, s, i], l] = _ref103;
      r && l && l.change && l.change(s, i);
    }), {
      isSeeking: e,
      scrollSeekConfiguration: o,
      scrollSeekRangeChanged: n,
      scrollVelocity: t
    };
  }, X(ae), {
    singleton: !0
  }),
  Ke = U(_ref104 => {
    let [{
      scrollContainerState: t,
      scrollTo: e
    }] = _ref104;
    const n = $$k(),
      o = $$k(),
      r = $$k(),
      s = w$1(!1),
      i = w$1(void 0);
    return F(x$1(rt(n, o), H(_ref105 => {
      let [{
        scrollHeight: l,
        scrollTop: c,
        viewportHeight: d
      }, {
        offsetTop: f
      }] = _ref105;
      return {
        scrollHeight: l,
        scrollTop: Math.max(0, c - f),
        viewportHeight: d
      };
    })), t), F(x$1(e, G(o), H(_ref106 => {
      let [l, {
        offsetTop: c
      }] = _ref106;
      return {
        ...l,
        top: l.top + c
      };
    })), r), {
      customScrollParent: i,
      // config
      useWindowScroll: s,
      // input
      windowScrollContainerState: n,
      // signals
      windowScrollTo: r,
      windowViewportRect: o
    };
  }, X(at)),
  $o = U(_ref107 => {
    let [{
      sizeRanges: t,
      sizes: e
    }, {
      headerHeight: n,
      scrollTop: o
    }, {
      initialTopMostItemIndex: r
    }, {
      didMount: s
    }, {
      useWindowScroll: i,
      windowScrollContainerState: l,
      windowViewportRect: c
    }] = _ref107;
    const d = $$k(),
      f = w$1(void 0),
      S = w$1(null),
      p = w$1(null);
    return F(l, S), F(c, p), K(x$1(d, G(e, o, i, S, p, n)), _ref108 => {
      let [m, C, I, y, g, u, T] = _ref108;
      const b = Ro(C.sizeTree);
      y && g !== null && u !== null && (I = g.scrollTop - u.offsetTop), I -= T, m({
        ranges: b,
        scrollTop: I
      });
    }), F(x$1(f, V(Ae), H(Uo)), r), F(x$1(s, G(f), V(_ref109 => {
      let [, m] = _ref109;
      return m !== void 0;
    }), Y(), H(_ref110 => {
      let [, m] = _ref110;
      return m.ranges;
    })), t), {
      getState: d,
      restoreStateFrom: f
    };
  }, X(Ht, at, ue, Vt, Ke));
function Uo(t) {
  return {
    align: "start",
    index: 0,
    offset: t.scrollTop
  };
}
const Ko = U(_ref111 => {
  let [{
    topItemsIndexes: t
  }] = _ref111;
  const e = w$1(0);
  return F(x$1(e, V(n => n >= 0), H(n => Array.from({
    length: n
  }).map((o, r) => r))), t), {
    topItemCount: e
  };
}, X(Nt));
function Kn(t) {
  let e = !1,
    n;
  return () => (e || (e = !0, n = t()), n);
}
const jo = Kn(() => /iP(ad|od|hone)/i.test(navigator.userAgent) && /WebKit/i.test(navigator.userAgent)),
  qo = U(_ref112 => {
    let [{
      deviation: t,
      scrollBy: e,
      scrollingInProgress: n,
      scrollTop: o
    }, {
      isAtBottom: r,
      isScrolling: s,
      lastJumpDueToItemResize: i,
      scrollDirection: l
    }, {
      listState: c
    }, {
      beforeUnshiftWith: d,
      gap: f,
      shiftWithOffset: S,
      sizes: p
    }, {
      log: m
    }, {
      recalcInProgress: C
    }] = _ref112;
    const I = pt(x$1(c, G(i), bt((_ref113, _ref114) => {
      let [, g, u, T] = _ref113;
      let [{
        bottom: b,
        items: h,
        offsetBottom: a,
        totalCount: R
      }, k] = _ref114;
      const O = b + a;
      let z = 0;
      return u === R && g.length > 0 && h.length > 0 && (h[0].originalIndex === 0 && g[0].originalIndex === 0 || (z = O - T, z !== 0 && (z += k))), [z, h, R, O];
    }, [0, [], 0, 0]), V(_ref115 => {
      let [g] = _ref115;
      return g !== 0;
    }), G(o, l, n, r, m, C), V(_ref116 => {
      let [, g, u, T,,, b] = _ref116;
      return !b && !T && g !== 0 && u === le;
    }), H(_ref117 => {
      let [[g],,,,, u] = _ref117;
      return u("Upward scrolling compensation", {
        amount: g
      }, ht.DEBUG), g;
    })));
    function y(g) {
      g > 0 ? (M$1(e, {
        behavior: "auto",
        top: -g
      }), M$1(t, 0)) : (M$1(t, 0), M$1(e, {
        behavior: "auto",
        top: -g
      }));
    }
    return K(x$1(I, G(t, s)), _ref118 => {
      let [g, u, T] = _ref118;
      T && jo() ? M$1(t, u - g) : y(-g);
    }), K(x$1(rt(ct(s, !1), t, C), V(_ref119 => {
      let [g, u, T] = _ref119;
      return !g && !T && u !== 0;
    }), H(_ref120 => {
      let [g, u] = _ref120;
      return u;
    }), zt(1)), y), F(x$1(S, H(g => ({
      top: -g
    }))), e), K(x$1(d, G(p, f), H(_ref121 => {
      let [g, {
        groupIndices: u,
        lastSize: T,
        sizeTree: b
      }, h] = _ref121;
      function a(R) {
        return R * (T + h);
      }
      if (u.length === 0) return a(g);
      {
        let R = 0;
        const k = re(b, 0);
        let O = 0,
          z = 0;
        for (; O < g;) {
          O++, R += k;
          let P = u.length === z + 1 ? 1 / 0 : u[z + 1] - u[z] - 1;
          O + P > g && (R -= k, P = g - O + 1), O += P, R += a(P), z++;
        }
        return R;
      }
    })), g => {
      M$1(t, g), requestAnimationFrame(() => {
        M$1(e, {
          top: g
        }), requestAnimationFrame(() => {
          M$1(t, 0), M$1(C, !1);
        });
      });
    }), {
      deviation: t
    };
  }, X(at, ae, Nt, Ht, Pt, Ge)),
  Yo = U(_ref122 => {
    let [t, e, n, o, r, s, i, l, c, d] = _ref122;
    return {
      ...t,
      ...e,
      ...n,
      ...o,
      ...r,
      ...s,
      ...i,
      ...l,
      ...c,
      ...d
    };
  }, X(Ue, _o, Vt, Un, $n, Go, Ao, Ke, Do, Pt)),
  jn = U(_ref123 => {
    let [{
      data: t,
      defaultItemSize: e,
      firstItemIndex: n,
      fixedItemSize: o,
      gap: r,
      groupIndices: s,
      itemSize: i,
      sizeRanges: l,
      sizes: c,
      statefulTotalCount: d,
      totalCount: f,
      trackItemSizes: S
    }, {
      initialItemFinalLocationReached: p,
      initialTopMostItemIndex: m,
      scrolledToInitialItem: C
    }, I, y, g, {
      listState: u,
      topItemsIndexes: T,
      ...b
    }, {
      scrollToIndex: h
    }, a, {
      topItemCount: R
    }, {
      groupCounts: k
    }, O] = _ref123;
    return F(b.rangeChanged, O.scrollSeekRangeChanged), F(x$1(O.windowViewportRect, H(z => z.visibleHeight)), I.viewportHeight), {
      data: t,
      defaultItemHeight: e,
      firstItemIndex: n,
      fixedItemHeight: o,
      gap: r,
      groupCounts: k,
      initialItemFinalLocationReached: p,
      initialTopMostItemIndex: m,
      scrolledToInitialItem: C,
      sizeRanges: l,
      topItemCount: R,
      topItemsIndexes: T,
      // input
      totalCount: f,
      ...g,
      groupIndices: s,
      itemSize: i,
      listState: u,
      scrollToIndex: h,
      // output
      statefulTotalCount: d,
      trackItemSizes: S,
      // exported from stateFlagsSystem
      ...b,
      // the bag of IO from featureGroup1System
      ...O,
      ...I,
      sizes: c,
      ...y
    };
  }, X(Ht, ue, at, $o, Mo, Nt, ce, qo, Ko, _n, Yo));
function Zo(t, e) {
  const n = {},
    o = {};
  let r = 0;
  const s = t.length;
  for (; r < s;) o[t[r]] = 1, r += 1;
  for (const i in e) Object.hasOwn(o, i) || (n[i] = e[i]);
  return n;
}
const pe = typeof document < "u" ? React__default.useLayoutEffect : React__default.useEffect;
function je(t, e, n) {
  const o = Object.keys(e.required || {}),
    r = Object.keys(e.optional || {}),
    s = Object.keys(e.methods || {}),
    i = Object.keys(e.events || {}),
    l = React__default.createContext({});
  function c(g, u) {
    g.propsReady && M$1(g.propsReady, !1);
    for (const T of o) {
      const b = g[e.required[T]];
      M$1(b, u[T]);
    }
    for (const T of r) if (T in u) {
      const b = g[e.optional[T]];
      M$1(b, u[T]);
    }
    g.propsReady && M$1(g.propsReady, !0);
  }
  function d(g) {
    return s.reduce((u, T) => (u[T] = b => {
      const h = g[e.methods[T]];
      M$1(h, b);
    }, u), {});
  }
  function f(g) {
    return i.reduce((u, T) => (u[T] = fo(g[e.events[T]]), u), {});
  }
  const S = React__default.forwardRef((g, u) => {
      const {
          children: T,
          ...b
        } = g,
        [h] = React__default.useState(() => ye(po(t), k => {
          c(k, b);
        })),
        [a] = React__default.useState(ln(f, h));
      pe(() => {
        for (const k of i) k in b && K(a[k], b[k]);
        return () => {
          Object.values(a).map(We);
        };
      }, [b, a, h]), pe(() => {
        c(h, b);
      }), React__default.useImperativeHandle(u, sn(d(h)));
      const R = n;
      return /* @__PURE__ */jsx(l.Provider, {
        value: h,
        children: n ? /* @__PURE__ */jsx(R, {
          ...Zo([...o, ...r, ...i], b),
          children: T
        }) : T
      });
    }),
    p = g => React__default.useCallback(Hn(M$1, React__default.useContext(l)[g]), [g]),
    m = g => {
      const T = React__default.useContext(l)[g],
        b = React__default.useCallback(h => K(T, h), [T]);
      return React__default.useSyncExternalStore(b, () => lt(T), () => lt(T));
    },
    C = g => {
      const T = React__default.useContext(l)[g],
        [b, h] = React__default.useState(ln(lt, T));
      return pe(() => K(T, a => {
        a !== b && h(sn(a));
      }), [T, b]), b;
    },
    I = React__default.version.startsWith("18") ? m : C;
  return {
    Component: S,
    useEmitter: (g, u) => {
      const b = React__default.useContext(l)[g];
      pe(() => K(b, u), [u, b]);
    },
    useEmitterValue: I,
    usePublisher: p
  };
}
const Re = React__default.createContext(void 0),
  qn = React__default.createContext(void 0),
  Yn = typeof document < "u" ? React__default.useLayoutEffect : React__default.useEffect;
function Zn(t, e, n) {
  let o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Gt;
  let r = arguments.length > 4 ? arguments[4] : undefined;
  let s = arguments.length > 5 ? arguments[5] : undefined;
  const i = React__default.useRef(null),
    l = React__default.useRef(null),
    c = React__default.useRef(null),
    d = React__default.useCallback(p => {
      const m = p.target,
        C = m === window || m === document,
        I = s ? C ? window.pageXOffset || document.documentElement.scrollLeft : m.scrollLeft : C ? window.pageYOffset || document.documentElement.scrollTop : m.scrollTop,
        y = s ? C ? document.documentElement.scrollWidth : m.scrollWidth : C ? document.documentElement.scrollHeight : m.scrollHeight,
        g = s ? C ? window.innerWidth : m.offsetWidth : C ? window.innerHeight : m.offsetHeight,
        u = () => {
          t({
            scrollHeight: y,
            scrollTop: Math.max(I, 0),
            viewportHeight: g
          });
        };
      p.suppressFlushSync ? u() : io.flushSync(u), l.current !== null && (I === l.current || I <= 0 || I === y - g) && (l.current = null, e(!0), c.current && (clearTimeout(c.current), c.current = null));
    }, [t, e]);
  React__default.useEffect(() => {
    const p = r || i.current;
    return o(r || i.current), d({
      suppressFlushSync: !0,
      target: p
    }), p.addEventListener("scroll", d, {
      passive: !0
    }), () => {
      o(null), p.removeEventListener("scroll", d);
    };
  }, [i, d, n, o, r]);
  function f(p) {
    const m = i.current;
    if (!m || (s ? "offsetWidth" in m && m.offsetWidth === 0 : "offsetHeight" in m && m.offsetHeight === 0)) return;
    const C = p.behavior === "smooth";
    let I, y, g;
    m === window ? (y = Math.max(Ct(document.documentElement, s ? "width" : "height"), s ? document.documentElement.scrollWidth : document.documentElement.scrollHeight), I = s ? window.innerWidth : window.innerHeight, g = s ? document.documentElement.scrollLeft : document.documentElement.scrollTop) : (y = m[s ? "scrollWidth" : "scrollHeight"], I = Ct(m, s ? "width" : "height"), g = m[s ? "scrollLeft" : "scrollTop"]);
    const u = y - I;
    if (p.top = Math.ceil(Math.max(Math.min(u, p.top), 0)), Nn(I, y) || p.top === g) {
      t({
        scrollHeight: y,
        scrollTop: g,
        viewportHeight: I
      }), C && e(!0);
      return;
    }
    C ? (l.current = p.top, c.current && clearTimeout(c.current), c.current = setTimeout(() => {
      c.current = null, l.current = null, e(!0);
    }, 1e3)) : l.current = null, s && (p = {
      behavior: p.behavior,
      left: p.top
    }), m.scrollTo(p);
  }
  function S(p) {
    s && (p = {
      behavior: p.behavior,
      left: p.top
    }), i.current.scrollBy(p);
  }
  return {
    scrollByCallback: S,
    scrollerRef: i,
    scrollToCallback: f
  };
}
const ke = "-webkit-sticky",
  Sn = "sticky",
  Xn = Kn(() => {
    if (typeof document > "u") return Sn;
    const t = document.createElement("div");
    return t.style.position = ke, t.style.position === ke ? ke : Sn;
  });
function qe(t) {
  return t;
}
const Xo = /* @__PURE__ */U(() => {
    const t = w$1(c => "Item ".concat(c)),
      e = w$1(null),
      n = w$1(c => "Group ".concat(c)),
      o = w$1({}),
      r = w$1(qe),
      s = w$1("div"),
      i = w$1(Gt),
      l = function (c) {
        let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return ct(x$1(o, H(f => f[c]), Y()), d);
      };
    return {
      components: o,
      computeItemKey: r,
      context: e,
      EmptyPlaceholder: l("EmptyPlaceholder"),
      FooterComponent: l("Footer"),
      GroupComponent: l("Group", "div"),
      groupContent: n,
      HeaderComponent: l("Header"),
      HeaderFooterTag: s,
      ItemComponent: l("Item", "div"),
      itemContent: t,
      ListComponent: l("List", "div"),
      ScrollerComponent: l("Scroller", "div"),
      scrollerRef: i,
      ScrollSeekPlaceholder: l("ScrollSeekPlaceholder"),
      TopItemListComponent: l("TopItemList")
    };
  }),
  Jo = /* @__PURE__ */U(_ref124 => {
    let [t, e] = _ref124;
    return {
      ...t,
      ...e
    };
  }, X(jn, Xo)),
  Qo = _ref125 => {
    let {
      height: t
    } = _ref125;
    return /* @__PURE__ */jsx("div", {
      style: {
        height: t
      }
    });
  },
  tr = {
    overflowAnchor: "none",
    position: Xn(),
    zIndex: 1
  },
  Jn = {
    overflowAnchor: "none"
  },
  er = {
    ...Jn,
    display: "inline-block",
    height: "100%"
  },
  xn = /* @__PURE__ */React__default.memo(function (_ref126) {
    let {
      showTopList: e = !1
    } = _ref126;
    const n = W("listState"),
      o = gt("sizeRanges"),
      r = W("useWindowScroll"),
      s = W("customScrollParent"),
      i = gt("windowScrollContainerState"),
      l = gt("scrollContainerState"),
      c = s || r ? i : l,
      d = W("itemContent"),
      f = W("context"),
      S = W("groupContent"),
      p = W("trackItemSizes"),
      m = W("itemSize"),
      C = W("log"),
      I = gt("gap"),
      y = W("horizontalDirection"),
      {
        callbackRef: g
      } = kn(o, m, p, e ? Gt : c, C, I, s, y, W("skipAnimationFrameInResizeObserver")),
      [u, T] = React__default.useState(0);
    Xe("deviation", B => {
      u !== B && T(B);
    });
    const b = W("EmptyPlaceholder"),
      h = W("ScrollSeekPlaceholder") || Qo,
      a = W("ListComponent"),
      R = W("ItemComponent"),
      k = W("GroupComponent"),
      O = W("computeItemKey"),
      z = W("isSeeking"),
      P = W("groupIndices").length > 0,
      D = W("alignToBottom"),
      J = W("initialItemFinalLocationReached"),
      nt = e ? {} : {
        boxSizing: "border-box",
        ...(y ? {
          display: "inline-block",
          height: "100%",
          marginLeft: u !== 0 ? u : D ? "auto" : 0,
          paddingLeft: n.offsetTop,
          paddingRight: n.offsetBottom,
          whiteSpace: "nowrap"
        } : {
          marginTop: u !== 0 ? u : D ? "auto" : 0,
          paddingBottom: n.offsetBottom,
          paddingTop: n.offsetTop
        }),
        ...(J ? {} : {
          visibility: "hidden"
        })
      };
    return !e && n.totalCount === 0 && b ? /* @__PURE__ */jsx(b, {
      ...Z(b, f)
    }) : /* @__PURE__ */jsx(a, {
      ...Z(a, f),
      "data-testid": e ? "virtuoso-top-item-list" : "virtuoso-item-list",
      ref: g,
      style: nt,
      children: (e ? n.topItems : n.items).map(B => {
        const q = B.originalIndex,
          st = O(q + n.firstItemIndex, B.data, f);
        return z ? /* @__PURE__ */createElement$2(h, {
          ...Z(h, f),
          height: B.size,
          index: B.index,
          key: st,
          type: B.type || "item",
          ...(B.type === "group" ? {} : {
            groupIndex: B.groupIndex
          })
        }) : B.type === "group" ? /* @__PURE__ */createElement$2(k, {
          ...Z(k, f),
          "data-index": q,
          "data-item-index": B.index,
          "data-known-size": B.size,
          key: st,
          style: tr
        }, S(B.index, f)) : /* @__PURE__ */createElement$2(R, {
          ...Z(R, f),
          ...Qn(R, B.data),
          "data-index": q,
          "data-item-group-index": B.groupIndex,
          "data-item-index": B.index,
          "data-known-size": B.size,
          key: st,
          style: y ? er : Jn
        }, P ? d(B.index, B.groupIndex, B.data, f) : d(B.index, B.data, f));
      })
    });
  }),
  nr = {
    height: "100%",
    outline: "none",
    overflowY: "auto",
    position: "relative",
    WebkitOverflowScrolling: "touch"
  },
  or = {
    outline: "none",
    overflowX: "auto",
    position: "relative"
  },
  Zt = t => ({
    height: "100%",
    position: "absolute",
    top: 0,
    width: "100%",
    ...(t ? {
      display: "flex",
      flexDirection: "column"
    } : {})
  }),
  rr = {
    position: Xn(),
    top: 0,
    width: "100%",
    zIndex: 1
  };
function Z(t, e) {
  if (typeof t != "string") return {
    context: e
  };
}
function Qn(t, e) {
  return {
    item: typeof t == "string" ? void 0 : e
  };
}
const sr = /* @__PURE__ */React__default.memo(function () {
    const e = W("HeaderComponent"),
      n = gt("headerHeight"),
      o = W("HeaderFooterTag"),
      r = Et(React__default.useMemo(() => i => {
        n(Ct(i, "height"));
      }, [n]), !0, W("skipAnimationFrameInResizeObserver")),
      s = W("context");
    return e ? /* @__PURE__ */jsx(o, {
      ref: r,
      children: /* @__PURE__ */jsx(e, {
        ...Z(e, s)
      })
    }) : null;
  }),
  ir = /* @__PURE__ */React__default.memo(function () {
    const e = W("FooterComponent"),
      n = gt("footerHeight"),
      o = W("HeaderFooterTag"),
      r = Et(React__default.useMemo(() => i => {
        n(Ct(i, "height"));
      }, [n]), !0, W("skipAnimationFrameInResizeObserver")),
      s = W("context");
    return e ? /* @__PURE__ */jsx(o, {
      ref: r,
      children: /* @__PURE__ */jsx(e, {
        ...Z(e, s)
      })
    }) : null;
  });
function Ye(_ref127) {
  let {
    useEmitter: t,
    useEmitterValue: e,
    usePublisher: n
  } = _ref127;
  return React__default.memo(function (_ref128) {
    let {
      children: s,
      style: i,
      ...l
    } = _ref128;
    const c = n("scrollContainerState"),
      d = e("ScrollerComponent"),
      f = n("smoothScrollTargetReached"),
      S = e("scrollerRef"),
      p = e("context"),
      m = e("horizontalDirection") || !1,
      {
        scrollByCallback: C,
        scrollerRef: I,
        scrollToCallback: y
      } = Zn(c, f, d, S, void 0, m);
    return t("scrollTo", y), t("scrollBy", C), /* @__PURE__ */jsx(d, {
      "data-testid": "virtuoso-scroller",
      "data-virtuoso-scroller": !0,
      ref: I,
      style: {
        ...(m ? or : nr),
        ...i
      },
      tabIndex: 0,
      ...l,
      ...Z(d, p),
      children: s
    });
  });
}
function Ze(_ref129) {
  let {
    useEmitter: t,
    useEmitterValue: e,
    usePublisher: n
  } = _ref129;
  return React__default.memo(function (_ref130) {
    let {
      children: s,
      style: i,
      ...l
    } = _ref130;
    const c = n("windowScrollContainerState"),
      d = e("ScrollerComponent"),
      f = n("smoothScrollTargetReached"),
      S = e("totalListHeight"),
      p = e("deviation"),
      m = e("customScrollParent"),
      C = e("context"),
      {
        scrollByCallback: I,
        scrollerRef: y,
        scrollToCallback: g
      } = Zn(c, f, d, Gt, m);
    return Yn(() => (y.current = m || window, () => {
      y.current = null;
    }), [y, m]), t("windowScrollTo", g), t("scrollBy", I), /* @__PURE__ */jsx(d, {
      "data-virtuoso-scroller": !0,
      style: {
        position: "relative",
        ...i,
        ...(S !== 0 ? {
          height: S + p
        } : {})
      },
      ...l,
      ...Z(d, C),
      children: s
    });
  });
}
const lr = _ref131 => {
    let {
      children: t
    } = _ref131;
    const e = React__default.useContext(Re),
      n = gt("viewportHeight"),
      o = gt("fixedItemHeight"),
      r = W("alignToBottom"),
      s = W("horizontalDirection"),
      i = React__default.useMemo(() => ne(n, c => Ct(c, s ? "width" : "height")), [n, s]),
      l = Et(i, !0, W("skipAnimationFrameInResizeObserver"));
    return React__default.useEffect(() => {
      e && (n(e.viewportHeight), o(e.itemHeight));
    }, [e, n, o]), /* @__PURE__ */jsx("div", {
      "data-viewport-type": "element",
      ref: l,
      style: Zt(r),
      children: t
    });
  },
  cr = _ref132 => {
    let {
      children: t
    } = _ref132;
    const e = React__default.useContext(Re),
      n = gt("windowViewportRect"),
      o = gt("fixedItemHeight"),
      r = W("customScrollParent"),
      s = _e(n, r, W("skipAnimationFrameInResizeObserver")),
      i = W("alignToBottom");
    return React__default.useEffect(() => {
      e && (o(e.itemHeight), n({
        offsetTop: 0,
        visibleHeight: e.viewportHeight,
        visibleWidth: 100
      }));
    }, [e, n, o]), /* @__PURE__ */jsx("div", {
      "data-viewport-type": "window",
      ref: s,
      style: Zt(i),
      children: t
    });
  },
  ur = _ref133 => {
    let {
      children: t
    } = _ref133;
    const e = W("TopItemListComponent") || "div",
      n = W("headerHeight"),
      o = {
        ...rr,
        marginTop: "".concat(n, "px")
      },
      r = W("context");
    return /* @__PURE__ */jsx(e, {
      style: o,
      ...Z(e, r),
      children: t
    });
  },
  ar = /* @__PURE__ */React__default.memo(function (e) {
    const n = W("useWindowScroll"),
      o = W("topItemsIndexes").length > 0,
      r = W("customScrollParent"),
      s = W("context"),
      i = r || n ? fr : dr,
      l = r || n ? cr : lr;
    return /* @__PURE__ */jsxs(i, {
      ...e,
      ...Z(i, s),
      children: [o && /* @__PURE__ */jsx(ur, {
        children: /* @__PURE__ */jsx(xn, {
          showTopList: !0
        })
      }), /* @__PURE__ */jsxs(l, {
        children: [/* @__PURE__ */jsx(sr, {}), /* @__PURE__ */jsx(xn, {}), /* @__PURE__ */jsx(ir, {})]
      })]
    });
  }),
  {
    Component: to,
    useEmitter: Xe,
    useEmitterValue: W,
    usePublisher: gt
  } = /* @__PURE__ */je(Jo, {
    events: {
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      endReached: "endReached",
      groupIndices: "groupIndices",
      isScrolling: "isScrolling",
      itemsRendered: "itemsRendered",
      rangeChanged: "rangeChanged",
      startReached: "startReached",
      totalListHeightChanged: "totalListHeightChanged"
    },
    methods: {
      autoscrollToBottom: "autoscrollToBottom",
      getState: "getState",
      scrollBy: "scrollBy",
      scrollIntoView: "scrollIntoView",
      scrollTo: "scrollTo",
      scrollToIndex: "scrollToIndex"
    },
    optional: {
      alignToBottom: "alignToBottom",
      atBottomThreshold: "atBottomThreshold",
      atTopThreshold: "atTopThreshold",
      components: "components",
      computeItemKey: "computeItemKey",
      context: "context",
      customScrollParent: "customScrollParent",
      data: "data",
      defaultItemHeight: "defaultItemHeight",
      firstItemIndex: "firstItemIndex",
      fixedItemHeight: "fixedItemHeight",
      followOutput: "followOutput",
      groupContent: "groupContent",
      groupCounts: "groupCounts",
      headerFooterTag: "HeaderFooterTag",
      horizontalDirection: "horizontalDirection",
      increaseViewportBy: "increaseViewportBy",
      initialItemCount: "initialItemCount",
      initialScrollTop: "initialScrollTop",
      initialTopMostItemIndex: "initialTopMostItemIndex",
      itemContent: "itemContent",
      itemSize: "itemSize",
      logLevel: "logLevel",
      overscan: "overscan",
      restoreStateFrom: "restoreStateFrom",
      scrollerRef: "scrollerRef",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      skipAnimationFrameInResizeObserver: "skipAnimationFrameInResizeObserver",
      topItemCount: "topItemCount",
      totalCount: "totalCount",
      useWindowScroll: "useWindowScroll"
    },
    required: {}
  }, ar),
  dr = /* @__PURE__ */Ye({
    useEmitter: Xe,
    useEmitterValue: W,
    usePublisher: gt
  }),
  fr = /* @__PURE__ */Ze({
    useEmitter: Xe,
    useEmitterValue: W,
    usePublisher: gt
  }),
  $r = to,
  wn = {
    bottom: 0,
    itemHeight: 0,
    items: [],
    itemWidth: 0,
    offsetBottom: 0,
    offsetTop: 0,
    top: 0
  },
  br = {
    bottom: 0,
    itemHeight: 0,
    items: [{
      index: 0
    }],
    itemWidth: 0,
    offsetBottom: 0,
    offsetTop: 0,
    top: 0
  },
  {
    ceil: Cn,
    floor: we,
    max: ee,
    min: Oe,
    round: yn
  } = Math;
function vn(t, e, n) {
  return Array.from({
    length: e - t + 1
  }).map((o, r) => ({
    data: n === null ? null : n[r + t],
    index: r + t
  }));
}
function Rr(t) {
  return {
    ...br,
    items: t
  };
}
function he(t, e) {
  return t && t.width === e.width && t.height === e.height;
}
function Er(t, e) {
  return t && t.column === e.column && t.row === e.row;
}
const Hr = /* @__PURE__ */U(_ref134 => {
  let [{
    increaseViewportBy: t,
    listBoundary: e,
    overscan: n,
    visibleRange: o
  }, {
    footerHeight: r,
    headerHeight: s,
    scrollBy: i,
    scrollContainerState: l,
    scrollTo: c,
    scrollTop: d,
    smoothScrollTargetReached: f,
    viewportHeight: S
  }, p, m, {
    didMount: C,
    propsReady: I
  }, {
    customScrollParent: y,
    useWindowScroll: g,
    windowScrollContainerState: u,
    windowScrollTo: T,
    windowViewportRect: b
  }, h] = _ref134;
  const a = w$1(0),
    R = w$1(0),
    k = w$1(wn),
    O = w$1({
      height: 0,
      width: 0
    }),
    z = w$1({
      height: 0,
      width: 0
    }),
    P = $$k(),
    D = $$k(),
    J = w$1(0),
    nt = w$1(null),
    B = w$1({
      column: 0,
      row: 0
    }),
    q = $$k(),
    st = $$k(),
    dt = w$1(!1),
    St = w$1(0),
    ft = w$1(!0),
    ut = w$1(!1),
    At = w$1(!1);
  K(x$1(C, G(St), V(_ref135 => {
    let [v, N] = _ref135;
    return !!N;
  })), () => {
    M$1(ft, !1);
  }), K(x$1(rt(C, ft, z, O, St, ut), V(_ref136 => {
    let [v, N, Q, it,, tt] = _ref136;
    return v && !N && Q.height !== 0 && it.height !== 0 && !tt;
  })), _ref137 => {
    let [,,,, v] = _ref137;
    M$1(ut, !0), De(1, () => {
      M$1(P, v);
    }), Rt(x$1(d), () => {
      M$1(e, [0, 0]), M$1(ft, !0);
    });
  }), F(x$1(st, V(v => v != null && v.scrollTop > 0), vt(0)), R), K(x$1(C, G(st), V(_ref138 => {
    let [, v] = _ref138;
    return v != null;
  })), _ref139 => {
    let [, v] = _ref139;
    v && (M$1(O, v.viewport), M$1(z, v.item), M$1(B, v.gap), v.scrollTop > 0 && (M$1(dt, !0), Rt(x$1(d, qt(1)), N => {
      M$1(dt, !1);
    }), M$1(c, {
      top: v.scrollTop
    })));
  }), F(x$1(O, H(_ref140 => {
    let {
      height: v
    } = _ref140;
    return v;
  })), S), F(x$1(rt(A$1(O, he), A$1(z, he), A$1(B, (v, N) => v && v.column === N.column && v.row === N.row), A$1(d)), H(_ref141 => {
    let [v, N, Q, it] = _ref141;
    return {
      gap: Q,
      item: N,
      scrollTop: it,
      viewport: v
    };
  })), q), F(x$1(rt(A$1(a), o, A$1(B, Er), A$1(z, he), A$1(O, he), A$1(nt), A$1(R), A$1(dt), A$1(ft), A$1(St)), V(_ref142 => {
    let [,,,,,,, v] = _ref142;
    return !v;
  }), H(_ref143 => {
    let [v, [N, Q], it, tt, kt, Jt, Dt,, de, Ot] = _ref143;
    const {
        column: Ft,
        row: Qt
      } = it,
      {
        height: fe,
        width: Ee
      } = tt,
      {
        width: Qe
      } = kt;
    if (Dt === 0 && (v === 0 || Qe === 0)) return wn;
    if (Ee === 0) {
      const rn = $e(Ot, v),
        ro = rn + Math.max(Dt - 1, 0);
      return Rr(vn(rn, ro, Jt));
    }
    const me = eo(Qe, Ee, Ft);
    let $t, Mt;
    de ? N === 0 && Q === 0 && Dt > 0 ? ($t = 0, Mt = Dt - 1) : ($t = me * we((N + Qt) / (fe + Qt)), Mt = me * Cn((Q + Qt) / (fe + Qt)) - 1, Mt = Oe(v - 1, ee(Mt, me - 1)), $t = Oe(Mt, ee(0, $t))) : ($t = 0, Mt = -1);
    const tn = vn($t, Mt, Jt),
      {
        bottom: en,
        top: nn
      } = bn(kt, it, tt, tn),
      on = Cn(v / me),
      oo = on * fe + (on - 1) * Qt - en;
    return {
      bottom: en,
      itemHeight: fe,
      items: tn,
      itemWidth: Ee,
      offsetBottom: oo,
      offsetTop: nn,
      top: nn
    };
  })), k), F(x$1(nt, V(v => v !== null), H(v => v.length)), a), F(x$1(rt(O, z, k, B), V(_ref144 => {
    let [v, N, {
      items: Q
    }] = _ref144;
    return Q.length > 0 && N.height !== 0 && v.height !== 0;
  }), H(_ref145 => {
    let [v, N, {
      items: Q
    }, it] = _ref145;
    const {
      bottom: tt,
      top: kt
    } = bn(v, it, N, Q);
    return [kt, tt];
  }), Y(se)), e);
  const xt = w$1(!1);
  F(x$1(d, G(xt), H(_ref146 => {
    let [v, N] = _ref146;
    return N || v !== 0;
  })), xt);
  const Xt = pt(x$1(rt(k, a), V(_ref147 => {
      let [{
        items: v
      }] = _ref147;
      return v.length > 0;
    }), G(xt), V(_ref148 => {
      let [[v, N], Q] = _ref148;
      const tt = v.items[v.items.length - 1].index === N - 1;
      return (Q || v.bottom > 0 && v.itemHeight > 0 && v.offsetBottom === 0 && v.items.length === N) && tt;
    }), H(_ref149 => {
      let [[, v]] = _ref149;
      return v - 1;
    }), Y())),
    Wt = pt(x$1(A$1(k), V(_ref150 => {
      let {
        items: v
      } = _ref150;
      return v.length > 0 && v[0].index === 0;
    }), vt(0), Y())),
    yt = pt(x$1(A$1(k), G(dt), V(_ref151 => {
      let [{
        items: v
      }, N] = _ref151;
      return v.length > 0 && !N;
    }), H(_ref152 => {
      let [{
        items: v
      }] = _ref152;
      return {
        endIndex: v[v.length - 1].index,
        startIndex: v[0].index
      };
    }), Y(Vn), zt(0)));
  F(yt, m.scrollSeekRangeChanged), F(x$1(P, G(O, z, a, B), H(_ref153 => {
    let [v, N, Q, it, tt] = _ref153;
    const kt = Gn(v),
      {
        align: Jt,
        behavior: Dt,
        offset: de
      } = kt;
    let Ot = kt.index;
    Ot === "LAST" && (Ot = it - 1), Ot = ee(0, Ot, Oe(it - 1, Ot));
    let Ft = Ve(N, tt, Q, Ot);
    return Jt === "end" ? Ft = yn(Ft - N.height + Q.height) : Jt === "center" && (Ft = yn(Ft - N.height / 2 + Q.height / 2)), de && (Ft += de), {
      behavior: Dt,
      top: Ft
    };
  })), c);
  const Bt = ct(x$1(k, H(v => v.offsetBottom + v.bottom)), 0);
  return F(x$1(b, H(v => ({
    height: v.visibleHeight,
    width: v.visibleWidth
  }))), O), {
    customScrollParent: y,
    // input
    data: nt,
    deviation: J,
    footerHeight: r,
    gap: B,
    headerHeight: s,
    increaseViewportBy: t,
    initialItemCount: R,
    itemDimensions: z,
    overscan: n,
    restoreStateFrom: st,
    scrollBy: i,
    scrollContainerState: l,
    scrollHeight: D,
    scrollTo: c,
    scrollToIndex: P,
    scrollTop: d,
    smoothScrollTargetReached: f,
    totalCount: a,
    useWindowScroll: g,
    viewportDimensions: O,
    windowScrollContainerState: u,
    windowScrollTo: T,
    windowViewportRect: b,
    ...m,
    // output
    gridState: k,
    horizontalDirection: At,
    initialTopMostItemIndex: St,
    totalListHeight: Bt,
    ...p,
    endReached: Xt,
    propsReady: I,
    rangeChanged: yt,
    startReached: Wt,
    stateChanged: q,
    stateRestoreInProgress: dt,
    ...h
  };
}, X(Ue, at, ae, Un, Vt, Ke, Pt));
function eo(t, e, n) {
  return ee(1, we((t + n) / (we(e) + n)));
}
function bn(t, e, n, o) {
  const {
    height: r
  } = n;
  if (r === void 0 || o.length === 0) return {
    bottom: 0,
    top: 0
  };
  const s = Ve(t, e, n, o[0].index);
  return {
    bottom: Ve(t, e, n, o[o.length - 1].index) + r,
    top: s
  };
}
function Ve(t, e, n, o) {
  const r = eo(t.width, n.width, e.column),
    s = we(o / r),
    i = s * n.height + ee(0, s - 1) * e.row;
  return i > 0 ? i + e.row : i;
}
const Br = /* @__PURE__ */U(() => {
    const t = w$1(S => "Item ".concat(S)),
      e = w$1({}),
      n = w$1(null),
      o = w$1("virtuoso-grid-item"),
      r = w$1("virtuoso-grid-list"),
      s = w$1(qe),
      i = w$1("div"),
      l = w$1(Gt),
      c = function (S) {
        let p = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return ct(x$1(e, H(m => m[S]), Y()), p);
      },
      d = w$1(!1),
      f = w$1(!1);
    return F(A$1(f), d), {
      components: e,
      computeItemKey: s,
      context: n,
      FooterComponent: c("Footer"),
      HeaderComponent: c("Header"),
      headerFooterTag: i,
      itemClassName: o,
      ItemComponent: c("Item", "div"),
      itemContent: t,
      listClassName: r,
      ListComponent: c("List", "div"),
      readyStateChanged: d,
      reportReadyState: f,
      ScrollerComponent: c("Scroller", "div"),
      scrollerRef: l,
      ScrollSeekPlaceholder: c("ScrollSeekPlaceholder", "div")
    };
  }),
  kr = /* @__PURE__ */U(_ref154 => {
    let [t, e] = _ref154;
    return {
      ...t,
      ...e
    };
  }, X(Hr, Br)),
  Or = /* @__PURE__ */React__default.memo(function () {
    const e = et("gridState"),
      n = et("listClassName"),
      o = et("itemClassName"),
      r = et("itemContent"),
      s = et("computeItemKey"),
      i = et("isSeeking"),
      l = It("scrollHeight"),
      c = et("ItemComponent"),
      d = et("ListComponent"),
      f = et("ScrollSeekPlaceholder"),
      S = et("context"),
      p = It("itemDimensions"),
      m = It("gap"),
      C = et("log"),
      I = et("stateRestoreInProgress"),
      y = It("reportReadyState"),
      g = Et(React__default.useMemo(() => u => {
        const T = u.parentElement.parentElement.scrollHeight;
        l(T);
        const b = u.firstChild;
        if (b) {
          const {
            height: h,
            width: a
          } = b.getBoundingClientRect();
          p({
            height: h,
            width: a
          });
        }
        m({
          column: Rn("column-gap", getComputedStyle(u).columnGap, C),
          row: Rn("row-gap", getComputedStyle(u).rowGap, C)
        });
      }, [l, p, m, C]), !0, !1);
    return Yn(() => {
      e.itemHeight > 0 && e.itemWidth > 0 && y(!0);
    }, [e]), I ? null : /* @__PURE__ */jsx(d, {
      className: n,
      ref: g,
      ...Z(d, S),
      "data-testid": "virtuoso-item-list",
      style: {
        paddingBottom: e.offsetBottom,
        paddingTop: e.offsetTop
      },
      children: e.items.map(u => {
        const T = s(u.index, u.data, S);
        return i ? /* @__PURE__ */jsx(f, {
          ...Z(f, S),
          height: e.itemHeight,
          index: u.index,
          width: e.itemWidth
        }, T) : /* @__PURE__ */createElement$2(c, {
          ...Z(c, S),
          className: o,
          "data-index": u.index,
          key: T
        }, r(u.index, u.data, S));
      })
    });
  }),
  Fr = React__default.memo(function () {
    const e = et("HeaderComponent"),
      n = It("headerHeight"),
      o = et("headerFooterTag"),
      r = Et(React__default.useMemo(() => i => {
        n(Ct(i, "height"));
      }, [n]), !0, !1),
      s = et("context");
    return e ? /* @__PURE__ */jsx(o, {
      ref: r,
      children: /* @__PURE__ */jsx(e, {
        ...Z(e, s)
      })
    }) : null;
  }),
  zr = React__default.memo(function () {
    const e = et("FooterComponent"),
      n = It("footerHeight"),
      o = et("headerFooterTag"),
      r = Et(React__default.useMemo(() => i => {
        n(Ct(i, "height"));
      }, [n]), !0, !1),
      s = et("context");
    return e ? /* @__PURE__ */jsx(o, {
      ref: r,
      children: /* @__PURE__ */jsx(e, {
        ...Z(e, s)
      })
    }) : null;
  }),
  Lr = _ref155 => {
    let {
      children: t
    } = _ref155;
    const e = React__default.useContext(qn),
      n = It("itemDimensions"),
      o = It("viewportDimensions"),
      r = Et(React__default.useMemo(() => s => {
        o(s.getBoundingClientRect());
      }, [o]), !0, !1);
    return React__default.useEffect(() => {
      e && (o({
        height: e.viewportHeight,
        width: e.viewportWidth
      }), n({
        height: e.itemHeight,
        width: e.itemWidth
      }));
    }, [e, o, n]), /* @__PURE__ */jsx("div", {
      ref: r,
      style: Zt(!1),
      children: t
    });
  },
  Pr = _ref156 => {
    let {
      children: t
    } = _ref156;
    const e = React__default.useContext(qn),
      n = It("windowViewportRect"),
      o = It("itemDimensions"),
      r = et("customScrollParent"),
      s = _e(n, r, !1);
    return React__default.useEffect(() => {
      e && (o({
        height: e.itemHeight,
        width: e.itemWidth
      }), n({
        offsetTop: 0,
        visibleHeight: e.viewportHeight,
        visibleWidth: e.viewportWidth
      }));
    }, [e, n, o]), /* @__PURE__ */jsx("div", {
      ref: s,
      style: Zt(!1),
      children: t
    });
  },
  Vr = /* @__PURE__ */React__default.memo(function (_ref157) {
    let {
      ...e
    } = _ref157;
    const n = et("useWindowScroll"),
      o = et("customScrollParent"),
      r = o || n ? Mr : Wr,
      s = o || n ? Pr : Lr,
      i = et("context");
    return /* @__PURE__ */jsx(r, {
      ...e,
      ...Z(r, i),
      children: /* @__PURE__ */jsxs(s, {
        children: [/* @__PURE__ */jsx(Fr, {}), /* @__PURE__ */jsx(Or, {}), /* @__PURE__ */jsx(zr, {})]
      })
    });
  }),
  {
    Component: Ar,
    useEmitter: no,
    useEmitterValue: et,
    usePublisher: It
  } = /* @__PURE__ */je(kr, {
    events: {
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      endReached: "endReached",
      isScrolling: "isScrolling",
      rangeChanged: "rangeChanged",
      readyStateChanged: "readyStateChanged",
      startReached: "startReached",
      stateChanged: "stateChanged"
    },
    methods: {
      scrollBy: "scrollBy",
      scrollTo: "scrollTo",
      scrollToIndex: "scrollToIndex"
    },
    optional: {
      components: "components",
      computeItemKey: "computeItemKey",
      context: "context",
      customScrollParent: "customScrollParent",
      data: "data",
      headerFooterTag: "headerFooterTag",
      increaseViewportBy: "increaseViewportBy",
      initialItemCount: "initialItemCount",
      initialTopMostItemIndex: "initialTopMostItemIndex",
      itemClassName: "itemClassName",
      itemContent: "itemContent",
      listClassName: "listClassName",
      logLevel: "logLevel",
      overscan: "overscan",
      restoreStateFrom: "restoreStateFrom",
      scrollerRef: "scrollerRef",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      totalCount: "totalCount",
      useWindowScroll: "useWindowScroll"
    }
  }, Vr),
  Wr = /* @__PURE__ */Ye({
    useEmitter: no,
    useEmitterValue: et,
    usePublisher: It
  }),
  Mr = /* @__PURE__ */Ze({
    useEmitter: no,
    useEmitterValue: et,
    usePublisher: It
  });
function Rn(t, e, n) {
  return e !== "normal" && !(e != null && e.endsWith("px")) && n("".concat(t, " was not resolved to pixel value correctly"), e, ht.WARN), e === "normal" ? 0 : parseInt(e != null ? e : "0", 10);
}

// a string of all valid unicode whitespaces
var whitespaces$4 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' + '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';
var uncurryThis$8 = functionUncurryThis;
var requireObjectCoercible$2 = requireObjectCoercible$a;
var toString$8 = toString$g;
var whitespaces$3 = whitespaces$4;
var replace$2 = uncurryThis$8(''.replace);
var ltrim = RegExp('^[' + whitespaces$3 + ']+');
var rtrim = RegExp('(^|[^' + whitespaces$3 + '])[' + whitespaces$3 + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString$8(requireObjectCoercible$2($this));
    if (TYPE & 1) string = replace$2(string, ltrim, '');
    if (TYPE & 2) string = replace$2(string, rtrim, '$1');
    return string;
  };
};
var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};
var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var fails$8 = fails$y;
var whitespaces$2 = whitespaces$4;
var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails$8(function () {
    return !!whitespaces$2[METHOD_NAME]() || non[METHOD_NAME]() !== non || PROPER_FUNCTION_NAME$1 && whitespaces$2[METHOD_NAME].name !== METHOD_NAME;
  });
};
var $$j = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$$j({
  target: 'String',
  proto: true,
  forced: forcedStringTrimMethod('trim')
}, {
  trim: function trim() {
    return $trim(this);
  }
});
var $$i = _export;
var iterate$2 = iterate$9;
var aCallable$4 = aCallable$k;
var anObject$3 = anObject$r;
var getIteratorDirect = getIteratorDirect$a;

// `Iterator.prototype.every` method
// https://github.com/tc39/proposal-iterator-helpers
$$i({
  target: 'Iterator',
  proto: true,
  real: true
}, {
  every: function every(predicate) {
    anObject$3(this);
    aCallable$4(predicate);
    var record = getIteratorDirect(this);
    var counter = 0;
    return !iterate$2(record, function (value, stop) {
      if (!predicate(value, counter++)) return stop();
    }, {
      IS_RECORD: true,
      INTERRUPTED: true
    }).stopped;
  }
});
var uncurryThis$7 = functionUncurryThis;
var isArray = isArray$4;
var isCallable$8 = isCallable$s;
var classof = classofRaw$2;
var toString$7 = toString$g;
var push = uncurryThis$7([].push);
var getJsonReplacerFunction = function (replacer) {
  if (isCallable$8(replacer)) return replacer;
  if (!isArray(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push(keys, element);else if (typeof element == 'number' || classof(element) === 'Number' || classof(element) === 'String') push(keys, toString$7(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};
var $$h = _export;
var getBuiltIn$4 = getBuiltIn$b;
var apply$1 = functionApply;
var call$5 = functionCall;
var uncurryThis$6 = functionUncurryThis;
var fails$7 = fails$y;
var isCallable$7 = isCallable$s;
var isSymbol$2 = isSymbol$5;
var arraySlice$1 = arraySlice$3;
var getReplacerFunction = getJsonReplacerFunction;
var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var $String$1 = String;
var $stringify = getBuiltIn$4('JSON', 'stringify');
var exec$1 = uncurryThis$6(/./.exec);
var charAt$2 = uncurryThis$6(''.charAt);
var charCodeAt = uncurryThis$6(''.charCodeAt);
var replace$1 = uncurryThis$6(''.replace);
var numberToString = uncurryThis$6(1.0.toString);
var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;
var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL$1 || fails$7(function () {
  var symbol = getBuiltIn$4('Symbol')('stringify detection');
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) !== '[null]'
  // WebKit converts symbol values to JSON as null
  || $stringify({
    a: symbol
  }) !== '{}'
  // V8 throws on boxed symbols
  || $stringify(Object(symbol)) !== '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails$7(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"' || $stringify('\uDEAD') !== '"\\udead"';
});
var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice$1(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable$7($replacer) && (it === undefined || isSymbol$2(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable$7($replacer)) value = call$5($replacer, this, $String$1(key), value);
    if (!isSymbol$2(value)) return value;
  };
  return apply$1($stringify, null, args);
};
var fixIllFormed = function (match, offset, string) {
  var prev = charAt$2(string, offset - 1);
  var next = charAt$2(string, offset + 1);
  if (exec$1(low, match) && !exec$1(hi, next) || exec$1(hi, match) && !exec$1(low, prev)) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  }
  return match;
};
if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $$h({
    target: 'JSON',
    stat: true,
    arity: 3,
    forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE
  }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice$1(arguments);
      var result = apply$1(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace$1(result, tester, fixIllFormed) : result;
    }
  });
}
var getBuiltIn$3 = getBuiltIn$b;
var defineBuiltInAccessor$1 = defineBuiltInAccessor$3;
var wellKnownSymbol$2 = wellKnownSymbol$l;
var DESCRIPTORS$2 = descriptors;
var SPECIES$1 = wellKnownSymbol$2('species');
var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$3(CONSTRUCTOR_NAME);
  if (DESCRIPTORS$2 && Constructor && !Constructor[SPECIES$1]) {
    defineBuiltInAccessor$1(Constructor, SPECIES$1, {
      configurable: true,
      get: function () {
        return this;
      }
    });
  }
};
var $TypeError$1 = TypeError;
var validateArgumentsLength$1 = function (passed, required) {
  if (passed < required) throw new $TypeError$1('Not enough arguments');
  return passed;
};
var userAgent$2 = engineUserAgent;

// eslint-disable-next-line redos/no-vulnerable -- safe
var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$2);
var global$9 = global$q;
var apply = functionApply;
var bind$4 = functionBindContext;
var isCallable$6 = isCallable$s;
var hasOwn$2 = hasOwnProperty_1;
var fails$6 = fails$y;
var html = html$2;
var arraySlice = arraySlice$3;
var createElement = documentCreateElement$2;
var validateArgumentsLength = validateArgumentsLength$1;
var IS_IOS$1 = engineIsIos;
var IS_NODE$3 = engineIsNode;
var set = global$9.setImmediate;
var clear = global$9.clearImmediate;
var process$3 = global$9.process;
var Dispatch = global$9.Dispatch;
var Function$1 = global$9.Function;
var MessageChannel = global$9.MessageChannel;
var String$1 = global$9.String;
var counter = 0;
var queue$2 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;
fails$6(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global$9.location;
});
var run = function (id) {
  if (hasOwn$2(queue$2, id)) {
    var fn = queue$2[id];
    delete queue$2[id];
    fn();
  }
};
var runner = function (id) {
  return function () {
    run(id);
  };
};
var eventListener = function (event) {
  run(event.data);
};
var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global$9.postMessage(String$1(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable$6(handler) ? handler : Function$1(handler);
    var args = arraySlice(arguments, 1);
    queue$2[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$2[id];
  };
  // Node.js 0.8-
  if (IS_NODE$3) {
    defer = function (id) {
      process$3.nextTick(runner(id));
    };
    // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
    // Browsers with MessageChannel, includes WebWorkers
    // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind$4(port.postMessage, port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global$9.addEventListener && isCallable$6(global$9.postMessage) && !global$9.importScripts && $location && $location.protocol !== 'file:' && !fails$6(globalPostMessageDefer)) {
    defer = globalPostMessageDefer;
    global$9.addEventListener('message', eventListener, false);
    // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
    // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}
var task$1 = {
  set: set,
  clear: clear
};
var global$8 = global$q;
var DESCRIPTORS$1 = descriptors;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn$1 = function (name) {
  if (!DESCRIPTORS$1) return global$8[name];
  var descriptor = getOwnPropertyDescriptor(global$8, name);
  return descriptor && descriptor.value;
};
var Queue$2 = function () {
  this.head = null;
  this.tail = null;
};
Queue$2.prototype = {
  add: function (item) {
    var entry = {
      item: item,
      next: null
    };
    var tail = this.tail;
    if (tail) tail.next = entry;else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};
var queue$1 = Queue$2;
var userAgent$1 = engineUserAgent;
var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$1) && typeof Pebble != 'undefined';
var userAgent = engineUserAgent;
var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);
var global$7 = global$q;
var safeGetBuiltIn = safeGetBuiltIn$1;
var bind$3 = functionBindContext;
var macrotask = task$1.set;
var Queue$1 = queue$1;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$2 = engineIsNode;
var MutationObserver = global$7.MutationObserver || global$7.WebKitMutationObserver;
var document$2 = global$7.document;
var process$2 = global$7.process;
var Promise$1 = global$7.Promise;
var microtask$2 = safeGetBuiltIn('queueMicrotask');
var notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask$2) {
  var queue = new Queue$1();
  var flush = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$2.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify$1();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, {
      characterData: true
    });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
    // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$3(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
    // Node.js without promises
  } else if (IS_NODE$2) {
    notify$1 = function () {
      process$2.nextTick(flush);
    };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessage
    // - onreadystatechange
    // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind$3(macrotask, global$7);
    notify$1 = function () {
      macrotask(flush);
    };
  }
  microtask$2 = function (fn) {
    if (!queue.head) notify$1();
    queue.add(fn);
  };
}
var microtask_1 = microtask$2;
var hostReportErrors$1 = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) {/* empty */}
};
var perform$3 = function (exec) {
  try {
    return {
      error: false,
      value: exec()
    };
  } catch (error) {
    return {
      error: true,
      value: error
    };
  }
};
var global$6 = global$q;
var promiseNativeConstructor = global$6.Promise;

/* global Deno -- Deno case */
var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';
var IS_DENO$1 = engineIsDeno;
var IS_NODE$1 = engineIsNode;
var engineIsBrowser = !IS_DENO$1 && !IS_NODE$1 && typeof window == 'object' && typeof document == 'object';
var global$5 = global$q;
var NativePromiseConstructor$4 = promiseNativeConstructor;
var isCallable$5 = isCallable$s;
var isForced = isForced_1;
var inspectSource = inspectSource$3;
var wellKnownSymbol$1 = wellKnownSymbol$l;
var IS_BROWSER = engineIsBrowser;
var IS_DENO = engineIsDeno;
var V8_VERSION = engineV8Version;
NativePromiseConstructor$4 && NativePromiseConstructor$4.prototype;
var SPECIES = wellKnownSymbol$1('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$5(global$5.PromiseRejectionEvent);
var FORCED_PROMISE_CONSTRUCTOR$5 = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$4);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$4);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor$4(function (resolve) {
      resolve(1);
    });
    var FakePromise = function (exec) {
      exec(function () {/* empty */}, function () {/* empty */});
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () {/* empty */}) instanceof FakePromise;
    if (!SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  }
  return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT$1;
});
var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};
var newPromiseCapability$2 = {};
var aCallable$3 = aCallable$k;
var $TypeError = TypeError;
var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$3(resolve);
  this.reject = aCallable$3(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};
var $$g = _export;
var IS_NODE = engineIsNode;
var global$4 = global$q;
var call$4 = functionCall;
var defineBuiltIn$3 = defineBuiltIn$9;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$4;
var setSpecies = setSpecies$1;
var aCallable$2 = aCallable$k;
var isCallable$4 = isCallable$s;
var isObject$5 = isObject$i;
var anInstance = anInstance$2;
var speciesConstructor$1 = speciesConstructor$3;
var task = task$1.set;
var microtask$1 = microtask_1;
var hostReportErrors = hostReportErrors$1;
var perform$2 = perform$3;
var Queue = queue$1;
var InternalStateModule = internalState;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;
var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype$2 = NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var PromiseConstructor = NativePromiseConstructor$3;
var PromisePrototype = NativePromisePrototype$2;
var TypeError$1 = global$4.TypeError;
var document$1 = global$4.document;
var process$1 = global$4.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$3.f;
var newGenericPromiseCapability = newPromiseCapability$1;
var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$4.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject$5(it) && isCallable$4(then = it.then) ? then : false;
};
var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError$1('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$4(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};
var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask$1(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};
var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$4.dispatchEvent(event);
  } else event = {
    promise: promise,
    reason: reason
  };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$4['on' + name])) handler(event);else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};
var onUnhandled = function (state) {
  call$4(task, global$4, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$2(function () {
        if (IS_NODE) {
          process$1.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};
var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};
var onHandleUnhandled = function (state) {
  call$4(task, global$4, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process$1.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};
var bind$2 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};
var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};
var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask$1(function () {
        var wrapper = {
          done: false
        };
        try {
          call$4(then, value, bind$2(internalResolve, wrapper, state), bind$2(internalReject, wrapper, state));
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({
      done: false
    }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable$2(executor);
    call$4(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$2(internalResolve, state), bind$2(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn$3(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor$1(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$4(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$4(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process$1.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);else microtask$1(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$2(internalResolve, state);
    this.reject = bind$2(internalReject, state);
  };
  newPromiseCapabilityModule$3.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
  };
  if (isCallable$4(NativePromiseConstructor$3) && NativePromisePrototype$2 !== Object.prototype) {
    nativeThen = NativePromisePrototype$2.then;
    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$3(NativePromisePrototype$2, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$4(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
      }, {
        unsafe: true
      });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$2.constructor;
    } catch (error) {/* empty */}

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype$2, PromisePrototype);
    }
  }
}
$$g({
  global: true,
  constructor: true,
  wrap: true,
  forced: FORCED_PROMISE_CONSTRUCTOR$4
}, {
  Promise: PromiseConstructor
});
setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);
var wellKnownSymbol = wellKnownSymbol$l;
var ITERATOR$2 = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;
try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return {
        done: !!called++
      };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$2] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () {
    throw 2;
  });
} catch (error) {/* empty */}
var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) {
    return false;
  } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$2] = function () {
      return {
        next: function () {
          return {
            done: ITERATION_SUPPORT = true
          };
        }
      };
    };
    exec(object);
  } catch (error) {/* empty */}
  return ITERATION_SUPPORT;
};
var NativePromiseConstructor$2 = promiseNativeConstructor;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;
var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor$2.all(iterable).then(undefined, function () {/* empty */});
});
var $$f = _export;
var call$3 = functionCall;
var aCallable$1 = aCallable$k;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$3;
var iterate$1 = iterate$9;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$f({
  target: 'Promise',
  stat: true,
  forced: PROMISE_STATICS_INCORRECT_ITERATION$1
}, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$3($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});
var $$e = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor$1 = promiseNativeConstructor;
var getBuiltIn$2 = getBuiltIn$b;
var isCallable$3 = isCallable$s;
var defineBuiltIn$2 = defineBuiltIn$9;
var NativePromisePrototype$1 = NativePromiseConstructor$1 && NativePromiseConstructor$1.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$e({
  target: 'Promise',
  proto: true,
  forced: FORCED_PROMISE_CONSTRUCTOR$2,
  real: true
}, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable$3(NativePromiseConstructor$1)) {
  var method$1 = getBuiltIn$2('Promise').prototype['catch'];
  if (NativePromisePrototype$1['catch'] !== method$1) {
    defineBuiltIn$2(NativePromisePrototype$1, 'catch', method$1, {
      unsafe: true
    });
  }
}
var $$d = _export;
var call$2 = functionCall;
var aCallable = aCallable$k;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var perform = perform$3;
var iterate = iterate$9;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$d({
  target: 'Promise',
  stat: true,
  forced: PROMISE_STATICS_INCORRECT_ITERATION
}, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$1.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call$2($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});
var $$c = _export;
var newPromiseCapabilityModule = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$c({
  target: 'Promise',
  stat: true,
  forced: FORCED_PROMISE_CONSTRUCTOR$1
}, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    var capabilityReject = capability.reject;
    capabilityReject(r);
    return capability.promise;
  }
});
var anObject$2 = anObject$r;
var isObject$4 = isObject$i;
var newPromiseCapability = newPromiseCapability$2;
var promiseResolve$2 = function (C, x) {
  anObject$2(C);
  if (isObject$4(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};
var $$b = _export;
var getBuiltIn$1 = getBuiltIn$b;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve$1 = promiseResolve$2;
getBuiltIn$1('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$$b({
  target: 'Promise',
  stat: true,
  forced: FORCED_PROMISE_CONSTRUCTOR
}, {
  resolve: function resolve(x) {
    return promiseResolve$1(this, x);
  }
});
var $$a = _export;
var NativePromiseConstructor = promiseNativeConstructor;
var fails$5 = fails$y;
var getBuiltIn = getBuiltIn$b;
var isCallable$2 = isCallable$s;
var speciesConstructor = speciesConstructor$3;
var promiseResolve = promiseResolve$2;
var defineBuiltIn$1 = defineBuiltIn$9;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromiseConstructor && fails$5(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromisePrototype['finally'].call({
    then: function () {/* empty */}
  }, function () {/* empty */});
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$$a({
  target: 'Promise',
  proto: true,
  real: true,
  forced: NON_GENERIC
}, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable$2(onFinally);
    return this.then(isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () {
        return x;
      });
    } : onFinally, isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () {
        throw e;
      });
    } : onFinally);
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (isCallable$2(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromisePrototype['finally'] !== method) {
    defineBuiltIn$1(NativePromisePrototype, 'finally', method, {
      unsafe: true
    });
  }
}

// Unique ID creation requires a high quality random # generator.  In node.js
// this is pretty straight-forward - we use the crypto API.

var crypto = require$$0;
var rng$2 = function nodeRNG() {
  return crypto.randomBytes(16);
};

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}
function bytesToUuid$2(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
}
var bytesToUuid_1 = bytesToUuid$2;
var rng$1 = rng$2;
var bytesToUuid$1 = bytesToUuid_1;

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/uuidjs/uuid for API details
function v1$1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];
  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng$1();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }
  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }
  return buf ? buf : bytesToUuid$1(b);
}
var v1_1 = v1$1;
var rng = rng$2;
var bytesToUuid = bytesToUuid_1;
function v4$1(options, buf, offset) {
  var i = buf && offset || 0;
  if (typeof options == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};
  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }
  return buf || bytesToUuid(rnds);
}
var v4_1 = v4$1;
var v1 = v1_1;
var v4 = v4_1;
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
var uuid_1 = uuid;
var TemplateType;
(function (TemplateType) {
  TemplateType["TEXT"] = "TEXT";
  TemplateType["SELECT"] = "SELECT";
  TemplateType["RADIO"] = "RADIO";
  TemplateType["COLOR"] = "COLOR";
  TemplateType["TEXTAREA"] = "TEXTAREA";
  TemplateType["NUMBER"] = "NUMBER";
  TemplateType["EMAIL"] = "EMAIL";
  TemplateType["CHECKBOX"] = "CHECKBOX";
  TemplateType["DATE"] = "DATE";
})(TemplateType || (TemplateType = {}));
var Status;
(function (Status) {
  Status["PENDING"] = "PENDING";
  Status["ACTIVE"] = "ACTIVE";
})(Status || (Status = {}));
var Category;
(function (Category) {
  Category["PROJECT"] = "PROJECT";
  Category["RESOURCE"] = "RESOURCE";
})(Category || (Category = {}));
var DaysOfWeek;
(function (DaysOfWeek) {
  DaysOfWeek[DaysOfWeek["Sunday"] = 0] = "Sunday";
  DaysOfWeek[DaysOfWeek["Monday"] = 1] = "Monday";
  DaysOfWeek[DaysOfWeek["Tuesday"] = 2] = "Tuesday";
  DaysOfWeek[DaysOfWeek["Wednesday"] = 3] = "Wednesday";
  DaysOfWeek[DaysOfWeek["Thursday"] = 4] = "Thursday";
  DaysOfWeek[DaysOfWeek["Friday"] = 5] = "Friday";
  DaysOfWeek[DaysOfWeek["Saturday"] = 6] = "Saturday";
})(DaysOfWeek || (DaysOfWeek = {}));
const getDayName = day => {
  if (day === DaysOfWeek.Sunday) return 'Sunday';
  if (day === DaysOfWeek.Monday) return 'Monday';
  if (day === DaysOfWeek.Tuesday) return 'Tuesday';
  if (day === DaysOfWeek.Wednesday) return 'Wednesday';
  if (day === DaysOfWeek.Thursday) return 'Thursday';
  if (day === DaysOfWeek.Friday) return 'Friday';
  if (day === DaysOfWeek.Saturday) return 'Saturday';
  return 'Sunday';
};
const createDefaultCustomField = function () {
  let partial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const now = new Date().toISOString();
  const isOptionsType = partial.type === TemplateType.CHECKBOX || partial.type === TemplateType.RADIO || partial.type === TemplateType.SELECT;
  return Object.assign({
    // this id is temp as to avoid issues with react rendering
    _client_id: uuid_1.v4(),
    order: 0,
    status: Status.ACTIVE,
    company: '',
    category: Category.PROJECT,
    type: TemplateType.TEXT,
    canResourceEdit: false,
    isRequired: false,
    label: '',
    deleted: false,
    instructions: '',
    defaultValue: '',
    placeholderText: '',
    createdDate: now,
    filterGrid: isOptionsType,
    isChoicesSortedAlphabetically: isOptionsType
  }, partial);
};
const copyCustomField = original => {
  const copy = Object.assign(Object.assign({}, original), {
    _id: undefined,
    _client_id: generateClientId(original, true),
    order: original.order + 1
  });
  if (original.choices) {
    copy.choices = original.choices.map(choice => ({
      value: choice.value
    }));
  }
  return copy;
};
const generateClientId = function (field) {
  let copy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (copy) {
    const baseId = (field === null || field === void 0 ? void 0 : field._id) || (field === null || field === void 0 ? void 0 : field._client_id);
    return "".concat(baseId, "_copy_").concat(Date.now());
  }
  return (field === null || field === void 0 ? void 0 : field._client_id) || uuid_1.v4();
};
const getFieldKey = function (field) {
  let useClientId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (useClientId) {
    return (field === null || field === void 0 ? void 0 : field._client_id) || (field === null || field === void 0 ? void 0 : field._id) || generateClientId(field);
  }
  return (field === null || field === void 0 ? void 0 : field._id) || (field === null || field === void 0 ? void 0 : field._client_id) || generateClientId(field);
};

/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */

function Cache(maxSize) {
  this._maxSize = maxSize;
  this.clear();
}
Cache.prototype.clear = function () {
  this._size = 0;
  this._values = Object.create(null);
};
Cache.prototype.get = function (key) {
  return this._values[key];
};
Cache.prototype.set = function (key, value) {
  this._size >= this._maxSize && this.clear();
  if (!(key in this._values)) this._size++;
  return this._values[key] = value;
};
var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512;
var pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE);
var propertyExpr = {
  Cache: Cache,
  split: split,
  normalizePath: normalizePath,
  setter: function (path) {
    var parts = normalizePath(path);
    return setCache.get(path) || setCache.set(path, function setter(obj, value) {
      var index = 0;
      var len = parts.length;
      var data = obj;
      while (index < len - 1) {
        var part = parts[index];
        if (part === '__proto__' || part === 'constructor' || part === 'prototype') {
          return obj;
        }
        data = data[parts[index++]];
      }
      data[parts[index]] = value;
    });
  },
  getter: function (path, safe) {
    var parts = normalizePath(path);
    return getCache.get(path) || getCache.set(path, function getter(data) {
      var index = 0,
        len = parts.length;
      while (index < len) {
        if (data != null || !safe) data = data[parts[index++]];else return;
      }
      return data;
    });
  },
  join: function (segments) {
    return segments.reduce(function (path, part) {
      return path + (isQuoted(part) || DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
    }, '');
  },
  forEach: function (path, cb, thisArg) {
    forEach(Array.isArray(path) ? path : split(path), cb, thisArg);
  }
};
function normalizePath(path) {
  return pathCache.get(path) || pathCache.set(path, split(path).map(function (part) {
    return part.replace(CLEAN_QUOTES_REGEX, '$2');
  }));
}
function split(path) {
  return path.match(SPLIT_REGEX) || [''];
}
function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket;
  for (idx = 0; idx < len; idx++) {
    part = parts[idx];
    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"';
      }
      isBracket = isQuoted(part);
      isArray = !isBracket && /^\d+$/.test(part);
      iter.call(thisArg, part, isBracket, isArray, idx, parts);
    }
  }
}
function isQuoted(str) {
  return typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1;
}
function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX);
}
function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part);
}
function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part));
}
const reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const words = str => str.match(reWords) || [];
const upperFirst = str => str[0].toUpperCase() + str.slice(1);
const join = (str, d) => words(str).join(d).toLowerCase();
const camelCase = str => words(str).reduce((acc, next) => "".concat(acc).concat(!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()), '');
const pascalCase = str => upperFirst(camelCase(str));
const snakeCase = str => join(str, '_');
const kebabCase = str => join(str, '-');
const sentenceCase = str => upperFirst(join(str, ' '));
const titleCase = str => words(str).map(upperFirst).join(' ');
var tinyCase = {
  words,
  upperFirst,
  camelCase,
  pascalCase,
  snakeCase,
  kebabCase,
  sentenceCase,
  titleCase
};
var toposort$2 = {
  exports: {}
};

/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

toposort$2.exports = function (edges) {
  return toposort(uniqueNodes(edges), edges);
};
toposort$2.exports.array = toposort;
function toposort(nodes, edges) {
  var cursor = nodes.length,
    sorted = new Array(cursor),
    visited = {},
    i = cursor
    // Better data structures make algorithm much faster.
    ,
    outgoingEdges = makeOutgoingEdges(edges),
    nodesHash = makeNodesHash(nodes);

  // check for unknown nodes
  edges.forEach(function (edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    }
  });
  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set());
  }
  return sorted;
  function visit(node, i, predecessors) {
    if (predecessors.has(node)) {
      var nodeRep;
      try {
        nodeRep = ", node was:" + JSON.stringify(node);
      } catch (e) {
        nodeRep = "";
      }
      throw new Error('Cyclic dependency' + nodeRep);
    }
    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
    }
    if (visited[i]) return;
    visited[i] = true;
    var outgoing = outgoingEdges.get(node) || new Set();
    outgoing = Array.from(outgoing);
    if (i = outgoing.length) {
      predecessors.add(node);
      do {
        var child = outgoing[--i];
        visit(child, nodesHash.get(child), predecessors);
      } while (i);
      predecessors.delete(node);
    }
    sorted[--cursor] = node;
  }
}
function uniqueNodes(arr) {
  var res = new Set();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    res.add(edge[0]);
    res.add(edge[1]);
  }
  return Array.from(res);
}
function makeOutgoingEdges(arr) {
  var edges = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    if (!edges.has(edge[0])) edges.set(edge[0], new Set());
    if (!edges.has(edge[1])) edges.set(edge[1], new Set());
    edges.get(edge[0]).add(edge[1]);
  }
  return edges;
}
function makeNodesHash(arr) {
  var res = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i);
  }
  return res;
}
var toposort$1 = toposort$2.exports;
const toString$6 = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : () => '';
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function printNumber(val) {
  if (val != +val) return 'NaN';
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}
function printSimpleValue(val) {
  let quoteStrings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (val == null || val === true || val === false) return '' + val;
  const typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? "\"".concat(val, "\"") : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  const tag = toString$6.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}
function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    let result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}
function toArray(value) {
  return value == null ? [] : [].concat(value);
}
let _Symbol$toStringTag, _Symbol$hasInstance, _Symbol$toStringTag2;
let strReg = /\$\{\s*(\w+)\s*\}/g;
_Symbol$toStringTag = Symbol.toStringTag;
class ValidationErrorNoStack {
  constructor(errorOrErrors, value, field, type) {
    this.name = void 0;
    this.message = void 0;
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.params = void 0;
    this.errors = void 0;
    this.inner = void 0;
    this[_Symbol$toStringTag] = 'Error';
    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach(err => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        const innerErrors = err.inner.length ? err.inner : [err];
        this.inner.push(...innerErrors);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? "".concat(this.errors.length, " errors occurred") : this.errors[0];
  }
}
_Symbol$hasInstance = Symbol.hasInstance;
_Symbol$toStringTag2 = Symbol.toStringTag;
class ValidationError extends Error {
  static formatError(message, params) {
    // Attempt to make the path more friendly for error message interpolation.
    const path = params.label || params.path || 'this';
    // Store the original path under `originalPath` so it isn't lost to custom
    // message functions; e.g., ones provided in `setLocale()` calls.
    params = Object.assign({}, params, {
      path,
      originalPath: params.path
    });
    if (typeof message === 'string') return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === 'function') return message(params);
    return message;
  }
  static isError(err) {
    return err && err.name === 'ValidationError';
  }
  constructor(errorOrErrors, value, field, type, disableStack) {
    const errorNoStack = new ValidationErrorNoStack(errorOrErrors, value, field, type);
    if (disableStack) {
      return errorNoStack;
    }
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.params = void 0;
    this.errors = [];
    this.inner = [];
    this[_Symbol$toStringTag2] = 'Error';
    this.name = errorNoStack.name;
    this.message = errorNoStack.message;
    this.type = errorNoStack.type;
    this.value = errorNoStack.value;
    this.path = errorNoStack.path;
    this.errors = errorNoStack.errors;
    this.inner = errorNoStack.inner;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ValidationError);
    }
  }
  static [_Symbol$hasInstance](inst) {
    return ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
  }
}
let mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  defined: '${path} must be defined',
  notNull: '${path} cannot be null',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: _ref158 => {
    let {
      path,
      type,
      value,
      originalValue
    } = _ref158;
    const castMsg = originalValue != null && originalValue !== value ? " (cast from the value `".concat(printValue(originalValue, true), "`).") : '.';
    return type !== 'mixed' ? "".concat(path, " must be a `").concat(type, "` type, ") + "but the final value was: `".concat(printValue(value, true), "`") + castMsg : "".concat(path, " must match the configured type. ") + "The validated value was: `".concat(printValue(value, true), "`") + castMsg;
  }
};
let string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  datetime: '${path} must be a valid ISO date-time',
  datetime_precision: '${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits',
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
let number$1 = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
let date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
let boolean = {
  isValue: '${path} field must be ${value}'
};
let object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}',
  exact: '${path} object contains unknown properties: ${properties}'
};
let array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must have ${length} items'
};
let tuple = {
  notType: params => {
    const {
      path,
      value,
      spec
    } = params;
    const typeLen = spec.types.length;
    if (Array.isArray(value)) {
      if (value.length < typeLen) return "".concat(path, " tuple value has too few items, expected a length of ").concat(typeLen, " but got ").concat(value.length, " for value: `").concat(printValue(value, true), "`");
      if (value.length > typeLen) return "".concat(path, " tuple value has too many items, expected a length of ").concat(typeLen, " but got ").concat(value.length, " for value: `").concat(printValue(value, true), "`");
    }
    return ValidationError.formatError(mixed.notType, params);
  }
};
Object.assign(Object.create(null), {
  mixed,
  string,
  number: number$1,
  date,
  object,
  array,
  boolean,
  tuple
});
const isSchema = obj => obj && obj.__isYupSchema__;
class Condition {
  static fromOptions(refs, config) {
    if (!config.then && !config.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    let {
      is,
      then,
      otherwise
    } = config;
    let check = typeof is === 'function' ? is : function () {
      for (var _len9 = arguments.length, values = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        values[_key9] = arguments[_key9];
      }
      return values.every(value => value === is);
    };
    return new Condition(refs, (values, schema) => {
      var _branch;
      let branch = check(...values) ? then : otherwise;
      return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
    });
  }
  constructor(refs, builder) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;
    this.fn = builder;
  }
  resolve(base, options) {
    let values = this.refs.map(ref =>
    // TODO: ? operator here?
    ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn(values, base, options);
    if (schema === undefined ||
    // @ts-ignore this can be base
    schema === base) {
      return base;
    }
    if (!isSchema(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  }
}
const prefixes = {
  context: '$',
  value: '.'
};
class Reference {
  constructor(key) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && propertyExpr.getter(this.path, true);
    this.map = options.map;
  }
  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  }

  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: 'ref',
      key: this.key
    };
  }
  toString() {
    return "Ref(".concat(this.key, ")");
  }
  static isRef(value) {
    return value && value.__isYupRef;
  }
}

// @ts-ignore
Reference.prototype.__isYupRef = true;
const isAbsent = value => value == null;
function createValidation(config) {
  function validate(_ref159, panic, next) {
    let {
      value,
      path = '',
      options,
      originalValue,
      schema
    } = _ref159;
    const {
      name,
      test,
      params,
      message,
      skipAbsent
    } = config;
    let {
      parent,
      context,
      abortEarly = schema.spec.abortEarly,
      disableStackTrace = schema.spec.disableStackTrace
    } = options;
    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }
    function createError() {
      let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const nextParams = Object.assign({
        value,
        originalValue,
        label: schema.spec.label,
        path: overrides.path || path,
        spec: schema.spec,
        disableStackTrace: overrides.disableStackTrace || disableStackTrace
      }, params, overrides.params);
      for (const key of Object.keys(nextParams)) nextParams[key] = resolve(nextParams[key]);
      const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
      error.params = nextParams;
      return error;
    }
    const invalid = abortEarly ? panic : next;
    let ctx = {
      path,
      parent,
      type: name,
      from: options.from,
      createError,
      resolve,
      options,
      originalValue,
      schema
    };
    const handleResult = validOrError => {
      if (ValidationError.isError(validOrError)) invalid(validOrError);else if (!validOrError) invalid(createError());else next(null);
    };
    const handleError = err => {
      if (ValidationError.isError(err)) invalid(err);else panic(err);
    };
    const shouldSkip = skipAbsent && isAbsent(value);
    if (shouldSkip) {
      return handleResult(true);
    }
    let result;
    try {
      var _result;
      result = test.call(ctx, value, ctx);
      if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
        if (options.sync) {
          throw new Error("Validation test of type: \"".concat(ctx.type, "\" returned a Promise during a synchronous validate. ") + "This test will finish after the validate call has returned");
        }
        return Promise.resolve(result).then(handleResult, handleError);
      }
    } catch (err) {
      handleError(err);
      return;
    }
    handleResult(result);
  }
  validate.OPTIONS = config;
  return validate;
}
function getIn(schema, path, value) {
  let context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : value;
  let parent, lastPart, lastPartDebug;

  // root path: ''
  if (!path) return {
    parent,
    parentPath: path,
    schema
  };
  propertyExpr.forEach(path, (_part, isBracket, isArray) => {
    let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });
    let isTuple = schema.type === 'tuple';
    let idx = isArray ? parseInt(part, 10) : 0;
    if (schema.innerType || isTuple) {
      if (isTuple && !isArray) throw new Error("Yup.reach cannot implicitly index into a tuple type. the path part \"".concat(lastPartDebug, "\" must contain an index to the tuple element, e.g. \"").concat(lastPartDebug, "[0]\""));
      if (value && idx >= value.length) {
        throw new Error("Yup.reach cannot resolve an array item at index: ".concat(_part, ", in the path: ").concat(path, ". ") + "because there is no value at that index. ");
      }
      parent = value;
      value = value && value[idx];
      schema = isTuple ? schema.spec.types[idx] : schema.innerType;
    }

    // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal
    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error("The schema does not contain the path: ".concat(path, ". ") + "(failed at: ".concat(lastPartDebug, " which is a type: \"").concat(schema.type, "\")"));
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }
    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}
class ReferenceSet extends Set {
  describe() {
    const description = [];
    for (const item of this.values()) {
      description.push(Reference.isRef(item) ? item.describe() : item);
    }
    return description;
  }
  resolveAll(resolve) {
    let result = [];
    for (const item of this.values()) {
      result.push(resolve(item));
    }
    return result;
  }
  clone() {
    return new ReferenceSet(this.values());
  }
  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.forEach(value => next.add(value));
    removeItems.forEach(value => next.delete(value));
    return next;
  }
}

// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function clone(src) {
  let seen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
  if (isSchema(src) || !src || typeof src !== 'object') return src;
  if (seen.has(src)) return seen.get(src);
  let copy;
  if (src instanceof Date) {
    // Date
    copy = new Date(src.getTime());
    seen.set(src, copy);
  } else if (src instanceof RegExp) {
    // RegExp
    copy = new RegExp(src);
    seen.set(src, copy);
  } else if (Array.isArray(src)) {
    // Array
    copy = new Array(src.length);
    seen.set(src, copy);
    for (let i = 0; i < src.length; i++) copy[i] = clone(src[i], seen);
  } else if (src instanceof Map) {
    // Map
    copy = new Map();
    seen.set(src, copy);
    for (const [k, v] of src.entries()) copy.set(k, clone(v, seen));
  } else if (src instanceof Set) {
    // Set
    copy = new Set();
    seen.set(src, copy);
    for (const v of src) copy.add(clone(v, seen));
  } else if (src instanceof Object) {
    // Object
    copy = {};
    seen.set(src, copy);
    for (const [k, v] of Object.entries(src)) copy[k] = clone(v, seen);
  } else {
    throw Error("Unable to clone ".concat(src));
  }
  return copy;
}

// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class Schema {
  constructor(options) {
    this.type = void 0;
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this.internalTests = {};
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this._typeCheck = void 0;
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = options.type;
    this._typeCheck = options.check;
    this.spec = Object.assign({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      disableStackTrace: false,
      nullable: false,
      optional: true,
      coerce: true
    }, options == null ? void 0 : options.spec);
    this.withMutation(s => {
      s.nonNullable();
    });
  }

  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(spec) {
    if (this._mutate) {
      if (spec) Object.assign(this.spec, spec);
      return this;
    }

    // if the nested value is a schema we can skip cloning, since
    // they are already immutable
    const next = Object.create(Object.getPrototypeOf(this));

    // @ts-expect-error this is readonly
    next.type = this.type;
    next._typeCheck = this._typeCheck;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.internalTests = Object.assign({}, this.internalTests);
    next.exclusiveTests = Object.assign({}, this.exclusiveTests);

    // @ts-expect-error this is readonly
    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone(Object.assign({}, this.spec, spec));
    return next;
  }
  label(label) {
    let next = this.clone();
    next.spec.label = label;
    return next;
  }
  meta() {
    if (arguments.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, arguments.length <= 0 ? undefined : arguments[0]);
    return next;
  }
  withMutation(fn) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn(this);
    this._mutate = before;
    return result;
  }
  concat(schema) {
    if (!schema || schema === this) return this;
    if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError("You cannot `concat()` schema's of different types: ".concat(this.type, " and ").concat(schema.type));
    let base = this;
    let combined = schema.clone();
    const mergedSpec = Object.assign({}, base.spec, combined.spec);
    combined.spec = mergedSpec;
    combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);

    // manually merge the blacklist/whitelist (the other `schema` takes
    // precedence in case of conflicts)
    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);

    // start with the current tests
    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests;

    // manually add the new tests to ensure
    // the deduping logic is consistent
    combined.withMutation(next => {
      schema.tests.forEach(fn => {
        next.test(fn.OPTIONS);
      });
    });
    combined.transforms = [...base.transforms, ...combined.transforms];
    return combined;
  }
  isType(v) {
    if (v == null) {
      if (this.spec.nullable && v === null) return true;
      if (this.spec.optional && v === undefined) return true;
      return false;
    }
    return this._typeCheck(v);
  }
  resolve(options) {
    let schema = this;
    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((prevSchema, condition) => condition.resolve(prevSchema, options), schema);
      schema = schema.resolve(options);
    }
    return schema;
  }
  resolveOptions(options) {
    var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
    return Object.assign({}, options, {
      from: options.from || [],
      strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
      abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
      recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
      disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
    });
  }

  /**
   * Run the configured transform pipeline over an input value.
   */

  cast(value) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let resolvedSchema = this.resolve(Object.assign({
      value
    }, options));
    let allowOptionality = options.assert === 'ignore-optionality';
    let result = resolvedSchema._cast(value, options);
    if (options.assert !== false && !resolvedSchema.isType(result)) {
      if (allowOptionality && isAbsent(result)) {
        return result;
      }
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError("The value of ".concat(options.path || 'field', " could not be cast to a value ") + "that satisfies the schema type: \"".concat(resolvedSchema.type, "\". \n\n") + "attempted value: ".concat(formattedValue, " \n") + (formattedResult !== formattedValue ? "result of cast: ".concat(formattedResult) : ''));
    }
    return result;
  }
  _cast(rawValue, options) {
    let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn) => fn.call(this, prevValue, rawValue, this), rawValue);
    if (value === undefined) {
      value = this.getDefault(options);
    }
    return value;
  }
  _validate(_value) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let panic = arguments.length > 2 ? arguments[2] : undefined;
    let next = arguments.length > 3 ? arguments[3] : undefined;
    let {
      path,
      originalValue = _value,
      strict = this.spec.strict
    } = options;
    let value = _value;
    if (!strict) {
      value = this._cast(value, Object.assign({
        assert: false
      }, options));
    }
    let initialTests = [];
    for (let test of Object.values(this.internalTests)) {
      if (test) initialTests.push(test);
    }
    this.runTests({
      path,
      value,
      originalValue,
      options,
      tests: initialTests
    }, panic, initialErrors => {
      // even if we aren't ending early we can't proceed further if the types aren't correct
      if (initialErrors.length) {
        return next(initialErrors, value);
      }
      this.runTests({
        path,
        value,
        originalValue,
        options,
        tests: this.tests
      }, panic, next);
    });
  }

  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(runOptions, panic, next) {
    let fired = false;
    let {
      tests,
      value,
      originalValue,
      path,
      options
    } = runOptions;
    let panicOnce = arg => {
      if (fired) return;
      fired = true;
      panic(arg, value);
    };
    let nextOnce = arg => {
      if (fired) return;
      fired = true;
      next(arg, value);
    };
    let count = tests.length;
    let nestedErrors = [];
    if (!count) return nextOnce([]);
    let args = {
      value,
      originalValue,
      path,
      options,
      schema: this
    };
    for (let i = 0; i < tests.length; i++) {
      const test = tests[i];
      test(args, panicOnce, function finishTestRun(err) {
        if (err) {
          Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
        }
        if (--count <= 0) {
          nextOnce(nestedErrors);
        }
      });
    }
  }
  asNestedTest(_ref160) {
    let {
      key,
      index,
      parent,
      parentPath,
      originalParent,
      options
    } = _ref160;
    const k = key != null ? key : index;
    if (k == null) {
      throw TypeError('Must include `key` or `index` for nested validations');
    }
    const isIndex = typeof k === 'number';
    let value = parent[k];
    const testOptions = Object.assign({}, options, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: true,
      parent,
      value,
      originalValue: originalParent[k],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: undefined,
      // index: undefined,
      [isIndex ? 'index' : 'key']: k,
      path: isIndex || k.includes('.') ? "".concat(parentPath || '', "[").concat(isIndex ? k : "\"".concat(k, "\""), "]") : (parentPath ? "".concat(parentPath, ".") : '') + key
    });
    return (_, panic, next) => this.resolve(testOptions)._validate(value, testOptions, panic, next);
  }
  validate(value, options) {
    var _options$disableStack2;
    let schema = this.resolve(Object.assign({}, options, {
      value
    }));
    let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
    return new Promise((resolve, reject) => schema._validate(value, options, (error, parsed) => {
      if (ValidationError.isError(error)) error.value = parsed;
      reject(error);
    }, (errors, validated) => {
      if (errors.length) reject(new ValidationError(errors, validated, undefined, undefined, disableStackTrace));else resolve(validated);
    }));
  }
  validateSync(value, options) {
    var _options$disableStack3;
    let schema = this.resolve(Object.assign({}, options, {
      value
    }));
    let result;
    let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
    schema._validate(value, Object.assign({}, options, {
      sync: true
    }), (error, parsed) => {
      if (ValidationError.isError(error)) error.value = parsed;
      throw error;
    }, (errors, validated) => {
      if (errors.length) throw new ValidationError(errors, value, undefined, undefined, disableStackTrace);
      result = validated;
    });
    return result;
  }
  isValid(value, options) {
    return this.validate(value, options).then(() => true, err => {
      if (ValidationError.isError(err)) return false;
      throw err;
    });
  }
  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err)) return false;
      throw err;
    }
  }
  _getDefault(options) {
    let defaultValue = this.spec.default;
    if (defaultValue == null) {
      return defaultValue;
    }
    return typeof defaultValue === 'function' ? defaultValue.call(this, options) : clone(defaultValue);
  }
  getDefault(options
  // If schema is defaulted we know it's at least not undefined
  ) {
    let schema = this.resolve(options || {});
    return schema._getDefault(options);
  }
  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }
    let next = this.clone({
      default: def
    });
    return next;
  }
  strict() {
    let isStrict = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return this.clone({
      strict: isStrict
    });
  }
  nullability(nullable, message) {
    const next = this.clone({
      nullable
    });
    next.internalTests.nullable = createValidation({
      message,
      name: 'nullable',
      test(value) {
        return value === null ? this.schema.spec.nullable : true;
      }
    });
    return next;
  }
  optionality(optional, message) {
    const next = this.clone({
      optional
    });
    next.internalTests.optionality = createValidation({
      message,
      name: 'optionality',
      test(value) {
        return value === undefined ? this.schema.spec.optional : true;
      }
    });
    return next;
  }
  optional() {
    return this.optionality(true);
  }
  defined() {
    let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mixed.defined;
    return this.optionality(false, message);
  }
  nullable() {
    return this.nullability(true);
  }
  nonNullable() {
    let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mixed.notNull;
    return this.nullability(false, message);
  }
  required() {
    let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mixed.required;
    return this.clone().withMutation(next => next.nonNullable(message).defined(message));
  }
  notRequired() {
    return this.clone().withMutation(next => next.nullable().optional());
  }
  transform(fn) {
    let next = this.clone();
    next.transforms.push(fn);
    return next;
  }

  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */

  test() {
    let opts;
    if (arguments.length === 1) {
      if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'function') {
        opts = {
          test: arguments.length <= 0 ? undefined : arguments[0]
        };
      } else {
        opts = arguments.length <= 0 ? undefined : arguments[0];
      }
    } else if (arguments.length === 2) {
      opts = {
        name: arguments.length <= 0 ? undefined : arguments[0],
        test: arguments.length <= 1 ? undefined : arguments[1]
      };
    } else {
      opts = {
        name: arguments.length <= 0 ? undefined : arguments[0],
        message: arguments.length <= 1 ? undefined : arguments[1],
        test: arguments.length <= 2 ? undefined : arguments[2]
      };
    }
    if (opts.message === undefined) opts.message = mixed.default;
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
    if (opts.exclusive) {
      if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }
    if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(fn => {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }
      return true;
    });
    next.tests.push(validate);
    return next;
  }
  when(keys, options) {
    if (!Array.isArray(keys) && typeof keys !== 'string') {
      options = keys;
      keys = '.';
    }
    let next = this.clone();
    let deps = toArray(keys).map(key => new Reference(key));
    deps.forEach(dep => {
      // @ts-ignore readonly array
      if (dep.isSibling) next.deps.push(dep.key);
    });
    next.conditions.push(typeof options === 'function' ? new Condition(deps, options) : Condition.fromOptions(deps, options));
    return next;
  }
  typeError(message) {
    let next = this.clone();
    next.internalTests.typeError = createValidation({
      message,
      name: 'typeError',
      skipAbsent: true,
      test(value) {
        if (!this.schema._typeCheck(value)) return this.createError({
          params: {
            type: this.schema.type
          }
        });
        return true;
      }
    });
    return next;
  }
  oneOf(enums) {
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : mixed.oneOf;
    let next = this.clone();
    enums.forEach(val => {
      next._whitelist.add(val);
      next._blacklist.delete(val);
    });
    next.internalTests.whiteList = createValidation({
      message,
      name: 'oneOf',
      skipAbsent: true,
      test(value) {
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: Array.from(valids).join(', '),
            resolved
          }
        });
      }
    });
    return next;
  }
  notOneOf(enums) {
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : mixed.notOneOf;
    let next = this.clone();
    enums.forEach(val => {
      next._blacklist.add(val);
      next._whitelist.delete(val);
    });
    next.internalTests.blacklist = createValidation({
      message,
      name: 'notOneOf',
      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value)) return this.createError({
          params: {
            values: Array.from(invalids).join(', '),
            resolved
          }
        });
        return true;
      }
    });
    return next;
  }
  strip() {
    let strip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }

  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(options) {
    const next = (options ? this.resolve(options) : this).clone();
    const {
      label,
      meta,
      optional,
      nullable
    } = next.spec;
    const description = {
      meta,
      label,
      optional,
      nullable,
      default: next.getDefault(options),
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.map(fn => ({
        name: fn.OPTIONS.name,
        params: fn.OPTIONS.params
      })).filter((n, idx, list) => list.findIndex(c => c.name === n.name) === idx)
    };
    return description;
  }
}
// @ts-expect-error
Schema.prototype.__isYupSchema__ = true;
for (const method of ['validate', 'validateSync']) Schema.prototype["".concat(method, "At")] = function (path, value) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    parent,
    parentPath,
    schema
  } = getIn(this, path, value, options.context);
  return schema[method](parent && parent[parentPath], Object.assign({}, options, {
    parent,
    path
  }));
};
for (const alias of ['equals', 'is']) Schema.prototype[alias] = Schema.prototype.oneOf;
for (const alias of ['not', 'nope']) Schema.prototype[alias] = Schema.prototype.notOneOf;
const returnsTrue = () => true;
function create$8(spec) {
  return new MixedSchema(spec);
}
class MixedSchema extends Schema {
  constructor(spec) {
    super(typeof spec === 'function' ? {
      type: 'mixed',
      check: spec
    } : Object.assign({
      type: 'mixed',
      check: returnsTrue
    }, spec));
  }
}
create$8.prototype = MixedSchema.prototype;
function create$7() {
  return new BooleanSchema();
}
class BooleanSchema extends Schema {
  constructor() {
    super({
      type: 'boolean',
      check(v) {
        if (v instanceof Boolean) v = v.valueOf();
        return typeof v === 'boolean';
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        if (ctx.spec.coerce && !ctx.isType(value)) {
          if (/^(true|1)$/i.test(String(value))) return true;
          if (/^(false|0)$/i.test(String(value))) return false;
        }
        return value;
      });
    });
  }
  isTrue() {
    let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : boolean.isValue;
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'true'
      },
      test(value) {
        return isAbsent(value) || value === true;
      }
    });
  }
  isFalse() {
    let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : boolean.isValue;
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'false'
      },
      test(value) {
        return isAbsent(value) || value === false;
      }
    });
  }
  default(def) {
    return super.default(def);
  }
  defined(msg) {
    return super.defined(msg);
  }
  optional() {
    return super.optional();
  }
  required(msg) {
    return super.required(msg);
  }
  notRequired() {
    return super.notRequired();
  }
  nullable() {
    return super.nullable();
  }
  nonNullable(msg) {
    return super.nonNullable(msg);
  }
  strip(v) {
    return super.strip(v);
  }
}
create$7.prototype = BooleanSchema.prototype;

/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */

// prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date) {
  const struct = parseDateStruct(date);
  if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;

  // timestamps without timezone identifiers should be considered local time
  if (struct.z === undefined && struct.plusMinus === undefined) {
    return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
  }
  let totalMinutesOffset = 0;
  if (struct.z !== 'Z' && struct.plusMinus !== undefined) {
    totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
    if (struct.plusMinus === '+') totalMinutesOffset = 0 - totalMinutesOffset;
  }
  return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function parseDateStruct(date) {
  var _regexResult$7$length, _regexResult$;
  const regexResult = isoReg.exec(date);
  if (!regexResult) return null;

  // use of toNumber() avoids NaN timestamps caused by “undefined”
  // values being passed to Date constructor
  return {
    year: toNumber$2(regexResult[1]),
    month: toNumber$2(regexResult[2], 1) - 1,
    day: toNumber$2(regexResult[3], 1),
    hour: toNumber$2(regexResult[4]),
    minute: toNumber$2(regexResult[5]),
    second: toNumber$2(regexResult[6]),
    millisecond: regexResult[7] ?
    // allow arbitrary sub-second precision beyond milliseconds
    toNumber$2(regexResult[7].substring(0, 3)) : 0,
    precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
    z: regexResult[8] || undefined,
    plusMinus: regexResult[9] || undefined,
    hourOffset: toNumber$2(regexResult[10]),
    minuteOffset: toNumber$2(regexResult[11])
  };
}
function toNumber$2(str) {
  let defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return Number(str) || defaultValue;
}

// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let rEmail =
// eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let rUrl =
// eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;

// eslint-disable-next-line
let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let yearMonthDay = '^\\d{4}-\\d{2}-\\d{2}';
let hourMinuteSecond = '\\d{2}:\\d{2}:\\d{2}';
let zOrOffset = '(([+-]\\d{2}(:?\\d{2})?)|Z)';
let rIsoDateTime = new RegExp("".concat(yearMonthDay, "T").concat(hourMinuteSecond, "(\\.\\d+)?").concat(zOrOffset, "$"));
let isTrimmed = value => isAbsent(value) || value === value.trim();
let objStringTag = {}.toString();
function create$6() {
  return new StringSchema();
}
class StringSchema extends Schema {
  constructor() {
    super({
      type: 'string',
      check(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === 'string';
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        if (!ctx.spec.coerce || ctx.isType(value)) return value;

        // don't ever convert arrays
        if (Array.isArray(value)) return value;
        const strValue = value != null && value.toString ? value.toString() : value;

        // no one wants plain objects converted to [Object object]
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });
  }
  required(message) {
    return super.required(message).withMutation(schema => schema.test({
      message: message || mixed.required,
      name: 'required',
      skipAbsent: true,
      test: value => !!value.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation(schema => {
      schema.tests = schema.tests.filter(t => t.OPTIONS.name !== 'required');
      return schema;
    });
  }
  length(length) {
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : string.length;
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },
      skipAbsent: true,
      test(value) {
        return value.length === this.resolve(length);
      }
    });
  }
  min(min) {
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : string.min;
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      test(value) {
        return value.length >= this.resolve(min);
      }
    });
  }
  max(max) {
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : string.max;
    return this.test({
      name: 'max',
      exclusive: true,
      message,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value.length <= this.resolve(max);
      }
    });
  }
  matches(regex, options) {
    let excludeEmptyString = false;
    let message;
    let name;
    if (options) {
      if (typeof options === 'object') {
        ({
          excludeEmptyString = false,
          message,
          name
        } = options);
      } else {
        message = options;
      }
    }
    return this.test({
      name: name || 'matches',
      message: message || string.matches,
      params: {
        regex
      },
      skipAbsent: true,
      test: value => value === '' && excludeEmptyString || value.search(regex) !== -1
    });
  }
  email() {
    let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.email;
    return this.matches(rEmail, {
      name: 'email',
      message,
      excludeEmptyString: true
    });
  }
  url() {
    let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.url;
    return this.matches(rUrl, {
      name: 'url',
      message,
      excludeEmptyString: true
    });
  }
  uuid() {
    let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.uuid;
    return this.matches(rUUID, {
      name: 'uuid',
      message,
      excludeEmptyString: false
    });
  }
  datetime(options) {
    let message = '';
    let allowOffset;
    let precision;
    if (options) {
      if (typeof options === 'object') {
        ({
          message = '',
          allowOffset = false,
          precision = undefined
        } = options);
      } else {
        message = options;
      }
    }
    return this.matches(rIsoDateTime, {
      name: 'datetime',
      message: message || string.datetime,
      excludeEmptyString: true
    }).test({
      name: 'datetime_offset',
      message: message || string.datetime_offset,
      params: {
        allowOffset
      },
      skipAbsent: true,
      test: value => {
        if (!value || allowOffset) return true;
        const struct = parseDateStruct(value);
        if (!struct) return false;
        return !!struct.z;
      }
    }).test({
      name: 'datetime_precision',
      message: message || string.datetime_precision,
      params: {
        precision
      },
      skipAbsent: true,
      test: value => {
        if (!value || precision == undefined) return true;
        const struct = parseDateStruct(value);
        if (!struct) return false;
        return struct.precision === precision;
      }
    });
  }

  //-- transforms --
  ensure() {
    return this.default('').transform(val => val === null ? '' : val);
  }
  trim() {
    let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.trim;
    return this.transform(val => val != null ? val.trim() : val).test({
      message,
      name: 'trim',
      test: isTrimmed
    });
  }
  lowercase() {
    let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.lowercase;
    return this.transform(value => !isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      skipAbsent: true,
      test: value => isAbsent(value) || value === value.toLowerCase()
    });
  }
  uppercase() {
    let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.uppercase;
    return this.transform(value => !isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      skipAbsent: true,
      test: value => isAbsent(value) || value === value.toUpperCase()
    });
  }
}
create$6.prototype = StringSchema.prototype;

//
// String Interfaces
//

let isNaN$1 = value => value != +value;
function create$5() {
  return new NumberSchema();
}
class NumberSchema extends Schema {
  constructor() {
    super({
      type: 'number',
      check(value) {
        if (value instanceof Number) value = value.valueOf();
        return typeof value === 'number' && !isNaN$1(value);
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        if (!ctx.spec.coerce) return value;
        let parsed = value;
        if (typeof parsed === 'string') {
          parsed = parsed.replace(/\s/g, '');
          if (parsed === '') return NaN;
          // don't use parseFloat to avoid positives on alpha-numeric strings
          parsed = +parsed;
        }

        // null -> NaN isn't useful; treat all nulls as null and let it fail on
        // nullability check vs TypeErrors
        if (ctx.isType(parsed) || parsed === null) return parsed;
        return parseFloat(parsed);
      });
    });
  }
  min(min) {
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : number$1.min;
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      test(value) {
        return value >= this.resolve(min);
      }
    });
  }
  max(max) {
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : number$1.max;
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value <= this.resolve(max);
      }
    });
  }
  lessThan(less) {
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : number$1.lessThan;
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        less
      },
      skipAbsent: true,
      test(value) {
        return value < this.resolve(less);
      }
    });
  }
  moreThan(more) {
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : number$1.moreThan;
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        more
      },
      skipAbsent: true,
      test(value) {
        return value > this.resolve(more);
      }
    });
  }
  positive() {
    let msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : number$1.positive;
    return this.moreThan(0, msg);
  }
  negative() {
    let msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : number$1.negative;
    return this.lessThan(0, msg);
  }
  integer() {
    let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : number$1.integer;
    return this.test({
      name: 'integer',
      message,
      skipAbsent: true,
      test: val => Number.isInteger(val)
    });
  }
  truncate() {
    return this.transform(value => !isAbsent(value) ? value | 0 : value);
  }
  round(method) {
    var _method;
    let avail = ['ceil', 'floor', 'round', 'trunc'];
    method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round';

    // this exists for symemtry with the new Math.trunc
    if (method === 'trunc') return this.truncate();
    if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
    return this.transform(value => !isAbsent(value) ? Math[method](value) : value);
  }
}
create$5.prototype = NumberSchema.prototype;

//
// Number Interfaces
//

let invalidDate = new Date('');
let isDate = obj => Object.prototype.toString.call(obj) === '[object Date]';
function create$4() {
  return new DateSchema();
}
class DateSchema extends Schema {
  constructor() {
    super({
      type: 'date',
      check(v) {
        return isDate(v) && !isNaN(v.getTime());
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
        // nullability check vs TypeErrors
        if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
        value = parseIsoDate(value);

        // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
        return !isNaN(value) ? new Date(value) : DateSchema.INVALID_DATE;
      });
    });
  }
  prepareParam(ref, name) {
    let param;
    if (!Reference.isRef(ref)) {
      let cast = this.cast(ref);
      if (!this._typeCheck(cast)) throw new TypeError("`".concat(name, "` must be a Date or a value that can be `cast()` to a Date"));
      param = cast;
    } else {
      param = ref;
    }
    return param;
  }
  min(min) {
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : date.min;
    let limit = this.prepareParam(min, 'min');
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      test(value) {
        return value >= this.resolve(limit);
      }
    });
  }
  max(max) {
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : date.max;
    let limit = this.prepareParam(max, 'max');
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value <= this.resolve(limit);
      }
    });
  }
}
DateSchema.INVALID_DATE = invalidDate;
create$4.prototype = DateSchema.prototype;
create$4.INVALID_DATE = invalidDate;

// @ts-expect-error
function sortFields(fields) {
  let excludedEdges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let edges = [];
  let nodes = new Set();
  let excludes = new Set(excludedEdges.map(_ref161 => {
    let [a, b] = _ref161;
    return "".concat(a, "-").concat(b);
  }));
  function addNode(depPath, key) {
    let node = propertyExpr.split(depPath)[0];
    nodes.add(node);
    if (!excludes.has("".concat(key, "-").concat(node))) edges.push([key, node]);
  }
  for (const key of Object.keys(fields)) {
    let value = fields[key];
    nodes.add(key);
    if (Reference.isRef(value) && value.isSibling) addNode(value.path, key);else if (isSchema(value) && 'deps' in value) value.deps.forEach(path => addNode(path, key));
  }
  return toposort$1.array(Array.from(nodes), edges).reverse();
}
function findIndex(arr, err) {
  let idx = Infinity;
  arr.some((key, ii) => {
    var _err$path;
    if ((_err$path = err.path) != null && _err$path.includes(key)) {
      idx = ii;
      return true;
    }
  });
  return idx;
}
function sortByKeyOrder(keys) {
  return (a, b) => {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}
const parseJson = (value, _, ctx) => {
  if (typeof value !== 'string') {
    return value;
  }
  let parsed = value;
  try {
    parsed = JSON.parse(value);
  } catch (err) {
    /* */
  }
  return ctx.isType(parsed) ? parsed : value;
};

// @ts-ignore
function deepPartial(schema) {
  if ('fields' in schema) {
    const partial = {};
    for (const [key, fieldSchema] of Object.entries(schema.fields)) {
      partial[key] = deepPartial(fieldSchema);
    }
    return schema.setFields(partial);
  }
  if (schema.type === 'array') {
    const nextArray = schema.optional();
    if (nextArray.innerType) nextArray.innerType = deepPartial(nextArray.innerType);
    return nextArray;
  }
  if (schema.type === 'tuple') {
    return schema.optional().clone({
      types: schema.spec.types.map(deepPartial)
    });
  }
  if ('optional' in schema) {
    return schema.optional();
  }
  return schema;
}
const deepHas = (obj, p) => {
  const path = [...propertyExpr.normalizePath(p)];
  if (path.length === 1) return path[0] in obj;
  let last = path.pop();
  let parent = propertyExpr.getter(propertyExpr.join(path), true)(obj);
  return !!(parent && last in parent);
};
let isObject$3 = obj => Object.prototype.toString.call(obj) === '[object Object]';
function unknown(ctx, value) {
  let known = Object.keys(ctx.fields);
  return Object.keys(value).filter(key => known.indexOf(key) === -1);
}
const defaultSort = sortByKeyOrder([]);
function create$3(spec) {
  return new ObjectSchema(spec);
}
class ObjectSchema extends Schema {
  constructor(spec) {
    super({
      type: 'object',
      check(value) {
        return isObject$3(value) || typeof value === 'function';
      }
    });
    this.fields = Object.create(null);
    this._sortErrors = defaultSort;
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(() => {
      if (spec) {
        this.shape(spec);
      }
    });
  }
  _cast(_value) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$stripUnknown;
    let value = super._cast(_value, options);

    //should ignore nulls here
    if (value === undefined) return this.getDefault(options);
    if (!this._typeCheck(value)) return value;
    let fields = this.fields;
    let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
    let props = [].concat(this._nodes, Object.keys(value).filter(v => !this._nodes.includes(v)));
    let intermediateValue = {}; // is filled during the transform below
    let innerOptions = Object.assign({}, options, {
      parent: intermediateValue,
      __validating: options.__validating || false
    });
    let isChanged = false;
    for (const prop of props) {
      let field = fields[prop];
      let exists = (prop in value);
      if (field) {
        let fieldValue;
        let inputValue = value[prop];

        // safe to mutate since this is fired in sequence
        innerOptions.path = (options.path ? "".concat(options.path, ".") : '') + prop;
        field = field.resolve({
          value: inputValue,
          context: options.context,
          parent: intermediateValue
        });
        let fieldSpec = field instanceof Schema ? field.spec : undefined;
        let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
        if (fieldSpec != null && fieldSpec.strip) {
          isChanged = isChanged || prop in value;
          continue;
        }
        fieldValue = !options.__validating || !strict ?
        // TODO: use _cast, this is double resolving
        field.cast(value[prop], innerOptions) : value[prop];
        if (fieldValue !== undefined) {
          intermediateValue[prop] = fieldValue;
        }
      } else if (exists && !strip) {
        intermediateValue[prop] = value[prop];
      }
      if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) {
        isChanged = true;
      }
    }
    return isChanged ? intermediateValue : value;
  }
  _validate(_value) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let panic = arguments.length > 2 ? arguments[2] : undefined;
    let next = arguments.length > 3 ? arguments[3] : undefined;
    let {
      from = [],
      originalValue = _value,
      recursive = this.spec.recursive
    } = options;
    options.from = [{
      schema: this,
      value: originalValue
    }, ...from];
    // this flag is needed for handling `strict` correctly in the context of
    // validation vs just casting. e.g strict() on a field is only used when validating
    options.__validating = true;
    options.originalValue = originalValue;
    super._validate(_value, options, panic, (objectErrors, value) => {
      if (!recursive || !isObject$3(value)) {
        next(objectErrors, value);
        return;
      }
      originalValue = originalValue || value;
      let tests = [];
      for (let key of this._nodes) {
        let field = this.fields[key];
        if (!field || Reference.isRef(field)) {
          continue;
        }
        tests.push(field.asNestedTest({
          options,
          key,
          parent: value,
          parentPath: options.path,
          originalParent: originalValue
        }));
      }
      this.runTests({
        tests,
        value,
        originalValue,
        options
      }, panic, fieldErrors => {
        next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
      });
    });
  }
  clone(spec) {
    const next = super.clone(spec);
    next.fields = Object.assign({}, this.fields);
    next._nodes = this._nodes;
    next._excludedEdges = this._excludedEdges;
    next._sortErrors = this._sortErrors;
    return next;
  }
  concat(schema) {
    let next = super.concat(schema);
    let nextFields = next.fields;
    for (let [field, schemaOrRef] of Object.entries(this.fields)) {
      const target = nextFields[field];
      nextFields[field] = target === undefined ? schemaOrRef : target;
    }
    return next.withMutation(s =>
    // XXX: excludes here is wrong
    s.setFields(nextFields, [...this._excludedEdges, ...schema._excludedEdges]));
  }
  _getDefault(options) {
    if ('default' in this.spec) {
      return super._getDefault(options);
    }

    // if there is no default set invent one
    if (!this._nodes.length) {
      return undefined;
    }
    let dft = {};
    this._nodes.forEach(key => {
      var _innerOptions;
      const field = this.fields[key];
      let innerOptions = options;
      if ((_innerOptions = innerOptions) != null && _innerOptions.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[key]
        });
      }
      dft[key] = field && 'getDefault' in field ? field.getDefault(innerOptions) : undefined;
    });
    return dft;
  }
  setFields(shape, excludedEdges) {
    let next = this.clone();
    next.fields = shape;
    next._nodes = sortFields(shape, excludedEdges);
    next._sortErrors = sortByKeyOrder(Object.keys(shape));
    // XXX: this carries over edges which may not be what you want
    if (excludedEdges) next._excludedEdges = excludedEdges;
    return next;
  }
  shape(additions) {
    let excludes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return this.clone().withMutation(next => {
      let edges = next._excludedEdges;
      if (excludes.length) {
        if (!Array.isArray(excludes[0])) excludes = [excludes];
        edges = [...next._excludedEdges, ...excludes];
      }

      // XXX: excludes here is wrong
      return next.setFields(Object.assign(next.fields, additions), edges);
    });
  }
  partial() {
    const partial = {};
    for (const [key, schema] of Object.entries(this.fields)) {
      partial[key] = 'optional' in schema && schema.optional instanceof Function ? schema.optional() : schema;
    }
    return this.setFields(partial);
  }
  deepPartial() {
    const next = deepPartial(this);
    return next;
  }
  pick(keys) {
    const picked = {};
    for (const key of keys) {
      if (this.fields[key]) picked[key] = this.fields[key];
    }
    return this.setFields(picked, this._excludedEdges.filter(_ref162 => {
      let [a, b] = _ref162;
      return keys.includes(a) && keys.includes(b);
    }));
  }
  omit(keys) {
    const remaining = [];
    for (const key of Object.keys(this.fields)) {
      if (keys.includes(key)) continue;
      remaining.push(key);
    }
    return this.pick(remaining);
  }
  from(from, to, alias) {
    let fromGetter = propertyExpr.getter(from, true);
    return this.transform(obj => {
      if (!obj) return obj;
      let newObj = obj;
      if (deepHas(obj, from)) {
        newObj = Object.assign({}, obj);
        if (!alias) delete newObj[from];
        newObj[to] = fromGetter(obj);
      }
      return newObj;
    });
  }

  /** Parse an input JSON string to an object */
  json() {
    return this.transform(parseJson);
  }

  /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */
  exact(message) {
    return this.test({
      name: 'exact',
      exclusive: true,
      message: message || object.exact,
      test(value) {
        if (value == null) return true;
        const unknownKeys = unknown(this.schema, value);
        return unknownKeys.length === 0 || this.createError({
          params: {
            properties: unknownKeys.join(', ')
          }
        });
      }
    });
  }
  stripUnknown() {
    return this.clone({
      noUnknown: true
    });
  }
  noUnknown() {
    let noAllow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : object.noUnknown;
    if (typeof noAllow !== 'boolean') {
      message = noAllow;
      noAllow = true;
    }
    let next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,
      test(value) {
        if (value == null) return true;
        const unknownKeys = unknown(this.schema, value);
        return !noAllow || unknownKeys.length === 0 || this.createError({
          params: {
            unknown: unknownKeys.join(', ')
          }
        });
      }
    });
    next.spec.noUnknown = noAllow;
    return next;
  }
  unknown() {
    let allow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : object.noUnknown;
    return this.noUnknown(!allow, message);
  }
  transformKeys(fn) {
    return this.transform(obj => {
      if (!obj) return obj;
      const result = {};
      for (const key of Object.keys(obj)) result[fn(key)] = obj[key];
      return result;
    });
  }
  camelCase() {
    return this.transformKeys(tinyCase.camelCase);
  }
  snakeCase() {
    return this.transformKeys(tinyCase.snakeCase);
  }
  constantCase() {
    return this.transformKeys(key => tinyCase.snakeCase(key).toUpperCase());
  }
  describe(options) {
    const next = (options ? this.resolve(options) : this).clone();
    const base = super.describe(options);
    base.fields = {};
    for (const [key, value] of Object.entries(next.fields)) {
      var _innerOptions2;
      let innerOptions = options;
      if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[key]
        });
      }
      base.fields[key] = value.describe(innerOptions);
    }
    return base;
  }
}
create$3.prototype = ObjectSchema.prototype;
function create$2(type) {
  return new ArraySchema(type);
}
class ArraySchema extends Schema {
  constructor(type) {
    super({
      type: 'array',
      spec: {
        types: type
      },
      check(v) {
        return Array.isArray(v);
      }
    });

    // `undefined` specifically means uninitialized, as opposed to "no subtype"
    this.innerType = void 0;
    this.innerType = type;
  }
  _cast(_value, _opts) {
    const value = super._cast(_value, _opts);

    // should ignore nulls here
    if (!this._typeCheck(value) || !this.innerType) {
      return value;
    }
    let isChanged = false;
    const castArray = value.map((v, idx) => {
      const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
        path: "".concat(_opts.path || '', "[").concat(idx, "]")
      }));
      if (castElement !== v) {
        isChanged = true;
      }
      return castElement;
    });
    return isChanged ? castArray : value;
  }
  _validate(_value) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let panic = arguments.length > 2 ? arguments[2] : undefined;
    let next = arguments.length > 3 ? arguments[3] : undefined;
    var _options$recursive;
    // let sync = options.sync;
    // let path = options.path;
    let innerType = this.innerType;
    // let endEarly = options.abortEarly ?? this.spec.abortEarly;
    let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
    options.originalValue != null ? options.originalValue : _value;
    super._validate(_value, options, panic, (arrayErrors, value) => {
      var _options$originalValu2;
      if (!recursive || !innerType || !this._typeCheck(value)) {
        next(arrayErrors, value);
        return;
      }

      // #950 Ensure that sparse array empty slots are validated
      let tests = new Array(value.length);
      for (let index = 0; index < value.length; index++) {
        var _options$originalValu;
        tests[index] = innerType.asNestedTest({
          options,
          index,
          parent: value,
          parentPath: options.path,
          originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
        });
      }
      this.runTests({
        value,
        tests,
        originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
        options
      }, panic, innerTypeErrors => next(innerTypeErrors.concat(arrayErrors), value));
    });
  }
  clone(spec) {
    const next = super.clone(spec);
    // @ts-expect-error readonly
    next.innerType = this.innerType;
    return next;
  }

  /** Parse an input JSON string to an object */
  json() {
    return this.transform(parseJson);
  }
  concat(schema) {
    let next = super.concat(schema);

    // @ts-expect-error readonly
    next.innerType = this.innerType;
    if (schema.innerType)
      // @ts-expect-error readonly
      next.innerType = next.innerType ?
      // @ts-expect-error Lazy doesn't have concat and will break
      next.innerType.concat(schema.innerType) : schema.innerType;
    return next;
  }
  of(schema) {
    // FIXME: this should return a new instance of array without the default to be
    let next = this.clone();
    if (!isSchema(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + printValue(schema));

    // @ts-expect-error readonly
    next.innerType = schema;
    next.spec = Object.assign({}, next.spec, {
      types: schema
    });
    return next;
  }
  length(length) {
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : array.length;
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },
      skipAbsent: true,
      test(value) {
        return value.length === this.resolve(length);
      }
    });
  }
  min(min, message) {
    message = message || array.min;
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      // FIXME(ts): Array<typeof T>
      test(value) {
        return value.length >= this.resolve(min);
      }
    });
  }
  max(max, message) {
    message = message || array.max;
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value.length <= this.resolve(max);
      }
    });
  }
  ensure() {
    return this.default(() => []).transform((val, original) => {
      // We don't want to return `null` for nullable schema
      if (this._typeCheck(val)) return val;
      return original == null ? [] : [].concat(original);
    });
  }
  compact(rejector) {
    let reject = !rejector ? v => !!v : (v, i, a) => !rejector(v, i, a);
    return this.transform(values => values != null ? values.filter(reject) : values);
  }
  describe(options) {
    const next = (options ? this.resolve(options) : this).clone();
    const base = super.describe(options);
    if (next.innerType) {
      var _innerOptions;
      let innerOptions = options;
      if ((_innerOptions = innerOptions) != null && _innerOptions.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[0]
        });
      }
      base.innerType = next.innerType.describe(innerOptions);
    }
    return base;
  }
}
create$2.prototype = ArraySchema.prototype;
const isoDateStringRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/;
const CustomFieldTemplateSchema = create$3().shape({
  _id: create$6(),
  _client_id: create$6(),
  order: create$5(),
  status: create$8().oneOf(Object.values(Status)),
  company: create$6(),
  category: create$8().oneOf(Object.values(Category)),
  type: create$8().oneOf(Object.values(TemplateType)),
  canResourceEdit: create$7(),
  isRequired: create$7(),
  isChoicesSortedAlphabetically: create$7().required(),
  label: create$6().required('Custom Field Label is required'),
  deleted: create$7(),
  shouldDelete: create$7(),
  instructions: create$6(),
  defaultValue: create$6(),
  defaultRadioId: create$6(),
  placeholderText: create$6(),
  characterLimit: create$5().integer().min(0),
  minValue: create$5(),
  maxValue: create$5(),
  stepValue: create$5(),
  choices: create$2().of(create$3().shape({
    value: create$6()
  })),
  allowMultipleValues: create$7(),
  weekStartOn: create$8().oneOf(Object.values(DaysOfWeek)),
  createdDate: create$6().matches(isoDateStringRegex, 'Invalid date format'),
  updatedDate: create$6().matches(isoDateStringRegex, 'Invalid date format'),
  deletedDate: create$6().matches(isoDateStringRegex, 'Invalid date format'),
  filterGrid: create$7()
});
const validateCustomFields = (customFields, callback) => __awaiter(void 0, void 0, void 0, function* () {
  const newErrors = {};
  let firstInvalidFieldId = null;
  for (let i = 0; i < customFields.length; i++) {
    const field = customFields[i];
    try {
      yield CustomFieldTemplateSchema.validate(field, {
        abortEarly: false
      });
    } catch (error) {
      if (error instanceof ValidationError) {
        const fieldId = getFieldKey(field);
        newErrors[fieldId] = error.inner.reduce((acc, err) => {
          if (err.path) {
            acc[err.path] = err.message;
          }
          return acc;
        }, {});
        if (firstInvalidFieldId === null) {
          firstInvalidFieldId = fieldId;
          if (typeof callback === 'function') {
            callback();
          }
        }
      }
    }
  }
  if (Object.keys(newErrors).length) {
    console.error({
      newErrors
    });
  }
  return [newErrors, firstInvalidFieldId];
});
var CustomFieldsActions;
(function (CustomFieldsActions) {
  CustomFieldsActions["ADD_FIELD"] = "ADD_FIELD";
  CustomFieldsActions["UPDATE_FIELD"] = "UPDATE_FIELD";
  CustomFieldsActions["DELETE_FIELD"] = "DELETE_FIELD";
  CustomFieldsActions["SET_FIELDS"] = "SET_FIELDS";
  CustomFieldsActions["RESET_STATE"] = "RESET_STATE";
  CustomFieldsActions["SAVE_STATE"] = "SAVE_STATE";
  CustomFieldsActions["COPY_FIELD"] = "COPY_FIELD";
})(CustomFieldsActions || (CustomFieldsActions = {}));
const findFieldIndex = (fields, fieldToFind) => fields.findIndex(field => field._id && field._id === fieldToFind._id || field._client_id && field._client_id === fieldToFind._client_id);
const getSortedFields = fields => fields.map((item, index) => Object.assign(Object.assign({}, item), {
  order: index
})).sort((a, b) => {
  var _a, _b;
  return ((_a = a.order) !== null && _a !== void 0 ? _a : 0) - ((_b = b.order) !== null && _b !== void 0 ? _b : 0);
});
const customFieldsReducer = (state, action) => {
  switch (action.type) {
    case CustomFieldsActions.ADD_FIELD:
      return Object.assign(Object.assign({}, state), {
        customFields: [...state.customFields, action.payload]
      });
    case CustomFieldsActions.UPDATE_FIELD:
      {
        const fieldToUpdate = action.payload;
        const fieldIndex = findFieldIndex(state.customFields, fieldToUpdate);
        if (fieldIndex === -1) {
          return state;
        }
        if (JSON.stringify(state.customFields[fieldIndex]) !== JSON.stringify(fieldToUpdate)) {
          const updatedField = Object.assign(Object.assign({}, state.customFields[fieldIndex]), fieldToUpdate);
          return Object.assign(Object.assign({}, state), {
            customFields: [...state.customFields.slice(0, fieldIndex), updatedField, ...state.customFields.slice(fieldIndex + 1)]
          });
        }
        return state;
      }
    case CustomFieldsActions.DELETE_FIELD:
      if (!action.payload._id) {
        return Object.assign(Object.assign({}, state), {
          customFields: state.customFields.filter(item => getFieldKey(action.payload) !== getFieldKey(item))
        });
      }
      return Object.assign(Object.assign({}, state), {
        customFields: state.customFields.map(item => Object.assign(Object.assign({}, item), {
          shouldDelete: (item === null || item === void 0 ? void 0 : item.shouldDelete) || getFieldKey(action.payload) === getFieldKey(item)
        }))
      });
    case CustomFieldsActions.SET_FIELDS:
      return Object.assign(Object.assign({}, state), {
        customFields: action.payload,
        initialized: true
      });
    case CustomFieldsActions.RESET_STATE:
      return Object.assign(Object.assign({}, state), {
        customFields: action.payload
      });
    case CustomFieldsActions.SAVE_STATE:
      return Object.assign(Object.assign({}, state), {
        customFields: action.payload.customFields
      });
    case CustomFieldsActions.COPY_FIELD:
      {
        const {
          field,
          targetIndex
        } = action.payload;
        const sortedFields = getSortedFields(state.customFields);
        const updatedFields = [...sortedFields];
        updatedFields.splice(targetIndex, 0, field);
        return Object.assign(Object.assign({}, state), {
          customFields: updatedFields.map((item, index) => Object.assign(Object.assign({}, item), {
            order: index
          }))
        });
      }
    default:
      return state;
  }
};
const CustomFieldsContext = /*#__PURE__*/createContext(undefined);
const defaultHandlers = {
  tabName: 'Custom Fields',
  // Ensure this is typed as a string literal
  saveTabName: () => null,
  toggleCustomFields: () => null,
  sendNotification: () => null,
  moveCustomFields: (cfgId, targetCfgId, customFields) => Promise.resolve(),
  copyCustomFields: (targetCfgIds, customFields) => Promise.resolve(),
  customFieldsOn: true
};
const CustomFieldsProvider = _ref163 => {
  let {
    children,
    customFields,
    updateCustomFields,
    sendNotification,
    category,
    customFieldGroups,
    entities,
    items,
    addEntity,
    removeEntity,
    addItem,
    removeItem,
    createCustomFieldGroup,
    updateCustomFieldGroup,
    deleteCustomFieldGroup,
    updateEntities,
    updateItems,
    isCFGExtensionInstalled,
    isCFExtensionInstalled,
    selectedGroupHandler,
    initialized,
    onCustomFieldsChange,
    toggleCustomFields: _toggleCustomFields = defaultHandlers.toggleCustomFields,
    customFieldsOn: _customFieldsOn2 = defaultHandlers.customFieldsOn,
    onCFsValidation,
    copyCustomFields: _copyCustomFields = defaultHandlers.copyCustomFields,
    moveCustomFields: _moveCustomFields = defaultHandlers.moveCustomFields
  } = _ref163;
  const [openItem, setOpenItem] = useState('');
  const [focusedItem, setFocusedItem] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [_customFieldsOn, _setCustomFieldsOn] = useState(_customFieldsOn2);
  const [state, dispatch] = useReducer(customFieldsReducer, {
    customFields,
    initialized: false
  });
  const previousCustomFields = useRef(customFields);
  const onCustomFieldsChangeRef = useRef(onCustomFieldsChange);
  useEffect(() => {
    onCustomFieldsChangeRef.current = onCustomFieldsChange;
  }, [onCustomFieldsChange]);
  const debouncedCallback = useRef(lodash.exports.debounce(fields => {
    if (onCustomFieldsChangeRef.current) {
      const hasChanged = !lodash.exports.isEqual(fields, previousCustomFields.current);
      if (hasChanged) {
        previousCustomFields.current = fields;
        onCustomFieldsChangeRef.current(fields);
      }
    }
  }, 250)).current;
  useEffect(() => {
    debouncedCallback(state.customFields);
    return () => {
      debouncedCallback.cancel();
    };
  }, [state.customFields, debouncedCallback]);
  const [errors, setErrors] = useState({});
  const [disabled, setDisabled] = useState(true);
  const defaultHandler = [undefined, () => undefined];
  const [selectedGroup, setSelectedGroup] = selectedGroupHandler !== null && selectedGroupHandler !== void 0 ? selectedGroupHandler : defaultHandler;
  const isEdited = useMemo(() => {
    const normalizeField = (field, index) => Object.assign(Object.assign({}, field), {
      order: index,
      shouldDelete: undefined
    });
    const stateFields = state.customFields.reduce((acc, field) => field.shouldDelete ? acc : [...acc, normalizeField(field, acc.length)], []);
    if (stateFields.length !== customFields.length) {
      return true;
    }
    const propFields = customFields.map((field, index) => normalizeField(field, index));
    const stateString = JSON.stringify(stateFields);
    const propString = JSON.stringify(propFields);
    if (stateString === propString) {
      return false;
    }
    return !lodash.exports.isEqual(stateFields, propFields);
  }, [state.customFields, customFields]);
  useEffect(() => {
    if (isEdited) {
      setDisabled(false);
    }
  }, [isEdited]);
  const dragContainerRef = useRef(null);
  const fieldRefs = useRef({});
  const customFieldsScrollRef = useRef(null);
  const addFieldRef = useCallback((element, itemId) => {
    if (fieldRefs.current[itemId]) {
      return;
    }
    if (element) {
      fieldRefs.current[itemId] = element;
    }
  }, [fieldRefs]);
  const scrollToField = useCallback((index, itemId) => {
    var _a, _b, _c;
    if (((_a = customFieldsScrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollToIndex) !== undefined) {
      return (_c = (_b = customFieldsScrollRef.current) === null || _b === void 0 ? void 0 : _b.scrollToIndex) === null || _c === void 0 ? void 0 : _c.call(_b, index);
    }
    if (fieldRefs.current[itemId]) {
      return fieldRefs.current[itemId].scrollIntoView({
        block: 'start',
        inline: 'start',
        behavior: 'smooth'
      });
    }
  }, [customFieldsScrollRef]);
  const handleNotification = useCallback((message, type) => {
    if (sendNotification) {
      sendNotification(message, type);
    }
  }, [sendNotification]);
  const handleToggleCustomFields = useCallback(on => {
    if (_toggleCustomFields) {
      _toggleCustomFields(on);
    }
  }, [_toggleCustomFields]);
  const openItemId = (itemId, index) => {
    setOpenItem(itemId);
    setFocusedItem(itemId);
    setTimeout(() => {
      if (index !== undefined) {
        scrollToField(index, itemId);
      }
    }, 100);
  };
  useEffect(() => {
    if (initialized) {
      dispatch({
        type: CustomFieldsActions.SET_FIELDS,
        payload: customFields
      });
    }
  }, [customFields, initialized]);
  const updateState = useCallback(action => __awaiter(void 0, void 0, void 0, function* () {
    let updatedFields;
    try {
      switch (action.type) {
        case CustomFieldsActions.COPY_FIELD:
          dispatch(action);
          break;
        case CustomFieldsActions.ADD_FIELD:
          dispatch(Object.assign(Object.assign({}, action), {
            payload: action.payload
          }));
          break;
        case CustomFieldsActions.UPDATE_FIELD:
          dispatch(action);
          break;
        case CustomFieldsActions.DELETE_FIELD:
          dispatch(action);
          break;
        case CustomFieldsActions.SET_FIELDS:
          dispatch(Object.assign(Object.assign({}, action), {
            payload: action.payload
          }));
          break;
        case CustomFieldsActions.RESET_STATE:
          dispatch(Object.assign(Object.assign({}, action), {
            payload: action.payload
          }));
          break;
        case CustomFieldsActions.SAVE_STATE:
          setLoading(true);
          setDisabled(true);
          // remove id frontend/app-modules/src/lib/custom-field-groups/utils/custom-fields.ts:8
          updatedFields = yield updateCustomFields(action.payload.customFields.map(item => {
            var _a;
            return Object.assign(Object.assign({}, item), {
              _client_id: ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.withClientId) && (item === null || item === void 0 ? void 0 : item._client_id) ? item._client_id : undefined
            });
          }).map((item, index) => Object.assign(Object.assign({}, item), {
            order: index
          }))).catch(e => {
            console.error(e);
            setDisabled(false);
            handleNotification('Failed to save custom fields', 'warning');
          }).finally(() => setLoading(false));
          if (updatedFields && selectedGroup && setSelectedGroup) {
            handleNotification('Custom Fields saved.', 'success');
            dispatch(Object.assign(Object.assign({}, action), {
              payload: {
                customFields: updatedFields.filter(field => !field.shouldDelete)
              }
            }));
            yield updateCustomFieldGroup(selectedGroup._id, {
              customFields: updatedFields.map(field => field._id)
            });
            setSelectedGroup(Object.assign(Object.assign({}, selectedGroup), {
              customFields: updatedFields.map(field => field._id)
            }));
          }
          break;
        default:
          throw new Error("Unsupported action type: ".concat(action.type));
      }
    } catch (error) {
      console.error('Error updating custom fields:', error);
      throw error;
    }
  }), [updateCustomFields, handleNotification, updateCustomFieldGroup, setSelectedGroup, selectedGroup]);
  const resetState = () => __awaiter(void 0, void 0, void 0, function* () {
    yield updateState({
      type: CustomFieldsActions.RESET_STATE,
      payload: customFields
    });
    setErrors({});
  });
  const validateFields = () => __awaiter(void 0, void 0, void 0, function* () {
    const [newErrors, firstInvalidFieldId] = yield validateCustomFields(state.customFields, () => handleNotification('Some Custom Fields could not be validated.', 'warning'));
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0 && firstInvalidFieldId) {
      const index = state.customFields.findIndex(field => getFieldKey(field) === firstInvalidFieldId);
      if ((fieldRefs === null || fieldRefs === void 0 ? void 0 : fieldRefs.current) && firstInvalidFieldId in fieldRefs.current) {
        const firstInvalidInput = fieldRefs.current[firstInvalidFieldId];
        if (firstInvalidInput && index !== -1) {
          openItemId(firstInvalidFieldId, index);
        }
      } else if (index !== -1) {
        openItemId(firstInvalidFieldId, index);
      }
      return false;
    }
    return true;
  });
  const saveState = withClientId => __awaiter(void 0, void 0, void 0, function* () {
    try {
      setOpenItem('');
      const isValid = yield validateFields();
      if (!isValid) {
        return false;
      }
      yield updateState({
        type: CustomFieldsActions.SAVE_STATE,
        payload: {
          customFields: state.customFields,
          withClientId
        }
      });
      setOpenItem('');
      return true;
    } catch (error) {
      console.error('Error saving state:', error);
      return false;
    }
  });
  const addField = field => __awaiter(void 0, void 0, void 0, function* () {
    if (selectedGroup && setSelectedGroup) {
      setSelectedGroup(Object.assign(Object.assign({}, selectedGroup), {
        customFields: [...selectedGroup.customFields, getFieldKey(field)]
      }));
    }
    yield updateState({
      type: CustomFieldsActions.ADD_FIELD,
      payload: field
    });
  });
  const updateField = field => __awaiter(void 0, void 0, void 0, function* () {
    yield updateState({
      type: CustomFieldsActions.UPDATE_FIELD,
      payload: field
    });
  });
  const deleteField = item => __awaiter(void 0, void 0, void 0, function* () {
    resetErrorState(getFieldKey(item));
    yield updateState({
      type: CustomFieldsActions.DELETE_FIELD,
      payload: item
    });
  });
  const setFields = fields => __awaiter(void 0, void 0, void 0, function* () {
    yield updateState({
      type: CustomFieldsActions.SET_FIELDS,
      payload: fields
    });
  });
  const duplicateField = (field, targetIndex) => __awaiter(void 0, void 0, void 0, function* () {
    yield updateState({
      type: CustomFieldsActions.COPY_FIELD,
      payload: {
        field,
        targetIndex
      }
    });
  });
  const addError = (id, path, message) => {
    setErrors(prev => Object.assign(Object.assign({}, prev), {
      [id]: Object.assign(Object.assign({}, prev[id] || {}), {
        [path]: message
      })
    }));
  };
  const resetErrorState = fieldId => {
    setErrors(prevErrors => {
      const fieldErrors = prevErrors[fieldId];
      if (!fieldErrors) return prevErrors;
      const newErrors = prevErrors;
      delete newErrors[fieldId];
      return newErrors;
    });
  };
  const removeError = (fieldId, path) => {
    setErrors(prevErrors => {
      const fieldErrors = prevErrors[fieldId];
      if (!fieldErrors) return prevErrors;
      const newFieldErrors = Object.assign({}, fieldErrors);
      delete newFieldErrors[path];
      if (Object.keys(newFieldErrors).length === 0) {
        const newErrors = Object.assign({}, prevErrors);
        delete newErrors[fieldId];
        return newErrors;
      } else {
        return Object.assign(Object.assign({}, prevErrors), {
          [fieldId]: newFieldErrors
        });
      }
    });
  };
  const toggleCustomFieldsOn = on => __awaiter(void 0, void 0, void 0, function* () {
    _setCustomFieldsOn(on);
    handleToggleCustomFields(on);
  });
  const matchesTypeAlias = useCallback((fieldType, searchTerm) => {
    const TYPE_ALIASES = {
      select: ['dropdown', 'select', 'choice'],
      dropdown: ['select', 'dropdown', 'choice'],
      text: ['input', 'text', 'string', 'text field'],
      number: ['numeric', 'number', 'integer'],
      boolean: ['checkbox', 'boolean', 'yes/no'],
      date: ['calendar', 'date', 'datetime']
    };
    const fieldTypeLower = fieldType.toLowerCase();
    const searchTermLower = searchTerm.toLowerCase();
    if (fieldTypeLower.includes(searchTermLower)) {
      return true;
    }
    for (const [type, aliases] of Object.entries(TYPE_ALIASES)) {
      if (fieldTypeLower === type.toLowerCase() && aliases.some(alias => alias.includes(searchTermLower))) {
        return true;
      }
      if (aliases.includes(fieldTypeLower) && type.toLowerCase().includes(searchTermLower)) {
        return true;
      }
    }
    return false;
  }, []);
  const filteredFields = useMemo(() => {
    if (!searchTerm.trim()) {
      return state.customFields.filter(customField => !(customField === null || customField === void 0 ? void 0 : customField.shouldDelete));
    }
    const searchLower = searchTerm.toLowerCase();
    return state.customFields.filter(field => {
      var _a;
      if (field === null || field === void 0 ? void 0 : field.shouldDelete) return false;
      const matchesLabel = (_a = field.label) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchLower);
      const matchesType = field.type && matchesTypeAlias(field.type, searchLower);
      return matchesLabel || matchesType;
    });
  }, [state.customFields, searchTerm, matchesTypeAlias]);
  return jsx(CustomFieldsContext.Provider, {
    value: {
      state: Object.assign(Object.assign({}, state), {
        customFields: state.customFields.filter(customField => Boolean(!(customField === null || customField === void 0 ? void 0 : customField.shouldDelete)))
      }),
      addField,
      updateField,
      deleteField,
      duplicateField,
      setFields,
      resetState,
      saveState,
      loading,
      disabled,
      isEdited,
      openItem,
      setOpenItem: openItemId,
      toggleCustomFields: toggleCustomFieldsOn,
      customFieldsOn: _customFieldsOn,
      category,
      dragContainerRef,
      fieldRefs,
      addFieldRef,
      initialized: state.initialized && (isCFGExtensionInstalled ? !!selectedGroup : true),
      errors,
      addError,
      removeError,
      customFieldsScrollRef,
      focusedItem,
      setFocusedItem,
      customFieldGroups,
      entities,
      items,
      addEntity,
      removeEntity,
      addItem,
      removeItem,
      createCustomFieldGroup,
      updateCustomFieldGroup,
      deleteCustomFieldGroup,
      updateEntities,
      updateItems,
      isCFGExtensionInstalled,
      isCFExtensionInstalled,
      selectedCFGroupHandler: [selectedGroup, setSelectedGroup],
      searchTerm,
      setSearchTerm,
      filteredFields,
      validateFields,
      copyCustomFields: _copyCustomFields,
      moveCustomFields: _moveCustomFields,
      handleNotification
    },
    children: children
  });
};
const useCustomFields = () => {
  const context = useContext(CustomFieldsContext);
  if (context === undefined) {
    throw new Error('useCustomFields must be used within a CustomFieldsProvider');
  }
  return context;
};
var global$3 = global$q;
var fails$4 = fails$y;
var uncurryThis$5 = functionUncurryThis;
var toString$5 = toString$g;
var trim$1 = stringTrim.trim;
var whitespaces$1 = whitespaces$4;
var $parseInt$1 = global$3.parseInt;
var Symbol$5 = global$3.Symbol;
var ITERATOR$1 = Symbol$5 && Symbol$5.iterator;
var hex$1 = /^[+-]?0x/i;
var exec = uncurryThis$5(hex$1.exec);
var FORCED$4 = $parseInt$1(whitespaces$1 + '08') !== 8 || $parseInt$1(whitespaces$1 + '0x16') !== 22
// MS Edge 18- broken with boxed symbols
|| ITERATOR$1 && !fails$4(function () {
  $parseInt$1(Object(ITERATOR$1));
});

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED$4 ? function parseInt(string, radix) {
  var S = trim$1(toString$5(string));
  return $parseInt$1(S, radix >>> 0 || (exec(hex$1, S) ? 16 : 10));
} : $parseInt$1;
var $$9 = _export;
var $parseInt = numberParseInt;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$$9({
  global: true,
  forced: parseInt !== $parseInt
}, {
  parseInt: $parseInt
});
const HOUR_BASE_WIDHT = 40;
const DAY_BASE_WIDHT = 40;
const WEEK_BASE_WIDHT = 80;
const MONTH_BASE_WIDHT = 140;
const BASE_WINDOW_WIDTH = 1920;
var ScaleEnum;
(function (ScaleEnum) {
  ScaleEnum["CellDuration"] = "CellDuration";
  ScaleEnum["Day"] = "Day";
  ScaleEnum["Week"] = "Week";
  ScaleEnum["Month"] = "Month";
  ScaleEnum["Quarter"] = "Quarter";
})(ScaleEnum || (ScaleEnum = {}));
const getInitialDate = weekStartDay => {
  const currentDate = new Date();
  const dateStartOfWeek = startOfWeek(currentDate);
  const diff = differenceInDays(currentDate, dateStartOfWeek);
  return addDays$1(currentDate, -diff);
};
const multiplierForBigWidth = (currentCellWidth, baseWidth) => {
  const windowMultiplier = window.innerWidth / BASE_WINDOW_WIDTH * 30;
  const cellWidthMultiplier = baseWidth / currentCellWidth * 20;
  return {
    windowMultiplier,
    cellWidthMultiplier
  };
};
const multiplierForSmallWidth = (currentCellWidth, baseWidth) => {
  const windowWidthDiff = BASE_WINDOW_WIDTH - window.innerWidth;
  const windowMultiplier = windowWidthDiff / BASE_WINDOW_WIDTH * 100;
  const cellWidthDiff = baseWidth - currentCellWidth;
  const cellWidthMultiplier = cellWidthDiff / baseWidth * 100 * (cellWidthDiff / 10);
  return {
    windowMultiplier,
    cellWidthMultiplier
  };
};
const multiplier = (currentCellWidth, baseWidth) => {
  /** The old multiplier works better on small width
   * but it breaks everything on big widths
   * so it is used when width is smaller than default
   */
  const multiplier = currentCellWidth < baseWidth ? multiplierForSmallWidth : multiplierForBigWidth;
  const {
    windowMultiplier,
    cellWidthMultiplier
  } = multiplier(currentCellWidth, baseWidth);
  return windowMultiplier > cellWidthMultiplier ? windowMultiplier : cellWidthMultiplier;
};
const CELLDURATION = {
  value: 'CellDuration',
  BEValue: BookingScaleEnum.SCALE_HOUR,
  daysByMultiplier: function () {
    let currentCellWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : HOUR_BASE_WIDHT;
    let meanWorkDayDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
    const cells = Math.ceil(window.innerWidth / currentCellWidth);
    const days = Math.ceil(cells / meanWorkDayDuration);
    // You need to increase the days value to make sure that the timeline length is greater than the current viewport.
    // It is recommended to use a timeline width at least 3 times the viewport width.
    // Take into account that the viewport size may be different on different screens.
    // Too short timeline may result in an infinite loop  of timeline shifts.
    return days * 6;
  },
  scrollingStepDays: function (currentCellWidth) {
    let meanWorkDayDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
    const cells = Math.ceil(window.innerWidth / currentCellWidth);
    const days = Math.ceil(cells / meanWorkDayDuration);
    return Math.floor(days);
  },
  startDate: () => {
    const currentDate = startOfDay(new Date());
    currentDate.setHours(9);
    return formatDate(currentDate, DATE_FORMATS.DATE_FORMAT_LONG);
  },
  firstViewHeader: 'Day',
  firstViewHeaderFormat: 'dddd, MMM d',
  secondViewHeader: 'Hour',
  secondViewHeaderFormat: '',
  label: 'Hours Scale',
  display: 'Hour'
};
const WEEK = {
  value: 'Week',
  BEValue: BookingScaleEnum.SCALE_WEEK,
  baseCellWidth: WEEK_BASE_WIDHT,
  daysByMultiplier: currentCellWidth => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const multipliedResult = parseInt(300 + 300 * multiplier(currentCellWidth, WEEK_BASE_WIDHT) / 100);
    const cells = Math.floor(window.innerWidth / currentCellWidth);
    const days = cells * 7; // assume 7 days week
    // You need to increase the days value to make sure that the timeline length is greater than the current viewport.
    // It is recommended to use a timeline width at least 3 times the viewport width.
    // Take into account that the viewport size may be different on different screens.
    // Too short timeline may result in an infinite loop  of timeline shifts.
    // set to at least 4 to support 4k and zoom out customer case
    const recommendedNoOfDays = days * 4;
    return multipliedResult < recommendedNoOfDays ? recommendedNoOfDays : multipliedResult;
  },
  scrollingStepDays: currentCellWidth =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  parseInt(100 + 100 * multiplier(currentCellWidth, WEEK_BASE_WIDHT) / 100),
  startDate: weekStartDay => formatDate(getInitialDate(), DATE_FORMATS.YEAR_MONTH_DAY_FORMAT),
  firstViewHeader: 'Month',
  firstViewHeaderFormat: 'MMMM yyyy',
  secondViewHeader: 'Week',
  secondViewHeaderFormat: '',
  label: 'Weeks Scale',
  display: 'Week'
};
const MONTH = {
  value: 'Month',
  BEValue: BookingScaleEnum.SCALE_MONTH,
  daysByMultiplier: currentCellWidth => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const multipliedResult = parseInt(500 + 500 * multiplier(currentCellWidth, MONTH_BASE_WIDHT) / 100);
    const cells = Math.floor(window.innerWidth / currentCellWidth);
    const days = cells * 31; // assume 31 days in a month
    // You need to increase the days value to make sure that the timeline length is greater than the current viewport.
    // It is recommended to use a timeline width at least 3 times the viewport width.
    // Take into account that the viewport size may be different on different screens.
    // Too short timeline may result in an infinite loop  of timeline shifts.
    // set to at least 4 to support 4k and zoom out customer case
    const recommendedNoOfDays = days * 4;
    return multipliedResult < recommendedNoOfDays ? recommendedNoOfDays : multipliedResult;
  },
  scrollingStepDays: currentCellWidth =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  parseInt(100 + 100 * multiplier(currentCellWidth, MONTH_BASE_WIDHT) / 100),
  startDate: () => {
    const currentDate = new Date();
    const dateStartOfWeek = startOfMonth(currentDate);
    const diff = differenceInDays(currentDate, dateStartOfWeek);
    return addDays$1(currentDate, -diff);
  },
  firstViewHeader: 'Year',
  firstViewHeaderFormat: 'yyyy',
  secondViewHeader: 'Month',
  secondViewHeaderFormat: 'MMM',
  label: 'Month Scale',
  display: 'Month'
};
const DAY = {
  value: 'Day',
  BEValue: BookingScaleEnum.SCALE_DAY,
  daysByMultiplier: currentCellWidth => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const multipliedResult = parseInt(100 + 100 * multiplier(currentCellWidth, DAY_BASE_WIDHT) / 100);
    const cells = Math.floor(window.innerWidth / currentCellWidth);
    // You need to increase the days value to make sure that the timeline length is greater than the current viewport.
    // It is recommended to use a timeline width at least 3 times the viewport width.
    // Take into account that the viewport size may be different on different screens.
    // Too short timeline may result in an infinite loop  of timeline shifts.
    // set to at least 4 to support 4k and zoom out customer case
    const recommendedNoOfDays = cells * 4;
    return multipliedResult < recommendedNoOfDays ? recommendedNoOfDays : multipliedResult;
  },
  scrollingStepDays: currentCellWidth =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  parseInt(20 + 20 * multiplier(currentCellWidth, DAY_BASE_WIDHT) / 100),
  startDate: weekStartDay => formatDate(getInitialDate(), DATE_FORMATS.YEAR_MONTH_DAY_FORMAT),
  firstViewHeader: 'Month',
  firstViewHeaderFormat: 'MMMM yyyy',
  secondViewHeader: 'Day',
  secondViewHeaderFormat: 'ddd d',
  label: 'Day Scale',
  display: 'Day'
};
const THIS_WEEK = Object.assign(Object.assign({}, DAY), {
  display: 'This Week',
  label: 'This Week',
  startDate: weekStartDay => formatDate(getInitialDate(), DATE_FORMATS.YEAR_MONTH_DAY_FORMAT),
  customSearchId: 'this_week',
  noActiveClass: true
});
const THIS_MONTH = Object.assign(Object.assign({}, DAY), {
  display: 'This Month',
  label: 'This Month',
  startDate: () => {
    const dateStartOfMonth = startOfMonth(new Date());
    return formatDate(dateStartOfMonth, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT);
  },
  customSearchId: 'this_month',
  noActiveClass: true
});
const scales = {
  CELLDURATION,
  DAY,
  WEEK,
  MONTH,
  THIS_WEEK,
  THIS_MONTH
};
const getScaleObjectByValue = value => Object.values(scales).find(scale => scale.value === value);
const selectAccountResourceRoleRights = state => state.account.resourceRoleRights;
const selectIsAccountPm = state => state.account.isProjectManager;
const selectIsAccountApprover = state => state.account.isApprover;
const selectAccountResourceId = state => state.account.resourceId;
const selectDefaultScale = state => {
  var _a, _b;
  return ((_b = (_a = state.account.preferences) === null || _a === void 0 ? void 0 : _a.grid) === null || _b === void 0 ? void 0 : _b.defaultScale) || 'Day';
};
const selectIsHourScale = createSelector(selectDefaultScale, scale => {
  return scale === CELLDURATION.value;
});
const selectGridContextMenuType = state => {
  var _a, _b;
  return ((_b = (_a = state.account.preferences) === null || _a === void 0 ? void 0 : _a.grid) === null || _b === void 0 ? void 0 : _b.contextMenu) || 'NEW';
};
const selectIsGridModernMenuUsed = createSelector(selectGridContextMenuType, contextMenu => {
  return contextMenu === 'NEW';
});
const selectSchedulerMode = state => {
  var _a, _b;
  return (_b = (_a = state.account.preferences) === null || _a === void 0 ? void 0 : _a.grid) === null || _b === void 0 ? void 0 : _b.mode;
};
const hasRole = (resourceRoleRights, role) => resourceRoleRights && role in resourceRoleRights && resourceRoleRights[role] === ResourceRoleRightStatusEnum.ON;
const hasOneOfRoles = (resourceRoleRights, roles) => roles.some(role => hasRole(resourceRoleRights, role));
const hasAllRoles = (resourceRoleRights, roles) => roles.every(role => hasRole(resourceRoleRights, role));
const getFuncByRole = rule => {
  switch (rule) {
    case 'one':
      return (resourceRoleRights, rights) => hasRole(resourceRoleRights, rights[0]);
    case 'oneOf':
      return (resourceRoleRights, rights) => hasOneOfRoles(resourceRoleRights, rights);
    case 'all':
      return (resourceRoleRights, rights) => hasAllRoles(resourceRoleRights, rights);
    default:
      return (resourceRoleRights, rights) => hasRole(resourceRoleRights, rights[0]);
  }
};
const hasRoleRights = (rightsToCheck, resourceRoleRights) => {
  return rightsToCheck.reduce((acc, rightToCheck) => {
    const func = getFuncByRole(rightToCheck.rule);
    acc.push(func(resourceRoleRights, rightToCheck.rights));
    return acc;
  }, []);
};
const useHasRoleRights = rightsToCheck => {
  const resourceRoleRights = useSelector(selectAccountResourceRoleRights);
  return useMemo(() => {
    return hasRoleRights(rightsToCheck, resourceRoleRights);
  }, [resourceRoleRights, rightsToCheck]);
};
const rights$b = [{
  rights: ['settingViewExt', 'settingAddExt'],
  rule: 'oneOf'
}];
const useCanUserSeeExtensionsSettingsPage = () => {
  const [canViewSettingExt] = useHasRoleRights(rights$b);
  return canViewSettingExt;
};
const CustomFieldGroupsComponent = _ref164 => {
  let {
    where
  } = _ref164;
  const {
    openCFGroups,
    isCFGroupsModalOpen,
    openModalCFGroups,
    closeModalCFGroups,
    openDialog,
    customFieldGroups,
    closeCFGroups,
    isCFGroupsOpen,
    setSelectedGroup,
    selectedGroup,
    isCFGExtensionInstalled,
    openExtensionNotActiveModal
  } = useCustomFieldGroups();
  const ref = useRef(null);
  const [selectedValue, setSelectedValue] = useState(null);
  const isOpen = where === 'modal' ? isCFGroupsModalOpen : isCFGroupsOpen;
  const openCFGDropdown = where === 'modal' ? openModalCFGroups : openCFGroups;
  const closeCFGDropdown = where === 'modal' ? closeModalCFGroups : closeCFGroups;
  const {
    open: openWarning,
    isOpen: isOpenWarning,
    close: closeWarning
  } = useOpenState();
  const staticSelectOption = useMemo(() => {
    return [{
      dataCy: 'add-custom-field-group-menu-item',
      label: jsx(Layout, {
        hAlign: "center",
        flex: "1 1 auto",
        children: jsx(Button, {
          variant: "text",
          fullWidth: true,
          endIcon: "add",
          dataCy: "add-custom-field-group-button",
          children: "New Custom Field Group"
        })
      }),
      closeOnClick: true,
      onClick: openDialog
    }];
  }, [openDialog]);
  const handleChange = (event, value) => {
    if (value) {
      if (isEdited) {
        setSelectedValue(value);
        openWarning(event);
      } else {
        setSelectedGroup(value);
        closeCFGDropdown();
      }
    }
  };
  const handleProceed = () => {
    if (selectedValue) {
      setSelectedGroup(selectedValue);
      closeCFGDropdown();
      closeWarning();
      setSelectedValue(null);
    }
  };
  const handleCancel = () => {
    closeWarning();
    setSelectedValue(null);
  };
  const open = !isCFGExtensionInstalled ? openExtensionNotActiveModal : openCFGDropdown;
  const {
    isEdited
  } = useCustomFields();
  return jsxs("div", {
    style: {
      width: 326,
      boxSizing: 'content-box'
    },
    ref: ref,
    "data-cy": "select-custom-field-group",
    children: [jsx(Dialog, {
      width: 280,
      open: isOpenWarning,
      anchorElement: ref.current,
      title: jsx(Layout, {
        stack: true,
        children: jsx(Typography, {
          variant: "headline",
          size: "small",
          align: "center",
          children: "Unsaved Changes"
        })
      }),
      content: jsx(Layout, {
        stack: true,
        stretch: true,
        flex: "1",
        children: jsxs(Layout, {
          gap: "--Spacing-200",
          children: [jsx("div", {
            style: {
              minWidth: 24
            },
            children: jsx(Icon, {
              name: "error",
              color: "error",
              size: 24
            })
          }), jsx(Typography, {
            variant: "body",
            size: "small",
            children: "Attention: There are unsaved changes in this Custom Field Group that will be lost if you switch Groups."
          })]
        })
      }),
      actions: jsxs(Layout, {
        gap: 8,
        hAlign: "flex-end",
        children: [jsx(Button, {
          variant: "text",
          onClick: handleCancel,
          children: "Cancel"
        }), jsx(Button, {
          variant: "destructive",
          onClick: handleProceed,
          children: "Proceed"
        })]
      }),
      onClose: closeWarning,
      divider: false,
      className: "SURE",
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      }
    }), jsx(Select, {
      label: "Custom Field Group",
      value: selectedGroup,
      onChange: handleChange,
      options: customFieldGroups,
      optionLabel: "name",
      optionValue: "_id",
      disableClearable: true,
      staticOptions: staticSelectOption,
      disableCloseOnSelect: true,
      isOpen: isOpen,
      onClose: closeCFGDropdown,
      onOpen: open,
      dataCy: "select-input-custom-field-group"
    })]
  });
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}
function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component) {
  var prototype = Component.prototype;
  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }
  if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
    var componentName = Component.displayName || Component.name;
    var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
    throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
    }
    prototype.componentWillUpdate = componentWillUpdate;
    var componentDidUpdate = prototype.componentDidUpdate;
    prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }
  return Component;
}
function ownKeys$a(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$a(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$a(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$a(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _callSuper$e(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$e() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$e() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$e = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

/**
 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
 */
/*:: type ChildrenParams = {
  onSectionRendered: (params: RenderedSection) => void,
  scrollToColumn: number,
  scrollToRow: number,
};*/
/*:: type Props = {
  children: (params: ChildrenParams) => React.Element<*>,
  className?: string,
  columnCount: number,
  disabled: boolean,
  isControlled: boolean,
  mode: 'cells' | 'edges',
  onScrollToChange?: (params: ScrollIndices) => void,
  rowCount: number,
  scrollToColumn: number,
  scrollToRow: number,
};*/
/*:: type State = ScrollIndices & {
  instanceProps: {
    prevScrollToColumn: number,
    prevScrollToRow: number,
  },
};*/
var ArrowKeyStepper = /*#__PURE__*/function (_React$PureComponent) {
  function ArrowKeyStepper() {
    var _this;
    _classCallCheck(this, ArrowKeyStepper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$e(this, ArrowKeyStepper, [].concat(args));
    _defineProperty(_this, "state", {
      scrollToColumn: 0,
      scrollToRow: 0,
      instanceProps: {
        prevScrollToColumn: 0,
        prevScrollToRow: 0
      }
    });
    _defineProperty(_this, "_columnStartIndex", 0);
    _defineProperty(_this, "_columnStopIndex", 0);
    _defineProperty(_this, "_rowStartIndex", 0);
    _defineProperty(_this, "_rowStopIndex", 0);
    _defineProperty(_this, "_onKeyDown", function (event /*: KeyboardEvent*/) {
      var _this$props = _this.props,
        columnCount = _this$props.columnCount,
        disabled = _this$props.disabled,
        mode = _this$props.mode,
        rowCount = _this$props.rowCount;
      if (disabled) {
        return;
      }
      var _this$_getScrollState = _this._getScrollState(),
        scrollToColumnPrevious = _this$_getScrollState.scrollToColumn,
        scrollToRowPrevious = _this$_getScrollState.scrollToRow;
      var _this$_getScrollState2 = _this._getScrollState(),
        scrollToColumn = _this$_getScrollState2.scrollToColumn,
        scrollToRow = _this$_getScrollState2.scrollToRow;

      // The above cases all prevent default event event behavior.
      // This is to keep the grid from scrolling after the snap-to update.
      switch (event.key) {
        case 'ArrowDown':
          scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(_this._rowStopIndex + 1, rowCount - 1);
          break;
        case 'ArrowLeft':
          scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(_this._columnStartIndex - 1, 0);
          break;
        case 'ArrowRight':
          scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(_this._columnStopIndex + 1, columnCount - 1);
          break;
        case 'ArrowUp':
          scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(_this._rowStartIndex - 1, 0);
          break;
      }
      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
        event.preventDefault();
        _this._updateScrollState({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      }
    });
    _defineProperty(_this, "_onSectionRendered", function (_ref /*:: */) {
      var columnStartIndex = _ref /*:: */.columnStartIndex,
        columnStopIndex = _ref /*:: */.columnStopIndex,
        rowStartIndex = _ref /*:: */.rowStartIndex,
        rowStopIndex = _ref /*:: */.rowStopIndex;
      _this._columnStartIndex = columnStartIndex;
      _this._columnStopIndex = columnStopIndex;
      _this._rowStartIndex = rowStartIndex;
      _this._rowStopIndex = rowStopIndex;
    });
    return _this;
  }
  _inherits(ArrowKeyStepper, _React$PureComponent);
  return _createClass(ArrowKeyStepper, [{
    key: "setScrollIndexes",
    value: function setScrollIndexes(_ref2 /*:: */) {
      var scrollToColumn = _ref2 /*:: */.scrollToColumn,
        scrollToRow = _ref2 /*:: */.scrollToRow;
      this.setState({
        scrollToRow: scrollToRow,
        scrollToColumn: scrollToColumn
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        className = _this$props2.className,
        children = _this$props2.children;
      var _this$_getScrollState3 = this._getScrollState(),
        scrollToColumn = _this$_getScrollState3.scrollToColumn,
        scrollToRow = _this$_getScrollState3.scrollToRow;
      return /*#__PURE__*/React.createElement("div", {
        className: className,
        onKeyDown: this._onKeyDown
      }, children({
        onSectionRendered: this._onSectionRendered,
        scrollToColumn: scrollToColumn,
        scrollToRow: scrollToRow
      }));
    }
  }, {
    key: "_getScrollState",
    value: function _getScrollState() {
      return this.props.isControlled ? this.props : this.state;
    }
  }, {
    key: "_updateScrollState",
    value: function _updateScrollState(_ref3 /*:: */) {
      var scrollToColumn = _ref3 /*:: */.scrollToColumn,
        scrollToRow = _ref3 /*:: */.scrollToRow;
      var _this$props3 = this.props,
        isControlled = _this$props3.isControlled,
        onScrollToChange = _this$props3.onScrollToChange;
      if (typeof onScrollToChange === 'function') {
        onScrollToChange({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      }
      if (!isControlled) {
        this.setState({
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        });
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps /*: Props*/, prevState /*: State*/) /*: $Shape<State>*/{
      if (nextProps.isControlled) {
        return {};
      }
      if (nextProps.scrollToColumn !== prevState.instanceProps.prevScrollToColumn || nextProps.scrollToRow !== prevState.instanceProps.prevScrollToRow) {
        return _objectSpread$a(_objectSpread$a({}, prevState), {}, {
          scrollToColumn: nextProps.scrollToColumn,
          scrollToRow: nextProps.scrollToRow,
          instanceProps: {
            prevScrollToColumn: nextProps.scrollToColumn,
            prevScrollToRow: nextProps.scrollToRow
          }
        });
      }
      return {};
    }
  }]);
}(React.PureComponent);
_defineProperty(ArrowKeyStepper, "defaultProps", {
  disabled: false,
  isControlled: false,
  mode: 'edges',
  scrollToColumn: 0,
  scrollToRow: 0
});
polyfill(ArrowKeyStepper);

/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Added support for injecting custom window object
 **/

function createDetectElementResize(nonce, hostWindow) {
  // Check `document` and `window` in case of server-side rendering
  var _window;
  if (typeof hostWindow !== 'undefined') {
    _window = hostWindow;
  } else if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = global;
  }
  var attachEvent = typeof _window.document !== 'undefined' && _window.document.attachEvent;
  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };
      return function (fn) {
        return raf(fn);
      };
    }();
    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();
    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
        expand = triggers.firstElementChild,
        contract = triggers.lastElementChild,
        expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };
    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };
    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }
      var element = this;
      resetTriggers(this);
      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }
      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;
          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };

    /* Detect CSS Animations support to detect element display/re-attach */
    var animation = false,
      keyframeprefix = '',
      animationstartevent = 'animationstart',
      domPrefixes = 'Webkit Moz O ms'.split(' '),
      startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
      pfx = '';
    {
      var elm = _window.document.createElement('fakeelement');
      if (elm.style.animationName !== undefined) {
        animation = true;
      }
      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }
    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }
  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
        head = doc.head || doc.getElementsByTagName('head')[0],
        style = doc.createElement('style');
      style.id = 'detectElementResize';
      style.type = 'text/css';
      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }
      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }
      head.appendChild(style);
    }
  };
  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;
        var elementStyle = _window.getComputedStyle(element);
        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }
        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        var expandTrigger = doc.createElement('div');
        expandTrigger.className = 'expand-trigger';
        expandTrigger.appendChild(doc.createElement('div'));
        var contractTrigger = doc.createElement('div');
        contractTrigger.className = 'contract-trigger';
        element.__resizeTriggers__.appendChild(expandTrigger);
        element.__resizeTriggers__.appendChild(contractTrigger);
        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);

        /* Listen for a css animation to detect element display/re-attach */
        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };
          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }
      element.__resizeListeners__.push(fn);
    }
  };
  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);
        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
          element.__resizeTriggers__.__animationListener__ = null;
        }
        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {
          // Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };
  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}
function ownKeys$9(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$9(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$9(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$9(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _callSuper$d(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$d() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$d() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$d = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
/*:: type Size = {
  height: number,
  width: number,
};*/
/*:: type Props = {
  /** Function responsible for rendering children.*-/
  children: Size => React.Element<*>,

  /** Optional custom CSS class name to attach to root AutoSizer element.  *-/
  className?: string,

  /** Default height to use for initial render; useful for SSR *-/
  defaultHeight?: number,

  /** Default width to use for initial render; useful for SSR *-/
  defaultWidth?: number,

  /** Disable dynamic :height property *-/
  disableHeight: boolean,

  /** Disable dynamic :width property *-/
  disableWidth: boolean,

  /** Nonce of the inlined stylesheet for Content Security Policy *-/
  nonce?: string,

  /** Callback to be invoked on-resize *-/
  onResize: Size => void,

  /** Optional inline style *-/
  style: ?Object,
};*/
/*:: type State = {
  height: number,
  width: number,
};*/
/*:: type ResizeHandler = (element: HTMLElement, onResize: () => void) => void;*/
/*:: type DetectElementResize = {
  addResizeListener: ResizeHandler,
  removeResizeListener: ResizeHandler,
};*/
var AutoSizer = /*#__PURE__*/function (_React$Component) {
  function AutoSizer() {
    var _this;
    _classCallCheck(this, AutoSizer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$d(this, AutoSizer, [].concat(args));
    _defineProperty(_this, "state", {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    });
    _defineProperty(_this, "_parentNode", void 0);
    _defineProperty(_this, "_autoSizer", void 0);
    _defineProperty(_this, "_window", void 0);
    // uses any instead of Window because Flow doesn't have window type
    _defineProperty(_this, "_detectElementResize", void 0);
    _defineProperty(_this, "_onResize", function () {
      var _this$props = _this.props,
        disableHeight = _this$props.disableHeight,
        disableWidth = _this$props.disableWidth,
        onResize = _this$props.onResize;
      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.

        var height = _this._parentNode.offsetHeight || 0;
        var width = _this._parentNode.offsetWidth || 0;
        var win = _this._window || window;
        var style = win.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(style.paddingRight, 10) || 0;
        var paddingTop = parseInt(style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
        var newHeight = height - paddingTop - paddingBottom;
        var newWidth = width - paddingLeft - paddingRight;
        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: height - paddingTop - paddingBottom,
            width: width - paddingLeft - paddingRight
          });
          onResize({
            height: height,
            width: width
          });
        }
      }
    });
    _defineProperty(_this, "_setRef", function (autoSizer /*: ?HTMLElement*/) {
      _this._autoSizer = autoSizer;
    });
    return _this;
  }
  _inherits(AutoSizer, _React$Component);
  return _createClass(AutoSizer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var nonce = this.props.nonce;
      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;
        this._window = this._autoSizer.parentNode.ownerDocument.defaultView;

        // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41
        this._detectElementResize = createDetectElementResize(nonce, this._window);
        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
        this._onResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        disableHeight = _this$props2.disableHeight,
        disableWidth = _this$props2.disableWidth,
        style = _this$props2.style;
      var _this$state = this.state,
        height = _this$state.height,
        width = _this$state.width;

      // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.
      var outerStyle /*: Object*/ = {
        overflow: 'visible'
      };
      var childParams /*: Object*/ = {};
      if (!disableHeight) {
        outerStyle.height = 0;
        childParams.height = height;
      }
      if (!disableWidth) {
        outerStyle.width = 0;
        childParams.width = width;
      }

      /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */

      return /*#__PURE__*/React.createElement("div", {
        className: className,
        ref: this._setRef,
        style: _objectSpread$9(_objectSpread$9({}, outerStyle), style)
      }, children(childParams));
    }
  }]);
}(React.Component);
_defineProperty(AutoSizer, "defaultProps", {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
});
function _callSuper$c(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$c() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$c() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$c = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
/*:: type Children = (params: {measure: () => void}) => React.Element<*>;*/
/*:: type Cell = {
  columnIndex: number,
  rowIndex: number,
};*/
/*:: type Props = {
  cache: CellMeasureCache,
  children: Children | React.Element<*>,
  columnIndex?: number,
  index?: number,
  parent: {
    invalidateCellSizeAfterRender?: (cell: Cell) => void,
    recomputeGridSize?: (cell: Cell) => void,
  },
  rowIndex?: number,
};*/
/**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */
var CellMeasurer = /*#__PURE__*/function (_React$PureComponent) {
  function CellMeasurer() {
    var _this;
    _classCallCheck(this, CellMeasurer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$c(this, CellMeasurer, [].concat(args));
    _defineProperty(_this, "_child", /*#__PURE__*/React.createRef());
    _defineProperty(_this, "_measure", function () {
      var _this$props = _this.props,
        cache = _this$props.cache,
        _this$props$columnInd = _this$props.columnIndex,
        columnIndex = _this$props$columnInd === void 0 ? 0 : _this$props$columnInd,
        parent = _this$props.parent,
        _this$props$rowIndex = _this$props.rowIndex,
        rowIndex = _this$props$rowIndex === void 0 ? _this.props.index || 0 : _this$props$rowIndex;
      var _this$_getCellMeasure = _this._getCellMeasurements(),
        height = _this$_getCellMeasure.height,
        width = _this$_getCellMeasure.width;
      if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
        cache.set(rowIndex, columnIndex, width, height);
        if (parent && typeof parent.recomputeGridSize === 'function') {
          parent.recomputeGridSize({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    });
    _defineProperty(_this, "_registerChild", function (element) {
      if (element && !(element instanceof Element)) {
        console.warn('CellMeasurer registerChild expects to be passed Element or null');
      }
      _this._child.current = element;
      if (element) {
        _this._maybeMeasureCell();
      }
    });
    return _this;
  }
  _inherits(CellMeasurer, _React$PureComponent);
  return _createClass(CellMeasurer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._maybeMeasureCell();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._maybeMeasureCell();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var children = this.props.children;
      var resolvedChildren = typeof children === 'function' ? children({
        measure: this._measure,
        registerChild: this._registerChild
      }) : children;
      if (resolvedChildren === null) {
        return resolvedChildren;
      }
      return /*#__PURE__*/cloneElement(resolvedChildren, {
        ref: function ref(node) {
          if (typeof resolvedChildren.ref === 'function') {
            resolvedChildren.ref(node);
          } else if (resolvedChildren.ref) {
            resolvedChildren.ref.current = node;
          }
          _this2._child.current = node;
        }
      });
    }
  }, {
    key: "_getCellMeasurements",
    value: function _getCellMeasurements() {
      var cache = this.props.cache;
      var node = this._child.current;

      // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height

      if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
        var styleWidth = node.style.width;
        var styleHeight = node.style.height;

        // If we are re-measuring a cell that has already been measured,
        // It will have a hard-coded width/height from the previous measurement.
        // The fact that we are measuring indicates this measurement is probably stale,
        // So explicitly clear it out (eg set to "auto") so we can recalculate.
        // See issue #593 for more info.
        // Even if we are measuring initially- if we're inside of a MultiGrid component,
        // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
        // eg top/left Grid renders before bottom/right Grid
        // Since the CellMeasurerCache is shared between them this taints derived cell size values.
        if (!cache.hasFixedWidth()) {
          node.style.width = 'auto';
        }
        if (!cache.hasFixedHeight()) {
          node.style.height = 'auto';
        }
        var height = Math.ceil(node.offsetHeight);
        var width = Math.ceil(node.offsetWidth);

        // Reset after measuring to avoid breaking styles; see #660
        if (styleWidth) {
          node.style.width = styleWidth;
        }
        if (styleHeight) {
          node.style.height = styleHeight;
        }
        return {
          height: height,
          width: width
        };
      } else {
        return {
          height: 0,
          width: 0
        };
      }
    }
  }, {
    key: "_maybeMeasureCell",
    value: function _maybeMeasureCell() {
      var _this$props2 = this.props,
        cache = _this$props2.cache,
        _this$props2$columnIn = _this$props2.columnIndex,
        columnIndex = _this$props2$columnIn === void 0 ? 0 : _this$props2$columnIn,
        parent = _this$props2.parent,
        _this$props2$rowIndex = _this$props2.rowIndex,
        rowIndex = _this$props2$rowIndex === void 0 ? this.props.index || 0 : _this$props2$rowIndex;
      if (!cache.has(rowIndex, columnIndex)) {
        var _this$_getCellMeasure2 = this._getCellMeasurements(),
          height = _this$_getCellMeasure2.height,
          width = _this$_getCellMeasure2.width;
        cache.set(rowIndex, columnIndex, width, height);

        // If size has changed, let Grid know to re-render.
        if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') {
          parent.invalidateCellSizeAfterRender({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    }
  }]);
}(React.PureComponent); // Used for DEV mode warning check
_defineProperty(CellMeasurer, "__internalCellMeasurerFlag", false);
if (process.env.NODE_ENV !== 'production') {
  CellMeasurer.__internalCellMeasurerFlag = true;
}
function _objectDestructuringEmpty(t) {
  if (null == t) throw new TypeError("Cannot destructure " + t);
}
function _extends$5() {
  return _extends$5 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$5.apply(null, arguments);
}
var propTypes = {
  exports: {}
};
var reactIs = {
  exports: {}
};
var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = "function" === typeof Symbol && Symbol.for,
  c = b ? Symbol.for("react.element") : 60103,
  d = b ? Symbol.for("react.portal") : 60106,
  e = b ? Symbol.for("react.fragment") : 60107,
  f = b ? Symbol.for("react.strict_mode") : 60108,
  g = b ? Symbol.for("react.profiler") : 60114,
  h = b ? Symbol.for("react.provider") : 60109,
  k = b ? Symbol.for("react.context") : 60110,
  l = b ? Symbol.for("react.async_mode") : 60111,
  m = b ? Symbol.for("react.concurrent_mode") : 60111,
  n = b ? Symbol.for("react.forward_ref") : 60112,
  p = b ? Symbol.for("react.suspense") : 60113,
  q = b ? Symbol.for("react.suspense_list") : 60120,
  r$1 = b ? Symbol.for("react.memo") : 60115,
  t = b ? Symbol.for("react.lazy") : 60116,
  v = b ? Symbol.for("react.block") : 60121,
  w = b ? Symbol.for("react.fundamental") : 60117,
  x = b ? Symbol.for("react.responder") : 60118,
  y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r$1:
              case h:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m;
}
reactIs_production_min.AsyncMode = l;
reactIs_production_min.ConcurrentMode = m;
reactIs_production_min.ContextConsumer = k;
reactIs_production_min.ContextProvider = h;
reactIs_production_min.Element = c;
reactIs_production_min.ForwardRef = n;
reactIs_production_min.Fragment = e;
reactIs_production_min.Lazy = t;
reactIs_production_min.Memo = r$1;
reactIs_production_min.Portal = d;
reactIs_production_min.Profiler = g;
reactIs_production_min.StrictMode = f;
reactIs_production_min.Suspense = p;
reactIs_production_min.isAsyncMode = function (a) {
  return A(a) || z(a) === l;
};
reactIs_production_min.isConcurrentMode = A;
reactIs_production_min.isContextConsumer = function (a) {
  return z(a) === k;
};
reactIs_production_min.isContextProvider = function (a) {
  return z(a) === h;
};
reactIs_production_min.isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};
reactIs_production_min.isForwardRef = function (a) {
  return z(a) === n;
};
reactIs_production_min.isFragment = function (a) {
  return z(a) === e;
};
reactIs_production_min.isLazy = function (a) {
  return z(a) === t;
};
reactIs_production_min.isMemo = function (a) {
  return z(a) === r$1;
};
reactIs_production_min.isPortal = function (a) {
  return z(a) === d;
};
reactIs_production_min.isProfiler = function (a) {
  return z(a) === g;
};
reactIs_production_min.isStrictMode = function (a) {
  return z(a) === f;
};
reactIs_production_min.isSuspense = function (a) {
  return z(a) === p;
};
reactIs_production_min.isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r$1 || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
reactIs_production_min.typeOf = z;
var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== "production") {
  (function () {
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?

    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
    function isValidElementType(type) {
      return typeof type === 'string' || typeof type === 'function' ||
      // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
      if (typeof object === 'object' && object !== null) {
        var $$typeof = object.$$typeof;
        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            var type = object.type;
            switch (type) {
              case REACT_ASYNC_MODE_TYPE:
              case REACT_CONCURRENT_MODE_TYPE:
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
                return type;
              default:
                var $$typeofType = type && type.$$typeof;
                switch ($$typeofType) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                  case REACT_PROVIDER_TYPE:
                    return $$typeofType;
                  default:
                    return $$typeof;
                }
            }
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }
      return undefined;
    } // AsyncMode is deprecated along with isAsyncMode

    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

    function isAsyncMode(object) {
      {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
          hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

          console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
        }
      }
      return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
      return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
      return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
      return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    reactIs_development.AsyncMode = AsyncMode;
    reactIs_development.ConcurrentMode = ConcurrentMode;
    reactIs_development.ContextConsumer = ContextConsumer;
    reactIs_development.ContextProvider = ContextProvider;
    reactIs_development.Element = Element;
    reactIs_development.ForwardRef = ForwardRef;
    reactIs_development.Fragment = Fragment;
    reactIs_development.Lazy = Lazy;
    reactIs_development.Memo = Memo;
    reactIs_development.Portal = Portal;
    reactIs_development.Profiler = Profiler;
    reactIs_development.StrictMode = StrictMode;
    reactIs_development.Suspense = Suspense;
    reactIs_development.isAsyncMode = isAsyncMode;
    reactIs_development.isConcurrentMode = isConcurrentMode;
    reactIs_development.isContextConsumer = isContextConsumer;
    reactIs_development.isContextProvider = isContextProvider;
    reactIs_development.isElement = isElement;
    reactIs_development.isForwardRef = isForwardRef;
    reactIs_development.isFragment = isFragment;
    reactIs_development.isLazy = isLazy;
    reactIs_development.isMemo = isMemo;
    reactIs_development.isPortal = isPortal;
    reactIs_development.isProfiler = isProfiler;
    reactIs_development.isStrictMode = isStrictMode;
    reactIs_development.isSuspense = isSuspense;
    reactIs_development.isValidElementType = isValidElementType;
    reactIs_development.typeOf = typeOf;
  })();
}
if (process.env.NODE_ENV === 'production') {
  reactIs.exports = reactIs_production_min;
} else {
  reactIs.exports = reactIs_development;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject$2(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }

    // Detect buggy property enumeration order in older V8 versions.

    // https://bugs.chromium.org/p/v8/issues/detail?id=4118
    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject$2(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty$1.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;
var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function () {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has$2;
  printWarning$1 = function (text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {/**/}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs.exports;
var assign = objectAssign;
var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has = has$2;
var checkPropTypes = checkPropTypes_1;
var printWarning = function () {};
if (process.env.NODE_ENV !== 'production') {
  printWarning = function (text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
var factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data : {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] &&
          // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  } // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}
var PropTypes = propTypes.exports;
function r(e) {
  var t,
    f,
    n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length;) (e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}

/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var cachedIndices = {};
  return function (_ref) {
    var callback = _ref.callback,
      indices = _ref.indices;
    var keys = Object.keys(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];
      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });
    cachedIndices = indices;
    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var size;
function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (canUseDOM) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }
  return size;
}
function ownKeys$8(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$8(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$8(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$8(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _callSuper$b(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$b() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$b() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$b = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

// @TODO Merge Collection and CollectionView

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var IS_SCROLLING_TIMEOUT$1 = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS$1 = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

/**
 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
 */
var CollectionView = /*#__PURE__*/function (_React$PureComponent) {
  function CollectionView() {
    var _this;
    _classCallCheck(this, CollectionView);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$b(this, CollectionView, [].concat(args));

    // If this component is being rendered server-side, getScrollbarSize() will return undefined.
    // We handle this case in componentDidMount()
    _defineProperty(_this, "state", {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    });
    _defineProperty(_this, "_calculateSizeAndPositionDataOnNextUpdate", false);
    // Invokes callbacks only when their values have changed.
    _defineProperty(_this, "_onSectionRenderedMemoizer", createCallbackMemoizer());
    _defineProperty(_this, "_onScrollMemoizer", createCallbackMemoizer(false));
    _defineProperty(_this, "_invokeOnSectionRenderedHelper", function () {
      var _this$props = _this.props,
        cellLayoutManager = _this$props.cellLayoutManager,
        onSectionRendered = _this$props.onSectionRendered;
      _this._onSectionRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          indices: cellLayoutManager.getLastRenderedIndices()
        }
      });
    });
    _defineProperty(_this, "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });
    _defineProperty(_this, "_updateScrollPositionForScrollToCell", function () {
      var _this$props2 = _this.props,
        cellLayoutManager = _this$props2.cellLayoutManager,
        height = _this$props2.height,
        scrollToAlignment = _this$props2.scrollToAlignment,
        scrollToCell = _this$props2.scrollToCell,
        width = _this$props2.width;
      var _this$state = _this.state,
        scrollLeft = _this$state.scrollLeft,
        scrollTop = _this$state.scrollTop;
      if (scrollToCell >= 0) {
        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
          align: scrollToAlignment,
          cellIndex: scrollToCell,
          height: height,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          width: width
        });
        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
          _this._setScrollPosition(scrollPosition);
        }
      }
    });
    _defineProperty(_this, "_onScroll", function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target !== _this._scrollingContainer) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      _this._enablePointerEventsAfterDelay();

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
      var _this$props3 = _this.props,
        cellLayoutManager = _this$props3.cellLayoutManager,
        height = _this$props3.height,
        isScrollingChange = _this$props3.isScrollingChange,
        width = _this$props3.width;
      var scrollbarSize = _this._scrollbarSize;
      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize(),
        totalHeight = _cellLayoutManager$ge.height,
        totalWidth = _cellLayoutManager$ge.width;
      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop));

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (_this.state.scrollLeft !== scrollLeft || _this.state.scrollTop !== scrollTop) {
        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
        // All things considered, this seems to be the best current work around that I'm aware of.
        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
        var scrollPositionChangeReason = event.cancelable ? SCROLL_POSITION_CHANGE_REASONS$1.OBSERVED : SCROLL_POSITION_CHANGE_REASONS$1.REQUESTED;

        // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)
        if (!_this.state.isScrolling) {
          isScrollingChange(true);
        }
        _this.setState({
          isScrolling: true,
          scrollLeft: scrollLeft,
          scrollPositionChangeReason: scrollPositionChangeReason,
          scrollTop: scrollTop
        });
      }
      _this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalWidth: totalWidth,
        totalHeight: totalHeight
      });
    });
    _this._scrollbarSize = scrollbarSize();
    if (_this._scrollbarSize === undefined) {
      _this._scrollbarSizeMeasured = false;
      _this._scrollbarSize = 0;
    } else {
      _this._scrollbarSizeMeasured = true;
    }
    return _this;
  }

  /**
   * Forced recompute of cell sizes and positions.
   * This function should be called if cell sizes have changed but nothing else has.
   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
   */
  _inherits(CollectionView, _React$PureComponent);
  return _createClass(CollectionView, [{
    key: "recomputeCellSizesAndPositions",
    value: function recomputeCellSizesAndPositions() {
      this._calculateSizeAndPositionDataOnNextUpdate = true;
      this.forceUpdate();
    }

    /* ---------------------------- Component lifecycle methods ---------------------------- */

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
        cellLayoutManager = _this$props4.cellLayoutManager,
        scrollLeft = _this$props4.scrollLeft,
        scrollToCell = _this$props4.scrollToCell,
        scrollTop = _this$props4.scrollTop;

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.
      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = scrollbarSize();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }
      if (scrollToCell >= 0) {
        this._updateScrollPositionForScrollToCell();
      } else if (scrollLeft >= 0 || scrollTop >= 0) {
        this._setScrollPosition({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });
      }

      // Update onSectionRendered callback.
      this._invokeOnSectionRenderedHelper();
      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize(),
        totalHeight = _cellLayoutManager$ge2.height,
        totalWidth = _cellLayoutManager$ge2.width;

      // Initialize onScroll callback.
      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalHeight: totalHeight,
        totalWidth: totalWidth
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props5 = this.props,
        height = _this$props5.height,
        scrollToAlignment = _this$props5.scrollToAlignment,
        scrollToCell = _this$props5.scrollToCell,
        width = _this$props5.width;
      var _this$state2 = this.state,
        scrollLeft = _this$state2.scrollLeft,
        scrollPositionChangeReason = _this$state2.scrollPositionChangeReason,
        scrollTop = _this$state2.scrollTop;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.
      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS$1.REQUESTED) {
        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Update scroll offsets if the current :scrollToCell values requires it
      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
        this._updateScrollPositionForScrollToCell();
      }

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnSectionRenderedHelper();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        autoHeight = _this$props6.autoHeight,
        cellCount = _this$props6.cellCount,
        cellLayoutManager = _this$props6.cellLayoutManager,
        className = _this$props6.className,
        height = _this$props6.height,
        horizontalOverscanSize = _this$props6.horizontalOverscanSize,
        id = _this$props6.id,
        noContentRenderer = _this$props6.noContentRenderer,
        style = _this$props6.style,
        verticalOverscanSize = _this$props6.verticalOverscanSize,
        width = _this$props6.width;
      var _this$state3 = this.state,
        isScrolling = _this$state3.isScrolling,
        scrollLeft = _this$state3.scrollLeft,
        scrollTop = _this$state3.scrollTop;

      // Memoization reset
      if (this._lastRenderedCellCount !== cellCount || this._lastRenderedCellLayoutManager !== cellLayoutManager || this._calculateSizeAndPositionDataOnNextUpdate) {
        this._lastRenderedCellCount = cellCount;
        this._lastRenderedCellLayoutManager = cellLayoutManager;
        this._calculateSizeAndPositionDataOnNextUpdate = false;
        cellLayoutManager.calculateSizeAndPositionData();
      }
      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize(),
        totalHeight = _cellLayoutManager$ge3.height,
        totalWidth = _cellLayoutManager$ge3.width;

      // Safely expand the rendered area by the specified overscan amount
      var left = Math.max(0, scrollLeft - horizontalOverscanSize);
      var top = Math.max(0, scrollTop - verticalOverscanSize);
      var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
      var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);
      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
        height: bottom - top,
        isScrolling: isScrolling,
        width: right - left,
        x: left,
        y: top
      }) : [];
      var collectionStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        WebkitOverflowScrolling: 'touch',
        width: width,
        willChange: 'transform'
      };

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0;

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
      return /*#__PURE__*/React.createElement("div", {
        ref: this._setScrollingContainerRef,
        "aria-label": this.props['aria-label'],
        className: clsx('ReactVirtualized__Collection', className),
        id: id,
        onScroll: this._onScroll,
        role: "grid",
        style: _objectSpread$8(_objectSpread$8({}, collectionStyle), style),
        tabIndex: 0
      }, cellCount > 0 && /*#__PURE__*/React.createElement("div", {
        className: "ReactVirtualized__Collection__innerScrollContainer",
        style: {
          height: totalHeight,
          maxHeight: totalHeight,
          maxWidth: totalWidth,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          width: totalWidth
        }
      }, childrenToDisplay), cellCount === 0 && noContentRenderer());
    }

    /* ---------------------------- Helper methods ---------------------------- */

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Collection.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */
  }, {
    key: "_enablePointerEventsAfterDelay",
    value: function _enablePointerEventsAfterDelay() {
      var _this2 = this;
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
      this._disablePointerEventsTimeoutId = setTimeout(function () {
        var isScrollingChange = _this2.props.isScrollingChange;
        isScrollingChange(false);
        _this2._disablePointerEventsTimeoutId = null;
        _this2.setState({
          isScrolling: false
        });
      }, IS_SCROLLING_TIMEOUT$1);
    }
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function _invokeOnScrollMemoizer(_ref) {
      var _this3 = this;
      var scrollLeft = _ref.scrollLeft,
        scrollTop = _ref.scrollTop,
        totalHeight = _ref.totalHeight,
        totalWidth = _ref.totalWidth;
      this._onScrollMemoizer({
        callback: function callback(_ref2) {
          var scrollLeft = _ref2.scrollLeft,
            scrollTop = _ref2.scrollTop;
          var _this3$props = _this3.props,
            height = _this3$props.height,
            onScroll = _this3$props.onScroll,
            width = _this3$props.width;
          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: "_setScrollPosition",
    value: function _setScrollPosition(_ref3) {
      var scrollLeft = _ref3.scrollLeft,
        scrollTop = _ref3.scrollTop;
      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS$1.REQUESTED
      };
      if (scrollLeft >= 0) {
        newState.scrollLeft = scrollLeft;
      }
      if (scrollTop >= 0) {
        newState.scrollTop = scrollTop;
      }
      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.cellCount === 0 && (prevState.scrollLeft !== 0 || prevState.scrollTop !== 0)) {
        return {
          scrollLeft: 0,
          scrollTop: 0,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS$1.REQUESTED
        };
      } else if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null ? nextProps.scrollTop : prevState.scrollTop,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS$1.REQUESTED
        };
      }
      return null;
    }
  }]);
}(React.PureComponent);
_defineProperty(CollectionView, "defaultProps", {
  'aria-label': 'grid',
  horizontalOverscanSize: 0,
  noContentRenderer: function noContentRenderer() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  onSectionRendered: function onSectionRendered() {
    return null;
  },
  scrollToAlignment: 'auto',
  scrollToCell: -1,
  style: {},
  verticalOverscanSize: 0
});
CollectionView.propTypes = process.env.NODE_ENV !== "production" ? {
  'aria-label': PropTypes.string,
  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,
  /**
   * Number of cells in collection.
   */
  cellCount: PropTypes.number.isRequired,
  /**
   * Calculates cell sizes and positions and manages rendering the appropriate cells given a specified window.
   */
  cellLayoutManager: PropTypes.object.isRequired,
  /**
   * Optional custom CSS class name to attach to root Collection element.
   */
  className: PropTypes.string,
  /**
   * Height of Collection; this property determines the number of visible (vs virtualized) rows.
   */
  height: PropTypes.number.isRequired,
  /**
   * Optional custom id to attach to root Collection element.
   */
  id: PropTypes.string,
  /**
   * Enables the `Collection` to horiontally "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  horizontalOverscanSize: PropTypes.number.isRequired,
  isScrollingChange: PropTypes.func,
  /**
   * Optional renderer to be used in place of rows when either :rowCount or :cellCount is 0.
   */
  noContentRenderer: PropTypes.func.isRequired,
  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
   */
  onScroll: PropTypes.func.isRequired,
  /**
   * Callback invoked with information about the section of the Collection that was just rendered.
   * This callback is passed a named :indices parameter which is an Array of the most recently rendered section indices.
   */
  onSectionRendered: PropTypes.func.isRequired,
  /**
   * Horizontal offset.
   */
  scrollLeft: PropTypes.number,
  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,
  /**
   * Cell index to ensure visible (by forcefully scrolling if necessary).
   */
  scrollToCell: PropTypes.number.isRequired,
  /**
   * Vertical offset.
   */
  scrollTop: PropTypes.number,
  /**
   * Optional custom inline style to attach to root Collection element.
   */
  style: PropTypes.object,
  /**
   * Enables the `Collection` to vertically "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  verticalOverscanSize: PropTypes.number.isRequired,
  /**
   * Width of Collection; this property determines the number of visible (vs virtualized) columns.
   */
  width: PropTypes.number.isRequired
} : {};
polyfill(CollectionView);

/*:: import type {Index, SizeAndPositionInfo} from './types';*/
/**
 * A section of the Window.
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
 */
var Section = /*#__PURE__*/function () {
  function Section(_ref /*:: */) {
    var height = _ref /*:: */.height,
      width = _ref /*:: */.width,
      x = _ref /*:: */.x,
      y = _ref /*:: */.y;
    _classCallCheck(this, Section);
    this.height = height;
    this.width = width;
    this.x = x;
    this.y = y;
    this._indexMap = {};
    this._indices = [];
  }

  /** Add a cell to this section. */
  return _createClass(Section, [{
    key: "addCellIndex",
    value: function addCellIndex(_ref2 /*:: */) {
      var index = _ref2 /*:: */.index;
      if (!this._indexMap[index]) {
        this._indexMap[index] = true;
        this._indices.push(index);
      }
    }

    /** Get all cell indices that have been added to this section. */
  }, {
    key: "getCellIndices",
    value: function getCellIndices() /*: Array<number>*/{
      return this._indices;
    }

    /** Intended for debugger/test purposes only */
  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this.x, ",").concat(this.y, " ").concat(this.width, "x").concat(this.height);
    }
  }]);
}();

/*:: import type {Index, SizeAndPositionInfo} from './types';*/
var SECTION_SIZE = 100;
/*:: type RegisterCellParams = {
  cellMetadatum: SizeAndPositionInfo,
  index: number,
};*/
/**
 * Contains 0 to many Sections.
 * Grows (and adds Sections) dynamically as cells are registered.
 * Automatically adds cells to the appropriate Section(s).
 */
var SectionManager = /*#__PURE__*/function () {
  function SectionManager() {
    var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SECTION_SIZE;
    _classCallCheck(this, SectionManager);
    this._sectionSize = sectionSize;
    this._cellMetadata = [];
    this._sections = {};
  }

  /**
   * Gets all cell indices contained in the specified region.
   * A region may encompass 1 or more Sections.
   */
  return _createClass(SectionManager, [{
    key: "getCellIndices",
    value: function getCellIndices(_ref /*:: */) /*: Array<number>*/{
      var height = _ref /*:: */.height,
        width = _ref /*:: */.width,
        x = _ref /*:: */.x,
        y = _ref /*:: */.y;
      var indices = {};
      this.getSections({
        height: height,
        width: width,
        x: x,
        y: y
      }).forEach(function (section) {
        return section.getCellIndices().forEach(function (index) {
          indices[index] = index;
        });
      });

      // Object keys are strings; this function returns numbers
      return Object.keys(indices).map(function (index) {
        return indices[index];
      });
    }

    /** Get size and position information for the cell specified. */
  }, {
    key: "getCellMetadata",
    value: function getCellMetadata(_ref2 /*:: */) /*: SizeAndPositionInfo*/{
      var index = _ref2 /*:: */.index;
      return this._cellMetadata[index];
    }

    /** Get all Sections overlapping the specified region. */
  }, {
    key: "getSections",
    value: function getSections(_ref3 /*:: */) /*: Array<Section>*/{
      var height = _ref3 /*:: */.height,
        width = _ref3 /*:: */.width,
        x = _ref3 /*:: */.x,
        y = _ref3 /*:: */.y;
      var sectionXStart = Math.floor(x / this._sectionSize);
      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
      var sectionYStart = Math.floor(y / this._sectionSize);
      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);
      var sections = [];
      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
          var key = "".concat(sectionX, ".").concat(sectionY);
          if (!this._sections[key]) {
            this._sections[key] = new Section({
              height: this._sectionSize,
              width: this._sectionSize,
              x: sectionX * this._sectionSize,
              y: sectionY * this._sectionSize
            });
          }
          sections.push(this._sections[key]);
        }
      }
      return sections;
    }

    /** Total number of Sections based on the currently registered cells. */
  }, {
    key: "getTotalSectionCount",
    value: function getTotalSectionCount() {
      return Object.keys(this._sections).length;
    }

    /** Intended for debugger/test purposes only */
  }, {
    key: "toString",
    value: function toString() {
      var _this = this;
      return Object.keys(this._sections).map(function (index) {
        return _this._sections[index].toString();
      });
    }

    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */
  }, {
    key: "registerCell",
    value: function registerCell(_ref4 /*:: */) {
      var cellMetadatum = _ref4 /*:: */.cellMetadatum,
        index = _ref4 /*:: */.index;
      this._cellMetadata[index] = cellMetadatum;
      this.getSections(cellMetadatum).forEach(function (section) {
        return section.addCellIndex({
          index: index
        });
      });
    }
  }]);
}();
function calculateSizeAndPositionData(_ref) {
  var cellCount = _ref.cellCount,
    cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter,
    sectionSize = _ref.sectionSize;
  var cellMetadata = [];
  var sectionManager = new SectionManager(sectionSize);
  var height = 0;
  var width = 0;
  for (var index = 0; index < cellCount; index++) {
    var cellMetadatum = cellSizeAndPositionGetter({
      index: index
    });
    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
      throw Error("Invalid metadata returned for cell ".concat(index, ":\n        x:").concat(cellMetadatum.x, ", y:").concat(cellMetadatum.y, ", width:").concat(cellMetadatum.width, ", height:").concat(cellMetadatum.height));
    }
    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);
    cellMetadata[index] = cellMetadatum;
    sectionManager.registerCell({
      cellMetadatum: cellMetadatum,
      index: index
    });
  }
  return {
    cellMetadata: cellMetadata,
    height: height,
    sectionManager: sectionManager,
    width: width
  };
}

/**
 * Determines a new offset that ensures a certain cell is visible, given the current offset.
 * If the cell is already visible then the current offset will be returned.
 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
 *
 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
 * @param cellOffset Offset (x or y) position for cell
 * @param cellSize Size (width or height) of cell
 * @param containerSize Total size (width or height) of the container
 * @param currentOffset Container's current (x or y) offset
 * @return Offset to use to ensure the specified cell is visible
 */
function getUpdatedOffsetForIndex(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'auto' : _ref$align,
    cellOffset = _ref.cellOffset,
    cellSize = _ref.cellSize,
    containerSize = _ref.containerSize,
    currentOffset = _ref.currentOffset;
  var maxOffset = cellOffset;
  var minOffset = maxOffset - containerSize + cellSize;
  switch (align) {
    case 'start':
      return maxOffset;
    case 'end':
      return minOffset;
    case 'center':
      return maxOffset - (containerSize - cellSize) / 2;
    default:
      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
  }
}
function _callSuper$a(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$a() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$a() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$a = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
/*:: import type {ScrollPosition, SizeInfo} from './types';*/
/**
 * Renders scattered or non-linear data.
 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
 */
var Collection = /*#__PURE__*/function (_React$PureComponent) {
  function Collection(props, context) {
    var _this;
    _classCallCheck(this, Collection);
    _this = _callSuper$a(this, Collection, [props, context]);
    _this._cellMetadata = [];
    _this._lastRenderedCellIndices = [];

    // Cell cache during scroll (for performance)
    _this._cellCache = [];
    _this._isScrollingChange = _this._isScrollingChange.bind(_this);
    _this._setCollectionViewRef = _this._setCollectionViewRef.bind(_this);
    return _this;
  }
  _inherits(Collection, _React$PureComponent);
  return _createClass(Collection, [{
    key: "forceUpdate",
    value: function forceUpdate() {
      if (this._collectionView !== undefined) {
        this._collectionView.forceUpdate();
      }
    }

    /** See Collection#recomputeCellSizesAndPositions */
  }, {
    key: "recomputeCellSizesAndPositions",
    value: function recomputeCellSizesAndPositions() {
      this._cellCache = [];
      this._collectionView.recomputeCellSizesAndPositions();
    }

    /** React lifecycle methods */
  }, {
    key: "render",
    value: function render() {
      var props = _extends$5({}, (_objectDestructuringEmpty(this.props), this.props));
      return /*#__PURE__*/React.createElement(CollectionView, _extends$5({
        cellLayoutManager: this,
        isScrollingChange: this._isScrollingChange,
        ref: this._setCollectionViewRef
      }, props));
    }

    /** CellLayoutManager interface */
  }, {
    key: "calculateSizeAndPositionData",
    value: function calculateSizeAndPositionData$1() {
      var _this$props = this.props,
        cellCount = _this$props.cellCount,
        cellSizeAndPositionGetter = _this$props.cellSizeAndPositionGetter,
        sectionSize = _this$props.sectionSize;
      var data = calculateSizeAndPositionData({
        cellCount: cellCount,
        cellSizeAndPositionGetter: cellSizeAndPositionGetter,
        sectionSize: sectionSize
      });
      this._cellMetadata = data.cellMetadata;
      this._sectionManager = data.sectionManager;
      this._height = data.height;
      this._width = data.width;
    }

    /**
     * Returns the most recently rendered set of cell indices.
     */
  }, {
    key: "getLastRenderedIndices",
    value: function getLastRenderedIndices() {
      return this._lastRenderedCellIndices;
    }

    /**
     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
     */
  }, {
    key: "getScrollPositionForCell",
    value: function getScrollPositionForCell(_ref) /*: ScrollPosition*/{
      var align = _ref.align,
        cellIndex = _ref.cellIndex,
        height = _ref.height,
        scrollLeft = _ref.scrollLeft,
        scrollTop = _ref.scrollTop,
        width = _ref.width;
      var cellCount = this.props.cellCount;
      if (cellIndex >= 0 && cellIndex < cellCount) {
        var cellMetadata = this._cellMetadata[cellIndex];
        scrollLeft = getUpdatedOffsetForIndex({
          align: align,
          cellOffset: cellMetadata.x,
          cellSize: cellMetadata.width,
          containerSize: width,
          currentOffset: scrollLeft,
          targetIndex: cellIndex
        });
        scrollTop = getUpdatedOffsetForIndex({
          align: align,
          cellOffset: cellMetadata.y,
          cellSize: cellMetadata.height,
          containerSize: height,
          currentOffset: scrollTop,
          targetIndex: cellIndex
        });
      }
      return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      };
    }
  }, {
    key: "getTotalSize",
    value: function getTotalSize() /*: SizeInfo*/{
      return {
        height: this._height,
        width: this._width
      };
    }
  }, {
    key: "cellRenderers",
    value: function cellRenderers(_ref2) {
      var _this2 = this;
      var height = _ref2.height,
        isScrolling = _ref2.isScrolling,
        width = _ref2.width,
        x = _ref2.x,
        y = _ref2.y;
      var _this$props2 = this.props,
        cellGroupRenderer = _this$props2.cellGroupRenderer,
        cellRenderer = _this$props2.cellRenderer;

      // Store for later calls to getLastRenderedIndices()
      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
        height: height,
        width: width,
        x: x,
        y: y
      });
      return cellGroupRenderer({
        cellCache: this._cellCache,
        cellRenderer: cellRenderer,
        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref3) {
          var index = _ref3.index;
          return _this2._sectionManager.getCellMetadata({
            index: index
          });
        },
        indices: this._lastRenderedCellIndices,
        isScrolling: isScrolling
      });
    }
  }, {
    key: "_isScrollingChange",
    value: function _isScrollingChange(isScrolling) {
      if (!isScrolling) {
        this._cellCache = [];
      }
    }
  }, {
    key: "_setCollectionViewRef",
    value: function _setCollectionViewRef(ref) {
      this._collectionView = ref;
    }
  }]);
}(React.PureComponent);
_defineProperty(Collection, "defaultProps", {
  'aria-label': 'grid',
  cellGroupRenderer: defaultCellGroupRenderer
});
Collection.propTypes = process.env.NODE_ENV !== "production" ? {
  'aria-label': PropTypes.string,
  /**
   * Number of cells in Collection.
   */
  cellCount: PropTypes.number.isRequired,
  /**
   * Responsible for rendering a group of cells given their indices.
   * Should implement the following interface: ({
   *   cellSizeAndPositionGetter:Function,
   *   indices: Array<number>,
   *   cellRenderer: Function
   * }): Array<PropTypes.node>
   */
  cellGroupRenderer: PropTypes.func.isRequired,
  /**
   * Responsible for rendering a cell given an row and column index.
   * Should implement the following interface: ({ index: number, key: string, style: object }): PropTypes.element
   */
  cellRenderer: PropTypes.func.isRequired,
  /**
   * Callback responsible for returning size and offset/position information for a given cell (index).
   * ({ index: number }): { height: number, width: number, x: number, y: number }
   */
  cellSizeAndPositionGetter: PropTypes.func.isRequired,
  /**
   * Optionally override the size of the sections a Collection's cells are split into.
   */
  sectionSize: PropTypes.number
} : {};
function defaultCellGroupRenderer(_ref4) {
  var cellCache = _ref4.cellCache,
    cellRenderer = _ref4.cellRenderer,
    cellSizeAndPositionGetter = _ref4.cellSizeAndPositionGetter,
    indices = _ref4.indices,
    isScrolling = _ref4.isScrolling;
  return indices.map(function (index) {
    var cellMetadata = cellSizeAndPositionGetter({
      index: index
    });
    var cellRendererProps = {
      index: index,
      isScrolling: isScrolling,
      key: index,
      style: {
        height: cellMetadata.height,
        left: cellMetadata.x,
        position: 'absolute',
        top: cellMetadata.y,
        width: cellMetadata.width
      }
    };

    // Avoid re-creating cells while scrolling.
    // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
    // If a scroll is in progress- cache and reuse cells.
    // This cache will be thrown away once scrolling complets.
    if (isScrolling) {
      if (!(index in cellCache)) {
        cellCache[index] = cellRenderer(cellRendererProps);
      }
      return cellCache[index];
    } else {
      return cellRenderer(cellRendererProps);
    }
  }).filter(function (renderedCell) {
    return !!renderedCell;
  });
}
function _callSuper$9(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$9() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$9() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$9 = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

/**
 * High-order component that auto-calculates column-widths for `Grid` cells.
 */
var ColumnSizer = /*#__PURE__*/function (_React$PureComponent) {
  function ColumnSizer(props, context) {
    var _this;
    _classCallCheck(this, ColumnSizer);
    _this = _callSuper$9(this, ColumnSizer, [props, context]);
    _this._registerChild = _this._registerChild.bind(_this);
    return _this;
  }
  _inherits(ColumnSizer, _React$PureComponent);
  return _createClass(ColumnSizer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        columnMaxWidth = _this$props.columnMaxWidth,
        columnMinWidth = _this$props.columnMinWidth,
        columnCount = _this$props.columnCount,
        width = _this$props.width;
      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
        if (this._registeredChild) {
          this._registeredChild.recomputeGridSize();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        columnMaxWidth = _this$props2.columnMaxWidth,
        columnMinWidth = _this$props2.columnMinWidth,
        columnCount = _this$props2.columnCount,
        width = _this$props2.width;
      var safeColumnMinWidth = columnMinWidth || 1;
      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;
      var columnWidth = width / columnCount;
      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
      columnWidth = Math.floor(columnWidth);
      var adjustedWidth = Math.min(width, columnWidth * columnCount);
      return children({
        adjustedWidth: adjustedWidth,
        columnWidth: columnWidth,
        getColumnWidth: function getColumnWidth() {
          return columnWidth;
        },
        registerChild: this._registerChild
      });
    }
  }, {
    key: "_registerChild",
    value: function _registerChild(child) {
      if (child && typeof child.recomputeGridSize !== 'function') {
        throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
      }
      this._registeredChild = child;
      if (this._registeredChild) {
        this._registeredChild.recomputeGridSize();
      }
    }
  }]);
}(React.PureComponent);
ColumnSizer.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Function responsible for rendering a virtualized Grid.
   * This function should implement the following signature:
   * ({ adjustedWidth, getColumnWidth, registerChild }) => PropTypes.element
   *
   * The specified :getColumnWidth function should be passed to the Grid's :columnWidth property.
   * The :registerChild should be passed to the Grid's :ref property.
   * The :adjustedWidth property is optional; it reflects the lesser of the overall width or the width of all columns.
   */
  children: PropTypes.func.isRequired,
  /** Optional maximum allowed column width */
  columnMaxWidth: PropTypes.number,
  /** Optional minimum allowed column width */
  columnMinWidth: PropTypes.number,
  /** Number of columns in Grid or Table child */
  columnCount: PropTypes.number.isRequired,
  /** Width of Grid or Table child */
  width: PropTypes.number.isRequired
} : {};

/**
 * Helper method that determines when to recalculate row or column metadata.
 */
/*:: type Params<T> = {
  // Number of rows or columns in the current axis
  cellCount: number,

  // Width or height of cells for the current axis
  cellSize: ?number,

  // Method to invoke if cell metadata should be recalculated
  computeMetadataCallback: (props: T) => void,

  // Parameters to pass to :computeMetadataCallback
  computeMetadataCallbackProps: T,

  // Newly updated number of rows or columns in the current axis
  nextCellsCount: number,

  // Newly updated width or height of cells for the current axis
  nextCellSize: ?number,

  // Newly updated scroll-to-index
  nextScrollToIndex: number,

  // Scroll-to-index
  scrollToIndex: number,

  // Callback to invoke if the scroll position should be recalculated
  updateScrollOffsetForScrollToIndex: () => void,
};*/
function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref /*:: */) {
  var cellCount = _ref /*:: */.cellCount,
    cellSize = _ref /*:: */.cellSize,
    computeMetadataCallback = _ref /*:: */.computeMetadataCallback,
    computeMetadataCallbackProps = _ref /*:: */.computeMetadataCallbackProps,
    nextCellsCount = _ref /*:: */.nextCellsCount,
    nextCellSize = _ref /*:: */.nextCellSize,
    nextScrollToIndex = _ref /*:: */.nextScrollToIndex,
    scrollToIndex = _ref /*:: */.scrollToIndex,
    updateScrollOffsetForScrollToIndex = _ref /*:: */.updateScrollOffsetForScrollToIndex;
  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps);

    // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.
    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}
function _objectWithoutPropertiesLoose$5(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _objectWithoutProperties$4(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$5(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

/*:: import type {Alignment, CellSizeGetter, VisibleCellRange} from '../types';*/
/*:: type CellSizeAndPositionManagerParams = {
  cellCount: number,
  cellSizeGetter: CellSizeGetter,
  estimatedCellSize: number,
};*/
/*:: type ConfigureParams = {
  cellCount: number,
  estimatedCellSize: number,
  cellSizeGetter: CellSizeGetter,
};*/
/*:: type GetUpdatedOffsetForIndex = {
  align: Alignment,
  containerSize: number,
  currentOffset: number,
  targetIndex: number,
};*/
/*:: type GetVisibleCellRangeParams = {
  containerSize: number,
  offset: number,
};*/
/*:: type SizeAndPositionData = {
  offset: number,
  size: number,
};*/
/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */
var CellSizeAndPositionManager = /*#__PURE__*/function () {
  function CellSizeAndPositionManager(_ref /*:: */) {
    var cellCount = _ref /*:: */.cellCount,
      cellSizeGetter = _ref /*:: */.cellSizeGetter,
      estimatedCellSize = _ref /*:: */.estimatedCellSize;
    _classCallCheck(this, CellSizeAndPositionManager);
    // Cache of size and position data for cells, mapped by cell index.
    // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
    _defineProperty(this, "_cellSizeAndPositionData", {});
    // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
    _defineProperty(this, "_lastMeasuredIndex", -1);
    // Used in deferred mode to track which cells have been queued for measurement.
    _defineProperty(this, "_lastBatchedIndex", -1);
    _defineProperty(this, "_cellCount", void 0);
    _defineProperty(this, "_cellSizeGetter", void 0);
    _defineProperty(this, "_estimatedCellSize", void 0);
    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;
  }
  return _createClass(CellSizeAndPositionManager, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: "configure",
    value: function configure(_ref2 /*:: */) {
      var cellCount = _ref2 /*:: */.cellCount,
        estimatedCellSize = _ref2 /*:: */.estimatedCellSize,
        cellSizeGetter = _ref2 /*:: */.cellSizeGetter;
      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
      this._cellSizeGetter = cellSizeGetter;
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() /*: number*/{
      return this._cellCount;
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() /*: number*/{
      return this._estimatedCellSize;
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() /*: number*/{
      return this._lastMeasuredIndex;
    }
  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment() {
      return 0;
    }

    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */
  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index /*: number*/) /*: SizeAndPositionData*/{
      if (index < 0 || index >= this._cellCount) {
        throw Error("Requested index ".concat(index, " is outside of range 0..").concat(this._cellCount));
      }
      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var size = this._cellSizeGetter({
            index: i
          });

          // undefined or NaN probably means a logic error in the size getter.
          // null means we're using CellMeasurer and haven't yet measured a given index.
          if (size === undefined || isNaN(size)) {
            throw Error("Invalid size returned for cell ".concat(i, " of value ").concat(size));
          } else if (size === null) {
            this._cellSizeAndPositionData[i] = {
              offset: offset,
              size: 0
            };
            this._lastBatchedIndex = index;
          } else {
            this._cellSizeAndPositionData[i] = {
              offset: offset,
              size: size
            };
            offset += size;
            this._lastMeasuredIndex = index;
          }
        }
      }
      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() /*: SizeAndPositionData*/{
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }

    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */
  }, {
    key: "getTotalSize",
    value: function getTotalSize() /*: number*/{
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
    }

    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */
  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex(_ref3 /*:: */) /*: number*/{
      var _ref3$align = _ref3 /*:: */.align,
        align = _ref3$align === void 0 ? 'auto' : _ref3$align,
        containerSize = _ref3 /*:: */.containerSize,
        currentOffset = _ref3 /*:: */.currentOffset,
        targetIndex = _ref3 /*:: */.targetIndex;
      if (containerSize <= 0) {
        return 0;
      }
      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;
      var idealOffset;
      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;
        case 'end':
          idealOffset = minOffset;
          break;
        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;
        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }
      var totalSize = this.getTotalSize();
      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(params /*: GetVisibleCellRangeParams*/) /*: VisibleCellRange*/{
      var containerSize = params.containerSize,
        offset = params.offset;
      var totalSize = this.getTotalSize();
      if (totalSize === 0) {
        return {};
      }
      var maxOffset = offset + containerSize;
      var start = this._findNearestCell(offset);
      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;
      var stop = start;
      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;
        offset += this.getSizeAndPositionOfCell(stop).size;
      }
      return {
        start: start,
        stop: stop
      };
    }

    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */
  }, {
    key: "resetCell",
    value: function resetCell(index /*: number*/) /*: void*/{
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: "_binarySearch",
    value: function _binarySearch(high /*: number*/, low /*: number*/, offset /*: number*/) /*: number*/{
      while (low <= high) {
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = this.getSizeAndPositionOfCell(middle).offset;
        if (currentOffset === offset) {
          return middle;
        } else if (currentOffset < offset) {
          low = middle + 1;
        } else if (currentOffset > offset) {
          high = middle - 1;
        }
      }
      if (low > 0) {
        return low - 1;
      } else {
        return 0;
      }
    }
  }, {
    key: "_exponentialSearch",
    value: function _exponentialSearch(index /*: number*/, offset /*: number*/) /*: number*/{
      var interval = 1;
      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }
      return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
    }

    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */
  }, {
    key: "_findNearestCell",
    value: function _findNearestCell(offset /*: number*/) /*: number*/{
      if (isNaN(offset)) {
        throw Error("Invalid offset ".concat(offset, " specified"));
      }

      // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.
      offset = Math.max(0, offset);
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch(lastMeasuredIndex, 0, offset);
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch(lastMeasuredIndex, offset);
      }
    }
  }]);
}();
var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;
var isBrowser$1 = function isBrowser() {
  return typeof window !== 'undefined';
};
var isChrome = function isChrome() {
  return !!window.chrome;
};
var getMaxElementSize = function getMaxElementSize() /*: number*/{
  if (isBrowser$1()) {
    if (isChrome()) {
      return CHROME_MAX_ELEMENT_SIZE;
    }
  }
  return DEFAULT_MAX_ELEMENT_SIZE;
};
var _excluded$6 = ["maxScrollSize"];
/*:: type ContainerSizeAndOffset = {
  containerSize: number,
  offset: number,
};*/
/*:: type Params = {
  maxScrollSize?: number,
  cellCount: number,
  cellSizeGetter: CellSizeGetter,
  estimatedCellSize: number,
};*/
/**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */
/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */
var ScalingCellSizeAndPositionManager = /*#__PURE__*/function () {
  function ScalingCellSizeAndPositionManager(_ref /*:: */) {
    var _ref$maxScrollSize = _ref /*:: */.maxScrollSize,
      maxScrollSize = _ref$maxScrollSize === void 0 ? getMaxElementSize() : _ref$maxScrollSize,
      params = _objectWithoutProperties$4(_ref /*:: */, _excluded$6);
    _classCallCheck(this, ScalingCellSizeAndPositionManager);
    _defineProperty(this, "_cellSizeAndPositionManager", void 0);
    _defineProperty(this, "_maxScrollSize", void 0);
    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new CellSizeAndPositionManager(params);
    this._maxScrollSize = maxScrollSize;
  }
  return _createClass(ScalingCellSizeAndPositionManager, [{
    key: "areOffsetsAdjusted",
    value: function areOffsetsAdjusted() /*: boolean*/{
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: "configure",
    value: function configure(params
    /*: {
        cellCount: number,
        estimatedCellSize: number,
        cellSizeGetter: CellSizeGetter,
      }*/) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: "getCellCount",
    value: function getCellCount() /*: number*/{
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: "getEstimatedCellSize",
    value: function getEstimatedCellSize() /*: number*/{
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: "getLastMeasuredIndex",
    value: function getLastMeasuredIndex() /*: number*/{
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }

    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */
  }, {
    key: "getOffsetAdjustment",
    value: function getOffsetAdjustment(_ref2 /*:: */) /*: number*/{
      var containerSize = _ref2 /*:: */.containerSize,
        offset = _ref2 /*:: */.offset;
      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();
      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });
      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: "getSizeAndPositionOfCell",
    value: function getSizeAndPositionOfCell(index /*: number*/) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: "getSizeAndPositionOfLastMeasuredCell",
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }

    /** See CellSizeAndPositionManager#getTotalSize */
  }, {
    key: "getTotalSize",
    value: function getTotalSize() /*: number*/{
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }

    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */
  }, {
    key: "getUpdatedOffsetForIndex",
    value: function getUpdatedOffsetForIndex(_ref3 /*:: */) {
      var _ref3$align = _ref3 /*:: */.align,
        align = _ref3$align === void 0 ? 'auto' : _ref3$align,
        containerSize = _ref3 /*:: */.containerSize,
        currentOffset = _ref3 /*:: */.currentOffset,
        targetIndex = _ref3 /*:: */.targetIndex;
      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });
      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex
      });
      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }

    /** See CellSizeAndPositionManager#getVisibleCellRange */
  }, {
    key: "getVisibleCellRange",
    value: function getVisibleCellRange(_ref4 /*:: */) /*: VisibleCellRange*/{
      var containerSize = _ref4 /*:: */.containerSize,
        offset = _ref4 /*:: */.offset;
      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });
      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: "resetCell",
    value: function resetCell(index /*: number*/) /*: void*/{
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: "_getOffsetPercentage",
    value: function _getOffsetPercentage(_ref5 /*:: */) {
      var containerSize = _ref5 /*:: */.containerSize,
        offset = _ref5 /*:: */.offset,
        totalSize = _ref5 /*:: */.totalSize;
      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: "_offsetToSafeOffset",
    value: function _offsetToSafeOffset(_ref6 /*:: */) /*: number*/{
      var containerSize = _ref6 /*:: */.containerSize,
        offset = _ref6 /*:: */.offset;
      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();
      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });
        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: "_safeOffsetToOffset",
    value: function _safeOffsetToOffset(_ref7 /*:: */) /*: number*/{
      var containerSize = _ref7 /*:: */.containerSize,
        offset = _ref7 /*:: */.offset;
      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();
      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });
        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);
}();

/*:: import type {OverscanIndicesGetterParams, OverscanIndices} from './types';*/
var SCROLL_DIRECTION_BACKWARD = -1;
var SCROLL_DIRECTION_FORWARD$1 = 1;

/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter$1(_ref /*:: */) /*: OverscanIndices*/{
  var cellCount = _ref /*:: */.cellCount,
    overscanCellsCount = _ref /*:: */.overscanCellsCount,
    scrollDirection = _ref /*:: */.scrollDirection,
    startIndex = _ref /*:: */.startIndex,
    stopIndex = _ref /*:: */.stopIndex;
  if (scrollDirection === SCROLL_DIRECTION_FORWARD$1) {
    return {
      overscanStartIndex: Math.max(0, startIndex),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
  }
}

/*:: import type {Alignment, CellSize} from '../types';*/

/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */
/*:: type Params = {
  // Width or height of cells for the current axis
  cellSize?: CellSize,

  // Manages size and position metadata of cells
  cellSizeAndPositionManager: ScalingCellSizeAndPositionManager,

  // Previous number of rows or columns
  previousCellsCount: number,

  // Previous width or height of cells
  previousCellSize: CellSize,

  previousScrollToAlignment: Alignment,

  // Previous scroll-to-index
  previousScrollToIndex: number,

  // Previous width or height of the virtualized container
  previousSize: number,

  // Current scrollLeft or scrollTop
  scrollOffset: number,

  scrollToAlignment: Alignment,

  // Scroll-to-index
  scrollToIndex: number,

  // Width or height of the virtualized container
  size: number,

  sizeJustIncreasedFromZero: boolean,

  // Callback to invoke with an scroll-to-index value
  updateScrollIndexCallback: (index: number) => void,
};*/
function updateScrollIndexHelper(_ref /*:: */) {
  var cellSize = _ref /*:: */.cellSize,
    cellSizeAndPositionManager = _ref /*:: */.cellSizeAndPositionManager,
    previousCellsCount = _ref /*:: */.previousCellsCount,
    previousCellSize = _ref /*:: */.previousCellSize,
    previousScrollToAlignment = _ref /*:: */.previousScrollToAlignment,
    previousScrollToIndex = _ref /*:: */.previousScrollToIndex,
    previousSize = _ref /*:: */.previousSize,
    scrollOffset = _ref /*:: */.scrollOffset,
    scrollToAlignment = _ref /*:: */.scrollToAlignment,
    scrollToIndex = _ref /*:: */.scrollToIndex,
    size = _ref /*:: */.size,
    sizeJustIncreasedFromZero = _ref /*:: */.sizeJustIncreasedFromZero,
    updateScrollIndexCallback = _ref /*:: */.updateScrollIndexCallback;
  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;

  // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.
  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex);

    // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}

/*:: import type {CellRangeRendererParams} from './types';*/

/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */

function defaultCellRangeRenderer(_ref /*:: */) {
  var cellCache = _ref /*:: */.cellCache,
    cellRenderer = _ref /*:: */.cellRenderer,
    columnSizeAndPositionManager = _ref /*:: */.columnSizeAndPositionManager,
    columnStartIndex = _ref /*:: */.columnStartIndex,
    columnStopIndex = _ref /*:: */.columnStopIndex,
    deferredMeasurementCache = _ref /*:: */.deferredMeasurementCache,
    horizontalOffsetAdjustment = _ref /*:: */.horizontalOffsetAdjustment,
    isScrolling = _ref /*:: */.isScrolling,
    isScrollingOptOut = _ref /*:: */.isScrollingOptOut,
    parent = _ref /*:: */.parent,
    rowSizeAndPositionManager = _ref /*:: */.rowSizeAndPositionManager,
    rowStartIndex = _ref /*:: */.rowStartIndex,
    rowStopIndex = _ref /*:: */.rowStopIndex,
    styleCache = _ref /*:: */.styleCache,
    verticalOffsetAdjustment = _ref /*:: */.verticalOffsetAdjustment,
    visibleColumnIndices = _ref /*:: */.visibleColumnIndices,
    visibleRowIndices = _ref /*:: */.visibleRowIndices;
  var renderedCells = [];

  // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
  // User cannot scroll beyond these size limitations.
  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
  // We should never cache styles for compressed offsets though as this can lead to bugs.
  // See issue #576 for more.
  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;
  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = "".concat(rowIndex, "-").concat(columnIndex);
      var style = void 0;

      // Cache style objects so shallow-compare doesn't re-render unnecessarily.
      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        // In deferred mode, cells will be initially rendered before we know their size.
        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          // Position not-yet-measured cells at top/left 0,0,
          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
          // Positioning them further to the right/bottom influences their measured size.
          style = {
            height: 'auto',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 'auto'
          };
        } else {
          style = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: 'absolute',
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };
          styleCache[key] = style;
        }
      }
      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent,
        rowIndex: rowIndex,
        style: style
      };
      var renderedCell = void 0;

      // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      //
      // If isScrollingOptOut is specified, we always cache cells.
      // For more info refer to issue #1028
      if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }
        renderedCell = cellCache[key];

        // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }
      if (renderedCell == null || renderedCell === false) {
        continue;
      }
      if (process.env.NODE_ENV !== 'production') {
        warnAboutMissingStyle(parent, renderedCell);
      }
      if (!renderedCell.props.role) {
        renderedCell = /*#__PURE__*/React__default.cloneElement(renderedCell, {
          role: 'gridcell'
        });
      }
      renderedCells.push(renderedCell);
    }
  }
  return renderedCells;
}
function warnAboutMissingStyle(parent, renderedCell) {
  if (process.env.NODE_ENV !== 'production') {
    if (renderedCell) {
      // If the direct child is a CellMeasurer, then we should check its child
      // See issue #611
      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
        renderedCell = renderedCell.props.children;
      }
      if (renderedCell && renderedCell.props && renderedCell.props.style === undefined && parent.__warnedAboutMissingStyle !== true) {
        parent.__warnedAboutMissingStyle = true;
        console.warn('Rendered cell should include style property for positioning.');
      }
    }
  }
}

/*:: type Callback = (timestamp: number) => void;*/
/*:: type CancelAnimationFrame = (requestId: number) => void;*/
/*:: type RequestAnimationFrame = (callback: Callback) => number;*/
// Properly handle server-side rendering.
var win;
if (typeof window !== 'undefined') {
  win = window;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
}

// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback /*: Callback*/) /*: RequestAnimationFrame*/{
  return win /*: any*/.setTimeout(callback, 1000 / 60);
};
var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id /*: number*/) {
  win /*: any*/.clearTimeout(id);
};
var raf /*: RequestAnimationFrame*/ = request /*: any*/;
var caf /*: CancelAnimationFrame*/ = cancel /*: any*/;

/*:: export type AnimationTimeoutId = {
  id: number,
};*/
var cancelAnimationTimeout = function cancelAnimationTimeout(frame /*: AnimationTimeoutId*/) {
  return caf(frame.id);
};

/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */
var requestAnimationTimeout = function requestAnimationTimeout(callback /*: Function*/, delay /*: number*/) /*: AnimationTimeoutId*/{
  var start;
  // wait for end of processing current event handler, because event handler may be long
  Promise.resolve().then(function () {
    start = Date.now();
  });
  var _timeout = function timeout() {
    if (Date.now() - start >= delay) {
      callback.call();
    } else {
      frame.id = raf(_timeout);
    }
  };
  var frame /*: AnimationTimeoutId*/ = {
    id: raf(_timeout)
  };
  return frame;
};
function ownKeys$7(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$7(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$7(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _callSuper$8(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$8() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$8() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$8 = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL$1 = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};
var renderNull /*: NoContentRenderer*/ = function renderNull() {
  return null;
};
/*:: type ScrollPosition = {
  scrollTop?: number,
  scrollLeft?: number,
};*/
/*:: type Props = {
  'aria-label': string,
  'aria-readonly'?: boolean,

  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   *-/
  autoContainerWidth: boolean,

  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   *-/
  autoHeight: boolean,

  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   *-/
  autoWidth: boolean,

  /** Responsible for rendering a cell given an row and column index.  *-/
  cellRenderer: CellRenderer,

  /** Responsible for rendering a group of cells given their index ranges.  *-/
  cellRangeRenderer: CellRangeRenderer,

  /** Optional custom CSS class name to attach to root Grid element.  *-/
  className?: string,

  /** Number of columns in grid.  *-/
  columnCount: number,

  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  *-/
  columnWidth: CellSize,

  /** Unfiltered props for the Grid container. *-/
  containerProps?: Object,

  /** ARIA role for the cell-container.  *-/
  containerRole: string,

  /** Optional inline style applied to inner cell-container *-/
  containerStyle: Object,

  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   *-/
  deferredMeasurementCache?: Object,

  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   *-/
  estimatedColumnSize: number,

  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   *-/
  estimatedRowSize: number,

  /** Exposed for testing purposes only.  *-/
  getScrollbarSize: () => number,

  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  *-/
  height: number,

  /** Optional custom id to attach to root Grid element.  *-/
  id?: string,

  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   *-/
  isScrolling?: boolean,

  /**
   * Opt-out of isScrolling param passed to cellRangeRenderer.
   * To avoid the extra render when scroll stops.
   *-/
  isScrollingOptOut: boolean,

  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  *-/
  noContentRenderer: NoContentRenderer,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   *-/
  onScroll: (params: Scroll) => void,

  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   *-/
  onScrollbarPresenceChange: (params: ScrollbarPresenceChange) => void,

  /** Callback invoked with information about the section of the Grid that was just rendered.  *-/
  onSectionRendered: (params: RenderedSection) => void,

  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   *-/
  overscanColumnCount: number,

  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   *-/
  overscanIndicesGetter: OverscanIndicesGetter,

  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   *-/
  overscanRowCount: number,

  /** ARIA role for the grid element.  *-/
  role: string,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   *-/
  rowHeight: CellSize,

  /** Number of rows in grid.  *-/
  rowCount: number,

  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. *-/
  scrollingResetTimeInterval: number,

  /** Horizontal offset. *-/
  scrollLeft?: number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   *-/
  scrollToAlignment: Alignment,

  /** Column index to ensure visible (by forcefully scrolling if necessary) *-/
  scrollToColumn: number,

  /** Vertical offset. *-/
  scrollTop?: number,

  /** Row index to ensure visible (by forcefully scrolling if necessary) *-/
  scrollToRow: number,

  /** Optional inline style *-/
  style: Object,

  /** Tab index for focus *-/
  tabIndex: ?number,

  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  *-/
  width: number,

  /** Reference to DOM node *-/
  elementRef?: React.Ref<React.ElementType>,
};*/
/*:: type InstanceProps = {
  prevColumnWidth: CellSize,
  prevRowHeight: CellSize,

  prevColumnCount: number,
  prevRowCount: number,
  prevIsScrolling: boolean,
  prevScrollToColumn: number,
  prevScrollToRow: number,

  columnSizeAndPositionManager: ScalingCellSizeAndPositionManager,
  rowSizeAndPositionManager: ScalingCellSizeAndPositionManager,

  scrollbarSize: number,
  scrollbarSizeMeasured: boolean,
};*/
/*:: type State = {
  instanceProps: InstanceProps,
  isScrolling: boolean,
  scrollDirectionHorizontal: -1 | 1,
  scrollDirectionVertical: -1 | 1,
  scrollLeft: number,
  scrollTop: number,
  scrollPositionChangeReason: 'observed' | 'requested' | null,
  needToResetStyleCache: boolean,
};*/
/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */
var Grid = /*#__PURE__*/function (_React$PureComponent) {
  function Grid(props /*: Props*/) {
    var _this;
    _classCallCheck(this, Grid);
    _this = _callSuper$8(this, Grid, [props]);
    // Invokes onSectionRendered callback only when start/stop row or column indices change
    _defineProperty(_this, "_onGridRenderedMemoizer", createCallbackMemoizer());
    _defineProperty(_this, "_onScrollMemoizer", createCallbackMemoizer(false));
    _defineProperty(_this, "_deferredInvalidateColumnIndex", null);
    _defineProperty(_this, "_deferredInvalidateRowIndex", null);
    _defineProperty(_this, "_recomputeScrollLeftFlag", false);
    _defineProperty(_this, "_recomputeScrollTopFlag", false);
    _defineProperty(_this, "_horizontalScrollBarSize", 0);
    _defineProperty(_this, "_verticalScrollBarSize", 0);
    _defineProperty(_this, "_scrollbarPresenceChanged", false);
    _defineProperty(_this, "_scrollingContainer", void 0);
    _defineProperty(_this, "_childrenToDisplay", void 0);
    _defineProperty(_this, "_columnStartIndex", void 0);
    _defineProperty(_this, "_columnStopIndex", void 0);
    _defineProperty(_this, "_rowStartIndex", void 0);
    _defineProperty(_this, "_rowStopIndex", void 0);
    _defineProperty(_this, "_renderedColumnStartIndex", 0);
    _defineProperty(_this, "_renderedColumnStopIndex", 0);
    _defineProperty(_this, "_renderedRowStartIndex", 0);
    _defineProperty(_this, "_renderedRowStopIndex", 0);
    _defineProperty(_this, "_initialScrollTop", void 0);
    _defineProperty(_this, "_initialScrollLeft", void 0);
    _defineProperty(_this, "_disablePointerEventsTimeoutId", void 0);
    _defineProperty(_this, "_styleCache", {});
    _defineProperty(_this, "_cellCache", {});
    _defineProperty(_this, "_debounceScrollEndedCallback", function () {
      _this._disablePointerEventsTimeoutId = null;
      // isScrolling is used to determine if we reset styleCache
      _this.setState({
        isScrolling: false,
        needToResetStyleCache: false
      });
    });
    _defineProperty(_this, "_invokeOnGridRenderedHelper", function () {
      var onSectionRendered = _this.props.onSectionRendered;
      _this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: _this._columnStartIndex,
          columnOverscanStopIndex: _this._columnStopIndex,
          columnStartIndex: _this._renderedColumnStartIndex,
          columnStopIndex: _this._renderedColumnStopIndex,
          rowOverscanStartIndex: _this._rowStartIndex,
          rowOverscanStopIndex: _this._rowStopIndex,
          rowStartIndex: _this._renderedRowStartIndex,
          rowStopIndex: _this._renderedRowStopIndex
        }
      });
    });
    _defineProperty(_this, "_setScrollingContainerRef", function (ref /*: Element*/) {
      _this._scrollingContainer = ref;
      if (typeof _this.props.elementRef === 'function') {
        _this.props.elementRef(ref);
      } else if (_typeof(_this.props.elementRef) === 'object') {
        _this.props.elementRef.current = ref;
      }
    });
    _defineProperty(_this, "_onScroll", function (event /*: Event*/) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target === _this._scrollingContainer) {
        _this.handleScrollEvent(event.target /*: any*/);
      }
    });
    var columnSizeAndPositionManager = new ScalingCellSizeAndPositionManager({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.columnWidth)(params);
      },
      estimatedCellSize: Grid._getEstimatedColumnSize(props)
    });
    var rowSizeAndPositionManager = new ScalingCellSizeAndPositionManager({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.rowHeight)(params);
      },
      estimatedCellSize: Grid._getEstimatedRowSize(props)
    });
    _this.state = {
      instanceProps: {
        columnSizeAndPositionManager: columnSizeAndPositionManager,
        rowSizeAndPositionManager: rowSizeAndPositionManager,
        prevColumnWidth: props.columnWidth,
        prevRowHeight: props.rowHeight,
        prevColumnCount: props.columnCount,
        prevRowCount: props.rowCount,
        prevIsScrolling: props.isScrolling === true,
        prevScrollToColumn: props.scrollToColumn,
        prevScrollToRow: props.scrollToRow,
        scrollbarSize: 0,
        scrollbarSizeMeasured: false
      },
      isScrolling: false,
      scrollDirectionHorizontal: SCROLL_DIRECTION_FORWARD$1,
      scrollDirectionVertical: SCROLL_DIRECTION_FORWARD$1,
      scrollLeft: 0,
      scrollTop: 0,
      scrollPositionChangeReason: null,
      needToResetStyleCache: false
    };
    if (props.scrollToRow > 0) {
      _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
    }
    if (props.scrollToColumn > 0) {
      _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
    }
    return _this;
  }

  /**
   * Gets offsets for a given cell and alignment.
   */
  _inherits(Grid, _React$PureComponent);
  return _createClass(Grid, [{
    key: "getOffsetForCell",
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$alignment = _ref.alignment,
        alignment = _ref$alignment === void 0 ? this.props.scrollToAlignment : _ref$alignment,
        _ref$columnIndex = _ref.columnIndex,
        columnIndex = _ref$columnIndex === void 0 ? this.props.scrollToColumn : _ref$columnIndex,
        _ref$rowIndex = _ref.rowIndex,
        rowIndex = _ref$rowIndex === void 0 ? this.props.scrollToRow : _ref$rowIndex;
      var offsetProps = _objectSpread$7(_objectSpread$7({}, this.props), {}, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });
      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }

    /**
     * Gets estimated total rows' height.
     */
  }, {
    key: "getTotalRowsHeight",
    value: function getTotalRowsHeight() {
      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
    }

    /**
     * Gets estimated total columns' width.
     */
  }, {
    key: "getTotalColumnsWidth",
    value: function getTotalColumnsWidth() {
      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
    }

    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */
  }, {
    key: "handleScrollEvent",
    value: function handleScrollEvent(_ref2 /*:: */) {
      var _ref2$scrollLeft = _ref2 /*:: */.scrollLeft,
        scrollLeftParam = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft,
        _ref2$scrollTop = _ref2 /*:: */.scrollTop,
        scrollTopParam = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop;
      // On iOS, we can arrive at negative offsets by swiping past the start.
      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
      if (scrollTopParam < 0) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      this._debounceScrollEnded();
      var _this$props = this.props,
        autoHeight = _this$props.autoHeight,
        autoWidth = _this$props.autoWidth,
        height = _this$props.height,
        width = _this$props.width;
      var instanceProps = this.state.instanceProps;

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
      var scrollbarSize = instanceProps.scrollbarSize;
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        // Don't change direction for an axis unless scroll offset has changed.
        var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? SCROLL_DIRECTION_FORWARD$1 : SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
        var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? SCROLL_DIRECTION_FORWARD$1 : SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
        var newState /*: $Shape<State>*/ = {
          isScrolling: true,
          scrollDirectionHorizontal: scrollDirectionHorizontal,
          scrollDirectionVertical: scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };
        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }
        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }
        newState.needToResetStyleCache = false;
        this.setState(newState);
      }
      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalColumnsWidth: totalColumnsWidth,
        totalRowsHeight: totalRowsHeight
      });
    }

    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.
  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref3 /*:: */) {
      var columnIndex = _ref3 /*:: */.columnIndex,
        rowIndex = _ref3 /*:: */.rowIndex;
      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }

    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */
  }, {
    key: "measureAllCells",
    value: function measureAllCells() {
      var _this$props2 = this.props,
        columnCount = _this$props2.columnCount,
        rowCount = _this$props2.rowCount;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }

    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */
  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$columnIndex = _ref4.columnIndex,
        columnIndex = _ref4$columnIndex === void 0 ? 0 : _ref4$columnIndex,
        _ref4$rowIndex = _ref4.rowIndex,
        rowIndex = _ref4$rowIndex === void 0 ? 0 : _ref4$rowIndex;
      var _this$props3 = this.props,
        scrollToColumn = _this$props3.scrollToColumn,
        scrollToRow = _this$props3.scrollToRow;
      var instanceProps = this.state.instanceProps;
      instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
      instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);

      // Cell sizes may be determined by a function property.
      // In this case the cDU handler can't know if they changed.
      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === SCROLL_DIRECTION_FORWARD$1 ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
      this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === SCROLL_DIRECTION_FORWARD$1 ? rowIndex <= scrollToRow : rowIndex >= scrollToRow);

      // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.
      this._styleCache = {};
      this._cellCache = {};
      this.forceUpdate();
    }

    /**
     * Ensure column and row are visible.
     */
  }, {
    key: "scrollToCell",
    value: function scrollToCell(_ref5 /*:: */) {
      var columnIndex = _ref5 /*:: */.columnIndex,
        rowIndex = _ref5 /*:: */.rowIndex;
      var columnCount = this.props.columnCount;
      var props = this.props;

      // Don't adjust scroll offset for single-column grids (eg List, Table).
      // This can cause a funky scroll offset because of the vertical scrollbar width.
      if (columnCount > 1 && columnIndex !== undefined) {
        this._updateScrollLeftForScrollToColumn(_objectSpread$7(_objectSpread$7({}, props), {}, {
          scrollToColumn: columnIndex
        }));
      }
      if (rowIndex !== undefined) {
        this._updateScrollTopForScrollToRow(_objectSpread$7(_objectSpread$7({}, props), {}, {
          scrollToRow: rowIndex
        }));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
        getScrollbarSize = _this$props4.getScrollbarSize,
        height = _this$props4.height,
        scrollLeft = _this$props4.scrollLeft,
        scrollToColumn = _this$props4.scrollToColumn,
        scrollTop = _this$props4.scrollTop,
        scrollToRow = _this$props4.scrollToRow,
        width = _this$props4.width;
      var instanceProps = this.state.instanceProps;

      // Reset initial offsets to be ignored in browser
      this._initialScrollTop = 0;
      this._initialScrollLeft = 0;

      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.
      this._handleInvalidatedGridSize();

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.
      if (!instanceProps.scrollbarSizeMeasured) {
        this.setState(function (prevState) {
          var stateUpdate = _objectSpread$7(_objectSpread$7({}, prevState), {}, {
            needToResetStyleCache: false
          });
          stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
          stateUpdate.instanceProps.scrollbarSizeMeasured = true;
          return stateUpdate;
        });
      }
      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
        var stateUpdate = Grid._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });
        if (stateUpdate) {
          stateUpdate.needToResetStyleCache = false;
          this.setState(stateUpdate);
        }
      }

      // refs don't work in `react-test-renderer`
      if (this._scrollingContainer) {
        // setting the ref's scrollLeft and scrollTop.
        // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
        if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) {
          this._scrollingContainer.scrollLeft = this.state.scrollLeft;
        }
        if (this._scrollingContainer.scrollTop !== this.state.scrollTop) {
          this._scrollingContainer.scrollTop = this.state.scrollTop;
        }
      }

      // Don't update scroll offset if the size is 0; we don't render any cells in this case.
      // Setting a state may cause us to later thing we've updated the offce when we haven't.
      var sizeIsBiggerThanZero = height > 0 && width > 0;
      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }
      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      }

      // Update onRowsRendered callback
      this._invokeOnGridRenderedHelper();

      // Initialize onScroll callback
      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
      });
      this._maybeCallOnScrollbarPresenceChange();
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps /*: Props*/, prevState /*: State*/) {
      var _this2 = this;
      var _this$props5 = this.props,
        autoHeight = _this$props5.autoHeight,
        autoWidth = _this$props5.autoWidth,
        columnCount = _this$props5.columnCount,
        height = _this$props5.height,
        rowCount = _this$props5.rowCount,
        scrollToAlignment = _this$props5.scrollToAlignment,
        scrollToColumn = _this$props5.scrollToColumn,
        scrollToRow = _this$props5.scrollToRow,
        width = _this$props5.width;
      var _this$state = this.state,
        scrollLeft = _this$state.scrollLeft,
        scrollPositionChangeReason = _this$state.scrollPositionChangeReason,
        scrollTop = _this$state.scrollTop,
        instanceProps = _this$state.instanceProps;
      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.
      this._handleInvalidatedGridSize();

      // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218
      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.
      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Special case where the previous size was 0:
      // In this case we don't show any windowed cells at all.
      // So we should always recalculate offset afterwards.
      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;

      // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;
        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        updateScrollIndexHelper({
          cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }
      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;
        this._updateScrollTopForScrollToRow(this.props);
      } else {
        updateScrollIndexHelper({
          cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      }

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnGridRenderedHelper();

      // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
        this._invokeOnScrollMemoizer({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          totalColumnsWidth: totalColumnsWidth,
          totalRowsHeight: totalRowsHeight
        });
      }
      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        cancelAnimationTimeout(this._disablePointerEventsTimeoutId);
      }
    }

    /**
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        autoContainerWidth = _this$props6.autoContainerWidth,
        autoHeight = _this$props6.autoHeight,
        autoWidth = _this$props6.autoWidth,
        className = _this$props6.className,
        containerProps = _this$props6.containerProps,
        containerRole = _this$props6.containerRole,
        containerStyle = _this$props6.containerStyle,
        height = _this$props6.height,
        id = _this$props6.id,
        noContentRenderer = _this$props6.noContentRenderer,
        role = _this$props6.role,
        style = _this$props6.style,
        tabIndex = _this$props6.tabIndex,
        width = _this$props6.width;
      var _this$state2 = this.state,
        instanceProps = _this$state2.instanceProps,
        needToResetStyleCache = _this$state2.needToResetStyleCache;
      var isScrolling = this._isScrolling();
      var gridStyle /*: Object*/ = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: autoWidth ? 'auto' : width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };
      if (needToResetStyleCache) {
        this._styleCache = {};
      }

      // calculate _styleCache here
      // if state.isScrolling (not from _isScrolling) then reset
      if (!this.state.isScrolling) {
        this._resetStyleCache();
      }

      // calculate children to render here
      this._calculateChildrenToRender(this.props, this.state);
      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      }

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
      var childrenToDisplay = this._childrenToDisplay;
      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
      return /*#__PURE__*/React.createElement("div", _extends$5({
        ref: this._setScrollingContainerRef
      }, containerProps, {
        "aria-label": this.props['aria-label'],
        "aria-readonly": this.props['aria-readonly'],
        className: clsx('ReactVirtualized__Grid', className),
        id: id,
        onScroll: this._onScroll,
        role: role,
        style: _objectSpread$7(_objectSpread$7({}, gridStyle), style),
        tabIndex: tabIndex
      }), childrenToDisplay.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "ReactVirtualized__Grid__innerScrollContainer",
        role: containerRole,
        style: _objectSpread$7({
          width: autoContainerWidth ? 'auto' : totalColumnsWidth,
          height: totalRowsHeight,
          maxWidth: totalColumnsWidth,
          maxHeight: totalRowsHeight,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          position: 'relative'
        }, containerStyle)
      }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
    }

    /* ---------------------------- Helper methods ---------------------------- */
  }, {
    key: "_calculateChildrenToRender",
    value: function _calculateChildrenToRender() {
      var props /*: Props*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state /*: State*/ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer,
        cellRangeRenderer = props.cellRangeRenderer,
        columnCount = props.columnCount,
        deferredMeasurementCache = props.deferredMeasurementCache,
        height = props.height,
        overscanColumnCount = props.overscanColumnCount,
        overscanIndicesGetter = props.overscanIndicesGetter,
        overscanRowCount = props.overscanRowCount,
        rowCount = props.rowCount,
        width = props.width,
        isScrollingOptOut = props.isScrollingOptOut;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
        scrollDirectionVertical = state.scrollDirectionVertical,
        instanceProps = state.instanceProps;
      var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
      var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;
      var isScrolling = this._isScrolling(props, state);
      this._childrenToDisplay = [];

      // Render only enough columns and rows to cover the visible area of the grid.
      if (height > 0 && width > 0) {
        var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });
        var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        });

        // Store for _invokeOnGridRenderedHelper()
        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;
        var overscanColumnIndices = overscanIndicesGetter({
          direction: 'horizontal',
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
        });
        var overscanRowIndices = overscanIndicesGetter({
          direction: 'vertical',
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
        });

        // Store for _invokeOnGridRenderedHelper()
        var columnStartIndex = overscanColumnIndices.overscanStartIndex;
        var columnStopIndex = overscanColumnIndices.overscanStopIndex;
        var rowStartIndex = overscanRowIndices.overscanStartIndex;
        var rowStopIndex = overscanRowIndices.overscanStopIndex;

        // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
        if (deferredMeasurementCache) {
          // If rows have a dynamic height, scan the rows we are about to render.
          // If any have not yet been measured, then we need to render all columns initially,
          // Because the height of the row is equal to the tallest cell within that row,
          // (And so we can't know the height without measuring all column-cells first).
          if (!deferredMeasurementCache.hasFixedHeight()) {
            for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
              if (!deferredMeasurementCache.has(rowIndex, 0)) {
                columnStartIndex = 0;
                columnStopIndex = columnCount - 1;
                break;
              }
            }
          }

          // If columns have a dynamic width, scan the columns we are about to render.
          // If any have not yet been measured, then we need to render all rows initially,
          // Because the width of the column is equal to the widest cell within that column,
          // (And so we can't know the width without measuring all row-cells first).
          if (!deferredMeasurementCache.hasFixedWidth()) {
            for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
              if (!deferredMeasurementCache.has(0, columnIndex)) {
                rowStartIndex = 0;
                rowStopIndex = rowCount - 1;
                break;
              }
            }
          }
        }
        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          columnStartIndex: columnStartIndex,
          columnStopIndex: columnStopIndex,
          deferredMeasurementCache: deferredMeasurementCache,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          isScrollingOptOut: isScrollingOptOut,
          parent: this,
          rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          rowStartIndex: rowStartIndex,
          rowStopIndex: rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        });

        // update the indices
        this._columnStartIndex = columnStartIndex;
        this._columnStopIndex = columnStopIndex;
        this._rowStartIndex = rowStartIndex;
        this._rowStopIndex = rowStopIndex;
      }
    }

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */
  }, {
    key: "_debounceScrollEnded",
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
      if (this._disablePointerEventsTimeoutId) {
        cancelAnimationTimeout(this._disablePointerEventsTimeoutId);
      }
      this._disablePointerEventsTimeoutId = requestAnimationTimeout(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: "_handleInvalidatedGridSize",
    value:
    /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */
    function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;
        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;
        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
      }
    }
  }, {
    key: "_invokeOnScrollMemoizer",
    value: function _invokeOnScrollMemoizer(_ref6 /*:: */) {
      var _this3 = this;
      var scrollLeft = _ref6 /*:: */.scrollLeft,
        scrollTop = _ref6 /*:: */.scrollTop,
        totalColumnsWidth = _ref6 /*:: */.totalColumnsWidth,
        totalRowsHeight = _ref6 /*:: */.totalRowsHeight;
      this._onScrollMemoizer({
        callback: function callback(_ref7) {
          var scrollLeft = _ref7.scrollLeft,
            scrollTop = _ref7.scrollTop;
          var _this3$props = _this3.props,
            height = _this3$props.height,
            onScroll = _this3$props.onScroll,
            width = _this3$props.width;
          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: "_isScrolling",
    value: function _isScrolling() /*: boolean*/{
      var props /*: Props*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state /*: State*/ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      // If isScrolling is defined in props, use it to override the value in state
      // This is a performance optimization for WindowScroller + Grid
      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
    }
  }, {
    key: "_maybeCallOnScrollbarPresenceChange",
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
        this._scrollbarPresenceChanged = false;
        onScrollbarPresenceChange({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this.state.instanceProps.scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: "scrollToPosition",
    value:
    /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */
    function scrollToPosition(_ref8 /*:: */) {
      var scrollLeft = _ref8 /*:: */.scrollLeft,
        scrollTop = _ref8 /*:: */.scrollTop;
      var stateUpdate = Grid._getScrollToPositionStateUpdate({
        prevState: this.state,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });
      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft() {
      var props /*: Props*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state /*: State*/ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return Grid._getCalculatedScrollLeft(props, state);
    }
  }, {
    key: "_updateScrollLeftForScrollToColumn",
    value: function _updateScrollLeftForScrollToColumn() {
      var props /*: Props*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state /*: State*/ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop() {
      var props /*: Props*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state /*: State*/ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      return Grid._getCalculatedScrollTop(props, state);
    }
  }, {
    key: "_resetStyleCache",
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;
      var cellCache = this._cellCache;
      var isScrollingOptOut = this.props.isScrollingOptOut;

      // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
      // This keeps the cellCache to a resonable size.
      this._cellCache = {};
      this._styleCache = {};

      // Copy over the visible cell styles so avoid unnecessary re-render.
      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = "".concat(rowIndex, "-").concat(columnIndex);
          this._styleCache[key] = styleCache[key];
          if (isScrollingOptOut) {
            this._cellCache[key] = cellCache[key];
          }
        }
      }
    }
  }, {
    key: "_updateScrollTopForScrollToRow",
    value: function _updateScrollTopForScrollToRow() {
      var props /*: Props*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state /*: State*/ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps /*: Props*/, prevState /*: State*/) /*: $Shape<State>*/{
      var newState = {};
      if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
        newState.scrollLeft = 0;
        newState.scrollTop = 0;

        // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
        // scrollTo{Column,Row} should override scroll{Left,Top}
      } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) {
        Object.assign(newState, Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: nextProps.scrollLeft,
          scrollTop: nextProps.scrollTop
        }));
      }
      var instanceProps = prevState.instanceProps;

      // Initially we should not clearStyleCache
      newState.needToResetStyleCache = false;
      if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) {
        // Reset cache. set it to {} in render
        newState.needToResetStyleCache = true;
      }
      instanceProps.columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
      });
      instanceProps.rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
      });
      if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
        instanceProps.prevColumnCount = 0;
        instanceProps.prevRowCount = 0;
      }

      // If scrolling is controlled outside this component, clear cache when scrolling stops
      if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) {
        Object.assign(newState, {
          isScrolling: false
        });
      }
      var maybeStateA;
      var maybeStateB;
      calculateSizeAndPositionDataAndUpdateScrollOffset({
        cellCount: instanceProps.prevColumnCount,
        cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: instanceProps.prevScrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
        }
      });
      calculateSizeAndPositionDataAndUpdateScrollOffset({
        cellCount: instanceProps.prevRowCount,
        cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: instanceProps.prevScrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
        }
      });
      instanceProps.prevColumnCount = nextProps.columnCount;
      instanceProps.prevColumnWidth = nextProps.columnWidth;
      instanceProps.prevIsScrolling = nextProps.isScrolling === true;
      instanceProps.prevRowCount = nextProps.rowCount;
      instanceProps.prevRowHeight = nextProps.rowHeight;
      instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
      instanceProps.prevScrollToRow = nextProps.scrollToRow;

      // getting scrollBarSize (moved from componentWillMount)
      instanceProps.scrollbarSize = nextProps.getScrollbarSize();
      if (instanceProps.scrollbarSize === undefined) {
        instanceProps.scrollbarSizeMeasured = false;
        instanceProps.scrollbarSize = 0;
      } else {
        instanceProps.scrollbarSizeMeasured = true;
      }
      newState.instanceProps = instanceProps;
      return _objectSpread$7(_objectSpread$7(_objectSpread$7({}, newState), maybeStateA), maybeStateB);
    }
  }, {
    key: "_getEstimatedColumnSize",
    value: function _getEstimatedColumnSize(props /*: Props*/) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: "_getEstimatedRowSize",
    value: function _getEstimatedRowSize(props /*: Props*/) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }
  }, {
    key: "_getScrollToPositionStateUpdate",
    value:
    /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */
    function _getScrollToPositionStateUpdate(_ref9 /*:: */) /*: $Shape<State>*/{
      var prevState = _ref9 /*:: */.prevState,
        scrollLeft = _ref9 /*:: */.scrollLeft,
        scrollTop = _ref9 /*:: */.scrollTop;
      var newState /*: Object*/ = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };
      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? SCROLL_DIRECTION_FORWARD$1 : SCROLL_DIRECTION_BACKWARD;
        newState.scrollLeft = scrollLeft;
      }
      if (typeof scrollTop === 'number' && scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? SCROLL_DIRECTION_FORWARD$1 : SCROLL_DIRECTION_BACKWARD;
        newState.scrollTop = scrollTop;
      }
      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) {
        return newState;
      }
      return {};
    }
  }, {
    key: "_wrapSizeGetter",
    value: function _wrapSizeGetter(value /*: CellSize*/) /*: CellSizeGetter*/{
      return typeof value === 'function' ? value : function () {
        return value /*: any*/;
      };
    }
  }, {
    key: "_getCalculatedScrollLeft",
    value: function _getCalculatedScrollLeft(nextProps /*: Props*/, prevState /*: State*/) {
      var columnCount = nextProps.columnCount,
        height = nextProps.height,
        scrollToAlignment = nextProps.scrollToAlignment,
        scrollToColumn = nextProps.scrollToColumn,
        width = nextProps.width;
      var scrollLeft = prevState.scrollLeft,
        instanceProps = prevState.instanceProps;
      if (columnCount > 0) {
        var finalColumn = columnCount - 1;
        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
        return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });
      }
      return 0;
    }
  }, {
    key: "_getScrollLeftForScrollToColumnStateUpdate",
    value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps /*: Props*/, prevState /*: State*/) /*: $Shape<State>*/{
      var scrollLeft = prevState.scrollLeft;
      var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);
      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: calculatedScrollLeft,
          scrollTop: -1
        });
      }
      return {};
    }
  }, {
    key: "_getCalculatedScrollTop",
    value: function _getCalculatedScrollTop(nextProps /*: Props*/, prevState /*: State*/) {
      var height = nextProps.height,
        rowCount = nextProps.rowCount,
        scrollToAlignment = nextProps.scrollToAlignment,
        scrollToRow = nextProps.scrollToRow,
        width = nextProps.width;
      var scrollTop = prevState.scrollTop,
        instanceProps = prevState.instanceProps;
      if (rowCount > 0) {
        var finalRow = rowCount - 1;
        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
        return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });
      }
      return 0;
    }
  }, {
    key: "_getScrollTopForScrollToRowStateUpdate",
    value: function _getScrollTopForScrollToRowStateUpdate(nextProps /*: Props*/, prevState /*: State*/) /*: $Shape<State>*/{
      var scrollTop = prevState.scrollTop;
      var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);
      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: -1,
          scrollTop: calculatedScrollTop
        });
      }
      return {};
    }
  }]);
}(React.PureComponent);
_defineProperty(Grid, "defaultProps", {
  'aria-label': 'grid',
  'aria-readonly': true,
  autoContainerWidth: false,
  autoHeight: false,
  autoWidth: false,
  cellRangeRenderer: defaultCellRangeRenderer,
  containerRole: 'row',
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: scrollbarSize,
  noContentRenderer: renderNull,
  onScroll: function onScroll() {},
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
  onSectionRendered: function onSectionRendered() {},
  overscanColumnCount: 0,
  overscanIndicesGetter: defaultOverscanIndicesGetter$1,
  overscanRowCount: 10,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL$1,
  scrollToAlignment: 'auto',
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0,
  isScrollingOptOut: false
});
polyfill(Grid);

/*:: import type {OverscanIndicesGetterParams, OverscanIndices} from './types';*/
var SCROLL_DIRECTION_FORWARD = 1;

/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref /*:: */) /*: OverscanIndices*/{
  var cellCount = _ref /*:: */.cellCount,
    overscanCellsCount = _ref /*:: */.overscanCellsCount,
    scrollDirection = _ref /*:: */.scrollDirection,
    startIndex = _ref /*:: */.startIndex,
    stopIndex = _ref /*:: */.stopIndex;
  // Make sure we render at least 1 cell extra before and after (except near boundaries)
  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
  // For more info see issues #625
  overscanCellsCount = Math.max(1, overscanCellsCount);
  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex - 1),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
  }
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray$2(r);
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray$2(r) || _nonIterableSpread();
}
function _callSuper$7(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$7() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$7() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$7 = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

/**
 * Higher-order component that manages lazy-loading for "infinite" data.
 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
 */
var InfiniteLoader = /*#__PURE__*/function (_React$PureComponent) {
  function InfiniteLoader(props, context) {
    var _this;
    _classCallCheck(this, InfiniteLoader);
    _this = _callSuper$7(this, InfiniteLoader, [props, context]);
    _this._loadMoreRowsMemoizer = createCallbackMemoizer();
    _this._onRowsRendered = _this._onRowsRendered.bind(_this);
    _this._registerChild = _this._registerChild.bind(_this);
    return _this;
  }
  _inherits(InfiniteLoader, _React$PureComponent);
  return _createClass(InfiniteLoader, [{
    key: "resetLoadMoreRowsCache",
    value: function resetLoadMoreRowsCache(autoReload) {
      this._loadMoreRowsMemoizer = createCallbackMemoizer();
      if (autoReload) {
        this._doStuff(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        onRowsRendered: this._onRowsRendered,
        registerChild: this._registerChild
      });
    }
  }, {
    key: "_loadUnloadedRanges",
    value: function _loadUnloadedRanges(unloadedRanges) {
      var _this2 = this;
      var loadMoreRows = this.props.loadMoreRows;
      unloadedRanges.forEach(function (unloadedRange) {
        var promise = loadMoreRows(unloadedRange);
        if (promise) {
          promise.then(function () {
            // Refresh the visible rows if any of them have just been loaded.
            // Otherwise they will remain in their unloaded visual state.
            if (isRangeVisible({
              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
              startIndex: unloadedRange.startIndex,
              stopIndex: unloadedRange.stopIndex
            })) {
              if (_this2._registeredChild) {
                forceUpdateReactVirtualizedComponent(_this2._registeredChild, _this2._lastRenderedStartIndex);
              }
            }
          });
        }
      });
    }
  }, {
    key: "_onRowsRendered",
    value: function _onRowsRendered(_ref) {
      var startIndex = _ref.startIndex,
        stopIndex = _ref.stopIndex;
      this._lastRenderedStartIndex = startIndex;
      this._lastRenderedStopIndex = stopIndex;
      this._doStuff(startIndex, stopIndex);
    }
  }, {
    key: "_doStuff",
    value: function _doStuff(startIndex, stopIndex) {
      var _ref2,
        _this3 = this;
      var _this$props = this.props,
        isRowLoaded = _this$props.isRowLoaded,
        minimumBatchSize = _this$props.minimumBatchSize,
        rowCount = _this$props.rowCount,
        threshold = _this$props.threshold;
      var unloadedRanges = scanForUnloadedRanges({
        isRowLoaded: isRowLoaded,
        minimumBatchSize: minimumBatchSize,
        rowCount: rowCount,
        startIndex: Math.max(0, startIndex - threshold),
        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
      });

      // For memoize comparison
      var squashedUnloadedRanges = (_ref2 = []).concat.apply(_ref2, _toConsumableArray(unloadedRanges.map(function (_ref3) {
        var startIndex = _ref3.startIndex,
          stopIndex = _ref3.stopIndex;
        return [startIndex, stopIndex];
      })));
      this._loadMoreRowsMemoizer({
        callback: function callback() {
          _this3._loadUnloadedRanges(unloadedRanges);
        },
        indices: {
          squashedUnloadedRanges: squashedUnloadedRanges
        }
      });
    }
  }, {
    key: "_registerChild",
    value: function _registerChild(registeredChild) {
      this._registeredChild = registeredChild;
    }
  }]);
}(React.PureComponent);
/**
 * Determines if the specified start/stop range is visible based on the most recently rendered range.
 */
_defineProperty(InfiniteLoader, "defaultProps", {
  minimumBatchSize: 10,
  rowCount: 0,
  threshold: 15
});
InfiniteLoader.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Function responsible for rendering a virtualized component.
   * This function should implement the following signature:
   * ({ onRowsRendered, registerChild }) => PropTypes.element
   *
   * The specified :onRowsRendered function should be passed through to the child's :onRowsRendered property.
   * The :registerChild callback should be set as the virtualized component's :ref.
   */
  children: PropTypes.func.isRequired,
  /**
   * Function responsible for tracking the loaded state of each row.
   * It should implement the following signature: ({ index: number }): boolean
   */
  isRowLoaded: PropTypes.func.isRequired,
  /**
   * Callback to be invoked when more rows must be loaded.
   * It should implement the following signature: ({ startIndex, stopIndex }): Promise
   * The returned Promise should be resolved once row data has finished loading.
   * It will be used to determine when to refresh the list with the newly-loaded data.
   * This callback may be called multiple times in reaction to a single scroll event.
   */
  loadMoreRows: PropTypes.func.isRequired,
  /**
   * Minimum number of rows to be loaded at a time.
   * This property can be used to batch requests to reduce HTTP requests.
   */
  minimumBatchSize: PropTypes.number.isRequired,
  /**
   * Number of rows in list; can be arbitrary high number if actual number is unknown.
   */
  rowCount: PropTypes.number.isRequired,
  /**
   * Threshold at which to pre-fetch data.
   * A threshold X means that data will start loading when a user scrolls within X rows.
   * This value defaults to 15.
   */
  threshold: PropTypes.number.isRequired
} : {};
function isRangeVisible(_ref4) {
  var lastRenderedStartIndex = _ref4.lastRenderedStartIndex,
    lastRenderedStopIndex = _ref4.lastRenderedStopIndex,
    startIndex = _ref4.startIndex,
    stopIndex = _ref4.stopIndex;
  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}

/**
 * Returns all of the ranges within a larger range that contain unloaded rows.
 */
function scanForUnloadedRanges(_ref5) {
  var isRowLoaded = _ref5.isRowLoaded,
    minimumBatchSize = _ref5.minimumBatchSize,
    rowCount = _ref5.rowCount,
    startIndex = _ref5.startIndex,
    stopIndex = _ref5.stopIndex;
  var unloadedRanges = [];
  var rangeStartIndex = null;
  var rangeStopIndex = null;
  for (var index = startIndex; index <= stopIndex; index++) {
    var loaded = isRowLoaded({
      index: index
    });
    if (!loaded) {
      rangeStopIndex = index;
      if (rangeStartIndex === null) {
        rangeStartIndex = index;
      }
    } else if (rangeStopIndex !== null) {
      unloadedRanges.push({
        startIndex: rangeStartIndex,
        stopIndex: rangeStopIndex
      });
      rangeStartIndex = rangeStopIndex = null;
    }
  }

  // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
  // Scan forward to try filling our :minimumBatchSize.
  if (rangeStopIndex !== null) {
    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);
    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
      if (!isRowLoaded({
        index: _index
      })) {
        rangeStopIndex = _index;
      } else {
        break;
      }
    }
    unloadedRanges.push({
      startIndex: rangeStartIndex,
      stopIndex: rangeStopIndex
    });
  }

  // Check to see if our first range ended prematurely.
  // In this case we should scan backwards to try filling our :minimumBatchSize.
  if (unloadedRanges.length) {
    var firstUnloadedRange = unloadedRanges[0];
    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
      var _index2 = firstUnloadedRange.startIndex - 1;
      if (!isRowLoaded({
        index: _index2
      })) {
        firstUnloadedRange.startIndex = _index2;
      } else {
        break;
      }
    }
  }
  return unloadedRanges;
}

/**
 * Since RV components use shallowCompare we need to force a render (even though props haven't changed).
 * However InfiniteLoader may wrap a Grid or it may wrap a Table or List.
 * In the first case the built-in React forceUpdate() method is sufficient to force a re-render,
 * But in the latter cases we need to use the RV-specific forceUpdateGrid() method.
 * Else the inner Grid will not be re-rendered and visuals may be stale.
 *
 * Additionally, while a Grid is scrolling the cells can be cached,
 * So it's important to invalidate that cache by recalculating sizes
 * before forcing a rerender.
 */
function forceUpdateReactVirtualizedComponent(component) {
  var currentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;
  if (recomputeSize) {
    recomputeSize.call(component, currentIndex);
  } else {
    component.forceUpdate();
  }
}
function _callSuper$6(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$6() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$6() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$6 = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */
/*:: type Props = {
  'aria-label'?: string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   *-/
  autoHeight: boolean,

  /** Optional CSS class name *-/
  className?: string,

  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   *-/
  estimatedRowSize: number,

  /** Height constraint for list (determines how many actual rows are rendered) *-/
  height: number,

  /** Optional renderer to be used in place of rows when rowCount is 0 *-/
  noRowsRenderer: NoContentRenderer,

  /** Callback invoked with information about the slice of rows that were just rendered.  *-/

  onRowsRendered: (params: RenderedRows) => void,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   *-/
  onScroll: (params: Scroll) => void,

  /** See Grid#overscanIndicesGetter *-/
  overscanIndicesGetter: OverscanIndicesGetter,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   *-/
  overscanRowCount: number,

  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  *-/
  rowHeight: CellSize,

  /** Responsible for rendering a row given an index; ({ index: number }): node *-/
  rowRenderer: RowRenderer,

  /** Number of rows in list. *-/
  rowCount: number,

  /** See Grid#scrollToAlignment *-/
  scrollToAlignment: Alignment,

  /** Row index to ensure visible (by forcefully scrolling if necessary) *-/
  scrollToIndex: number,

  /** Vertical offset. *-/
  scrollTop?: number,

  /** Optional inline style *-/
  style: Object,

  /** Tab index for focus *-/
  tabIndex?: number,

  /** Width of list *-/
  width: number,
};*/
var List = /*#__PURE__*/function (_React$PureComponent) {
  function List() {
    var _this;
    _classCallCheck(this, List);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$6(this, List, [].concat(args));
    _defineProperty(_this, "Grid", void 0);
    _defineProperty(_this, "_cellRenderer", function (_ref /*:: */) {
      var parent = _ref /*:: */.parent,
        rowIndex = _ref /*:: */.rowIndex,
        style = _ref /*:: */.style,
        isScrolling = _ref /*:: */.isScrolling,
        isVisible = _ref /*:: */.isVisible,
        key = _ref /*:: */.key;
      var rowRenderer = _this.props.rowRenderer;

      // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713
      var widthDescriptor = Object.getOwnPropertyDescriptor(style, 'width');
      if (widthDescriptor && widthDescriptor.writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }
      return rowRenderer({
        index: rowIndex,
        style: style,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent
      });
    });
    _defineProperty(_this, "_setRef", function (ref /*: ?React.ElementRef<typeof Grid>*/) {
      _this.Grid = ref;
    });
    _defineProperty(_this, "_onScroll", function (_ref2 /*:: */) {
      var clientHeight = _ref2 /*:: */.clientHeight,
        scrollHeight = _ref2 /*:: */.scrollHeight,
        scrollTop = _ref2 /*:: */.scrollTop;
      var onScroll = _this.props.onScroll;
      onScroll({
        clientHeight: clientHeight,
        scrollHeight: scrollHeight,
        scrollTop: scrollTop
      });
    });
    _defineProperty(_this, "_onSectionRendered", function (_ref3 /*:: */) {
      var rowOverscanStartIndex = _ref3 /*:: */.rowOverscanStartIndex,
        rowOverscanStopIndex = _ref3 /*:: */.rowOverscanStopIndex,
        rowStartIndex = _ref3 /*:: */.rowStartIndex,
        rowStopIndex = _ref3 /*:: */.rowStopIndex;
      var onRowsRendered = _this.props.onRowsRendered;
      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    });
    return _this;
  }
  _inherits(List, _React$PureComponent);
  return _createClass(List, [{
    key: "forceUpdateGrid",
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }

    /** See Grid#getOffsetForCell */
  }, {
    key: "getOffsetForRow",
    value: function getOffsetForRow(_ref4 /*:: */) {
      var alignment = _ref4 /*:: */.alignment,
        index = _ref4 /*:: */.index;
      if (this.Grid) {
        var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
            alignment: alignment,
            rowIndex: index,
            columnIndex: 0
          }),
          scrollTop = _this$Grid$getOffsetF.scrollTop;
        return scrollTop;
      }
      return 0;
    }

    /** CellMeasurer compatibility */
  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref5 /*:: */) {
      var columnIndex = _ref5 /*:: */.columnIndex,
        rowIndex = _ref5 /*:: */.rowIndex;
      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#measureAllCells */
  }, {
    key: "measureAllRows",
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }

    /** CellMeasurer compatibility */
  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref6$columnIndex = _ref6.columnIndex,
        columnIndex = _ref6$columnIndex === void 0 ? 0 : _ref6$columnIndex,
        _ref6$rowIndex = _ref6.rowIndex,
        rowIndex = _ref6$rowIndex === void 0 ? 0 : _ref6$rowIndex;
      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#recomputeGridSize */
  }, {
    key: "recomputeRowHeights",
    value: function recomputeRowHeights() {
      var index /*: number*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index,
          columnIndex: 0
        });
      }
    }

    /** See Grid#scrollToPosition */
  }, {
    key: "scrollToPosition",
    value: function scrollToPosition() {
      var scrollTop /*: number*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (this.Grid) {
        this.Grid.scrollToPosition({
          scrollTop: scrollTop
        });
      }
    }

    /** See Grid#scrollToCell */
  }, {
    key: "scrollToRow",
    value: function scrollToRow() {
      var index /*: number*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        noRowsRenderer = _this$props.noRowsRenderer,
        scrollToIndex = _this$props.scrollToIndex,
        width = _this$props.width;
      var classNames = clsx('ReactVirtualized__List', className);
      return /*#__PURE__*/React.createElement(Grid, _extends$5({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }]);
}(React.PureComponent);
_defineProperty(List, "defaultProps", {
  autoHeight: false,
  estimatedRowSize: 30,
  onScroll: function onScroll() {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {},
  overscanIndicesGetter: defaultOverscanIndicesGetter,
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
});
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray$2(r, e) || _nonIterableRest();
}

/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/binary-search-bounds
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/

function _GEA(a, l, h, y) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
      x = a[m];
    if (x >= y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function _GEP(a, l, h, y, c) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
      x = a[m];
    if (c(x, y) >= 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function dispatchBsearchGE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}
function _GTA(a, l, h, y) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
      x = a[m];
    if (x > y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function _GTP(a, l, h, y, c) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
      x = a[m];
    if (c(x, y) > 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function dispatchBsearchGT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}
function _LTA(a, l, h, y) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
      x = a[m];
    if (x < y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function _LTP(a, l, h, y, c) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
      x = a[m];
    if (c(x, y) < 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function dispatchBsearchLT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}
function _LEA(a, l, h, y) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
      x = a[m];
    if (x <= y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function _LEP(a, l, h, y, c) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
      x = a[m];
    if (c(x, y) <= 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function dispatchBsearchLE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}
function _EQA(a, l, h, y) {
  while (l <= h) {
    var m = l + h >>> 1,
      x = a[m];
    if (x === y) {
      return m;
    } else if (x <= y) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return -1;
}
function _EQP(a, l, h, y, c) {
  while (l <= h) {
    var m = l + h >>> 1,
      x = a[m];
    var p = c(x, y);
    if (p === 0) {
      return m;
    } else if (p <= 0) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return -1;
}
function dispatchBsearchEQ(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _EQP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _EQA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}
var bounds = {
  ge: dispatchBsearchGE,
  gt: dispatchBsearchGT,
  lt: dispatchBsearchLT,
  le: dispatchBsearchLE,
  eq: dispatchBsearchEQ
};

/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/interval-tree-1d
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax in an upstream dependency.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/
var NOT_FOUND = 0;
var SUCCESS$1 = 1;
var EMPTY = 2;
function IntervalTreeNode(mid, left, right, leftPoints, rightPoints) {
  this.mid = mid;
  this.left = left;
  this.right = right;
  this.leftPoints = leftPoints;
  this.rightPoints = rightPoints;
  this.count = (left ? left.count : 0) + (right ? right.count : 0) + leftPoints.length;
}
var proto = IntervalTreeNode.prototype;
function copy(a, b) {
  a.mid = b.mid;
  a.left = b.left;
  a.right = b.right;
  a.leftPoints = b.leftPoints;
  a.rightPoints = b.rightPoints;
  a.count = b.count;
}
function rebuild(node, intervals) {
  var ntree = createIntervalTree(intervals);
  node.mid = ntree.mid;
  node.left = ntree.left;
  node.right = ntree.right;
  node.leftPoints = ntree.leftPoints;
  node.rightPoints = ntree.rightPoints;
  node.count = ntree.count;
}
function rebuildWithInterval(node, interval) {
  var intervals = node.intervals([]);
  intervals.push(interval);
  rebuild(node, intervals);
}
function rebuildWithoutInterval(node, interval) {
  var intervals = node.intervals([]);
  var idx = intervals.indexOf(interval);
  if (idx < 0) {
    return NOT_FOUND;
  }
  intervals.splice(idx, 1);
  rebuild(node, intervals);
  return SUCCESS$1;
}
proto.intervals = function (result) {
  result.push.apply(result, this.leftPoints);
  if (this.left) {
    this.left.intervals(result);
  }
  if (this.right) {
    this.right.intervals(result);
  }
  return result;
};
proto.insert = function (interval) {
  var weight = this.count - this.leftPoints.length;
  this.count += 1;
  if (interval[1] < this.mid) {
    if (this.left) {
      if (4 * (this.left.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.left.insert(interval);
      }
    } else {
      this.left = createIntervalTree([interval]);
    }
  } else if (interval[0] > this.mid) {
    if (this.right) {
      if (4 * (this.right.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.right.insert(interval);
      }
    } else {
      this.right = createIntervalTree([interval]);
    }
  } else {
    var l = bounds.ge(this.leftPoints, interval, compareBegin);
    var r = bounds.ge(this.rightPoints, interval, compareEnd);
    this.leftPoints.splice(l, 0, interval);
    this.rightPoints.splice(r, 0, interval);
  }
};
proto.remove = function (interval) {
  var weight = this.count - this.leftPoints;
  if (interval[1] < this.mid) {
    if (!this.left) {
      return NOT_FOUND;
    }
    var rw = this.right ? this.right.count : 0;
    if (4 * rw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }
    var r = this.left.remove(interval);
    if (r === EMPTY) {
      this.left = null;
      this.count -= 1;
      return SUCCESS$1;
    } else if (r === SUCCESS$1) {
      this.count -= 1;
    }
    return r;
  } else if (interval[0] > this.mid) {
    if (!this.right) {
      return NOT_FOUND;
    }
    var lw = this.left ? this.left.count : 0;
    if (4 * lw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }
    var r = this.right.remove(interval);
    if (r === EMPTY) {
      this.right = null;
      this.count -= 1;
      return SUCCESS$1;
    } else if (r === SUCCESS$1) {
      this.count -= 1;
    }
    return r;
  } else {
    if (this.count === 1) {
      if (this.leftPoints[0] === interval) {
        return EMPTY;
      } else {
        return NOT_FOUND;
      }
    }
    if (this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
      if (this.left && this.right) {
        var p = this;
        var n = this.left;
        while (n.right) {
          p = n;
          n = n.right;
        }
        if (p === this) {
          n.right = this.right;
        } else {
          var l = this.left;
          var r = this.right;
          p.count -= n.count;
          p.right = n.left;
          n.left = l;
          n.right = r;
        }
        copy(this, n);
        this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
      } else if (this.left) {
        copy(this, this.left);
      } else {
        copy(this, this.right);
      }
      return SUCCESS$1;
    }
    for (var l = bounds.ge(this.leftPoints, interval, compareBegin); l < this.leftPoints.length; ++l) {
      if (this.leftPoints[l][0] !== interval[0]) {
        break;
      }
      if (this.leftPoints[l] === interval) {
        this.count -= 1;
        this.leftPoints.splice(l, 1);
        for (var r = bounds.ge(this.rightPoints, interval, compareEnd); r < this.rightPoints.length; ++r) {
          if (this.rightPoints[r][1] !== interval[1]) {
            break;
          } else if (this.rightPoints[r] === interval) {
            this.rightPoints.splice(r, 1);
            return SUCCESS$1;
          }
        }
      }
    }
    return NOT_FOUND;
  }
};
function reportLeftRange(arr, hi, cb) {
  for (var i = 0; i < arr.length && arr[i][0] <= hi; ++i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}
function reportRightRange(arr, lo, cb) {
  for (var i = arr.length - 1; i >= 0 && arr[i][1] >= lo; --i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}
function reportRange(arr, cb) {
  for (var i = 0; i < arr.length; ++i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}
proto.queryPoint = function (x, cb) {
  if (x < this.mid) {
    if (this.left) {
      var r = this.left.queryPoint(x, cb);
      if (r) {
        return r;
      }
    }
    return reportLeftRange(this.leftPoints, x, cb);
  } else if (x > this.mid) {
    if (this.right) {
      var r = this.right.queryPoint(x, cb);
      if (r) {
        return r;
      }
    }
    return reportRightRange(this.rightPoints, x, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};
proto.queryInterval = function (lo, hi, cb) {
  if (lo < this.mid && this.left) {
    var r = this.left.queryInterval(lo, hi, cb);
    if (r) {
      return r;
    }
  }
  if (hi > this.mid && this.right) {
    var r = this.right.queryInterval(lo, hi, cb);
    if (r) {
      return r;
    }
  }
  if (hi < this.mid) {
    return reportLeftRange(this.leftPoints, hi, cb);
  } else if (lo > this.mid) {
    return reportRightRange(this.rightPoints, lo, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};
function compareNumbers(a, b) {
  return a - b;
}
function compareBegin(a, b) {
  var d = a[0] - b[0];
  if (d) {
    return d;
  }
  return a[1] - b[1];
}
function compareEnd(a, b) {
  var d = a[1] - b[1];
  if (d) {
    return d;
  }
  return a[0] - b[0];
}
function createIntervalTree(intervals) {
  if (intervals.length === 0) {
    return null;
  }
  var pts = [];
  for (var i = 0; i < intervals.length; ++i) {
    pts.push(intervals[i][0], intervals[i][1]);
  }
  pts.sort(compareNumbers);
  var mid = pts[pts.length >> 1];
  var leftIntervals = [];
  var rightIntervals = [];
  var centerIntervals = [];
  for (var i = 0; i < intervals.length; ++i) {
    var s = intervals[i];
    if (s[1] < mid) {
      leftIntervals.push(s);
    } else if (mid < s[0]) {
      rightIntervals.push(s);
    } else {
      centerIntervals.push(s);
    }
  }

  //Split center intervals
  var leftPoints = centerIntervals;
  var rightPoints = centerIntervals.slice();
  leftPoints.sort(compareBegin);
  rightPoints.sort(compareEnd);
  return new IntervalTreeNode(mid, createIntervalTree(leftIntervals), createIntervalTree(rightIntervals), leftPoints, rightPoints);
}

//User friendly wrapper that makes it possible to support empty trees
function IntervalTree(root) {
  this.root = root;
}
var tproto = IntervalTree.prototype;
tproto.insert = function (interval) {
  if (this.root) {
    this.root.insert(interval);
  } else {
    this.root = new IntervalTreeNode(interval[0], null, null, [interval], [interval]);
  }
};
tproto.remove = function (interval) {
  if (this.root) {
    var r = this.root.remove(interval);
    if (r === EMPTY) {
      this.root = null;
    }
    return r !== NOT_FOUND;
  }
  return false;
};
tproto.queryPoint = function (p, cb) {
  if (this.root) {
    return this.root.queryPoint(p, cb);
  }
};
tproto.queryInterval = function (lo, hi, cb) {
  if (lo <= hi && this.root) {
    return this.root.queryInterval(lo, hi, cb);
  }
};
Object.defineProperty(tproto, 'count', {
  get: function get() {
    if (this.root) {
      return this.root.count;
    }
    return 0;
  }
});
Object.defineProperty(tproto, 'intervals', {
  get: function get() {
    if (this.root) {
      return this.root.intervals([]);
    }
    return [];
  }
});
function createWrapper(intervals) {
  if (!intervals || intervals.length === 0) {
    return new IntervalTree(null);
  }
  return new IntervalTree(createIntervalTree(intervals));
}

/*:: type RenderCallback = (index: number, left: number, top: number) => void;*/
// Position cache requirements:
//   O(log(n)) lookup of cells to render for a given viewport size
//   O(1) lookup of shortest measured column (so we know when to enter phase 1)
var PositionCache = /*#__PURE__*/function () {
  function PositionCache() {
    _classCallCheck(this, PositionCache);
    // Tracks the height of each column
    _defineProperty(this, "_columnSizeMap", {});
    // Store tops and bottoms of each cell for fast intersection lookup.
    _defineProperty(this, "_intervalTree", createWrapper());
    // Maps cell index to x coordinates for quick lookup.
    _defineProperty(this, "_leftMap", {});
  }
  return _createClass(PositionCache, [{
    key: "estimateTotalHeight",
    value: function estimateTotalHeight(cellCount /*: number*/, columnCount /*: number*/, defaultCellHeight /*: number*/) /*: number*/{
      var unmeasuredCellCount = cellCount - this.count;
      return this.tallestColumnSize + Math.ceil(unmeasuredCellCount / columnCount) * defaultCellHeight;
    }

    // Render all cells visible within the viewport range defined.
  }, {
    key: "range",
    value: function range(scrollTop /*: number*/, clientHeight /*: number*/, renderCallback /*: RenderCallback*/) /*: void*/{
      var _this = this;
      this._intervalTree.queryInterval(scrollTop, scrollTop + clientHeight, function (_ref) {
        var _ref2 = _slicedToArray(_ref, 3),
          top = _ref2[0];
        _ref2[1];
        var index = _ref2[2];
        return renderCallback(index, _this._leftMap[index], top);
      });
    }
  }, {
    key: "setPosition",
    value: function setPosition(index /*: number*/, left /*: number*/, top /*: number*/, height /*: number*/) /*: void*/{
      this._intervalTree.insert([top, top + height, index]);
      this._leftMap[index] = left;
      var columnSizeMap = this._columnSizeMap;
      var columnHeight = columnSizeMap[left];
      if (columnHeight === undefined) {
        columnSizeMap[left] = top + height;
      } else {
        columnSizeMap[left] = Math.max(columnHeight, top + height);
      }
    }
  }, {
    key: "count",
    get: function get() /*: number*/{
      return this._intervalTree.count;
    }
  }, {
    key: "shortestColumnSize",
    get: function get() /*: number*/{
      var columnSizeMap = this._columnSizeMap;
      var size = 0;
      for (var i in columnSizeMap) {
        var height = columnSizeMap[i /*: any*/];
        size = size === 0 ? height : Math.min(size, height);
      }
      return size;
    }
  }, {
    key: "tallestColumnSize",
    get: function get() /*: number*/{
      var columnSizeMap = this._columnSizeMap;
      var size = 0;
      for (var i in columnSizeMap) {
        var height = columnSizeMap[i /*: any*/];
        size = Math.max(size, height);
      }
      return size;
    }
  }]);
}();
function ownKeys$6(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$6(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$6(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _callSuper$5(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$5() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$5() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$5 = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
/*:: import type {AnimationTimeoutId} from '../utils/requestAnimationTimeout';*/
/*:: type Props = {
  autoHeight: boolean,
  cellCount: number,
  cellMeasurerCache: CellMeasurerCache,
  cellPositioner: Positioner,
  cellRenderer: CellRenderer,
  className: ?string,
  height: number,
  id: ?string,
  keyMapper: KeyMapper,
  onCellsRendered: ?OnCellsRenderedCallback,
  onScroll: ?OnScrollCallback,
  overscanByPixels: number,
  role: string,
  scrollingResetTimeInterval: number,
  style: mixed,
  tabIndex: number,
  width: number,
  rowDirection: string,
  scrollTop?: number,
};*/
/*:: type State = {
  isScrolling: boolean,
  scrollTop: number,
};*/
var emptyObject = {};

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;

/**
 * This component efficiently displays arbitrarily positioned cells using windowing techniques.
 * Cell position is determined by an injected `cellPositioner` property.
 * Windowing is vertical; this component does not support horizontal scrolling.
 *
 * Rendering occurs in two phases:
 * 1) First pass uses estimated cell sizes (provided by the cache) to determine how many cells to measure in a batch.
 *    Batch size is chosen using a fast, naive layout algorithm that stacks images in order until the viewport has been filled.
 *    After measurement is complete (componentDidMount or componentDidUpdate) this component evaluates positioned cells
 *    in order to determine if another measurement pass is required (eg if actual cell sizes were less than estimated sizes).
 *    All measurements are permanently cached (keyed by `keyMapper`) for performance purposes.
 * 2) Second pass uses the external `cellPositioner` to layout cells.
 *    At this time the positioner has access to cached size measurements for all cells.
 *    The positions it returns are cached by Masonry for fast access later.
 *    Phase one is repeated if the user scrolls beyond the current layout's bounds.
 *    If the layout is invalidated due to eg a resize, cached positions can be cleared using `recomputeCellPositions()`.
 *
 * Animation constraints:
 *   Simple animations are supported (eg translate/slide into place on initial reveal).
 *   More complex animations are not (eg flying from one position to another on resize).
 *
 * Layout constraints:
 *   This component supports multi-column layout.
 *   The height of each item may vary.
 *   The width of each item must not exceed the width of the column it is "in".
 *   The left position of all items within a column must align.
 *   (Items may not span multiple columns.)
 */
var Masonry = /*#__PURE__*/function (_React$PureComponent) {
  function Masonry() {
    var _this;
    _classCallCheck(this, Masonry);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$5(this, Masonry, [].concat(args));
    _defineProperty(_this, "state", {
      isScrolling: false,
      scrollTop: 0
    });
    _defineProperty(_this, "_debounceResetIsScrollingId", void 0);
    _defineProperty(_this, "_invalidateOnUpdateStartIndex", null);
    _defineProperty(_this, "_invalidateOnUpdateStopIndex", null);
    _defineProperty(_this, "_positionCache", new PositionCache());
    _defineProperty(_this, "_startIndex", null);
    _defineProperty(_this, "_startIndexMemoized", null);
    _defineProperty(_this, "_stopIndex", null);
    _defineProperty(_this, "_stopIndexMemoized", null);
    _defineProperty(_this, "_debounceResetIsScrollingCallback", function () {
      _this.setState({
        isScrolling: false
      });
    });
    _defineProperty(_this, "_setScrollingContainerRef", function (ref) {
      _this._scrollingContainer = ref;
    });
    _defineProperty(_this, "_onScroll", function (event) {
      var height = _this.props.height;
      var eventScrollTop = event.currentTarget.scrollTop;

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
      var scrollTop = Math.min(Math.max(0, _this._getEstimatedTotalHeight() - height), eventScrollTop);

      // On iOS, we can arrive at negative offsets by swiping past the start or end.
      // Avoid re-rendering in this case as it can cause problems; see #532 for more.
      if (eventScrollTop !== scrollTop) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      _this._debounceResetIsScrolling();

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (_this.state.scrollTop !== scrollTop) {
        _this.setState({
          isScrolling: true,
          scrollTop: scrollTop
        });
      }
    });
    return _this;
  }
  _inherits(Masonry, _React$PureComponent);
  return _createClass(Masonry, [{
    key: "clearCellPositions",
    value: function clearCellPositions() {
      this._positionCache = new PositionCache();
      this.forceUpdate();
    }

    // HACK This method signature was intended for Grid
  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref) {
      var index = _ref.rowIndex;
      if (this._invalidateOnUpdateStartIndex === null) {
        this._invalidateOnUpdateStartIndex = index;
        this._invalidateOnUpdateStopIndex = index;
      } else {
        this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, index);
        this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, index);
      }
    }
  }, {
    key: "recomputeCellPositions",
    value: function recomputeCellPositions() {
      var stopIndex = this._positionCache.count - 1;
      this._positionCache = new PositionCache();
      this._populatePositionCache(0, stopIndex);
      this.forceUpdate();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._checkInvalidateOnUpdate();
      this._invokeOnScrollCallback();
      this._invokeOnCellsRenderedCallback();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps /*: Props*/, prevState /*: State*/) {
      this._checkInvalidateOnUpdate();
      this._invokeOnScrollCallback();
      this._invokeOnCellsRenderedCallback();
      if (this.props.scrollTop !== prevProps.scrollTop) {
        this._debounceResetIsScrolling();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._debounceResetIsScrollingId) {
        cancelAnimationTimeout(this._debounceResetIsScrollingId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        autoHeight = _this$props.autoHeight,
        cellCount = _this$props.cellCount,
        cellMeasurerCache = _this$props.cellMeasurerCache,
        cellRenderer = _this$props.cellRenderer,
        className = _this$props.className,
        height = _this$props.height,
        id = _this$props.id,
        keyMapper = _this$props.keyMapper,
        overscanByPixels = _this$props.overscanByPixels,
        role = _this$props.role,
        style = _this$props.style,
        tabIndex = _this$props.tabIndex,
        width = _this$props.width,
        rowDirection = _this$props.rowDirection;
      var _this$state = this.state,
        isScrolling = _this$state.isScrolling,
        scrollTop = _this$state.scrollTop;
      var children = [];
      var estimateTotalHeight = this._getEstimatedTotalHeight();
      var shortestColumnSize = this._positionCache.shortestColumnSize;
      var measuredCellCount = this._positionCache.count;
      var startIndex = 0;
      var stopIndex;
      this._positionCache.range(Math.max(0, scrollTop - overscanByPixels), height + overscanByPixels * 2, function (index /*: number*/, left /*: number*/, top /*: number*/) {
        if (typeof stopIndex === 'undefined') {
          startIndex = index;
          stopIndex = index;
        } else {
          startIndex = Math.min(startIndex, index);
          stopIndex = Math.max(stopIndex, index);
        }
        children.push(cellRenderer({
          index: index,
          isScrolling: isScrolling,
          key: keyMapper(index),
          parent: _this2,
          style: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
            height: cellMeasurerCache.getHeight(index)
          }, rowDirection === 'ltr' ? 'left' : 'right', left), "position", 'absolute'), "top", top), "width", cellMeasurerCache.getWidth(index))
        }));
      });

      // We need to measure additional cells for this layout
      if (shortestColumnSize < scrollTop + height + overscanByPixels && measuredCellCount < cellCount) {
        var batchSize = Math.min(cellCount - measuredCellCount, Math.ceil((scrollTop + height + overscanByPixels - shortestColumnSize) / cellMeasurerCache.defaultHeight * width / cellMeasurerCache.defaultWidth));
        for (var _index = measuredCellCount; _index < measuredCellCount + batchSize; _index++) {
          stopIndex = _index;
          children.push(cellRenderer({
            index: _index,
            isScrolling: isScrolling,
            key: keyMapper(_index),
            parent: this,
            style: {
              width: cellMeasurerCache.getWidth(_index)
            }
          }));
        }
      }
      this._startIndex = startIndex;
      this._stopIndex = stopIndex;
      return /*#__PURE__*/React.createElement("div", {
        ref: this._setScrollingContainerRef,
        "aria-label": this.props['aria-label'],
        className: clsx('ReactVirtualized__Masonry', className),
        id: id,
        onScroll: this._onScroll,
        role: role,
        style: _objectSpread$6({
          boxSizing: 'border-box',
          direction: 'ltr',
          height: autoHeight ? 'auto' : height,
          overflowX: 'hidden',
          overflowY: estimateTotalHeight < height ? 'hidden' : 'auto',
          position: 'relative',
          width: width,
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform'
        }, style),
        tabIndex: tabIndex
      }, /*#__PURE__*/React.createElement("div", {
        className: "ReactVirtualized__Masonry__innerScrollContainer",
        style: {
          width: '100%',
          height: estimateTotalHeight,
          maxWidth: '100%',
          maxHeight: estimateTotalHeight,
          overflow: 'hidden',
          pointerEvents: isScrolling ? 'none' : '',
          position: 'relative'
        }
      }, children));
    }
  }, {
    key: "_checkInvalidateOnUpdate",
    value: function _checkInvalidateOnUpdate() {
      if (typeof this._invalidateOnUpdateStartIndex === 'number') {
        var startIndex = this._invalidateOnUpdateStartIndex;
        var stopIndex = this._invalidateOnUpdateStopIndex;
        this._invalidateOnUpdateStartIndex = null;
        this._invalidateOnUpdateStopIndex = null;

        // Query external layout logic for position of newly-measured cells
        this._populatePositionCache(startIndex, stopIndex);
        this.forceUpdate();
      }
    }
  }, {
    key: "_debounceResetIsScrolling",
    value: function _debounceResetIsScrolling() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
      if (this._debounceResetIsScrollingId) {
        cancelAnimationTimeout(this._debounceResetIsScrollingId);
      }
      this._debounceResetIsScrollingId = requestAnimationTimeout(this._debounceResetIsScrollingCallback, scrollingResetTimeInterval);
    }
  }, {
    key: "_getEstimatedTotalHeight",
    value: function _getEstimatedTotalHeight() {
      var _this$props2 = this.props,
        cellCount = _this$props2.cellCount,
        cellMeasurerCache = _this$props2.cellMeasurerCache,
        width = _this$props2.width;
      var estimatedColumnCount = Math.max(1, Math.floor(width / cellMeasurerCache.defaultWidth));
      return this._positionCache.estimateTotalHeight(cellCount, estimatedColumnCount, cellMeasurerCache.defaultHeight);
    }
  }, {
    key: "_invokeOnScrollCallback",
    value: function _invokeOnScrollCallback() {
      var _this$props3 = this.props,
        height = _this$props3.height,
        onScroll = _this$props3.onScroll;
      var scrollTop = this.state.scrollTop;
      if (this._onScrollMemoized !== scrollTop) {
        onScroll({
          clientHeight: height,
          scrollHeight: this._getEstimatedTotalHeight(),
          scrollTop: scrollTop
        });
        this._onScrollMemoized = scrollTop;
      }
    }
  }, {
    key: "_invokeOnCellsRenderedCallback",
    value: function _invokeOnCellsRenderedCallback() {
      if (this._startIndexMemoized !== this._startIndex || this._stopIndexMemoized !== this._stopIndex) {
        var onCellsRendered = this.props.onCellsRendered;
        onCellsRendered({
          startIndex: this._startIndex,
          stopIndex: this._stopIndex
        });
        this._startIndexMemoized = this._startIndex;
        this._stopIndexMemoized = this._stopIndex;
      }
    }
  }, {
    key: "_populatePositionCache",
    value: function _populatePositionCache(startIndex /*: number*/, stopIndex /*: number*/) {
      var _this$props4 = this.props,
        cellMeasurerCache = _this$props4.cellMeasurerCache,
        cellPositioner = _this$props4.cellPositioner;
      for (var _index2 = startIndex; _index2 <= stopIndex; _index2++) {
        var _cellPositioner = cellPositioner(_index2),
          left = _cellPositioner.left,
          top = _cellPositioner.top;
        this._positionCache.setPosition(_index2, left, top, cellMeasurerCache.getHeight(_index2));
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps /*: Props*/, prevState /*: State*/) /*: $Shape<State>*/{
      if (nextProps.scrollTop !== undefined && prevState.scrollTop !== nextProps.scrollTop) {
        return {
          isScrolling: true,
          scrollTop: nextProps.scrollTop
        };
      }
      return null;
    }
  }]);
}(React.PureComponent);
_defineProperty(Masonry, "defaultProps", {
  autoHeight: false,
  keyMapper: identity,
  onCellsRendered: noop$1,
  onScroll: noop$1,
  overscanByPixels: 20,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  style: emptyObject,
  tabIndex: 0,
  rowDirection: 'ltr'
});
function identity(value) {
  return value;
}
function noop$1() {}
/*:: type KeyMapper = (index: number) => mixed;*/
/*:: export type CellMeasurerCache = {
  defaultHeight: number,
  defaultWidth: number,
  getHeight: (index: number) => number,
  getWidth: (index: number) => number,
};*/
/*:: type CellRenderer = (params: {|
  index: number,
  isScrolling: boolean,
  key: mixed,
  parent: mixed,
  style: mixed,
|}) => mixed;*/
/*:: type OnCellsRenderedCallback = (params: {|
  startIndex: number,
  stopIndex: number,
|}) => void;*/
/*:: type OnScrollCallback = (params: {|
  clientHeight: number,
  scrollHeight: number,
  scrollTop: number,
|}) => void;*/
/*:: type Position = {
  left: number,
  top: number,
};*/
polyfill(Masonry);
/*:: export type Positioner = (index: number) => Position;*/

/*:: type CellMeasurerCacheDecoratorParams = {
  cellMeasurerCache: CellMeasurerCache,
  columnIndexOffset: number,
  rowIndexOffset: number,
};*/
/*:: type IndexParam = {
  index: number,
};*/
/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCacheDecorator = /*#__PURE__*/function () {
  function CellMeasurerCacheDecorator() {
    var _this = this;
    var params /*: CellMeasurerCacheDecoratorParams*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, CellMeasurerCacheDecorator);
    _defineProperty(this, "_cellMeasurerCache", void 0);
    _defineProperty(this, "_columnIndexOffset", void 0);
    _defineProperty(this, "_rowIndexOffset", void 0);
    _defineProperty(this, "columnWidth", function (_ref /*:: */) {
      var index = _ref /*:: */.index;
      _this._cellMeasurerCache.columnWidth({
        index: index + _this._columnIndexOffset
      });
    });
    _defineProperty(this, "rowHeight", function (_ref2 /*:: */) {
      var index = _ref2 /*:: */.index;
      _this._cellMeasurerCache.rowHeight({
        index: index + _this._rowIndexOffset
      });
    });
    var cellMeasurerCache = params.cellMeasurerCache,
      _params$columnIndexOf = params.columnIndexOffset,
      columnIndexOffset = _params$columnIndexOf === void 0 ? 0 : _params$columnIndexOf,
      _params$rowIndexOffse = params.rowIndexOffset,
      rowIndexOffset = _params$rowIndexOffse === void 0 ? 0 : _params$rowIndexOffse;
    this._cellMeasurerCache = cellMeasurerCache;
    this._columnIndexOffset = columnIndexOffset;
    this._rowIndexOffset = rowIndexOffset;
  }
  return _createClass(CellMeasurerCacheDecorator, [{
    key: "clear",
    value: function clear(rowIndex /*: number*/, columnIndex /*: number*/) /*: void*/{
      this._cellMeasurerCache.clear(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "clearAll",
    value: function clearAll() /*: void*/{
      this._cellMeasurerCache.clearAll();
    }
  }, {
    key: "defaultHeight",
    get: function get() /*: number*/{
      return this._cellMeasurerCache.defaultHeight;
    }
  }, {
    key: "defaultWidth",
    get: function get() /*: number*/{
      return this._cellMeasurerCache.defaultWidth;
    }
  }, {
    key: "hasFixedHeight",
    value: function hasFixedHeight() /*: boolean*/{
      return this._cellMeasurerCache.hasFixedHeight();
    }
  }, {
    key: "hasFixedWidth",
    value: function hasFixedWidth() /*: boolean*/{
      return this._cellMeasurerCache.hasFixedWidth();
    }
  }, {
    key: "getHeight",
    value: function getHeight(rowIndex /*: number*/) /*: ?number*/{
      var columnIndex /*: ?number*/ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._cellMeasurerCache.getHeight(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "getWidth",
    value: function getWidth(rowIndex /*: number*/) /*: ?number*/{
      var columnIndex /*: ?number*/ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._cellMeasurerCache.getWidth(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "has",
    value: function has(rowIndex /*: number*/) /*: boolean*/{
      var columnIndex /*: ?number*/ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this._cellMeasurerCache.has(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: "set",
    value: function set(rowIndex /*: number*/, columnIndex /*: number*/, width /*: number*/, height /*: number*/) /*: void*/{
      this._cellMeasurerCache.set(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset, width /*: number*/, height /*: number*/);
    }
  }]);
}();
var _excluded$5 = ["rowIndex"],
  _excluded2 = ["columnIndex", "rowIndex"],
  _excluded3 = ["columnIndex"],
  _excluded4 = ["onScroll", "onSectionRendered", "onScrollbarPresenceChange", "scrollLeft", "scrollToColumn", "scrollTop", "scrollToRow"];
function ownKeys$5(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$5(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$5(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _callSuper$4(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$4() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$4() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$4 = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
var SCROLLBAR_SIZE_BUFFER = 20;

/**
 * Renders 1, 2, or 4 Grids depending on configuration.
 * A main (body) Grid will always be rendered.
 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
 * If no sticky columns, only 1 sticky header Grid will be rendered.
 * If sticky columns, 2 sticky header Grids will be rendered.
 */
var MultiGrid = /*#__PURE__*/function (_React$PureComponent) {
  function MultiGrid(props, context) {
    var _this;
    _classCallCheck(this, MultiGrid);
    _this = _callSuper$4(this, MultiGrid, [props, context]);
    _defineProperty(_this, "state", {
      scrollLeft: 0,
      scrollTop: 0,
      scrollbarSize: 0,
      showHorizontalScrollbar: false,
      showVerticalScrollbar: false
    });
    _defineProperty(_this, "_deferredInvalidateColumnIndex", null);
    _defineProperty(_this, "_deferredInvalidateRowIndex", null);
    _defineProperty(_this, "_bottomLeftGridRef", function (ref) {
      _this._bottomLeftGrid = ref;
    });
    _defineProperty(_this, "_bottomRightGridRef", function (ref) {
      _this._bottomRightGrid = ref;
    });
    _defineProperty(_this, "_cellRendererBottomLeftGrid", function (_ref) {
      var rowIndex = _ref.rowIndex,
        rest = _objectWithoutProperties$4(_ref, _excluded$5);
      var _this$props = _this.props,
        cellRenderer = _this$props.cellRenderer,
        fixedRowCount = _this$props.fixedRowCount,
        rowCount = _this$props.rowCount;
      if (rowIndex === rowCount - fixedRowCount) {
        return /*#__PURE__*/React.createElement("div", {
          key: rest.key,
          style: _objectSpread$5(_objectSpread$5({}, rest.style), {}, {
            height: SCROLLBAR_SIZE_BUFFER
          })
        });
      } else {
        return cellRenderer(_objectSpread$5(_objectSpread$5({}, rest), {}, {
          parent: _this,
          rowIndex: rowIndex + fixedRowCount
        }));
      }
    });
    _defineProperty(_this, "_cellRendererBottomRightGrid", function (_ref2) {
      var columnIndex = _ref2.columnIndex,
        rowIndex = _ref2.rowIndex,
        rest = _objectWithoutProperties$4(_ref2, _excluded2);
      var _this$props2 = _this.props,
        cellRenderer = _this$props2.cellRenderer,
        fixedColumnCount = _this$props2.fixedColumnCount,
        fixedRowCount = _this$props2.fixedRowCount;
      return cellRenderer(_objectSpread$5(_objectSpread$5({}, rest), {}, {
        columnIndex: columnIndex + fixedColumnCount,
        parent: _this,
        rowIndex: rowIndex + fixedRowCount
      }));
    });
    _defineProperty(_this, "_cellRendererTopRightGrid", function (_ref3) {
      var columnIndex = _ref3.columnIndex,
        rest = _objectWithoutProperties$4(_ref3, _excluded3);
      var _this$props3 = _this.props,
        cellRenderer = _this$props3.cellRenderer,
        columnCount = _this$props3.columnCount,
        fixedColumnCount = _this$props3.fixedColumnCount;
      if (columnIndex === columnCount - fixedColumnCount) {
        return /*#__PURE__*/React.createElement("div", {
          key: rest.key,
          style: _objectSpread$5(_objectSpread$5({}, rest.style), {}, {
            width: SCROLLBAR_SIZE_BUFFER
          })
        });
      } else {
        return cellRenderer(_objectSpread$5(_objectSpread$5({}, rest), {}, {
          columnIndex: columnIndex + fixedColumnCount,
          parent: _this
        }));
      }
    });
    _defineProperty(_this, "_columnWidthRightGrid", function (_ref4) {
      var index = _ref4.index;
      var _this$props4 = _this.props,
        columnCount = _this$props4.columnCount,
        fixedColumnCount = _this$props4.fixedColumnCount,
        columnWidth = _this$props4.columnWidth;
      var _this$state = _this.state,
        scrollbarSize = _this$state.scrollbarSize,
        showHorizontalScrollbar = _this$state.showHorizontalScrollbar;

      // An extra cell is added to the count
      // This gives the smaller Grid extra room for offset,
      // In case the main (bottom right) Grid has a scrollbar
      // If no scrollbar, the extra space is overflow:hidden anyway
      if (showHorizontalScrollbar && index === columnCount - fixedColumnCount) {
        return scrollbarSize;
      }
      return typeof columnWidth === 'function' ? columnWidth({
        index: index + fixedColumnCount
      }) : columnWidth;
    });
    _defineProperty(_this, "_onScroll", function (scrollInfo) {
      var scrollLeft = scrollInfo.scrollLeft,
        scrollTop = scrollInfo.scrollTop;
      _this.setState({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });
      var onScroll = _this.props.onScroll;
      if (onScroll) {
        onScroll(scrollInfo);
      }
    });
    _defineProperty(_this, "_onScrollbarPresenceChange", function (_ref5) {
      var horizontal = _ref5.horizontal,
        size = _ref5.size,
        vertical = _ref5.vertical;
      var _this$state2 = _this.state,
        showHorizontalScrollbar = _this$state2.showHorizontalScrollbar,
        showVerticalScrollbar = _this$state2.showVerticalScrollbar;
      if (horizontal !== showHorizontalScrollbar || vertical !== showVerticalScrollbar) {
        _this.setState({
          scrollbarSize: size,
          showHorizontalScrollbar: horizontal,
          showVerticalScrollbar: vertical
        });
        var onScrollbarPresenceChange = _this.props.onScrollbarPresenceChange;
        if (typeof onScrollbarPresenceChange === 'function') {
          onScrollbarPresenceChange({
            horizontal: horizontal,
            size: size,
            vertical: vertical
          });
        }
      }
    });
    _defineProperty(_this, "_onScrollLeft", function (scrollInfo) {
      var scrollLeft = scrollInfo.scrollLeft;
      _this._onScroll({
        scrollLeft: scrollLeft,
        scrollTop: _this.state.scrollTop
      });
    });
    _defineProperty(_this, "_onScrollTop", function (scrollInfo) {
      var scrollTop = scrollInfo.scrollTop;
      _this._onScroll({
        scrollTop: scrollTop,
        scrollLeft: _this.state.scrollLeft
      });
    });
    _defineProperty(_this, "_rowHeightBottomGrid", function (_ref6) {
      var index = _ref6.index;
      var _this$props5 = _this.props,
        fixedRowCount = _this$props5.fixedRowCount,
        rowCount = _this$props5.rowCount,
        rowHeight = _this$props5.rowHeight;
      var _this$state3 = _this.state,
        scrollbarSize = _this$state3.scrollbarSize,
        showVerticalScrollbar = _this$state3.showVerticalScrollbar;

      // An extra cell is added to the count
      // This gives the smaller Grid extra room for offset,
      // In case the main (bottom right) Grid has a scrollbar
      // If no scrollbar, the extra space is overflow:hidden anyway
      if (showVerticalScrollbar && index === rowCount - fixedRowCount) {
        return scrollbarSize;
      }
      return typeof rowHeight === 'function' ? rowHeight({
        index: index + fixedRowCount
      }) : rowHeight;
    });
    _defineProperty(_this, "_topLeftGridRef", function (ref) {
      _this._topLeftGrid = ref;
    });
    _defineProperty(_this, "_topRightGridRef", function (ref) {
      _this._topRightGrid = ref;
    });
    var deferredMeasurementCache = props.deferredMeasurementCache,
      _fixedColumnCount = props.fixedColumnCount,
      _fixedRowCount = props.fixedRowCount;
    _this._maybeCalculateCachedStyles(true);
    if (deferredMeasurementCache) {
      _this._deferredMeasurementCacheBottomLeftGrid = _fixedRowCount > 0 ? new CellMeasurerCacheDecorator({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: 0,
        rowIndexOffset: _fixedRowCount
      }) : deferredMeasurementCache;
      _this._deferredMeasurementCacheBottomRightGrid = _fixedColumnCount > 0 || _fixedRowCount > 0 ? new CellMeasurerCacheDecorator({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: _fixedColumnCount,
        rowIndexOffset: _fixedRowCount
      }) : deferredMeasurementCache;
      _this._deferredMeasurementCacheTopRightGrid = _fixedColumnCount > 0 ? new CellMeasurerCacheDecorator({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: _fixedColumnCount,
        rowIndexOffset: 0
      }) : deferredMeasurementCache;
    }
    return _this;
  }
  _inherits(MultiGrid, _React$PureComponent);
  return _createClass(MultiGrid, [{
    key: "forceUpdateGrids",
    value: function forceUpdateGrids() {
      this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate();
      this._bottomRightGrid && this._bottomRightGrid.forceUpdate();
      this._topLeftGrid && this._topLeftGrid.forceUpdate();
      this._topRightGrid && this._topRightGrid.forceUpdate();
    }

    /** See Grid#invalidateCellSizeAfterRender */
  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref7$columnIndex = _ref7.columnIndex,
        columnIndex = _ref7$columnIndex === void 0 ? 0 : _ref7$columnIndex,
        _ref7$rowIndex = _ref7.rowIndex,
        rowIndex = _ref7$rowIndex === void 0 ? 0 : _ref7$rowIndex;
      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }

    /** See Grid#measureAllCells */
  }, {
    key: "measureAllCells",
    value: function measureAllCells() {
      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
      this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
      this._topLeftGrid && this._topLeftGrid.measureAllCells();
      this._topRightGrid && this._topRightGrid.measureAllCells();
    }

    /** See Grid#recomputeGridSize */
  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref8$columnIndex = _ref8.columnIndex,
        columnIndex = _ref8$columnIndex === void 0 ? 0 : _ref8$columnIndex,
        _ref8$rowIndex = _ref8.rowIndex,
        rowIndex = _ref8$rowIndex === void 0 ? 0 : _ref8$rowIndex;
      var _this$props6 = this.props,
        fixedColumnCount = _this$props6.fixedColumnCount,
        fixedRowCount = _this$props6.fixedRowCount;
      var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
      var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);
      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: adjustedRowIndex
      });
      this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: adjustedRowIndex
      });
      this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: rowIndex
      });
      this._topRightGrid && this._topRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: rowIndex
      });
      this._leftGridWidth = null;
      this._topGridHeight = null;
      this._maybeCalculateCachedStyles(true);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props7 = this.props,
        scrollLeft = _this$props7.scrollLeft,
        scrollTop = _this$props7.scrollTop;
      if (scrollLeft > 0 || scrollTop > 0) {
        var newState = {};
        if (scrollLeft > 0) {
          newState.scrollLeft = scrollLeft;
        }
        if (scrollTop > 0) {
          newState.scrollTop = scrollTop;
        }
        this.setState(newState);
      }
      this._handleInvalidatedGridSize();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._handleInvalidatedGridSize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
        onScroll = _this$props8.onScroll,
        onSectionRendered = _this$props8.onSectionRendered;
      _this$props8.onScrollbarPresenceChange;
      _this$props8.scrollLeft;
      var scrollToColumn = _this$props8.scrollToColumn;
      _this$props8.scrollTop;
      var scrollToRow = _this$props8.scrollToRow,
        rest = _objectWithoutProperties$4(_this$props8, _excluded4);
      this._prepareForRender();

      // Don't render any of our Grids if there are no cells.
      // This mirrors what Grid does,
      // And prevents us from recording inaccurage measurements when used with CellMeasurer.
      if (this.props.width === 0 || this.props.height === 0) {
        return null;
      }

      // scrollTop and scrollLeft props are explicitly filtered out and ignored

      var _this$state4 = this.state,
        scrollLeft = _this$state4.scrollLeft,
        scrollTop = _this$state4.scrollTop;
      return /*#__PURE__*/React.createElement("div", {
        style: this._containerOuterStyle
      }, /*#__PURE__*/React.createElement("div", {
        style: this._containerTopStyle
      }, this._renderTopLeftGrid(rest), this._renderTopRightGrid(_objectSpread$5(_objectSpread$5({}, rest), {}, {
        onScroll: onScroll,
        scrollLeft: scrollLeft
      }))), /*#__PURE__*/React.createElement("div", {
        style: this._containerBottomStyle
      }, this._renderBottomLeftGrid(_objectSpread$5(_objectSpread$5({}, rest), {}, {
        onScroll: onScroll,
        scrollTop: scrollTop
      })), this._renderBottomRightGrid(_objectSpread$5(_objectSpread$5({}, rest), {}, {
        onScroll: onScroll,
        onSectionRendered: onSectionRendered,
        scrollLeft: scrollLeft,
        scrollToColumn: scrollToColumn,
        scrollToRow: scrollToRow,
        scrollTop: scrollTop
      }))));
    }
  }, {
    key: "_getBottomGridHeight",
    value: function _getBottomGridHeight(props) {
      var height = props.height;
      var topGridHeight = this._getTopGridHeight(props);
      return height - topGridHeight;
    }
  }, {
    key: "_getLeftGridWidth",
    value: function _getLeftGridWidth(props) {
      var fixedColumnCount = props.fixedColumnCount,
        columnWidth = props.columnWidth;
      if (this._leftGridWidth == null) {
        if (typeof columnWidth === 'function') {
          var leftGridWidth = 0;
          for (var index = 0; index < fixedColumnCount; index++) {
            leftGridWidth += columnWidth({
              index: index
            });
          }
          this._leftGridWidth = leftGridWidth;
        } else {
          this._leftGridWidth = columnWidth * fixedColumnCount;
        }
      }
      return this._leftGridWidth;
    }
  }, {
    key: "_getRightGridWidth",
    value: function _getRightGridWidth(props) {
      var width = props.width;
      var leftGridWidth = this._getLeftGridWidth(props);
      return width - leftGridWidth;
    }
  }, {
    key: "_getTopGridHeight",
    value: function _getTopGridHeight(props) {
      var fixedRowCount = props.fixedRowCount,
        rowHeight = props.rowHeight;
      if (this._topGridHeight == null) {
        if (typeof rowHeight === 'function') {
          var topGridHeight = 0;
          for (var index = 0; index < fixedRowCount; index++) {
            topGridHeight += rowHeight({
              index: index
            });
          }
          this._topGridHeight = topGridHeight;
        } else {
          this._topGridHeight = rowHeight * fixedRowCount;
        }
      }
      return this._topGridHeight;
    }
  }, {
    key: "_handleInvalidatedGridSize",
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;
        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;
        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
        this.forceUpdate();
      }
    }

    /**
     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
     * This method recalculates styles only when specific props change.
     */
  }, {
    key: "_maybeCalculateCachedStyles",
    value: function _maybeCalculateCachedStyles(resetAll) {
      var _this$props9 = this.props,
        columnWidth = _this$props9.columnWidth,
        enableFixedColumnScroll = _this$props9.enableFixedColumnScroll,
        enableFixedRowScroll = _this$props9.enableFixedRowScroll,
        height = _this$props9.height,
        fixedColumnCount = _this$props9.fixedColumnCount,
        fixedRowCount = _this$props9.fixedRowCount,
        rowHeight = _this$props9.rowHeight,
        style = _this$props9.style,
        styleBottomLeftGrid = _this$props9.styleBottomLeftGrid,
        styleBottomRightGrid = _this$props9.styleBottomRightGrid,
        styleTopLeftGrid = _this$props9.styleTopLeftGrid,
        styleTopRightGrid = _this$props9.styleTopRightGrid,
        width = _this$props9.width;
      var sizeChange = resetAll || height !== this._lastRenderedHeight || width !== this._lastRenderedWidth;
      var leftSizeChange = resetAll || columnWidth !== this._lastRenderedColumnWidth || fixedColumnCount !== this._lastRenderedFixedColumnCount;
      var topSizeChange = resetAll || fixedRowCount !== this._lastRenderedFixedRowCount || rowHeight !== this._lastRenderedRowHeight;
      if (resetAll || sizeChange || style !== this._lastRenderedStyle) {
        this._containerOuterStyle = _objectSpread$5({
          height: height,
          overflow: 'visible',
          // Let :focus outline show through
          width: width
        }, style);
      }
      if (resetAll || sizeChange || topSizeChange) {
        this._containerTopStyle = {
          height: this._getTopGridHeight(this.props),
          position: 'relative',
          width: width
        };
        this._containerBottomStyle = {
          height: height - this._getTopGridHeight(this.props),
          overflow: 'visible',
          // Let :focus outline show through
          position: 'relative',
          width: width
        };
      }
      if (resetAll || styleBottomLeftGrid !== this._lastRenderedStyleBottomLeftGrid) {
        this._bottomLeftGridStyle = _objectSpread$5({
          left: 0,
          overflowX: 'hidden',
          overflowY: enableFixedColumnScroll ? 'auto' : 'hidden',
          position: 'absolute'
        }, styleBottomLeftGrid);
      }
      if (resetAll || leftSizeChange || styleBottomRightGrid !== this._lastRenderedStyleBottomRightGrid) {
        this._bottomRightGridStyle = _objectSpread$5({
          left: this._getLeftGridWidth(this.props),
          position: 'absolute'
        }, styleBottomRightGrid);
      }
      if (resetAll || styleTopLeftGrid !== this._lastRenderedStyleTopLeftGrid) {
        this._topLeftGridStyle = _objectSpread$5({
          left: 0,
          overflowX: 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopLeftGrid);
      }
      if (resetAll || leftSizeChange || styleTopRightGrid !== this._lastRenderedStyleTopRightGrid) {
        this._topRightGridStyle = _objectSpread$5({
          left: this._getLeftGridWidth(this.props),
          overflowX: enableFixedRowScroll ? 'auto' : 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopRightGrid);
      }
      this._lastRenderedColumnWidth = columnWidth;
      this._lastRenderedFixedColumnCount = fixedColumnCount;
      this._lastRenderedFixedRowCount = fixedRowCount;
      this._lastRenderedHeight = height;
      this._lastRenderedRowHeight = rowHeight;
      this._lastRenderedStyle = style;
      this._lastRenderedStyleBottomLeftGrid = styleBottomLeftGrid;
      this._lastRenderedStyleBottomRightGrid = styleBottomRightGrid;
      this._lastRenderedStyleTopLeftGrid = styleTopLeftGrid;
      this._lastRenderedStyleTopRightGrid = styleTopRightGrid;
      this._lastRenderedWidth = width;
    }
  }, {
    key: "_prepareForRender",
    value: function _prepareForRender() {
      if (this._lastRenderedColumnWidth !== this.props.columnWidth || this._lastRenderedFixedColumnCount !== this.props.fixedColumnCount) {
        this._leftGridWidth = null;
      }
      if (this._lastRenderedFixedRowCount !== this.props.fixedRowCount || this._lastRenderedRowHeight !== this.props.rowHeight) {
        this._topGridHeight = null;
      }
      this._maybeCalculateCachedStyles();
      this._lastRenderedColumnWidth = this.props.columnWidth;
      this._lastRenderedFixedColumnCount = this.props.fixedColumnCount;
      this._lastRenderedFixedRowCount = this.props.fixedRowCount;
      this._lastRenderedRowHeight = this.props.rowHeight;
    }
  }, {
    key: "_renderBottomLeftGrid",
    value: function _renderBottomLeftGrid(props) {
      var enableFixedColumnScroll = props.enableFixedColumnScroll,
        fixedColumnCount = props.fixedColumnCount,
        fixedRowCount = props.fixedRowCount,
        rowCount = props.rowCount,
        hideBottomLeftGridScrollbar = props.hideBottomLeftGridScrollbar;
      var showVerticalScrollbar = this.state.showVerticalScrollbar;
      if (!fixedColumnCount) {
        return null;
      }
      var additionalRowCount = showVerticalScrollbar ? 1 : 0,
        height = this._getBottomGridHeight(props),
        width = this._getLeftGridWidth(props),
        scrollbarSize = this.state.showVerticalScrollbar ? this.state.scrollbarSize : 0,
        gridWidth = hideBottomLeftGridScrollbar ? width + scrollbarSize : width;
      var bottomLeftGrid = /*#__PURE__*/React.createElement(Grid, _extends$5({}, props, {
        cellRenderer: this._cellRendererBottomLeftGrid,
        className: this.props.classNameBottomLeftGrid,
        columnCount: fixedColumnCount,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomLeftGrid,
        height: height,
        onScroll: enableFixedColumnScroll ? this._onScrollTop : undefined,
        ref: this._bottomLeftGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount) + additionalRowCount,
        rowHeight: this._rowHeightBottomGrid,
        style: this._bottomLeftGridStyle,
        tabIndex: null,
        width: gridWidth
      }));
      if (hideBottomLeftGridScrollbar) {
        return /*#__PURE__*/React.createElement("div", {
          className: "BottomLeftGrid_ScrollWrapper",
          style: _objectSpread$5(_objectSpread$5({}, this._bottomLeftGridStyle), {}, {
            height: height,
            width: width,
            overflowY: 'hidden'
          })
        }, bottomLeftGrid);
      }
      return bottomLeftGrid;
    }
  }, {
    key: "_renderBottomRightGrid",
    value: function _renderBottomRightGrid(props) {
      var columnCount = props.columnCount,
        fixedColumnCount = props.fixedColumnCount,
        fixedRowCount = props.fixedRowCount,
        rowCount = props.rowCount,
        scrollToColumn = props.scrollToColumn,
        scrollToRow = props.scrollToRow;
      return /*#__PURE__*/React.createElement(Grid, _extends$5({}, props, {
        cellRenderer: this._cellRendererBottomRightGrid,
        className: this.props.classNameBottomRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount),
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomRightGrid,
        height: this._getBottomGridHeight(props),
        onScroll: this._onScroll,
        onScrollbarPresenceChange: this._onScrollbarPresenceChange,
        ref: this._bottomRightGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount),
        rowHeight: this._rowHeightBottomGrid,
        scrollToColumn: scrollToColumn - fixedColumnCount,
        scrollToRow: scrollToRow - fixedRowCount,
        style: this._bottomRightGridStyle,
        width: this._getRightGridWidth(props)
      }));
    }
  }, {
    key: "_renderTopLeftGrid",
    value: function _renderTopLeftGrid(props) {
      var fixedColumnCount = props.fixedColumnCount,
        fixedRowCount = props.fixedRowCount;
      if (!fixedColumnCount || !fixedRowCount) {
        return null;
      }
      return /*#__PURE__*/React.createElement(Grid, _extends$5({}, props, {
        className: this.props.classNameTopLeftGrid,
        columnCount: fixedColumnCount,
        height: this._getTopGridHeight(props),
        ref: this._topLeftGridRef,
        rowCount: fixedRowCount,
        style: this._topLeftGridStyle,
        tabIndex: null,
        width: this._getLeftGridWidth(props)
      }));
    }
  }, {
    key: "_renderTopRightGrid",
    value: function _renderTopRightGrid(props) {
      var columnCount = props.columnCount,
        enableFixedRowScroll = props.enableFixedRowScroll,
        fixedColumnCount = props.fixedColumnCount,
        fixedRowCount = props.fixedRowCount,
        scrollLeft = props.scrollLeft,
        hideTopRightGridScrollbar = props.hideTopRightGridScrollbar;
      var _this$state5 = this.state,
        showHorizontalScrollbar = _this$state5.showHorizontalScrollbar,
        scrollbarSize = _this$state5.scrollbarSize;
      if (!fixedRowCount) {
        return null;
      }
      var additionalColumnCount = showHorizontalScrollbar ? 1 : 0,
        height = this._getTopGridHeight(props),
        width = this._getRightGridWidth(props),
        additionalHeight = showHorizontalScrollbar ? scrollbarSize : 0;
      var gridHeight = height,
        style = this._topRightGridStyle;
      if (hideTopRightGridScrollbar) {
        gridHeight = height + additionalHeight;
        style = _objectSpread$5(_objectSpread$5({}, this._topRightGridStyle), {}, {
          left: 0
        });
      }
      var topRightGrid = /*#__PURE__*/React.createElement(Grid, _extends$5({}, props, {
        cellRenderer: this._cellRendererTopRightGrid,
        className: this.props.classNameTopRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount) + additionalColumnCount,
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheTopRightGrid,
        height: gridHeight,
        onScroll: enableFixedRowScroll ? this._onScrollLeft : undefined,
        ref: this._topRightGridRef,
        rowCount: fixedRowCount,
        scrollLeft: scrollLeft,
        style: style,
        tabIndex: null,
        width: width
      }));
      if (hideTopRightGridScrollbar) {
        return /*#__PURE__*/React.createElement("div", {
          className: "TopRightGrid_ScrollWrapper",
          style: _objectSpread$5(_objectSpread$5({}, this._topRightGridStyle), {}, {
            height: height,
            width: width,
            overflowX: 'hidden'
          })
        }, topRightGrid);
      }
      return topRightGrid;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null && nextProps.scrollLeft >= 0 ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null && nextProps.scrollTop >= 0 ? nextProps.scrollTop : prevState.scrollTop
        };
      }
      return null;
    }
  }]);
}(React.PureComponent);
_defineProperty(MultiGrid, "defaultProps", {
  classNameBottomLeftGrid: '',
  classNameBottomRightGrid: '',
  classNameTopLeftGrid: '',
  classNameTopRightGrid: '',
  enableFixedColumnScroll: false,
  enableFixedRowScroll: false,
  fixedColumnCount: 0,
  fixedRowCount: 0,
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  styleBottomLeftGrid: {},
  styleBottomRightGrid: {},
  styleTopLeftGrid: {},
  styleTopRightGrid: {},
  hideTopRightGridScrollbar: false,
  hideBottomLeftGridScrollbar: false
});
MultiGrid.propTypes = process.env.NODE_ENV !== "production" ? {
  classNameBottomLeftGrid: PropTypes.string.isRequired,
  classNameBottomRightGrid: PropTypes.string.isRequired,
  classNameTopLeftGrid: PropTypes.string.isRequired,
  classNameTopRightGrid: PropTypes.string.isRequired,
  enableFixedColumnScroll: PropTypes.bool.isRequired,
  enableFixedRowScroll: PropTypes.bool.isRequired,
  fixedColumnCount: PropTypes.number.isRequired,
  fixedRowCount: PropTypes.number.isRequired,
  onScrollbarPresenceChange: PropTypes.func,
  style: PropTypes.object.isRequired,
  styleBottomLeftGrid: PropTypes.object.isRequired,
  styleBottomRightGrid: PropTypes.object.isRequired,
  styleTopLeftGrid: PropTypes.object.isRequired,
  styleTopRightGrid: PropTypes.object.isRequired,
  hideTopRightGridScrollbar: PropTypes.bool,
  hideBottomLeftGridScrollbar: PropTypes.bool
} : {};
polyfill(MultiGrid);
function _callSuper$3(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$3() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$3() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$3 = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

/**
 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
 */
var ScrollSync = /*#__PURE__*/function (_React$PureComponent) {
  function ScrollSync(props, context) {
    var _this;
    _classCallCheck(this, ScrollSync);
    _this = _callSuper$3(this, ScrollSync, [props, context]);
    _this.state = {
      clientHeight: 0,
      clientWidth: 0,
      scrollHeight: 0,
      scrollLeft: 0,
      scrollTop: 0,
      scrollWidth: 0
    };
    _this._onScroll = _this._onScroll.bind(_this);
    return _this;
  }
  _inherits(ScrollSync, _React$PureComponent);
  return _createClass(ScrollSync, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
        clientHeight = _this$state.clientHeight,
        clientWidth = _this$state.clientWidth,
        scrollHeight = _this$state.scrollHeight,
        scrollLeft = _this$state.scrollLeft,
        scrollTop = _this$state.scrollTop,
        scrollWidth = _this$state.scrollWidth;
      return children({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        onScroll: this._onScroll,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }, {
    key: "_onScroll",
    value: function _onScroll(_ref) {
      var clientHeight = _ref.clientHeight,
        clientWidth = _ref.clientWidth,
        scrollHeight = _ref.scrollHeight,
        scrollLeft = _ref.scrollLeft,
        scrollTop = _ref.scrollTop,
        scrollWidth = _ref.scrollWidth;
      this.setState({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }]);
}(React.PureComponent);
ScrollSync.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Function responsible for rendering 2 or more virtualized components.
   * This function should implement the following signature:
   * ({ onScroll, scrollLeft, scrollTop }) => PropTypes.element
   */
  children: PropTypes.func.isRequired
} : {};

/*:: import type {CellDataGetterParams} from './types';*/
/**
 * Default accessor for returning a cell value for a given attribute.
 * This function expects to operate on either a vanilla Object or an Immutable Map.
 * You should override the column's cellDataGetter if your data is some other type of object.
 */
function defaultCellDataGetter(_ref /*:: */) {
  var dataKey = _ref /*:: */.dataKey,
    rowData = _ref /*:: */.rowData;
  if (typeof rowData.get === 'function') {
    return rowData.get(dataKey);
  } else {
    return rowData[dataKey];
  }
}

/*:: import type {CellRendererParams} from './types';*/
/**
 * Default cell renderer that displays an attribute as a simple string
 * You should override the column's cellRenderer if your data is some other type of object.
 */
function defaultCellRenderer(_ref /*:: */) /*: string*/{
  var cellData = _ref /*:: */.cellData;
  if (cellData == null) {
    return '';
  } else {
    return String(cellData);
  }
}

/*:: import type {HeaderRowRendererParams} from './types';*/
function defaultHeaderRowRenderer(_ref /*:: */) {
  var className = _ref /*:: */.className,
    columns = _ref /*:: */.columns,
    style = _ref /*:: */.style;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    role: "row",
    style: style
  }, columns);
}
var SortDirection = {
  /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */
  ASC: 'ASC',
  /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */
  DESC: 'DESC'
};

/**
 * Displayed beside a header to indicate that a Table is currently sorted by this column.
 */
function SortIndicator(_ref) {
  var sortDirection = _ref.sortDirection;
  var classNames = clsx('ReactVirtualized__Table__sortableHeaderIcon', {
    'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === SortDirection.ASC,
    'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === SortDirection.DESC
  });
  return /*#__PURE__*/React.createElement("svg", {
    className: classNames,
    width: 18,
    height: 18,
    viewBox: "0 0 24 24"
  }, sortDirection === SortDirection.ASC ? /*#__PURE__*/React.createElement("path", {
    d: "M7 14l5-5 5 5z"
  }) : /*#__PURE__*/React.createElement("path", {
    d: "M7 10l5 5 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
}
SortIndicator.propTypes = process.env.NODE_ENV !== "production" ? {
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC])
} : {};

/*:: import type {HeaderRendererParams} from './types';*/
/**
 * Default table header renderer.
 */
function defaultHeaderRenderer(_ref /*:: */) {
  var dataKey = _ref /*:: */.dataKey,
    label = _ref /*:: */.label,
    sortBy = _ref /*:: */.sortBy,
    sortDirection = _ref /*:: */.sortDirection;
  var showSortIndicator = sortBy === dataKey;
  var children = [/*#__PURE__*/React.createElement("span", {
    className: "ReactVirtualized__Table__headerTruncatedText",
    key: "label",
    title: typeof label === 'string' ? label : null
  }, label)];
  if (showSortIndicator) {
    children.push( /*#__PURE__*/React.createElement(SortIndicator, {
      key: "SortIndicator",
      sortDirection: sortDirection
    }));
  }
  return children;
}

/*:: import type {RowRendererParams} from './types';*/
/**
 * Default row renderer for Table.
 */
function defaultRowRenderer(_ref /*:: */) {
  var className = _ref /*:: */.className,
    columns = _ref /*:: */.columns,
    index = _ref /*:: */.index,
    key = _ref /*:: */.key,
    onRowClick = _ref /*:: */.onRowClick,
    onRowDoubleClick = _ref /*:: */.onRowDoubleClick,
    onRowMouseOut = _ref /*:: */.onRowMouseOut,
    onRowMouseOver = _ref /*:: */.onRowMouseOver,
    onRowRightClick = _ref /*:: */.onRowRightClick,
    rowData = _ref /*:: */.rowData,
    style = _ref /*:: */.style;
  var a11yProps = {
    'aria-rowindex': index + 1
  };
  if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
    a11yProps['aria-label'] = 'row';
    a11yProps.tabIndex = 0;
    if (onRowClick) {
      a11yProps.onClick = function (event) {
        return onRowClick({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }
    if (onRowDoubleClick) {
      a11yProps.onDoubleClick = function (event) {
        return onRowDoubleClick({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }
    if (onRowMouseOut) {
      a11yProps.onMouseOut = function (event) {
        return onRowMouseOut({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }
    if (onRowMouseOver) {
      a11yProps.onMouseOver = function (event) {
        return onRowMouseOver({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }
    if (onRowRightClick) {
      a11yProps.onContextMenu = function (event) {
        return onRowRightClick({
          event: event,
          index: index,
          rowData: rowData
        });
      };
    }
  }
  return /*#__PURE__*/React.createElement("div", _extends$5({}, a11yProps, {
    className: className,
    key: key,
    role: "row",
    style: style
  }), columns);
}
function _callSuper$2(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$2() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$2() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$2 = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

/**
 * Describes the header and cell contents of a table column.
 */
var Column = /*#__PURE__*/function (_React$Component) {
  function Column() {
    _classCallCheck(this, Column);
    return _callSuper$2(this, Column, arguments);
  }
  _inherits(Column, _React$Component);
  return _createClass(Column);
}(React.Component);
_defineProperty(Column, "defaultProps", {
  cellDataGetter: defaultCellDataGetter,
  cellRenderer: defaultCellRenderer,
  defaultSortDirection: SortDirection.ASC,
  flexGrow: 0,
  flexShrink: 1,
  headerRenderer: defaultHeaderRenderer,
  style: {}
});
Column.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Optional aria-label value to set on the column header */
  'aria-label': PropTypes.string,
  /**
   * Callback responsible for returning a cell's data, given its :dataKey
   * ({ columnData: any, dataKey: string, rowData: any }): any
   */
  cellDataGetter: PropTypes.func,
  /**
   * Callback responsible for rendering a cell's contents.
   * ({ cellData: any, columnData: any, dataKey: string, rowData: any, rowIndex: number }): node
   */
  cellRenderer: PropTypes.func,
  /** Optional CSS class to apply to cell */
  className: PropTypes.string,
  /** Optional additional data passed to this column's :cellDataGetter */
  columnData: PropTypes.object,
  /** Uniquely identifies the row-data attribute corresponding to this cell */
  dataKey: PropTypes.any.isRequired,
  /** Optional direction to be used when clicked the first time */
  defaultSortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),
  /** If sort is enabled for the table at large, disable it for this column */
  disableSort: PropTypes.bool,
  /** Flex grow style; defaults to 0 */
  flexGrow: PropTypes.number,
  /** Flex shrink style; defaults to 1 */
  flexShrink: PropTypes.number,
  /** Optional CSS class to apply to this column's header */
  headerClassName: PropTypes.string,
  /**
   * Optional callback responsible for rendering a column header contents.
   * ({ columnData: object, dataKey: string, disableSort: boolean, label: node, sortBy: string, sortDirection: string }): PropTypes.node
   */
  headerRenderer: PropTypes.func.isRequired,
  /** Optional inline style to apply to this column's header */
  headerStyle: PropTypes.object,
  /** Optional id to set on the column header */
  id: PropTypes.string,
  /** Header label for this column */
  label: PropTypes.node,
  /** Maximum width of column; this property will only be used if :flexGrow is > 0. */
  maxWidth: PropTypes.number,
  /** Minimum width of column. */
  minWidth: PropTypes.number,
  /** Optional inline style to apply to cell */
  style: PropTypes.object,
  /** Flex basis (width) for this column; This value can grow or shrink based on :flexGrow and :flexShrink properties. */
  width: PropTypes.number.isRequired
} : {};
function ownKeys$4(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$4(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _callSuper$1(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct$1() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

/**
 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
 * This component expects explicit width, height, and padding parameters.
 */
var Table = /*#__PURE__*/function (_React$PureComponent) {
  function Table(props) {
    var _this;
    _classCallCheck(this, Table);
    _this = _callSuper$1(this, Table, [props]);
    _this.state = {
      scrollbarWidth: 0
    };
    _this._createColumn = _this._createColumn.bind(_this);
    _this._createRow = _this._createRow.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
    _this._setRef = _this._setRef.bind(_this);
    _this._setGridElementRef = _this._setGridElementRef.bind(_this);
    return _this;
  }
  _inherits(Table, _React$PureComponent);
  return _createClass(Table, [{
    key: "forceUpdateGrid",
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }

    /** See Grid#getOffsetForCell */
  }, {
    key: "getOffsetForRow",
    value: function getOffsetForRow(_ref) {
      var alignment = _ref.alignment,
        index = _ref.index;
      if (this.Grid) {
        var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
            alignment: alignment,
            rowIndex: index
          }),
          scrollTop = _this$Grid$getOffsetF.scrollTop;
        return scrollTop;
      }
      return 0;
    }

    /** CellMeasurer compatibility */
  }, {
    key: "invalidateCellSizeAfterRender",
    value: function invalidateCellSizeAfterRender(_ref2 /*:: */) {
      var columnIndex = _ref2 /*:: */.columnIndex,
        rowIndex = _ref2 /*:: */.rowIndex;
      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#measureAllCells */
  }, {
    key: "measureAllRows",
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }

    /** CellMeasurer compatibility */
  }, {
    key: "recomputeGridSize",
    value: function recomputeGridSize() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$columnIndex = _ref3.columnIndex,
        columnIndex = _ref3$columnIndex === void 0 ? 0 : _ref3$columnIndex,
        _ref3$rowIndex = _ref3.rowIndex,
        rowIndex = _ref3$rowIndex === void 0 ? 0 : _ref3$rowIndex;
      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#recomputeGridSize */
  }, {
    key: "recomputeRowHeights",
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index
        });
      }
    }

    /** See Grid#scrollToPosition */
  }, {
    key: "scrollToPosition",
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (this.Grid) {
        this.Grid.scrollToPosition({
          scrollTop: scrollTop
        });
      }
    }

    /** See Grid#scrollToCell */
  }, {
    key: "scrollToRow",
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: "getScrollbarWidth",
    value: function getScrollbarWidth() {
      if (this.GridElement) {
        var _Grid = this.GridElement;
        var clientWidth = _Grid.clientWidth || 0;
        var offsetWidth = _Grid.offsetWidth || 0;
        return offsetWidth - clientWidth;
      }
      return 0;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._setScrollbarWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._setScrollbarWidth();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        disableHeader = _this$props.disableHeader,
        gridClassName = _this$props.gridClassName,
        gridStyle = _this$props.gridStyle,
        headerHeight = _this$props.headerHeight,
        headerRowRenderer = _this$props.headerRowRenderer,
        height = _this$props.height,
        id = _this$props.id,
        noRowsRenderer = _this$props.noRowsRenderer,
        rowClassName = _this$props.rowClassName,
        rowStyle = _this$props.rowStyle,
        scrollToIndex = _this$props.scrollToIndex,
        style = _this$props.style,
        width = _this$props.width;
      var scrollbarWidth = this.state.scrollbarWidth;
      var availableRowsHeight = disableHeader ? height : height - headerHeight;
      var rowClass = typeof rowClassName === 'function' ? rowClassName({
        index: -1
      }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({
        index: -1
      }) : rowStyle;

      // Precompute and cache column styles before rendering rows and columns to speed things up
      this._cachedColumnStyles = [];
      React.Children.toArray(children).forEach(function (column, index) {
        var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style || Column.defaultProps.style);
        _this2._cachedColumnStyles[index] = _objectSpread$4({
          overflow: 'hidden'
        }, flexStyles);
      });

      // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
      // This is done because Grid is a pure component and won't update unless its properties or state has changed.
      // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.
      return /*#__PURE__*/React.createElement("div", {
        "aria-label": this.props['aria-label'],
        "aria-labelledby": this.props['aria-labelledby'],
        "aria-colcount": React.Children.toArray(children).length,
        "aria-rowcount": this.props.rowCount,
        className: clsx('ReactVirtualized__Table', className),
        id: id,
        role: "grid",
        style: style
      }, !disableHeader && headerRowRenderer({
        className: clsx('ReactVirtualized__Table__headerRow', rowClass),
        columns: this._getHeaderColumns(),
        style: _objectSpread$4({
          height: headerHeight,
          overflow: 'hidden',
          paddingRight: scrollbarWidth,
          width: width
        }, rowStyleObject)
      }), /*#__PURE__*/React.createElement(Grid, _extends$5({}, this.props, {
        elementRef: this._setGridElementRef,
        "aria-readonly": null,
        autoContainerWidth: true,
        className: clsx('ReactVirtualized__Table__Grid', gridClassName),
        cellRenderer: this._createRow,
        columnWidth: width,
        columnCount: 1,
        height: availableRowsHeight,
        id: undefined,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        role: "rowgroup",
        scrollbarWidth: scrollbarWidth,
        scrollToRow: scrollToIndex,
        style: _objectSpread$4(_objectSpread$4({}, gridStyle), {}, {
          overflowX: 'hidden'
        })
      })));
    }
  }, {
    key: "_createColumn",
    value: function _createColumn(_ref4) {
      var column = _ref4.column,
        columnIndex = _ref4.columnIndex,
        isScrolling = _ref4.isScrolling,
        parent = _ref4.parent,
        rowData = _ref4.rowData,
        rowIndex = _ref4.rowIndex;
      var onColumnClick = this.props.onColumnClick;
      var _column$props = column.props,
        cellDataGetter = _column$props.cellDataGetter,
        cellRenderer = _column$props.cellRenderer,
        className = _column$props.className,
        columnData = _column$props.columnData,
        dataKey = _column$props.dataKey,
        id = _column$props.id;
      var cellData = cellDataGetter({
        columnData: columnData,
        dataKey: dataKey,
        rowData: rowData
      });
      var renderedCell = cellRenderer({
        cellData: cellData,
        columnData: columnData,
        columnIndex: columnIndex,
        dataKey: dataKey,
        isScrolling: isScrolling,
        parent: parent,
        rowData: rowData,
        rowIndex: rowIndex
      });
      var onClick = function onClick(event) {
        onColumnClick && onColumnClick({
          columnData: columnData,
          dataKey: dataKey,
          event: event
        });
      };
      var style = this._cachedColumnStyles[columnIndex];
      var title = typeof renderedCell === 'string' ? renderedCell : null;

      // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942
      return /*#__PURE__*/React.createElement("div", {
        "aria-colindex": columnIndex + 1,
        "aria-describedby": id,
        className: clsx('ReactVirtualized__Table__rowColumn', className),
        key: 'Row' + rowIndex + '-' + 'Col' + columnIndex,
        onClick: onClick,
        role: "gridcell",
        style: style,
        title: title
      }, renderedCell);
    }
  }, {
    key: "_createHeader",
    value: function _createHeader(_ref5) {
      var column = _ref5.column,
        index = _ref5.index;
      var _this$props2 = this.props,
        headerClassName = _this$props2.headerClassName,
        headerStyle = _this$props2.headerStyle,
        onHeaderClick = _this$props2.onHeaderClick,
        sort = _this$props2.sort,
        sortBy = _this$props2.sortBy,
        sortDirection = _this$props2.sortDirection;
      var _column$props2 = column.props,
        columnData = _column$props2.columnData,
        dataKey = _column$props2.dataKey,
        defaultSortDirection = _column$props2.defaultSortDirection,
        disableSort = _column$props2.disableSort,
        headerRenderer = _column$props2.headerRenderer,
        id = _column$props2.id,
        label = _column$props2.label;
      var sortEnabled = !disableSort && sort;
      var classNames = clsx('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
        ReactVirtualized__Table__sortableHeaderColumn: sortEnabled
      });
      var style = this._getFlexStyleForColumn(column, _objectSpread$4(_objectSpread$4({}, headerStyle), column.props.headerStyle));
      var renderedHeader = headerRenderer({
        columnData: columnData,
        dataKey: dataKey,
        disableSort: disableSort,
        label: label,
        sortBy: sortBy,
        sortDirection: sortDirection
      });
      var headerOnClick, headerOnKeyDown, headerTabIndex, headerAriaSort, headerAriaLabel;
      if (sortEnabled || onHeaderClick) {
        // If this is a sortable header, clicking it should update the table data's sorting.
        var isFirstTimeSort = sortBy !== dataKey;

        // If this is the firstTime sort of this column, use the column default sort order.
        // Otherwise, invert the direction of the sort.
        var newSortDirection = isFirstTimeSort ? defaultSortDirection : sortDirection === SortDirection.DESC ? SortDirection.ASC : SortDirection.DESC;
        var onClick = function onClick(event) {
          sortEnabled && sort({
            defaultSortDirection: defaultSortDirection,
            event: event,
            sortBy: dataKey,
            sortDirection: newSortDirection
          });
          onHeaderClick && onHeaderClick({
            columnData: columnData,
            dataKey: dataKey,
            event: event
          });
        };
        var onKeyDown = function onKeyDown(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            onClick(event);
          }
        };
        headerAriaLabel = column.props['aria-label'] || label || dataKey;
        headerAriaSort = 'none';
        headerTabIndex = 0;
        headerOnClick = onClick;
        headerOnKeyDown = onKeyDown;
      }
      if (sortBy === dataKey) {
        headerAriaSort = sortDirection === SortDirection.ASC ? 'ascending' : 'descending';
      }

      // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942
      return /*#__PURE__*/React.createElement("div", {
        "aria-label": headerAriaLabel,
        "aria-sort": headerAriaSort,
        className: classNames,
        id: id,
        key: 'Header-Col' + index,
        onClick: headerOnClick,
        onKeyDown: headerOnKeyDown,
        role: "columnheader",
        style: style,
        tabIndex: headerTabIndex
      }, renderedHeader);
    }
  }, {
    key: "_createRow",
    value: function _createRow(_ref6) {
      var _this3 = this;
      var index = _ref6.rowIndex,
        isScrolling = _ref6.isScrolling,
        key = _ref6.key,
        parent = _ref6.parent,
        style = _ref6.style;
      var _this$props3 = this.props,
        children = _this$props3.children,
        onRowClick = _this$props3.onRowClick,
        onRowDoubleClick = _this$props3.onRowDoubleClick,
        onRowRightClick = _this$props3.onRowRightClick,
        onRowMouseOver = _this$props3.onRowMouseOver,
        onRowMouseOut = _this$props3.onRowMouseOut,
        rowClassName = _this$props3.rowClassName,
        rowGetter = _this$props3.rowGetter,
        rowRenderer = _this$props3.rowRenderer,
        rowStyle = _this$props3.rowStyle;
      var scrollbarWidth = this.state.scrollbarWidth;
      var rowClass = typeof rowClassName === 'function' ? rowClassName({
        index: index
      }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({
        index: index
      }) : rowStyle;
      var rowData = rowGetter({
        index: index
      });
      var columns = React.Children.toArray(children).map(function (column, columnIndex) {
        return _this3._createColumn({
          column: column,
          columnIndex: columnIndex,
          isScrolling: isScrolling,
          parent: parent,
          rowData: rowData,
          rowIndex: index,
          scrollbarWidth: scrollbarWidth
        });
      });
      var className = clsx('ReactVirtualized__Table__row', rowClass);
      var flattenedStyle = _objectSpread$4(_objectSpread$4({}, style), {}, {
        height: this._getRowHeight(index),
        overflow: 'hidden',
        paddingRight: scrollbarWidth
      }, rowStyleObject);
      return rowRenderer({
        className: className,
        columns: columns,
        index: index,
        isScrolling: isScrolling,
        key: key,
        onRowClick: onRowClick,
        onRowDoubleClick: onRowDoubleClick,
        onRowRightClick: onRowRightClick,
        onRowMouseOver: onRowMouseOver,
        onRowMouseOut: onRowMouseOut,
        rowData: rowData,
        style: flattenedStyle
      });
    }

    /**
     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
     */
  }, {
    key: "_getFlexStyleForColumn",
    value: function _getFlexStyleForColumn(column) {
      var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var flexValue = "".concat(column.props.flexGrow, " ").concat(column.props.flexShrink, " ").concat(column.props.width, "px");
      var style = _objectSpread$4(_objectSpread$4({}, customStyle), {}, {
        flex: flexValue,
        msFlex: flexValue,
        WebkitFlex: flexValue
      });
      if (column.props.maxWidth) {
        style.maxWidth = column.props.maxWidth;
      }
      if (column.props.minWidth) {
        style.minWidth = column.props.minWidth;
      }
      return style;
    }
  }, {
    key: "_getHeaderColumns",
    value: function _getHeaderColumns() {
      var _this4 = this;
      var _this$props4 = this.props,
        children = _this$props4.children,
        disableHeader = _this$props4.disableHeader;
      var items = disableHeader ? [] : React.Children.toArray(children);
      return items.map(function (column, index) {
        return _this4._createHeader({
          column: column,
          index: index
        });
      });
    }
  }, {
    key: "_getRowHeight",
    value: function _getRowHeight(rowIndex) {
      var rowHeight = this.props.rowHeight;
      return typeof rowHeight === 'function' ? rowHeight({
        index: rowIndex
      }) : rowHeight;
    }
  }, {
    key: "_onScroll",
    value: function _onScroll(_ref7) {
      var clientHeight = _ref7.clientHeight,
        scrollHeight = _ref7.scrollHeight,
        scrollTop = _ref7.scrollTop;
      var onScroll = this.props.onScroll;
      onScroll({
        clientHeight: clientHeight,
        scrollHeight: scrollHeight,
        scrollTop: scrollTop
      });
    }
  }, {
    key: "_onSectionRendered",
    value: function _onSectionRendered(_ref8) {
      var rowOverscanStartIndex = _ref8.rowOverscanStartIndex,
        rowOverscanStopIndex = _ref8.rowOverscanStopIndex,
        rowStartIndex = _ref8.rowStartIndex,
        rowStopIndex = _ref8.rowStopIndex;
      var onRowsRendered = this.props.onRowsRendered;
      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }
  }, {
    key: "_setRef",
    value: function _setRef(ref) {
      this.Grid = ref;
    }
  }, {
    key: "_setGridElementRef",
    value: function _setGridElementRef(ref) {
      this.GridElement = ref;
    }
  }, {
    key: "_setScrollbarWidth",
    value: function _setScrollbarWidth() {
      var scrollbarWidth = this.getScrollbarWidth();
      this.setState({
        scrollbarWidth: scrollbarWidth
      });
    }
  }]);
}(React.PureComponent);
_defineProperty(Table, "defaultProps", {
  disableHeader: false,
  estimatedRowSize: 30,
  headerHeight: 0,
  headerStyle: {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  overscanIndicesGetter: defaultOverscanIndicesGetter,
  overscanRowCount: 10,
  rowRenderer: defaultRowRenderer,
  headerRowRenderer: defaultHeaderRowRenderer,
  rowStyle: {},
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
});
Table.propTypes = process.env.NODE_ENV !== "production" ? {
  /** This is just set on the grid top element. */
  'aria-label': PropTypes.string,
  /** This is just set on the grid top element. */
  'aria-labelledby': PropTypes.string,
  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,
  /** One or more Columns describing the data displayed in this row */
  children: function children(props) {
    var children = React.Children.toArray(props.children);
    for (var i = 0; i < children.length; i++) {
      var childType = children[i].type;
      if (childType !== Column && !(childType.prototype instanceof Column)) {
        return new Error('Table only accepts children of type Column');
      }
    }
  },
  /** Optional CSS class name */
  className: PropTypes.string,
  /** Disable rendering the header at all */
  disableHeader: PropTypes.bool,
  /**
   * Used to estimate the total height of a Table before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,
  /** Optional custom CSS class name to attach to inner Grid element. */
  gridClassName: PropTypes.string,
  /** Optional inline style to attach to inner Grid element. */
  gridStyle: PropTypes.object,
  /** Optional CSS class to apply to all column headers */
  headerClassName: PropTypes.string,
  /** Fixed height of header row */
  headerHeight: PropTypes.number.isRequired,
  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: any[],
   *   style: any
   * }): PropTypes.node
   */
  headerRowRenderer: PropTypes.func,
  /** Optional custom inline style to attach to table header columns. */
  headerStyle: PropTypes.object,
  /** Fixed/available height for out DOM element */
  height: PropTypes.number.isRequired,
  /** Optional id */
  id: PropTypes.string,
  /** Optional renderer to be used in place of table body rows when rowCount is 0 */
  noRowsRenderer: PropTypes.func,
  /**
   * Optional callback when a column is clicked.
   * ({ columnData: any, dataKey: string }): void
   */
  onColumnClick: PropTypes.func,
  /**
   * Optional callback when a column's header is clicked.
   * ({ columnData: any, dataKey: string }): void
   */
  onHeaderClick: PropTypes.func,
  /**
   * Callback invoked when a user clicks on a table row.
   * ({ index: number }): void
   */
  onRowClick: PropTypes.func,
  /**
   * Callback invoked when a user double-clicks on a table row.
   * ({ index: number }): void
   */
  onRowDoubleClick: PropTypes.func,
  /**
   * Callback invoked when the mouse leaves a table row.
   * ({ index: number }): void
   */
  onRowMouseOut: PropTypes.func,
  /**
   * Callback invoked when a user moves the mouse over a table row.
   * ({ index: number }): void
   */
  onRowMouseOver: PropTypes.func,
  /**
   * Callback invoked when a user right-clicks on a table row.
   * ({ index: number }): void
   */
  onRowRightClick: PropTypes.func,
  /**
   * Callback invoked with information about the slice of rows that were just rendered.
   * ({ startIndex, stopIndex }): void
   */
  onRowsRendered: PropTypes.func,
  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, scrollHeight, scrollTop }): void
   */
  onScroll: PropTypes.func.isRequired,
  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: PropTypes.func.isRequired,
  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: PropTypes.number.isRequired,
  /**
   * Optional CSS class to apply to all table rows (including the header row).
   * This property can be a CSS class name (string) or a function that returns a class name.
   * If a function is provided its signature should be: ({ index: number }): string
   */
  rowClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /**
   * Callback responsible for returning a data row given an index.
   * ({ index: number }): any
   */
  rowGetter: PropTypes.func.isRequired,
  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * ({ index: number }): number
   */
  rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,
  /** Number of rows in table. */
  rowCount: PropTypes.number.isRequired,
  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: Array,
   *   index: number,
   *   isScrolling: boolean,
   *   onRowClick: ?Function,
   *   onRowDoubleClick: ?Function,
   *   onRowMouseOver: ?Function,
   *   onRowMouseOut: ?Function,
   *   rowData: any,
   *   style: any
   * }): PropTypes.node
   */
  rowRenderer: PropTypes.func,
  /** Optional custom inline style to attach to table rows. */
  rowStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  /** See Grid#scrollToAlignment */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,
  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: PropTypes.number.isRequired,
  /** Vertical offset. */
  scrollTop: PropTypes.number,
  /**
   * Sort function to be called if a sortable header is clicked.
   * Should implement the following interface: ({
   *   defaultSortDirection: 'ASC' | 'DESC',
   *   event: MouseEvent,
   *   sortBy: string,
   *   sortDirection: SortDirection
   * }): void
   */
  sort: PropTypes.func,
  /** Table data is currently sorted by this :dataKey (if it is sorted at all) */
  sortBy: PropTypes.string,
  /** Table data is currently sorted in this direction (if it is sorted at all) */
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),
  /** Optional inline style */
  style: PropTypes.object,
  /** Tab index for focus */
  tabIndex: PropTypes.number,
  /** Width of list */
  width: PropTypes.number.isRequired
} : {};

/*:: import type WindowScroller from '../WindowScroller.js';*/
var mountedInstances = [];
var originalBodyPointerEvents = null;
var disablePointerEventsTimeoutId = null;
function enablePointerEventsIfDisabled() {
  if (disablePointerEventsTimeoutId) {
    disablePointerEventsTimeoutId = null;
    if (document.body && originalBodyPointerEvents != null) {
      document.body.style.pointerEvents = originalBodyPointerEvents;
    }
    originalBodyPointerEvents = null;
  }
}
function enablePointerEventsAfterDelayCallback() {
  enablePointerEventsIfDisabled();
  mountedInstances.forEach(function (instance) {
    return instance.__resetIsScrolling();
  });
}
function enablePointerEventsAfterDelay() {
  if (disablePointerEventsTimeoutId) {
    cancelAnimationTimeout(disablePointerEventsTimeoutId);
  }
  var maximumTimeout = 0;
  mountedInstances.forEach(function (instance) {
    maximumTimeout = Math.max(maximumTimeout, instance.props.scrollingResetTimeInterval);
  });
  disablePointerEventsTimeoutId = requestAnimationTimeout(enablePointerEventsAfterDelayCallback, maximumTimeout);
}
function onScrollWindow(event /*: Event*/) {
  if (event.currentTarget === window && originalBodyPointerEvents == null && document.body) {
    originalBodyPointerEvents = document.body.style.pointerEvents;
    document.body.style.pointerEvents = 'none';
  }
  enablePointerEventsAfterDelay();
  mountedInstances.forEach(function (instance) {
    if (instance.props.scrollElement === event.currentTarget) {
      instance.__handleWindowScrollEvent();
    }
  });
}
function registerScrollListener(component /*: WindowScroller*/, element /*: Element*/) {
  if (!mountedInstances.some(function (instance) {
    return instance.props.scrollElement === element;
  })) {
    element.addEventListener('scroll', onScrollWindow);
  }
  mountedInstances.push(component);
}
function unregisterScrollListener(component /*: WindowScroller*/, element /*: Element*/) {
  mountedInstances = mountedInstances.filter(function (instance) {
    return instance !== component;
  });
  if (!mountedInstances.length) {
    element.removeEventListener('scroll', onScrollWindow);
    if (disablePointerEventsTimeoutId) {
      cancelAnimationTimeout(disablePointerEventsTimeoutId);
      enablePointerEventsIfDisabled();
    }
  }
}

/**
 * Gets the dimensions of the element, accounting for API differences between
 * `window` and other DOM elements.
 */
/*:: type Dimensions = {
  height: number,
  width: number,
};*/
// TODO Move this into WindowScroller and import from there
/*:: type WindowScrollerProps = {
  serverHeight: number,
  serverWidth: number,
};*/
var isWindow = function isWindow(element) {
  return element === window;
};
var getBoundingBox = function getBoundingBox(element) {
  return element.getBoundingClientRect();
};
function getDimensions(scrollElement /*: ?Element*/, props /*: WindowScrollerProps*/) /*: Dimensions*/{
  if (!scrollElement) {
    return {
      height: props.serverHeight,
      width: props.serverWidth
    };
  } else if (isWindow(scrollElement)) {
    var _window = window,
      innerHeight = _window.innerHeight,
      innerWidth = _window.innerWidth;
    return {
      height: typeof innerHeight === 'number' ? innerHeight : 0,
      width: typeof innerWidth === 'number' ? innerWidth : 0
    };
  } else {
    return getBoundingBox(scrollElement);
  }
}

/**
 * Gets the vertical and horizontal position of an element within its scroll container.
 * Elements that have been “scrolled past” return negative values.
 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
 * In this case the body’s top or left position will be a negative number and this element’s top or left will be increased (by that amount).
 */
function getPositionOffset(element /*: Element*/, container /*: Element*/) {
  if (isWindow(container) && document.documentElement) {
    var containerElement = document.documentElement;
    var elementRect = getBoundingBox(element);
    var containerRect = getBoundingBox(containerElement);
    return {
      top: elementRect.top - containerRect.top,
      left: elementRect.left - containerRect.left
    };
  } else {
    var scrollOffset = getScrollOffset(container);
    var _elementRect = getBoundingBox(element);
    var _containerRect = getBoundingBox(container);
    return {
      top: _elementRect.top + scrollOffset.top - _containerRect.top,
      left: _elementRect.left + scrollOffset.left - _containerRect.left
    };
  }
}

/**
 * Gets the vertical and horizontal scroll amount of the element, accounting for IE compatibility
 * and API differences between `window` and other DOM elements.
 */
function getScrollOffset(element /*: Element*/) {
  if (isWindow(element) && document.documentElement) {
    return {
      top: 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop,
      left: 'scrollX' in window ? window.scrollX : document.documentElement.scrollLeft
    };
  } else {
    return {
      top: element.scrollTop,
      left: element.scrollLeft
    };
  }
}
function ownKeys$3(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$3(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
/*:: type Props = {
  /**
   * Function responsible for rendering children.
   * This function should implement the following signature:
   * ({ height, isScrolling, scrollLeft, scrollTop, width }) => PropTypes.element
   *-/
  children: ({
    onChildScroll: ({scrollTop: number}) => void,
    registerChild: (?Element) => void,
    height: number,
    isScrolling: boolean,
    scrollLeft: number,
    scrollTop: number,
    width: number,
  }) => React.Node,

  /** Callback to be invoked on-resize: ({ height, width }) *-/
  onResize: ({height: number, width: number}) => void,

  /** Callback to be invoked on-scroll: ({ scrollLeft, scrollTop }) *-/
  onScroll: ({scrollLeft: number, scrollTop: number}) => void,

  /** Element to attach scroll event listeners. Defaults to window. *-/
  scrollElement: ?(typeof window | Element),
  /**
   * Wait this amount of time after the last scroll event before resetting child `pointer-events`.
   *-/
  scrollingResetTimeInterval: number,

  /** Height used for server-side rendering *-/
  serverHeight: number,

  /** Width used for server-side rendering *-/
  serverWidth: number,

  /** Force scrollTop updates when .updatePosition is called, fixing forced header height change updates *-/
  updateScrollTopOnUpdatePosition?: boolean,
};*/
/*:: type State = {
  height: number,
  width: number,
  isScrolling: boolean,
  scrollLeft: number,
  scrollTop: number,
};*/
/*:: type ResizeHandler = (element: Element, onResize: () => void) => void;*/
/*:: type DetectElementResize = {
  addResizeListener: ResizeHandler,
  removeResizeListener: ResizeHandler,
};*/
/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var IS_SCROLLING_TIMEOUT = 150;
var getWindow = function getWindow() {
  return typeof window !== 'undefined' ? window : undefined;
};
var WindowScroller = /*#__PURE__*/function (_React$PureComponent) {
  function WindowScroller() {
    var _this;
    _classCallCheck(this, WindowScroller);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WindowScroller, [].concat(args));
    _defineProperty(_this, "_window", getWindow());
    _defineProperty(_this, "_isMounted", false);
    _defineProperty(_this, "_positionFromTop", 0);
    _defineProperty(_this, "_positionFromLeft", 0);
    _defineProperty(_this, "_detectElementResize", void 0);
    _defineProperty(_this, "_child", void 0);
    _defineProperty(_this, "_windowScrollerRef", /*#__PURE__*/React.createRef());
    _defineProperty(_this, "state", _objectSpread$3(_objectSpread$3({}, getDimensions(_this.props.scrollElement, _this.props)), {}, {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    }));
    _defineProperty(_this, "_registerChild", function (element) {
      if (element && !(element instanceof Element)) {
        console.warn('WindowScroller registerChild expects to be passed Element or null');
      }
      _this._child = element;
      _this.updatePosition();
    });
    _defineProperty(_this, "_onChildScroll", function (_ref) {
      var scrollTop = _ref.scrollTop;
      if (_this.state.scrollTop === scrollTop) {
        return;
      }
      var scrollElement = _this.props.scrollElement;
      if (scrollElement) {
        if (typeof scrollElement.scrollTo === 'function') {
          scrollElement.scrollTo(0, scrollTop + _this._positionFromTop);
        } else {
          scrollElement.scrollTop = scrollTop + _this._positionFromTop;
        }
      }
    });
    _defineProperty(_this, "_registerResizeListener", function (element) {
      if (element === window) {
        window.addEventListener('resize', _this._onResize, false);
      } else {
        _this._detectElementResize.addResizeListener(element, _this._onResize);
      }
    });
    _defineProperty(_this, "_unregisterResizeListener", function (element) {
      if (element === window) {
        window.removeEventListener('resize', _this._onResize, false);
      } else if (element) {
        _this._detectElementResize.removeResizeListener(element, _this._onResize);
      }
    });
    _defineProperty(_this, "_onResize", function () {
      _this.updatePosition();
    });
    // Referenced by utils/onScroll
    _defineProperty(_this, "__handleWindowScrollEvent", function () {
      if (!_this._isMounted) {
        return;
      }
      var onScroll = _this.props.onScroll;
      var scrollElement = _this.props.scrollElement;
      if (scrollElement) {
        var scrollOffset = getScrollOffset(scrollElement);
        var scrollLeft = Math.max(0, scrollOffset.left - _this._positionFromLeft);
        var scrollTop = Math.max(0, scrollOffset.top - _this._positionFromTop);
        _this.setState({
          isScrolling: true,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });
        onScroll({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });
      }
    });
    // Referenced by utils/onScroll
    _defineProperty(_this, "__resetIsScrolling", function () {
      _this.setState({
        isScrolling: false
      });
    });
    return _this;
  }
  _inherits(WindowScroller, _React$PureComponent);
  return _createClass(WindowScroller, [{
    key: "updatePosition",
    value: function updatePosition() {
      var scrollElement /*: ?Element*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.scrollElement;
      var onResize = this.props.onResize;
      var _this$state = this.state,
        height = _this$state.height,
        width = _this$state.width;
      var thisNode = this._child || this._windowScrollerRef.current;
      if (thisNode instanceof Element && scrollElement) {
        var offset = getPositionOffset(thisNode, scrollElement);
        this._positionFromTop = offset.top;
        this._positionFromLeft = offset.left;
      }
      var dimensions = getDimensions(scrollElement, this.props);
      if (height !== dimensions.height || width !== dimensions.width) {
        this.setState({
          height: dimensions.height,
          width: dimensions.width
        });
        onResize({
          height: dimensions.height,
          width: dimensions.width
        });
      }
      if (this.props.updateScrollTopOnUpdatePosition === true) {
        this.__handleWindowScrollEvent();
        this.__resetIsScrolling();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var scrollElement = this.props.scrollElement;
      this._detectElementResize = createDetectElementResize();
      this.updatePosition(scrollElement);
      if (scrollElement) {
        registerScrollListener(this, scrollElement);
        this._registerResizeListener(scrollElement);
      }
      this._isMounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps /*: Props*/, prevState /*: State*/) {
      var scrollElement = this.props.scrollElement;
      var prevScrollElement = prevProps.scrollElement;
      if (prevScrollElement !== scrollElement && prevScrollElement != null && scrollElement != null) {
        this.updatePosition(scrollElement);
        unregisterScrollListener(this, prevScrollElement);
        registerScrollListener(this, scrollElement);
        this._unregisterResizeListener(prevScrollElement);
        this._registerResizeListener(scrollElement);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var scrollElement = this.props.scrollElement;
      if (scrollElement) {
        unregisterScrollListener(this, scrollElement);
        this._unregisterResizeListener(scrollElement);
      }
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state2 = this.state,
        isScrolling = _this$state2.isScrolling,
        scrollTop = _this$state2.scrollTop,
        scrollLeft = _this$state2.scrollLeft,
        height = _this$state2.height,
        width = _this$state2.width;
      return /*#__PURE__*/React.createElement('div', {
        ref: this._windowScrollerRef
      }, children({
        onChildScroll: this._onChildScroll,
        registerChild: this._registerChild,
        height: height,
        isScrolling: isScrolling,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        width: width
      }));
    }
  }]);
}(React.PureComponent);
_defineProperty(WindowScroller, "defaultProps", {
  onResize: function onResize() {},
  onScroll: function onScroll() {},
  scrollingResetTimeInterval: IS_SCROLLING_TIMEOUT,
  scrollElement: getWindow(),
  serverHeight: 0,
  serverWidth: 0
});
function useItemKey(item) {
  const itemKey = useMemo(() => getFieldKey(item), [item]);
  return itemKey;
}
var $$8 = _export;
var DESCRIPTORS = descriptors;
var global$2 = global$q;
var uncurryThis$4 = functionUncurryThis;
var hasOwn$1 = hasOwnProperty_1;
var isCallable$1 = isCallable$s;
var isPrototypeOf$1 = objectIsPrototypeOf;
var toString$4 = toString$g;
var defineBuiltInAccessor = defineBuiltInAccessor$3;
var copyConstructorProperties = copyConstructorProperties$3;
var NativeSymbol = global$2.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;
if (DESCRIPTORS && isCallable$1(NativeSymbol) && (!('description' in SymbolPrototype) ||
// Safari 12 bug
NativeSymbol().description !== undefined)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString$4(arguments[0]);
    var result = isPrototypeOf$1(SymbolPrototype, this) ? new NativeSymbol(description)
    // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
    : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;
  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = uncurryThis$4(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis$4(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis$4(''.replace);
  var stringSlice$1 = uncurryThis$4(''.slice);
  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn$1(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice$1(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });
  $$8({
    global: true,
    constructor: true,
    forced: true
  }, {
    Symbol: SymbolWrapper
  });
}
const SelectChoices = /*#__PURE__*/React__default.memo(_ref165 => {
  let {
    name,
    choices: _choices = [{
      value: ''
    }],
    addChoice,
    updateChoice,
    deleteChoice
  } = _ref165;
  const inputRefs = useRef([]);
  const handleKeyDown = useCallback((e, index, choice) => {
    if (e.key === 'Backspace' && choice.value === '') {
      e.preventDefault();
      if (index === 0) {
        return;
      }
      deleteChoice(index);
      const newIndex = Math.max(index - 1, 0);
      setTimeout(() => {
        var _a;
        return (_a = inputRefs.current[newIndex]) === null || _a === void 0 ? void 0 : _a.focus();
      }, 0);
    } else if (e.key === 'Enter' && choice.value !== '') {
      addChoice();
      setTimeout(() => {
        var _a;
        return (_a = inputRefs.current[_choices.length]) === null || _a === void 0 ? void 0 : _a.focus();
      }, 0);
    }
  }, [_choices.length, addChoice, deleteChoice]);
  const handleAddChoice = useCallback(() => {
    addChoice();
    setTimeout(() => {
      var _a;
      return (_a = inputRefs.current[_choices.length]) === null || _a === void 0 ? void 0 : _a.focus();
    }, 0);
  }, [addChoice, _choices.length]);
  const choiceItems = useMemo(() => _choices.map((choice, index) => jsx(Layout, {
    children: jsx(TextField, {
      name: "typeChoice-".concat(name, "-").concat(index),
      label: "Type Choice",
      value: choice.value,
      onChange: e => updateChoice(e.target.value, index),
      onKeyDown: e => handleKeyDown(e, index, choice),
      inputRef: el => inputRefs.current[index] = el,
      endIcon: _choices.length > 1 ? 'delete' : undefined,
      endIconOnClick: _choices.length > 1 ? () => deleteChoice(index) : undefined
    })
  }, "choice-".concat(index))), [_choices, name, updateChoice, handleKeyDown, deleteChoice]);
  return jsxs(Layout, {
    stack: true,
    gap: "--Spacing-200",
    children: [choiceItems, jsx(Layout, {
      hAlign: "flex-end",
      children: jsx(Button, {
        endIcon: "add",
        variant: "outlined",
        onClick: handleAddChoice,
        children: "Add"
      })
    })]
  });
});
const AddChoiceList = _ref166 => {
  let {
    item,
    title,
    helperText,
    dataCy
  } = _ref166;
  const {
    updateField
  } = useCustomFields();
  const itemKey = useItemKey(item);
  const addChoice = () => {
    const updatedChoices = item.choices ? [...item.choices, {
      value: ''
    }] : [{
      value: ''
    }];
    updateField(Object.assign(Object.assign({}, item), {
      choices: updatedChoices
    }));
  };
  const deleteChoice = index => {
    const updatedChoices = [...((item === null || item === void 0 ? void 0 : item.choices) || [])];
    updatedChoices.splice(index, 1);
    updateField(Object.assign(Object.assign({}, item), {
      choices: updatedChoices
    }));
  };
  const updateChoice = (value, index) => {
    const updatedChoices = [...((item === null || item === void 0 ? void 0 : item.choices) || [])];
    updatedChoices[index] = Object.assign(Object.assign({}, updatedChoices[index]), {
      value
    });
    updateField(Object.assign(Object.assign({}, item), {
      choices: updatedChoices
    }));
  };
  return jsxs(Layout, {
    stack: true,
    flex: "1",
    children: [jsx(Layout, {
      pb: 32,
      hAlign: "space-between",
      children: jsx(FieldOptionLabel, {
        text: title,
        dataCy: dataCy,
        helperText: helperText
      })
    }), jsx(SelectChoices, {
      name: itemKey,
      choices: item.choices,
      addChoice: addChoice,
      updateChoice: updateChoice,
      deleteChoice: deleteChoice
    })]
  });
};
const FieldTypeSelector = _ref167 => {
  let {
    item
  } = _ref167;
  const {
    updateField
  } = useCustomFields();
  return jsx(Select, {
    disabled: true,
    disableClearable: true,
    helperText: "This Type can not be changed",
    label: "Custom Field Type",
    name: "field-option-type-select",
    onChange: (e, selection) => updateField(Object.assign(Object.assign({}, item), {
      type: selection === null || selection === void 0 ? void 0 : selection.value
    })),
    optionLabel: "label",
    options: Object.entries(fieldTypeMap).map(_ref168 => {
      let [value, {
        displayText
      }] = _ref168;
      return {
        value,
        label: displayText
      };
    }),
    optionValue: "value",
    value: {
      value: item.type,
      label: fieldTypeMap[item.type].displayText
    }
  });
};
const FieldContentFooter = _ref169 => {
  let {
    item,
    index
  } = _ref169;
  const {
    deleteField,
    duplicateField,
    setOpenItem,
    updateField
  } = useCustomFields();
  const deleteCustomField = () => deleteField(item);
  const itemKey = useItemKey(item);
  const {
    open,
    isOpen,
    anchorElement,
    close
  } = useOpenState();
  const duplicate = e => {
    e.stopPropagation();
    const newField = copyCustomField(item);
    duplicateField(newField, item.order + 1);
    setOpenItem(newField._client_id, index);
  };
  return jsxs(Layout, {
    hAlign: "space-between",
    gap: 24,
    vAlign: "center",
    children: [jsx(Checkbox, {
      name: "".concat(item.label, "-required-").concat(itemKey),
      dataCy: "cy-required-field-option-".concat(item.type),
      label: "Required",
      checked: item.isRequired,
      onChange: e => updateField(Object.assign(Object.assign({}, item), {
        isRequired: !item.isRequired
      }))
    }), jsx(Dialog, {
      level: "high",
      open: isOpen,
      title: jsx("div", {
        style: {
          width: 312
        },
        children: jsx(Typography, {
          variant: "headline",
          size: "small",
          children: "Are you sure you want to remove this field?"
        })
      }),
      content: jsx("div", {
        style: {
          width: 312
        },
        children: jsx(Layout, {
          children: jsx(Typography, {
            variant: "body",
            size: "medium",
            color: "on-surface-variant",
            children: "This action is permanent. To undo, select Discard."
          })
        })
      }),
      icon: "error",
      iconColor: "error-container",
      actions: jsxs(Layout, {
        children: [jsx(Button, {
          variant: "text",
          onClick: close,
          fullWidth: true,
          children: "No, Cancel"
        }), jsx(Button, {
          variant: "destructive",
          onClick: deleteCustomField,
          fullWidth: true,
          children: "Remove Field"
        })]
      }),
      onClose: close,
      anchorElement: anchorElement,
      hideBackdrop: true,
      anchorOriginPosition: {
        vertical: 'top',
        horizontal: 'right'
      },
      transformOriginPosition: {
        vertical: 'bottom',
        horizontal: 'right'
      }
    }), jsxs(Layout, {
      children: [jsx(Button, {
        variant: "text",
        onClick: duplicate,
        children: "Duplicate"
      }), jsx(Button, {
        variant: "destructive",
        onClick: open,
        children: "Remove"
      })]
    })]
  });
};
const RadioSelection = _ref170 => {
  let {
    choices,
    type,
    text,
    description,
    onChange,
    value
  } = _ref170;
  return jsxs(Layout, {
    stack: true,
    children: [jsx(FieldOptionLabel, {
      text: text,
      dataCy: "cy-field-options-selection-radio-".concat(type),
      helperText: description
    }), jsx(Layout, {
      gap: "--Spacing-150",
      children: choices.map(choice => jsx(Radio, {
        value: choice.value,
        label: choice.label,
        onChange: onChange,
        checked: value === choice.value
      }, "".concat(choice.value, "-").concat(type)))
    })]
  });
};
const FieldOptionLabel = _ref171 => {
  let {
    text,
    dataCy,
    helperText
  } = _ref171;
  return jsxs(Layout, {
    stack: true,
    gap: 8,
    children: [jsx(Typography, {
      variant: "label",
      size: "large",
      prominent: true,
      dataCy: dataCy,
      children: text
    }), helperText && jsx(Typography, {
      variant: "body",
      size: "small",
      dataCy: dataCy + 'helperText',
      color: "on-surface-variant",
      children: helperText
    })]
  });
};
function withFieldContainer(WrappedComponent) {
  return function WithFieldContainer(props) {
    const {
        hasHelperText = false
      } = props,
      restProps = __rest(props, ["hasHelperText"]);
    const desiredSpace = 40;
    const labelHeight = 20;
    return jsx(Layout, {
      pb: hasHelperText ? desiredSpace - labelHeight : desiredSpace,
      children: jsx(WrappedComponent, Object.assign({}, restProps))
    });
  };
}
const FieldContainer = withFieldContainer(_ref172 => {
  let {
    children
  } = _ref172;
  return children;
});
const useFieldContent = (key, templateType) => {
  const contentType = templateType.toLowerCase();
  return {
    contentType,
    fieldNameProps: {
      name: "fieldLabel-".concat(key),
      label: 'Field Name',
      dataCy: "cy-field-name-".concat(contentType)
    },
    displayDescriptionProps: {
      name: "displayDescription-".concat(key),
      label: 'Display Description',
      dataCy: "cy-display-description-".concat(contentType),
      helperText: 'Describe how people should use this field.'
    },
    placeholderProps: {
      name: "placeholder-".concat(key),
      label: 'Placeholder Text',
      dataCy: "cy-display-placeholder-".concat(contentType),
      helperText: 'Appears within the input field as a hint.'
    }
  };
};
const BaseFieldContent = _ref173 => {
  let {
    item,
    index,
    withPlaceholder: _withPlaceholder = true,
    children
  } = _ref173;
  var _a;
  const itemKey = useItemKey(item);
  const {
    fieldNameProps,
    displayDescriptionProps,
    placeholderProps
  } = useFieldContent(itemKey, item.type);
  const {
    updateField,
    errors,
    removeError,
    category,
    addError,
    focusedItem,
    setFocusedItem
  } = useCustomFields();
  const labelRef = useRef(null);
  const hasLabelError = useMemo(() => {
    var _a;
    return Boolean((_a = errors[itemKey]) === null || _a === void 0 ? void 0 : _a.label);
  }, [errors, itemKey]);
  const shouldAutoFocus = useMemo(() => itemKey === focusedItem, [focusedItem, itemKey]);
  const handleBlur = useCallback((e, path) => {
    if (!e.target.value.trim()) {
      setTimeout(() => addError(itemKey, path, 'Custom Field Label is required.'), 100);
    }
  }, [addError, itemKey]);
  const handleLabelChange = useCallback(e => {
    if (hasLabelError) {
      removeError(itemKey, 'label');
    }
    updateField(Object.assign(Object.assign({}, item), {
      label: e.target.value
    }));
  }, [hasLabelError, itemKey, removeError, updateField, item]);
  useEffect(() => {
    return () => {
      if (itemKey === focusedItem) {
        setFocusedItem('');
      }
    };
    // -- intentionally only running cleanup on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return jsxs("div", {
    children: [jsx(FieldContainer, {
      hasHelperText: true,
      children: jsx(FieldTypeSelector, {
        item: item
      })
    }), jsx(FieldContainer, {
      hasHelperText: hasLabelError,
      children: jsx(TextField, Object.assign({}, fieldNameProps, {
        onChange: handleLabelChange,
        onBlur: e => handleBlur(e, 'label'),
        defaultValue: item.label,
        error: hasLabelError,
        helperText: hasLabelError ? (_a = errors[itemKey]) === null || _a === void 0 ? void 0 : _a.label : '',
        autoFocus: shouldAutoFocus,
        required: true,
        inputRef: labelRef
      }))
    }), jsx(FieldContainer, {
      hasHelperText: true,
      children: jsx(TextField, Object.assign({}, displayDescriptionProps, {
        onChange: e => updateField(Object.assign(Object.assign({}, item), {
          instructions: e.target.value
        })),
        defaultValue: item.instructions
      }))
    }), _withPlaceholder && jsx(FieldContainer, {
      hasHelperText: true,
      children: jsx(TextField, Object.assign({}, placeholderProps, {
        onChange: e => updateField(Object.assign(Object.assign({}, item), {
          placeholderText: e.target.value
        })),
        defaultValue: item.placeholderText
      }))
    }), children, category === 'resource' && jsx(FieldContainer, {
      children: jsx(RadioSelection, {
        choices: [{
          label: 'Yes',
          value: true
        }, {
          label: 'No',
          value: false
        }],
        type: "editable-values",
        text: "Allow Resource to edit",
        description: "If selecting \u201CYes\u201D, the logged in Resource will be able to edit this field from their profile page.",
        onChange: e => updateField(Object.assign(Object.assign({}, item), {
          canResourceEdit: !item.canResourceEdit
        })),
        value: !!item.canResourceEdit
      })
    }), jsx(FieldContentFooter, {
      index: index,
      item: item
    })]
  });
};
var BaseFieldContent$1 = /*#__PURE__*/React__default.memo(BaseFieldContent);
const CheckboxFieldContent = _ref174 => {
  let {
    item,
    index
  } = _ref174;
  const {
    updateField
  } = useCustomFields();
  return jsxs(BaseFieldContent$1, {
    item: item,
    withPlaceholder: false,
    index: index,
    children: [jsx(FieldContainer, {
      children: jsx(AddChoiceList, {
        item: item,
        dataCy: "cy-checkbox-choice-options-add",
        title: "Checkbox Choices",
        helperText: "Enter each choice on a new line."
      })
    }), jsx(FieldContainer, {
      hasHelperText: true,
      children: jsx(RadioSelection, {
        choices: [{
          label: 'Yes',
          value: true
        }, {
          label: 'No',
          value: false
        }],
        type: "multiple-values",
        text: "Sort choices alphabetically?",
        description: "Check the box to sort choices below in alphabetical order",
        onChange: () => updateField(Object.assign(Object.assign({}, item), {
          isChoicesSortedAlphabetically: !item.isChoicesSortedAlphabetically
        })),
        value: !!item.isChoicesSortedAlphabetically
      })
    }), jsx(FieldContainer, {
      hasHelperText: true,
      children: jsx(RadioSelection, {
        choices: [{
          label: 'Yes',
          value: true
        }, {
          label: 'No',
          value: false
        }],
        type: "searchable-values",
        text: "Searchable in Filter?",
        description: "Allow filter to be used as value in Resource search filter on the Scheduler",
        onChange: () => updateField(Object.assign(Object.assign({}, item), {
          filterGrid: !item.filterGrid
        })),
        value: !!item.filterGrid
      })
    })]
  });
};
var CheckboxFieldContent$1 = /*#__PURE__*/React__default.memo(CheckboxFieldContent);
const ColorFieldContent = _ref175 => {
  let {
    item,
    index
  } = _ref175;
  return jsx(BaseFieldContent$1, {
    item: item,
    withPlaceholder: false,
    index: index
  });
};
var ColorFieldContent$1 = /*#__PURE__*/React__default.memo(ColorFieldContent);
const DatePickerContent = _ref176 => {
  let {
    item,
    index
  } = _ref176;
  const {
    updateField
  } = useCustomFields();
  return jsx(BaseFieldContent$1, {
    item: item,
    withPlaceholder: false,
    index: index,
    children: jsx(FieldContainer, {
      hasHelperText: true,
      children: jsx(Select, {
        options: [{
          value: DaysOfWeek.Sunday,
          label: 'Sunday'
        }, {
          value: DaysOfWeek.Monday,
          label: 'Monday'
        }],
        value: {
          value: item.weekStartOn,
          label: getDayName(item.weekStartOn)
        },
        label: "Week starts on:",
        helperText: "Day week starts in date picker",
        onChange: (e, value) => updateField(Object.assign(Object.assign({}, item), {
          weekStartOn: value === null || value === void 0 ? void 0 : value.value
        })),
        name: "field-option-type-select",
        disableClearable: true,
        optionLabel: "label",
        optionValue: "value"
      })
    })
  });
};
var DatePickerContent$1 = /*#__PURE__*/React__default.memo(DatePickerContent);
const DropdownContent = _ref177 => {
  let {
    item,
    index
  } = _ref177;
  const {
    updateField
  } = useCustomFields();
  return jsxs(BaseFieldContent$1, {
    item: item,
    index: index,
    withPlaceholder: true,
    children: [jsx(FieldContainer, {
      children: jsx(RadioSelection, {
        choices: [{
          label: 'Yes',
          value: true
        }, {
          label: 'No',
          value: false
        }],
        type: "multiple-values",
        text: "Sort choices alphabetically?",
        description: "Check the box to sort choices below in alphabetical order",
        onChange: () => updateField(Object.assign(Object.assign({}, item), {
          isChoicesSortedAlphabetically: !item.isChoicesSortedAlphabetically
        })),
        value: !!item.isChoicesSortedAlphabetically
      })
    }), jsx(FieldContainer, {
      children: jsx(AddChoiceList, {
        item: item,
        dataCy: "cy-dropdown-choice-options-add",
        title: "Dropdown Choices",
        helperText: "Enter each choice on a new line.\n"
      })
    }), jsx(FieldContainer, {
      children: jsx(RadioSelection, {
        choices: [{
          label: 'Yes',
          value: true
        }, {
          label: 'No',
          value: false
        }],
        type: "multiple-values",
        text: "Select multiple values?",
        description: "User can pick more than 1 value",
        onChange: () => updateField(Object.assign(Object.assign({}, item), {
          allowMultipleValues: !item.allowMultipleValues
        })),
        value: !!item.allowMultipleValues
      })
    }), jsx(FieldContainer, {
      children: jsx(RadioSelection, {
        choices: [{
          label: 'Yes',
          value: true
        }, {
          label: 'No',
          value: false
        }],
        type: "searchable-values",
        text: "Searchable in Filter?",
        description: "Allow filter to be used as value in Resource search filter on the Scheduler",
        onChange: e => updateField(Object.assign(Object.assign({}, item), {
          filterGrid: !item.filterGrid
        })),
        value: !!item.filterGrid
      })
    })]
  });
};
var DropdownContent$1 = /*#__PURE__*/React__default.memo(DropdownContent);
const EmailFieldContent = _ref178 => {
  let {
    item,
    index
  } = _ref178;
  return jsx(BaseFieldContent$1, {
    item: item,
    index: index
  });
};
var EmailFieldContent$1 = /*#__PURE__*/React__default.memo(EmailFieldContent);
const NumberFieldContent = _ref179 => {
  let {
    item,
    index
  } = _ref179;
  const {
    updateField
  } = useCustomFields();
  return jsxs(BaseFieldContent$1, {
    item: item,
    index: index,
    children: [jsx(FieldContainer, {
      hasHelperText: true,
      children: jsx(NumberInput, {
        name: "characterLimit",
        label: "Character Limit",
        dataCy: "cy-display-char-limit-number-field",
        helperText: "Leave blank for no limit.",
        onChange: (e, value) => {
          if (value !== undefined) {
            return updateField(Object.assign(Object.assign({}, item), {
              characterLimit: Math.abs(value)
            }));
          }
        },
        defaultValue: item.characterLimit,
        min: 0,
        value: Math.abs(+((item === null || item === void 0 ? void 0 : item.characterLimit) || 0))
      })
    }), jsx(FieldContainer, {
      hasHelperText: true,
      children: jsx(NumberInput, {
        name: "minValue",
        label: "Min Value",
        dataCy: "cy-display-min-value-number-field",
        helperText: "Minimum number value",
        onChange: (e, value) => updateField(Object.assign(Object.assign({}, item), {
          minValue: value
        })),
        defaultValue: item.minValue
      })
    }), jsx(FieldContainer, {
      hasHelperText: true,
      children: jsx(NumberInput, {
        name: "maxValue",
        label: "Max Value",
        dataCy: "cy-display-max-value-number-field",
        helperText: "Maximum number value",
        onChange: (e, value) => updateField(Object.assign(Object.assign({}, item), {
          maxValue: value
        })),
        defaultValue: item.maxValue
      })
    }), jsx(FieldContainer, {
      hasHelperText: true,
      children: jsx(NumberInput, {
        name: "stepValue",
        label: "Step Value",
        dataCy: "cy-display-step-value-number-field",
        helperText: "Step of numbers",
        onChange: (e, value) => updateField(Object.assign(Object.assign({}, item), {
          stepValue: value
        })),
        defaultValue: item.stepValue
      })
    })]
  });
};
var NumberFieldContent$1 = /*#__PURE__*/React__default.memo(NumberFieldContent);
const RadioFieldContent = _ref180 => {
  let {
    item,
    index
  } = _ref180;
  const {
    updateField
  } = useCustomFields();
  return jsxs(BaseFieldContent$1, {
    item: item,
    withPlaceholder: false,
    index: index,
    children: [jsx(FieldContainer, {
      children: jsx(AddChoiceList, {
        item: item,
        dataCy: "cy-radio-choice-options-add",
        title: "Radio Choices",
        helperText: "Enter each choice on a new line.\n"
      })
    }), jsx(FieldContainer, {
      hasHelperText: true,
      children: jsx(RadioSelection, {
        choices: [{
          label: 'Yes',
          value: true
        }, {
          label: 'No',
          value: false
        }],
        type: "multiple-values",
        text: "Sort choices alphabetically?",
        description: "Check the box to sort choices below in alphabetical order",
        onChange: () => updateField(Object.assign(Object.assign({}, item), {
          isChoicesSortedAlphabetically: !item.isChoicesSortedAlphabetically
        })),
        value: !!item.isChoicesSortedAlphabetically
      })
    }), jsx(FieldContainer, {
      hasHelperText: true,
      children: jsx(RadioSelection, {
        choices: [{
          label: 'Yes',
          value: true
        }, {
          label: 'No',
          value: false
        }],
        type: "searchable-values",
        text: "Searchable in Filter?",
        description: "Allow filter to be used as value in Resource search filter on the Scheduler",
        onChange: () => updateField(Object.assign(Object.assign({}, item), {
          filterGrid: !item.filterGrid
        })),
        value: !!item.filterGrid
      })
    })]
  });
};
var RadioFieldContent$1 = /*#__PURE__*/React__default.memo(RadioFieldContent);
const TextContent = _ref181 => {
  let {
    item,
    index
  } = _ref181;
  const {
    updateField
  } = useCustomFields();
  return jsx(BaseFieldContent$1, {
    item: item,
    index: index,
    children: jsx(FieldContainer, {
      hasHelperText: true,
      children: jsx(NumberInput, {
        name: "characterLimit",
        label: "Character Limit",
        dataCy: "cy-display-char-limit-".concat(item.type.toLowerCase()),
        helperText: "Leave blank for no limit.",
        value: Math.abs(+((item === null || item === void 0 ? void 0 : item.characterLimit) || 0)),
        onChange: (e, value) => {
          if (value !== undefined) {
            return updateField(Object.assign(Object.assign({}, item), {
              characterLimit: Math.abs(value)
            }));
          }
        },
        min: 0
      })
    })
  });
};
var TextContent$1 = /*#__PURE__*/React__default.memo(TextContent);
const ContentComponent = /*#__PURE__*/React__default.memo(_ref182 => {
  let {
    item,
    index
  } = _ref182;
  const itemKey = useItemKey(item);
  switch (item.type) {
    case TemplateType.CHECKBOX:
      return jsx(CheckboxFieldContent$1, {
        index: index,
        item: item
      }, "".concat(itemKey, "-checkbox"));
    case TemplateType.COLOR:
      return jsx(ColorFieldContent$1, {
        index: index,
        item: item
      }, "".concat(itemKey, "-color"));
    case TemplateType.EMAIL:
      return jsx(EmailFieldContent$1, {
        index: index,
        item: item
      }, "".concat(itemKey, "-email"));
    case TemplateType.RADIO:
      return jsx(RadioFieldContent$1, {
        index: index,
        item: item
      }, "".concat(itemKey, "-radio"));
    case TemplateType.TEXT:
      return jsx(TextContent$1, {
        index: index,
        item: item
      }, "".concat(itemKey, "-text"));
    case TemplateType.TEXTAREA:
      return jsx(TextContent$1, {
        index: index,
        item: item
      }, "".concat(itemKey, "-textarea"));
    case TemplateType.NUMBER:
      return jsx(NumberFieldContent$1, {
        index: index,
        item: item
      }, "".concat(itemKey, "-number"));
    case TemplateType.SELECT:
      return jsx(DropdownContent$1, {
        index: index,
        item: item
      }, "".concat(itemKey, "-select"));
    case TemplateType.DATE:
      return jsx(DatePickerContent$1, {
        index: index,
        item: item
      }, "".concat(itemKey, "-date"));
    default:
      return jsx("div", {
        children: "No content for the given template type."
      });
  }
});
var _path$3, _path2$2, _path3$2;
var _excluded$4 = ["title", "titleId"];
function _extends$4() {
  return _extends$4 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4.apply(null, arguments);
}
function _objectWithoutProperties$3(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$4(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$4(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgNoContentArrowBottom = function SvgNoContentArrowBottom(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$3(_ref, _excluded$4);
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 49,
    viewBox: "0 0 45 49",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9853 20.336C20.9853 20.336 31.1286 20.7934 40.778 37.6215",
    stroke: "#6DDBA6",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7763 25.0642C13.7763 25.0642 14.695 39.1045 12.4282 44.3781",
    stroke: "#6DDBA6",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path3$2 || (_path3$2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.135 9.9989C23.135 9.9989 30.3315 12.5672 38.9273 7.01711",
    stroke: "#6DDBA6",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
};
var ForwardRef$3 = /*#__PURE__*/forwardRef(SvgNoContentArrowBottom);
var _path$2, _path2$1, _path3$1;
var _excluded$3 = ["title", "titleId"];
function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3.apply(null, arguments);
}
function _objectWithoutProperties$2(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$3(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$3(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgNoContentArrowTop = function SvgNoContentArrowTop(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$2(_ref, _excluded$3);
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 51,
    viewBox: "0 0 47 51",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2787 31.1622C24.2787 31.1622 15.6258 21.9982 7.83348 20.2031",
    stroke: "#6DDBA6",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0384 28.898C33.0384 28.898 35.3528 8.60413 38.9223 4.1389",
    stroke: "#6DDBA6",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3098 42.3291C20.3098 42.3291 7.05939 40.0542 4.24497 41.874",
    stroke: "#6DDBA6",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
};
var ForwardRef$2 = /*#__PURE__*/forwardRef(SvgNoContentArrowTop);
const NoContentArrowTop = /*#__PURE__*/styled(ForwardRef$2).withConfig({
  displayName: "styled__NoContentArrowTop",
  componentId: "sc-6hpglp-0"
})(["position:absolute;top:-32px;left:-36px;"]);
const NoContentArrowBottom = /*#__PURE__*/styled(ForwardRef$3).withConfig({
  displayName: "styled__NoContentArrowBottom",
  componentId: "sc-6hpglp-1"
})(["position:absolute;bottom:-31px;right:-28px;"]);
function getDragStyles(_ref183) {
  let {
    isDragging,
    withSpace,
    isAbove,
    preview,
    isFirst
  } = _ref183;
  if (preview) {
    return "";
  }
  if (!withSpace && isDragging) {
    return css(["padding-top:24px;padding-bottom:24px;opacity:0.1;"]);
  }
  if (withSpace && isDragging) {
    return css(["padding-top:", "px;padding-bottom:", "px;"], isAbove ? 80 : 0, isAbove ? 16 : 80);
  }
  return '';
}
const DraggableItemWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__DraggableItemWrapper",
  componentId: "sc-6hpglp-2"
})(["padding-bottom:16px;transition:padding 0.3s ease;flex:1;cursor:grab;&:active{cursor:grabbing;}", ";"], props => getDragStyles(props));
const DraggableItem$2 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__DraggableItem",
  componentId: "sc-6hpglp-3"
})(["width:100%;padding:8px 8px 8px 16px;background-color:", ";transform:translate3d(0,0,0);border-radius:8px;position:relative;transition:opacity 0.3s ease;"], _ref184 => {
  let {
    theme
  } = _ref184;
  return theme.designTokens.color.color.surfaces['surface-container-high'].value;
});
const ContentWrapper$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__ContentWrapper",
  componentId: "sc-6hpglp-4"
})(["padding-top:", ";padding-bottom:", ";padding-left:54px;padding-right:54px;overflow-y:scroll;"], _ref185 => {
  let {
    open
  } = _ref185;
  return open ? '40px' : '0px';
}, _ref186 => {
  let {
    open
  } = _ref186;
  return open ? '28px' : '0px';
});
const DraggableItemBar = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__DraggableItemBar",
  componentId: "sc-6hpglp-5"
})(["display:flex;justify-content:space-between;align-items:center;align-self:stretch;"]);
const GrabCursorContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__GrabCursorContainer",
  componentId: "sc-6hpglp-6"
})(["cursor:grab;"]);
const PointerContainer$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__PointerContainer",
  componentId: "sc-6hpglp-7"
})(["cursor:grab;height:24px;"]);
const AnimatedChevron = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__AnimatedChevron",
  componentId: "sc-6hpglp-8"
})(["cursor:pointer;transition:transform 100ms ease-in-out;transform:", ";"], _ref187 => {
  let {
    open
  } = _ref187;
  return open ? 'rotate(180deg)' : 'rotate(0deg)';
});
const PreviewDraggableItem = /*#__PURE__*/styled(DraggableItem$2).attrs({
  preview: true
}).withConfig({
  displayName: "styled__PreviewDraggableItem",
  componentId: "sc-6hpglp-9"
})(["box-shadow:", ";position:relative;z-index:", ";cursor:default;"], _ref188 => {
  let {
    hasShadow,
    theme
  } = _ref188;
  return hasShadow && theme.shadows[3];
}, _ref189 => {
  let {
    hasShadow
  } = _ref189;
  return hasShadow && 99;
});
const PreviewLine = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__PreviewLine",
  componentId: "sc-6hpglp-10"
})(["width:70%;border-style:solid;border-radius:4px;border-width:2px;border-color:", ";"], props => props.theme.designTokens.color['on color'].surface['on-surface'].value);
const CustomBorder = "url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23333' stroke-width='4' stroke-dasharray='4%2c 14' stroke-dashoffset='8' stroke-linecap='round'/%3e%3c/svg%3e\");";
const DropItemPreview = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__DropItemPreview",
  componentId: "sc-6hpglp-11"
})(["background-image:", ";border-radius:8px;height:35px;"], CustomBorder);
const DraggableItemPreview = () => {
  return jsx("div", {
    style: {
      position: 'relative'
    },
    children: jsxs(Layout, {
      stack: true,
      gap: "--Spacing-200",
      vAlign: "center",
      children: [jsxs(PreviewDraggableItem, {
        hasShadow: true,
        children: [jsx("div", {
          style: {
            opacity: 0.4
          },
          children: jsxs(Layout, {
            vAlign: "center",
            children: [jsx(Dot, {
              size: 19,
              color: "on-surface"
            }), jsx(Layout, {
              pl: "--Spacing-200",
              flex: "1",
              children: jsx(PreviewLine, {})
            })]
          })
        }), jsx(NoContentArrowTop, {}), jsx(NoContentArrowBottom, {})]
      }), jsx(PreviewDraggableItem, {
        children: jsx("div", {
          style: {
            opacity: 0.4
          },
          children: jsxs(Layout, {
            vAlign: "center",
            children: [jsx(Dot, {
              size: 19,
              color: "on-surface"
            }), jsx(Layout, {
              pl: "--Spacing-200",
              flex: "1",
              children: jsx(PreviewLine, {})
            })]
          })
        })
      }), jsx(PreviewDraggableItem, {
        children: jsx("div", {
          style: {
            opacity: 0.4
          },
          children: jsxs(Layout, {
            vAlign: "center",
            children: [jsx(Dot, {
              size: 19,
              color: "on-surface"
            }), jsx(Layout, {
              pl: "--Spacing-200",
              flex: "1",
              children: jsx(PreviewLine, {})
            })]
          })
        })
      }), jsx(DropItemPreview, {})]
    })
  });
};
const DragItem = _ref190 => {
  let {
    onDragOver,
    onDragStart,
    onDrop,
    handleRemoveField,
    handleDragEnd,
    handleMoveField,
    item,
    index,
    isDragging,
    withSpace,
    Wrapper
  } = _ref190;
  const {
    openItem,
    setOpenItem,
    addFieldRef,
    deleteField,
    errors,
    duplicateField,
    category,
    isEdited,
    isCFGExtensionInstalled
  } = useCustomFields();
  const {
    openCopyMoveModal
  } = useCustomFieldGroups();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const moreRef = useRef(null);
  const itemKey = useItemKey(item);
  const isItemOpen = useMemo(() => itemKey === openItem, [itemKey, openItem]);
  const closeMenu = useCallback(cb => {
    setIsMenuOpen(false);
    if (cb) {
      cb();
    }
  }, []);
  const menuOptions = useMemo(() => {
    const baseOptions = [{
      label: 'Move to Top',
      onClick: e => {
        e.stopPropagation();
        closeMenu();
        handleMoveField('toTop', index);
      }
    }, {
      label: 'Move to Bottom',
      onClick: e => {
        e.stopPropagation();
        closeMenu();
        handleMoveField('toBottom', index);
      }
    }, {
      label: 'Move Up',
      onClick: e => {
        e.stopPropagation();
        closeMenu();
        handleMoveField('up', index);
      }
    }, {
      label: 'Move Down',
      onClick: e => {
        e.stopPropagation();
        closeMenu();
        handleMoveField('down', index);
      }
    }, {
      divider: true
    }];
    const conditionalOptions = !Wrapper && isCFGExtensionInstalled ? [{
      label: 'Move To',
      disabled: isEdited,
      onClick: e => {
        e.stopPropagation();
        closeMenu();
        openCopyMoveModal('move', item._id);
      }
    }, {
      label: 'Copy To',
      disabled: isEdited,
      onClick: e => {
        e.stopPropagation();
        closeMenu();
        openCopyMoveModal('copy', item._id);
      }
    }, {
      divider: true
    }] : [];
    const endOptions = [{
      label: 'Duplicate Field',
      onClick: e => {
        e.stopPropagation();
        closeMenu();
        const newField = copyCustomField(item);
        duplicateField(newField, item.order + 1);
        setOpenItem(newField._client_id, index);
      }
    }, {
      label: 'Remove Field',
      onClick: e => {
        e.stopPropagation();
        closeMenu();
        deleteField(item);
      }
    }];
    return [...baseOptions, ...conditionalOptions, ...endOptions];
  }, [closeMenu, handleMoveField, deleteField, item, index, setOpenItem, duplicateField, openCopyMoveModal, isEdited, isCFGExtensionInstalled, Wrapper]);
  const hasError = useMemo(() => Boolean(errors[itemKey]), [errors, itemKey]);
  const [isAbove, setIsAbove] = useState(false);
  const handleDragOver = useCallback(e => {
    if (index === 0) {
      const newIsAbove = e.nativeEvent.offsetY < 22;
      setIsAbove(newIsAbove);
    }
    onDragOver(e);
  }, [index, onDragOver]);
  if (Wrapper !== undefined) {
    return jsx(DraggableItemWrapper, {
      isDragging: isDragging,
      withSpace: withSpace,
      isAbove: isAbove,
      isFirst: index === 0,
      open: isItemOpen,
      ref: ref => addFieldRef(ref, itemKey),
      className: item._client_id,
      "data-cy": "draggable-custom-field",
      children: jsx(Wrapper, {
        item: item,
        category: category,
        onDragStart: e => onDragStart(e, item),
        onDragOver: e => {
          handleDragOver(e);
        },
        onDrop: e => onDrop(e, index),
        handleDragEnd: e => handleDragEnd(e),
        index: index,
        children: jsxs(DraggableItem$2, {
          draggable: !isItemOpen,
          onDragStart: e => onDragStart(e, item),
          onDragOver: e => {
            handleDragOver(e);
          },
          onDrop: e => onDrop(e, index),
          onDragEnd: e => {
            handleDragEnd(e);
          },
          open: isItemOpen,
          isDragging: isDragging,
          withSpace: withSpace,
          isAbove: isAbove,
          isFirst: index === 0,
          children: [jsxs(DraggableItemBar, {
            onClick: e => {
              e.preventDefault();
              e.stopPropagation();
              const target = e.target;
              const isMenuItemClick = typeof target.className === 'string' && target.className.includes('menu-item');
              if (isMenuItemClick) {
                return;
              }
              return setOpenItem(isItemOpen ? '' : itemKey, index);
            },
            children: [jsxs(Layout, {
              vAlign: "center",
              children: [jsx(Layout, {
                pr: 16,
                children: hasError ? jsx(Icon, {
                  name: "error",
                  color: "error",
                  size: 24
                }) : jsx(GrabCursorContainer, {
                  children: jsx(Icon, {
                    name: "dragIndicator",
                    size: 24
                  })
                })
              }), jsx(Layout, {
                pr: 8,
                children: jsx(Icon, {
                  name: fieldTypeMap[item.type].icon,
                  size: 24
                })
              }), jsx(Layout, {
                stack: true,
                children: jsx(Typography, {
                  variant: "label",
                  size: "large",
                  weight: 500,
                  children: item.label || fieldTypeMap[item.type].displayText
                })
              })]
            }), jsxs(Layout, {
              vAlign: "center",
              gap: "--Spacing-100",
              children: [item.isRequired && jsx(Tooltip, {
                interactive: true,
                title: jsx(Typography, {
                  children: "This custom field is mandatory."
                }),
                children: jsx(Tag, {
                  title: "Required"
                })
              }), item.filterGrid && jsx(Icon, {
                name: "mystery",
                size: 16,
                color: "outline"
              }), jsxs(Layout, {
                children: [jsx(Menu, {
                  isOpen: isMenuOpen,
                  anchorElement: moreRef.current,
                  onClose: () => setIsMenuOpen(false),
                  anchorOrigins: {
                    vertical: 'top',
                    horizontal: 'left'
                  },
                  transformOrigins: {
                    vertical: 'top',
                    horizontal: 'right'
                  },
                  options: menuOptions,
                  density: -4
                }), jsx(PointerContainer$1, {
                  ref: moreRef,
                  onClick: e => {
                    e.stopPropagation();
                    setIsMenuOpen(true);
                  },
                  children: jsx(Icon, {
                    name: "more",
                    size: 24
                  })
                })]
              }), jsx(AnimatedChevron, {
                open: isItemOpen,
                onClick: e => {
                  e.stopPropagation();
                  setOpenItem(itemKey, index);
                },
                children: jsx(Icon, {
                  name: "chevronDown",
                  size: 24
                })
              })]
            })]
          }), jsx(ContentWrapper$1, {
            open: isItemOpen,
            children: isItemOpen && jsx(ContentComponent, {
              item: item,
              index: index
            })
          })]
        })
      }, "drag-item-wrapper-".concat(index))
    }, itemKey);
  }
  return jsx(DraggableItemWrapper, {
    isDragging: isDragging,
    withSpace: withSpace,
    isAbove: isAbove,
    isFirst: index === 0,
    open: isItemOpen,
    ref: ref => addFieldRef(ref, itemKey),
    className: item._client_id,
    "data-cy": "draggable-custom-field-with-wrapper",
    children: jsxs(DraggableItem$2, {
      draggable: !isItemOpen,
      onDragStart: e => onDragStart(e, item),
      onDragOver: e => {
        handleDragOver(e);
      },
      onDrop: e => onDrop(e, index),
      onDragEnd: e => {
        handleDragEnd(e);
      },
      open: isItemOpen,
      isDragging: isDragging,
      withSpace: withSpace,
      isAbove: isAbove,
      isFirst: index === 0,
      children: [jsxs(DraggableItemBar, {
        onClick: e => {
          e.preventDefault();
          e.stopPropagation();
          const target = e.target;
          const isMenuItemClick = typeof target.className === 'string' && target.className.includes('menu-item');
          if (isMenuItemClick) {
            return;
          }
          return setOpenItem(isItemOpen ? '' : itemKey, index);
        },
        children: [jsxs(Layout, {
          vAlign: "center",
          children: [jsx(Layout, {
            pr: 16,
            children: hasError ? jsx(Icon, {
              name: "error",
              color: "error",
              size: 24
            }) : jsx(GrabCursorContainer, {
              children: jsx(Icon, {
                name: "dragIndicator",
                size: 24
              })
            })
          }), jsx(Layout, {
            pr: 8,
            children: jsx(Icon, {
              name: fieldTypeMap[item.type].icon,
              size: 24
            })
          }), jsx(Layout, {
            stack: true,
            children: jsx(Typography, {
              variant: "label",
              size: "large",
              weight: 500,
              children: item.label || fieldTypeMap[item.type].displayText
            })
          })]
        }), jsxs(Layout, {
          vAlign: "center",
          gap: "--Spacing-100",
          children: [item.isRequired && jsx(Tooltip, {
            interactive: true,
            title: jsx(Typography, {
              children: "This custom field is mandatory."
            }),
            children: jsx(Tag, {
              title: "Required"
            })
          }), Boolean(item.filterGrid) && jsx(Icon, {
            name: "mystery",
            size: 16,
            color: "outline"
          }), jsxs(Layout, {
            children: [jsx(Menu, {
              isOpen: isMenuOpen,
              anchorElement: moreRef.current,
              onClose: () => setIsMenuOpen(false),
              anchorOrigins: {
                vertical: 'top',
                horizontal: 'left'
              },
              transformOrigins: {
                vertical: 'top',
                horizontal: 'right'
              },
              options: menuOptions,
              density: -4
            }), jsx(PointerContainer$1, {
              ref: moreRef,
              onClick: e => {
                e.stopPropagation();
                setIsMenuOpen(true);
              },
              children: jsx(Icon, {
                name: "more",
                size: 24
              })
            })]
          }), jsx(AnimatedChevron, {
            open: isItemOpen,
            onClick: () => setOpenItem(itemKey, index),
            children: jsx(Icon, {
              name: "chevronDown",
              size: 24
            })
          })]
        })]
      }), jsx(ContentWrapper$1, {
        open: isItemOpen,
        children: isItemOpen && jsx(ContentComponent, {
          item: item,
          index: index
        })
      })]
    })
  }, itemKey);
};
const DraggableItem$1 = /*#__PURE__*/React__default.memo(DragItem);
const fieldTypeMap = {
  [TemplateType.CHECKBOX]: {
    icon: 'check_box',
    label: 'checkbox',
    displayText: 'Checkbox'
  },
  [TemplateType.COLOR]: {
    icon: 'colors',
    label: 'color',
    displayText: 'Color'
  },
  [TemplateType.DATE]: {
    icon: 'today',
    label: 'date',
    displayText: 'Date Picker'
  },
  [TemplateType.EMAIL]: {
    icon: 'mail_outline',
    label: 'email',
    displayText: 'Email'
  },
  [TemplateType.NUMBER]: {
    icon: 'pin',
    label: 'number',
    displayText: 'Number'
  },
  [TemplateType.RADIO]: {
    icon: 'radio_button_checked',
    label: 'radio',
    displayText: 'Radio Button'
  },
  [TemplateType.SELECT]: {
    icon: 'drop_down',
    label: 'select',
    displayText: 'Dropdown'
  },
  [TemplateType.TEXT]: {
    icon: 'format_size',
    label: 'text',
    displayText: 'Text Field'
  },
  [TemplateType.TEXTAREA]: {
    icon: 'textAd',
    label: 'textarea',
    displayText: 'Text Area'
  }
};
const Container$5 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__Container",
  componentId: "zegc8k-0"
})(["flex:1;min-height:0;height:100%;background-color:", ";padding-right:", "px;box-sizing:content-box;overflow-y:", ";"], props => props.theme.designTokens.color.color.surfaces['surface-container'].value, props => props.theme.designSpacing['--Spacing-100'], props => props.isVirtual ? 'initial' : 'scroll');
const StickyHeader$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__StickyHeader",
  componentId: "zegc8k-1"
})(["position:sticky;background-color:", ";border-bottom:", ";user-select:none;"], props => props.theme.designTokens.color.color.surfaces['surface-container'].value, _ref191 => {
  let {
    withBorder
  } = _ref191;
  return withBorder && '1px solid #bdcac0';
});
const ResourcesHeader$1 = /*#__PURE__*/styled(StickyHeader$1).withConfig({
  displayName: "styled__ResourcesHeader",
  componentId: "zegc8k-2"
})([""]);
const GroupsHeader$1 = /*#__PURE__*/styled(StickyHeader$1).withConfig({
  displayName: "styled__GroupsHeader",
  componentId: "zegc8k-3"
})([""]);
const SelectItem$1 = _ref192 => {
  let {
    label,
    selected,
    selectAll,
    onClick,
    cfType,
    disabled
  } = _ref192;
  return jsx(Layout, {
    pr: "--Spacing-50",
    children: jsxs(Layout, {
      pl: selectAll ? 0 : 40,
      vAlign: "center",
      gap: "--Spacing-100",
      flex: "1",
      children: [jsx(Checkbox, {
        name: label,
        checked: selected,
        onChange: onClick,
        onClick: onClick,
        disabled: disabled,
        label: jsx(Typography, {
          variant: "label",
          size: "medium",
          prominent: true,
          color: "on-surface-variant",
          children: label
        })
      }), cfType && jsx(Icon, {
        name: fieldTypeMap[cfType].icon
      })]
    })
  });
};
const pluralize$1 = (string, number) => number > 1 || number === 0 ? "".concat(string, "s") : string;
const MoveCopyModal = _ref193 => {
  let {
    customFieldsToChange,
    targetCFGs,
    action,
    toggleTargetCFG,
    toggleCustomField,
    areAllTargetCFGsSelected,
    areAllCustomFieldsSelected,
    toggleAllCustomFields,
    toggleAllTargetCFGs,
    filterItems
  } = _ref193;
  const containerRef = useRef(null);
  const {
    state
  } = useCustomFields();
  const {
    customFieldGroups,
    selectedGroup
  } = useCustomFieldGroups();
  const cfgsWithoutSelected = useMemo(() => customFieldGroups.filter(cfg => cfg._id !== selectedGroup._id), [customFieldGroups, selectedGroup._id]);
  const filteredCustomFields = useMemo(() => filterItems(state.customFields, customFieldsToChange), [state.customFields, customFieldsToChange, filterItems]);
  const filteredCustomFieldIds = useMemo(() => filteredCustomFields.map(cf => cf._id), [filteredCustomFields]);
  const filteredCustomFieldGroups = useMemo(() => filterItems(cfgsWithoutSelected, targetCFGs), [cfgsWithoutSelected, targetCFGs, filterItems]);
  const filteredCustomFieldGroupIds = useMemo(() => filteredCustomFieldGroups.map(cfg => cfg._id), [filteredCustomFieldGroups]);
  const allCustomFieldsSelected = useMemo(() => filteredCustomFieldIds.length > 0 && areAllCustomFieldsSelected(filteredCustomFieldIds), [areAllCustomFieldsSelected, filteredCustomFieldIds]);
  const allTargetsSelected = useMemo(() => filteredCustomFieldGroupIds.length > 0 && areAllTargetCFGsSelected(filteredCustomFieldGroupIds), [areAllTargetCFGsSelected, filteredCustomFieldGroupIds]);
  const selectedFieldsCount = customFieldsToChange.length;
  const selectedGroupsCount = targetCFGs.length;
  const CustomFieldsList = useMemo(() => {
    const renderCf = cf => jsx(SelectItem$1, {
      label: cf.label,
      onClick: () => toggleCustomField(cf._id),
      selected: customFieldsToChange.includes(cf._id),
      cfType: cf.type
    }, cf._id);
    if (state.customFields.length > 100) {
      return jsx(AutoSizer, {
        children: _ref194 => {
          let {
            height,
            width
          } = _ref194;
          return jsx($r, {
            style: {
              height,
              width
            },
            totalCount: filteredCustomFields.length,
            itemContent: index => renderCf(filteredCustomFields[index]),
            overscan: 20
          });
        }
      });
    }
    return filteredCustomFields.map(renderCf);
  }, [state.customFields, customFieldsToChange, toggleCustomField, filteredCustomFields]);
  const CustomFieldGroupsList = useMemo(() => {
    const renderCfg = cfg => jsx(SelectItem$1, {
      label: cfg.name,
      onClick: () => toggleTargetCFG(cfg._id),
      selected: targetCFGs.includes(cfg._id)
    }, cfg._id);
    if (cfgsWithoutSelected.length > 100) {
      return jsx(AutoSizer, {
        children: _ref195 => {
          let {
            height,
            width
          } = _ref195;
          return jsx($r, {
            style: {
              height,
              width,
              paddingRight: 8
            },
            totalCount: cfgsWithoutSelected.length,
            itemContent: index => renderCfg(cfgsWithoutSelected[index]),
            overscan: 20
          });
        }
      });
    }
    return filteredCustomFieldGroups.map(renderCfg);
  }, [cfgsWithoutSelected, targetCFGs, toggleTargetCFG, filteredCustomFieldGroups]);
  return jsxs(Layout, {
    gap: "--Spacing-300",
    stretch: true,
    children: [jsx(Layout, {
      stack: true,
      stretch: true,
      fullHeight: true,
      gap: "--Spacing-300",
      children: jsxs(Layout, {
        stack: true,
        stretch: true,
        children: [jsx(GroupsHeader$1, {
          withBorder: true,
          children: jsxs(Layout, {
            pt: "--Spacing-100",
            pb: "--Spacing-100",
            gap: "--Spacing-150",
            vAlign: "center",
            children: [jsx(Icon, {
              name: "edit",
              size: 24,
              color: "on-surface-variant"
            }), jsxs(Layout, {
              stack: true,
              children: [jsx(Typography, {
                variant: "label",
                size: "large",
                prominent: true,
                children: "Custom Fields"
              }), jsxs(Typography, {
                variant: "body",
                size: "medium",
                color: "on-surface-variant",
                children: [selectedFieldsCount, " ", pluralize$1('Field', selectedFieldsCount), " Selected"]
              })]
            })]
          })
        }), jsx(Container$5, {
          isVirtual: state.customFields.length > 100,
          children: jsxs(Layout, {
            pl: "--Spacing-200",
            pt: "--Spacing-100",
            stack: true,
            fullHeight: true,
            children: [jsx(SelectItem$1, {
              label: "Select All",
              selected: allCustomFieldsSelected,
              selectAll: true,
              onClick: () => toggleAllCustomFields(filteredCustomFieldIds)
            }), jsx(Layout, {
              stack: true,
              fullHeight: true,
              children: CustomFieldsList
            })]
          })
        })]
      })
    }), jsx(Layout, {
      stack: true,
      stretch: true,
      fullHeight: true,
      gap: "--Spacing-300",
      children: jsxs(Layout, {
        stack: true,
        stretch: true,
        fullHeight: true,
        children: [jsx(ResourcesHeader$1, {
          withBorder: true,
          children: jsx(Layout, {
            pt: "--Spacing-100",
            pb: "--Spacing-100",
            gap: "--Spacing-150",
            vAlign: "center",
            flex: "1",
            children: jsxs(Layout, {
              gap: "--Spacing-150",
              vAlign: "center",
              children: [jsx(Icon, {
                name: "folder",
                size: 24,
                color: "on-surface-variant"
              }), jsxs(Layout, {
                stack: true,
                children: [jsx(Typography, {
                  variant: "label",
                  size: "large",
                  prominent: true,
                  children: "Custom Field Groups"
                }), jsxs(Typography, {
                  variant: "body",
                  size: "medium",
                  color: "on-surface-variant",
                  children: [selectedGroupsCount, " ", pluralize$1('Group', selectedGroupsCount), " Selected"]
                })]
              })]
            })
          })
        }), jsx(Container$5, {
          ref: containerRef,
          isVirtual: cfgsWithoutSelected.length > 100,
          children: jsxs(Layout, {
            pl: "--Spacing-200",
            pt: "--Spacing-100",
            stack: true,
            fullHeight: true,
            children: [jsx(SelectItem$1, {
              label: "Select All",
              selected: allTargetsSelected,
              selectAll: true,
              disabled: action === 'move',
              onClick: () => toggleAllTargetCFGs(filteredCustomFieldGroupIds)
            }), jsx(Layout, {
              stack: true,
              fullHeight: true,
              children: CustomFieldGroupsList
            })]
          })
        })]
      })
    })]
  });
};
const Container$4 = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__Container",
  componentId: "bo1obt-0"
})(["flex:1;min-height:0;height:100%;background-color:", ";padding-right:", "px;box-sizing:content-box;overflow-y:", ";"], props => props.theme.designTokens.color.color.surfaces['surface-container'].value, props => props.theme.designSpacing['--Spacing-100'], props => props.isVirtual ? 'initial' : 'scroll');
const StickyHeader = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__StickyHeader",
  componentId: "bo1obt-1"
})(["position:sticky;background-color:", ";border-bottom:", ";user-select:none;"], props => props.theme.designTokens.color.color.surfaces['surface-container'].value, _ref196 => {
  let {
    withBorder
  } = _ref196;
  return withBorder && '1px solid #bdcac0';
});
const ResourcesHeader = /*#__PURE__*/styled(StickyHeader).withConfig({
  displayName: "styled__ResourcesHeader",
  componentId: "bo1obt-2"
})([""]);
const GroupsHeader = /*#__PURE__*/styled(StickyHeader).withConfig({
  displayName: "styled__GroupsHeader",
  componentId: "bo1obt-3"
})([""]);
const SelectItem = _ref197 => {
  let {
    label,
    selected,
    selectAll,
    onClick,
    dataCy
  } = _ref197;
  return jsx(Layout, {
    pr: "--Spacing-50",
    children: jsx(Layout, {
      pl: selectAll ? 0 : 40,
      children: jsx(Checkbox, {
        name: label,
        checked: selected,
        onChange: onClick,
        onClick: onClick,
        label: jsx(Typography, {
          variant: "label",
          size: "medium",
          prominent: true,
          color: "on-surface-variant",
          children: label
        }),
        dataCy: dataCy
      })
    })
  });
};
const pluralize = (string, number) => number > 1 || number === 0 ? "".concat(string, "s") : string;
const ScrollableContainer = () => {
  const {
    items,
    groups,
    resources: entities,
    selectedGroup,
    handleSelectResource,
    handleSelectGroup,
    handleSelectAllResources,
    handleSelectAllGroups,
    allResourcesSelected,
    allGroupsSelected,
    resourcesSelected,
    groupsSelected,
    companyGroups
  } = useCustomFieldGroups();
  const {
    category
  } = useCustomFields();
  const containerRef = useRef(null);
  const selectedResourceIds = useMemo(() => new Set(selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.entities.map(entity => entity)), [selectedGroup.entities]);
  const selectedGroupIds = useMemo(() => new Set(selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.items.map(item => item)), [selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.items]);
  const entitiesTitle = category === 'project' ? 'Project' : 'Resource';
  const entitiesList = useMemo(() => {
    const renderEntityItem = entity => {
      const label = isProject(entity) ? entity.name : "".concat(entity.firstName, " ").concat(entity.lastName);
      return jsx(SelectItem, {
        label: label,
        onClick: () => handleSelectResource(entity),
        selected: selectedResourceIds.has(entity._id)
      }, entity._id);
    };
    if (entities.length > 100) {
      return jsx(AutoSizer, {
        children: _ref198 => {
          let {
            height,
            width
          } = _ref198;
          return jsx($r, {
            style: {
              height,
              width,
              paddingRight: 8
            },
            totalCount: entities.length,
            itemContent: index => renderEntityItem(entities[index]),
            overscan: 20
          });
        }
      });
    }
    return entities.map(renderEntityItem);
  }, [entities, selectedResourceIds, handleSelectResource]);
  const groupsList = useMemo(() => {
    const renderGroupItem = group => {
      const label = group.name;
      return jsx(SelectItem, {
        label: label,
        onClick: () => handleSelectGroup(group),
        selected: selectedGroupIds.has(group._id)
      }, group._id);
    };
    if (companyGroups.length > 100) {
      return jsx(AutoSizer, {
        children: _ref199 => {
          let {
            height,
            width
          } = _ref199;
          return jsx($r, {
            style: {
              height,
              width,
              paddingRight: 8
            },
            totalCount: groups.length,
            itemContent: index => renderGroupItem(groups[index]),
            overscan: 20
          });
        }
      });
    }
    return groups.map(renderGroupItem);
  }, [companyGroups, groups, selectedGroupIds, handleSelectGroup]);
  return jsxs(Layout, {
    gap: "--Spacing-300",
    stretch: true,
    children: [jsx(Layout, {
      stack: true,
      stretch: true,
      fullHeight: true,
      gap: "--Spacing-300",
      children: jsxs(Layout, {
        stack: true,
        stretch: true,
        children: [jsx(GroupsHeader, {
          withBorder: true,
          children: jsxs(Layout, {
            pt: "--Spacing-100",
            pb: "--Spacing-100",
            gap: "--Spacing-150",
            vAlign: "center",
            children: [jsx(Icon, {
              name: "folder",
              size: 24,
              color: "on-surface-variant"
            }), jsxs(Layout, {
              stack: true,
              children: [jsx(Typography, {
                variant: "label",
                size: "large",
                children: "Groups"
              }), jsxs(Typography, {
                variant: "body",
                size: "medium",
                color: "on-surface-variant",
                children: [groupsSelected, " ", pluralize('Group', groupsSelected), " Selected"]
              })]
            })]
          })
        }), jsx(Container$4, {
          isVirtual: companyGroups.length > 100,
          children: jsxs(Layout, {
            pl: "--Spacing-200",
            pt: "--Spacing-100",
            stack: true,
            fullHeight: true,
            children: [jsx(SelectItem, {
              label: "Select All Groups",
              selected: allGroupsSelected,
              selectAll: true,
              onClick: handleSelectAllGroups,
              dataCy: "select-all-groups"
            }), jsx(Layout, {
              stack: true,
              fullHeight: true,
              children: groupsList
            })]
          })
        })]
      })
    }), jsx(Layout, {
      stack: true,
      stretch: true,
      fullHeight: true,
      gap: "--Spacing-300",
      children: jsxs(Layout, {
        stack: true,
        stretch: true,
        fullHeight: true,
        children: [jsx(ResourcesHeader, {
          withBorder: true,
          children: jsxs(Layout, {
            pt: "--Spacing-100",
            pb: "--Spacing-100",
            gap: "--Spacing-150",
            vAlign: "center",
            children: [jsx(Icon, {
              name: category === 'project' ? 'folder' : 'personOutline',
              size: 24,
              color: "on-surface-variant"
            }), jsxs(Layout, {
              stack: true,
              children: [jsxs(Typography, {
                variant: "label",
                size: "large",
                children: [entitiesTitle, "s"]
              }), jsxs(Typography, {
                variant: "body",
                size: "medium",
                color: "on-surface-variant",
                children: [resourcesSelected, " ", pluralize(entitiesTitle, resourcesSelected), " Selected"]
              })]
            })]
          })
        }), jsx(Container$4, {
          ref: containerRef,
          isVirtual: entities.length > 100,
          children: jsxs(Layout, {
            pl: "--Spacing-200",
            pt: "--Spacing-100",
            stack: true,
            fullHeight: true,
            children: [jsx(SelectItem, {
              label: "Select All ".concat(entitiesTitle, "s"),
              selected: allResourcesSelected,
              selectAll: true,
              onClick: handleSelectAllResources,
              dataCy: "select-all-entities"
            }), jsx(Layout, {
              stack: true,
              fullHeight: true,
              children: entitiesList
            })]
          })
        })]
      })
    })]
  });
};
const isProjectArray = entities => {
  return entities.length === 0 || 'projectCode' in entities[0];
};
function isProject(entity) {
  return 'projectCode' in entity;
}
const ImageContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "custom-field-groups-context__ImageContainer",
  componentId: "l4pp6c-0"
})(["box-shadow:0.51px 1.03px 3.08px 0px rgba(0,0,0,0.12),2.57px 5.14px 5.65px 0px rgba(0,0,0,0.1),5.14px 11.31px 7.71px 0px rgba(0,0,0,0.06),9.25px 20.05px 8.74px 0px rgba(0,0,0,0.02),14.91px 31.35px 9.77px 0px rgba(0,0,0,0);border-radius:14.39px;"]);
const AddCustomFieldGroupModalContent = _ref200 => {
  let {
    filterHandler,
    showSelectedHandler,
    deleteCFG,
    category
  } = _ref200;
  const [filter, setFilter] = filterHandler;
  const [showSelected, setShowSelected] = showSelectedHandler;
  const {
    customFieldGroups,
    updateGroup,
    selectedGroup
  } = useCustomFieldGroups();
  const debounceDeleteCFG = useMemo(() => {
    const debouncedFn = lodash.exports.debounce(() => {
      deleteCFG();
    }, 500);
    return debouncedFn;
  }, [deleteCFG]);
  useEffect(() => {
    return () => {
      debounceDeleteCFG.cancel();
    };
  }, [debounceDeleteCFG]);
  return jsxs(Layout, {
    stack: true,
    fullHeight: true,
    pt: "--Spacing-100",
    children: [jsxs(Layout, {
      gap: "--Spacing-200",
      children: [jsx(CustomFieldGroupsComponent, {
        where: "modal"
      }), jsx(Button, {
        variant: "text",
        endIcon: "delete",
        onClick: debounceDeleteCFG,
        disabled: customFieldGroups.length === 1,
        dataCy: "remove-custom-field-group",
        children: "Remove Custom Field Group"
      })]
    }), jsx(Layout, {
      pb: "--Spacing-200",
      pt: "--Spacing-200",
      children: jsx(Divider, {})
    }), jsxs(Layout, {
      gap: "--Spacing-200",
      pb: "--Spacing-200",
      hAlign: "space-between",
      children: [jsx("div", {
        style: {
          width: '50%',
          maxWidth: 326
        },
        children: jsx(TextField, {
          label: "Filter",
          onChange: e => setFilter(e.target.value),
          name: "customFieldGroupsFilter",
          placeholder: "Name of Group or ".concat(category === 'project' ? 'Project' : 'Resource'),
          value: filter,
          dataCy: "custom-field-groups-filter"
        })
      }), jsx(Switch, {
        label: jsx(Typography, {
          variant: "label",
          size: "large",
          color: "on-surface",
          children: "Show selected only"
        }),
        checked: showSelected,
        onChange: () => setShowSelected(!showSelected),
        dataCy: "show-selected-only"
      })]
    }), jsx("div", {
      style: {
        minHeight: 0,
        display: 'flex',
        overflow: 'visible',
        height: '100%'
      },
      children: jsx(ScrollableContainer, {})
    }), jsx("div", {
      style: {
        marginTop: 'auto'
      },
      children: jsx(Layout, {
        hAlign: "flex-end",
        pt: "--Spacing-300",
        children: jsx(Switch, {
          label: jsx(Typography, {
            variant: "label",
            size: "small",
            color: "on-surface-variant",
            children: "Automatically add this Custom Field Group to all newly created ".concat(category === 'project' ? 'Projects' : 'Resources')
          }),
          checked: selectedGroup.addAutomatically,
          dataCy: "automatically-assign-custom-field-groups",
          onChange: () => updateGroup(selectedGroup._id, {
            addAutomatically: !selectedGroup.addAutomatically
          })
        })
      })
    })]
  });
};
const MoveCopyGroupModalContent = _ref201 => {
  let {
    initAction,
    close,
    customFieldId
  } = _ref201;
  const {
    copyCustomFields,
    moveCustomFields,
    selectedCFGroupHandler,
    handleNotification
  } = useCustomFields();
  const {
    cfGroups,
    updateGroup
  } = useCustomFieldGroups();
  const [selectedGroup] = selectedCFGroupHandler;
  const {
    customFieldsToChange,
    targetCFGs,
    action,
    toggleTargetCFG,
    toggleCustomField,
    areAllTargetCFGsSelected,
    areAllCustomFieldsSelected,
    toggleAllCustomFields,
    toggleAllTargetCFGs,
    setFilterText,
    filterText,
    showSelectedOnly,
    setShowSelectedOnly,
    filterItems,
    setAction
  } = useCopyMove(initAction, customFieldId, selectedGroup);
  const {
    open,
    isOpen,
    close: closeDialog
  } = useOpenState();
  const anchor = useRef(null);
  const actionText = action.charAt(0).toUpperCase() + action.slice(1).toLowerCase();
  const actionCompletedText = action === 'move' ? 'moved' : 'copied';
  const callSaveAction = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
    if (action === 'copy') {
      yield copyCustomFields(targetCFGs, customFieldsToChange);
    } else {
      const sourceId = selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup._id;
      const targetId = targetCFGs[0];
      if (sourceId && targetId) {
        const sourceGroup = cfGroups.find(cfg => cfg._id === sourceId);
        const targetGroup = cfGroups.find(cfg => cfg._id === targetId);
        if (sourceGroup && Array.isArray(sourceGroup.customFields)) {
          const updatedSourceFields = sourceGroup.customFields.filter(field => !customFieldsToChange.includes(field));
          updateGroup(sourceId, {
            customFields: updatedSourceFields
          });
        }
        if (targetGroup && Array.isArray(targetGroup.customFields)) {
          const updatedTargetFields = [...new Set([...targetGroup.customFields, ...customFieldsToChange])];
          updateGroup(targetId, {
            customFields: updatedTargetFields
          });
        }
        yield moveCustomFields(sourceId, targetId, customFieldsToChange);
      }
    }
    handleNotification("Selected items were successfully ".concat(actionCompletedText), 'success');
    return close();
  }), [close, action, cfGroups, copyCustomFields, customFieldsToChange, moveCustomFields, selectedGroup, targetCFGs, updateGroup, handleNotification, actionCompletedText]);
  const debouncedSaveAction = useMemo(() => lodash.exports.debounce(() => callSaveAction(), 300), [callSaveAction]);
  const saveAction = useCallback(() => {
    return debouncedSaveAction();
  }, [debouncedSaveAction]);
  useEffect(() => {
    return () => {
      debouncedSaveAction.cancel();
    };
  }, [debouncedSaveAction]);
  return jsxs(Layout, {
    stack: true,
    fullHeight: true,
    pt: "--Spacing-100",
    ref: anchor,
    children: [jsxs(Layout, {
      gap: "--Spacing-200",
      children: [jsx(CustomFieldGroupsComponent, {
        where: "modal"
      }), jsxs(Layout, {
        gap: "--Spacing-200",
        children: [jsx(Radio, {
          value: "move",
          checked: action === 'move',
          label: "Move To",
          onChange: e => setAction(e.target.value)
        }), jsx(Radio, {
          value: "copy",
          checked: action === 'copy',
          label: "Copy To",
          onChange: e => setAction(e.target.value)
        })]
      })]
    }), jsx(Layout, {
      pb: "--Spacing-200",
      pt: "--Spacing-200",
      children: jsx(Divider, {})
    }), jsxs(Layout, {
      gap: "--Spacing-200",
      pb: "--Spacing-200",
      hAlign: "space-between",
      children: [jsx("div", {
        style: {
          width: '50%',
          maxWidth: 326
        },
        children: jsx(TextField, {
          label: "Filter",
          onChange: e => setFilterText(e.target.value),
          name: "customFieldGroupsFilter",
          placeholder: "Name of Group or Custom Field",
          value: filterText,
          dataCy: "filter-custom-field-groups"
        })
      }), jsx(Switch, {
        label: jsx(Typography, {
          variant: "label",
          size: "large",
          color: "on-surface",
          children: "Show selected only"
        }),
        checked: showSelectedOnly,
        onChange: () => setShowSelectedOnly(!showSelectedOnly),
        dataCy: "show-selected-only-items"
      })]
    }), jsx("div", {
      style: {
        minHeight: 0,
        display: 'flex',
        overflow: 'visible',
        height: '100%'
      },
      children: jsx(MoveCopyModal, {
        customFieldsToChange: customFieldsToChange,
        targetCFGs: targetCFGs,
        action: action,
        toggleTargetCFG: toggleTargetCFG,
        toggleCustomField: toggleCustomField,
        areAllTargetCFGsSelected: areAllTargetCFGsSelected,
        areAllCustomFieldsSelected: areAllCustomFieldsSelected,
        toggleAllCustomFields: toggleAllCustomFields,
        toggleAllTargetCFGs: toggleAllTargetCFGs,
        filterItems: filterItems
      })
    }), jsx("div", {
      style: {
        marginTop: 'auto'
      },
      children: jsxs(Layout, {
        hAlign: "flex-end",
        pt: "--Spacing-300",
        gap: "--Spacing-200",
        children: [jsx(Button, {
          variant: "text",
          onClick: close,
          children: "Cancel"
        }), jsx(Button, {
          onClick: action === 'move' ? open : saveAction,
          disabled: customFieldsToChange.length === 0 || targetCFGs.length === 0,
          children: "".concat(actionText, " to ").concat(action === 'move' ? 'group' : 'group/s')
        })]
      })
    }), jsx(Dialog, {
      width: 304,
      open: isOpen,
      icon: "error",
      iconColor: "secondary",
      title: jsx(Typography, {
        color: "on-surface",
        size: "small",
        variant: "headline",
        align: "center",
        children: "Are you sure you want to move these?"
      }),
      content: jsxs(Typography, {
        variant: "body",
        size: "medium",
        color: "on-surface-variant",
        children: ["Moving the selected Custom Field/s will permanently remove them from their original group.", ' ']
      }),
      actions: jsxs(Layout, {
        hAlign: "flex-end",
        gap: "--Spacing-50",
        children: [jsx(Button, {
          variant: "text",
          onClick: closeDialog,
          dataCy: "cancel-move-custom-field-group",
          children: "No, cancel"
        }), jsx(Button, {
          onClick: saveAction,
          variant: "destructive",
          dataCy: "proceed-with-move-custom-field-group",
          children: "Proceed with move"
        })]
      }),
      level: "high",
      hideBackdrop: true,
      onClose: closeDialog,
      anchorOriginPosition: {
        vertical: 'center',
        horizontal: 'center'
      },
      transformOriginPosition: {
        vertical: 'center',
        horizontal: 'center'
      },
      anchorElement: anchor.current
    })]
  });
};
const useDialog = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const openDialog = useCallback(() => setIsDialogOpen(true), []);
  const closeDialog = useCallback(() => setIsDialogOpen(false), []);
  return {
    isDialogOpen,
    openDialog,
    closeDialog
  };
};
const useModal$1 = (closeDialog, filterHandler, showSelectedHandler, deleteCFG, category) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = useCallback(() => {
    setIsModalOpen(true);
    closeDialog();
  }, [closeDialog]);
  const closeModal = useCallback(() => setIsModalOpen(false), []);
  const modalComponent = useMemo(() => jsx(Modal, {
    fullHeight: true,
    level: "default",
    backdrop: true,
    fullWidth: "md",
    title: jsxs(Layout, {
      stack: true,
      gap: "--Spacing-100",
      children: [jsx(Typography, {
        variant: "headline",
        size: "large",
        children: "Custom Field Groups"
      }), jsx(Typography, {
        variant: "body",
        size: "medium",
        children: "Custom Field Group settings for your ".concat(category === 'project' ? 'Projects' : 'Resources', ".")
      })]
    }),
    content: jsx(AddCustomFieldGroupModalContent, {
      filterHandler: filterHandler,
      showSelectedHandler: showSelectedHandler,
      deleteCFG: deleteCFG,
      category: category
    }),
    onClose: closeModal
  }), [closeModal, filterHandler, showSelectedHandler, deleteCFG, category]);
  return {
    isModalOpen,
    openModal,
    closeModal,
    modalComponent
  };
};
const useMoveCopyModal = (closeDialog, category) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [initAction, setInitAction] = useState('move');
  const [customFieldId, setCustomFieldId] = useState('');
  const hasRoleRight = useCanUserSeeExtensionsSettingsPage();
  const openModal = useCallback((action, cfId) => {
    if (hasRoleRight) {
      setIsModalOpen(true);
      closeDialog();
      setInitAction(action);
      setCustomFieldId(cfId);
    }
  }, [closeDialog, hasRoleRight]);
  const closeModal = useCallback(() => setIsModalOpen(false), []);
  const modalComponent = jsx(Modal, {
    fullHeight: true,
    level: "default",
    backdrop: true,
    fullWidth: "md",
    title: jsxs(Layout, {
      stack: true,
      gap: "--Spacing-100",
      children: [jsx(Typography, {
        variant: "headline",
        size: "large",
        children: "Move / Copy to another group"
      }), jsx(Typography, {
        variant: "body",
        size: "medium",
        children: "Custom Field Group settings for your ".concat(category === 'project' ? 'Projects' : 'Resources', ".")
      })]
    }),
    content: jsx(MoveCopyGroupModalContent, {
      initAction: initAction,
      close: closeModal,
      customFieldId: customFieldId
    }),
    onClose: closeModal
  });
  return {
    isModalOpen,
    openModal,
    closeModal,
    modalComponent
  };
};
const useExtensionNotActiveModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);
  const closeModal = useCallback(() => setIsModalOpen(false), []);
  const modalComponent = useMemo(() => jsx(Modal, {
    level: "high",
    backdrop: true,
    title: jsx(Typography, {
      variant: "display",
      size: "small",
      prominent: true,
      color: "on-surface-variant",
      children: "Custom Field Groups"
    }),
    content: jsxs(Layout, {
      gap: 48,
      children: [jsxs(Layout, {
        stack: true,
        gap: 50,
        children: [jsxs(Layout, {
          stack: true,
          vAlign: "center",
          gap: "--Spacing-150",
          children: [jsxs(Layout, {
            gap: 2,
            vAlign: "center",
            children: [jsx(Icon, {
              name: "arrowForward",
              size: 24
            }), jsx(Typography, {
              variant: "label",
              size: "large",
              prominent: true,
              children: "Organize fields in custom groups."
            })]
          }), jsxs(Layout, {
            gap: 2,
            vAlign: "center",
            children: [jsx(Icon, {
              name: "arrowForward",
              size: 24
            }), jsx(Typography, {
              variant: "label",
              size: "large",
              prominent: true,
              children: "Multiple groups per project or resource."
            })]
          }), jsxs(Layout, {
            gap: 2,
            vAlign: "center",
            children: [jsx(Icon, {
              name: "arrowForward",
              size: 24
            }), jsx(Typography, {
              variant: "label",
              size: "large",
              prominent: true,
              children: "Drag-and drop for fast setup."
            })]
          }), jsxs(Layout, {
            gap: 2,
            vAlign: "center",
            children: [jsx(Icon, {
              name: "arrowForward",
              size: 24
            }), jsx(Typography, {
              variant: "label",
              size: "large",
              prominent: true,
              children: "Easily reorder and edit."
            })]
          }), jsxs(Layout, {
            gap: 2,
            vAlign: "center",
            children: [jsx(Icon, {
              name: "arrowForward",
              size: 24
            }), jsx(Typography, {
              variant: "label",
              size: "large",
              prominent: true,
              children: "Apply to resources and projects."
            })]
          })]
        }), jsxs(Layout, {
          stack: true,
          gap: "--Spacing-200",
          children: [jsx(Typography, {
            variant: "headline",
            size: "small",
            color: "on-surface-variant",
            children: "Group your unique Custom Fields"
          }), jsx(Typography, {
            variant: "body",
            size: "medium",
            color: "on-surface-variant",
            children: "Custom Field groups make it easier to manage custom fields \n at scale. Group fields by your business logic. This could be by \n department, type of project, role and so on. These groups can \n then be applied to resources and projects, streamlining your \n workflow and keeping everything organized."
          })]
        })]
      }), jsxs(Layout, {
        stack: true,
        vAlign: "space-between",
        hAlign: "flex-end",
        gap: "--Spacing-400",
        children: [jsx(ImageContainer, {
          children: jsx(Image$1, {
            src: "https://hubplanner-static.s3.eu-west-1.amazonaws.com/img/custom_field_groups.png",
            name: "image",
            height: 381
          })
        }), jsx(Button, {
          endIcon: "arrowForward",
          onClick: () => window.location.href = '/settings#extensions',
          children: "Try out Custom Field Groups"
        })]
      })]
    }),
    onClose: closeModal
  }), [closeModal]);
  return {
    isModalOpen,
    openModal,
    closeModal,
    modalComponent
  };
};
const useCustomFieldGroupsManager = (closeDialog, groups, resetSelectedGroup, createCustomFieldGroup, updateCustomFieldGroup, deleteCustomFieldGroup, setSelectedGroup, selectedGroup) => {
  const [customFieldGroups, setCustomFieldGroups] = useState(groups);
  useEffect(() => {
    if (customFieldGroups.length === 0 && groups.length !== 0) {
      setCustomFieldGroups(groups);
    }
  }, [customFieldGroups.length, groups]);
  useEffect(() => {
    setCustomFieldGroups(groups);
  }, [selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup._id, groups]);
  const addGroup = useCallback(newGroup => __awaiter(void 0, void 0, void 0, function* () {
    const newCF = yield createCustomFieldGroup(newGroup);
    setCustomFieldGroups(prevGroups => [...prevGroups, Object.assign({}, newCF)]);
    setSelectedGroup(newCF);
    closeDialog();
  }), [closeDialog, createCustomFieldGroup, setSelectedGroup]);
  const removeGroup = useCallback(groupId => __awaiter(void 0, void 0, void 0, function* () {
    if (groups.length === 1) {
      return;
    }
    yield deleteCustomFieldGroup(groupId);
    setCustomFieldGroups(prevGroups => {
      const newGroups = prevGroups.filter(group => group._id !== groupId);
      setSelectedGroup(newGroups[0]);
      return newGroups;
    });
  }), [deleteCustomFieldGroup, groups, setSelectedGroup]);
  const updateGroup = useCallback((groupId, updatedData) => __awaiter(void 0, void 0, void 0, function* () {
    yield updateCustomFieldGroup(groupId, updatedData);
    setCustomFieldGroups(prevGroups => prevGroups.map(group => group._id === groupId ? Object.assign(Object.assign({}, group), updatedData) : group));
    closeDialog();
  }), [closeDialog, updateCustomFieldGroup]);
  return {
    customFieldGroups,
    addGroup,
    removeGroup,
    updateGroup,
    setCustomFieldGroups
  };
};
const useCopyMove = (initAction, customFieldId, selectedGroup) => {
  const [customFieldsToChange, setCustomFieldsToChange] = useState(customFieldId ? [customFieldId] : []);
  const [sourceCFG, setSourceCFG] = useState(null);
  const [targetCFGs, setTargetCFGs] = useState([]);
  const [action, setAction] = useState(initAction);
  const [filterText, setFilterText] = useState('');
  const [showSelectedOnly, setShowSelectedOnly] = useState(false);
  const isMoveModeWithSelection = () => action === 'move' && targetCFGs.length > 0;
  const isItemSelected = (id, collection) => collection.includes(id);
  const removeItem = (id, collection) => collection.filter(item => item !== id);
  const addItem = (id, collection) => [...collection, id];
  const createSelectionHandlers = (selectionState, setSelectionState, options) => {
    return {
      select: id => {
        if (isItemSelected(id, selectionState)) return;
        if ((options === null || options === void 0 ? void 0 : options.moveMode) && isMoveModeWithSelection()) {
          setSelectionState(addItem(id, []));
          return;
        }
        setSelectionState(addItem(id, selectionState));
      },
      unselect: id => {
        setSelectionState(removeItem(id, selectionState));
      },
      toggle: id => {
        if (isItemSelected(id, selectionState)) {
          setSelectionState(removeItem(id, selectionState));
        } else {
          if ((options === null || options === void 0 ? void 0 : options.moveMode) && isMoveModeWithSelection()) {
            setSelectionState(addItem(id, []));
            return;
          }
          setSelectionState(addItem(id, selectionState));
        }
      },
      selectAll: ids => {
        if ((options === null || options === void 0 ? void 0 : options.moveMode) && action === 'move') return;
        const newIds = ids.filter(id => !isItemSelected(id, selectionState));
        if (newIds.length > 0) {
          setSelectionState([...selectionState, ...newIds]);
        }
      },
      unselectAll: availableIds => {
        if (!availableIds) {
          setSelectionState([]);
          return;
        }
        const newSelection = selectionState.filter(id => !availableIds.includes(id));
        setSelectionState(newSelection);
      },
      areAllSelected: availableIds => {
        return availableIds.length > 0 && availableIds.every(id => isItemSelected(id, selectionState));
      },
      toggleAll: availableIds => {
        if (availableIds.length > 0 && availableIds.every(id => isItemSelected(id, selectionState))) {
          if (!availableIds) {
            setSelectionState([]);
            return;
          }
          const newSelection = selectionState.filter(id => !availableIds.includes(id));
          setSelectionState(newSelection);
        } else {
          if ((options === null || options === void 0 ? void 0 : options.moveMode) && action === 'move') return;
          const newIds = availableIds.filter(id => !isItemSelected(id, selectionState));
          if (newIds.length > 0) {
            setSelectionState([...selectionState, ...newIds]);
          }
        }
      }
    };
  };
  useEffect(() => {
    var _a;
    const validFieldIds = ((_a = selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.customFields) === null || _a === void 0 ? void 0 : _a.map(field => field)) || [];
    setCustomFieldsToChange(prev => prev.filter(id => validFieldIds.includes(id)));
  }, [selectedGroup]);
  useEffect(() => {
    if (targetCFGs.length > 1 && action === 'move') {
      setTargetCFGs(addItem(targetCFGs[0], []));
    }
  }, [action, targetCFGs]);
  const handleSetTargetCFGs = cfgs => {
    if (isMoveModeWithSelection()) return;
    setTargetCFGs(cfgs);
  };
  const filterItems = (items, selectionArray) => {
    let filteredItems = items;
    if (showSelectedOnly) {
      filteredItems = items.filter(item => selectionArray.includes(item._id));
    }
    if (filterText.trim()) {
      const normalizedFilter = filterText.toLowerCase().trim();
      filteredItems = filteredItems.filter(item => {
        const label = (item.label || '').toLowerCase();
        const name = (item.name || '').toLowerCase();
        return label.includes(normalizedFilter) || name.includes(normalizedFilter);
      });
    }
    return filteredItems;
  };
  const getFilteredIds = (items, selectionArray) => {
    return filterItems(items, selectionArray).map(item => item._id);
  };
  const customFieldHandlers = createSelectionHandlers(customFieldsToChange, setCustomFieldsToChange);
  const targetCFGHandlers = createSelectionHandlers(targetCFGs, setTargetCFGs, {
    moveMode: true
  });
  return {
    customFieldsToChange,
    sourceCFG,
    targetCFGs,
    action,
    setCustomFieldsToChange,
    setSourceCFG,
    setAction,
    setTargetCFGs: handleSetTargetCFGs,
    selectTargetCFG: targetCFGHandlers.select,
    unselectTargetCFG: targetCFGHandlers.unselect,
    toggleTargetCFG: targetCFGHandlers.toggle,
    selectAllTargetCFGs: targetCFGHandlers.selectAll,
    unselectAllTargetCFGs: targetCFGHandlers.unselectAll,
    toggleAllTargetCFGs: targetCFGHandlers.toggleAll,
    areAllTargetCFGsSelected: targetCFGHandlers.areAllSelected,
    selectCustomField: customFieldHandlers.select,
    unselectCustomField: customFieldHandlers.unselect,
    toggleCustomField: customFieldHandlers.toggle,
    selectAllCustomFields: customFieldHandlers.selectAll,
    unselectAllCustomFields: customFieldHandlers.unselectAll,
    toggleAllCustomFields: customFieldHandlers.toggleAll,
    areAllCustomFieldsSelected: customFieldHandlers.areAllSelected,
    filterText,
    filterItems,
    getFilteredIds,
    setFilterText,
    showSelectedOnly,
    setShowSelectedOnly
  };
};
const useCustomFieldGroup = _ref202 => {
  let {
    selectedGroupHandler,
    cfGroups,
    entities,
    items,
    addEntity,
    removeEntity,
    addItem,
    removeItem,
    updateEntities,
    updateItems,
    createCustomFieldGroup,
    updateCustomFieldGroup,
    deleteCustomFieldGroup
  } = _ref202;
  const {
    category
  } = useCustomFields();
  const [filter, setFilter] = useState('');
  const [showSelectedOnly, setShowSelectedOnly] = useState(false);
  const [selectedGroup, setSelectedGroup] = selectedGroupHandler;
  const {
    isDialogOpen,
    openDialog,
    closeDialog
  } = useDialog();
  const {
    isOpen: isCFGroupsOpen,
    open: openCFGroups,
    close: closeCFGroups
  } = useOpenState();
  const {
    isOpen: isCFGroupsModalOpen,
    open: openModalCFGroups,
    close: closeModalCFGroups
  } = useOpenState();
  const resetSelectedGroup = () => setSelectedGroup({
    _id: '',
    name: '',
    items: [],
    entities: [],
    customFields: [],
    addAutomatically: false,
    updatedAt: '',
    createdAt: ''
  });
  const {
    customFieldGroups,
    addGroup,
    removeGroup,
    updateGroup: updateGroupInList,
    setCustomFieldGroups
  } = useCustomFieldGroupsManager(closeDialog, cfGroups, resetSelectedGroup, createCustomFieldGroup, updateCustomFieldGroup, deleteCustomFieldGroup, setSelectedGroup, selectedGroup);
  const {
    isModalOpen,
    openModal,
    closeModal,
    modalComponent
  } = useModal$1(closeDialog, [filter, setFilter], [showSelectedOnly, setShowSelectedOnly], () => removeGroup(selectedGroup._id), category);
  const {
    isModalOpen: isCopyMoveModalOpen,
    openModal: openCopyMoveModal,
    closeModal: closeCopyMoveModal,
    modalComponent: copyMoveModalComponent
  } = useMoveCopyModal(closeDialog, category);
  const {
    isModalOpen: isExtensionNotActiveModalOpen,
    openModal: openExtensionNotActiveModal,
    closeModal: closeExtensionNotActiveModal,
    modalComponent: extensionNotActiveModal
  } = useExtensionNotActiveModal();
  const selectedItemIds = useMemo(() => {
    var _a;
    const validItemsSet = new Set(items.map(item => item._id));
    return new Set(((_a = selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.items) === null || _a === void 0 ? void 0 : _a.filter(id => validItemsSet.has(id))) || []);
  }, [selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.items, items]);
  const allItemsSelected = useMemo(() => items.length > 0 && items.every(item => selectedItemIds.has(item._id)), [selectedItemIds, items]);
  const filterItems = useCallback(items => {
    const lowerFilter = filter.toLowerCase();
    return items.filter(item => item.name.toLowerCase().includes(lowerFilter) && (!showSelectedOnly || selectedItemIds.has(item._id)));
  }, [filter, showSelectedOnly, selectedItemIds]);
  const handleSelectGroup = useCallback(item => __awaiter(void 0, void 0, void 0, function* () {
    const isSelected = selectedGroup.items.some(i => i === item._id);
    const newItems = isSelected ? selectedGroup.items.filter(i => i !== item._id) : [...selectedGroup.items, item._id];
    setSelectedGroup(prev => Object.assign(Object.assign({}, prev), {
      items: newItems
    }));
    setCustomFieldGroups(prevGroups => prevGroups.map(group => group._id === selectedGroup._id ? Object.assign(Object.assign({}, group), {
      items: newItems
    }) : group));
    const action = isSelected ? removeItem : addItem;
    return yield action(selectedGroup._id, item._id);
  }), [setSelectedGroup, setCustomFieldGroups, addItem, removeItem, selectedGroup]);
  const handleSelectAllItems = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
    const newItems = allItemsSelected ? [] : filterItems(items).map(item => item._id);
    const updatedItems = allItemsSelected ? [] : [...selectedGroup.items, ...newItems];
    setSelectedGroup(prev => Object.assign(Object.assign({}, prev), {
      items: updatedItems
    }));
    setCustomFieldGroups(prevGroups => prevGroups.map(group => group._id === selectedGroup._id ? Object.assign(Object.assign({}, group), {
      items: updatedItems
    }) : group));
    return yield updateItems(selectedGroup._id, updatedItems);
  }), [allItemsSelected, setSelectedGroup, setCustomFieldGroups, items, selectedGroup, updateItems, filterItems]);
  const displayGroups = useMemo(() => {
    return filterItems(items);
  }, [filterItems, items]);
  const saveCustomFieldGroup = useCallback(cfGroupName => {
    const trimmedName = cfGroupName.trim();
    if (!trimmedName) return;
    const newGroup = {
      _id: '',
      name: trimmedName,
      items: [],
      entities: [],
      type: 'resource',
      customFields: [],
      addAutomatically: false,
      updatedAt: '',
      createdAt: ''
    };
    addGroup(newGroup);
    closeDialog();
  }, [addGroup, closeDialog]);
  const updateGroup = useCallback((groupId, newData) => {
    updateGroupInList(groupId, newData);
    if (selectedGroup._id === groupId) {
      setSelectedGroup(prev => Object.assign(Object.assign({}, prev), newData));
    }
  }, [selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup._id, setSelectedGroup, updateGroupInList]);
  const selectedEntities = useMemo(() => {
    var _a;
    const validEntitiesSet = new Set(entities.map(entity => entity._id));
    return new Set(((_a = selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.entities) === null || _a === void 0 ? void 0 : _a.filter(id => validEntitiesSet.has(id))) || []);
  }, [selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.entities, entities]);
  const allEntitiesSelected = useMemo(() => entities.length > 0 && entities.every(entity => selectedEntities.has(entity._id)), [selectedEntities, entities]);
  const filterEntities = useCallback(items => {
    const lowerFilter = filter.toLowerCase();
    if (isProjectArray(items)) {
      return items.filter(item => {
        return item.name.toLowerCase().includes(lowerFilter) && (!showSelectedOnly || selectedEntities.has(item._id));
      });
    }
    return items.filter(item => {
      const fullName = "".concat(item.firstName, " ").concat(item.lastName);
      return fullName.toLowerCase().includes(lowerFilter) && (!showSelectedOnly || selectedEntities.has(item._id));
    });
  }, [filter, showSelectedOnly, selectedEntities]);
  const handleSelectAllEntities = useCallback(() => {
    const filteredEntityIds = filterEntities(entities).map(entity => entity._id);
    const allFilteredEntitiesSelected = filteredEntityIds.every(id => selectedGroup.entities.includes(id));
    let updatedEntities;
    if (allFilteredEntitiesSelected) {
      updatedEntities = selectedGroup.entities.filter(id => !filteredEntityIds.includes(id));
    } else {
      updatedEntities = Array.from(new Set([...Array.from(selectedGroup.entities), ...filteredEntityIds]));
    }
    setSelectedGroup(prev => Object.assign(Object.assign({}, prev), {
      entities: updatedEntities
    }));
    setCustomFieldGroups(prevGroups => prevGroups.map(group => group._id === selectedGroup._id ? Object.assign(Object.assign({}, group), {
      entities: updatedEntities
    }) : group));
    return updateEntities(selectedGroup._id, updatedEntities);
  }, [setSelectedGroup, setCustomFieldGroups, entities, selectedGroup, updateEntities, filterEntities]);
  const handleSelectEntity = useCallback(resource => __awaiter(void 0, void 0, void 0, function* () {
    const isSelected = selectedGroup.entities.some(r => r === resource._id);
    const newEntities = isSelected ? selectedGroup.entities.filter(r => r !== resource._id) : [...selectedGroup.entities, resource._id];
    setSelectedGroup(prev => Object.assign(Object.assign({}, prev), {
      entities: newEntities
    }));
    setCustomFieldGroups(prevGroups => prevGroups.map(group => group._id === selectedGroup._id ? Object.assign(Object.assign({}, group), {
      entities: newEntities
    }) : group));
    if (!isSelected) {
      return yield addEntity(selectedGroup._id, resource._id);
    } else {
      return yield removeEntity(selectedGroup._id, resource._id);
    }
  }), [setSelectedGroup, setCustomFieldGroups, addEntity, removeEntity, selectedGroup]);
  const displayEntities = useMemo(() => {
    const filtered = entities;
    if (category === 'project') {
      const filteredEntities = filterEntities(filtered);
      return filteredEntities === null || filteredEntities === void 0 ? void 0 : filteredEntities.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    }
    return filterEntities(filtered).sort((a, b) => {
      const aName = "".concat(a.firstName, " ").concat(a.lastName).trim().toLowerCase();
      const bName = "".concat(b.firstName, " ").concat(b.lastName).trim().toLowerCase();
      return aName.localeCompare(bName);
    });
  }, [filterEntities, entities, category]);
  return {
    isDialogOpen,
    isCFGroupsOpen,
    openCFGroups,
    closeCFGroups,
    isModalOpen,
    isCFGroupsModalOpen,
    isExtensionNotActiveModalOpen,
    openExtensionNotActiveModal,
    closeExtensionNotActiveModal,
    extensionNotActiveModal,
    isCopyMoveModalOpen,
    openCopyMoveModal,
    closeCopyMoveModal,
    copyMoveModalComponent,
    openModalCFGroups,
    closeModalCFGroups,
    openDialog,
    closeDialog,
    openModal,
    closeModal,
    modalComponent,
    customFieldGroups,
    cfGroups,
    addGroup,
    removeGroup,
    updateGroup,
    filterItems,
    showSelectedOnly,
    resourcesSelected: selectedEntities.size,
    groupsSelected: selectedItemIds.size,
    selectedGroup,
    setSelectedGroup,
    saveCustomFieldGroup,
    resources: displayEntities,
    groups: displayGroups,
    allResourcesSelected: allEntitiesSelected,
    allGroupsSelected: allItemsSelected,
    handleSelectResource: handleSelectEntity,
    handleSelectGroup,
    handleSelectAllResources: handleSelectAllEntities,
    handleSelectAllGroups: handleSelectAllItems
  };
};
const CustomFieldGroupContext = /*#__PURE__*/createContext(undefined);
const CustomFieldGroupProvider = _ref203 => {
  let {
    children,
    cfGroups,
    entities,
    items,
    addEntity,
    removeEntity,
    addItem,
    removeItem,
    createCustomFieldGroup,
    updateCustomFieldGroup,
    deleteCustomFieldGroup,
    updateEntities,
    updateItems,
    isCFGExtensionInstalled,
    selectedCFGroupHandler
  } = _ref203;
  const [selectedGroup, setSelectedGroup] = selectedCFGroupHandler;
  const hookResult = useCustomFieldGroup({
    selectedGroupHandler: [selectedGroup, setSelectedGroup],
    cfGroups,
    entities,
    items,
    addEntity,
    removeEntity,
    addItem,
    removeItem,
    updateEntities,
    updateItems,
    createCustomFieldGroup,
    updateCustomFieldGroup,
    deleteCustomFieldGroup,
    selectedCFGroupHandler
  });
  const contextValue = Object.assign(Object.assign({}, hookResult), {
    items,
    entities,
    companyGroups: items,
    addEntity,
    removeEntity,
    addItem,
    removeItem,
    createCustomFieldGroup,
    updateCustomFieldGroup,
    deleteCustomFieldGroup,
    updateEntities,
    updateItems,
    selectedCFGroupHandler,
    isCFGExtensionInstalled
  });
  return jsxs(CustomFieldGroupContext.Provider, {
    value: contextValue,
    children: [children, hookResult.isModalOpen && hookResult.modalComponent, hookResult.isCopyMoveModalOpen && hookResult.copyMoveModalComponent, hookResult.isExtensionNotActiveModalOpen && hookResult.extensionNotActiveModal]
  });
};
const useCustomFieldGroups = () => {
  const context = useContext(CustomFieldGroupContext);
  if (!context) {
    throw new Error('useCustomFieldGroups must be used within a CustomFieldGroupProvider');
  }
  return context;
};
const EditGroupNameButton = () => {
  const {
    open,
    isOpen,
    close,
    anchorElement
  } = useOpenState();
  const {
    updateGroup,
    selectedGroup,
    customFieldGroups
  } = useCustomFieldGroups();
  const [groupName, setGroupName] = useState(selectedGroup.name);
  const prevNameRef = useRef(selectedGroup.name);
  useEffect(() => {
    if (prevNameRef.current !== selectedGroup.name) {
      setGroupName(selectedGroup.name);
      prevNameRef.current = selectedGroup.name;
    }
  }, [selectedGroup.name]);
  const handleSave = useCallback(() => {
    updateGroup(selectedGroup._id, {
      name: groupName
    });
    close();
  }, [updateGroup, close, groupName, selectedGroup._id]);
  const handleClick = e => {
    open(e);
  };
  const handleClose = useCallback(() => {
    setGroupName('');
    close();
  }, [close, setGroupName]);
  const isDuplicateName = useMemo(() => {
    return customFieldGroups.some(group => group.name.toLowerCase() === groupName.toLowerCase() && groupName.length > 0 && selectedGroup.name.toLowerCase() !== groupName.toLowerCase());
  }, [customFieldGroups, groupName, selectedGroup]);
  const handleKeyDown = useCallback(e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSave();
      handleClose();
    }
  }, [handleSave, handleClose]);
  const title = jsx(Layout, {
    stack: true,
    children: jsx(Typography, {
      variant: "headline",
      size: "large",
      color: "neutral0",
      children: "Edit Group Name"
    })
  });
  useEffect(() => {
    if (!groupName) {
      setGroupName(selectedGroup.name);
    }
  }, [groupName, selectedGroup]);
  const content = useMemo(() => [jsxs(Layout, {
    stack: true,
    stretch: true,
    flex: "1",
    pt: "--Spacing-100",
    gap: "--Spacing-200",
    children: [jsx(TextField, {
      name: "note",
      label: "Custom field group name",
      placeholder: "eg: Design Custom Field",
      defaultValue: selectedGroup.name,
      onChange: e => setGroupName(e.target.value),
      onKeyDown: handleKeyDown,
      dataCy: "edit-group-name-text-field"
    }), isDuplicateName && jsxs(Layout, {
      gap: "--Spacing-200",
      children: [jsx("div", {
        style: {
          minWidth: 24
        },
        children: jsx(Icon, {
          name: "error",
          color: "error",
          size: 24
        })
      }), jsx(Typography, {
        variant: "body",
        size: "small",
        children: "Attention: This group already exists. If you want duplicates please proceed. Otherwise choose a new group name."
      })]
    })]
  })], [selectedGroup.name, isDuplicateName, handleKeyDown]);
  const actions = jsxs(Layout, {
    gap: 8,
    hAlign: "flex-end",
    children: [jsx(Button, {
      variant: "text",
      onClick: handleClose,
      dataCy: "cancel-edit-group-name",
      children: "Cancel"
    }), jsx(Button, {
      onClick: handleSave,
      disabled: groupName === selectedGroup.name,
      dataCy: "save-edit-group-name",
      children: "Save"
    })]
  });
  if (!selectedGroup) {
    return null;
  }
  return jsxs(Layout, {
    children: [jsx(Button, {
      endIcon: "edit",
      variant: "text",
      onClick: handleClick,
      dataCy: "edit-custom-field-group-name",
      children: "Edit group name"
    }), jsx(Dialog, {
      width: 355 - 48,
      open: isOpen,
      title: title,
      content: content,
      actions: actions,
      level: "high",
      hideBackdrop: true,
      onClose: handleClose,
      anchorElement: anchorElement,
      transformOriginPosition: {
        vertical: 'top',
        horizontal: 'right'
      },
      anchorOriginPosition: {
        vertical: 'top',
        horizontal: 'left'
      }
    })]
  });
};
const AddButton = () => {
  const {
    isDialogOpen,
    openDialog,
    closeDialog,
    saveCustomFieldGroup,
    isCFGExtensionInstalled,
    openExtensionNotActiveModal,
    customFieldGroups
  } = useCustomFieldGroups();
  const [customFieldGroupName, setCustomFieldGroupName] = useState('');
  const buttonRef = useRef(null);
  const hasRoleRight = useCanUserSeeExtensionsSettingsPage();
  const handleClick = () => {
    if (!isCFGExtensionInstalled && hasRoleRight) {
      return openExtensionNotActiveModal();
    }
    openDialog();
  };
  const handleClose = () => {
    setCustomFieldGroupName('');
    closeDialog();
  };
  const open = useMemo(() => {
    return Boolean(buttonRef.current) && isDialogOpen;
  }, [buttonRef, isDialogOpen]);
  const handleKeyDown = useCallback(e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      saveCustomFieldGroup(customFieldGroupName);
      setCustomFieldGroupName('');
      closeDialog();
    }
  }, [customFieldGroupName, saveCustomFieldGroup, closeDialog]);
  const isDuplicateName = useMemo(() => {
    return customFieldGroups.some(group => group.name.toLowerCase() === customFieldGroupName.toLowerCase() && customFieldGroupName.length > 0);
  }, [customFieldGroups, customFieldGroupName]);
  const dialogContent = useMemo(() => [jsxs(Fragment, {
    children: [jsx(TextField, {
      label: "Custom field group name",
      name: "customFieldGroupName",
      onChange: e => setCustomFieldGroupName(e.target.value),
      value: customFieldGroupName,
      autoComplete: "off",
      placeholder: "eg: Design Custom Field",
      onKeyDown: handleKeyDown,
      dataCy: "note-text-field"
    }), isDuplicateName && jsxs(Layout, {
      gap: "--Spacing-200",
      children: [jsx("div", {
        style: {
          minWidth: 24
        },
        children: jsx(Icon, {
          name: "error",
          color: "error",
          size: 24
        })
      }), jsx(Typography, {
        variant: "body",
        size: "small",
        children: "Attention: This group already exists. If you want duplicates please proceed. Otherwise choose a new group name."
      })]
    })]
  })], [isDuplicateName, customFieldGroupName, handleKeyDown]);
  return jsxs(Layout, {
    children: [jsx(Button, {
      ref: buttonRef,
      endIcon: "add",
      onClick: handleClick,
      dataCy: "create-new-custom-field-group",
      children: "Create new group"
    }), jsx(Dialog, {
      anchorElement: buttonRef.current,
      gap: "--Spacing-100",
      onClose: handleClose,
      open: open,
      width: 307,
      title: jsx(Typography, {
        color: "on-surface",
        size: "large",
        variant: "headline",
        children: "Create New Group"
      }),
      content: dialogContent,
      actions: jsxs(Layout, {
        hAlign: "flex-end",
        gap: "--Spacing-200",
        children: [jsx(Button, {
          variant: "text",
          onClick: handleClose,
          dataCy: "cancel-create-new-custom-field-group",
          children: "Cancel"
        }), jsx(Button, {
          disabled: !customFieldGroupName,
          onClick: () => {
            saveCustomFieldGroup(customFieldGroupName);
            setCustomFieldGroupName('');
          },
          dataCy: "save-create-new-custom-field-group",
          children: "Save"
        })]
      })
    })]
  });
};
const CustomFieldsPage = () => {
  const {
    openModal,
    isCFGExtensionInstalled,
    openExtensionNotActiveModal
  } = useCustomFieldGroups();
  const open = !isCFGExtensionInstalled ? openExtensionNotActiveModal : openModal;
  return jsxs(Layout, {
    gap: 16,
    children: [jsx(CustomFieldGroupsComponent, {}), jsx(AddButton, {}), jsx(Button, {
      variant: "outlined",
      onClick: open,
      dataCy: "manage-custom-field-groups",
      children: "Manage groups"
    }), jsx(EditGroupNameButton, {})]
  });
};
const useModal = _ref204 => {
  let {
    title,
    content
  } = _ref204;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);
  const closeModal = useCallback(() => setIsModalOpen(false), []);
  const modalComponent = useMemo(() => jsx(Modal, {
    level: "high",
    backdrop: true,
    title: title,
    content: content,
    onClose: closeModal
  }), [closeModal, content, title]);
  return {
    isModalOpen,
    openModal,
    closeModal,
    modalComponent
  };
};
var $$7 = _export;
var toObject$1 = toObject$b;
var lengthOfArrayLike$1 = lengthOfArrayLike$9;
var setArrayLength = arraySetLength;
var deletePropertyOrThrow = deletePropertyOrThrow$2;
var doesNotExceedSafeInteger = doesNotExceedSafeInteger$3;

// IE8-
var INCORRECT_RESULT = [].unshift(0) !== 1;

// V8 ~ Chrome < 71 and Safari <= 15.4, FF < 23 throws InternalError
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', {
      writable: false
    }).unshift();
  } catch (error) {
    return error instanceof TypeError;
  }
};
var FORCED$3 = INCORRECT_RESULT || !properErrorOnNonWritableLength();

// `Array.prototype.unshift` method
// https://tc39.es/ecma262/#sec-array.prototype.unshift
$$7({
  target: 'Array',
  proto: true,
  arity: 1,
  forced: FORCED$3
}, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  unshift: function unshift(item) {
    var O = toObject$1(this);
    var len = lengthOfArrayLike$1(O);
    var argCount = arguments.length;
    if (argCount) {
      doesNotExceedSafeInteger(len + argCount);
      var k = len;
      while (k--) {
        var to = k + argCount;
        if (k in O) O[to] = O[k];else deletePropertyOrThrow(O, to);
      }
      for (var j = 0; j < argCount; j++) {
        O[j] = arguments[j];
      }
    }
    return setArrayLength(O, len + argCount);
  }
});
const updateFieldOrders = fields => fields.map((field, index) => Object.assign(Object.assign({}, field), {
  order: index
}));
const addNewField = (newField, fields, targetIndex) => {
  const newFields = [...fields.slice(0, targetIndex), newField, ...fields.slice(targetIndex)];
  return updateFieldOrders(newFields);
};
const reorderFields = (fields, fromIndex, toIndex) => {
  const newFields = [...fields];
  const [movedItem] = newFields.splice(fromIndex, 1);
  newFields.splice(toIndex, 0, movedItem);
  return updateFieldOrders(newFields);
};
const copyField = (fields, sourceIndex, targetIndex) => {
  const copiedField = copyCustomField(fields[sourceIndex]);
  const newFields = [...fields.slice(0, targetIndex), copiedField, ...fields.slice(targetIndex)];
  return updateFieldOrders(newFields);
};
const handleFieldOperation = (fields, draggedIndex, draggedType, targetIndex, isAltKeyPressed) => {
  if (draggedType && draggedIndex === null) {
    const isOptionsType = draggedType === TemplateType.CHECKBOX || draggedType === TemplateType.RADIO || draggedType === TemplateType.SELECT;
    const newField = createDefaultCustomField({
      type: draggedType,
      order: targetIndex,
      filterGrid: isOptionsType,
      isChoicesSortedAlphabetically: isOptionsType
    });
    return addNewField(newField, fields, targetIndex);
  }
  if (draggedIndex !== null && isAltKeyPressed) {
    return copyField(fields, draggedIndex, targetIndex);
  }
  return fields;
};
const removeField = (fields, index) => {
  if (index < 0 || index >= fields.length) return fields;
  const newFields = [...fields].filter(item => !item.shouldDelete);
  const updated = newFields.map((field, idx) => field.order === index ? Object.assign(Object.assign({}, field), {
    order: idx,
    shouldDelete: true
  }) : Object.assign(Object.assign({}, field), {
    order: idx
  }));
  return updated;
};
const moveField = action => (fields, index) => {
  if (index < 0 || index >= fields.length) return fields;
  const newFields = [...fields];
  const [movedField] = newFields.splice(index, 1);
  switch (action) {
    case 'toTop':
      newFields.unshift(movedField);
      break;
    case 'toBottom':
      newFields.push(movedField);
      break;
    case 'up':
      if (index > 0) {
        newFields.splice(index - 1, 0, movedField);
      } else {
        newFields.unshift(movedField);
      }
      break;
    case 'down':
      if (index < fields.length - 1) {
        newFields.splice(index + 1, 0, movedField);
      } else {
        newFields.push(movedField);
      }
      break;
    default:
      return fields;
  }
  return newFields.map((field, idx) => Object.assign(Object.assign({}, field), {
    order: idx
  }));
};
const useElementMeasurements = () => {
  const measurements = useRef(new Map());
  const getMeasurements = useCallback(element => {
    if (!measurements.current.has(element)) {
      const rect = element.getBoundingClientRect();
      measurements.current.set(element, {
        rect,
        middleY: rect.top + rect.height / 2,
        isOpenField: rect.height > 60
      });
    }
    return measurements.current.get(element);
  }, []);
  useEffect(() => {
    const {
      current
    } = measurements;
    return () => current.clear();
  }, []);
  return getMeasurements;
};
const useDragCalculations = customFields => {
  return useMemo(() => ({
    getAdjustedTargetIndex: (draggedIndex, targetIndex, isAboveHalf, isOpenField) => {
      if (draggedIndex === targetIndex) return draggedIndex;
      if (isOpenField) {
        return isAboveHalf ? Math.max(0, targetIndex - 1) : Math.min(targetIndex + 1, customFields.length);
      }
      return targetIndex;
    },
    shouldUpdateFields: (draggedIndex, targetIndex, adjustedTargetIndex) => {
      return draggedIndex !== null && draggedIndex !== targetIndex && draggedIndex !== adjustedTargetIndex;
    }
  }), [customFields.length]);
};
const useCustomFieldsDragDrop = (customFields, setCustomFields, setOpenItem, category) => {
  const [dragState, setDragState] = useState({
    draggedIndex: null,
    draggedType: null,
    isDragging: false,
    draggingIndex: null
  });
  const {
    firstDayOfWeek
  } = useHubUIConfigContext();
  const getMeasurements = useElementMeasurements();
  const {
    getAdjustedTargetIndex,
    shouldUpdateFields
  } = useDragCalculations(customFields);
  const handleDragStart = useCallback((index, type) => {
    setDragState({
      draggedIndex: index,
      draggedType: type,
      isDragging: true,
      draggingIndex: index
    });
  }, []);
  const handleClick = useCallback(type => {
    const newField = createDefaultCustomField({
      type,
      order: 0,
      weekStartOn: firstDayOfWeek,
      category: category === 'project' ? Category.PROJECT : Category.RESOURCE
    });
    setCustomFields(addNewField(newField, customFields, 0).sort((a, b) => a.order - b.order));
    if (setOpenItem) {
      setOpenItem(getFieldKey(newField), 0);
    }
    return newField;
  }, [customFields, setCustomFields, setOpenItem, firstDayOfWeek, category]);
  const handleDragEnd = useCallback(e => {
    setDragState(prev => Object.assign(Object.assign({}, prev), {
      draggingIndex: null,
      isDragging: false
    }));
  }, []);
  const handleDragOver = useCallback((e, targetIndex) => {
    if (!e) return;
    e.preventDefault();
    const {
      draggedIndex
    } = dragState;
    if (draggedIndex === null) {
      setDragState(prev => Object.assign(Object.assign({}, prev), {
        draggingIndex: targetIndex
      }));
      return;
    }
    const measurements = getMeasurements(e.currentTarget);
    const isAboveHalf = e.clientY < measurements.middleY;
    const adjustedTargetIndex = getAdjustedTargetIndex(draggedIndex, targetIndex, isAboveHalf, measurements.isOpenField);
    if (shouldUpdateFields(draggedIndex, targetIndex, adjustedTargetIndex)) {
      const reorderedFields = reorderFields(customFields, draggedIndex, adjustedTargetIndex);
      setDragState(prev => Object.assign(Object.assign({}, prev), {
        draggedIndex: adjustedTargetIndex,
        draggingIndex: draggedIndex
      }));
      setCustomFields(reorderedFields);
      return;
    }
    return setDragState(prev => Object.assign(Object.assign({}, prev), {
      draggingIndex: targetIndex
    }));
  }, [dragState, customFields, setCustomFields, setDragState, getMeasurements, getAdjustedTargetIndex, shouldUpdateFields]);
  const handleDrop = useCallback((e, targetIndex, dropAbove) => {
    e.preventDefault();
    const {
      draggedIndex,
      draggedType,
      draggingIndex
    } = dragState;
    const dropOffset = dropAbove ? 0 : 1;
    const updatedIndex = (draggingIndex !== null ? draggingIndex : targetIndex) + dropOffset;
    const update = handleFieldOperation(customFields, draggedIndex, draggedType, updatedIndex, e.altKey);
    if (setOpenItem && draggedType) {
      const index = draggingIndex !== null ? draggingIndex : targetIndex;
      const offset = index >= customFields.length ? 0 : dropOffset;
      setOpenItem === null || setOpenItem === void 0 ? void 0 : setOpenItem(getFieldKey(update[index + offset]), index + offset);
    }
    setDragState({
      draggedIndex: null,
      draggedType: null,
      draggingIndex: null
    });
    setCustomFields(update);
  }, [dragState, customFields, setCustomFields, setOpenItem]);
  const handleMoveField = (action, index) => {
    setCustomFields(moveField(action)(customFields, index));
  };
  const handleRemoveField = index => {
    setCustomFields(removeField(customFields, index));
  };
  return {
    customFields,
    setCustomFields,
    dragState,
    handleDragStart,
    handleDrop,
    handleDragOver,
    handleDragEnd,
    handleMoveField,
    handleRemoveField,
    handleClick
  };
};

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$2(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}
var isObject_1 = isObject$2;

/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$2 = freeGlobal || freeSelf || Function('return this')();
var _root = root$2;
var root$1 = _root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$2 = function () {
  return root$1.Date.now();
};
var now_1 = now$2;

/** Used to match a single whitespace character. */

var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex$1(string) {
  var index = string.length;
  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}
var _trimmedEndIndex = trimmedEndIndex$1;
var trimmedEndIndex = _trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim$1(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}
var _baseTrim = baseTrim$1;
var root = _root;

/** Built-in value references. */
var Symbol$4 = root.Symbol;
var _Symbol = Symbol$4;
var Symbol$3 = _Symbol;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto$1.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$3 ? Symbol$3.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag$1),
    tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1;
var Symbol$2 = _Symbol,
  getRawTag = _getRawTag,
  objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$1(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$1;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$1(value) {
  return value != null && typeof value == 'object';
}
var isObjectLike_1 = isObjectLike$1;
var baseGetTag = _baseGetTag,
  isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
var isSymbol_1 = isSymbol$1;
var baseTrim = _baseTrim,
  isObject$1 = isObject_1,
  isSymbol = isSymbol_1;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$1(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_1 = toNumber$1;
var isObject = isObject_1,
  now$1 = now_1,
  toNumber = toNumber_1;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
  nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
    lastThis,
    maxWait,
    result,
    timerId,
    lastCallTime,
    lastInvokeTime = 0,
    leading = false,
    maxing = false,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs,
      thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime,
      timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now$1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }
  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }
  function flush() {
    return timerId === undefined ? result : trailingEdge(now$1());
  }
  function debounced() {
    var time = now$1(),
      isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var debounce_1 = debounce;
const SCROLL_ZONE = 60 + 32;
const SCROLL_STEP = 10;
const DEBOUNCE_DELAY = 16;
const useSmoothScroll = () => {
  const scrollAnimationRef = useRef();
  const isScrollingRef = useRef(false);
  const virtuosoScrollerRef = useRef(null);
  const boundingBoxRef = useRef(null);
  useEffect(() => {
    return () => {
      if (scrollAnimationRef.current) {
        cancelAnimationFrame(scrollAnimationRef.current);
        isScrollingRef.current = false;
      }
    };
  }, []);
  const updateBoundingBox = useCallback(() => {
    if (virtuosoScrollerRef.current) {
      boundingBoxRef.current = virtuosoScrollerRef.current.getBoundingClientRect();
    }
  }, []);
  useEffect(() => {
    updateBoundingBox();
    const resizeObserver = new ResizeObserver(() => {
      updateBoundingBox();
    });
    if (virtuosoScrollerRef.current) {
      resizeObserver.observe(virtuosoScrollerRef.current);
    }
    return () => {
      if (scrollAnimationRef.current) {
        cancelAnimationFrame(scrollAnimationRef.current);
        isScrollingRef.current = false;
      }
      resizeObserver.disconnect();
    };
  }, [updateBoundingBox]);
  const stopScroll = useCallback(() => {
    if (scrollAnimationRef.current) {
      cancelAnimationFrame(scrollAnimationRef.current);
    }
    isScrollingRef.current = false;
  }, []);
  const smoothScroll = useCallback(direction => {
    const element = virtuosoScrollerRef.current;
    if (!element) return;
    const scroll = () => {
      if (!isScrollingRef.current) return;
      const isAtTop = element.scrollTop <= 0;
      const isAtBottom = element.scrollTop + element.clientHeight >= element.scrollHeight;
      if (direction === 'up' && isAtTop || direction === 'down' && isAtBottom) {
        stopScroll();
        return;
      }
      element.scrollTop += direction === 'down' ? SCROLL_STEP : -SCROLL_STEP;
      scrollAnimationRef.current = requestAnimationFrame(scroll);
    };
    if (!isScrollingRef.current) {
      isScrollingRef.current = true;
      scroll();
    }
  }, [stopScroll]);
  const debouncedScrollHandler = useMemo(() => debounce_1((e, element) => {
    const rect = element.getBoundingClientRect();
    const relativeY = e.clientY - rect.top;
    if (relativeY > element.clientHeight - SCROLL_ZONE) {
      smoothScroll('down');
    } else if (relativeY < SCROLL_ZONE) {
      smoothScroll('up');
    } else {
      stopScroll();
    }
  }, DEBOUNCE_DELAY), [smoothScroll, stopScroll]);
  useEffect(() => {
    const handleGlobalDragEnd = () => {
      debouncedScrollHandler.cancel();
      stopScroll();
    };
    const handleDragLeave = e => {
      if (e.screenX === 0 && e.screenY === 0) {
        debouncedScrollHandler.cancel();
        stopScroll();
      }
    };
    window.addEventListener('dragend', handleGlobalDragEnd);
    window.addEventListener('mouseup', handleGlobalDragEnd);
    window.addEventListener('dragleave', handleDragLeave);
    return () => {
      debouncedScrollHandler.cancel();
      window.removeEventListener('dragend', handleGlobalDragEnd);
      window.removeEventListener('mouseup', handleGlobalDragEnd);
      window.removeEventListener('dragleave', handleDragLeave);
    };
  }, [debouncedScrollHandler, stopScroll]);
  const handleContainerDragOver = useCallback(e => {
    const element = virtuosoScrollerRef.current;
    if (!element) return;
    debouncedScrollHandler(e, element);
  }, [debouncedScrollHandler]);
  const handleContainerDragEnd = useCallback(() => {
    debouncedScrollHandler.cancel();
    stopScroll();
  }, [debouncedScrollHandler, stopScroll]);
  const setScrollerRef = useCallback(ref => {
    virtuosoScrollerRef.current = ref;
    updateBoundingBox();
  }, [updateBoundingBox]);
  return {
    handleContainerDragOver,
    handleContainerDragEnd,
    setScrollerRef,
    smoothScroll,
    stopScroll
  };
};
const DragContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__DragContainer",
  componentId: "sc-125xu4j-0"
})(["min-width:371px;width:584px;gap:16px;display:flex;flex-direction:column;border-radius:16px;background-color:", ";border:3px dashed ", ";border-radius:14px;overflow-y:scroll;padding-right:8px;"], _ref205 => {
  let {
    hasContent,
    theme,
    isDragging
  } = _ref205;
  return !hasContent && isDragging ? theme.designTokens.color.color.surfaces['surface-container-highest'].value : 'transparent';
}, _ref206 => {
  let {
    theme,
    hasContent,
    initialized
  } = _ref206;
  return !hasContent && initialized ? theme.designTokens.color.color.light['outline'].value : 'transparent';
});
const DraggableItemsContainer = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "styled__DraggableItemsContainer",
  componentId: "sc-125xu4j-1"
})(["border:3px dashed ", ";border-radius:8px;background-color:", ";box-sizing:border-box;"], _ref207 => {
  let {
    theme,
    isDragging
  } = _ref207;
  return isDragging ? theme.designTokens.color.color.light['outline'].value : 'transparent';
}, _ref208 => {
  let {
    theme,
    isDragging
  } = _ref208;
  return isDragging && theme.designTokens.color.color.surfaces['surface-container-highest'].value;
});
const EmptyStateContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__EmptyStateContainer",
  componentId: "sc-125xu4j-2"
})(["display:flex;height:100%;flex:1;justify-content:center;align-items:center;"]);
const DragCustomFieldButton = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__DragCustomFieldButton",
  componentId: "sc-125xu4j-3"
})(["background-color:", ";padding:8px 8px;border-radius:4px;justify-content:center;align-items:center;box-sizing:content-box;box-shadow:", ";position:relative;> *{cursor:grab;}&:active,& *:active{cursor:grabbing;}&::after{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,0);transition:background-color 0.3s ease;pointer-events:none;}&:hover::after{background-color:", ";}"], _ref209 => {
  let {
    theme,
    inverse
  } = _ref209;
  return inverse ? theme.designTokens.color.color.surfaces['inverse-surface'].value : theme.designTokens.color.color.surfaces['surface-container'].value;
}, props => props.theme.shadows[2], _ref210 => {
  let {
    theme
  } = _ref210;
  return theme.designTokens.color.color['state-layers'].light['primary']['opacity-0.12'].value;
});
const DisabledCF = /*#__PURE__*/css(["&&{&:before{content:'';position:absolute;top:0;left:0;right:0;bottom:0;background-color:rgba(255,255,255,0.5);z-index:1;}& > *{opacity:0.6;filter:grayscale(20%);pointer-events:none;}& input,& select,& textarea,& button{pointer-events:none;user-select:none;}& button{cursor:not-allowed;}}"]);
const CustomFieldsContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__CustomFieldsContainer",
  componentId: "sc-125xu4j-4"
})(["display:flex;flex-direction:column;position:relative;flex:1;min-height:0;gap:16px;", ""], _ref211 => {
  let {
    disabled
  } = _ref211;
  return disabled && DisabledCF;
});
const CustomFieldsFlexContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__CustomFieldsFlexContainer",
  componentId: "sc-125xu4j-5"
})(["display:flex;flex:1 1 auto;overflow:auto;gap:8px;"]);
const TEMPLATE_CONTAINER_WIDTH = 362;
const TemplateButtonContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__TemplateButtonContainer",
  componentId: "sc-125xu4j-7"
})(["display:flex;flex-direction:column;height:100%;width:", "px;"], props => props.width || TEMPLATE_CONTAINER_WIDTH);
const FixedTemplateHeader = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__FixedTemplateHeader",
  componentId: "sc-125xu4j-8"
})(["flex-shrink:0;width:100%;"]);
const TemplateScrollableContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__TemplateScrollableContent",
  componentId: "sc-125xu4j-9"
})(["flex-grow:1;overflow-y:auto;padding-left:8px;padding-right:8px;"]);
const TemplateLayoutContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__TemplateLayoutContainer",
  componentId: "sc-125xu4j-10"
})(["max-width:", "px;"], TEMPLATE_CONTAINER_WIDTH);
const NoFlexShrink = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__NoFlexShrink",
  componentId: "sc-125xu4j-11"
})(["flex:0 0 auto;display:flex;flex-direction:column;gap:16px;justify-content:flex-end;"]);
const OVER_SCAN_AMOUNT = 5;
const DEFAULT_ITEM_HEIGHT = 60;
const increaseViewport = {
  top: OVER_SCAN_AMOUNT * DEFAULT_ITEM_HEIGHT,
  bottom: OVER_SCAN_AMOUNT * DEFAULT_ITEM_HEIGHT
};
const openedViewPortSettings = {
  top: OVER_SCAN_AMOUNT * DEFAULT_ITEM_HEIGHT / 2,
  bottom: OVER_SCAN_AMOUNT * DEFAULT_ITEM_HEIGHT / 2
};
const DragState = () => jsx(EmptyStateContainer, {
  children: jsx("div", {
    style: {
      width: 371
    },
    children: jsx(Typography, {
      color: "inverse-surface",
      align: "center",
      children: "Drag or click a field type from the right menu to start creating your Custom Field Group."
    })
  })
});
const EmptyState = () => jsx(EmptyStateContainer, {
  children: jsx("div", {
    style: {
      width: 371
    },
    children: jsxs(Layout, {
      stack: true,
      gap: "--Spacing-300",
      children: [jsx(Typography, {
        color: "inverse-surface",
        variant: "label",
        size: "xl",
        align: "center",
        children: "Drag or click a field type from the right menu to start creating your Custom Field Group."
      }), jsx(DraggableItemPreview, {})]
    })
  })
});
const TemplateActionButton = _a => {
  var {
      icon,
      text,
      draggable,
      inverse
    } = _a,
    htmlDivProps = __rest(_a, ["icon", "text", "draggable", "inverse"]);
  const contentColor = inverse ? 'inverse-on-surface' : 'on-surface-variant';
  return jsx(DragCustomFieldButton, Object.assign({
    inverse: inverse,
    draggable: draggable
  }, htmlDivProps, {
    "data-cy": "template-action-button-".concat(text.toLowerCase().replace(/\s/g, '-')),
    children: jsxs(Layout, {
      vAlign: "center",
      gap: "--Spacing-200",
      children: [jsx("div", {
        style: {
          height: 24,
          width: 24,
          zIndex: 1
        },
        children: jsx(Icon, {
          name: "dragIndicator",
          size: 24,
          color: contentColor
        })
      }), jsxs(Layout, {
        gap: "--Spacing-100",
        vAlign: "center",
        children: [jsx(Icon, {
          name: icon,
          size: 24,
          color: contentColor
        }), jsx(Typography, {
          variant: "body",
          size: "medium",
          color: contentColor,
          weight: 500,
          children: text
        })]
      })]
    })
  }));
};
const CustomFields$1 = _ref212 => {
  let {
    customFields,
    handleDragStart,
    handleDragOver,
    handleDrop,
    handleDragEnd,
    handleMoveField,
    handleRemoveField,
    draggingIndex,
    isDragging,
    withSpace,
    ItemWrapper
  } = _ref212;
  const {
    customFieldsScrollRef,
    openItem,
    category
  } = useCustomFields();
  const {
    handleContainerDragOver,
    handleContainerDragEnd,
    setScrollerRef
  } = useSmoothScroll();
  const hasOpenItem = useMemo(() => openItem !== '', [openItem]);
  const memoizedCfs = useMemo(() => {
    return customFields.map(field => Object.assign(Object.assign({}, field), {
      key: getFieldKey(field)
    }));
  }, [customFields]);
  const virtuosoStyle = useMemo(() => ({
    height: '100%',
    overflowY: 'scroll',
    cursor: isDragging ? 'grabbing' : 'default'
  }), [isDragging]);
  const onDragStartFactory = useCallback(index => e => {
    e.dataTransfer.effectAllowed = 'move';
    handleDragStart(index, null);
  }, [handleDragStart]);
  const onDragOverFactory = useCallback(index => e => {
    e.preventDefault();
    return handleDragOver(e, index);
  }, [handleDragOver]);
  const onDropFactory = useCallback(index => (e, dropIndex, dropAbove) => {
    e.preventDefault();
    e.stopPropagation();
    return handleDrop(e, dropIndex, dropAbove);
  }, [handleDrop]);
  const onRemoveFactory = useCallback(item => () => handleRemoveField(item), [handleRemoveField]);
  const renderDraggableItem = (item, index, category) => {
    const commonProps = {
      key: "".concat(getFieldKey(item), "-draggable"),
      onDragStart: onDragStartFactory(index),
      onDragOver: onDragOverFactory(index),
      onDrop: onDropFactory(index),
      handleDragEnd: handleDragEnd,
      handleMoveField: handleMoveField,
      handleRemoveField: onRemoveFactory(item),
      isDragging: draggingIndex === index,
      withSpace: withSpace,
      item,
      index
    };
    return jsx(DraggableItem$1, Object.assign({}, commonProps, {
      Wrapper: ItemWrapper || undefined,
      "data-cy": "custom-field-".concat(getFieldKey(item))
    }));
  };
  return jsx(DraggableItemsContainer, {
    fullHeight: true,
    stack: true,
    gap: "--Spacing-200",
    isDragging: isDragging,
    withSpace: withSpace,
    children: (customFields === null || customFields === void 0 ? void 0 : customFields.length) > 50 ? jsx($r, {
      style: virtuosoStyle,
      data: memoizedCfs,
      totalCount: memoizedCfs.length,
      increaseViewportBy: hasOpenItem ? openedViewPortSettings : increaseViewport,
      ref: customFieldsScrollRef,
      scrollerRef: setScrollerRef,
      computeItemKey: (_, item) => getFieldKey(item),
      itemContent: (index, item, type) => renderDraggableItem(item, index),
      onDragOver: handleContainerDragOver,
      onMouseUp: handleContainerDragEnd,
      onMouseLeave: handleContainerDragEnd,
      onDragEnd: handleDragEnd,
      skipAnimationFrameInResizeObserver: true,
      "data-cy": "custom-fields-container-virtualized"
    }) : jsx("div", {
      style: {
        height: '100%',
        overflowY: 'scroll'
      },
      ref: customFieldsScrollRef,
      onDragOver: handleContainerDragOver,
      onMouseUp: handleContainerDragEnd,
      onMouseLeave: handleContainerDragEnd,
      "data-cy": "custom-fields-container-non-virtualized",
      children: customFields.map((item, index) => renderDraggableItem(item, index))
    })
  });
};
const TemplateLayout = _ref213 => {
  let {
    handleDragStart,
    handleDragEnd,
    handleClick,
    title: _title = 'Drag a field to add your own field to the list.',
    width
  } = _ref213;
  return jsxs(TemplateButtonContainer, {
    width: width,
    children: [jsx(Layout, {
      pb: "--Spacing-100",
      pt: "--Spacing-100",
      pl: "--Spacing-100",
      pr: "--Spacing-100",
      children: jsx(FixedTemplateHeader, {
        children: jsx(Typography, {
          variant: "label",
          size: "medium",
          weight: 500,
          children: _title
        })
      })
    }), jsx(TemplateScrollableContent, {
      children: jsx(Layout, {
        stack: true,
        gap: "--Spacing-200",
        pb: "--Spacing-200",
        children: Object.values(TemplateType).map(type => jsx(TemplateActionButton, {
          icon: fieldTypeMap[type].icon,
          text: fieldTypeMap[type].displayText,
          draggable: true,
          onDragStart: () => handleDragStart(null, type),
          onDragEnd: handleDragEnd,
          onClick: () => handleClick(type)
        }, "".concat(type, "-template-action-button")))
      })
    })]
  });
};
const CustomFieldGroupContainer = _ref214 => {
  let {
    showDebug
  } = _ref214;
  const {
    state,
    setFields,
    resetState,
    saveState,
    isEdited,
    setOpenItem,
    customFieldsOn,
    dragContainerRef,
    initialized,
    deleteField: handleRemoveField,
    loading,
    customFieldGroups,
    entities,
    items,
    addEntity,
    removeEntity,
    addItem,
    removeItem,
    createCustomFieldGroup,
    updateCustomFieldGroup,
    deleteCustomFieldGroup,
    updateEntities,
    updateItems,
    isCFGExtensionInstalled,
    isCFExtensionInstalled,
    selectedCFGroupHandler
  } = useCustomFields();
  const {
    handleDragStart,
    handleDragOver,
    handleDrop,
    handleDragEnd,
    handleMoveField,
    handleClick,
    dragState
  } = useCustomFieldsDragDrop(state.customFields, setFields, setOpenItem);
  const hasRoleRight = useCanUserSeeExtensionsSettingsPage();
  const {
    isModalOpen: isExtensionNotActiveModalOpen,
    openModal: openExtensionNotActiveModal,
    modalComponent: extensionNotActiveModal
  } = useModal({
    title: jsx(Typography, {
      variant: "display",
      size: "small",
      prominent: true,
      color: "on-surface-variant",
      children: "Custom Fields"
    }),
    content: jsxs(Layout, {
      gap: 48,
      children: [jsx(Layout, {
        stack: true,
        gap: 50,
        children: jsxs(Layout, {
          stack: true,
          vAlign: "center",
          gap: "--Spacing-150",
          children: [jsxs(Layout, {
            gap: 2,
            vAlign: "center",
            children: [jsx(Icon, {
              name: "arrowForward",
              size: 24
            }), jsx(Typography, {
              variant: "label",
              size: "large",
              prominent: true,
              children: "Adds a New Custom Field Manager to Settings"
            })]
          }), jsxs(Layout, {
            gap: 2,
            vAlign: "center",
            children: [jsx(Icon, {
              name: "arrowForward",
              size: 24
            }), jsx(Typography, {
              variant: "label",
              size: "large",
              prominent: true,
              children: "Create Project and Resource Fields."
            })]
          }), jsxs(Layout, {
            gap: 2,
            vAlign: "center",
            children: [jsx(Icon, {
              name: "arrowForward",
              size: 24
            }), jsx(Typography, {
              variant: "label",
              size: "large",
              prominent: true,
              children: "Choose from many different Form Types and options"
            })]
          }), jsxs(Layout, {
            gap: 2,
            vAlign: "center",
            children: [jsx(Icon, {
              name: "arrowForward",
              size: 24
            }), jsx(Typography, {
              variant: "label",
              size: "large",
              prominent: true,
              children: "Rename Tabs in Project and Resource Modals"
            })]
          }), jsxs(Layout, {
            gap: 2,
            vAlign: "center",
            children: [jsx(Icon, {
              name: "arrowForward",
              size: 24
            }), jsx(Typography, {
              variant: "label",
              size: "large",
              prominent: true,
              children: "Add your own Fields such as Skills, Locations, Clients, etc"
            })]
          }), jsxs(Layout, {
            gap: 2,
            vAlign: "center",
            children: [jsx(Icon, {
              name: "arrowForward",
              size: 24
            }), jsx(Typography, {
              variant: "label",
              size: "large",
              prominent: true,
              children: "Add help instruction text"
            })]
          }), jsxs(Layout, {
            gap: 2,
            vAlign: "center",
            children: [jsx(Icon, {
              name: "arrowForward",
              size: 24
            }), jsx(Typography, {
              variant: "label",
              size: "large",
              prominent: true,
              children: "Create different properties on each field"
            })]
          }), jsxs(Layout, {
            gap: 2,
            vAlign: "center",
            children: [jsx(Icon, {
              name: "arrowForward",
              size: 24
            }), jsx(Typography, {
              variant: "label",
              size: "large",
              prominent: true,
              children: "Create pre-defined values or placeholder suggestions"
            })]
          }), jsxs(Layout, {
            gap: 2,
            vAlign: "center",
            children: [jsx(Icon, {
              name: "arrowForward",
              size: 24
            }), jsx(Typography, {
              variant: "label",
              size: "large",
              prominent: true,
              children: "Really simple to get up and running"
            })]
          })]
        })
      }), jsxs(Layout, {
        stack: true,
        vAlign: "space-between",
        hAlign: "flex-end",
        gap: "--Spacing-400",
        children: [jsx(Image$1, {
          src: "/img/extensions/extension_custom_fields.jpg",
          name: "image",
          height: 381
        }), jsx(Button, {
          endIcon: "arrowForward",
          onClick: () => window.location.href = '/settings#extensions',
          children: "Try out Custom Fields"
        })]
      })]
    })
  });
  const [selectedGroup] = selectedCFGroupHandler;
  const showEmptyState = useMemo(() => {
    const selectedGroupHasCustomFields = selectedGroup && selectedGroup.customFields.length > 0;
    const stateHasNoCustomFields = state.customFields.length === 0;
    if (selectedGroupHasCustomFields && stateHasNoCustomFields) {
      return false;
    }
    return initialized && (isCFGExtensionInstalled ? !!selectedGroup : true) && stateHasNoCustomFields;
  }, [initialized, selectedGroup, isCFGExtensionInstalled, state.customFields]);
  useEffect(() => {
    const handleDragLeave = e => {
      if ((e.screenX === 0 && e.screenY === 0 || e.clientX >= 0 && e.clientY >= 0) && e.offsetY < -8) {
        handleDragEnd(e);
      }
    };
    window.addEventListener('dragleave', handleDragLeave);
    return () => {
      window.removeEventListener('dragleave', handleDragLeave);
    };
  }, [handleDragEnd]);
  const handleTemplateClick = type => {
    if (!isCFExtensionInstalled && hasRoleRight) {
      return openExtensionNotActiveModal();
    }
    handleClick(type);
  };
  const handleSaveChanges = () => {
    if (!isCFExtensionInstalled && hasRoleRight) {
      return openExtensionNotActiveModal();
    }
    saveState();
  };
  return jsx(CustomFieldGroupProvider, {
    cfGroups: customFieldGroups,
    entities: entities,
    items: items,
    addEntity: addEntity,
    removeEntity: removeEntity,
    addItem: addItem,
    removeItem: removeItem,
    createCustomFieldGroup: createCustomFieldGroup,
    updateCustomFieldGroup: updateCustomFieldGroup,
    deleteCustomFieldGroup: deleteCustomFieldGroup,
    updateEntities: updateEntities,
    updateItems: updateItems,
    isCFGExtensionInstalled: isCFGExtensionInstalled,
    selectedCFGroupHandler: selectedCFGroupHandler && selectedCFGroupHandler,
    children: jsxs(CustomFieldsContainer, {
      disabled: !customFieldsOn,
      children: [isExtensionNotActiveModalOpen && extensionNotActiveModal, selectedCFGroupHandler && Array.isArray(selectedCFGroupHandler) && selectedGroup && jsx(CustomFieldsPage, {}), jsxs(CustomFieldsFlexContainer, {
        children: [jsx(DragContainer, {
          onDrop: e => {
            e.preventDefault();
            e.stopPropagation();
            return handleDrop(e, state.customFields.length, dragState.draggingIndex === 0 && e.nativeEvent.offsetY < 60);
          },
          onDragOver: e => e.preventDefault(),
          onDragEnd: e => e.preventDefault(),
          hasContent: state.customFields.length > 0,
          isDragging: dragState.isDragging,
          ref: dragContainerRef,
          initialized: showEmptyState,
          "data-cy": "custom-fields-scroll-container",
          children: showEmptyState ? jsxs(Layout, {
            fullHeight: true,
            children: [dragState.isDragging && jsx(DragState, {}), showEmptyState && !dragState.isDragging && jsx(EmptyState, {})]
          }) : jsx(CustomFields$1, {
            customFields: state.customFields,
            handleDragOver: handleDragOver,
            handleDragStart: handleDragStart,
            handleDrop: handleDrop,
            handleRemoveField: handleRemoveField,
            handleMoveField: handleMoveField,
            handleDragEnd: handleDragEnd,
            draggingIndex: dragState.draggingIndex,
            isDragging: dragState.isDragging,
            withSpace: Boolean(dragState.draggedType)
          })
        }), jsx(Layout, {
          pl: 52,
          pr: 52,
          children: jsx(Divider, {
            type: "vertical"
          })
        }), jsx(TemplateLayoutContainer, {
          children: jsx(TemplateLayout, {
            width: 213 + 16,
            handleDragStart: handleDragStart,
            handleDragEnd: handleDragEnd,
            handleClick: handleTemplateClick,
            title: "Drag or click a field type to add it to your Group."
          })
        })]
      }), jsxs(NoFlexShrink, {
        children: [jsx(Layout, {
          flex: "1",
          children: jsx(Divider, {})
        }), jsxs(Layout, {
          fullHeight: true,
          hAlign: "flex-end",
          vAlign: "flex-start",
          children: [jsx(Button, {
            variant: "text",
            onClick: resetState,
            disabled: !isEdited,
            dataCy: "cancel-custom-fields-changes",
            children: "Cancel"
          }), jsx(Button, {
            onClick: () => loading ? null : handleSaveChanges(),
            disabled: !isEdited,
            dataCy: "save-custom-fields-changes",
            children: "Save Changes"
          })]
        })]
      })]
    })
  });
};
const CustomFieldsNoTemplate = () => {
  const {
    state,
    setFields,
    deleteField
  } = useCustomFields();
  const {
    handleDragStart,
    handleDragOver,
    handleDrop,
    handleMoveField,
    handleDragEnd,
    dragState
  } = useCustomFieldsDragDrop(state.customFields, setFields);
  return jsx(CustomFields$1, {
    customFields: state.customFields,
    handleDragOver: handleDragOver,
    handleDragStart: handleDragStart,
    handleDrop: handleDrop,
    handleDragEnd: handleDragEnd,
    handleRemoveField: item => deleteField(item),
    handleMoveField: handleMoveField,
    draggingIndex: dragState.draggingIndex
  });
};
const CustomFields = _ref215 => {
  let {
    customFields,
    updateCustomFields,
    toggleCustomFields,
    customFieldsOn,
    initialized,
    category,
    sendNotification,
    entities,
    customFieldGroups,
    items,
    addEntity,
    removeEntity,
    addItem,
    removeItem,
    createCustomFieldGroup,
    updateCustomFieldGroup,
    deleteCustomFieldGroup,
    updateEntities,
    updateItems,
    isCFGExtensionInstalled,
    isCFExtensionInstalled,
    selectedGroupHandler
  } = _ref215;
  return jsx(CustomFieldsProvider, {
    customFields: customFields,
    updateCustomFields: updateCustomFields,
    toggleCustomFields: toggleCustomFields,
    customFieldsOn: customFieldsOn,
    category: category,
    initialized: initialized,
    sendNotification: sendNotification,
    entities: entities,
    cfGroups: customFieldGroups,
    customFieldGroups: customFieldGroups,
    items: items,
    addEntity: addEntity,
    removeEntity: removeEntity,
    updateEntities: updateEntities,
    addItem: addItem,
    removeItem: removeItem,
    createCustomFieldGroup: createCustomFieldGroup,
    updateCustomFieldGroup: updateCustomFieldGroup,
    deleteCustomFieldGroup: deleteCustomFieldGroup,
    updateItems: updateItems,
    isCFGExtensionInstalled: isCFGExtensionInstalled,
    selectedGroupHandler: selectedGroupHandler,
    isCFExtensionInstalled: isCFExtensionInstalled,
    children: jsx(HubUIConfigContextProvider, {
      children: jsx(CustomFieldsNoTemplate, {})
    })
  });
};
const CustomFieldsWithTemplates = _ref216 => {
  let {
    showDebug,
    customFields,
    updateCustomFields,
    toggleCustomFields,
    customFieldsOn,
    initialized,
    category,
    sendNotification,
    entities,
    customFieldGroups,
    items,
    addEntity,
    removeEntity,
    addItem,
    removeItem,
    createCustomFieldGroup,
    updateCustomFieldGroup,
    deleteCustomFieldGroup,
    updateEntities,
    updateItems,
    isCFExtensionInstalled,
    isCFGExtensionInstalled,
    selectedGroupHandler,
    copyCustomFields,
    moveCustomFields
  } = _ref216;
  return jsx(CustomFieldsProvider, {
    customFields: customFields,
    cfGroups: customFieldGroups,
    updateCustomFields: updateCustomFields,
    toggleCustomFields: toggleCustomFields,
    customFieldsOn: customFieldsOn,
    category: category,
    initialized: initialized,
    sendNotification: sendNotification,
    entities: entities,
    customFieldGroups: customFieldGroups,
    items: items,
    addEntity: addEntity,
    removeEntity: removeEntity,
    updateEntities: updateEntities,
    addItem: addItem,
    removeItem: removeItem,
    createCustomFieldGroup: createCustomFieldGroup,
    updateCustomFieldGroup: updateCustomFieldGroup,
    deleteCustomFieldGroup: deleteCustomFieldGroup,
    updateItems: updateItems,
    isCFGExtensionInstalled: isCFGExtensionInstalled,
    isCFExtensionInstalled: isCFExtensionInstalled,
    selectedGroupHandler: selectedGroupHandler,
    moveCustomFields: moveCustomFields,
    copyCustomFields: copyCustomFields,
    children: jsx(HubUIConfigContextProvider, {
      children: jsx(CustomFieldGroupContainer, {
        showDebug: showDebug
      })
    })
  });
};

/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */
var durations = {
  none: 0,
  small: 100,
  medium: 350,
  large: 700
};

/**
 * Runs a flash animation on the background color of the provided `element`.
 *
 * This animation should be used after an element has been reordered,
 * in order to highlight where the element has moved to.
 */
function triggerPostMoveFlash(element) {
  element.animate([{
    backgroundColor: "var(--ds-background-selected, #E9F2FF)"
  }, {}], {
    duration: durations.large,
    /**
     * This is equivalent to the browser default, but we are making it
     * explicit to avoid relying on implicit behavior.
     *
     * This curve is not part of `@atlaskit/motion` but it was an intentional
     * design decision to use this curve.
     */
    easing: 'cubic-bezier(0.25, 0.1, 0.25, 1.0)',
    iterations: 1
  });
}

// using a symbol so we can guarantee a key with a unique value
var uniqueKey = Symbol('closestEdge');

/**
 * Returns the value added by `attachClosestEdge()` to the `userData` object. It will return `null` if there is no value.
 */
function extractClosestEdge(userData) {
  var _ref2;
  return (_ref2 = userData[uniqueKey]) !== null && _ref2 !== void 0 ? _ref2 : null;
}
function getReorderDestinationIndex(_ref) {
  var startIndex = _ref.startIndex,
    closestEdgeOfTarget = _ref.closestEdgeOfTarget,
    indexOfTarget = _ref.indexOfTarget,
    axis = _ref.axis;
  // invalid index's
  if (startIndex === -1 || indexOfTarget === -1) {
    return startIndex;
  }

  // if we are targeting the same index we don't need to do anything
  if (startIndex === indexOfTarget) {
    return startIndex;
  }
  if (closestEdgeOfTarget == null) {
    return indexOfTarget;
  }
  var isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
  var isMovingForward = startIndex < indexOfTarget;
  // moving forward
  if (isMovingForward) {
    return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
  }
  // moving backwards
  return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}

/** Create a new combined function that will call all the provided functions */
function combine() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function cleanup() {
    fns.forEach(function (fn) {
      return fn();
    });
  };
}
var dist = {};
var bind$1 = {};
Object.defineProperty(bind$1, "__esModule", {
  value: true
});
bind$1.bind = void 0;
function bind(target, _a) {
  var type = _a.type,
    listener = _a.listener,
    options = _a.options;
  target.addEventListener(type, listener, options);
  return function unbind() {
    target.removeEventListener(type, listener, options);
  };
}
bind$1.bind = bind;
var bindAll$1 = {};
var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(bindAll$1, "__esModule", {
  value: true
});
bindAll$1.bindAll = void 0;
var bind_1 = bind$1;
function toOptions(value) {
  if (typeof value === 'undefined') {
    return undefined;
  }
  if (typeof value === 'boolean') {
    return {
      capture: value
    };
  }
  return value;
}
function getBinding(original, sharedOptions) {
  if (sharedOptions == null) {
    return original;
  }
  var binding = __assign(__assign({}, original), {
    options: __assign(__assign({}, toOptions(sharedOptions)), toOptions(original.options))
  });
  return binding;
}
function bindAll(target, bindings, sharedOptions) {
  var unbinds = bindings.map(function (original) {
    var binding = getBinding(original, sharedOptions);
    return (0, bind_1.bind)(target, binding);
  });
  return function unbindAll() {
    unbinds.forEach(function (unbind) {
      return unbind();
    });
  };
}
bindAll$1.bindAll = bindAll;
(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.bindAll = exports.bind = void 0;
  var bind_1 = bind$1;
  Object.defineProperty(exports, "bind", {
    enumerable: true,
    get: function () {
      return bind_1.bind;
    }
  });
  var bind_all_1 = bindAll$1;
  Object.defineProperty(exports, "bindAll", {
    enumerable: true,
    get: function () {
      return bind_all_1.bindAll;
    }
  });
})(dist);

// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
var honeyPotDataAttribute = 'data-pdnd-honey-pot';
function isHoneyPotElement(target) {
  return target instanceof Element && target.hasAttribute(honeyPotDataAttribute);
}
function getElementFromPointWithoutHoneypot(client) {
  // eslint-disable-next-line no-restricted-syntax
  var _document$elementsFro = document.elementsFromPoint(client.x, client.y),
    _document$elementsFro2 = _slicedToArray(_document$elementsFro, 2),
    top = _document$elementsFro2[0],
    second = _document$elementsFro2[1];
  if (!top) {
    return null;
  }
  if (isHoneyPotElement(top)) {
    return second !== null && second !== void 0 ? second : null;
  }
  return top;
}

// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
var maxZIndex = 2147483647;
function ownKeys$2(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var honeyPotSize = 2;
var halfHoneyPotSize = honeyPotSize / 2;

/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/
function floorToClosestPixel(point) {
  return {
    x: Math.floor(point.x),
    y: Math.floor(point.y)
  };
}

/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */
function pullBackByHalfHoneyPotSize(point) {
  return {
    x: point.x - halfHoneyPotSize,
    y: point.y - halfHoneyPotSize
  };
}

/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */
function preventGoingBackwardsOffScreen(point) {
  return {
    x: Math.max(point.x, 0),
    y: Math.max(point.y, 0)
  };
}

/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */
function preventGoingForwardsOffScreen(point) {
  return {
    x: Math.min(point.x, window.innerWidth - honeyPotSize),
    y: Math.min(point.y, window.innerHeight - honeyPotSize)
  };
}

/**
 * Create a `2x2` `DOMRect` around the `client` position
 */
function getHoneyPotRectFor(_ref) {
  var client = _ref.client;
  var point = preventGoingForwardsOffScreen(preventGoingBackwardsOffScreen(pullBackByHalfHoneyPotSize(floorToClosestPixel(client))));

  // When debugging, it is helpful to
  // make this element a bit bigger
  return DOMRect.fromRect({
    x: point.x,
    y: point.y,
    width: honeyPotSize,
    height: honeyPotSize
  });
}
function getRectStyles(_ref2) {
  var clientRect = _ref2.clientRect;
  return {
    left: "".concat(clientRect.left, "px"),
    top: "".concat(clientRect.top, "px"),
    width: "".concat(clientRect.width, "px"),
    height: "".concat(clientRect.height, "px")
  };
}
function isWithin(_ref3) {
  var client = _ref3.client,
    clientRect = _ref3.clientRect;
  return (
    // is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width &&
    // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height
  );
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */
function mountHoneyPot(_ref4) {
  var initial = _ref4.initial;
  var element = document.createElement('div');
  element.setAttribute(honeyPotDataAttribute, 'true');

  // can shift during the drag thanks to Firefox
  var clientRect = getHoneyPotRectFor({
    client: initial
  });
  Object.assign(element.style, _objectSpread$2(_objectSpread$2({
    // Setting a background color explicitly to avoid any inherited styles.
    // Looks like this could be `opacity: 0`, but worried that _might_
    // cause the element to be ignored on some platforms.
    // When debugging, set backgroundColor to something like "red".
    backgroundColor: 'transparent',
    position: 'fixed',
    // Being explicit to avoid inheriting styles
    padding: 0,
    margin: 0,
    boxSizing: 'border-box'
  }, getRectStyles({
    clientRect: clientRect
  })), {}, {
    // We want this element to absorb pointer events,
    // it's kind of the whole point 😉
    pointerEvents: 'auto',
    // Want to make sure the honey pot is top of everything else.
    // Don't need to worry about native drag previews, as they will
    // have been rendered (and removed) before the honey pot is rendered
    zIndex: maxZIndex
  }));
  document.body.appendChild(element);

  /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */
  var unbindPointerMove = dist.bind(window, {
    type: 'pointermove',
    listener: function listener(event) {
      var client = {
        x: event.clientX,
        y: event.clientY
      };
      clientRect = getHoneyPotRectFor({
        client: client
      });
      Object.assign(element.style, getRectStyles({
        clientRect: clientRect
      }));
    },
    // using capture so we are less likely to be impacted by event stopping
    options: {
      capture: true
    }
  });
  return function finish(_ref5) {
    var current = _ref5.current;
    // Don't need this any more
    unbindPointerMove();

    // If the user is hover the honey pot, we remove it
    // so that the user can continue to interact with the page normally.
    if (isWithin({
      client: current,
      clientRect: clientRect
    })) {
      element.remove();
      return;
    }
    function cleanup() {
      unbindPostDragEvents();
      element.remove();
    }
    var unbindPostDragEvents = dist.bindAll(window, [{
      type: 'pointerdown',
      listener: cleanup
    }, {
      type: 'pointermove',
      listener: cleanup
    }, {
      type: 'focusin',
      listener: cleanup
    }, {
      type: 'focusout',
      listener: cleanup
    },
    // a 'pointerdown' should happen before 'dragstart', but just being super safe
    {
      type: 'dragstart',
      listener: cleanup
    },
    // if the user has dragged something out of the window
    // and then is dragging something back into the window
    // the first events we will see are "dragenter" (and then "dragover").
    // So if we see any of these we need to clear the post drag fix.
    {
      type: 'dragenter',
      listener: cleanup
    }, {
      type: 'dragover',
      listener: cleanup
    }

    // Not adding a "wheel" event listener, as "wheel" by itself does not
    // resolve the bug.
    ], {
      // Using `capture` so less likely to be impacted by other code stopping events
      capture: true
    });
  };
}
function makeHoneyPotFix() {
  var latestPointerMove = null;
  function bindEvents() {
    // For sanity, only collecting this value from when events are first bound.
    // This prevents the case where a super old "pointermove" could be used
    // from a prior interaction.
    latestPointerMove = null;
    return dist.bind(window, {
      type: 'pointermove',
      listener: function listener(event) {
        latestPointerMove = {
          x: event.clientX,
          y: event.clientY
        };
      },
      // listening for pointer move in capture phase
      // so we are less likely to be impacted by events being stopped.
      options: {
        capture: true
      }
    });
  }
  function getOnPostDispatch() {
    var finish = null;
    return function onPostEvent(_ref6) {
      var eventName = _ref6.eventName,
        payload = _ref6.payload;
      // We are adding the honey pot `onDragStart` so we don't
      // impact the creation of the native drag preview.
      if (eventName === 'onDragStart') {
        var _latestPointerMove;
        var input = payload.location.initial.input;

        // Sometimes there will be no latest "pointermove" (eg iOS).
        // In which case, we use the start position of the drag.
        var initial = (_latestPointerMove = latestPointerMove) !== null && _latestPointerMove !== void 0 ? _latestPointerMove : {
          x: input.clientX,
          y: input.clientY
        };

        // Don't need to defensively call `finish()` as `onDrop` from
        // one interaction is guaranteed to be called before `onDragStart`
        // of the next.
        finish = mountHoneyPot({
          initial: initial
        });
      }
      if (eventName === 'onDrop') {
        var _finish;
        var _input = payload.location.current.input;
        (_finish = finish) === null || _finish === void 0 || _finish({
          current: {
            x: _input.clientX,
            y: _input.clientY
          }
        });
        finish = null;
        // this interaction is finished, we want to use
        // the latest "pointermove" for each interaction
        latestPointerMove = null;
      }
    };
  }
  return {
    bindEvents: bindEvents,
    getOnPostDispatch: getOnPostDispatch
  };
}

/** Provide a function that you only ever want to be called a single time */
function once(fn) {
  var cache = null;
  return function wrapped() {
    if (!cache) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var result = fn.apply(this, args);
      cache = {
        result: result
      };
    }
    return cache.result;
  };
}

// using `cache` as our `isFirefox()` result will not change in a browser

/**
 * Returns `true` if a `Firefox` browser
 * */
var isFirefox = once(function isFirefox() {
  if (process.env.NODE_ENV === 'test') {
    return false;
  }
  return navigator.userAgent.includes('Firefox');
});

// using `cache` as our `isSafari()` result will not change in a browser

/**
 * Returns `true` if a `Safari` browser.
 * Returns `true` if the browser is running on iOS (they are all Safari).
 * */
var isSafari = once(function isSafari() {
  if (process.env.NODE_ENV === 'test') {
    return false;
  }
  var _navigator = navigator,
    userAgent = _navigator.userAgent;
  return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */

// Using symbols for event properties so we don't clash with
// anything on the `event` object
var symbols = {
  isLeavingWindow: Symbol('leaving'),
  isEnteringWindow: Symbol('entering')
};
function isLeavingWindowInSafari(_ref2) {
  var dragLeave = _ref2.dragLeave;
  if (!isSafari()) {
    return false;
  }
  return dragLeave.hasOwnProperty(symbols.isLeavingWindow);
}
(function fixSafari() {
  // Don't do anything when server side rendering
  if (typeof window === 'undefined') {
    return;
  }

  // rather than checking the userAgent for "jsdom" we can do this check
  // so that the check will be removed completely in production code
  if (process.env.NODE_ENV === 'test') {
    return;
  }
  if (!isSafari()) {
    return;
  }
  function getInitialState() {
    return {
      enterCount: 0,
      isOverWindow: false
    };
  }
  var state = getInitialState();
  function resetState() {
    state = getInitialState();
  }

  // These event listeners are bound _forever_ and _never_ removed
  // We don't bother cleaning up these event listeners (for now)
  // as this workaround is only for Safari

  // This is how the event count works:
  //
  // lift (+1 enterCount)
  // - dragstart(draggable) [enterCount: 0]
  // - dragenter(draggable) [enterCount: 1]
  // leaving draggable (+0 enterCount)
  // - dragenter(document.body) [enterCount: 2]
  // - dragleave(draggable) [enterCount: 1]
  // leaving window (-1 enterCount)
  // - dragleave(document.body) [enterCount: 0] {leaving the window}

  // Things to note:
  // - dragenter and dragleave bubble
  // - the first dragenter when entering a window might not be on `window`
  //   - it could be on an element that is pressed up against the window
  //   - (so we cannot rely on `event.target` values)

  dist.bindAll(window, [{
    type: 'dragstart',
    listener: function listener() {
      state.enterCount = 0;
      // drag start occurs in the source window
      state.isOverWindow = true;
      // When a drag first starts it will also trigger a "dragenter" on the draggable element
    }
  }, {
    type: 'drop',
    listener: resetState
  }, {
    type: 'dragend',
    listener: resetState
  }, {
    type: 'dragenter',
    listener: function listener(event) {
      if (!state.isOverWindow && state.enterCount === 0) {
        // Patching the `event` object
        // The `event` object is shared with all event listeners for the event
        // @ts-expect-error: adding property to the event object
        event[symbols.isEnteringWindow] = true;
      }
      state.isOverWindow = true;
      state.enterCount++;
    }
  }, {
    type: 'dragleave',
    listener: function listener(event) {
      state.enterCount--;
      if (state.isOverWindow && state.enterCount === 0) {
        // Patching the `event` object as it is shared with all event listeners
        // The `event` object is shared with all event listeners for the event
        // @ts-expect-error: adding property to the event object
        event[symbols.isLeavingWindow] = true;
        state.isOverWindow = false;
      }
    }
  }],
  // using `capture: true` so that adding event listeners
  // in bubble phase will have the correct symbols
  {
    capture: true
  });
})();

/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */
function isNodeLike(target) {
  return 'nodeName' in target;
}

/**
 * Is an `EventTarget` a `Node` from another `window`?
 */
function isFromAnotherWindow(eventTarget) {
  return isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}
function isLeavingWindow(_ref) {
  var dragLeave = _ref.dragLeave;
  var type = dragLeave.type,
    relatedTarget = dragLeave.relatedTarget;
  if (type !== 'dragleave') {
    return false;
  }
  if (isSafari()) {
    return isLeavingWindowInSafari({
      dragLeave: dragLeave
    });
  }

  // Standard check: if going to `null` we are leaving the `window`
  if (relatedTarget == null) {
    return true;
  }

  /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */

  if (isFirefox()) {
    return isFromAnotherWindow(relatedTarget);
  }

  /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */

  // Case 2
  // Using `instanceof` check as the element will be in the same `window`
  return relatedTarget instanceof HTMLIFrameElement;
}
function getBindingsForBrokenDrags(_ref) {
  var onDragEnd = _ref.onDragEnd;
  return [
  // ## Detecting drag ending for removed draggables
  //
  // If a draggable element is removed during a drag and the user drops:
  // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
  // 2. if not over a valid drop target (or cancelled): we get nothing
  // The "dragend" event will not fire on the source draggable if it has been
  // removed from the DOM.
  // So we need to figure out if a drag operation has finished by looking at other events
  // We can do this by looking at other events

  // ### First detection: "pointermove" events

  // 1. "pointermove" events cannot fire during a drag and drop operation
  // according to the spec. So if we get a "pointermove" it means that
  // the drag and drop operations has finished. So if we get a "pointermove"
  // we know that the drag is over
  // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
  // other pointer events. However, firefox will allow a few
  // pointer event to get through after a drag starts.
  // The most I've seen is 3
  {
    type: 'pointermove',
    listener: function () {
      var callCount = 0;
      return function listener() {
        // Using 20 as it is far bigger than the most observed (3)
        if (callCount < 20) {
          callCount++;
          return;
        }
        onDragEnd();
      };
    }()
  },
  // ### Second detection: "pointerdown" events

  // If we receive this event then we know that a drag operation has finished
  // and potentially another one is about to start.
  // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
  {
    type: 'pointerdown',
    listener: onDragEnd
  }];
}
function getInput(event) {
  return {
    altKey: event.altKey,
    button: event.button,
    buttons: event.buttons,
    ctrlKey: event.ctrlKey,
    metaKey: event.metaKey,
    shiftKey: event.shiftKey,
    clientX: event.clientX,
    clientY: event.clientY,
    pageX: event.pageX,
    pageY: event.pageY
  };
}
var rafSchd = function rafSchd(fn) {
  var lastArgs = [];
  var frameId = null;
  var wrapperFn = function wrapperFn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    lastArgs = args;
    if (frameId) {
      return;
    }
    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(void 0, lastArgs);
    });
  };
  wrapperFn.cancel = function () {
    if (!frameId) {
      return;
    }
    cancelAnimationFrame(frameId);
    frameId = null;
  };
  return wrapperFn;
};
var rafSchd$1 = rafSchd;
var scheduleOnDrag = rafSchd$1(function (fn) {
  return fn();
});
var dragStart = function () {
  var scheduled = null;
  function schedule(fn) {
    var frameId = requestAnimationFrame(function () {
      scheduled = null;
      fn();
    });
    scheduled = {
      frameId: frameId,
      fn: fn
    };
  }
  function flush() {
    if (scheduled) {
      cancelAnimationFrame(scheduled.frameId);
      scheduled.fn();
      scheduled = null;
    }
  }
  return {
    schedule: schedule,
    flush: flush
  };
}();
function makeDispatch(_ref) {
  var source = _ref.source,
    initial = _ref.initial,
    dispatchEvent = _ref.dispatchEvent;
  var previous = {
    dropTargets: []
  };
  function safeDispatch(args) {
    dispatchEvent(args);
    previous = {
      dropTargets: args.payload.location.current.dropTargets
    };
  }
  var dispatch = {
    start: function start(_ref2) {
      var nativeSetDragImage = _ref2.nativeSetDragImage;
      // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
      // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
      var location = {
        current: initial,
        previous: previous,
        initial: initial
      };
      // a `onGenerateDragPreview` does _not_ add another entry for `previous`
      // onDragPreview
      safeDispatch({
        eventName: 'onGenerateDragPreview',
        payload: {
          source: source,
          location: location,
          nativeSetDragImage: nativeSetDragImage
        }
      });
      dragStart.schedule(function () {
        safeDispatch({
          eventName: 'onDragStart',
          payload: {
            source: source,
            location: location
          }
        });
      });
    },
    dragUpdate: function dragUpdate(_ref3) {
      var current = _ref3.current;
      dragStart.flush();
      scheduleOnDrag.cancel();
      safeDispatch({
        eventName: 'onDropTargetChange',
        payload: {
          source: source,
          location: {
            initial: initial,
            previous: previous,
            current: current
          }
        }
      });
    },
    drag: function drag(_ref4) {
      var current = _ref4.current;
      scheduleOnDrag(function () {
        dragStart.flush();
        var location = {
          initial: initial,
          previous: previous,
          current: current
        };
        safeDispatch({
          eventName: 'onDrag',
          payload: {
            source: source,
            location: location
          }
        });
      });
    },
    drop: function drop(_ref5) {
      var current = _ref5.current,
        updatedSourcePayload = _ref5.updatedSourcePayload;
      dragStart.flush();
      scheduleOnDrag.cancel();
      safeDispatch({
        eventName: 'onDrop',
        payload: {
          source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
          location: {
            current: current,
            previous: previous,
            initial: initial
          }
        }
      });
    }
  };
  return dispatch;
}
var globalState = {
  isActive: false
};
function canStart() {
  return !globalState.isActive;
}
function getNativeSetDragImage(event) {
  if (event.dataTransfer) {
    // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
  }
  return null;
}
function hasHierarchyChanged(_ref) {
  var current = _ref.current,
    next = _ref.next;
  if (current.length !== next.length) {
    return true;
  }
  // not checking stickiness, data or dropEffect,
  // just whether the hierarchy has changed
  for (var i = 0; i < current.length; i++) {
    if (current[i].element !== next[i].element) {
      return true;
    }
  }
  return false;
}
function start(_ref2) {
  var event = _ref2.event,
    dragType = _ref2.dragType,
    getDropTargetsOver = _ref2.getDropTargetsOver,
    dispatchEvent = _ref2.dispatchEvent;
  if (!canStart()) {
    return;
  }
  var initial = getStartLocation({
    event: event,
    dragType: dragType,
    getDropTargetsOver: getDropTargetsOver
  });
  globalState.isActive = true;
  var state = {
    current: initial
  };

  // Setting initial drop effect for the drag
  setDropEffectOnEvent({
    event: event,
    current: initial.dropTargets
  });
  var dispatch = makeDispatch({
    source: dragType.payload,
    dispatchEvent: dispatchEvent,
    initial: initial
  });
  function updateState(next) {
    // only looking at whether hierarchy has changed to determine whether something as 'changed'
    var hasChanged = hasHierarchyChanged({
      current: state.current.dropTargets,
      next: next.dropTargets
    });

    // Always updating the state to include latest data, dropEffect and stickiness
    // Only updating consumers if the hierarchy has changed in some way
    // Consumers can get the latest data by using `onDrag`
    state.current = next;
    if (hasChanged) {
      dispatch.dragUpdate({
        current: state.current
      });
    }
  }
  function onUpdateEvent(event) {
    var input = getInput(event);

    // If we are over the honey pot, we need to get the element
    // that the user would have been over if not for the honey pot
    var target = isHoneyPotElement(event.target) ? getElementFromPointWithoutHoneypot({
      x: input.clientX,
      y: input.clientY
    }) : event.target;
    var nextDropTargets = getDropTargetsOver({
      target: target,
      input: input,
      source: dragType.payload,
      current: state.current.dropTargets
    });
    if (nextDropTargets.length) {
      // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
      event.preventDefault();
      setDropEffectOnEvent({
        event: event,
        current: nextDropTargets
      });
    }
    updateState({
      dropTargets: nextDropTargets,
      input: input
    });
  }
  function cancel() {
    // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
    // a "dragleave" event is fired on the active drop target before a "dragend" event.
    // We are replicating that behaviour in `cancel` if there are any active drop targets to
    // ensure consistent behaviour.
    //
    // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
    // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)

    if (state.current.dropTargets.length) {
      updateState({
        dropTargets: [],
        input: state.current.input
      });
    }
    dispatch.drop({
      current: state.current,
      updatedSourcePayload: null
    });
    finish();
  }
  function finish() {
    globalState.isActive = false;
    unbindEvents();
  }
  var unbindEvents = dist.bindAll(window, [{
    // 👋 Note: we are repurposing the `dragover` event as our `drag` event
    // this is because firefox does not publish pointer coordinates during
    // a `drag` event, but does for every other type of drag event
    // `dragover` fires on all elements that are being dragged over
    // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
    // 🦊😤
    type: 'dragover',
    listener: function listener(event) {
      // We need to regularly calculate the drop targets in order to allow:
      //  - dynamic `canDrop()` checks
      //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
      // Sadly we cannot schedule inspecting changes resulting from this event
      // we need to be able to conditionally cancel the event with `event.preventDefault()`
      // to enable the correct native drop experience.

      // 1. check to see if anything has changed
      onUpdateEvent(event);

      // 2. let consumers know a move has occurred
      // This will include the latest 'input' values
      dispatch.drag({
        current: state.current
      });
    }
  }, {
    type: 'dragenter',
    listener: onUpdateEvent
  }, {
    type: 'dragleave',
    listener: function listener(event) {
      if (!isLeavingWindow({
        dragLeave: event
      })) {
        return;
      }

      /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/

      updateState({
        input: state.current.input,
        dropTargets: []
      });
      if (dragType.startedFrom === 'external') {
        cancel();
      }
    }
  }, {
    // A "drop" can only happen if the browser allowed the drop
    type: 'drop',
    listener: function listener(event) {
      // Capture the final input.
      // We are capturing the final `input` for the
      // most accurate honey pot experience
      state.current = {
        dropTargets: state.current.dropTargets,
        input: getInput(event)
      };

      /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */

      if (!state.current.dropTargets.length) {
        cancel();
        return;
      }
      event.preventDefault();

      // applying the latest drop effect to the event
      setDropEffectOnEvent({
        event: event,
        current: state.current.dropTargets
      });
      dispatch.drop({
        current: state.current,
        // When dropping something native, we need to extract the latest
        // `.items` from the "drop" event as it is now accessible
        updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
      });
      finish();
    }
  }, {
    // "dragend" fires when on the drag source (eg a draggable element)
    // when the drag is finished.
    // "dragend" will fire after "drop" (if there was a successful drop)
    // "dragend" does not fire if the draggable source has been removed during the drag
    // or for external drag sources (eg files)

    // This "dragend" listener will not fire if there was a successful drop
    // as we will have already removed the event listener

    type: 'dragend',
    listener: function listener(event) {
      // In firefox, the position of the "dragend" event can
      // be a bit different to the last "dragover" event.
      // Updating the input so we can get the best possible
      // information for the honey pot.
      state.current = {
        dropTargets: state.current.dropTargets,
        input: getInput(event)
      };
      cancel();
    }
  }].concat(_toConsumableArray(getBindingsForBrokenDrags({
    onDragEnd: cancel
  }))),
  // Once we have started a managed drag operation it is important that we see / own all drag events
  // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
  // all "drop" events in the bubble phase on the `document.body`.
  // This meant that we never saw the "drop" event.
  {
    capture: true
  });
  dispatch.start({
    nativeSetDragImage: getNativeSetDragImage(event)
  });
}
function setDropEffectOnEvent(_ref3) {
  var _current$;
  var event = _ref3.event,
    current = _ref3.current;
  // setting the `dropEffect` to be the innerMost drop targets dropEffect
  var innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
  if (innerMost != null && event.dataTransfer) {
    event.dataTransfer.dropEffect = innerMost;
  }
}
function getStartLocation(_ref4) {
  var event = _ref4.event,
    dragType = _ref4.dragType,
    getDropTargetsOver = _ref4.getDropTargetsOver;
  var input = getInput(event);

  // When dragging from outside of the browser,
  // the drag is not being sourced from any local drop targets
  if (dragType.startedFrom === 'external') {
    return {
      input: input,
      dropTargets: []
    };
  }
  var dropTargets = getDropTargetsOver({
    input: input,
    source: dragType.payload,
    target: event.target,
    current: []
  });
  return {
    input: input,
    dropTargets: dropTargets
  };
}
var lifecycle = {
  canStart: canStart,
  start: start
};

// Extending `Map` to allow us to link Key and Values together

var ledger = new Map();
function registerUsage(_ref) {
  var typeKey = _ref.typeKey,
    mount = _ref.mount;
  var entry = ledger.get(typeKey);
  if (entry) {
    entry.usageCount++;
    return entry;
  }
  var initial = {
    typeKey: typeKey,
    unmount: mount(),
    usageCount: 1
  };
  ledger.set(typeKey, initial);
  return initial;
}
function register(args) {
  var entry = registerUsage(args);
  return function unregister() {
    entry.usageCount--;
    if (entry.usageCount > 0) {
      return;
    }
    // Only a single usage left, remove it
    entry.unmount();
    ledger.delete(args.typeKey);
  };
}
function addAttribute(element, _ref) {
  var attribute = _ref.attribute,
    value = _ref.value;
  element.setAttribute(attribute, value);
  return function () {
    return element.removeAttribute(attribute);
  };
}
function ownKeys$1(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$1(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _createForOfIteratorHelper$1(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray$1(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$1(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0;
  }
}
function _arrayLikeToArray$1(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function copyReverse(array) {
  return array.slice(0).reverse();
}
function makeDropTarget(_ref) {
  var typeKey = _ref.typeKey,
    defaultDropEffect = _ref.defaultDropEffect;
  var registry = new WeakMap();
  var dropTargetDataAtt = "data-drop-target-for-".concat(typeKey);
  var dropTargetSelector = "[".concat(dropTargetDataAtt, "]");
  function addToRegistry(args) {
    registry.set(args.element, args);
    return function () {
      return registry.delete(args.element);
    };
  }
  function dropTargetForConsumers(args) {
    // Guardrail: warn if the draggable element is already registered
    if (process.env.NODE_ENV !== 'production') {
      var existing = registry.get(args.element);
      if (existing) {
        // eslint-disable-next-line no-console
        console.warn("You have already registered a [".concat(typeKey, "] dropTarget on the same element"), {
          existing: existing,
          proposed: args
        });
      }
      if (args.element instanceof HTMLIFrameElement) {
        // eslint-disable-next-line no-console
        console.warn("\n            We recommend not registering <iframe> elements as drop targets\n            as it can result in some strange browser event ordering.\n          " // Removing newlines and excessive whitespace
        .replace(/\s{2,}/g, ' ').trim());
      }
    }
    return combine(addAttribute(args.element, {
      attribute: dropTargetDataAtt,
      value: 'true'
    }), addToRegistry(args));
  }
  function getActualDropTargets(_ref2) {
    var _args$getData, _args$getData2, _args$getDropEffect, _args$getDropEffect2;
    var source = _ref2.source,
      target = _ref2.target,
      input = _ref2.input,
      _ref2$result = _ref2.result,
      result = _ref2$result === void 0 ? [] : _ref2$result;
    if (target == null) {
      return result;
    }
    if (!(target instanceof Element)) {
      // For "text-selection" drags, the original `target`
      // is not an `Element`, so we need to start looking from
      // the parent element
      if (target instanceof Node) {
        return getActualDropTargets({
          source: source,
          target: target.parentElement,
          input: input,
          result: result
        });
      }

      // not sure what we are working with,
      // so we can exit.
      return result;
    }
    var closest = target.closest(dropTargetSelector);

    // Cannot find anything else
    if (closest == null) {
      return result;
    }
    var args = registry.get(closest);

    // error: something had a dropTargetSelector but we could not
    // find a match. For now, failing silently
    if (args == null) {
      return result;
    }
    var feedback = {
      input: input,
      source: source,
      element: args.element
    };

    // if dropping is not allowed, skip this drop target
    // and continue looking up the DOM tree
    if (args.canDrop && !args.canDrop(feedback)) {
      return getActualDropTargets({
        source: source,
        target: args.element.parentElement,
        input: input,
        result: result
      });
    }

    // calculate our new record
    var data = (_args$getData = (_args$getData2 = args.getData) === null || _args$getData2 === void 0 ? void 0 : _args$getData2.call(args, feedback)) !== null && _args$getData !== void 0 ? _args$getData : {};
    var dropEffect = (_args$getDropEffect = (_args$getDropEffect2 = args.getDropEffect) === null || _args$getDropEffect2 === void 0 ? void 0 : _args$getDropEffect2.call(args, feedback)) !== null && _args$getDropEffect !== void 0 ? _args$getDropEffect : defaultDropEffect;
    var record = {
      data: data,
      element: args.element,
      dropEffect: dropEffect,
      // we are collecting _actual_ drop targets, so these are
      // being applied _not_ due to stickiness
      isActiveDueToStickiness: false
    };
    return getActualDropTargets({
      source: source,
      target: args.element.parentElement,
      input: input,
      // Using bubble ordering. Same ordering as `event.getPath()`
      result: [].concat(_toConsumableArray(result), [record])
    });
  }
  function notifyCurrent(_ref3) {
    var eventName = _ref3.eventName,
      payload = _ref3.payload;
    var _iterator = _createForOfIteratorHelper$1(payload.location.current.dropTargets),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _entry$eventName;
        var record = _step.value;
        var entry = registry.get(record.element);
        var args = _objectSpread$1(_objectSpread$1({}, payload), {}, {
          self: record
        });
        entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry,
        // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        args);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  var actions = {
    onGenerateDragPreview: notifyCurrent,
    onDrag: notifyCurrent,
    onDragStart: notifyCurrent,
    onDrop: notifyCurrent,
    onDropTargetChange: function onDropTargetChange(_ref4) {
      var payload = _ref4.payload;
      var isCurrent = new Set(payload.location.current.dropTargets.map(function (record) {
        return record.element;
      }));
      var visited = new Set();
      var _iterator2 = _createForOfIteratorHelper$1(payload.location.previous.dropTargets),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _entry$onDropTargetCh;
          var record = _step2.value;
          visited.add(record.element);
          var entry = registry.get(record.element);
          var isOver = isCurrent.has(record.element);
          var args = _objectSpread$1(_objectSpread$1({}, payload), {}, {
            self: record
          });
          entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);

          // if we cannot find the drop target in the current array, then it has been left
          if (!isOver) {
            var _entry$onDragLeave;
            entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var _iterator3 = _createForOfIteratorHelper$1(payload.location.current.dropTargets),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _entry$onDropTargetCh2, _entry$onDragEnter;
          var _record = _step3.value;
          // already published an update to this drop target
          if (visited.has(_record.element)) {
            continue;
          }
          // at this point we have a new drop target that is being entered into
          var _args = _objectSpread$1(_objectSpread$1({}, payload), {}, {
            self: _record
          });
          var _entry = registry.get(_record.element);
          _entry === null || _entry === void 0 || (_entry$onDropTargetCh2 = _entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(_entry, _args);
          _entry === null || _entry === void 0 || (_entry$onDragEnter = _entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(_entry, _args);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  };
  function dispatchEvent(args) {
    actions[args.eventName](args);
  }
  function getIsOver(_ref5) {
    var source = _ref5.source,
      target = _ref5.target,
      input = _ref5.input,
      current = _ref5.current;
    var actual = getActualDropTargets({
      source: source,
      target: target,
      input: input
    });

    // stickiness is only relevant when we have less
    // drop targets than we did before
    if (actual.length >= current.length) {
      return actual;
    }

    // less 'actual' drop targets than before,
    // we need to see if 'stickiness' applies

    // An old drop target will continue to be dropped on if:
    // 1. it has the same parent
    // 2. nothing exists in it's previous index

    var lastCaptureOrdered = copyReverse(current);
    var actualCaptureOrdered = copyReverse(actual);
    var resultCaptureOrdered = [];
    for (var index = 0; index < lastCaptureOrdered.length; index++) {
      var _argsForLast$getIsSti;
      var last = lastCaptureOrdered[index];
      var fresh = actualCaptureOrdered[index];

      // if a record is in the new index -> use that
      // it will have the latest data + dropEffect
      if (fresh != null) {
        resultCaptureOrdered.push(fresh);
        continue;
      }

      // At this point we have no drop target in the old spot
      // Check to see if we can use a previous sticky drop target

      // The "parent" is the one inside of `resultCaptureOrdered`
      // (the parent might be a drop target that was sticky)
      var parent = resultCaptureOrdered[index - 1];
      var lastParent = lastCaptureOrdered[index - 1];

      // Stickiness is based on parent relationships, so if the parent relationship has change
      // then we can stop our search
      if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) {
        break;
      }

      // We need to check whether the old drop target can still be dropped on

      var argsForLast = registry.get(last.element);

      // We cannot drop on a drop target that is no longer mounted
      if (!argsForLast) {
        break;
      }
      var feedback = {
        input: input,
        source: source,
        element: argsForLast.element
      };

      // We cannot drop on a drop target that no longer allows being dropped on
      if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) {
        break;
      }

      // We cannot drop on a drop target that is no longer sticky
      if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) {
        break;
      }

      // Note: intentionally not recollecting `getData()` or `getDropEffect()`
      // Previous values for `data` and `dropEffect` will be borrowed
      // This is to prevent things like the 'closest edge' changing when
      // no longer over a drop target.
      // We could change our mind on this behaviour in the future

      resultCaptureOrdered.push(_objectSpread$1(_objectSpread$1({}, last), {}, {
        // making it clear to consumers this drop target is active due to stickiness
        isActiveDueToStickiness: true
      }));
    }

    // return bubble ordered result
    return copyReverse(resultCaptureOrdered);
  }
  return {
    dropTargetForConsumers: dropTargetForConsumers,
    getIsOver: getIsOver,
    dispatchEvent: dispatchEvent
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function makeMonitor() {
  var registry = new Set();
  var dragging = null;
  function tryAddToActive(monitor) {
    if (!dragging) {
      return;
    }
    // Monitor is allowed to monitor events if:
    // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
    // 2. `canMonitor` returns true
    if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) {
      dragging.active.add(monitor);
    }
  }
  function monitorForConsumers(args) {
    // We are giving each `args` a new reference so that you
    // can create multiple monitors with the same `args`.
    var entry = _objectSpread({}, args);
    registry.add(entry);

    // if there is an active drag we need to see if this new monitor is relevant
    tryAddToActive(entry);
    return function cleanup() {
      registry.delete(entry);

      // We need to stop publishing events during a drag to this monitor!
      if (dragging) {
        dragging.active.delete(entry);
      }
    };
  }
  function dispatchEvent(_ref) {
    var eventName = _ref.eventName,
      payload = _ref.payload;
    if (eventName === 'onGenerateDragPreview') {
      dragging = {
        canMonitorArgs: {
          initial: payload.location.initial,
          source: payload.source
        },
        active: new Set()
      };
      var _iterator = _createForOfIteratorHelper(registry),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var monitor = _step.value;
          tryAddToActive(monitor);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    // This should never happen.
    if (!dragging) {
      return;
    }

    // Creating an array from the set _before_ iterating
    // This is so that monitors added during the current event will not be called.
    // This behaviour matches native EventTargets where an event listener
    // cannot add another event listener during an active event to the same
    // event target in the same event (for us we have a single global event target)
    var active = Array.from(dragging.active);
    for (var _i = 0, _active = active; _i < _active.length; _i++) {
      var _monitor = _active[_i];
      // A monitor can be removed by another monitor during an event.
      // We need to check that the monitor is still registered before calling it
      if (dragging.active.has(_monitor)) {
        var _monitor$eventName;
        // @ts-expect-error: I cannot get this type working!
        (_monitor$eventName = _monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(_monitor, payload);
      }
    }
    if (eventName === 'onDrop') {
      dragging.active.clear();
      dragging = null;
    }
  }
  return {
    dispatchEvent: dispatchEvent,
    monitorForConsumers: monitorForConsumers
  };
}
function makeAdapter(_ref) {
  var typeKey = _ref.typeKey,
    mount = _ref.mount,
    dispatchEventToSource = _ref.dispatchEventToSource,
    onPostDispatch = _ref.onPostDispatch,
    defaultDropEffect = _ref.defaultDropEffect;
  var monitorAPI = makeMonitor();
  var dropTargetAPI = makeDropTarget({
    typeKey: typeKey,
    defaultDropEffect: defaultDropEffect
  });
  function dispatchEvent(args) {
    // 1. forward the event to source
    dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);

    // 2. forward the event to relevant dropTargets
    dropTargetAPI.dispatchEvent(args);

    // 3. forward event to monitors
    monitorAPI.dispatchEvent(args);

    // 4. post consumer dispatch (used for honey pot fix)
    onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
  }
  function start(_ref2) {
    var event = _ref2.event,
      dragType = _ref2.dragType;
    lifecycle.start({
      event: event,
      dragType: dragType,
      getDropTargetsOver: dropTargetAPI.getIsOver,
      dispatchEvent: dispatchEvent
    });
  }
  function registerUsage() {
    function mountAdapter() {
      var api = {
        canStart: lifecycle.canStart,
        start: start
      };
      return mount(api);
    }
    return register({
      typeKey: typeKey,
      mount: mountAdapter
    });
  }
  return {
    registerUsage: registerUsage,
    dropTarget: dropTargetAPI.dropTargetForConsumers,
    monitor: monitorAPI.monitorForConsumers
  };
}

// using `cache` as our `isAndroid()` result will not change in a browser
var isAndroid = once(function isAndroid() {
  return navigator.userAgent.toLocaleLowerCase().includes('android');
});
var androidFallbackText = 'pdnd:android-fallback';

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var textMediaType = 'text/plain';

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var URLMediaType = 'text/uri-list';

/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */
var elementAdapterNativeDataKey = 'application/vnd.pdnd';
var draggableRegistry = new WeakMap();
var honeyPotFix = makeHoneyPotFix();
var adapter = makeAdapter({
  typeKey: 'element',
  defaultDropEffect: 'move',
  mount: function mount(api) {
    /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */
    return combine(honeyPotFix.bindEvents(), dist.bind(document, {
      type: 'dragstart',
      listener: function listener(event) {
        var _entry$dragHandle, _entry$getInitialData, _entry$getInitialData2, _entry$dragHandle2, _entry$getInitialData3, _entry$getInitialData4;
        if (!api.canStart(event)) {
          return;
        }

        // If the "dragstart" event is cancelled, then a drag won't start
        // There will be no further drag operation events (eg no "dragend" event)
        if (event.defaultPrevented) {
          return;
        }

        // Technically `dataTransfer` can be `null` according to the types
        // But that behaviour does not seem to appear in the spec.
        // If there is not `dataTransfer`, we can assume something is wrong and not
        // start a drag
        if (!event.dataTransfer) {
          // Including this code on "test" and "development" environments:
          // - Browser tests commonly run against "development" builds
          // - Unit tests commonly run in "test"
          if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.warn("\n              It appears as though you have are not testing DragEvents correctly.\n\n              - If you are unit testing, ensure you have polyfilled DragEvent.\n              - If you are browser testing, ensure you are dispatching drag events correctly.\n\n              Please see our testing guides for more information:\n              https://atlassian.design/components/pragmatic-drag-and-drop/core-package/testing\n            ".replace(/ {2}/g, ''));
          }
          return;
        }

        // the closest parent that is a draggable element will be marked as
        // the `event.target` for the event
        var target = event.target;

        // this source is only for elements
        // Note: only HTMLElements can have the "draggable" attribute
        if (!(target instanceof HTMLElement)) {
          return null;
        }

        // see if the thing being dragged is owned by us
        var entry = draggableRegistry.get(target);

        // no matching element found
        // → dragging an element with `draggable="true"` that is not controlled by us
        if (!entry) {
          return null;
        }

        /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */

        var input = getInput(event);
        var feedback = {
          element: entry.element,
          dragHandle: (_entry$dragHandle = entry.dragHandle) !== null && _entry$dragHandle !== void 0 ? _entry$dragHandle : null,
          input: input
        };

        // Check: does the draggable want to allow dragging?
        if (entry.canDrag && !entry.canDrag(feedback)) {
          // cancel drag operation if we cannot drag
          event.preventDefault();
          return null;
        }

        // Check: is there a drag handle and is the user using it?
        if (entry.dragHandle) {
          // technically don't need this util, but just being
          // consistent with how we look up what is under the users
          // cursor.
          var over = getElementFromPointWithoutHoneypot({
            x: input.clientX,
            y: input.clientY
          });

          // if we are not dragging from the drag handle (or something inside the drag handle)
          // then we will cancel the active drag
          if (!entry.dragHandle.contains(over)) {
            event.preventDefault();
            return null;
          }
        }

        /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */
        var nativeData = (_entry$getInitialData = (_entry$getInitialData2 = entry.getInitialDataForExternal) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) !== null && _entry$getInitialData !== void 0 ? _entry$getInitialData : null;
        if (nativeData) {
          for (var _i = 0, _Object$entries = Object.entries(nativeData); _i < _Object$entries.length; _i++) {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              data = _Object$entries$_i[1];
            event.dataTransfer.setData(key, data !== null && data !== void 0 ? data : '');
          }
        }

        /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */
        if (isAndroid() && !event.dataTransfer.types.includes(textMediaType) && !event.dataTransfer.types.includes(URLMediaType)) {
          event.dataTransfer.setData(textMediaType, androidFallbackText);
        }

        /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */
        event.dataTransfer.setData(elementAdapterNativeDataKey, '');
        var payload = {
          element: entry.element,
          dragHandle: (_entry$dragHandle2 = entry.dragHandle) !== null && _entry$dragHandle2 !== void 0 ? _entry$dragHandle2 : null,
          data: (_entry$getInitialData3 = (_entry$getInitialData4 = entry.getInitialData) === null || _entry$getInitialData4 === void 0 ? void 0 : _entry$getInitialData4.call(entry, feedback)) !== null && _entry$getInitialData3 !== void 0 ? _entry$getInitialData3 : {}
        };
        var dragType = {
          type: 'element',
          payload: payload,
          startedFrom: 'internal'
        };
        api.start({
          event: event,
          dragType: dragType
        });
      }
    }));
  },
  dispatchEventToSource: function dispatchEventToSource(_ref) {
    var _draggableRegistry$ge, _draggableRegistry$ge2;
    var eventName = _ref.eventName,
      payload = _ref.payload;
    // During a drag operation, a draggable can be:
    // - remounted with different functions
    // - removed completely
    // So we need to get the latest entry from the registry in order
    // to call the latest event functions

    (_draggableRegistry$ge = draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge,
    // I cannot seem to get the types right here.
    // TS doesn't seem to like that one event can need `nativeSetDragImage`
    // @ts-expect-error
    payload);
  },
  onPostDispatch: honeyPotFix.getOnPostDispatch()
});
var monitorForElements = adapter.monitor;

/** Common event payload for all events */

/** A map containing payloads for all events */

/** Common event payload for all drop target events */

/** A map containing payloads for all events on drop targets */

/** Arguments given to all feedback functions (eg `canDrag()`) on for a `draggable()` */

/** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForElements()` */

/** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForElements` */

// import { useDragAndDrop } from './useDragAndDrop';
// import { Edge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/dist/types/types';
// import { DropIndicator } from '@atlaskit/pragmatic-drag-and-drop-react-drop-indicator/box';
// const Container = styled.div`
//     display: flex;
//     flex-direction: column;
//     width: 100%;
//     gap: 8px;
// `;
const LayoutWithBorder = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "modal-custom-field-groups__LayoutWithBorder",
  componentId: "zmv14e-0"
})(["border:1px solid ", ";border-radius:8px;position:relative;opacity:", ";background:", ";[class^='css-']{background-color:", ";}[class^='css-']::before{border:2px solid ", ";}"], _ref217 => {
  let {
    theme
  } = _ref217;
  return theme.designTokens.color.color.light['outline-variant'].value;
}, _ref218 => {
  let {
    dragging
  } = _ref218;
  return dragging ? 0.4 : 1;
}, props => props.theme.designTokens.color.color.surfaces['surface'].value, _ref219 => {
  let {
    theme
  } = _ref219;
  return theme.designTokens.color.color.primary.primary.value;
}, _ref220 => {
  let {
    theme
  } = _ref220;
  return theme.designTokens.color.color.primary.primary.value;
});
const LayoutWithBorderNoCFGExt = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "modal-custom-field-groups__LayoutWithBorderNoCFGExt",
  componentId: "zmv14e-1"
})(["border:1px dashed rgb(62,74,66,0.4);border-radius:8px;position:relative;background:", ";[class^='css-']{background-color:", ";}[class^='css-']::before{border:2px solid ", ";}"], props => props.theme.designTokens.color.color.surfaces['surface'].value, _ref221 => {
  let {
    theme
  } = _ref221;
  return theme.designTokens.color.color.primary.primary.value;
}, _ref222 => {
  let {
    theme
  } = _ref222;
  return theme.designTokens.color.color.primary.primary.value;
});
const DraggableContainer = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "modal-custom-field-groups__DraggableContainer",
  componentId: "zmv14e-2"
})(["opacity:", ";"], _ref223 => {
  let {
    dragging
  } = _ref223;
  return dragging ? 0.4 : 1;
});
const DragHandle = /*#__PURE__*/styled.div.withConfig({
  displayName: "modal-custom-field-groups__DragHandle",
  componentId: "zmv14e-3"
})(["cursor:grab;display:flex;align-items:center;gap:8px;"]);
const PointerContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "modal-custom-field-groups__PointerContainer",
  componentId: "zmv14e-4"
})([""]);
const DraggableItem = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "modal-custom-field-groups__DraggableItem",
  componentId: "zmv14e-5"
})(["width:100%;"]);
const GroupHeader = _ref224 => {
  let {
    name,
    hasRequiredFields
  } = _ref224;
  return jsxs(Layout, {
    stack: true,
    vAlign: "space-between",
    children: [jsx(Typography, {
      size: "xl",
      variant: "label",
      children: name
    }), jsx(Typography, {
      size: "small",
      variant: "label",
      color: "error-container",
      children: hasRequiredFields && '*Required Fields in this Group'
    })]
  });
};
const ModalCustomFieldGroups = _a => {
  var {
      group,
      index,
      groups,
      onReorder,
      isExpanded,
      onToggleExpand,
      instanceId,
      renderFieldComponent,
      canDrag,
      removeGroup,
      isCFGExtensionInstalled,
      entityId,
      removeEntity,
      bookingContext
    } = _a,
    props = __rest(_a, ["group", "index", "groups", "onReorder", "isExpanded", "onToggleExpand", "instanceId", "renderFieldComponent", "canDrag", "removeGroup", "isCFGExtensionInstalled", "entityId", "removeEntity", "bookingContext"]);
  const ref = useRef(null);
  // TODO: Commented out as sorting outside of the settings page is currently disabled and out of scope.
  // const [closestEdge, setClosestEdge] = useState<Edge | null>(null);
  // const [isMenuOpen, setIsMenuOpen] = useState(false);
  const moreRef = useRef(null);
  // TODO: Commented out as sorting outside of the settings page is currently disabled and out of scope.
  // const { state, moveUp, moveDown, moveToTop, moveToBottom } = useDragAndDrop(
  //     ref,
  //     groups,
  //     index,
  //     group._id as string,
  //     instanceId,
  //     setClosestEdge,
  //     onReorder,
  //     canDrag
  // );
  const filteredCFsForGroup = useMemo(() => {
    const filtered = props.customFields.filter(cf => group.customFields.includes(cf._id));
    return filtered;
  }, [props.customFields, group]);
  const hasRequiredFields = filteredCFsForGroup.some(cf => cf.isRequired);
  // const closeMenu = useCallback(() => {
  //     setIsMenuOpen(false);
  // }, []);
  // const nonBookingContextItems = useMemo<OptionsType[]>(
  //     () => [
  //         // TODO: Commented out as sorting outside of the settings page is currently disabled and out of scope.
  //         // {
  //         //     divider: true,
  //         // },
  //         {
  //             label: 'Remove From Group',
  //             disabled: !isCFGExtensionInstalled || group.entities.includes(entityId as string),
  //             onClick: (e) => {
  //                 e.stopPropagation();
  //                 closeMenu();
  //                 removeEntity(group._id, entityId as string);
  //             },
  //         },
  //     ],
  //     [removeEntity, closeMenu, entityId, group, isCFGExtensionInstalled]
  // );
  // const menuOptions = useMemo<OptionsType[]>(() => {
  //     // TODO: Commented out as sorting outside of the settings page is currently disabled and out of scope.
  //     // const options: OptionsType[] = [
  //     //     {
  //     //         label: 'Move to Top',
  //     //         disabled: groups.length === 1,
  //     //         onClick: (e) => {
  //     //             e.stopPropagation();
  //     //             closeMenu();
  //     //             // moveToTop();
  //     //         },
  //     //     },
  //     //     {
  //     //         label: 'Move to Bottom',
  //     //         disabled: groups.length === 1,
  //     //         onClick: (e) => {
  //     //             e.stopPropagation();
  //     //             closeMenu();
  //     //             // moveToBottom();
  //     //         },
  //     //     },
  //     //     {
  //     //         label: 'Move Up',
  //     //         disabled: groups.length === 1,
  //     //         onClick: (e) => {
  //     //             e.stopPropagation();
  //     //             closeMenu();
  //     //             // moveUp();
  //     //         },
  //     //     },
  //     //     {
  //     //         label: 'Move Down',
  //     //         disabled: groups.length === 1,
  //     //         onClick: (e) => {
  //     //             e.stopPropagation();
  //     //             closeMenu();
  //     //             // moveDown();
  //     //         },
  //     //     },
  //     // ];
  //     const options = [];
  //     if (!bookingContext && entityId) {
  //         options.push(...nonBookingContextItems);
  //     }
  //     return options;
  // }, [
  //     // TODO: Commented out as sorting outside of the settings page is currently disabled and out of scope.
  //     // closeMenu,
  //     // groups,
  //     // moveUp,
  //     // moveDown,
  //     // moveToTop,
  //     // moveToBottom,
  //     nonBookingContextItems,
  //     bookingContext,
  //     entityId,
  // ]);
  const handleExpandIconClick = useCallback(event => {
    event.stopPropagation();
    if (group.customFields.length) {
      onToggleExpand();
    }
  }, [group.customFields.length, onToggleExpand]);
  return jsxs(Fragment, {
    children: [jsxs(LayoutWithBorder, {
      stack: true,
      ref: ref,
      children: [jsx(DraggableContainer, {
        vAlign: "center",
        pt: "--Spacing-100",
        pb: "--Spacing-100",
        pl: "--Spacing-200",
        pr: "--Spacing-200",
        hAlign: "space-between",
        children: jsxs(DraggableItem, {
          vAlign: "center",
          hAlign: "space-between",
          gap: "--Spacing-200",
          onClick: e => {
            e.stopPropagation();
            if (group.customFields.length !== 0) {
              onToggleExpand();
            }
          },
          children: [jsx(DragHandle, {
            children: jsx(GroupHeader, {
              name: group.name,
              hasRequiredFields: hasRequiredFields
            })
          }), jsx(Layout, {
            vAlign: "center",
            children: jsx(IconButton, {
              onClick: handleExpandIconClick,
              icon: isExpanded ? 'chevronUp' : 'chevronDown',
              disabled: group.customFields.length === 0
            })
          })]
        })
      }), isExpanded && (renderFieldComponent ? jsx(Layout, {
        stack: true,
        gap: "--Spacing-400",
        pb: "--Spacing-400",
        pl: "--Spacing-200",
        pt: "--Spacing-200",
        pr: "--Spacing-200",
        children: filteredCFsForGroup.map(renderFieldComponent)
      }) : jsx(CustomFields, Object.assign({}, props, {
        removeEntity: removeEntity,
        customFieldGroups: [group],
        isCFGExtensionInstalled: isCFGExtensionInstalled
      })))]
    }), !isCFGExtensionInstalled && jsx(LayoutWithBorderNoCFGExt, {
      stack: true,
      ref: ref,
      children: jsx(DraggableContainer, {
        vAlign: "center",
        pt: "--Spacing-100",
        pb: "--Spacing-100",
        pl: "--Spacing-200",
        pr: "--Spacing-200",
        hAlign: "space-between",
        children: jsxs(DraggableItem, {
          vAlign: "center",
          hAlign: "space-between",
          gap: "--Spacing-200",
          children: [jsx("div", {
            style: {
              opacity: 0.4
            },
            children: jsxs(Layout, {
              gap: "--Spacing-200",
              vAlign: "center",
              children: [jsx(IconButton, {
                icon: "dragIndicator"
              }), jsx(GroupHeader, {
                name: "Add New Custom Field Group?",
                hasRequiredFields: false
              })]
            })
          }), jsxs(Layout, {
            vAlign: "center",
            hAlign: "flex-end",
            children: [jsx(Button, {
              endIcon: "add",
              onClick: () => window.location.href = '/settings#extensions',
              children: "Add Extension"
            }), jsx("div", {
              style: {
                opacity: 0.4
              },
              children: jsx(PointerContainer, {
                ref: moreRef,
                children: jsx(IconButton, {
                  icon: "more",
                  iconSize: 24
                })
              })
            }), jsx("div", {
              style: {
                opacity: 0.4
              },
              children: jsx(IconButton, {
                icon: isExpanded ? 'chevronUp' : 'chevronDown',
                disabled: group.customFields.length === 0,
                onClick: handleExpandIconClick
              })
            })]
          })]
        })
      })
    })]
  });
};
const Container$3 = /*#__PURE__*/styled.div.withConfig({
  displayName: "custom-field-groups-container__Container",
  componentId: "sc-1g85es9-0"
})(["display:flex;flex-direction:column;width:100%;gap:8px;"]);
const CustomFieldGroupsContainer = _a => {
  var {
      groups,
      onReorder,
      isCFExtensionInstalled,
      isCFGExtensionInstalled,
      removeGroup,
      entityId,
      bookingContext,
      navigateToCFSettings
    } = _a,
    props = __rest(_a, ["groups", "onReorder", "isCFExtensionInstalled", "isCFGExtensionInstalled", "removeGroup", "entityId", "bookingContext", "navigateToCFSettings"]);
  const containerRef = useRef(null);
  const [expandedId, setExpandedId] = useState({});
  const [instanceId] = useState(() => Symbol('instance-id'));
  const hasRoleRight = useCanUserSeeExtensionsSettingsPage();
  const allExpanded = useMemo(() => {
    return groups === null || groups === void 0 ? void 0 : groups.every(group => {
      return expandedId[group._id];
    });
  }, [expandedId, groups]);
  const someExpanded = useMemo(() => {
    return groups === null || groups === void 0 ? void 0 : groups.some(group => {
      return expandedId[group._id];
    });
  }, [expandedId, groups]);
  const expandToggleInitialized = useRef(false);
  useEffect(() => {
    if ((groups === null || groups === void 0 ? void 0 : groups.length) === 1 && !expandToggleInitialized.current) {
      setExpandedId((groups === null || groups === void 0 ? void 0 : groups.reduce((acc, group) => {
        acc[group._id] = true;
        return acc;
      }, {})) || {});
      expandToggleInitialized.current = true;
    }
  }, [groups]);
  useEffect(() => {
    if (!containerRef.current) return;
    return combine(monitorForElements({
      canMonitor(_ref225) {
        let {
          source
        } = _ref225;
        return source.data.instanceId === instanceId;
      },
      onDrop(args) {
        const {
          location,
          source
        } = args;
        if (!location.current.dropTargets.length) return;
        if (source.data.type === 'custom-field-group') {
          const startIndex = source.data.index;
          const target = location.current.dropTargets[0];
          const indexOfTarget = target.data.index;
          const closestEdgeOfTarget = extractClosestEdge(target.data);
          const finishIndex = getReorderDestinationIndex({
            startIndex,
            indexOfTarget,
            closestEdgeOfTarget,
            axis: 'vertical'
          });
          if (startIndex !== finishIndex) {
            onReorder(startIndex, finishIndex);
            triggerPostMoveFlash(target.element);
          }
        }
      }
    }));
  }, [groups, onReorder, instanceId]);
  const handleExpandAllToggle = () => {
    if (allExpanded) {
      setExpandedId({});
    } else {
      setExpandedId((groups === null || groups === void 0 ? void 0 : groups.reduce((acc, group) => {
        acc[group._id] = true;
        return acc;
      }, {})) || {});
    }
  };
  if (!isCFExtensionInstalled && hasRoleRight) {
    return jsxs(Layout, {
      stack: true,
      gap: 40,
      children: [jsxs(Layout, {
        stack: true,
        hAlign: "center",
        gap: "--Spacing-300",
        children: [jsx("div", {
          style: {
            width: '100%'
          },
          children: jsx(Layout, {
            hAlign: "center",
            fullHeight: true,
            children: jsx(Icon, {
              name: "missing_extension",
              size: 132
            })
          })
        }), jsx(Typography, {
          variant: "label",
          size: "large",
          align: "center",
          children: "Oops! Looks like you're missing this extension! \n Don't worry, it's just a quick install away. Click below to read more or install."
        })]
      }), jsxs(Layout, {
        stack: true,
        gap: "--Spacing-400",
        children: [jsxs(Layout, {
          gap: "--Spacing-50",
          stack: true,
          children: [jsx(Typography, {
            variant: "title",
            size: "medium",
            children: "Custom Fields Extension"
          }), jsx(Typography, {
            variant: "body",
            size: "small",
            children: "Create your own resource and project Custom Fields. Allowing you to mimic your \n own business terminology in Hub Planner."
          })]
        }), jsxs(Layout, {
          gap: 10,
          children: [jsx(Button, {
            endIcon: "arrowOutward",
            variant: "outlined",
            onClick: () => window.open('https://hubplanner.com/custom-fields-customize-your-resourcing-to-work-the-way-you-do/', '_blank'),
            children: "Learn more about Custom Fields"
          }), jsx(Button, {
            endIcon: "add",
            variant: "outlined",
            onClick: () => window.location.href = '/settings#extensions',
            children: "Add Custom Fields Extension"
          })]
        })]
      })]
    });
  }
  if (groups.length === 0) {
    const entity = props.category === 'project' ? 'Project' : 'Resource';
    return jsxs(Layout, {
      stack: true,
      hAlign: "center",
      gap: "--Spacing-200",
      children: [jsxs(Layout, {
        stack: true,
        hAlign: "center",
        children: [jsx(Typography, {
          variant: "label",
          size: "large",
          align: "center",
          children: "Seems like you do not have any Custom Field Groups for this ".concat(entity, " yet.")
        }), jsx(Typography, {
          variant: "label",
          size: "large",
          align: "center",
          children: "Head on over to the Custom Field Settings and start adding some."
        })]
      }), jsx("div", {
        style: {
          width: 288
        },
        children: jsx(Button, {
          variant: "outlined",
          endIcon: "arrowForward",
          onClick: navigateToCFSettings,
          children: "Go to Custom Field Settings"
        })
      })]
    });
  }
  return jsxs(Container$3, {
    ref: containerRef,
    children: [jsx(Switch, {
      label: "Expand All Groups",
      onChange: handleExpandAllToggle,
      checked: allExpanded,
      disabled: groups.length === 0
    }), groups.map((group, index) => jsx(ModalCustomFieldGroups, Object.assign({
      group: group,
      index: index,
      groups: groups,
      onReorder: onReorder,
      isExpanded: Boolean(expandedId[group._id]),
      onToggleExpand: () => {
        setExpandedId(prev => {
          return Object.assign(Object.assign({}, prev), {
            [group._id]: !prev[group._id]
          });
        });
      },
      instanceId: instanceId,
      canDrag: !someExpanded,
      isCFGExtensionInstalled: isCFGExtensionInstalled,
      isCFExtensionInstalled: isCFExtensionInstalled,
      removeGroup: removeGroup,
      entityId: entityId,
      bookingContext: bookingContext
    }, props), group._id))]
  });
};
const Wrapper$3 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "missing-extension-page__Wrapper",
  componentId: "sc-1syffp0-0"
})(["margin:0 auto;width:100%;height:100vh;padding:56px 85px;"]);
const MissingExtension = _ref226 => {
  let {
    headerText,
    headerIcon,
    hasViewRights,
    bottomLeftContent,
    bottomRightContent,
    extensionTitle,
    subTitle,
    actionButtonText,
    infoPoints,
    mainImageComponent,
    onInstallClick
  } = _ref226;
  const handleInstallBtnClick = useCallback(event => {
    event.preventDefault();
    if (onInstallClick) {
      onInstallClick(event);
    } else {
      window.location.href = '/settings#extensions';
    }
  }, [onInstallClick]);
  return jsxs(Wrapper$3, {
    stack: true,
    vAlign: "flex-start",
    children: [jsxs(Layout, {
      gap: "--Spacing-100",
      vAlign: "center",
      children: [jsx(Layout, {
        flex: "0 0 32px",
        children: jsx(Icon, {
          name: headerIcon,
          size: 32
        })
      }), jsx(Typography, {
        variant: "label",
        size: "xl",
        color: "on-surface-variant",
        prominent: true,
        children: headerText
      })]
    }), jsxs(Layout, {
      pt: 46,
      gap: 48,
      children: [jsx(Layout, {
        flex: "0 1 497px",
        stack: true,
        children: mainImageComponent
      }), jsxs(Layout, {
        flex: "0 1 379px",
        stack: true,
        gap: 32,
        children: [jsxs(Layout, {
          stack: true,
          gap: "--Spacing-50",
          children: [jsx(Typography, {
            variant: "display",
            size: "small",
            prominent: true,
            color: "on-surface-variant",
            children: extensionTitle
          }), jsx(Typography, {
            variant: "label",
            size: "medium",
            prominent: true,
            color: "on-surface-variant",
            children: subTitle
          })]
        }), jsx(Layout, {
          stack: true,
          gap: "--Spacing-100",
          children: infoPoints.map((item, index) => jsxs(Layout, {
            gap: "--Spacing-100",
            vAlign: "center",
            children: [jsx(Icon, {
              name: "arrowForward"
            }), jsx(Typography, {
              variant: "label",
              size: "large",
              prominent: true,
              children: item
            })]
          }, index))
        }), hasViewRights && jsx(Layout, {
          children: jsx(Button, {
            onClick: handleInstallBtnClick,
            endIcon: "arrowForward",
            children: actionButtonText
          })
        })]
      })]
    }), jsxs(Layout, {
      pt: 118,
      gap: 48,
      children: [jsx(Layout, {
        flex: "0 1 500px",
        stack: true,
        gap: 100,
        children: bottomLeftContent
      }), jsx(Layout, {
        flex: "1 1 auto",
        stack: true,
        children: bottomRightContent
      })]
    })]
  });
};
function currentDateString(dateString) {
  if (dateString) {
    return new Date(dateString).toISOString();
  }
  return new Date().toISOString();
}
const shouldRenderReview = (company, user, rating) => {
  var _a;
  if (!company.reviews) {
    return false;
  }
  if (!company.reviews.enabled) {
    return false;
  }
  if (!((_a = company.reviews.enabledForRoles) === null || _a === void 0 ? void 0 : _a.includes(user.role))) {
    return false;
  }
  const timeSinceFirstOpened = calculateDifference(new Date(), rating.reviewOpenDate, 'day');
  if (timeSinceFirstOpened >= 7 && rating.originalScore === null) {
    return false;
  }
  if (rating.originalScore) {
    return false;
  }
  return true;
};
const FeedbackContext = /*#__PURE__*/createContext(undefined);
const FeedbackProvider = _ref227 => {
  let {
    children,
    company,
    user,
    userRating,
    onSubmitRating,
    onUpdateRating,
    contactSupport
  } = _ref227;
  var _a;
  const userCompanyState = useMemo(() => ({
    email: user.email,
    rid: user.rid,
    cid: user.cid,
    firstName: user.firstName,
    lastName: user.lastName,
    companyname: company.companyname,
    subdomain: company.subdomain,
    status: company.status,
    plan: company.plan,
    role: user.role,
    companyResCount: company.companyResCount
  }), [user, company]);
  const [rating, setRating] = useState(() => Object.assign(Object.assign({
    reviewOpened: false,
    reviewOpenDate: '',
    reviewScore: null,
    originalScore: null,
    changeAnswerClicked: false,
    reviewSubmitted: false,
    contactCsTeamClicked: false,
    leaveReviewG2Clicked: false,
    feedback: '',
    hasViewed: false
  }, userCompanyState), userRating));
  const shouldRender = useMemo(() => shouldRenderReview(company, user, rating), [company, user, rating]);
  const updateRatingState = newRating => {
    setRating(prev => {
      const updatedRating = Object.assign(Object.assign({}, rating), newRating);
      onUpdateRating(newRating).catch(error => {
        console.error('Error updating rating:', error);
        setRating(prev);
      });
      return updatedRating;
    });
  };
  const setRatingScore = score => {
    const newRating = rating.originalScore ? {
      reviewScore: score,
      changeAnswerClicked: true
    } : {
      originalScore: score,
      reviewScore: score,
      reviewSubmitted: true
    };
    updateRatingState(newRating);
  };
  const updateFeedback = feedback => {
    setRating(prev => Object.assign(Object.assign({}, prev), {
      feedback
    }));
  };
  const handleOpen = () => {
    const openDate = rating.reviewOpenDate || currentDateString();
    const newRating = {
      reviewOpenDate: openDate,
      reviewOpened: true,
      hasViewed: true
    };
    if (userRating === null) {
      // create a new rating
      const ratingObject = Object.assign(Object.assign({}, rating), newRating);
      updateRatingState(ratingObject);
      return onSubmitRating(ratingObject).catch(error => console.error('Error submitting rating:', error));
    }
    updateRatingState(newRating);
  };
  const handleSubmit = () => {
    onSubmitRating(rating).catch(error => console.error('Error submitting rating:', error));
  };
  const handleContactSupport = message => {
    updateRatingState({
      contactCsTeamClicked: true,
      feedback: message
    });
    contactSupport(message);
  };
  const onLeaveReview = () => {
    updateRatingState({
      leaveReviewG2Clicked: true
    });
  };
  return jsx(FeedbackContext.Provider, {
    value: {
      shouldRender,
      hasViewed: rating.hasViewed,
      rating: rating.reviewScore,
      feedback: rating.feedback,
      isG2: (_a = company.reviews) === null || _a === void 0 ? void 0 : _a.enabledG2,
      setRating: setRatingScore,
      setFeedback: updateFeedback,
      handleOpen,
      handleSubmit,
      onLeaveReview,
      handleContactSupport
    },
    children: children
  });
};
const useFeedback = () => {
  const context = useContext(FeedbackContext);
  if (context === undefined) {
    throw new Error('useFeedback must be used within a FeedbackProvider');
  }
  return context;
};
var call$1 = functionCall;
var hasOwn = hasOwnProperty_1;
var isPrototypeOf = objectIsPrototypeOf;
var regExpFlags = regexpFlags$1;
var RegExpPrototype$1 = RegExp.prototype;
var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$1) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype$1, R) ? call$1(regExpFlags, R) : flags;
};
var PROPER_FUNCTION_NAME = functionName.PROPER;
var defineBuiltIn = defineBuiltIn$9;
var anObject$1 = anObject$r;
var $toString = toString$g;
var fails$3 = fails$y;
var getRegExpFlags = regexpGetFlags;
var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];
var NOT_GENERIC = fails$3(function () {
  return nativeToString.call({
    source: 'a',
    flags: 'b'
  }) !== '/a/b';
});
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExpPrototype, TO_STRING, function toString() {
    var R = anObject$1(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, {
    unsafe: true
  });
}
const getRatingColor = rating => {
  if (rating && rating < 5) {
    return '#D1240D';
  }
  if (rating && rating >= 5 && rating < 8) {
    return '#FF6600';
  }
  return '#36633E';
};
const Rating = /*#__PURE__*/styled(Chip).attrs({
  className: 'custom-rating'
}).withConfig({
  displayName: "rating__Rating",
  componentId: "t9vqz6-0"
})(["&&{&.custom-rating{background-color:", ";color:white;border:none;}}"], props => getRatingColor(props === null || props === void 0 ? void 0 : props.rating));
const scaleLength = 10;
const RatingScale = _ref228 => {
  let {
    setRating
  } = _ref228;
  const scale = useMemo(() => Array.from({
    length: scaleLength
  }, (_, i) => i + 1), []);
  return jsx(Layout, {
    hAlign: "space-between",
    children: scale.map(value => jsx(Chip, {
      label: value.toString(),
      onClick: () => setRating(value)
    }))
  });
};
const titleConfigs = [{
  condition: rating => rating === null,
  text: 'Thanks for being with us!'
}, {
  condition: rating => rating !== null && rating < 5,
  text: 'Houston, I think we have a problem!'
}, {
  condition: rating => rating !== null && rating < 8,
  text: 'What could we improve?'
}, {
  condition: rating => rating !== null && rating >= 8,
  text: 'Wow, Wow, Wow!'
}];
const ratingFeedBackText = [{
  condition: rating => rating === null || rating === -1,
  text: "Thinking we could do something better? Or have an idea of something missing? We strive for user satisfaction and product evolution so we're all ears and would love to hear more from you. Drop us a line with your ideas for improvement."
}, {
  condition: rating => rating !== null && rating < 5,
  text: 'Your satisfaction with Hub Planner is our top priority, and we apologise for any issues you’re experiencing. We genuinely want to understand your concerns and resolve them promptly. Please contact our customer support team, as we are eager to speak with you and help. Rest assured, we’re here to assist you.'
}, {
  condition: rating => rating !== null && rating < 8,
  text: 'Thinking we could do something better? Or have an idea of something missing? We strive for user satisfaction and product evolution so we all ears and would love to hear more from you. Drop us a line with your ideas for improvement.'
}, {
  condition: rating => rating !== null && rating >= 8,
  text: "Thank you so much for the fantastic rating! We're thrilled you had such a great experience. If you have a moment, we'd love to hear what made it special for you. Your feedback helps us keep improving!"
}];
const useFeedbackDialog = _ref229 => {
  let {
    onClose,
    onSubmit,
    onContactSupport,
    onLeaveReview,
    rating,
    feedback,
    setRating,
    setFeedback,
    isG2
  } = _ref229;
  const [csMessage, setCsMessage] = useState('');
  const [showContactCS, setShowContactCS] = useState(false);
  const changeAnswer = useCallback(() => setRating(null), [setRating]);
  const leaveG2Review = useCallback(() => {
    var _a;
    onLeaveReview();
    onClose();
    return (_a = window === null || window === void 0 ? void 0 : window.open('https://www.g2.com/contributor/hubplanner_vs_rl_email?secure%5Bpage_id%5D=hubplanner_vs_rl_email&secure%5Brewards%5D=true&secure%5Btoken%5D=386e43aa27a7e7590beaefdd3110ab81b2a8f36fe24b590b43da6c1a1feade51&utm_medium=product&utm_campaign=MKT-Product-G2-Reviews-2024&utm_source=Product', '_blank')) === null || _a === void 0 ? void 0 : _a.focus();
  }, [onLeaveReview, onClose]);
  const handleSubmit = useCallback(() => {
    onClose();
    onSubmit(feedback);
  }, [feedback, onSubmit, onClose]);
  const handleFeedbackChange = useCallback(e => {
    setFeedback(e.target.value);
  }, [setFeedback]);
  const getTitle = useCallback(rating => {
    const index = titleConfigs.findIndex(config => config.condition(rating));
    return index !== -1 ? titleConfigs[index].text : 'Thanks for being with us!';
  }, []);
  const getRatingFeedBackText = useCallback(rating => {
    const index = ratingFeedBackText.findIndex(config => config.condition(rating));
    if (rating && rating >= 8 && isG2) {
      return 'Loving Hub Planner? Share your experience on G2!';
    }
    return ratingFeedBackText[index].text;
  }, [isG2]);
  const titleElement = useMemo(() => jsxs(Layout, {
    stretch: true,
    vAlign: "center",
    hAlign: "space-between",
    children: [jsx(Typography, {
      variant: "title",
      size: "large",
      children: showContactCS ? 'Contact our CS Team' : getTitle(rating)
    }), jsx(IconButton, {
      icon: showContactCS ? 'close' : 'unfold',
      onClick: onClose
    })]
  }), [rating, onClose, getTitle, showContactCS]);
  const contentElement = useMemo(() => {
    if (showContactCS) {
      return jsx("div", {
        style: {
          width: 500,
          boxSizing: 'content-box'
        },
        children: jsxs(Layout, {
          stretch: true,
          stack: true,
          gap: "--Spacing-300",
          children: [jsx(Typography, {
            variant: "body",
            size: "medium",
            color: "on-surface-variant",
            children: "Please use the form below to contact us."
          }), jsx(TextField, {
            multiline: true,
            minRows: 7,
            placeholder: "How may we help you?",
            label: "Message",
            onChange: e => setCsMessage(e.target.value),
            value: csMessage
          })]
        })
      });
    }
    if (rating === null) {
      return jsx("div", {
        style: {
          width: 500,
          boxSizing: 'content-box'
        },
        children: jsxs(Layout, {
          stack: true,
          gap: "--Spacing-200",
          children: [jsx(Typography, {
            variant: "body",
            size: "large",
            color: "on-surface-variant",
            children: "Your feedback helps us improve the platform."
          }), jsxs(Layout, {
            stack: true,
            gap: "--Spacing-100",
            children: [jsx(Typography, {
              variant: "body",
              size: "medium",
              color: "on-surface-variant",
              children: "Rate your overall experience of Hub Planner on a scale of 1 - 10."
            }), jsx(RatingScale, {
              setRating: setRating
            })]
          })]
        })
      });
    }
    return jsx("div", {
      style: {
        width: 500,
        boxSizing: 'content-box'
      },
      children: jsxs(Layout, {
        stack: true,
        gap: "--Spacing-200",
        children: [jsxs(Layout, {
          gap: "--Spacing-100",
          vAlign: "center",
          children: [jsx(Typography, {
            variant: "body",
            size: "large",
            children: "You submitted a"
          }), jsx(Rating, {
            label: rating === null || rating === void 0 ? void 0 : rating.toString(),
            rating: rating
          })]
        }), jsx(Typography, {
          variant: "body",
          size: "medium",
          color: "on-surface-variant",
          children: getRatingFeedBackText(rating)
        }), isG2 && rating && rating >= 8 && jsxs(Layout, {
          stack: true,
          hAlign: "center",
          gap: "--Spacing-100",
          stretch: true,
          children: [jsx(Typography, {
            children: "Get a $25 Amazon gift card as our thanks for a stellar review"
          }), jsxs("div", {
            style: {
              width: 423
            },
            children: [jsx(Image$1, {
              name: "amazonG2",
              height: 127,
              width: 423
            }), jsx(Layout, {
              hAlign: "flex-start",
              stretch: true,
              children: jsxs("ul", {
                style: {
                  listStyleType: 'disc',
                  color: '#3E4A42',
                  paddingLeft: 14
                },
                children: [jsx("li", {
                  children: jsx(Typography, {
                    variant: "body",
                    size: "small",
                    color: "on-surface-variant",
                    children: "2 minutes of your time"
                  })
                }), jsx("li", {
                  children: jsx(Typography, {
                    variant: "body",
                    size: "small",
                    color: "on-surface-variant",
                    children: "Help shape our future"
                  })
                }), jsx("li", {
                  children: jsx(Typography, {
                    variant: "body",
                    size: "small",
                    color: "on-surface-variant",
                    children: "Guide others to their ideal solution"
                  })
                })]
              })
            })]
          })]
        }), !isG2 && jsxs(React__default.Fragment, {
          children: [jsx(TextField, {
            multiline: true,
            minRows: 3,
            value: feedback,
            onChange: handleFeedbackChange,
            placeholder: "Please let us know why you have chosen this rating.",
            label: "Feedback"
          }), jsx(Typography, {
            variant: "body",
            size: "small",
            color: "on-surface-variant",
            children: "This is optional, but greatly appreciated"
          })]
        })]
      })
    });
  }, [rating, setRating, feedback, isG2, getRatingFeedBackText, handleFeedbackChange, showContactCS, csMessage]);
  const actionsElement = useMemo(() => {
    if (rating === null) return null;
    if (showContactCS) {
      return jsxs(Layout, {
        hAlign: "flex-end",
        gap: "--Spacing-100",
        children: [jsx(Button, {
          onClick: () => setShowContactCS(false),
          variant: "outlined",
          children: "Back"
        }), jsx(Button, {
          disabled: csMessage === '',
          onClick: () => {
            onContactSupport && onContactSupport(csMessage);
            onClose();
          },
          children: "Submit"
        })]
      });
    }
    if (rating && rating < 5) {
      if (isG2) {
        return jsxs(Layout, {
          gap: "--Spacing-100",
          hAlign: "flex-end",
          children: [jsx(Button, {
            variant: "text",
            onClick: changeAnswer,
            children: "Change answer"
          }), onContactSupport && jsx(Button, {
            onClick: () => setShowContactCS(true),
            children: "Contact our CS Team"
          })]
        });
      }
      return jsxs(Layout, {
        gap: "--Spacing-100",
        hAlign: "flex-end",
        children: [jsx(Button, {
          variant: "outlined",
          onClick: changeAnswer,
          children: "Change answer"
        }), jsx(Button, {
          disabled: feedback === '',
          onClick: handleSubmit,
          children: "Submit feedback"
        })]
      });
    }
    if (isG2) {
      return jsxs(Layout, {
        gap: "--Spacing-100",
        hAlign: "flex-end",
        children: [jsx(Button, {
          variant: "text",
          onClick: changeAnswer,
          children: "Change answer"
        }), rating && rating >= 8 && jsx(Button, {
          onClick: leaveG2Review,
          children: "Leave a Review"
        }), onContactSupport && rating && rating < 8 && jsx(Button, {
          onClick: () => setShowContactCS(true),
          children: "Contact our CS Team"
        })]
      });
    }
    if (rating && rating > 7) {
      return jsx(Layout, {
        hAlign: "flex-end",
        children: jsx(Button, {
          disabled: feedback === '',
          onClick: handleSubmit,
          children: "Submit feedback"
        })
      });
    }
    return jsxs(Layout, {
      gap: "--Spacing-100",
      hAlign: "flex-end",
      children: [jsx(Button, {
        variant: "text",
        onClick: changeAnswer,
        children: "Change answer"
      }), jsx(Button, {
        disabled: feedback === '',
        onClick: handleSubmit,
        children: "Submit feedback"
      })]
    });
  }, [isG2, rating, feedback, csMessage, showContactCS, onClose, changeAnswer, handleSubmit, leaveG2Review, onContactSupport]);
  return {
    titleElement,
    contentElement,
    actionsElement,
    rating,
    feedback,
    onClose
  };
};
const createSyntheticClickEvent = element => {
  const nativeClick = new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window
  });
  return Object.assign(Object.assign({}, nativeClick), {
    currentTarget: element,
    target: element
  });
};
const InProductReviewComponent = () => {
  const {
    isG2,
    rating,
    feedback,
    hasViewed,
    shouldRender,
    setRating,
    handleOpen,
    setFeedback,
    handleSubmit,
    onLeaveReview,
    handleContactSupport
  } = useFeedback();
  const {
    open,
    isOpen,
    anchorElement,
    close
  } = useOpenState();
  const {
    titleElement,
    actionsElement,
    contentElement,
    onClose
  } = useFeedbackDialog({
    isG2,
    rating,
    feedback,
    setRating,
    setFeedback,
    onClose: close,
    onSubmit: handleSubmit,
    onContactSupport: handleContactSupport,
    onLeaveReview
  });
  const [isButtonMounted, setIsButtonMounted] = useState(false);
  const shouldDefaultOpen = useMemo(() => isButtonMounted && !hasViewed, [isButtonMounted, hasViewed]);
  const isDialogOpen = shouldDefaultOpen || isOpen;
  const buttonRef = useRef(null);
  const onOpen = useCallback(e => {
    handleOpen();
    open(e);
  }, [handleOpen, open]);
  useEffect(() => {
    if (buttonRef.current) {
      setIsButtonMounted(true);
    }
  }, []);
  useEffect(() => {
    if (isDialogOpen && !hasViewed && buttonRef.current) {
      const event = createSyntheticClickEvent(buttonRef.current);
      onOpen(event);
    }
  }, [isDialogOpen, hasViewed, onOpen]);
  return (shouldRender || isOpen) && jsxs("div", {
    id: "in-product-review-container",
    children: [jsx(Fab, {
      onClick: onOpen,
      icon: "feedback_thumb",
      iconSize: 32,
      ref: buttonRef
    }), jsx(Dialog, {
      open: shouldDefaultOpen || isOpen,
      title: titleElement,
      actions: actionsElement,
      content: contentElement,
      onClose: onClose,
      anchorElement: shouldDefaultOpen ? buttonRef.current : anchorElement,
      anchorOriginPosition: {
        vertical: 'top',
        horizontal: 'left'
      },
      transformOriginPosition: {
        vertical: 'bottom',
        horizontal: 'right'
      }
    })]
  });
};
const InProductReview = _ref230 => {
  let {
    company,
    user,
    userRating,
    submitRating,
    updateRating,
    onContactSupport
  } = _ref230;
  return jsx(FeedbackProvider, {
    company: company,
    user: user,
    userRating: userRating,
    onSubmitRating: submitRating,
    onUpdateRating: updateRating,
    contactSupport: onContactSupport,
    children: jsx(InProductReviewComponent, {})
  });
};
const StyledWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "loader__StyledWrapper",
  componentId: "sc-1v4a5un-0"
})(["display:flex;justify-content:center;align-items:center;flex-direction:column;"]);
const combinedPulse = /*#__PURE__*/keyframes$1(["0%{transform:scale(1);opacity:0.1;}50%{transform:scale(0.93);opacity:1;}100%{transform:scale(1);opacity:0.1;}"]);
const AnimatedWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "loader__AnimatedWrapper",
  componentId: "sc-1v4a5un-1"
})(["display:inline-block;animation:", " 1400ms linear 1ms infinite;"], combinedPulse);
const Loader = _ref231 => {
  let {
    text
  } = _ref231;
  return jsxs(StyledWrapper, {
    children: [jsx(AnimatedWrapper, {
      children: jsx(Logo$1, {
        variant: "icon",
        logoSize: 125,
        logoColor: "inverse-on-surface"
      })
    }), jsx(Typography, {
      color: "surface-variant",
      align: "center",
      children: text
    })]
  });
};
const LayoutGroupContext = createContext({});

/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */
function useConstant(init) {
  const ref = useRef(null);
  if (ref.current === null) {
    ref.current = init();
  }
  return ref.current;
}

/**
 * @public
 */
const PresenceContext = createContext(null);

/**
 * @public
 */
const MotionConfigContext = createContext({
  transformPagePoint: p => p,
  isStatic: false,
  reducedMotion: "never"
});

/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */
class PopChildMeasure extends React.Component {
  getSnapshotBeforeUpdate(prevProps) {
    const element = this.props.childRef.current;
    if (element && prevProps.isPresent && !this.props.isPresent) {
      const size = this.props.sizeRef.current;
      size.height = element.offsetHeight || 0;
      size.width = element.offsetWidth || 0;
      size.top = element.offsetTop;
      size.left = element.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {}
  render() {
    return this.props.children;
  }
}
function PopChild(_ref232) {
  let {
    children,
    isPresent
  } = _ref232;
  const id = useId();
  const ref = useRef(null);
  const size = useRef({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  });
  const {
    nonce
  } = useContext(MotionConfigContext);
  /**
   * We create and inject a style block so we can apply this explicit
   * sizing in a non-destructive manner by just deleting the style block.
   *
   * We can't apply size via render as the measurement happens
   * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
   * styles directly on the DOM node, we might be overwriting
   * styles set via the style prop.
   */
  useInsertionEffect(() => {
    const {
      width,
      height,
      top,
      left
    } = size.current;
    if (isPresent || !ref.current || !width || !height) return;
    ref.current.dataset.motionPopId = id;
    const style = document.createElement("style");
    if (nonce) style.nonce = nonce;
    document.head.appendChild(style);
    if (style.sheet) {
      style.sheet.insertRule("\n          [data-motion-pop-id=\"".concat(id, "\"] {\n            position: absolute !important;\n            width: ").concat(width, "px !important;\n            height: ").concat(height, "px !important;\n            top: ").concat(top, "px !important;\n            left: ").concat(left, "px !important;\n          }\n        "));
    }
    return () => {
      document.head.removeChild(style);
    };
  }, [isPresent]);
  return jsx(PopChildMeasure, {
    isPresent: isPresent,
    childRef: ref,
    sizeRef: size,
    children: React.cloneElement(children, {
      ref
    })
  });
}
const PresenceChild = _ref233 => {
  let {
    children,
    initial,
    isPresent,
    onExitComplete,
    custom,
    presenceAffectsLayout,
    mode
  } = _ref233;
  const presenceChildren = useConstant(newChildrenMap);
  const id = useId();
  const memoizedOnExitComplete = useCallback(childId => {
    presenceChildren.set(childId, true);
    for (const isComplete of presenceChildren.values()) {
      if (!isComplete) return; // can stop searching when any is incomplete
    }
    onExitComplete && onExitComplete();
  }, [presenceChildren, onExitComplete]);
  const context = useMemo(() => ({
    id,
    initial,
    isPresent,
    custom,
    onExitComplete: memoizedOnExitComplete,
    register: childId => {
      presenceChildren.set(childId, false);
      return () => presenceChildren.delete(childId);
    }
  }),
  /**
   * If the presence of a child affects the layout of the components around it,
   * we want to make a new context value to ensure they get re-rendered
   * so they can detect that layout change.
   */
  presenceAffectsLayout ? [Math.random(), memoizedOnExitComplete] : [isPresent, memoizedOnExitComplete]);
  useMemo(() => {
    presenceChildren.forEach((_, key) => presenceChildren.set(key, false));
  }, [isPresent]);
  /**
   * If there's no `motion` components to fire exit animations, we want to remove this
   * component immediately.
   */
  React.useEffect(() => {
    !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
  }, [isPresent]);
  if (mode === "popLayout") {
    children = jsx(PopChild, {
      isPresent: isPresent,
      children: children
    });
  }
  return jsx(PresenceContext.Provider, {
    value: context,
    children: children
  });
};
function newChildrenMap() {
  return new Map();
}

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */
function usePresence() {
  let subscribe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  const context = useContext(PresenceContext);
  if (context === null) return [true, null];
  const {
    isPresent,
    onExitComplete,
    register
  } = context;
  // It's safe to call the following hooks conditionally (after an early return) because the context will always
  // either be null or non-null for the lifespan of the component.
  const id = useId();
  useEffect(() => {
    if (subscribe) register(id);
  }, [subscribe]);
  const safeToRemove = useCallback(() => subscribe && onExitComplete && onExitComplete(id), [id, onExitComplete, subscribe]);
  return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}
const getChildKey = child => child.key || "";
function onlyElements(children) {
  const filtered = [];
  // We use forEach here instead of map as map mutates the component key by preprending `.$`
  Children.forEach(children, child => {
    if (isValidElement(child)) filtered.push(child);
  });
  return filtered;
}
const isBrowser = typeof window !== "undefined";
const useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect;

/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */
const AnimatePresence = _ref234 => {
  let {
    children,
    custom,
    initial = true,
    onExitComplete,
    presenceAffectsLayout = true,
    mode = "sync",
    propagate = false
  } = _ref234;
  const [isParentPresent, safeToRemove] = usePresence(propagate);
  /**
   * Filter any children that aren't ReactElements. We can only track components
   * between renders with a props.key.
   */
  const presentChildren = useMemo(() => onlyElements(children), [children]);
  /**
   * Track the keys of the currently rendered children. This is used to
   * determine which children are exiting.
   */
  const presentKeys = propagate && !isParentPresent ? [] : presentChildren.map(getChildKey);
  /**
   * If `initial={false}` we only want to pass this to components in the first render.
   */
  const isInitialRender = useRef(true);
  /**
   * A ref containing the currently present children. When all exit animations
   * are complete, we use this to re-render the component with the latest children
   * *committed* rather than the latest children *rendered*.
   */
  const pendingPresentChildren = useRef(presentChildren);
  /**
   * Track which exiting children have finished animating out.
   */
  const exitComplete = useConstant(() => new Map());
  /**
   * Save children to render as React state. To ensure this component is concurrent-safe,
   * we check for exiting children via an effect.
   */
  const [diffedChildren, setDiffedChildren] = useState(presentChildren);
  const [renderedChildren, setRenderedChildren] = useState(presentChildren);
  useIsomorphicLayoutEffect(() => {
    isInitialRender.current = false;
    pendingPresentChildren.current = presentChildren;
    /**
     * Update complete status of exiting children.
     */
    for (let i = 0; i < renderedChildren.length; i++) {
      const key = getChildKey(renderedChildren[i]);
      if (!presentKeys.includes(key)) {
        if (exitComplete.get(key) !== true) {
          exitComplete.set(key, false);
        }
      } else {
        exitComplete.delete(key);
      }
    }
  }, [renderedChildren, presentKeys.length, presentKeys.join("-")]);
  const exitingChildren = [];
  if (presentChildren !== diffedChildren) {
    let nextChildren = [...presentChildren];
    /**
     * Loop through all the currently rendered components and decide which
     * are exiting.
     */
    for (let i = 0; i < renderedChildren.length; i++) {
      const child = renderedChildren[i];
      const key = getChildKey(child);
      if (!presentKeys.includes(key)) {
        nextChildren.splice(i, 0, child);
        exitingChildren.push(child);
      }
    }
    /**
     * If we're in "wait" mode, and we have exiting children, we want to
     * only render these until they've all exited.
     */
    if (mode === "wait" && exitingChildren.length) {
      nextChildren = exitingChildren;
    }
    setRenderedChildren(onlyElements(nextChildren));
    setDiffedChildren(presentChildren);
    /**
     * Early return to ensure once we've set state with the latest diffed
     * children, we can immediately re-render.
     */
    return;
  }
  if (process.env.NODE_ENV !== "production" && mode === "wait" && renderedChildren.length > 1) {
    console.warn("You're attempting to animate multiple children within AnimatePresence, but its mode is set to \"wait\". This will lead to odd visual behaviour.");
  }
  /**
   * If we've been provided a forceRender function by the LayoutGroupContext,
   * we can use it to force a re-render amongst all surrounding components once
   * all components have finished animating out.
   */
  const {
    forceRender
  } = useContext(LayoutGroupContext);
  return jsx(Fragment, {
    children: renderedChildren.map(child => {
      const key = getChildKey(child);
      const isPresent = propagate && !isParentPresent ? false : presentChildren === renderedChildren || presentKeys.includes(key);
      const onExit = () => {
        if (exitComplete.has(key)) {
          exitComplete.set(key, true);
        } else {
          return;
        }
        let isEveryExitComplete = true;
        exitComplete.forEach(isExitComplete => {
          if (!isExitComplete) isEveryExitComplete = false;
        });
        if (isEveryExitComplete) {
          forceRender === null || forceRender === void 0 ? void 0 : forceRender();
          setRenderedChildren(pendingPresentChildren.current);
          propagate && (safeToRemove === null || safeToRemove === void 0 ? void 0 : safeToRemove());
          onExitComplete && onExitComplete();
        }
      };
      return jsx(PresenceChild, {
        isPresent: isPresent,
        initial: !isInitialRender.current || initial ? undefined : false,
        custom: isPresent ? undefined : custom,
        presenceAffectsLayout: presenceAffectsLayout,
        mode: mode,
        onExitComplete: isPresent ? undefined : onExit,
        children: child
      }, key);
    })
  });
};

/*#__NO_SIDE_EFFECTS__*/
const noop = any => any;
let warning = noop;
let invariant = noop;
if (process.env.NODE_ENV !== "production") {
  warning = (check, message) => {
    if (!check && typeof console !== "undefined") {
      console.warn(message);
    }
  };
  invariant = (check, message) => {
    if (!check) {
      throw new Error(message);
    }
  };
}

/*#__NO_SIDE_EFFECTS__*/
function memo(callback) {
  let result;
  return () => {
    if (result === undefined) result = callback();
    return result;
  };
}

/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/
/*#__NO_SIDE_EFFECTS__*/
const progress = (from, to, value) => {
  const toFromDifference = to - from;
  return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */
/*#__NO_SIDE_EFFECTS__*/
const secondsToMilliseconds = seconds => seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/
const millisecondsToSeconds = milliseconds => milliseconds / 1000;
const MotionGlobalConfig = {
  skipAnimations: false,
  useManualTiming: false
};
function createRenderStep(runNextFrame) {
  /**
   * We create and reuse two queues, one to queue jobs for the current frame
   * and one for the next. We reuse to avoid triggering GC after x frames.
   */
  let thisFrame = new Set();
  let nextFrame = new Set();
  /**
   * Track whether we're currently processing jobs in this step. This way
   * we can decide whether to schedule new jobs for this frame or next.
   */
  let isProcessing = false;
  let flushNextFrame = false;
  /**
   * A set of processes which were marked keepAlive when scheduled.
   */
  const toKeepAlive = new WeakSet();
  let latestFrameData = {
    delta: 0.0,
    timestamp: 0.0,
    isProcessing: false
  };
  function triggerCallback(callback) {
    if (toKeepAlive.has(callback)) {
      step.schedule(callback);
      runNextFrame();
    }
    callback(latestFrameData);
  }
  const step = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: function (callback) {
      let keepAlive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      let immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      const addToCurrentFrame = immediate && isProcessing;
      const queue = addToCurrentFrame ? thisFrame : nextFrame;
      if (keepAlive) toKeepAlive.add(callback);
      if (!queue.has(callback)) queue.add(callback);
      return callback;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: callback => {
      nextFrame.delete(callback);
      toKeepAlive.delete(callback);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: frameData => {
      latestFrameData = frameData;
      /**
       * If we're already processing we've probably been triggered by a flushSync
       * inside an existing process. Instead of executing, mark flushNextFrame
       * as true and ensure we flush the following frame at the end of this one.
       */
      if (isProcessing) {
        flushNextFrame = true;
        return;
      }
      isProcessing = true;
      [thisFrame, nextFrame] = [nextFrame, thisFrame];
      // Execute this frame
      thisFrame.forEach(triggerCallback);
      // Clear the frame so no callbacks remain. This is to avoid
      // memory leaks should this render step not run for a while.
      thisFrame.clear();
      isProcessing = false;
      if (flushNextFrame) {
        flushNextFrame = false;
        step.process(frameData);
      }
    }
  };
  return step;
}
const stepsOrder = ["read",
// Read
"resolveKeyframes",
// Write/Read/Write/Read
"update",
// Compute
"preRender",
// Compute
"render",
// Write
"postRender" // Compute
];
const maxElapsed = 40;
function createRenderBatcher(scheduleNextBatch, allowKeepAlive) {
  let runNextFrame = false;
  let useDefaultElapsed = true;
  const state = {
    delta: 0.0,
    timestamp: 0.0,
    isProcessing: false
  };
  const flagRunNextFrame = () => runNextFrame = true;
  const steps = stepsOrder.reduce((acc, key) => {
    acc[key] = createRenderStep(flagRunNextFrame);
    return acc;
  }, {});
  const {
    read,
    resolveKeyframes,
    update,
    preRender,
    render,
    postRender
  } = steps;
  const processBatch = () => {
    const timestamp = performance.now();
    runNextFrame = false;
    state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, maxElapsed), 1);
    state.timestamp = timestamp;
    state.isProcessing = true;
    // Unrolled render loop for better per-frame performance
    read.process(state);
    resolveKeyframes.process(state);
    update.process(state);
    preRender.process(state);
    render.process(state);
    postRender.process(state);
    state.isProcessing = false;
    if (runNextFrame && allowKeepAlive) {
      useDefaultElapsed = false;
      scheduleNextBatch(processBatch);
    }
  };
  const wake = () => {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!state.isProcessing) {
      scheduleNextBatch(processBatch);
    }
  };
  const schedule = stepsOrder.reduce((acc, key) => {
    const step = steps[key];
    acc[key] = function (process) {
      let keepAlive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      let immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (!runNextFrame) wake();
      return step.schedule(process, keepAlive, immediate);
    };
    return acc;
  }, {});
  const cancel = process => {
    for (let i = 0; i < stepsOrder.length; i++) {
      steps[stepsOrder[i]].cancel(process);
    }
  };
  return {
    schedule,
    cancel,
    state,
    steps
  };
}
const {
  schedule: frame,
  cancel: cancelFrame,
  state: frameData,
  steps: frameSteps
} = createRenderBatcher(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : noop, true);
const LazyContext = createContext({
  strict: false
});
const featureProps = {
  animation: ["animate", "variants", "whileHover", "whileTap", "exit", "whileInView", "whileFocus", "whileDrag"],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
const featureDefinitions = {};
for (const key in featureProps) {
  featureDefinitions[key] = {
    isEnabled: props => featureProps[key].some(name => !!props[name])
  };
}
function loadFeatures(features) {
  for (const key in features) {
    featureDefinitions[key] = {
      ...featureDefinitions[key],
      ...features[key]
    };
  }
}

/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */
const validMotionProps = new Set(["animate", "exit", "variants", "initial", "style", "values", "variants", "transition", "transformTemplate", "custom", "inherit", "onBeforeLayoutMeasure", "onAnimationStart", "onAnimationComplete", "onUpdate", "onDragStart", "onDrag", "onDragEnd", "onMeasureDragConstraints", "onDirectionLock", "onDragTransitionEnd", "_dragX", "_dragY", "onHoverStart", "onHoverEnd", "onViewportEnter", "onViewportLeave", "globalTapTarget", "ignoreStrict", "viewport"]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */
function isValidMotionProp(key) {
  return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || validMotionProps.has(key);
}
let shouldForward = key => !isValidMotionProp(key);
function loadExternalIsValidProp(isValidProp) {
  if (!isValidProp) return;
  // Explicitly filter our events
  shouldForward = key => key.startsWith("on") ? !isValidMotionProp(key) : isValidProp(key);
}
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */
try {
  /**
   * We attempt to import this package but require won't be defined in esm environments, in that case
   * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
   * in favour of explicit injection.
   */
  loadExternalIsValidProp(require("@emotion/is-prop-valid").default);
} catch (_a) {
  // We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function filterProps(props, isDom, forwardMotionProps) {
  const filteredProps = {};
  for (const key in props) {
    /**
     * values is considered a valid prop by Emotion, so if it's present
     * this will be rendered out to the DOM unless explicitly filtered.
     *
     * We check the type as it could be used with the `feColorMatrix`
     * element, which we support.
     */
    if (key === "values" && typeof props.values === "object") continue;
    if (shouldForward(key) || forwardMotionProps === true && isValidMotionProp(key) || !isDom && !isValidMotionProp(key) ||
    // If trying to use native HTML drag events, forward drag listeners
    props["draggable"] && key.startsWith("onDrag")) {
      filteredProps[key] = props[key];
    }
  }
  return filteredProps;
}
const warned = new Set();
function warnOnce(condition, message, element) {
  if (condition || warned.has(message)) return;
  console.warn(message);
  if (element) console.warn(element);
  warned.add(message);
}
function createDOMMotionComponentProxy(componentFactory) {
  if (typeof Proxy === "undefined") {
    return componentFactory;
  }
  /**
   * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
   * Rather than generating them anew every render.
   */
  const componentCache = new Map();
  const deprecatedFactoryFunction = function () {
    if (process.env.NODE_ENV !== "production") {
      warnOnce(false, "motion() is deprecated. Use motion.create() instead.");
    }
    return componentFactory(...arguments);
  };
  return new Proxy(deprecatedFactoryFunction, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (_target, key) => {
      if (key === "create") return componentFactory;
      /**
       * If this element doesn't exist in the component cache, create it and cache.
       */
      if (!componentCache.has(key)) {
        componentCache.set(key, componentFactory(key));
      }
      return componentCache.get(key);
    }
  });
}
const MotionContext = createContext({});

/**
 * Decides if the supplied variable is variant label
 */
function isVariantLabel(v) {
  return typeof v === "string" || Array.isArray(v);
}
function isAnimationControls(v) {
  return v !== null && typeof v === "object" && typeof v.start === "function";
}
const variantPriorityOrder = ["animate", "whileInView", "whileFocus", "whileHover", "whileTap", "whileDrag", "exit"];
const variantProps = ["initial", ...variantPriorityOrder];
function isControllingVariants(props) {
  return isAnimationControls(props.animate) || variantProps.some(name => isVariantLabel(props[name]));
}
function isVariantNode(props) {
  return Boolean(isControllingVariants(props) || props.variants);
}
function getCurrentTreeVariants(props, context) {
  if (isControllingVariants(props)) {
    const {
      initial,
      animate
    } = props;
    return {
      initial: initial === false || isVariantLabel(initial) ? initial : undefined,
      animate: isVariantLabel(animate) ? animate : undefined
    };
  }
  return props.inherit !== false ? context : {};
}
function useCreateMotionContext(props) {
  const {
    initial,
    animate
  } = getCurrentTreeVariants(props, useContext(MotionContext));
  return useMemo(() => ({
    initial,
    animate
  }), [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate)]);
}
function variantLabelsAsDependency(prop) {
  return Array.isArray(prop) ? prop.join(" ") : prop;
}
const motionComponentSymbol = Symbol.for("motionComponentSymbol");
function isRefObject(ref) {
  return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */
function useMotionRef(visualState, visualElement, externalRef) {
  return useCallback(instance => {
    if (instance) {
      visualState.onMount && visualState.onMount(instance);
    }
    if (visualElement) {
      if (instance) {
        visualElement.mount(instance);
      } else {
        visualElement.unmount();
      }
    }
    if (externalRef) {
      if (typeof externalRef === "function") {
        externalRef(instance);
      } else if (isRefObject(externalRef)) {
        externalRef.current = instance;
      }
    }
  },
  /**
   * Only pass a new ref callback to React if we've received a visual element
   * factory. Otherwise we'll be mounting/remounting every time externalRef
   * or other dependencies change.
   */
  [visualElement]);
}

/**
 * Convert camelCase to dash-case properties.
 */
const camelToDash = str => str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();
const optimizedAppearDataId = "framerAppearId";
const optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId);
const {
  schedule: microtask,
  cancel: cancelMicrotask
} = createRenderBatcher(queueMicrotask, false);

/**
 * Internal, exported only for usage in Framer
 */
const SwitchLayoutGroupContext = createContext({});
function useVisualElement(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
  var _a, _b;
  const {
    visualElement: parent
  } = useContext(MotionContext);
  const lazyContext = useContext(LazyContext);
  const presenceContext = useContext(PresenceContext);
  const reducedMotionConfig = useContext(MotionConfigContext).reducedMotion;
  const visualElementRef = useRef(null);
  /**
   * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
   */
  createVisualElement = createVisualElement || lazyContext.renderer;
  if (!visualElementRef.current && createVisualElement) {
    visualElementRef.current = createVisualElement(Component, {
      visualState,
      parent,
      props,
      presenceContext,
      blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
      reducedMotionConfig
    });
  }
  const visualElement = visualElementRef.current;
  /**
   * Load Motion gesture and animation features. These are rendered as renderless
   * components so each feature can optionally make use of React lifecycle methods.
   */
  const initialLayoutGroupConfig = useContext(SwitchLayoutGroupContext);
  if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) {
    createProjectionNode$1(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
  }
  const isMounted = useRef(false);
  useInsertionEffect(() => {
    /**
     * Check the component has already mounted before calling
     * `update` unnecessarily. This ensures we skip the initial update.
     */
    if (visualElement && isMounted.current) {
      visualElement.update(props, presenceContext);
    }
  });
  /**
   * Cache this value as we want to know whether HandoffAppearAnimations
   * was present on initial render - it will be deleted after this.
   */
  const optimisedAppearId = props[optimizedAppearDataAttribute];
  const wantsHandoff = useRef(Boolean(optimisedAppearId) && !((_a = window.MotionHandoffIsComplete) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId)) && ((_b = window.MotionHasOptimisedAnimation) === null || _b === void 0 ? void 0 : _b.call(window, optimisedAppearId)));
  useIsomorphicLayoutEffect(() => {
    if (!visualElement) return;
    isMounted.current = true;
    window.MotionIsMounted = true;
    visualElement.updateFeatures();
    microtask.render(visualElement.render);
    /**
     * Ideally this function would always run in a useEffect.
     *
     * However, if we have optimised appear animations to handoff from,
     * it needs to happen synchronously to ensure there's no flash of
     * incorrect styles in the event of a hydration error.
     *
     * So if we detect a situtation where optimised appear animations
     * are running, we use useLayoutEffect to trigger animations.
     */
    if (wantsHandoff.current && visualElement.animationState) {
      visualElement.animationState.animateChanges();
    }
  });
  useEffect(() => {
    if (!visualElement) return;
    if (!wantsHandoff.current && visualElement.animationState) {
      visualElement.animationState.animateChanges();
    }
    if (wantsHandoff.current) {
      // This ensures all future calls to animateChanges() in this component will run in useEffect
      queueMicrotask(() => {
        var _a;
        (_a = window.MotionHandoffMarkAsComplete) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId);
      });
      wantsHandoff.current = false;
    }
  });
  return visualElement;
}
function createProjectionNode$1(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
  const {
    layoutId,
    layout,
    drag,
    dragConstraints,
    layoutScroll,
    layoutRoot
  } = props;
  visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : getClosestProjectingNode(visualElement.parent));
  visualElement.projection.setOptions({
    layoutId,
    layout,
    alwaysMeasureLayout: Boolean(drag) || dragConstraints && isRefObject(dragConstraints),
    visualElement,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof layout === "string" ? layout : "both",
    initialPromotionConfig,
    layoutScroll,
    layoutRoot
  });
}
function getClosestProjectingNode(visualElement) {
  if (!visualElement) return undefined;
  return visualElement.options.allowProjection !== false ? visualElement.projection : getClosestProjectingNode(visualElement.parent);
}

/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */
function createRendererMotionComponent(_ref235) {
  let {
    preloadedFeatures,
    createVisualElement,
    useRender,
    useVisualState,
    Component
  } = _ref235;
  var _a, _b;
  preloadedFeatures && loadFeatures(preloadedFeatures);
  function MotionComponent(props, externalRef) {
    /**
     * If we need to measure the element we load this functionality in a
     * separate class component in order to gain access to getSnapshotBeforeUpdate.
     */
    let MeasureLayout;
    const configAndProps = {
      ...useContext(MotionConfigContext),
      ...props,
      layoutId: useLayoutId(props)
    };
    const {
      isStatic
    } = configAndProps;
    const context = useCreateMotionContext(props);
    const visualState = useVisualState(props, isStatic);
    if (!isStatic && isBrowser) {
      useStrictMode(configAndProps, preloadedFeatures);
      const layoutProjection = getProjectionFunctionality(configAndProps);
      MeasureLayout = layoutProjection.MeasureLayout;
      /**
       * Create a VisualElement for this component. A VisualElement provides a common
       * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
       * providing a way of rendering to these APIs outside of the React render loop
       * for more performant animations and interactions
       */
      context.visualElement = useVisualElement(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
    }
    /**
     * The mount order and hierarchy is specific to ensure our element ref
     * is hydrated by the time features fire their effects.
     */
    return jsxs(MotionContext.Provider, {
      value: context,
      children: [MeasureLayout && context.visualElement ? jsx(MeasureLayout, {
        visualElement: context.visualElement,
        ...configAndProps
      }) : null, useRender(Component, props, useMotionRef(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)]
    });
  }
  MotionComponent.displayName = "motion.".concat(typeof Component === "string" ? Component : "create(".concat((_b = (_a = Component.displayName) !== null && _a !== void 0 ? _a : Component.name) !== null && _b !== void 0 ? _b : "", ")"));
  const ForwardRefMotionComponent = forwardRef(MotionComponent);
  ForwardRefMotionComponent[motionComponentSymbol] = Component;
  return ForwardRefMotionComponent;
}
function useLayoutId(_ref236) {
  let {
    layoutId
  } = _ref236;
  const layoutGroupId = useContext(LayoutGroupContext).id;
  return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function useStrictMode(configAndProps, preloadedFeatures) {
  const isStrict = useContext(LazyContext).strict;
  /**
   * If we're in development mode, check to make sure we're not rendering a motion component
   * as a child of LazyMotion, as this will break the file-size benefits of using it.
   */
  if (process.env.NODE_ENV !== "production" && preloadedFeatures && isStrict) {
    const strictMessage = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    configAndProps.ignoreStrict ? warning(false, strictMessage) : invariant(false, strictMessage);
  }
}
function getProjectionFunctionality(props) {
  const {
    drag,
    layout
  } = featureDefinitions;
  if (!drag && !layout) return {};
  const combined = {
    ...drag,
    ...layout
  };
  return {
    MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
    ProjectionNode: combined.ProjectionNode
  };
}

/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */
const lowercaseSVGElements = ["animate", "circle", "defs", "desc", "ellipse", "g", "image", "line", "filter", "marker", "mask", "metadata", "path", "pattern", "polygon", "polyline", "rect", "stop", "switch", "symbol", "svg", "text", "tspan", "use", "view"];
function isSVGComponent(Component) {
  if (
  /**
   * If it's not a string, it's a custom React component. Currently we only support
   * HTML custom React components.
   */
  typeof Component !== "string" ||
  /**
   * If it contains a dash, the element is a custom HTML webcomponent.
   */
  Component.includes("-")) {
    return false;
  } else if (
  /**
   * If it's in our list of lowercase SVG tags, it's an SVG component
   */
  lowercaseSVGElements.indexOf(Component) > -1 ||
  /**
   * If it contains a capital letter, it's an SVG component
   */
  /[A-Z]/u.test(Component)) {
    return true;
  }
  return false;
}
function getValueState(visualElement) {
  const state = [{}, {}];
  visualElement === null || visualElement === void 0 ? void 0 : visualElement.values.forEach((value, key) => {
    state[0][key] = value.get();
    state[1][key] = value.getVelocity();
  });
  return state;
}
function resolveVariantFromProps(props, definition, custom, visualElement) {
  /**
   * If the variant definition is a function, resolve.
   */
  if (typeof definition === "function") {
    const [current, velocity] = getValueState(visualElement);
    definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
  }
  /**
   * If the variant definition is a variant label, or
   * the function returned a variant label, resolve.
   */
  if (typeof definition === "string") {
    definition = props.variants && props.variants[definition];
  }
  /**
   * At this point we've resolved both functions and variant labels,
   * but the resolved variant label might itself have been a function.
   * If so, resolve. This can only have returned a valid target object.
   */
  if (typeof definition === "function") {
    const [current, velocity] = getValueState(visualElement);
    definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
  }
  return definition;
}
const isKeyframesTarget = v => {
  return Array.isArray(v);
};
const isCustomValue = v => {
  return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const resolveFinalValueInKeyframes = v => {
  // TODO maybe throw if v.length - 1 is placeholder token?
  return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};
const isMotionValue = value => Boolean(value && value.getVelocity);

/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */
function resolveMotionValue(value) {
  const unwrappedValue = isMotionValue(value) ? value.get() : value;
  return isCustomValue(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}
function makeState(_ref237, props, context, presenceContext) {
  let {
    scrapeMotionValuesFromProps,
    createRenderState,
    onUpdate
  } = _ref237;
  const state = {
    latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
    renderState: createRenderState()
  };
  if (onUpdate) {
    /**
     * onMount works without the VisualElement because it could be
     * called before the VisualElement payload has been hydrated.
     * (e.g. if someone is using m components <m.circle />)
     */
    state.onMount = instance => onUpdate({
      props,
      current: instance,
      ...state
    });
    state.onUpdate = visualElement => onUpdate(visualElement);
  }
  return state;
}
const makeUseVisualState = config => (props, isStatic) => {
  const context = useContext(MotionContext);
  const presenceContext = useContext(PresenceContext);
  const make = () => makeState(config, props, context, presenceContext);
  return isStatic ? make() : useConstant(make);
};
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
  const values = {};
  const motionValues = scrapeMotionValues(props, {});
  for (const key in motionValues) {
    values[key] = resolveMotionValue(motionValues[key]);
  }
  let {
    initial,
    animate
  } = props;
  const isControllingVariants$1 = isControllingVariants(props);
  const isVariantNode$1 = isVariantNode(props);
  if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
    if (initial === undefined) initial = context.initial;
    if (animate === undefined) animate = context.animate;
  }
  let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
  isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
  const variantToSet = isInitialAnimationBlocked ? animate : initial;
  if (variantToSet && typeof variantToSet !== "boolean" && !isAnimationControls(variantToSet)) {
    const list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
    for (let i = 0; i < list.length; i++) {
      const resolved = resolveVariantFromProps(props, list[i]);
      if (resolved) {
        const {
          transitionEnd,
          transition,
          ...target
        } = resolved;
        for (const key in target) {
          let valueTarget = target[key];
          if (Array.isArray(valueTarget)) {
            /**
             * Take final keyframe if the initial animation is blocked because
             * we want to initialise at the end of that blocked animation.
             */
            const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
            valueTarget = valueTarget[index];
          }
          if (valueTarget !== null) {
            values[key] = valueTarget;
          }
        }
        for (const key in transitionEnd) {
          values[key] = transitionEnd[key];
        }
      }
    }
  }
  return values;
}

/**
 * Generate a list of every possible transform key.
 */
const transformPropOrder = ["transformPerspective", "x", "y", "z", "translateX", "translateY", "translateZ", "scale", "scaleX", "scaleY", "rotate", "rotateX", "rotateY", "rotateZ", "skew", "skewX", "skewY"];
/**
 * A quick lookup for transform props.
 */
const transformProps = new Set(transformPropOrder);
const checkStringStartsWith = token => key => typeof key === "string" && key.startsWith(token);
const isCSSVariableName = /*@__PURE__*/checkStringStartsWith("--");
const startsAsVariableToken = /*@__PURE__*/checkStringStartsWith("var(--");
const isCSSVariableToken = value => {
  const startsWithToken = startsAsVariableToken(value);
  if (!startsWithToken) return false;
  // Ensure any comments are stripped from the value as this can harm performance of the regex.
  return singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;

/**
 * Provided a value and a ValueType, returns the value as that value type.
 */
const getValueAsType = (value, type) => {
  return type && typeof value === "number" ? type.transform(value) : value;
};
const clamp = (min, max, v) => {
  if (v > max) return max;
  if (v < min) return min;
  return v;
};
const number = {
  test: v => typeof v === "number",
  parse: parseFloat,
  transform: v => v
};
const alpha = {
  ...number,
  transform: v => clamp(0, 1, v)
};
const scale = {
  ...number,
  default: 1
};
const createUnitType = unit => ({
  test: v => typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
  parse: parseFloat,
  transform: v => "".concat(v).concat(unit)
});
const degrees = /*@__PURE__*/createUnitType("deg");
const percent = /*@__PURE__*/createUnitType("%");
const px = /*@__PURE__*/createUnitType("px");
const vh = /*@__PURE__*/createUnitType("vh");
const vw = /*@__PURE__*/createUnitType("vw");
const progressPercentage = {
  ...percent,
  parse: v => percent.parse(v) / 100,
  transform: v => percent.transform(v * 100)
};
const browserNumberValueTypes = {
  // Border props
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  // Positioning props
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  // Spacing props
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  // Misc
  backgroundPositionX: px,
  backgroundPositionY: px
};
const transformValueTypes = {
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  transformPerspective: px,
  opacity: alpha,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px
};
const int = {
  ...number,
  transform: Math.round
};
const numberValueTypes = {
  ...browserNumberValueTypes,
  ...transformValueTypes,
  zIndex: int,
  size: px,
  // SVG
  fillOpacity: alpha,
  strokeOpacity: alpha,
  numOctaves: int
};
const translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
const numTransforms = transformPropOrder.length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */
function buildTransform(latestValues, transform, transformTemplate) {
  // The transform string we're going to build into.
  let transformString = "";
  let transformIsDefault = true;
  /**
   * Loop over all possible transforms in order, adding the ones that
   * are present to the transform string.
   */
  for (let i = 0; i < numTransforms; i++) {
    const key = transformPropOrder[i];
    const value = latestValues[key];
    if (value === undefined) continue;
    let valueIsDefault = true;
    if (typeof value === "number") {
      valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
    } else {
      valueIsDefault = parseFloat(value) === 0;
    }
    if (!valueIsDefault || transformTemplate) {
      const valueAsType = getValueAsType(value, numberValueTypes[key]);
      if (!valueIsDefault) {
        transformIsDefault = false;
        const transformName = translateAlias[key] || key;
        transformString += "".concat(transformName, "(").concat(valueAsType, ") ");
      }
      if (transformTemplate) {
        transform[key] = valueAsType;
      }
    }
  }
  transformString = transformString.trim();
  // If we have a custom `transform` template, pass our transform values and
  // generated transformString to that before returning
  if (transformTemplate) {
    transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
  } else if (transformIsDefault) {
    transformString = "none";
  }
  return transformString;
}
function buildHTMLStyles(state, latestValues, transformTemplate) {
  const {
    style,
    vars,
    transformOrigin
  } = state;
  // Track whether we encounter any transform or transformOrigin values.
  let hasTransform = false;
  let hasTransformOrigin = false;
  /**
   * Loop over all our latest animated values and decide whether to handle them
   * as a style or CSS variable.
   *
   * Transforms and transform origins are kept separately for further processing.
   */
  for (const key in latestValues) {
    const value = latestValues[key];
    if (transformProps.has(key)) {
      // If this is a transform, flag to enable further transform processing
      hasTransform = true;
      continue;
    } else if (isCSSVariableName(key)) {
      vars[key] = value;
      continue;
    } else {
      // Convert the value to its default value type, ie 0 -> "0px"
      const valueAsType = getValueAsType(value, numberValueTypes[key]);
      if (key.startsWith("origin")) {
        // If this is a transform origin, flag and enable further transform-origin processing
        hasTransformOrigin = true;
        transformOrigin[key] = valueAsType;
      } else {
        style[key] = valueAsType;
      }
    }
  }
  if (!latestValues.transform) {
    if (hasTransform || transformTemplate) {
      style.transform = buildTransform(latestValues, state.transform, transformTemplate);
    } else if (style.transform) {
      /**
       * If we have previously created a transform but currently don't have any,
       * reset transform style to none.
       */
      style.transform = "none";
    }
  }
  /**
   * Build a transformOrigin style. Uses the same defaults as the browser for
   * undefined origins.
   */
  if (hasTransformOrigin) {
    const {
      originX = "50%",
      originY = "50%",
      originZ = 0
    } = transformOrigin;
    style.transformOrigin = "".concat(originX, " ").concat(originY, " ").concat(originZ);
  }
}
const dashKeys = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
};
const camelKeys = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */
function buildSVGPath(attrs, length) {
  let spacing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  let offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  let useDashCase = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  // Normalise path length by setting SVG attribute pathLength to 1
  attrs.pathLength = 1;
  // We use dash case when setting attributes directly to the DOM node and camel case
  // when defining props on a React component.
  const keys = useDashCase ? dashKeys : camelKeys;
  // Build the dash offset
  attrs[keys.offset] = px.transform(-offset);
  // Build the dash array
  const pathLength = px.transform(length);
  const pathSpacing = px.transform(spacing);
  attrs[keys.array] = "".concat(pathLength, " ").concat(pathSpacing);
}
function calcOrigin$1(origin, offset, size) {
  return typeof origin === "string" ? origin : px.transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */
function calcSVGTransformOrigin(dimensions, originX, originY) {
  const pxOriginX = calcOrigin$1(originX, dimensions.x, dimensions.width);
  const pxOriginY = calcOrigin$1(originY, dimensions.y, dimensions.height);
  return "".concat(pxOriginX, " ").concat(pxOriginY);
}

/**
 * Build SVG visual attrbutes, like cx and style.transform
 */
function buildSVGAttrs(state, _ref238, isSVGTag, transformTemplate) {
  let {
    attrX,
    attrY,
    attrScale,
    originX,
    originY,
    pathLength,
    pathSpacing = 1,
    pathOffset = 0,
    // This is object creation, which we try to avoid per-frame.
    ...latest
  } = _ref238;
  buildHTMLStyles(state, latest, transformTemplate);
  /**
   * For svg tags we just want to make sure viewBox is animatable and treat all the styles
   * as normal HTML tags.
   */
  if (isSVGTag) {
    if (state.style.viewBox) {
      state.attrs.viewBox = state.style.viewBox;
    }
    return;
  }
  state.attrs = state.style;
  state.style = {};
  const {
    attrs,
    style,
    dimensions
  } = state;
  /**
   * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
   * and copy it into style.
   */
  if (attrs.transform) {
    if (dimensions) style.transform = attrs.transform;
    delete attrs.transform;
  }
  // Parse transformOrigin
  if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) {
    style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
  }
  // Render attrX/attrY/attrScale as attributes
  if (attrX !== undefined) attrs.x = attrX;
  if (attrY !== undefined) attrs.y = attrY;
  if (attrScale !== undefined) attrs.scale = attrScale;
  // Build SVG path if one has been defined
  if (pathLength !== undefined) {
    buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
  }
}
const createHtmlRenderState = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
const createSvgRenderState = () => ({
  ...createHtmlRenderState(),
  attrs: {}
});
const isSVGTag = tag => typeof tag === "string" && tag.toLowerCase() === "svg";
function renderHTML(element, _ref239, styleProp, projection) {
  let {
    style,
    vars
  } = _ref239;
  Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
  // Loop over any CSS variables and assign those.
  for (const key in vars) {
    element.style.setProperty(key, vars[key]);
  }
}

/**
 * A set of attribute names that are always read/written as camel case.
 */
const camelCaseAttributes = new Set(["baseFrequency", "diffuseConstant", "kernelMatrix", "kernelUnitLength", "keySplines", "keyTimes", "limitingConeAngle", "markerHeight", "markerWidth", "numOctaves", "targetX", "targetY", "surfaceScale", "specularConstant", "specularExponent", "stdDeviation", "tableValues", "viewBox", "gradientTransform", "pathLength", "startOffset", "textLength", "lengthAdjust"]);
function renderSVG(element, renderState, _styleProp, projection) {
  renderHTML(element, renderState, undefined, projection);
  for (const key in renderState.attrs) {
    element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
  }
}
const scaleCorrectors = {};
function addScaleCorrector(correctors) {
  Object.assign(scaleCorrectors, correctors);
}
function isForcedMotionValue(key, _ref240) {
  let {
    layout,
    layoutId
  } = _ref240;
  return transformProps.has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!scaleCorrectors[key] || key === "opacity");
}
function scrapeMotionValuesFromProps$1(props, prevProps, visualElement) {
  var _a;
  const {
    style
  } = props;
  const newValues = {};
  for (const key in style) {
    if (isMotionValue(style[key]) || prevProps.style && isMotionValue(prevProps.style[key]) || isForcedMotionValue(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) {
      newValues[key] = style[key];
    }
  }
  return newValues;
}
function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
  const newValues = scrapeMotionValuesFromProps$1(props, prevProps, visualElement);
  for (const key in props) {
    if (isMotionValue(props[key]) || isMotionValue(prevProps[key])) {
      const targetKey = transformPropOrder.indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
      newValues[targetKey] = props[key];
    }
  }
  return newValues;
}
function updateSVGDimensions(instance, renderState) {
  try {
    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
  } catch (e) {
    // Most likely trying to measure an unrendered element under Firefox
    renderState.dimensions = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  }
}
const layoutProps = ["x", "y", "width", "height", "cx", "cy", "r"];
const svgMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
    createRenderState: createSvgRenderState,
    onUpdate: _ref241 => {
      let {
        props,
        prevProps,
        current,
        renderState,
        latestValues
      } = _ref241;
      if (!current) return;
      let hasTransform = !!props.drag;
      if (!hasTransform) {
        for (const key in latestValues) {
          if (transformProps.has(key)) {
            hasTransform = true;
            break;
          }
        }
      }
      if (!hasTransform) return;
      let needsMeasure = !prevProps;
      if (prevProps) {
        /**
         * Check the layout props for changes, if any are found we need to
         * measure the element again.
         */
        for (let i = 0; i < layoutProps.length; i++) {
          const key = layoutProps[i];
          if (props[key] !== prevProps[key]) {
            needsMeasure = true;
          }
        }
      }
      if (!needsMeasure) return;
      frame.read(() => {
        updateSVGDimensions(current, renderState);
        frame.render(() => {
          buildSVGAttrs(renderState, latestValues, isSVGTag(current.tagName), props.transformTemplate);
          renderSVG(current, renderState);
        });
      });
    }
  })
};
const htmlMotionConfig = {
  useVisualState: makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
    createRenderState: createHtmlRenderState
  })
};
function copyRawValuesOnly(target, source, props) {
  for (const key in source) {
    if (!isMotionValue(source[key]) && !isForcedMotionValue(key, props)) {
      target[key] = source[key];
    }
  }
}
function useInitialMotionValues(_ref242, visualState) {
  let {
    transformTemplate
  } = _ref242;
  return useMemo(() => {
    const state = createHtmlRenderState();
    buildHTMLStyles(state, visualState, transformTemplate);
    return Object.assign({}, state.vars, state.style);
  }, [visualState]);
}
function useStyle(props, visualState) {
  const styleProp = props.style || {};
  const style = {};
  /**
   * Copy non-Motion Values straight into style
   */
  copyRawValuesOnly(style, styleProp, props);
  Object.assign(style, useInitialMotionValues(props, visualState));
  return style;
}
function useHTMLProps(props, visualState) {
  // The `any` isn't ideal but it is the type of createElement props argument
  const htmlProps = {};
  const style = useStyle(props, visualState);
  if (props.drag && props.dragListener !== false) {
    // Disable the ghost element when a user drags
    htmlProps.draggable = false;
    // Disable text selection
    style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
    // Disable scrolling on the draggable direction
    style.touchAction = props.drag === true ? "none" : "pan-".concat(props.drag === "x" ? "y" : "x");
  }
  if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) {
    htmlProps.tabIndex = 0;
  }
  htmlProps.style = style;
  return htmlProps;
}
function useSVGProps(props, visualState, _isStatic, Component) {
  const visualProps = useMemo(() => {
    const state = createSvgRenderState();
    buildSVGAttrs(state, visualState, isSVGTag(Component), props.transformTemplate);
    return {
      ...state.attrs,
      style: {
        ...state.style
      }
    };
  }, [visualState]);
  if (props.style) {
    const rawStyles = {};
    copyRawValuesOnly(rawStyles, props.style, props);
    visualProps.style = {
      ...rawStyles,
      ...visualProps.style
    };
  }
  return visualProps;
}
function createUseRender() {
  let forwardMotionProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  const useRender = (Component, props, ref, _ref243, isStatic) => {
    let {
      latestValues
    } = _ref243;
    const useVisualProps = isSVGComponent(Component) ? useSVGProps : useHTMLProps;
    const visualProps = useVisualProps(props, latestValues, isStatic, Component);
    const filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
    const elementProps = Component !== Fragment$1 ? {
      ...filteredProps,
      ...visualProps,
      ref
    } : {};
    /**
     * If component has been handed a motion value as its child,
     * memoise its initial value and render that. Subsequent updates
     * will be handled by the onChange handler
     */
    const {
      children
    } = props;
    const renderedChildren = useMemo(() => isMotionValue(children) ? children.get() : children, [children]);
    return createElement$2(Component, {
      ...elementProps,
      children: renderedChildren
    });
  };
  return useRender;
}
function createMotionComponentFactory(preloadedFeatures, createVisualElement) {
  return function createMotionComponent(Component) {
    let {
      forwardMotionProps
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      forwardMotionProps: false
    };
    const baseConfig = isSVGComponent(Component) ? svgMotionConfig : htmlMotionConfig;
    const config = {
      ...baseConfig,
      preloadedFeatures,
      useRender: createUseRender(forwardMotionProps),
      createVisualElement,
      Component
    };
    return createRendererMotionComponent(config);
  };
}
function shallowCompare(next, prev) {
  if (!Array.isArray(prev)) return false;
  const prevLength = prev.length;
  if (prevLength !== next.length) return false;
  for (let i = 0; i < prevLength; i++) {
    if (prev[i] !== next[i]) return false;
  }
  return true;
}
function resolveVariant(visualElement, definition, custom) {
  const props = visualElement.getProps();
  return resolveVariantFromProps(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}
const supportsScrollTimeline = memo(() => window.ScrollTimeline !== undefined);
class BaseGroupPlaybackControls {
  constructor(animations) {
    // Bound to accomodate common `return animation.stop` pattern
    this.stop = () => this.runAll("stop");
    this.animations = animations.filter(Boolean);
  }
  get finished() {
    // Support for new finished Promise and legacy thennable API
    return Promise.all(this.animations.map(animation => "finished" in animation ? animation.finished : animation));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(propName) {
    return this.animations[0][propName];
  }
  setAll(propName, newValue) {
    for (let i = 0; i < this.animations.length; i++) {
      this.animations[i][propName] = newValue;
    }
  }
  attachTimeline(timeline, fallback) {
    const subscriptions = this.animations.map(animation => {
      if (supportsScrollTimeline() && animation.attachTimeline) {
        return animation.attachTimeline(timeline);
      } else if (typeof fallback === "function") {
        return fallback(animation);
      }
    });
    return () => {
      subscriptions.forEach((cancel, i) => {
        cancel && cancel();
        this.animations[i].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(time) {
    this.setAll("time", time);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(speed) {
    this.setAll("speed", speed);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let max = 0;
    for (let i = 0; i < this.animations.length; i++) {
      max = Math.max(max, this.animations[i].duration);
    }
    return max;
  }
  runAll(methodName) {
    this.animations.forEach(controls => controls[methodName]());
  }
  flatten() {
    this.runAll("flatten");
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}

/**
 * TODO: This is a temporary class to support the legacy
 * thennable API
 */
class GroupPlaybackControls extends BaseGroupPlaybackControls {
  then(onResolve, onReject) {
    return Promise.all(this.animations).then(onResolve).catch(onReject);
  }
}
function getValueTransition(transition, key) {
  return transition ? transition[key] || transition["default"] || transition : undefined;
}

/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */
const maxGeneratorDuration = 20000;
function calcGeneratorDuration(generator) {
  let duration = 0;
  const timeStep = 50;
  let state = generator.next(duration);
  while (!state.done && duration < maxGeneratorDuration) {
    duration += timeStep;
    state = generator.next(duration);
  }
  return duration >= maxGeneratorDuration ? Infinity : duration;
}
function isGenerator(type) {
  return typeof type === "function";
}
function attachTimeline(animation, timeline) {
  animation.timeline = timeline;
  animation.onfinish = null;
}
const isBezierDefinition = easing => Array.isArray(easing) && typeof easing[0] === "number";

/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */
const supportsFlags = {
  linearEasing: undefined
};
function memoSupports(callback, supportsFlag) {
  const memoized = memo(callback);
  return () => {
    var _a;
    return (_a = supportsFlags[supportsFlag]) !== null && _a !== void 0 ? _a : memoized();
  };
}
const supportsLinearEasing = /*@__PURE__*/memoSupports(() => {
  try {
    document.createElement("div").animate({
      opacity: 0
    }, {
      easing: "linear(0, 1)"
    });
  } catch (e) {
    return false;
  }
  return true;
}, "linearEasing");
const generateLinearEasing = function (easing, duration) {
  let resolution = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  let points = "";
  const numPoints = Math.max(Math.round(duration / resolution), 2);
  for (let i = 0; i < numPoints; i++) {
    points += easing(progress(0, numPoints - 1, i)) + ", ";
  }
  return "linear(".concat(points.substring(0, points.length - 2), ")");
};
function isWaapiSupportedEasing(easing) {
  return Boolean(typeof easing === "function" && supportsLinearEasing() || !easing || typeof easing === "string" && (easing in supportedWaapiEasing || supportsLinearEasing()) || isBezierDefinition(easing) || Array.isArray(easing) && easing.every(isWaapiSupportedEasing));
}
const cubicBezierAsString = _ref244 => {
  let [a, b, c, d] = _ref244;
  return "cubic-bezier(".concat(a, ", ").concat(b, ", ").concat(c, ", ").concat(d, ")");
};
const supportedWaapiEasing = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /*@__PURE__*/cubicBezierAsString([0, 0.65, 0.55, 1]),
  circOut: /*@__PURE__*/cubicBezierAsString([0.55, 0, 1, 0.45]),
  backIn: /*@__PURE__*/cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
  backOut: /*@__PURE__*/cubicBezierAsString([0.33, 1.53, 0.69, 0.99])
};
function mapEasingToNativeEasing(easing, duration) {
  if (!easing) {
    return undefined;
  } else if (typeof easing === "function" && supportsLinearEasing()) {
    return generateLinearEasing(easing, duration);
  } else if (isBezierDefinition(easing)) {
    return cubicBezierAsString(easing);
  } else if (Array.isArray(easing)) {
    return easing.map(segmentEasing => mapEasingToNativeEasing(segmentEasing, duration) || supportedWaapiEasing.easeOut);
  } else {
    return supportedWaapiEasing[easing];
  }
}
const isDragging = {
  x: false,
  y: false
};
function isDragActive() {
  return isDragging.x || isDragging.y;
}
function resolveElements(elementOrSelector, scope, selectorCache) {
  var _a;
  if (elementOrSelector instanceof Element) {
    return [elementOrSelector];
  } else if (typeof elementOrSelector === "string") {
    let root = document;
    if (scope) {
      // TODO: Refactor to utils package
      // invariant(
      //     Boolean(scope.current),
      //     "Scope provided, but no element detected."
      // )
      root = scope.current;
    }
    const elements = (_a = selectorCache === null || selectorCache === void 0 ? void 0 : selectorCache[elementOrSelector]) !== null && _a !== void 0 ? _a : root.querySelectorAll(elementOrSelector);
    return elements ? Array.from(elements) : [];
  }
  return Array.from(elementOrSelector);
}
function setupGesture(elementOrSelector, options) {
  const elements = resolveElements(elementOrSelector);
  const gestureAbortController = new AbortController();
  const eventOptions = {
    passive: true,
    ...options,
    signal: gestureAbortController.signal
  };
  const cancel = () => gestureAbortController.abort();
  return [elements, eventOptions, cancel];
}

/**
 * Filter out events that are not pointer events, or are triggering
 * while a Motion gesture is active.
 */
function filterEvents$1(callback) {
  return event => {
    if (event.pointerType === "touch" || isDragActive()) return;
    callback(event);
  };
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */
function hover(elementOrSelector, onHoverStart) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const [elements, eventOptions, cancel] = setupGesture(elementOrSelector, options);
  const onPointerEnter = filterEvents$1(enterEvent => {
    const {
      target
    } = enterEvent;
    const onHoverEnd = onHoverStart(enterEvent);
    if (typeof onHoverEnd !== "function" || !target) return;
    const onPointerLeave = filterEvents$1(leaveEvent => {
      onHoverEnd(leaveEvent);
      target.removeEventListener("pointerleave", onPointerLeave);
    });
    target.addEventListener("pointerleave", onPointerLeave, eventOptions);
  });
  elements.forEach(element => {
    element.addEventListener("pointerenter", onPointerEnter, eventOptions);
  });
  return cancel;
}

/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */
const isNodeOrChild = (parent, child) => {
  if (!child) {
    return false;
  } else if (parent === child) {
    return true;
  } else {
    return isNodeOrChild(parent, child.parentElement);
  }
};
const isPrimaryPointer = event => {
  if (event.pointerType === "mouse") {
    return typeof event.button !== "number" || event.button <= 0;
  } else {
    /**
     * isPrimary is true for all mice buttons, whereas every touch point
     * is regarded as its own input. So subsequent concurrent touch points
     * will be false.
     *
     * Specifically match against false here as incomplete versions of
     * PointerEvents in very old browser might have it set as undefined.
     */
    return event.isPrimary !== false;
  }
};
const focusableElements = new Set(["BUTTON", "INPUT", "SELECT", "TEXTAREA", "A"]);
function isElementKeyboardAccessible(element) {
  return focusableElements.has(element.tagName) || element.tabIndex !== -1;
}
const isPressing = new WeakSet();

/**
 * Filter out events that are not "Enter" keys.
 */
function filterEvents(callback) {
  return event => {
    if (event.key !== "Enter") return;
    callback(event);
  };
}
function firePointerEvent(target, type) {
  target.dispatchEvent(new PointerEvent("pointer" + type, {
    isPrimary: true,
    bubbles: true
  }));
}
const enableKeyboardPress = (focusEvent, eventOptions) => {
  const element = focusEvent.currentTarget;
  if (!element) return;
  const handleKeydown = filterEvents(() => {
    if (isPressing.has(element)) return;
    firePointerEvent(element, "down");
    const handleKeyup = filterEvents(() => {
      firePointerEvent(element, "up");
    });
    const handleBlur = () => firePointerEvent(element, "cancel");
    element.addEventListener("keyup", handleKeyup, eventOptions);
    element.addEventListener("blur", handleBlur, eventOptions);
  });
  element.addEventListener("keydown", handleKeydown, eventOptions);
  /**
   * Add an event listener that fires on blur to remove the keydown events.
   */
  element.addEventListener("blur", () => element.removeEventListener("keydown", handleKeydown), eventOptions);
};

/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */
function isValidPressEvent(event) {
  return isPrimaryPointer(event) && !isDragActive();
}
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */
function press(elementOrSelector, onPressStart) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const [elements, eventOptions, cancelEvents] = setupGesture(elementOrSelector, options);
  const startPress = startEvent => {
    const element = startEvent.currentTarget;
    if (!isValidPressEvent(startEvent) || isPressing.has(element)) return;
    isPressing.add(element);
    const onPressEnd = onPressStart(startEvent);
    const onPointerEnd = (endEvent, success) => {
      window.removeEventListener("pointerup", onPointerUp);
      window.removeEventListener("pointercancel", onPointerCancel);
      if (!isValidPressEvent(endEvent) || !isPressing.has(element)) {
        return;
      }
      isPressing.delete(element);
      if (typeof onPressEnd === "function") {
        onPressEnd(endEvent, {
          success
        });
      }
    };
    const onPointerUp = upEvent => {
      onPointerEnd(upEvent, options.useGlobalTarget || isNodeOrChild(element, upEvent.target));
    };
    const onPointerCancel = cancelEvent => {
      onPointerEnd(cancelEvent, false);
    };
    window.addEventListener("pointerup", onPointerUp, eventOptions);
    window.addEventListener("pointercancel", onPointerCancel, eventOptions);
  };
  elements.forEach(element => {
    if (!isElementKeyboardAccessible(element) && element.getAttribute("tabindex") === null) {
      element.tabIndex = 0;
    }
    const target = options.useGlobalTarget ? window : element;
    target.addEventListener("pointerdown", startPress, eventOptions);
    element.addEventListener("focus", event => enableKeyboardPress(event, eventOptions), eventOptions);
  });
  return cancelEvents;
}
function setDragLock(axis) {
  if (axis === "x" || axis === "y") {
    if (isDragging[axis]) {
      return null;
    } else {
      isDragging[axis] = true;
      return () => {
        isDragging[axis] = false;
      };
    }
  } else {
    if (isDragging.x || isDragging.y) {
      return null;
    } else {
      isDragging.x = isDragging.y = true;
      return () => {
        isDragging.x = isDragging.y = false;
      };
    }
  }
}
const positionalKeys = new Set(["width", "height", "top", "left", "right", "bottom", ...transformPropOrder]);
let now;
function clearTime() {
  now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */
const time = {
  now: () => {
    if (now === undefined) {
      time.set(frameData.isProcessing || MotionGlobalConfig.useManualTiming ? frameData.timestamp : performance.now());
    }
    return now;
  },
  set: newTime => {
    now = newTime;
    queueMicrotask(clearTime);
  }
};
function addUniqueItem(arr, item) {
  if (arr.indexOf(item) === -1) arr.push(item);
}
function removeItem(arr, item) {
  const index = arr.indexOf(item);
  if (index > -1) arr.splice(index, 1);
}
class SubscriptionManager {
  constructor() {
    this.subscriptions = [];
  }
  add(handler) {
    addUniqueItem(this.subscriptions, handler);
    return () => removeItem(this.subscriptions, handler);
  }
  notify(a, b, c) {
    const numSubscriptions = this.subscriptions.length;
    if (!numSubscriptions) return;
    if (numSubscriptions === 1) {
      /**
       * If there's only a single handler we can just call it without invoking a loop.
       */
      this.subscriptions[0](a, b, c);
    } else {
      for (let i = 0; i < numSubscriptions; i++) {
        /**
         * Check whether the handler exists before firing as it's possible
         * the subscriptions were modified during this loop running.
         */
        const handler = this.subscriptions[i];
        handler && handler(a, b, c);
      }
    }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}

/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/
function velocityPerSecond(velocity, frameDuration) {
  return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */
const MAX_VELOCITY_DELTA = 30;
const isFloat = value => {
  return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */
class MotionValue {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(init) {
    var _this5 = this;
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    /**
     * This will be replaced by the build step with the latest version number.
     * When MotionValues are provided to motion components, warn if versions are mixed.
     */
    this.version = "11.18.2";
    /**
     * Tracks whether this value can output a velocity. Currently this is only true
     * if the value is numerical, but we might be able to widen the scope here and support
     * other value types.
     *
     * @internal
     */
    this.canTrackVelocity = null;
    /**
     * An object containing a SubscriptionManager for each active event.
     */
    this.events = {};
    this.updateAndNotify = function (v) {
      let render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      const currentTime = time.now();
      /**
       * If we're updating the value during another frame or eventloop
       * than the previous frame, then the we set the previous frame value
       * to current.
       */
      if (_this5.updatedAt !== currentTime) {
        _this5.setPrevFrameValue();
      }
      _this5.prev = _this5.current;
      _this5.setCurrent(v);
      // Update update subscribers
      if (_this5.current !== _this5.prev && _this5.events.change) {
        _this5.events.change.notify(_this5.current);
      }
      // Update render subscribers
      if (render && _this5.events.renderRequest) {
        _this5.events.renderRequest.notify(_this5.current);
      }
    };
    this.hasAnimated = false;
    this.setCurrent(init);
    this.owner = options.owner;
  }
  setCurrent(current) {
    this.current = current;
    this.updatedAt = time.now();
    if (this.canTrackVelocity === null && current !== undefined) {
      this.canTrackVelocity = isFloat(this.current);
    }
  }
  setPrevFrameValue() {
    let prevFrameValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.current;
    this.prevFrameValue = prevFrameValue;
    this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(subscription) {
    if (process.env.NODE_ENV !== "production") {
      warnOnce(false, "value.onChange(callback) is deprecated. Switch to value.on(\"change\", callback).");
    }
    return this.on("change", subscription);
  }
  on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = new SubscriptionManager();
    }
    const unsubscribe = this.events[eventName].add(callback);
    if (eventName === "change") {
      return () => {
        unsubscribe();
        /**
         * If we have no more change listeners by the start
         * of the next frame, stop active animations.
         */
        frame.read(() => {
          if (!this.events.change.getSize()) {
            this.stop();
          }
        });
      };
    }
    return unsubscribe;
  }
  clearListeners() {
    for (const eventManagers in this.events) {
      this.events[eventManagers].clear();
    }
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(passiveEffect, stopPassiveEffect) {
    this.passiveEffect = passiveEffect;
    this.stopPassiveEffect = stopPassiveEffect;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(v) {
    let render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (!render || !this.passiveEffect) {
      this.updateAndNotify(v, render);
    } else {
      this.passiveEffect(v, this.updateAndNotify);
    }
  }
  setWithVelocity(prev, current, delta) {
    this.set(current);
    this.prev = undefined;
    this.prevFrameValue = prev;
    this.prevUpdatedAt = this.updatedAt - delta;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(v) {
    let endAnimation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    this.updateAndNotify(v);
    this.prev = v;
    this.prevUpdatedAt = this.prevFrameValue = undefined;
    endAnimation && this.stop();
    if (this.stopPassiveEffect) this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const currentTime = time.now();
    if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > MAX_VELOCITY_DELTA) {
      return 0;
    }
    const delta = Math.min(this.updatedAt - this.prevUpdatedAt, MAX_VELOCITY_DELTA);
    // Casts because of parseFloat's poor typing
    return velocityPerSecond(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(startAnimation) {
    this.stop();
    return new Promise(resolve => {
      this.hasAnimated = true;
      this.animation = startAnimation(resolve);
      if (this.events.animationStart) {
        this.events.animationStart.notify();
      }
    }).then(() => {
      if (this.events.animationComplete) {
        this.events.animationComplete.notify();
      }
      this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    if (this.animation) {
      this.animation.stop();
      if (this.events.animationCancel) {
        this.events.animationCancel.notify();
      }
    }
    this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners();
    this.stop();
    if (this.stopPassiveEffect) {
      this.stopPassiveEffect();
    }
  }
}
function motionValue(init, options) {
  return new MotionValue(init, options);
}

/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */
function setMotionValue(visualElement, key, value) {
  if (visualElement.hasValue(key)) {
    visualElement.getValue(key).set(value);
  } else {
    visualElement.addValue(key, motionValue(value));
  }
}
function setTarget(visualElement, definition) {
  const resolved = resolveVariant(visualElement, definition);
  let {
    transitionEnd = {},
    transition = {},
    ...target
  } = resolved || {};
  target = {
    ...target,
    ...transitionEnd
  };
  for (const key in target) {
    const value = resolveFinalValueInKeyframes(target[key]);
    setMotionValue(visualElement, key, value);
  }
}
function isWillChangeMotionValue(value) {
  return Boolean(isMotionValue(value) && value.add);
}
function addValueToWillChange(visualElement, key) {
  const willChange = visualElement.getValue("willChange");
  /**
   * It could be that a user has set willChange to a regular MotionValue,
   * in which case we can't add the value to it.
   */
  if (isWillChangeMotionValue(willChange)) {
    return willChange.add(key);
  }
}
function getOptimisedAppearId(visualElement) {
  return visualElement.props[optimizedAppearDataAttribute];
}
const instantAnimationState = {
  current: false
};

/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/
// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const calcBezier = (t, a1, a2) => (((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const subdivisionPrecision = 0.0000001;
const subdivisionMaxIterations = 12;
function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
  let currentX;
  let currentT;
  let i = 0;
  do {
    currentT = lowerBound + (upperBound - lowerBound) / 2.0;
    currentX = calcBezier(currentT, mX1, mX2) - x;
    if (currentX > 0.0) {
      upperBound = currentT;
    } else {
      lowerBound = currentT;
    }
  } while (Math.abs(currentX) > subdivisionPrecision && ++i < subdivisionMaxIterations);
  return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
  // If this is a linear gradient, return linear easing
  if (mX1 === mY1 && mX2 === mY2) return noop;
  const getTForX = aX => binarySubdivide(aX, 0, 1, mX1, mX2);
  // If animation is at start/end, return t without easing
  return t => t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
}

// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const mirrorEasing = easing => p => p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const reverseEasing = easing => p => 1 - easing(1 - p);
const backOut = /*@__PURE__*/cubicBezier(0.33, 1.53, 0.69, 0.99);
const backIn = /*@__PURE__*/reverseEasing(backOut);
const backInOut = /*@__PURE__*/mirrorEasing(backIn);
const anticipate = p => (p *= 2) < 1 ? 0.5 * backIn(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
const circIn = p => 1 - Math.sin(Math.acos(p));
const circOut = reverseEasing(circIn);
const circInOut = mirrorEasing(circIn);

/**
 * Check if the value is a zero value string like "0px" or "0%"
 */
const isZeroValueString = v => /^0[^.\s]+$/u.test(v);
function isNone(value) {
  if (typeof value === "number") {
    return value === 0;
  } else if (value !== null) {
    return value === "none" || value === "0" || isZeroValueString(value);
  } else {
    return true;
  }
}

// If this number is a decimal, make it just five decimal places
// to avoid exponents
const sanitize = v => Math.round(v * 100000) / 100000;
const floatRegex = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function isNullish(v) {
  return v == null;
}
const singleColorRegex = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;

/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */
const isColorString = (type, testProp) => v => {
  return Boolean(typeof v === "string" && singleColorRegex.test(v) && v.startsWith(type) || testProp && !isNullish(v) && Object.prototype.hasOwnProperty.call(v, testProp));
};
const splitColor = (aName, bName, cName) => v => {
  if (typeof v !== "string") return v;
  const [a, b, c, alpha] = v.match(floatRegex);
  return {
    [aName]: parseFloat(a),
    [bName]: parseFloat(b),
    [cName]: parseFloat(c),
    alpha: alpha !== undefined ? parseFloat(alpha) : 1
  };
};
const clampRgbUnit = v => clamp(0, 255, v);
const rgbUnit = {
  ...number,
  transform: v => Math.round(clampRgbUnit(v))
};
const rgba = {
  test: /*@__PURE__*/isColorString("rgb", "red"),
  parse: /*@__PURE__*/splitColor("red", "green", "blue"),
  transform: _ref245 => {
    let {
      red,
      green,
      blue,
      alpha: alpha$1 = 1
    } = _ref245;
    return "rgba(" + rgbUnit.transform(red) + ", " + rgbUnit.transform(green) + ", " + rgbUnit.transform(blue) + ", " + sanitize(alpha.transform(alpha$1)) + ")";
  }
};
function parseHex(v) {
  let r = "";
  let g = "";
  let b = "";
  let a = "";
  // If we have 6 characters, ie #FF0000
  if (v.length > 5) {
    r = v.substring(1, 3);
    g = v.substring(3, 5);
    b = v.substring(5, 7);
    a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
  } else {
    r = v.substring(1, 2);
    g = v.substring(2, 3);
    b = v.substring(3, 4);
    a = v.substring(4, 5);
    r += r;
    g += g;
    b += b;
    a += a;
  }
  return {
    red: parseInt(r, 16),
    green: parseInt(g, 16),
    blue: parseInt(b, 16),
    alpha: a ? parseInt(a, 16) / 255 : 1
  };
}
const hex = {
  test: /*@__PURE__*/isColorString("#"),
  parse: parseHex,
  transform: rgba.transform
};
const hsla = {
  test: /*@__PURE__*/isColorString("hsl", "hue"),
  parse: /*@__PURE__*/splitColor("hue", "saturation", "lightness"),
  transform: _ref246 => {
    let {
      hue,
      saturation,
      lightness,
      alpha: alpha$1 = 1
    } = _ref246;
    return "hsla(" + Math.round(hue) + ", " + percent.transform(sanitize(saturation)) + ", " + percent.transform(sanitize(lightness)) + ", " + sanitize(alpha.transform(alpha$1)) + ")";
  }
};
const color = {
  test: v => rgba.test(v) || hex.test(v) || hsla.test(v),
  parse: v => {
    if (rgba.test(v)) {
      return rgba.parse(v);
    } else if (hsla.test(v)) {
      return hsla.parse(v);
    } else {
      return hex.parse(v);
    }
  },
  transform: v => {
    return typeof v === "string" ? v : v.hasOwnProperty("red") ? rgba.transform(v) : hsla.transform(v);
  }
};
const colorRegex = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function test(v) {
  var _a, _b;
  return isNaN(v) && typeof v === "string" && (((_a = v.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match(colorRegex)) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const NUMBER_TOKEN = "number";
const COLOR_TOKEN = "color";
const VAR_TOKEN = "var";
const VAR_FUNCTION_TOKEN = "var(";
const SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function analyseComplexValue(value) {
  const originalValue = value.toString();
  const values = [];
  const indexes = {
    color: [],
    number: [],
    var: []
  };
  const types = [];
  let i = 0;
  const tokenised = originalValue.replace(complexRegex, parsedValue => {
    if (color.test(parsedValue)) {
      indexes.color.push(i);
      types.push(COLOR_TOKEN);
      values.push(color.parse(parsedValue));
    } else if (parsedValue.startsWith(VAR_FUNCTION_TOKEN)) {
      indexes.var.push(i);
      types.push(VAR_TOKEN);
      values.push(parsedValue);
    } else {
      indexes.number.push(i);
      types.push(NUMBER_TOKEN);
      values.push(parseFloat(parsedValue));
    }
    ++i;
    return SPLIT_TOKEN;
  });
  const split = tokenised.split(SPLIT_TOKEN);
  return {
    values,
    split,
    indexes,
    types
  };
}
function parseComplexValue(v) {
  return analyseComplexValue(v).values;
}
function createTransformer(source) {
  const {
    split,
    types
  } = analyseComplexValue(source);
  const numSections = split.length;
  return v => {
    let output = "";
    for (let i = 0; i < numSections; i++) {
      output += split[i];
      if (v[i] !== undefined) {
        const type = types[i];
        if (type === NUMBER_TOKEN) {
          output += sanitize(v[i]);
        } else if (type === COLOR_TOKEN) {
          output += color.transform(v[i]);
        } else {
          output += v[i];
        }
      }
    }
    return output;
  };
}
const convertNumbersToZero = v => typeof v === "number" ? 0 : v;
function getAnimatableNone$1(v) {
  const parsed = parseComplexValue(v);
  const transformer = createTransformer(v);
  return transformer(parsed.map(convertNumbersToZero));
}
const complex = {
  test,
  parse: parseComplexValue,
  createTransformer,
  getAnimatableNone: getAnimatableNone$1
};

/**
 * Properties that should default to 1 or 100%
 */
const maxDefaults = new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(v) {
  const [name, value] = v.slice(0, -1).split("(");
  if (name === "drop-shadow") return v;
  const [number] = value.match(floatRegex) || [];
  if (!number) return v;
  const unit = value.replace(number, "");
  let defaultValue = maxDefaults.has(name) ? 1 : 0;
  if (number !== value) defaultValue *= 100;
  return name + "(" + defaultValue + unit + ")";
}
const functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const filter = {
  ...complex,
  getAnimatableNone: v => {
    const functions = v.match(functionRegex);
    return functions ? functions.map(applyDefaultFilter).join(" ") : v;
  }
};

/**
 * A map of default value types for common values
 */
const defaultValueTypes = {
  ...numberValueTypes,
  // Color props
  color,
  backgroundColor: color,
  outlineColor: color,
  fill: color,
  stroke: color,
  // Border props
  borderColor: color,
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  filter,
  WebkitFilter: filter
};
/**
 * Gets the default ValueType for the provided value key
 */
const getDefaultValueType = key => defaultValueTypes[key];
function getAnimatableNone(key, value) {
  let defaultValueType = getDefaultValueType(key);
  if (defaultValueType !== filter) defaultValueType = complex;
  // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
  return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */
const invalidTemplates = new Set(["auto", "none", "0"]);
function makeNoneKeyframesAnimatable(unresolvedKeyframes, noneKeyframeIndexes, name) {
  let i = 0;
  let animatableTemplate = undefined;
  while (i < unresolvedKeyframes.length && !animatableTemplate) {
    const keyframe = unresolvedKeyframes[i];
    if (typeof keyframe === "string" && !invalidTemplates.has(keyframe) && analyseComplexValue(keyframe).values.length) {
      animatableTemplate = unresolvedKeyframes[i];
    }
    i++;
  }
  if (animatableTemplate && name) {
    for (const noneIndex of noneKeyframeIndexes) {
      unresolvedKeyframes[noneIndex] = getAnimatableNone(name, animatableTemplate);
    }
  }
}
const isNumOrPxType = v => v === number || v === px;
const getPosFromMatrix = (matrix, pos) => parseFloat(matrix.split(", ")[pos]);
const getTranslateFromMatrix = (pos2, pos3) => (_bbox, _ref247) => {
  let {
    transform
  } = _ref247;
  if (transform === "none" || !transform) return 0;
  const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
  if (matrix3d) {
    return getPosFromMatrix(matrix3d[1], pos3);
  } else {
    const matrix = transform.match(/^matrix\((.+)\)$/u);
    if (matrix) {
      return getPosFromMatrix(matrix[1], pos2);
    } else {
      return 0;
    }
  }
};
const transformKeys = new Set(["x", "y", "z"]);
const nonTranslationalTransformKeys = transformPropOrder.filter(key => !transformKeys.has(key));
function removeNonTranslationalTransform(visualElement) {
  const removedTransforms = [];
  nonTranslationalTransformKeys.forEach(key => {
    const value = visualElement.getValue(key);
    if (value !== undefined) {
      removedTransforms.push([key, value.get()]);
      value.set(key.startsWith("scale") ? 1 : 0);
    }
  });
  return removedTransforms;
}
const positionalValues = {
  // Dimensions
  width: (_ref248, _ref249) => {
    let {
      x
    } = _ref248;
    let {
      paddingLeft = "0",
      paddingRight = "0"
    } = _ref249;
    return x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight);
  },
  height: (_ref250, _ref251) => {
    let {
      y
    } = _ref250;
    let {
      paddingTop = "0",
      paddingBottom = "0"
    } = _ref251;
    return y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom);
  },
  top: (_bbox, _ref252) => {
    let {
      top
    } = _ref252;
    return parseFloat(top);
  },
  left: (_bbox, _ref253) => {
    let {
      left
    } = _ref253;
    return parseFloat(left);
  },
  bottom: (_ref254, _ref255) => {
    let {
      y
    } = _ref254;
    let {
      top
    } = _ref255;
    return parseFloat(top) + (y.max - y.min);
  },
  right: (_ref256, _ref257) => {
    let {
      x
    } = _ref256;
    let {
      left
    } = _ref257;
    return parseFloat(left) + (x.max - x.min);
  },
  // Transform
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
positionalValues.translateX = positionalValues.x;
positionalValues.translateY = positionalValues.y;
const toResolve = new Set();
let isScheduled = false;
let anyNeedsMeasurement = false;
function measureAllKeyframes() {
  if (anyNeedsMeasurement) {
    const resolversToMeasure = Array.from(toResolve).filter(resolver => resolver.needsMeasurement);
    const elementsToMeasure = new Set(resolversToMeasure.map(resolver => resolver.element));
    const transformsToRestore = new Map();
    /**
     * Write pass
     * If we're measuring elements we want to remove bounding box-changing transforms.
     */
    elementsToMeasure.forEach(element => {
      const removedTransforms = removeNonTranslationalTransform(element);
      if (!removedTransforms.length) return;
      transformsToRestore.set(element, removedTransforms);
      element.render();
    });
    // Read
    resolversToMeasure.forEach(resolver => resolver.measureInitialState());
    // Write
    elementsToMeasure.forEach(element => {
      element.render();
      const restore = transformsToRestore.get(element);
      if (restore) {
        restore.forEach(_ref258 => {
          let [key, value] = _ref258;
          var _a;
          (_a = element.getValue(key)) === null || _a === void 0 ? void 0 : _a.set(value);
        });
      }
    });
    // Read
    resolversToMeasure.forEach(resolver => resolver.measureEndState());
    // Write
    resolversToMeasure.forEach(resolver => {
      if (resolver.suspendedScrollY !== undefined) {
        window.scrollTo(0, resolver.suspendedScrollY);
      }
    });
  }
  anyNeedsMeasurement = false;
  isScheduled = false;
  toResolve.forEach(resolver => resolver.complete());
  toResolve.clear();
}
function readAllKeyframes() {
  toResolve.forEach(resolver => {
    resolver.readKeyframes();
    if (resolver.needsMeasurement) {
      anyNeedsMeasurement = true;
    }
  });
}
function flushKeyframeResolvers() {
  readAllKeyframes();
  measureAllKeyframes();
}
class KeyframeResolver {
  constructor(unresolvedKeyframes, onComplete, name, motionValue, element) {
    let isAsync = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    /**
     * Track whether this resolver has completed. Once complete, it never
     * needs to attempt keyframe resolution again.
     */
    this.isComplete = false;
    /**
     * Track whether this resolver is async. If it is, it'll be added to the
     * resolver queue and flushed in the next frame. Resolvers that aren't going
     * to trigger read/write thrashing don't need to be async.
     */
    this.isAsync = false;
    /**
     * Track whether this resolver needs to perform a measurement
     * to resolve its keyframes.
     */
    this.needsMeasurement = false;
    /**
     * Track whether this resolver is currently scheduled to resolve
     * to allow it to be cancelled and resumed externally.
     */
    this.isScheduled = false;
    this.unresolvedKeyframes = [...unresolvedKeyframes];
    this.onComplete = onComplete;
    this.name = name;
    this.motionValue = motionValue;
    this.element = element;
    this.isAsync = isAsync;
  }
  scheduleResolve() {
    this.isScheduled = true;
    if (this.isAsync) {
      toResolve.add(this);
      if (!isScheduled) {
        isScheduled = true;
        frame.read(readAllKeyframes);
        frame.resolveKeyframes(measureAllKeyframes);
      }
    } else {
      this.readKeyframes();
      this.complete();
    }
  }
  readKeyframes() {
    const {
      unresolvedKeyframes,
      name,
      element,
      motionValue
    } = this;
    /**
     * If a keyframe is null, we hydrate it either by reading it from
     * the instance, or propagating from previous keyframes.
     */
    for (let i = 0; i < unresolvedKeyframes.length; i++) {
      if (unresolvedKeyframes[i] === null) {
        /**
         * If the first keyframe is null, we need to find its value by sampling the element
         */
        if (i === 0) {
          const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
          const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
          if (currentValue !== undefined) {
            unresolvedKeyframes[0] = currentValue;
          } else if (element && name) {
            const valueAsRead = element.readValue(name, finalKeyframe);
            if (valueAsRead !== undefined && valueAsRead !== null) {
              unresolvedKeyframes[0] = valueAsRead;
            }
          }
          if (unresolvedKeyframes[0] === undefined) {
            unresolvedKeyframes[0] = finalKeyframe;
          }
          if (motionValue && currentValue === undefined) {
            motionValue.set(unresolvedKeyframes[0]);
          }
        } else {
          unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
      }
    }
  }
  setFinalKeyframe() {}
  measureInitialState() {}
  renderEndStyles() {}
  measureEndState() {}
  complete() {
    this.isComplete = true;
    this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
    toResolve.delete(this);
  }
  cancel() {
    if (!this.isComplete) {
      this.isScheduled = false;
      toResolve.delete(this);
    }
  }
  resume() {
    if (!this.isComplete) this.scheduleResolve();
  }
}

/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */
const isNumericalString = v => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);

/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */
const splitCSSVariableRegex =
// eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function parseCSSVariable(current) {
  const match = splitCSSVariableRegex.exec(current);
  if (!match) return [,];
  const [, token1, token2, fallback] = match;
  return ["--".concat(token1 !== null && token1 !== void 0 ? token1 : token2), fallback];
}
const maxDepth = 4;
function getVariableValue(current, element) {
  let depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  invariant(depth <= maxDepth, "Max CSS variable fallback depth detected in property \"".concat(current, "\". This may indicate a circular fallback dependency."));
  const [token, fallback] = parseCSSVariable(current);
  // No CSS variable detected
  if (!token) return;
  // Attempt to read this CSS variable off the element
  const resolved = window.getComputedStyle(element).getPropertyValue(token);
  if (resolved) {
    const trimmed = resolved.trim();
    return isNumericalString(trimmed) ? parseFloat(trimmed) : trimmed;
  }
  return isCSSVariableToken(fallback) ? getVariableValue(fallback, element, depth + 1) : fallback;
}

/**
 * Tests a provided value against a ValueType
 */
const testValueType = v => type => type.test(v);

/**
 * ValueType for "auto"
 */
const auto = {
  test: v => v === "auto",
  parse: v => v
};

/**
 * A list of value types commonly used for dimensions
 */
const dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */
const findDimensionValueType = v => dimensionValueTypes.find(testValueType(v));
class DOMKeyframesResolver extends KeyframeResolver {
  constructor(unresolvedKeyframes, onComplete, name, motionValue, element) {
    super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
  }
  readKeyframes() {
    const {
      unresolvedKeyframes,
      element,
      name
    } = this;
    if (!element || !element.current) return;
    super.readKeyframes();
    /**
     * If any keyframe is a CSS variable, we need to find its value by sampling the element
     */
    for (let i = 0; i < unresolvedKeyframes.length; i++) {
      let keyframe = unresolvedKeyframes[i];
      if (typeof keyframe === "string") {
        keyframe = keyframe.trim();
        if (isCSSVariableToken(keyframe)) {
          const resolved = getVariableValue(keyframe, element.current);
          if (resolved !== undefined) {
            unresolvedKeyframes[i] = resolved;
          }
          if (i === unresolvedKeyframes.length - 1) {
            this.finalKeyframe = keyframe;
          }
        }
      }
    }
    /**
     * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
     * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
     * have a far bigger performance impact.
     */
    this.resolveNoneKeyframes();
    /**
     * Check to see if unit type has changed. If so schedule jobs that will
     * temporarily set styles to the destination keyframes.
     * Skip if we have more than two keyframes or this isn't a positional value.
     * TODO: We can throw if there are multiple keyframes and the value type changes.
     */
    if (!positionalKeys.has(name) || unresolvedKeyframes.length !== 2) {
      return;
    }
    const [origin, target] = unresolvedKeyframes;
    const originType = findDimensionValueType(origin);
    const targetType = findDimensionValueType(target);
    /**
     * Either we don't recognise these value types or we can animate between them.
     */
    if (originType === targetType) return;
    /**
     * If both values are numbers or pixels, we can animate between them by
     * converting them to numbers.
     */
    if (isNumOrPxType(originType) && isNumOrPxType(targetType)) {
      for (let i = 0; i < unresolvedKeyframes.length; i++) {
        const value = unresolvedKeyframes[i];
        if (typeof value === "string") {
          unresolvedKeyframes[i] = parseFloat(value);
        }
      }
    } else {
      /**
       * Else, the only way to resolve this is by measuring the element.
       */
      this.needsMeasurement = true;
    }
  }
  resolveNoneKeyframes() {
    const {
      unresolvedKeyframes,
      name
    } = this;
    const noneKeyframeIndexes = [];
    for (let i = 0; i < unresolvedKeyframes.length; i++) {
      if (isNone(unresolvedKeyframes[i])) {
        noneKeyframeIndexes.push(i);
      }
    }
    if (noneKeyframeIndexes.length) {
      makeNoneKeyframesAnimatable(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
  }
  measureInitialState() {
    const {
      element,
      unresolvedKeyframes,
      name
    } = this;
    if (!element || !element.current) return;
    if (name === "height") {
      this.suspendedScrollY = window.pageYOffset;
    }
    this.measuredOrigin = positionalValues[name](element.measureViewportBox(), window.getComputedStyle(element.current));
    unresolvedKeyframes[0] = this.measuredOrigin;
    // Set final key frame to measure after next render
    const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
    if (measureKeyframe !== undefined) {
      element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
  }
  measureEndState() {
    var _a;
    const {
      element,
      name,
      unresolvedKeyframes
    } = this;
    if (!element || !element.current) return;
    const value = element.getValue(name);
    value && value.jump(this.measuredOrigin, false);
    const finalKeyframeIndex = unresolvedKeyframes.length - 1;
    const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
    unresolvedKeyframes[finalKeyframeIndex] = positionalValues[name](element.measureViewportBox(), window.getComputedStyle(element.current));
    if (finalKeyframe !== null && this.finalKeyframe === undefined) {
      this.finalKeyframe = finalKeyframe;
    }
    // If we removed transform values, reapply them before the next render
    if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) {
      this.removedTransforms.forEach(_ref259 => {
        let [unsetTransformName, unsetTransformValue] = _ref259;
        element.getValue(unsetTransformName).set(unsetTransformValue);
      });
    }
    this.resolveNoneKeyframes();
  }
}

/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */
const isAnimatable = (value, name) => {
  // If the list of keys tat might be non-animatable grows, replace with Set
  if (name === "zIndex") return false;
  // If it's a number or a keyframes array, we can animate it. We might at some point
  // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
  // but for now lets leave it like this for performance reasons
  if (typeof value === "number" || Array.isArray(value)) return true;
  if (typeof value === "string" && (
  // It's animatable if we have a string
  complex.test(value) || value === "0") &&
  // And it contains numbers and/or colors
  !value.startsWith("url(") // Unless it starts with "url("
  ) {
    return true;
  }
  return false;
};
function hasKeyframesChanged(keyframes) {
  const current = keyframes[0];
  if (keyframes.length === 1) return true;
  for (let i = 0; i < keyframes.length; i++) {
    if (keyframes[i] !== current) return true;
  }
}
function canAnimate(keyframes, name, type, velocity) {
  /**
   * Check if we're able to animate between the start and end keyframes,
   * and throw a warning if we're attempting to animate between one that's
   * animatable and another that isn't.
   */
  const originKeyframe = keyframes[0];
  if (originKeyframe === null) return false;
  /**
   * These aren't traditionally animatable but we do support them.
   * In future we could look into making this more generic or replacing
   * this function with mix() === mixImmediate
   */
  if (name === "display" || name === "visibility") return true;
  const targetKeyframe = keyframes[keyframes.length - 1];
  const isOriginAnimatable = isAnimatable(originKeyframe, name);
  const isTargetAnimatable = isAnimatable(targetKeyframe, name);
  warning(isOriginAnimatable === isTargetAnimatable, "You are trying to animate ".concat(name, " from \"").concat(originKeyframe, "\" to \"").concat(targetKeyframe, "\". ").concat(originKeyframe, " is not an animatable value - to enable this animation set ").concat(originKeyframe, " to a value animatable to ").concat(targetKeyframe, " via the `style` property."));
  // Always skip if any of these are true
  if (!isOriginAnimatable || !isTargetAnimatable) {
    return false;
  }
  return hasKeyframesChanged(keyframes) || (type === "spring" || isGenerator(type)) && velocity;
}
const isNotNull = value => value !== null;
function getFinalKeyframe(keyframes, _ref260, finalKeyframe) {
  let {
    repeat,
    repeatType = "loop"
  } = _ref260;
  const resolvedKeyframes = keyframes.filter(isNotNull);
  const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
  return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */
const MAX_RESOLVE_DELAY = 40;
class BaseAnimation {
  constructor(_ref261) {
    let {
      autoplay = true,
      delay = 0,
      type = "keyframes",
      repeat = 0,
      repeatDelay = 0,
      repeatType = "loop",
      ...options
    } = _ref261;
    // Track whether the animation has been stopped. Stopped animations won't restart.
    this.isStopped = false;
    this.hasAttemptedResolve = false;
    this.createdAt = time.now();
    this.options = {
      autoplay,
      delay,
      type,
      repeat,
      repeatDelay,
      repeatType,
      ...options
    };
    this.updateFinishedPromise();
  }
  /**
   * This method uses the createdAt and resolvedAt to calculate the
   * animation startTime. *Ideally*, we would use the createdAt time as t=0
   * as the following frame would then be the first frame of the animation in
   * progress, which would feel snappier.
   *
   * However, if there's a delay (main thread work) between the creation of
   * the animation and the first commited frame, we prefer to use resolvedAt
   * to avoid a sudden jump into the animation.
   */
  calcStartTime() {
    if (!this.resolvedAt) return this.createdAt;
    return this.resolvedAt - this.createdAt > MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt;
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    if (!this._resolved && !this.hasAttemptedResolve) {
      flushKeyframeResolvers();
    }
    return this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(keyframes, finalKeyframe) {
    this.resolvedAt = time.now();
    this.hasAttemptedResolve = true;
    const {
      name,
      type,
      velocity,
      delay,
      onComplete,
      onUpdate,
      isGenerator
    } = this.options;
    /**
     * If we can't animate this value with the resolved keyframes
     * then we should complete it immediately.
     */
    if (!isGenerator && !canAnimate(keyframes, name, type, velocity)) {
      // Finish immediately
      if (!delay) {
        onUpdate && onUpdate(getFinalKeyframe(keyframes, this.options, finalKeyframe));
        onComplete && onComplete();
        this.resolveFinishedPromise();
        return;
      }
      // Finish after a delay
      else {
        this.options.duration = 0;
      }
    }
    const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
    if (resolvedAnimation === false) return;
    this._resolved = {
      keyframes,
      finalKeyframe,
      ...resolvedAnimation
    };
    this.onPostResolved();
  }
  onPostResolved() {}
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(resolve, reject) {
    return this.currentFinishedPromise.then(resolve, reject);
  }
  flatten() {
    this.options.type = "keyframes";
    this.options.ease = "linear";
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise(resolve => {
      this.resolveFinishedPromise = resolve;
    });
  }
}

/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/
const mixNumber$1 = (from, to, progress) => {
  return from + (to - from) * progress;
};

// Adapted from https://gist.github.com/mjackson/5311256
function hueToRgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}
function hslaToRgba(_ref262) {
  let {
    hue,
    saturation,
    lightness,
    alpha
  } = _ref262;
  hue /= 360;
  saturation /= 100;
  lightness /= 100;
  let red = 0;
  let green = 0;
  let blue = 0;
  if (!saturation) {
    red = green = blue = lightness;
  } else {
    const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
    const p = 2 * lightness - q;
    red = hueToRgb(p, q, hue + 1 / 3);
    green = hueToRgb(p, q, hue);
    blue = hueToRgb(p, q, hue - 1 / 3);
  }
  return {
    red: Math.round(red * 255),
    green: Math.round(green * 255),
    blue: Math.round(blue * 255),
    alpha
  };
}
function mixImmediate(a, b) {
  return p => p > 0 ? b : a;
}

// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const mixLinearColor = (from, to, v) => {
  const fromExpo = from * from;
  const expo = v * (to * to - fromExpo) + fromExpo;
  return expo < 0 ? 0 : Math.sqrt(expo);
};
const colorTypes = [hex, rgba, hsla];
const getColorType = v => colorTypes.find(type => type.test(v));
function asRGBA(color) {
  const type = getColorType(color);
  warning(Boolean(type), "'".concat(color, "' is not an animatable color. Use the equivalent color code instead."));
  if (!Boolean(type)) return false;
  let model = type.parse(color);
  if (type === hsla) {
    // TODO Remove this cast - needed since Motion's stricter typing
    model = hslaToRgba(model);
  }
  return model;
}
const mixColor = (from, to) => {
  const fromRGBA = asRGBA(from);
  const toRGBA = asRGBA(to);
  if (!fromRGBA || !toRGBA) {
    return mixImmediate(from, to);
  }
  const blended = {
    ...fromRGBA
  };
  return v => {
    blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v);
    blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v);
    blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v);
    blended.alpha = mixNumber$1(fromRGBA.alpha, toRGBA.alpha, v);
    return rgba.transform(blended);
  };
};

/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */
const combineFunctions = (a, b) => v => b(a(v));
const pipe = function () {
  for (var _len10 = arguments.length, transformers = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
    transformers[_key10] = arguments[_key10];
  }
  return transformers.reduce(combineFunctions);
};
const invisibleValues = new Set(["none", "hidden"]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */
function mixVisibility(origin, target) {
  if (invisibleValues.has(origin)) {
    return p => p <= 0 ? origin : target;
  } else {
    return p => p >= 1 ? target : origin;
  }
}
function mixNumber(a, b) {
  return p => mixNumber$1(a, b, p);
}
function getMixer(a) {
  if (typeof a === "number") {
    return mixNumber;
  } else if (typeof a === "string") {
    return isCSSVariableToken(a) ? mixImmediate : color.test(a) ? mixColor : mixComplex;
  } else if (Array.isArray(a)) {
    return mixArray;
  } else if (typeof a === "object") {
    return color.test(a) ? mixColor : mixObject;
  }
  return mixImmediate;
}
function mixArray(a, b) {
  const output = [...a];
  const numValues = output.length;
  const blendValue = a.map((v, i) => getMixer(v)(v, b[i]));
  return p => {
    for (let i = 0; i < numValues; i++) {
      output[i] = blendValue[i](p);
    }
    return output;
  };
}
function mixObject(a, b) {
  const output = {
    ...a,
    ...b
  };
  const blendValue = {};
  for (const key in output) {
    if (a[key] !== undefined && b[key] !== undefined) {
      blendValue[key] = getMixer(a[key])(a[key], b[key]);
    }
  }
  return v => {
    for (const key in blendValue) {
      output[key] = blendValue[key](v);
    }
    return output;
  };
}
function matchOrder(origin, target) {
  var _a;
  const orderedOrigin = [];
  const pointers = {
    color: 0,
    var: 0,
    number: 0
  };
  for (let i = 0; i < target.values.length; i++) {
    const type = target.types[i];
    const originIndex = origin.indexes[type][pointers[type]];
    const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
    orderedOrigin[i] = originValue;
    pointers[type]++;
  }
  return orderedOrigin;
}
const mixComplex = (origin, target) => {
  const template = complex.createTransformer(target);
  const originStats = analyseComplexValue(origin);
  const targetStats = analyseComplexValue(target);
  const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
  if (canInterpolate) {
    if (invisibleValues.has(origin) && !targetStats.values.length || invisibleValues.has(target) && !originStats.values.length) {
      return mixVisibility(origin, target);
    }
    return pipe(mixArray(matchOrder(originStats, targetStats), targetStats.values), template);
  } else {
    warning(true, "Complex values '".concat(origin, "' and '").concat(target, "' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition."));
    return mixImmediate(origin, target);
  }
};
function mix(from, to, p) {
  if (typeof from === "number" && typeof to === "number" && typeof p === "number") {
    return mixNumber$1(from, to, p);
  }
  const mixer = getMixer(from);
  return mixer(from, to);
}
const velocitySampleDuration = 5; // ms
function calcGeneratorVelocity(resolveValue, t, current) {
  const prevT = Math.max(t - velocitySampleDuration, 0);
  return velocityPerSecond(current - resolveValue(prevT), t - prevT);
}
const springDefaults = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1.0,
  velocity: 0.0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 0.005,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10.0,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
};
const safeMin = 0.001;
function findSpring(_ref263) {
  let {
    duration = springDefaults.duration,
    bounce = springDefaults.bounce,
    velocity = springDefaults.velocity,
    mass = springDefaults.mass
  } = _ref263;
  let envelope;
  let derivative;
  warning(duration <= secondsToMilliseconds(springDefaults.maxDuration), "Spring duration must be 10 seconds or less");
  let dampingRatio = 1 - bounce;
  /**
   * Restrict dampingRatio and duration to within acceptable ranges.
   */
  dampingRatio = clamp(springDefaults.minDamping, springDefaults.maxDamping, dampingRatio);
  duration = clamp(springDefaults.minDuration, springDefaults.maxDuration, millisecondsToSeconds(duration));
  if (dampingRatio < 1) {
    /**
     * Underdamped spring
     */
    envelope = undampedFreq => {
      const exponentialDecay = undampedFreq * dampingRatio;
      const delta = exponentialDecay * duration;
      const a = exponentialDecay - velocity;
      const b = calcAngularFreq(undampedFreq, dampingRatio);
      const c = Math.exp(-delta);
      return safeMin - a / b * c;
    };
    derivative = undampedFreq => {
      const exponentialDecay = undampedFreq * dampingRatio;
      const delta = exponentialDecay * duration;
      const d = delta * velocity + velocity;
      const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
      const f = Math.exp(-delta);
      const g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
      const factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
      return factor * ((d - e) * f) / g;
    };
  } else {
    /**
     * Critically-damped spring
     */
    envelope = undampedFreq => {
      const a = Math.exp(-undampedFreq * duration);
      const b = (undampedFreq - velocity) * duration + 1;
      return -safeMin + a * b;
    };
    derivative = undampedFreq => {
      const a = Math.exp(-undampedFreq * duration);
      const b = (velocity - undampedFreq) * (duration * duration);
      return a * b;
    };
  }
  const initialGuess = 5 / duration;
  const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
  duration = secondsToMilliseconds(duration);
  if (isNaN(undampedFreq)) {
    return {
      stiffness: springDefaults.stiffness,
      damping: springDefaults.damping,
      duration
    };
  } else {
    const stiffness = Math.pow(undampedFreq, 2) * mass;
    return {
      stiffness,
      damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
      duration
    };
  }
}
const rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
  let result = initialGuess;
  for (let i = 1; i < rootIterations; i++) {
    result = result - envelope(result) / derivative(result);
  }
  return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
  return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}
const durationKeys = ["duration", "bounce"];
const physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys) {
  return keys.some(key => options[key] !== undefined);
}
function getSpringOptions(options) {
  let springOptions = {
    velocity: springDefaults.velocity,
    stiffness: springDefaults.stiffness,
    damping: springDefaults.damping,
    mass: springDefaults.mass,
    isResolvedFromDuration: false,
    ...options
  };
  // stiffness/damping/mass overrides duration/bounce
  if (!isSpringType(options, physicsKeys) && isSpringType(options, durationKeys)) {
    if (options.visualDuration) {
      const visualDuration = options.visualDuration;
      const root = 2 * Math.PI / (visualDuration * 1.2);
      const stiffness = root * root;
      const damping = 2 * clamp(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
      springOptions = {
        ...springOptions,
        mass: springDefaults.mass,
        stiffness,
        damping
      };
    } else {
      const derived = findSpring(options);
      springOptions = {
        ...springOptions,
        ...derived,
        mass: springDefaults.mass
      };
      springOptions.isResolvedFromDuration = true;
    }
  }
  return springOptions;
}
function spring() {
  let optionsOrVisualDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : springDefaults.visualDuration;
  let bounce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : springDefaults.bounce;
  const options = typeof optionsOrVisualDuration !== "object" ? {
    visualDuration: optionsOrVisualDuration,
    keyframes: [0, 1],
    bounce
  } : optionsOrVisualDuration;
  let {
    restSpeed,
    restDelta
  } = options;
  const origin = options.keyframes[0];
  const target = options.keyframes[options.keyframes.length - 1];
  /**
   * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
   * to reduce GC during animation.
   */
  const state = {
    done: false,
    value: origin
  };
  const {
    stiffness,
    damping,
    mass,
    duration,
    velocity,
    isResolvedFromDuration
  } = getSpringOptions({
    ...options,
    velocity: -millisecondsToSeconds(options.velocity || 0)
  });
  const initialVelocity = velocity || 0.0;
  const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
  const initialDelta = target - origin;
  const undampedAngularFreq = millisecondsToSeconds(Math.sqrt(stiffness / mass));
  /**
   * If we're working on a granular scale, use smaller defaults for determining
   * when the spring is finished.
   *
   * These defaults have been selected emprically based on what strikes a good
   * ratio between feeling good and finishing as soon as changes are imperceptible.
   */
  const isGranularScale = Math.abs(initialDelta) < 5;
  restSpeed || (restSpeed = isGranularScale ? springDefaults.restSpeed.granular : springDefaults.restSpeed.default);
  restDelta || (restDelta = isGranularScale ? springDefaults.restDelta.granular : springDefaults.restDelta.default);
  let resolveSpring;
  if (dampingRatio < 1) {
    const angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
    // Underdamped spring
    resolveSpring = t => {
      const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
      return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
    };
  } else if (dampingRatio === 1) {
    // Critically damped spring
    resolveSpring = t => target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
  } else {
    // Overdamped spring
    const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
    resolveSpring = t => {
      const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
      // When performing sinh or cosh values can hit Infinity so we cap them here
      const freqForT = Math.min(dampedAngularFreq * t, 300);
      return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
    };
  }
  const generator = {
    calculatedDuration: isResolvedFromDuration ? duration || null : null,
    next: t => {
      const current = resolveSpring(t);
      if (!isResolvedFromDuration) {
        let currentVelocity = 0.0;
        /**
         * We only need to calculate velocity for under-damped springs
         * as over- and critically-damped springs can't overshoot, so
         * checking only for displacement is enough.
         */
        if (dampingRatio < 1) {
          currentVelocity = t === 0 ? secondsToMilliseconds(initialVelocity) : calcGeneratorVelocity(resolveSpring, t, current);
        }
        const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
        const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
        state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
      } else {
        state.done = t >= duration;
      }
      state.value = state.done ? target : current;
      return state;
    },
    toString: () => {
      const calculatedDuration = Math.min(calcGeneratorDuration(generator), maxGeneratorDuration);
      const easing = generateLinearEasing(progress => generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
      return calculatedDuration + "ms " + easing;
    }
  };
  return generator;
}
function inertia(_ref264) {
  let {
    keyframes,
    velocity = 0.0,
    power = 0.8,
    timeConstant = 325,
    bounceDamping = 10,
    bounceStiffness = 500,
    modifyTarget,
    min,
    max,
    restDelta = 0.5,
    restSpeed
  } = _ref264;
  const origin = keyframes[0];
  const state = {
    done: false,
    value: origin
  };
  const isOutOfBounds = v => min !== undefined && v < min || max !== undefined && v > max;
  const nearestBoundary = v => {
    if (min === undefined) return max;
    if (max === undefined) return min;
    return Math.abs(min - v) < Math.abs(max - v) ? min : max;
  };
  let amplitude = power * velocity;
  const ideal = origin + amplitude;
  const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
  /**
   * If the target has changed we need to re-calculate the amplitude, otherwise
   * the animation will start from the wrong position.
   */
  if (target !== ideal) amplitude = target - origin;
  const calcDelta = t => -amplitude * Math.exp(-t / timeConstant);
  const calcLatest = t => target + calcDelta(t);
  const applyFriction = t => {
    const delta = calcDelta(t);
    const latest = calcLatest(t);
    state.done = Math.abs(delta) <= restDelta;
    state.value = state.done ? target : latest;
  };
  /**
   * Ideally this would resolve for t in a stateless way, we could
   * do that by always precalculating the animation but as we know
   * this will be done anyway we can assume that spring will
   * be discovered during that.
   */
  let timeReachedBoundary;
  let spring$1;
  const checkCatchBoundary = t => {
    if (!isOutOfBounds(state.value)) return;
    timeReachedBoundary = t;
    spring$1 = spring({
      keyframes: [state.value, nearestBoundary(state.value)],
      velocity: calcGeneratorVelocity(calcLatest, t, state.value),
      // TODO: This should be passing * 1000
      damping: bounceDamping,
      stiffness: bounceStiffness,
      restDelta,
      restSpeed
    });
  };
  checkCatchBoundary(0);
  return {
    calculatedDuration: null,
    next: t => {
      /**
       * We need to resolve the friction to figure out if we need a
       * spring but we don't want to do this twice per frame. So here
       * we flag if we updated for this frame and later if we did
       * we can skip doing it again.
       */
      let hasUpdatedFrame = false;
      if (!spring$1 && timeReachedBoundary === undefined) {
        hasUpdatedFrame = true;
        applyFriction(t);
        checkCatchBoundary(t);
      }
      /**
       * If we have a spring and the provided t is beyond the moment the friction
       * animation crossed the min/max boundary, use the spring.
       */
      if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) {
        return spring$1.next(t - timeReachedBoundary);
      } else {
        !hasUpdatedFrame && applyFriction(t);
        return state;
      }
    }
  };
}
const easeIn = /*@__PURE__*/cubicBezier(0.42, 0, 1, 1);
const easeOut = /*@__PURE__*/cubicBezier(0, 0, 0.58, 1);
const easeInOut = /*@__PURE__*/cubicBezier(0.42, 0, 0.58, 1);
const isEasingArray = ease => {
  return Array.isArray(ease) && typeof ease[0] !== "number";
};
const easingLookup = {
  linear: noop,
  easeIn,
  easeInOut,
  easeOut,
  circIn,
  circInOut,
  circOut,
  backIn,
  backInOut,
  backOut,
  anticipate
};
const easingDefinitionToFunction = definition => {
  if (isBezierDefinition(definition)) {
    // If cubic bezier definition, create bezier curve
    invariant(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [x1, y1, x2, y2] = definition;
    return cubicBezier(x1, y1, x2, y2);
  } else if (typeof definition === "string") {
    // Else lookup from table
    invariant(easingLookup[definition] !== undefined, "Invalid easing type '".concat(definition, "'"));
    return easingLookup[definition];
  }
  return definition;
};
function createMixers(output, ease, customMixer) {
  const mixers = [];
  const mixerFactory = customMixer || mix;
  const numMixers = output.length - 1;
  for (let i = 0; i < numMixers; i++) {
    let mixer = mixerFactory(output[i], output[i + 1]);
    if (ease) {
      const easingFunction = Array.isArray(ease) ? ease[i] || noop : ease;
      mixer = pipe(easingFunction, mixer);
    }
    mixers.push(mixer);
  }
  return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */
function interpolate(input, output) {
  let {
    clamp: isClamp = true,
    ease,
    mixer
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const inputLength = input.length;
  invariant(inputLength === output.length, "Both input and output ranges must be the same length");
  /**
   * If we're only provided a single input, we can just make a function
   * that returns the output.
   */
  if (inputLength === 1) return () => output[0];
  if (inputLength === 2 && output[0] === output[1]) return () => output[1];
  const isZeroDeltaRange = input[0] === input[1];
  // If input runs highest -> lowest, reverse both arrays
  if (input[0] > input[inputLength - 1]) {
    input = [...input].reverse();
    output = [...output].reverse();
  }
  const mixers = createMixers(output, ease, mixer);
  const numMixers = mixers.length;
  const interpolator = v => {
    if (isZeroDeltaRange && v < input[0]) return output[0];
    let i = 0;
    if (numMixers > 1) {
      for (; i < input.length - 2; i++) {
        if (v < input[i + 1]) break;
      }
    }
    const progressInRange = progress(input[i], input[i + 1], v);
    return mixers[i](progressInRange);
  };
  return isClamp ? v => interpolator(clamp(input[0], input[inputLength - 1], v)) : interpolator;
}
function fillOffset(offset, remaining) {
  const min = offset[offset.length - 1];
  for (let i = 1; i <= remaining; i++) {
    const offsetProgress = progress(0, remaining, i);
    offset.push(mixNumber$1(min, 1, offsetProgress));
  }
}
function defaultOffset(arr) {
  const offset = [0];
  fillOffset(offset, arr.length - 1);
  return offset;
}
function convertOffsetToTimes(offset, duration) {
  return offset.map(o => o * duration);
}
function defaultEasing(values, easing) {
  return values.map(() => easing || easeInOut).splice(0, values.length - 1);
}
function keyframes(_ref265) {
  let {
    duration = 300,
    keyframes: keyframeValues,
    times,
    ease = "easeInOut"
  } = _ref265;
  /**
   * Easing functions can be externally defined as strings. Here we convert them
   * into actual functions.
   */
  const easingFunctions = isEasingArray(ease) ? ease.map(easingDefinitionToFunction) : easingDefinitionToFunction(ease);
  /**
   * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
   * to reduce GC during animation.
   */
  const state = {
    done: false,
    value: keyframeValues[0]
  };
  /**
   * Create a times array based on the provided 0-1 offsets
   */
  const absoluteTimes = convertOffsetToTimes(
  // Only use the provided offsets if they're the correct length
  // TODO Maybe we should warn here if there's a length mismatch
  times && times.length === keyframeValues.length ? times : defaultOffset(keyframeValues), duration);
  const mapTimeToKeyframe = interpolate(absoluteTimes, keyframeValues, {
    ease: Array.isArray(easingFunctions) ? easingFunctions : defaultEasing(keyframeValues, easingFunctions)
  });
  return {
    calculatedDuration: duration,
    next: t => {
      state.value = mapTimeToKeyframe(t);
      state.done = t >= duration;
      return state;
    }
  };
}
const frameloopDriver = update => {
  const passTimestamp = _ref266 => {
    let {
      timestamp
    } = _ref266;
    return update(timestamp);
  };
  return {
    start: () => frame.update(passTimestamp, true),
    stop: () => cancelFrame(passTimestamp),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => frameData.isProcessing ? frameData.timestamp : time.now()
  };
};
const generators = {
  decay: inertia,
  inertia,
  tween: keyframes,
  keyframes: keyframes,
  spring
};
const percentToProgress = percent => percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */
class MainThreadAnimation extends BaseAnimation {
  constructor(options) {
    super(options);
    /**
     * The time at which the animation was paused.
     */
    this.holdTime = null;
    /**
     * The time at which the animation was cancelled.
     */
    this.cancelTime = null;
    /**
     * The current time of the animation.
     */
    this.currentTime = 0;
    /**
     * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
     */
    this.playbackSpeed = 1;
    /**
     * The state of the animation to apply when the animation is resolved. This
     * allows calls to the public API to control the animation before it is resolved,
     * without us having to resolve it first.
     */
    this.pendingPlayState = "running";
    /**
     * The time at which the animation was started.
     */
    this.startTime = null;
    this.state = "idle";
    /**
     * This method is bound to the instance to fix a pattern where
     * animation.stop is returned as a reference from a useEffect.
     */
    this.stop = () => {
      this.resolver.cancel();
      this.isStopped = true;
      if (this.state === "idle") return;
      this.teardown();
      const {
        onStop
      } = this.options;
      onStop && onStop();
    };
    const {
      name,
      motionValue,
      element,
      keyframes
    } = this.options;
    const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || KeyframeResolver;
    const onResolved = (resolvedKeyframes, finalKeyframe) => this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
    this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue, element);
    this.resolver.scheduleResolve();
  }
  flatten() {
    super.flatten();
    // If we've already resolved the animation, re-initialise it
    if (this._resolved) {
      Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
    }
  }
  initPlayback(keyframes$1) {
    const {
      type = "keyframes",
      repeat = 0,
      repeatDelay = 0,
      repeatType,
      velocity = 0
    } = this.options;
    const generatorFactory = isGenerator(type) ? type : generators[type] || keyframes;
    /**
     * If our generator doesn't support mixing numbers, we need to replace keyframes with
     * [0, 100] and then make a function that maps that to the actual keyframes.
     *
     * 100 is chosen instead of 1 as it works nicer with spring animations.
     */
    let mapPercentToKeyframes;
    let mirroredGenerator;
    if (generatorFactory !== keyframes && typeof keyframes$1[0] !== "number") {
      if (process.env.NODE_ENV !== "production") {
        invariant(keyframes$1.length === 2, "Only two keyframes currently supported with spring and inertia animations. Trying to animate ".concat(keyframes$1));
      }
      mapPercentToKeyframes = pipe(percentToProgress, mix(keyframes$1[0], keyframes$1[1]));
      keyframes$1 = [0, 100];
    }
    const generator = generatorFactory({
      ...this.options,
      keyframes: keyframes$1
    });
    /**
     * If we have a mirror repeat type we need to create a second generator that outputs the
     * mirrored (not reversed) animation and later ping pong between the two generators.
     */
    if (repeatType === "mirror") {
      mirroredGenerator = generatorFactory({
        ...this.options,
        keyframes: [...keyframes$1].reverse(),
        velocity: -velocity
      });
    }
    /**
     * If duration is undefined and we have repeat options,
     * we need to calculate a duration from the generator.
     *
     * We set it to the generator itself to cache the duration.
     * Any timeline resolver will need to have already precalculated
     * the duration by this step.
     */
    if (generator.calculatedDuration === null) {
      generator.calculatedDuration = calcGeneratorDuration(generator);
    }
    const {
      calculatedDuration
    } = generator;
    const resolvedDuration = calculatedDuration + repeatDelay;
    const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    return {
      generator,
      mirroredGenerator,
      mapPercentToKeyframes,
      calculatedDuration,
      resolvedDuration,
      totalDuration
    };
  }
  onPostResolved() {
    const {
      autoplay = true
    } = this.options;
    this.play();
    if (this.pendingPlayState === "paused" || !autoplay) {
      this.pause();
    } else {
      this.state = this.pendingPlayState;
    }
  }
  tick(timestamp) {
    let sample = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const {
      resolved
    } = this;
    // If the animations has failed to resolve, return the final keyframe.
    if (!resolved) {
      const {
        keyframes
      } = this.options;
      return {
        done: true,
        value: keyframes[keyframes.length - 1]
      };
    }
    const {
      finalKeyframe,
      generator,
      mirroredGenerator,
      mapPercentToKeyframes,
      keyframes,
      calculatedDuration,
      totalDuration,
      resolvedDuration
    } = resolved;
    if (this.startTime === null) return generator.next(0);
    const {
      delay,
      repeat,
      repeatType,
      repeatDelay,
      onUpdate
    } = this.options;
    /**
     * requestAnimationFrame timestamps can come through as lower than
     * the startTime as set by performance.now(). Here we prevent this,
     * though in the future it could be possible to make setting startTime
     * a pending operation that gets resolved here.
     */
    if (this.speed > 0) {
      this.startTime = Math.min(this.startTime, timestamp);
    } else if (this.speed < 0) {
      this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
    }
    // Update currentTime
    if (sample) {
      this.currentTime = timestamp;
    } else if (this.holdTime !== null) {
      this.currentTime = this.holdTime;
    } else {
      // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
      // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
      // example.
      this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
    }
    // Rebase on delay
    const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
    const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
    this.currentTime = Math.max(timeWithoutDelay, 0);
    // If this animation has finished, set the current time  to the total duration.
    if (this.state === "finished" && this.holdTime === null) {
      this.currentTime = totalDuration;
    }
    let elapsed = this.currentTime;
    let frameGenerator = generator;
    if (repeat) {
      /**
       * Get the current progress (0-1) of the animation. If t is >
       * than duration we'll get values like 2.5 (midway through the
       * third iteration)
       */
      const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
      /**
       * Get the current iteration (0 indexed). For instance the floor of
       * 2.5 is 2.
       */
      let currentIteration = Math.floor(progress);
      /**
       * Get the current progress of the iteration by taking the remainder
       * so 2.5 is 0.5 through iteration 2
       */
      let iterationProgress = progress % 1.0;
      /**
       * If iteration progress is 1 we count that as the end
       * of the previous iteration.
       */
      if (!iterationProgress && progress >= 1) {
        iterationProgress = 1;
      }
      iterationProgress === 1 && currentIteration--;
      currentIteration = Math.min(currentIteration, repeat + 1);
      /**
       * Reverse progress if we're not running in "normal" direction
       */
      const isOddIteration = Boolean(currentIteration % 2);
      if (isOddIteration) {
        if (repeatType === "reverse") {
          iterationProgress = 1 - iterationProgress;
          if (repeatDelay) {
            iterationProgress -= repeatDelay / resolvedDuration;
          }
        } else if (repeatType === "mirror") {
          frameGenerator = mirroredGenerator;
        }
      }
      elapsed = clamp(0, 1, iterationProgress) * resolvedDuration;
    }
    /**
     * If we're in negative time, set state as the initial keyframe.
     * This prevents delay: x, duration: 0 animations from finishing
     * instantly.
     */
    const state = isInDelayPhase ? {
      done: false,
      value: keyframes[0]
    } : frameGenerator.next(elapsed);
    if (mapPercentToKeyframes) {
      state.value = mapPercentToKeyframes(state.value);
    }
    let {
      done
    } = state;
    if (!isInDelayPhase && calculatedDuration !== null) {
      done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
    }
    const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
    if (isAnimationFinished && finalKeyframe !== undefined) {
      state.value = getFinalKeyframe(keyframes, this.options, finalKeyframe);
    }
    if (onUpdate) {
      onUpdate(state.value);
    }
    if (isAnimationFinished) {
      this.finish();
    }
    return state;
  }
  get duration() {
    const {
      resolved
    } = this;
    return resolved ? millisecondsToSeconds(resolved.calculatedDuration) : 0;
  }
  get time() {
    return millisecondsToSeconds(this.currentTime);
  }
  set time(newTime) {
    newTime = secondsToMilliseconds(newTime);
    this.currentTime = newTime;
    if (this.holdTime !== null || this.speed === 0) {
      this.holdTime = newTime;
    } else if (this.driver) {
      this.startTime = this.driver.now() - newTime / this.speed;
    }
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(newSpeed) {
    const hasChanged = this.playbackSpeed !== newSpeed;
    this.playbackSpeed = newSpeed;
    if (hasChanged) {
      this.time = millisecondsToSeconds(this.currentTime);
    }
  }
  play() {
    if (!this.resolver.isScheduled) {
      this.resolver.resume();
    }
    if (!this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped) return;
    const {
      driver = frameloopDriver,
      onPlay,
      startTime
    } = this.options;
    if (!this.driver) {
      this.driver = driver(timestamp => this.tick(timestamp));
    }
    onPlay && onPlay();
    const now = this.driver.now();
    if (this.holdTime !== null) {
      this.startTime = now - this.holdTime;
    } else if (!this.startTime) {
      this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
    } else if (this.state === "finished") {
      this.startTime = now;
    }
    if (this.state === "finished") {
      this.updateFinishedPromise();
    }
    this.cancelTime = this.startTime;
    this.holdTime = null;
    /**
     * Set playState to running only after we've used it in
     * the previous logic.
     */
    this.state = "running";
    this.driver.start();
  }
  pause() {
    var _a;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused";
    this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
  }
  complete() {
    if (this.state !== "running") {
      this.play();
    }
    this.pendingPlayState = this.state = "finished";
    this.holdTime = null;
  }
  finish() {
    this.teardown();
    this.state = "finished";
    const {
      onComplete
    } = this.options;
    onComplete && onComplete();
  }
  cancel() {
    if (this.cancelTime !== null) {
      this.tick(this.cancelTime);
    }
    this.teardown();
    this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle";
    this.stopDriver();
    this.resolveFinishedPromise();
    this.updateFinishedPromise();
    this.startTime = this.cancelTime = null;
    this.resolver.cancel();
  }
  stopDriver() {
    if (!this.driver) return;
    this.driver.stop();
    this.driver = undefined;
  }
  sample(time) {
    this.startTime = 0;
    return this.tick(time, true);
  }
}

/**
 * A list of values that can be hardware-accelerated.
 */
const acceleratedValues = new Set(["opacity", "clipPath", "filter", "transform"
// TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
// or until we implement support for linear() easing.
// "background-color"
]);
function startWaapiAnimation(element, valueName, keyframes) {
  let {
    delay = 0,
    duration = 300,
    repeat = 0,
    repeatType = "loop",
    ease = "easeInOut",
    times
  } = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  const keyframeOptions = {
    [valueName]: keyframes
  };
  if (times) keyframeOptions.offset = times;
  const easing = mapEasingToNativeEasing(ease, duration);
  /**
   * If this is an easing array, apply to keyframes, not animation as a whole
   */
  if (Array.isArray(easing)) keyframeOptions.easing = easing;
  return element.animate(keyframeOptions, {
    delay,
    duration,
    easing: !Array.isArray(easing) ? easing : "linear",
    fill: "both",
    iterations: repeat + 1,
    direction: repeatType === "reverse" ? "alternate" : "normal"
  });
}
const supportsWaapi = /*@__PURE__*/memo(() => Object.hasOwnProperty.call(Element.prototype, "animate"));

/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */
const sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */
const maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */
function requiresPregeneratedKeyframes(options) {
  return isGenerator(options.type) || options.type === "spring" || !isWaapiSupportedEasing(options.ease);
}
function pregenerateKeyframes(keyframes, options) {
  /**
   * Create a main-thread animation to pregenerate keyframes.
   * We sample this at regular intervals to generate keyframes that we then
   * linearly interpolate between.
   */
  const sampleAnimation = new MainThreadAnimation({
    ...options,
    keyframes,
    repeat: 0,
    delay: 0,
    isGenerator: true
  });
  let state = {
    done: false,
    value: keyframes[0]
  };
  const pregeneratedKeyframes = [];
  /**
   * Bail after 20 seconds of pre-generated keyframes as it's likely
   * we're heading for an infinite loop.
   */
  let t = 0;
  while (!state.done && t < maxDuration) {
    state = sampleAnimation.sample(t);
    pregeneratedKeyframes.push(state.value);
    t += sampleDelta;
  }
  return {
    times: undefined,
    keyframes: pregeneratedKeyframes,
    duration: t - sampleDelta,
    ease: "linear"
  };
}
const unsupportedEasingFunctions = {
  anticipate,
  backInOut,
  circInOut
};
function isUnsupportedEase(key) {
  return key in unsupportedEasingFunctions;
}
class AcceleratedAnimation extends BaseAnimation {
  constructor(options) {
    super(options);
    const {
      name,
      motionValue,
      element,
      keyframes
    } = this.options;
    this.resolver = new DOMKeyframesResolver(keyframes, (resolvedKeyframes, finalKeyframe) => this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue, element);
    this.resolver.scheduleResolve();
  }
  initPlayback(keyframes, finalKeyframe) {
    let {
      duration = 300,
      times,
      ease,
      type,
      motionValue,
      name,
      startTime
    } = this.options;
    /**
     * If element has since been unmounted, return false to indicate
     * the animation failed to initialised.
     */
    if (!motionValue.owner || !motionValue.owner.current) {
      return false;
    }
    /**
     * If the user has provided an easing function name that isn't supported
     * by WAAPI (like "anticipate"), we need to provide the corressponding
     * function. This will later get converted to a linear() easing function.
     */
    if (typeof ease === "string" && supportsLinearEasing() && isUnsupportedEase(ease)) {
      ease = unsupportedEasingFunctions[ease];
    }
    /**
     * If this animation needs pre-generated keyframes then generate.
     */
    if (requiresPregeneratedKeyframes(this.options)) {
      const {
        onComplete,
        onUpdate,
        motionValue,
        element,
        ...options
      } = this.options;
      const pregeneratedAnimation = pregenerateKeyframes(keyframes, options);
      keyframes = pregeneratedAnimation.keyframes;
      // If this is a very short animation, ensure we have
      // at least two keyframes to animate between as older browsers
      // can't animate between a single keyframe.
      if (keyframes.length === 1) {
        keyframes[1] = keyframes[0];
      }
      duration = pregeneratedAnimation.duration;
      times = pregeneratedAnimation.times;
      ease = pregeneratedAnimation.ease;
      type = "keyframes";
    }
    const animation = startWaapiAnimation(motionValue.owner.current, name, keyframes, {
      ...this.options,
      duration,
      times,
      ease
    });
    // Override the browser calculated startTime with one synchronised to other JS
    // and WAAPI animations starting this event loop.
    animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
    if (this.pendingTimeline) {
      attachTimeline(animation, this.pendingTimeline);
      this.pendingTimeline = undefined;
    } else {
      /**
       * Prefer the `onfinish` prop as it's more widely supported than
       * the `finished` promise.
       *
       * Here, we synchronously set the provided MotionValue to the end
       * keyframe. If we didn't, when the WAAPI animation is finished it would
       * be removed from the element which would then revert to its old styles.
       */
      animation.onfinish = () => {
        const {
          onComplete
        } = this.options;
        motionValue.set(getFinalKeyframe(keyframes, this.options, finalKeyframe));
        onComplete && onComplete();
        this.cancel();
        this.resolveFinishedPromise();
      };
    }
    return {
      animation,
      duration,
      times,
      type,
      ease,
      keyframes: keyframes
    };
  }
  get duration() {
    const {
      resolved
    } = this;
    if (!resolved) return 0;
    const {
      duration
    } = resolved;
    return millisecondsToSeconds(duration);
  }
  get time() {
    const {
      resolved
    } = this;
    if (!resolved) return 0;
    const {
      animation
    } = resolved;
    return millisecondsToSeconds(animation.currentTime || 0);
  }
  set time(newTime) {
    const {
      resolved
    } = this;
    if (!resolved) return;
    const {
      animation
    } = resolved;
    animation.currentTime = secondsToMilliseconds(newTime);
  }
  get speed() {
    const {
      resolved
    } = this;
    if (!resolved) return 1;
    const {
      animation
    } = resolved;
    return animation.playbackRate;
  }
  set speed(newSpeed) {
    const {
      resolved
    } = this;
    if (!resolved) return;
    const {
      animation
    } = resolved;
    animation.playbackRate = newSpeed;
  }
  get state() {
    const {
      resolved
    } = this;
    if (!resolved) return "idle";
    const {
      animation
    } = resolved;
    return animation.playState;
  }
  get startTime() {
    const {
      resolved
    } = this;
    if (!resolved) return null;
    const {
      animation
    } = resolved;
    // Coerce to number as TypeScript incorrectly types this
    // as CSSNumberish
    return animation.startTime;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(timeline) {
    if (!this._resolved) {
      this.pendingTimeline = timeline;
    } else {
      const {
        resolved
      } = this;
      if (!resolved) return noop;
      const {
        animation
      } = resolved;
      attachTimeline(animation, timeline);
    }
    return noop;
  }
  play() {
    if (this.isStopped) return;
    const {
      resolved
    } = this;
    if (!resolved) return;
    const {
      animation
    } = resolved;
    if (animation.playState === "finished") {
      this.updateFinishedPromise();
    }
    animation.play();
  }
  pause() {
    const {
      resolved
    } = this;
    if (!resolved) return;
    const {
      animation
    } = resolved;
    animation.pause();
  }
  stop() {
    this.resolver.cancel();
    this.isStopped = true;
    if (this.state === "idle") return;
    this.resolveFinishedPromise();
    this.updateFinishedPromise();
    const {
      resolved
    } = this;
    if (!resolved) return;
    const {
      animation,
      keyframes,
      duration,
      type,
      ease,
      times
    } = resolved;
    if (animation.playState === "idle" || animation.playState === "finished") {
      return;
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read commited styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */
    if (this.time) {
      const {
        motionValue,
        onUpdate,
        onComplete,
        element,
        ...options
      } = this.options;
      const sampleAnimation = new MainThreadAnimation({
        ...options,
        keyframes,
        duration,
        type,
        ease,
        times,
        isGenerator: true
      });
      const sampleTime = secondsToMilliseconds(this.time);
      motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - sampleDelta).value, sampleAnimation.sample(sampleTime).value, sampleDelta);
    }
    const {
      onStop
    } = this.options;
    onStop && onStop();
    this.cancel();
  }
  complete() {
    const {
      resolved
    } = this;
    if (!resolved) return;
    resolved.animation.finish();
  }
  cancel() {
    const {
      resolved
    } = this;
    if (!resolved) return;
    resolved.animation.cancel();
  }
  static supports(options) {
    const {
      motionValue,
      name,
      repeatDelay,
      repeatType,
      damping,
      type
    } = options;
    if (!motionValue || !motionValue.owner || !(motionValue.owner.current instanceof HTMLElement)) {
      return false;
    }
    const {
      onUpdate,
      transformTemplate
    } = motionValue.owner.getProps();
    return supportsWaapi() && name && acceleratedValues.has(name) &&
    /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !onUpdate && !transformTemplate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
  }
}
const underDampedSpring = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
};
const criticallyDampedSpring = target => ({
  type: "spring",
  stiffness: 550,
  damping: target === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
});
const keyframesTransition = {
  type: "keyframes",
  duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */
const ease = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
};
const getDefaultTransition = (valueKey, _ref267) => {
  let {
    keyframes
  } = _ref267;
  if (keyframes.length > 2) {
    return keyframesTransition;
  } else if (transformProps.has(valueKey)) {
    return valueKey.startsWith("scale") ? criticallyDampedSpring(keyframes[1]) : underDampedSpring;
  }
  return ease;
};

/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */
function isTransitionDefined(_ref268) {
  let {
    when,
    delay: _delay,
    delayChildren,
    staggerChildren,
    staggerDirection,
    repeat,
    repeatType,
    repeatDelay,
    from,
    elapsed,
    ...transition
  } = _ref268;
  return !!Object.keys(transition).length;
}
const animateMotionValue = function (name, value, target) {
  let transition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  let element = arguments.length > 4 ? arguments[4] : undefined;
  let isHandoff = arguments.length > 5 ? arguments[5] : undefined;
  return onComplete => {
    const valueTransition = getValueTransition(transition, name) || {};
    /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */
    const delay = valueTransition.delay || transition.delay || 0;
    /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */
    let {
      elapsed = 0
    } = transition;
    elapsed = elapsed - secondsToMilliseconds(delay);
    let options = {
      keyframes: Array.isArray(target) ? target : [null, target],
      ease: "easeOut",
      velocity: value.getVelocity(),
      ...valueTransition,
      delay: -elapsed,
      onUpdate: v => {
        value.set(v);
        valueTransition.onUpdate && valueTransition.onUpdate(v);
      },
      onComplete: () => {
        onComplete();
        valueTransition.onComplete && valueTransition.onComplete();
      },
      name,
      motionValue: value,
      element: isHandoff ? undefined : element
    };
    /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */
    if (!isTransitionDefined(valueTransition)) {
      options = {
        ...options,
        ...getDefaultTransition(name, options)
      };
    }
    /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */
    if (options.duration) {
      options.duration = secondsToMilliseconds(options.duration);
    }
    if (options.repeatDelay) {
      options.repeatDelay = secondsToMilliseconds(options.repeatDelay);
    }
    if (options.from !== undefined) {
      options.keyframes[0] = options.from;
    }
    let shouldSkip = false;
    if (options.type === false || options.duration === 0 && !options.repeatDelay) {
      options.duration = 0;
      if (options.delay === 0) {
        shouldSkip = true;
      }
    }
    if (instantAnimationState.current || MotionGlobalConfig.skipAnimations) {
      shouldSkip = true;
      options.duration = 0;
      options.delay = 0;
    }
    /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */
    if (shouldSkip && !isHandoff && value.get() !== undefined) {
      const finalKeyframe = getFinalKeyframe(options.keyframes, valueTransition);
      if (finalKeyframe !== undefined) {
        frame.update(() => {
          options.onUpdate(finalKeyframe);
          options.onComplete();
        });
        // We still want to return some animation controls here rather
        // than returning undefined
        return new GroupPlaybackControls([]);
      }
    }
    /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */
    if (!isHandoff && AcceleratedAnimation.supports(options)) {
      return new AcceleratedAnimation(options);
    } else {
      return new MainThreadAnimation(options);
    }
  };
};

/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */
function shouldBlockAnimation(_ref269, key) {
  let {
    protectedKeys,
    needsAnimating
  } = _ref269;
  const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
  needsAnimating[key] = false;
  return shouldBlock;
}
function animateTarget(visualElement, targetAndTransition) {
  let {
    delay = 0,
    transitionOverride,
    type
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a;
  let {
    transition = visualElement.getDefaultTransition(),
    transitionEnd,
    ...target
  } = targetAndTransition;
  if (transitionOverride) transition = transitionOverride;
  const animations = [];
  const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
  for (const key in target) {
    const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
    const valueTarget = target[key];
    if (valueTarget === undefined || animationTypeState && shouldBlockAnimation(animationTypeState, key)) {
      continue;
    }
    const valueTransition = {
      delay,
      ...getValueTransition(transition || {}, key)
    };
    /**
     * If this is the first time a value is being animated, check
     * to see if we're handling off from an existing animation.
     */
    let isHandoff = false;
    if (window.MotionHandoffAnimation) {
      const appearId = getOptimisedAppearId(visualElement);
      if (appearId) {
        const startTime = window.MotionHandoffAnimation(appearId, key, frame);
        if (startTime !== null) {
          valueTransition.startTime = startTime;
          isHandoff = true;
        }
      }
    }
    addValueToWillChange(visualElement, key);
    value.start(animateMotionValue(key, value, valueTarget, visualElement.shouldReduceMotion && positionalKeys.has(key) ? {
      type: false
    } : valueTransition, visualElement, isHandoff));
    const animation = value.animation;
    if (animation) {
      animations.push(animation);
    }
  }
  if (transitionEnd) {
    Promise.all(animations).then(() => {
      frame.update(() => {
        transitionEnd && setTarget(visualElement, transitionEnd);
      });
    });
  }
  return animations;
}
function animateVariant(visualElement, variant) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _a;
  const resolved = resolveVariant(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
  let {
    transition = visualElement.getDefaultTransition() || {}
  } = resolved || {};
  if (options.transitionOverride) {
    transition = options.transitionOverride;
  }
  /**
   * If we have a variant, create a callback that runs it as an animation.
   * Otherwise, we resolve a Promise immediately for a composable no-op.
   */
  const getAnimation = resolved ? () => Promise.all(animateTarget(visualElement, resolved, options)) : () => Promise.resolve();
  /**
   * If we have children, create a callback that runs all their animations.
   * Otherwise, we resolve a Promise immediately for a composable no-op.
   */
  const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? function () {
    let forwardDelay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    const {
      delayChildren = 0,
      staggerChildren,
      staggerDirection
    } = transition;
    return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
  } : () => Promise.resolve();
  /**
   * If the transition explicitly defines a "when" option, we need to resolve either
   * this animation or all children animations before playing the other.
   */
  const {
    when
  } = transition;
  if (when) {
    const [first, last] = when === "beforeChildren" ? [getAnimation, getChildAnimations] : [getChildAnimations, getAnimation];
    return first().then(() => last());
  } else {
    return Promise.all([getAnimation(), getChildAnimations(options.delay)]);
  }
}
function animateChildren(visualElement, variant) {
  let delayChildren = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  let staggerChildren = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  let staggerDirection = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
  let options = arguments.length > 5 ? arguments[5] : undefined;
  const animations = [];
  const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
  const generateStaggerDuration = staggerDirection === 1 ? function () {
    let i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return i * staggerChildren;
  } : function () {
    let i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return maxStaggerDuration - i * staggerChildren;
  };
  Array.from(visualElement.variantChildren).sort(sortByTreeOrder).forEach((child, i) => {
    child.notify("AnimationStart", variant);
    animations.push(animateVariant(child, variant, {
      ...options,
      delay: delayChildren + generateStaggerDuration(i)
    }).then(() => child.notify("AnimationComplete", variant)));
  });
  return Promise.all(animations);
}
function sortByTreeOrder(a, b) {
  return a.sortNodePosition(b);
}
function animateVisualElement(visualElement, definition) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  visualElement.notify("AnimationStart", definition);
  let animation;
  if (Array.isArray(definition)) {
    const animations = definition.map(variant => animateVariant(visualElement, variant, options));
    animation = Promise.all(animations);
  } else if (typeof definition === "string") {
    animation = animateVariant(visualElement, definition, options);
  } else {
    const resolvedDefinition = typeof definition === "function" ? resolveVariant(visualElement, definition, options.custom) : definition;
    animation = Promise.all(animateTarget(visualElement, resolvedDefinition, options));
  }
  return animation.then(() => {
    visualElement.notify("AnimationComplete", definition);
  });
}
const numVariantProps = variantProps.length;
function getVariantContext(visualElement) {
  if (!visualElement) return undefined;
  if (!visualElement.isControllingVariants) {
    const context = visualElement.parent ? getVariantContext(visualElement.parent) || {} : {};
    if (visualElement.props.initial !== undefined) {
      context.initial = visualElement.props.initial;
    }
    return context;
  }
  const context = {};
  for (let i = 0; i < numVariantProps; i++) {
    const name = variantProps[i];
    const prop = visualElement.props[name];
    if (isVariantLabel(prop) || prop === false) {
      context[name] = prop;
    }
  }
  return context;
}
const reversePriorityOrder = [...variantPriorityOrder].reverse();
const numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement) {
  return animations => Promise.all(animations.map(_ref270 => {
    let {
      animation,
      options
    } = _ref270;
    return animateVisualElement(visualElement, animation, options);
  }));
}
function createAnimationState(visualElement) {
  let animate = animateList(visualElement);
  let state = createState();
  let isInitialRender = true;
  /**
   * This function will be used to reduce the animation definitions for
   * each active animation type into an object of resolved values for it.
   */
  const buildResolvedTypeValues = type => (acc, definition) => {
    var _a;
    const resolved = resolveVariant(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    if (resolved) {
      const {
        transition,
        transitionEnd,
        ...target
      } = resolved;
      acc = {
        ...acc,
        ...target,
        ...transitionEnd
      };
    }
    return acc;
  };
  /**
   * This just allows us to inject mocked animation functions
   * @internal
   */
  function setAnimateFunction(makeAnimator) {
    animate = makeAnimator(visualElement);
  }
  /**
   * When we receive new props, we need to:
   * 1. Create a list of protected keys for each type. This is a directory of
   *    value keys that are currently being "handled" by types of a higher priority
   *    so that whenever an animation is played of a given type, these values are
   *    protected from being animated.
   * 2. Determine if an animation type needs animating.
   * 3. Determine if any values have been removed from a type and figure out
   *    what to animate those to.
   */
  function animateChanges(changedActiveType) {
    const {
      props
    } = visualElement;
    const context = getVariantContext(visualElement.parent) || {};
    /**
     * A list of animations that we'll build into as we iterate through the animation
     * types. This will get executed at the end of the function.
     */
    const animations = [];
    /**
     * Keep track of which values have been removed. Then, as we hit lower priority
     * animation types, we can check if they contain removed values and animate to that.
     */
    const removedKeys = new Set();
    /**
     * A dictionary of all encountered keys. This is an object to let us build into and
     * copy it without iteration. Each time we hit an animation type we set its protected
     * keys - the keys its not allowed to animate - to the latest version of this object.
     */
    let encounteredKeys = {};
    /**
     * If a variant has been removed at a given index, and this component is controlling
     * variant animations, we want to ensure lower-priority variants are forced to animate.
     */
    let removedVariantIndex = Infinity;
    /**
     * Iterate through all animation types in reverse priority order. For each, we want to
     * detect which values it's handling and whether or not they've changed (and therefore
     * need to be animated). If any values have been removed, we want to detect those in
     * lower priority props and flag for animation.
     */
    for (let i = 0; i < numAnimationTypes; i++) {
      const type = reversePriorityOrder[i];
      const typeState = state[type];
      const prop = props[type] !== undefined ? props[type] : context[type];
      const propIsVariant = isVariantLabel(prop);
      /**
       * If this type has *just* changed isActive status, set activeDelta
       * to that status. Otherwise set to null.
       */
      const activeDelta = type === changedActiveType ? typeState.isActive : null;
      if (activeDelta === false) removedVariantIndex = i;
      /**
       * If this prop is an inherited variant, rather than been set directly on the
       * component itself, we want to make sure we allow the parent to trigger animations.
       *
       * TODO: Can probably change this to a !isControllingVariants check
       */
      let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
      /**
       *
       */
      if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) {
        isInherited = false;
      }
      /**
       * Set all encountered keys so far as the protected keys for this type. This will
       * be any key that has been animated or otherwise handled by active, higher-priortiy types.
       */
      typeState.protectedKeys = {
        ...encounteredKeys
      };
      // Check if we can skip analysing this prop early
      if (
      // If it isn't active and hasn't *just* been set as inactive
      !typeState.isActive && activeDelta === null ||
      // If we didn't and don't have any defined prop for this animation type
      !prop && !typeState.prevProp ||
      // Or if the prop doesn't define an animation
      isAnimationControls(prop) || typeof prop === "boolean") {
        continue;
      }
      /**
       * As we go look through the values defined on this type, if we detect
       * a changed value or a value that was removed in a higher priority, we set
       * this to true and add this prop to the animation list.
       */
      const variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
      let shouldAnimateType = variantDidChange ||
      // If we're making this variant active, we want to always make it active
      type === changedActiveType && typeState.isActive && !isInherited && propIsVariant ||
      // If we removed a higher-priority variant (i is in reverse order)
      i > removedVariantIndex && propIsVariant;
      let handledRemovedValues = false;
      /**
       * As animations can be set as variant lists, variants or target objects, we
       * coerce everything to an array if it isn't one already
       */
      const definitionList = Array.isArray(prop) ? prop : [prop];
      /**
       * Build an object of all the resolved values. We'll use this in the subsequent
       * animateChanges calls to determine whether a value has changed.
       */
      let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
      if (activeDelta === false) resolvedValues = {};
      /**
       * Now we need to loop through all the keys in the prev prop and this prop,
       * and decide:
       * 1. If the value has changed, and needs animating
       * 2. If it has been removed, and needs adding to the removedKeys set
       * 3. If it has been removed in a higher priority type and needs animating
       * 4. If it hasn't been removed in a higher priority but hasn't changed, and
       *    needs adding to the type's protectedKeys list.
       */
      const {
        prevResolvedValues = {}
      } = typeState;
      const allKeys = {
        ...prevResolvedValues,
        ...resolvedValues
      };
      const markToAnimate = key => {
        shouldAnimateType = true;
        if (removedKeys.has(key)) {
          handledRemovedValues = true;
          removedKeys.delete(key);
        }
        typeState.needsAnimating[key] = true;
        const motionValue = visualElement.getValue(key);
        if (motionValue) motionValue.liveStyle = false;
      };
      for (const key in allKeys) {
        const next = resolvedValues[key];
        const prev = prevResolvedValues[key];
        // If we've already handled this we can just skip ahead
        if (encounteredKeys.hasOwnProperty(key)) continue;
        /**
         * If the value has changed, we probably want to animate it.
         */
        let valueHasChanged = false;
        if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
          valueHasChanged = !shallowCompare(next, prev);
        } else {
          valueHasChanged = next !== prev;
        }
        if (valueHasChanged) {
          if (next !== undefined && next !== null) {
            // If next is defined and doesn't equal prev, it needs animating
            markToAnimate(key);
          } else {
            // If it's undefined, it's been removed.
            removedKeys.add(key);
          }
        } else if (next !== undefined && removedKeys.has(key)) {
          /**
           * If next hasn't changed and it isn't undefined, we want to check if it's
           * been removed by a higher priority
           */
          markToAnimate(key);
        } else {
          /**
           * If it hasn't changed, we add it to the list of protected values
           * to ensure it doesn't get animated.
           */
          typeState.protectedKeys[key] = true;
        }
      }
      /**
       * Update the typeState so next time animateChanges is called we can compare the
       * latest prop and resolvedValues to these.
       */
      typeState.prevProp = prop;
      typeState.prevResolvedValues = resolvedValues;
      /**
       *
       */
      if (typeState.isActive) {
        encounteredKeys = {
          ...encounteredKeys,
          ...resolvedValues
        };
      }
      if (isInitialRender && visualElement.blockInitialAnimation) {
        shouldAnimateType = false;
      }
      /**
       * If this is an inherited prop we want to skip this animation
       * unless the inherited variants haven't changed on this render.
       */
      const willAnimateViaParent = isInherited && variantDidChange;
      const needsAnimating = !willAnimateViaParent || handledRemovedValues;
      if (shouldAnimateType && needsAnimating) {
        animations.push(...definitionList.map(animation => ({
          animation: animation,
          options: {
            type
          }
        })));
      }
    }
    /**
     * If there are some removed value that haven't been dealt with,
     * we need to create a new animation that falls back either to the value
     * defined in the style prop, or the last read value.
     */
    if (removedKeys.size) {
      const fallbackAnimation = {};
      removedKeys.forEach(key => {
        const fallbackTarget = visualElement.getBaseTarget(key);
        const motionValue = visualElement.getValue(key);
        if (motionValue) motionValue.liveStyle = true;
        // @ts-expect-error - @mattgperry to figure if we should do something here
        fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
      });
      animations.push({
        animation: fallbackAnimation
      });
    }
    let shouldAnimate = Boolean(animations.length);
    if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) {
      shouldAnimate = false;
    }
    isInitialRender = false;
    return shouldAnimate ? animate(animations) : Promise.resolve();
  }
  /**
   * Change whether a certain animation type is active.
   */
  function setActive(type, isActive) {
    var _a;
    // If the active state hasn't changed, we can safely do nothing here
    if (state[type].isActive === isActive) return Promise.resolve();
    // Propagate active change to children
    (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach(child => {
      var _a;
      return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
    });
    state[type].isActive = isActive;
    const animations = animateChanges(type);
    for (const key in state) {
      state[key].protectedKeys = {};
    }
    return animations;
  }
  return {
    animateChanges,
    setActive,
    setAnimateFunction,
    getState: () => state,
    reset: () => {
      state = createState();
      isInitialRender = true;
    }
  };
}
function checkVariantsDidChange(prev, next) {
  if (typeof next === "string") {
    return next !== prev;
  } else if (Array.isArray(next)) {
    return !shallowCompare(next, prev);
  }
  return false;
}
function createTypeState() {
  let isActive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    isActive,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function createState() {
  return {
    animate: createTypeState(true),
    whileInView: createTypeState(),
    whileHover: createTypeState(),
    whileTap: createTypeState(),
    whileDrag: createTypeState(),
    whileFocus: createTypeState(),
    exit: createTypeState()
  };
}
class Feature {
  constructor(node) {
    this.isMounted = false;
    this.node = node;
  }
  update() {}
}
class AnimationFeature extends Feature {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(node) {
    super(node);
    node.animationState || (node.animationState = createAnimationState(node));
  }
  updateAnimationControlsSubscription() {
    const {
      animate
    } = this.node.getProps();
    if (isAnimationControls(animate)) {
      this.unmountControls = animate.subscribe(this.node);
    }
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const {
      animate
    } = this.node.getProps();
    const {
      animate: prevAnimate
    } = this.node.prevProps || {};
    if (animate !== prevAnimate) {
      this.updateAnimationControlsSubscription();
    }
  }
  unmount() {
    var _a;
    this.node.animationState.reset();
    (_a = this.unmountControls) === null || _a === void 0 ? void 0 : _a.call(this);
  }
}
let id$1 = 0;
class ExitAnimationFeature extends Feature {
  constructor() {
    super(...arguments);
    this.id = id$1++;
  }
  update() {
    if (!this.node.presenceContext) return;
    const {
      isPresent,
      onExitComplete
    } = this.node.presenceContext;
    const {
      isPresent: prevIsPresent
    } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || isPresent === prevIsPresent) {
      return;
    }
    const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
    if (onExitComplete && !isPresent) {
      exitAnimation.then(() => onExitComplete(this.id));
    }
  }
  mount() {
    const {
      register
    } = this.node.presenceContext || {};
    if (register) {
      this.unmount = register(this.id);
    }
  }
  unmount() {}
}
const animations = {
  animation: {
    Feature: AnimationFeature
  },
  exit: {
    Feature: ExitAnimationFeature
  }
};
function addDomEvent(target, eventName, handler) {
  let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    passive: true
  };
  target.addEventListener(eventName, handler, options);
  return () => target.removeEventListener(eventName, handler);
}
function extractEventInfo(event) {
  return {
    point: {
      x: event.pageX,
      y: event.pageY
    }
  };
}
const addPointerInfo = handler => {
  return event => isPrimaryPointer(event) && handler(event, extractEventInfo(event));
};
function addPointerEvent(target, eventName, handler, options) {
  return addDomEvent(target, eventName, addPointerInfo(handler), options);
}
const distance = (a, b) => Math.abs(a - b);
function distance2D(a, b) {
  // Multi-dimensional
  const xDelta = distance(a.x, b.x);
  const yDelta = distance(a.y, b.y);
  return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}

/**
 * @internal
 */
class PanSession {
  constructor(event, handlers) {
    let {
      transformPagePoint,
      contextWindow,
      dragSnapToOrigin = false
    } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    /**
     * @internal
     */
    this.startEvent = null;
    /**
     * @internal
     */
    this.lastMoveEvent = null;
    /**
     * @internal
     */
    this.lastMoveEventInfo = null;
    /**
     * @internal
     */
    this.handlers = {};
    /**
     * @internal
     */
    this.contextWindow = window;
    this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
      const info = getPanInfo(this.lastMoveEventInfo, this.history);
      const isPanStarted = this.startEvent !== null;
      // Only start panning if the offset is larger than 3 pixels. If we make it
      // any larger than this we'll want to reset the pointer history
      // on the first update to avoid visual snapping to the cursoe.
      const isDistancePastThreshold = distance2D(info.offset, {
        x: 0,
        y: 0
      }) >= 3;
      if (!isPanStarted && !isDistancePastThreshold) return;
      const {
        point
      } = info;
      const {
        timestamp
      } = frameData;
      this.history.push({
        ...point,
        timestamp
      });
      const {
        onStart,
        onMove
      } = this.handlers;
      if (!isPanStarted) {
        onStart && onStart(this.lastMoveEvent, info);
        this.startEvent = this.lastMoveEvent;
      }
      onMove && onMove(this.lastMoveEvent, info);
    };
    this.handlePointerMove = (event, info) => {
      this.lastMoveEvent = event;
      this.lastMoveEventInfo = transformPoint(info, this.transformPagePoint);
      // Throttle mouse move event to once per frame
      frame.update(this.updatePoint, true);
    };
    this.handlePointerUp = (event, info) => {
      this.end();
      const {
        onEnd,
        onSessionEnd,
        resumeAnimation
      } = this.handlers;
      if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
      if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
      const panInfo = getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : transformPoint(info, this.transformPagePoint), this.history);
      if (this.startEvent && onEnd) {
        onEnd(event, panInfo);
      }
      onSessionEnd && onSessionEnd(event, panInfo);
    };
    // If we have more than one touch, don't start detecting this gesture
    if (!isPrimaryPointer(event)) return;
    this.dragSnapToOrigin = dragSnapToOrigin;
    this.handlers = handlers;
    this.transformPagePoint = transformPagePoint;
    this.contextWindow = contextWindow || window;
    const info = extractEventInfo(event);
    const initialInfo = transformPoint(info, this.transformPagePoint);
    const {
      point
    } = initialInfo;
    const {
      timestamp
    } = frameData;
    this.history = [{
      ...point,
      timestamp
    }];
    const {
      onSessionStart
    } = handlers;
    onSessionStart && onSessionStart(event, getPanInfo(initialInfo, this.history));
    this.removeListeners = pipe(addPointerEvent(this.contextWindow, "pointermove", this.handlePointerMove), addPointerEvent(this.contextWindow, "pointerup", this.handlePointerUp), addPointerEvent(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(handlers) {
    this.handlers = handlers;
  }
  end() {
    this.removeListeners && this.removeListeners();
    cancelFrame(this.updatePoint);
  }
}
function transformPoint(info, transformPagePoint) {
  return transformPagePoint ? {
    point: transformPagePoint(info.point)
  } : info;
}
function subtractPoint(a, b) {
  return {
    x: a.x - b.x,
    y: a.y - b.y
  };
}
function getPanInfo(_ref271, history) {
  let {
    point
  } = _ref271;
  return {
    point,
    delta: subtractPoint(point, lastDevicePoint(history)),
    offset: subtractPoint(point, startDevicePoint(history)),
    velocity: getVelocity(history, 0.1)
  };
}
function startDevicePoint(history) {
  return history[0];
}
function lastDevicePoint(history) {
  return history[history.length - 1];
}
function getVelocity(history, timeDelta) {
  if (history.length < 2) {
    return {
      x: 0,
      y: 0
    };
  }
  let i = history.length - 1;
  let timestampedPoint = null;
  const lastPoint = lastDevicePoint(history);
  while (i >= 0) {
    timestampedPoint = history[i];
    if (lastPoint.timestamp - timestampedPoint.timestamp > secondsToMilliseconds(timeDelta)) {
      break;
    }
    i--;
  }
  if (!timestampedPoint) {
    return {
      x: 0,
      y: 0
    };
  }
  const time = millisecondsToSeconds(lastPoint.timestamp - timestampedPoint.timestamp);
  if (time === 0) {
    return {
      x: 0,
      y: 0
    };
  }
  const currentVelocity = {
    x: (lastPoint.x - timestampedPoint.x) / time,
    y: (lastPoint.y - timestampedPoint.y) / time
  };
  if (currentVelocity.x === Infinity) {
    currentVelocity.x = 0;
  }
  if (currentVelocity.y === Infinity) {
    currentVelocity.y = 0;
  }
  return currentVelocity;
}
const SCALE_PRECISION = 0.0001;
const SCALE_MIN = 1 - SCALE_PRECISION;
const SCALE_MAX = 1 + SCALE_PRECISION;
const TRANSLATE_PRECISION = 0.01;
const TRANSLATE_MIN = 0 - TRANSLATE_PRECISION;
const TRANSLATE_MAX = 0 + TRANSLATE_PRECISION;
function calcLength(axis) {
  return axis.max - axis.min;
}
function isNear(value, target, maxDistance) {
  return Math.abs(value - target) <= maxDistance;
}
function calcAxisDelta(delta, source, target) {
  let origin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;
  delta.origin = origin;
  delta.originPoint = mixNumber$1(source.min, source.max, delta.origin);
  delta.scale = calcLength(target) / calcLength(source);
  delta.translate = mixNumber$1(target.min, target.max, delta.origin) - delta.originPoint;
  if (delta.scale >= SCALE_MIN && delta.scale <= SCALE_MAX || isNaN(delta.scale)) {
    delta.scale = 1.0;
  }
  if (delta.translate >= TRANSLATE_MIN && delta.translate <= TRANSLATE_MAX || isNaN(delta.translate)) {
    delta.translate = 0.0;
  }
}
function calcBoxDelta(delta, source, target, origin) {
  calcAxisDelta(delta.x, source.x, target.x, origin ? origin.originX : undefined);
  calcAxisDelta(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function calcRelativeAxis(target, relative, parent) {
  target.min = parent.min + relative.min;
  target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent) {
  calcRelativeAxis(target.x, relative.x, parent.x);
  calcRelativeAxis(target.y, relative.y, parent.y);
}
function calcRelativeAxisPosition(target, layout, parent) {
  target.min = layout.min - parent.min;
  target.max = target.min + calcLength(layout);
}
function calcRelativePosition(target, layout, parent) {
  calcRelativeAxisPosition(target.x, layout.x, parent.x);
  calcRelativeAxisPosition(target.y, layout.y, parent.y);
}

/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */
function applyConstraints(point, _ref272, elastic) {
  let {
    min,
    max
  } = _ref272;
  if (min !== undefined && point < min) {
    // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? mixNumber$1(min, point, elastic.min) : Math.max(point, min);
  } else if (max !== undefined && point > max) {
    // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? mixNumber$1(max, point, elastic.max) : Math.min(point, max);
  }
  return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */
function calcRelativeAxisConstraints(axis, min, max) {
  return {
    min: min !== undefined ? axis.min + min : undefined,
    max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
  };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */
function calcRelativeConstraints(layoutBox, _ref273) {
  let {
    top,
    left,
    bottom,
    right
  } = _ref273;
  return {
    x: calcRelativeAxisConstraints(layoutBox.x, left, right),
    y: calcRelativeAxisConstraints(layoutBox.y, top, bottom)
  };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
  let min = constraintsAxis.min - layoutAxis.min;
  let max = constraintsAxis.max - layoutAxis.max;
  // If the constraints axis is actually smaller than the layout axis then we can
  // flip the constraints
  if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) {
    [min, max] = [max, min];
  }
  return {
    min,
    max
  };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */
function calcViewportConstraints(layoutBox, constraintsBox) {
  return {
    x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
    y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y)
  };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */
function calcOrigin(source, target) {
  let origin = 0.5;
  const sourceLength = calcLength(source);
  const targetLength = calcLength(target);
  if (targetLength > sourceLength) {
    origin = progress(target.min, target.max - sourceLength, source.min);
  } else if (sourceLength > targetLength) {
    origin = progress(source.min, source.max - targetLength, target.min);
  }
  return clamp(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */
function rebaseAxisConstraints(layout, constraints) {
  const relativeConstraints = {};
  if (constraints.min !== undefined) {
    relativeConstraints.min = constraints.min - layout.min;
  }
  if (constraints.max !== undefined) {
    relativeConstraints.max = constraints.max - layout.min;
  }
  return relativeConstraints;
}
const defaultElastic = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */
function resolveDragElastic() {
  let dragElastic = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultElastic;
  if (dragElastic === false) {
    dragElastic = 0;
  } else if (dragElastic === true) {
    dragElastic = defaultElastic;
  }
  return {
    x: resolveAxisElastic(dragElastic, "left", "right"),
    y: resolveAxisElastic(dragElastic, "top", "bottom")
  };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
  return {
    min: resolvePointElastic(dragElastic, minLabel),
    max: resolvePointElastic(dragElastic, maxLabel)
  };
}
function resolvePointElastic(dragElastic, label) {
  return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}
const createAxisDelta = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
});
const createDelta = () => ({
  x: createAxisDelta(),
  y: createAxisDelta()
});
const createAxis = () => ({
  min: 0,
  max: 0
});
const createBox = () => ({
  x: createAxis(),
  y: createAxis()
});
function eachAxis(callback) {
  return [callback("x"), callback("y")];
}

/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */
function convertBoundingBoxToBox(_ref274) {
  let {
    top,
    left,
    right,
    bottom
  } = _ref274;
  return {
    x: {
      min: left,
      max: right
    },
    y: {
      min: top,
      max: bottom
    }
  };
}
function convertBoxToBoundingBox(_ref275) {
  let {
    x,
    y
  } = _ref275;
  return {
    top: y.min,
    right: x.max,
    bottom: y.max,
    left: x.min
  };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */
function transformBoxPoints(point, transformPoint) {
  if (!transformPoint) return point;
  const topLeft = transformPoint({
    x: point.left,
    y: point.top
  });
  const bottomRight = transformPoint({
    x: point.right,
    y: point.bottom
  });
  return {
    top: topLeft.y,
    left: topLeft.x,
    bottom: bottomRight.y,
    right: bottomRight.x
  };
}
function isIdentityScale(scale) {
  return scale === undefined || scale === 1;
}
function hasScale(_ref276) {
  let {
    scale,
    scaleX,
    scaleY
  } = _ref276;
  return !isIdentityScale(scale) || !isIdentityScale(scaleX) || !isIdentityScale(scaleY);
}
function hasTransform(values) {
  return hasScale(values) || has2DTranslate(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function has2DTranslate(values) {
  return is2DTranslate(values.x) || is2DTranslate(values.y);
}
function is2DTranslate(value) {
  return value && value !== "0%";
}

/**
 * Scales a point based on a factor and an originPoint
 */
function scalePoint(point, scale, originPoint) {
  const distanceFromOrigin = point - originPoint;
  const scaled = scale * distanceFromOrigin;
  return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */
function applyPointDelta(point, translate, scale, originPoint, boxScale) {
  if (boxScale !== undefined) {
    point = scalePoint(point, boxScale, originPoint);
  }
  return scalePoint(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */
function applyAxisDelta(axis) {
  let translate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  let scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  let originPoint = arguments.length > 3 ? arguments[3] : undefined;
  let boxScale = arguments.length > 4 ? arguments[4] : undefined;
  axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
  axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */
function applyBoxDelta(box, _ref277) {
  let {
    x,
    y
  } = _ref277;
  applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
  applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
const TREE_SCALE_SNAP_MIN = 0.999999999999;
const TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */
function applyTreeDeltas(box, treeScale, treePath) {
  let isSharedTransition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  const treeLength = treePath.length;
  if (!treeLength) return;
  // Reset the treeScale
  treeScale.x = treeScale.y = 1;
  let node;
  let delta;
  for (let i = 0; i < treeLength; i++) {
    node = treePath[i];
    delta = node.projectionDelta;
    /**
     * TODO: Prefer to remove this, but currently we have motion components with
     * display: contents in Framer.
     */
    const {
      visualElement
    } = node.options;
    if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") {
      continue;
    }
    if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) {
      transformBox(box, {
        x: -node.scroll.offset.x,
        y: -node.scroll.offset.y
      });
    }
    if (delta) {
      // Incoporate each ancestor's scale into a culmulative treeScale for this component
      treeScale.x *= delta.x.scale;
      treeScale.y *= delta.y.scale;
      // Apply each ancestor's calculated delta into this component's recorded layout box
      applyBoxDelta(box, delta);
    }
    if (isSharedTransition && hasTransform(node.latestValues)) {
      transformBox(box, node.latestValues);
    }
  }
  /**
   * Snap tree scale back to 1 if it's within a non-perceivable threshold.
   * This will help reduce useless scales getting rendered.
   */
  if (treeScale.x < TREE_SCALE_SNAP_MAX && treeScale.x > TREE_SCALE_SNAP_MIN) {
    treeScale.x = 1.0;
  }
  if (treeScale.y < TREE_SCALE_SNAP_MAX && treeScale.y > TREE_SCALE_SNAP_MIN) {
    treeScale.y = 1.0;
  }
}
function translateAxis(axis, distance) {
  axis.min = axis.min + distance;
  axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */
function transformAxis(axis, axisTranslate, axisScale, boxScale) {
  let axisOrigin = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0.5;
  const originPoint = mixNumber$1(axis.min, axis.max, axisOrigin);
  // Apply the axis delta to the final axis
  applyAxisDelta(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */
function transformBox(box, transform) {
  transformAxis(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
  transformAxis(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}
function measureViewportBox(instance, transformPoint) {
  return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint));
}
function measurePageBox(element, rootProjectionNode, transformPagePoint) {
  const viewportBox = measureViewportBox(element, transformPagePoint);
  const {
    scroll
  } = rootProjectionNode;
  if (scroll) {
    translateAxis(viewportBox.x, scroll.offset.x);
    translateAxis(viewportBox.y, scroll.offset.y);
  }
  return viewportBox;
}

// Fixes https://github.com/motiondivision/motion/issues/2270
const getContextWindow = _ref278 => {
  let {
    current
  } = _ref278;
  return current ? current.ownerDocument.defaultView : null;
};
const elementDragControls = new WeakMap();
/**
 *
 */
// let latestPointerEvent: PointerEvent
class VisualElementDragControls {
  constructor(visualElement) {
    this.openDragLock = null;
    this.isDragging = false;
    this.currentDirection = null;
    this.originPoint = {
      x: 0,
      y: 0
    };
    /**
     * The permitted boundaries of travel, in pixels.
     */
    this.constraints = false;
    this.hasMutatedConstraints = false;
    /**
     * The per-axis resolved elastic values.
     */
    this.elastic = createBox();
    this.visualElement = visualElement;
  }
  start(originEvent) {
    let {
      snapToCursor = false
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    /**
     * Don't start dragging if this component is exiting
     */
    const {
      presenceContext
    } = this.visualElement;
    if (presenceContext && presenceContext.isPresent === false) return;
    const onSessionStart = event => {
      const {
        dragSnapToOrigin
      } = this.getProps();
      // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
      // the component.
      dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
      if (snapToCursor) {
        this.snapToCursor(extractEventInfo(event).point);
      }
    };
    const onStart = (event, info) => {
      // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
      const {
        drag,
        dragPropagation,
        onDragStart
      } = this.getProps();
      if (drag && !dragPropagation) {
        if (this.openDragLock) this.openDragLock();
        this.openDragLock = setDragLock(drag);
        // If we don 't have the lock, don't start dragging
        if (!this.openDragLock) return;
      }
      this.isDragging = true;
      this.currentDirection = null;
      this.resolveConstraints();
      if (this.visualElement.projection) {
        this.visualElement.projection.isAnimationBlocked = true;
        this.visualElement.projection.target = undefined;
      }
      /**
       * Record gesture origin
       */
      eachAxis(axis => {
        let current = this.getAxisMotionValue(axis).get() || 0;
        /**
         * If the MotionValue is a percentage value convert to px
         */
        if (percent.test(current)) {
          const {
            projection
          } = this.visualElement;
          if (projection && projection.layout) {
            const measuredAxis = projection.layout.layoutBox[axis];
            if (measuredAxis) {
              const length = calcLength(measuredAxis);
              current = length * (parseFloat(current) / 100);
            }
          }
        }
        this.originPoint[axis] = current;
      });
      // Fire onDragStart event
      if (onDragStart) {
        frame.postRender(() => onDragStart(event, info));
      }
      addValueToWillChange(this.visualElement, "transform");
      const {
        animationState
      } = this.visualElement;
      animationState && animationState.setActive("whileDrag", true);
    };
    const onMove = (event, info) => {
      // latestPointerEvent = event
      const {
        dragPropagation,
        dragDirectionLock,
        onDirectionLock,
        onDrag
      } = this.getProps();
      // If we didn't successfully receive the gesture lock, early return.
      if (!dragPropagation && !this.openDragLock) return;
      const {
        offset
      } = info;
      // Attempt to detect drag direction if directionLock is true
      if (dragDirectionLock && this.currentDirection === null) {
        this.currentDirection = getCurrentDirection(offset);
        // If we've successfully set a direction, notify listener
        if (this.currentDirection !== null) {
          onDirectionLock && onDirectionLock(this.currentDirection);
        }
        return;
      }
      // Update each point with the latest position
      this.updateAxis("x", info.point, offset);
      this.updateAxis("y", info.point, offset);
      /**
       * Ideally we would leave the renderer to fire naturally at the end of
       * this frame but if the element is about to change layout as the result
       * of a re-render we want to ensure the browser can read the latest
       * bounding box to ensure the pointer and element don't fall out of sync.
       */
      this.visualElement.render();
      /**
       * This must fire after the render call as it might trigger a state
       * change which itself might trigger a layout update.
       */
      onDrag && onDrag(event, info);
    };
    const onSessionEnd = (event, info) => this.stop(event, info);
    const resumeAnimation = () => eachAxis(axis => {
      var _a;
      return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
    });
    const {
      dragSnapToOrigin
    } = this.getProps();
    this.panSession = new PanSession(originEvent, {
      onSessionStart,
      onStart,
      onMove,
      onSessionEnd,
      resumeAnimation
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin,
      contextWindow: getContextWindow(this.visualElement)
    });
  }
  stop(event, info) {
    const isDragging = this.isDragging;
    this.cancel();
    if (!isDragging) return;
    const {
      velocity
    } = info;
    this.startAnimation(velocity);
    const {
      onDragEnd
    } = this.getProps();
    if (onDragEnd) {
      frame.postRender(() => onDragEnd(event, info));
    }
  }
  cancel() {
    this.isDragging = false;
    const {
      projection,
      animationState
    } = this.visualElement;
    if (projection) {
      projection.isAnimationBlocked = false;
    }
    this.panSession && this.panSession.end();
    this.panSession = undefined;
    const {
      dragPropagation
    } = this.getProps();
    if (!dragPropagation && this.openDragLock) {
      this.openDragLock();
      this.openDragLock = null;
    }
    animationState && animationState.setActive("whileDrag", false);
  }
  updateAxis(axis, _point, offset) {
    const {
      drag
    } = this.getProps();
    // If we're not dragging this axis, do an early return.
    if (!offset || !shouldDrag(axis, drag, this.currentDirection)) return;
    const axisValue = this.getAxisMotionValue(axis);
    let next = this.originPoint[axis] + offset[axis];
    // Apply constraints
    if (this.constraints && this.constraints[axis]) {
      next = applyConstraints(next, this.constraints[axis], this.elastic[axis]);
    }
    axisValue.set(next);
  }
  resolveConstraints() {
    var _a;
    const {
      dragConstraints,
      dragElastic
    } = this.getProps();
    const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
    const prevConstraints = this.constraints;
    if (dragConstraints && isRefObject(dragConstraints)) {
      if (!this.constraints) {
        this.constraints = this.resolveRefConstraints();
      }
    } else {
      if (dragConstraints && layout) {
        this.constraints = calcRelativeConstraints(layout.layoutBox, dragConstraints);
      } else {
        this.constraints = false;
      }
    }
    this.elastic = resolveDragElastic(dragElastic);
    /**
     * If we're outputting to external MotionValues, we want to rebase the measured constraints
     * from viewport-relative to component-relative.
     */
    if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) {
      eachAxis(axis => {
        if (this.constraints !== false && this.getAxisMotionValue(axis)) {
          this.constraints[axis] = rebaseAxisConstraints(layout.layoutBox[axis], this.constraints[axis]);
        }
      });
    }
  }
  resolveRefConstraints() {
    const {
      dragConstraints: constraints,
      onMeasureDragConstraints
    } = this.getProps();
    if (!constraints || !isRefObject(constraints)) return false;
    const constraintsElement = constraints.current;
    invariant(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const {
      projection
    } = this.visualElement;
    // TODO
    if (!projection || !projection.layout) return false;
    const constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
    let measuredConstraints = calcViewportConstraints(projection.layout.layoutBox, constraintsBox);
    /**
     * If there's an onMeasureDragConstraints listener we call it and
     * if different constraints are returned, set constraints to that
     */
    if (onMeasureDragConstraints) {
      const userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
      this.hasMutatedConstraints = !!userConstraints;
      if (userConstraints) {
        measuredConstraints = convertBoundingBoxToBox(userConstraints);
      }
    }
    return measuredConstraints;
  }
  startAnimation(velocity) {
    const {
      drag,
      dragMomentum,
      dragElastic,
      dragTransition,
      dragSnapToOrigin,
      onDragTransitionEnd
    } = this.getProps();
    const constraints = this.constraints || {};
    const momentumAnimations = eachAxis(axis => {
      if (!shouldDrag(axis, drag, this.currentDirection)) {
        return;
      }
      let transition = constraints && constraints[axis] || {};
      if (dragSnapToOrigin) transition = {
        min: 0,
        max: 0
      };
      /**
       * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
       * of spring animations so we should look into adding a disable spring option to `inertia`.
       * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
       * using the value of `dragElastic`.
       */
      const bounceStiffness = dragElastic ? 200 : 1000000;
      const bounceDamping = dragElastic ? 40 : 10000000;
      const inertia = {
        type: "inertia",
        velocity: dragMomentum ? velocity[axis] : 0,
        bounceStiffness,
        bounceDamping,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...dragTransition,
        ...transition
      };
      // If we're not animating on an externally-provided `MotionValue` we can use the
      // component's animation controls which will handle interactions with whileHover (etc),
      // otherwise we just have to animate the `MotionValue` itself.
      return this.startAxisValueAnimation(axis, inertia);
    });
    // Run all animations and then resolve the new drag constraints.
    return Promise.all(momentumAnimations).then(onDragTransitionEnd);
  }
  startAxisValueAnimation(axis, transition) {
    const axisValue = this.getAxisMotionValue(axis);
    addValueToWillChange(this.visualElement, axis);
    return axisValue.start(animateMotionValue(axis, axisValue, 0, transition, this.visualElement, false));
  }
  stopAnimation() {
    eachAxis(axis => this.getAxisMotionValue(axis).stop());
  }
  pauseAnimation() {
    eachAxis(axis => {
      var _a;
      return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
    });
  }
  getAnimationState(axis) {
    var _a;
    return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(axis) {
    const dragKey = "_drag".concat(axis.toUpperCase());
    const props = this.visualElement.getProps();
    const externalMotionValue = props[dragKey];
    return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
  }
  snapToCursor(point) {
    eachAxis(axis => {
      const {
        drag
      } = this.getProps();
      // If we're not dragging this axis, do an early return.
      if (!shouldDrag(axis, drag, this.currentDirection)) return;
      const {
        projection
      } = this.visualElement;
      const axisValue = this.getAxisMotionValue(axis);
      if (projection && projection.layout) {
        const {
          min,
          max
        } = projection.layout.layoutBox[axis];
        axisValue.set(point[axis] - mixNumber$1(min, max, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current) return;
    const {
      drag,
      dragConstraints
    } = this.getProps();
    const {
      projection
    } = this.visualElement;
    if (!isRefObject(dragConstraints) || !projection || !this.constraints) return;
    /**
     * Stop current animations as there can be visual glitching if we try to do
     * this mid-animation
     */
    this.stopAnimation();
    /**
     * Record the relative position of the dragged element relative to the
     * constraints box and save as a progress value.
     */
    const boxProgress = {
      x: 0,
      y: 0
    };
    eachAxis(axis => {
      const axisValue = this.getAxisMotionValue(axis);
      if (axisValue && this.constraints !== false) {
        const latest = axisValue.get();
        boxProgress[axis] = calcOrigin({
          min: latest,
          max: latest
        }, this.constraints[axis]);
      }
    });
    /**
     * Update the layout of this element and resolve the latest drag constraints
     */
    const {
      transformTemplate
    } = this.visualElement.getProps();
    this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
    projection.root && projection.root.updateScroll();
    projection.updateLayout();
    this.resolveConstraints();
    /**
     * For each axis, calculate the current progress of the layout axis
     * within the new constraints.
     */
    eachAxis(axis => {
      if (!shouldDrag(axis, drag, null)) return;
      /**
       * Calculate a new transform based on the previous box progress
       */
      const axisValue = this.getAxisMotionValue(axis);
      const {
        min,
        max
      } = this.constraints[axis];
      axisValue.set(mixNumber$1(min, max, boxProgress[axis]));
    });
  }
  addListeners() {
    if (!this.visualElement.current) return;
    elementDragControls.set(this.visualElement, this);
    const element = this.visualElement.current;
    /**
     * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
     */
    const stopPointerListener = addPointerEvent(element, "pointerdown", event => {
      const {
        drag,
        dragListener = true
      } = this.getProps();
      drag && dragListener && this.start(event);
    });
    const measureDragConstraints = () => {
      const {
        dragConstraints
      } = this.getProps();
      if (isRefObject(dragConstraints) && dragConstraints.current) {
        this.constraints = this.resolveRefConstraints();
      }
    };
    const {
      projection
    } = this.visualElement;
    const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
    if (projection && !projection.layout) {
      projection.root && projection.root.updateScroll();
      projection.updateLayout();
    }
    frame.read(measureDragConstraints);
    /**
     * Attach a window resize listener to scale the draggable target within its defined
     * constraints as the window resizes.
     */
    const stopResizeListener = addDomEvent(window, "resize", () => this.scalePositionWithinConstraints());
    /**
     * If the element's layout changes, calculate the delta and apply that to
     * the drag gesture's origin point.
     */
    const stopLayoutUpdateListener = projection.addEventListener("didUpdate", _ref279 => {
      let {
        delta,
        hasLayoutChanged
      } = _ref279;
      if (this.isDragging && hasLayoutChanged) {
        eachAxis(axis => {
          const motionValue = this.getAxisMotionValue(axis);
          if (!motionValue) return;
          this.originPoint[axis] += delta[axis].translate;
          motionValue.set(motionValue.get() + delta[axis].translate);
        });
        this.visualElement.render();
      }
    });
    return () => {
      stopResizeListener();
      stopPointerListener();
      stopMeasureLayoutListener();
      stopLayoutUpdateListener && stopLayoutUpdateListener();
    };
  }
  getProps() {
    const props = this.visualElement.getProps();
    const {
      drag = false,
      dragDirectionLock = false,
      dragPropagation = false,
      dragConstraints = false,
      dragElastic = defaultElastic,
      dragMomentum = true
    } = props;
    return {
      ...props,
      drag,
      dragDirectionLock,
      dragPropagation,
      dragConstraints,
      dragElastic,
      dragMomentum
    };
  }
}
function shouldDrag(direction, drag, currentDirection) {
  return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */
function getCurrentDirection(offset) {
  let lockThreshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  let direction = null;
  if (Math.abs(offset.y) > lockThreshold) {
    direction = "y";
  } else if (Math.abs(offset.x) > lockThreshold) {
    direction = "x";
  }
  return direction;
}
class DragGesture extends Feature {
  constructor(node) {
    super(node);
    this.removeGroupControls = noop;
    this.removeListeners = noop;
    this.controls = new VisualElementDragControls(node);
  }
  mount() {
    // If we've been provided a DragControls for manual control over the drag gesture,
    // subscribe this component to it on mount.
    const {
      dragControls
    } = this.node.getProps();
    if (dragControls) {
      this.removeGroupControls = dragControls.subscribe(this.controls);
    }
    this.removeListeners = this.controls.addListeners() || noop;
  }
  unmount() {
    this.removeGroupControls();
    this.removeListeners();
  }
}
const asyncHandler = handler => (event, info) => {
  if (handler) {
    frame.postRender(() => handler(event, info));
  }
};
class PanGesture extends Feature {
  constructor() {
    super(...arguments);
    this.removePointerDownListener = noop;
  }
  onPointerDown(pointerDownEvent) {
    this.session = new PanSession(pointerDownEvent, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: getContextWindow(this.node)
    });
  }
  createPanHandlers() {
    const {
      onPanSessionStart,
      onPanStart,
      onPan,
      onPanEnd
    } = this.node.getProps();
    return {
      onSessionStart: asyncHandler(onPanSessionStart),
      onStart: asyncHandler(onPanStart),
      onMove: onPan,
      onEnd: (event, info) => {
        delete this.session;
        if (onPanEnd) {
          frame.postRender(() => onPanEnd(event, info));
        }
      }
    };
  }
  mount() {
    this.removePointerDownListener = addPointerEvent(this.node.current, "pointerdown", event => this.onPointerDown(event));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener();
    this.session && this.session.end();
  }
}

/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */
const globalProjectionState = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: true,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: false
};
function pixelsToPercent(pixels, axis) {
  if (axis.max === axis.min) return 0;
  return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */
const correctBorderRadius = {
  correct: (latest, node) => {
    if (!node.target) return latest;
    /**
     * If latest is a string, if it's a percentage we can return immediately as it's
     * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
     */
    if (typeof latest === "string") {
      if (px.test(latest)) {
        latest = parseFloat(latest);
      } else {
        return latest;
      }
    }
    /**
     * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
     * pixel value as a percentage of each axis
     */
    const x = pixelsToPercent(latest, node.target.x);
    const y = pixelsToPercent(latest, node.target.y);
    return "".concat(x, "% ").concat(y, "%");
  }
};
const correctBoxShadow = {
  correct: (latest, _ref280) => {
    let {
      treeScale,
      projectionDelta
    } = _ref280;
    const original = latest;
    const shadow = complex.parse(latest);
    // TODO: Doesn't support multiple shadows
    if (shadow.length > 5) return original;
    const template = complex.createTransformer(latest);
    const offset = typeof shadow[0] !== "number" ? 1 : 0;
    // Calculate the overall context scale
    const xScale = projectionDelta.x.scale * treeScale.x;
    const yScale = projectionDelta.y.scale * treeScale.y;
    shadow[0 + offset] /= xScale;
    shadow[1 + offset] /= yScale;
    /**
     * Ideally we'd correct x and y scales individually, but because blur and
     * spread apply to both we have to take a scale average and apply that instead.
     * We could potentially improve the outcome of this by incorporating the ratio between
     * the two scales.
     */
    const averageScale = mixNumber$1(xScale, yScale, 0.5);
    // Blur
    if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
    // Spread
    if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
    return template(shadow);
  }
};
class MeasureLayoutWithContext extends Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const {
      visualElement,
      layoutGroup,
      switchLayoutGroup,
      layoutId
    } = this.props;
    const {
      projection
    } = visualElement;
    addScaleCorrector(defaultScaleCorrectors);
    if (projection) {
      if (layoutGroup.group) layoutGroup.group.add(projection);
      if (switchLayoutGroup && switchLayoutGroup.register && layoutId) {
        switchLayoutGroup.register(projection);
      }
      projection.root.didUpdate();
      projection.addEventListener("animationComplete", () => {
        this.safeToRemove();
      });
      projection.setOptions({
        ...projection.options,
        onExitComplete: () => this.safeToRemove()
      });
    }
    globalProjectionState.hasEverUpdated = true;
  }
  getSnapshotBeforeUpdate(prevProps) {
    const {
      layoutDependency,
      visualElement,
      drag,
      isPresent
    } = this.props;
    const projection = visualElement.projection;
    if (!projection) return null;
    /**
     * TODO: We use this data in relegate to determine whether to
     * promote a previous element. There's no guarantee its presence data
     * will have updated by this point - if a bug like this arises it will
     * have to be that we markForRelegation and then find a new lead some other way,
     * perhaps in didUpdate
     */
    projection.isPresent = isPresent;
    if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) {
      projection.willUpdate();
    } else {
      this.safeToRemove();
    }
    if (prevProps.isPresent !== isPresent) {
      if (isPresent) {
        projection.promote();
      } else if (!projection.relegate()) {
        /**
         * If there's another stack member taking over from this one,
         * it's in charge of the exit animation and therefore should
         * be in charge of the safe to remove. Otherwise we call it here.
         */
        frame.postRender(() => {
          const stack = projection.getStack();
          if (!stack || !stack.members.length) {
            this.safeToRemove();
          }
        });
      }
    }
    return null;
  }
  componentDidUpdate() {
    const {
      projection
    } = this.props.visualElement;
    if (projection) {
      projection.root.didUpdate();
      microtask.postRender(() => {
        if (!projection.currentAnimation && projection.isLead()) {
          this.safeToRemove();
        }
      });
    }
  }
  componentWillUnmount() {
    const {
      visualElement,
      layoutGroup,
      switchLayoutGroup: promoteContext
    } = this.props;
    const {
      projection
    } = visualElement;
    if (projection) {
      projection.scheduleCheckAfterUnmount();
      if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
      if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
    }
  }
  safeToRemove() {
    const {
      safeToRemove
    } = this.props;
    safeToRemove && safeToRemove();
  }
  render() {
    return null;
  }
}
function MeasureLayout(props) {
  const [isPresent, safeToRemove] = usePresence();
  const layoutGroup = useContext(LayoutGroupContext);
  return jsx(MeasureLayoutWithContext, {
    ...props,
    layoutGroup: layoutGroup,
    switchLayoutGroup: useContext(SwitchLayoutGroupContext),
    isPresent: isPresent,
    safeToRemove: safeToRemove
  });
}
const defaultScaleCorrectors = {
  borderRadius: {
    ...correctBorderRadius,
    applyTo: ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomLeftRadius", "borderBottomRightRadius"]
  },
  borderTopLeftRadius: correctBorderRadius,
  borderTopRightRadius: correctBorderRadius,
  borderBottomLeftRadius: correctBorderRadius,
  borderBottomRightRadius: correctBorderRadius,
  boxShadow: correctBoxShadow
};
function animateSingleValue(value, keyframes, options) {
  const motionValue$1 = isMotionValue(value) ? value : motionValue(value);
  motionValue$1.start(animateMotionValue("", motionValue$1, keyframes, options));
  return motionValue$1.animation;
}
function isSVGElement(element) {
  return element instanceof SVGElement && element.tagName !== "svg";
}
const compareByDepth = (a, b) => a.depth - b.depth;
class FlatTree {
  constructor() {
    this.children = [];
    this.isDirty = false;
  }
  add(child) {
    addUniqueItem(this.children, child);
    this.isDirty = true;
  }
  remove(child) {
    removeItem(this.children, child);
    this.isDirty = true;
  }
  forEach(callback) {
    this.isDirty && this.children.sort(compareByDepth);
    this.isDirty = false;
    this.children.forEach(callback);
  }
}

/**
 * Timeout defined in ms
 */
function delay(callback, timeout) {
  const start = time.now();
  const checkElapsed = _ref281 => {
    let {
      timestamp
    } = _ref281;
    const elapsed = timestamp - start;
    if (elapsed >= timeout) {
      cancelFrame(checkElapsed);
      callback(elapsed - timeout);
    }
  };
  frame.read(checkElapsed, true);
  return () => cancelFrame(checkElapsed);
}
const borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"];
const numBorders = borders.length;
const asNumber = value => typeof value === "string" ? parseFloat(value) : value;
const isPx = value => typeof value === "number" || px.test(value);
function mixValues(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
  if (shouldCrossfadeOpacity) {
    target.opacity = mixNumber$1(0,
    // TODO Reinstate this if only child
    lead.opacity !== undefined ? lead.opacity : 1, easeCrossfadeIn(progress));
    target.opacityExit = mixNumber$1(follow.opacity !== undefined ? follow.opacity : 1, 0, easeCrossfadeOut(progress));
  } else if (isOnlyMember) {
    target.opacity = mixNumber$1(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
  }
  /**
   * Mix border radius
   */
  for (let i = 0; i < numBorders; i++) {
    const borderLabel = "border".concat(borders[i], "Radius");
    let followRadius = getRadius(follow, borderLabel);
    let leadRadius = getRadius(lead, borderLabel);
    if (followRadius === undefined && leadRadius === undefined) continue;
    followRadius || (followRadius = 0);
    leadRadius || (leadRadius = 0);
    const canMix = followRadius === 0 || leadRadius === 0 || isPx(followRadius) === isPx(leadRadius);
    if (canMix) {
      target[borderLabel] = Math.max(mixNumber$1(asNumber(followRadius), asNumber(leadRadius), progress), 0);
      if (percent.test(leadRadius) || percent.test(followRadius)) {
        target[borderLabel] += "%";
      }
    } else {
      target[borderLabel] = leadRadius;
    }
  }
  /**
   * Mix rotation
   */
  if (follow.rotate || lead.rotate) {
    target.rotate = mixNumber$1(follow.rotate || 0, lead.rotate || 0, progress);
  }
}
function getRadius(values, radiusName) {
  return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const easeCrossfadeIn = /*@__PURE__*/compress(0, 0.5, circOut);
const easeCrossfadeOut = /*@__PURE__*/compress(0.5, 0.95, noop);
function compress(min, max, easing) {
  return p => {
    // Could replace ifs with clamp
    if (p < min) return 0;
    if (p > max) return 1;
    return easing(progress(min, max, p));
  };
}

/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */
function copyAxisInto(axis, originAxis) {
  axis.min = originAxis.min;
  axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */
function copyBoxInto(box, originBox) {
  copyAxisInto(box.x, originBox.x);
  copyAxisInto(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */
function copyAxisDeltaInto(delta, originDelta) {
  delta.translate = originDelta.translate;
  delta.scale = originDelta.scale;
  delta.originPoint = originDelta.originPoint;
  delta.origin = originDelta.origin;
}

/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */
function removePointDelta(point, translate, scale, originPoint, boxScale) {
  point -= translate;
  point = scalePoint(point, 1 / scale, originPoint);
  if (boxScale !== undefined) {
    point = scalePoint(point, 1 / boxScale, originPoint);
  }
  return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */
function removeAxisDelta(axis) {
  let translate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  let scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  let origin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;
  let boxScale = arguments.length > 4 ? arguments[4] : undefined;
  let originAxis = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : axis;
  let sourceAxis = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : axis;
  if (percent.test(translate)) {
    translate = parseFloat(translate);
    const relativeProgress = mixNumber$1(sourceAxis.min, sourceAxis.max, translate / 100);
    translate = relativeProgress - sourceAxis.min;
  }
  if (typeof translate !== "number") return;
  let originPoint = mixNumber$1(originAxis.min, originAxis.max, origin);
  if (axis === originAxis) originPoint -= translate;
  axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
  axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeAxisTransforms(axis, transforms, _ref282, origin, sourceAxis) {
  let [key, scaleKey, originKey] = _ref282;
  removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */
const xKeys = ["x", "scaleX", "originX"];
const yKeys = ["y", "scaleY", "originY"];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeBoxTransforms(box, transforms, originBox, sourceBox) {
  removeAxisTransforms(box.x, transforms, xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
  removeAxisTransforms(box.y, transforms, yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}
function isAxisDeltaZero(delta) {
  return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
  return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function axisEquals(a, b) {
  return a.min === b.min && a.max === b.max;
}
function boxEquals(a, b) {
  return axisEquals(a.x, b.x) && axisEquals(a.y, b.y);
}
function axisEqualsRounded(a, b) {
  return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function boxEqualsRounded(a, b) {
  return axisEqualsRounded(a.x, b.x) && axisEqualsRounded(a.y, b.y);
}
function aspectRatio(box) {
  return calcLength(box.x) / calcLength(box.y);
}
function axisDeltaEquals(a, b) {
  return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}
class NodeStack {
  constructor() {
    this.members = [];
  }
  add(node) {
    addUniqueItem(this.members, node);
    node.scheduleRender();
  }
  remove(node) {
    removeItem(this.members, node);
    if (node === this.prevLead) {
      this.prevLead = undefined;
    }
    if (node === this.lead) {
      const prevLead = this.members[this.members.length - 1];
      if (prevLead) {
        this.promote(prevLead);
      }
    }
  }
  relegate(node) {
    const indexOfNode = this.members.findIndex(member => node === member);
    if (indexOfNode === 0) return false;
    /**
     * Find the next projection node that is present
     */
    let prevLead;
    for (let i = indexOfNode; i >= 0; i--) {
      const member = this.members[i];
      if (member.isPresent !== false) {
        prevLead = member;
        break;
      }
    }
    if (prevLead) {
      this.promote(prevLead);
      return true;
    } else {
      return false;
    }
  }
  promote(node, preserveFollowOpacity) {
    const prevLead = this.lead;
    if (node === prevLead) return;
    this.prevLead = prevLead;
    this.lead = node;
    node.show();
    if (prevLead) {
      prevLead.instance && prevLead.scheduleRender();
      node.scheduleRender();
      node.resumeFrom = prevLead;
      if (preserveFollowOpacity) {
        node.resumeFrom.preserveOpacity = true;
      }
      if (prevLead.snapshot) {
        node.snapshot = prevLead.snapshot;
        node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
      }
      if (node.root && node.root.isUpdating) {
        node.isLayoutDirty = true;
      }
      const {
        crossfade
      } = node.options;
      if (crossfade === false) {
        prevLead.hide();
      }
      /**
       * TODO:
       *   - Test border radius when previous node was deleted
       *   - boxShadow mixing
       *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
       *   - Shared between element A in transformed container and element B (transform stays the same or changes)
       *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
       * ---
       *   - Crossfade opacity of root nodes
       *   - layoutId changes after animation
       *   - layoutId changes mid animation
       */
    }
  }
  exitAnimationComplete() {
    this.members.forEach(node => {
      const {
        options,
        resumingFrom
      } = node;
      options.onExitComplete && options.onExitComplete();
      if (resumingFrom) {
        resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
      }
    });
  }
  scheduleRender() {
    this.members.forEach(node => {
      node.instance && node.scheduleRender(false);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    if (this.lead && this.lead.snapshot) {
      this.lead.snapshot = undefined;
    }
  }
}
function buildProjectionTransform(delta, treeScale, latestTransform) {
  let transform = "";
  /**
   * The translations we use to calculate are always relative to the viewport coordinate space.
   * But when we apply scales, we also scale the coordinate space of an element and its children.
   * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
   * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
   */
  const xTranslate = delta.x.translate / treeScale.x;
  const yTranslate = delta.y.translate / treeScale.y;
  const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
  if (xTranslate || yTranslate || zTranslate) {
    transform = "translate3d(".concat(xTranslate, "px, ").concat(yTranslate, "px, ").concat(zTranslate, "px) ");
  }
  /**
   * Apply scale correction for the tree transform.
   * This will apply scale to the screen-orientated axes.
   */
  if (treeScale.x !== 1 || treeScale.y !== 1) {
    transform += "scale(".concat(1 / treeScale.x, ", ").concat(1 / treeScale.y, ") ");
  }
  if (latestTransform) {
    const {
      transformPerspective,
      rotate,
      rotateX,
      rotateY,
      skewX,
      skewY
    } = latestTransform;
    if (transformPerspective) transform = "perspective(".concat(transformPerspective, "px) ").concat(transform);
    if (rotate) transform += "rotate(".concat(rotate, "deg) ");
    if (rotateX) transform += "rotateX(".concat(rotateX, "deg) ");
    if (rotateY) transform += "rotateY(".concat(rotateY, "deg) ");
    if (skewX) transform += "skewX(".concat(skewX, "deg) ");
    if (skewY) transform += "skewY(".concat(skewY, "deg) ");
  }
  /**
   * Apply scale to match the size of the element to the size we want it.
   * This will apply scale to the element-orientated axes.
   */
  const elementScaleX = delta.x.scale * treeScale.x;
  const elementScaleY = delta.y.scale * treeScale.y;
  if (elementScaleX !== 1 || elementScaleY !== 1) {
    transform += "scale(".concat(elementScaleX, ", ").concat(elementScaleY, ")");
  }
  return transform || "none";
}
const metrics = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
};
const isDebug = typeof window !== "undefined" && window.MotionDebug !== undefined;
const transformAxes = ["", "X", "Y", "Z"];
const hiddenVisibility = {
  visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */
const animationTarget = 1000;
let id = 0;
function resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
  const {
    latestValues
  } = visualElement;
  // Record the distorting transform and then temporarily set it to 0
  if (latestValues[key]) {
    values[key] = latestValues[key];
    visualElement.setStaticValue(key, 0);
    if (sharedAnimationValues) {
      sharedAnimationValues[key] = 0;
    }
  }
}
function cancelTreeOptimisedTransformAnimations(projectionNode) {
  projectionNode.hasCheckedOptimisedAppear = true;
  if (projectionNode.root === projectionNode) return;
  const {
    visualElement
  } = projectionNode.options;
  if (!visualElement) return;
  const appearId = getOptimisedAppearId(visualElement);
  if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
    const {
      layout,
      layoutId
    } = projectionNode.options;
    window.MotionCancelOptimisedAnimation(appearId, "transform", frame, !(layout || layoutId));
  }
  const {
    parent
  } = projectionNode;
  if (parent && !parent.hasCheckedOptimisedAppear) {
    cancelTreeOptimisedTransformAnimations(parent);
  }
}
function createProjectionNode(_ref283) {
  let {
    attachResizeListener,
    defaultParent,
    measureScroll,
    checkIsScrollRoot,
    resetTransform
  } = _ref283;
  return class ProjectionNode {
    constructor() {
      let latestValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      let parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent();
      /**
       * A unique ID generated for every projection node.
       */
      this.id = id++;
      /**
       * An id that represents a unique session instigated by startUpdate.
       */
      this.animationId = 0;
      /**
       * A Set containing all this component's children. This is used to iterate
       * through the children.
       *
       * TODO: This could be faster to iterate as a flat array stored on the root node.
       */
      this.children = new Set();
      /**
       * Options for the node. We use this to configure what kind of layout animations
       * we should perform (if any).
       */
      this.options = {};
      /**
       * We use this to detect when its safe to shut down part of a projection tree.
       * We have to keep projecting children for scale correction and relative projection
       * until all their parents stop performing layout animations.
       */
      this.isTreeAnimating = false;
      this.isAnimationBlocked = false;
      /**
       * Flag to true if we think this layout has been changed. We can't always know this,
       * currently we set it to true every time a component renders, or if it has a layoutDependency
       * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
       * and if one node is dirtied, they all are.
       */
      this.isLayoutDirty = false;
      /**
       * Flag to true if we think the projection calculations for this node needs
       * recalculating as a result of an updated transform or layout animation.
       */
      this.isProjectionDirty = false;
      /**
       * Flag to true if the layout *or* transform has changed. This then gets propagated
       * throughout the projection tree, forcing any element below to recalculate on the next frame.
       */
      this.isSharedProjectionDirty = false;
      /**
       * Flag transform dirty. This gets propagated throughout the whole tree but is only
       * respected by shared nodes.
       */
      this.isTransformDirty = false;
      /**
       * Block layout updates for instant layout transitions throughout the tree.
       */
      this.updateManuallyBlocked = false;
      this.updateBlockedByResize = false;
      /**
       * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
       * call.
       */
      this.isUpdating = false;
      /**
       * If this is an SVG element we currently disable projection transforms
       */
      this.isSVG = false;
      /**
       * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
       * its projection styles.
       */
      this.needsReset = false;
      /**
       * Flags whether this node should have its transform reset prior to measuring.
       */
      this.shouldResetTransform = false;
      /**
       * Store whether this node has been checked for optimised appear animations. As
       * effects fire bottom-up, and we want to look up the tree for appear animations,
       * this makes sure we only check each path once, stopping at nodes that
       * have already been checked.
       */
      this.hasCheckedOptimisedAppear = false;
      /**
       * An object representing the calculated contextual/accumulated/tree scale.
       * This will be used to scale calculcated projection transforms, as these are
       * calculated in screen-space but need to be scaled for elements to layoutly
       * make it to their calculated destinations.
       *
       * TODO: Lazy-init
       */
      this.treeScale = {
        x: 1,
        y: 1
      };
      /**
       *
       */
      this.eventHandlers = new Map();
      this.hasTreeAnimated = false;
      // Note: Currently only running on root node
      this.updateScheduled = false;
      this.scheduleUpdate = () => this.update();
      this.projectionUpdateScheduled = false;
      this.checkUpdateFailed = () => {
        if (this.isUpdating) {
          this.isUpdating = false;
          this.clearAllSnapshots();
        }
      };
      /**
       * This is a multi-step process as shared nodes might be of different depths. Nodes
       * are sorted by depth order, so we need to resolve the entire tree before moving to
       * the next step.
       */
      this.updateProjection = () => {
        this.projectionUpdateScheduled = false;
        /**
         * Reset debug counts. Manually resetting rather than creating a new
         * object each frame.
         */
        if (isDebug) {
          metrics.totalNodes = metrics.resolvedTargetDeltas = metrics.recalculatedProjection = 0;
        }
        this.nodes.forEach(propagateDirtyNodes);
        this.nodes.forEach(resolveTargetDelta);
        this.nodes.forEach(calcProjection);
        this.nodes.forEach(cleanDirtyNodes);
        if (isDebug) {
          window.MotionDebug.record(metrics);
        }
      };
      /**
       * Frame calculations
       */
      this.resolvedRelativeTargetAt = 0.0;
      this.hasProjected = false;
      this.isVisible = true;
      this.animationProgress = 0;
      /**
       * Shared layout
       */
      // TODO Only running on root node
      this.sharedNodes = new Map();
      this.latestValues = latestValues;
      this.root = parent ? parent.root || parent : this;
      this.path = parent ? [...parent.path, parent] : [];
      this.parent = parent;
      this.depth = parent ? parent.depth + 1 : 0;
      for (let i = 0; i < this.path.length; i++) {
        this.path[i].shouldResetTransform = true;
      }
      if (this.root === this) this.nodes = new FlatTree();
    }
    addEventListener(name, handler) {
      if (!this.eventHandlers.has(name)) {
        this.eventHandlers.set(name, new SubscriptionManager());
      }
      return this.eventHandlers.get(name).add(handler);
    }
    notifyListeners(name) {
      const subscriptionManager = this.eventHandlers.get(name);
      for (var _len11 = arguments.length, args = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
        args[_key11 - 1] = arguments[_key11];
      }
      subscriptionManager && subscriptionManager.notify(...args);
    }
    hasListeners(name) {
      return this.eventHandlers.has(name);
    }
    /**
     * Lifecycles
     */
    mount(instance) {
      let isLayoutDirty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.root.hasTreeAnimated;
      if (this.instance) return;
      this.isSVG = isSVGElement(instance);
      this.instance = instance;
      const {
        layoutId,
        layout,
        visualElement
      } = this.options;
      if (visualElement && !visualElement.current) {
        visualElement.mount(instance);
      }
      this.root.nodes.add(this);
      this.parent && this.parent.children.add(this);
      if (isLayoutDirty && (layout || layoutId)) {
        this.isLayoutDirty = true;
      }
      if (attachResizeListener) {
        let cancelDelay;
        const resizeUnblockUpdate = () => this.root.updateBlockedByResize = false;
        attachResizeListener(instance, () => {
          this.root.updateBlockedByResize = true;
          cancelDelay && cancelDelay();
          cancelDelay = delay(resizeUnblockUpdate, 250);
          if (globalProjectionState.hasAnimatedSinceResize) {
            globalProjectionState.hasAnimatedSinceResize = false;
            this.nodes.forEach(finishAnimation);
          }
        });
      }
      if (layoutId) {
        this.root.registerSharedNode(layoutId, this);
      }
      // Only register the handler if it requires layout animation
      if (this.options.animate !== false && visualElement && (layoutId || layout)) {
        this.addEventListener("didUpdate", _ref284 => {
          let {
            delta,
            hasLayoutChanged,
            hasRelativeTargetChanged,
            layout: newLayout
          } = _ref284;
          if (this.isTreeAnimationBlocked()) {
            this.target = undefined;
            this.relativeTarget = undefined;
            return;
          }
          // TODO: Check here if an animation exists
          const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || defaultLayoutTransition;
          const {
            onLayoutAnimationStart,
            onLayoutAnimationComplete
          } = visualElement.getProps();
          /**
           * The target layout of the element might stay the same,
           * but its position relative to its parent has changed.
           */
          const targetChanged = !this.targetLayout || !boxEqualsRounded(this.targetLayout, newLayout) || hasRelativeTargetChanged;
          /**
           * If the layout hasn't seemed to have changed, it might be that the
           * element is visually in the same place in the document but its position
           * relative to its parent has indeed changed. So here we check for that.
           */
          const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
          if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
            if (this.resumeFrom) {
              this.resumingFrom = this.resumeFrom;
              this.resumingFrom.resumingFrom = undefined;
            }
            this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
            const animationOptions = {
              ...getValueTransition(layoutTransition, "layout"),
              onPlay: onLayoutAnimationStart,
              onComplete: onLayoutAnimationComplete
            };
            if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
              animationOptions.delay = 0;
              animationOptions.type = false;
            }
            this.startAnimation(animationOptions);
          } else {
            /**
             * If the layout hasn't changed and we have an animation that hasn't started yet,
             * finish it immediately. Otherwise it will be animating from a location
             * that was probably never commited to screen and look like a jumpy box.
             */
            if (!hasLayoutChanged) {
              finishAnimation(this);
            }
            if (this.isLead() && this.options.onExitComplete) {
              this.options.onExitComplete();
            }
          }
          this.targetLayout = newLayout;
        });
      }
    }
    unmount() {
      this.options.layoutId && this.willUpdate();
      this.root.nodes.remove(this);
      const stack = this.getStack();
      stack && stack.remove(this);
      this.parent && this.parent.children.delete(this);
      this.instance = undefined;
      cancelFrame(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = true;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = false;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
    }
    // Note: currently only running on root node
    startUpdate() {
      if (this.isUpdateBlocked()) return;
      this.isUpdating = true;
      this.nodes && this.nodes.forEach(resetSkewAndRotation);
      this.animationId++;
    }
    getTransformTemplate() {
      const {
        visualElement
      } = this.options;
      return visualElement && visualElement.getProps().transformTemplate;
    }
    willUpdate() {
      let shouldNotifyListeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.root.hasTreeAnimated = true;
      if (this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      /**
       * If we're running optimised appear animations then these must be
       * cancelled before measuring the DOM. This is so we can measure
       * the true layout of the element rather than the WAAPI animation
       * which will be unaffected by the resetSkewAndRotate step.
       *
       * Note: This is a DOM write. Worst case scenario is this is sandwiched
       * between other snapshot reads which will cause unnecessary style recalculations.
       * This has to happen here though, as we don't yet know which nodes will need
       * snapshots in startUpdate(), but we only want to cancel optimised animations
       * if a layout animation measurement is actually going to be affected by them.
       */
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) {
        cancelTreeOptimisedTransformAnimations(this);
      }
      !this.root.isUpdating && this.root.startUpdate();
      if (this.isLayoutDirty) return;
      this.isLayoutDirty = true;
      for (let i = 0; i < this.path.length; i++) {
        const node = this.path[i];
        node.shouldResetTransform = true;
        node.updateScroll("snapshot");
        if (node.options.layoutRoot) {
          node.willUpdate(false);
        }
      }
      const {
        layoutId,
        layout
      } = this.options;
      if (layoutId === undefined && !layout) return;
      const transformTemplate = this.getTransformTemplate();
      this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
      this.updateSnapshot();
      shouldNotifyListeners && this.notifyListeners("willUpdate");
    }
    update() {
      this.updateScheduled = false;
      const updateWasBlocked = this.isUpdateBlocked();
      // When doing an instant transition, we skip the layout update,
      // but should still clean up the measurements so that the next
      // snapshot could be taken correctly.
      if (updateWasBlocked) {
        this.unblockUpdate();
        this.clearAllSnapshots();
        this.nodes.forEach(clearMeasurements);
        return;
      }
      if (!this.isUpdating) {
        this.nodes.forEach(clearIsLayoutDirty);
      }
      this.isUpdating = false;
      /**
       * Write
       */
      this.nodes.forEach(resetTransformStyle);
      /**
       * Read ==================
       */
      // Update layout measurements of updated children
      this.nodes.forEach(updateLayout);
      /**
       * Write
       */
      // Notify listeners that the layout is updated
      this.nodes.forEach(notifyLayoutUpdate);
      this.clearAllSnapshots();
      /**
       * Manually flush any pending updates. Ideally
       * we could leave this to the following requestAnimationFrame but this seems
       * to leave a flash of incorrectly styled content.
       */
      const now = time.now();
      frameData.delta = clamp(0, 1000 / 60, now - frameData.timestamp);
      frameData.timestamp = now;
      frameData.isProcessing = true;
      frameSteps.update.process(frameData);
      frameSteps.preRender.process(frameData);
      frameSteps.render.process(frameData);
      frameData.isProcessing = false;
    }
    didUpdate() {
      if (!this.updateScheduled) {
        this.updateScheduled = true;
        microtask.read(this.scheduleUpdate);
      }
    }
    clearAllSnapshots() {
      this.nodes.forEach(clearSnapshot);
      this.sharedNodes.forEach(removeLeadSnapshots);
    }
    scheduleUpdateProjection() {
      if (!this.projectionUpdateScheduled) {
        this.projectionUpdateScheduled = true;
        frame.preRender(this.updateProjection, false, true);
      }
    }
    scheduleCheckAfterUnmount() {
      /**
       * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
       * we manually call didUpdate to give a chance to the siblings to animate.
       * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
       */
      frame.postRender(() => {
        if (this.isLayoutDirty) {
          this.root.didUpdate();
        } else {
          this.root.checkUpdateFailed();
        }
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      if (this.snapshot || !this.instance) return;
      this.snapshot = this.measure();
    }
    updateLayout() {
      if (!this.instance) return;
      // TODO: Incorporate into a forwarded scroll offset
      this.updateScroll();
      if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) {
        return;
      }
      /**
       * When a node is mounted, it simply resumes from the prevLead's
       * snapshot instead of taking a new one, but the ancestors scroll
       * might have updated while the prevLead is unmounted. We need to
       * update the scroll again to make sure the layout we measure is
       * up to date.
       */
      if (this.resumeFrom && !this.resumeFrom.instance) {
        for (let i = 0; i < this.path.length; i++) {
          const node = this.path[i];
          node.updateScroll();
        }
      }
      const prevLayout = this.layout;
      this.layout = this.measure(false);
      this.layoutCorrected = createBox();
      this.isLayoutDirty = false;
      this.projectionDelta = undefined;
      this.notifyListeners("measure", this.layout.layoutBox);
      const {
        visualElement
      } = this.options;
      visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
    }
    updateScroll() {
      let phase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "measure";
      let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) {
        needsMeasurement = false;
      }
      if (needsMeasurement) {
        const isRoot = checkIsScrollRoot(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase,
          isRoot,
          offset: measureScroll(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : isRoot
        };
      }
    }
    resetTransform() {
      if (!resetTransform) return;
      const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
      const hasProjection = this.projectionDelta && !isDeltaZero(this.projectionDelta);
      const transformTemplate = this.getTransformTemplate();
      const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
      const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
      if (isResetRequested && (hasProjection || hasTransform(this.latestValues) || transformTemplateHasChanged)) {
        resetTransform(this.instance, transformTemplateValue);
        this.shouldResetTransform = false;
        this.scheduleRender();
      }
    }
    measure() {
      let removeTransform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      const pageBox = this.measurePageBox();
      let layoutBox = this.removeElementScroll(pageBox);
      /**
       * Measurements taken during the pre-render stage
       * still have transforms applied so we remove them
       * via calculation.
       */
      if (removeTransform) {
        layoutBox = this.removeTransform(layoutBox);
      }
      roundBox(layoutBox);
      return {
        animationId: this.root.animationId,
        measuredBox: pageBox,
        layoutBox,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var _a;
      const {
        visualElement
      } = this.options;
      if (!visualElement) return createBox();
      const box = visualElement.measureViewportBox();
      const wasInScrollRoot = ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) || this.path.some(checkNodeWasScrollRoot);
      if (!wasInScrollRoot) {
        // Remove viewport scroll to give page-relative coordinates
        const {
          scroll
        } = this.root;
        if (scroll) {
          translateAxis(box.x, scroll.offset.x);
          translateAxis(box.y, scroll.offset.y);
        }
      }
      return box;
    }
    removeElementScroll(box) {
      var _a;
      const boxWithoutScroll = createBox();
      copyBoxInto(boxWithoutScroll, box);
      if ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) {
        return boxWithoutScroll;
      }
      /**
       * Performance TODO: Keep a cumulative scroll offset down the tree
       * rather than loop back up the path.
       */
      for (let i = 0; i < this.path.length; i++) {
        const node = this.path[i];
        const {
          scroll,
          options
        } = node;
        if (node !== this.root && scroll && options.layoutScroll) {
          /**
           * If this is a new scroll root, we want to remove all previous scrolls
           * from the viewport box.
           */
          if (scroll.wasRoot) {
            copyBoxInto(boxWithoutScroll, box);
          }
          translateAxis(boxWithoutScroll.x, scroll.offset.x);
          translateAxis(boxWithoutScroll.y, scroll.offset.y);
        }
      }
      return boxWithoutScroll;
    }
    applyTransform(box) {
      let transformOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      const withTransforms = createBox();
      copyBoxInto(withTransforms, box);
      for (let i = 0; i < this.path.length; i++) {
        const node = this.path[i];
        if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) {
          transformBox(withTransforms, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
          });
        }
        if (!hasTransform(node.latestValues)) continue;
        transformBox(withTransforms, node.latestValues);
      }
      if (hasTransform(this.latestValues)) {
        transformBox(withTransforms, this.latestValues);
      }
      return withTransforms;
    }
    removeTransform(box) {
      const boxWithoutTransform = createBox();
      copyBoxInto(boxWithoutTransform, box);
      for (let i = 0; i < this.path.length; i++) {
        const node = this.path[i];
        if (!node.instance) continue;
        if (!hasTransform(node.latestValues)) continue;
        hasScale(node.latestValues) && node.updateSnapshot();
        const sourceBox = createBox();
        const nodeBox = node.measurePageBox();
        copyBoxInto(sourceBox, nodeBox);
        removeBoxTransforms(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
      }
      if (hasTransform(this.latestValues)) {
        removeBoxTransforms(boxWithoutTransform, this.latestValues);
      }
      return boxWithoutTransform;
    }
    setTargetDelta(delta) {
      this.targetDelta = delta;
      this.root.scheduleUpdateProjection();
      this.isProjectionDirty = true;
    }
    setOptions(options) {
      this.options = {
        ...this.options,
        ...options,
        crossfade: options.crossfade !== undefined ? options.crossfade : true
      };
    }
    clearMeasurements() {
      this.scroll = undefined;
      this.layout = undefined;
      this.snapshot = undefined;
      this.prevTransformTemplateValue = undefined;
      this.targetDelta = undefined;
      this.target = undefined;
      this.isLayoutDirty = false;
    }
    forceRelativeParentToResolveTarget() {
      if (!this.relativeParent) return;
      /**
       * If the parent target isn't up-to-date, force it to update.
       * This is an unfortunate de-optimisation as it means any updating relative
       * projection will cause all the relative parents to recalculate back
       * up the tree.
       */
      if (this.relativeParent.resolvedRelativeTargetAt !== frameData.timestamp) {
        this.relativeParent.resolveTargetDelta(true);
      }
    }
    resolveTargetDelta() {
      let forceRecalculation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _a;
      /**
       * Once the dirty status of nodes has been spread through the tree, we also
       * need to check if we have a shared node of a different depth that has itself
       * been dirtied.
       */
      const lead = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
      this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
      this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
      const isShared = Boolean(this.resumingFrom) || this !== lead;
      /**
       * We don't use transform for this step of processing so we don't
       * need to check whether any nodes have changed transform.
       */
      const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
      if (canSkip) return;
      const {
        layout,
        layoutId
      } = this.options;
      /**
       * If we have no layout, we can't perform projection, so early return
       */
      if (!this.layout || !(layout || layoutId)) return;
      this.resolvedRelativeTargetAt = frameData.timestamp;
      /**
       * If we don't have a targetDelta but do have a layout, we can attempt to resolve
       * a relativeParent. This will allow a component to perform scale correction
       * even if no animation has started.
       */
      if (!this.targetDelta && !this.relativeTarget) {
        const relativeParent = this.getClosestProjectingParent();
        if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
          this.relativeParent = relativeParent;
          this.forceRelativeParentToResolveTarget();
          this.relativeTarget = createBox();
          this.relativeTargetOrigin = createBox();
          calcRelativePosition(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
          copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
        } else {
          this.relativeParent = this.relativeTarget = undefined;
        }
      }
      /**
       * If we have no relative target or no target delta our target isn't valid
       * for this frame.
       */
      if (!this.relativeTarget && !this.targetDelta) return;
      /**
       * Lazy-init target data structure
       */
      if (!this.target) {
        this.target = createBox();
        this.targetWithTransforms = createBox();
      }
      /**
       * If we've got a relative box for this component, resolve it into a target relative to the parent.
       */
      if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
        this.forceRelativeParentToResolveTarget();
        calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target);
        /**
         * If we've only got a targetDelta, resolve it into a target
         */
      } else if (this.targetDelta) {
        if (Boolean(this.resumingFrom)) {
          // TODO: This is creating a new object every frame
          this.target = this.applyTransform(this.layout.layoutBox);
        } else {
          copyBoxInto(this.target, this.layout.layoutBox);
        }
        applyBoxDelta(this.target, this.targetDelta);
      } else {
        /**
         * If no target, use own layout as target
         */
        copyBoxInto(this.target, this.layout.layoutBox);
      }
      /**
       * If we've been told to attempt to resolve a relative target, do so.
       */
      if (this.attemptToResolveRelativeTarget) {
        this.attemptToResolveRelativeTarget = false;
        const relativeParent = this.getClosestProjectingParent();
        if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
          this.relativeParent = relativeParent;
          this.forceRelativeParentToResolveTarget();
          this.relativeTarget = createBox();
          this.relativeTargetOrigin = createBox();
          calcRelativePosition(this.relativeTargetOrigin, this.target, relativeParent.target);
          copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
        } else {
          this.relativeParent = this.relativeTarget = undefined;
        }
      }
      /**
       * Increase debug counter for resolved target deltas
       */
      if (isDebug) {
        metrics.resolvedTargetDeltas++;
      }
    }
    getClosestProjectingParent() {
      if (!this.parent || hasScale(this.parent.latestValues) || has2DTranslate(this.parent.latestValues)) {
        return undefined;
      }
      if (this.parent.isProjecting()) {
        return this.parent;
      } else {
        return this.parent.getClosestProjectingParent();
      }
    }
    isProjecting() {
      return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var _a;
      const lead = this.getLead();
      const isShared = Boolean(this.resumingFrom) || this !== lead;
      let canSkip = true;
      /**
       * If this is a normal layout animation and neither this node nor its nearest projecting
       * is dirty then we can't skip.
       */
      if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) {
        canSkip = false;
      }
      /**
       * If this is a shared layout animation and this node's shared projection is dirty then
       * we can't skip.
       */
      if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) {
        canSkip = false;
      }
      /**
       * If we have resolved the target this frame we must recalculate the
       * projection to ensure it visually represents the internal calculations.
       */
      if (this.resolvedRelativeTargetAt === frameData.timestamp) {
        canSkip = false;
      }
      if (canSkip) return;
      const {
        layout,
        layoutId
      } = this.options;
      /**
       * If this section of the tree isn't animating we can
       * delete our target sources for the following frame.
       */
      this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
      if (!this.isTreeAnimating) {
        this.targetDelta = this.relativeTarget = undefined;
      }
      if (!this.layout || !(layout || layoutId)) return;
      /**
       * Reset the corrected box with the latest values from box, as we're then going
       * to perform mutative operations on it.
       */
      copyBoxInto(this.layoutCorrected, this.layout.layoutBox);
      /**
       * Record previous tree scales before updating.
       */
      const prevTreeScaleX = this.treeScale.x;
      const prevTreeScaleY = this.treeScale.y;
      /**
       * Apply all the parent deltas to this box to produce the corrected box. This
       * is the layout box, as it will appear on screen as a result of the transforms of its parents.
       */
      applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, isShared);
      /**
       * If this layer needs to perform scale correction but doesn't have a target,
       * use the layout as the target.
       */
      if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
        lead.target = lead.layout.layoutBox;
        lead.targetWithTransforms = createBox();
      }
      const {
        target
      } = lead;
      if (!target) {
        /**
         * If we don't have a target to project into, but we were previously
         * projecting, we want to remove the stored transform and schedule
         * a render to ensure the elements reflect the removed transform.
         */
        if (this.prevProjectionDelta) {
          this.createProjectionDeltas();
          this.scheduleRender();
        }
        return;
      }
      if (!this.projectionDelta || !this.prevProjectionDelta) {
        this.createProjectionDeltas();
      } else {
        copyAxisDeltaInto(this.prevProjectionDelta.x, this.projectionDelta.x);
        copyAxisDeltaInto(this.prevProjectionDelta.y, this.projectionDelta.y);
      }
      /**
       * Update the delta between the corrected box and the target box before user-set transforms were applied.
       * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
       * for our layout reprojection, but still allow them to be scaled correctly by the user.
       * It might be that to simplify this we may want to accept that user-set scale is also corrected
       * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
       * to allow people to choose whether these styles are corrected based on just the
       * layout reprojection or the final bounding box.
       */
      calcBoxDelta(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
      if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !axisDeltaEquals(this.projectionDelta.x, this.prevProjectionDelta.x) || !axisDeltaEquals(this.projectionDelta.y, this.prevProjectionDelta.y)) {
        this.hasProjected = true;
        this.scheduleRender();
        this.notifyListeners("projectionUpdate", target);
      }
      /**
       * Increase debug counter for recalculated projections
       */
      if (isDebug) {
        metrics.recalculatedProjection++;
      }
    }
    hide() {
      this.isVisible = false;
      // TODO: Schedule render
    }
    show() {
      this.isVisible = true;
      // TODO: Schedule render
    }
    scheduleRender() {
      let notifyAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var _a;
      (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.scheduleRender();
      if (notifyAll) {
        const stack = this.getStack();
        stack && stack.scheduleRender();
      }
      if (this.resumingFrom && !this.resumingFrom.instance) {
        this.resumingFrom = undefined;
      }
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = createDelta();
      this.projectionDelta = createDelta();
      this.projectionDeltaWithTransform = createDelta();
    }
    setAnimationOrigin(delta) {
      let hasOnlyRelativeTargetChanged = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      const snapshot = this.snapshot;
      const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
      const mixedValues = {
        ...this.latestValues
      };
      const targetDelta = createDelta();
      if (!this.relativeParent || !this.relativeParent.options.layoutRoot) {
        this.relativeTarget = this.relativeTargetOrigin = undefined;
      }
      this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
      const relativeLayout = createBox();
      const snapshotSource = snapshot ? snapshot.source : undefined;
      const layoutSource = this.layout ? this.layout.source : undefined;
      const isSharedLayoutAnimation = snapshotSource !== layoutSource;
      const stack = this.getStack();
      const isOnlyMember = !stack || stack.members.length <= 1;
      const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some(hasOpacityCrossfade));
      this.animationProgress = 0;
      let prevRelativeTarget;
      this.mixTargetDelta = latest => {
        const progress = latest / 1000;
        mixAxisDelta(targetDelta.x, delta.x, progress);
        mixAxisDelta(targetDelta.y, delta.y, progress);
        this.setTargetDelta(targetDelta);
        if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
          calcRelativePosition(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
          mixBox(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
          /**
           * If this is an unchanged relative target we can consider the
           * projection not dirty.
           */
          if (prevRelativeTarget && boxEquals(this.relativeTarget, prevRelativeTarget)) {
            this.isProjectionDirty = false;
          }
          if (!prevRelativeTarget) prevRelativeTarget = createBox();
          copyBoxInto(prevRelativeTarget, this.relativeTarget);
        }
        if (isSharedLayoutAnimation) {
          this.animationValues = mixedValues;
          mixValues(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
        }
        this.root.scheduleUpdateProjection();
        this.scheduleRender();
        this.animationProgress = progress;
      };
      this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
    }
    startAnimation(options) {
      this.notifyListeners("animationStart");
      this.currentAnimation && this.currentAnimation.stop();
      if (this.resumingFrom && this.resumingFrom.currentAnimation) {
        this.resumingFrom.currentAnimation.stop();
      }
      if (this.pendingAnimation) {
        cancelFrame(this.pendingAnimation);
        this.pendingAnimation = undefined;
      }
      /**
       * Start the animation in the next frame to have a frame with progress 0,
       * where the target is the same as when the animation started, so we can
       * calculate the relative positions correctly for instant transitions.
       */
      this.pendingAnimation = frame.update(() => {
        globalProjectionState.hasAnimatedSinceResize = true;
        this.currentAnimation = animateSingleValue(0, animationTarget, {
          ...options,
          onUpdate: latest => {
            this.mixTargetDelta(latest);
            options.onUpdate && options.onUpdate(latest);
          },
          onComplete: () => {
            options.onComplete && options.onComplete();
            this.completeAnimation();
          }
        });
        if (this.resumingFrom) {
          this.resumingFrom.currentAnimation = this.currentAnimation;
        }
        this.pendingAnimation = undefined;
      });
    }
    completeAnimation() {
      if (this.resumingFrom) {
        this.resumingFrom.currentAnimation = undefined;
        this.resumingFrom.preserveOpacity = undefined;
      }
      const stack = this.getStack();
      stack && stack.exitAnimationComplete();
      this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
      this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      if (this.currentAnimation) {
        this.mixTargetDelta && this.mixTargetDelta(animationTarget);
        this.currentAnimation.stop();
      }
      this.completeAnimation();
    }
    applyTransformsToTarget() {
      const lead = this.getLead();
      let {
        targetWithTransforms,
        target,
        layout,
        latestValues
      } = lead;
      if (!targetWithTransforms || !target || !layout) return;
      /**
       * If we're only animating position, and this element isn't the lead element,
       * then instead of projecting into the lead box we instead want to calculate
       * a new target that aligns the two boxes but maintains the layout shape.
       */
      if (this !== lead && this.layout && layout && shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
        target = this.target || createBox();
        const xLength = calcLength(this.layout.layoutBox.x);
        target.x.min = lead.target.x.min;
        target.x.max = target.x.min + xLength;
        const yLength = calcLength(this.layout.layoutBox.y);
        target.y.min = lead.target.y.min;
        target.y.max = target.y.min + yLength;
      }
      copyBoxInto(targetWithTransforms, target);
      /**
       * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
       * This is the final box that we will then project into by calculating a transform delta and
       * applying it to the corrected box.
       */
      transformBox(targetWithTransforms, latestValues);
      /**
       * Update the delta between the corrected box and the final target box, after
       * user-set transforms are applied to it. This will be used by the renderer to
       * create a transform style that will reproject the element from its layout layout
       * into the desired bounding box.
       */
      calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
    }
    registerSharedNode(layoutId, node) {
      if (!this.sharedNodes.has(layoutId)) {
        this.sharedNodes.set(layoutId, new NodeStack());
      }
      const stack = this.sharedNodes.get(layoutId);
      stack.add(node);
      const config = node.options.initialPromotionConfig;
      node.promote({
        transition: config ? config.transition : undefined,
        preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
      });
    }
    isLead() {
      const stack = this.getStack();
      return stack ? stack.lead === this : true;
    }
    getLead() {
      var _a;
      const {
        layoutId
      } = this.options;
      return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
    }
    getPrevLead() {
      var _a;
      const {
        layoutId
      } = this.options;
      return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
    }
    getStack() {
      const {
        layoutId
      } = this.options;
      if (layoutId) return this.root.sharedNodes.get(layoutId);
    }
    promote() {
      let {
        needsReset,
        transition,
        preserveFollowOpacity
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const stack = this.getStack();
      if (stack) stack.promote(this, preserveFollowOpacity);
      if (needsReset) {
        this.projectionDelta = undefined;
        this.needsReset = true;
      }
      if (transition) this.setOptions({
        transition
      });
    }
    relegate() {
      const stack = this.getStack();
      if (stack) {
        return stack.relegate(this);
      } else {
        return false;
      }
    }
    resetSkewAndRotation() {
      const {
        visualElement
      } = this.options;
      if (!visualElement) return;
      // If there's no detected skew or rotation values, we can early return without a forced render.
      let hasDistortingTransform = false;
      /**
       * An unrolled check for rotation values. Most elements don't have any rotation and
       * skipping the nested loop and new object creation is 50% faster.
       */
      const {
        latestValues
      } = visualElement;
      if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) {
        hasDistortingTransform = true;
      }
      // If there's no distorting values, we don't need to do any more.
      if (!hasDistortingTransform) return;
      const resetValues = {};
      if (latestValues.z) {
        resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
      }
      // Check the skew and rotate value of all axes and reset to 0
      for (let i = 0; i < transformAxes.length; i++) {
        resetDistortingTransform("rotate".concat(transformAxes[i]), visualElement, resetValues, this.animationValues);
        resetDistortingTransform("skew".concat(transformAxes[i]), visualElement, resetValues, this.animationValues);
      }
      // Force a render of this element to apply the transform with all skews and rotations
      // set to 0.
      visualElement.render();
      // Put back all the values we reset
      for (const key in resetValues) {
        visualElement.setStaticValue(key, resetValues[key]);
        if (this.animationValues) {
          this.animationValues[key] = resetValues[key];
        }
      }
      // Schedule a render for the next frame. This ensures we won't visually
      // see the element with the reset rotate value applied.
      visualElement.scheduleRender();
    }
    getProjectionStyles(styleProp) {
      var _a, _b;
      if (!this.instance || this.isSVG) return undefined;
      if (!this.isVisible) {
        return hiddenVisibility;
      }
      const styles = {
        visibility: ""
      };
      const transformTemplate = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = false;
        styles.opacity = "";
        styles.pointerEvents = resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
        styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
        return styles;
      }
      const lead = this.getLead();
      if (!this.projectionDelta || !this.layout || !lead.target) {
        const emptyStyles = {};
        if (this.options.layoutId) {
          emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
          emptyStyles.pointerEvents = resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
        }
        if (this.hasProjected && !hasTransform(this.latestValues)) {
          emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
          this.hasProjected = false;
        }
        return emptyStyles;
      }
      const valuesToRender = lead.animationValues || lead.latestValues;
      this.applyTransformsToTarget();
      styles.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
      if (transformTemplate) {
        styles.transform = transformTemplate(valuesToRender, styles.transform);
      }
      const {
        x,
        y
      } = this.projectionDelta;
      styles.transformOrigin = "".concat(x.origin * 100, "% ").concat(y.origin * 100, "% 0");
      if (lead.animationValues) {
        /**
         * If the lead component is animating, assign this either the entering/leaving
         * opacity
         */
        styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
      } else {
        /**
         * Or we're not animating at all, set the lead component to its layout
         * opacity and other components to hidden.
         */
        styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
      }
      /**
       * Apply scale correction
       */
      for (const key in scaleCorrectors) {
        if (valuesToRender[key] === undefined) continue;
        const {
          correct,
          applyTo
        } = scaleCorrectors[key];
        /**
         * Only apply scale correction to the value if we have an
         * active projection transform. Otherwise these values become
         * vulnerable to distortion if the element changes size without
         * a corresponding layout animation.
         */
        const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
        if (applyTo) {
          const num = applyTo.length;
          for (let i = 0; i < num; i++) {
            styles[applyTo[i]] = corrected;
          }
        } else {
          styles[key] = corrected;
        }
      }
      /**
       * Disable pointer events on follow components. This is to ensure
       * that if a follow component covers a lead component it doesn't block
       * pointer events on the lead.
       */
      if (this.options.layoutId) {
        styles.pointerEvents = lead === this ? resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
      }
      return styles;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = undefined;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach(node => {
        var _a;
        return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
      });
      this.root.nodes.forEach(clearMeasurements);
      this.root.sharedNodes.clear();
    }
  };
}
function updateLayout(node) {
  node.updateLayout();
}
function notifyLayoutUpdate(node) {
  var _a;
  const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
  if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
    const {
      layoutBox: layout,
      measuredBox: measuredLayout
    } = node.layout;
    const {
      animationType
    } = node.options;
    const isShared = snapshot.source !== node.layout.source;
    // TODO Maybe we want to also resize the layout snapshot so we don't trigger
    // animations for instance if layout="size" and an element has only changed position
    if (animationType === "size") {
      eachAxis(axis => {
        const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
        const length = calcLength(axisSnapshot);
        axisSnapshot.min = layout[axis].min;
        axisSnapshot.max = axisSnapshot.min + length;
      });
    } else if (shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) {
      eachAxis(axis => {
        const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
        const length = calcLength(layout[axis]);
        axisSnapshot.max = axisSnapshot.min + length;
        /**
         * Ensure relative target gets resized and rerendererd
         */
        if (node.relativeTarget && !node.currentAnimation) {
          node.isProjectionDirty = true;
          node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
        }
      });
    }
    const layoutDelta = createDelta();
    calcBoxDelta(layoutDelta, layout, snapshot.layoutBox);
    const visualDelta = createDelta();
    if (isShared) {
      calcBoxDelta(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
    } else {
      calcBoxDelta(visualDelta, layout, snapshot.layoutBox);
    }
    const hasLayoutChanged = !isDeltaZero(layoutDelta);
    let hasRelativeTargetChanged = false;
    if (!node.resumeFrom) {
      const relativeParent = node.getClosestProjectingParent();
      /**
       * If the relativeParent is itself resuming from a different element then
       * the relative snapshot is not relavent
       */
      if (relativeParent && !relativeParent.resumeFrom) {
        const {
          snapshot: parentSnapshot,
          layout: parentLayout
        } = relativeParent;
        if (parentSnapshot && parentLayout) {
          const relativeSnapshot = createBox();
          calcRelativePosition(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
          const relativeLayout = createBox();
          calcRelativePosition(relativeLayout, layout, parentLayout.layoutBox);
          if (!boxEqualsRounded(relativeSnapshot, relativeLayout)) {
            hasRelativeTargetChanged = true;
          }
          if (relativeParent.options.layoutRoot) {
            node.relativeTarget = relativeLayout;
            node.relativeTargetOrigin = relativeSnapshot;
            node.relativeParent = relativeParent;
          }
        }
      }
    }
    node.notifyListeners("didUpdate", {
      layout,
      snapshot,
      delta: visualDelta,
      layoutDelta,
      hasLayoutChanged,
      hasRelativeTargetChanged
    });
  } else if (node.isLead()) {
    const {
      onExitComplete
    } = node.options;
    onExitComplete && onExitComplete();
  }
  /**
   * Clearing transition
   * TODO: Investigate why this transition is being passed in as {type: false } from Framer
   * and why we need it at all
   */
  node.options.transition = undefined;
}
function propagateDirtyNodes(node) {
  /**
   * Increase debug counter for nodes encountered this frame
   */
  if (isDebug) {
    metrics.totalNodes++;
  }
  if (!node.parent) return;
  /**
   * If this node isn't projecting, propagate isProjectionDirty. It will have
   * no performance impact but it will allow the next child that *is* projecting
   * but *isn't* dirty to just check its parent to see if *any* ancestor needs
   * correcting.
   */
  if (!node.isProjecting()) {
    node.isProjectionDirty = node.parent.isProjectionDirty;
  }
  /**
   * Propagate isSharedProjectionDirty and isTransformDirty
   * throughout the whole tree. A future revision can take another look at
   * this but for safety we still recalcualte shared nodes.
   */
  node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
  node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function cleanDirtyNodes(node) {
  node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function clearSnapshot(node) {
  node.clearSnapshot();
}
function clearMeasurements(node) {
  node.clearMeasurements();
}
function clearIsLayoutDirty(node) {
  node.isLayoutDirty = false;
}
function resetTransformStyle(node) {
  const {
    visualElement
  } = node.options;
  if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) {
    visualElement.notify("BeforeLayoutMeasure");
  }
  node.resetTransform();
}
function finishAnimation(node) {
  node.finishAnimation();
  node.targetDelta = node.relativeTarget = node.target = undefined;
  node.isProjectionDirty = true;
}
function resolveTargetDelta(node) {
  node.resolveTargetDelta();
}
function calcProjection(node) {
  node.calcProjection();
}
function resetSkewAndRotation(node) {
  node.resetSkewAndRotation();
}
function removeLeadSnapshots(stack) {
  stack.removeLeadSnapshot();
}
function mixAxisDelta(output, delta, p) {
  output.translate = mixNumber$1(delta.translate, 0, p);
  output.scale = mixNumber$1(delta.scale, 1, p);
  output.origin = delta.origin;
  output.originPoint = delta.originPoint;
}
function mixAxis(output, from, to, p) {
  output.min = mixNumber$1(from.min, to.min, p);
  output.max = mixNumber$1(from.max, to.max, p);
}
function mixBox(output, from, to, p) {
  mixAxis(output.x, from.x, to.x, p);
  mixAxis(output.y, from.y, to.y, p);
}
function hasOpacityCrossfade(node) {
  return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const defaultLayoutTransition = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
const userAgentContains = string => typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */
const roundPoint = userAgentContains("applewebkit/") && !userAgentContains("chrome/") ? Math.round : noop;
function roundAxis(axis) {
  // Round to the nearest .5 pixels to support subpixel layouts
  axis.min = roundPoint(axis.min);
  axis.max = roundPoint(axis.max);
}
function roundBox(box) {
  roundAxis(box.x);
  roundAxis(box.y);
}
function shouldAnimatePositionOnly(animationType, snapshot, layout) {
  return animationType === "position" || animationType === "preserve-aspect" && !isNear(aspectRatio(snapshot), aspectRatio(layout), 0.2);
}
function checkNodeWasScrollRoot(node) {
  var _a;
  return node !== node.root && ((_a = node.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot);
}
const DocumentProjectionNode = createProjectionNode({
  attachResizeListener: (ref, notify) => addDomEvent(ref, "resize", notify),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => true
});
const rootProjectionNode = {
  current: undefined
};
const HTMLProjectionNode = createProjectionNode({
  measureScroll: instance => ({
    x: instance.scrollLeft,
    y: instance.scrollTop
  }),
  defaultParent: () => {
    if (!rootProjectionNode.current) {
      const documentNode = new DocumentProjectionNode({});
      documentNode.mount(window);
      documentNode.setOptions({
        layoutScroll: true
      });
      rootProjectionNode.current = documentNode;
    }
    return rootProjectionNode.current;
  },
  resetTransform: (instance, value) => {
    instance.style.transform = value !== undefined ? value : "none";
  },
  checkIsScrollRoot: instance => Boolean(window.getComputedStyle(instance).position === "fixed")
});
const drag = {
  pan: {
    Feature: PanGesture
  },
  drag: {
    Feature: DragGesture,
    ProjectionNode: HTMLProjectionNode,
    MeasureLayout
  }
};
function handleHoverEvent(node, event, lifecycle) {
  const {
    props
  } = node;
  if (node.animationState && props.whileHover) {
    node.animationState.setActive("whileHover", lifecycle === "Start");
  }
  const eventName = "onHover" + lifecycle;
  const callback = props[eventName];
  if (callback) {
    frame.postRender(() => callback(event, extractEventInfo(event)));
  }
}
class HoverGesture extends Feature {
  mount() {
    const {
      current
    } = this.node;
    if (!current) return;
    this.unmount = hover(current, startEvent => {
      handleHoverEvent(this.node, startEvent, "Start");
      return endEvent => handleHoverEvent(this.node, endEvent, "End");
    });
  }
  unmount() {}
}
class FocusGesture extends Feature {
  constructor() {
    super(...arguments);
    this.isActive = false;
  }
  onFocus() {
    let isFocusVisible = false;
    /**
     * If this element doesn't match focus-visible then don't
     * apply whileHover. But, if matches throws that focus-visible
     * is not a valid selector then in that browser outline styles will be applied
     * to the element by default and we want to match that behaviour with whileFocus.
     */
    try {
      isFocusVisible = this.node.current.matches(":focus-visible");
    } catch (e) {
      isFocusVisible = true;
    }
    if (!isFocusVisible || !this.node.animationState) return;
    this.node.animationState.setActive("whileFocus", true);
    this.isActive = true;
  }
  onBlur() {
    if (!this.isActive || !this.node.animationState) return;
    this.node.animationState.setActive("whileFocus", false);
    this.isActive = false;
  }
  mount() {
    this.unmount = pipe(addDomEvent(this.node.current, "focus", () => this.onFocus()), addDomEvent(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {}
}
function handlePressEvent(node, event, lifecycle) {
  const {
    props
  } = node;
  if (node.animationState && props.whileTap) {
    node.animationState.setActive("whileTap", lifecycle === "Start");
  }
  const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
  const callback = props[eventName];
  if (callback) {
    frame.postRender(() => callback(event, extractEventInfo(event)));
  }
}
class PressGesture extends Feature {
  mount() {
    const {
      current
    } = this.node;
    if (!current) return;
    this.unmount = press(current, startEvent => {
      handlePressEvent(this.node, startEvent, "Start");
      return (endEvent, _ref285) => {
        let {
          success
        } = _ref285;
        return handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
      };
    }, {
      useGlobalTarget: this.node.props.globalTapTarget
    });
  }
  unmount() {}
}

/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */
const observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */
const observers = new WeakMap();
const fireObserverCallback = entry => {
  const callback = observerCallbacks.get(entry.target);
  callback && callback(entry);
};
const fireAllObserverCallbacks = entries => {
  entries.forEach(fireObserverCallback);
};
function initIntersectionObserver(_ref286) {
  let {
    root,
    ...options
  } = _ref286;
  const lookupRoot = root || document;
  /**
   * If we don't have an observer lookup map for this root, create one.
   */
  if (!observers.has(lookupRoot)) {
    observers.set(lookupRoot, {});
  }
  const rootObservers = observers.get(lookupRoot);
  const key = JSON.stringify(options);
  /**
   * If we don't have an observer for this combination of root and settings,
   * create one.
   */
  if (!rootObservers[key]) {
    rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, {
      root,
      ...options
    });
  }
  return rootObservers[key];
}
function observeIntersection(element, options, callback) {
  const rootInteresectionObserver = initIntersectionObserver(options);
  observerCallbacks.set(element, callback);
  rootInteresectionObserver.observe(element);
  return () => {
    observerCallbacks.delete(element);
    rootInteresectionObserver.unobserve(element);
  };
}
const thresholdNames = {
  some: 0,
  all: 1
};
class InViewFeature extends Feature {
  constructor() {
    super(...arguments);
    this.hasEnteredView = false;
    this.isInView = false;
  }
  startObserver() {
    this.unmount();
    const {
      viewport = {}
    } = this.node.getProps();
    const {
      root,
      margin: rootMargin,
      amount = "some",
      once
    } = viewport;
    const options = {
      root: root ? root.current : undefined,
      rootMargin,
      threshold: typeof amount === "number" ? amount : thresholdNames[amount]
    };
    const onIntersectionUpdate = entry => {
      const {
        isIntersecting
      } = entry;
      /**
       * If there's been no change in the viewport state, early return.
       */
      if (this.isInView === isIntersecting) return;
      this.isInView = isIntersecting;
      /**
       * Handle hasEnteredView. If this is only meant to run once, and
       * element isn't visible, early return. Otherwise set hasEnteredView to true.
       */
      if (once && !isIntersecting && this.hasEnteredView) {
        return;
      } else if (isIntersecting) {
        this.hasEnteredView = true;
      }
      if (this.node.animationState) {
        this.node.animationState.setActive("whileInView", isIntersecting);
      }
      /**
       * Use the latest committed props rather than the ones in scope
       * when this observer is created
       */
      const {
        onViewportEnter,
        onViewportLeave
      } = this.node.getProps();
      const callback = isIntersecting ? onViewportEnter : onViewportLeave;
      callback && callback(entry);
    };
    return observeIntersection(this.node.current, options, onIntersectionUpdate);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver === "undefined") return;
    const {
      props,
      prevProps
    } = this.node;
    const hasOptionsChanged = ["amount", "margin", "root"].some(hasViewportOptionChanged(props, prevProps));
    if (hasOptionsChanged) {
      this.startObserver();
    }
  }
  unmount() {}
}
function hasViewportOptionChanged(_ref287) {
  let {
    viewport = {}
  } = _ref287;
  let {
    viewport: prevViewport = {}
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return name => viewport[name] !== prevViewport[name];
}
const gestureAnimations = {
  inView: {
    Feature: InViewFeature
  },
  tap: {
    Feature: PressGesture
  },
  focus: {
    Feature: FocusGesture
  },
  hover: {
    Feature: HoverGesture
  }
};
const layout = {
  layout: {
    ProjectionNode: HTMLProjectionNode,
    MeasureLayout
  }
};

// Does this device prefer reduced motion? Returns `null` server-side.
const prefersReducedMotion = {
  current: null
};
const hasReducedMotionListener = {
  current: false
};
function initPrefersReducedMotion() {
  hasReducedMotionListener.current = true;
  if (!isBrowser) return;
  if (window.matchMedia) {
    const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
    const setReducedMotionPreferences = () => prefersReducedMotion.current = motionMediaQuery.matches;
    motionMediaQuery.addListener(setReducedMotionPreferences);
    setReducedMotionPreferences();
  } else {
    prefersReducedMotion.current = false;
  }
}

/**
 * A list of all ValueTypes
 */
const valueTypes = [...dimensionValueTypes, color, complex];
/**
 * Tests a value against the list of ValueTypes
 */
const findValueType = v => valueTypes.find(testValueType(v));
const visualElementStore = new WeakMap();
function updateMotionValuesFromProps(element, next, prev) {
  for (const key in next) {
    const nextValue = next[key];
    const prevValue = prev[key];
    if (isMotionValue(nextValue)) {
      /**
       * If this is a motion value found in props or style, we want to add it
       * to our visual element's motion value map.
       */
      element.addValue(key, nextValue);
      /**
       * Check the version of the incoming motion value with this version
       * and warn against mismatches.
       */
      if (process.env.NODE_ENV === "development") {
        warnOnce(nextValue.version === "11.18.2", "Attempting to mix Motion versions ".concat(nextValue.version, " with 11.18.2 may not work as expected."));
      }
    } else if (isMotionValue(prevValue)) {
      /**
       * If we're swapping from a motion value to a static value,
       * create a new motion value from that
       */
      element.addValue(key, motionValue(nextValue, {
        owner: element
      }));
    } else if (prevValue !== nextValue) {
      /**
       * If this is a flat value that has changed, update the motion value
       * or create one if it doesn't exist. We only want to do this if we're
       * not handling the value with our animation state.
       */
      if (element.hasValue(key)) {
        const existingValue = element.getValue(key);
        if (existingValue.liveStyle === true) {
          existingValue.jump(nextValue);
        } else if (!existingValue.hasAnimated) {
          existingValue.set(nextValue);
        }
      } else {
        const latestValue = element.getStaticValue(key);
        element.addValue(key, motionValue(latestValue !== undefined ? latestValue : nextValue, {
          owner: element
        }));
      }
    }
  }
  // Handle removed values
  for (const key in prev) {
    if (next[key] === undefined) element.removeValue(key);
  }
  return next;
}
const propEventHandlers = ["AnimationStart", "AnimationComplete", "Update", "BeforeLayoutMeasure", "LayoutMeasure", "LayoutAnimationStart", "LayoutAnimationComplete"];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */
class VisualElement {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
    return {};
  }
  constructor(_ref288) {
    let {
      parent,
      props,
      presenceContext,
      reducedMotionConfig,
      blockInitialAnimation,
      visualState
    } = _ref288;
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    /**
     * A reference to the current underlying Instance, e.g. a HTMLElement
     * or Three.Mesh etc.
     */
    this.current = null;
    /**
     * A set containing references to this VisualElement's children.
     */
    this.children = new Set();
    /**
     * Determine what role this visual element should take in the variant tree.
     */
    this.isVariantNode = false;
    this.isControllingVariants = false;
    /**
     * Decides whether this VisualElement should animate in reduced motion
     * mode.
     *
     * TODO: This is currently set on every individual VisualElement but feels
     * like it could be set globally.
     */
    this.shouldReduceMotion = null;
    /**
     * A map of all motion values attached to this visual element. Motion
     * values are source of truth for any given animated value. A motion
     * value might be provided externally by the component via props.
     */
    this.values = new Map();
    this.KeyframeResolver = KeyframeResolver;
    /**
     * Cleanup functions for active features (hover/tap/exit etc)
     */
    this.features = {};
    /**
     * A map of every subscription that binds the provided or generated
     * motion values onChange listeners to this visual element.
     */
    this.valueSubscriptions = new Map();
    /**
     * A reference to the previously-provided motion values as returned
     * from scrapeMotionValuesFromProps. We use the keys in here to determine
     * if any motion values need to be removed after props are updated.
     */
    this.prevMotionValues = {};
    /**
     * An object containing a SubscriptionManager for each active event.
     */
    this.events = {};
    /**
     * An object containing an unsubscribe function for each prop event subscription.
     * For example, every "Update" event can have multiple subscribers via
     * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
     */
    this.propEventSubscriptions = {};
    this.notifyUpdate = () => this.notify("Update", this.latestValues);
    this.render = () => {
      if (!this.current) return;
      this.triggerBuild();
      this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
    };
    this.renderScheduledAt = 0.0;
    this.scheduleRender = () => {
      const now = time.now();
      if (this.renderScheduledAt < now) {
        this.renderScheduledAt = now;
        frame.render(this.render, false, true);
      }
    };
    const {
      latestValues,
      renderState,
      onUpdate
    } = visualState;
    this.onUpdate = onUpdate;
    this.latestValues = latestValues;
    this.baseTarget = {
      ...latestValues
    };
    this.initialValues = props.initial ? {
      ...latestValues
    } : {};
    this.renderState = renderState;
    this.parent = parent;
    this.props = props;
    this.presenceContext = presenceContext;
    this.depth = parent ? parent.depth + 1 : 0;
    this.reducedMotionConfig = reducedMotionConfig;
    this.options = options;
    this.blockInitialAnimation = Boolean(blockInitialAnimation);
    this.isControllingVariants = isControllingVariants(props);
    this.isVariantNode = isVariantNode(props);
    if (this.isVariantNode) {
      this.variantChildren = new Set();
    }
    this.manuallyAnimateOnMount = Boolean(parent && parent.current);
    /**
     * Any motion values that are provided to the element when created
     * aren't yet bound to the element, as this would technically be impure.
     * However, we iterate through the motion values and set them to the
     * initial values for this component.
     *
     * TODO: This is impure and we should look at changing this to run on mount.
     * Doing so will break some tests but this isn't necessarily a breaking change,
     * more a reflection of the test.
     */
    const {
      willChange,
      ...initialMotionValues
    } = this.scrapeMotionValuesFromProps(props, {}, this);
    for (const key in initialMotionValues) {
      const value = initialMotionValues[key];
      if (latestValues[key] !== undefined && isMotionValue(value)) {
        value.set(latestValues[key], false);
      }
    }
  }
  mount(instance) {
    this.current = instance;
    visualElementStore.set(instance, this);
    if (this.projection && !this.projection.instance) {
      this.projection.mount(instance);
    }
    if (this.parent && this.isVariantNode && !this.isControllingVariants) {
      this.removeFromVariantTree = this.parent.addVariantChild(this);
    }
    this.values.forEach((value, key) => this.bindToMotionValue(key, value));
    if (!hasReducedMotionListener.current) {
      initPrefersReducedMotion();
    }
    this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : prefersReducedMotion.current;
    if (process.env.NODE_ENV !== "production") {
      warnOnce(this.shouldReduceMotion !== true, "You have Reduced Motion enabled on your device. Animations may not appear as expected.");
    }
    if (this.parent) this.parent.children.add(this);
    this.update(this.props, this.presenceContext);
  }
  unmount() {
    visualElementStore.delete(this.current);
    this.projection && this.projection.unmount();
    cancelFrame(this.notifyUpdate);
    cancelFrame(this.render);
    this.valueSubscriptions.forEach(remove => remove());
    this.valueSubscriptions.clear();
    this.removeFromVariantTree && this.removeFromVariantTree();
    this.parent && this.parent.children.delete(this);
    for (const key in this.events) {
      this.events[key].clear();
    }
    for (const key in this.features) {
      const feature = this.features[key];
      if (feature) {
        feature.unmount();
        feature.isMounted = false;
      }
    }
    this.current = null;
  }
  bindToMotionValue(key, value) {
    if (this.valueSubscriptions.has(key)) {
      this.valueSubscriptions.get(key)();
    }
    const valueIsTransform = transformProps.has(key);
    const removeOnChange = value.on("change", latestValue => {
      this.latestValues[key] = latestValue;
      this.props.onUpdate && frame.preRender(this.notifyUpdate);
      if (valueIsTransform && this.projection) {
        this.projection.isTransformDirty = true;
      }
    });
    const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
    let removeSyncCheck;
    if (window.MotionCheckAppearSync) {
      removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
    }
    this.valueSubscriptions.set(key, () => {
      removeOnChange();
      removeOnRenderRequest();
      if (removeSyncCheck) removeSyncCheck();
      if (value.owner) value.stop();
    });
  }
  sortNodePosition(other) {
    /**
     * If these nodes aren't even of the same type we can't compare their depth.
     */
    if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) {
      return 0;
    }
    return this.sortInstanceNodePosition(this.current, other.current);
  }
  updateFeatures() {
    let key = "animation";
    for (key in featureDefinitions) {
      const featureDefinition = featureDefinitions[key];
      if (!featureDefinition) continue;
      const {
        isEnabled,
        Feature: FeatureConstructor
      } = featureDefinition;
      /**
       * If this feature is enabled but not active, make a new instance.
       */
      if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) {
        this.features[key] = new FeatureConstructor(this);
      }
      /**
       * If we have a feature, mount or update it.
       */
      if (this.features[key]) {
        const feature = this.features[key];
        if (feature.isMounted) {
          feature.update();
        } else {
          feature.mount();
          feature.isMounted = true;
        }
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : createBox();
  }
  getStaticValue(key) {
    return this.latestValues[key];
  }
  setStaticValue(key, value) {
    this.latestValues[key] = value;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(props, presenceContext) {
    if (props.transformTemplate || this.props.transformTemplate) {
      this.scheduleRender();
    }
    this.prevProps = this.props;
    this.props = props;
    this.prevPresenceContext = this.presenceContext;
    this.presenceContext = presenceContext;
    /**
     * Update prop event handlers ie onAnimationStart, onAnimationComplete
     */
    for (let i = 0; i < propEventHandlers.length; i++) {
      const key = propEventHandlers[i];
      if (this.propEventSubscriptions[key]) {
        this.propEventSubscriptions[key]();
        delete this.propEventSubscriptions[key];
      }
      const listenerName = "on" + key;
      const listener = props[listenerName];
      if (listener) {
        this.propEventSubscriptions[key] = this.on(key, listener);
      }
    }
    this.prevMotionValues = updateMotionValuesFromProps(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
    if (this.handleChildMotionValue) {
      this.handleChildMotionValue();
    }
    this.onUpdate && this.onUpdate(this);
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(name) {
    return this.props.variants ? this.props.variants[name] : undefined;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(child) {
    const closestVariantNode = this.getClosestVariantNode();
    if (closestVariantNode) {
      closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
      return () => closestVariantNode.variantChildren.delete(child);
    }
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(key, value) {
    // Remove existing value if it exists
    const existingValue = this.values.get(key);
    if (value !== existingValue) {
      if (existingValue) this.removeValue(key);
      this.bindToMotionValue(key, value);
      this.values.set(key, value);
      this.latestValues[key] = value.get();
    }
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(key) {
    this.values.delete(key);
    const unsubscribe = this.valueSubscriptions.get(key);
    if (unsubscribe) {
      unsubscribe();
      this.valueSubscriptions.delete(key);
    }
    delete this.latestValues[key];
    this.removeValueFromRenderState(key, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(key) {
    return this.values.has(key);
  }
  getValue(key, defaultValue) {
    if (this.props.values && this.props.values[key]) {
      return this.props.values[key];
    }
    let value = this.values.get(key);
    if (value === undefined && defaultValue !== undefined) {
      value = motionValue(defaultValue === null ? undefined : defaultValue, {
        owner: this
      });
      this.addValue(key, value);
    }
    return value;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(key, target) {
    var _a;
    let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
    if (value !== undefined && value !== null) {
      if (typeof value === "string" && (isNumericalString(value) || isZeroValueString(value))) {
        // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
      } else if (!findValueType(value) && complex.test(target)) {
        value = getAnimatableNone(key, target);
      }
      this.setBaseTarget(key, isMotionValue(value) ? value.get() : value);
    }
    return isMotionValue(value) ? value.get() : value;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(key, value) {
    this.baseTarget[key] = value;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(key) {
    var _a;
    const {
      initial
    } = this.props;
    let valueFromInitial;
    if (typeof initial === "string" || typeof initial === "object") {
      const variant = resolveVariantFromProps(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
      if (variant) {
        valueFromInitial = variant[key];
      }
    }
    /**
     * If this value still exists in the current initial variant, read that.
     */
    if (initial && valueFromInitial !== undefined) {
      return valueFromInitial;
    }
    /**
     * Alternatively, if this VisualElement config has defined a getBaseTarget
     * so we can read the value from an alternative source, try that.
     */
    const target = this.getBaseTargetFromProps(this.props, key);
    if (target !== undefined && !isMotionValue(target)) return target;
    /**
     * If the value was initially defined on initial, but it doesn't any more,
     * return undefined. Otherwise return the value as initially read from the DOM.
     */
    return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
  }
  on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = new SubscriptionManager();
    }
    return this.events[eventName].add(callback);
  }
  notify(eventName) {
    if (this.events[eventName]) {
      for (var _len12 = arguments.length, args = new Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
        args[_key12 - 1] = arguments[_key12];
      }
      this.events[eventName].notify(...args);
    }
  }
}
class DOMVisualElement extends VisualElement {
  constructor() {
    super(...arguments);
    this.KeyframeResolver = DOMKeyframesResolver;
  }
  sortInstanceNodePosition(a, b) {
    /**
     * compareDocumentPosition returns a bitmask, by using the bitwise &
     * we're returning true if 2 in that bitmask is set to true. 2 is set
     * to true if b preceeds a.
     */
    return a.compareDocumentPosition(b) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(props, key) {
    return props.style ? props.style[key] : undefined;
  }
  removeValueFromRenderState(key, _ref289) {
    let {
      vars,
      style
    } = _ref289;
    delete vars[key];
    delete style[key];
  }
  handleChildMotionValue() {
    if (this.childSubscription) {
      this.childSubscription();
      delete this.childSubscription;
    }
    const {
      children
    } = this.props;
    if (isMotionValue(children)) {
      this.childSubscription = children.on("change", latest => {
        if (this.current) {
          this.current.textContent = "".concat(latest);
        }
      });
    }
  }
}
function getComputedStyle$1(element) {
  return window.getComputedStyle(element);
}
class HTMLVisualElement extends DOMVisualElement {
  constructor() {
    super(...arguments);
    this.type = "html";
    this.renderInstance = renderHTML;
  }
  readValueFromInstance(instance, key) {
    if (transformProps.has(key)) {
      const defaultType = getDefaultValueType(key);
      return defaultType ? defaultType.default || 0 : 0;
    } else {
      const computedStyle = getComputedStyle$1(instance);
      const value = (isCSSVariableName(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
      return typeof value === "string" ? value.trim() : value;
    }
  }
  measureInstanceViewportBox(instance, _ref290) {
    let {
      transformPagePoint
    } = _ref290;
    return measureViewportBox(instance, transformPagePoint);
  }
  build(renderState, latestValues, props) {
    buildHTMLStyles(renderState, latestValues, props.transformTemplate);
  }
  scrapeMotionValuesFromProps(props, prevProps, visualElement) {
    return scrapeMotionValuesFromProps$1(props, prevProps, visualElement);
  }
}
class SVGVisualElement extends DOMVisualElement {
  constructor() {
    super(...arguments);
    this.type = "svg";
    this.isSVGTag = false;
    this.measureInstanceViewportBox = createBox;
  }
  getBaseTargetFromProps(props, key) {
    return props[key];
  }
  readValueFromInstance(instance, key) {
    if (transformProps.has(key)) {
      const defaultType = getDefaultValueType(key);
      return defaultType ? defaultType.default || 0 : 0;
    }
    key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
    return instance.getAttribute(key);
  }
  scrapeMotionValuesFromProps(props, prevProps, visualElement) {
    return scrapeMotionValuesFromProps(props, prevProps, visualElement);
  }
  build(renderState, latestValues, props) {
    buildSVGAttrs(renderState, latestValues, this.isSVGTag, props.transformTemplate);
  }
  renderInstance(instance, renderState, styleProp, projection) {
    renderSVG(instance, renderState, styleProp, projection);
  }
  mount(instance) {
    this.isSVGTag = isSVGTag(instance.tagName);
    super.mount(instance);
  }
}
const createDomVisualElement = (Component, options) => {
  return isSVGComponent(Component) ? new SVGVisualElement(options) : new HTMLVisualElement(options, {
    allowProjection: Component !== Fragment$1
  });
};
const createMotionComponent = /*@__PURE__*/createMotionComponentFactory({
  ...animations,
  ...gestureAnimations,
  ...drag,
  ...layout
}, createDomVisualElement);
const motion = /*@__PURE__*/createDOMMotionComponentProxy(createMotionComponent);
const WizardContext = /*#__PURE__*/createContext(null);
if (process.env.NODE_ENV !== "production") {
  WizardContext.displayName = 'WizardContext';
}
const useWizard = () => {
  const context = useContext(WizardContext);
  if (!context && process.env.NODE_ENV !== "production") {
    throw Error('Wrap your step with `Wizard`');
  } else {
    return context;
  }
};

/**
 * Log messages in the console with a corresponding urgency
 *
 * @param level The urgency of the message
 * @param message The message to log in the console
 */
const log$1 = (level, message) => {
  if (process.env.NODE_ENV !== "production") {
    const packageName = '[react-use-wizard]';
    switch (level) {
      case 'warn':
        console.warn(packageName + " " + message);
        break;
      case 'error':
        console.error(packageName + " " + message);
        break;
      default:
        console.log(packageName + " " + message);
    }
  }
};
const Wizard = /*#__PURE__*/memo$1(_ref291 => {
  let {
    header,
    footer,
    children,
    onStepChange,
    wrapper: Wrapper,
    startIndex = 0
  } = _ref291;
  const [activeStep, setActiveStep] = useState(startIndex);
  const [isLoading, setIsLoading] = useState(false);
  const hasNextStep = useRef(true);
  const hasPreviousStep = useRef(false);
  const nextStepHandler = useRef(() => {});
  const stepCount = Children.toArray(children).length;
  hasNextStep.current = activeStep < stepCount - 1;
  hasPreviousStep.current = activeStep > 0;
  const goToNextStep = useCallback(() => {
    if (hasNextStep.current) {
      const newActiveStepIndex = activeStep + 1;
      setActiveStep(newActiveStepIndex);
      onStepChange == null ? void 0 : onStepChange(newActiveStepIndex);
    }
  }, [activeStep, onStepChange]);
  const goToPreviousStep = useCallback(() => {
    if (hasPreviousStep.current) {
      nextStepHandler.current = null;
      const newActiveStepIndex = activeStep - 1;
      setActiveStep(newActiveStepIndex);
      onStepChange == null ? void 0 : onStepChange(newActiveStepIndex);
    }
  }, [activeStep, onStepChange]);
  const goToStep = useCallback(stepIndex => {
    if (stepIndex >= 0 && stepIndex < stepCount) {
      nextStepHandler.current = null;
      setActiveStep(stepIndex);
      onStepChange == null ? void 0 : onStepChange(stepIndex);
    } else {
      if (process.env.NODE_ENV !== "production") {
        log$1('warn', ["Invalid step index [" + stepIndex + "] passed to 'goToStep'. ", "Ensure the given stepIndex is not out of boundaries."].join(''));
      }
    }
  }, [stepCount, onStepChange]); // Callback to attach the step handler

  const handleStep = useRef(handler => {
    nextStepHandler.current = handler;
  });
  const doNextStep = useCallback(async () => {
    if (hasNextStep.current && nextStepHandler.current) {
      try {
        setIsLoading(true);
        await nextStepHandler.current();
        setIsLoading(false);
        nextStepHandler.current = null;
        goToNextStep();
      } catch (error) {
        setIsLoading(false);
        throw error;
      }
    } else {
      goToNextStep();
    }
  }, [goToNextStep]);
  const wizardValue = useMemo(() => ({
    nextStep: doNextStep,
    previousStep: goToPreviousStep,
    handleStep: handleStep.current,
    isLoading,
    activeStep,
    stepCount,
    isFirstStep: !hasPreviousStep.current,
    isLastStep: !hasNextStep.current,
    goToStep
  }), [doNextStep, goToPreviousStep, isLoading, activeStep, stepCount, goToStep]);
  const activeStepContent = useMemo(() => {
    const reactChildren = Children.toArray(children);
    if (process.env.NODE_ENV !== "production") {
      // No steps passed
      if (reactChildren.length === 0) {
        log$1('warn', 'Make sure to pass your steps as children in your <Wizard>');
      } // The passed start index is invalid

      if (activeStep > reactChildren.length) {
        log$1('warn', 'An invalid startIndex is passed to <Wizard>');
      } // Invalid header element

      if (header && !isValidElement(header)) {
        log$1('error', 'Invalid header passed to <Wizard>');
      } // Invalid footer element

      if (footer && !isValidElement(footer)) {
        log$1('error', 'Invalid footer passed to <Wizard>');
      }
    }
    return reactChildren[activeStep];
  }, [activeStep, children, header, footer]);
  const enhancedActiveStepContent = useMemo(() => Wrapper ? cloneElement(Wrapper, {
    children: activeStepContent
  }) : activeStepContent, [Wrapper, activeStepContent]);
  return createElement$2(WizardContext.Provider, {
    value: wizardValue
  }, header, enhancedActiveStepContent, footer);
});
const LogoHeader = () => {
  return jsx("div", {
    style: {
      zIndex: 2,
      paddingBottom: 50,
      transition: 'all 100ms ease'
    },
    children: jsx(Logo$1, {
      logoSize: 18,
      variant: "horizontal-large",
      logoColor: "on-surface-variant",
      fontColor: "on-surface"
    })
  });
};
var TeamSizes;
(function (TeamSizes) {
  TeamSizes["SIZE_0_50"] = "SIZE_0_50";
  TeamSizes["SIZE_50_250"] = "SIZE_50_250";
  TeamSizes["SIZE_250_1000"] = "SIZE_250_1000";
  TeamSizes["SIZE_1000_PLUS"] = "SIZE_1000_PLUS";
})(TeamSizes || (TeamSizes = {}));
var Departments;
(function (Departments) {
  Departments["OTHER"] = "Other";
  Departments["IT_CONSULTANCY"] = "IT Consultancy";
  Departments["IT_DEPARTMENT"] = "IT Department";
  Departments["OPERATIONS"] = "Operations";
  Departments["DESIGN_AND_CREATIVES"] = "Design & Creatives";
})(Departments || (Departments = {}));
var Steps;
(function (Steps) {
  Steps[Steps["WELCOME"] = 0] = "WELCOME";
  Steps[Steps["TEAM_SIZE"] = 1] = "TEAM_SIZE";
  Steps[Steps["TEAM_TYPE"] = 2] = "TEAM_TYPE";
  Steps[Steps["CF_RESOURCES"] = 3] = "CF_RESOURCES";
  Steps[Steps["CF_PROJECTS"] = 4] = "CF_PROJECTS";
  Steps[Steps["DEMO_RESOURCES"] = 5] = "DEMO_RESOURCES";
})(Steps || (Steps = {}));
const useTemplateFields = (template, type) => {
  const [allFields, setAllFields] = useState([]);
  const [defaultProjectCustomFields, setDefaultProjectCustomFields] = useState([]);
  const [defaultResourceCustomFields, setDefaultResourceCustomFields] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const loadFields = () => __awaiter(void 0, void 0, void 0, function* () {
      try {
        setIsLoading(true);
        const [projectFields, resourceFields] = yield Promise.all([import('./projects.esm.js'), import('./resources.esm.js')]);
        const projectsWithSource = projectFields.default.map(field => Object.assign({}, field));
        const resourcesWithSource = resourceFields.default.map(field => Object.assign({}, field));
        setAllFields([...projectsWithSource, ...resourcesWithSource]);
        setDefaultProjectCustomFields(projectsWithSource);
        setDefaultResourceCustomFields(resourcesWithSource);
      } catch (err) {
        console.error('Error loading custom fields:', err);
        setAllFields([]);
      } finally {
        setIsLoading(false);
      }
    });
    loadFields();
  }, []);
  const fields = useMemo(() => {
    if (!template || allFields.length === 0) return [];
    return allFields.filter(field => field.category === (type === 'resource' ? Category.RESOURCE : Category.PROJECT)).sort((a, b) => a.order - b.order);
    // only run on template and type checks
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [template, type]);
  return {
    allFields,
    defaultProjectCustomFields,
    defaultResourceCustomFields,
    fields,
    isLoading
  };
};
const initialState = {
  project: {
    fields: [],
    selectedKeys: new Set()
  },
  resource: {
    fields: [],
    selectedKeys: new Set()
  }
};
const sortSelectedKeys = (fields, keys) => fields.sort((a, b) => {
  const aSelected = keys.includes(getFieldKey(a, true));
  const bSelected = keys.includes(getFieldKey(b, true));
  const aDeleted = a.deleted === true;
  const bDeleted = b.deleted === true;
  if (aDeleted !== bDeleted) {
    return aDeleted ? 1 : -1;
  }
  if (aSelected !== bSelected) {
    return aSelected ? -1 : 1;
  }
  return a.order - b.order;
}).map((field, index) => Object.assign(Object.assign({}, field), {
  order: index
}));
function onboardingCustomFieldsReducer(state, action) {
  switch (action.type) {
    case 'INITIALIZE_FIELDS':
      {
        const {
          category,
          fields
        } = action;
        const fieldKeys = new Set(fields.map(field => getFieldKey(field, true)));
        const sortedFields = [...fields].sort((a, b) => a.order - b.order);
        return Object.assign(Object.assign({}, state), {
          [category]: {
            fields: sortedFields,
            selectedKeys: fieldKeys
          }
        });
      }
    case 'UPDATE_SAVED_FIELDS':
      {
        const {
          category,
          savedFields
        } = action.payload;
        return Object.assign(Object.assign({}, state), {
          [category]: Object.assign(Object.assign({}, state[category]), {
            fields: savedFields
          })
        });
      }
    case 'SET_CUSTOM_FIELDS':
      {
        const {
          category,
          fields
        } = action;
        const currentSelectedKeys = state[category].selectedKeys;
        const updatedFields = fields.map(field => Object.assign(Object.assign({}, field), {
          deleted: !currentSelectedKeys.has(getFieldKey(field, true))
        }));
        return Object.assign(Object.assign({}, state), {
          [category]: {
            fields: updatedFields,
            selectedKeys: currentSelectedKeys
          }
        });
      }
    case 'UPDATE_FIELD_SET':
      {
        const {
          category,
          fields
        } = action;
        return Object.assign(Object.assign({}, state), {
          [category]: {
            fields,
            selectedKeys: state[category].selectedKeys
          }
        });
      }
    case 'TOGGLE_FIELD':
      {
        const {
          category,
          field
        } = action;
        const fieldKey = getFieldKey(field, true);
        const currentState = state[category];
        const isNewField = !currentState.fields.some(f => getFieldKey(f, true) === fieldKey);
        if (isNewField) {
          return Object.assign(Object.assign({}, state), {
            [category]: {
              fields: [Object.assign(Object.assign({}, field), {
                deleted: false
              }), ...currentState.fields],
              selectedKeys: new Set([...currentState.selectedKeys, fieldKey])
            }
          });
        }
        const wasSelected = currentState.selectedKeys.has(fieldKey);
        const newSelectedKeys = new Set(currentState.selectedKeys);
        wasSelected ? newSelectedKeys.delete(fieldKey) : newSelectedKeys.add(fieldKey);
        return Object.assign(Object.assign({}, state), {
          [category]: {
            fields: currentState.fields.map(existingField => getFieldKey(existingField) === fieldKey ? Object.assign(Object.assign({}, existingField), {
              deleted: wasSelected
            }) : existingField),
            selectedKeys: newSelectedKeys
          }
        });
      }
    case 'UPDATE_DEPARTMENT_FIELDS':
      {
        const {
          department
        } = action;
        const updateCategoryFields = categoryFields => {
          const selectedKeys = new Set(categoryFields.filter(field => !field.templates || field.templates.includes(department)).map(field => getFieldKey(field, true)));
          const updatedFields = categoryFields.map(field => Object.assign(Object.assign({}, field), {
            deleted: !selectedKeys.has(getFieldKey(field, true))
          }));
          return {
            fields: sortSelectedKeys(updatedFields, Array.from(selectedKeys)),
            selectedKeys
          };
        };
        return {
          project: updateCategoryFields(state.project.fields),
          resource: updateCategoryFields(state.resource.fields)
        };
      }
    case 'RESET_FIELDS':
      return initialState;
    default:
      return state;
  }
}
const OnboardingCustomFieldsContext = /*#__PURE__*/createContext(undefined);
const OnboardingCustomFieldsProvider = _ref292 => {
  let {
    children
  } = _ref292;
  const [state, dispatch] = useReducer(onboardingCustomFieldsReducer, initialState);
  const updateFieldSet = useCallback((category, fields) => {
    dispatch({
      type: 'UPDATE_FIELD_SET',
      category,
      fields
    });
  }, []);
  const initializeFields = useCallback((category, fields) => {
    dispatch({
      type: 'INITIALIZE_FIELDS',
      category,
      fields
    });
  }, []);
  const toggleField = useCallback((field, category) => {
    dispatch({
      type: 'TOGGLE_FIELD',
      category,
      field
    });
  }, []);
  const updateDepartmentFields = useCallback((department, allFields) => {
    dispatch({
      type: 'UPDATE_DEPARTMENT_FIELDS',
      department,
      allFields
    });
  }, []);
  const updateSavedFields = useCallback((category, savedFields) => {
    dispatch({
      type: 'UPDATE_SAVED_FIELDS',
      payload: {
        category,
        savedFields
      }
    });
  }, []);
  const resetFields = useCallback(() => {
    dispatch({
      type: 'RESET_FIELDS'
    });
  }, []);
  const setOnboardingCustomFields = useCallback((fields, category) => {
    const sortedFields = [...fields].sort((a, b) => a.order - b.order);
    dispatch({
      type: 'SET_CUSTOM_FIELDS',
      category,
      fields: sortedFields
    });
  }, []);
  const getSelectedFields = useCallback(category => {
    return state[category].fields.filter(field => state[category].selectedKeys.has(getFieldKey(field, true)));
  }, [state]);
  const value = Object.assign(Object.assign({}, state), {
    initializeFields,
    toggleField,
    updateDepartmentFields,
    resetFields,
    getSelectedFields,
    setOnboardingCustomFields,
    updateFieldSet,
    updateSavedFields
  });
  return jsx(OnboardingCustomFieldsContext.Provider, {
    value: value,
    children: children
  });
};
const useOnboardingCustomFields = () => {
  const context = useContext(OnboardingCustomFieldsContext);
  if (!context) {
    throw new Error('useOnboardingCustomFields must be used within an OnboardingCustomFieldsProvider');
  }
  return context;
};
const OnboardingContext = /*#__PURE__*/createContext(undefined);
const OnboardingProvider = _ref293 => {
  let {
    children,
    submitOnboarding,
    defaultCountry,
    domain,
    saveCustomFields,
    validateDomain,
    deleteCustomFields,
    onStepCallback
  } = _ref293;
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [domainName, setDomainName] = useState(domain !== null && domain !== void 0 ? domain : '');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [selectedTeamSize, setSelectedTeamSize] = useState();
  const [selectedDepartment, setSelectedDepartment] = useState();
  const [otherDepartment, setOtherDepartment] = useState();
  const [demoResources, setDemoResources] = useState(50);
  const [demoProjects, setDemoProjects] = useState(10);
  const [demoResourcesEnabled, setDemoResourcesEnabled] = useState(true);
  const [demoProjectsEnabled, setDemoProjectsEnabled] = useState(true);
  const [countries, setCountries] = useState([]);
  const [countriesEnabled, setCountriesEnabled] = useState(true);
  const [selectedCountry, setSelectedCountry] = useState(DEFAULT_COUNTRY);
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [featureUpdatesEnabled, setFeatureUpdatesEnabled] = useState(true);
  const [skippedFromStep, setSkippedFromStep] = useState(null);
  const {
    allFields,
    defaultProjectCustomFields,
    defaultResourceCustomFields
  } = useTemplateFields(selectedDepartment !== null && selectedDepartment !== void 0 ? selectedDepartment : '', step === Steps.CF_RESOURCES ? 'resource' : 'project');
  const completedWelcomeScreen = useMemo(() => {
    return Boolean(domainName);
  }, [domainName]);
  const {
    project: {
      fields: projectCustomFields,
      selectedKeys: projectKeys
    },
    resource: {
      fields: resourceCustomFields,
      selectedKeys: resourceKeys
    },
    initializeFields,
    toggleField,
    updateDepartmentFields,
    updateFieldSet,
    updateSavedFields
  } = useOnboardingCustomFields();
  const previousDepartment = React__default.useRef(selectedDepartment);
  useEffect(() => {
    if (!selectedDepartment || !allFields.length) return;
    if (previousDepartment.current !== selectedDepartment) {
      updateDepartmentFields(selectedDepartment, allFields);
      previousDepartment.current = selectedDepartment;
    }
  }, [selectedDepartment, allFields, updateDepartmentFields]);
  useEffect(() => {
    if (defaultProjectCustomFields.length > 0) {
      initializeFields('project', defaultProjectCustomFields);
    }
    if (defaultResourceCustomFields.length > 0) {
      initializeFields('resource', defaultResourceCustomFields);
    }
  }, [defaultProjectCustomFields, defaultResourceCustomFields, initializeFields]);
  const handleToggleCustomField = useCallback((field, type) => {
    toggleField(field, type);
  }, [toggleField]);
  const saveCFs = useCallback(type => customFields => __awaiter(void 0, void 0, void 0, function* () {
    try {
      const selectedKeys = type === 'project' ? projectKeys : resourceKeys;
      const orderedFields = customFields.filter(field => selectedKeys.has(getFieldKey(field, true))).map((field, index) => Object.assign(Object.assign({}, field), {
        order: index,
        _id: undefined
      }));
      yield deleteCustomFields(type);
      const savedFields = yield saveCustomFields(type)(orderedFields);
      if (savedFields) {
        const updatedFields = [...customFields];
        savedFields.forEach(savedField => {
          const existingIndex = updatedFields.findIndex(field => field.type === savedField.type && field.category === savedField.category && field.label === savedField.label);
          if (existingIndex !== -1) {
            updatedFields[existingIndex] = Object.assign(Object.assign(Object.assign({}, updatedFields[existingIndex]), savedField), {
              templates: updatedFields[existingIndex].templates
            });
          }
        });
        updateSavedFields(type, updatedFields);
      }
    } catch (error) {
      console.error("Failed to save ".concat(type, " fields:"), error);
    }
  }), [projectKeys, resourceKeys, saveCustomFields, updateSavedFields, deleteCustomFields]);
  const getAllFieldsHelper = useCallback(type => {
    return type === 'resource' ? resourceCustomFields : projectCustomFields;
  }, [resourceCustomFields, projectCustomFields]);
  const getSelectedKeysHelper = useCallback(type => {
    return Array.from(type === 'resource' ? resourceKeys : projectKeys);
  }, [resourceKeys, projectKeys]);
  const updateFields = useCallback((customFields, setFields) => {
    setFields(customFields);
  }, []);
  const onStepUpdate = () => __awaiter(void 0, void 0, void 0, function* () {
    const submitData = {
      teamSize: selectedTeamSize,
      kindOfWork: otherDepartment || selectedDepartment ? [otherDepartment || selectedDepartment] : [],
      newFeatureEmailAgreed: featureUpdatesEnabled,
      resourcesAmount: demoResourcesEnabled ? demoResources : undefined,
      projectsAmount: demoProjectsEnabled ? demoProjects : undefined,
      countries: countriesEnabled ? countries : undefined,
      skippedFromStep: skippedFromStep !== null ? skippedFromStep : undefined
    };
    return yield onStepCallback(submitData);
  });
  const submit = skipping => __awaiter(void 0, void 0, void 0, function* () {
    setLoading(true);
    try {
      const submitData = {
        firstName: firstName || 'First Name',
        lastName: lastName || 'Last Name',
        companyName: companyName || 'My Company',
        phoneNumber,
        subDomain: domainName,
        teamSize: selectedTeamSize,
        kindOfWork: otherDepartment || selectedDepartment ? [otherDepartment || selectedDepartment] : [],
        newFeatureEmailAgreed: featureUpdatesEnabled,
        resourcesAmount: skipping ? undefined : demoResourcesEnabled ? demoResources : undefined,
        projectsAmount: skipping ? undefined : demoProjectsEnabled ? demoProjects : undefined,
        countries: skipping ? undefined : countriesEnabled ? countries : undefined,
        skippedFromStep: skippedFromStep !== null ? skippedFromStep : undefined
      };
      return yield submitOnboarding(submitData);
    } finally {
      setLoading(false);
    }
  });
  const value = {
    firstName,
    setFirstName,
    completedWelcomeScreen,
    lastName,
    setLastName,
    companyName,
    setCompanyName,
    domainName,
    setDomainName,
    phoneNumber,
    setPhoneNumber,
    selectedTeamSize,
    setSelectedTeamSize,
    selectedDepartment,
    setSelectedDepartment,
    otherDepartment,
    setOtherDepartment,
    projectCustomFields,
    resourceCustomFields,
    selectedResourceFieldKeys: Array.from(resourceKeys),
    selectedProjectFieldKeys: Array.from(projectKeys),
    setProjectCustomFields: fields => updateFieldSet('project', fields),
    setResourceCustomFields: fields => updateFieldSet('resource', fields),
    setSelectedProjectFieldKeys: fields => {
      const newFields = projectCustomFields.map(field => Object.assign(Object.assign({}, field), {
        deleted: !fields.includes(getFieldKey(field))
      }));
      updateFieldSet('project', newFields);
    },
    setSelectedResourceFieldKeys: fields => {
      const newFields = resourceCustomFields.map(field => Object.assign(Object.assign({}, field), {
        deleted: !fields.includes(getFieldKey(field))
      }));
      updateFieldSet('resource', newFields);
    },
    toggleCustomField: handleToggleCustomField,
    demoProjects,
    setDemoProjects,
    demoResources,
    setDemoResources,
    demoResourcesEnabled,
    setDemoResourcesEnabled,
    demoProjectsEnabled,
    setDemoProjectsEnabled,
    countries,
    setCountries,
    countriesEnabled,
    setCountriesEnabled,
    defaultCountry,
    selectedCountry,
    setSelectedCountry,
    step,
    setStep,
    loading,
    setLoading,
    featureUpdatesEnabled,
    setFeatureUpdatesEnabled,
    submitOnboarding: submit,
    saveProjectFields: saveCFs('project'),
    saveResourceFields: saveCFs('resource'),
    validateDomain,
    getAllFields: getAllFieldsHelper,
    getSelectedFields: getSelectedKeysHelper,
    updateFields,
    setSkippedFromStep,
    onStepCallback: onStepUpdate
  };
  return jsx(OnboardingContext.Provider, {
    value: value,
    children: children
  });
};
const useOnboarding = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboarding must be used within an OnboardingProvider');
  }
  return context;
};
const StepBG = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "styled__StepBG",
  componentId: "sc-1beq6zj-0"
})(["height:100%;flex:1;z-index:2;overflow:auto;"]);
const WelcomeText = /*#__PURE__*/styled(Typography).withConfig({
  displayName: "styled__WelcomeText",
  componentId: "sc-1beq6zj-1"
})(["line-height:57px !important;"]);
const BGOverlay = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__BGOverlay",
  componentId: "sc-1beq6zj-2"
})(["border-top-right-radius:calc(620 * 100vh / 950);border-bottom-right-radius:calc(620 * 100vh / 950);mix-blend-mode:overlay;background-color:#1c201d;position:fixed;width:calc(100vw * 1.2);height:100vh;aspect-ratio:1440/900;z-index:0;animation:slideIn 500ms ease-out forwards;top:0;@keyframes slideIn{from{opacity:0;left:-60%;}to{opacity:1;left:30%;transform:translateX(-50%);}}"]);
const Container$2 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "styled__Container",
  componentId: "sc-1beq6zj-3"
})(["height:100vh;width:100%;margin:0 auto;background-color:", ";z-index:1;overflow:hidden;position:relative;"], _ref294 => {
  let {
    theme
  } = _ref294;
  return theme.designTokens.color.color.surfaces['surface-container-high'].value;
});
const StepContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__StepContainer",
  componentId: "sc-1beq6zj-5"
})(["display:flex;align-items:center;justify-content:center;gap:8px;margin:16px 0;background:rgba(249,250,252,0.4);backdrop-filter:blur(25px);padding:8px 12px;border-radius:100px;"]);
const Step = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__Step",
  componentId: "sc-1beq6zj-6"
})(["height:8px;border-radius:9999px;transition:all 0.3s ease;width:8px;background-color:", ";", ""], _ref295 => {
  let {
    theme
  } = _ref295;
  return theme.designTokens.color['on color'].surface['on-surface-variant'].value;
}, _ref296 => {
  let {
    $isActive
  } = _ref296;
  if ($isActive) {
    return css(["opacity:1;"]);
  } else {
    return css(["opacity:0.3;"]);
  }
});
const StyledContainer = {
  FieldTemplates: styled(Layout).withConfig({
    displayName: "custom-fields-step__FieldTemplates",
    componentId: "sc-156s5jk-0"
  })(["background-color:white;border-radius:8px;"]),
  Fields: styled(Layout).withConfig({
    displayName: "custom-fields-step__Fields",
    componentId: "sc-156s5jk-1"
  })(["border:2px solid ", ";border-radius:16px;padding:16px 24px;height:100%;min-height:0;overflow-y:auto;"], _ref297 => {
    let {
      theme
    } = _ref297;
    return theme.designTokens.color.color.light['outline-variant'].value;
  }),
  FieldsItem: styled(Layout).withConfig({
    displayName: "custom-fields-step__FieldsItem",
    componentId: "sc-156s5jk-2"
  })(["min-height:0;"])
};
const TEMPLATE_TITLES = {
  project: 'Drag a field type to add it to your desired grouping.',
  resource: 'Drag a field to add your own field to the list.'
};
const STEP_CONTENT = {
  project: {
    title: 'How do you define your projects?',
    description: 'These fields support your project management, from pipeline stage to project completion. Include details that are important for your project workflow.'
  },
  resource: {
    title: 'What skills & roles make up your team?',
    description: 'Adding details such as location, skills and role, makes it quick to identify the right people to get the job done.'
  }
};
const CHECKBOX_STYLE = {
  width: 36,
  height: 40,
  paddingTop: 5,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};
const CheckboxWrapper = _ref298 => {
  let {
    children,
    item,
    index,
    category,
    onDragStart,
    onDragOver,
    onDrop,
    handleDragEnd
  } = _ref298;
  const {
    toggleField,
    project,
    resource
  } = useOnboardingCustomFields();
  const fieldKey = useMemo(() => getFieldKey(item, true), [item]);
  const isChecked = useMemo(() => {
    const selectedKeys = category === 'project' ? project.selectedKeys : resource.selectedKeys;
    return selectedKeys.has(getFieldKey(item, true));
  }, [category, project.selectedKeys, resource.selectedKeys, item]);
  const handleChange = useCallback(() => {
    toggleField(item, category);
  }, [toggleField, item, category]);
  const handleClick = useCallback(event => {
    event.stopPropagation();
  }, []);
  return jsx("div", {
    onDragStart: e => onDragStart(e, item),
    onDragOver: e => {
      onDragOver(e);
    },
    onDrop: e => onDrop(e, index),
    onDragEnd: e => {
      handleDragEnd(e);
    },
    children: jsxs(Layout, {
      children: [jsx("div", {
        style: CHECKBOX_STYLE,
        children: jsx(StyledCheckbox, {
          checked: isChecked,
          onChange: handleChange,
          onClick: handleClick,
          color: "primary"
        })
      }), children]
    }, fieldKey)
  });
};
const CustomFieldsComponent = _ref299 => {
  let {
    category
  } = _ref299;
  const {
    state,
    setFields,
    deleteField,
    dragContainerRef,
    searchTerm,
    setSearchTerm,
    filteredFields,
    setOpenItem,
    validateFields
  } = useCustomFields();
  const {
    handleDragStart,
    handleDragOver,
    handleDrop,
    handleMoveField,
    handleDragEnd,
    dragState,
    handleClick
  } = useCustomFieldsDragDrop(state.customFields, setFields, setOpenItem, category);
  const {
    toggleCustomField
  } = useOnboarding();
  const validateFieldsRef = useRef(validateFields);
  useEffect(() => {
    validateFieldsRef.current = validateFields;
  }, [validateFields]);
  useEffect(() => {
    validateFieldsRef.current();
  }, []);
  useEffect(() => {
    const handleDragLeave = e => {
      const target = e.target;
      const relatedTarget = e.relatedTarget;
      if (relatedTarget && (target === null || target === void 0 ? void 0 : target.contains(relatedTarget))) {
        return;
      }
      if (target && (relatedTarget === null || relatedTarget === void 0 ? void 0 : relatedTarget.contains(target))) {
        return;
      }
      handleDragEnd();
    };
    window.addEventListener('dragleave', handleDragLeave);
    return () => window.removeEventListener('dragleave', handleDragLeave);
  }, [handleDragEnd]);
  return jsx("div", {
    style: {
      height: 'calc(100% - 95px)'
    },
    children: jsxs(StyledContainer.Fields, {
      gap: 20,
      children: [jsxs(StyledContainer.FieldsItem, {
        stack: true,
        flex: "1",
        gap: "--Spacing-200",
        children: [jsxs(Layout, {
          gap: "--Spacing-100",
          pr: "--Spacing-200",
          children: [jsxs(Layout, {
            gap: "--Spacing-50",
            vAlign: "center",
            flex: "1",
            children: [jsx(Icon, {
              name: category === 'project' ? 'folder' : 'people'
            }), jsx(Typography, {
              variant: "label",
              size: "xl",
              noWrap: true,
              children: category === 'project' ? 'Project Fields' : 'Resource Fields'
            })]
          }), jsx("div", {
            style: {
              maxWidth: 391,
              width: '50%'
            },
            children: jsx(TextField, {
              placeholder: "Search for a skill, role, location...",
              onChange: e => setSearchTerm(e.target.value),
              value: searchTerm,
              endIcon: "search"
            })
          })]
        }), jsx("div", {
          style: {
            flex: 1,
            overflow: 'auto'
          },
          onDragOver: e => e.preventDefault(),
          onDragEnd: e => e.preventDefault(),
          onDrop: e => {
            e.preventDefault();
            e.stopPropagation();
            return handleDrop(e, state.customFields.length, dragState.draggingIndex === 0 && e.nativeEvent.offsetY < 60);
          },
          ref: dragContainerRef,
          children: jsx(CustomFields$1, {
            customFields: filteredFields,
            handleDragOver: handleDragOver,
            handleDragStart: handleDragStart,
            handleDrop: handleDrop,
            handleDragEnd: handleDragEnd,
            handleRemoveField: deleteField,
            handleMoveField: handleMoveField,
            draggingIndex: dragState.draggingIndex,
            withSpace: Boolean(dragState.draggedType),
            ItemWrapper: CheckboxWrapper
          })
        })]
      }), jsxs(Layout, {
        stack: true,
        gap: "--Spacing-200",
        children: [jsxs(Layout, {
          gap: 4,
          vAlign: "center",
          children: [jsx(Icon, {
            name: "wrench"
          }), jsx(Typography, {
            variant: "label",
            size: "xl",
            children: "Create your own field"
          })]
        }), jsx(StyledContainer.FieldTemplates, {
          pb: "--Spacing-100",
          pl: "--Spacing-100",
          pr: "--Spacing-100",
          pt: "--Spacing-200",
          children: jsx(TemplateLayout, {
            title: TEMPLATE_TITLES[category],
            handleDragStart: handleDragStart,
            handleDragEnd: handleDragEnd,
            handleClick: type => {
              const newField = handleClick(type);
              toggleCustomField(newField, category);
            }
          })
        })]
      })]
    })
  });
};
const CustomFieldStep = _ref300 => {
  let {
    category
  } = _ref300;
  const {
    getAllFields,
    setResourceCustomFields,
    setProjectCustomFields,
    updateFields,
    selectedProjectFieldKeys,
    selectedResourceFieldKeys
  } = useOnboarding();
  const {
    setOnboardingCustomFields
  } = useOnboardingCustomFields();
  const customFields = getAllFields(category);
  const isProject = category === 'project';
  const updateCustomFields = cf => __awaiter(void 0, void 0, void 0, function* () {
    const setter = isProject ? setProjectCustomFields : setResourceCustomFields;
    const selectedKeys = isProject ? selectedProjectFieldKeys : selectedResourceFieldKeys;
    const sortedFields = [...cf].sort((a, b) => {
      const aSelected = selectedKeys.includes(getFieldKey(a));
      const bSelected = selectedKeys.includes(getFieldKey(b));
      return aSelected === bSelected ? a.order - b.order : aSelected ? -1 : 1;
    });
    setter(sortedFields);
    return sortedFields;
  });
  const handleCustomFieldsChange = fields => {
    const setter = isProject ? setProjectCustomFields : setResourceCustomFields;
    updateFields(fields, updatedFields => {
      const sortedFields = [...updatedFields].sort((a, b) => a.order - b.order);
      setter(sortedFields);
      setOnboardingCustomFields(sortedFields, isProject ? 'project' : 'resource');
    });
  };
  const sharedCfGroups = [];
  const sharedEntities = [];
  const sharedItems = [];
  const sharedAddEntity = args => new Promise(resolve => {
    console.log(...args);
    resolve();
  });
  const sharedRemoveEntity = args => new Promise(resolve => {
    console.log(...args);
    resolve();
  });
  const sharedUpdateEntities = args => new Promise(resolve => {
    console.log(...args);
    resolve();
  });
  const sharedAddItem = args => new Promise(resolve => {
    console.log(...args);
    resolve();
  });
  const sharedRemoveItem = args => new Promise(resolve => {
    console.log(...args);
    resolve();
  });
  const sharedUpdateItems = args => new Promise(resolve => {
    console.log(...args);
    resolve();
  });
  const sharedCreateCustomFieldGroup = args => new Promise(resolve => {
    resolve(args);
  });
  const sharedUpdateCustomFieldGroup = args => new Promise(resolve => {
    console.log(...args);
    resolve();
  });
  const sharedDeleteCustomFieldGroup = args => new Promise(resolve => {
    console.log(...args);
    resolve();
  });
  const sharedIsCFGExtensionInstalled = true;
  return jsxs(StepBG, {
    stack: true,
    gap: "--Spacing-400",
    children: [jsxs(Layout, {
      stack: true,
      gap: 8,
      children: [jsx(Typography, {
        tagName: "span",
        variant: "headline",
        size: "medium",
        color: "on-surface-variant",
        noWrap: true,
        weight: 500,
        children: STEP_CONTENT[category].title
      }), jsx(Typography, {
        tagName: "span",
        variant: "body",
        size: "small",
        color: "on-surface-variant",
        noWrap: true,
        children: STEP_CONTENT[category].description
      })]
    }), jsx(CustomFieldsProvider, {
      cfGroups: sharedCfGroups,
      customFields: customFields,
      updateCustomFields: updateCustomFields,
      customFieldsOn: true,
      category: category,
      initialized: true,
      onCustomFieldsChange: handleCustomFieldsChange,
      toggleCustomFields: console.log,
      sendNotification: console.log,
      customFieldGroups: [],
      isCFExtensionInstalled: true,
      entities: sharedEntities,
      items: sharedItems,
      addEntity: sharedAddEntity,
      removeEntity: sharedRemoveEntity,
      updateEntities: sharedUpdateEntities,
      addItem: sharedAddItem,
      removeItem: sharedRemoveItem,
      updateItems: sharedUpdateItems,
      createCustomFieldGroup: sharedCreateCustomFieldGroup,
      updateCustomFieldGroup: sharedUpdateCustomFieldGroup,
      deleteCustomFieldGroup: sharedDeleteCustomFieldGroup,
      isCFGExtensionInstalled: sharedIsCFGExtensionInstalled,
      selectedGroupHandler: [undefined, console.log],
      children: jsx(CustomFieldGroupProvider, {
        cfGroups: sharedCfGroups,
        items: sharedItems,
        entities: sharedEntities,
        addEntity: sharedAddEntity,
        removeEntity: sharedRemoveEntity,
        addItem: sharedAddItem,
        removeItem: sharedRemoveItem,
        createCustomFieldGroup: sharedCreateCustomFieldGroup,
        updateCustomFieldGroup: sharedUpdateCustomFieldGroup,
        deleteCustomFieldGroup: sharedDeleteCustomFieldGroup,
        updateEntities: sharedUpdateEntities,
        updateItems: sharedUpdateItems,
        isCFGExtensionInstalled: sharedIsCFGExtensionInstalled,
        selectedCFGroupHandler: [undefined, console.log],
        children: jsx(CustomFieldsComponent, {
          category: category
        })
      })
    })]
  });
};
function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var _excluded$2 = ["cdnSuffix", "cdnUrl", "countryCode", "style", "svg"];
var DEFAULT_CDN_URL = 'https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/';
var DEFAULT_CDN_SUFFIX = 'svg';
// offset between uppercase ascii and regional indicator symbols
var OFFSET = 127397;
var ReactCountryFlag = function ReactCountryFlag(_ref) {
  var _ref$cdnSuffix = _ref.cdnSuffix,
    cdnSuffix = _ref$cdnSuffix === void 0 ? DEFAULT_CDN_SUFFIX : _ref$cdnSuffix,
    _ref$cdnUrl = _ref.cdnUrl,
    cdnUrl = _ref$cdnUrl === void 0 ? DEFAULT_CDN_URL : _ref$cdnUrl,
    countryCode = _ref.countryCode,
    style = _ref.style,
    _ref$svg = _ref.svg,
    svg = _ref$svg === void 0 ? false : _ref$svg,
    props = _objectWithoutPropertiesLoose$2(_ref, _excluded$2);
  if (typeof countryCode !== 'string') {
    return null;
  }
  if (svg) {
    var flagUrl = "" + cdnUrl + countryCode.toLowerCase() + "." + cdnSuffix;
    return createElement$2("img", Object.assign({}, props, {
      src: flagUrl,
      style: _extends$2({
        display: 'inline-block',
        width: '1em',
        height: '1em',
        verticalAlign: 'middle'
      }, style)
    }));
  }
  var emoji = countryCode.toUpperCase().replace(/./g, function (_char) {
    return String.fromCodePoint(_char.charCodeAt(0) + OFFSET);
  });
  return createElement$2("span", Object.assign({
    role: "img"
  }, props, {
    style: _extends$2({
      display: 'inline-block',
      fontSize: '1em',
      lineHeight: '1em',
      verticalAlign: 'middle'
    }, style)
  }), emoji);
};
var countries_list = [{
  name: "Afghanistan",
  code: "AF"
}, {
  name: "Åland",
  code: "AX"
}, {
  name: "Albania",
  code: "AL"
}, {
  name: "Algeria",
  code: "DZ"
}, {
  name: "American Samoa",
  code: "AS"
}, {
  name: "Andorra",
  code: "AD"
}, {
  name: "Angola",
  code: "AO"
}, {
  name: "Anguilla",
  code: "AI"
}, {
  name: "Antigua and Barbuda",
  code: "AG"
}, {
  name: "Argentina",
  code: "AR"
}, {
  name: "Armenia",
  code: "AM"
}, {
  name: "Aruba",
  code: "AW"
}, {
  name: "Australia",
  code: "AU"
}, {
  name: "Austria",
  code: "AT"
}, {
  name: "Azerbaijan",
  code: "AZ"
}, {
  name: "Bahamas",
  code: "BS"
}, {
  name: "Bahrain",
  code: "BH"
}, {
  name: "Bangladesh",
  code: "BD"
}, {
  name: "Barbados",
  code: "BB"
}, {
  name: "Belarus",
  code: "BY"
}, {
  name: "Belgium",
  code: "BE"
}, {
  name: "Belize",
  code: "BZ"
}, {
  name: "Benin",
  code: "BJ"
}, {
  name: "Bermuda",
  code: "BM"
}, {
  name: "Bhutan",
  code: "BT"
}, {
  name: "Bolivia",
  code: "BO"
}, {
  name: "Bonaire, Sint Eustatius and Saba",
  code: "BQ"
}, {
  name: "Bosnia and Herzegovina",
  code: "BA"
}, {
  name: "Botswana",
  code: "BW"
}, {
  name: "Brazil",
  code: "BR"
}, {
  name: "British Indian Ocean Territory",
  code: "IO"
}, {
  name: "Brunei Darussalam",
  code: "BN"
}, {
  name: "Bulgaria",
  code: "BG"
}, {
  name: "Burkina Faso",
  code: "BF"
}, {
  name: "Burundi",
  code: "BI"
}, {
  name: "Cambodia",
  code: "KH"
}, {
  name: "Cameroon",
  code: "CM"
}, {
  name: "Canada",
  code: "CA"
}, {
  name: "Cape Verde",
  code: "CV"
}, {
  name: "Cayman Islands",
  code: "KY"
}, {
  name: "Central African Republic",
  code: "CF"
}, {
  name: "Chad",
  code: "TD"
}, {
  name: "Chile",
  code: "CL"
}, {
  name: "China",
  code: "CN"
}, {
  name: "Christmas Island",
  code: "CX"
}, {
  name: "Cocos (Keeling) Islands",
  code: "CC"
}, {
  name: "Colombia",
  code: "CO"
}, {
  name: "Comoros",
  code: "KM"
}, {
  name: "Congo (Brazzaville)",
  code: "CG"
}, {
  name: "Congo (Kinshasa)",
  code: "CD"
}, {
  name: "Cook Islands",
  code: "CK"
}, {
  name: "Costa Rica",
  code: "CR"
}, {
  name: "Côte d'Ivoire",
  code: "CI"
}, {
  name: "Croatia",
  code: "HR"
}, {
  name: "Cuba",
  code: "CU"
}, {
  name: "Curaçao",
  code: "CW"
}, {
  name: "Cyprus",
  code: "CY"
}, {
  name: "Czech Republic",
  code: "CZ"
}, {
  name: "Denmark",
  code: "DK"
}, {
  name: "Djibouti",
  code: "DJ"
}, {
  name: "Dominica",
  code: "DM"
}, {
  name: "Dominican Republic",
  code: "DO"
}, {
  name: "Ecuador",
  code: "EC"
}, {
  name: "Egypt",
  code: "EG"
}, {
  name: "El Salvador",
  code: "SV"
}, {
  name: "Equatorial Guinea",
  code: "GQ"
}, {
  name: "Eritrea",
  code: "ER"
}, {
  name: "Estonia",
  code: "EE"
}, {
  name: "Ethiopia",
  code: "ET"
}, {
  name: "Falkland Islands",
  code: "FK"
}, {
  name: "Faroe Islands",
  code: "FO"
}, {
  name: "Fiji",
  code: "FJ"
}, {
  name: "Finland",
  code: "FI"
}, {
  name: "France",
  code: "FR"
}, {
  name: "French Guiana",
  code: "GF"
}, {
  name: "French Polynesia",
  code: "PF"
}, {
  name: "Gabon",
  code: "GA"
}, {
  name: "Gambia",
  code: "GM"
}, {
  name: "Georgia",
  code: "GE"
}, {
  name: "Germany",
  code: "DE"
}, {
  name: "Ghana",
  code: "GH"
}, {
  name: "Gibraltar",
  code: "GI"
}, {
  name: "Greece",
  code: "GR"
}, {
  name: "Greenland",
  code: "GL"
}, {
  name: "Grenada",
  code: "GD"
}, {
  name: "Guadeloupe",
  code: "GP"
}, {
  name: "Guam",
  code: "GU"
}, {
  name: "Guatemala",
  code: "GT"
}, {
  name: "Guernsey",
  code: "GG"
}, {
  name: "Guinea",
  code: "GN"
}, {
  name: "Guinea-Bissau",
  code: "GW"
}, {
  name: "Guyana",
  code: "GY"
}, {
  name: "Haiti",
  code: "HT"
}, {
  name: "Honduras",
  code: "HN"
}, {
  name: "Hong Kong",
  code: "HK"
}, {
  name: "Hungary",
  code: "HU"
}, {
  name: "Iceland",
  code: "IS"
}, {
  name: "India",
  code: "IN"
}, {
  name: "Indonesia",
  code: "ID"
}, {
  name: "Iran",
  code: "IR"
}, {
  name: "Iraq",
  code: "IQ"
}, {
  name: "Ireland",
  code: "IE"
}, {
  name: "Isle of Man",
  code: "IM"
}, {
  name: "Israel",
  code: "IL"
}, {
  name: "Italy",
  code: "IT"
}, {
  name: "Jamaica",
  code: "JM"
}, {
  name: "Japan",
  code: "JP"
}, {
  name: "Jersey",
  code: "JE"
}, {
  name: "Jordan",
  code: "JO"
}, {
  name: "Kazakhstan",
  code: "KZ"
}, {
  name: "Kenya",
  code: "KE"
}, {
  name: "Kiribati",
  code: "KI"
}, {
  name: "Korea, North",
  code: "KP"
}, {
  name: "Korea, South",
  code: "KR"
}, {
  name: "Kuwait",
  code: "KW"
}, {
  name: "Kyrgyzstan",
  code: "KG"
}, {
  name: "Laos",
  code: "LA"
}, {
  name: "Latvia",
  code: "LV"
}, {
  name: "Lebanon",
  code: "LB"
}, {
  name: "Lesotho",
  code: "LS"
}, {
  name: "Liberia",
  code: "LR"
}, {
  name: "Libya",
  code: "LY"
}, {
  name: "Liechtenstein",
  code: "LI"
}, {
  name: "Lithuania",
  code: "LT"
}, {
  name: "Luxembourg",
  code: "LU"
}, {
  name: "Macau",
  code: "MO"
}, {
  name: "Macedonia",
  code: "MK"
}, {
  name: "Madagascar",
  code: "MG"
}, {
  name: "Malawi",
  code: "MW"
}, {
  name: "Malaysia",
  code: "MY"
}, {
  name: "Maldives",
  code: "MV"
}, {
  name: "Mali",
  code: "ML"
}, {
  name: "Malta",
  code: "MT"
}, {
  name: "Marshall Islands",
  code: "MH"
}, {
  name: "Martinique",
  code: "MQ"
}, {
  name: "Mauritania",
  code: "MR"
}, {
  name: "Mauritius",
  code: "MU"
}, {
  name: "Mayotte",
  code: "YT"
}, {
  name: "Mexico",
  code: "MX"
}, {
  name: "Micronesia, Federated States of",
  code: "FM"
}, {
  name: "Moldova",
  code: "MD"
}, {
  name: "Monaco",
  code: "MC"
}, {
  name: "Mongolia",
  code: "MN"
}, {
  name: "Montenegro",
  code: "ME"
}, {
  name: "Montserrat",
  code: "MS"
}, {
  name: "Morocco",
  code: "MA"
}, {
  name: "Mozambique",
  code: "MZ"
}, {
  name: "Myanmar",
  code: "MM"
}, {
  name: "Namibia",
  code: "NA"
}, {
  name: "Nauru",
  code: "NR"
}, {
  name: "Nepal",
  code: "NP"
}, {
  name: "Netherlands",
  code: "NL"
}, {
  name: "New Caledonia",
  code: "NC"
}, {
  name: "New Zealand",
  code: "NZ"
}, {
  name: "Nicaragua",
  code: "NI"
}, {
  name: "Niger",
  code: "NE"
}, {
  name: "Nigeria",
  code: "NG"
}, {
  name: "Niue",
  code: "NU"
}, {
  name: "Norfolk Island",
  code: "NF"
}, {
  name: "Northern Mariana Islands",
  code: "MP"
}, {
  name: "Norway",
  code: "NO"
}, {
  name: "Oman",
  code: "OM"
}, {
  name: "Pakistan",
  code: "PK"
}, {
  name: "Palau",
  code: "PW"
}, {
  name: "Palestine",
  code: "PS"
}, {
  name: "Panama",
  code: "PA"
}, {
  name: "Papua New Guinea",
  code: "PG"
}, {
  name: "Paraguay",
  code: "PY"
}, {
  name: "Peru",
  code: "PE"
}, {
  name: "Philippines",
  code: "PH"
}, {
  name: "Poland",
  code: "PL"
}, {
  name: "Portugal",
  code: "PT"
}, {
  name: "Puerto Rico",
  code: "PR"
}, {
  name: "Qatar",
  code: "QA"
}, {
  name: "Reunion",
  code: "RE"
}, {
  name: "Romania",
  code: "RO"
}, {
  name: "Russian Federation",
  code: "RU"
}, {
  name: "Rwanda",
  code: "RW"
}, {
  name: "Saint Barthélemy",
  code: "BL"
}, {
  name: "Saint Helena",
  code: "SH"
}, {
  name: "Saint Kitts and Nevis",
  code: "KN"
}, {
  name: "Saint Lucia",
  code: "LC"
}, {
  name: "Saint Martin (French part)",
  code: "MF"
}, {
  name: "Saint Pierre and Miquelon",
  code: "PM"
}, {
  name: "Saint Vincent and the Grenadines",
  code: "VC"
}, {
  name: "Samoa",
  code: "WS"
}, {
  name: "San Marino",
  code: "SM"
}, {
  name: "Sao Tome and Principe",
  code: "ST"
}, {
  name: "Saudi Arabia",
  code: "SA"
}, {
  name: "Senegal",
  code: "SN"
}, {
  name: "Serbia",
  code: "RS"
}, {
  name: "Seychelles",
  code: "SC"
}, {
  name: "Sierra Leone",
  code: "SL"
}, {
  name: "Singapore",
  code: "SG"
}, {
  name: "Sint Maarten (Dutch part)",
  code: "SX"
}, {
  name: "Slovakia",
  code: "SK"
}, {
  name: "Slovenia",
  code: "SI"
}, {
  name: "Solomon Islands",
  code: "SB"
}, {
  name: "Somalia",
  code: "SO"
}, {
  name: "South Africa",
  code: "ZA"
}, {
  name: "South Sudan",
  code: "SS"
}, {
  name: "Spain",
  code: "ES"
}, {
  name: "Sri Lanka",
  code: "LK"
}, {
  name: "Sudan",
  code: "SD"
}, {
  name: "Suriname",
  code: "SR"
}, {
  name: "Svalbard and Jan Mayen Islands",
  code: "SJ"
}, {
  name: "Swaziland",
  code: "SZ"
}, {
  name: "Sweden",
  code: "SE"
}, {
  name: "Switzerland",
  code: "CH"
}, {
  name: "Syria",
  code: "SY"
}, {
  name: "Taiwan",
  code: "TW"
}, {
  name: "Tajikistan",
  code: "TJ"
}, {
  name: "Tanzania",
  code: "TZ"
}, {
  name: "Thailand",
  code: "TH"
}, {
  name: "Timor-Leste",
  code: "TL"
}, {
  name: "Togo",
  code: "TG"
}, {
  name: "Tokelau",
  code: "TK"
}, {
  name: "Tonga",
  code: "TO"
}, {
  name: "Trinidad and Tobago",
  code: "TT"
}, {
  name: "Tunisia",
  code: "TN"
}, {
  name: "Turkey",
  code: "TR"
}, {
  name: "Turkmenistan",
  code: "TM"
}, {
  name: "Turks and Caicos Islands",
  code: "TC"
}, {
  name: "Tuvalu",
  code: "TV"
}, {
  name: "Uganda",
  code: "UG"
}, {
  name: "Ukraine",
  code: "UA"
}, {
  name: "United Arab Emirates",
  code: "AE"
}, {
  name: "United Kingdom",
  code: "GB"
}, {
  name: "United States",
  code: "US"
}, {
  name: "Uruguay",
  code: "UY"
}, {
  name: "Uzbekistan",
  code: "UZ"
}, {
  name: "Vanuatu",
  code: "VU"
}, {
  name: "Vatican City",
  code: "VA"
}, {
  name: "Venezuela",
  code: "VE"
}, {
  name: "Vietnam",
  code: "VN"
}, {
  name: "Virgin Islands, British",
  code: "VG"
}, {
  name: "Virgin Islands, U.S.",
  code: "VI"
}, {
  name: "Wallis and Futuna Islands",
  code: "WF"
}, {
  name: "Western Sahara",
  code: "EH"
}, {
  name: "Yemen",
  code: "YE"
}, {
  name: "Zambia",
  code: "ZM"
}, {
  name: "Zimbabwe",
  code: "ZW"
}];
const StyledDemoDataContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "demo-data-step__StyledDemoDataContainer",
  componentId: "ylk0uk-0"
})(["padding:16px;border-radius:16px;background-color:", ";width:330px;height:fit-content;transition:opacity 0.2s ease-in-out;", " [class*='switch__StyledSwitch']{opacity:1 !important;pointer-events:auto !important;cursor:pointer !important;}"], _ref301 => {
  let {
    theme
  } = _ref301;
  return theme.designTokens.color.color.surfaces['surface-container-low'].value;
}, _ref302 => {
  let {
    disabled
  } = _ref302;
  return disabled && css(["& > *:not([class*='switch__StyledSwitch']){opacity:0.5;pointer-events:none;cursor:not-allowed;}"]);
});
const DEMO_CONTENT = {
  resource: {
    title: 'Resources',
    description: 'Add demo resources that you can schedule.',
    icon: 'resourceMgmt'
  },
  project: {
    title: 'Projects',
    description: 'Add demo projects to schedule work.',
    icon: 'folder'
  },
  country: {
    title: 'Public Holidays',
    description: 'Add country holidays that can affect availability.',
    icon: 'umbrella'
  }
};
const NUMERIC_SELECT_OPTIONS = [{
  value: '10'
}, {
  value: '25'
}, {
  value: '50'
}, {
  value: '100'
}];
const isResourceOrProject = type => {
  return type === 'resource' || type === 'project';
};
const isCountry = type => {
  return type === 'country';
};
const isCountryObject = value => {
  return typeof value === 'object' && value !== null && 'code' in value && 'name' in value && typeof value.code === 'string' && typeof value.name === 'string';
};
const CountryFlag = _ref303 => {
  let {
    country,
    size: _size = 18
  } = _ref303;
  return jsx(ReactCountryFlag, {
    className: "countryFlag",
    countryCode: country.code,
    alt: country.name,
    "aria-label": country.name,
    style: {
      width: "".concat(_size, "px"),
      height: "".concat(_size, "px"),
      borderRadius: '50%',
      objectFit: 'cover',
      fontSize: "".concat(_size, "px"),
      lineHeight: "".concat(_size, "px")
    },
    svg: true
  });
};
const CountrySelectLabel = _ref304 => {
  let {
    country
  } = _ref304;
  return jsxs(Layout, {
    gap: "--Spacing-50",
    vAlign: "center",
    hAlign: "space-between",
    flex: "1",
    children: [jsx(Typography, {
      variant: "label",
      size: "large",
      prominent: true,
      children: country.name
    }), jsx(CountryFlag, {
      country: country,
      size: 24
    })]
  });
};
const DemoDataSelect = _ref305 => {
  let {
    type,
    selectedValue,
    setSelectedValue,
    countries,
    setCountries
  } = _ref305;
  var _a;
  if (isCountry(type)) {
    return jsx(Select, {
      dataCy: "onboarding-country-selector",
      disableClearable: true,
      options: countries_list,
      value: countries.map(country => Object.assign(Object.assign({}, country), {
        startIcon: jsx(CountryFlag, {
          country: country
        })
      })),
      onChange: (_, value) => value && setCountries(value),
      optionLabel: "name",
      optionValue: "code",
      multiple: true,
      customFilterOptions: (options, state) => {
        const searchValue = state.inputValue.toLowerCase().trim();
        return options.filter(option => {
          var _a, _b;
          return ((_a = option.code) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchValue)) || ((_b = option.name) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(searchValue));
        });
      },
      labelRenderer: country => jsx(CountrySelectLabel, {
        country: country
      })
    });
  }
  return jsx(Select, {
    disableClearable: true,
    options: NUMERIC_SELECT_OPTIONS,
    value: {
      value: (_a = selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.toString()) !== null && _a !== void 0 ? _a : ''
    },
    onChange: (_, value) => {
      value && setSelectedValue(parseInt(value.value));
    },
    optionLabel: option => option.value,
    optionValue: "value",
    dataCy: "onboarding-demo-".concat(type, "-selector")
  });
};
const DemoData = _ref306 => {
  let {
    type
  } = _ref306;
  const {
    demoResources,
    setDemoResources,
    demoProjects,
    setDemoProjects,
    countries,
    setCountries,
    demoProjectsEnabled,
    demoResourcesEnabled,
    countriesEnabled,
    setDemoResourcesEnabled,
    setDemoProjectsEnabled,
    setCountriesEnabled,
    defaultCountry
  } = useOnboarding();
  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current && defaultCountry) {
      const countryFromList = countries_list.find(c => {
        var _a;
        return c.code.toLowerCase() === ((_a = defaultCountry.code) === null || _a === void 0 ? void 0 : _a.toLowerCase());
      });
      if (countryFromList && !countries.some(country => {
        var _a;
        return country.code.toLowerCase() === ((_a = defaultCountry.code) === null || _a === void 0 ? void 0 : _a.toLowerCase());
      })) {
        setCountries([...countries, countryFromList]);
      }
    }
    isInitialMount.current = false;
  }, [defaultCountry, countries, setCountries]);
  const toggle = useCallback(e => {
    const setters = {
      country: setCountriesEnabled,
      project: setDemoProjectsEnabled,
      resource: setDemoResourcesEnabled
    };
    setters[type](e.target.checked);
  }, [type, setCountriesEnabled, setDemoProjectsEnabled, setDemoResourcesEnabled]);
  const enabled = useMemo(() => ({
    country: countriesEnabled,
    project: demoProjectsEnabled,
    resource: demoResourcesEnabled
  })[type], [type, demoProjectsEnabled, countriesEnabled, demoResourcesEnabled]);
  const selectedValue = useMemo(() => ({
    resource: demoResources,
    project: demoProjects,
    country: countries
  })[type], [type, demoResources, demoProjects, countries]);
  const setSelectedValue = useCallback(value => {
    if (isResourceOrProject(type)) {
      if (typeof value !== 'number') {
        throw new Error('Value must be a number for resource or project types');
      }
      type === 'resource' ? setDemoResources(value) : setDemoProjects(value);
      return;
    }
    if (isCountry(type) && isCountryObject(value)) {
      setCountries(value);
      return;
    }
    throw new Error('Invalid value type for the selected demo data type');
  }, [type, setDemoResources, setDemoProjects, setCountries]);
  const content = DEMO_CONTENT[type];
  return jsxs(StyledDemoDataContainer, {
    disabled: !enabled,
    children: [jsxs(Layout, {
      hAlign: "space-between",
      vAlign: "center",
      children: [jsx(Switch, {
        checked: enabled,
        onChange: toggle,
        dataCy: "onboarding-switch-".concat(type)
      }), jsx(Icon, {
        name: content.icon,
        size: 45,
        color: "on-surface-variant"
      })]
    }), jsxs(Layout, {
      stack: true,
      gap: "--Spacing-100",
      children: [jsx(Typography, {
        tagName: "span",
        variant: "headline",
        size: "small",
        weight: 700,
        color: "on-surface-variant",
        children: content.title
      }), jsx(Typography, {
        variant: "body",
        size: "small",
        color: "on-surface-variant",
        children: content.description
      })]
    }), jsx("div", {
      style: {
        width: type === 'country' ? '100%' : 75
      },
      children: jsx(Layout, {
        pt: "--Spacing-200",
        children: jsx(DemoDataSelect, {
          type: type,
          selectedValue: selectedValue,
          setSelectedValue: setSelectedValue,
          countries: countries,
          setCountries: setCountries
        })
      })
    })]
  });
};
const DemoDataStep = () => {
  const {
    submitOnboarding
  } = useOnboarding();
  return jsxs(StepBG, {
    stack: true,
    gap: 54,
    children: [jsxs(Layout, {
      stack: true,
      gap: 8,
      children: [jsx(Typography, {
        tagName: "span",
        variant: "headline",
        size: "medium",
        color: "on-surface-variant",
        noWrap: true,
        weight: 500,
        children: "How would you like to start?"
      }), jsx("div", {
        style: {
          maxWidth: 1000
        },
        children: jsxs(Typography, {
          tagName: "span",
          variant: "body",
          size: "small",
          color: "on-surface-variant",
          children: ["Get a head start with \u201CDemo Data\u201D in a pre-filled workspace, fully customizable to fit your team. Prefer to start fresh? Choose a blank workspace ", '\n', " and build from scratch\u2014it\u2019s entirely up to you."]
        })
      })]
    }), jsxs(Layout, {
      stack: true,
      children: [jsxs(Layout, {
        wrap: true,
        gap: "--Spacing-300",
        children: [jsx(DemoData, {
          type: "resource"
        }), jsx(DemoData, {
          type: "project"
        }), jsx(DemoData, {
          type: "country"
        })]
      }), jsx(Layout, {
        pt: 80,
        vAlign: "center",
        hAlign: "center",
        children: jsx("div", {
          style: {
            width: 355
          },
          children: jsx(Button, {
            startIcon: "wrench",
            endIcon: "wrench",
            variant: "outlined",
            onClick: () => submitOnboarding(true),
            dataCy: "onboarding-manual-start",
            children: "Or manually build up your workspace"
          })
        })
      })]
    })]
  });
};
const CardContainer = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "styled__CardContainer",
  componentId: "sc-6x2t10-0"
})(["background-color:", ";border-radius:40px;padding:24px;height:289px;max-width:", ";box-sizing:border-box;box-shadow:", ";&:hover{background-color:", ";box-shadow:0px 1px 2px 0px #0000001f,2px 3px 4px 0px #0000001a,3px 7px 5px 0px #0000000f,6px 13px 6px 0px #00000005,10px 20px 6px 0px #00000000;}border:", ";transition:background-color ease-out 300ms;position:relative;"], _ref307 => {
  let {
    theme
  } = _ref307;
  return theme.designTokens.color.color.surfaces['background'].value;
}, props => props.width ? "".concat(props.width, "px") : 'initial', _ref308 => {
  let {
    selected
  } = _ref308;
  return selected ? '2px 4px 9px 0px #0000001F, 7px 15px 17px 0px #0000001A, 16px 34px 23px 0px #0000000F, 28px 61px 27px 0px #00000005, 44px 95px 29px 0px #00000000' : '0px 1px 2px 0px #0000001f, 2px 3px 4px 0px #0000001a, 3px 7px 5px 0px #0000000f, 6px 13px 6px 0px #00000005, 10px 20px 6px 0px #00000000;';
}, _ref309 => {
  let {
    theme
  } = _ref309;
  return theme.designTokens.color.color.surfaces['surface-container-low'].value;
}, _ref310 => {
  let {
    selected,
    theme
  } = _ref310;
  return selected ? "3px solid ".concat(theme.designTokens.color.color.light['outline-variant'].value) : '3px solid transparent';
});
const CardBadge = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled__CardBadge",
  componentId: "sc-6x2t10-1"
})(["background-color:", ";border-radius:24px;height:48px;display:flex;justify-content:center;align-items:center;width:fit-content;padding:8px 16px;flex-shrink:0;"], _ref311 => {
  let {
    theme
  } = _ref311;
  return theme.designTokens.color.color.surfaces['surface-container-high'].value;
});
const BadgeText = /*#__PURE__*/styled(Typography).withConfig({
  displayName: "styled__BadgeText",
  componentId: "sc-6x2t10-2"
})(["font-weight:700 !important;"]);
const countries = countries_list;
const TEAM_SIZE_CARD_CONFIG = {
  [TeamSizes.SIZE_0_50]: {
    badgeText: '0 - 50',
    text: 'I need light capabilities for a smaller team.',
    icon: 'users_three'
  },
  [TeamSizes.SIZE_50_250]: {
    badgeText: '50 - 250',
    text: 'I have a mid size team.',
    icon: 'users_mid'
  },
  [TeamSizes.SIZE_250_1000]: {
    badgeText: '250 - 1000',
    text: 'The team is scaling and growing.',
    icon: 'rocket_graph'
  },
  [TeamSizes.SIZE_1000_PLUS]: {
    badgeText: '1000+',
    text: 'Advanced capabilities for larger teams.',
    icon: 'buildings'
  }
};
const DEPARTMENT_CARD_CONFIG = {
  [Departments.DESIGN_AND_CREATIVES]: {
    badgeText: 'Design & Creatives',
    text: 'Allocate members on creative projects and get an overview of utilization.',
    icon: 'pen_nib'
  },
  [Departments.IT_CONSULTANCY]: {
    badgeText: 'IT Consultancy',
    text: 'External consulting projects, high utilisation & allocation focus.',
    icon: 'code'
  },
  [Departments.IT_DEPARTMENT]: {
    badgeText: 'IT Department',
    text: 'IT running technical projects needing efficient allocation.',
    icon: 'terminal'
  },
  [Departments.OPERATIONS]: {
    badgeText: 'Operations',
    text: 'Resource Management as part of process and system efficiency.',
    icon: 'puzzle_piece'
  },
  [Departments.OTHER]: {
    badgeText: 'Other',
    text: 'Custom department type',
    icon: 'puzzle_piece'
  }
};
const DepartmentGridContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "department-step__DepartmentGridContainer",
  componentId: "jlb3z9-0"
})(["display:grid;grid-template-columns:repeat(auto-fill,434px);gap:32px;width:80%;@media (max-width:1200px){grid-template-columns:repeat(auto-fill,minmax(300px,434px));}"]);
const ScrollContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "department-step__ScrollContainer",
  componentId: "jlb3z9-1"
})(["overflow-y:scroll;height:100%;"]);
const LastCardWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "department-step__LastCardWrapper",
  componentId: "jlb3z9-2"
})(["position:relative;.other-input{position:absolute;", "}"], props => props.shouldShowInputRight ? "\n                bottom: -86px;\n                left: 0;\n            " : "\n                top: calc(100% + -82px);\n                right: -240px;\n            ");
const OtherDepartmentWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "department-step__OtherDepartmentWrapper",
  componentId: "jlb3z9-3"
})(["width:224px;align-self:flex-end;"]);
const DepartmentTypeCard = _ref312 => {
  let {
    department,
    selectedDepartment,
    onClick
  } = _ref312;
  const {
    width: windowWidth
  } = useScreenSize();
  const {
    badgeText,
    text,
    icon
  } = DEPARTMENT_CARD_CONFIG[department];
  const isLastCard = department === Departments.IT_DEPARTMENT;
  const layoutCalculations = useMemo(() => {
    const containerWidth = windowWidth * 0.75;
    const cardWidthWithGap = 434;
    const cardsPerRow = Math.floor(containerWidth / cardWidthWithGap);
    const shouldShowInputRight = cardsPerRow >= 4;
    return {
      shouldShowInputRight
    };
  }, [windowWidth]);
  const {
    shouldShowInputRight
  } = layoutCalculations;
  if (!isLastCard) {
    return jsx(CardContainer, {
      selected: department === selectedDepartment,
      onClick: () => onClick(department),
      dataCy: "onboarding-select-department-".concat(department),
      width: 484,
      children: jsx("div", {
        style: {
          width: 484
        },
        children: jsxs(Layout, {
          gap: "--Spacing-200",
          stack: true,
          children: [jsx(CardBadge, {
            children: jsx(BadgeText, {
              variant: "headline",
              size: "small",
              color: "on-surface-variant",
              children: badgeText
            })
          }), jsx(Typography, {
            variant: "body",
            size: "medium",
            color: "on-surface",
            children: text
          }), jsx("div", {
            style: {
              marginLeft: 'auto'
            },
            children: jsx(Icon, {
              name: icon,
              size: 140,
              color: "outline-variant",
              noFill: true
            })
          })]
        })
      })
    });
  }
  return jsxs(LastCardWrapper, {
    shouldShowInputRight: shouldShowInputRight,
    children: [jsx(CardContainer, {
      selected: department === selectedDepartment,
      onClick: () => onClick(department),
      dataCy: "onboarding-select-department-".concat(department),
      width: 484,
      children: jsx("div", {
        style: {
          width: 484
        },
        children: jsxs(Layout, {
          gap: "--Spacing-200",
          stack: true,
          children: [jsx(CardBadge, {
            children: jsx(BadgeText, {
              variant: "headline",
              size: "small",
              color: "on-surface-variant",
              children: badgeText
            })
          }), jsx(Typography, {
            variant: "body",
            size: "medium",
            color: "on-surface",
            children: text
          }), jsx("div", {
            style: {
              marginLeft: 'auto'
            },
            children: jsx(Icon, {
              name: icon,
              size: 140,
              color: "outline-variant",
              noFill: true
            })
          })]
        })
      })
    }), jsx("div", {
      className: "other-input",
      children: jsx(OtherDepartmentWrapper, {
        children: jsx(OtherDepartmentInput, {})
      })
    })]
  });
};
const OtherDepartmentInput = () => {
  const {
    selectedDepartment,
    setSelectedDepartment,
    setOtherDepartment,
    otherDepartment
  } = useOnboarding();
  const isSelected = useMemo(() => selectedDepartment === Departments.OTHER, [selectedDepartment]);
  const handleOtherClick = useCallback(() => {
    setSelectedDepartment(isSelected ? undefined : Departments.OTHER);
  }, [setSelectedDepartment, isSelected]);
  return jsx(Layout, {
    stack: true,
    children: jsxs(OtherDepartmentWrapper, {
      children: [jsx(Radio, {
        label: "Other",
        value: isSelected,
        checked: isSelected,
        onClick: handleOtherClick,
        onChange: handleOtherClick,
        dataCy: "onboarding-other-selector"
      }), jsx(TextField, {
        onFocus: () => {
          if (!isSelected) {
            handleOtherClick();
          }
        },
        placeholder: "Please enter team type",
        value: otherDepartment,
        onChange: e => setOtherDepartment(e.target.value),
        dataCy: "onboarding-other-input"
      })]
    })
  });
};
const DepartmentGrid = _ref313 => {
  let {
    selectedDepartment,
    onDepartmentClick
  } = _ref313;
  return jsx(DepartmentGridContainer, {
    children: [Departments.IT_CONSULTANCY, Departments.DESIGN_AND_CREATIVES, Departments.OPERATIONS, Departments.IT_DEPARTMENT].map(department => jsx(DepartmentTypeCard, {
      department: department,
      onClick: onDepartmentClick,
      selectedDepartment: selectedDepartment
    }, department))
  });
};
const DepartmentStep = () => {
  const {
    selectedDepartment,
    setSelectedDepartment
  } = useOnboarding();
  const {
    nextStep
  } = useWizard();
  const handleDepartmentClick = department => {
    nextStep();
    setSelectedDepartment(department);
  };
  return jsxs(StepBG, {
    stack: true,
    gap: "--Spacing-400",
    children: [jsxs(Layout, {
      stack: true,
      gap: 8,
      children: [jsx(Typography, {
        tagName: "span",
        variant: "headline",
        size: "medium",
        color: "on-surface-variant",
        noWrap: true,
        weight: 500,
        children: "What kind of work does your team do?"
      }), jsx(Typography, {
        tagName: "span",
        variant: "body",
        size: "small",
        color: "on-surface-variant",
        noWrap: true,
        children: "This helps us customize your experience."
      })]
    }), jsx(ScrollContainer, {
      children: jsx(Layout, {
        pt: "--Spacing-150",
        pb: "--Spacing-300",
        pr: "--Spacing-400",
        gap: "--Spacing-400",
        children: jsx(DepartmentGrid, {
          selectedDepartment: selectedDepartment,
          onDepartmentClick: handleDepartmentClick
        })
      })
    })]
  });
};
const LoadingOverlay = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "loading-step__LoadingOverlay",
  componentId: "sc-1q45iar-0"
})(["position:fixed;top:0;left:0;right:0;bottom:0;background-color:", ";height:100vh;width:100vw;"], props => props.theme.designTokens.color.color.surfaces['inverse-surface'].value);
const LoaderContainer = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "loading-step__LoaderContainer",
  componentId: "sc-1q45iar-1"
})([""]);
const LoadingStep = () => {
  return jsx(LoadingOverlay, {
    hAlign: "center",
    vAlign: "center",
    children: jsx(LoaderContainer, {
      hAlign: "center",
      vAlign: "center",
      stack: true,
      gap: "--Spacing-200",
      children: jsx(Loader, {
        text: "Building your schedule"
      })
    })
  });
};
const TEAM_SIZE_OPTIONS = [TeamSizes.SIZE_0_50, TeamSizes.SIZE_50_250, TeamSizes.SIZE_250_1000, TeamSizes.SIZE_1000_PLUS];
const CARD_WIDTH = 240 - 24 * 2 - 3 * 2;
const TeamSizeCard = _ref314 => {
  let {
    teamSize,
    selectedTeamSize,
    onClick
  } = _ref314;
  const {
    badgeText,
    text,
    icon
  } = TEAM_SIZE_CARD_CONFIG[teamSize];
  const isLargeTeam = teamSize === TeamSizes.SIZE_1000_PLUS;
  return jsx(CardContainer, {
    selected: teamSize === selectedTeamSize,
    onClick: () => onClick(teamSize),
    dataCy: "team-size-".concat(teamSize),
    children: jsx("div", {
      style: {
        width: CARD_WIDTH
      },
      children: jsxs(Layout, {
        gap: "--Spacing-300",
        stack: true,
        vAlign: "center",
        fullHeight: true,
        children: [jsx(CardBadge, {
          children: jsx(BadgeText, {
            variant: "headline",
            size: "small",
            color: "on-surface-variant",
            children: badgeText
          })
        }), jsx("div", {
          style: {
            flexShrink: 0
          },
          children: jsx(Typography, {
            variant: "body",
            size: "medium",
            color: "on-surface",
            children: text
          })
        }), jsx("div", {
          style: {
            flex: 1,
            flexGrow: 1,
            flexShrink: 0,
            minHeight: 0
          },
          children: jsx(Icon, {
            name: icon,
            size: "100%",
            color: "outline-variant",
            noFill: !isLargeTeam
          })
        })]
      })
    })
  });
};
const TeamSizeGrid = _ref315 => {
  let {
    selectedTeamSize,
    onTeamSizeClick
  } = _ref315;
  return jsx(Layout, {
    gap: "--Spacing-200",
    children: TEAM_SIZE_OPTIONS.map(teamSize => jsx(TeamSizeCard, {
      teamSize: teamSize,
      onClick: onTeamSizeClick,
      selectedTeamSize: selectedTeamSize
    }, teamSize))
  });
};
const TeamSizeStep = () => {
  const {
    selectedTeamSize,
    setSelectedTeamSize
  } = useOnboarding();
  const {
    nextStep
  } = useWizard();
  const handleTeamSizeClick = teamSize => {
    nextStep();
    setSelectedTeamSize(teamSize);
  };
  return jsxs(StepBG, {
    stack: true,
    gap: "--Spacing-400",
    flex: "1",
    children: [jsxs(Layout, {
      stack: true,
      gap: 8,
      children: [jsx(WelcomeText, {
        variant: "headline",
        size: "medium",
        color: "on-surface-variant",
        noWrap: true,
        weight: 500,
        children: "What's your team size?"
      }), jsx(WelcomeText, {
        variant: "title",
        size: "medium",
        color: "on-surface-variant",
        children: "This helps us customize your trial."
      })]
    }), jsx(Layout, {
      stack: true,
      gap: "--Spacing-400",
      pb: 16,
      children: jsx(TeamSizeGrid, {
        selectedTeamSize: selectedTeamSize,
        onTeamSizeClick: handleTeamSizeClick
      })
    })]
  });
};

// TODO: Remove from `core-js@4` since it's moved to entry points

var $$6 = _export;
var call = functionCall;
var isCallable = isCallable$s;
var anObject = anObject$r;
var toString$3 = toString$g;
var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test('abc') === true && execCalled;
}();
var nativeTest = /./.test;

// `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test
$$6({
  target: 'RegExp',
  proto: true,
  forced: !DELEGATES_TO_EXEC
}, {
  test: function (S) {
    var R = anObject(this);
    var string = toString$3(S);
    var exec = R.exec;
    if (!isCallable(exec)) return call(nativeTest, R, string);
    var result = call(exec, R, string);
    if (result === null) return false;
    anObject(result);
    return true;
  }
});
const getAccountValidationSchema = function () {
  let {
    validateDomain
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return create$3({
    firstName: create$6().optional().transform(value => (value === null || value === void 0 ? void 0 : value.trim()) || undefined).test('trimmed-length', 'First name must be at least 2 characters', value => !value || value.length >= 2).test('valid-chars', 'First name can only contain letters, hyphens and apostrophes', value => !value || /^[a-zA-Z-']+$/.test(value)),
    lastName: create$6().optional().transform(value => (value === null || value === void 0 ? void 0 : value.trim()) || undefined).test('trimmed-length', 'Last name must be at least 2 characters', value => !value || value.length >= 2).test('valid-chars', 'Last name can only contain letters, hyphens and apostrophes', value => !value || /^[a-zA-Z-']+$/.test(value)),
    companyName: create$6().optional().transform(value => (value === null || value === void 0 ? void 0 : value.trim()) || undefined).test('trimmed-length', 'Company name must be at least 2 characters', value => !value || value.length >= 2),
    domainName: create$6().required('Domain name is required').transform(value => value === null || value === void 0 ? void 0 : value.replace(/\s/g, '')).min(3, 'Domain must be at least 3 characters').max(30, 'Domain cannot be more than 30 characters').matches(/^[a-zA-Z0-9-]+$/, 'Domain can only contain letters, numbers, and hyphens').test('unique-domain', 'This domain is already taken', value => __awaiter(void 0, void 0, void 0, function* () {
      if (!value || !validateDomain) return true;
      return yield validateDomain(value);
    })),
    phoneNumber: create$6().optional().transform(value => (value === null || value === void 0 ? void 0 : value.trim()) || undefined).test('phone-validation', 'Invalid phone number format', value => {
      if (!value) return true;
      const digitCount = value.replace(/[^0-9]/g, '').length;
      if (digitCount < 5) return true;
      return /^\+?[\d-()]+$/.test(value);
    })
  });
};
const WelcomeStep = () => {
  const {
    firstName,
    setFirstName,
    lastName,
    setLastName,
    companyName,
    setCompanyName,
    domainName,
    setDomainName,
    featureUpdatesEnabled,
    setFeatureUpdatesEnabled,
    phoneNumber,
    setPhoneNumber,
    defaultCountry,
    validateDomain,
    selectedCountry,
    setSelectedCountry
  } = useOnboarding();
  const {
    handleBlur,
    handleChange,
    getFieldError
  } = useFormValidation({
    validationSchema: getAccountValidationSchema({
      validateDomain
    }),
    initialValues: {
      firstName,
      lastName,
      companyName,
      domainName,
      phoneNumber
    }
  });
  return jsxs(StepBG, {
    stack: true,
    gap: 54,
    flex: "1",
    children: [jsxs(Layout, {
      stack: true,
      gap: 8,
      children: [jsxs(WelcomeText, {
        tagName: "span",
        variant: "display",
        size: "large",
        color: "on-surface-variant",
        noWrap: true,
        children: ["Welcome to", ' ', jsx(WelcomeText, {
          tagName: "span",
          variant: "display",
          size: "xl",
          color: "on-surface-variant",
          noWrap: true,
          weight: 500,
          children: "Hub Planner"
        }), jsx(WelcomeText, {
          tagName: "span",
          variant: "display",
          size: "large",
          color: "on-surface-variant",
          noWrap: true,
          children: "!"
        })]
      }), jsx(Typography, {
        variant: "title",
        size: "medium",
        color: "on-surface-variant",
        children: "Let\u2019s start with setting up some of the basic information and details of your account."
      })]
    }), jsx("div", {
      style: {
        overflowY: 'auto'
      },
      children: jsxs(Layout, {
        gap: 135,
        children: [jsx("div", {
          style: {
            width: '35%',
            overflowY: 'auto',
            paddingTop: 12,
            paddingBottom: 24
          },
          children: jsxs(Layout, {
            stack: true,
            gap: "--Spacing-400",
            hAlign: "space-between",
            children: [jsx(Typography, {
              variant: "headline",
              size: "xl",
              color: "on-surface-variant",
              weight: 700,
              children: "Account Details"
            }), jsxs(Layout, {
              gap: "--Spacing-200",
              stack: true,
              children: [jsx(TextField, {
                label: "First Name",
                placeholder: "Please enter your first name",
                value: firstName,
                onChange: e => {
                  setFirstName(e.target.value);
                  handleChange('firstName', e.target.value);
                },
                onBlur: () => handleBlur('firstName', firstName),
                error: Boolean(getFieldError('firstName')),
                errorMessage: getFieldError('firstName'),
                dataCy: "onboarding-firstName"
              }), jsx(TextField, {
                label: "Last Name",
                placeholder: "Please enter your last name",
                value: lastName,
                onChange: e => {
                  setLastName(e.target.value);
                  handleChange('lastName', e.target.value);
                },
                onBlur: () => handleBlur('lastName', lastName),
                error: Boolean(getFieldError('lastName')),
                errorMessage: getFieldError('lastName'),
                dataCy: "onboarding-lastName"
              }), jsx(TextField, {
                label: "Company Name",
                placeholder: "Add your company name",
                value: companyName,
                onChange: e => {
                  setCompanyName(e.target.value);
                  handleChange('companyName', e.target.value);
                },
                onBlur: () => handleBlur('companyName', companyName),
                error: Boolean(getFieldError('companyName')),
                errorMessage: getFieldError('companyName'),
                dataCy: "onboarding-companyName"
              }), jsx(TextField, {
                label: "Domain Name",
                placeholder: "eg. MyCompanyName",
                value: domainName,
                onChange: e => {
                  const noSpaces = e.target.value.replace(/\s/g, '');
                  setDomainName(noSpaces);
                  handleChange('domainName', noSpaces);
                },
                onBlur: () => handleBlur('domainName', domainName),
                error: Boolean(getFieldError('domainName')),
                errorMessage: getFieldError('domainName'),
                dataCy: "onboarding-domainName"
              }), jsx(PhoneNumberInput, {
                value: phoneNumber,
                onChange: setPhoneNumber,
                countries: countries,
                defaultCountryCode: defaultCountry.code,
                setCountry: setSelectedCountry,
                country: selectedCountry
              })]
            }), jsxs(Layout, {
              stack: true,
              hAlign: "space-between",
              children: [jsx(Checkbox, {
                checked: featureUpdatesEnabled,
                onChange: () => setFeatureUpdatesEnabled(!featureUpdatesEnabled),
                label: jsx(Typography, {
                  variant: "label",
                  size: "large",
                  weight: 600,
                  color: "on-surface",
                  children: "New Feature Update Email"
                }),
                dataCy: "onboarding-new-feature"
              }), jsx("div", {
                style: {
                  paddingLeft: 40
                },
                children: jsx(Typography, {
                  weight: 300,
                  variant: "body",
                  size: "small",
                  color: "on-surface",
                  children: "We would like to keep you up to date on new feature being developed in Hub Planner by sending you an email now and then. You can disable this later at anytime you wish."
                })
              })]
            })]
          })
        }), jsx(Icon, {
          name: "registration",
          size: 455
        })]
      })
    })]
  });
};
const StepIndicator = () => {
  const {
    selectedTeamSize,
    selectedDepartment,
    submitOnboarding,
    saveProjectFields,
    saveResourceFields,
    loading,
    firstName,
    lastName,
    companyName,
    domainName,
    phoneNumber,
    validateDomain,
    setStep,
    projectCustomFields,
    resourceCustomFields,
    setSkippedFromStep,
    completedWelcomeScreen,
    onStepCallback
  } = useOnboarding();
  const {
    activeStep,
    stepCount,
    previousStep,
    nextStep,
    handleStep,
    goToStep
  } = useWizard();
  const [canGoNext, setCanGoNext] = useState(false);
  const [cfsValid, setCfsValid] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const validateAllRef = useRef(null);
  const firstStep = activeStep === 0;
  const lastStep = activeStep === stepCount - 1;
  const {
    validateAll
  } = useFormValidation({
    validationSchema: getAccountValidationSchema({
      validateDomain
    }),
    initialValues: {
      firstName,
      lastName,
      companyName,
      domainName,
      phoneNumber
    }
  });
  useEffect(() => {
    validateAllRef.current = validateAll;
  }, [validateAll]);
  const validate = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
    if (!validateAllRef.current) return;
    const validated = yield validateAllRef.current({
      firstName,
      lastName,
      companyName,
      domainName,
      phoneNumber
    });
    setCanGoNext(validated);
  }), [firstName, lastName, companyName, domainName, phoneNumber]);
  useEffect(() => {
    validate();
  }, [validate]);
  useEffect(() => {
    const validateCfs = () => __awaiter(void 0, void 0, void 0, function* () {
      if (activeStep === Steps.CF_PROJECTS) {
        const [newErrors] = yield validateCustomFields(projectCustomFields);
        if (Object.keys(newErrors).length) {
          setCfsValid(false);
          return;
        }
        setCfsValid(true);
      }
      if (activeStep === Steps.CF_RESOURCES) {
        const [newErrors] = yield validateCustomFields(resourceCustomFields);
        if (Object.keys(newErrors).length) {
          setCfsValid(false);
          return;
        }
        setCfsValid(true);
      }
    });
    validateCfs();
  }, [activeStep, projectCustomFields, resourceCustomFields]);
  const debouncedNextStep = useMemo(() => {
    const debounced = lodash.exports.debounce(resolve => {
      resolve(nextStep());
    }, 500);
    return () => new Promise(resolve => {
      debounced(resolve);
    });
  }, [nextStep]);
  const goNext = () => __awaiter(void 0, void 0, void 0, function* () {
    if (isSubmitting) return;
    try {
      setIsSubmitting(true);
      const validated = yield validateAll({
        firstName,
        lastName,
        companyName,
        domainName,
        phoneNumber
      });
      if (activeStep === Steps.WELCOME && !validated) {
        return;
      }
      if (activeStep === Steps.CF_PROJECTS) {
        const [newErrors] = yield validateCustomFields(projectCustomFields);
        if (Object.keys(newErrors).length) {
          setCfsValid(false);
          return;
        }
        yield saveProjectFields(projectCustomFields);
        setCfsValid(true);
      }
      if (activeStep === Steps.CF_RESOURCES) {
        const [newErrors] = yield validateCustomFields(resourceCustomFields);
        if (Object.keys(newErrors).length) {
          setCfsValid(false);
          return;
        }
        yield saveResourceFields(resourceCustomFields);
        setCfsValid(true);
      }
      yield debouncedNextStep();
    } finally {
      setIsSubmitting(false);
    }
  });
  const skipToEnd = useCallback(() => {
    setSkippedFromStep(activeStep);
    goToStep(stepCount - 1);
  }, [goToStep, stepCount, activeStep, setSkippedFromStep]);
  handleStep(() => __awaiter(void 0, void 0, void 0, function* () {
    setStep(activeStep + 1);
    if (activeStep !== Steps.WELCOME) {
      yield onStepCallback();
    }
  }));
  useEffect(() => {
    const handleKeyPress = e => {
      const target = e.target;
      if (e.key === 'Escape' && !firstStep && !lastStep && target.tagName !== 'INPUT' && target.tagName !== 'TEXTAREA') {
        skipToEnd();
      }
    };
    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [firstStep, lastStep, skipToEnd]);
  const canPressNext = activeStep === Steps.TEAM_SIZE && true || activeStep === Steps.TEAM_TYPE && true || activeStep === Steps.CF_PROJECTS && cfsValid || activeStep === Steps.CF_RESOURCES && cfsValid || activeStep === Steps.WELCOME && canGoNext && (completedWelcomeScreen || (domainName === null || domainName === void 0 ? void 0 : domainName.trim()));
  const handleGoBack = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
      if (activeStep === Steps.TEAM_SIZE) {
        goToStep(Steps.WELCOME);
        setStep(Steps.WELCOME);
        return;
      }
      if (!selectedTeamSize && activeStep) {
        goToStep(Steps.TEAM_SIZE);
        setStep(Steps.TEAM_SIZE);
        return;
      }
      if (!selectedDepartment && selectedTeamSize && activeStep) {
        if (activeStep === Steps.TEAM_TYPE) {
          setStep(activeStep - 1);
          previousStep();
          return;
        }
        goToStep(Steps.TEAM_TYPE);
        setStep(Steps.TEAM_TYPE);
        return;
      }
      setStep(activeStep - 1);
      previousStep();
    } finally {
      yield onStepCallback();
    }
  });
  const launch = () => __awaiter(void 0, void 0, void 0, function* () {
    goNext();
    yield submitOnboarding();
  });
  const NextButton = activeStep === stepCount - 1 ? jsx(Button, {
    disabled: loading || isSubmitting,
    variant: "filled",
    onClick: () => launch(),
    fullWidth: true,
    dataCy: "onboarding-launch-hub-planner",
    children: "Launch Hub Planner"
  }) : jsx(Button, {
    variant: "outlined",
    disabled: loading || !canPressNext || isSubmitting,
    onClick: () => goNext(),
    endIcon: "arrowForward",
    fullWidth: true,
    dataCy: "onboarding-next",
    children: "Next"
  });
  return jsx("div", {
    style: {
      zIndex: 2
    },
    children: jsxs(Layout, {
      hAlign: "space-between",
      pt: 40,
      children: [jsx(Layout, {
        children: jsx("div", {
          style: {
            width: 141
          },
          children: !firstStep && !lastStep && jsx(Button, {
            variant: "text",
            onClick: skipToEnd,
            dataCy: "onboarding-skip-setup",
            children: "Skip initial setup"
          })
        })
      }), jsxs(Layout, {
        gap: "--Spacing-100",
        children: [jsx("div", {
          style: {
            width: 200
          },
          children: activeStep !== 0 && jsx(Button, {
            variant: "outlined",
            onClick: handleGoBack,
            startIcon: "arrowBack",
            fullWidth: true,
            dataCy: "onboarding-go-back",
            children: "Go Back"
          })
        }), jsx("div", {
          style: {
            width: 200
          },
          children: NextButton
        })]
      }), jsx(StepContainer, {
        children: Array.from({
          length: stepCount
        }, (_, index) => jsx(Step, {
          "$isActive": index === activeStep
        }, index))
      })]
    })
  });
};
const variants = {
  enter: direction => {
    return {
      x: direction > 0 ? 400 : -400,
      opacity: 0
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: direction => {
    return {
      zIndex: 0,
      x: direction < 0 ? 400 : -400,
      opacity: 0
    };
  }
};
const AnimatedStep = /*#__PURE__*/React__default.memo(_ref316 => {
  let {
    children,
    previousStep: previousStepIndex
  } = _ref316;
  const {
    activeStep
  } = useWizard();
  useEffect(() => {
    return () => {
      previousStepIndex.current = activeStep;
    };
  }, [activeStep, previousStepIndex]);
  return jsx(motion.div, {
    custom: activeStep - previousStepIndex.current,
    variants: variants,
    initial: "enter",
    animate: "center",
    exit: "exit",
    transition: {
      type: 'tween',
      duration: 0.2,
      ease: [0.4, 0.0, 0.2, 1]
    },
    style: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      minHeight: 0,
      zIndex: 2
    },
    children: children
  });
});
const Onboarding = () => {
  const previousStep = React__default.useRef(0);
  const {
    loading
  } = useOnboarding();
  if (loading) {
    return jsx(LoadingStep, {});
  }
  return jsxs(Container$2, {
    pl: 96,
    pr: 96,
    pt: 49,
    pb: 43,
    stack: true,
    gap: 50,
    children: [jsx(BGOverlay, {}), jsx(Layout, {
      stack: true,
      fullHeight: true,
      children: jsxs(Wizard, {
        footer: jsx(StepIndicator, {}),
        header: jsx(LogoHeader, {}),
        wrapper: jsx(AnimatePresence, {
          initial: false,
          mode: "wait"
        }),
        children: [jsx(AnimatedStep, {
          previousStep: previousStep,
          children: jsx(WelcomeStep, {})
        }, Steps.WELCOME), jsx(AnimatedStep, {
          previousStep: previousStep,
          children: jsx(TeamSizeStep, {})
        }, Steps.TEAM_SIZE), jsx(AnimatedStep, {
          previousStep: previousStep,
          children: jsx(DepartmentStep, {})
        }, Steps.TEAM_TYPE), jsx(AnimatedStep, {
          previousStep: previousStep,
          children: jsx(CustomFieldStep, {
            category: "resource"
          })
        }, Steps.CF_RESOURCES), jsx(AnimatedStep, {
          previousStep: previousStep,
          children: jsx(CustomFieldStep, {
            category: "project"
          })
        }, Steps.CF_PROJECTS), jsx(AnimatedStep, {
          previousStep: previousStep,
          children: jsx(DemoDataStep, {})
        }, Steps.DEMO_RESOURCES)]
      })
    })]
  });
};
const EMPTY_OBJECT = {};
const EMPTY_ARRAY = [];
const selectResourceGroups = state => state.resourceGroupReducer.resourceGroups;
const selectMappedResourceGroups = createSelector(selectResourceGroups, resourceGroups => {
  return (resourceGroups === null || resourceGroups === void 0 ? void 0 : resourceGroups.length) ? resourceGroups.reduce((acc, group) => {
    var _a;
    (_a = group.resources) === null || _a === void 0 ? void 0 : _a.forEach(resourceId => {
      if (!acc[resourceId]) {
        acc[resourceId] = {};
      }
      acc[resourceId][group._id] = group;
    });
    return acc;
  }, {}) : EMPTY_OBJECT;
});
const selectGroupIdsWhereIAmApprover = createSelector(selectAccountResourceId, selectResourceGroups, (loggedInId, resourceGroups) => {
  return resourceGroups ? resourceGroups.filter(group => {
    var _a;
    return (_a = group.approvers) === null || _a === void 0 ? void 0 : _a.includes(loggedInId);
  }).map(_ref317 => {
    let {
      _id
    } = _ref317;
    return _id;
  }) : EMPTY_ARRAY;
});
const selectResources = state => state.resourceReducer.resources;
const selectResourcesMap = createSelector(selectResources, projects => {
  return projects.reduce((acc, project) => {
    acc[project._id] = project;
    return acc;
  }, {});
});
const makeSelectResourceByIdFromMap = id => createSelector(selectResourcesMap, projectsMap => {
  if (!id) {
    return undefined;
  }
  return projectsMap[id];
});
const makeSelectPermittedResourcesForScheduleRequest = _ref318 => {
  let {
    project,
    resourceType
  } = _ref318;
  return createSelector(selectAccountResourceId, selectIsAccountPm, selectAccountResourceRoleRights, selectResources, selectIsUnassignedExtensionInstalled, selectIsPMExtensionInstalled, (accountResourceId, isPm, resourceRoleRights, resources, isUWExtensionInstalled, isPMExtensionInstalled) => {
    let result = resources;
    const hasFullSchedulingRights = hasRole(resourceRoleRights, 'manageEvents');
    const hasPMSchedulingRights = hasRole(resourceRoleRights, 'pmManageEvents');
    const canRequestResource = hasRole(resourceRoleRights, 'canRequestResource');
    const manageAllResourceRequests = hasRole(resourceRoleRights, 'manageAllResourceRequests');
    const manageUnassignedRows = hasRole(resourceRoleRights, 'manageUnassignedRows');
    const pmManageUnassignedRows = hasRole(resourceRoleRights, 'pmManageUnassignedRows');
    const hasIndividualRights = hasRole(resourceRoleRights, 'scheduleMyselfOnAnyProjectOrEvent');
    const hasLimitedIndividualRights = hasRole(resourceRoleRights, 'scheduleMyselfOnProjectsOrEventsIAmPartOf');
    result = result.filter(resource => {
      if (resourceType && resource.type !== resourceType) {
        return false;
      }
      if (resource.status !== ResourceStatusEnum.STATUS_ACTIVE) {
        return false;
      }
      if (resource._id === accountResourceId) {
        if (hasIndividualRights) {
          return true;
        }
        if (hasLimitedIndividualRights && (!project || (project === null || project === void 0 ? void 0 : project.hasRightsToProject) || (project === null || project === void 0 ? void 0 : project.hasPMRightsToProject) || (project === null || project === void 0 ? void 0 : project.resources.includes(accountResourceId)))) {
          return true;
        }
      }
      if (resource.type === ResourceTypeEnum.UNASSIGNED) {
        return isUWExtensionInstalled && (manageUnassignedRows || isPMExtensionInstalled && isPm && pmManageUnassignedRows || hasFullSchedulingRights || canRequestResource || manageAllResourceRequests) && (resource.hasRightsToResource || (project === null || project === void 0 ? void 0 : project.resources.includes(resource._id)));
      } else {
        return (hasFullSchedulingRights || canRequestResource || manageAllResourceRequests || isPMExtensionInstalled && isPm && hasPMSchedulingRights) && (resource.hasRightsToResource || (project === null || project === void 0 ? void 0 : project.resources.includes(resource._id)));
      }
    });
    return result;
  });
};
const makeSelectPermittedResourcesForRequest = _ref319 => {
  let {
    project,
    resourceType
  } = _ref319;
  return createSelector(selectAccountResourceRoleRights, selectResources, selectIsUnassignedExtensionInstalled, selectIsPMExtensionInstalled, (resourceRoleRights, resources, isUWExtensionInstalled) => {
    let result = resources;
    const canRequestResource = hasRole(resourceRoleRights, 'canRequestResource');
    const manageAllResourceRequests = hasRole(resourceRoleRights, 'manageAllResourceRequests');
    const projectToUse = project && '_id' in project ? project : undefined;
    result = result.filter(resource => {
      var _a, _b;
      if (resourceType && resource.type !== resourceType) {
        return false;
      }
      if (resource.status !== ResourceStatusEnum.STATUS_ACTIVE) {
        return false;
      }
      if (resource.type === ResourceTypeEnum.UNASSIGNED) {
        return isUWExtensionInstalled && (canRequestResource || manageAllResourceRequests) && (resource.hasRightsToResource || ((_a = projectToUse === null || projectToUse === void 0 ? void 0 : projectToUse.resources) === null || _a === void 0 ? void 0 : _a.includes(resource._id)));
      } else {
        if (canRequestResource || manageAllResourceRequests) {
          return resource.hasRightsToResource || ((_b = projectToUse === null || projectToUse === void 0 ? void 0 : projectToUse.resources) === null || _b === void 0 ? void 0 : _b.includes(resource._id));
        }
        return false;
      }
    });
    return result;
  });
};
const roleRights$4 = [{
  rights: ['manageAllVacations'],
  rule: 'all'
}, {
  rights: ['manageAllResourceRequests'],
  rule: 'all'
}];
const canApprove = _ref320 => {
  let {
    booking,
    hasManageAllVacationsRights,
    hasManageAllResourceRequestsRights,
    isVacationExtensionInstalled,
    isRequestResourceExtensionInstalled,
    groupIdsWhereIAmApprover,
    defaultVacationId,
    accountResourceId,
    accountIsApprover,
    mappedResourceGroups,
    bookingResource
  } = _ref320;
  var _a, _b, _c, _d, _e;
  const canManageVacations = isVacationExtensionInstalled && hasManageAllVacationsRights;
  const canManageResourceRequest = isRequestResourceExtensionInstalled && hasManageAllResourceRequestsRights;
  if (!booking) {
    return false;
  }
  const isRequestor = booking.bookingCreatorId === accountResourceId;
  const resourceId = (typeof (booking === null || booking === void 0 ? void 0 : booking.resourceInfo) === 'string' ? booking.resourceInfo : (_a = booking === null || booking === void 0 ? void 0 : booking.resourceInfo) === null || _a === void 0 ? void 0 : _a._id) || (booking === null || booking === void 0 ? void 0 : booking.resource);
  const isApproverOnRequest = accountIsApprover && (accountResourceId && ((_b = bookingResource === null || bookingResource === void 0 ? void 0 : bookingResource.approverIds) === null || _b === void 0 ? void 0 : _b.includes(accountResourceId)) || ((_d = (_c = booking.approvalInfo) === null || _c === void 0 ? void 0 : _c.approvers) === null || _d === void 0 ? void 0 : _d.some(approver => approver.id === accountResourceId)) || resourceId && (groupIdsWhereIAmApprover === null || groupIdsWhereIAmApprover === void 0 ? void 0 : groupIdsWhereIAmApprover.some(groupId => {
    var _a;
    return (_a = mappedResourceGroups[groupId]) === null || _a === void 0 ? void 0 : _a[resourceId];
  })));
  if (isApproverOnRequest) {
    return true;
  }
  const projectId = typeof booking.project === 'string' ? booking.project : (_e = booking.project) === null || _e === void 0 ? void 0 : _e._id;
  const isVacationBooking = projectId === defaultVacationId;
  if (isRequestor) {
    if (isVacationExtensionInstalled && isVacationBooking) {
      return canManageVacations;
    }
    return isRequestResourceExtensionInstalled && canManageResourceRequest;
  }
  if (isVacationExtensionInstalled && isVacationBooking) {
    if (booking.private || booking.isResourcePermitted === false) {
      return false;
    }
    return canManageVacations;
  }
  if (booking.private || booking.isResourcePermitted === false || booking.isProjectPermitted === false) {
    return false;
  }
  return isRequestResourceExtensionInstalled && canManageResourceRequest;
};
const canApproveBooking = (booking, state) => {
  var _a;
  // to be used just by scheduler events or in saga where there is no way to use react hooks
  const accountResourceId = selectAccountResourceId(state);
  const accountIsApprover = selectIsAccountApprover(state);
  const defaultVacationId = selectDefaultVacationId(state);
  const isVacationExtensionInstalled = selectIsVacationRequestExtensionInstalled(state);
  const isRequestResourceExtensionInstalled = selectIsResourceRequestExtensionInstalled(state);
  const mappedResourceGroups = selectMappedResourceGroups(state);
  const groupIdsWhereIAmApprover = selectGroupIdsWhereIAmApprover(state);
  const resourceId = (typeof (booking === null || booking === void 0 ? void 0 : booking.resourceInfo) === 'string' ? booking.resourceInfo : (_a = booking === null || booking === void 0 ? void 0 : booking.resourceInfo) === null || _a === void 0 ? void 0 : _a._id) || (booking === null || booking === void 0 ? void 0 : booking.resource);
  const bookingResource = makeSelectResourceByIdFromMap(resourceId)(state);
  const accountRights = selectAccountResourceRoleRights(state);
  const [hasManageAllVacationsRights, hasManageAllResourceRequestsRights] = hasRoleRights(roleRights$4, accountRights);
  return canApprove({
    booking,
    bookingResource,
    defaultVacationId,
    groupIdsWhereIAmApprover,
    isRequestResourceExtensionInstalled,
    accountResourceId,
    accountIsApprover,
    mappedResourceGroups,
    hasManageAllVacationsRights,
    hasManageAllResourceRequestsRights,
    isVacationExtensionInstalled
  });
};
const useCanApproveBooking = booking => {
  var _a;
  const accountResourceId = useSelector(selectAccountResourceId);
  const accountIsApprover = useSelector(selectIsAccountApprover);
  const defaultVacationId = useSelector(selectDefaultVacationId);
  const isVacationExtensionInstalled = useSelector(selectIsVacationRequestExtensionInstalled);
  const isRequestResourceExtensionInstalled = useSelector(selectIsResourceRequestExtensionInstalled);
  const mappedResourceGroups = useSelector(selectMappedResourceGroups);
  const groupIdsWhereIAmApprover = useSelector(selectGroupIdsWhereIAmApprover);
  const resourceId = (typeof (booking === null || booking === void 0 ? void 0 : booking.resourceInfo) === 'string' ? booking.resourceInfo : (_a = booking === null || booking === void 0 ? void 0 : booking.resourceInfo) === null || _a === void 0 ? void 0 : _a._id) || (booking === null || booking === void 0 ? void 0 : booking.resource);
  const bookingResourceSelector = useMemo(() => makeSelectResourceByIdFromMap(resourceId), [resourceId]);
  const bookingResource = useSelector(bookingResourceSelector);
  const [hasManageAllVacationsRights, hasManageAllResourceRequestsRights] = useHasRoleRights(roleRights$4);
  return useMemo(() => {
    return canApprove({
      booking,
      hasManageAllVacationsRights,
      hasManageAllResourceRequestsRights,
      bookingResource,
      mappedResourceGroups,
      accountIsApprover,
      accountResourceId,
      defaultVacationId,
      groupIdsWhereIAmApprover,
      isRequestResourceExtensionInstalled,
      isVacationExtensionInstalled
    });
  }, [accountIsApprover, accountResourceId, booking, bookingResource, defaultVacationId, groupIdsWhereIAmApprover, hasManageAllResourceRequestsRights, hasManageAllVacationsRights, isRequestResourceExtensionInstalled, isVacationExtensionInstalled, mappedResourceGroups]);
};
const roleRights$3 = [{
  rights: ['manageAllResourceRequests'],
  rule: 'one'
}, {
  rights: ['manageAllVacations'],
  rule: 'one'
}];
const useCanDeleteRequest = booking => {
  const [hasManageAllRequestsRights, hasManageAllVacationRights] = useHasRoleRights(roleRights$3);
  const defaultVacationId = useSelector(selectDefaultVacationId);
  const accountResourceId = useSelector(selectAccountResourceId);
  const accountIsApprover = useSelector(selectIsAccountApprover);
  const mappedResourceGroups = useSelector(selectMappedResourceGroups);
  const isVacationExtensionInstalled = useSelector(selectIsVacationRequestExtensionInstalled);
  const groupIdsWhereIAmApprover = useSelector(selectGroupIdsWhereIAmApprover);
  return useMemo(() => {
    var _a, _b, _c;
    if (!booking) {
      return false;
    }
    const isRequestor = booking.bookingCreatorId === accountResourceId;
    if (isRequestor) {
      return true;
    }
    const resourceId = (typeof (booking === null || booking === void 0 ? void 0 : booking.resourceInfo) === 'string' ? booking.resourceInfo : (_a = booking === null || booking === void 0 ? void 0 : booking.resourceInfo) === null || _a === void 0 ? void 0 : _a._id) || (booking === null || booking === void 0 ? void 0 : booking.resource);
    const isApproverOnRequest = accountIsApprover && (((_c = (_b = booking.approvalInfo) === null || _b === void 0 ? void 0 : _b.approvers) === null || _c === void 0 ? void 0 : _c.some(approver => approver.id === accountResourceId)) || resourceId && (groupIdsWhereIAmApprover === null || groupIdsWhereIAmApprover === void 0 ? void 0 : groupIdsWhereIAmApprover.some(groupId => {
      var _a;
      return (_a = mappedResourceGroups[groupId]) === null || _a === void 0 ? void 0 : _a[resourceId];
    })));
    if (isApproverOnRequest) {
      return true;
    }
    const project = booking.project;
    const projectId = typeof project === 'string' ? project : project === null || project === void 0 ? void 0 : project._id;
    const isVacationBooking = projectId === defaultVacationId;
    if (isVacationExtensionInstalled && isVacationBooking) {
      if (booking.private || booking.isResourcePermitted === false) {
        return false;
      }
      return hasManageAllVacationRights;
    }
    if (booking.private || booking.isResourcePermitted === false || booking.isProjectPermitted === false) {
      return false;
    }
    return hasManageAllRequestsRights;
  }, [accountIsApprover, accountResourceId, booking, defaultVacationId, groupIdsWhereIAmApprover, hasManageAllRequestsRights, hasManageAllVacationRights, isVacationExtensionInstalled, mappedResourceGroups]);
};
const roleRights$2 = [{
  rights: ['canEditRequestResource'],
  rule: 'one'
}, {
  rights: ['canEditRequestVacation'],
  rule: 'one'
}];
const canEdit = _ref321 => {
  let {
    booking,
    accountResourceId,
    defaultVacationId,
    hasEditResourceRequestRights,
    hasEditVacationRequestRights,
    accountIsApprover,
    groupIdsWhereIAmApprover,
    mappedGroupResources,
    isVacationExtensionInstalled
  } = _ref321;
  var _a, _b, _c, _d;
  if (!booking) {
    return false;
  }
  const isRequestor = booking.bookingCreatorId === accountResourceId;
  const resourceId = (typeof (booking === null || booking === void 0 ? void 0 : booking.resourceInfo) === 'string' ? booking.resourceInfo : (_a = booking === null || booking === void 0 ? void 0 : booking.resourceInfo) === null || _a === void 0 ? void 0 : _a._id) || (booking === null || booking === void 0 ? void 0 : booking.resource);
  const isApproverOnRequest = accountIsApprover && (((_c = (_b = booking.approvalInfo) === null || _b === void 0 ? void 0 : _b.approvers) === null || _c === void 0 ? void 0 : _c.some(approver => approver.id === accountResourceId)) || resourceId && (groupIdsWhereIAmApprover === null || groupIdsWhereIAmApprover === void 0 ? void 0 : groupIdsWhereIAmApprover.some(groupId => {
    var _a;
    return (_a = mappedGroupResources[groupId]) === null || _a === void 0 ? void 0 : _a[resourceId];
  })));
  if (isApproverOnRequest || isRequestor) {
    return true;
  }
  const projectId = typeof booking.project === 'string' ? booking.project : (_d = booking.project) === null || _d === void 0 ? void 0 : _d._id;
  const isVacation = projectId === defaultVacationId;
  if (isVacation && isVacationExtensionInstalled) {
    if (booking.private || booking.isResourcePermitted === false) {
      return false;
    }
    return hasEditVacationRequestRights;
  }
  if (booking.private || booking.isResourcePermitted === false || booking.isProjectPermitted === false) {
    return false;
  }
  return hasEditResourceRequestRights;
};
const canEditRequest = (booking, state) => {
  // to be used just by scheduler events or in saga where there is no way to use react hooks
  const accountRights = selectAccountResourceRoleRights(state);
  const [hasEditResourceRequestRights, hasEditVacationRequestRights] = hasRoleRights(roleRights$2, accountRights);
  const defaultVacationId = selectDefaultVacationId(state);
  const accountResourceId = selectAccountResourceId(state);
  const accountIsApprover = selectIsAccountApprover(state);
  const groupIdsWhereIAmApprover = selectGroupIdsWhereIAmApprover(state);
  const mappedGroupResources = selectMappedResourceGroups(state);
  const isVacationExtensionInstalled = selectIsVacationRequestExtensionInstalled(state);
  return canEdit({
    booking,
    defaultVacationId,
    hasEditResourceRequestRights,
    hasEditVacationRequestRights,
    accountResourceId,
    accountIsApprover,
    groupIdsWhereIAmApprover,
    mappedGroupResources,
    isVacationExtensionInstalled
  });
};
const useCanEditRequest = booking => {
  const [hasEditResourceRequestRights, hasEditVacationRequestRights] = useHasRoleRights(roleRights$2);
  const defaultVacationId = useSelector(selectDefaultVacationId);
  const accountResourceId = useSelector(selectAccountResourceId);
  const accountIsApprover = useSelector(selectIsAccountApprover);
  const groupIdsWhereIAmApprover = useSelector(selectGroupIdsWhereIAmApprover);
  const mappedGroupResources = useSelector(selectMappedResourceGroups);
  const isVacationExtensionInstalled = useSelector(selectIsVacationRequestExtensionInstalled);
  return useMemo(() => {
    return canEdit({
      hasEditVacationRequestRights,
      hasEditResourceRequestRights,
      defaultVacationId,
      booking,
      accountResourceId,
      accountIsApprover,
      groupIdsWhereIAmApprover,
      mappedGroupResources,
      isVacationExtensionInstalled
    });
  }, [isVacationExtensionInstalled, mappedGroupResources, accountIsApprover, accountResourceId, booking, defaultVacationId, groupIdsWhereIAmApprover, hasEditResourceRequestRights, hasEditVacationRequestRights]);
};
const roleRights$1 = [{
  rights: ['canRequestResource'],
  rule: 'all'
}, {
  rights: ['manageAllResourceRequests'],
  rule: 'all'
}, {
  rights: ['canRequestVacation'],
  rule: 'all'
}, {
  rights: ['manageAllVacations'],
  rule: 'all'
}];
const canRequestInner = _ref322 => {
  let {
    canRequestVacation,
    canRequestResource,
    manageAllResourceRequests,
    manageAllVacation,
    project,
    resource,
    isVacationExtInstalled,
    defaultVacationId
  } = _ref322;
  if (!project || !resource) {
    return false;
  }
  let createRight = canRequestResource;
  let manageAllRight = manageAllResourceRequests;
  if (isVacationExtInstalled && project._id === defaultVacationId) {
    createRight = canRequestVacation;
    manageAllRight = manageAllVacation;
  }
  if (!createRight && !manageAllRight) {
    return false;
  }
  return resource.hasRightsToResource || project.resources.includes(resource._id);
};
const canRequest = (_ref323, state) => {
  let {
    project,
    resource
  } = _ref323;
  // to be used just by scheduler events or in saga where there is no way to use react hooks
  const accountRights = selectAccountResourceRoleRights(state);
  const [canRequestResource, manageAllResourceRequests, canRequestVacation, manageAllVacation] = hasRoleRights(roleRights$1, accountRights);
  const defaultVacationId = selectDefaultVacationId(state);
  const isVacationExtInstalled = selectIsVacationRequestExtensionInstalled(state);
  return canRequestInner({
    project,
    resource,
    defaultVacationId,
    isVacationExtInstalled,
    manageAllResourceRequests,
    manageAllVacation,
    canRequestResource,
    canRequestVacation
  });
};
const useCanRequest = _ref324 => {
  let {
    project,
    resource
  } = _ref324;
  const [canRequestResource, manageAllResourceRequests, canRequestVacation, manageAllVacation] = useHasRoleRights(roleRights$1);
  const defaultVacationId = useSelector(selectDefaultVacationId);
  const isVacationExtInstalled = useSelector(selectIsVacationRequestExtensionInstalled);
  return useMemo(() => {
    return canRequestInner({
      project,
      resource,
      canRequestResource,
      canRequestVacation,
      manageAllVacation,
      defaultVacationId,
      isVacationExtInstalled,
      manageAllResourceRequests
    });
  }, [canRequestResource, canRequestVacation, defaultVacationId, isVacationExtInstalled, manageAllResourceRequests, manageAllVacation, project, resource]);
};
const selectProjects = state => state.projectReducer.projects;
const selectProjectsMap = createSelector(selectProjects, projects => {
  return projects.reduce((acc, project) => {
    acc[project._id] = project;
    return acc;
  }, {});
});
const makeSelectProjectByIdFromMap = id => createSelector(selectProjectsMap, projectsMap => {
  if (!id) {
    return undefined;
  }
  return projectsMap[id];
});
const makeSelectPermittedProjectsForScheduleRequest = _ref325 => {
  let {
    resource,
    projectType
  } = _ref325;
  return createSelector(selectAccountResourceId, selectIsAccountPm, selectAccountResourceRoleRights, selectProjects, selectIsUnassignedExtensionInstalled, selectIsPMExtensionInstalled, selectIsVacationRequestExtensionInstalled, selectDefaultVacationId, (accountResourceId, isPm, resourceRoleRights, projects, isUWExtensionInstalled, isPMExtensionInstalled, isVacationExtensionInstalled, defaultVacationId) => {
    let result = projects.filter(project => project.status !== ProjectStatusEnum.STATUS_ARCHIVED);
    const hasFullSchedulingRights = hasRole(resourceRoleRights, 'manageEvents');
    const hasPMSchedulingRights = hasRole(resourceRoleRights, 'pmManageEvents');
    const canRequestResource = hasRole(resourceRoleRights, 'canRequestResource');
    const manageAllResourceRequests = hasRole(resourceRoleRights, 'manageAllResourceRequests');
    const manageUnassignedRows = hasRole(resourceRoleRights, 'manageUnassignedRows');
    const pmManageUnassignedRows = hasRole(resourceRoleRights, 'pmManageUnassignedRows');
    const hasIndividualRights = hasRole(resourceRoleRights, 'scheduleMyselfOnAnyProjectOrEvent');
    const hasLimitedIndividualRights = hasRole(resourceRoleRights, 'scheduleMyselfOnProjectsOrEventsIAmPartOf');
    const manageAllVacations = hasRole(resourceRoleRights, 'manageAllVacations');
    const canRequestVacation = hasRole(resourceRoleRights, 'canRequestVacation');
    if (projectType) {
      result = result.filter(project => project.type === projectType);
    }
    if (!resource) {
      if (hasIndividualRights) {
        return result;
      }
      return result.filter(project => project.hasRightsToProject || project.hasPMRightsToProject);
    }
    const requestMyself = resource._id === accountResourceId;
    if (requestMyself) {
      if (hasIndividualRights) {
        return result;
      }
      if (hasLimitedIndividualRights) {
        return result.filter(project => project.hasRightsToProject || project.resourceIds.includes(accountResourceId));
      }
    }
    const resourceProjectsMap = new Map();
    projects.filter(project => project.resources.includes(resource._id)).forEach(project => {
      resourceProjectsMap.set(project._id, project._id);
    });
    const isVacationEvent = project => {
      if (!isVacationExtensionInstalled) {
        // when no ext installed we trait it like a normal event
        return false;
      }
      return project._id === defaultVacationId;
    };
    const roleChecker = [hasFullSchedulingRights ? project => {
      return project.hasRightsToProject || resource.hasRightsToResource && resourceProjectsMap.has(project._id);
    } : undefined, hasPMSchedulingRights ? project => {
      return project.hasRightsToProject || project.hasPMRightsToProject;
    } : undefined, manageUnassignedRows && isUWExtensionInstalled ? project => {
      return project.hasRightsToProject;
    } : undefined, pmManageUnassignedRows && isUWExtensionInstalled && isPMExtensionInstalled && isPm ? project => {
      return project.hasRightsToProject || project.hasPMRightsToProject;
    } : undefined, manageAllResourceRequests ? project => {
      return project.hasRightsToProject && !isVacationEvent(project);
    } : undefined, canRequestResource ? project => {
      return !isVacationEvent(project) && (project.hasRightsToProject || resource.hasRightsToResource && resourceProjectsMap.has(project._id));
    } : undefined, manageAllVacations ? project => {
      return project.hasRightsToProject && isVacationEvent(project);
    } : undefined, canRequestVacation ? project => {
      return isVacationEvent(project) && (project.hasRightsToProject || resource.hasRightsToResource && resourceProjectsMap.has(project._id));
    } : undefined].filter(fn => {
      return Boolean(fn);
    });
    return result.filter(project => {
      return project.status !== ProjectStatusEnum.STATUS_ARCHIVED && roleChecker.some(fn => fn(project));
    });
  });
};
const isSchedulerItemABookingType = booking => {
  if (!booking) {
    return false;
  }
  if (typeof booking === 'object' && Object.keys(booking).length === 0) {
    return false;
  }
  return !('datesEvent' in booking) && !('phase' in booking) && !('milestone' in booking) && !('deadline' in booking) && Boolean(booking._id);
};
const isSchedulerItemADeadlineType = booking => {
  if (!booking) {
    return false;
  }
  if (typeof booking === 'object' && Object.keys(booking).length === 0) {
    return false;
  }
  return 'deadline' in booking && booking.deadline;
};
const isSchedulerItemAPhaseType = booking => {
  if (!booking) {
    return false;
  }
  if (typeof booking === 'object' && Object.keys(booking).length === 0) {
    return false;
  }
  return 'phase' in booking && booking.phase;
};
const isSchedulerItemAMilestoneType = booking => {
  if (!booking) {
    return false;
  }
  if (typeof booking === 'object' && Object.keys(booking).length === 0) {
    return false;
  }
  return 'milestone' in booking && booking.milestone;
};
const isSchedulerItemADatesEventType = booking => {
  if (!booking) {
    return false;
  }
  if (typeof booking === 'object' && Object.keys(booking).length === 0) {
    return false;
  }
  return 'datesEvent' in booking && booking.datesEvent;
};
const selectSchedulerCurrentSelectedBooking = state => state.scheduler.currentSelectedBooking;
const selectSchedulerCurrentSelection = state => state.scheduler.currentSelection;
const selectSchedulerClipboard = state => state.scheduler.clipboard;
const selectSchedulerCurrentView = state => state.scheduler.currentView;
const selectContextMenuScheduleInitialData = state => state.scheduler.contextMenuScheduleInitialData;
const selectSchedulerSelectedBookingProject = createSelector(selectProjectsMap, selectSchedulerCurrentSelectedBooking, (projectsMap, selectedBooking) => {
  var _a, _b, _c;
  let id = undefined;
  if (isSchedulerItemABookingType(selectedBooking)) {
    id = (_a = selectedBooking.project) === null || _a === void 0 ? void 0 : _a._id;
  } else if (isSchedulerItemADeadlineType(selectedBooking)) {
    id = (_c = (_b = selectedBooking.booking) === null || _b === void 0 ? void 0 : _b.project) === null || _c === void 0 ? void 0 : _c._id;
  } else if (isSchedulerItemAPhaseType(selectedBooking)) {
    id = selectedBooking.project || selectedBooking.projectId;
  } else if (isSchedulerItemAMilestoneType(selectedBooking)) {
    id = selectedBooking.project || selectedBooking.projectId;
  } else if (isSchedulerItemADatesEventType(selectedBooking)) {
    id = selectedBooking.project || selectedBooking.projectId;
  }
  if (!id) {
    return undefined;
  }
  return projectsMap[id];
});
const selectIsSelectedBookingPhase = createSelector(selectSchedulerCurrentSelectedBooking, selectedBooking => {
  if (!selectedBooking) {
    return false;
  }
  return 'phase' in selectedBooking && selectedBooking.phase;
});
const selectIsSelectedBookingMilestone = createSelector(selectSchedulerCurrentSelectedBooking, selectedBooking => {
  if (!selectedBooking) {
    return false;
  }
  return 'milestone' in selectedBooking && selectedBooking.milestone;
});
const selectIsSelectedBookingDatesEvent = createSelector(selectSchedulerCurrentSelectedBooking, selectedBooking => {
  if (!selectedBooking) {
    return false;
  }
  return 'datesEvent' in selectedBooking && selectedBooking.datesEvent;
});
const useCanRequestVacationForSelection = () => {
  const currentSelection = useSelector(selectSchedulerCurrentSelection);
  const isDefaultVacationEventSet = useSelector(selectIsDefaultVacationEventSet);
  const isVacationRequestExtensionInstalled = useSelector(selectIsVacationRequestExtensionInstalled);
  return useMemo(() => {
    const {
      rowTags
    } = currentSelection || {};
    const {
      hasRequestVacationRights,
      resource,
      menuRow
    } = rowTags || {};
    return isDefaultVacationEventSet && hasRequestVacationRights && resource && !menuRow && isVacationRequestExtensionInstalled;
  }, [currentSelection, isDefaultVacationEventSet, isVacationRequestExtensionInstalled]);
};
const getRequestUrls = resourceId => ({
  requestUrl: "/requests/team-resource-requests?flow=RES_REQUEST_FLOW_SINGLE&resourceId=".concat(resourceId),
  vacationUrl: "/requests/vacation-requests?flow=VACATION_FLOW_SINGLE&resourceId=".concat(resourceId)
});
const changeActiveLinkFromLocation = () => ({
  type: 'CHANGE_ACTIVE_LINK_FROM_LOCATION'
});
const menuActions = {
  changeActiveLinkFromLocation
};
const showDeleteConfirmationModal = params => ({
  type: 'SHOW_MODAL',
  modalType: 'DELETE_CONFIRMATION_MODAL',
  payload: params
});
const showConfirmationModal = function (onConfirm, title, message) {
  let {
    withCancel,
    onReject,
    confirmButtonText,
    confirmButtonDataCy,
    cancelButtonText,
    withEscButton,
    cancelActionOnHide,
    additionalButtons
  } = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return {
    type: 'SHOW_MODAL',
    modalType: 'CONFIRMATION_MODAL',
    payload: {
      onConfirm,
      title,
      message,
      additional: {
        withCancel,
        onReject,
        confirmButtonText,
        confirmButtonDataCy,
        cancelButtonText,
        withEscButton,
        cancelActionOnHide,
        additionalButtons
      }
    }
  };
};
const showResourceModal = _ref326 => {
  let {
    onSubmit,
    onClose,
    type,
    resourceId
  } = _ref326;
  return {
    type: 'SHOW_MODAL',
    modalType: 'RESOURCE_MODAL',
    payload: {
      onSubmit,
      type,
      resourceId,
      onClose
    }
  };
};
const showProjectModal = _ref327 => {
  let {
    onSubmit,
    type,
    onClose,
    projectId,
    initialData: _initialData = {}
  } = _ref327;
  return {
    type: 'SHOW_MODAL',
    modalType: 'PROJECT_MODAL',
    payload: {
      onSubmit,
      type,
      projectId,
      initialData: _initialData,
      onClose
    }
  };
};
const showEditRequestResourceModal = (onSubmit, booking) => ({
  type: 'SHOW_MODAL',
  modalType: 'EDIT_REQUEST_RESOURCE_MODAL',
  payload: {
    onSubmit,
    booking
  }
});
const showMissingDeadlinesExtensionModal = () => ({
  type: 'SHOW_MODAL',
  modalType: 'MISSING_DEADLINES_MODAL'
});
const showMissingDependenciesExtensionModal = () => ({
  type: 'SHOW_MODAL',
  modalType: 'MISSING_DEPENDENCIES_MODAL'
});
const modalActions = {
  showDeleteConfirmationModal,
  showConfirmationModal,
  showResourceModal,
  showProjectModal,
  showMissingDeadlinesExtensionModal,
  showMissingDependenciesExtensionModal,
  showEditRequestResourceModal
};
const updateResourceOrVacationRequest = _ref328 => {
  let {
    booking,
    bookingId,
    options
  } = _ref328;
  return {
    type: 'EDIT_RESOURCE_VACATION_REQUEST',
    payload: {
      booking,
      bookingId,
      options
    }
  };
};
const requestsActions = {
  updateResourceOrVacationRequest
};
const ApprovalContextMenuContext = /*#__PURE__*/createContext({
  onClose: () => {
    // do nothing
  },
  onApproveRejectRequest: (action, note) => {
    // do nothing
  },
  onDashboardClick: () => {
    // do nothing
  },
  onEditClick: () => {
    // do nothing
  },
  onDeleteClick: () => {
    // do nothing
  }
});
const useApprovalContextMenuContext = () => {
  return useContext(ApprovalContextMenuContext);
};
const ApprovalMenuContextProvider = props => {
  const {
    children,
    onClose: onCloseProp,
    onUpdateBooking: onUpdateBookingProp,
    onDeleteBooking: onDeleteBookingProp
  } = props;
  const dispatch = useDispatch();
  const currentSelectedBooking = useSelector(selectSchedulerCurrentSelectedBooking);
  const resourceId = useSelector(selectAccountResourceId);
  const vacationId = useSelector(selectDefaultVacationId);
  const sickLeaveId = useSelector(selectSickLeaveId);
  const onClose = useCallback(() => {
    if (!onCloseProp) {
      return;
    }
    onCloseProp();
  }, [onCloseProp]);
  const onApproveRejectRequest = useCallback((type, note) => {
    if (!onUpdateBookingProp || !isSchedulerItemABookingType(currentSelectedBooking)) {
      return;
    }
    onUpdateBookingProp({
      type,
      id: currentSelectedBooking.id,
      repeat: currentSelectedBooking.repeat,
      repeatId: currentSelectedBooking.repeatId,
      interval: currentSelectedBooking.interval,
      repeatEndsOnDate: currentSelectedBooking.repeatEndsOnDate,
      repeatEndsAfterTimes: currentSelectedBooking.repeatEndsAfterTimes,
      repeatEveryTime: currentSelectedBooking.repeatEveryTime,
      repeatEveryInterval: currentSelectedBooking.repeatEveryInterval,
      repeatOnWeekdays: currentSelectedBooking.repeatOnWeekdays,
      repeatOn: currentSelectedBooking.repeatOn,
      repeatOnDates: currentSelectedBooking.repeatOnDates,
      repeatOnCustom1: currentSelectedBooking.repeatOnCustom1,
      repeatOnCustom2: currentSelectedBooking.repeatOnCustom2,
      approvalInfo: {
        approvedOrRejectedById: resourceId,
        approvedOrRejectedDate: new Date(),
        approverNote: note
      }
    });
  }, [currentSelectedBooking, onUpdateBookingProp, resourceId]);
  const onEditClick = useCallback(() => {
    if (!onCloseProp) {
      return;
    }
    dispatch(modalActions.showEditRequestResourceModal(data => {
      dispatch(requestsActions.updateResourceOrVacationRequest(data));
    }, currentSelectedBooking));
    onCloseProp();
  }, [currentSelectedBooking, dispatch, onCloseProp]);
  const onDashboardClick = useCallback(() => {
    var _a;
    if (!isSchedulerItemABookingType(currentSelectedBooking) || !onCloseProp) {
      return;
    }
    const {
      requestUrl,
      vacationUrl
    } = getRequestUrls(currentSelectedBooking.resourceInfo._id);
    const requestLink = [vacationId, sickLeaveId].includes((_a = currentSelectedBooking === null || currentSelectedBooking === void 0 ? void 0 : currentSelectedBooking.project) === null || _a === void 0 ? void 0 : _a._id) ? vacationUrl : requestUrl;
    window.location.hash = requestLink;
    dispatch(menuActions.changeActiveLinkFromLocation());
    onCloseProp();
  }, [currentSelectedBooking, dispatch, onCloseProp, sickLeaveId, vacationId]);
  const onDeleteClick = useCallback(() => {
    if (!onDeleteBookingProp || !isSchedulerItemABookingType(currentSelectedBooking)) {
      return;
    }
    dispatch(modalActions.showDeleteConfirmationModal({
      title: 'Delete request',
      message: 'Do you really want do delete this request?',
      onConfirm: () => {
        onDeleteBookingProp(currentSelectedBooking);
        onCloseProp === null || onCloseProp === void 0 ? void 0 : onCloseProp();
      }
    }));
  }, [currentSelectedBooking, dispatch, onCloseProp, onDeleteBookingProp]);
  return jsx(ApprovalContextMenuContext.Provider, {
    value: {
      onClose,
      onApproveRejectRequest,
      onDashboardClick,
      onEditClick,
      onDeleteClick
    },
    children: children
  });
};
const ClassicApprovalContextMenuInner = /*#__PURE__*/React__default.memo(props => {
  const {
    position,
    anchorEl,
    booking
  } = props;
  const {
    onClose,
    onApproveRejectRequest,
    onDashboardClick,
    onEditClick,
    onDeleteClick
  } = useApprovalContextMenuContext();
  const canApproveBooking = useCanApproveBooking(booking);
  const canEditRequest = useCanEditRequest(booking);
  const canDeleteRequest = useCanDeleteRequest(booking);
  const menuItems = useMemo(() => {
    return [{
      hidden: !canApproveBooking,
      label: 'Approve',
      dataCy: 'legacy-menu-approve-request',
      onClick: () => {
        onApproveRejectRequest(BookingTypeEnum.APPROVED);
      }
    }, {
      hidden: !canApproveBooking,
      label: 'Reject',
      dataCy: 'legacy-menu-reject-request',
      onClick: () => {
        onApproveRejectRequest(BookingTypeEnum.REJECTED);
      }
    }, {
      hidden: !canApproveBooking,
      divider: true
    }, {
      label: 'Request dashboard',
      dataCy: 'legacy-menu-request-dashboard',
      onClick: () => {
        onDashboardClick();
      }
    }, {
      hidden: !canEditRequest,
      divider: true
    }, {
      hidden: !canEditRequest,
      label: 'Edit request',
      dataCy: 'legacy-menu-edit-request',
      onClick: () => {
        onEditClick();
      }
    }, {
      hidden: !canDeleteRequest,
      label: 'Delete request',
      dataCy: 'legacy-menu-delete-request',
      onClick: () => {
        onDeleteClick();
      }
    }];
  }, [canApproveBooking, canDeleteRequest, canEditRequest, onApproveRejectRequest, onDashboardClick, onDeleteClick, onEditClick]);
  return jsx(ContextMenu, {
    variant: "anchor",
    items: menuItems,
    isOpen: true,
    anchorEl: anchorEl,
    position: position,
    onClose: onClose
  });
});
const ClassicApprovalContextMenu = props => {
  const booking = useSelector(selectSchedulerCurrentSelectedBooking);
  if (!isSchedulerItemABookingType(booking)) {
    return null;
  }
  return jsx(ClassicApprovalContextMenuInner, Object.assign({}, props, {
    booking: booking
  }));
};
const BackSection = /*#__PURE__*/React__default.memo(props => {
  return jsx(Layout, {
    hAlign: "space-between",
    vAlign: "center",
    children: jsx(Button, {
      variant: "text",
      startIcon: "navigateBefore",
      onClick: props.onClick,
      dataCy: "scheduler-booking-modern-menu-back-button",
      children: "Back"
    })
  });
});
const NoteForm = /*#__PURE__*/React__default.memo(props => {
  const {
    variant,
    onBackClick
  } = props;
  const [note, setNote] = useState(undefined);
  const {
    onClose,
    onApproveRejectRequest
  } = useApprovalContextMenuContext();
  const handleChange = useCallback(event => {
    setNote(event.target.value);
  }, []);
  const handleSubmit = useCallback(() => {
    if (variant === 'approve') {
      onApproveRejectRequest(BookingTypeEnum.APPROVED, note);
    } else if (variant === 'reject') {
      onApproveRejectRequest(BookingTypeEnum.REJECTED, note);
    }
    onClose();
  }, [note, onApproveRejectRequest, onClose, variant]);
  const submitBtnDisabled = !note;
  return jsxs(Layout, {
    stack: true,
    gap: "--Spacing-200",
    fullHeight: true,
    children: [jsx(BackSection, {
      onClick: onBackClick
    }), jsx(Layout, {
      stack: true,
      flex: "1 1 auto",
      children: jsx(TextField, {
        name: "note",
        label: "Note",
        dataCy: "note-text-field",
        multiline: true,
        minRows: 4,
        maxRows: 4,
        onChange: handleChange
      })
    }), jsx(Layout, {
      hAlign: "flex-end",
      children: jsx(Button, {
        onClick: handleSubmit,
        disabled: submitBtnDisabled,
        dataCy: variant === 'approve' ? 'button--mod-menu-with-note-Approve' : 'button--mod-menu-with-note-Reject',
        children: variant === 'approve' ? 'Approve with a note' : 'Reject with a note'
      })
    })]
  });
});
const SLIDE_NUMBERS$6 = {
  approveWithNote: 0,
  rejectWithNote: 1
};
const StyledSlides$3 = /*#__PURE__*/styled(Slides).withConfig({
  displayName: "modern__StyledSlides",
  componentId: "l7qgvy-0"
})(["width:415px;height:375px;"]);
const ModernApprovalContextMenuInner = /*#__PURE__*/React__default.memo(props => {
  const {
    position,
    anchorEl,
    booking
  } = props;
  const canApproveBooking = useCanApproveBooking(booking);
  const canEditRequest = useCanEditRequest(booking);
  const canDeleteRequest = useCanDeleteRequest(booking);
  const {
    onClose,
    onApproveRejectRequest,
    onDashboardClick,
    onEditClick,
    onDeleteClick
  } = useApprovalContextMenuContext();
  const title = undefined;
  const content = jsx(StyledSlides$3, {
    mainComponent: _ref329 => {
      let {
        toSlidesGroup
      } = _ref329;
      return jsxs(Layout, {
        stack: true,
        stretch: true,
        gap: "--Spacing-200",
        children: [jsx(Layout, {
          flex: "1 1 auto",
          stack: true,
          stretch: true,
          children: jsx(List$1, {
            onItemClick: item => {
              item.onClick();
            },
            rowRenderer: item => {
              return jsx(ListItem, {
                label: item.label,
                startAdornment: item.icon,
                endAdornment: item.hasNextSlide ? 'navigateNext' : undefined
              });
            },
            items: [{
              hidden: !canApproveBooking,
              hasNextSlide: true,
              dataCy: 'button--approve-with-note',
              onClick: () => {
                toSlidesGroup(SLIDE_NUMBERS$6.approveWithNote);
              },
              label: 'Approve with a note',
              icon: 'check'
            }, {
              hidden: !canApproveBooking,
              hasNextSlide: true,
              dataCy: 'button--reject-with-note',
              onClick: () => {
                toSlidesGroup(SLIDE_NUMBERS$6.rejectWithNote);
              },
              label: 'Reject with a note',
              icon: 'close'
            }, {
              hasNextSlide: false,
              label: 'Request dashboard',
              dataCy: 'button--request-dashboard',
              icon: 'timesheets',
              onClick: () => {
                onDashboardClick();
              }
            }, {
              hidden: !canEditRequest,
              hasNextSlide: false,
              label: 'Edit request',
              dataCy: 'button--edit-request',
              icon: 'edit',
              onClick: () => {
                onEditClick();
              }
            }, {
              hidden: !canDeleteRequest,
              hasNextSlide: false,
              label: 'Delete request',
              dataCy: 'button--delete-request',
              icon: 'delete',
              onClick: () => {
                onDeleteClick();
              }
            }]
          })
        }), canApproveBooking ? jsxs(Layout, {
          gap: "--Spacing-100",
          hAlign: "flex-end",
          children: [jsx(Button, {
            variant: "outlined",
            dataCy: "button--reject",
            onClick: () => {
              onApproveRejectRequest(BookingTypeEnum.REJECTED);
              onClose();
            },
            children: "Reject"
          }), jsx(Button, {
            dataCy: "button--approve",
            onClick: () => {
              onApproveRejectRequest(BookingTypeEnum.APPROVED);
              onClose();
            },
            children: "Approve"
          })]
        }) : null]
      });
    },
    items: _ref330 => {
      let {
        topSlide
      } = _ref330;
      return [[jsx(NoteForm, {
        variant: "approve",
        onBackClick: topSlide
      })], [jsx(NoteForm, {
        variant: "reject",
        onBackClick: topSlide
      })]];
    }
  });
  const actions = undefined;
  return jsx(Dialog, {
    open: true,
    title: title,
    content: content,
    actions: actions,
    onClose: onClose,
    position: position,
    anchorElement: anchorEl,
    level: "default",
    hideBackdrop: true
  });
});
const ModernApprovalContextMenu = props => {
  const booking = useSelector(selectSchedulerCurrentSelectedBooking);
  if (!isSchedulerItemABookingType(booking)) {
    return null;
  }
  return jsx(ModernApprovalContextMenuInner, Object.assign({}, props, {
    booking: booking
  }));
};
const ApprovalContextMenu = props => {
  const {
    isOpen,
    position,
    anchorEl,
    onClose,
    onUpdateBooking,
    onDeleteBooking
  } = props;
  const modern = useSelector(selectIsGridModernMenuUsed);
  if (!isOpen) {
    return null;
  }
  return jsx(ApprovalMenuContextProvider, {
    onClose: onClose,
    onUpdateBooking: onUpdateBooking,
    onDeleteBooking: onDeleteBooking,
    children: jsx("div", {
      children: modern ? jsx(ModernApprovalContextMenu, {
        position: position,
        anchorEl: anchorEl
      }) : jsx(ClassicApprovalContextMenu, {
        position: position,
        anchorEl: anchorEl
      })
    })
  });
};
const useCanPasteBooking = () => {
  const currentSelection = useSelector(selectSchedulerCurrentSelection);
  const rowTags = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags;
  const clipboard = useSelector(selectSchedulerClipboard);
  return useMemo(() => {
    var _a;
    const isEventCopied = (_a = clipboard === null || clipboard === void 0 ? void 0 : clipboard.resource) === null || _a === void 0 ? void 0 : _a.includes('eventsRow_');
    const areRowTagsEmpty = rowTags ? !Object.keys(rowTags).length : true;
    let pasteBookingDisabled = !clipboard || !rowTags || areRowTagsEmpty || rowTags.menuRow || rowTags.isEventRow || rowTags.unassignedParentRow || rowTags.parent || isEventCopied;
    const isPermitted = (rowTags === null || rowTags === void 0 ? void 0 : rowTags.hasOnlyScheduleRights) && (clipboard === null || clipboard === void 0 ? void 0 : clipboard.type) === BookingTypeEnum.SCHEDULED;
    if (isEventCopied && clipboard && rowTags && !areRowTagsEmpty) {
      pasteBookingDisabled = !rowTags.isEventRow;
    }
    return !pasteBookingDisabled && isPermitted;
  }, [clipboard, rowTags]);
};
const rights$a = [{
  rule: 'one',
  rights: ['settingAddEditProjects']
}];
const useCanEditProject = _ref331 => {
  let {
    project
  } = _ref331;
  const [hasEditProjectRights] = useHasRoleRights(rights$a);
  const selector = useMemo(() => {
    if (typeof project === 'string') {
      return makeSelectProjectByIdFromMap(project);
    }
    return makeSelectProjectByIdFromMap(project === null || project === void 0 ? void 0 : project._id);
  }, [project]);
  const storeProject = useSelector(selector);
  return useMemo(() => {
    if (!project) {
      return false;
    }
    let projectToCheck;
    if (typeof project !== 'string' && 'hasRightsToProject' in project) {
      projectToCheck = project;
    } else {
      projectToCheck = storeProject;
    }
    if (!projectToCheck) {
      return undefined;
    }
    return hasEditProjectRights && (projectToCheck.hasRightsToProject || projectToCheck.hasPMRightsToProject);
  }, [hasEditProjectRights, project, storeProject]);
};
const rights$9 = [{
  rights: ['settingAddEditResources'],
  rule: 'all'
}];
const useCanEditResource = _ref332 => {
  let {
    resource
  } = _ref332;
  const [canEditResource] = useHasRoleRights(rights$9);
  const selector = useMemo(() => {
    return makeSelectResourceByIdFromMap(resource === null || resource === void 0 ? void 0 : resource._id);
  }, [resource === null || resource === void 0 ? void 0 : resource._id]);
  const storeResource = useSelector(selector);
  return useMemo(() => {
    if (!resource) {
      return false;
    }
    let resourceToCheck;
    if ('hasRightsToResource' in resource) {
      resourceToCheck = resource;
    } else {
      resourceToCheck = storeResource;
    }
    if (!resourceToCheck) {
      return false;
    }
    return canEditResource && resourceToCheck.hasRightsToResource;
  }, [canEditResource, resource, storeResource]);
};
const rights$8 = [{
  rights: ['settingAddEditResources', 'settingResourceWd'],
  rule: 'all'
}];
const useCanEditResourceWorkHours = _ref333 => {
  let {
    resource
  } = _ref333;
  const [canEditWorkHours] = useHasRoleRights(rights$8);
  return useMemo(() => {
    if (!resource) {
      return false;
    }
    return canEditWorkHours && resource.type === ResourceTypeEnum.REGULAR && resource.hasRightsToResource;
  }, [canEditWorkHours, resource]);
};
const roleRights = [{
  rights: ['manageEvents'],
  rule: 'all'
}, {
  rights: ['pmManageEvents'],
  rule: 'all'
}, {
  rights: ['manageUnassignedRows'],
  rule: 'all'
}, {
  rights: ['pmManageUnassignedRows'],
  rule: 'all'
}, {
  rights: ['scheduleMyselfOnAnyProjectOrEvent'],
  rule: 'all'
}, {
  rights: ['scheduleMyselfOnProjectsOrEventsIAmPartOf'],
  rule: 'all'
}];
const useCanSchedule = _ref334 => {
  let {
    project,
    resource
  } = _ref334;
  const accountResourceId = useSelector(selectAccountResourceId);
  const isAccountPm = useSelector(selectAccountResourceId);
  const isUWExtensionInstalled = useSelector(selectIsUnassignedExtensionInstalled);
  const isPMExtensionInstalled = useSelector(selectIsPMExtensionInstalled);
  const [hasFullSchedulingRights, hasPMSchedulingRights, manageUnassignedRows, pmManageUnassignedRows, hasIndividualRights, hasLimitedIndividualRights] = useHasRoleRights(roleRights);
  return useMemo(() => {
    if (!project || !resource) {
      return false;
    }
    const scheduleMyself = resource._id === accountResourceId;
    if (scheduleMyself) {
      if (hasIndividualRights) {
        return true;
      }
      if (hasLimitedIndividualRights) {
        return project.hasRightsToProject || project.hasPMRightsToProject || project.resources.includes(resource._id);
      }
    }
    if (resource.type === ResourceTypeEnum.UNASSIGNED) {
      if (!isUWExtensionInstalled) {
        return false;
      }
      if (manageUnassignedRows || hasFullSchedulingRights) {
        return project.hasRightsToProject && (resource.hasRightsToResource || project.resources.includes(resource._id));
      }
      if (isPMExtensionInstalled && isAccountPm && pmManageUnassignedRows || isPMExtensionInstalled && isAccountPm && hasPMSchedulingRights) {
        return project.hasPMRightsToProject && (resource.hasRightsToResource || project.resources.includes(resource._id));
      }
    }
    if (resource.type === ResourceTypeEnum.REGULAR) {
      if (hasFullSchedulingRights) {
        return project.hasRightsToProject && (resource.hasRightsToResource || project.resources.includes(resource._id)) || resource.hasRightsToResource && project.resources.includes(resource._id);
      }
      if (isPMExtensionInstalled && isAccountPm && hasPMSchedulingRights) {
        return project.hasPMRightsToProject && (resource.hasRightsToResource || project.resources.includes(resource._id));
      }
    }
    return false;
  }, [accountResourceId, hasFullSchedulingRights, hasIndividualRights, hasLimitedIndividualRights, hasPMSchedulingRights, isAccountPm, isPMExtensionInstalled, isUWExtensionInstalled, manageUnassignedRows, pmManageUnassignedRows, project, resource]);
};
const isResource = resource => {
  return (resource === null || resource === void 0 ? void 0 : resource.type) === ResourceTypeEnum.REGULAR;
};
var global$1 = global$q;
var fails$2 = fails$y;
var uncurryThis$3 = functionUncurryThis;
var toString$2 = toString$g;
var trim = stringTrim.trim;
var whitespaces = whitespaces$4;
var charAt$1 = uncurryThis$3(''.charAt);
var $parseFloat$1 = global$1.parseFloat;
var Symbol$1 = global$1.Symbol;
var ITERATOR = Symbol$1 && Symbol$1.iterator;
var FORCED$2 = 1 / $parseFloat$1(whitespaces + '-0') !== -Infinity
// MS Edge 18- broken with boxed symbols
|| ITERATOR && !fails$2(function () {
  $parseFloat$1(Object(ITERATOR));
});

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
var numberParseFloat = FORCED$2 ? function parseFloat(string) {
  var trimmedString = trim(toString$2(string));
  var result = $parseFloat$1(trimmedString);
  return result === 0 && charAt$1(trimmedString, 0) === '-' ? -0 : result;
} : $parseFloat$1;
var $$5 = _export;
var parseFloat$1 = numberParseFloat;

// `Number.parseFloat` method
// https://tc39.es/ecma262/#sec-number.parseFloat
// eslint-disable-next-line es/no-number-parsefloat -- required for testing
$$5({
  target: 'Number',
  stat: true,
  forced: Number.parseFloat !== parseFloat$1
}, {
  parseFloat: parseFloat$1
});
const PERCENTAGE = {
  state: AllocationStateEnum.PERCENTAGE,
  display: 'Percentage',
  valueName: 'percentage',
  unit: '%'
};
const HOURS_DAY = {
  state: AllocationStateEnum.HOURS_DAY,
  display: 'Hours a day',
  valueName: 'hours',
  unit: 'hrs/day'
};
const TOTAL_HOURS = {
  state: AllocationStateEnum.TOTAL_HOURS,
  display: 'Total hours',
  valueName: 'total',
  unit: 'Total hours'
};
const allocationDefinitionsByStateName = {
  PERCENTAGE,
  HOURS_DAY,
  TOTAL_HOURS
};
const overrideDatesCheck = (newOverride, data, editOverride, editOverrideIdx) => {
  const overFrom = (newOverride === null || newOverride === void 0 ? void 0 : newOverride.from) && formatDate(newOverride.from, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT);
  const overTo = (newOverride === null || newOverride === void 0 ? void 0 : newOverride.to) && formatDate(newOverride.to, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT);
  let overrideOverlap = false;
  overrideOverlap = data === null || data === void 0 ? void 0 : data.filter((el, idx) => editOverride ? idx !== editOverrideIdx : true).some(el => {
    const elFrom = typeof el.from === 'string' ? formatDate(removeUTCZuluFromDateObject(new Date(el.from)), DATE_FORMATS.YEAR_MONTH_DAY_FORMAT) : formatDate(new Date(el.from), DATE_FORMATS.YEAR_MONTH_DAY_FORMAT);
    const elTo = typeof el.from === 'string' ? formatDate(removeUTCZuluFromDateObject(new Date(el.to)), DATE_FORMATS.YEAR_MONTH_DAY_FORMAT) : formatDate(new Date(el.to), DATE_FORMATS.YEAR_MONTH_DAY_FORMAT);
    if (!overFrom || !overTo) {
      return false;
    }
    return overFrom >= elFrom && overFrom <= elTo || overTo >= elFrom && overTo <= elTo || elFrom >= overFrom && elFrom <= overTo || elTo >= overFrom && elTo <= overTo;
  });
  return overrideOverlap;
};
var uncurryThis$2 = functionUncurryThis;

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
var thisNumberValue$1 = uncurryThis$2(1.0.valueOf);
var toIntegerOrInfinity$3 = toIntegerOrInfinity$9;
var toString$1 = toString$g;
var requireObjectCoercible$1 = requireObjectCoercible$a;
var $RangeError$1 = RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
var stringRepeat = function repeat(count) {
  var str = toString$1(requireObjectCoercible$1(this));
  var result = '';
  var n = toIntegerOrInfinity$3(count);
  if (n < 0 || n === Infinity) throw new $RangeError$1('Wrong number of repetitions');
  for (; n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};
var $$4 = _export;
var uncurryThis$1 = functionUncurryThis;
var toIntegerOrInfinity$2 = toIntegerOrInfinity$9;
var thisNumberValue = thisNumberValue$1;
var $repeat = stringRepeat;
var fails$1 = fails$y;
var $RangeError = RangeError;
var $String = String;
var floor = Math.floor;
var repeat = uncurryThis$1($repeat);
var stringSlice = uncurryThis$1(''.slice);
var nativeToFixed = uncurryThis$1(1.0.toFixed);
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  }
  return n;
};
var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor(c / n);
    c = c % n * 1e7;
  }
};
var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = $String(data[index]);
      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
    }
  }
  return s;
};
var FORCED$1 = fails$1(function () {
  return nativeToFixed(0.00008, 3) !== '0.000' || nativeToFixed(0.9, 0) !== '1' || nativeToFixed(1.255, 2) !== '1.25' || nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails$1(function () {
  // V8 ~ Android 4.3-
  nativeToFixed({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$$4({
  target: 'Number',
  proto: true,
  forced: FORCED$1
}, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toIntegerOrInfinity$2(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (fractDigits < 0 || fractDigits > 20) throw new $RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number !== number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return $String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits ? '0.' + repeat('0', fractDigits - k) + result : stringSlice(result, 0, k - fractDigits) + '.' + stringSlice(result, k - fractDigits));
    } else {
      result = sign + result;
    }
    return result;
  }
});
var $$3 = _export;
var $parseFloat = numberParseFloat;

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
$$3({
  global: true,
  forced: parseFloat !== $parseFloat
}, {
  parseFloat: $parseFloat
});
const getBookingAllocationValuesFromSingleValue = props => {
  const {
    nameOfValue,
    value,
    avgDailyCapacity,
    numberOfWorkDays,
    totalBookingMinutes
  } = props;
  const bookingAllocationValues = {
    percentage: 0,
    hours: 0,
    total: 0
  };
  bookingAllocationValues[nameOfValue] = value;
  let totalHours, avgHoursPerDay;
  if (Number.isFinite(totalBookingMinutes)) {
    totalHours = totalBookingMinutes / 60;
    // 0/0 is NaN, so handle this. https://hubplanner.atlassian.net/browse/HUB-8374
    avgHoursPerDay = totalHours / numberOfWorkDays || 0;
  } else {
    avgHoursPerDay = avgDailyCapacity;
    totalHours = avgHoursPerDay * numberOfWorkDays;
  }
  switch (nameOfValue) {
    case 'percentage':
      bookingAllocationValues.hours = parseFloat((avgHoursPerDay * (value / 100)).toFixed(2));
      bookingAllocationValues.total = parseFloat((totalHours * (value / 100)).toFixed(2));
      break;
    case 'hours':
      bookingAllocationValues.percentage = numberOfWorkDays === 0 ? 100 : parseFloat(((value / avgHoursPerDay || 0) * 100).toFixed(2));
      bookingAllocationValues.total = numberOfWorkDays === 0 ? bookingAllocationValues[nameOfValue] : parseFloat((value * numberOfWorkDays).toFixed(2));
      break;
    case 'total':
      bookingAllocationValues.percentage = numberOfWorkDays === 0 ? 100 : parseFloat(((value / totalHours || 0) * 100).toFixed(2));
      bookingAllocationValues.hours = numberOfWorkDays === 0 ? bookingAllocationValues[nameOfValue] : parseFloat((value / numberOfWorkDays || 0).toFixed(2));
      break;
  }
  return bookingAllocationValues;
};
const getAllocationValuesFromCategory = category => {
  if (!category) {
    return {
      name: PERCENTAGE.valueName,
      value: 100
    };
  }
  const {
    state,
    minutesPerDay,
    percentAllocation,
    totalBucketMinutesAllocation
  } = category;
  switch (state) {
    case HOURS_DAY.state:
      return {
        name: HOURS_DAY.valueName,
        value: minutesPerDay / 60
      };
    case TOTAL_HOURS.state:
      return {
        name: TOTAL_HOURS.valueName,
        value: totalBucketMinutesAllocation / 60
      };
    case PERCENTAGE.state:
      return {
        name: PERCENTAGE.valueName,
        value: percentAllocation
      };
    default:
      return {
        name: PERCENTAGE.valueName,
        value: 100
      };
  }
};
const getAllocationValuesChanges = (objData, allocationDefaultValues) => {
  const {
    hours,
    total,
    percentage
  } = allocationDefaultValues;
  const {
    name,
    value
  } = objData;
  let newValues = {
    percentage: 0,
    hours: 0,
    total: 0
  };
  if (isNaN(value)) return newValues;
  switch (name) {
    case 'percentage':
      newValues = {
        percentage: toFixedTrimmed(value, 2),
        hours: toFixedTrimmed(value * hours / percentage, 2),
        total: toFixedTrimmed(value * total / percentage, 2)
      };
      break;
    case 'hours':
      newValues = {
        percentage: isNaN(toFixedTrimmed(value * percentage / hours, 2)) ? 0 : toFixedTrimmed(value * percentage / hours, 2),
        hours: toFixedTrimmed(value, 2),
        total: toFixedTrimmed(toFixedTrimmed(value * percentage / hours, 2) * total / percentage, 2)
      };
      break;
    case 'total':
      newValues = {
        percentage: isNaN(toFixedTrimmed(value * percentage / total, 2)) ? 0 : toFixedTrimmed(value * percentage / total, 2),
        hours: toFixedTrimmed(toFixedTrimmed(value * percentage / total, 2) * hours / percentage, 2),
        total: toFixedTrimmed(value, 2)
      };
      break;
  }
  return newValues;
};
const calculateAllocationForCategory = _ref335 => {
  let {
    percentage,
    hours,
    total,
    category,
    useCategoriesAllocation
  } = _ref335;
  if (useCategoriesAllocation && category) {
    return Object.assign(Object.assign({}, getAllocationValuesChanges(getAllocationValuesFromCategory(category), {
      percentage,
      hours,
      total
    })), {
      state: category.state
    });
  }
  return undefined;
};
const useCalculateAllocationForCategory = () => {
  const useCategoriesAllocation = useSelector(selectUseCategoriesAllocation);
  return useCallback(_ref336 => {
    let {
      percentage,
      hours,
      total,
      category
    } = _ref336;
    return calculateAllocationForCategory({
      percentage,
      hours,
      total,
      category,
      useCategoriesAllocation
    });
  }, [useCategoriesAllocation]);
};
const scheduleFormValidationSchema = create$3().shape({
  resource: create$8().required('Required'),
  project: create$8().required('Required'),
  category: create$8().required('Required'),
  bookingColor: create$6(),
  title: create$6().optional(),
  useProjectColor: create$7().required(),
  deadlineName: create$6().optional(),
  deadlineDate: create$4().optional(),
  interval: create$8().optional().nullable(),
  repeatEndsOn: create$8().optional(),
  repeatEndsOnDate: create$4().optional().nullable(),
  repeatEndsAfterTimes: create$5().optional().nullable(),
  repeatEveryTime: create$5().optional(),
  repeatEveryInterval: create$8().optional(),
  repeatOnWeekdays: create$8().optional(),
  repeatOn: create$8().optional(),
  repeatOnDates: create$2(),
  repeatOnCustom1: create$8().nullable().optional(),
  repeatOnCustom2: create$8().nullable().optional(),
  state: create$8().defined(),
  percentage: create$5().defined().min(0),
  hours: create$5().defined().min(0),
  total: create$5().defined().min(0),
  daysCounter: create$5().optional().nullable(),
  startDate: create$4().required('Required').test((value, ctx) => {
    return isSameOrBefore(value, ctx.parent.endDate) ? true : ctx.createError({
      message: "Start date can't be greater than end date"
    });
  }),
  endDate: create$4().required('Required').test((value, ctx) => {
    return isSameOrAfter(value, ctx.parent.startDate) ? true : ctx.createError({
      message: "End date can't be smaller than start date"
    });
  })
}).test('booking-color-validator', 'Booking color config is invalid', (values, ctx) => {
  const errors = [];
  if (!values.useProjectColor && !values.bookingColor) {
    errors.push(ctx.createError({
      path: 'bookingColor',
      message: 'Required'
    }));
  }
  if (errors.length) {
    return new ValidationError(errors);
  }
  return true;
}).test('repeat-booking-validator', 'Repeat booking configuration is invalid', (values, ctx) => {
  var _a, _b, _c, _d, _e, _f;
  const errors = [];
  if (values.interval && values.interval.value !== BookingRepeatEnum.NONE) {
    if (!values.repeatEndsOn) {
      errors.push(ctx.createError({
        path: 'repeatEndsOn',
        message: 'Required'
      }));
    }
  }
  if (((_a = values.interval) === null || _a === void 0 ? void 0 : _a.value) === BookingRepeatEnum.CUSTOM) {
    if (!values.repeatEveryInterval) {
      errors.push(ctx.createError({
        path: 'repeatEveryInterval',
        message: 'Required'
      }));
    }
    if (!Number.isFinite(values.repeatEveryTime)) {
      errors.push(ctx.createError({
        path: 'repeatEveryTime',
        message: 'Required'
      }));
    }
    if (values.repeatEveryTime === 0 || values.repeatEveryTime && values.repeatEveryTime < 1) {
      errors.push(ctx.createError({
        path: 'repeatEveryTime',
        message: 'Has to be positive'
      }));
    }
  }
  if (values.repeatEndsOn === RepeatEndsOnEnum.DATE) {
    if (!values.repeatEndsOnDate) {
      errors.push(ctx.createError({
        path: 'repeatEndsOnDate',
        message: 'Required'
      }));
    } else if (isBefore(values.repeatEndsOnDate, values.endDate, 'day')) {
      errors.push(ctx.createError({
        path: 'repeatEndsOnDate',
        message: "Repeat end date can't be before booking end date"
      }));
    }
  }
  if (values.repeatEndsOn === RepeatEndsOnEnum.AFTERTIMES) {
    if (!Number.isFinite(values.repeatEndsAfterTimes)) {
      errors.push(ctx.createError({
        path: 'repeatEndsAfterTimes',
        message: 'Required'
      }));
    }
    if (typeof values.repeatEndsAfterTimes === 'number' && values.repeatEndsAfterTimes < 1) {
      errors.push(ctx.createError({
        path: 'repeatEndsAfterTimes',
        message: 'Has to be positive'
      }));
    }
  }
  if (((_b = values.repeatEveryInterval) === null || _b === void 0 ? void 0 : _b.value) === BookingRepeatIntervalEnum.WEEK) {
    if (!Object.values(values.repeatOnWeekdays || {}).some(Boolean)) {
      errors.push(ctx.createError({
        path: 'repeatOnWeekdays',
        message: 'Required'
      }));
    }
  }
  if (((_c = values.repeatEveryInterval) === null || _c === void 0 ? void 0 : _c.value) === BookingRepeatIntervalEnum.MONTH) {
    if (!((_d = values.repeatOn) === null || _d === void 0 ? void 0 : _d.value)) {
      errors.push(ctx.createError({
        path: 'repeatOn',
        message: 'Required'
      }));
    }
    if (((_e = values.repeatOn) === null || _e === void 0 ? void 0 : _e.value) === RepeatMonthlyOnEnum.DATES) {
      if (!values.repeatOnDates || !values.repeatOnDates.length) {
        errors.push(ctx.createError({
          path: 'repeatOnDates',
          message: 'Required'
        }));
      }
    }
    if (((_f = values.repeatOn) === null || _f === void 0 ? void 0 : _f.value) === RepeatMonthlyOnEnum.CUSTOM) {
      if (!values.repeatOnCustom1) {
        errors.push(ctx.createError({
          path: 'repeatOnCustom1',
          message: 'Required'
        }));
      }
      if (!values.repeatOnCustom2) {
        errors.push(ctx.createError({
          path: 'repeatOnCustom2',
          message: 'Required'
        }));
      }
    }
  }
  if (errors.length) {
    return new ValidationError(errors);
  }
  return true;
});
const mapBookingToCreateDto = (values, scale) => {
  var _a, _b, _c, _d;
  const approvers = []; // TODO: values.approvers.map(approver => ({ id: approver._id }));
  const approvalInfo = {
    approvers,
    requesterNote: '' // TODO: values.note,
  };
  return Object.assign({
    allDay: scale !== 'CellDuration',
    scale: (_a = getScaleObjectByValue(scale)) === null || _a === void 0 ? void 0 : _a.BEValue,
    project: (_b = values.project) === null || _b === void 0 ? void 0 : _b._id,
    resource: (_c = values.resource) === null || _c === void 0 ? void 0 : _c._id,
    categoryTemplateId: (_d = values.category) === null || _d === void 0 ? void 0 : _d._id,
    approvalInfo,
    title: '',
    start: formatDate(values.startDate, DATE_FORMATS.BE_FORMAT),
    end: formatDate(values.endDate, DATE_FORMATS.BE_FORMAT),
    state: values.state,
    percentAllocation: values.percentage,
    minutesPerDay: values.hours * 60,
    totalBucketMinutesAllocation: values.total * 60,
    useProjectColor: values.useProjectColor,
    backgroundColor: values.bookingColor
  }, mapBookingRepeatToRequest(values));
};
const mapBookingToUpdateDto = values => {
  var _a, _b;
  return Object.assign({
    project: values.project,
    resource: (_a = values.resource) === null || _a === void 0 ? void 0 : _a._id,
    resourceInfo: values.resource,
    categoryTemplate: values.category,
    categoryTemplateId: (_b = values.category) === null || _b === void 0 ? void 0 : _b._id,
    start: values.startDate,
    end: values.endDate,
    state: values.state,
    percentAllocation: values.percentage,
    minutesPerDay: values.hours * 60,
    totalBucketMinutesAllocation: values.total * 60,
    useProjectColor: values.useProjectColor,
    backgroundColor: values.bookingColor
  }, mapBookingRepeatToRequest(values));
};
const mapBookingRepeatToRequest = values => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
  let result = {
    interval: ((_a = values.interval) === null || _a === void 0 ? void 0 : _a.value) || BookingRepeatEnum.NONE,
    repeat: true
  };
  if (((_b = values.interval) === null || _b === void 0 ? void 0 : _b.value) === 'NONE') {
    result = Object.assign(Object.assign({}, result), {
      repeat: false,
      repeatEndsOnDate: null,
      repeatEndsAfterTimes: null,
      repeatEveryTime: null,
      repeatEveryInterval: null,
      repeatOnWeekdays: null,
      repeatOn: null,
      repeatOnDates: null,
      repeatOnCustom1: null,
      repeatOnCustom2: null
    });
  } else if (((_c = values.interval) === null || _c === void 0 ? void 0 : _c.value) !== 'CUSTOM') {
    result = Object.assign(Object.assign({}, result), {
      repeatEndsOnDate: values.repeatEndsOn === RepeatEndsOnEnum.DATE && values.repeatEndsOnDate ? formatDate(toMidnight(values.repeatEndsOnDate), DATE_FORMATS.BE_FORMAT) : null,
      repeatEndsAfterTimes: values.repeatEndsOn === 'AFTERTIMES' ? values.repeatEndsAfterTimes : null,
      repeatEveryTime: null,
      repeatEveryInterval: null,
      repeatOnWeekdays: null,
      repeatOn: null,
      repeatOnDates: null,
      repeatOnCustom1: null,
      repeatOnCustom2: null
    });
  } else if (((_d = values.interval) === null || _d === void 0 ? void 0 : _d.value) === 'CUSTOM') {
    result = Object.assign(Object.assign({}, result), {
      repeatEndsOnDate: values.repeatEndsOn === 'DATE' && values.repeatEndsOnDate ? formatDate(toMidnight(values.repeatEndsOnDate), DATE_FORMATS.BE_FORMAT) : null,
      repeatEndsAfterTimes: values.repeatEndsOn === 'AFTERTIMES' ? values.repeatEndsAfterTimes : null,
      repeatEveryTime: values.repeatEveryTime,
      repeatEveryInterval: (_e = values.repeatEveryInterval) === null || _e === void 0 ? void 0 : _e.value,
      repeatOnWeekdays: ((_f = values.repeatEveryInterval) === null || _f === void 0 ? void 0 : _f.value) === 'WEEK' ? values.repeatOnWeekdays : null,
      repeatOn: ((_g = values.repeatEveryInterval) === null || _g === void 0 ? void 0 : _g.value) === 'MONTH' ? (_h = values.repeatOn) === null || _h === void 0 ? void 0 : _h.value : null,
      repeatOnDates: ((_j = values.repeatEveryInterval) === null || _j === void 0 ? void 0 : _j.value) === 'MONTH' && ((_k = values.repeatOn) === null || _k === void 0 ? void 0 : _k.value) === 'DATES' ? values.repeatOnDates : null,
      repeatOnCustom1: ((_l = values.repeatEveryInterval) === null || _l === void 0 ? void 0 : _l.value) === 'MONTH' && ((_m = values.repeatOn) === null || _m === void 0 ? void 0 : _m.value) === 'CUSTOM' ? values.repeatOnCustom1 : null,
      repeatOnCustom2: ((_o = values.repeatEveryInterval) === null || _o === void 0 ? void 0 : _o.value) === 'MONTH' && ((_p = values.repeatOn) === null || _p === void 0 ? void 0 : _p.value) === 'CUSTOM' ? values.repeatOnCustom2 : null
    });
  }
  return result;
};
const projectDatesValidationSchema = create$3().shape({
  startDate: create$4().required().test((value, ctx) => {
    return isSameOrBefore(value, ctx.parent.endDate, 'day') ? true : ctx.createError({
      message: "Start date can't be greater than end date"
    });
  }),
  endDate: create$4().required('Required').test((value, ctx) => {
    return isSameOrAfter(value, ctx.parent.startDate, 'day') ? true : ctx.createError({
      message: "End date can't be smaller than start date"
    });
  }),
  projectId: create$6().required('Required')
});
const mapProjectDatesFormToRequest = values => {
  if (!values.startDate || !values.endDate || !values.projectId) {
    return undefined;
  }
  return {
    project: {
      _id: values.projectId,
      start: formatDate(values.startDate, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT),
      end: formatDate(values.endDate, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT),
      useProjectDuration: true
    }
  };
};
const mapCurrentSelectionToProjectDatesFormData = currentSelection => {
  var _a, _b, _c, _d;
  if (currentSelection && 'datesEvent' in currentSelection) {
    return {
      projectId: currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.projectId,
      endDate: toDate$1((_a = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.dates) === null || _a === void 0 ? void 0 : _a.end),
      startDate: toDate$1((_b = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.dates) === null || _b === void 0 ? void 0 : _b.start)
    };
  }
  return {
    projectId: (_d = (_c = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _c === void 0 ? void 0 : _c.project) === null || _d === void 0 ? void 0 : _d._id,
    endDate: toDate$1(currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.end),
    startDate: toDate$1(currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.start)
  };
};
const mapProjectBasicInfoToDatesFormData = project => {
  return {
    projectId: project === null || project === void 0 ? void 0 : project._id,
    endDate: toDate$1(project === null || project === void 0 ? void 0 : project.end),
    startDate: toDate$1(project === null || project === void 0 ? void 0 : project.start)
  };
};
const simpleRepeatOptions = [{
  label: 'Does not repeat',
  value: SimpleRepeatEnum.NONE
}, {
  label: 'Daily',
  value: SimpleRepeatEnum.DAILY
}, {
  label: 'Weekly',
  value: SimpleRepeatEnum.WEEKLY
}, {
  label: 'Monthly',
  value: SimpleRepeatEnum.MONTHLY
}];
const simpleRepeatOptionsMap = simpleRepeatOptions.reduce((acc, option) => {
  acc[option.value] = option;
  return acc;
}, {});
const getRepeatAddIntervalFunc = interval => {
  switch (interval) {
    case SimpleRepeatEnum.DAILY:
      return addDays$1;
    case SimpleRepeatEnum.WEEKLY:
      return addWeeks;
    case SimpleRepeatEnum.MONTHLY:
      return addMonths;
    case SimpleRepeatEnum.NONE:
    default:
      return undefined;
  }
};
const projectMilestoneValidationSchema = create$3().shape({
  _id: create$6().optional(),
  name: create$6().required('Required'),
  date: create$4().required('Required'),
  color: create$6().required('Required'),
  interval: create$8().required('Required'),
  repeat: create$7().optional(),
  repeatTimes: create$5().integer('Invalid number, must be an integer').optional(),
  project: create$6().required('Required')
}).test('repeat-time-validator', 'Repeat times invalid', (values, ctx) => {
  var _a;
  if (((_a = values.interval) === null || _a === void 0 ? void 0 : _a.value) && values.interval.value !== SimpleRepeatEnum.NONE) {
    if (!values.repeatTimes || values.repeatTimes < 1) {
      return ctx.createError({
        path: 'repeatTimes',
        message: 'Invalid number, must be bigger than 0'
      });
    }
  }
});
const mapProjectMilestoneFormToRequest = (values, initialFormValues) => {
  var _a;
  if (!values.date || !values.interval) {
    return undefined;
  }
  const addIntervalFunc = getRepeatAddIntervalFunc((_a = values.interval) === null || _a === void 0 ? void 0 : _a.value);
  const milestones = [];
  if (values.interval && values.interval.value !== SimpleRepeatEnum.NONE && values.repeatTimes && initialFormValues && !initialFormValues.repeat && addIntervalFunc) {
    // transform from non repeated to repeated
    const repeatId = new ObjectID().toString();
    if (!values.date) {
      return;
    }
    for (let i = 0; i < values.repeatTimes; i++) {
      milestones.push({
        name: values.name,
        interval: values.interval.value,
        repeatTimes: values.repeatTimes,
        repeat: true,
        color: values.color,
        project: values.project,
        _id: undefined,
        repeatId,
        date: formatDate(addIntervalFunc(values.date, i), DATE_FORMATS.YEAR_MONTH_DAY_FORMAT)
      });
    }
    if (milestones[0] && '_id' in milestones[0]) {
      milestones[0]._id = values._id;
    }
    return milestones;
  }
  let repeatPart = {
    repeatTimes: values.repeatTimes,
    repeat: 0 < (values.repeatTimes || 0) && values.interval && values.interval.value !== SimpleRepeatEnum.NONE
  };
  if (initialFormValues && initialFormValues.repeat) {
    // when milestone is updated we always remove it from series atm
    repeatPart = {
      repeatTimes: 0,
      repeat: false,
      repeatId: null,
      interval: SimpleRepeatEnum.NONE
    };
  }
  return Object.assign({
    date: formatDate(values.date, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT),
    name: values.name,
    interval: values.interval.value,
    repeatTimes: values.repeatTimes,
    repeat: 0 < (values.repeatTimes || 0) && 'NONE' !== values.interval.value,
    color: values.color,
    project: values.project,
    _id: values._id
  }, repeatPart);
};
const mapCurrentSelectionToProjectMilestoneFormData = currentSelection => {
  var _a, _b;
  if (currentSelection && 'milestone' in currentSelection && currentSelection.milestone) {
    return {
      interval: simpleRepeatOptionsMap[currentSelection.interval],
      color: currentSelection.color,
      repeat: currentSelection.repeat,
      repeatTimes: currentSelection.repeatTimes,
      date: toDate$1(currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.date),
      project: currentSelection.projectId,
      _id: currentSelection._id,
      name: currentSelection.name
    };
  }
  if (currentSelection && 'rowTags' in currentSelection) {
    return {
      interval: simpleRepeatOptionsMap.NONE,
      color: '#00B050',
      repeatTimes: 0,
      repeat: false,
      date: toDate$1(currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.start),
      name: undefined,
      project: (_b = (_a = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.project) === null || _b === void 0 ? void 0 : _b._id
    };
  }
  return {
    interval: simpleRepeatOptionsMap.NONE,
    color: '#00B050',
    repeatTimes: 0,
    repeat: false,
    date: toDate$1(),
    name: undefined,
    project: undefined
  };
};
const projectPhaseValidationSchema = create$3().shape({
  _id: create$6().optional(),
  name: create$6().required('Required'),
  startDate: create$4().required().test((value, ctx) => {
    return isSameOrBefore(value, ctx.parent.endDate, 'day') ? true : ctx.createError({
      message: "Start date can't be greater than end date"
    });
  }),
  endDate: create$4().required('Required').test((value, ctx) => {
    return isSameOrAfter(value, ctx.parent.startDate, 'day') ? true : ctx.createError({
      message: "End date can't be smaller than start date"
    });
  }),
  color: create$6().required(),
  interval: create$8().required(),
  repeat: create$7().optional(),
  repeatTimes: create$5().integer('Invalid number, must be an integer').optional(),
  project: create$6().required()
}).test('repeat-time-validator', 'Repeat times invalid', (values, ctx) => {
  var _a;
  if (((_a = values.interval) === null || _a === void 0 ? void 0 : _a.value) && values.interval.value !== SimpleRepeatEnum.NONE) {
    if (!values.repeatTimes || values.repeatTimes < 1) {
      return ctx.createError({
        path: 'repeatTimes',
        message: 'Invalid number, must be bigger than 0'
      });
    }
  }
});
const mapProjectPhaseFormToRequest = (values, initialFormValues, companyStartEndTimes) => {
  var _a, _b;
  if (!values.startDate || !values.endDate) {
    return undefined;
  }
  const startDate = set$2(values.startDate, {
    seconds: 0,
    minutes: (companyStartEndTimes === null || companyStartEndTimes === void 0 ? void 0 : companyStartEndTimes.startMinute) || 0,
    hours: (companyStartEndTimes === null || companyStartEndTimes === void 0 ? void 0 : companyStartEndTimes.startDay) || 8
  });
  const endDate = set$2(values.endDate, {
    seconds: 0,
    minutes: (companyStartEndTimes === null || companyStartEndTimes === void 0 ? void 0 : companyStartEndTimes.endMinute) || 0,
    hours: (companyStartEndTimes === null || companyStartEndTimes === void 0 ? void 0 : companyStartEndTimes.endDay) || 16
  });
  const addIntervalFunc = getRepeatAddIntervalFunc((_a = values.interval) === null || _a === void 0 ? void 0 : _a.value);
  if (values.interval && values.interval.value !== SimpleRepeatEnum.NONE && values.repeatTimes && initialFormValues && !initialFormValues.repeat && addIntervalFunc) {
    // transform from non repeated to repeated
    const repeatId = new ObjectID().toString();
    const phases = [];
    for (let i = 0; i < values.repeatTimes; i++) {
      phases.push({
        name: values.name,
        interval: values.interval.value,
        repeatTimes: values.repeatTimes,
        repeat: 0 < (values.repeatTimes || 0),
        color: values.color,
        project: values.project,
        _id: undefined,
        repeatId,
        start: formatDate(addIntervalFunc(startDate, i), DATE_FORMATS.BE_FORMAT),
        end: formatDate(addIntervalFunc(endDate, i), DATE_FORMATS.BE_FORMAT)
      });
    }
    if (phases[0] && '_id' in phases[0]) {
      phases[0]._id = values._id;
    }
    return phases;
  }
  let repeatPart = {
    repeatTimes: values.repeatTimes,
    repeat: 0 < (values.repeatTimes || 0) && values.interval && values.interval.value !== SimpleRepeatEnum.NONE
  };
  if (initialFormValues && initialFormValues.repeat) {
    // when phase is updated we always remove it from series atm
    repeatPart = {
      repeatTimes: 0,
      repeat: false,
      repeatId: null,
      interval: SimpleRepeatEnum.NONE
    };
  }
  return Object.assign({
    start: formatDate(startDate, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT),
    end: formatDate(endDate, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT),
    name: values.name,
    interval: ((_b = values.interval) === null || _b === void 0 ? void 0 : _b.value) || SimpleRepeatEnum.NONE,
    color: values.color,
    project: values.project,
    _id: values._id
  }, repeatPart);
};
const mapCurrentSelectionToProjectPhaseFormData = currentSelection => {
  var _a, _b;
  if (currentSelection && 'phase' in currentSelection && currentSelection.phase) {
    return {
      interval: simpleRepeatOptionsMap[currentSelection.interval],
      color: currentSelection.color,
      repeatTimes: currentSelection.repeatTimes,
      repeat: currentSelection.repeat,
      endDate: toDate$1(currentSelection.end),
      startDate: toDate$1(currentSelection.start),
      name: currentSelection.name,
      project: currentSelection.projectId,
      _id: currentSelection._id
    };
  }
  if (currentSelection && 'rowTags' in currentSelection) {
    return {
      interval: simpleRepeatOptionsMap.NONE,
      color: '#00B050',
      repeatTimes: 0,
      repeat: false,
      endDate: toDate$1(currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.end),
      startDate: toDate$1(currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.start),
      name: undefined,
      project: (_b = (_a = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.project) === null || _b === void 0 ? void 0 : _b._id
    };
  }
  return {
    interval: simpleRepeatOptionsMap.NONE,
    color: '#00B050',
    repeatTimes: 0,
    repeat: false,
    endDate: toDate$1(currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.end),
    startDate: toDate$1(currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.start),
    name: undefined,
    project: ''
  };
};
const useGetDefaultApprovers = props => {
  const {
    resource
  } = props;
  const approvers = useSelector(selectCompanyApprovers);
  const mappedResourceGroups = useSelector(selectMappedResourceGroups);
  return useMemo(() => {
    var _a;
    const groups = (resource === null || resource === void 0 ? void 0 : resource._id) ? Object.values((_a = mappedResourceGroups[resource._id]) !== null && _a !== void 0 ? _a : {}) : [];
    const groupApproverIds = groups.reduce((acc, group) => {
      acc.push(...(group.approvers || []));
      return acc;
    }, []);
    const defaultApproverIds = (resource === null || resource === void 0 ? void 0 : resource.defaultApproverIds) || [];
    const allDefaultApproverIds = Array.from(new Set([...groupApproverIds, ...defaultApproverIds]));
    let defaultApprovers = [];
    if ((resource === null || resource === void 0 ? void 0 : resource._id) && approvers.length) {
      defaultApprovers = approvers.filter(approver => allDefaultApproverIds.includes(approver._id));
    }
    return defaultApprovers;
  }, [approvers, mappedResourceGroups, resource === null || resource === void 0 ? void 0 : resource._id, resource === null || resource === void 0 ? void 0 : resource.defaultApproverIds]);
};
const selectCategoryGroups = state => state.categoryGroupReducer.categoryGroups;
const selectCategoryTemplatesFromGroups = createSelector(selectCategoryGroups, groups => {
  return groups.reduce((acc, group) => {
    return acc.concat(group.categories);
  }, []);
});
const selectDefaultCategoryGroup = state => state.categoryGroupReducer.categoryGroups.find(group => group.type === CategoryGroupTypeEnum.DEFAULT);
const selectCategoryGroupsMappedById = createSelector(selectCategoryGroups, categoryGroups => {
  return categoryGroups.reduce((acc, categoryGroup) => {
    acc[categoryGroup._id] = categoryGroup;
    return acc;
  }, {});
});
const makeSelectCategoriesFromGroupsByIds = function () {
  let groupsIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return createSelector(selectCategoryGroups, selectCategoryGroupsMappedById, (categoryGroups, mapped) => {
    let groups = [];
    if (!groupsIds.length) {
      groups = categoryGroups;
    } else {
      groups = groupsIds.map(id => {
        return mapped[id];
      }).filter(Boolean);
    }
    const result = groups.reduce((acc, categoryGroup) => {
      return acc.concat(categoryGroup.categories);
    }, []);
    result.sort((a, b) => {
      if (a.groupName === b.groupName) {
        return (a.name || '').localeCompare(b.name || '', undefined, {
          numeric: true,
          sensitivity: 'base'
        });
      }
      return (a.groupName || '').localeCompare(b.groupName || '', undefined, {
        numeric: true,
        sensitivity: 'base'
      });
    });
    return result;
  });
};
const makeSelectCategoryFromGroup = categoryId => createSelector(selectCategoryTemplatesFromGroups, categoryTemplates => {
  if (!categoryId) {
    return undefined;
  }
  return categoryTemplates.find(category => category._id === categoryId);
});
const REQUEST = 'REQUEST';
const SUCCESS = 'SUCCESS';
const FAILURE = 'FAILURE';
const createRequestTypes = (base, includeFailure) => {
  let typesArray = [REQUEST, SUCCESS];
  if (includeFailure) {
    typesArray = [...typesArray, FAILURE];
  }
  return typesArray.reduce((acc, type) => {
    acc[type] = "".concat(base, "_").concat(type);
    return acc;
  }, {});
};
function actionCreator(type, payload) {
  return {
    type,
    payload: payload || {}
  };
}
const CREATE_PROJECT = createRequestTypes('CREATE_PROJECT', true);
const UPDATE_PROJECT = createRequestTypes('UPDATE_PROJECT', true);
const projectActions = {
  create: {
    request: function (data, callback) {
      let redirect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return actionCreator(CREATE_PROJECT.REQUEST, {
        data,
        callback,
        redirect
      });
    },
    success: function (project) {
      let projectGroupsAdd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return actionCreator(CREATE_PROJECT.SUCCESS, {
        project,
        projectGroupsAdd
      });
    },
    failure: () => actionCreator(CREATE_PROJECT.FAILURE)
  },
  update: {
    request: (id, data, callback) => actionCreator(UPDATE_PROJECT.REQUEST, {
      id,
      data,
      callback
    }),
    success: (project, projectGroupsAdd, projectGroupsRemove, accountGridMode) => actionCreator(UPDATE_PROJECT.SUCCESS, {
      project,
      projectGroupsAdd,
      projectGroupsRemove,
      accountGridMode
    }),
    failure: () => actionCreator(UPDATE_PROJECT.FAILURE)
  }
};
const CREATE_RESOURCE = createRequestTypes('CREATE_RESOURCE', true);
const UPDATE_RESOURCE = createRequestTypes('UPDATE_RESOURCE', true);
const resourceActions = {
  create: {
    request: function (data, callback) {
      let redirect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return actionCreator(CREATE_RESOURCE.REQUEST, {
        data,
        callback,
        redirect
      });
    },
    success: function (resource) {
      let resourceGroupsAdd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return actionCreator(CREATE_RESOURCE.SUCCESS, {
        resource,
        resourceGroupsAdd
      });
    },
    failure: () => actionCreator(CREATE_RESOURCE.FAILURE)
  },
  update: {
    request: (id, body, callback) => actionCreator(UPDATE_RESOURCE.REQUEST, {
      id,
      body,
      callback
    }),
    success: (resource, additionalInfo) => {
      return actionCreator(UPDATE_RESOURCE.SUCCESS, {
        resource,
        additionalInfo
      });
    },
    failure: (id, body) => {
      return actionCreator(UPDATE_RESOURCE.FAILURE, {
        id,
        body
      });
    }
  }
};
var $$2 = _export;
var toObject = toObject$b;
var lengthOfArrayLike = lengthOfArrayLike$9;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$9;
var addToUnscopables = addToUnscopables$4;

// `Array.prototype.at` method
// https://tc39.es/ecma262/#sec-array.prototype.at
$$2({
  target: 'Array',
  proto: true
}, {
  at: function at(index) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var relativeIndex = toIntegerOrInfinity$1(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return k < 0 || k >= len ? undefined : O[k];
  }
});
addToUnscopables('at');
var $$1 = _export;
var uncurryThis = functionUncurryThis;
var requireObjectCoercible = requireObjectCoercible$a;
var toIntegerOrInfinity = toIntegerOrInfinity$9;
var toString = toString$g;
var fails = fails$y;
var charAt = uncurryThis(''.charAt);
var FORCED = fails(function () {
  // eslint-disable-next-line es/no-array-string-prototype-at -- safe
  return '𠮷'.at(-2) !== '\uD842';
});

// `String.prototype.at` method
// https://tc39.es/ecma262/#sec-string.prototype.at
$$1({
  target: 'String',
  proto: true,
  forced: FORCED
}, {
  at: function at(index) {
    var S = toString(requireObjectCoercible(this));
    var len = S.length;
    var relativeIndex = toIntegerOrInfinity(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return k < 0 || k >= len ? undefined : charAt(S, k);
  }
});
const calculateUnavailabilityIntervals = (currentSelection, companyWeekdays, customAvailabilityWeekdays, useCustomAvailability) => {
  var _a, _b, _c, _d, _e, _f;
  if (!currentSelection) {
    return [];
  }
  const start = formatDate(currentSelection.start, DATE_FORMATS.DAY_LONG).toLowerCase();
  const end = formatDate(currentSelection.end, DATE_FORMATS.DAY_LONG).toLowerCase();
  const weekDays = useCustomAvailability ? customAvailabilityWeekdays : companyWeekdays;
  if (!weekDays) {
    return [];
  }
  const firstStart = ((_c = (_b = (_a = weekDays[start]) === null || _a === void 0 ? void 0 : _a.intervals) === null || _b === void 0 ? void 0 : _b.at(0)) === null || _c === void 0 ? void 0 : _c.start) || 9 * 60;
  const firstEnd = getHours(currentSelection.start) * 60 + getMinutes(currentSelection.start);
  const secondStart = getHours(currentSelection.end) * 60 + getMinutes(currentSelection.end);
  const secondEnd = ((_f = (_e = (_d = weekDays[end]) === null || _d === void 0 ? void 0 : _d.intervals) === null || _e === void 0 ? void 0 : _e.at(-1)) === null || _f === void 0 ? void 0 : _f.end) || 18 * 60;
  const intervals = [];
  if (firstStart < firstEnd) {
    intervals.push({
      start: firstStart,
      end: firstEnd
    });
  }
  if (secondStart < secondEnd) {
    intervals.push({
      start: secondStart,
      end: secondEnd
    });
  }
  return intervals;
};
const calculateUnavailabilityDays = (currentSelection, isHourScale, companyWeekdays, currentResource) => {
  var _a, _b, _c, _d;
  const create = [];
  if (!currentSelection) {
    return create;
  }
  if (isHourScale) {
    const from = formatDate(currentSelection.start, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT);
    const to = formatDate(currentSelection.end, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT);
    if (from === to) {
      const intervals = calculateUnavailabilityIntervals(currentSelection, companyWeekdays, (_b = (_a = currentResource.customAvailabilities) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.weekDays, currentResource.useResourceAvailability);
      create.push({
        from: formatDate(currentSelection.start, DATE_FORMATS.BE_FORMAT),
        to: formatDate(currentSelection.end, DATE_FORMATS.BE_FORMAT),
        intervals,
        minutes: intervals.reduce((acc, interval) => {
          return acc + (interval.end - interval.start);
        }, 0)
      });
    } else {
      const intervals = calculateUnavailabilityIntervals(currentSelection, companyWeekdays, (_d = (_c = currentResource.customAvailabilities) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.weekDays, currentResource.useResourceAvailability);
      const intervalsToSave = [intervals[0]].filter(Boolean);
      create.push({
        from: formatDate(currentSelection.start, DATE_FORMATS.BE_FORMAT),
        to: formatDate(currentSelection.start, DATE_FORMATS.BE_FORMAT),
        intervals: intervalsToSave,
        minutes: intervalsToSave.reduce((acc, interval) => {
          return acc + (interval.end - interval.start);
        }, 0)
      });
      const dayAfterStart = formatDate(addDays$1(currentSelection.start, 1), DATE_FORMATS.YEAR_MONTH_DAY_FORMAT);
      const dayBeforeEnd = formatDate(subDays(currentSelection.end, 1), DATE_FORMATS.YEAR_MONTH_DAY_FORMAT);
      if (dayAfterStart !== to && dayBeforeEnd !== from) {
        create.push({
          from: formatDate(addDays$1(currentSelection.start, 1), DATE_FORMATS.BE_FORMAT),
          to: formatDate(subDays(currentSelection.end, 1), DATE_FORMATS.BE_FORMAT),
          intervals: [],
          minutes: undefined
        });
      }
      const lastDayIntervalsToSave = [intervals[1]].filter(Boolean);
      create.push({
        from: formatDate(currentSelection.end, DATE_FORMATS.BE_FORMAT),
        to: formatDate(currentSelection.end, DATE_FORMATS.BE_FORMAT),
        intervals: lastDayIntervalsToSave,
        minutes: lastDayIntervalsToSave.reduce((acc, interval) => {
          return acc + (interval.end - interval.start);
        }, 0)
      });
    }
  } else {
    create.push({
      from: formatDate(currentSelection.start, DATE_FORMATS.BE_FORMAT),
      to: formatDate(currentSelection.end, DATE_FORMATS.BE_FORMAT),
      intervals: []
    });
  }
  return create;
};

// min - because it can have only not working days
const MIN_NUMBER_BOOKING_DAYS = 0;
const MAX_NUMBER_BOOKING_DAYS = 999;
var BookingModalTabsEnums;
(function (BookingModalTabsEnums) {
  BookingModalTabsEnums["TASKS"] = "3";
  BookingModalTabsEnums["NOTES"] = "5";
  BookingModalTabsEnums["DEPENDENCIES"] = "7";
})(BookingModalTabsEnums || (BookingModalTabsEnums = {}));
const ContextMenuContext = /*#__PURE__*/createContext({
  viewData: undefined,
  requestToolBarContext: false,
  showRequestVacationBtn: false,
  scheduleRequestProject: false,
  showMoreProjectActionsBtn: false,
  showMarkAsUnavailableBtn: false,
  showScheduleSelectionBtn: false,
  showRequestSelectionBtn: false,
  showMoreBtn: false,
  showSplitBookingOption: false,
  disableSplitBookingOption: false,
  canSchedule: false,
  canRequest: false,
  displayRequestBtn: true,
  displayScheduleBtn: true,
  canUpdateBooking: false,
  newResource: {
    name: '',
    type: ResourceTypeEnum.REGULAR
  },
  setNewResource() {
    // do nothing
  },
  newProject: {
    name: '',
    type: ProjectTypeEnum.REGULAR
  },
  setNewProject() {
    // do nothing
  },
  newCategory: {
    name: ''
  },
  setNewCategory(newCategory) {
    // do nothing
  },
  reCalcAllocation() {
    // do nothing
  },
  updateCategoryAllocation() {
    // do nothing
  },
  markAsUnavailable() {
    // do nothing
  },
  requestVacation() {
    // do nothing
  },
  onPasteBooking() {
    // do nothing
  },
  onClose() {
    // do nothing
  },
  onCreateMilestone() {
    // do nothing
  },
  onUpdateMilestone() {
    // do nothing
  },
  onCreatePhase() {
    // do nothing
  },
  onUpdatePhase() {
    // do nothing
  },
  onUpdateProjectDates() {
    // do nothing
  },
  onCopyBooking() {
    // do nothing
  },
  onDuplicateBooking() {
    // do nothing
  },
  onEditBookingTitle() {
    // do nothing
  },
  onBulkMove() {
    // do nothing
  },
  showBookingModal(tabId) {
    // do nothing
  },
  onSplitBooking() {
    // do nothing
  },
  onCutBooking() {
    // do nothing
  },
  onDeleteBooking() {
    // do nothing
  },
  onSubmitSchedule() {
    // do nothing
  },
  onSubmitRequest() {
    // do nothing
  },
  onSubmitUpdateBooking() {
    // do nothing
  },
  onUpdateBookingCategory(category) {
    // do nothing
  },
  onEditProject() {
    // do nothing
  },
  onEditResource() {
    // do nothing
  },
  onAssignToAll() {
    // do nothing
  },
  onSwitchProject(project) {
    // do nothing
  },
  onSwitchResource(resource) {
    // do nothing
  },
  onUpdateBooking(data) {
    // do nothing
  },
  scheduleSelection() {
    // do nothing
  },
  requestSelection() {
    // do nothing
  },
  scheduleOnNewProject(values) {
    // do nothing
  },
  onDeleteProjectItem() {
    // do nothing
  },
  onCreateProject(data, redirect) {
    // do nothing
  },
  onDaysCounterChanged(event) {
    // do nothing
  },
  onDaysCounterBlur(event) {
    // do nothing
  },
  onStartDateChange() {
    // do nothing
  },
  onEndDateChange() {
    // do nothing
  }
});
const useContextMenuContext = () => {
  return useContext(ContextMenuContext);
};
const ContextMenuContextProviderInner = props => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
  const {
    children,
    requestToolBarContext = false,
    scheduleToolBarContext = false,
    viewObject,
    viewData,
    onPasteBooking: onPasteBookingProp,
    onRequestVacation,
    onClose: onCloseProp,
    onCreatePhase: onCreatePhaseProp,
    onUpdatePhase: onUpdatePhaseProp,
    onCreateMilestone: onCreateMilestoneProp,
    onUpdateMilestone: onUpdateMilestoneProp,
    onUpdateProjectDates: onUpdateProjectDatesProp,
    onCopyBooking: onCopyBookingProp,
    onDuplicateBooking: onDuplicateBookingProp,
    onEditBookingTitle: onEditBookingTitleProp,
    onBulkMove: onBulkMoveProp,
    showBookingModal: showBookingModalProp,
    onSplitBooking: onSlitBookingProp,
    onDeleteBooking: onDeleteBookingProp,
    onCutBooking: onCutBookingProp,
    onSchedule: onScheduleProp,
    onRequest: onRequestProp,
    onUpdateBooking: onUpdateBookingProp,
    onAssignToAll: onAssignToAllProp,
    onDeleteProjectItem: onDeleteProjectItemProp,
    onCreateProject: onCreateProjectProp
  } = props;
  const scale = useSelector(selectDefaultScale);
  const {
    values,
    setValues,
    isValid,
    dirty
  } = useFormikContext();
  const dispatch = useDispatch();
  const weekDaysSettings = useSelector(selectWeekDaysSetting);
  const avgDailyCapacity = useSelector(selectCompanyAvgDailyCapacity);
  const schedulerCurrentSelection = useSelector(selectSchedulerCurrentSelection);
  const schedulerCurrentSelectedBooking = useSelector(selectSchedulerCurrentSelectedBooking);
  const bookingDefaultState = useSelector(selectBookingDefaultState);
  const companyStartEndTimes = useSelector(selectCompanyStartEndTimes);
  const projectSelectorFromSelectedSchedulerItem = useMemo(() => {
    var _a, _b, _c;
    let projectId;
    if (isSchedulerItemABookingType(schedulerCurrentSelectedBooking)) {
      projectId = (_a = schedulerCurrentSelectedBooking === null || schedulerCurrentSelectedBooking === void 0 ? void 0 : schedulerCurrentSelectedBooking.project) === null || _a === void 0 ? void 0 : _a._id;
    } else if (isSchedulerItemADeadlineType(schedulerCurrentSelectedBooking)) {
      projectId = (_c = (_b = schedulerCurrentSelectedBooking === null || schedulerCurrentSelectedBooking === void 0 ? void 0 : schedulerCurrentSelectedBooking.booking) === null || _b === void 0 ? void 0 : _b.project) === null || _c === void 0 ? void 0 : _c._id;
    } else if (typeof (schedulerCurrentSelectedBooking === null || schedulerCurrentSelectedBooking === void 0 ? void 0 : schedulerCurrentSelectedBooking.project) === 'string') {
      projectId = schedulerCurrentSelectedBooking === null || schedulerCurrentSelectedBooking === void 0 ? void 0 : schedulerCurrentSelectedBooking.project;
    } else if (typeof (schedulerCurrentSelectedBooking === null || schedulerCurrentSelectedBooking === void 0 ? void 0 : schedulerCurrentSelectedBooking.projectId) === 'string') {
      projectId = schedulerCurrentSelectedBooking === null || schedulerCurrentSelectedBooking === void 0 ? void 0 : schedulerCurrentSelectedBooking.projectId;
    }
    return makeSelectProjectByIdFromMap(projectId);
  }, [schedulerCurrentSelectedBooking]);
  const currentSelectedProjectFromBooking = useSelector(projectSelectorFromSelectedSchedulerItem);
  const projectSelectorFromSchedulerSelection = useMemo(() => {
    var _a, _b;
    return makeSelectProjectByIdFromMap(((_b = (_a = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.project) === null || _b === void 0 ? void 0 : _b._id) || (viewData === null || viewData === void 0 ? void 0 : viewData.projectId));
  }, [(_b = (_a = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.project) === null || _b === void 0 ? void 0 : _b._id, viewData === null || viewData === void 0 ? void 0 : viewData.projectId]);
  const projectFromRowSelection = useSelector(projectSelectorFromSchedulerSelection);
  const schedulerGridMode = useSelector(selectSchedulerMode);
  const schedulerCurrentView = useSelector(selectSchedulerCurrentView);
  const isRequestExtInstalled = useSelector(selectIsResourceRequestExtensionInstalled);
  const resourceHolidaysSelector = useMemo(() => {
    var _a;
    return makeSelectHolidaysByCalendarIds((_a = values.resource) === null || _a === void 0 ? void 0 : _a.calendarIds);
  }, [(_c = values.resource) === null || _c === void 0 ? void 0 : _c.calendarIds]);
  const resourceHolidays = useSelector(resourceHolidaysSelector);
  const getFormValuesWithNewAllocation = useMemo(() => {
    return getFormValuesWithNewAllocationFactory({
      resourceHolidays: resourceHolidays,
      weekDaysSettings,
      avgDailyCapacity
    });
  }, [avgDailyCapacity, resourceHolidays, weekDaysSettings]);
  const [newResource, setNewResource] = useState({
    name: '',
    type: ResourceTypeEnum.REGULAR
  });
  const [newProject, setNewProject] = useState({
    name: '',
    type: ProjectTypeEnum.REGULAR
  });
  const [newCategory, setNewCategory] = useState({
    name: ''
  });
  const categories = useSelector(selectCategoryTemplatesFromGroups);
  const useCategoriesAllocation = useSelector(selectUseCategoriesAllocation);
  const calculateAllocationForCategory = useCalculateAllocationForCategory();
  const canSchedule = useCanSchedule({
    resource: values.resource,
    project: values.project
  });
  const canRequest = useCanRequest({
    resource: values.resource,
    project: values.project
  });
  const onClose = useCallback(() => {
    onCloseProp === null || onCloseProp === void 0 ? void 0 : onCloseProp();
  }, [onCloseProp]);
  const updateCategoryAllocation = useCallback(() => {
    setValues(values => {
      const result = calculateAllocationForCategory({
        percentage: values.percentage,
        hours: values.hours,
        total: values.total,
        category: values.category
      });
      return Object.assign(Object.assign({}, values), result);
    });
  }, [calculateAllocationForCategory, setValues]);
  const reCalcAllocation = useCallback(() => {
    setValues(currentValues => {
      const bookingAllocationValueName = allocationDefinitionsByStateName[currentValues.state].valueName;
      const {
        workDaysCount,
        totalMinutes
      } = calculateResourceCapacity({
        endDate: currentValues.endDate,
        resource: currentValues.resource,
        startDate: currentValues.startDate,
        companyWorkWeekDetails: weekDaysSettings,
        holidays: resourceHolidays
      });
      const newAllocationValues = getBookingAllocationValuesFromSingleValue({
        nameOfValue: bookingAllocationValueName,
        value: currentValues[bookingAllocationValueName],
        avgDailyCapacity,
        numberOfWorkDays: workDaysCount,
        totalBookingMinutes: totalMinutes
      });
      if (!isNumber(newAllocationValues.hours) || !isNumber(newAllocationValues.total) || !isNumber(newAllocationValues.percentage)) {
        return Object.assign({}, currentValues);
      }
      return Object.assign(Object.assign({}, currentValues), newAllocationValues);
    }, false);
  }, [avgDailyCapacity, resourceHolidays, setValues, weekDaysSettings]);
  const showMarkAsUnavailableBtn = Boolean((_d = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _d === void 0 ? void 0 : _d.isResourceRow);
  const markAsUnavailable = useCallback(() => {
    var _a;
    const currentResource = (_a = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.resource;
    if (!currentResource || !(currentResource === null || currentResource === void 0 ? void 0 : currentResource._id)) {
      return;
    }
    const canNotAddOverride = overrideDatesCheck({
      from: schedulerCurrentSelection.start,
      to: schedulerCurrentSelection.end
    }, Object.values((currentResource === null || currentResource === void 0 ? void 0 : currentResource.customAvailabilitiesOverridesById) || {}));
    if (canNotAddOverride) {
      dispatch(modalActions.showConfirmationModal(() => {
        // do nothing
      }, 'Not Allowed', "We are sorry, You cannot mark these dates as unavailable as there is already a custom availability date range set on these dates. Please edit the resource and configure the availability there instead.", {
        withCancel: false,
        confirmButtonText: 'Cancel'
      }));
    } else {
      dispatch(resourceActions.update.request(currentResource._id, {
        companySpecific: {
          customAvailabilityOverridesToSave: {
            create: calculateUnavailabilityDays(schedulerCurrentSelection, scale === CELLDURATION.value, weekDaysSettings, currentResource)
          }
        }
      }));
    }
  }, [schedulerCurrentSelection, dispatch, scale, weekDaysSettings]);
  const showRequestVacationBtn = useMemo(() => {
    var _a;
    const {
      unassignedRow,
      project,
      resource
    } = (schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) || {};
    if (scheduleToolBarContext) {
      return false;
    }
    if (requestToolBarContext) {
      return Boolean(!unassignedRow && resource);
    }
    if (schedulerGridMode === 'PARENT' && ((_a = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.isResourceRow) && (resource === null || resource === void 0 ? void 0 : resource.type) === ResourceTypeEnum.REGULAR) {
      return true;
    }
    return Boolean(!unassignedRow && !project);
  }, [requestToolBarContext, scheduleToolBarContext, schedulerCurrentSelection, schedulerGridMode]);
  const defaultVacationApprovers = useGetDefaultApprovers({
    resource: values.resource
  });
  const requestVacation = useCallback(() => {
    var _a;
    const currentSelectedResource = (_a = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.resource;
    if (!currentSelectedResource || !onRequestVacation) {
      return;
    }
    onRequestVacation({
      resource: currentSelectedResource._id,
      approvalInfo: {
        approvers: (defaultVacationApprovers || currentSelectedResource.defaultApproverIds || []).map(approverOrId => {
          if (approverOrId && typeof approverOrId === 'object') {
            return {
              id: approverOrId._id
            };
          }
          return {
            id: approverOrId
          };
        })
      }
    });
  }, [(_e = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _e === void 0 ? void 0 : _e.resource, defaultVacationApprovers, onRequestVacation]);
  const onPasteBooking = useCallback(() => {
    onPasteBookingProp === null || onPasteBookingProp === void 0 ? void 0 : onPasteBookingProp();
  }, [onPasteBookingProp]);
  const showMoreProjectActionsBtn = useMemo(() => {
    return Boolean(schedulerGridMode && schedulerGridMode !== 'LEGACY' && schedulerCurrentView === 'project');
  }, [schedulerCurrentView, schedulerGridMode]);
  const showMoreBtn = useMemo(() => {
    const {
      isResourceRow,
      unassignedParentRow,
      menuRow,
      isEventRow
    } = (schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) || {};
    return Boolean(isResourceRow || unassignedParentRow || menuRow || isEventRow) && !showMoreProjectActionsBtn;
  }, [schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags, showMoreProjectActionsBtn]);
  const scheduleRequestProject = useMemo(() => {
    var _a;
    return Boolean((_a = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.isProjectRow);
  }, [(_f = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _f === void 0 ? void 0 : _f.isProjectRow]);
  const onCreatePhase = useCallback(formValues => {
    const formattedPhase = mapProjectPhaseFormToRequest(formValues, undefined, companyStartEndTimes);
    if (!formattedPhase || !onCreatePhaseProp) {
      return;
    }
    onCreatePhaseProp(formattedPhase);
  }, [companyStartEndTimes, onCreatePhaseProp]);
  const onUpdatePhase = useCallback((formValues, initialFormValues) => {
    const formattedPhases = mapProjectPhaseFormToRequest(formValues, initialFormValues, companyStartEndTimes);
    if (!formattedPhases || !onUpdatePhaseProp) {
      return;
    }
    const phaseId = Array.isArray(formattedPhases) ? formattedPhases[0]._id : formattedPhases._id;
    const project = Array.isArray(formattedPhases) ? formattedPhases[0].project : formattedPhases.project;
    if (!project || !phaseId) {
      return;
    }
    onUpdatePhaseProp(phaseId, project, formattedPhases);
  }, [companyStartEndTimes, onUpdatePhaseProp]);
  const onCreateMilestone = useCallback(formValues => {
    const formattedMilestone = mapProjectMilestoneFormToRequest(formValues);
    if (!formattedMilestone || !onCreateMilestoneProp) {
      return;
    }
    onCreateMilestoneProp(formattedMilestone);
  }, [onCreateMilestoneProp]);
  const onUpdateMilestone = useCallback((formValues, initialMilestoneFormValues) => {
    const formattedMilestones = mapProjectMilestoneFormToRequest(formValues, initialMilestoneFormValues);
    if (!formattedMilestones || !onUpdateMilestoneProp) {
      return;
    }
    const milestoneId = Array.isArray(formattedMilestones) ? formattedMilestones[0]._id : formattedMilestones._id;
    const project = Array.isArray(formattedMilestones) ? formattedMilestones[0].project : formattedMilestones.project;
    if (!project || !milestoneId) {
      return;
    }
    onUpdateMilestoneProp(project, formattedMilestones);
  }, [onUpdateMilestoneProp]);
  const onUpdateProjectDates = useCallback(formValues => {
    const formattedProjectDates = mapProjectDatesFormToRequest(formValues);
    if (!formattedProjectDates || !onUpdateProjectDatesProp) {
      return;
    }
    onUpdateProjectDatesProp(formattedProjectDates);
  }, [onUpdateProjectDatesProp]);
  const onCopyBooking = useCallback(() => {
    onCopyBookingProp === null || onCopyBookingProp === void 0 ? void 0 : onCopyBookingProp();
  }, [onCopyBookingProp]);
  const onDuplicateBooking = useCallback(() => {
    onDuplicateBookingProp === null || onDuplicateBookingProp === void 0 ? void 0 : onDuplicateBookingProp();
  }, [onDuplicateBookingProp]);
  const onEditBookingTitle = useCallback(() => {
    onEditBookingTitleProp === null || onEditBookingTitleProp === void 0 ? void 0 : onEditBookingTitleProp();
  }, [onEditBookingTitleProp]);
  const onBulkMove = useCallback(() => {
    onBulkMoveProp === null || onBulkMoveProp === void 0 ? void 0 : onBulkMoveProp();
  }, [onBulkMoveProp]);
  const showBookingModal = useCallback(tabId => {
    showBookingModalProp === null || showBookingModalProp === void 0 ? void 0 : showBookingModalProp(tabId);
  }, [showBookingModalProp]);
  const showSplitBookingOption = useMemo(() => {
    if (!schedulerCurrentSelectedBooking) {
      return false;
    }
    return isSchedulerItemABookingType(schedulerCurrentSelectedBooking) && !schedulerCurrentSelectedBooking.repeat && scale !== CELLDURATION.value && schedulerCurrentSelectedBooking.allDay;
  }, [scale, schedulerCurrentSelectedBooking]);
  const disableSplitBookingOption = useMemo(() => {
    if (!schedulerCurrentSelectedBooking || !isSchedulerItemABookingType(schedulerCurrentSelectedBooking)) {
      return false;
    }
    return isSameDay(schedulerCurrentSelectedBooking.start, schedulerCurrentSelectedBooking.end);
  }, [schedulerCurrentSelectedBooking]);
  const onSplitBooking = useCallback(params => {
    onSlitBookingProp === null || onSlitBookingProp === void 0 ? void 0 : onSlitBookingProp(params);
  }, [onSlitBookingProp]);
  const onDeleteBooking = useCallback(() => {
    onDeleteBookingProp === null || onDeleteBookingProp === void 0 ? void 0 : onDeleteBookingProp();
  }, [onDeleteBookingProp]);
  const onCutBooking = useCallback(() => {
    onCutBookingProp === null || onCutBookingProp === void 0 ? void 0 : onCutBookingProp();
  }, [onCutBookingProp]);
  const onSubmitSchedule = useCallback(() => {
    onScheduleProp === null || onScheduleProp === void 0 ? void 0 : onScheduleProp(Object.assign(Object.assign({}, mapBookingToCreateDto(values, scale)), {
      type: BookingTypeEnum.SCHEDULED
    }));
  }, [onScheduleProp, scale, values]);
  const onSubmitRequest = useCallback(() => {
    const requestData = Object.assign(Object.assign({}, mapBookingToCreateDto(values, scale)), {
      type: BookingTypeEnum.WAITING_FOR_APPROVAL
    });
    onRequestProp === null || onRequestProp === void 0 ? void 0 : onRequestProp(requestData);
  }, [onRequestProp, scale, values]);
  const onSubmitUpdateBooking = useCallback(() => {
    onUpdateBookingProp === null || onUpdateBookingProp === void 0 ? void 0 : onUpdateBookingProp(mapBookingToUpdateDto(values));
  }, [onUpdateBookingProp, values]);
  const onUpdateBookingCategory = useCallback(category => {
    if (!onUpdateBookingProp || !isSchedulerItemABookingType(schedulerCurrentSelectedBooking)) {
      return;
    }
    const newAllocationValues = calculateAllocationForCategory({
      category: category,
      percentage: category.percentAllocation,
      hours: category.minutesPerDay / 60,
      total: category.totalBucketMinutesAllocation / 60
    });
    onUpdateBookingProp(Object.assign({
      categoryTemplate: category,
      repeatId: schedulerCurrentSelectedBooking === null || schedulerCurrentSelectedBooking === void 0 ? void 0 : schedulerCurrentSelectedBooking.repeatId,
      repeat: schedulerCurrentSelectedBooking === null || schedulerCurrentSelectedBooking === void 0 ? void 0 : schedulerCurrentSelectedBooking.repeat,
      interval: schedulerCurrentSelectedBooking === null || schedulerCurrentSelectedBooking === void 0 ? void 0 : schedulerCurrentSelectedBooking.interval,
      repeatEveryTime: schedulerCurrentSelectedBooking === null || schedulerCurrentSelectedBooking === void 0 ? void 0 : schedulerCurrentSelectedBooking.repeatEveryTime,
      repeatEveryInterval: schedulerCurrentSelectedBooking === null || schedulerCurrentSelectedBooking === void 0 ? void 0 : schedulerCurrentSelectedBooking.repeatEveryInterval,
      repeatEndsAfterTimes: schedulerCurrentSelectedBooking === null || schedulerCurrentSelectedBooking === void 0 ? void 0 : schedulerCurrentSelectedBooking.repeatEndsAfterTimes,
      repeatOn: schedulerCurrentSelectedBooking === null || schedulerCurrentSelectedBooking === void 0 ? void 0 : schedulerCurrentSelectedBooking.repeatOn,
      repeatOnWeekdays: schedulerCurrentSelectedBooking === null || schedulerCurrentSelectedBooking === void 0 ? void 0 : schedulerCurrentSelectedBooking.repeatOnWeekdays,
      repeatOnDates: schedulerCurrentSelectedBooking === null || schedulerCurrentSelectedBooking === void 0 ? void 0 : schedulerCurrentSelectedBooking.repeatOnDates,
      repeatOnCustom1: schedulerCurrentSelectedBooking === null || schedulerCurrentSelectedBooking === void 0 ? void 0 : schedulerCurrentSelectedBooking.repeatOnCustom1,
      repeatOnCustom2: schedulerCurrentSelectedBooking === null || schedulerCurrentSelectedBooking === void 0 ? void 0 : schedulerCurrentSelectedBooking.repeatOnCustom2
    }, useCategoriesAllocation && newAllocationValues ? {
      percentAllocation: newAllocationValues.percentage,
      minutesPerDay: newAllocationValues.hours * 60,
      totalBucketMinutesAllocation: newAllocationValues.total * 60,
      state: newAllocationValues.state
    } : {}));
  }, [calculateAllocationForCategory, onUpdateBookingProp, schedulerCurrentSelectedBooking, useCategoriesAllocation]);
  const onEditProject = useCallback(() => {
    let projectToUse;
    if (projectFromRowSelection) {
      projectToUse = projectFromRowSelection;
    } else if (currentSelectedProjectFromBooking && typeof currentSelectedProjectFromBooking !== 'string') {
      projectToUse = currentSelectedProjectFromBooking;
    } else {
      return;
    }
    dispatch(modalActions.showProjectModal({
      onSubmit: data => dispatch(projectActions.update.request(projectToUse._id, data)),
      type: projectToUse.type,
      projectId: projectToUse._id
    }));
  }, [currentSelectedProjectFromBooking, dispatch, projectFromRowSelection]);
  const onEditResource = useCallback(() => {
    var _a;
    const currentSelectedResource = isSchedulerItemABookingType(schedulerCurrentSelectedBooking) ? schedulerCurrentSelectedBooking.resourceInfo : (_a = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.resource;
    if (!currentSelectedResource) {
      return;
    }
    dispatch(modalActions.showResourceModal({
      type: currentSelectedResource.type,
      resourceId: currentSelectedResource._id,
      onSubmit: data => {
        dispatch(resourceActions.update.request(currentSelectedResource._id, data));
      }
    }));
  }, [dispatch, schedulerCurrentSelectedBooking, schedulerCurrentSelection]);
  const onAssignToAll = useCallback(() => {
    if (!onAssignToAllProp) {
      return;
    }
    onAssignToAllProp();
  }, [onAssignToAllProp]);
  const onSwitchProject = useCallback(project => {
    if (!onUpdateBookingProp) {
      return;
    }
    const categoryTemplate = categories.find(category => category._id === project.defaultCategoryTemplate);
    if (categoryTemplate) {
      onUpdateBookingProp({
        project,
        categoryTemplate
      });
    } else {
      onUpdateBookingProp({
        project
      });
    }
  }, [categories, onUpdateBookingProp]);
  const onSwitchResource = useCallback(resource => {
    if (!onUpdateBookingProp) {
      return;
    }
    onUpdateBookingProp({
      resourceInfo: Object.assign(Object.assign({}, resource), {
        _id: resource._id
      })
    });
  }, [onUpdateBookingProp]);
  const onUpdateBooking = useCallback(data => {
    if (!onUpdateBookingProp) {
      return;
    }
    onUpdateBookingProp(data);
  }, [onUpdateBookingProp]);
  const categoryTemplateSelector = useMemo(() => {
    return makeSelectCategoryFromGroup(projectFromRowSelection === null || projectFromRowSelection === void 0 ? void 0 : projectFromRowSelection.defaultCategoryTemplate);
  }, [projectFromRowSelection === null || projectFromRowSelection === void 0 ? void 0 : projectFromRowSelection.defaultCategoryTemplate]);
  const categoryTemplate = useSelector(categoryTemplateSelector);
  const showScheduleSelectionBtn = useMemo(() => {
    return Boolean((viewObject === null || viewObject === void 0 ? void 0 : viewObject.isSingleProjectView) && schedulerGridMode === 'LEGACY') || schedulerGridMode === 'PARENT';
  }, [schedulerGridMode, viewObject === null || viewObject === void 0 ? void 0 : viewObject.isSingleProjectView]);
  const scheduleSelection = useCallback(() => {
    var _a, _b, _c, _d, _e;
    if (!onScheduleProp) {
      return;
    }
    onScheduleProp({
      start: formatDate(schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.start, DATE_FORMATS.BE_FORMAT),
      end: formatDate(schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.end, DATE_FORMATS.BE_FORMAT),
      type: BookingTypeEnum.SCHEDULED,
      resource: ((_b = (_a = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.resource) === null || _b === void 0 ? void 0 : _b._id) || (viewData === null || viewData === void 0 ? void 0 : viewData.resourceId),
      project: ((_d = (_c = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _c === void 0 ? void 0 : _c.project) === null || _d === void 0 ? void 0 : _d._id) || (viewData === null || viewData === void 0 ? void 0 : viewData.projectId),
      state: useCategoriesAllocation ? (categoryTemplate === null || categoryTemplate === void 0 ? void 0 : categoryTemplate.state) || bookingDefaultState : bookingDefaultState,
      scale: (_e = getScaleObjectByValue(scale)) === null || _e === void 0 ? void 0 : _e.BEValue,
      allDay: scale !== 'CellDuration'
    });
  }, [bookingDefaultState, categoryTemplate === null || categoryTemplate === void 0 ? void 0 : categoryTemplate.state, onScheduleProp, scale, schedulerCurrentSelection, useCategoriesAllocation, viewData]);
  const showRequestSelectionBtn = useMemo(() => {
    return Boolean((viewObject === null || viewObject === void 0 ? void 0 : viewObject.isSingleProjectView) && schedulerGridMode === 'LEGACY') || schedulerGridMode === 'PARENT';
  }, [schedulerGridMode, viewObject === null || viewObject === void 0 ? void 0 : viewObject.isSingleProjectView]);
  const requestSelection = useCallback(() => {
    var _a, _b, _c, _d, _e;
    if (!onScheduleProp) {
      return;
    }
    onScheduleProp({
      start: formatDate(schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.start, DATE_FORMATS.BE_FORMAT),
      end: formatDate(schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.end, DATE_FORMATS.BE_FORMAT),
      type: BookingTypeEnum.WAITING_FOR_APPROVAL,
      resource: ((_b = (_a = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.resource) === null || _b === void 0 ? void 0 : _b._id) || (viewData === null || viewData === void 0 ? void 0 : viewData.resourceId),
      project: ((_d = (_c = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _c === void 0 ? void 0 : _c.project) === null || _d === void 0 ? void 0 : _d._id) || (viewData === null || viewData === void 0 ? void 0 : viewData.projectId),
      state: useCategoriesAllocation ? (categoryTemplate === null || categoryTemplate === void 0 ? void 0 : categoryTemplate.state) || bookingDefaultState : bookingDefaultState,
      scale: (_e = getScaleObjectByValue(scale)) === null || _e === void 0 ? void 0 : _e.BEValue,
      allDay: scale !== 'CellDuration',
      approvalInfo: {
        approvers: []
      }
    });
  }, [bookingDefaultState, categoryTemplate === null || categoryTemplate === void 0 ? void 0 : categoryTemplate.state, onScheduleProp, scale, schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.end, (_h = (_g = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _g === void 0 ? void 0 : _g.project) === null || _h === void 0 ? void 0 : _h._id, (_k = (_j = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _j === void 0 ? void 0 : _j.resource) === null || _k === void 0 ? void 0 : _k._id, schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.start, useCategoriesAllocation, viewData === null || viewData === void 0 ? void 0 : viewData.projectId, viewData === null || viewData === void 0 ? void 0 : viewData.resourceId]);
  const scheduleOnNewProject = useCallback(values => {
    if (!onScheduleProp) {
      return;
    }
    dispatch(projectActions.create.request({
      project: {
        name: values.name
      },
      options: {
        skipCustomFieldsValidation: true
      }
    }, project => {
      var _a, _b, _c;
      onScheduleProp({
        start: formatDate(schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.start, DATE_FORMATS.BE_FORMAT),
        end: formatDate(schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.end, DATE_FORMATS.BE_FORMAT),
        resource: ((_b = (_a = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.resource) === null || _b === void 0 ? void 0 : _b._id) || (viewData === null || viewData === void 0 ? void 0 : viewData.resourceId),
        project: project._id,
        state: useCategoriesAllocation ? (categoryTemplate === null || categoryTemplate === void 0 ? void 0 : categoryTemplate.state) || bookingDefaultState : bookingDefaultState,
        scale: (_c = getScaleObjectByValue(scale)) === null || _c === void 0 ? void 0 : _c.BEValue,
        allDay: scale !== 'CellDuration'
      });
    }));
  }, [bookingDefaultState, categoryTemplate === null || categoryTemplate === void 0 ? void 0 : categoryTemplate.state, dispatch, onScheduleProp, scale, schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.end, (_m = (_l = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _l === void 0 ? void 0 : _l.resource) === null || _m === void 0 ? void 0 : _m._id, schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.start, useCategoriesAllocation, viewData === null || viewData === void 0 ? void 0 : viewData.resourceId]);
  const onDeleteProjectItem = useCallback(() => {
    if (!onDeleteProjectItemProp) {
      return;
    }
    onDeleteProjectItemProp();
  }, [onDeleteProjectItemProp]);
  const onCreateProject = useCallback((data, redirect) => {
    if (!onCreateProjectProp) {
      return;
    }
    onCreateProjectProp(data, redirect);
  }, [onCreateProjectProp]);
  const prevNoOfDays = usePrevious(values.daysCounter);
  const handleDaysCounterChange = useCallback(event => {
    setValues(prev => {
      const parsedValue = Number.parseFloat(event.target.value);
      if (!isNumber(parsedValue)) {
        return prev;
      }
      let newNoOfDaysValue = parsedValue > MAX_NUMBER_BOOKING_DAYS ? MAX_NUMBER_BOOKING_DAYS : parsedValue;
      if (newNoOfDaysValue < 0) {
        newNoOfDaysValue = 0;
      }
      const {
        endDate: newEndDate,
        numberOfWorkDays
      } = calculateEndDate({
        startDate: prev.startDate,
        noOfDays: newNoOfDaysValue,
        resource: prev.resource,
        companyWorkWeekDetails: weekDaysSettings,
        holidays: resourceHolidays
      });
      return getFormValuesWithNewAllocation(Object.assign(Object.assign({}, prev), {
        daysCounter: numberOfWorkDays,
        endDate: newEndDate
      }));
    });
  }, [getFormValuesWithNewAllocation, resourceHolidays, setValues, weekDaysSettings]);
  const handleDaysCounterBlur = useCallback(event => {
    setValues(values => {
      if (!isNumber(values.daysCounter) && isNumber(prevNoOfDays)) {
        return getFormValuesWithNewAllocation(Object.assign(Object.assign({}, values), {
          daysCounter: prevNoOfDays
        }));
      }
      return getFormValuesWithNewAllocation(values);
    });
  }, [getFormValuesWithNewAllocation, prevNoOfDays, setValues]);
  const onStartDateChange = useCallback(startDate => {
    setValues(prev => {
      const {
        workDaysCount
      } = calculateResourceCapacity({
        endDate: prev.endDate,
        startDate: startDate,
        resource: prev.resource,
        companyWorkWeekDetails: weekDaysSettings,
        holidays: resourceHolidays
      });
      return getFormValuesWithNewAllocation(Object.assign(Object.assign({}, prev), {
        daysCounter: workDaysCount
      }));
    });
  }, [getFormValuesWithNewAllocation, resourceHolidays, setValues, weekDaysSettings]);
  const onEndDateChange = useCallback(endDate => {
    setValues(prev => {
      const {
        workDaysCount
      } = calculateResourceCapacity({
        endDate: endDate,
        startDate: prev.startDate,
        resource: prev.resource,
        companyWorkWeekDetails: weekDaysSettings,
        holidays: resourceHolidays
      });
      return getFormValuesWithNewAllocation(Object.assign(Object.assign({}, prev), {
        daysCounter: workDaysCount
      }));
    });
  }, [getFormValuesWithNewAllocation, resourceHolidays, setValues, weekDaysSettings]);
  return jsx(ContextMenuContext.Provider, {
    value: {
      showScheduleSelectionBtn,
      showRequestSelectionBtn,
      requestToolBarContext,
      displayScheduleBtn: !requestToolBarContext,
      displayRequestBtn: !scheduleToolBarContext && isRequestExtInstalled,
      scheduleRequestProject,
      showMoreProjectActionsBtn,
      showRequestVacationBtn,
      showMarkAsUnavailableBtn,
      reCalcAllocation,
      onStartDateChange,
      onEndDateChange,
      newResource,
      setNewResource,
      newProject,
      setNewProject,
      newCategory,
      setNewCategory,
      canSchedule: canSchedule && isValid,
      canRequest: canRequest && isValid,
      canUpdateBooking: isValid && dirty,
      updateCategoryAllocation,
      markAsUnavailable,
      requestVacation,
      showMoreBtn,
      onPasteBooking,
      onClose,
      onCreateMilestone,
      onUpdateMilestone,
      onCreatePhase,
      onUpdatePhase,
      onUpdateProjectDates,
      onCopyBooking,
      onDuplicateBooking,
      onEditBookingTitle,
      onBulkMove,
      showBookingModal,
      onSplitBooking,
      onDeleteBooking,
      onCutBooking,
      showSplitBookingOption,
      disableSplitBookingOption,
      onSubmitRequest,
      onSubmitSchedule,
      onUpdateBookingCategory,
      onEditProject,
      onEditResource,
      onAssignToAll,
      onSwitchProject,
      onSwitchResource,
      onUpdateBooking,
      onSubmitUpdateBooking,
      scheduleSelection,
      requestSelection,
      scheduleOnNewProject,
      onDeleteProjectItem,
      onCreateProject,
      onDaysCounterChanged: handleDaysCounterChange,
      onDaysCounterBlur: handleDaysCounterBlur,
      viewData
    },
    children: children
  });
};
const ContextMenuContextProvider = props => {
  var _a;
  const {
    children,
    requestToolBarContext,
    scheduleToolBarContext,
    viewObject,
    viewData,
    onPasteBooking,
    onRequestVacation,
    onClose,
    onCreateMilestone,
    onUpdateMilestone,
    onCreatePhase,
    onUpdatePhase,
    onUpdateProjectDates,
    onCopyBooking,
    onDuplicateBooking,
    onEditBookingTitle,
    showBookingModal,
    onBulkMove,
    onSplitBooking,
    onDeleteBooking,
    onCutBooking,
    onSchedule,
    onRequest,
    onUpdateBooking,
    onAssignToAll,
    onDeleteProjectItem,
    onCreateProject
  } = props;
  const initialData = useSelector(selectContextMenuScheduleInitialData);
  const weekDaysSettings = useSelector(selectWeekDaysSetting);
  const resourceHolidaysSelector = useMemo(() => {
    var _a;
    return makeSelectHolidaysByCalendarIds((_a = initialData === null || initialData === void 0 ? void 0 : initialData.resource) === null || _a === void 0 ? void 0 : _a.calendarIds);
  }, [(_a = initialData.resource) === null || _a === void 0 ? void 0 : _a.calendarIds]);
  const resourceHolidays = useSelector(resourceHolidaysSelector);
  const initialValues = useMemo(() => {
    var _a, _b, _c;
    const result = {
      category: ((_a = initialData.category) === null || _a === void 0 ? void 0 : _a._id) ? initialData.category : undefined,
      resource: ((_b = initialData.resource) === null || _b === void 0 ? void 0 : _b._id) ? initialData.resource : undefined,
      project: ((_c = initialData.project) === null || _c === void 0 ? void 0 : _c._id) ? initialData.project : undefined,
      startDate: initialData.startDate || dateToPrecision(new Date(), 'day'),
      endDate: initialData.endDate || dateToPrecision(new Date(), 'day'),
      interval: initialData.interval,
      repeatEveryTime: initialData.repeatEveryTime || undefined,
      repeatEveryInterval: initialData.repeatEveryInterval || undefined,
      repeatOnWeekdays: initialData.repeatOnWeekdays || undefined,
      repeatOn: initialData.repeatOn || undefined,
      repeatOnDates: initialData.repeatOnDates || undefined,
      repeatOnCustom1: initialData.repeatOnCustom1 || undefined,
      repeatOnCustom2: initialData.repeatOnCustom2 || undefined,
      repeatEndsOn: initialData.repeatEndsOn || undefined,
      repeatEndsOnDate: initialData.repeatEndsOnDate ? toDate$1(removeUTCZuluFromDateTimestamp(initialData.repeatEndsOnDate)) : undefined,
      repeatEndsAfterTimes: initialData.repeatEndsAfterTimes,
      state: initialData.state || AllocationStateEnum.PERCENTAGE,
      percentage: isNumber(initialData.percentage) ? initialData.percentage : 100,
      hours: isNumber(initialData.hours) ? initialData.hours : 8,
      total: isNumber(initialData.total) ? initialData.total : 8,
      bookingColor: initialData.useProjectColor ? '' : initialData.bookingColor || DEFAULT_COLOR,
      useProjectColor: initialData.useProjectColor,
      daysCounter: 1
    };
    const {
      workDaysCount
    } = calculateResourceCapacity({
      endDate: result.endDate,
      startDate: result.startDate,
      resource: result.resource,
      companyWorkWeekDetails: weekDaysSettings,
      holidays: resourceHolidays
    });
    result.daysCounter = workDaysCount;
    return result;
  }, [initialData.bookingColor, initialData.category, initialData.endDate, initialData.hours, initialData.interval, initialData.percentage, initialData.project, initialData.repeatEndsAfterTimes, initialData.repeatEndsOn, initialData.repeatEndsOnDate, initialData.repeatEveryInterval, initialData.repeatEveryTime, initialData.repeatOn, initialData.repeatOnCustom1, initialData.repeatOnCustom2, initialData.repeatOnDates, initialData.repeatOnWeekdays, initialData.resource, initialData.startDate, initialData.state, initialData.total, initialData.useProjectColor, resourceHolidays, weekDaysSettings]);
  return jsx(Formik, {
    initialValues: initialValues,
    validationSchema: scheduleFormValidationSchema,
    enableReinitialize: true,
    onSubmit: () => {
      // do nothing, actions are handled by separate btns/functions
    },
    children: jsx(Form, {
      children: jsx(ContextMenuContextProviderInner, {
        viewObject: viewObject,
        viewData: viewData,
        requestToolBarContext: requestToolBarContext,
        scheduleToolBarContext: scheduleToolBarContext,
        onPasteBooking: onPasteBooking,
        onRequestVacation: onRequestVacation,
        onCreateMilestone: onCreateMilestone,
        onUpdateMilestone: onUpdateMilestone,
        onCreatePhase: onCreatePhase,
        onUpdatePhase: onUpdatePhase,
        onUpdateProjectDates: onUpdateProjectDates,
        onClose: onClose,
        onDuplicateBooking: onDuplicateBooking,
        onCopyBooking: onCopyBooking,
        onEditBookingTitle: onEditBookingTitle,
        showBookingModal: showBookingModal,
        onBulkMove: onBulkMove,
        onSplitBooking: onSplitBooking,
        onCutBooking: onCutBooking,
        onDeleteBooking: onDeleteBooking,
        onRequest: onRequest,
        onSchedule: onSchedule,
        onUpdateBooking: onUpdateBooking,
        onAssignToAll: onAssignToAll,
        onDeleteProjectItem: onDeleteProjectItem,
        onCreateProject: onCreateProject,
        children: children
      })
    })
  });
};
const getFormValuesWithNewAllocationFactory = _ref337 => {
  let {
    weekDaysSettings,
    avgDailyCapacity,
    resourceHolidays
  } = _ref337;
  return formValues => {
    const bookingAllocationValueName = allocationDefinitionsByStateName[formValues.state].valueName;
    const {
      workDaysCount,
      totalMinutes
    } = calculateResourceCapacity({
      endDate: formValues.endDate,
      resource: formValues.resource,
      startDate: formValues.startDate,
      companyWorkWeekDetails: weekDaysSettings,
      holidays: resourceHolidays
    });
    const newAllocationValues = getBookingAllocationValuesFromSingleValue({
      nameOfValue: bookingAllocationValueName,
      value: formValues[bookingAllocationValueName],
      avgDailyCapacity,
      numberOfWorkDays: workDaysCount,
      totalBookingMinutes: totalMinutes
    });
    if (!isNumber(newAllocationValues.hours) || !isNumber(newAllocationValues.total) || !isNumber(newAllocationValues.percentage)) {
      return Object.assign({}, formValues);
    }
    return Object.assign(Object.assign({}, formValues), newAllocationValues);
  };
};
const ClassicChildParentMode = /*#__PURE__*/React__default.memo(props => {
  var _a, _b, _c, _d;
  const {
    position,
    anchorEl
  } = props;
  const {
    resourceKeyWord,
    projectKeyWord
  } = useAppKeyWords();
  const canPasteBooking = useCanPasteBooking();
  const currentSelection = useSelector(selectSchedulerCurrentSelection);
  const currentSelectedProject = (_a = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.project;
  const currentSelectedResource = (_b = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _b === void 0 ? void 0 : _b.resource;
  const canSchedule = useCanSchedule({
    project: currentSelectedProject,
    resource: currentSelectedResource
  });
  const canRequest = useCanRequest({
    project: currentSelectedProject,
    resource: currentSelectedResource
  });
  const canEditResourceWorkHours = useCanEditResourceWorkHours({
    resource: currentSelectedResource
  });
  const canEditResource = useCanEditResource({
    resource: currentSelectedResource
  }) && Boolean((_c = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _c === void 0 ? void 0 : _c.isResourceRow);
  const canEditProject = useCanEditProject({
    project: currentSelectedProject
  }) && Boolean((_d = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _d === void 0 ? void 0 : _d.isProjectRow);
  const {
    onClose,
    onPasteBooking,
    showScheduleSelectionBtn,
    scheduleSelection,
    showRequestSelectionBtn,
    requestSelection,
    showMarkAsUnavailableBtn,
    markAsUnavailable,
    onEditResource,
    onEditProject
  } = useContextMenuContext();
  const menuItems = useMemo(() => {
    return [{
      disabled: !canPasteBooking,
      dataCy: "button--paste-booking",
      label: "Paste booking",
      onClick: () => {
        onPasteBooking();
      }
    }, {
      divider: true
    }, {
      disabled: !canSchedule,
      hidden: !showScheduleSelectionBtn,
      dataCy: "button--schedule-selection",
      label: "Schedule selection",
      onClick: () => {
        scheduleSelection();
      }
    }, {
      disabled: !canRequest,
      hidden: !showRequestSelectionBtn,
      dataCy: "button--request-selection",
      label: "Request ".concat(resourceKeyWord),
      onClick: () => {
        requestSelection();
      }
    }, {
      hidden: !(showMarkAsUnavailableBtn && canEditResourceWorkHours),
      divider: true
    }, {
      hidden: !(showMarkAsUnavailableBtn && canEditResourceWorkHours),
      dataCy: "mark-as-unavailable",
      label: "Mark as unavailable ",
      onClick: () => {
        onClose();
        markAsUnavailable();
      }
    }, {
      hidden: !canEditResource,
      divider: true
    }, {
      hidden: !canEditResource,
      dataCy: "button--edit-resource",
      label: "Edit ".concat(isResource(currentSelectedResource) ? resourceKeyWord : 'unassigned'),
      onClick: () => {
        onClose();
        onEditResource();
      }
    }, {
      hidden: !canEditProject,
      dataCy: "button--edit-project",
      label: "Edit ".concat(isEvent(currentSelectedProject) ? 'event' : projectKeyWord),
      onClick: () => {
        onClose();
        onEditProject();
      }
    }];
  }, [canPasteBooking, canSchedule, showScheduleSelectionBtn, canRequest, showRequestSelectionBtn, resourceKeyWord, showMarkAsUnavailableBtn, canEditResourceWorkHours, canEditResource, currentSelectedResource, canEditProject, currentSelectedProject, projectKeyWord, onPasteBooking, scheduleSelection, requestSelection, onClose, markAsUnavailable, onEditResource, onEditProject]);
  return jsx(ContextMenu, {
    variant: "anchor",
    isOpen: true,
    position: position,
    items: menuItems,
    onClose: onClose,
    anchorEl: anchorEl
  });
});
const isAllDayBooking = booking => {
  if (!booking) {
    return false;
  }
  return 'allDay' in booking && booking.allDay;
};
const useIsAllDaySchedulerCurrentSelectedBooking = () => {
  const booking = useSelector(selectSchedulerCurrentSelectedBooking);
  return isAllDayBooking(booking);
};
const isHourScaleBooking = booking => {
  if (!booking || !isSchedulerItemABookingType(booking)) {
    return false;
  }
  return booking.scale.value === CELLDURATION.value;
};
const useIsHourScaleSchedulerCurrentSelectedBooking = () => {
  const booking = useSelector(selectSchedulerCurrentSelectedBooking);
  return isHourScaleBooking(booking);
};
const config = {
  [ExtensionsEnum.DEPENDENCIES]: {
    label: 'Dependencies',
    action: () => modalActions.showMissingDependenciesExtensionModal()
  },
  [ExtensionsEnum.DEADLINES]: {
    label: 'Deadlines',
    action: () => modalActions.showMissingDeadlinesExtensionModal()
  },
  [ExtensionsEnum.TASKS]: {
    label: 'Tasks',
    action: () => {
      window.location.href = '/settings#extensions';
    }
  }
};
const StyledTooltip = /*#__PURE__*/styled(Tooltip).withConfig({
  displayName: "missing-extension-tooltip__StyledTooltip",
  componentId: "nk9chf-0"
})(["&.hub-ui__tooltip-content-wrapper{display:flex;width:100%;flex:1 1 auto;}"]);
const MissingExtensionTooltip = /*#__PURE__*/React__default.memo(props => {
  const {
    children,
    extension,
    onClick
  } = props;
  const dispatch = useDispatch();
  const extensionConfig = useMemo(() => {
    return config[extension];
  }, [extension]);
  const handleClick = useCallback(() => {
    onClick === null || onClick === void 0 ? void 0 : onClick();
    dispatch(extensionConfig.action());
  }, [dispatch, extensionConfig, onClick]);
  if (!extensionConfig) {
    return null;
  }
  return jsx(StyledTooltip, {
    interactive: true,
    title: jsxs(Layout, {
      stack: true,
      gap: "--Spacing-100",
      hAlign: "flex-start",
      children: [jsx(Typography, {
        variant: "label",
        size: "large",
        color: "on-tertiary-container",
        children: "Missing Extension"
      }), jsxs(Typography, {
        variant: "body",
        size: "medium",
        align: "left",
        color: "on-tertiary-container",
        children: ["Please install the \"", extensionConfig.label, "\" for access this option."]
      }), jsx(Button, {
        variant: "text",
        onClick: handleClick,
        endIcon: "arrowForward",
        children: "Go to Extension"
      })]
    }),
    children: children
  });
});
const rights$7 = [{
  rights: ['manageEvents'],
  rule: 'one'
}, {
  rights: ['pmManageEvents'],
  rule: 'one'
}];
const useCanBulkMoveSelectedBooking = () => {
  const [hasManageEventsRights, hasPMManageEventsRights] = useHasRoleRights(rights$7);
  const selectedBooking = useSelector(selectSchedulerCurrentSelectedBooking);
  const isPMExtensionInstalled = useSelector(selectIsPMExtensionInstalled);
  const isProjectManager = useSelector(selectIsAccountPm);
  const accountResourceId = useSelector(selectAccountResourceId);
  return useMemo(() => {
    if (!selectedBooking || !isSchedulerItemABookingType(selectedBooking)) {
      return false;
    }
    const project = selectedBooking.project;
    const isPMonProject = project.projectManagers.includes(accountResourceId);
    const hasPMRights = isPMExtensionInstalled && isProjectManager && isPMonProject;
    const canBulkMove = hasManageEventsRights || hasPMRights && hasPMManageEventsRights;
    return canBulkMove;
  }, [accountResourceId, hasManageEventsRights, hasPMManageEventsRights, isPMExtensionInstalled, isProjectManager, selectedBooking]);
};
const rights$6 = [{
  rights: ['settingBookingNotes'],
  rule: 'one'
}];
const useCanEditCreateBookingNotesForSelectedBooking = () => {
  const [canEditCreateNotes] = useHasRoleRights(rights$6);
  const selectedBooking = useSelector(selectSchedulerCurrentSelectedBooking);
  return useMemo(() => {
    if (!selectedBooking || !isSchedulerItemABookingType(selectedBooking)) {
      return false;
    }
    return canEditCreateNotes && selectedBooking.hasEditNoteRights;
  }, [canEditCreateNotes, selectedBooking]);
};
const schedulerActions = {
  openSidebar: tabId => actionCreator('OPEN_SIDEBAR', {
    tabId
  }),
  updateBookingSelection: booking => actionCreator('UPDATE_BOOKING_SELECTION', {
    booking
  })
};
const useModifierKeyPrefix = () => {
  let modifierKeyPrefix = 'CTRL +'; // control key
  if (window.navigator.platform.indexOf('Mac') === 0) {
    modifierKeyPrefix = '⌘'; // command key
  }
  return modifierKeyPrefix;
};
const SCHEDULER_SIDEBAR_TABS = {
  NOTE_TAB: {
    id: 1
  },
  TASKS_TAB: {
    id: 2
  },
  LINKS_TAB: {
    id: 3
  },
  INFO_TAB: {
    id: 4
  }
};
const projectDeadlineValidationSchema = _ref338 => {
  let {
    validatePartial: _validatePartial = false,
    booking,
    isDeadlinesExtensionInstalled,
    deadlinesCompanyConfig
  } = _ref338;
  return create$3().shape({
    deadlineName: create$6(),
    deadlineDate: create$4().required('Required').test((value, ctx) => {
      if (!isDeadlinesExtensionInstalled) {
        return true;
      }
      if (deadlinesCompanyConfig === 'ENABLED' || deadlinesCompanyConfig === 'PARTIAL' && !_validatePartial) {
        return true;
      }
      const bookingToUse = isSchedulerItemABookingType(booking) ? booking : isSchedulerItemADeadlineType(booking) ? booking.booking : undefined;
      if (value && (bookingToUse === null || bookingToUse === void 0 ? void 0 : bookingToUse.end) && !isSameOrAfter(value, bookingToUse.end, 'day')) {
        return ctx.createError({
          message: _validatePartial ? "Warning. Deadline is before booking end date" : "Deadline can't be before booking end date"
        });
      }
      return true;
    })
  });
};
const useProjectDeadlineValidationSchema = (booking, validatePartial) => {
  const isDeadlinesExtensionInstalled = useSelector(selectIsDeadlinesExtensionInstalled);
  const deadlinesCompanyConfig = useSelector(selectCompanyDeadlinesBeforeBookingEndDateConfig);
  return useMemo(() => {
    return projectDeadlineValidationSchema({
      booking,
      isDeadlinesExtensionInstalled,
      deadlinesCompanyConfig,
      validatePartial
    });
  }, [booking, deadlinesCompanyConfig, isDeadlinesExtensionInstalled, validatePartial]);
};
const mapBookingToDeadlineFormData = booking => {
  return {
    deadlineName: (booking === null || booking === void 0 ? void 0 : booking.deadlineName) || undefined,
    deadlineDate: (booking === null || booking === void 0 ? void 0 : booking.deadlineDate) ? toDate$1(removeUTCZuluFromDateTimestamp(booking.deadlineDate)) : addDays$1((booking === null || booking === void 0 ? void 0 : booking.end) ? new Date(booking.end) : new Date(), 2)
  };
};
const CREATE_BOOKING_DEADLINE = createRequestTypes('CREATE_BOOKING_DEADLINE');
const UPDATE_BOOKING_DEADLINE = createRequestTypes('UPDATE_BOOKING_DEADLINE');
const DELETE_BOOKING_DEADLINE = createRequestTypes('DELETE_BOOKING_DEADLINE');
const bookingActions = {
  createDeadline: {
    request: function (booking) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      let callback = arguments.length > 2 ? arguments[2] : undefined;
      return actionCreator(CREATE_BOOKING_DEADLINE['REQUEST'], {
        booking,
        options,
        callback
      });
    },
    success: (bookings, options) => actionCreator(CREATE_BOOKING_DEADLINE.SUCCESS, {
      bookings,
      options
    }),
    failure: () => actionCreator(CREATE_BOOKING_DEADLINE.FAILURE)
  },
  updateDeadline: {
    request: function (booking) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      let callback = arguments.length > 2 ? arguments[2] : undefined;
      let onFailure = arguments.length > 3 ? arguments[3] : undefined;
      return actionCreator(UPDATE_BOOKING_DEADLINE.REQUEST, {
        booking,
        options,
        callback,
        onFailure
      });
    },
    success: _ref339 => {
      let {
        bookings
      } = _ref339;
      return actionCreator(UPDATE_BOOKING_DEADLINE.SUCCESS, {
        bookings
      });
    },
    failure: _ref340 => {
      let {
        bookings
      } = _ref340;
      return actionCreator(UPDATE_BOOKING_DEADLINE.FAILURE, {
        bookings
      });
    }
  },
  deleteDeadline: {
    request: function (booking) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      let callback = arguments.length > 2 ? arguments[2] : undefined;
      return actionCreator(DELETE_BOOKING_DEADLINE.REQUEST, {
        booking,
        options: options,
        callback
      });
    },
    success: function (booking) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return actionCreator(DELETE_BOOKING_DEADLINE.SUCCESS, {
        booking,
        options: options
      });
    },
    failure: function (booking) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return actionCreator(DELETE_BOOKING_DEADLINE.FAILURE, {
        booking,
        options: options
      });
    }
  }
};
const dispatchRefreshBookings = function () {
  let {
    bookingId
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  window.dispatchEvent(new CustomEvent('refreshBookings', {
    detail: {
      bookingId
    }
  }));
};
const StyledForm$7 = /*#__PURE__*/styled(Form).withConfig({
  displayName: "deadline-form__StyledForm",
  componentId: "sc-1w3ma40-0"
})(["height:100%;display:flex;flex-direction:column;"]);
const FormFields$9 = () => {
  const formikContext = useFormikContext();
  const currentSelectedBooking = useSelector(selectSchedulerCurrentSelectedBooking);
  const validationSchema = useProjectDeadlineValidationSchema(currentSelectedBooking, true);
  const [validationWarning, setValidationWarning] = useState('');
  useEffect(() => {
    try {
      validationSchema.validateSync(formikContext.values);
      setValidationWarning('');
    } catch (error) {
      if (error instanceof ValidationError) {
        setValidationWarning(error.message);
      }
    }
  }, [formikContext.values, validationSchema]);
  return jsxs(Layout, {
    stack: true,
    gap: "--Spacing-200",
    flex: "1 1 auto",
    children: [jsx(TextFieldFormikWrapper, {
      name: "deadlineName",
      label: "Deadline title",
      dataCy: "deadline-title"
    }), jsx(DatePickerInputFormikWrapper, {
      name: "deadlineDate",
      dataCy: "deadline-date-picker",
      helperText: validationWarning
    })]
  });
};
const DeadlineForm = /*#__PURE__*/React__default.memo(props => {
  const {
    onBackClick
  } = props;
  const dispatch = useDispatch();
  const {
    onClose
  } = useContextMenuContext();
  const currentSelectedBooking = useSelector(selectSchedulerCurrentSelectedBooking);
  const booking = isSchedulerItemABookingType(currentSelectedBooking) ? currentSelectedBooking : isSchedulerItemADeadlineType(currentSelectedBooking) ? currentSelectedBooking.booking : undefined;
  const isEdit = Boolean(booking === null || booking === void 0 ? void 0 : booking.deadlineDate);
  const initialValues = useMemo(() => {
    if (!booking) {
      return {};
    }
    return mapBookingToDeadlineFormData(booking);
  }, [booking]);
  const handleSubmit = useCallback(values => {
    if (!booking) {
      return;
    }
    const action = isEdit ? bookingActions.updateDeadline.request : bookingActions.createDeadline.request;
    if (!values.deadlineDate) {
      return;
    }
    const onSave = () => {
      dispatch(schedulerActions.updateBookingSelection());
      onClose();
    };
    if ((booking === null || booking === void 0 ? void 0 : booking.repeat) && booking.repeatId) {
      dispatch(showConfirmationModal(() => {
        if (!values.deadlineDate) {
          return;
        }
        dispatch(action({
          _id: booking._id || booking.id,
          deadlineName: values.deadlineName,
          deadlineDate: formatDate(toMidnight(values.deadlineDate), DATE_FORMATS.BE_FORMAT),
          repeatId: booking.repeatId
        }, {
          createRepeatFromExisting: false,
          modifyAllRepeated: false
        }, () => {
          dispatchRefreshBookings();
          onSave();
        }));
      }, isEdit ? 'Deadline edit warning' : 'Deadline create warning', jsxs(Fragment, {
        children: [jsxs(Typography, {
          children: ["You are trying to ", isEdit ? 'update' : 'create', " a deadline on a repeating booking. Choose if you would like to update just this booking or all bookings from repeat series."]
        }), jsxs(Typography, {
          color: "error",
          children: [jsx("strong", {
            children: "Warning!"
          }), " If you ", isEdit ? 'update' : 'create', " on this booking, booking will be updated and removed from the repeat cycle. If you update all, all bookings will be updated."]
        })]
      }), {
        withEscButton: true,
        withCancel: true,
        confirmButtonText: 'Update this',
        cancelActionOnHide: true,
        onReject: () => {
          // do nothing
        },
        additionalButtons: [{
          text: 'Update all',
          onClick: () => {
            if (!values.deadlineDate) {
              return;
            }
            dispatch(action({
              _id: booking._id || booking.id,
              deadlineName: values.deadlineName,
              deadlineDate: formatDate(toMidnight(values.deadlineDate), DATE_FORMATS.BE_FORMAT),
              repeatId: booking.repeatId
            }, {
              createRepeatFromExisting: true,
              modifyAllRepeated: true,
              removeRemovedRepeated: true,
              bookingAfterDeadlineConfirmation: true
            }, () => {
              onSave();
            }));
          }
        }]
      }));
    } else {
      dispatch(action({
        _id: booking._id || booking.id,
        deadlineName: values.deadlineName,
        deadlineDate: formatDate(toMidnight(values.deadlineDate), DATE_FORMATS.BE_FORMAT)
      }, {
        bookingAfterDeadlineConfirmation: true
      }, () => {
        onSave();
      }));
    }
  }, [booking, dispatch, isEdit, onClose]);
  const handleDeleteBtnClick = useCallback(() => {
    if (!booking) {
      return;
    }
    const onDelete = () => {
      dispatch(schedulerActions.updateBookingSelection());
      onClose();
    };
    if (booking.repeat && booking.repeatId) {
      dispatch(showConfirmationModal(() => {
        dispatch(bookingActions.deleteDeadline.request({
          bookingId: booking._id || booking.id,
          repeatId: booking.repeatId
        }, {
          createRepeatFromExisting: false,
          modifyAllRepeated: false
        }, onDelete));
      }, 'Delete deadline warning', jsxs(Fragment, {
        children: [jsx(Typography, {
          children: "You are trying to remove a deadline from a repeating booking. Choose if you would like to update just this deadline or all bookings from repeat series."
        }), jsxs(Typography, {
          color: "error",
          children: [jsx("strong", {
            children: "Warning!"
          }), " If you delete this deadline, booking will be updated and removed from the repeat cycle. If you update all, all bookings will be updated."]
        })]
      }), {
        withEscButton: true,
        withCancel: true,
        confirmButtonText: 'Update this',
        cancelActionOnHide: true,
        onReject: () => {
          // do nothing
        },
        additionalButtons: [{
          text: 'Update all',
          onClick: () => {
            dispatch(bookingActions.deleteDeadline.request({
              bookingId: booking._id || booking.id,
              repeatId: booking.repeatId
            }, {
              createRepeatFromExisting: true,
              modifyAllRepeated: true,
              removeRemovedRepeated: true
            }, onDelete));
          }
        }]
      }));
    } else {
      dispatch(bookingActions.deleteDeadline.request({
        bookingId: booking._id || booking.id
      }, {}, onDelete));
    }
  }, [booking, dispatch, onClose]);
  const validationSchema = useProjectDeadlineValidationSchema(booking);
  return jsxs(Layout, {
    stack: true,
    gap: 24,
    stretch: true,
    children: [jsxs(Layout, {
      hAlign: onBackClick ? 'space-between' : 'flex-end',
      children: [onBackClick ? jsx(BackSection, {
        onClick: onBackClick
      }) : null, isEdit ? jsx(IconButton, {
        icon: "delete",
        dataCy: "deadline-delete",
        onClick: handleDeleteBtnClick
      }) : null]
    }), jsx(Formik, {
      initialValues: initialValues,
      onSubmit: handleSubmit,
      validationSchema: validationSchema,
      enableReinitialize: true,
      children: jsxs(StyledForm$7, {
        children: [jsx(FormFields$9, {}), jsx(Layout, {
          hAlign: "flex-end",
          pt: "--Spacing-200",
          children: jsx(Button, {
            type: "submit",
            dataCy: "add-update-deadline",
            children: isEdit ? 'Update deadline' : 'Add deadline'
          })
        })]
      })
    })]
  });
});
const rights$5 = [{
  rule: 'one',
  rights: ['settingAddEditProjects']
}];
const useCanCreateProject = () => {
  const [hasCreateProjectRights] = useHasRoleRights(rights$5);
  return hasCreateProjectRights;
};
const Wrapper$2 = /*#__PURE__*/styled.div.withConfig({
  displayName: "avatars__Wrapper",
  componentId: "sc-1dd50zf-0"
})(["display:flex;justify-content:center;align-items:center;width:40px;height:40px;border-radius:100%;background-color:", ";"], props => props.theme.designTokens.color.color.surfaces['tertiary-container'].value);
const StyledResourceIcon = /*#__PURE__*/styled(Icon).withConfig({
  displayName: "avatars__StyledResourceIcon",
  componentId: "sc-1dd50zf-1"
})(["border-radius:100%;background-color:", ";"], props => props.theme.designTokens.color.color.surfaces['tertiary-container'].value);
const StyledProjectIcon = /*#__PURE__*/styled(Icon).withConfig({
  displayName: "avatars__StyledProjectIcon",
  componentId: "sc-1dd50zf-2"
})(["border-radius:100%;background-color:", ";"], props => props.theme.designTokens.color.color.surfaces['tertiary-container'].value);
const ResourcePlaceholderAvatar = () => {
  return jsx(Wrapper$2, {
    children: jsx(StyledResourceIcon, {
      name: "avatar",
      size: 40
    })
  });
};
const ProjectPlaceholderAvatar = () => {
  return jsx(Wrapper$2, {
    children: jsx(StyledProjectIcon, {
      name: "folder",
      size: 24
    })
  });
};
const ProjectsList = /*#__PURE__*/React__default.memo(props => {
  var _a;
  const {
    onProjectClick,
    onCreateBtnClick,
    withCreateBtn,
    simpleRow
  } = props;
  const {
    projectKeyWord,
    projectPluralKeyWord
  } = useAppKeyWords();
  const currentSchedulerSelection = useSelector(selectSchedulerCurrentSelection);
  const onlyEvents = (_a = currentSchedulerSelection === null || currentSchedulerSelection === void 0 ? void 0 : currentSchedulerSelection.rowTags) === null || _a === void 0 ? void 0 : _a.isEventRow;
  const canCreateProject = useCanCreateProject();
  const formikContext = useFormikContext();
  const {
    resource: selectedResource,
    project: selectedProject
  } = formikContext.values;
  const {
    value: filterText,
    setDebouncedValue: setDebouncedFilterText,
    debounced: debouncedFilterText,
    setValue: setFilterText
  } = useDebouncedValue({
    defaultValue: ''
  });
  const [type, setType] = useState(onlyEvents ? ProjectTypeEnum.EVENT : ProjectTypeEnum.REGULAR);
  const handleCreteBtnClick = useCallback(() => {
    if (!onCreateBtnClick) {
      return;
    }
    onCreateBtnClick({
      name: filterText,
      type
    });
  }, [filterText, onCreateBtnClick, type]);
  const projectSelector = useMemo(() => {
    return makeSelectPermittedProjectsForScheduleRequest({
      projectType: type,
      resource: selectedResource
    });
  }, [selectedResource, type]);
  const projectsNotFiltered = useSelector(projectSelector);
  const projects = useMemo(() => {
    return projectsNotFiltered.filter(project => {
      return searchStringCompare(project.name, debouncedFilterText) || searchStringCompare(project.projectCode, debouncedFilterText);
    });
  }, [debouncedFilterText, projectsNotFiltered]);
  const rowRenderer = useCallback(project => {
    return jsx(ProjectRow, {
      project: project,
      selectedProject: selectedProject,
      simpleRow: simpleRow
    });
  }, [selectedProject, simpleRow]);
  return jsxs(Layout, {
    stack: true,
    gap: 24,
    stretch: true,
    children: [jsx(TextField, {
      name: "project-search",
      "data-cy": "project-search",
      placeholder: "Type to filter...",
      value: filterText,
      onChange: event => setDebouncedFilterText(event.target.value),
      clearable: true,
      onClear: () => setFilterText(''),
      autoFocus: true,
      autoComplete: "off"
    }), jsxs(Layout, {
      gap: "--Spacing-100",
      wrap: true,
      children: [onlyEvents ? null : jsx(Button, {
        onClick: () => setType(ProjectTypeEnum.REGULAR),
        variant: type === ProjectTypeEnum.REGULAR ? 'filled' : 'outlined',
        dataCy: "menu-filter-projects",
        children: truncate(projectKeyWord, 13)
      }), jsx(Button, {
        onClick: () => setType(ProjectTypeEnum.EVENT),
        variant: type === ProjectTypeEnum.EVENT ? 'filled' : 'outlined',
        dataCy: "menu-filter-events",
        children: "Events"
      })]
    }), jsx(List$1, {
      virtualized: true,
      items: projects,
      rowRenderer: rowRenderer,
      onItemClick: onProjectClick,
      emptyText: "Sorry, there are no ".concat(type === ProjectTypeEnum.REGULAR ? projectPluralKeyWord : 'events', " with this name")
    }), withCreateBtn && canCreateProject ? jsx(Layout, {
      hAlign: "flex-end",
      children: jsxs(Button, {
        variant: "outlined",
        dataCy: "modern-menu-add-new-project-event",
        startIcon: "add",
        onClick: handleCreteBtnClick,
        children: ["Add new ", type === ProjectTypeEnum.REGULAR ? projectKeyWord : 'event', ' ', !projects.length && filterText ? "\"".concat(filterText, "\"") : null]
      })
    }) : null]
  });
});
const ProjectRow = props => {
  const {
    project,
    selectedProject,
    simpleRow
  } = props;
  const projectStatusFormat = useProjectStatusFormat(project);
  if (simpleRow) {
    return jsx(ListItem, {
      noWrap: true,
      label: project.name,
      supportingText: project.projectCode ? " (".concat(project.projectCode, ")") : ''
    });
  }
  const supportingText = project.projectCode ? "".concat(project.projectCode, " - ").concat(projectStatusFormat) : projectStatusFormat;
  return jsx(ListItem, {
    startAdornment: jsx(Layout, {
      flex: "0 0 40px",
      children: !project.thumb || isAvatarPlaceholder(project.thumb) ? jsx(ProjectPlaceholderAvatar, {}) : jsx(Avatar, {
        src: project.thumb
      })
    }),
    label: project.name,
    supportingText: supportingText,
    endAdornment: (selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject._id) === project._id ? 'check' : null,
    density: -2,
    noWrap: true
  });
};
const useIsExtensionInstalled = extensionName => {
  const extension = useSelector(selectExtensions);
  return isActive(extension, extensionName);
};
const IsExtensionInstalled = /*#__PURE__*/React__default.memo(props => {
  const {
    extension,
    children
  } = props;
  const isInstalled = useIsExtensionInstalled(extension);
  if (!isInstalled) {
    return null;
  }
  return children;
});
const rights$4 = [{
  rule: 'one',
  rights: ['settingAddEditResources']
}];
const useCanCreateResource = () => {
  const [hasCreateResourceRights] = useHasRoleRights(rights$4);
  return hasCreateResourceRights;
};
const useResourceRoleFormat = resource => {
  return useMemo(() => {
    var _a;
    if (!resource) {
      return '';
    }
    if (isUnassignedWork(resource)) {
      return 'Unassigned';
    }
    const {
      role
    } = resource;
    return (_a = RESOURCE_ROLES_BY_NAMES[role]) === null || _a === void 0 ? void 0 : _a.label;
  }, [resource]);
};
const ResourcesList = /*#__PURE__*/React__default.memo(props => {
  const {
    onResourceClick,
    withCreateBtn,
    onCreateBtnClick,
    simpleRow
  } = props;
  const formikContext = useFormikContext();
  const {
    resource: selectedResource,
    project: selectedProject
  } = formikContext.values;
  const appKeyWords = useAppKeyWords();
  const canCreateResource = useCanCreateResource();
  const {
    value: filterText,
    setDebouncedValue: setDebouncedFilterText,
    debounced: debouncedFilterText,
    setValue: setFilterText
  } = useDebouncedValue({
    defaultValue: ''
  });
  const [type, setType] = useState(ResourceTypeEnum.REGULAR);
  const resourcesSelector = useMemo(() => {
    return makeSelectPermittedResourcesForScheduleRequest({
      project: selectedProject,
      resourceType: type
    });
  }, [selectedProject, type]);
  const resourcesNoFiltered = useSelector(resourcesSelector);
  const resources = useMemo(() => {
    return resourcesNoFiltered.filter(resource => {
      return searchStringCompare(resource.name, debouncedFilterText);
    });
  }, [debouncedFilterText, resourcesNoFiltered]);
  const handleCreateBtnClick = useCallback(() => {
    if (!onCreateBtnClick) {
      return;
    }
    onCreateBtnClick({
      type,
      name: filterText
    });
  }, [filterText, onCreateBtnClick, type]);
  const rowRenderer = useCallback(resource => {
    return jsx(ResourceRow, {
      resource: resource,
      simpleRow: simpleRow,
      selectedResource: selectedResource
    });
  }, [selectedResource, simpleRow]);
  return jsxs(Layout, {
    stack: true,
    gap: 24,
    stretch: true,
    children: [jsx(TextField, {
      name: "resource-search",
      placeholder: "Type to filter...",
      value: filterText,
      onChange: event => setDebouncedFilterText(event.target.value),
      clearable: true,
      onClear: () => setFilterText(''),
      autoFocus: true,
      autoComplete: "off"
    }), jsxs(Layout, {
      gap: "--Spacing-100",
      wrap: true,
      children: [jsx(Button, {
        onClick: () => setType(ResourceTypeEnum.REGULAR),
        variant: type === ResourceTypeEnum.REGULAR ? 'filled' : 'outlined',
        dataCy: "menu-filter-resources",
        children: truncate(appKeyWords.resourcePluralKeyWord, 13)
      }), jsx(IsExtensionInstalled, {
        extension: ExtensionsEnum.UNASSIGNED,
        children: jsx(Button, {
          onClick: () => setType(ResourceTypeEnum.UNASSIGNED),
          variant: type === ResourceTypeEnum.UNASSIGNED ? 'filled' : 'outlined',
          dataCy: "menu-filter-unassigned",
          children: "Unassigned"
        })
      })]
    }), jsx(List$1, {
      virtualized: true,
      items: resources,
      rowRenderer: rowRenderer,
      onItemClick: onResourceClick,
      emptyText: "Sorry, there are no ".concat(type === ResourceTypeEnum.UNASSIGNED ? 'results' : appKeyWords.resourcePluralKeyWord, " with this name")
    }), jsx(Layout, {
      hAlign: "flex-end",
      children: withCreateBtn && canCreateResource ? jsxs(Button, {
        variant: "outlined",
        dataCy: "modern-menu-add-new-resource-unassigned",
        startIcon: "add",
        onClick: handleCreateBtnClick,
        children: ["Add new ", type === ResourceTypeEnum.REGULAR ? appKeyWords.resourceKeyWord : 'Unassigned', ' ', !resources.length && filterText ? "\"".concat(filterText, "\"") : null]
      }) : null
    })]
  });
});
const ResourceRow = props => {
  const {
    simpleRow,
    resource,
    selectedResource
  } = props;
  const resourceRoleFormat = useResourceRoleFormat(resource);
  if (simpleRow) {
    return jsx(ListItem, {
      noWrap: true,
      label: resource.name
    });
  }
  return jsx(ListItem, {
    noWrap: true,
    density: -2,
    label: resource.name,
    supportingText: resourceRoleFormat,
    endAdornment: (selectedResource === null || selectedResource === void 0 ? void 0 : selectedResource._id) === resource._id ? 'check' : null,
    startAdornment: jsx(Layout, {
      flex: "0 0 40px",
      children: !(resource === null || resource === void 0 ? void 0 : resource.thumb) || isAvatarPlaceholder(resource.thumb) ? jsx(ResourcePlaceholderAvatar, {}) : jsx(Avatar, {
        src: resource === null || resource === void 0 ? void 0 : resource.thumb,
        firstName: resource === null || resource === void 0 ? void 0 : resource.firstName,
        lastName: resource === null || resource === void 0 ? void 0 : resource.lastName
      })
    })
  });
};
const SplitBooking = /*#__PURE__*/React__default.memo(() => {
  const selectedBooking = useSelector(selectSchedulerCurrentSelectedBooking);
  const modern = useSelector(selectIsGridModernMenuUsed);
  const {
    onSplitBooking
  } = useContextMenuContext();
  const handleDateSelect = useCallback(date => {
    if (!isSchedulerItemABookingType(selectedBooking)) {
      return;
    }
    onSplitBooking({
      bookingId: selectedBooking._id,
      splitDate: date
    });
  }, [onSplitBooking, selectedBooking]);
  const disabledDays = useCallback(day => {
    if (!isSchedulerItemABookingType(selectedBooking)) {
      return true;
    }
    return isBefore(addDays$1(day, -1), selectedBooking.start) || isAfter(day, selectedBooking.end);
  }, [selectedBooking]);
  const initialValue = useMemo(() => {
    if (!isSchedulerItemABookingType(selectedBooking)) {
      return new Date();
    }
    return addDays$1((selectedBooking === null || selectedBooking === void 0 ? void 0 : selectedBooking.start) || new Date(), 1);
  }, [selectedBooking]);
  return jsx(Wrapper$1, {
    children: jsx(DatePickerInput, {
      dense: !modern,
      withHeader: false,
      name: "split-booking-calendar",
      onChange: handleDateSelect,
      variant: "standalone",
      disabledDays: disabledDays,
      value: initialValue
    })
  });
});
const Wrapper$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "split-booking__Wrapper",
  componentId: "sc-1xird4s-0"
})(["min-height:415px;"]);
const StyledInput = /*#__PURE__*/styled(NumberInputFormikWrapper).withConfig({
  displayName: "booking-allocation-form-part__StyledInput",
  componentId: "sc-1bdbdxr-0"
})(["opacity:", ";"], props => props.active ? 1 : 0.5);
function BookingAllocationFormPart(props) {
  const {
    inline,
    onChange,
    withTitle
  } = props;
  const formikContext = useFormikContext();
  const {
    values,
    setFieldValue
  } = formikContext;
  const {
    state
  } = values;
  const handleInputClick = (event, state) => {
    event.target.select();
    setFieldValue('state', state).then(() => {
      if (onChange) {
        onChange();
      }
    });
  };
  return jsxs(Layout, {
    stack: true,
    gap: 24,
    children: [withTitle ? jsx(Typography, {
      variant: "label",
      size: "xl",
      children: "Allocation"
    }) : null, jsxs(Layout, {
      stack: !inline,
      gap: 24,
      children: [jsx(StyledInput, {
        name: "percentage",
        label: "Percentage",
        endAdornment: "%",
        dataCy: "allocation-percentage-input",
        active: state === AllocationStateEnum.PERCENTAGE,
        onFocus: event => {
          handleInputClick(event, AllocationStateEnum.PERCENTAGE);
        },
        onChange: () => onChange === null || onChange === void 0 ? void 0 : onChange()
      }), jsx(StyledInput, {
        name: "hours",
        label: "Hours a day",
        endAdornment: "hrs",
        dataCy: "allocation-hours_day-input",
        active: state === AllocationStateEnum.HOURS_DAY,
        onFocus: event => {
          handleInputClick(event, AllocationStateEnum.HOURS_DAY);
        },
        onChange: () => onChange === null || onChange === void 0 ? void 0 : onChange()
      }), jsx(StyledInput, {
        name: "total",
        label: "Total hours",
        endAdornment: "hrs",
        dataCy: "allocation-total_hours",
        active: state === AllocationStateEnum.TOTAL_HOURS,
        onFocus: event => {
          handleInputClick(event, AllocationStateEnum.TOTAL_HOURS);
        },
        onChange: () => onChange === null || onChange === void 0 ? void 0 : onChange()
      })]
    })]
  });
}
const EditAllocation = /*#__PURE__*/React__default.memo(() => {
  const {
    values
  } = useFormikContext();
  const {
    reCalcAllocation,
    onUpdateBooking
  } = useContextMenuContext();
  const handleSubmit = useCallback(() => {
    onUpdateBooking(Object.assign({
      percentAllocation: values.percentage,
      minutesPerDay: values.hours * 60,
      totalBucketMinutesAllocation: values.total * 60,
      state: values.state
    }, mapBookingRepeatToRequest(values)));
  }, [onUpdateBooking, values]);
  return jsxs(Layout, {
    stack: true,
    gap: "--Spacing-100",
    children: [jsx(BookingAllocationFormPart, {
      onChange: reCalcAllocation
    }), jsx(Layout, {
      hAlign: "flex-end",
      children: jsx(Button, {
        onClick: handleSubmit,
        dataCy: "button--submit-allocation",
        children: "Submit"
      })
    })]
  });
});
const useCategoryTemplateAllocationFormat = (categoryTemplate, prefix) => {
  const useCategoriesAllocation = useSelector(selectUseCategoriesAllocation);
  return useMemo(() => {
    if (!categoryTemplate || !useCategoriesAllocation) {
      return '';
    }
    const {
      state,
      percentAllocation,
      totalBucketMinutesAllocation,
      minutesPerDay
    } = categoryTemplate;
    const allocationType = allocationDefinitionsByStateName[state];
    const values = {
      percentage: percentAllocation,
      total: totalBucketMinutesAllocation / 60,
      hours: minutesPerDay / 60
    };
    return "".concat(prefix !== null && prefix !== void 0 ? prefix : '').concat(values[allocationType.valueName] || 0, " ").concat(allocationType.unit);
  }, [categoryTemplate, prefix, useCategoriesAllocation]);
};
const rights$3 = [{
  rule: 'one',
  rights: ['settingBookCat']
}];
const useCanCreateCategoryTemplate = () => {
  const [hasCreateCategoryTemplateRights] = useHasRoleRights(rights$3);
  return hasCreateCategoryTemplateRights;
};
const StyledLayout$4 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "edit-category__StyledLayout",
  componentId: "sc-1vsjz7e-0"
})(["height:350px;"]);
const StyledList = /*#__PURE__*/styled(List$1).withConfig({
  displayName: "edit-category__StyledList",
  componentId: "sc-1vsjz7e-1"
})(["flex:1 1 auto;"]);
const EditCategory = /*#__PURE__*/React__default.memo(() => {
  const history = useHistory();
  const canCreateCategoryTemplate = useCanCreateCategoryTemplate();
  const {
    onClose,
    onUpdateBookingCategory
  } = useContextMenuContext();
  const formikContext = useFormikContext();
  const {
    project: selectedProject
  } = formikContext.values;
  const categoriesSelector = useMemo(() => {
    return makeSelectCategoriesFromGroupsByIds(selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.categoryGroups);
  }, [selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.categoryGroups]);
  const categories = useSelector(categoriesSelector);
  const rowRenderer = useCallback(item => {
    if ('isGroup' in item) {
      return jsx(Typography, {
        children: item.groupName
      });
    }
    return jsx(CategoryRow$1, {
      category: item
    });
  }, []);
  const handleCategoryClick = useCallback(item => {
    if ('isGroup' in item) {
      return;
    }
    onUpdateBookingCategory(item);
    onClose();
  }, [onClose, onUpdateBookingCategory]);
  const handleNewCategoryClick = useCallback(() => {
    onClose();
    history.push('/settings/categoryGroups');
  }, [history, onClose]);
  return jsxs(StyledLayout$4, {
    stack: true,
    gap: "--Spacing-100",
    children: [jsx(StyledList, {
      items: categories,
      rowRenderer: rowRenderer,
      onItemClick: handleCategoryClick,
      virtualized: true
    }), jsx(Layout, {
      hAlign: "flex-end",
      children: canCreateCategoryTemplate ? jsx(Button, {
        variant: "outlined",
        dataCy: "button--add-new-booking-categories",
        onClick: handleNewCategoryClick,
        children: "Add new category"
      }) : null
    })]
  });
});
const CategoryRow$1 = props => {
  const {
    category
  } = props;
  const allocationText = useCategoryTemplateAllocationFormat(category, ' - ');
  return jsx(ListItem, {
    density: -2,
    noWrap: true,
    label: category.name,
    supportingText: "".concat(category.groupName).concat(allocationText),
    startAdornment: jsx(Layout, {
      flex: "0 0 40px",
      children: jsx(Dot, {
        color: category.gridColor,
        size: 32
      })
    })
  });
};
const StyledDayCounterInput = /*#__PURE__*/styled(NumberInputFormikWrapper).withConfig({
  displayName: "day-counter-input__StyledDayCounterInput",
  componentId: "uylsxy-0"
})(["flex:0 0 68px;"]);
const BookingColor = /*#__PURE__*/React__default.memo(() => {
  var _a;
  const {
    projectKeyWord
  } = useAppKeyWords();
  const isCategoryColorUsed = useSelector(selectIsCategoryColorUsed);
  const {
    values,
    setFieldValue
  } = useFormikContext();
  const handleInheritClick = useCallback(() => {
    setFieldValue('useProjectColor', true, false).then(() => {
      setFieldValue('bookingColor', '', true);
    });
  }, [setFieldValue]);
  const handleColorChange = useCallback(color => {
    setFieldValue('useProjectColor', false, false).then(() => {
      setFieldValue('bookingColor', color, true);
    });
  }, [setFieldValue]);
  return jsxs(Layout, {
    stack: true,
    children: [isCategoryColorUsed && ((_a = values.category) === null || _a === void 0 ? void 0 : _a.gridColor) ? jsxs(Typography, {
      color: "error",
      children: [jsx("b", {
        children: "Color Warning!"
      }), " You are currently using category colors to define the bookings color, you must first disable this feature under ", jsx("a", {
        href: "/settings#custom",
        children: "Settings / Customization"
      }), " to use the custom booking colors feature instead."]
    }) : null, !isCategoryColorUsed ? jsxs(Fragment, {
      children: [!values.useProjectColor ? jsxs(Button, {
        onClick: handleInheritClick,
        dataCy: "inherit-color-from-project",
        children: ["Inherit from ", projectKeyWord]
      }) : null, jsx(ColorPicker, {
        value: values.bookingColor,
        onChange: handleColorChange,
        dataCy: "scheduler-classic-menu-bookingColor"
      })]
    }) : null]
  });
});
var $ = _export;
var parseInt$1 = numberParseInt;

// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$({
  target: 'Number',
  stat: true,
  forced: Number.parseInt !== parseInt$1
}, {
  parseInt: parseInt$1
});
const StyledLayout$3 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "booking-repeat__StyledLayout",
  componentId: "bz9dp1-0"
})(["flex:1 1 auto;height:160px;"]);
const RepeatContainerStyledLayout = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "booking-repeat__RepeatContainerStyledLayout",
  componentId: "bz9dp1-1"
})(["margin:0 -8px;width:calc(100% + 24px);flex:1 1 calc(100% + 24px);max-width:unset;"]);
const StyledDivider = /*#__PURE__*/styled(Divider).withConfig({
  displayName: "booking-repeat__StyledDivider",
  componentId: "bz9dp1-2"
})(["opacity:0.4;"]);
const RepeatIntervalSelect = props => {
  const {
    onItemClick
  } = props;
  const handleOptionClick = useCallback(option => {
    onItemClick(option);
  }, [onItemClick]);
  const rowRenderer = useCallback(option => {
    return jsx(ListItem, {
      dataCy: createCySelector("option-".concat(option.label)),
      label: option.label,
      density: -4
    });
  }, []);
  return jsx(StyledLayout$3, {
    stack: true,
    children: jsx(List$1, {
      virtualized: true,
      items: repeatIntervalOptions,
      rowRenderer: rowRenderer,
      onItemClick: handleOptionClick
    })
  });
};
const FormFields$8 = props => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const {
    onlyEnds,
    option
  } = props;
  const {
    values,
    setFieldValue,
    setFieldTouched,
    setValues
  } = useFormikContext();
  const {
    expand,
    expandedItem,
    collapse
  } = useAccordionState();
  const [innerValues, setInnerValues] = useState({});
  useEffect(() => {
    var _a;
    if (((_a = values.interval) === null || _a === void 0 ? void 0 : _a.value) !== option.value) {
      setInnerValues({
        repeatEndsOn: RepeatEndsOnEnum.NEVER
      });
    } else {
      setInnerValues({
        interval: option,
        repeatEndsAfterTimes: values.repeatEndsAfterTimes,
        repeatEndsOnDate: values.repeatEndsOnDate || undefined,
        repeatEndsOn: values.repeatEndsOn || RepeatEndsOnEnum.NEVER
      });
    }
  }, [option, option.value, (_a = values.interval) === null || _a === void 0 ? void 0 : _a.value, values.repeatEndsAfterTimes, values.repeatEndsOn, values.repeatEndsOnDate]);
  const handleRepeatEveryIntervalSelect = useCallback(option => {
    setFieldValue('repeatEveryInterval', option).then(() => {
      collapse();
    });
  }, [collapse, setFieldValue]);
  const handleEndsOnChange = useCallback((event, value) => {
    setValues(Object.assign(Object.assign({}, values), {
      interval: option,
      repeatEndsOn: value,
      repeatEndsOnDate: undefined,
      repeatEndsAfterTimes: undefined
    })).then(() => {
      setInnerValues(prev => {
        return Object.assign(Object.assign({}, prev), {
          interval: option,
          repeatEndsOn: value,
          repeatEndsOnDate: undefined,
          repeatEndsAfterTimes: undefined
        });
      });
    });
  }, [option, setValues, values]);
  const handleRepeatEveryTimeChange = useCallback(() => {
    setFieldValue('interval', option);
    setInnerValues(prev => {
      return Object.assign(Object.assign({}, prev), {
        interval: option
      });
    });
  }, [option, setFieldValue]);
  const handleRepeatEndsOnDateChange = useCallback(value => {
    setFieldValue('repeatEndsOnDate', value);
    setInnerValues(prev => {
      return Object.assign(Object.assign({}, prev), {
        repeatEndsOnDate: value
      });
    });
  }, [setFieldValue]);
  const handleRepeatEndsAfterTimes = useCallback(event => {
    const value = Number.parseInt(event.target.value);
    setFieldValue('repeatEndsAfterTimes', value);
    setInnerValues(prev => {
      return Object.assign(Object.assign({}, prev), {
        repeatEndsAfterTimes: value
      });
    });
  }, [setFieldValue]);
  const EndsContentJSX = useMemo(() => {
    return jsxs(Layout, {
      stack: true,
      gap: 16,
      pl: "--Spacing-150",
      children: [jsxs(Layout, {
        gap: 31,
        children: [jsx(Radio, {
          dataCy: createCySelector("".concat(option.value, "-").concat(RepeatEndsOnEnum.DATE)),
          name: "repeatEndsOn",
          value: RepeatEndsOnEnum.DATE,
          label: "On",
          onClick: handleEndsOnChange,
          checked: innerValues.repeatEndsOn === RepeatEndsOnEnum.DATE
        }), jsx(DatePickerInput, {
          dense: true,
          name: "repeatEndsOnDate",
          label: "Date",
          disabled: innerValues.repeatEndsOn !== RepeatEndsOnEnum.DATE,
          onChange: handleRepeatEndsOnDateChange,
          value: innerValues.repeatEndsOnDate,
          disabledDays: day => {
            return isBefore(day, values.endDate, 'day');
          },
          dataCy: createCySelector("".concat(option.value, "-").concat(RepeatEndsOnEnum.DATE, "-input")),
          initialMonthDate: values.endDate
        })]
      }), jsxs(Layout, {
        gap: "--Spacing-200",
        children: [jsx(Radio, {
          dataCy: createCySelector("".concat(option.value, "-").concat(RepeatEndsOnEnum.AFTERTIMES)),
          name: "repeatEndsOn",
          value: RepeatEndsOnEnum.AFTERTIMES,
          label: "After",
          onClick: handleEndsOnChange,
          checked: innerValues.repeatEndsOn === RepeatEndsOnEnum.AFTERTIMES
        }), jsx(NumberInput, {
          name: "repeatEndsAfterTimes",
          label: "Occurrences",
          disabled: innerValues.repeatEndsOn !== RepeatEndsOnEnum.AFTERTIMES,
          onChange: handleRepeatEndsAfterTimes,
          value: innerValues.repeatEndsAfterTimes,
          dataCy: createCySelector("".concat(option.value, "-").concat(RepeatEndsOnEnum.AFTERTIMES, "-input"))
        })]
      }), jsx(Layout, {
        children: jsx(Radio, {
          dataCy: createCySelector("".concat(option.value, "-").concat(RepeatEndsOnEnum.NEVER)),
          name: "repeatEndsOn",
          value: RepeatEndsOnEnum.NEVER,
          label: "Never",
          onClick: handleEndsOnChange,
          checked: innerValues.repeatEndsOn === RepeatEndsOnEnum.NEVER
        })
      })]
    });
  }, [handleEndsOnChange, handleRepeatEndsAfterTimes, handleRepeatEndsOnDateChange, innerValues.repeatEndsAfterTimes, innerValues.repeatEndsOn, innerValues.repeatEndsOnDate, option.value, values.endDate]);
  const customOccurrenceHeader = useMemo(() => {
    var _a, _b, _c, _d, _e, _f;
    if (((_a = values.repeatEveryInterval) === null || _a === void 0 ? void 0 : _a.value) === BookingRepeatIntervalEnum.WEEK) {
      const someSelected = Object.values((_b = values.repeatOnWeekdays) !== null && _b !== void 0 ? _b : {}).some(Boolean);
      if (!someSelected) {
        return jsx(Typography, {
          variant: "body",
          children: "Select week days"
        });
      }
      return jsx(Typography, {
        variant: "label",
        size: "large",
        prominent: true,
        children: jsx(WeekDaysSelectedFormat, {
          selected: values.repeatOnWeekdays
        })
      });
    }
    if (((_c = values.repeatEveryInterval) === null || _c === void 0 ? void 0 : _c.value) === BookingRepeatIntervalEnum.MONTH) {
      if (((_d = values.repeatOn) === null || _d === void 0 ? void 0 : _d.value) === RepeatMonthlyOnEnum.DATES) {
        if ((_e = values.repeatOnDates) === null || _e === void 0 ? void 0 : _e.length) {
          return repeatMonthlyOnDatesOption.label;
        }
      } else if (((_f = values.repeatOn) === null || _f === void 0 ? void 0 : _f.value) === RepeatMonthlyOnEnum.CUSTOM) {
        if (values.repeatOnCustom1 && values.repeatOnCustom2) {
          return repeatMonthlyOnCustomOption.label;
        }
      }
      return 'Select option';
    }
    return '';
  }, [(_b = values.repeatEveryInterval) === null || _b === void 0 ? void 0 : _b.value, (_c = values.repeatOn) === null || _c === void 0 ? void 0 : _c.value, values.repeatOnCustom1, values.repeatOnCustom2, (_d = values.repeatOnDates) === null || _d === void 0 ? void 0 : _d.length, values.repeatOnWeekdays]);
  const onRepeatOnChange = useCallback(value => {
    setFieldValue('repeatOn', {
      value
    });
    setFieldTouched('repeatOn', true, false);
    if (value === 'DATES') {
      setFieldValue('repeatOnCustom1', null);
      setFieldValue('repeatOnCustom2', null);
    } else if (value === 'CUSTOM') {
      setFieldValue('repeatOnDates', []);
    }
  }, [setFieldTouched, setFieldValue]);
  const {
    open: openRepeatOnDates,
    isOpen: isOpenRepeatOnDates,
    close: closeRepeatOnDates,
    anchorElement: repeatOnDatesOptionsRef
  } = useOpenState();
  const handleRepeatOnDates = useCallback(event => {
    onRepeatOnChange('DATES');
    openRepeatOnDates(event);
  }, [onRepeatOnChange, openRepeatOnDates]);
  const {
    open: openRepeatOnCustomDates,
    isOpen: isOpenRepeatOnCustomDates,
    close: closeRepeatOnCustomDates,
    anchorElement: repeatOnOptionsRef
  } = useOpenState();
  const handleRepeatOnCustomDates = useCallback(event => {
    onRepeatOnChange('CUSTOM');
    openRepeatOnCustomDates(event);
  }, [onRepeatOnChange, openRepeatOnCustomDates]);
  const handleRepeatOnDatesChange = useCallback(value => {
    setFieldValue('repeatOnDates', value);
    setFieldTouched('repeatOnDates', true, false);
  }, [setFieldTouched, setFieldValue]);
  const handleRepeatOnCustom1Change = useCallback(value => {
    setFieldValue('repeatOnCustom1', value);
    setFieldTouched('repeatOnCustom1', true, false);
  }, [setFieldTouched, setFieldValue]);
  const handleRepeatOnCustom2Change = useCallback(value => {
    setFieldValue('repeatOnCustom2', value);
    setFieldTouched('repeatOnCustom2', true, false);
  }, [setFieldTouched, setFieldValue]);
  const customOccurrenceContent = useMemo(() => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (((_a = values.repeatEveryInterval) === null || _a === void 0 ? void 0 : _a.value) === BookingRepeatIntervalEnum.WEEK) {
      return jsx(Layout, {
        stack: true,
        stretch: true,
        children: jsx(WeekDaysCheckboxList, {
          variant: "list",
          onChange: value => {
            setFieldValue('repeatOnWeekdays', value, true);
            setFieldTouched('repeatOnWeekdays', true, false);
          },
          value: values.repeatOnWeekdays
        })
      });
    }
    if (((_b = values.repeatEveryInterval) === null || _b === void 0 ? void 0 : _b.value) === BookingRepeatIntervalEnum.MONTH) {
      return jsxs(Layout, {
        stack: true,
        pl: "--Spacing-200",
        gap: "--Spacing-200",
        vAlign: "center",
        children: [jsx(Radio, {
          name: "repeatOn",
          dataCy: "month-repeat-interval-on-dates",
          value: "DATES",
          checked: ((_c = values.repeatOn) === null || _c === void 0 ? void 0 : _c.value) === 'DATES',
          label: repeatMonthlyOnDatesOption.label,
          onClick: handleRepeatOnDates
        }), ((_d = values.repeatOn) === null || _d === void 0 ? void 0 : _d.value) === 'DATES' ? jsx(DaysOfMonthSelectDialog, {
          open: isOpenRepeatOnDates,
          anchorElement: repeatOnDatesOptionsRef,
          selected: (_e = values.repeatOnDates) !== null && _e !== void 0 ? _e : [],
          onClose: () => {
            setFieldTouched('repeatOnDates', true, false);
            closeRepeatOnDates();
          },
          onSelect: value => {
            handleRepeatOnDatesChange(value);
            closeRepeatOnDates();
          }
        }) : null, jsx(Radio, {
          name: "repeatOn",
          dataCy: "month-repeat-interval-on-custom",
          value: "CUSTOM",
          checked: ((_f = values.repeatOn) === null || _f === void 0 ? void 0 : _f.value) === 'CUSTOM',
          label: repeatMonthlyOnCustomOption.label,
          onClick: handleRepeatOnCustomDates
        }), ((_g = values.repeatOn) === null || _g === void 0 ? void 0 : _g.value) === 'CUSTOM' ? jsx(CustomMonthDatesSelectDialog, {
          open: isOpenRepeatOnCustomDates,
          anchorElement: repeatOnOptionsRef,
          value: {
            ordinalIdentifier: values.repeatOnCustom1,
            day: values.repeatOnCustom2
          },
          onClose: () => {
            setFieldTouched('repeatOnCustom1', true, false);
            setFieldTouched('repeatOnCustom2', true, false);
            closeRepeatOnCustomDates();
          },
          onSelect: value => {
            handleRepeatOnCustom1Change(value.ordinalIdentifier);
            handleRepeatOnCustom2Change(value.day);
            closeRepeatOnCustomDates();
          }
        }) : null]
      });
    }
    return null;
  }, [closeRepeatOnCustomDates, closeRepeatOnDates, handleRepeatOnCustom1Change, handleRepeatOnCustom2Change, handleRepeatOnCustomDates, handleRepeatOnDates, handleRepeatOnDatesChange, isOpenRepeatOnCustomDates, isOpenRepeatOnDates, repeatOnDatesOptionsRef, repeatOnOptionsRef, setFieldTouched, setFieldValue, (_e = values.repeatEveryInterval) === null || _e === void 0 ? void 0 : _e.value, (_f = values.repeatOn) === null || _f === void 0 ? void 0 : _f.value, values.repeatOnCustom1, values.repeatOnCustom2, values.repeatOnDates, values.repeatOnWeekdays]);
  const accordionItems = useMemo(() => {
    var _a, _b, _c;
    const items = [{
      dataCy: 'select-custom-interval',
      id: '1',
      header: ((_a = values.repeatEveryInterval) === null || _a === void 0 ? void 0 : _a.label) || 'Select option',
      content: jsx(RepeatIntervalSelect, {
        onItemClick: handleRepeatEveryIntervalSelect
      })
    }, ((_b = values.repeatEveryInterval) === null || _b === void 0 ? void 0 : _b.value) === BookingRepeatIntervalEnum.WEEK || ((_c = values.repeatEveryInterval) === null || _c === void 0 ? void 0 : _c.value) === BookingRepeatIntervalEnum.MONTH ? {
      dataCy: 'custom-occurrence',
      id: '2',
      header: customOccurrenceHeader,
      content: customOccurrenceContent
    } : null, {
      dataCy: 'ends-on-date',
      id: '3',
      header: jsxs(Typography, {
        children: ["Ends:", ' ', jsx(Typography, {
          variant: "label",
          size: "large",
          prominent: true,
          tagName: "span",
          children: values.repeatEndsOn ? BookingRepeatEndsOnLabels[values.repeatEndsOn] : ''
        })]
      }),
      content: EndsContentJSX
    }];
    return items.filter(item => {
      return item !== null;
    });
  }, [EndsContentJSX, customOccurrenceContent, customOccurrenceHeader, handleRepeatEveryIntervalSelect, values.repeatEndsOn, (_g = values.repeatEveryInterval) === null || _g === void 0 ? void 0 : _g.label, (_h = values.repeatEveryInterval) === null || _h === void 0 ? void 0 : _h.value]);
  if (onlyEnds) {
    return jsxs(RepeatContainerStyledLayout, {
      stack: true,
      pt: 12,
      pb: 12,
      pl: 12,
      pr: 12,
      gap: 8,
      children: [jsx(Layout, {
        hAlign: "space-between",
        vAlign: "center",
        children: jsxs(Typography, {
          variant: "body",
          children: ["Ends:", ' ', jsx(Typography, {
            tagName: "span",
            variant: "label",
            size: "large",
            children: values.repeatEndsOn ? BookingRepeatEndsOnLabels[values.repeatEndsOn] : ''
          })]
        })
      }), jsx(Layout, {
        pl: 8,
        children: EndsContentJSX
      })]
    });
  }
  return jsxs(RepeatContainerStyledLayout, {
    stack: true,
    children: [jsxs(Layout, {
      hAlign: "space-between",
      vAlign: "center",
      pt: 8,
      pl: "--Spacing-200",
      pb: "--Spacing-100",
      children: [jsx(Typography, {
        variant: "body",
        size: "medium",
        children: "Repeat Every:"
      }), jsx(Layout, {
        flex: "0 0 77px",
        children: jsx(NumberInputFormikWrapper, {
          name: "repeatEveryTime",
          label: "Amount",
          onChange: handleRepeatEveryTimeChange,
          integerOnly: true,
          dataCy: "repeat-every-time"
        })
      })]
    }), jsx(StyledDivider, {}), jsx(Accordion, {
      openItem: expandedItem,
      onOpen: expand,
      items: accordionItems
    })]
  });
};
const WrapperLayout = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "booking-repeat__WrapperLayout",
  componentId: "bz9dp1-3"
})(["margin:0 -16px;width:calc(100% + 32px);flex:1 1 calc(100% + 32px);max-width:unset;"]);
const StyledAccordion = /*#__PURE__*/styled(Accordion).withConfig({
  displayName: "booking-repeat__StyledAccordion",
  componentId: "bz9dp1-4"
})([""]);
const RepeatNoneLayoutItem = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "booking-repeat__RepeatNoneLayoutItem",
  componentId: "bz9dp1-5"
})(["padding:0 16px;min-height:40px;width:100%;border-bottom:1px solid rgba(189,202,192,0.4);:hover{background-color:", ";}"], props => props.theme.designTokens.color.color.surfaces['surface-container-highest'].value);
const BookingRepeat$1 = /*#__PURE__*/React__default.memo(() => {
  const {
    setFieldValue
  } = useFormikContext();
  const items = useMemo(() => {
    return [{
      id: bookingRepeatOptionsMap.DAILY.value,
      header: bookingRepeatOptionsMap.DAILY.label,
      dataCy: 'repeat-option-daily',
      content: jsx(FormFields$8, {
        onlyEnds: true,
        option: bookingRepeatOptionsMap.DAILY
      })
    }, {
      id: bookingRepeatOptionsMap.WEEKLY.value,
      header: bookingRepeatOptionsMap.WEEKLY.label,
      dataCy: 'repeat-option-weekly',
      content: jsx(FormFields$8, {
        onlyEnds: true,
        option: bookingRepeatOptionsMap.WEEKLY
      })
    }, {
      id: bookingRepeatOptionsMap.BI_WEEKLY.value,
      header: bookingRepeatOptionsMap.BI_WEEKLY.label,
      dataCy: 'repeat-option-bi-weekly',
      content: jsx(FormFields$8, {
        onlyEnds: true,
        option: bookingRepeatOptionsMap.BI_WEEKLY
      })
    }, {
      id: bookingRepeatOptionsMap.MONTHLY.value,
      header: bookingRepeatOptionsMap.MONTHLY.label,
      dataCy: 'repeat-option-monthly',
      content: jsx(FormFields$8, {
        onlyEnds: true,
        option: bookingRepeatOptionsMap.MONTHLY
      })
    }, {
      id: bookingRepeatOptionsMap.YEARLY.value,
      header: bookingRepeatOptionsMap.YEARLY.label,
      dataCy: 'repeat-option-yearly',
      content: jsx(FormFields$8, {
        onlyEnds: true,
        option: bookingRepeatOptionsMap.YEARLY
      })
    }, {
      id: bookingRepeatOptionsMap.CUSTOM.value,
      header: bookingRepeatOptionsMap.CUSTOM.label,
      dataCy: 'repeat-option-custom',
      content: jsx(FormFields$8, {
        option: bookingRepeatOptionsMap.CUSTOM
      })
    }];
  }, []);
  const handleOpenAccordionTab = useCallback(repeatValueId => {
    if (!repeatValueId) {
      return;
    }
    const newInterval = repeatValueId ? bookingRepeatOptionsMap[repeatValueId] : bookingRepeatOptionsMap.NONE;
    setFieldValue('interval', newInterval);
  }, [setFieldValue]);
  return jsxs(WrapperLayout, {
    stack: true,
    children: [jsx(RepeatNoneLayoutItem, {
      vAlign: "center",
      dataCy: "repeat-option-none",
      onClick: () => {
        setFieldValue('interval', bookingRepeatOptionsMap.NONE);
      },
      children: jsx(Typography, {
        variant: "body",
        size: "medium",
        children: bookingRepeatOptionsMap.NONE.label
      })
    }), jsx(StyledAccordion, {
      items: items,
      onOpen: handleOpenAccordionTab
    })]
  });
});
const EditDates = /*#__PURE__*/React__default.memo(() => {
  var _a;
  const {
    projectKeyWord
  } = useAppKeyWords();
  const {
    onUpdateBooking,
    onDaysCounterChanged,
    onDaysCounterBlur
  } = useContextMenuContext();
  const isHoursScaleCurrentSchedulerSelectedBooking = useIsHourScaleSchedulerCurrentSelectedBooking();
  const isHourScale = useSelector(selectIsHourScale);
  const isCategoryColorUsed = useSelector(selectIsCategoryColorUsed);
  const {
    values,
    isValid,
    dirty,
    errors
  } = useFormikContext();
  const {
    onStartDateChange,
    onEndDateChange
  } = useContextMenuContext();
  const handleSubmit = useCallback(() => {
    onUpdateBooking(Object.assign({
      start: values.startDate,
      end: values.endDate,
      backgroundColor: values.bookingColor,
      useProjectColor: values.useProjectColor
    }, mapBookingRepeatToRequest(values)));
  }, [onUpdateBooking, values]);
  const items = useMemo(() => {
    var _a;
    return [{
      dataCy: 'start-date-toggler',
      id: '2',
      header: jsxs(Layout, {
        gap: "--Spacing-100",
        vAlign: "center",
        children: [jsxs(Typography, {
          children: ["Start:", ' ', jsx(Typography, {
            variant: "label",
            size: "large",
            prominent: true,
            tagName: "span",
            children: values.startDate ? formatDate(values.startDate, DATE_FORMATS.MONTH_DAY_YEAR) : ''
          })]
        }), errors.startDate ? jsx(Icon, {
          name: "error",
          color: "error"
        }) : null]
      }),
      content: jsxs(Layout, {
        stretch: true,
        hAlign: "center",
        gap: "--Spacing-100",
        children: [jsx(DatePickerInputFormikWrapper, {
          dataCy: "scheduler-booking-classic-menu-start-date",
          dense: true,
          withHeader: false,
          name: "startDate",
          label: "Start",
          disabled: isHourScale,
          onChange: onStartDateChange
        }), jsx(StyledDayCounterInput, {
          disabled: isHourScale || isHoursScaleCurrentSchedulerSelectedBooking,
          name: "daysCounter",
          dataCy: "scheduler-booking-classic-menu-days-counter",
          label: "Days",
          onChange: onDaysCounterChanged,
          onBlur: onDaysCounterBlur,
          min: MIN_NUMBER_BOOKING_DAYS,
          max: MAX_NUMBER_BOOKING_DAYS,
          step: 1,
          withSpinButtons: true,
          disableSpecialChars: true
        })]
      })
    }, {
      dataCy: 'end-date-toggler',
      id: '3',
      header: jsxs(Layout, {
        gap: "--Spacing-100",
        vAlign: "center",
        children: [jsxs(Typography, {
          children: ["End:", ' ', jsx(Typography, {
            variant: "label",
            size: "large",
            prominent: true,
            tagName: "span",
            children: values.endDate ? formatDate(values.endDate, DATE_FORMATS.MONTH_DAY_YEAR) : ''
          })]
        }), errors.endDate ? jsx(Icon, {
          name: "error",
          color: "error"
        }) : null]
      }),
      content: jsx(Layout, {
        stack: true,
        stretch: true,
        hAlign: "center",
        children: jsx(DatePickerInputFormikWrapper, {
          dataCy: "scheduler-booking-classic-menu-end-date",
          dense: true,
          withHeader: false,
          name: "endDate",
          label: "End",
          disabled: isHourScale,
          onChange: onEndDateChange,
          disabledDays: currentDate => {
            return isBefore(currentDate, values.startDate);
          }
        })
      })
    }, {
      dataCy: 'repeat-toggler',
      id: '6',
      header: "Repeat: ".concat((_a = values.interval) === null || _a === void 0 ? void 0 : _a.label),
      content: jsx(BookingRepeat$1, {})
    }, {
      dataCy: 'category-toggler',
      id: '7',
      header: isCategoryColorUsed ? 'Color: Category Inherited' : values.useProjectColor ? "Color: ".concat(projectKeyWord, "/Event inherited") : jsxs(Layout, {
        gap: "--Spacing-100",
        vAlign: "center",
        pt: "--Spacing-50",
        pb: "--Spacing-50",
        children: [jsx(Typography, {
          variant: "body",
          size: "medium",
          children: "Color:"
        }), jsx(Dot, {
          color: values.bookingColor
        })]
      }),
      content: jsx(BookingColor, {})
    }];
  }, [errors.endDate, errors.startDate, isCategoryColorUsed, isHourScale, isHoursScaleCurrentSchedulerSelectedBooking, onEndDateChange, onDaysCounterBlur, onDaysCounterChanged, onStartDateChange, projectKeyWord, values.bookingColor, values.endDate, (_a = values.interval) === null || _a === void 0 ? void 0 : _a.label, values.startDate, values.useProjectColor]);
  const {
    expand,
    expandedItem,
    collapse
  } = useAccordionState();
  useEffect(() => {
    collapse();
  }, [collapse, values.bookingColor, values.useProjectColor]);
  return jsxs(Layout, {
    stack: true,
    gap: "--Spacing-100",
    children: [jsx(Accordion, {
      items: items,
      onOpen: expand,
      openItem: expandedItem
    }), jsx(Layout, {
      hAlign: "flex-end",
      children: jsx(Button, {
        onClick: handleSubmit,
        dataCy: "button--submit-dates",
        disabled: !dirty || !isValid,
        children: "Submit"
      })
    })]
  });
});
const EditBookingClassicMenu = /*#__PURE__*/React__default.memo(props => {
  const {
    position,
    anchorEl
  } = props;
  const dispatch = useDispatch();
  const {
    projectKeyWord,
    resourceKeyWord
  } = useAppKeyWords();
  const {
    onClose,
    onDuplicateBooking,
    onCutBooking,
    onCopyBooking,
    onDeleteBooking,
    showBookingModal,
    showSplitBookingOption,
    disableSplitBookingOption,
    onBulkMove,
    onEditBookingTitle,
    onEditProject,
    onEditResource,
    onAssignToAll,
    onSwitchProject,
    onSwitchResource
  } = useContextMenuContext();
  const modifierKeyPrefix = useModifierKeyPrefix();
  const currentSchedulerSelectedBooking = useSelector(selectSchedulerCurrentSelectedBooking);
  const isHoursScaleCurrentSchedulerSelectedBooking = useIsHourScaleSchedulerCurrentSelectedBooking();
  const isAllDayCurrentSchedulerSelectedBooking = useIsAllDaySchedulerCurrentSelectedBooking();
  const isHourScale = useSelector(selectIsHourScale);
  const isDependenciesExtensionInstalled = useSelector(selectIsDependenciesExtensionInstalled);
  const isDeadlinesExtensionInstalled = useSelector(selectIsDeadlinesExtensionInstalled);
  const isTasksExtensionInstalled = useSelector(selectIsTasksExtensionInstalled);
  const canBulkMove = useCanBulkMoveSelectedBooking();
  const canEditNotes = useCanEditCreateBookingNotesForSelectedBooking();
  const currentSelectedProject = isSchedulerItemABookingType(currentSchedulerSelectedBooking) ? currentSchedulerSelectedBooking.project : undefined;
  const currentSelectedResource = isSchedulerItemABookingType(currentSchedulerSelectedBooking) ? currentSchedulerSelectedBooking === null || currentSchedulerSelectedBooking === void 0 ? void 0 : currentSchedulerSelectedBooking.resourceInfo : undefined;
  const canEditProject = useCanEditProject({
    project: currentSelectedProject
  });
  const canEditResource = useCanEditResource({
    resource: currentSelectedResource
  });
  useEffect(() => {
    if (!(currentSchedulerSelectedBooking === null || currentSchedulerSelectedBooking === void 0 ? void 0 : currentSchedulerSelectedBooking._id)) {
      onClose();
    }
  }, [currentSchedulerSelectedBooking === null || currentSchedulerSelectedBooking === void 0 ? void 0 : currentSchedulerSelectedBooking._id, currentSchedulerSelectedBooking, onClose]);
  const menuItems = useMemo(() => {
    return [{
      dataCy: 'scheduler-booking-legacy-menu-duplicate',
      label: jsxs(Layout, {
        hAlign: "space-between",
        stretch: true,
        children: [jsx(Typography, {
          variant: "body",
          size: "medium",
          children: "Duplicate"
        }), jsxs(Typography, {
          variant: "body",
          size: "medium",
          children: [modifierKeyPrefix, " D"]
        })]
      }),
      onClick: () => {
        onDuplicateBooking();
        onClose();
      }
    }, {
      dataCy: 'scheduler-booking-legacy-menu-copy',
      label: jsxs(Layout, {
        hAlign: "space-between",
        stretch: true,
        children: [jsx(Typography, {
          variant: "body",
          size: "medium",
          children: "Copy"
        }), jsxs(Typography, {
          variant: "body",
          size: "medium",
          children: [modifierKeyPrefix, " c"]
        })]
      }),
      onClick: () => {
        onCopyBooking();
        onClose();
      }
    }, {
      dataCy: 'scheduler-booking-legacy-menu-cut',
      label: jsxs(Layout, {
        hAlign: "space-between",
        stretch: true,
        children: [jsx(Typography, {
          variant: "body",
          size: "medium",
          children: "Cut"
        }), jsxs(Typography, {
          variant: "body",
          size: "medium",
          children: [modifierKeyPrefix, " x"]
        })]
      }),
      onClick: () => {
        onCutBooking();
        onClose();
      }
    }, {
      dataCy: 'scheduler-booking-legacy-menu-delete',
      label: jsxs(Layout, {
        hAlign: "space-between",
        stretch: true,
        children: [jsx(Typography, {
          variant: "body",
          size: "medium",
          children: "Delete"
        }), jsxs(Typography, {
          variant: "body",
          size: "medium",
          children: [modifierKeyPrefix, " Del"]
        })]
      }),
      onClick: () => {
        onDeleteBooking();
        onClose();
      }
    }, {
      divider: true
    }, {
      dataCy: 'scheduler-booking-legacy-linked-bookings',
      disabled: !isDependenciesExtensionInstalled,
      onClick: () => {
        showBookingModal(BookingModalTabsEnums.DEPENDENCIES);
        onClose();
      },
      label: !isDependenciesExtensionInstalled ? jsx(MissingExtensionTooltip, {
        extension: ExtensionsEnum.DEPENDENCIES,
        onClick: onClose,
        children: jsxs(Layout, {
          hAlign: "space-between",
          vAlign: "center",
          stretch: true,
          children: [jsx(Typography, {
            variant: "body",
            size: "medium",
            children: "Dependencies"
          }), jsx(Icon, {
            name: "info"
          })]
        })
      }) : 'Dependencies'
    }, {
      divider: true
    }, {
      dataCy: 'scheduler-booking-legacy-menu-category',
      label: 'Category',
      children: jsx(EditCategory, {})
    }, {
      divider: true
    }, {
      hidden: isHourScale || isHoursScaleCurrentSchedulerSelectedBooking,
      label: 'Dates',
      dataCy: 'scheduler-booking-legacy-menu-dates',
      children: jsx(EditDates, {})
    }, {
      hidden: isHourScale || !isAllDayCurrentSchedulerSelectedBooking,
      label: "Allocation",
      dataCy: 'scheduler-booking-legacy-menu-allocation',
      children: jsx(EditAllocation, {})
    }, {
      disabled: disableSplitBookingOption,
      hidden: !showSplitBookingOption,
      label: 'Split',
      dataCy: 'scheduler-booking-legacy-menu-split',
      children: jsx(SplitBooking, {})
    }, {
      hidden: (isHourScale || isHoursScaleCurrentSchedulerSelectedBooking) && (isHourScale || !isAllDayCurrentSchedulerSelectedBooking) && !showSplitBookingOption,
      divider: true
    }, {
      hidden: !canBulkMove,
      label: 'Bulk move',
      dataCy: 'scheduler-booking-legacy-menu-bulk-move',
      onClick: () => {
        onBulkMove();
        onClose();
      }
    }, {
      label: "Switch ".concat(projectKeyWord),
      dataCy: 'scheduler-booking-legacy-menu-switch-project',
      children: jsx(ProjectsList, {
        simpleRow: true,
        onProjectClick: project => {
          onClose();
          onSwitchProject(project);
        }
      })
    }, {
      label: "Reassign booking",
      dataCy: 'scheduler-booking-legacy-menu-reassign-booking',
      children: jsx(ResourcesList, {
        simpleRow: true,
        onResourceClick: resource => {
          onClose();
          onSwitchResource(resource);
        }
      })
    }, {
      label: "Assign to all in group",
      dataCy: 'scheduler-booking-legacy-menu-assign-to-all-in-group',
      onClick: () => {
        onClose();
        onAssignToAll();
      }
    }, {
      disabled: !isDeadlinesExtensionInstalled,
      label: !isDeadlinesExtensionInstalled ? jsx(MissingExtensionTooltip, {
        extension: ExtensionsEnum.DEADLINES,
        onClick: onClose,
        children: jsxs(Layout, {
          hAlign: "space-between",
          vAlign: "center",
          stretch: true,
          children: [jsx(Typography, {
            variant: "body",
            size: "medium",
            children: "Add deadline"
          }), jsx(Icon, {
            name: "info"
          })]
        })
      }) : isSchedulerItemABookingType(currentSchedulerSelectedBooking) && (currentSchedulerSelectedBooking === null || currentSchedulerSelectedBooking === void 0 ? void 0 : currentSchedulerSelectedBooking.deadlineDate) ? 'Edit deadline' : 'Add deadline',
      dataCy: "scheduler-booking-legacy-menu-add-edit-deadline",
      children: jsx(DeadlineForm, {})
    }, {
      divider: true
    }, {
      hidden: !canEditNotes,
      label: 'Notes',
      dataCy: 'scheduler-booking-legacy-menu-notes',
      children: jsxs(Fragment, {
        children: [jsx(ContextMenuItem, {
          dataCy: "scheduler-booking-legacy-menu-edit-note",
          onClick: () => {
            showBookingModal(BookingModalTabsEnums.NOTES);
            onClose();
          },
          children: "Edit note"
        }), jsx(ContextMenuItem, {
          dataCy: "scheduler-booking-legacy-menu-note-sidebar",
          onClick: () => {
            onClose();
            dispatch(schedulerActions.openSidebar(SCHEDULER_SIDEBAR_TABS.NOTE_TAB.id));
          },
          children: "Note sidebar"
        })]
      })
    }, {
      dataCy: 'scheduler-booking-legacy-menu-tasks',
      hidden: !isTasksExtensionInstalled,
      label: 'Tasks',
      onClick: () => {
        showBookingModal(BookingModalTabsEnums.TASKS);
        onClose();
      }
    }, {
      label: 'Edit',
      dataCy: 'scheduler-booking-legacy-menu-edit',
      children: jsxs(Fragment, {
        children: [jsx(ContextMenuItem, {
          dataCy: "scheduler-booking-legacy-menu-edit-booking",
          onClick: () => {
            showBookingModal();
            onClose();
          },
          children: "Edit booking"
        }), jsx(ContextMenuItem, {
          dataCy: "scheduler-booking-legacy-menu-edit-title",
          onClick: () => {
            onEditBookingTitle();
            onClose();
          },
          children: "Edit title"
        }), canEditProject ? jsxs(ContextMenuItem, {
          dataCy: "scheduler-booking-legacy-menu-edit-project",
          onClick: () => {
            onEditProject();
            onClose();
          },
          children: ["Edit ", projectKeyWord]
        }) : null, canEditResource ? jsxs(ContextMenuItem, {
          dataCy: "scheduler-booking-legacy-menu-edit-resource",
          onClick: () => {
            onEditResource();
            onClose();
          },
          children: ["Edit ", resourceKeyWord]
        }) : null]
      })
    }];
  }, [modifierKeyPrefix, isDependenciesExtensionInstalled, onClose, isHourScale, isHoursScaleCurrentSchedulerSelectedBooking, isAllDayCurrentSchedulerSelectedBooking, disableSplitBookingOption, showSplitBookingOption, canBulkMove, projectKeyWord, isDeadlinesExtensionInstalled, currentSchedulerSelectedBooking, canEditNotes, isTasksExtensionInstalled, canEditProject, canEditResource, resourceKeyWord, onDuplicateBooking, onCopyBooking, onCutBooking, onDeleteBooking, showBookingModal, onBulkMove, onSwitchProject, onSwitchResource, onAssignToAll, dispatch, onEditBookingTitle, onEditProject, onEditResource]);
  return jsx(ContextMenu, {
    variant: "anchor",
    isOpen: true,
    position: position,
    items: menuItems,
    onClose: onClose,
    anchorEl: anchorEl
  });
});
const rights$2 = [{
  rule: 'one',
  rights: ['settingProjectMs']
}];
const useCanCreateDeleteMilestone = _ref341 => {
  let {
    project
  } = _ref341;
  const [hasEditMilestoneRights] = useHasRoleRights(rights$2);
  const selector = useMemo(() => {
    if (typeof project === 'string') {
      return makeSelectProjectByIdFromMap(project);
    }
    return makeSelectProjectByIdFromMap(project === null || project === void 0 ? void 0 : project._id);
  }, [project]);
  const storeProject = useSelector(selector);
  return useMemo(() => {
    if (!project) {
      return false;
    }
    let projectToCheck;
    if (typeof project !== 'string' && 'hasRightsToProject' in project) {
      projectToCheck = project;
    } else {
      projectToCheck = storeProject;
    }
    if (!projectToCheck) {
      return undefined;
    }
    return hasEditMilestoneRights && projectToCheck.hasRightsToProject;
  }, [hasEditMilestoneRights, project, storeProject]);
};
const rights$1 = [{
  rule: 'one',
  rights: ['settingProjectPhases']
}];
const useCanCreateDeletePhase = _ref342 => {
  let {
    project
  } = _ref342;
  const [hasEditPhasesRights] = useHasRoleRights(rights$1);
  const selector = useMemo(() => {
    if (typeof project === 'string') {
      return makeSelectProjectByIdFromMap(project);
    }
    return makeSelectProjectByIdFromMap(project === null || project === void 0 ? void 0 : project._id);
  }, [project]);
  const storeProject = useSelector(selector);
  return useMemo(() => {
    if (!project) {
      return false;
    }
    let projectToCheck;
    if (typeof project !== 'string' && 'hasRightsToProject' in project) {
      projectToCheck = project;
    } else {
      projectToCheck = storeProject;
    }
    if (!projectToCheck) {
      return undefined;
    }
    return hasEditPhasesRights && projectToCheck.hasRightsToProject;
  }, [hasEditPhasesRights, project, storeProject]);
};
const rights = [{
  rule: 'one',
  rights: ['settingProjectDates']
}];
const useCanCreateDeleteProjectDates = _ref343 => {
  let {
    project
  } = _ref343;
  const [hasEditProjectDatesRights] = useHasRoleRights(rights);
  const selector = useMemo(() => {
    if (typeof project === 'string') {
      return makeSelectProjectByIdFromMap(project);
    }
    return makeSelectProjectByIdFromMap(project === null || project === void 0 ? void 0 : project._id);
  }, [project]);
  const storeProject = useSelector(selector);
  return useMemo(() => {
    if (!project) {
      return false;
    }
    let projectToCheck;
    if (typeof project !== 'string' && 'hasRightsToProject' in project) {
      projectToCheck = project;
    } else {
      projectToCheck = storeProject;
    }
    if (!projectToCheck) {
      return undefined;
    }
    return hasEditProjectDatesRights && projectToCheck.hasRightsToProject;
  }, [hasEditProjectDatesRights, project, storeProject]);
};
const FormFields$7 = props => {
  var _a, _b;
  const {
    isEdit,
    showRepeatSection
  } = props;
  const {
    values
  } = useFormikContext();
  const items = useMemo(() => {
    var _a, _b;
    return [{
      dataCy: 'milestone-date-format',
      id: '1',
      header: jsxs(Typography, {
        children: ["Date:", ' ', jsx(Typography, {
          variant: "label",
          size: "large",
          prominent: true,
          tagName: "span",
          children: formatDate(values.date, DATE_FORMATS.MONTH_DAY_YEAR)
        })]
      }),
      content: jsx(Layout, {
        stack: true,
        stretch: true,
        hAlign: "center",
        children: jsx(DatePickerInputFormikWrapper, {
          dense: true,
          withHeader: false,
          name: "date",
          label: "Date",
          dataCy: "scheduler-classic-menu-milestone"
        })
      })
    }, {
      hidden: !showRepeatSection,
      dataCy: 'repeat-toggler',
      id: '2',
      header: jsxs(Typography, {
        children: ["Repeat:", ' ', jsx(Typography, {
          variant: "label",
          size: "large",
          prominent: true,
          tagName: "span",
          children: (_a = values.interval) === null || _a === void 0 ? void 0 : _a.label
        })]
      }),
      content: jsx(Layout, {
        hAlign: "center",
        children: jsxs(Layout, {
          stack: true,
          stretch: true,
          gap: "--Spacing-200",
          flex: "1 1 100%",
          children: [jsx(SelectFormikWrapper, {
            disableClearable: true,
            options: simpleRepeatOptions,
            label: "Interval",
            optionLabel: "label",
            optionValue: "value",
            name: "interval",
            dataCy: "scheduler-classic-menu-milestone-interval"
          }), jsx(NumberInputFormikWrapper, {
            disabled: ((_b = values.interval) === null || _b === void 0 ? void 0 : _b.value) === SimpleRepeatEnum.NONE,
            name: "repeatTimes",
            label: "Number of repeat times",
            dataCy: "scheduler-classic-menu-milestone-repeat-times"
          })]
        })
      })
    }, {
      dataCy: 'color-format',
      id: '5',
      header: jsxs(Layout, {
        gap: "--Spacing-100",
        vAlign: "center",
        children: [jsx(Typography, {
          variant: "body",
          size: "medium",
          children: "Color:"
        }), jsx(Dot, {
          color: values.color,
          size: 32
        })]
      }),
      content: jsx(ColorPickerFormikWrapper, {
        name: "color",
        dataCy: "scheduler-classic-menu-milestone-hex-color"
      })
    }];
  }, [showRepeatSection, values.color, values.date, (_a = values.interval) === null || _a === void 0 ? void 0 : _a.label, (_b = values.interval) === null || _b === void 0 ? void 0 : _b.value]);
  const {
    expand,
    expandedItem,
    collapse
  } = useAccordionState();
  useEffect(() => {
    collapse();
  }, [collapse, values.date, values.color]);
  return jsxs(Layout, {
    stack: true,
    gap: "--Spacing-100",
    children: [jsx(TextFieldFormikWrapper, {
      name: "name",
      label: "Milestone name",
      placeholder: "E.g. Main Delivery",
      dataCy: "scheduler-booking-classic-menu-milestone-date"
    }), jsx(Accordion, {
      items: items,
      onOpen: expand,
      openItem: expandedItem
    }), jsx(Layout, {
      hAlign: "flex-end",
      children: jsx(Button, {
        type: "submit",
        dataCy: "button--submit-milestone-dates",
        children: isEdit ? 'Update milestone' : 'Add milestone'
      })
    })]
  });
};
const MilestoneForm$1 = /*#__PURE__*/React__default.memo(() => {
  const currentSelection = useSelector(selectSchedulerCurrentSelection);
  const selectedBooking = useSelector(selectSchedulerCurrentSelectedBooking);
  const {
    onCreateMilestone,
    onUpdateMilestone
  } = useContextMenuContext();
  const showRepeatSection = useMemo(() => {
    return Boolean(!(selectedBooking === null || selectedBooking === void 0 ? void 0 : selectedBooking._id)) || Boolean(selectedBooking && 'milestone' in selectedBooking && selectedBooking.milestone && !selectedBooking.repeat);
  }, [selectedBooking]);
  const isEdit = useMemo(() => {
    return selectedBooking && 'milestone' in selectedBooking && selectedBooking.milestone;
  }, [selectedBooking]);
  const initialValues = useMemo(() => {
    if (selectedBooking && 'milestone' in selectedBooking && selectedBooking.milestone) {
      return mapCurrentSelectionToProjectMilestoneFormData(selectedBooking);
    }
    return mapCurrentSelectionToProjectMilestoneFormData(currentSelection);
  }, [currentSelection, selectedBooking]);
  const handleSubmit = useCallback(values => {
    isEdit ? onUpdateMilestone(values, initialValues) : onCreateMilestone(values);
  }, [initialValues, isEdit, onCreateMilestone, onUpdateMilestone]);
  return jsx(Formik, {
    initialValues: initialValues,
    onSubmit: handleSubmit,
    validationSchema: projectMilestoneValidationSchema,
    enableReinitialize: true,
    children: jsx(Form, {
      children: jsx(FormFields$7, {
        isEdit: isEdit,
        showRepeatSection: showRepeatSection
      })
    })
  });
});
const FormFields$6 = props => {
  var _a, _b;
  const {
    isEdit,
    showRepeatSection
  } = props;
  const {
    values,
    errors
  } = useFormikContext();
  const items = useMemo(() => {
    var _a, _b;
    return [{
      dataCy: 'phase-start-date-format',
      id: '2',
      header: jsxs(Layout, {
        hAlign: "space-between",
        vAlign: "center",
        children: [jsxs(Typography, {
          children: ["Start date:", ' ', jsx(Typography, {
            variant: "label",
            size: "large",
            prominent: true,
            tagName: "span",
            children: formatDate(values.startDate, DATE_FORMATS.MONTH_DAY_YEAR)
          })]
        }), errors.startDate ? jsx(Icon, {
          name: "error",
          color: "error"
        }) : null]
      }),
      content: jsx(Layout, {
        stack: true,
        stretch: true,
        hAlign: "center",
        children: jsx(DatePickerInputFormikWrapper, {
          dense: true,
          withHeader: false,
          name: "startDate",
          label: "Start date",
          dataCy: "scheduler-classic-menu-phase-start-date"
        })
      })
    }, {
      dataCy: 'phase-end-date-format',
      id: '3',
      header: jsxs(Layout, {
        hAlign: "space-between",
        vAlign: "center",
        children: [jsxs(Typography, {
          children: ["End date:", ' ', jsx(Typography, {
            variant: "label",
            size: "large",
            prominent: true,
            tagName: "span",
            children: formatDate(values.endDate, DATE_FORMATS.MONTH_DAY_YEAR)
          })]
        }), errors.endDate ? jsx(Icon, {
          name: "error",
          color: "error"
        }) : null]
      }),
      content: jsx(Layout, {
        stack: true,
        stretch: true,
        hAlign: "center",
        children: jsx(DatePickerInputFormikWrapper, {
          dense: true,
          withHeader: false,
          name: "endDate",
          label: "End date",
          dataCy: "scheduler-classic-menu-phase-end-date"
        })
      })
    }, {
      dataCy: 'repeat-toggler',
      hidden: !showRepeatSection,
      id: '4',
      header: jsxs(Typography, {
        children: ["Repeat:", ' ', jsx(Typography, {
          variant: "label",
          size: "large",
          prominent: true,
          tagName: "span",
          children: (_a = values.interval) === null || _a === void 0 ? void 0 : _a.label
        })]
      }),
      content: jsxs(Layout, {
        stack: true,
        gap: "--Spacing-200",
        flex: "1 1 100%",
        children: [jsx(SelectFormikWrapper, {
          disableClearable: true,
          options: simpleRepeatOptions,
          label: "Interval",
          optionLabel: "label",
          optionValue: "value",
          name: "interval",
          dataCy: "scheduler-classic-menu-phase-interval"
        }), jsx(NumberInputFormikWrapper, {
          disabled: ((_b = values.interval) === null || _b === void 0 ? void 0 : _b.value) === SimpleRepeatEnum.NONE,
          name: "repeatTimes",
          label: "Number of repeat times",
          dataCy: "scheduler-classic-menu-phase-repeat-times"
        })]
      })
    }, {
      dataCy: 'color-format',
      id: '5',
      header: jsxs(Layout, {
        gap: "--Spacing-100",
        vAlign: "center",
        children: [jsx(Typography, {
          variant: "body",
          size: "medium",
          children: "Color:"
        }), jsx(Dot, {
          color: values.color,
          size: 32
        })]
      }),
      content: jsx(ColorPickerFormikWrapper, {
        name: "color",
        dataCy: "scheduler-classic-menu-phase-hex-color"
      })
    }];
  }, [errors.endDate, errors.startDate, showRepeatSection, values.color, values.endDate, (_a = values.interval) === null || _a === void 0 ? void 0 : _a.label, (_b = values.interval) === null || _b === void 0 ? void 0 : _b.value, values.startDate]);
  const {
    expand,
    expandedItem,
    collapse
  } = useAccordionState();
  useEffect(() => {
    collapse();
  }, [collapse, values.color, values.endDate, values.startDate]);
  return jsxs(Layout, {
    stack: true,
    gap: "--Spacing-100",
    children: [jsx(TextFieldFormikWrapper, {
      name: "name",
      label: "Phase name",
      placeholder: "E.g. Main Delivery",
      dataCy: "scheduler-booking-classic-menu-phase-end-date"
    }), jsx(Accordion, {
      items: items,
      onOpen: expand,
      openItem: expandedItem
    }), jsx(Layout, {
      hAlign: "flex-end",
      children: jsx(Button, {
        type: "submit",
        dataCy: "button--submit-phase-dates",
        children: isEdit ? 'Update phase' : 'Add phase'
      })
    })]
  });
};
const PhaseForm$1 = /*#__PURE__*/React__default.memo(() => {
  const currentSelection = useSelector(selectSchedulerCurrentSelection);
  const selectedBooking = useSelector(selectSchedulerCurrentSelectedBooking);
  const {
    onCreatePhase,
    onUpdatePhase
  } = useContextMenuContext();
  const showRepeatSection = useMemo(() => {
    return Boolean(!(selectedBooking === null || selectedBooking === void 0 ? void 0 : selectedBooking._id)) || Boolean(selectedBooking && 'phase' in selectedBooking && selectedBooking.phase && !selectedBooking.repeat);
  }, [selectedBooking]);
  const isEdit = useMemo(() => {
    return selectedBooking && 'phase' in selectedBooking && selectedBooking.phase;
  }, [selectedBooking]);
  const initialValues = useMemo(() => {
    if (selectedBooking && 'phase' in selectedBooking && selectedBooking.phase) {
      return mapCurrentSelectionToProjectPhaseFormData(selectedBooking);
    }
    return mapCurrentSelectionToProjectPhaseFormData(currentSelection);
  }, [currentSelection, selectedBooking]);
  const onSubmit = useCallback(formValues => {
    if (isEdit) {
      onUpdatePhase(formValues, initialValues);
    } else {
      onCreatePhase(formValues);
    }
  }, [initialValues, isEdit, onCreatePhase, onUpdatePhase]);
  return jsx(Formik, {
    initialValues: initialValues,
    onSubmit: onSubmit,
    enableReinitialize: true,
    validationSchema: projectPhaseValidationSchema,
    children: jsx(Form, {
      children: jsx(FormFields$6, {
        isEdit: isEdit,
        showRepeatSection: showRepeatSection
      })
    })
  });
});
const FormFields$5 = props => {
  const {
    isEdit
  } = props;
  const {
    values
  } = useFormikContext();
  const items = useMemo(() => {
    return [{
      dataCy: 'project-dates-start-date-toggle',
      id: '2',
      header: jsxs(Typography, {
        children: ["Start date:", ' ', jsx(Typography, {
          variant: "label",
          size: "large",
          prominent: true,
          tagName: "span",
          children: formatDate(values.startDate, DATE_FORMATS.MONTH_DAY_YEAR)
        })]
      }),
      content: jsx(Layout, {
        stack: true,
        stretch: true,
        hAlign: "center",
        children: jsx(DatePickerInputFormikWrapper, {
          dense: true,
          withHeader: false,
          name: "startDate",
          label: "Start date",
          dataCy: "scheduler-classic-menu-project-dates-start-date",
          disabledDays: currentDate => {
            if (!values.endDate) {
              return false;
            }
            return isAfter(currentDate, values.endDate);
          }
        })
      })
    }, {
      dataCy: 'project-dates-end-date-toggle',
      id: '3',
      header: jsxs(Typography, {
        children: ["End date:", ' ', jsx(Typography, {
          variant: "label",
          size: "large",
          prominent: true,
          tagName: "span",
          children: formatDate(values.endDate, DATE_FORMATS.MONTH_DAY_YEAR)
        })]
      }),
      content: jsx(Layout, {
        stack: true,
        stretch: true,
        hAlign: "center",
        children: jsx(DatePickerInputFormikWrapper, {
          dense: true,
          withHeader: false,
          name: "endDate",
          label: "End date",
          dataCy: "scheduler-classic-menu-project-dates-end-date",
          disabledDays: currentDate => {
            if (!values.startDate) {
              return false;
            }
            return isBefore(currentDate, values.startDate);
          }
        })
      })
    }];
  }, [values.endDate, values.startDate]);
  const {
    expand,
    expandedItem,
    collapse
  } = useAccordionState();
  useEffect(() => {
    collapse();
  }, [collapse, values.startDate, values.endDate]);
  return jsxs(Layout, {
    stack: true,
    gap: "--Spacing-100",
    children: [jsx(Accordion, {
      items: items,
      onOpen: expand,
      openItem: expandedItem
    }), jsx(Layout, {
      hAlign: "flex-end",
      children: jsx(Button, {
        type: "submit",
        dataCy: "button--update-project-dates",
        children: isEdit ? 'Update dates' : 'Add dates'
      })
    })]
  });
};
const ProjectDatesForm$1 = /*#__PURE__*/React__default.memo(() => {
  var _a, _b;
  const currentSelection = useSelector(selectSchedulerCurrentSelection);
  const selectedBooking = useSelector(selectSchedulerCurrentSelectedBooking);
  const {
    onUpdateProjectDates
  } = useContextMenuContext();
  const projectSelector = useMemo(() => {
    var _a, _b;
    if (selectedBooking && 'datesEvent' in selectedBooking && selectedBooking.datesEvent) {
      return makeSelectProjectByIdFromMap(selectedBooking.projectId);
    }
    return makeSelectProjectByIdFromMap((_b = (_a = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.project) === null || _b === void 0 ? void 0 : _b._id);
  }, [(_b = (_a = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.project) === null || _b === void 0 ? void 0 : _b._id, selectedBooking]);
  const project = useSelector(projectSelector);
  const isEdit = useMemo(() => {
    if ((project === null || project === void 0 ? void 0 : project.start) && (project === null || project === void 0 ? void 0 : project.end)) {
      return true;
    }
    return selectedBooking && 'datesEvent' in selectedBooking && selectedBooking.datesEvent;
  }, [project === null || project === void 0 ? void 0 : project.end, project === null || project === void 0 ? void 0 : project.start, selectedBooking]);
  const initialValues = useMemo(() => {
    if ((project === null || project === void 0 ? void 0 : project.end) && (project === null || project === void 0 ? void 0 : project.start)) {
      return mapProjectBasicInfoToDatesFormData(project);
    }
    return mapCurrentSelectionToProjectDatesFormData(currentSelection);
  }, [currentSelection, project]);
  return jsx(Formik, {
    initialValues: initialValues,
    onSubmit: onUpdateProjectDates,
    enableReinitialize: true,
    validationSchema: projectDatesValidationSchema,
    children: jsx(Form, {
      children: jsx(FormFields$5, {
        isEdit: isEdit
      })
    })
  });
});
const ClassicEditProjectItems = /*#__PURE__*/React__default.memo(props => {
  const {
    position,
    anchorEl
  } = props;
  const {
    projectKeyWord
  } = useAppKeyWords();
  const {
    onClose,
    onEditProject,
    onDeleteProjectItem
  } = useContextMenuContext();
  const isPhase = useSelector(selectIsSelectedBookingPhase);
  const isMilestone = useSelector(selectIsSelectedBookingMilestone);
  const isDatesEvent = useSelector(selectIsSelectedBookingDatesEvent);
  const currentSelectedProject = useSelector(selectSchedulerSelectedBookingProject);
  const canEditProject = useCanEditProject({
    project: currentSelectedProject
  });
  const canCreateDeletePhase = useCanCreateDeletePhase({
    project: currentSelectedProject
  });
  const canCreateMilestone = useCanCreateDeleteMilestone({
    project: currentSelectedProject
  });
  const canCreateProjectDates = useCanCreateDeleteProjectDates({
    project: currentSelectedProject
  });
  const canCreateDeleteProjectDatesItem = canCreateProjectDates && isDatesEvent;
  const canCreateDeletePhaseItem = canCreateDeletePhase && isPhase;
  const canCreateDeleteMilestoneItem = canCreateMilestone && isMilestone;
  const menuItems = useMemo(() => {
    return [{
      hidden: !canCreateDeleteMilestoneItem,
      label: "Update milestone",
      dataCy: 'edit-milestone',
      children: jsx(MilestoneForm$1, {})
    }, {
      hidden: !canCreateDeletePhaseItem,
      label: "Update phase",
      dataCy: 'edit-phase',
      children: jsx(PhaseForm$1, {})
    }, {
      hidden: !canCreateDeleteProjectDatesItem,
      label: "Start & end dates",
      dataCy: 'start-end-dates',
      children: jsx(ProjectDatesForm$1, {})
    }, {
      hidden: !canEditProject,
      divider: true
    }, {
      label: 'Delete',
      hidden: !canCreateDeleteProjectDatesItem && !canCreateDeletePhaseItem && !canCreateDeleteMilestoneItem,
      onClick: () => {
        onDeleteProjectItem();
      }
    }, {
      hidden: !canEditProject,
      dataCy: "edit-".concat(isEvent(currentSelectedProject) ? 'event' : 'project'),
      label: "Edit ".concat(isEvent(currentSelectedProject) ? 'event' : projectKeyWord),
      onClick: () => {
        onEditProject();
      }
    }];
  }, [canCreateDeleteMilestoneItem, canCreateDeletePhaseItem, canCreateDeleteProjectDatesItem, canEditProject, currentSelectedProject, onDeleteProjectItem, onEditProject, projectKeyWord]);
  return jsx(ContextMenu, {
    variant: "anchor",
    items: menuItems,
    isOpen: true,
    anchorEl: anchorEl,
    position: position,
    onClose: onClose
  });
});
const ClassicProjectParentMode = /*#__PURE__*/React__default.memo(props => {
  var _a;
  const {
    position,
    anchorEl
  } = props;
  const {
    projectKeyWord
  } = useAppKeyWords();
  const {
    onClose,
    onEditProject
  } = useContextMenuContext();
  const currentSelection = useSelector(selectSchedulerCurrentSelection);
  const currentSelectedProject = (_a = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.project;
  const canEditProject = useCanEditProject({
    project: currentSelectedProject
  });
  const menuItems = useMemo(() => {
    return [{
      label: "Create milestone",
      dataCy: 'create-milestone',
      children: jsx(MilestoneForm$1, {})
    }, {
      label: "Create phase",
      dataCy: 'create-phase',
      children: jsx(PhaseForm$1, {})
    }, {
      label: "Start & end dates",
      dataCy: 'start-end-dates',
      children: jsx(ProjectDatesForm$1, {})
    }, {
      hidden: !canEditProject,
      divider: true
    }, {
      hidden: !canEditProject,
      dataCy: "edit-".concat(isEvent(currentSelectedProject) ? 'event' : 'project'),
      label: "Edit ".concat(isEvent(currentSelectedProject) ? 'event' : projectKeyWord),
      onClick: () => {
        onEditProject();
      }
    }];
  }, [canEditProject, currentSelectedProject, onEditProject, projectKeyWord]);
  return jsx(ContextMenu, {
    variant: "anchor",
    isOpen: true,
    position: position,
    items: menuItems,
    onClose: onClose,
    anchorEl: anchorEl
  });
});
const StyledForm$6 = /*#__PURE__*/styled(Form).withConfig({
  displayName: "schedule-new-project__StyledForm",
  componentId: "p761bu-0"
})(["height:100%;display:flex;flex-direction:column;"]);
const projectValidationSchema = create$3().shape({
  name: create$6().required('Required')
});
const FormFields$4 = () => {
  const dispatch = useDispatch();
  const {
    onClose,
    onCreateProject
  } = useContextMenuContext();
  const {
    projectKeyWord
  } = useAppKeyWords();
  const {
    values
  } = useFormikContext();
  const handleAddMoreDetailsBtnClick = useCallback(() => {
    onClose();
    dispatch(modalActions.showProjectModal({
      onSubmit: data => onCreateProject(data, true),
      type: ProjectTypeEnum.REGULAR,
      projectId: null,
      initialData: {
        name: values.name
      }
    }));
  }, [dispatch, onClose, onCreateProject, values.name]);
  return jsxs(Layout, {
    stack: true,
    gap: 8,
    pt: 8,
    pb: 8,
    pr: 8,
    pl: 8,
    children: [jsx(TextFieldFormikWrapper, {
      name: "name",
      label: "Name",
      placeholder: "New ".concat(projectKeyWord, " name"),
      dataCy: "schedule-new-project-form-name"
    }), jsxs(Button, {
      type: "submit",
      dataCy: "schedule-new-project",
      children: ["Schedule new ", projectKeyWord]
    }), jsx(Button, {
      variant: "text",
      onClick: handleAddMoreDetailsBtnClick,
      dataCy: "add-more-details",
      children: "add more details"
    })]
  });
};
const ScheduleNewProject = /*#__PURE__*/React__default.memo(() => {
  const {
    scheduleOnNewProject
  } = useContextMenuContext();
  const handleSubmit = useCallback(values => {
    if (!values.name) {
      return;
    }
    scheduleOnNewProject({
      name: values.name
    });
  }, [scheduleOnNewProject]);
  const initialValues = useMemo(() => ({
    name: ''
  }), []);
  return jsx(Formik, {
    initialValues: initialValues,
    validationSchema: projectValidationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
    children: jsx(StyledForm$6, {
      children: jsx(FormFields$4, {})
    })
  });
});
const getAllocationStateName = state => {
  return allocationDefinitionsByStateName[state].display;
};
const CategoryList = /*#__PURE__*/React__default.memo(() => {
  const {
    value: filterText,
    setDebouncedValue: setDebouncedFilterText,
    debounced: debouncedFilterText
  } = useDebouncedValue({
    defaultValue: ''
  });
  const {
    updateCategoryAllocation
  } = useContextMenuContext();
  const formikContext = useFormikContext();
  const {
    setFieldValue
  } = formikContext;
  const {
    project: selectedProject
  } = formikContext.values;
  const categoriesSelector = useMemo(() => {
    return makeSelectCategoriesFromGroupsByIds(selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.categoryGroups);
  }, [selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.categoryGroups]);
  const categoriesNotFiltered = useSelector(categoriesSelector);
  const categories = useMemo(() => {
    if (!debouncedFilterText) {
      return categoriesNotFiltered;
    }
    return categoriesNotFiltered.filter(template => {
      return searchStringCompare(template.name, debouncedFilterText) || searchStringCompare(template.groupName, debouncedFilterText);
    });
  }, [categoriesNotFiltered, debouncedFilterText]);
  const handleCategoryClick = useCallback(category => {
    setFieldValue('category', category).then(() => {
      updateCategoryAllocation();
    });
  }, [setFieldValue, updateCategoryAllocation]);
  const rowRenderer = useCallback(category => {
    return jsx(CategoryRow, {
      category: category
    });
  }, []);
  return jsxs(Layout, {
    stack: true,
    gap: 8,
    flex: "1 1 100%",
    children: [jsx(TextField, {
      "data-cy": "category-search",
      placeholder: "Type to filter...",
      value: filterText,
      onChange: event => setDebouncedFilterText(event.target.value),
      autoFocus: true,
      autoComplete: "off"
    }), jsx(List$1, {
      items: categories,
      rowRenderer: rowRenderer,
      onItemClick: handleCategoryClick,
      virtualized: true,
      emptyText: "Sorry, there are no categories to choose from"
    })]
  });
});
const CategoryRow = props => {
  const {
    category
  } = props;
  const allocationText = useCategoryTemplateAllocationFormat(category, ' - ');
  return jsx(ListItem, {
    density: -2,
    noWrap: true,
    label: category.name,
    supportingText: "".concat(category.groupName).concat(allocationText),
    startAdornment: jsx(Layout, {
      flex: "0 0 40px",
      children: jsx(Dot, {
        color: category.gridColor,
        size: 32
      })
    })
  });
};
const ClassicScheduleForm = /*#__PURE__*/React__default.memo(props => {
  var _a, _b;
  const {
    projectOrResource = 'resource'
  } = props;
  const {
    projectKeyWord,
    resourceKeyWord
  } = useAppKeyWords();
  const {
    values,
    setFieldValue,
    errors
  } = useFormikContext();
  const {
    reCalcAllocation,
    onStartDateChange,
    onEndDateChange,
    canSchedule,
    onSubmitSchedule,
    canRequest,
    onSubmitRequest,
    displayScheduleBtn,
    displayRequestBtn,
    updateCategoryAllocation,
    onDaysCounterChanged,
    onDaysCounterBlur
  } = useContextMenuContext();
  const scale = useSelector(selectDefaultScale);
  const isCategoryColorUsed = useSelector(selectIsCategoryColorUsed);
  const currentSchedulerSelection = useSelector(selectSchedulerCurrentSelection);
  const isHourScale = useSelector(selectIsHourScale);
  const categories = useSelector(selectCategoryTemplatesFromGroups);
  const onlyEvents = (_a = currentSchedulerSelection === null || currentSchedulerSelection === void 0 ? void 0 : currentSchedulerSelection.rowTags) === null || _a === void 0 ? void 0 : _a.isEventRow;
  const isHoursScaleCurrentSchedulerSelectedBooking = useIsHourScaleSchedulerCurrentSelectedBooking();
  const handleProjectChange = useCallback(project => {
    const category = categories.find(category => category._id === project.defaultCategoryTemplate);
    Promise.all([category ? setFieldValue('category', category) : Promise.resolve(), setFieldValue('project', project)]).then(() => {
      updateCategoryAllocation();
    });
  }, [categories, setFieldValue, updateCategoryAllocation]);
  const handleResourceChange = useCallback(resource => {
    setFieldValue('resource', resource);
  }, [setFieldValue]);
  const items = useMemo(() => {
    var _a;
    return [projectOrResource === 'resource' ? {
      dataCy: 'resource-toggler',
      id: '1',
      header: values.resource ? values.resource.name : "Select ".concat(resourceKeyWord, " / unassigned"),
      content: jsx(ResourcesList, {
        simpleRow: true,
        onResourceClick: handleResourceChange
      })
    } : {
      dataCy: 'project-toggler',
      id: '1',
      header: values.project ? values.project.name : onlyEvents ? "Select an event" : "Select ".concat(projectKeyWord, " / event"),
      content: jsx(ProjectsList, {
        simpleRow: true,
        onProjectClick: handleProjectChange
      })
    }, {
      dataCy: 'start-date-toggler',
      id: '2',
      header: jsxs(Layout, {
        gap: "--Spacing-100",
        vAlign: "center",
        children: [jsxs(Typography, {
          children: ["Start:", ' ', jsx(Typography, {
            variant: "label",
            size: "large",
            prominent: true,
            tagName: "span",
            children: values.startDate ? formatDate(values.startDate, DATE_FORMATS.MONTH_DAY_YEAR) : ''
          })]
        }), errors.startDate ? jsx(Icon, {
          name: "error",
          color: "error"
        }) : null]
      }),
      content: jsxs(Layout, {
        stretch: true,
        hAlign: "center",
        gap: "--Spacing-100",
        children: [jsx(DatePickerInputFormikWrapper, {
          dataCy: "scheduler-booking-classic-menu-start-date",
          dense: true,
          name: "startDate",
          label: "Start",
          withHeader: false,
          disabled: scale === CELLDURATION.value || isHoursScaleCurrentSchedulerSelectedBooking,
          onChange: onStartDateChange
        }), jsx(StyledDayCounterInput, {
          disabled: scale === CELLDURATION.value || isHoursScaleCurrentSchedulerSelectedBooking,
          name: "daysCounter",
          dataCy: "scheduler-booking-classic-menu-days-counter",
          label: "Days",
          onChange: onDaysCounterChanged,
          onBlur: onDaysCounterBlur,
          min: MIN_NUMBER_BOOKING_DAYS,
          max: MAX_NUMBER_BOOKING_DAYS,
          step: 1,
          withSpinButtons: true,
          disableSpecialChars: true
        })]
      })
    }, {
      dataCy: 'end-date-toggler',
      id: '3',
      header: jsxs(Layout, {
        gap: "--Spacing-100",
        vAlign: "center",
        children: [jsxs(Typography, {
          children: ["End:", ' ', jsx(Typography, {
            variant: "label",
            size: "large",
            prominent: true,
            tagName: "span",
            children: values.endDate ? formatDate(values.endDate, DATE_FORMATS.MONTH_DAY_YEAR) : ''
          })]
        }), errors.endDate ? jsx(Icon, {
          name: "error",
          color: "error"
        }) : null]
      }),
      content: jsx(Layout, {
        stack: true,
        stretch: true,
        hAlign: "center",
        children: jsx(DatePickerInputFormikWrapper, {
          dataCy: "scheduler-booking-classic-menu-end-date",
          dense: true,
          name: "endDate",
          label: "End",
          withHeader: false,
          disabled: scale === CELLDURATION.value || isHoursScaleCurrentSchedulerSelectedBooking,
          onChange: onEndDateChange,
          disabledDays: currentDate => {
            return isBefore(currentDate, values.startDate, 'day');
          }
        })
      })
    }, {
      hidden: isHourScale,
      dataCy: 'allocation-toggler',
      id: '4',
      header: jsxs(Typography, {
        children: ["Allocation:", ' ', jsx(Typography, {
          variant: "label",
          size: "large",
          prominent: true,
          tagName: "span",
          children: getAllocationStateName(values.state)
        })]
      }),
      content: jsx(BookingAllocationFormPart, {
        onChange: reCalcAllocation
      })
    }, {
      dataCy: 'category-toggler',
      id: '5',
      header: jsxs(Typography, {
        children: ["Category:", ' ', jsx(Typography, {
          variant: "label",
          size: "large",
          prominent: true,
          tagName: "span",
          children: values.category ? values.category.name : ''
        })]
      }),
      content: jsx(CategoryList, {})
    }, {
      dataCy: 'repeat-toggler',
      id: '6',
      header: jsxs(Typography, {
        children: ["Repeat:", ' ', jsx(Typography, {
          variant: "label",
          size: "large",
          prominent: true,
          tagName: "span",
          children: (_a = values.interval) === null || _a === void 0 ? void 0 : _a.label
        })]
      }),
      content: jsx(BookingRepeat$1, {})
    }, {
      dataCy: 'color-toggler',
      id: '7',
      header: isCategoryColorUsed ? jsxs(Typography, {
        children: ["Color:", ' ', jsx(Typography, {
          variant: "label",
          size: "large",
          prominent: true,
          tagName: "span",
          children: "Category Inherited"
        })]
      }) : values.useProjectColor ? jsxs(Typography, {
        children: ["Color:", ' ', jsxs(Typography, {
          variant: "label",
          size: "large",
          prominent: true,
          tagName: "span",
          children: [projectKeyWord, "/Event inherited"]
        })]
      }) : jsxs(Layout, {
        gap: "--Spacing-100",
        vAlign: "center",
        pt: "--Spacing-50",
        pb: "--Spacing-50",
        children: [jsx(Typography, {
          variant: "body",
          size: "medium",
          children: "Color:"
        }), jsx(Dot, {
          color: values.bookingColor,
          size: 32
        })]
      }),
      content: jsx(BookingColor, {})
    }];
  }, [onEndDateChange, onStartDateChange, errors.endDate, errors.startDate, handleProjectChange, handleResourceChange, isCategoryColorUsed, isHourScale, isHoursScaleCurrentSchedulerSelectedBooking, onDaysCounterBlur, onDaysCounterChanged, onlyEvents, projectKeyWord, projectOrResource, reCalcAllocation, resourceKeyWord, scale, values.bookingColor, values.category, values.endDate, (_b = values.interval) === null || _b === void 0 ? void 0 : _b.label, values.project, values.resource, values.startDate, values.state, values.useProjectColor]);
  const {
    expand,
    expandedItem,
    collapse
  } = useAccordionState();
  useEffect(() => {
    collapse();
  }, [values.resource, values.project, values.category, values.bookingColor, values.useProjectColor, collapse]);
  const keyboardActions = useMemo(() => {
    return {
      Enter: () => {
        if (!canSchedule) {
          return;
        }
        onSubmitSchedule();
      }
    };
  }, [canSchedule, onSubmitSchedule]);
  useKeyDown(keyboardActions);
  return jsxs(Layout, {
    stack: true,
    gap: 24,
    children: [jsx(Accordion, {
      items: items,
      onOpen: expand,
      openItem: expandedItem
    }), jsxs(Layout, {
      gap: "--Spacing-200",
      hAlign: "space-between",
      children: [displayRequestBtn ? jsx(Layout, {
        flex: "1 1 50%",
        children: jsx(Button, {
          onClick: onSubmitRequest,
          dataCy: "button--classic-menu-Request",
          variant: "outlined",
          disabled: !canRequest,
          fullWidth: true,
          children: "Request"
        })
      }) : null, displayScheduleBtn ? jsx(Layout, {
        flex: "1 1 50%",
        children: jsx(Button, {
          onClick: onSubmitSchedule,
          dataCy: "button--classic-menu-Schedule",
          disabled: !canSchedule,
          fullWidth: true,
          children: "Schedule"
        })
      }) : null]
    })]
  });
});
const ClassicSingleResource = props => {
  var _a, _b, _c, _d;
  const {
    position,
    anchorEl
  } = props;
  const {
    resourceKeyWord,
    vacationEventName,
    projectKeyWord
  } = useAppKeyWords();
  const {
    onClose,
    onPasteBooking,
    onEditResource,
    showMarkAsUnavailableBtn,
    markAsUnavailable,
    requestVacation,
    showRequestVacationBtn,
    requestToolBarContext,
    showScheduleSelectionBtn,
    scheduleSelection,
    showRequestSelectionBtn,
    requestSelection,
    viewData
  } = useContextMenuContext();
  const isResourceRequestExtensionInstalled = useSelector(selectIsResourceRequestExtensionInstalled);
  const currentSelection = useSelector(selectSchedulerCurrentSelection);
  const projectSelectorFromSchedulerSelection = useMemo(() => {
    var _a, _b;
    return makeSelectProjectByIdFromMap(((_b = (_a = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.project) === null || _b === void 0 ? void 0 : _b._id) || (viewData === null || viewData === void 0 ? void 0 : viewData.projectId));
  }, [(_b = (_a = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.project) === null || _b === void 0 ? void 0 : _b._id, viewData === null || viewData === void 0 ? void 0 : viewData.projectId]);
  const currentSelectedProject = useSelector(projectSelectorFromSchedulerSelection);
  const currentSelectedResource = (_c = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _c === void 0 ? void 0 : _c.resource;
  const canRequest = useCanRequest({
    project: currentSelectedProject,
    resource: currentSelectedResource
  });
  const canPasteBooking = useCanPasteBooking();
  const canEditResource = useCanEditResource({
    resource: currentSelectedResource
  });
  const canEditResourceWorkHours = useCanEditResourceWorkHours({
    resource: currentSelectedResource
  });
  const canRequestVacationForSelection = useCanRequestVacationForSelection();
  const currentSchedulerSelection = useSelector(selectSchedulerCurrentSelection);
  const onlyEvents = (_d = currentSchedulerSelection === null || currentSchedulerSelection === void 0 ? void 0 : currentSchedulerSelection.rowTags) === null || _d === void 0 ? void 0 : _d.isEventRow;
  let modifierKeyPrefix = 'CTRL +'; // control key
  if (window.navigator.platform.indexOf('Mac') === 0) {
    modifierKeyPrefix = '⌘'; // command key
  }
  const items = useMemo(() => {
    const items = [{
      hidden: requestToolBarContext,
      disabled: !canPasteBooking,
      dataCy: 'button-classic-menu-paste',
      label: jsxs(Layout, {
        hAlign: "space-between",
        stretch: true,
        children: [jsx(Typography, {
          variant: "body",
          size: "medium",
          children: "Paste"
        }), jsxs(Typography, {
          variant: "body",
          size: "medium",
          children: [modifierKeyPrefix, " V"]
        })]
      }),
      onClick: () => {
        onPasteBooking();
      }
    }, {
      hidden: requestToolBarContext,
      divider: true
    }, {
      dataCy: 'schedule-selection',
      hidden: !showScheduleSelectionBtn,
      label: 'Schedule selection',
      onClick: () => {
        scheduleSelection();
      }
    }, {
      disabled: !canRequest,
      dataCy: 'request-selection',
      hidden: !showRequestSelectionBtn,
      label: "Request ".concat(resourceKeyWord),
      onClick: () => {
        requestSelection();
      }
    }, {
      dataCy: 'request-vacation',
      hidden: !showRequestVacationBtn,
      disabled: !canRequestVacationForSelection,
      label: "Request ".concat(vacationEventName),
      onClick: () => {
        requestVacation();
      }
    }, {
      hidden: !showRequestVacationBtn,
      divider: true
    }, {
      hidden: !(showMarkAsUnavailableBtn && canEditResourceWorkHours),
      label: "Mark as unavailable",
      dataCy: 'mark-as-unavailable',
      onClick: () => {
        onClose();
        markAsUnavailable();
      }
    }, {
      hidden: !isResourceRequestExtensionInstalled && requestToolBarContext,
      label: (() => {
        if (onlyEvents) {
          return "Add event";
        }
        return requestToolBarContext ? "Request ".concat(projectKeyWord, " / event") : "Schedule ".concat(projectKeyWord, " / event");
      })(),
      dataCy: 'schedule-request-project',
      children: jsx(ClassicScheduleForm, {
        projectOrResource: "project"
      })
    }, {
      hidden: requestToolBarContext || onlyEvents,
      label: "Add new ".concat(projectKeyWord),
      dataCy: 'add-new-project',
      children: jsx(ScheduleNewProject, {})
    }, {
      hidden: !canEditResource || requestToolBarContext || onlyEvents,
      divider: true
    }, {
      hidden: !canEditResource || requestToolBarContext || onlyEvents,
      dataCy: "edit-".concat(isResource(currentSelectedResource) ? 'resource' : 'unassigned'),
      label: "Edit ".concat(isResource(currentSelectedResource) ? resourceKeyWord : 'unassigned'),
      onClick: () => {
        onEditResource();
      }
    }];
    return items;
  }, [canRequest, requestToolBarContext, canPasteBooking, modifierKeyPrefix, showScheduleSelectionBtn, showRequestSelectionBtn, resourceKeyWord, showRequestVacationBtn, canRequestVacationForSelection, vacationEventName, showMarkAsUnavailableBtn, canEditResourceWorkHours, isResourceRequestExtensionInstalled, onlyEvents, projectKeyWord, canEditResource, currentSelectedResource, onPasteBooking, scheduleSelection, requestSelection, requestVacation, onClose, markAsUnavailable, onEditResource]);
  return jsx(ContextMenu, {
    variant: "anchor",
    isOpen: true,
    position: position,
    items: items,
    onClose: onClose,
    anchorEl: anchorEl
  });
};
const ClassicSingleProject = props => {
  var _a;
  const {
    position,
    anchorEl
  } = props;
  const {
    resourceKeyWord,
    projectKeyWord
  } = useAppKeyWords();
  const {
    onClose,
    onPasteBooking,
    onEditProject,
    requestToolBarContext
  } = useContextMenuContext();
  const currentSelection = useSelector(selectSchedulerCurrentSelection);
  const currentSelectedProject = (_a = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.project;
  const canPasteBooking = useCanPasteBooking();
  const canEditProject = useCanEditProject({
    project: currentSelectedProject
  });
  const modifierKeyPrefix = useModifierKeyPrefix();
  const menuItems = useMemo(() => {
    const items = [{
      hidden: requestToolBarContext,
      disabled: !canPasteBooking,
      dataCy: 'button-classic-menu-paste',
      label: jsxs(Layout, {
        hAlign: "space-between",
        stretch: true,
        children: [jsx(Typography, {
          variant: "body",
          size: "medium",
          children: "Paste"
        }), jsxs(Typography, {
          variant: "body",
          size: "medium",
          children: [modifierKeyPrefix, "V"]
        })]
      }),
      onClick: () => {
        onPasteBooking();
      }
    }, {
      hidden: requestToolBarContext,
      divider: true
    }, {
      label: requestToolBarContext ? "Request ".concat(resourceKeyWord) : "Schedule ".concat(resourceKeyWord),
      dataCy: 'schedule-resource',
      children: jsx(ClassicScheduleForm, {
        projectOrResource: "resource"
      })
    }, {
      label: "Create milestone",
      dataCy: 'create-milestone',
      children: jsx(MilestoneForm$1, {})
    }, {
      label: "Create phase",
      dataCy: 'create-phase',
      children: jsx(PhaseForm$1, {})
    }, {
      label: "Start & end dates",
      dataCy: 'start-end-dates',
      children: jsx(ProjectDatesForm$1, {})
    }, {
      hidden: !canEditProject || requestToolBarContext,
      divider: true
    }, {
      hidden: !canEditProject || requestToolBarContext,
      dataCy: "edit-".concat(isEvent(currentSelectedProject) ? 'event' : 'project'),
      label: "Edit ".concat(isEvent(currentSelectedProject) ? 'event' : projectKeyWord),
      onClick: () => {
        onEditProject();
      }
    }];
    return items.filter(item => {
      return Boolean(item);
    });
  }, [canEditProject, canPasteBooking, currentSelectedProject, onEditProject, modifierKeyPrefix, onPasteBooking, projectKeyWord, requestToolBarContext, resourceKeyWord]);
  return jsx(ContextMenu, {
    variant: "anchor",
    isOpen: true,
    position: position,
    items: menuItems,
    onClose: onClose,
    anchorEl: anchorEl
  });
};
const ClassicSingleMode = /*#__PURE__*/React__default.memo(props => {
  var _a, _b, _c, _d;
  const schedulerCurrentSelection = useSelector(selectSchedulerCurrentSelection);
  if (((_a = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.isResourceRow) || ((_b = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _b === void 0 ? void 0 : _b.isEventRow) || ((_c = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _c === void 0 ? void 0 : _c.unassignedRow)) {
    return jsx(ClassicSingleResource, {
      position: props.position,
      anchorEl: props.anchorEl
    });
  }
  if ((_d = schedulerCurrentSelection === null || schedulerCurrentSelection === void 0 ? void 0 : schedulerCurrentSelection.rowTags) === null || _d === void 0 ? void 0 : _d.isProjectRow) {
    return jsx(ClassicSingleProject, {
      position: props.position,
      anchorEl: props.anchorEl
    });
  }
});
const StyledLayout$2 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "child-parent-mode__StyledLayout",
  componentId: "sc-1qhcz9s-0"
})(["width:367px;height:500px;"]);
const ModernChildParentMode = /*#__PURE__*/React__default.memo(props => {
  var _a, _b, _c, _d;
  const {
    position,
    anchorEl
  } = props;
  const {
    resourceKeyWord,
    projectKeyWord
  } = useAppKeyWords();
  const canPasteBooking = useCanPasteBooking();
  const {
    onClose,
    onPasteBooking,
    showScheduleSelectionBtn,
    scheduleSelection,
    showRequestSelectionBtn,
    requestSelection,
    showMarkAsUnavailableBtn,
    markAsUnavailable,
    onEditResource,
    onEditProject
  } = useContextMenuContext();
  const currentSelection = useSelector(selectSchedulerCurrentSelection);
  const currentSelectedProject = (_a = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.project;
  const currentSelectedResource = (_b = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _b === void 0 ? void 0 : _b.resource;
  const canSchedule = useCanSchedule({
    project: currentSelectedProject,
    resource: currentSelectedResource
  });
  const canRequest = useCanRequest({
    project: currentSelectedProject,
    resource: currentSelectedResource
  });
  const canEditResourceWorkHours = useCanEditResourceWorkHours({
    resource: currentSelectedResource
  });
  const canEditResource = useCanEditResource({
    resource: currentSelectedResource
  }) && Boolean((_c = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _c === void 0 ? void 0 : _c.isResourceRow);
  const canEditProject = useCanEditProject({
    project: currentSelectedProject
  }) && Boolean((_d = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _d === void 0 ? void 0 : _d.isProjectRow);
  const title = undefined;
  const content = jsx(StyledLayout$2, {
    stack: true,
    children: jsx(List$1, {
      onItemClick: item => {
        item.onClick();
      },
      rowRenderer: item => {
        return jsx(ListItem, {
          label: item.label,
          startAdornment: item.icon
        });
      },
      items: [{
        disabled: !canPasteBooking,
        dataCy: 'button--paste-booking',
        onClick: () => {
          onPasteBooking();
        },
        label: 'Paste booking',
        icon: 'contentCopy'
      }, {
        disabled: !canSchedule,
        hidden: !showScheduleSelectionBtn,
        dataCy: 'button--schedule-selection',
        onClick: () => {
          scheduleSelection();
        },
        label: 'Schedule selection',
        icon: 'accessTime'
      }, {
        disabled: !canRequest,
        hidden: !showRequestSelectionBtn,
        dataCy: 'button--request-selection',
        onClick: () => {
          requestSelection();
        },
        label: "Request ".concat(resourceKeyWord),
        icon: 'personOutline'
      }, {
        hidden: !(showMarkAsUnavailableBtn && canEditResourceWorkHours),
        dataCy: 'mark-as-unavailable',
        onClick: () => {
          onClose();
          markAsUnavailable();
        },
        label: "Mark as unavailable ",
        icon: 'calendarClock'
      }, {
        hidden: !canEditResource,
        dataCy: 'button--edit-resource',
        onClick: () => {
          onClose();
          onEditResource();
        },
        label: "Edit ".concat(isResource(currentSelectedResource) ? resourceKeyWord : 'unassigned'),
        icon: 'edit'
      }, {
        hidden: !canEditProject,
        dataCy: 'button--edit-project',
        onClick: () => {
          onClose();
          onEditProject();
        },
        label: "Edit ".concat(isEvent(currentSelectedProject) ? 'event' : projectKeyWord),
        icon: 'edit'
      }]
    })
  });
  const actions = undefined;
  return jsx(Dialog, {
    open: true,
    title: title,
    content: content,
    actions: actions,
    position: position,
    level: "default",
    hideBackdrop: true,
    onClose: onClose,
    anchorElement: anchorEl
  });
});
const ModernMenuStyledSlides = /*#__PURE__*/styled(Slides).withConfig({
  displayName: "modern-menu-slides__ModernMenuStyledSlides",
  componentId: "cmrg7w-0"
})(["width:367px;min-height:555px;"]);
const labels = {
  DAILY: 'Booking will repeat daily',
  WEEKLY: 'Booking will repeat weekly',
  BI_WEEKLY: 'Booking will repeat bi-weekly',
  MONTHLY: 'Booking will repeat monthly',
  YEARLY: 'Booking will repeat yearly'
};
const RepeatFormat = /*#__PURE__*/React__default.memo(props => {
  const {
    interval,
    repeatEveryInterval,
    repeatOn,
    repeatOnCustom1,
    repeatOnCustom2,
    repeatOnDates,
    repeatEveryTime,
    repeatOnWeekdays = {}
  } = props;
  if (!interval) {
    return null;
  }
  if (interval.value === BookingRepeatEnum.NONE) {
    return null;
  }
  if (interval.value === BookingRepeatEnum.CUSTOM) {
    if ((repeatEveryInterval === null || repeatEveryInterval === void 0 ? void 0 : repeatEveryInterval.value) === BookingRepeatIntervalEnum.DAY) {
      return "Booking will repeat every ".concat(repeatEveryTime || '', " day");
    }
    if ((repeatEveryInterval === null || repeatEveryInterval === void 0 ? void 0 : repeatEveryInterval.value) === BookingRepeatIntervalEnum.WEEK) {
      const weekDays = Object.keys(repeatOnWeekdays || {}).reduce((acc, key) => {
        const weekday = repeatOnWeekdays === null || repeatOnWeekdays === void 0 ? void 0 : repeatOnWeekdays[key];
        if (weekday) {
          acc.push(firstLetterToUpperCase(key));
        }
        return acc;
      }, []).join(', ');
      return "Booking will repeat every ".concat(repeatEveryTime || '', " week on each ").concat(weekDays);
    }
    if ((repeatEveryInterval === null || repeatEveryInterval === void 0 ? void 0 : repeatEveryInterval.value) === BookingRepeatIntervalEnum.MONTH) {
      if ((repeatOn === null || repeatOn === void 0 ? void 0 : repeatOn.value) === RepeatMonthlyOnEnum.DATES) {
        return DaysOfMonthFormat({
          days: repeatOnDates,
          repeatEvery: repeatEveryTime
        });
      }
      if ((repeatOn === null || repeatOn === void 0 ? void 0 : repeatOn.value) === RepeatMonthlyOnEnum.CUSTOM) {
        return CustomMonthDatesFormat({
          repeatEvery: repeatEveryTime,
          days: {
            ordinalIdentifier: repeatOnCustom1,
            day: repeatOnCustom2
          }
        });
      }
      return null;
    }
    if ((repeatEveryInterval === null || repeatEveryInterval === void 0 ? void 0 : repeatEveryInterval.value) === BookingRepeatIntervalEnum.YEAR) {
      return "Booking will repeat every ".concat(repeatEveryTime || '', " year");
    }
    return null;
  }
  return labels[interval.value];
});
const SLIDE_NUMBERS$5 = {
  more: 0,
  resources: 1,
  projects: 2,
  categories: 3,
  repeat: 4
};
const StyledRepeatIconButton = /*#__PURE__*/styled(IconButton).withConfig({
  displayName: "booking-form__StyledRepeatIconButton",
  componentId: "rsp3hs-0"
})(["&&{padding-top:10px;}"]);
const BookingFormModernMenu = /*#__PURE__*/React__default.memo(props => {
  var _a, _b;
  const {
    to
  } = props;
  const {
    projectKeyWord,
    resourceKeyWord
  } = useAppKeyWords();
  const formikContext = useFormikContext();
  const scale = useSelector(selectDefaultScale);
  const {
    project: selectedProject,
    resource: selectedResource,
    category: selectedCategory
  } = formikContext.values;
  const {
    reCalcAllocation,
    onStartDateChange,
    onEndDateChange,
    onDaysCounterChanged,
    onDaysCounterBlur
  } = useContextMenuContext();
  const categorySelector = useMemo(() => makeSelectCategoryFromGroup(selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory._id), [selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory._id]);
  const categoryFromGroup = useSelector(categorySelector);
  const selectedCategoryGroupName = (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.groupName) || (categoryFromGroup === null || categoryFromGroup === void 0 ? void 0 : categoryFromGroup.groupName);
  const isHourScale = useSelector(selectIsHourScale);
  const currentSchedulerSelection = useSelector(selectSchedulerCurrentSelection);
  const booking = useSelector(selectSchedulerCurrentSelectedBooking);
  const isHoursScaleCurrentSchedulerSelectedBooking = useIsHourScaleSchedulerCurrentSelectedBooking();
  const isAllDayCurrentSchedulerSelectedBooking = useIsAllDaySchedulerCurrentSelectedBooking();
  const onlyEvents = (_a = currentSchedulerSelection === null || currentSchedulerSelection === void 0 ? void 0 : currentSchedulerSelection.rowTags) === null || _a === void 0 ? void 0 : _a.isEventRow;
  const {
    errors
  } = formikContext;
  const hasRepeatError = Boolean(errors.repeatEndsOn || errors.repeatEndsOnDate || errors.repeatEndsAfterTimes || errors.repeatEveryInterval || errors.repeatEveryTime || errors.repeatOnWeekdays || errors.repeatOnDates || errors.repeatOn || errors.repeatOnCustom1 || errors.repeatOnCustom2);
  const displayIntervalInfo = formikContext.values.interval && formikContext.values.interval.value !== BookingRepeatEnum.NONE;
  const selectedProjectStatus = useProjectStatusFormat(selectedProject);
  const selectedResourceRole = useResourceRoleFormat(selectedResource);
  return jsxs(Fragment, {
    children: [jsxs(Layout, {
      stack: true,
      gap: "--Spacing-100",
      children: [jsxs(Layout, {
        gap: "--Spacing-100",
        vAlign: "flex-start",
        children: [jsx(DatePickerInputFormikWrapper, {
          name: "startDate",
          label: "Start date",
          dataCy: "scheduler-booking-modern-menu-start-date",
          disabled: scale === CELLDURATION.value || isHoursScaleCurrentSchedulerSelectedBooking,
          withTailingIcon: false,
          onChange: onStartDateChange
        }), jsx(DatePickerInputFormikWrapper, {
          name: "endDate",
          label: "End date",
          dataCy: "scheduler-booking-modern-menu-end-date",
          withTailingIcon: false,
          disabled: scale === CELLDURATION.value || isHoursScaleCurrentSchedulerSelectedBooking,
          disabledDays: currentDate => {
            return isBefore(currentDate, formikContext.values.startDate, 'day');
          },
          onChange: onEndDateChange
        }), jsx(StyledDayCounterInput, {
          disabled: scale === CELLDURATION.value || isHoursScaleCurrentSchedulerSelectedBooking,
          name: "daysCounter",
          dataCy: "scheduler-booking-modern-menu-days-counter",
          label: "Days",
          onChange: onDaysCounterChanged,
          onBlur: onDaysCounterBlur,
          min: MIN_NUMBER_BOOKING_DAYS,
          max: MAX_NUMBER_BOOKING_DAYS,
          step: 1,
          withSpinButtons: true,
          disableSpecialChars: true
        }), jsx(StyledRepeatIconButton, {
          dataCy: "scheduler-booking-modern-menu-repeat",
          icon: "eventRepeat",
          onClick: () => {
            to(SLIDE_NUMBERS$5.repeat);
          }
        })]
      }), hasRepeatError ? jsx(Typography, {
        variant: "body",
        size: "medium",
        color: "error",
        children: "Booking repeat is not configured properly"
      }) : displayIntervalInfo ? jsx(Typography, {
        variant: "body",
        size: "medium",
        color: "on-surface-variant",
        children: jsx(RepeatFormat, {
          interval: formikContext.values.interval,
          repeatEveryInterval: formikContext.values.repeatEveryInterval,
          repeatEveryTime: formikContext.values.repeatEveryTime,
          repeatOn: formikContext.values.repeatOn,
          repeatOnCustom1: formikContext.values.repeatOnCustom1,
          repeatOnCustom2: formikContext.values.repeatOnCustom2,
          repeatOnDates: formikContext.values.repeatOnDates,
          repeatOnWeekdays: formikContext.values.repeatOnWeekdays
        })
      }) : null]
    }), isHourScale || (booking === null || booking === void 0 ? void 0 : booking._id) && !isAllDayCurrentSchedulerSelectedBooking ? null : jsx(BookingAllocationFormPart, {
      inline: true,
      withTitle: true,
      onChange: reCalcAllocation
    }), jsx(List$1, {
      onItemClick: item => {
        item.onClick();
      },
      rowRenderer: item => {
        return jsx(StyledListItem$1, {
          density: item.empty ? 0 : -2,
          empty: item.empty,
          label: item.label,
          startAdornment: item.startIcon,
          endAdornment: item.endIcon,
          supportingText: item.supportingText,
          noWrap: true
        });
      },
      items: [{
        dataCy: 'scheduler-booking-modern-menu-project-selector',
        onClick: () => {
          to(SLIDE_NUMBERS$5.projects);
        },
        empty: !selectedProject,
        startIcon: selectedProject ? !selectedProject.thumb || isAvatarPlaceholder(selectedProject.thumb) ? jsx(Layout, {
          flex: "0 0 40px",
          hAlign: "center",
          children: jsx(ProjectPlaceholderAvatar, {})
        }) : jsx(Layout, {
          flex: "0 0 40px",
          hAlign: "center",
          children: jsx(Avatar, {
            src: selectedProject.thumb
          })
        }) : undefined,
        supportingText: selectedProjectStatus,
        label: selectedProject ? selectedProject.name : "Choose a ".concat(onlyEvents ? "Event" : "".concat(projectKeyWord, " or Event")),
        endIcon: selectedProject ? 'navigateNext' : jsxs(Fragment, {
          children: [jsx(Icon, {
            name: "error",
            color: "warning - medium"
          }), jsx(Layout, {
            flex: "0 0 40px",
            hAlign: "center",
            children: jsx(Icon, {
              name: "navigateNext"
            })
          })]
        })
      }, {
        empty: !selectedCategory,
        dataCy: 'scheduler-booking-modern-menu-category-selector',
        onClick: () => {
          to(SLIDE_NUMBERS$5.categories);
        },
        startIcon: selectedCategory ? jsx(Layout, {
          vAlign: "center",
          flex: "0 0 40px",
          children: jsx(Dot, {
            color: (_b = selectedCategory.gridColor) !== null && _b !== void 0 ? _b : '#42B381'
          })
        }) : undefined,
        label: selectedCategory ? selectedCategory.name : "Choose a category",
        supportingText: selectedCategoryGroupName,
        endIcon: selectedCategory ? 'navigateNext' : jsxs(Fragment, {
          children: [jsx(Icon, {
            name: "error",
            color: "warning - medium"
          }), jsx(Layout, {
            flex: "0 0 40px",
            hAlign: "center",
            children: jsx(Icon, {
              name: "navigateNext"
            })
          })]
        })
      }, {
        empty: !selectedResource,
        dataCy: 'scheduler-booking-modern-menu-resource-selector',
        onClick: () => {
          to(SLIDE_NUMBERS$5.resources);
        },
        startIcon: selectedResource ? !(selectedResource === null || selectedResource === void 0 ? void 0 : selectedResource.thumb) || isAvatarPlaceholder(selectedResource.thumb) ? jsx(ResourcePlaceholderAvatar, {}) : jsx(Avatar, {
          src: selectedResource === null || selectedResource === void 0 ? void 0 : selectedResource.thumb,
          firstName: selectedResource === null || selectedResource === void 0 ? void 0 : selectedResource.firstName,
          lastName: selectedResource === null || selectedResource === void 0 ? void 0 : selectedResource.lastName
        }) : undefined,
        supportingText: selectedResourceRole,
        label: selectedResource ? selectedResource.name : "Choose a ".concat(resourceKeyWord),
        endIcon: selectedResourceRole ? 'navigateNext' : jsxs(Fragment, {
          children: [jsx(Icon, {
            name: "error",
            color: "warning - medium"
          }), jsx(Layout, {
            flex: "0 0 40px",
            hAlign: "center",
            children: jsx(Icon, {
              name: "navigateNext"
            })
          })]
        })
      }]
    })]
  });
});
const StyledListItem$1 = /*#__PURE__*/styled(ListItem).withConfig({
  displayName: "booking-form__StyledListItem",
  componentId: "rsp3hs-1"
})(["min-height:", ";"], props => props.empty ? "64px" : 'unset');
const BookingRepeat = props => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const {
    onBackClick
  } = props;
  const formikContext = useFormikContext();
  const {
    values,
    setFieldValue
  } = formikContext;
  const repeatOnOptionsRef = useRef(null);
  const {
    open: openRepeatOnDates,
    isOpen: isOpenRepeatOnDates,
    close: closeRepeatOnDates
  } = useOpenState();
  const {
    open: openRepeatOnCustomDates,
    isOpen: isOpenRepeatOnCustomDates,
    close: closeRepeatOnCustomDates
  } = useOpenState();
  const repeatOnCustomDates = useMemo(() => {
    return {
      ordinalIdentifier: formikContext.values.repeatOnCustom1,
      day: formikContext.values.repeatOnCustom2
    };
  }, [formikContext.values.repeatOnCustom1, formikContext.values.repeatOnCustom2]);
  return jsxs(Layout, {
    stack: true,
    gap: 24,
    children: [jsx(BackSection, {
      onClick: onBackClick
    }), jsx(Layout, {
      children: jsx(Typography, {
        variant: "label",
        size: "xl",
        align: "center",
        children: "Repeat Booking"
      })
    }), jsx(SelectFormikWrapper, {
      options: bookingRepeatOptions,
      optionLabel: "label",
      optionValue: "value",
      label: "Interval",
      name: "interval",
      dataCy: "booking-repeat-interval-select",
      disableClearable: true,
      level: "high"
    }), ((_a = values.interval) === null || _a === void 0 ? void 0 : _a.value) === BookingRepeatEnum.CUSTOM ? jsxs(Fragment, {
      children: [jsxs(Layout, {
        gap: "--Spacing-200",
        vAlign: "center",
        children: [jsx(Layout, {
          flex: "1 1 35%",
          children: jsx(Typography, {
            variant: "body",
            size: "medium",
            children: "Repeat Every"
          })
        }), jsxs(Layout, {
          gap: "--Spacing-100",
          children: [jsx(NumberInputFormikWrapper, {
            name: "repeatEveryTime",
            label: "Amount",
            integerOnly: true,
            min: 1,
            dataCy: "repeat-every-time"
          }), jsx(SelectFormikWrapper, {
            disableClearable: true,
            options: repeatIntervalOptions,
            label: "",
            optionLabel: "label",
            optionValue: "value",
            name: "repeatEveryInterval",
            placeholder: "Select option",
            level: "high",
            dataCy: "repeat-every-time-select"
          })]
        })]
      }), ((_b = values.repeatEveryInterval) === null || _b === void 0 ? void 0 : _b.value) === BookingRepeatIntervalEnum.WEEK ? jsxs(Layout, {
        stack: true,
        gap: 24,
        children: [jsx(Typography, {
          variant: "body",
          size: "medium",
          children: "Repeat on"
        }), jsx(WeekDaysCheckboxList, {
          variant: "buttons",
          onChange: value => {
            formikContext.setFieldTouched('repeatOnWeekdays', true, false);
            formikContext.setFieldValue('repeatOnWeekdays', value, true);
          },
          value: values.repeatOnWeekdays
        })]
      }) : null, ((_c = values.repeatEveryInterval) === null || _c === void 0 ? void 0 : _c.value) === BookingRepeatIntervalEnum.MONTH ? jsxs(Layout, {
        ref: repeatOnOptionsRef,
        stack: true,
        gap: 24,
        children: [jsx(SelectFormikWrapper, {
          dataCy: "repeat-on-monthly-select-option",
          options: repeatMonthlyOnOptions,
          label: "",
          optionLabel: "label",
          optionValue: "value",
          placeholder: "Select option",
          name: "repeatOn",
          level: "high",
          onChange: (event, option) => {
            if (option.value === RepeatMonthlyOnEnum.DATES) {
              openRepeatOnDates(event);
            } else if (option.value === RepeatMonthlyOnEnum.CUSTOM) {
              openRepeatOnCustomDates(event);
            }
          }
        }), ((_d = formikContext.values.repeatOn) === null || _d === void 0 ? void 0 : _d.value) === RepeatMonthlyOnEnum.DATES ? jsx(Typography, {
          variant: "body",
          size: "small",
          color: "on-surface-variant",
          children: jsx(DaysOfMonthFormat, {
            days: formikContext.values.repeatOnDates,
            repeatEvery: formikContext.values.repeatEveryTime
          })
        }) : null, ((_e = formikContext.values.repeatOn) === null || _e === void 0 ? void 0 : _e.value) === RepeatMonthlyOnEnum.CUSTOM ? jsx(Typography, {
          variant: "body",
          size: "small",
          color: "on-surface-variant",
          children: jsx(CustomMonthDatesFormat, {
            days: repeatOnCustomDates,
            repeatEvery: formikContext.values.repeatEveryTime
          })
        }) : null, isOpenRepeatOnDates ? jsx(DaysOfMonthSelectDialog, {
          selected: (_f = formikContext.values.repeatOnDates) !== null && _f !== void 0 ? _f : [],
          anchorElement: repeatOnOptionsRef.current,
          open: isOpenRepeatOnDates,
          onClose: () => {
            formikContext.setFieldTouched('repeatOnDates', true, false);
            closeRepeatOnDates();
          },
          onSelect: value => {
            formikContext.setFieldValue('repeatOnDates', value);
            closeRepeatOnDates();
          }
        }) : null, isOpenRepeatOnCustomDates ? jsx(CustomMonthDatesSelectDialog, {
          value: repeatOnCustomDates,
          onClose: () => {
            formikContext.setFieldTouched('repeatOnCustom1', true, false);
            formikContext.setFieldTouched('repeatOnCustom2', true, false);
            closeRepeatOnCustomDates();
          },
          open: isOpenRepeatOnCustomDates,
          anchorElement: repeatOnOptionsRef.current,
          onSelect: value => {
            formikContext.setFieldValue('repeatOnCustom1', value.ordinalIdentifier);
            formikContext.setFieldValue('repeatOnCustom2', value.day);
            closeRepeatOnCustomDates();
          }
        }) : null]
      }) : null]
    }) : null, ((_g = values.interval) === null || _g === void 0 ? void 0 : _g.value) && ((_h = values.interval) === null || _h === void 0 ? void 0 : _h.value) !== BookingRepeatEnum.NONE ? jsxs(Layout, {
      stack: true,
      gap: "--Spacing-100",
      children: [jsx(Typography, {
        variant: "body",
        size: "medium",
        children: "Ends"
      }), jsxs(Layout, {
        stack: true,
        gap: 16,
        pl: "--Spacing-150",
        children: [jsxs(Layout, {
          gap: 31,
          children: [jsx(RadioFormikWrapper, {
            name: "repeatEndsOn",
            value: RepeatEndsOnEnum.DATE,
            label: "On"
          }), jsx(DatePickerInputFormikWrapper, {
            initialMonthDate: values.endDate,
            name: "repeatEndsOnDate",
            label: "Date",
            onOpen: () => {
              setFieldValue('repeatEndsOn', RepeatEndsOnEnum.DATE, true);
            },
            disabledDays: day => {
              return isBefore(day, values.endDate, 'day');
            }
          })]
        }), jsxs(Layout, {
          gap: "--Spacing-200",
          children: [jsx(RadioFormikWrapper, {
            name: "repeatEndsOn",
            value: RepeatEndsOnEnum.AFTERTIMES,
            label: "After"
          }), jsx(NumberInputFormikWrapper, {
            name: "repeatEndsAfterTimes",
            label: "Occurrences",
            integerOnly: true,
            onClick: () => {
              setFieldValue('repeatEndsOn', RepeatEndsOnEnum.AFTERTIMES, true);
            }
          })]
        }), jsx(Layout, {
          children: jsx(RadioFormikWrapper, {
            name: "repeatEndsOn",
            value: "NEVER",
            label: "Never"
          })
        })]
      })]
    }) : null]
  });
};
const CategoryListSlide = props => {
  const {
    onBackClick,
    onAddNew
  } = props;
  const canCreateCategoryTemplate = useCanCreateCategoryTemplate();
  const formikContext = useFormikContext();
  const {
    updateCategoryAllocation
  } = useContextMenuContext();
  const {
    setFieldValue
  } = formikContext;
  const {
    category: selectedCategory,
    project: selectedProject
  } = formikContext.values;
  const {
    value: filterText,
    setDebouncedValue: setDebouncedFilterText,
    debounced: debouncedFilterText,
    setValue: setFilterText
  } = useDebouncedValue({
    defaultValue: ''
  });
  const categoriesSelector = useMemo(() => {
    return makeSelectCategoriesFromGroupsByIds(selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.categoryGroups);
  }, [selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.categoryGroups]);
  const categoriesNotFiltered = useSelector(categoriesSelector);
  const categories = useMemo(() => {
    return categoriesNotFiltered.filter(template => {
      return searchStringCompare(template.name, debouncedFilterText) || searchStringCompare(template.groupName, debouncedFilterText);
    });
  }, [categoriesNotFiltered, debouncedFilterText]);
  const handleCategoryClick = useCallback(category => {
    setFieldValue('category', category).then(() => {
      updateCategoryAllocation();
    });
    onBackClick();
  }, [onBackClick, setFieldValue, updateCategoryAllocation]);
  const rowRenderer = useCallback(category => {
    return jsx(CategoryItem, {
      category: category,
      selectedCategory: selectedCategory
    });
  }, [selectedCategory]);
  return jsxs(Layout, {
    stack: true,
    gap: 24,
    stretch: true,
    children: [jsx(BackSection, {
      onClick: onBackClick
    }), jsx(TextField, {
      name: "category-search",
      placeholder: "Type to filter...",
      value: filterText,
      onChange: event => setDebouncedFilterText(event.target.value),
      clearable: true,
      autoFocus: true,
      onClear: () => setFilterText(''),
      autoComplete: "off"
    }), jsx(List$1, {
      virtualized: true,
      items: categories,
      rowRenderer: rowRenderer,
      onItemClick: handleCategoryClick,
      emptyText: "Sorry, there are no categories to choose from"
    }), canCreateCategoryTemplate ? jsx(Layout, {
      hAlign: "flex-end",
      children: jsxs(Button, {
        variant: "outlined",
        dataCy: "button--Add New Category",
        startIcon: "add",
        onClick: () => onAddNew({
          name: filterText
        }),
        children: ["Add new category ", !categories.length && filterText ? "\"".concat(filterText, "\"") : null]
      })
    }) : null]
  });
};
const CategoryItem = props => {
  const {
    category,
    selectedCategory
  } = props;
  const categoryTemplateAllocationText = useCategoryTemplateAllocationFormat(category, ' - ');
  return jsx(ListItem, {
    startAdornment: jsx(Layout, {
      flex: "0 0 40px",
      children: jsx(Dot, {
        color: category.gridColor
      })
    }),
    label: category.name,
    supportingText: "".concat(category.groupName).concat(categoryTemplateAllocationText),
    endAdornment: (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory._id) === category._id ? 'check' : null,
    noWrap: true,
    density: -2
  });
};
const categoryValidationSchema = create$3().shape({
  name: create$6().required('Required'),
  gridColor: create$6().required('Required'),
  total: create$5().min(0).required(),
  hours: create$5().min(0).required(),
  percentage: create$5().min(0).required(),
  state: create$8().required(),
  categoryGroup: create$8().required()
});
const mapCategoryTemplateFormDataToRequest = data => {
  var _a;
  return {
    name: data.name,
    gridColor: data.gridColor,
    state: data.state,
    percentAllocation: data.percentage,
    totalBucketMinutesAllocation: data.hours * 60,
    minutesPerDay: data.total * 60,
    type: CategoryTypeEnum.CUSTOM,
    groupId: (_a = data.categoryGroup) === null || _a === void 0 ? void 0 : _a._id
  };
};
const CREATE_CATEGORY_TEMPLATE = createRequestTypes('CREATE_CATEGORY_TEMPLATE', true);
const categoryTemplateActions = {
  create: {
    request: (data, callback) => actionCreator(CREATE_CATEGORY_TEMPLATE.REQUEST, {
      data,
      callback
    }),
    success: (categoryTemplate, withAllocationText) => actionCreator(CREATE_CATEGORY_TEMPLATE.SUCCESS, {
      categoryTemplate,
      withAllocationText
    })
  }
};
const StyledForm$5 = /*#__PURE__*/styled(Form).withConfig({
  displayName: "category-short-form__StyledForm",
  componentId: "sc-4if2lv-0"
})(["height:100%;display:flex;flex-direction:column;"]);
const FormFields$3 = () => {
  const {
    setValues
  } = useFormikContext();
  const avgDailyCapacity = useSelector(selectCompanyAvgDailyCapacity);
  const shouldUseCategoriesAllocation = useSelector(selectUseCategoriesAllocation);
  const categoryGroups = useSelector(selectCategoryGroups);
  const handleAllocationValueChange = useCallback(() => {
    setValues(values => {
      const bookingAllocationValueName = allocationDefinitionsByStateName[values.state].valueName;
      const newAllocationValues = getBookingAllocationValuesFromSingleValue({
        nameOfValue: bookingAllocationValueName,
        value: values[bookingAllocationValueName],
        avgDailyCapacity,
        numberOfWorkDays: 1,
        totalBookingMinutes: avgDailyCapacity * 60
      });
      return Object.assign(Object.assign({}, values), newAllocationValues);
    });
  }, [avgDailyCapacity, setValues]);
  return jsxs(Layout, {
    stack: true,
    gap: 24,
    flex: "1 1 auto",
    children: [jsxs(Layout, {
      gap: 24,
      children: [jsx(TextFieldFormikWrapper, {
        name: "name",
        label: "Category name",
        dataCy: "new-category-short-form-name"
      }), jsx(ColorPickerDialogFormikWrapper, {
        name: "gridColor",
        dataCy: "new-category-short-form-grid-color"
      })]
    }), shouldUseCategoriesAllocation ? jsx(BookingAllocationFormPart, {
      withTitle: true,
      onChange: handleAllocationValueChange
    }) : null, jsx(SelectFormikWrapper, {
      options: categoryGroups,
      label: "Category group",
      optionLabel: "name",
      optionValue: "_id",
      name: "categoryGroup"
    })]
  });
};
const CategoryShortForm = /*#__PURE__*/React__default.memo(props => {
  const {
    newCategory,
    onBackClick,
    onCreate
  } = props;
  const dispatch = useDispatch();
  const defaultCategoryGroup = useSelector(selectDefaultCategoryGroup);
  const companyAvgDailyCapacity = useSelector(selectCompanyAvgDailyCapacity);
  const initialValues = useMemo(() => {
    return {
      categoryGroup: defaultCategoryGroup,
      name: newCategory.name,
      percentage: 100,
      total: companyAvgDailyCapacity,
      hours: companyAvgDailyCapacity,
      gridColor: '#000',
      state: AllocationStateEnum.PERCENTAGE
    };
  }, [companyAvgDailyCapacity, defaultCategoryGroup, newCategory.name]);
  const handleSubmit = useCallback(values => {
    dispatch(categoryTemplateActions.create.request(mapCategoryTemplateFormDataToRequest(values), category => {
      var _a;
      onCreate(Object.assign(Object.assign({}, category), {
        groupName: (_a = values.categoryGroup) === null || _a === void 0 ? void 0 : _a.name
      }));
    }));
  }, [dispatch, onCreate]);
  return jsxs(Layout, {
    stack: true,
    gap: 24,
    stretch: true,
    children: [jsx(BackSection, {
      onClick: onBackClick
    }), jsx(Formik, {
      initialValues: initialValues,
      onSubmit: handleSubmit,
      enableReinitialize: true,
      validationSchema: categoryValidationSchema,
      children: jsxs(StyledForm$5, {
        children: [jsx(FormFields$3, {}), jsx(Layout, {
          hAlign: "flex-end",
          children: jsx(Button, {
            type: "submit",
            dataCy: "button--add-category",
            children: "Add category"
          })
        })]
      })
    })]
  });
});
const StyledForm$4 = /*#__PURE__*/styled(Form).withConfig({
  displayName: "project-event-short-form__StyledForm",
  componentId: "ac52id-0"
})(["height:100%;display:flex;flex-direction:column;"]);
const projectEventValidationSchema = create$3().shape({
  name: create$6().required('Required')
});
const ProjectEventShortForm = props => {
  const {
    newProject,
    onBackClick,
    onCreate
  } = props;
  const appKeyWords = useAppKeyWords();
  const dispatch = useDispatch();
  const handleSubmit = useCallback(values => {
    dispatch(projectActions.create.request(Object.assign(Object.assign({}, mapFormToRequest(values)), {
      options: {
        skipCustomFieldsValidation: true
      }
    }), project => {
      onCreate(project);
    }));
  }, [dispatch, onCreate]);
  const initialValues = useMemo(() => ({
    name: newProject.name,
    code: '',
    type: newProject.type
  }), [newProject.name, newProject.type]);
  return jsxs(Layout, {
    stack: true,
    gap: 24,
    stretch: true,
    children: [jsx(BackSection, {
      onClick: onBackClick
    }), jsx(Formik, {
      initialValues: initialValues,
      validationSchema: projectEventValidationSchema,
      onSubmit: handleSubmit,
      enableReinitialize: true,
      children: jsxs(StyledForm$4, {
        children: [jsxs(Layout, {
          stack: true,
          gap: 24,
          flex: "1 1 auto",
          children: [jsx(TextFieldFormikWrapper, {
            name: "name",
            label: "Name",
            dataCy: "new-project-event-short-form-name"
          }), jsx(TextFieldFormikWrapper, {
            name: "code",
            label: "Code",
            dataCy: "new-project-event-short-form-code"
          })]
        }), jsx(Layout, {
          hAlign: "flex-end",
          children: jsxs(Button, {
            type: "submit",
            dataCy: newProject.type === ProjectTypeEnum.REGULAR ? 'create-project' : 'create-event',
            children: ["Create ", newProject.type === ProjectTypeEnum.REGULAR ? appKeyWords.projectKeyWord : 'event']
          })
        })]
      })
    })]
  });
};
const mapFormToRequest = function (values) {
  let resources = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return {
    project: {
      name: values.name,
      projectCode: values.code,
      type: values.type,
      resources
    }
  };
};
const ProjectListSlide = props => {
  const {
    onBackClick,
    onAddNew
  } = props;
  const {
    updateCategoryAllocation
  } = useContextMenuContext();
  const formikContext = useFormikContext();
  const {
    setFieldValue
  } = formikContext;
  const categories = useSelector(selectCategoryTemplatesFromGroups);
  const handleProjectClick = useCallback(project => {
    const category = categories.find(category => category._id === project.defaultCategoryTemplate);
    Promise.all([category ? setFieldValue('category', category) : Promise.resolve(), setFieldValue('project', project)]).then(() => {
      onBackClick();
      updateCategoryAllocation();
    });
  }, [categories, onBackClick, setFieldValue, updateCategoryAllocation]);
  return jsxs(Layout, {
    stack: true,
    gap: 24,
    stretch: true,
    children: [jsx(BackSection, {
      onClick: onBackClick
    }), jsx(ProjectsList, {
      withCreateBtn: true,
      onCreateBtnClick: onAddNew,
      onProjectClick: handleProjectClick
    })]
  });
};
const ResourceListSlide = props => {
  const {
    onBackClick,
    onAddNew
  } = props;
  const formikContext = useFormikContext();
  const {
    setFieldValue
  } = formikContext;
  const handleResourceClick = useCallback(resource => {
    setFieldValue('resource', resource);
    onBackClick();
  }, [onBackClick, setFieldValue]);
  return jsxs(Layout, {
    stack: true,
    gap: 24,
    stretch: true,
    children: [jsx(BackSection, {
      onClick: onBackClick
    }), jsx(ResourcesList, {
      onResourceClick: handleResourceClick,
      withCreateBtn: true,
      onCreateBtnClick: onAddNew
    })]
  });
};
const StyledForm$3 = /*#__PURE__*/styled(Form).withConfig({
  displayName: "resource-unassigned-short-form__StyledForm",
  componentId: "sc-1uk5p0d-0"
})(["height:100%;display:flex;flex-direction:column;"]);
const ResourceUnassignedShortForm = props => {
  const {
    onBackClick,
    newResource,
    onCreate
  } = props;
  return jsxs(Layout, {
    stack: true,
    gap: 24,
    stretch: true,
    children: [jsx(BackSection, {
      onClick: onBackClick
    }), newResource.type === ResourceTypeEnum.REGULAR ? jsx(NewResourceShortForm, {
      newResource: newResource,
      onCreate: onCreate
    }) : jsx(NewUnassignedShortForm, {
      newResource: newResource,
      onCreate: onCreate
    })]
  });
};
const resourceValidationSchema = create$3().shape({
  firstName: create$6().required('Required'),
  lastName: create$6().optional(),
  email: create$6().optional().email('Invalid email address').test((value, ctx) => {
    if (ctx.parent.sendInviteEmail) {
      return value ? true : ctx.createError({
        message: 'Email is required when sending an invite'
      });
    }
    return true;
  }),
  sendInviteEmail: create$7().required('Required'),
  role: create$8().required('Required')
});
const NewResourceShortForm = props => {
  const {
    newResource,
    onCreate
  } = props;
  const {
    resourceKeyWord
  } = useAppKeyWords();
  const dispatch = useDispatch();
  const handleSubmit = useCallback(form => {
    dispatch(resourceActions.create.request(Object.assign(Object.assign({}, mapResourceFormToRequest(form)), {
      options: {
        skipCustomFieldsValidation: true
      }
    }), resource => {
      onCreate(Object.assign(Object.assign({}, resource), {
        role: form.role.value
      }));
    }, false));
  }, [dispatch, onCreate]);
  const initialValues = useMemo(() => ({
    firstName: newResource.name,
    lastName: '',
    email: '',
    sendInviteEmail: false,
    role: {
      label: 'Team',
      value: ResourceRoleEnum.ROLE_TEAM
    }
  }), [newResource.name]);
  return jsx(Formik, {
    initialValues: initialValues,
    validationSchema: resourceValidationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
    children: jsxs(StyledForm$3, {
      children: [jsxs(Layout, {
        stack: true,
        gap: 24,
        flex: "1 1 auto",
        children: [jsx(TextFieldFormikWrapper, {
          name: "firstName",
          label: "First Name",
          dataCy: "new-resource-short-form-first-name"
        }), jsx(TextFieldFormikWrapper, {
          name: "lastName",
          label: "Last Name",
          dataCy: "new-resource-short-form-last-name"
        }), jsx(TextFieldFormikWrapper, {
          name: "email",
          label: "Email",
          dataCy: "new-resource-short-form-email"
        }), jsx(CheckboxFormikWrapper, {
          value: true,
          name: "sendInviteEmail",
          label: "Invite user"
        }), jsx(SelectFormikWrapper, {
          options: RESOURCE_ROLE_OPTIONS,
          label: "Role",
          optionLabel: "label",
          optionValue: "value",
          name: "role"
        })]
      }), jsx(Layout, {
        hAlign: "flex-end",
        children: jsxs(Button, {
          dataCy: "button--create-resource",
          type: "submit",
          children: ["Create ", resourceKeyWord]
        })
      })]
    })
  });
};
const mapResourceFormToRequest = values => ({
  sendInviteEmail: values.sendInviteEmail,
  resource: {
    email: values.email || null
  },
  companySpecific: {
    firstName: values.firstName,
    lastName: values.lastName,
    role: values.role.value
  }
});
const unassignedValidationSchema = create$3().shape({
  firstName: create$6().required('Required')
});
const NewUnassignedShortForm = props => {
  const {
    newResource,
    onCreate
  } = props;
  const dispatch = useDispatch();
  const handleSubmit = useCallback(values => {
    const unassignedToSave = {
      companySpecific: Object.assign({}, values),
      resource: {
        type: ResourceTypeEnum.UNASSIGNED
      }
    };
    dispatch(resourceActions.create.request(Object.assign(Object.assign({}, unassignedToSave), {
      options: {
        skipCustomFieldsValidation: true
      }
    }), newUnassigned => {
      onCreate(newUnassigned);
    }, false));
  }, [dispatch, onCreate]);
  const initialValues = useMemo(() => ({
    firstName: newResource.name
  }), [newResource.name]);
  return jsx(Formik, {
    initialValues: initialValues,
    validationSchema: unassignedValidationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
    children: jsxs(StyledForm$3, {
      children: [jsx(Layout, {
        stack: true,
        gap: 24,
        flex: "1 1 auto",
        children: jsx(TextFieldFormikWrapper, {
          name: "firstName",
          label: "First Name",
          dataCy: "new-unassigned-short-form-name"
        })
      }), jsx(Layout, {
        hAlign: "flex-end",
        children: jsx(Button, {
          dataCy: "button--create-unassigned",
          type: "submit",
          children: "Create unassigned"
        })
      })]
    })
  });
};
const SLIDES = {
  deadline: 0,
  split: 1
};
const StyledSlides$2 = /*#__PURE__*/styled(Slides).withConfig({
  displayName: "more-edit-actions__StyledSlides",
  componentId: "sc-1tkgy7c-0"
})(["height:100%;"]);
const StyledLayout$1 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "more-edit-actions__StyledLayout",
  componentId: "sc-1tkgy7c-1"
})(["height:100%;overflow:hidden;"]);
const ListLayoutWrapper = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "more-edit-actions__ListLayoutWrapper",
  componentId: "sc-1tkgy7c-2"
})(["overflow:auto;"]);
const MoreEditActions = /*#__PURE__*/React__default.memo(props => {
  const {
    top
  } = props;
  const {
    projectKeyWord,
    resourceKeyWord
  } = useAppKeyWords();
  const {
    onEditBookingTitle,
    onBulkMove,
    showBookingModal,
    onClose,
    showSplitBookingOption,
    disableSplitBookingOption,
    onCutBooking,
    onEditResource,
    onEditProject,
    onAssignToAll
  } = useContextMenuContext();
  const schedulerCurrentSelectedBooking = useSelector(selectSchedulerCurrentSelectedBooking);
  const isDependenciesExtensionInstalled = useSelector(selectIsDependenciesExtensionInstalled);
  const isTasksExtensionInstalled = useSelector(selectIsTasksExtensionInstalled);
  const isDeadlinesExtensionInstalled = useSelector(selectIsDeadlinesExtensionInstalled);
  const booking = isSchedulerItemABookingType(schedulerCurrentSelectedBooking) ? schedulerCurrentSelectedBooking : isSchedulerItemADeadlineType(schedulerCurrentSelectedBooking) ? schedulerCurrentSelectedBooking.booking : undefined;
  const {
    project: currentSelectedProject
  } = booking || {};
  const currentSelectedResource = isSchedulerItemABookingType(schedulerCurrentSelectedBooking) ? schedulerCurrentSelectedBooking === null || schedulerCurrentSelectedBooking === void 0 ? void 0 : schedulerCurrentSelectedBooking.resourceInfo : undefined;
  const canEditProject = useCanEditProject({
    project: currentSelectedProject
  });
  const canEditResource = useCanEditResource({
    resource: currentSelectedResource
  });
  const canBulkMove = useCanBulkMoveSelectedBooking();
  return jsx(StyledSlides$2, {
    mainComponent: _ref344 => {
      let {
        toSlidesGroup
      } = _ref344;
      return jsxs(StyledLayout$1, {
        stack: true,
        gap: 24,
        children: [jsx(BackSection, {
          onClick: top
        }), jsx(ListLayoutWrapper, {
          stack: true,
          flex: "1 1 auto",
          children: jsx(List$1, {
            onItemClick: item => {
              item.onClick();
            },
            rowRenderer: item => {
              if (typeof item.label === 'string') {
                return jsx(ListItem, {
                  label: item.label,
                  startAdornment: item.icon
                });
              }
              return item.label();
            },
            items: [{
              icon: 'contentCut',
              label: 'Cut',
              dataCy: 'scheduler-booking-modern-menu-cut-booking',
              onClick: onCutBooking
            }, {
              onClick: () => {
                onEditBookingTitle();
                onClose();
              },
              icon: 'edit',
              label: 'Edit title',
              dataCy: 'scheduler-booking-modern-edit-title'
            }, {
              onClick: () => {
                if (isDeadlinesExtensionInstalled) {
                  toSlidesGroup(SLIDES.deadline);
                }
              },
              icon: 'alarm',
              label: () => {
                if (!isDeadlinesExtensionInstalled) {
                  return jsx(MissingExtensionTooltip, {
                    extension: ExtensionsEnum.DEADLINES,
                    onClick: onClose,
                    children: jsx(ListItem, {
                      label: "Add deadline",
                      endAdornment: "info"
                    })
                  });
                }
                const text = isSchedulerItemABookingType(schedulerCurrentSelectedBooking) && (schedulerCurrentSelectedBooking === null || schedulerCurrentSelectedBooking === void 0 ? void 0 : schedulerCurrentSelectedBooking.deadlineDate) ? 'Edit deadline' : 'Add deadline';
                return jsx(ListItem, {
                  startAdornment: "alarm",
                  label: text
                });
              },
              dataCy: 'scheduler-booking-modern-menu-add-edit-deadline',
              disabled: !isDeadlinesExtensionInstalled
            }, {
              onClick: () => {
                showBookingModal();
                onClose();
              },
              icon: 'textAd',
              label: 'Edit Booking',
              dataCy: 'scheduler-booking-modern-menu-edit-booking'
            }, {
              onClick: () => {
                onEditProject();
                onClose();
              },
              icon: 'folder',
              disabled: !canEditProject,
              label: "Edit ".concat(projectKeyWord),
              dataCy: 'scheduler-booking-modern-menu-edit-project'
            }, {
              onClick: () => {
                onClose();
                onEditResource();
              },
              icon: 'personOutline',
              disabled: !canEditResource,
              label: "Edit ".concat(resourceKeyWord),
              dataCy: 'scheduler-booking-modern-edit-resource'
            }, {
              onClick: () => {
                onBulkMove();
                onClose();
              },
              hidden: !canBulkMove,
              icon: 'moveGroup',
              label: 'Bulk move',
              dataCy: 'scheduler-booking-modern-bulk-move'
            }, {
              onClick: () => {
                onAssignToAll();
                onClose();
              },
              icon: 'groupWork',
              label: 'Assign to all in group',
              dataCy: 'scheduler-booking-modern-menu-assign'
            }, {
              onClick: () => {
                showBookingModal(BookingModalTabsEnums.NOTES);
                onClose();
              },
              icon: 'format_size',
              label: 'Notes',
              dataCy: 'scheduler-booking-modern-menu-notes'
            }, {
              onClick: () => {
                if (isDependenciesExtensionInstalled) {
                  showBookingModal(BookingModalTabsEnums.DEPENDENCIES);
                  onClose();
                }
              },
              icon: 'dependent',
              label: () => {
                if (!isDependenciesExtensionInstalled) {
                  return jsx(MissingExtensionTooltip, {
                    extension: ExtensionsEnum.DEPENDENCIES,
                    onClick: onClose,
                    children: jsx(ListItem, {
                      label: "Dependencies",
                      endAdornment: "info"
                    })
                  });
                }
                return jsx(ListItem, {
                  startAdornment: "alarm",
                  label: "Dependencies"
                });
              },
              dataCy: 'scheduler-booking-modern-menu-links',
              disabled: !isDependenciesExtensionInstalled
            }, {
              onClick: () => {
                if (!isTasksExtensionInstalled) {
                  return;
                }
                showBookingModal(BookingModalTabsEnums.TASKS);
                onClose();
              },
              label: () => {
                if (!isTasksExtensionInstalled) {
                  return jsx(MissingExtensionTooltip, {
                    extension: ExtensionsEnum.TASKS,
                    onClick: onClose,
                    children: jsx(ListItem, {
                      label: "Tasks",
                      endAdornment: "info"
                    })
                  });
                }
                return jsx(ListItem, {
                  label: "Tasks",
                  startAdornment: "listAltAdd"
                });
              },
              icon: 'listAltAdd',
              dataCy: 'scheduler-booking-modern-menu-tasks',
              disabled: !isTasksExtensionInstalled
            }, {
              onClick: () => {
                toSlidesGroup(SLIDES.split);
              },
              icon: 'contentCut',
              label: 'Split',
              disabled: disableSplitBookingOption,
              hidden: !showSplitBookingOption,
              dataCy: 'scheduler-booking-modern-menu-split'
            }]
          })
        })]
      });
    },
    items: _ref345 => {
      let {
        topSlide
      } = _ref345;
      return [[jsx(DeadlineForm, {
        onBackClick: topSlide
      })], [jsxs(Layout, {
        stack: true,
        gap: 24,
        stretch: true,
        children: [jsx(BackSection, {
          onClick: topSlide
        }), jsx(SplitBooking, {})]
      })]];
    }
  });
});
const SLIDE_NUMBERS$4 = {
  more: 0,
  resources: 1,
  projects: 2,
  categories: 3,
  repeat: 4
};
const EditBookingModernMenu = /*#__PURE__*/React__default.memo(props => {
  const {
    position,
    anchorEl
  } = props;
  const formikContext = useFormikContext();
  const {
    setFieldValue
  } = formikContext;
  const {
    newResource,
    setNewResource,
    newProject,
    setNewProject,
    newCategory,
    setNewCategory,
    onClose,
    onDuplicateBooking,
    onCopyBooking,
    canUpdateBooking,
    onSubmitUpdateBooking,
    scheduleRequestProject,
    onDeleteBooking
  } = useContextMenuContext();
  const currentBooking = useSelector(selectSchedulerCurrentSelectedBooking);
  const currentSelectedResource = isSchedulerItemABookingType(currentBooking) ? currentBooking === null || currentBooking === void 0 ? void 0 : currentBooking.resourceInfo : undefined;
  const currentSelectedProject = isSchedulerItemABookingType(currentBooking) ? currentBooking === null || currentBooking === void 0 ? void 0 : currentBooking.project : undefined;
  const handleClose = useCallback(() => {
    onClose === null || onClose === void 0 ? void 0 : onClose();
  }, [onClose]);
  useEffect(() => {
    if (!(currentBooking === null || currentBooking === void 0 ? void 0 : currentBooking._id)) {
      handleClose();
    }
  }, [currentBooking === null || currentBooking === void 0 ? void 0 : currentBooking._id, handleClose]);
  const keyboardActions = useMemo(() => {
    return {
      Enter: () => {
        if (!canUpdateBooking) {
          return;
        }
        onSubmitUpdateBooking();
      }
    };
  }, [canUpdateBooking, onSubmitUpdateBooking]);
  useKeyDown(keyboardActions);
  const title = undefined;
  const actions = undefined;
  const content = jsx(ModernMenuStyledSlides, {
    mainComponent: _ref346 => {
      let {
        toSlidesGroup
      } = _ref346;
      return jsxs(Layout, {
        stack: true,
        stretch: true,
        children: [jsx(Typography, {
          variant: "title",
          size: "large",
          noWrap: true,
          children: scheduleRequestProject ? currentSelectedProject === null || currentSelectedProject === void 0 ? void 0 : currentSelectedProject.name : "".concat(currentSelectedResource === null || currentSelectedResource === void 0 ? void 0 : currentSelectedResource.firstName, " ").concat(currentSelectedResource === null || currentSelectedResource === void 0 ? void 0 : currentSelectedResource.lastName)
        }), jsx(Layout, {
          pt: "--Spacing-100",
          pb: "--Spacing-100",
          children: jsx(Divider, {})
        }), jsxs(Layout, {
          stack: true,
          gap: 24,
          stretch: true,
          flex: "1 1 auto",
          children: [jsxs(Layout, {
            hAlign: "space-between",
            children: [jsxs(Layout, {
              gap: "--Spacing-100",
              children: [jsx(Button, {
                variant: "text",
                startIcon: "contentCopy",
                dataCy: "button--duplciate-booking",
                onClick: onDuplicateBooking,
                children: "Duplicate"
              }), jsx(Button, {
                variant: "text",
                startIcon: "contentCopy",
                dataCy: "button--copy-booking",
                onClick: onCopyBooking,
                children: "Copy"
              }), jsx(Button, {
                variant: "text",
                startIcon: "delete",
                dataCy: "scheduler-booking-modern-menu-delete-booking",
                onClick: onDeleteBooking,
                children: "Delete"
              })]
            }), jsx(IconButton, {
              dataCy: "button--more-next-slide",
              icon: "moreVert",
              onClick: () => {
                toSlidesGroup(SLIDE_NUMBERS$4.more);
              }
            })]
          }), jsx(BookingFormModernMenu, {
            to: toSlidesGroup
          })]
        }), jsx(Layout, {
          pt: 24,
          gap: "--Spacing-100",
          hAlign: "flex-end",
          children: jsx(Button, {
            onClick: onSubmitUpdateBooking,
            dataCy: "button--mod-menu-update-schedule",
            disabled: !canUpdateBooking,
            type: "submit",
            children: "Update schedule"
          })
        })]
      });
    },
    items: _ref347 => {
      let {
        prevSlide,
        topSlide,
        nextSlide
      } = _ref347;
      return [[jsx(MoreEditActions, {
        top: topSlide
      })], [jsx(ResourceListSlide, {
        onBackClick: () => topSlide(),
        onAddNew: newResource => {
          setNewResource(newResource);
          nextSlide();
        }
      }), jsx(ResourceUnassignedShortForm, {
        onBackClick: () => prevSlide(),
        onCreate: resource => {
          setFieldValue('resource', resource).then(() => {
            topSlide();
            setNewResource({
              name: '',
              type: ResourceTypeEnum.REGULAR
            });
          });
        },
        newResource: newResource
      })], [jsx(ProjectListSlide, {
        onBackClick: () => topSlide(),
        onAddNew: newProject => {
          setNewProject(newProject);
          nextSlide();
        }
      }), jsx(ProjectEventShortForm, {
        onBackClick: () => prevSlide(),
        newProject: newProject,
        onCreate: project => {
          setFieldValue('project', project).then(() => {
            topSlide();
            setNewProject({
              name: '',
              type: ProjectTypeEnum.REGULAR
            });
          });
        }
      })], [jsx(CategoryListSlide, {
        onBackClick: () => topSlide(),
        onAddNew: newCategory => {
          setNewCategory(newCategory);
          nextSlide();
        }
      }), jsx(CategoryShortForm, {
        newCategory: newCategory,
        onBackClick: () => prevSlide(),
        onCreate: category => {
          setFieldValue('category', category).then(() => {
            topSlide();
            setNewCategory({
              name: ''
            });
          });
        }
      })], [jsx(BookingRepeat, {
        onBackClick: topSlide
      })]];
    }
  });
  return jsx(Dialog, {
    open: true,
    title: title,
    content: content,
    actions: actions,
    onClose: handleClose,
    position: position,
    anchorElement: anchorEl,
    level: "default",
    hideBackdrop: true
  });
});
const StyledLayout = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "edit-deadline__StyledLayout",
  componentId: "sc-1nn3h81-0"
})(["width:300px;height:350px;"]);
const EditDeadlineContextMenu = /*#__PURE__*/React__default.memo(props => {
  const {
    position,
    anchorEl
  } = props;
  const {
    onClose
  } = useContextMenuContext();
  const title = undefined;
  const content = jsx(StyledLayout, {
    children: jsx(DeadlineForm, {})
  });
  const actions = undefined;
  return jsx(Dialog, {
    open: true,
    title: title,
    content: content,
    actions: actions,
    position: position,
    level: "default",
    hideBackdrop: true,
    onClose: onClose,
    anchorElement: anchorEl
  });
});
const StyledForm$2 = /*#__PURE__*/styled(Form).withConfig({
  displayName: "milestone-form__StyledForm",
  componentId: "gbiig6-0"
})(["height:100%;display:flex;flex-direction:column;"]);
const FormFields$2 = props => {
  var _a;
  const {
    showRepeatSection
  } = props;
  const {
    values
  } = useFormikContext();
  return jsxs(Layout, {
    stack: true,
    gap: "--Spacing-200",
    flex: "1 1 auto",
    children: [jsxs(Layout, {
      gap: 24,
      children: [jsx(TextFieldFormikWrapper, {
        name: "name",
        label: "Milestone name",
        placeholder: "E.g. Main Delivery",
        dataCy: "scheduler-booking-modern-menu-milestone-name"
      }), jsx(ColorPickerDialogFormikWrapper, {
        name: "color",
        dataCy: "scheduler-booking-modern-menu-ms-hex-color"
      })]
    }), jsx(DatePickerInputFormikWrapper, {
      name: "date",
      label: "Milestone date",
      dataCy: "scheduler-booking-modern-menu-milestone-date"
    }), showRepeatSection ? jsxs(Fragment, {
      children: [jsx(SelectFormikWrapper, {
        disableClearable: true,
        options: simpleRepeatOptions,
        label: "Interval",
        optionLabel: "label",
        optionValue: "value",
        name: "interval",
        dataCy: "scheduler-booking-modern-menu-milestone-interval"
      }), jsx(NumberInputFormikWrapper, {
        disabled: ((_a = values.interval) === null || _a === void 0 ? void 0 : _a.value) === SimpleRepeatEnum.NONE,
        name: "repeatTimes",
        dataCy: "scheduler-booking-modern-menu-milestone-repeat-times",
        label: "Number of repeat times"
      })]
    }) : null]
  });
};
const MilestoneForm = /*#__PURE__*/React__default.memo(props => {
  const {
    onBackClick
  } = props;
  const currentSelection = useSelector(selectSchedulerCurrentSelection);
  const selectedBooking = useSelector(selectSchedulerCurrentSelectedBooking);
  const {
    onCreateMilestone,
    onUpdateMilestone
  } = useContextMenuContext();
  const showRepeatSection = useMemo(() => {
    return Boolean(!(selectedBooking === null || selectedBooking === void 0 ? void 0 : selectedBooking._id)) || Boolean(selectedBooking && 'milestone' in selectedBooking && selectedBooking.milestone && !selectedBooking.repeat);
  }, [selectedBooking]);
  const isEdit = useMemo(() => {
    return selectedBooking && 'milestone' in selectedBooking && selectedBooking.milestone;
  }, [selectedBooking]);
  const initialValues = useMemo(() => {
    if (selectedBooking && 'milestone' in selectedBooking && selectedBooking.milestone) {
      return mapCurrentSelectionToProjectMilestoneFormData(selectedBooking);
    }
    return mapCurrentSelectionToProjectMilestoneFormData(currentSelection);
  }, [currentSelection, selectedBooking]);
  const handleSubmit = useCallback(values => {
    isEdit ? onUpdateMilestone(values, initialValues) : onCreateMilestone(values);
  }, [initialValues, isEdit, onCreateMilestone, onUpdateMilestone]);
  return jsxs(Layout, {
    stack: true,
    gap: 24,
    stretch: true,
    children: [jsx(BackSection, {
      onClick: onBackClick
    }), jsx(Formik, {
      initialValues: initialValues,
      onSubmit: handleSubmit,
      validationSchema: projectMilestoneValidationSchema,
      enableReinitialize: true,
      children: jsxs(StyledForm$2, {
        children: [jsx(FormFields$2, {
          showRepeatSection: showRepeatSection
        }), jsx(Layout, {
          hAlign: "flex-end",
          children: jsx(Button, {
            type: "submit",
            dataCy: isEdit ? 'button--update-milestone' : 'button--add-milestone',
            children: isEdit ? 'Update milestone' : 'Add milestone'
          })
        })]
      })
    })]
  });
});
const StyledForm$1 = /*#__PURE__*/styled(Form).withConfig({
  displayName: "phase-form__StyledForm",
  componentId: "sc-9b7wqv-0"
})(["height:100%;display:flex;flex-direction:column;"]);
const FormFields$1 = props => {
  var _a;
  const {
    showRepeatSection
  } = props;
  const {
    values
  } = useFormikContext();
  return jsxs(Layout, {
    stack: true,
    gap: "--Spacing-200",
    flex: "1 1 auto",
    children: [jsxs(Layout, {
      gap: 24,
      children: [jsx(TextFieldFormikWrapper, {
        name: "name",
        label: "Phase name",
        placeholder: "E.g. Main Delivery",
        dataCy: "scheduler-booking-modern-menu-phase-end-date"
      }), jsx(ColorPickerDialogFormikWrapper, {
        name: "color",
        dataCy: "scheduler-booking-modern-menu-phase-hex-color"
      })]
    }), jsxs(Layout, {
      gap: 24,
      hAlign: "space-between",
      children: [jsx(DatePickerInputFormikWrapper, {
        name: "startDate",
        label: "Start date",
        dataCy: "scheduler-booking-modern-menu-phase-start-date"
      }), jsx(DatePickerInputFormikWrapper, {
        name: "endDate",
        label: "End date",
        dataCy: "scheduler-booking-modern-menu-phase-end-date"
      })]
    }), showRepeatSection ? jsxs(Fragment, {
      children: [jsx(SelectFormikWrapper, {
        disableClearable: true,
        options: simpleRepeatOptions,
        label: "Interval",
        optionLabel: "label",
        optionValue: "value",
        name: "interval",
        dataCy: "scheduler-booking-modern-menu-phase-interval"
      }), jsx(NumberInputFormikWrapper, {
        disabled: ((_a = values.interval) === null || _a === void 0 ? void 0 : _a.value) === SimpleRepeatEnum.NONE,
        name: "repeatTimes",
        label: "Number of repeat times",
        dataCy: "scheduler-booking-modern-menu-phase-repeat-times"
      })]
    }) : null]
  });
};
const PhaseForm = /*#__PURE__*/React__default.memo(props => {
  const {
    onBackClick
  } = props;
  const currentSelection = useSelector(selectSchedulerCurrentSelection);
  const selectedBooking = useSelector(selectSchedulerCurrentSelectedBooking);
  const {
    onCreatePhase,
    onUpdatePhase
  } = useContextMenuContext();
  const showRepeatSection = useMemo(() => {
    return Boolean(!(selectedBooking === null || selectedBooking === void 0 ? void 0 : selectedBooking._id)) || Boolean(selectedBooking && 'phase' in selectedBooking && selectedBooking.phase && !selectedBooking.repeat);
  }, [selectedBooking]);
  const isEdit = useMemo(() => {
    return selectedBooking && 'phase' in selectedBooking && selectedBooking.phase;
  }, [selectedBooking]);
  const initialValues = useMemo(() => {
    if (selectedBooking && 'phase' in selectedBooking && selectedBooking.phase) {
      return mapCurrentSelectionToProjectPhaseFormData(selectedBooking);
    }
    return mapCurrentSelectionToProjectPhaseFormData(currentSelection);
  }, [currentSelection, selectedBooking]);
  const onSubmit = useCallback(formValues => {
    if (isEdit) {
      onUpdatePhase(formValues, initialValues);
    } else {
      onCreatePhase(formValues);
    }
  }, [initialValues, isEdit, onCreatePhase, onUpdatePhase]);
  return jsxs(Layout, {
    stack: true,
    gap: 24,
    stretch: true,
    children: [jsx(BackSection, {
      onClick: onBackClick
    }), jsx(Formik, {
      initialValues: initialValues,
      onSubmit: onSubmit,
      enableReinitialize: true,
      validationSchema: projectPhaseValidationSchema,
      children: jsxs(StyledForm$1, {
        children: [jsx(FormFields$1, {
          showRepeatSection: showRepeatSection
        }), jsx(Layout, {
          hAlign: "flex-end",
          children: jsx(Button, {
            type: "submit",
            dataCy: isEdit ? 'button--update-phase' : 'button--submit-phase-dates',
            children: isEdit ? 'Update phase' : 'Add phase'
          })
        })]
      })
    })]
  });
});
const StyledForm = /*#__PURE__*/styled(Form).withConfig({
  displayName: "project-dates-form__StyledForm",
  componentId: "sc-8cmlka-0"
})(["height:100%;display:flex;flex-direction:column;"]);
const FormFields = () => {
  const {
    values
  } = useFormikContext();
  return jsx(Layout, {
    stack: true,
    gap: "--Spacing-200",
    flex: "1 1 auto",
    children: jsxs(Layout, {
      gap: 24,
      hAlign: "space-between",
      children: [jsx(DatePickerInputFormikWrapper, {
        name: "startDate",
        label: "Start date",
        dataCy: "scheduler-booking-modern-menu-phase-start-date",
        disabledDays: currentDate => {
          if (!values.endDate) {
            return false;
          }
          return isAfter(currentDate, values.endDate, 'day');
        }
      }), jsx(DatePickerInputFormikWrapper, {
        name: "endDate",
        label: "End date",
        dataCy: "scheduler-booking-modern-menu-phase-end-date",
        disabledDays: currentDate => {
          if (!values.startDate) {
            return false;
          }
          return isBefore(currentDate, values.startDate, 'day');
        }
      })]
    })
  });
};
const ProjectDatesForm = /*#__PURE__*/React__default.memo(props => {
  var _a, _b;
  const {
    onBackClick
  } = props;
  const currentSelection = useSelector(selectSchedulerCurrentSelection);
  const selectedBooking = useSelector(selectSchedulerCurrentSelectedBooking);
  const {
    onUpdateProjectDates
  } = useContextMenuContext();
  const projectSelector = useMemo(() => {
    var _a, _b;
    if (selectedBooking && 'datesEvent' in selectedBooking && selectedBooking.datesEvent) {
      return makeSelectProjectByIdFromMap(selectedBooking.projectId);
    }
    return makeSelectProjectByIdFromMap((_b = (_a = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.project) === null || _b === void 0 ? void 0 : _b._id);
  }, [(_b = (_a = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.project) === null || _b === void 0 ? void 0 : _b._id, selectedBooking]);
  const project = useSelector(projectSelector);
  const isEdit = useMemo(() => {
    if ((project === null || project === void 0 ? void 0 : project.start) && (project === null || project === void 0 ? void 0 : project.end)) {
      return true;
    }
    return selectedBooking && 'datesEvent' in selectedBooking && selectedBooking.datesEvent;
  }, [project === null || project === void 0 ? void 0 : project.end, project === null || project === void 0 ? void 0 : project.start, selectedBooking]);
  const initialValues = useMemo(() => {
    if ((project === null || project === void 0 ? void 0 : project.end) && (project === null || project === void 0 ? void 0 : project.start)) {
      return mapProjectBasicInfoToDatesFormData(project);
    }
    return mapCurrentSelectionToProjectDatesFormData(currentSelection);
  }, [currentSelection, project]);
  return jsxs(Layout, {
    stack: true,
    gap: 24,
    stretch: true,
    children: [jsx(BackSection, {
      onClick: onBackClick
    }), jsx(Formik, {
      initialValues: initialValues,
      onSubmit: onUpdateProjectDates,
      enableReinitialize: true,
      validationSchema: projectDatesValidationSchema,
      children: jsxs(StyledForm, {
        children: [jsx(FormFields, {}), jsx(Layout, {
          hAlign: "flex-end",
          children: jsx(Button, {
            type: "submit",
            dataCy: isEdit ? 'button--update-dates' : 'button--add-dates',
            children: isEdit ? 'Update dates' : 'Add dates'
          })
        })]
      })
    })]
  });
});
const SLIDE_NUMBERS$3 = {
  milestone: 0,
  phase: 1,
  dates: 2
};
const StyledSlides$1 = /*#__PURE__*/styled(Slides).withConfig({
  displayName: "edit-project-items__StyledSlides",
  componentId: "s1j7wj-0"
})(["width:367px;height:375px;"]);
const ModernEditProjectItems = /*#__PURE__*/React__default.memo(props => {
  const {
    position,
    anchorEl
  } = props;
  const {
    projectKeyWord
  } = useAppKeyWords();
  const {
    onClose,
    onEditProject,
    onDeleteProjectItem
  } = useContextMenuContext();
  const isPhase = useSelector(selectIsSelectedBookingPhase);
  const isMilestone = useSelector(selectIsSelectedBookingMilestone);
  const isDatesEvent = useSelector(selectIsSelectedBookingDatesEvent);
  const currentSelectedProject = useSelector(selectSchedulerSelectedBookingProject);
  const canEditProject = useCanEditProject({
    project: currentSelectedProject
  });
  const canCreateDeletePhase = useCanCreateDeletePhase({
    project: currentSelectedProject
  });
  const canCreateMilestone = useCanCreateDeleteMilestone({
    project: currentSelectedProject
  });
  const canCreateProjectDates = useCanCreateDeleteProjectDates({
    project: currentSelectedProject
  });
  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);
  const canCreateDeleteProjectDatesItem = canCreateProjectDates && isDatesEvent;
  const canCreateDeletePhaseItem = canCreateDeletePhase && isPhase;
  const canCreateDeleteMilestoneItem = canCreateMilestone && isMilestone;
  const title = undefined;
  const content = jsx(StyledSlides$1, {
    mainComponent: _ref348 => {
      let {
        toSlidesGroup
      } = _ref348;
      return jsx(Layout, {
        stack: true,
        stretch: true,
        children: jsx(List$1, {
          onItemClick: item => {
            item.onClick();
          },
          rowRenderer: item => {
            return jsx(ListItem, {
              startAdornment: item.icon,
              label: item.label,
              endAdornment: item.hasNextSlide ? 'navigateNext' : null
            });
          },
          items: [{
            hasNextSlide: true,
            hidden: !canCreateDeleteMilestoneItem,
            dataCy: 'scheduler-booking-modern-menu-edit-Update-milestone',
            onClick: () => {
              toSlidesGroup(SLIDE_NUMBERS$3.milestone);
            },
            label: 'Update milestone',
            icon: 'flag'
          }, {
            hasNextSlide: true,
            hidden: !canCreateDeletePhaseItem,
            dataCy: 'scheduler-booking-modern-menu-edit-Update-phase',
            onClick: () => {
              toSlidesGroup(SLIDE_NUMBERS$3.phase);
            },
            label: 'Update phase',
            icon: 'earthquake'
          }, {
            hasNextSlide: true,
            hidden: !canCreateDeleteProjectDatesItem,
            dataCy: 'scheduler-booking-modern-menu-edit-Update-start-end',
            onClick: () => {
              toSlidesGroup(SLIDE_NUMBERS$3.dates);
            },
            label: 'Start & end dates',
            icon: 'calendarMonth'
          }, {
            hasNextSlide: false,
            dataCy: 'scheduler-booking-modern-menu-delete-project',
            icon: 'delete',
            hidden: !canCreateDeleteProjectDatesItem && !canCreateDeletePhaseItem && !canCreateDeleteMilestoneItem,
            label: 'Delete',
            onClick: () => {
              onDeleteProjectItem();
            }
          }, {
            hasNextSlide: false,
            hidden: !canEditProject,
            dataCy: 'scheduler-booking-modern-menu-edit-project',
            onClick: () => {
              onEditProject();
            },
            label: "Edit ".concat(projectKeyWord),
            icon: 'edit'
          }]
        })
      });
    },
    items: _ref349 => {
      let {
        topSlide
      } = _ref349;
      return [[jsx(MilestoneForm, {
        onBackClick: topSlide
      })], [jsx(PhaseForm, {
        onBackClick: topSlide
      })], [jsx(ProjectDatesForm, {
        onBackClick: topSlide
      })]];
    }
  });
  const actions = undefined;
  return jsx(Dialog, {
    open: true,
    title: title,
    content: content,
    actions: actions,
    position: position,
    level: "default",
    hideBackdrop: true,
    onClose: handleClose,
    anchorElement: anchorEl
  });
});
const SLIDE_NUMBERS$2 = {
  milestone: 0,
  phase: 1,
  dates: 2
};
const StyledSlides = /*#__PURE__*/styled(Slides).withConfig({
  displayName: "project-parent-mode__StyledSlides",
  componentId: "sc-1961d6-0"
})(["width:367px;height:350px;"]);
const ModernProjectParentMode = /*#__PURE__*/React__default.memo(props => {
  var _a;
  const {
    position,
    anchorEl
  } = props;
  const {
    projectKeyWord
  } = useAppKeyWords();
  const {
    onClose,
    onEditProject,
    scheduleRequestProject
  } = useContextMenuContext();
  const currentSelection = useSelector(selectSchedulerCurrentSelection);
  const currentSelectedProject = (_a = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.project;
  const canEditProject = useCanEditProject({
    project: currentSelectedProject
  });
  const canCreatePhase = useCanCreateDeletePhase({
    project: currentSelectedProject
  });
  const canCreateMilestone = useCanCreateDeleteMilestone({
    project: currentSelectedProject
  });
  const canCreateProjectDates = useCanCreateDeleteProjectDates({
    project: currentSelectedProject
  });
  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);
  const title = undefined;
  const content = jsx(StyledSlides, {
    mainComponent: _ref350 => {
      let {
        toSlidesGroup
      } = _ref350;
      return jsx(Layout, {
        stack: true,
        stretch: true,
        children: jsx(List$1, {
          onItemClick: item => {
            item.onClick();
          },
          rowRenderer: item => {
            return jsx(ListItem, {
              startAdornment: item.icon,
              label: item.label,
              endAdornment: "navigateNext"
            });
          },
          items: [{
            hidden: !canCreateMilestone,
            dataCy: 'scheduler-booking-modern-menu-edit-create-milestone',
            onClick: () => {
              toSlidesGroup(SLIDE_NUMBERS$2.milestone);
            },
            label: 'Create milestone',
            icon: 'flag'
          }, {
            hidden: !canCreatePhase,
            dataCy: 'scheduler-booking-modern-menu-edit-create-phase',
            onClick: () => {
              toSlidesGroup(SLIDE_NUMBERS$2.phase);
            },
            label: 'Create phase',
            icon: 'earthquake'
          }, {
            hidden: !canCreateProjectDates,
            dataCy: 'scheduler-booking-modern-menu-edit-create-start-end',
            onClick: () => {
              toSlidesGroup(SLIDE_NUMBERS$2.dates);
            },
            label: 'Start & end dates',
            icon: 'calendarMonth'
          }, {
            hidden: !(scheduleRequestProject && canEditProject),
            dataCy: 'scheduler-booking-modern-menu-edit-project',
            onClick: () => {
              onEditProject();
            },
            label: "Edit ".concat(projectKeyWord),
            icon: 'edit'
          }]
        })
      });
    },
    items: _ref351 => {
      let {
        topSlide
      } = _ref351;
      return [[jsx(MilestoneForm, {
        onBackClick: topSlide
      })], [jsx(PhaseForm, {
        onBackClick: topSlide
      })], [jsx(ProjectDatesForm, {
        onBackClick: topSlide
      })]];
    }
  });
  const actions = undefined;
  return jsx(Dialog, {
    open: true,
    title: title,
    content: content,
    actions: actions,
    position: position,
    level: "default",
    hideBackdrop: true,
    onClose: handleClose,
    anchorElement: anchorEl
  });
});
const SLIDE_NUMBERS$1 = {
  milestone: 0,
  phase: 1,
  dates: 2
};
const MoreProjectActions = /*#__PURE__*/React__default.memo(props => {
  var _a;
  const {
    onBackClick
  } = props;
  const {
    projectKeyWord
  } = useAppKeyWords();
  const {
    onEditProject,
    scheduleRequestProject
  } = useContextMenuContext();
  const currentSelection = useSelector(selectSchedulerCurrentSelection);
  const currentSelectedProject = (_a = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.project;
  const canEditProject = useCanEditProject({
    project: currentSelectedProject
  });
  const canCreatePhase = useCanCreateDeletePhase({
    project: currentSelectedProject
  });
  const canCreateMilestone = useCanCreateDeleteMilestone({
    project: currentSelectedProject
  });
  const canCreateProjectDates = useCanCreateDeleteProjectDates({
    project: currentSelectedProject
  });
  return jsx(Slides, {
    mainComponent: _ref352 => {
      let {
        toSlidesGroup
      } = _ref352;
      return jsxs(Layout, {
        stack: true,
        gap: 24,
        children: [jsx(BackSection, {
          onClick: onBackClick
        }), jsx(List$1, {
          onItemClick: item => {
            item.onClick();
          },
          rowRenderer: item => {
            return jsx(ListItem, {
              startAdornment: item.icon,
              label: item.label
            });
          },
          items: [{
            hidden: !canCreateMilestone,
            icon: 'flag',
            label: 'Create Milestone',
            dataCy: 'scheduler-booking-modern-menu-edit-create-milestone',
            onClick: () => toSlidesGroup(SLIDE_NUMBERS$1.milestone)
          }, {
            hidden: !canCreatePhase,
            icon: 'earthquake',
            label: 'Create Phase',
            dataCy: 'scheduler-booking-modern-menu-edit-create-phase',
            onClick: () => toSlidesGroup(SLIDE_NUMBERS$1.phase)
          }, {
            hidden: !canCreateProjectDates,
            icon: 'calendarMonth',
            label: 'Start & end dates',
            dataCy: 'scheduler-booking-modern-menu-edit-start-end-dates',
            onClick: () => toSlidesGroup(SLIDE_NUMBERS$1.dates)
          }, {
            hidden: !(scheduleRequestProject && canEditProject),
            icon: 'edit',
            label: "Edit ".concat(projectKeyWord),
            dataCy: 'scheduler-booking-modern-menu-edit-project',
            onClick: () => onEditProject()
          }]
        })]
      });
    },
    items: _ref353 => {
      let {
        topSlide
      } = _ref353;
      return [[jsx(MilestoneForm, {
        onBackClick: topSlide
      })], [jsx(PhaseForm, {
        onBackClick: topSlide
      })], [jsx(ProjectDatesForm, {
        onBackClick: topSlide
      })]];
    }
  });
});
const SLIDE_NUMBERS = {
  more: 0,
  resources: 1,
  projects: 2,
  categories: 3,
  moreProjectActions: 5,
  repeat: 4
};
const ModernSingleMode = /*#__PURE__*/React__default.memo(props => {
  var _a, _b, _c, _d;
  const {
    position,
    anchorEl
  } = props;
  const {
    projectKeyWord,
    resourceKeyWord,
    vacationEventName
  } = useAppKeyWords();
  const formikContext = useFormikContext();
  const {
    setFieldValue,
    values
  } = formikContext;
  const {
    displayRequestBtn,
    displayScheduleBtn,
    setNewResource,
    newResource,
    newProject,
    setNewProject,
    newCategory,
    setNewCategory,
    canSchedule,
    canRequest,
    markAsUnavailable,
    onPasteBooking,
    requestVacation,
    showRequestVacationBtn,
    showMoreBtn,
    onEditResource,
    onEditProject,
    onClose,
    scheduleRequestProject,
    showMoreProjectActionsBtn,
    showMarkAsUnavailableBtn,
    onSubmitSchedule,
    onSubmitRequest,
    requestToolBarContext
  } = useContextMenuContext();
  const isResourceRequestExtensionInstalled = useSelector(selectIsResourceRequestExtensionInstalled);
  const currentSelection = useSelector(selectSchedulerCurrentSelection);
  const currentSelectedResource = (_a = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.resource;
  const currentSelectedProject = (_b = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _b === void 0 ? void 0 : _b.project;
  const canEditResourceWorkHours = useCanEditResourceWorkHours({
    resource: currentSelectedResource
  });
  const canEditResource = useCanEditResource({
    resource: currentSelectedResource
  });
  const canEditProject = useCanEditProject({
    project: currentSelectedProject
  });
  const canPasteBooking = useCanPasteBooking();
  const canRequestVacationForSelection = useCanRequestVacationForSelection();
  const title = undefined;
  const keyboardActions = useMemo(() => {
    return {
      Enter: () => {
        if (!displayScheduleBtn || !canSchedule) {
          return;
        }
        onSubmitSchedule();
      }
    };
  }, [canSchedule, displayScheduleBtn, onSubmitSchedule]);
  useKeyDown(keyboardActions);
  const contentHeader = useMemo(() => {
    var _a, _b;
    if (scheduleRequestProject) {
      return (currentSelectedProject === null || currentSelectedProject === void 0 ? void 0 : currentSelectedProject.name) || ((_a = values.project) === null || _a === void 0 ? void 0 : _a.name);
    }
    return (currentSelectedResource === null || currentSelectedResource === void 0 ? void 0 : currentSelectedResource.name) || ((_b = values.resource) === null || _b === void 0 ? void 0 : _b.name);
  }, [currentSelectedProject === null || currentSelectedProject === void 0 ? void 0 : currentSelectedProject.name, currentSelectedResource === null || currentSelectedResource === void 0 ? void 0 : currentSelectedResource.name, scheduleRequestProject, (_c = values.project) === null || _c === void 0 ? void 0 : _c.name, (_d = values.resource) === null || _d === void 0 ? void 0 : _d.name]);
  if (requestToolBarContext && !isResourceRequestExtensionInstalled) {
    return jsx(RequestMenu, {
      anchorEl: anchorEl,
      position: position
    });
  }
  const content = jsx(ModernMenuStyledSlides, {
    mainComponent: _ref354 => {
      let {
        toSlidesGroup
      } = _ref354;
      return jsxs(Layout, {
        stack: true,
        stretch: true,
        children: [contentHeader ? jsxs(Fragment, {
          children: [jsx(Typography, {
            variant: "title",
            size: "large",
            noWrap: true,
            children: contentHeader
          }), jsx(Layout, {
            pt: "--Spacing-100",
            pb: "--Spacing-100",
            children: jsx(Divider, {})
          })]
        }) : null, jsxs(Layout, {
          stack: true,
          gap: 24,
          stretch: true,
          flex: "1 1 auto",
          children: [jsxs(Layout, {
            hAlign: "space-between",
            children: [jsxs(Layout, {
              gap: "--Spacing-100",
              children: [jsx(Button, {
                variant: "text",
                startIcon: "contentCopy",
                dataCy: "button--paste-booking",
                disabled: !canPasteBooking,
                onClick: onPasteBooking,
                children: "Paste"
              }), showRequestVacationBtn ? jsxs(Button, {
                variant: "text",
                startIcon: "umbrella",
                dataCy: "button--request-vacation",
                disabled: !canRequestVacationForSelection,
                onClick: requestVacation,
                children: ["Request ", vacationEventName]
              }) : null, scheduleRequestProject ? jsxs(Button, {
                variant: "text",
                startIcon: "edit",
                dataCy: "button--edit-project",
                disabled: !canEditProject,
                onClick: onEditProject,
                children: ["Edit ", projectKeyWord]
              }) : null]
            }), jsxs(Layout, {
              gap: "--Spacing-100",
              children: [showMoreBtn ? jsx(Button, {
                dataCy: "button--more-next-slide",
                variant: "text",
                startIcon: "moreVert",
                onClick: () => {
                  toSlidesGroup(SLIDE_NUMBERS.more);
                },
                children: "More"
              }) : null, showMoreProjectActionsBtn ? jsx(Button, {
                dataCy: "button--more-next-slide",
                variant: "text",
                startIcon: "moreVert",
                onClick: () => {
                  toSlidesGroup(SLIDE_NUMBERS.moreProjectActions);
                },
                children: "More"
              }) : null]
            })]
          }), jsx(BookingFormModernMenu, {
            to: toSlidesGroup
          })]
        }), jsxs(Layout, {
          pt: 24,
          gap: "--Spacing-100",
          hAlign: "flex-end",
          children: [displayRequestBtn ? jsx(Button, {
            onClick: onSubmitRequest,
            dataCy: "button--mod-menu-Request",
            variant: "outlined",
            disabled: !canRequest,
            children: "Request"
          }) : null, displayScheduleBtn ? jsx(Button, {
            onClick: onSubmitSchedule,
            dataCy: "button--mod-menu-Schedule",
            disabled: !canSchedule,
            type: "submit",
            children: "Schedule"
          }) : null]
        })]
      });
    },
    items: _ref355 => {
      let {
        prevSlide,
        topSlide,
        nextSlide
      } = _ref355;
      return [[jsxs(Layout, {
        stack: true,
        gap: 24,
        children: [jsx(BackSection, {
          onClick: topSlide
        }), jsx(List$1, {
          onItemClick: item => {
            item.onClick();
          },
          rowRenderer: item => {
            return jsx(ListItem, {
              startAdornment: item.icon,
              label: item.label
            });
          },
          items: [{
            onClick: () => {
              onClose();
              markAsUnavailable();
            },
            hidden: !(showMarkAsUnavailableBtn && canEditResourceWorkHours),
            icon: 'calendarClock',
            label: 'Mark as unavailable',
            dataCy: 'scheduler-booking-modern-mark-as-unavailable'
          }, {
            onClick: () => {
              onClose();
              onEditResource();
            },
            hidden: !canEditResource,
            icon: 'personOutline',
            label: "Edit ".concat(isResource(currentSelectedResource) ? resourceKeyWord : 'unassigned'),
            dataCy: 'scheduler-booking-modern-edit-resource'
          }]
        })]
      })], [jsx(ResourceListSlide, {
        onBackClick: () => topSlide(),
        onAddNew: newResource => {
          setNewResource(newResource);
          nextSlide();
        }
      }), jsx(ResourceUnassignedShortForm, {
        onBackClick: () => prevSlide(),
        onCreate: resource => {
          setFieldValue('resource', resource).then(() => {
            topSlide();
            setNewResource({
              name: '',
              type: ResourceTypeEnum.REGULAR
            });
          });
        },
        newResource: newResource
      })], [jsx(ProjectListSlide, {
        onBackClick: () => topSlide(),
        onAddNew: newProject => {
          setNewProject(newProject);
          nextSlide();
        }
      }), jsx(ProjectEventShortForm, {
        onBackClick: () => prevSlide(),
        newProject: newProject,
        onCreate: project => {
          setFieldValue('project', project).then(() => {
            topSlide();
            setNewProject({
              name: '',
              type: ProjectTypeEnum.REGULAR
            });
          });
        }
      })], [jsx(CategoryListSlide, {
        onBackClick: () => topSlide(),
        onAddNew: newCategory => {
          setNewCategory(newCategory);
          nextSlide();
        }
      }), jsx(CategoryShortForm, {
        newCategory: newCategory,
        onBackClick: () => prevSlide(),
        onCreate: category => {
          setFieldValue('category', category).then(() => {
            topSlide();
            setNewCategory({
              name: ''
            });
          });
        }
      })], [jsx(BookingRepeat, {
        onBackClick: topSlide
      })], [jsx(MoreProjectActions, {
        onBackClick: topSlide
      })]];
    }
  });
  const actions = undefined;
  return jsx(Dialog, {
    open: true,
    title: title,
    content: content,
    actions: actions,
    onClose: onClose,
    position: position,
    anchorElement: anchorEl,
    level: "default",
    hideBackdrop: true
  });
});
const RequestMenu = /*#__PURE__*/React__default.memo(props => {
  var _a;
  const {
    position,
    anchorEl
  } = props;
  const {
    resourceKeyWord,
    vacationEventName
  } = useAppKeyWords();
  const {
    onClose,
    onPasteBooking,
    showRequestVacationBtn,
    requestVacation,
    showMarkAsUnavailableBtn,
    markAsUnavailable,
    onEditResource
  } = useContextMenuContext();
  const currentSelection = useSelector(selectSchedulerCurrentSelection);
  const currentSelectedResource = (_a = currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.rowTags) === null || _a === void 0 ? void 0 : _a.resource;
  const canEditResourceWorkHours = useCanEditResourceWorkHours({
    resource: currentSelectedResource
  });
  const canEditResource = useCanEditResource({
    resource: currentSelectedResource
  });
  const canPasteBooking = useCanPasteBooking();
  const title = undefined;
  const content = jsx(Layout, {
    stack: true,
    stretch: true,
    children: jsx(List$1, {
      onItemClick: item => {
        item.onClick();
      },
      rowRenderer: item => {
        return jsx(ListItem, {
          startAdornment: item.icon,
          label: item.label
        });
      },
      items: [{
        disabled: !canPasteBooking,
        dataCy: 'button--paste-booking',
        onClick: () => {
          onPasteBooking();
        },
        label: "Paste",
        icon: 'umbrella'
      }, {
        hidden: !showRequestVacationBtn,
        dataCy: 'button--request-vacation',
        onClick: () => {
          requestVacation();
        },
        label: "Request ".concat(vacationEventName),
        icon: 'flag'
      }, {
        hidden: !(showMarkAsUnavailableBtn && canEditResourceWorkHours),
        dataCy: 'scheduler-booking-modern-mark-as-unavailable',
        onClick: () => {
          onClose();
          markAsUnavailable();
        },
        label: 'Mark as unavailable',
        icon: 'calendarClock'
      }, {
        hidden: !canEditResource,
        dataCy: 'scheduler-booking-modern-edit-resource',
        onClick: () => {
          onClose();
          onEditResource();
        },
        label: "Edit ".concat(isResource(currentSelectedResource) ? resourceKeyWord : 'unassigned'),
        icon: 'personOutline'
      }]
    })
  });
  const actions = undefined;
  return jsx(Dialog, {
    open: true,
    title: title,
    content: content,
    actions: actions,
    onClose: onClose,
    position: position,
    anchorElement: anchorEl,
    level: "default",
    hideBackdrop: true
  });
});
const SchedulerSingleModeContextMenu = props => {
  const {
    isOpen,
    anchorEl,
    position,
    requestToolBarContext,
    scheduleToolBarContext,
    viewObject,
    viewData,
    onClose,
    onRequestVacation,
    onPasteBooking,
    onCreatePhase,
    onCreateMilestone,
    onUpdateProjectDates,
    onCopyBooking,
    onDuplicateBooking,
    onEditBookingTitle,
    showBookingModal,
    onBulkMove,
    onSplitBooking,
    onDeleteBooking,
    onCutBooking,
    onSchedule,
    onRequest,
    onUpdateBooking,
    onAssignToAll,
    onCreateProject
  } = props;
  const modern = useSelector(selectIsGridModernMenuUsed);
  if (!isOpen) {
    return null;
  }
  return jsx(ContextMenuContextProvider, {
    viewData: viewData,
    viewObject: viewObject,
    onRequestVacation: onRequestVacation,
    onPasteBooking: onPasteBooking,
    onClose: onClose,
    onCreatePhase: onCreatePhase,
    onCreateMilestone: onCreateMilestone,
    onUpdateProjectDates: onUpdateProjectDates,
    onDuplicateBooking: onDuplicateBooking,
    onCopyBooking: onCopyBooking,
    onDeleteBooking: onDeleteBooking,
    onCutBooking: onCutBooking,
    onEditBookingTitle: onEditBookingTitle,
    showBookingModal: showBookingModal,
    onBulkMove: onBulkMove,
    onSplitBooking: onSplitBooking,
    onSchedule: onSchedule,
    onRequest: onRequest,
    onUpdateBooking: onUpdateBooking,
    onAssignToAll: onAssignToAll,
    scheduleToolBarContext: scheduleToolBarContext,
    requestToolBarContext: requestToolBarContext,
    onCreateProject: onCreateProject,
    children: modern ? jsx(ModernSingleMode, {
      position: position,
      anchorEl: anchorEl
    }) : jsx(ClassicSingleMode, {
      position: position,
      anchorEl: anchorEl
    })
  });
};
const SchedulerEditBookingMenu = props => {
  const {
    position,
    isOpen,
    anchorEl,
    viewObject,
    viewData,
    onClose,
    onRequestVacation,
    onPasteBooking,
    onCreatePhase,
    onCreateMilestone,
    onUpdateProjectDates,
    onCopyBooking,
    onDuplicateBooking,
    onEditBookingTitle,
    showBookingModal,
    onBulkMove,
    onSplitBooking,
    onDeleteBooking,
    onCutBooking,
    onUpdateBooking,
    onAssignToAll,
    onCreateProject
  } = props;
  const modern = useSelector(selectIsGridModernMenuUsed);
  if (!isOpen) {
    return null;
  }
  return jsx(ContextMenuContextProvider, {
    viewObject: viewObject,
    viewData: viewData,
    onRequestVacation: onRequestVacation,
    onPasteBooking: onPasteBooking,
    onClose: onClose,
    onCreatePhase: onCreatePhase,
    onCreateMilestone: onCreateMilestone,
    onUpdateProjectDates: onUpdateProjectDates,
    onDuplicateBooking: onDuplicateBooking,
    onCopyBooking: onCopyBooking,
    onEditBookingTitle: onEditBookingTitle,
    showBookingModal: showBookingModal,
    onBulkMove: onBulkMove,
    onSplitBooking: onSplitBooking,
    onDeleteBooking: onDeleteBooking,
    onCutBooking: onCutBooking,
    onUpdateBooking: onUpdateBooking,
    onAssignToAll: onAssignToAll,
    onCreateProject: onCreateProject,
    children: modern ? jsx(EditBookingModernMenu, {
      position: position,
      anchorEl: anchorEl
    }) : jsx(EditBookingClassicMenu, {
      position: position,
      anchorEl: anchorEl
    })
  });
};
const SchedulerProjectParentMode = /*#__PURE__*/React__default.memo(props => {
  const {
    position,
    viewObject,
    viewData,
    onClose,
    onCreatePhase,
    onCreateMilestone,
    onUpdateProjectDates,
    isOpen,
    anchorEl,
    onCreateProject
  } = props;
  const modern = useSelector(selectIsGridModernMenuUsed);
  if (!isOpen) {
    return null;
  }
  return jsx(ContextMenuContextProvider, {
    viewData: viewData,
    viewObject: viewObject,
    onClose: onClose,
    onCreatePhase: onCreatePhase,
    onCreateMilestone: onCreateMilestone,
    onUpdateProjectDates: onUpdateProjectDates,
    onCreateProject: onCreateProject,
    children: modern ? jsx(ModernProjectParentMode, {
      position: position,
      anchorEl: anchorEl
    }) : jsx(ClassicProjectParentMode, {
      position: position,
      anchorEl: anchorEl
    })
  });
});
const SchedulerChildParentMode = /*#__PURE__*/React__default.memo(props => {
  const {
    isOpen,
    position,
    anchorEl,
    viewObject,
    viewData,
    onClose,
    onPasteBooking,
    onSchedule,
    onRequest,
    onRequestVacation,
    onCreateProject
  } = props;
  const modern = useSelector(selectIsGridModernMenuUsed);
  if (!isOpen) {
    return null;
  }
  return jsx(ContextMenuContextProvider, {
    onPasteBooking: onPasteBooking,
    viewData: viewData,
    viewObject: viewObject,
    onClose: onClose,
    onSchedule: onSchedule,
    onRequest: onRequest,
    onRequestVacation: onRequestVacation,
    onCreateProject: onCreateProject,
    children: modern ? jsx(ModernChildParentMode, {
      position: position,
      anchorEl: anchorEl
    }) : jsx(ClassicChildParentMode, {
      position: position,
      anchorEl: anchorEl
    })
  });
});
const SchedulerEditProjectItems = /*#__PURE__*/React__default.memo(props => {
  const {
    isOpen,
    position,
    anchorEl,
    viewObject,
    viewData,
    onClose,
    onUpdatePhase,
    onUpdateMilestone,
    onUpdateProjectDates,
    onDeleteProjectItem,
    onCreateProject
  } = props;
  const modern = useSelector(selectIsGridModernMenuUsed);
  if (!isOpen) {
    return null;
  }
  return jsx(ContextMenuContextProvider, {
    viewData: viewData,
    viewObject: viewObject,
    onClose: onClose,
    onUpdatePhase: onUpdatePhase,
    onUpdateMilestone: onUpdateMilestone,
    onUpdateProjectDates: onUpdateProjectDates,
    onDeleteProjectItem: onDeleteProjectItem,
    onCreateProject: onCreateProject,
    children: jsx("div", {
      children: modern ? jsx(ModernEditProjectItems, {
        position: position,
        anchorEl: anchorEl
      }) : jsx(ClassicEditProjectItems, {
        position: position,
        anchorEl: anchorEl
      })
    })
  });
});
const EditDeadline = props => {
  const {
    isOpen,
    position,
    anchorEl,
    onClose
  } = props;
  if (!isOpen) {
    return null;
  }
  return jsx(ContextMenuContextProvider, {
    onClose: onClose,
    children: jsx(EditDeadlineContextMenu, {
      position: position,
      anchorEl: anchorEl
    })
  });
};
var AvailabilityDisplayEnum;
(function (AvailabilityDisplayEnum) {
  AvailabilityDisplayEnum["TYPE_NOTIFICATION"] = "TYPE_NOTIFICATION";
  AvailabilityDisplayEnum["TYPE_AVAILABILITY"] = "TYPE_AVAILABILITY";
  AvailabilityDisplayEnum["TYPE_OFF"] = "TYPE_OFF";
  AvailabilityDisplayEnum["TYPE_PERCENTAGE"] = "TYPE_PERCENTAGE";
})(AvailabilityDisplayEnum || (AvailabilityDisplayEnum = {}));
const AvailabilityStatus = /*#__PURE__*/React__default.memo(props => {
  const {
    displayValue,
    onChange,
    hoverValue
  } = props;
  const options = useMemo(() => {
    return [{
      value: AvailabilityDisplayEnum.TYPE_NOTIFICATION,
      label: 'Display an availability color bar',
      dataCy: 'my-pref-radio-bar',
      additionalContent: jsx(Layout, {
        pl: 32,
        children: jsx(Switch, {
          checked: hoverValue,
          name: "availabilityHover",
          label: "Display availability on cell hover",
          labelPosition: "right",
          onChange: () => {
            onChange({
              availabilityHover: !hoverValue
            });
          },
          dataCy: "btn-switch-availabilityHover"
        })
      })
    }, {
      value: AvailabilityDisplayEnum.TYPE_AVAILABILITY,
      label: 'Always on - availability color bar',
      dataCy: 'my-pref-radio-numbers'
    }, {
      value: AvailabilityDisplayEnum.TYPE_OFF,
      label: 'Don’t show availability over a booking',
      dataCy: 'my-pref-radio-disable'
    }];
  }, [hoverValue, onChange]);
  return jsx(RadioGroup, {
    stack: true,
    rowHeight: 36,
    name: "availabilityDisplay",
    value: displayValue,
    options: options,
    optionLabel: "label",
    optionValue: "value",
    onChange: value => {
      onChange({
        availabilityDisplay: value
      });
    }
  });
});
var EventHeightMode;
(function (EventHeightMode) {
  EventHeightMode["XS"] = "XS";
  EventHeightMode["S"] = "S";
  EventHeightMode["M"] = "M";
  EventHeightMode["L"] = "L";
  EventHeightMode["XL"] = "XL";
})(EventHeightMode || (EventHeightMode = {}));
const XS = {
  eventHeight: 10,
  eventHeightMode: EventHeightMode.XS
};
const S = {
  eventHeight: 20,
  eventHeightMode: EventHeightMode.S
};
const M = {
  eventHeight: 32,
  eventHeightMode: EventHeightMode.M
};
const L = {
  eventHeight: 60,
  eventHeightMode: EventHeightMode.L
};
const XL = {
  eventHeight: 100,
  eventHeightMode: EventHeightMode.XL
};
const eventHeights = {
  XS,
  S,
  M,
  L,
  XL
};
const sizeOptions = [{
  value: EventHeightMode.XS,
  label: 'Mini',
  dataCy: 'my-pref-eventHeightMode-xs'
}, {
  value: EventHeightMode.S,
  label: 'Small',
  dataCy: 'my-pref-eventHeightMode-s'
}, {
  value: EventHeightMode.M,
  label: 'Regular',
  dataCy: 'my-pref-eventHeightMode-m'
}, {
  value: EventHeightMode.L,
  label: 'Wide (Recommended)',
  dataCy: 'my-pref-eventHeightMode-l'
}, {
  value: EventHeightMode.XL,
  label: 'Extra wide',
  dataCy: 'my-pref-eventHeightMode-xl'
}];
const BookingBarHeight = /*#__PURE__*/React__default.memo(props => {
  const {
    onChange,
    value
  } = props;
  return jsx(RadioGroup, {
    stack: true,
    rowHeight: 36,
    name: "eventHeightMode",
    value: value,
    options: sizeOptions,
    optionLabel: "label",
    optionValue: "value",
    onChange: value => {
      onChange(eventHeights[value]);
    }
  });
});
const options$3 = [{
  label: 'Disabled',
  value: 'DISABLED',
  dataCy: 'my-pref-booking-tooltip-delay-disabled'
}, {
  label: 'Instant',
  value: 'INSTANT',
  dataCy: 'my-pref-booking-tooltip-delay-instant'
}, {
  label: '0.5 seconds (default)',
  value: '500',
  dataCy: 'my-pref-booking-tooltip-delay-500'
}, {
  label: '1 second',
  value: '1000',
  dataCy: 'my-pref-booking-tooltip-delay-1000'
}, {
  label: '1.5 seconds',
  value: '1500',
  dataCy: 'my-pref-booking-tooltip-delay-1500'
}, {
  label: '2 seconds',
  value: '2000',
  dataCy: 'my-pref-booking-tooltip-delay-2000'
}, {
  label: '2.5 seconds',
  value: '2500',
  dataCy: 'my-pref-booking-tooltip-delay-2500'
}, {
  label: '5 seconds',
  value: '5000',
  dataCy: 'my-pref-booking-tooltip-delay-5000'
}];
const BookingTooltipDelay = /*#__PURE__*/React__default.memo(props => {
  const {
    value,
    onChange
  } = props;
  return jsx(RadioGroup, {
    stack: true,
    rowHeight: 36,
    name: "bookingTooltipDelay",
    value: value,
    options: options$3,
    optionLabel: "label",
    optionValue: "value",
    onChange: newValue => {
      onChange({
        bookingToolTipHoverDelay: newValue
      });
    }
  });
});
const SliderLabelLayout = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "common__SliderLabelLayout",
  componentId: "idnezi-0"
})(["padding-top:34px;"]);
const marks$1 = [{
  value: 250
}];
const Row$3 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "column-width__Row",
  componentId: "sc-15kjdd2-0"
})(["min-height:32px;"]);
const ColumnWidth = /*#__PURE__*/React__default.memo(props => {
  const {
    value,
    onChange
  } = props;
  return jsxs(Layout, {
    stack: true,
    stretch: true,
    gap: "--Spacing-200",
    children: [jsxs(Row$3, {
      stretch: true,
      hAlign: "space-between",
      vAlign: "center",
      children: [jsx(SliderLabelLayout, {
        flex: "0 0 100px",
        children: jsx(Typography, {
          children: "Hours Scale"
        })
      }), jsx(Slider, {
        sliderThumbBackgroundColor: "surface-container-high",
        size: "small",
        valueLabelDisplay: "on",
        marks: marks$1,
        min: 10,
        max: 250,
        value: value.CellDuration,
        onChangeCommitted: (_, val) => {
          onChange({
            cellWidth: Object.assign(Object.assign({}, value), {
              CellDuration: val
            })
          });
        }
      })]
    }), jsxs(Row$3, {
      stretch: true,
      hAlign: "space-between",
      vAlign: "center",
      children: [jsx(SliderLabelLayout, {
        flex: "0 0 100px",
        children: jsx(Typography, {
          children: "Day Scale"
        })
      }), jsx(Slider, {
        sliderThumbBackgroundColor: "surface-container-high",
        size: "small",
        valueLabelDisplay: "on",
        marks: marks$1,
        min: 10,
        max: 250,
        value: value.Day,
        onChangeCommitted: (_, val) => {
          onChange({
            cellWidth: Object.assign(Object.assign({}, value), {
              Day: val
            })
          });
        }
      })]
    }), jsxs(Row$3, {
      stretch: true,
      hAlign: "space-between",
      vAlign: "center",
      children: [jsx(SliderLabelLayout, {
        flex: "0 0 100px",
        children: jsx(Typography, {
          children: "Weeks Scale"
        })
      }), jsx(Slider, {
        sliderThumbBackgroundColor: "surface-container-high",
        size: "small",
        valueLabelDisplay: "on",
        marks: marks$1,
        min: 10,
        max: 250,
        value: value.Week,
        onChangeCommitted: (_, val) => {
          onChange({
            cellWidth: Object.assign(Object.assign({}, value), {
              Week: val
            })
          });
        }
      })]
    }), jsxs(Row$3, {
      stretch: true,
      hAlign: "space-between",
      vAlign: "center",
      children: [jsx(SliderLabelLayout, {
        flex: "0 0 100px",
        children: jsx(Typography, {
          children: "Month Scale"
        })
      }), jsx(Slider, {
        sliderThumbBackgroundColor: "surface-container-high",
        size: "small",
        valueLabelDisplay: "on",
        marks: marks$1,
        min: 10,
        max: 250,
        value: value.Month,
        onChangeCommitted: (_, val) => {
          onChange({
            cellWidth: Object.assign(Object.assign({}, value), {
              Month: val
            })
          });
        }
      })]
    })]
  });
});
var DeadlineLinkStylesEnum;
(function (DeadlineLinkStylesEnum) {
  DeadlineLinkStylesEnum["LINE"] = "solid";
  DeadlineLinkStylesEnum["DOTTED"] = "dotted";
  DeadlineLinkStylesEnum["DASHED"] = "dashed";
})(DeadlineLinkStylesEnum || (DeadlineLinkStylesEnum = {}));
const defaultDeadlineLinkStyle = DeadlineLinkStylesEnum.LINE;
var DeadlineLinkPositionEnum;
(function (DeadlineLinkPositionEnum) {
  DeadlineLinkPositionEnum["ABOVE_BOOKINGS"] = "Above";
  DeadlineLinkPositionEnum["BELOW_BOOKINGS"] = "Below";
})(DeadlineLinkPositionEnum || (DeadlineLinkPositionEnum = {}));
const defaultDeadlineLinkPosition = DeadlineLinkPositionEnum.ABOVE_BOOKINGS;
const defaultDeadlineLineColor = '#000';
const defaultDeadlineLinkWidth = 2;
const defaultDeadlineColor = '#000';
var DeadlineDisplayEnum;
(function (DeadlineDisplayEnum) {
  DeadlineDisplayEnum["SHOW"] = "show";
  DeadlineDisplayEnum["HIDE"] = "hide";
  DeadlineDisplayEnum["SHOW_FOR_SELECTED_BOOKING"] = "showForSelected";
})(DeadlineDisplayEnum || (DeadlineDisplayEnum = {}));
const defaultDeadlineDisplay = DeadlineDisplayEnum.SHOW;
var DeadlineTooltipDisplayEnum;
(function (DeadlineTooltipDisplayEnum) {
  DeadlineTooltipDisplayEnum["HIDE"] = "hide";
  DeadlineTooltipDisplayEnum["SHOW_DEADLINE_DATE"] = "showDeadLineDate";
  DeadlineTooltipDisplayEnum["SHOW_DEADLINE_NAME"] = "showDeadlineName";
})(DeadlineTooltipDisplayEnum || (DeadlineTooltipDisplayEnum = {}));
const defaultDeadlineTooltipDisplay = DeadlineTooltipDisplayEnum.SHOW_DEADLINE_NAME;
var _path$1;
var _excluded$1 = ["title", "titleId"];
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1.apply(null, arguments);
}
function _objectWithoutProperties$1(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgArrow = function SvgArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1(_ref, _excluded$1);
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 9,
    viewBox: "0 0 40 9",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2356 4.857C39.4328 4.65984 39.4328 4.34017 39.2356 4.143L36.0226 0.930008C35.8254 0.732843 35.5058 0.732843 35.3086 0.930008C35.1114 1.12717 35.1114 1.44684 35.3086 1.64401L38.1646 4.5L35.3086 7.356C35.1114 7.55316 35.1114 7.87283 35.3086 8.07C35.5058 8.26716 35.8254 8.26716 36.0226 8.07L39.2356 4.857ZM0.0195312 5.00487L38.8786 5.00488L38.8786 3.99513L0.0195313 3.99513L0.0195312 5.00487Z",
    fill: "#EA3323"
  })));
};
var ForwardRef$1 = /*#__PURE__*/forwardRef(SvgArrow);
const styleOptions$1 = [{
  value: DeadlineLinkStylesEnum.LINE,
  label: 'Line',
  dataCy: 'my-pref-deadline-link-style-line'
}, {
  value: DeadlineLinkStylesEnum.DASHED,
  label: 'Dashed',
  dataCy: 'my-pref-deadline-link-style-dashed'
}, {
  value: DeadlineLinkStylesEnum.DOTTED,
  label: 'Dotted',
  dataCy: 'my-pref-deadline-link-style-dotted'
}];
const orderOptions$1 = [{
  value: DeadlineLinkPositionEnum.ABOVE_BOOKINGS,
  label: 'Show line above bookings',
  dataCy: 'my-pref-deadline-link-position-above'
}, {
  value: DeadlineLinkPositionEnum.BELOW_BOOKINGS,
  label: 'Show line below bookings',
  dataCy: 'my-pref-deadline-link-position-below'
}];
const visibilityOptions$1 = [{
  value: DeadlineDisplayEnum.SHOW,
  label: 'Show deadlines',
  dataCy: 'my-pref-deadline-display-show'
}, {
  value: DeadlineDisplayEnum.HIDE,
  label: 'Hide deadlines',
  dataCy: 'my-pref-deadline-display-hide'
}, {
  value: DeadlineDisplayEnum.SHOW_FOR_SELECTED_BOOKING,
  label: 'Show deadlines when booking is selected ',
  dataCy: 'my-pref-deadline-display-show-for-selected-booking'
}];
const tooltipVisibilityOptions = [{
  value: DeadlineTooltipDisplayEnum.HIDE,
  label: 'Hide',
  dataCy: 'my-pref-deadline-tooltip-display-hide'
}, {
  value: DeadlineTooltipDisplayEnum.SHOW_DEADLINE_DATE,
  label: 'Show date',
  dataCy: 'my-pref-deadline-tooltip-display-show-date'
}, {
  value: DeadlineTooltipDisplayEnum.SHOW_DEADLINE_NAME,
  label: 'Show deadline title',
  dataCy: 'my-pref-deadline-tooltip-display-show-name'
}];
const DeadlineOptions = /*#__PURE__*/React__default.memo(props => {
  const {
    deadlineTooltipDisplay = defaultDeadlineTooltipDisplay,
    deadlineDisplay = defaultDeadlineDisplay,
    deadlineLinkPosition = defaultDeadlineLinkPosition,
    deadlineLinkColor = defaultDeadlineLineColor,
    deadlineLinkWidth = defaultDeadlineLinkWidth,
    deadlineLinkStyle = defaultDeadlineLinkStyle,
    deadlineColor = defaultDeadlineColor,
    onChange
  } = props;
  return jsxs(Layout, {
    stack: true,
    stretch: true,
    gap: "--Spacing-200",
    children: [jsxs(Layout, {
      stack: true,
      gap: "--Spacing-100",
      children: [jsx(Typography, {
        variant: "label",
        size: "xl",
        children: "Style"
      }), jsx(RadioGroup, {
        stack: true,
        rowHeight: 36,
        name: "deadlineLinkStyle",
        value: deadlineLinkStyle,
        options: styleOptions$1,
        optionLabel: "label",
        optionValue: "value",
        onChange: value => {
          onChange({
            deadlineLinkStyle: value
          });
        }
      }), jsxs(Layout, {
        stack: true,
        gap: "--Spacing-100",
        children: [jsx(Typography, {
          variant: "label",
          size: "xl",
          children: "Color"
        }), jsxs(Layout, {
          gap: 32,
          children: [jsxs(Layout, {
            stack: true,
            gap: "--Spacing-100",
            children: [jsxs(Layout, {
              gap: "--Spacing-100",
              vAlign: "center",
              children: [jsx(Layout, {
                flex: "1 1 auto",
                children: jsx(Typography, {
                  children: "Line Color"
                })
              }), jsx(ColorPickerDialog, {
                disablePortal: true,
                value: deadlineLinkColor,
                onChange: color => {
                  onChange({
                    deadlineLinkColor: color
                  });
                }
              })]
            }), jsxs(Layout, {
              gap: "--Spacing-100",
              vAlign: "center",
              children: [jsx(Typography, {
                children: "Deadline color"
              }), jsx(ColorPickerDialog, {
                disablePortal: true,
                value: deadlineColor,
                onChange: color => {
                  onChange({
                    deadlineColor: color
                  });
                }
              })]
            })]
          }), jsxs(Layout, {
            vAlign: "center",
            gap: 2,
            children: [jsx(Typography, {
              children: "Eg:"
            }), jsx(StyledArrow, {
              color: deadlineLinkColor
            }), jsx(Deadline, {
              color: deadlineColor
            })]
          })]
        })]
      })]
    }), jsxs(Layout, {
      stack: true,
      gap: "--Spacing-100",
      children: [jsx(Typography, {
        variant: "label",
        size: "xl",
        children: "Position"
      }), jsx(RadioGroup, {
        stack: true,
        rowHeight: 36,
        name: "deadlineLinkPosition",
        value: deadlineLinkPosition,
        options: orderOptions$1,
        optionLabel: "label",
        optionValue: "value",
        onChange: value => {
          onChange({
            deadlineLinkPosition: value
          });
        }
      })]
    }), jsxs(Layout, {
      stack: true,
      gap: "--Spacing-100",
      children: [jsx(Typography, {
        variant: "label",
        size: "xl",
        children: "Show / Hide Deadlines"
      }), jsx(RadioGroup, {
        stack: true,
        rowHeight: 36,
        name: "deadlineDisplay",
        value: deadlineDisplay,
        options: visibilityOptions$1,
        optionLabel: "label",
        optionValue: "value",
        onChange: value => {
          onChange({
            deadlineDisplay: value
          });
        }
      })]
    }), jsxs(Layout, {
      stack: true,
      gap: "--Spacing-100",
      children: [jsx(Typography, {
        variant: "label",
        size: "xl",
        children: "Show / Hide Deadline Tooltip"
      }), jsx(RadioGroup, {
        stack: true,
        rowHeight: 36,
        name: "deadlineTooltipDisplay",
        value: deadlineTooltipDisplay,
        options: tooltipVisibilityOptions,
        optionLabel: "label",
        optionValue: "value",
        onChange: value => {
          onChange({
            deadlineTooltipDisplay: value
          });
        }
      })]
    }), jsxs(Row$2, {
      stretch: true,
      hAlign: "space-between",
      vAlign: "center",
      children: [jsx(SliderLabelLayout, {
        flex: "0 0 100px",
        children: jsx(Typography, {
          children: "Width"
        })
      }), jsx(Slider, {
        sliderThumbBackgroundColor: "surface-container-high",
        size: "small",
        valueLabelDisplay: "on",
        value: deadlineLinkWidth,
        min: 1,
        max: 6,
        step: 1,
        onChangeCommitted: (_, value) => {
          onChange({
            deadlineLinkWidth: value
          });
        }
      })]
    })]
  });
});
const Row$2 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "deadline-options__Row",
  componentId: "sc-1w8p8oa-0"
})(["min-height:32px;"]);
const StyledArrow = /*#__PURE__*/styled(ForwardRef$1).withConfig({
  displayName: "deadline-options__StyledArrow",
  componentId: "sc-1w8p8oa-1"
})(["path{fill:", ";}"], props => props.color);
const Deadline = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "deadline-options__Deadline",
  componentId: "sc-1w8p8oa-2"
})(["width:30px;height:30px;transform:rotate(45deg);background-color:", ";position:relative;left:6px;"], props => props.color);
var BookingLinkStylesEnum;
(function (BookingLinkStylesEnum) {
  BookingLinkStylesEnum["LINE"] = "solid";
  BookingLinkStylesEnum["DOTTED"] = "dotted";
  BookingLinkStylesEnum["DASHED"] = "dashed";
})(BookingLinkStylesEnum || (BookingLinkStylesEnum = {}));
const defaultLinkStyle = BookingLinkStylesEnum.LINE;
var BookingLinkPositionEnum;
(function (BookingLinkPositionEnum) {
  BookingLinkPositionEnum["ABOVE_BOOKINGS"] = "Above";
  BookingLinkPositionEnum["BELOW_BOOKINGS"] = "Below";
})(BookingLinkPositionEnum || (BookingLinkPositionEnum = {}));
const defaultLinkPosition = BookingLinkPositionEnum.ABOVE_BOOKINGS;
const defaultLineColor = '#000';
const defaultLineWidth = 2;
var BookingLinksDisplayEnum;
(function (BookingLinksDisplayEnum) {
  BookingLinksDisplayEnum["SHOW"] = "show";
  BookingLinksDisplayEnum["HIDE"] = "hide";
  BookingLinksDisplayEnum["SHOW_FOR_SELECTED_BOOKING"] = "showForSelected";
})(BookingLinksDisplayEnum || (BookingLinksDisplayEnum = {}));
const defaultLinkDisplay = BookingLinksDisplayEnum.SHOW;
const styleOptions = [{
  value: BookingLinkStylesEnum.LINE,
  label: 'Line',
  dataCy: 'my-pref-booking-link-style-line'
}, {
  value: BookingLinkStylesEnum.DASHED,
  label: 'Dashed',
  dataCy: 'my-pref-booking-link-style-dashed'
}, {
  value: BookingLinkStylesEnum.DOTTED,
  label: 'Dotted',
  dataCy: 'my-pref-booking-link-style-dotted'
}];
const orderOptions = [{
  value: BookingLinkPositionEnum.ABOVE_BOOKINGS,
  label: 'Bring to front',
  dataCy: 'my-pref-booking-link-position-above'
}, {
  value: BookingLinkPositionEnum.BELOW_BOOKINGS,
  label: 'Send to back',
  dataCy: 'my-pref-booking-link-position-below'
}];
const visibilityOptions = [{
  value: BookingLinksDisplayEnum.SHOW,
  label: 'Show',
  dataCy: 'my-pref-booking-link-display-show'
}, {
  value: BookingLinksDisplayEnum.HIDE,
  label: 'Hide',
  dataCy: 'my-pref-booking-link-display-hide'
}, {
  value: BookingLinksDisplayEnum.SHOW_FOR_SELECTED_BOOKING,
  label: 'Show only when a booking is clicked',
  dataCy: 'my-pref-booking-link-display-selected-booking'
}];
const DependencyOptions = /*#__PURE__*/React__default.memo(props => {
  const {
    onChange,
    bookingLinkColor = defaultLineColor,
    bookingLinkStyle = defaultLinkStyle,
    bookingLinkPosition = defaultLinkPosition,
    bookingLinkDisplay = defaultLinkDisplay,
    bookingLinkWidth = defaultLineWidth
  } = props;
  return jsxs(Layout, {
    stack: true,
    stretch: true,
    gap: "--Spacing-200",
    children: [jsxs(Layout, {
      stack: true,
      gap: "--Spacing-100",
      children: [jsx(Typography, {
        variant: "label",
        size: "xl",
        children: "Style"
      }), jsx(RadioGroup, {
        stack: true,
        rowHeight: 36,
        name: "bookingLinkStyle",
        value: bookingLinkStyle,
        options: styleOptions,
        optionLabel: "label",
        optionValue: "value",
        onChange: value => {
          onChange({
            bookingLinkStyle: value
          });
        }
      })]
    }), jsxs(Layout, {
      stack: true,
      gap: "--Spacing-100",
      children: [jsx(Typography, {
        variant: "label",
        size: "xl",
        children: "Color"
      }), jsx(ColorPickerDialog, {
        disablePortal: true,
        value: bookingLinkColor,
        onChange: color => {
          onChange({
            bookingLinkColor: color
          });
        }
      })]
    }), jsxs(Layout, {
      stack: true,
      gap: "--Spacing-100",
      children: [jsx(Typography, {
        variant: "label",
        size: "xl",
        children: "Order"
      }), jsx(RadioGroup, {
        stack: true,
        rowHeight: 36,
        name: "bookingLinkPosition",
        value: bookingLinkPosition,
        options: orderOptions,
        optionLabel: "label",
        optionValue: "value",
        onChange: value => {
          onChange({
            bookingLinkPosition: value
          });
        }
      })]
    }), jsxs(Layout, {
      stack: true,
      gap: "--Spacing-100",
      children: [jsx(Typography, {
        variant: "label",
        size: "xl",
        children: "Visibility"
      }), jsx(RadioGroup, {
        stack: true,
        rowHeight: 36,
        name: "bookingLinkDisplay",
        value: bookingLinkDisplay,
        options: visibilityOptions,
        optionLabel: "label",
        optionValue: "value",
        onChange: value => {
          onChange({
            bookingLinkDisplay: value
          });
        }
      })]
    }), jsxs(Row$1, {
      stretch: true,
      hAlign: "space-between",
      vAlign: "center",
      children: [jsx(SliderLabelLayout, {
        flex: "0 0 100px",
        children: jsx(Typography, {
          children: "Width"
        })
      }), jsx(Slider, {
        sliderThumbBackgroundColor: "surface-container-high",
        size: "small",
        valueLabelDisplay: "on",
        value: bookingLinkWidth,
        min: 1,
        max: 6,
        step: 1,
        onChangeCommitted: (_, value) => {
          onChange({
            bookingLinkWidth: value
          });
        }
      })]
    })]
  });
});
const Row$1 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "dependency-options__Row",
  componentId: "sc-1ieq9zu-0"
})(["min-height:32px;"]);
const useOptions = () => {
  const {
    resourceKeyWord,
    projectKeyWord
  } = useAppKeyWords();
  return useMemo(() => {
    return [{
      label: "".concat(resourceKeyWord, " single mode (default)"),
      value: SchedulerGridModeEnum.LEGACY,
      dataCy: 'my-pref-view-resource-single'
    }, {
      label: 'Group mode',
      value: SchedulerGridModeEnum.PARENT,
      dataCy: 'my-pref-view-group'
    }, {
      label: "".concat(projectKeyWord, " & ").concat(resourceKeyWord, " single mode"),
      value: SchedulerGridModeEnum.SINGLE,
      dataCy: 'my-pref-view-resource-project'
    }];
  }, [projectKeyWord, resourceKeyWord]);
};
const LayoutMode = /*#__PURE__*/React__default.memo(props => {
  const {
    value,
    onChange
  } = props;
  const options = useOptions();
  return jsx(RadioGroup, {
    stack: true,
    rowHeight: 36,
    name: "contextMenu",
    value: value,
    options: options,
    optionLabel: "label",
    optionValue: "value",
    onChange: newValue => {
      onChange({
        mode: newValue
      });
    }
  });
});
const options$2 = [{
  label: 'Classic menu',
  value: ContextMenuType.LEGACY,
  dataCy: 'my-pref-radio-classic-menu'
}, {
  label: 'Modern menu (Recommended)',
  value: ContextMenuType.NEW,
  dataCy: 'my-pref-radio-modern-menu'
}];
const SchedulerMenuType = /*#__PURE__*/React__default.memo(props => {
  const {
    value,
    onChange
  } = props;
  return jsx(RadioGroup, {
    stack: true,
    rowHeight: 36,
    name: "schedulerMenuType",
    value: value,
    options: options$2,
    optionLabel: "label",
    optionValue: "value",
    onChange: newValue => {
      onChange({
        contextMenu: newValue
      });
    }
  });
});
const marks = [{
  value: 1
}, {
  value: 25
}];
const Row = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "scheduler-options__Row",
  componentId: "sc-1w6xgyg-0"
})(["min-height:32px;"]);
const SchedulerOptions = /*#__PURE__*/React__default.memo(props => {
  const {
    eventSmartResize,
    displayWeeks,
    displayMilestoneText,
    onChange,
    schedulerFooterVisible,
    groupBookingsLimit,
    groupBookings
  } = props;
  return jsxs(Layout, {
    stack: true,
    gap: "--Spacing-100",
    children: [jsx(Row, {
      children: jsx(Switch, {
        name: "displayWeeks",
        dataCy: "btn-switch-displayWeeks",
        label: "Display week numbers in header",
        labelPosition: "right",
        checked: displayWeeks,
        onChange: () => {
          onChange({
            displayWeeks: !displayWeeks
          });
        }
      })
    }), jsx(Row, {
      children: jsx(Switch, {
        name: "schedulerFooterVisible",
        dataCy: "btn-switch-schedulerFooterVisible",
        label: "Display Scheduler footer",
        labelPosition: "right",
        checked: schedulerFooterVisible,
        onChange: () => {
          onChange({
            schedulerFooterVisible: !schedulerFooterVisible
          });
        }
      })
    }), jsx(Row, {
      children: jsx(Switch, {
        name: "displayMilestoneText",
        dataCy: "btn-switch-displayMilestoneText",
        label: "Display milestone name",
        labelPosition: "right",
        checked: displayMilestoneText,
        onChange: () => {
          onChange({
            displayMilestoneText: !displayMilestoneText
          });
        }
      })
    }), jsx(Row, {
      children: jsx(Switch, {
        name: "eventSmartResize",
        dataCy: "btn-switch-eventSmartResize",
        label: "Enable smart moving",
        labelPosition: "right",
        helperText: "When moving / dragging a booking, it will jump over the non working days that are displayed. Booking duration is maintained.",
        checked: eventSmartResize,
        onChange: () => {
          onChange({
            eventSmartResize: !eventSmartResize
          });
        }
      })
    }), jsx(Row, {
      children: jsx(Switch, {
        name: "groupBookings",
        dataCy: "btn-switch-groupBookings",
        label: "Group overlapping bookings",
        labelPosition: "right",
        helperText: "In the settings you can choose how many bookings need to overlap so they auto group on page load.",
        checked: groupBookings,
        onChange: () => {
          onChange({
            groupBookings: !groupBookings
          });
        }
      })
    }), groupBookings ? jsxs(Layout, {
      stack: true,
      gap: "--Spacing-50",
      children: [jsxs(Row, {
        stretch: true,
        hAlign: "space-between",
        vAlign: "center",
        children: [jsx(SliderLabelLayout, {
          flex: "0 0 120px",
          pr: "--Spacing-200",
          children: jsx(Typography, {
            children: "Limit (25max)"
          })
        }), jsx(Slider, {
          sliderThumbBackgroundColor: "surface-container-high",
          size: "small",
          valueLabelDisplay: "on",
          marks: marks,
          min: 1,
          max: 25,
          value: groupBookingsLimit,
          onChangeCommitted: (_, val) => {
            onChange({
              groupBookingsLimit: val
            });
          }
        })]
      }), jsx(Typography, {
        size: "small",
        children: "On Page load the number of overlapping bookings to be grouped."
      })]
    }) : null]
  });
});
const options$1 = [{
  label: 'Hour',
  value: ScaleEnum.CellDuration,
  dataCy: 'my-pref-defaultScale-hour'
}, {
  label: 'Day',
  value: ScaleEnum.Day,
  dataCy: 'my-pref-defaultScale-day'
}, {
  label: 'Week',
  value: ScaleEnum.Week,
  dataCy: 'my-pref-defaultScale-week'
}, {
  label: 'Month',
  value: ScaleEnum.Month,
  dataCy: 'my-pref-defaultScale-month'
}];
const SchedulerScale = /*#__PURE__*/React__default.memo(props => {
  const {
    value,
    onChange
  } = props;
  return jsx(RadioGroup, {
    stack: true,
    rowHeight: 36,
    name: "schedulerScale",
    value: value,
    options: options$1,
    optionLabel: "label",
    optionValue: "value",
    onChange: newValue => {
      onChange({
        defaultScale: newValue
      });
    }
  });
});
var SubGroupsPositionEnum;
(function (SubGroupsPositionEnum) {
  SubGroupsPositionEnum["BOTTOM"] = "BOTTOM";
  SubGroupsPositionEnum["TOP"] = "TOP";
})(SubGroupsPositionEnum || (SubGroupsPositionEnum = {}));
const options = [{
  value: SubGroupsPositionEnum.TOP,
  label: 'Top',
  dataCy: 'my-pref-eventHeightMode-xs'
}, {
  value: SubGroupsPositionEnum.BOTTOM,
  label: 'Bottom',
  dataCy: 'my-pref-eventHeightMode-s'
}];
const SubGroupPosition = /*#__PURE__*/React__default.memo(props => {
  const {
    value = SubGroupsPositionEnum.BOTTOM,
    onChange
  } = props;
  return jsx(RadioGroup, {
    stack: true,
    rowHeight: 36,
    name: "subGroupPosition",
    value: value,
    options: options,
    optionLabel: "label",
    optionValue: "value",
    onChange: onChange
  });
});
const PersonalPreferencesSidebar = /*#__PURE__*/React__default.memo(props => {
  const {
    onClose,
    gridPreferences,
    onGridPreferencesChange,
    onSubGroupsPositionChange,
    subGroupsPosition
  } = props;
  const accordionItems = useMemo(() => {
    return [{
      dataCy: 'account-preferences-column-width',
      id: '1',
      header: jsx(StyledListItem, {
        label: "Column Width",
        supportingText: "Set the default width of cells in each scale."
      }),
      content: jsx(ColumnWidth, {
        value: gridPreferences.cellWidth,
        onChange: onGridPreferencesChange
      })
    }, {
      dataCy: 'account-preferences-booking-bar-height',
      id: '2',
      header: jsx(StyledListItem, {
        label: "Booking Bar Height"
      }),
      content: jsx(BookingBarHeight, {
        value: gridPreferences.eventHeightMode,
        onChange: onGridPreferencesChange
      })
    }, {
      dataCy: 'account-preferences-dependency-options',
      id: '3',
      header: jsx(StyledListItem, {
        label: "Dependency Options"
      }),
      content: jsx(DependencyOptions, {
        onChange: onGridPreferencesChange,
        bookingLinkDisplay: gridPreferences.bookingLinkDisplay,
        bookingLinkPosition: gridPreferences.bookingLinkPosition,
        bookingLinkColor: gridPreferences.bookingLinkColor,
        bookingLinkStyle: gridPreferences.bookingLinkStyle,
        bookingLinkWidth: gridPreferences.bookingLinkWidth
      })
    }, {
      dataCy: 'account-preferences-deadline-options',
      id: '4',
      header: jsx(StyledListItem, {
        label: "Deadline Options"
      }),
      content: jsx(DeadlineOptions, {
        onChange: onGridPreferencesChange,
        deadlineLinkStyle: gridPreferences.deadlineLinkStyle,
        deadlineColor: gridPreferences.deadlineColor,
        deadlineLinkColor: gridPreferences.deadlineLinkColor,
        deadlineDisplay: gridPreferences.deadlineDisplay,
        deadlineLinkPosition: gridPreferences.deadlineLinkPosition,
        deadlineLinkWidth: gridPreferences.deadlineLinkWidth,
        deadlineTooltipDisplay: gridPreferences.deadlineTooltipDisplay
      })
    }, {
      dataCy: 'account-preferences-subgroup-position',
      id: '5',
      header: jsx(StyledListItem, {
        label: "Subgroup Position in Sidebar"
      }),
      content: jsx(SubGroupPosition, {
        value: subGroupsPosition,
        onChange: onSubGroupsPositionChange
      })
    }, {
      dataCy: 'account-preferences-availability-status',
      id: '6',
      header: jsx(StyledListItem, {
        label: "Availability status Over Booking Bar"
      }),
      content: jsx(AvailabilityStatus, {
        onChange: onGridPreferencesChange,
        displayValue: gridPreferences.availabilityDisplay,
        hoverValue: gridPreferences.availabilityHover
      })
    }, {
      dataCy: 'account-preferences-menu-type',
      id: '7',
      header: jsx(StyledListItem, {
        label: "Scheduler Menu Type"
      }),
      content: jsx(SchedulerMenuType, {
        onChange: onGridPreferencesChange,
        value: gridPreferences.contextMenu
      })
    }, {
      dataCy: 'account-preferences-layout-mode',
      id: '8',
      header: jsx(StyledListItem, {
        label: "Default Layout Mode"
      }),
      content: jsx(LayoutMode, {
        onChange: onGridPreferencesChange,
        value: gridPreferences.mode
      })
    }, {
      dataCy: 'account-preferences-schedule-scale',
      id: '9',
      header: jsx(StyledListItem, {
        label: "Default Schedule Scale"
      }),
      content: jsx(SchedulerScale, {
        onChange: onGridPreferencesChange,
        value: gridPreferences.defaultScale
      })
    }, {
      dataCy: 'account-preferences-tooltip-delay',
      id: '10',
      header: jsx(StyledListItem, {
        label: "Booking Tool Tip Delay",
        supportingText: "On hovering a booking, the speed the tooltip will display after hovered."
      }),
      content: jsx(BookingTooltipDelay, {
        onChange: onGridPreferencesChange,
        value: gridPreferences.bookingToolTipHoverDelay
      })
    }, {
      dataCy: 'account-preferences-scheduler-options',
      id: '11',
      header: jsx(StyledListItem, {
        label: "Scheduler Options"
      }),
      content: jsx(SchedulerOptions, {
        onChange: onGridPreferencesChange,
        displayMilestoneText: gridPreferences.displayMilestoneText,
        displayWeeks: gridPreferences.displayWeeks,
        eventSmartResize: gridPreferences.eventSmartResize,
        groupBookings: gridPreferences.groupBookings,
        groupBookingsLimit: gridPreferences.groupBookingsLimit,
        schedulerFooterVisible: gridPreferences.schedulerFooterVisible
      })
    }];
  }, [gridPreferences.availabilityDisplay, gridPreferences.availabilityHover, gridPreferences.bookingLinkColor, gridPreferences.bookingLinkDisplay, gridPreferences.bookingLinkPosition, gridPreferences.bookingLinkStyle, gridPreferences.bookingLinkWidth, gridPreferences.bookingToolTipHoverDelay, gridPreferences.cellWidth, gridPreferences.contextMenu, gridPreferences.deadlineColor, gridPreferences.deadlineDisplay, gridPreferences.deadlineLinkColor, gridPreferences.deadlineLinkPosition, gridPreferences.deadlineLinkStyle, gridPreferences.deadlineLinkWidth, gridPreferences.deadlineTooltipDisplay, gridPreferences.defaultScale, gridPreferences.displayMilestoneText, gridPreferences.displayWeeks, gridPreferences.eventHeightMode, gridPreferences.eventSmartResize, gridPreferences.groupBookings, gridPreferences.groupBookingsLimit, gridPreferences.mode, gridPreferences.schedulerFooterVisible, onGridPreferencesChange, onSubGroupsPositionChange, subGroupsPosition]);
  return jsxs(Wrapper, {
    stack: true,
    children: [jsxs(Layout, {
      stack: true,
      pt: "--Spacing-150",
      pl: "--Spacing-300",
      pb: "--Spacing-200",
      pr: "--Spacing-300",
      children: [jsxs(Header, {
        hAlign: "space-between",
        vAlign: "center",
        children: [jsx(Typography, {
          variant: "title",
          size: "large",
          children: "Personal Preferences"
        }), jsx(IconButton, {
          icon: "close",
          onClick: onClose
        })]
      }), jsx(Typography, {
        variant: "body",
        size: "small",
        children: "Customise your scheduler as you like. All settings are saved for your user account only. Global Scheduler settings to change colors, etc can be found on your settings page."
      })]
    }), jsx(AccordionWrapper, {
      flex: "1 1 auto",
      stack: true,
      pr: "--Spacing-300",
      pb: "--Spacing-200",
      pl: "--Spacing-300",
      children: jsx(Accordion, {
        scrollTop: true,
        openItem: "1",
        items: accordionItems
      })
    })]
  });
});
const Header = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "personal-preferences-sidebar__Header",
  componentId: "sc-8nignb-0"
})(["min-height:48px;"]);
const AccordionWrapper = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "personal-preferences-sidebar__AccordionWrapper",
  componentId: "sc-8nignb-1"
})(["overflow:auto;"]);
const Wrapper = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "personal-preferences-sidebar__Wrapper",
  componentId: "sc-8nignb-2"
})(["background-color:", ";border-radius:", "px;box-shadow:", ";max-height:100%;overflow:auto;"], props => props.theme.designTokens.color.color.surfaces['surface-container-high'].value, props => props.theme.designSpacing['--Spacing-200'], props => props.theme.shadows[3]);
const StyledListItem = /*#__PURE__*/styled(ListItem).withConfig({
  displayName: "personal-preferences-sidebar__StyledListItem",
  componentId: "sc-8nignb-3"
})([".hub-ui__list-item{padding:0;}"]);
var UNDO_ACTIONS;
(function (UNDO_ACTIONS) {
  UNDO_ACTIONS["CREATE"] = "CREATE";
  UNDO_ACTIONS["MOVE"] = "MOVE";
  UNDO_ACTIONS["RESIZE"] = "RESIZE";
  UNDO_ACTIONS["DELETE"] = "DELETE";
  UNDO_ACTIONS["CUT_PASTE"] = "CUT_PASTE";
})(UNDO_ACTIONS || (UNDO_ACTIONS = {}));
class UndoService {
  constructor() {
    this._history = null;
    this._listeners = {};
  }
  addListener(callback) {
    const listenerId = uuid_1.v4();
    this._listeners[listenerId] = callback;
    return listenerId;
  }
  removeListener(listenerId) {
    delete this._listeners[listenerId];
  }
  notify() {
    var _a, _b, _c, _d, _e;
    let canUndo = false;
    switch ((_a = this._history) === null || _a === void 0 ? void 0 : _a.type) {
      case UNDO_ACTIONS.CUT_PASTE:
        canUndo = Boolean(((_b = this._history) === null || _b === void 0 ? void 0 : _b.createdBookingId) && ((_c = this._history) === null || _c === void 0 ? void 0 : _c.deletedBookingId));
        break;
      case UNDO_ACTIONS.CREATE:
        canUndo = Boolean((_d = this._history) === null || _d === void 0 ? void 0 : _d.createdBookingId);
        break;
      default:
        canUndo = Boolean((_e = this._history) === null || _e === void 0 ? void 0 : _e.bookingId);
    }
    Object.values(this._listeners).forEach(listener => {
      listener({
        canUndo
      });
    });
  }
  clear() {
    this._history = null;
    this.notify();
  }
  addAction(action) {
    if (!action) {
      return;
    }
    const {
      booking,
      type
    } = action;
    if (booking.repeat) {
      // PHASE 1 no undo on repeated bookings
      this.clear();
      return;
    }
    if (Array.isArray(booking.childIds) && booking.childIds.length || Array.isArray(booking.parentIds) && booking.parentIds.length) {
      // PHASE 1 no undo on dependent bookings
      this.clear();
      return;
    }
    const undoActionId = uuid_1.v4();
    this._history = {
      type: type,
      undoActionId: undoActionId,
      booking
    };
    this.notify();
    return undoActionId;
  }
  updateAction(undoActionId, data) {
    var _a;
    if (!undoActionId) {
      return;
    }
    if (((_a = this._history) === null || _a === void 0 ? void 0 : _a.undoActionId) === undoActionId) {
      this._history = Object.assign(Object.assign({}, this._history), data);
    }
    this.notify();
  }
  undo() {
    const action = this._history;
    this._history = null;
    this.notify();
    return action;
  }
}
var HP = "data:image/webp;base64,UklGRj4EAABXRUJQVlA4WAoAAAAQAAAA6wAAMgAAQUxQSI4DAAABkFXbdthGD4IgPAiC8CAYghjUDCIGNQOZQYaBIBTCgyAI5yOS0ihpsuYvIiZAuuFSG/e3uqt8nqHw+0U/jeg80uNnERsPtk9CnUc3/SAKj6+fg7KifQzHEuVjqEu0j6EtQfgUWFP/x/ga8imeS9SPwZZIC8RSygJWyvcSRyn2qsQXcF3AgAUS+BIO6WXZAlk+BzkedpVPQo4H1fBZSH7IIWv24p7zFgZmFgbRTCfClvNuIzMLIrbnbL+iKedNRdQs3phZEN1z3sJAzVSC5bzHqbDlnLcwiGYqYllvRE//pXZEWUgrt37pATZwSKOvxq1bRwE159bTXVrplnBCEREF4pXupXdC/mrcVh2ES+O2XXoVcnSwjohYyvcnC7LsjTO8PKQw3keF8eWO2Bj6daYxLCNn2LSjztjDoDSmnv2GlrftBLAHAHW3dALYAFrethNgn1IH6m7p5HZEy5sdDqQB1GSpArXjQNlsO4E6ANxfiquISGxQHpLldmtQR2cQEVGHFmYKkOV2n3MVEVGHOspyewAmIglIcpsAG/xEeZ03SboZ/BFF+jtgPQ/SjUCeCECRfp7apbsDoefSDQ12EXEo0j+h9prKiwm9DXhEHIQGey/JsMK/CQPiILSZ2FNAe/96ckIRUSAONmi9f/JqpK+PaTK+QunF0Q4+sUOTcZ3RnswcdxjgY0A7x5/kE+eEjtJcBp84H5N/Yb6X/6Q2UX9jn0vQJupqdTr8hu3lWhcseQtLbQMm0FGDvbePrlAnDIijtpICKnfeY5V1W9FVHI6eTX0PvoDY+xkokCZCgzJIrCQOeRDN4l2hsranRQ5oehN8ir0TG7j0+O6oAzohB3DpxLZWhhY7X0C6R53lL2sY0L7NdmeOssXtGyCO8BTjpQFZZkIDyha3b24XCg58R40XwOWeH55wX0Iyw9Ym2g/jLIOT8SlTEhtDr0uJOmPXey48Y9MlJHvHo094OHpuMtLknbbLHaLeu4ZzLdFzcA1yh/pTUO8KKaVBSCn1JGxHOUxkS0lFRFPaRHQv5TDpdySkoxwpSH9LSTsilkvZTcRSMhEJKaUwSCkFEbGU4sBSso6IpqOUXaVvKcVO4knDPc/b+zuvz7K/Z/4s5T3jWf99VPU982c53rPrs6SX4e5/yf4s+ir+2tCeo8qbnp9D3zX5eYYsb7v6eqe88fqzWpb3PvlK1eTtt+Nalyy7yjsPVlA4IIoAAADQCgCdASrsADMAPok2lUelIyIhMqgAoBEJaW7dCm28AANPsqUkJggqjnre7SPOMFaTf8JSLPmmpsiLliVQl3VijRU3BKoMCFbVvbt2bUW7W4K/68LVJJLWkMTgKmnAAAD++PWmf//MCryf//mMhP+RyO/6pgO+6P9tgKz/mE8acx63nj+AAAAAAAA=";
var HP_Small = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABGCAYAAAB4xUL+AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOmSURBVHgB7ZzhddowEICPvv4vnaDOBE02IBMknSBsEDJBkgkgEwATlE4AnaDZAHUC6ATqXXUCQZFlG9mSEn3vXcCSLNlnSdbdifSgAVLKPn5cohQs5yBIer3eClIBFVCgjFE20j9U55TagJjBC7yX7SjgFI8QI3RhsnumEBOBlBCXMqSaE0IzhA744MiPYazS5NyHlrEqQqrZewjh0a/qVinrEa03XoM7aJlUFBG0RxQQD+HmCGQL8dD6tZQpQkA8BFXEK8TDT2iZXlkmvkI30MH4rMAFWqcCWsS1oHqB8MzaVgLRcxXAXvELwr1KaW646kIRrh5BfINwE+dDF0qojFTG11p2x6YrY6s2rIyZbJ8lSudD0TlHHCOVMTZC+Qpq7jj3rbJl+YGySMp3mclkMpnM+6b2OoKQ+9inj3WEL8htQDHURu6DWorgxdQ9KO92LAo4RqDMUOat2Cmy29inD9bSt70iw4b9zsVPkEqmrQTNyHWfLlddgR9rSB+ngyeF2KcPaGIvvRdrj3hDvcHkM/aKk6GBVEJ+vri1Zbw3RRS2jFRin774YstIJfbpiz+2jFRin74QtoxUYp++sN5TKrFPH5BlemHLdC2onuHtUHovscc+fVHaG4jYY58+ECjXrkKVHDO83F5CemsLgXJdxUFTpUcAV0RanUM60N6OylsKmsY+ac1+A3H5LGkBSK9H2mY0sRlXmUwmk8lkMpkQ4CpyUKNsX9bcFlin/qBQrKxG2QHKEmpQp/62+egqwE+NhGz6mbY18PuE88nuECXlyRYZgrIDdukn2qEyBZejzwXsf3veZ/m3QZ3bBCNvt3HdqMdsn2KfK5Stbf9EFeuTGiUD5pFvsgC1R8LM10NiwMeCy49gH26753TaXjCGQyWY+XT+mNsZ8LlbrmdptDnmdNr4OuV6KO2G67k70X4zzK6LX59YaAisjXTS+vBE+i15t6Taurwx0nfHun4ud2mU2XB91N7iKF1vhX7itL5Rj+Rzhvy55vLOIVjJH3HEsXn7yZJ3UE6W/4hVd/1TbGx1Ekfm9tYoL1AeoCJNFCFQ+lrzoLqvRv9bBeq61F21I4ducsrp3+F/Bw8dj7kXjaG5j2PO10MKod+KVn6LuSZL0/O7oj/0BPBir0BNQAUorb9y4/oJ0Dh9NiZXAWrT+QDU3qaJWT8ek1IFn0c385vPoTZNpbxwOws47B26nhE/nBtuR0+W4b3xPEaj317QZGg0QUAmkxR/AVLJHTgMveQ/AAAAAElFTkSuQmCC";
var Image1 = "b242103b46694a77.jpg";
var Image2 = "76706fbd1828709c.jpg";
var Image3 = "f42dfaa99295da7c.jpg";
var Image4 = "64f9850cc6034d91.jpg";
var Image5 = "583294e28361523d.jpg";
const Container$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "authentication-container__Container",
  componentId: "sc-148gdhy-0"
})(["width:379px;padding:24px;background:", ";border-radius:24px;box-shadow:5px 10px 3px 0px rgba(0,0,0,0),3px 7px 3px 0px rgba(0,0,0,0.02),2px 4px 2px 0px rgba(0,0,0,0.06),1px 2px 2px 0px rgba(0,0,0,0.1),0px 0px 1px 0px rgba(0,0,0,0.12);height:fit-content;"], _ref356 => {
  let {
    theme,
    level
  } = _ref356;
  return level === 'high' ? theme.designTokens.color.color.surfaces['surface-container-high'].value : theme.designTokens.color.color.surfaces['surface-container'].value;
});
const validationSchema = create$3().shape({
  email: create$6().email('Invalid email address').required('Email is required'),
  password: create$6().required('Password is required').min(8, 'Password must be at least 8 characters').matches(/^(?=.*?[A-Z])/, 'Password must contain at least one uppercase letter').matches(/^(?=.*?[a-z])/, 'Password must contain at least one lowercase letter').matches(/^(?=.*?[0-9])/, 'Password must contain at least one number').matches(/^(?=.*?[!"#$%&'()*+,\-./:;<=>?@\\[\]^_`{|}~])/, 'Password must contain at least one special character'),
  acceptedTOS: create$7().oneOf([true], 'You must accept the terms of service').when('isSignUp', {
    is: true,
    then: schema => schema.required('You must accept the terms of service'),
    otherwise: schema => schema.optional()
  })
});
const OrContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "authentication-container__OrContainer",
  componentId: "sc-148gdhy-1"
})(["display:flex;align-items:center;gap:24px;width:100%;"]);
const Line = /*#__PURE__*/styled.div.withConfig({
  displayName: "authentication-container__Line",
  componentId: "sc-148gdhy-2"
})(["flex:1;height:1px;background-color:", ";"], _ref357 => {
  let {
    theme
  } = _ref357;
  return theme.designTokens.color.color.light['outline-variant'].value;
});
const OrDivider = () => {
  return jsxs(OrContainer, {
    children: [jsx(Line, {}), jsx(Layout, {
      children: jsx(Typography, {
        variant: "body",
        size: "medium",
        color: "on-surface",
        children: "or log in with"
      })
    }), jsx(Line, {})]
  });
};
const SocialButton = _ref358 => {
  let {
    label,
    icon,
    onClick
  } = _ref358;
  return jsxs(Layout, {
    stack: true,
    gap: 2,
    hAlign: "center",
    vAlign: "space-between",
    children: [jsx(IconButton, {
      iconSize: 24,
      icon: icon,
      onClick: onClick,
      variant: "outlined",
      noFill: true
    }), jsx(Typography, {
      variant: "body",
      size: "medium",
      color: "on-surface",
      children: label
    })]
  });
};
const ForgotPassword = _ref359 => {
  let {
    rememberMe,
    setRememberMe
  } = _ref359;
  return jsxs(Layout, {
    hAlign: "space-between",
    vAlign: "center",
    pr: "--Spacing-150",
    children: [jsx(Layout, {
      children: jsx(Checkbox, {
        name: "rememberMe",
        label: "Remember me",
        checked: rememberMe,
        onChange: () => setRememberMe(!rememberMe)
      })
    }), jsx(Typography, {
      variant: "label",
      size: "large",
      color: "primary",
      noWrap: true,
      children: jsx(Link, {
        href: "#",
        children: "Forgot password?"
      })
    })]
  });
};
const ServiceTerms = _ref360 => {
  let {
    values,
    setFieldValue
  } = _ref360;
  return jsx(Layout, {
    vAlign: "center",
    children: jsxs(Layout, {
      hAlign: "flex-start",
      vAlign: "center",
      flex: "1",
      children: [jsx(Layout, {
        children: jsx(Field$1, {
          as: Checkbox,
          name: "acceptedTOS",
          checked: values.acceptedTOS,
          onChange: () => setFieldValue('acceptedTOS', !values.acceptedTOS)
        })
      }), jsxs(Typography, {
        variant: "body",
        size: "small",
        color: "primary",
        noWrap: true,
        children: ["I agree to the ", jsx(Link, {
          href: "#",
          children: "Terms of Service"
        }), " and ", jsx(Link, {
          href: "#",
          children: "Privacy Policy"
        })]
      })]
    })
  });
};
const AuthenticationContainer = _ref361 => {
  let {
    onSubmit,
    onSocialClick,
    authMethods,
    isSignUp: _isSignUp = false
  } = _ref361;
  const [rememberMe, setRememberMe] = useState(false);
  const title = _isSignUp ? 'Sign up' : 'Login';
  const subtitle = _isSignUp ? '14 days trial with full access to all features' : '';
  const emailHelperText = _isSignUp ? 'We suggest you use your work email address' : '';
  const footerText = _isSignUp ? 'Already have an account?' : 'New here?';
  const footerLinkText = _isSignUp ? 'Sign In' : 'Start a new trial';
  const buttonText = _isSignUp ? 'Sign Up' : 'Sign In';
  const initialValues = {
    email: '',
    password: '',
    acceptedTOS: false,
    rememberMe: false
  };
  const isSSOOnly = authMethods.length === 1 && authMethods.includes('sso');
  if (isSSOOnly) {
    return jsx(Container$1, {
      children: jsxs(Layout, {
        gap: "--Spacing-400",
        stack: true,
        children: [jsx(Layout, {
          hAlign: "center",
          stack: true,
          gap: "--Spacing-200",
          children: jsx(Typography, {
            variant: "headline",
            size: "xl",
            color: "on-surface-variant",
            children: title
          })
        }), jsx(Button, {
          startIcon: "lock",
          onClick: () => onSocialClick && onSocialClick('sso'),
          children: "Sign In With SSO"
        })]
      })
    });
  }
  return jsx(Container$1, {
    level: _isSignUp ? 'default' : 'high',
    children: jsxs(Layout, {
      gap: "--Spacing-400",
      stack: true,
      children: [jsxs(Layout, {
        hAlign: "center",
        stack: true,
        gap: "--Spacing-200",
        children: [jsx(Typography, {
          variant: "headline",
          size: "xl",
          color: "on-surface-variant",
          children: title
        }), subtitle && jsx(Typography, {
          variant: "body",
          size: "medium",
          color: "on-surface-variant",
          children: subtitle
        })]
      }), jsx(Formik, {
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values, _ref362) => {
          let {
            setSubmitting
          } = _ref362;
          onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(values);
          setSubmitting(false);
        },
        handleSubmit: e => e.preventDefault(),
        children: _ref363 => {
          let {
            values,
            errors,
            touched,
            setFieldValue,
            isSubmitting,
            handleSubmit
          } = _ref363;
          return jsxs(Form, {
            style: {
              display: 'flex',
              flexDirection: 'column',
              gap: 32
            },
            onSubmit: e => {
              e.preventDefault();
              handleSubmit(e);
            },
            children: [jsxs(Layout, {
              gap: "--Spacing-150",
              stack: true,
              children: [jsxs(Layout, {
                gap: "--Spacing-400",
                stack: true,
                children: [jsx(Field$1, {
                  as: TextField,
                  name: "email",
                  label: "Email Address",
                  helperText: touched.email && errors.email || emailHelperText,
                  error: touched.email && errors.email,
                  required: true
                }), jsx(Field$1, {
                  as: TextField,
                  name: "password",
                  label: "Password",
                  type: "password",
                  helperText: errors.password && touched.password ? errors.password : '',
                  error: touched.password && errors.password,
                  required: true
                })]
              }), _isSignUp ? jsx(ServiceTerms, {
                values: values,
                setFieldValue: setFieldValue
              }) : jsx(ForgotPassword, {
                setRememberMe: setRememberMe,
                rememberMe: rememberMe
              })]
            }), jsxs(Layout, {
              stack: true,
              gap: "--Spacing-200",
              hAlign: "center",
              children: [jsx(Button, {
                type: "submit",
                fullWidth: true,
                disabled: isSubmitting,
                children: buttonText
              }), jsxs(Typography, {
                variant: "body",
                size: "medium",
                color: "on-surface",
                children: [footerText, jsx(Button, {
                  variant: "text",
                  href: "#",
                  children: footerLinkText
                })]
              })]
            })]
          });
        }
      }), jsx(OrDivider, {}), jsxs(Layout, {
        gap: "--Spacing-300",
        hAlign: "center",
        children: [authMethods.includes('google') && jsx(SocialButton, {
          onClick: () => onSocialClick === null || onSocialClick === void 0 ? void 0 : onSocialClick('google'),
          icon: "google",
          label: "Google"
        }), authMethods.includes('linkedin') && jsx(SocialButton, {
          onClick: () => onSocialClick === null || onSocialClick === void 0 ? void 0 : onSocialClick('linkedin'),
          icon: "linkedin",
          label: "Linkedin"
        }), authMethods.includes('sso') && jsx(SocialButton, {
          onClick: () => onSocialClick === null || onSocialClick === void 0 ? void 0 : onSocialClick('sso'),
          icon: "sso",
          label: "SSO"
        })]
      })]
    })
  });
};
const BACKGROUND_IMAGES = [Image1, Image2, Image3, Image4, Image5];
const Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "sign-in__Container",
  componentId: "sc-10w4cq9-0"
})(["width:100%;height:100%;"]);
const ContentSection = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "sign-in__ContentSection",
  componentId: "sc-10w4cq9-1"
})(["display:flex;margin:auto;width:100%;@media (min-width:1440px) and (min-height:950px){flex-direction:column;justify-content:center;}"]);
const BackgroundContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "sign-in__BackgroundContainer",
  componentId: "sc-10w4cq9-2"
})(["position:relative;width:100vw;height:100%;overflow:hidden;@media (min-height:700px){height:100vh;}"]);
const BackgroundImage = /*#__PURE__*/styled.div.withConfig({
  displayName: "sign-in__BackgroundImage",
  componentId: "sc-10w4cq9-3"
})(["position:absolute;inset:0;background:", ";background-color:lightgray;background-position:center;background-repeat:no-repeat;background-size:cover;transition:opacity 0.3s ease-in-out;"], _ref364 => {
  let {
    imageUrl
  } = _ref364;
  return imageUrl ? "linear-gradient(180deg,\n          rgba(255, 255, 255, 0.00) 3.57%,\n          rgba(0, 0, 0, 0.40) 62.47%),\n          url(".concat(imageUrl, ")") : 'none';
});
const ContentWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "sign-in__ContentWrapper",
  componentId: "sc-10w4cq9-4"
})(["position:relative;z-index:1;width:100%;height:100%;display:flex;flex-direction:column;padding:80px 96px;"]);
const Logo = /*#__PURE__*/styled.img.attrs({
  src: HP,
  alt: 'Hub Planner Logo'
}).withConfig({
  displayName: "sign-in__Logo",
  componentId: "sc-10w4cq9-5"
})(["height:50px;background-size:contain;width:fit-content;"]);
const HPSmall = /*#__PURE__*/styled.img.attrs({
  src: HP_Small,
  alt: 'Hub Planner Logo small'
}).withConfig({
  displayName: "sign-in__HPSmall",
  componentId: "sc-10w4cq9-6"
})(["height:65px;background-size:contain;width:fit-content;"]);
const WelcomeSection = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "sign-in__WelcomeSection",
  componentId: "sc-10w4cq9-7"
})(["text-align:left;order:-1;align-self:center;@media (min-width:1440px) and (min-height:950px){align-self:flex-start;text-align:center;order:1;}"]);
const LoginSection = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "sign-in__LoginSection",
  componentId: "sc-10w4cq9-8"
})([""]);
const SignUpLeftContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "sign-in__SignUpLeftContainer",
  componentId: "sc-10w4cq9-9"
})(["width:700px;height:100%;background-color:", ";box-sizing:border-box;"], _ref365 => {
  let {
    theme
  } = _ref365;
  return theme.designTokens.color.color.surfaces['inverse-surface'].value;
});
const SignUpBackground = /*#__PURE__*/styled.div.withConfig({
  displayName: "sign-in__SignUpBackground",
  componentId: "sc-10w4cq9-10"
})(["height:100vh;width:100vw;background-color:", ";"], _ref366 => {
  let {
    theme
  } = _ref366;
  return theme.designTokens.color.color.surfaces['surface-container-high'].value;
});
const RandomBackground = _ref367 => {
  let {
    images,
    children
  } = _ref367;
  const [backgroundImage, setBackgroundImage] = useState();
  const randomImage = useMemo(() => images[Math.floor(Math.random() * images.length)], [images]);
  useEffect(() => {
    const img = new Image();
    const handleLoad = () => setBackgroundImage(randomImage);
    const handleError = () => console.error('Failed to load image:', randomImage);
    img.onload = handleLoad;
    img.onerror = handleError;
    img.src = randomImage;
    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [randomImage]);
  return jsxs(BackgroundContainer, {
    children: [backgroundImage && jsx(BackgroundImage, {
      imageUrl: backgroundImage
    }), jsx(ContentWrapper, {
      children: children
    })]
  });
};
const Review = _ref368 => {
  let {
    rating: _rating = 4,
    avatarUrl: _avatarUrl = 'https://lumiere-a.akamaihd.net/v1/images/a_avatarpandorapedia_neytiri_16x9_1098_01_0e7d844a.jpeg?region=420%2C0%2C1080%2C1080',
    name: _name = 'Mykola K.',
    role: _role = 'First Line Manager',
    quote: _quote = "I've been using Hub Planner daily, and it's truly transformed how I plan time and manage tasks for my team..."
  } = _ref368;
  return jsx("div", {
    style: {
      width: 300
    },
    children: jsxs(Layout, {
      stack: true,
      hAlign: "center",
      gap: "--Spacing-200",
      children: [jsx(Avatar, {
        size: 105,
        src: _avatarUrl
      }), jsxs(Layout, {
        gap: "--Spacing-100",
        stack: true,
        hAlign: "center",
        children: [jsxs(Layout, {
          stack: true,
          hAlign: "center",
          children: [jsx(Typography, {
            variant: "title",
            size: "medium",
            color: "on-primary",
            children: _name
          }), jsx(Typography, {
            variant: "body",
            size: "small",
            color: "on-primary",
            children: _role
          })]
        }), jsxs(Typography, {
          variant: "body",
          size: "small",
          color: "on-primary",
          children: ["\"", _quote, "\""]
        })]
      }), jsxs(Layout, {
        gap: 6,
        vAlign: "center",
        children: [jsx(Layout, {
          gap: 2,
          children: Array(5).fill(null).map((_, index) => jsx(Icon, {
            name: index < _rating ? 'star' : 'star_stroke',
            size: 14
          }, index))
        }), jsx(Icon, {
          name: "g2",
          size: 28
        })]
      })]
    })
  });
};
const FullVisibilityText = () => jsx("div", {
  style: {
    textAlign: 'center',
    whiteSpace: 'break-spaces'
  },
  children: jsxs(Typography, {
    tagName: "span",
    variant: "headline",
    size: "xl",
    color: "inverse-on-surface",
    children: ["Get", ' ', jsxs(Typography, {
      tagName: "span",
      variant: "headline",
      size: "xl",
      color: "primary-container",
      children: ["full visibility", ' ']
    }), jsxs("span", {
      children: ["into your ", '\n', "team's "]
    }), jsx(Typography, {
      tagName: "span",
      variant: "headline",
      size: "xl",
      color: "primary-container",
      children: "workload"
    })]
  })
});
const SignIn = () => jsx(RandomBackground, {
  images: BACKGROUND_IMAGES,
  children: jsx(Container, {
    children: jsxs(Layout, {
      stack: true,
      fullHeight: true,
      vAlign: "space-between",
      children: [jsxs(Layout, {
        vAlign: "center",
        hAlign: "space-between",
        children: [jsx(Logo, {}), jsx(Button, {
          children: "Free Trial"
        })]
      }), jsxs(ContentSection, {
        hAlign: "center",
        vAlign: "center",
        gap: 48,
        children: [jsx(LoginSection, {
          hAlign: "center",
          vAlign: "center",
          children: jsx(AuthenticationContainer, {
            authMethods: ['google', 'sso']
          })
        }), jsxs(WelcomeSection, {
          gap: "--Spacing-150",
          stack: true,
          children: [jsx(Typography, {
            variant: "display",
            size: "xl",
            color: "inverse-on-surface",
            children: "Welcome back"
          }), jsx(Typography, {
            variant: "headline",
            size: "small",
            color: "inverse-on-surface",
            children: "Dive into your team's schedule and projects."
          })]
        })]
      })]
    })
  })
});
const SignUp = () => jsx(SignUpBackground, {
  children: jsxs(Layout, {
    fullHeight: true,
    flex: "1",
    children: [jsx(SignUpLeftContainer, {
      children: jsxs(Layout, {
        stack: true,
        pb: "--Spacing-300",
        pl: "--Spacing-300",
        pr: "--Spacing-300",
        pt: "--Spacing-300",
        flex: "1",
        gap: 48,
        children: [jsx(HPSmall, {}), jsxs(Layout, {
          pl: 76,
          pr: 76,
          stack: true,
          gap: 164,
          children: [jsxs(Layout, {
            stack: true,
            gap: "--Spacing-200",
            children: [jsx(FullVisibilityText, {}), jsxs(Typography, {
              variant: "title",
              size: "medium",
              color: "inverse-on-surface",
              align: "center",
              children: ["14-day free trial to explore our ", '\n', " resource management platform"]
            })]
          }), jsx(Layout, {
            hAlign: "center",
            stack: true,
            children: jsx(Review, {})
          })]
        })]
      })
    }), jsx(Layout, {
      fullHeight: true,
      vAlign: "center",
      hAlign: "center",
      flex: "1",
      children: jsx(AuthenticationContainer, {
        isSignUp: true,
        authMethods: ['google', 'linkedin']
      })
    })]
  })
});
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgEuFlag = function SvgEuFlag(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3857 74.7715C58.0333 74.7715 74.7715 58.0333 74.7715 37.3857C74.7715 16.7382 58.0333 0 37.3857 0C16.7382 0 0 16.7382 0 37.3857C0 58.0333 16.7382 74.7715 37.3857 74.7715Z",
    fill: "#0052B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.98 10.0146L38.1904 13.7399H42.1072L38.9383 16.0424L40.1487 19.7674L36.98 17.4652L33.8109 19.7674L35.0214 16.0424L31.8525 13.7399H35.7694L36.98 10.0146Z",
    fill: "#FFDA44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3487 13.8845L26.2595 16.5055L29.6516 14.5471L28.0585 18.1255L30.9692 20.7463L27.074 20.3368L25.4805 23.9152L24.6664 20.084L20.7708 19.6744L24.1629 17.716L23.3487 13.8845Z",
    fill: "#FFDA44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4788 24.0517L17.3101 24.8661L19.2685 21.474L19.6781 25.3696L23.5093 26.1839L19.9311 27.7769L20.3403 31.6726L17.7197 28.7617L14.1412 30.3548L16.0996 26.9627L13.4788 24.0517Z",
    fill: "#FFDA44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0146 37.7915L13.7399 36.5811L13.7399 32.6643L16.0424 35.8332L19.7674 34.6228L17.4652 37.7915L19.7674 40.9606L16.0424 39.75L13.7399 42.9189L13.7399 39.0021L10.0146 37.7915Z",
    fill: "#FFDA44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8845 51.4228L16.5055 48.5119L14.5471 45.1198L18.1255 46.713L20.7463 43.8022L20.3368 47.6975L23.9152 49.2909L20.084 50.1051L19.6744 54.0007L17.716 50.6086L13.8845 51.4228Z",
    fill: "#FFDA44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0517 61.2927L24.8661 57.4614L21.474 55.5029L25.3696 55.0934L26.1839 51.2622L27.7769 54.8404L31.6726 54.4311L28.7617 57.0518L30.3548 60.6303L26.9627 58.6719L24.0517 61.2927Z",
    fill: "#FFDA44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7915 64.7568L36.5811 61.0316L32.6643 61.0316L35.8332 58.7291L34.6228 55.0041L37.7915 57.3063L40.9606 55.0041L39.75 58.7291L42.9189 61.0316L39.0021 61.0316L37.7915 64.7568Z",
    fill: "#FFDA44"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4228 60.887L48.5119 58.266L45.1198 60.2244L46.713 56.6459L43.8022 54.0252L47.6975 54.4346L49.2909 50.8563L50.1051 54.6875L54.0007 55.0971L50.6086 57.0555L51.4228 60.887Z",
    fill: "#FFDA44"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2927 50.7198L57.4614 49.9054L55.5029 53.2975L55.0934 49.4019L51.2622 48.5876L54.8404 46.9945L54.4311 43.0989L57.0518 46.0098L60.6303 44.4167L58.6719 47.8088L61.2927 50.7198Z",
    fill: "#FFDA44"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7568 36.98L61.0316 38.1904L61.0316 42.1072L58.7291 38.9383L55.0041 40.1487L57.3063 36.98L55.0041 33.8109L58.7291 35.0214L61.0316 31.8525L61.0316 35.7694L64.7568 36.98Z",
    fill: "#FFDA44"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.887 23.3487L58.266 26.2595L60.2244 29.6516L56.6459 28.0585L54.0252 30.9692L54.4346 27.074L50.8563 25.4805L54.6875 24.6664L55.0971 20.7708L57.0555 24.1629L60.887 23.3487Z",
    fill: "#FFDA44"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7198 13.4788L49.9054 17.3101L53.2975 19.2685L49.4019 19.6781L48.5876 23.5092L46.9945 19.9311L43.0989 20.3403L46.0098 17.7197L44.4167 14.1412L47.8088 16.0996L50.7198 13.4788Z",
    fill: "#FFDA44"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEuFlag);
const StyledFlag = /*#__PURE__*/styled(ForwardRef).withConfig({
  displayName: "eu-attendance-tracker__StyledFlag",
  componentId: "sc-9wwymr-0"
})(["height:75px;width:75px;"]);
const EuAttendanceTrackerHeader = () => {
  return jsxs(Layout, {
    gap: "--Spacing-300",
    vAlign: "center",
    children: [jsx(Layout, {
      flex: "0 0 75px",
      children: jsx(StyledFlag, {})
    }), jsx(Typography, {
      variant: "title",
      size: "large",
      children: "Stay Compliant with EU Attendance Law"
    })]
  });
};
const EuAttendanceTrackerBody = () => {
  return jsxs(Layout, {
    gap: "--Spacing-200",
    stack: true,
    children: [jsxs(Typography, {
      variant: "body",
      size: "large",
      children: ["From ", jsx("b", {
        children: "July 1, 2024, EU law"
      }), " requires employers to track employees' working hours. We're exploring the interest in\u00A0an ", jsx("b", {
        children: "Attendance Tracker"
      }), " to ensure compliance."]
    }), jsx("a", {
      href: "https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX%3A62018CJ0055",
      target: "_blank",
      rel: "noopener noreferrer",
      children: jsx(Typography, {
        variant: "body",
        size: "small",
        tagName: "span",
        color: "on-tertiary-container",
        children: "Learn more about the legislation here"
      })
    })]
  });
};
const SurveyContent = /*#__PURE__*/React__default.memo(props => {
  var _a;
  const {
    survey,
    surveyResponse,
    isDialogOpen,
    shouldDefaultOpen,
    anchorElement,
    buttonRef,
    onDismiss,
    onSubmit
  } = props;
  const [state, setState] = useState({
    step: 0,
    answers: ((_a = surveyResponse === null || surveyResponse === void 0 ? void 0 : surveyResponse.answers) === null || _a === void 0 ? void 0 : _a.length) ? surveyResponse.answers.reduce((acc, answer) => {
      acc[answer.questionId] = answer;
      return acc;
    }, {}) : {}
  });
  const noOfSurveySteps = survey.questions.length;
  const currentQuestion = survey.questions[state.step];
  const handleClose = useCallback(() => {
    onDismiss(Object.values(state.answers));
  }, [onDismiss, state.answers]);
  const titleJSX = useMemo(() => {
    switch (currentQuestion.text) {
      case 'EU_ATTENDANCE_TRACKER':
        return jsx(EuAttendanceTrackerHeader, {});
      default:
        return jsxs(Layout, {
          gap: "--Spacing-300",
          vAlign: "center",
          children: [survey.imageUrl ? jsx("img", {
            src: survey.imageUrl
          }) : null, survey.title ? jsx(Typography, {
            variant: "title",
            size: "large",
            children: survey.title
          }) : null]
        });
    }
  }, [currentQuestion.text, survey.imageUrl, survey.title]);
  const contentJSX = useMemo(() => {
    if (currentQuestion.text === 'EU_ATTENDANCE_TRACKER') {
      return jsx(EuAttendanceTrackerBody, {});
    }
  }, [currentQuestion.text]);
  const actionJSX = useMemo(() => {
    switch (currentQuestion.type) {
      case 'BUTTON':
        return jsx(Layout, {
          gap: "--Spacing-200",
          hAlign: "flex-end",
          children: currentQuestion.options.map(option => {
            return jsx(Button, {
              variant: option.variant.toLowerCase(),
              onClick: () => {
                setState(prev => {
                  const newAnswers = Object.assign(Object.assign({}, prev.answers), {
                    [currentQuestion.id]: {
                      questionId: currentQuestion.id,
                      value: option.id
                    }
                  });
                  if (prev.step === noOfSurveySteps - 1) {
                    onSubmit(Object.values(newAnswers));
                    return Object.assign(Object.assign({}, prev), {
                      answers: newAnswers
                    });
                  } else {
                    return Object.assign(Object.assign({}, prev), {
                      step: prev.step + 1,
                      answers: newAnswers
                    });
                  }
                });
              },
              children: option.text
            });
          })
        });
      default:
        return null;
    }
  }, [currentQuestion.id, currentQuestion.options, currentQuestion.type, noOfSurveySteps, onSubmit]);
  return jsx(StyledDialog, {
    onClose: handleClose,
    open: isDialogOpen,
    withCloseButton: true,
    title: titleJSX,
    content: contentJSX,
    actions: actionJSX,
    anchorElement: shouldDefaultOpen ? buttonRef.current : anchorElement,
    anchorOriginPosition: anchorOriginPosition,
    transformOriginPosition: transformOriginPosition
  });
});
const StyledDialog = /*#__PURE__*/styled(Dialog).withConfig({
  displayName: "survey-content__StyledDialog",
  componentId: "owlv4m-0"
})([".hub-ui__dialog-paper{max-width:555px;}"]);
const anchorOriginPosition = {
  vertical: 'top',
  horizontal: 'left'
};
const transformOriginPosition = {
  vertical: 'bottom',
  horizontal: 'right'
};
const SHOW_ONLY_AWAITING_RESPONSE = true;
const SurveyPopup = /*#__PURE__*/React__default.memo(props => {
  const {
    className,
    accountId,
    companyId
  } = props;
  const {
    open,
    isOpen,
    anchorElement,
    close
  } = useOpenState();
  const buttonRef = useRef(null);
  const [isButtonMounted, setIsButtonMounted] = useState(false);
  const {
    survey,
    surveyResponse,
    loaded
  } = useActiveSurvey(accountId);
  const updateFn = useUpdateSurveyResponse(SHOW_ONLY_AWAITING_RESPONSE);
  const createFn = useCreateSurveyResponse(SHOW_ONLY_AWAITING_RESPONSE);
  const shouldDisplayPopup = useMemo(() => {
    var _a;
    return Boolean((_a = survey === null || survey === void 0 ? void 0 : survey.questions) === null || _a === void 0 ? void 0 : _a.length);
  }, [survey]);
  const shouldDefaultOpen = useMemo(() => {
    if (!shouldDisplayPopup || !isButtonMounted || !loaded) {
      return false;
    }
    if (!(surveyResponse === null || surveyResponse === void 0 ? void 0 : surveyResponse.dismissedAt)) {
      return true;
    }
    const noOfDays = calculateDifference(new Date(), surveyResponse.dismissedAt, 'day');
    return Math.abs(noOfDays) > 7;
  }, [isButtonMounted, loaded, shouldDisplayPopup, surveyResponse === null || surveyResponse === void 0 ? void 0 : surveyResponse.dismissedAt]);
  const isDialogOpen = shouldDefaultOpen || isOpen;
  const handleButtonRef = useCallback(ref => {
    buttonRef.current = ref;
    setIsButtonMounted(true);
  }, []);
  const submitSurvey = useCallback(data => {
    if (!survey) {
      return;
    }
    if (!(surveyResponse === null || surveyResponse === void 0 ? void 0 : surveyResponse.id)) {
      createFn({
        accountId: accountId,
        companyId: companyId,
        surveyId: survey.id,
        data
      });
    } else {
      updateFn({
        surveyId: survey.id,
        accountId: accountId,
        companyId: companyId,
        responseId: surveyResponse.id,
        data: data // TODO: check for type guard
      });
    }
    close();
  }, [accountId, close, companyId, createFn, survey, surveyResponse, updateFn]);
  const handleSubmit = useCallback(answers => {
    submitSurvey({
      dismissed: false,
      answers
    });
  }, [submitSurvey]);
  const handleDismiss = useCallback(() => {
    submitSurvey({
      dismissed: true,
      answers: []
    });
    close();
  }, [close, submitSurvey]);
  if (!shouldDisplayPopup || !survey) {
    return null;
  }
  return jsxs("div", {
    className: className,
    children: [jsx(Fab, {
      onClick: open,
      icon: "information2",
      color: "secondary-container",
      iconSize: 32,
      ref: handleButtonRef
    }), jsx(SurveyContent, {
      survey: survey,
      surveyResponse: surveyResponse,
      isDialogOpen: isDialogOpen,
      shouldDefaultOpen: shouldDefaultOpen,
      buttonRef: buttonRef,
      anchorElement: anchorElement,
      onDismiss: handleDismiss,
      onSubmit: handleSubmit
    })]
  });
});
const useActiveSurvey = accountId => {
  var _a, _b;
  const surveyQuery = useSurveys(SHOW_ONLY_AWAITING_RESPONSE);
  // TODO: for now we assume that there will be just one active survey
  // or we just open one at the moment so user won't be attacked by multiple surveys on initial app load
  const survey = (_b = (_a = surveyQuery.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[0];
  const surveyResponseQuery = useSurveyResponseForAccount(survey === null || survey === void 0 ? void 0 : survey.id, accountId);
  return {
    survey,
    surveyResponse: surveyResponseQuery.data,
    loaded: surveyQuery.isSuccess && surveyResponseQuery.isFetched
  };
};
export { AppModules, ApprovalContextMenu, BookingRepeatEndsOnLabels, BookingRepeatFormPart, BudgetStatusFilter, BuilderCheckboxList, BuilderEmptyList, BuilderHeaderWrapper, BuilderListWrapper, BuilderSelectData, BuilderWrapper, CrossFilter, CustomFieldGroupsContainer, CustomFields, CustomFieldsFilter, CustomFieldsWithTemplates, EditDeadline, FilterCondition, FilterRelationFormat, FilterRelationToggle, FiltersNavigation, InProductReview, IsPmFilter, Loader, MissingExtension, ModalCustomFieldGroups, Onboarding, OnboardingCustomFieldsProvider, OnboardingProvider, PersonalPreferencesSidebar, ProjectDatesFilter, ReportColumns, SchedulerChildParentMode, SchedulerEditBookingMenu, SchedulerEditProjectItems, SchedulerProjectParentMode, SchedulerSingleModeContextMenu, SelectedListWrapper, SignIn, SignUp, StyledAvailableListItem, StyledSelectedListItem, SurveyPopup, TypeSelector, UNDO_ACTIONS, UndoService, bookingRepeatOptions, bookingRepeatOptionsMap, calculateEndDate, calculateNewRepeatOptions, calculateResourceCapacity, canApproveBooking, canEditRequest, canRequest, categoryTemplateActions, makeIsExtensionInstalled, makeSelectHolidaysByCalendarIds, makeSelectPermittedProjectsForScheduleRequest, makeSelectPermittedResourcesForRequest, makeSelectPermittedResourcesForScheduleRequest, makeSelectProjectByIdFromMap, makeSelectResourceByIdFromMap, modalActions, projectActions, repeatIntervalOptions, repeatIntervalOptionsMap, repeatMonthlyOnCustomOption, repeatMonthlyOnCustomOptionsMap, repeatMonthlyOnDatesOption, repeatMonthlyOnOptions, resourceActions, selectAppKeyWords, selectBookingDefaultState, selectCalendars, selectCatColorDisplayNew, selectCompany, selectCompanyApprovers, selectCompanyAvgDailyCapacity, selectCompanyDeadlinesBeforeBookingEndDateConfig, selectCompanyStartEndTimes, selectDefaultVacationId, selectExtensions, selectIsApprovalExtensionInstalled, selectIsAuditLogExtensionInstalled, selectIsCategoryColorUsed, selectIsCategoryGroupsExtensionInstalled, selectIsCustomColumnsExtensionInstalled, selectIsCustomFieldsExtensionInstalled, selectIsDeadlinesExtensionInstalled, selectIsDefaultVacationEventSet, selectIsDependenciesExtensionInstalled, selectIsExtendedDashboardExtensionInstalled, selectIsFixedCostsExtensionInstalled, selectIsHolidayCalendarsExtensionInstalled, selectIsMFAExtensionInstalled, selectIsMyDashboardExtensionInstalled, selectIsPMExtensionInstalled, selectIsResourceRateExtensionInstalled, selectIsResourceRequestExtensionInstalled, selectIsSSOExtensionInstalled, selectIsSidebarProExtensionInstalled, selectIsSmartFiltersExtensionInstalled, selectIsSmartGroupsExtensionInstalled, selectIsSmartSchedulesExtensionInstalled, selectIsTasksExtensionInstalled, selectIsTimeSheetsExtensionInstalled, selectIsToilExtensionInstalled, selectIsUnassignedExtensionInstalled, selectIsVacationRequestExtensionInstalled, selectProjectStatuses, selectProjectStatusesMapped, selectProjects, selectProjectsMap, selectResources, selectResourcesMap, selectSickLeaveId, selectUseCategoriesAllocation, selectWeekDaysSetting, showConfirmationModal, showDeleteConfirmationModal, showEditRequestResourceModal, showMissingDeadlinesExtensionModal, showMissingDependenciesExtensionModal, showProjectModal, useActiveSurvey, useCanApproveBooking, useCanDeleteRequest, useCanEditRequest, useCanRequest, useCanRequestVacationForSelection, useCanUserSeeExtensionsSettingsPage, useCrossFilterTabsOptions };